
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("iuVKP", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $65DSU = parcelRequire("65DSU");


var $d5gEx = parcelRequire("d5gEx");











var $6cFsl = parcelRequire("6cFsl");


var $kiAM2 = parcelRequire("kiAM2");


var $7akNQ = parcelRequire("7akNQ");


var $c2Doe = parcelRequire("c2Doe");


var $iDrrr = parcelRequire("iDrrr");


var $91ZZN = parcelRequire("91ZZN");


var $dUAp3 = parcelRequire("dUAp3");


var $hdBxM = parcelRequire("hdBxM");


var $37RgG = parcelRequire("37RgG");


var $8lt5O = parcelRequire("8lt5O");


var $irnO2 = parcelRequire("irnO2");


var $89QZA = parcelRequire("89QZA");


var $bjY3F = parcelRequire("bjY3F");


var $lJ6db = parcelRequire("lJ6db");


var $isp1U = parcelRequire("isp1U");


var $bGNkz = parcelRequire("bGNkz");











var $9EOlJ = parcelRequire("9EOlJ");

const $741693f1d6085f6e$var$enableDebugging = ()=>{
    if (window.top) window.top.__aifcDebuggerEnabled__ = true;
};
const $741693f1d6085f6e$var$disableDebugging = ()=>{
    if (window.top) window.top.__aifcDebuggerEnabled__ = false;
};
function $741693f1d6085f6e$var$addAifcDebugListeners() {
    if (window.top) {
        window.top.__aifcDebuggerStart__ = $741693f1d6085f6e$var$enableDebugging;
        window.top.__aifcDebuggerStop__ = $741693f1d6085f6e$var$disableDebugging;
    }
}
function $741693f1d6085f6e$var$removeAifcDebugListeners() {
    if (window.top) {
        window.top.__aifcDebuggerStart__ = undefined;
        window.top.__aifcDebuggerStop__ = undefined;
    }
}
const $741693f1d6085f6e$var$AifcDebuggerListeners = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = [];
        $[0] = t0;
    } else t0 = $[0];
    (0, $cozmU.useEffect)($741693f1d6085f6e$var$_temp2, t0);
    return null;
} : ()=>{
    (0, $cozmU.useEffect)(()=>{
        $741693f1d6085f6e$var$addAifcDebugListeners();
        return ()=>{
            $741693f1d6085f6e$var$removeAifcDebugListeners();
        };
    }, []);
    return null;
};
const $741693f1d6085f6e$var$onAifcDebuggerError = (error, errorInfo)=>{
    // eslint-disable-next-line no-console
    console.error('AifcDebugger failed:', error, errorInfo);
};
const $741693f1d6085f6e$export$1f35aa17211e523d = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9EOlJ.ErrorBoundary), {
            fallbackRender: $741693f1d6085f6e$var$_temp3,
            onError: $741693f1d6085f6e$var$onAifcDebuggerError
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($741693f1d6085f6e$var$AifcDebuggerListeners, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9EOlJ.ErrorBoundary), {
        fallbackRender: ()=>null,
        onError: $741693f1d6085f6e$var$onAifcDebuggerError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($741693f1d6085f6e$var$AifcDebuggerListeners, null));
};
function $741693f1d6085f6e$var$_temp() {
    $741693f1d6085f6e$var$removeAifcDebugListeners();
}
function $741693f1d6085f6e$var$_temp2() {
    $741693f1d6085f6e$var$addAifcDebugListeners();
    return $741693f1d6085f6e$var$_temp;
}
function $741693f1d6085f6e$var$_temp3() {
    return null;
}



var $oV0CU = parcelRequire("oV0CU");


var $gyWKg = parcelRequire("gyWKg");





var $hJ1ww = parcelRequire("hJ1ww");

const $58f16686a4f70667$export$b9c35db6980960f2 = ({ profileData: profileData, displaySubmitFlag: displaySubmitFlag, siteId: siteId, activationId: activationId, product: product, experienceId: experienceId = (0, $oV0CU.AI_MATE_EXPERIENCE_ID), workspaceId: workspaceId, orgId: orgId, assistanceServiceConfig: assistanceServiceConfig, closeChat: closeChat, emojiProvider: emojiProvider, preventAbortRequestsOnStagingModalClose: preventAbortRequestsOnStagingModalClose, preventAbortRequestsOnStandaloneChatClose: preventAbortRequestsOnStandaloneChatClose, renderingTouchpoint: renderingTouchpoint, inProductExperience: inProductExperience, smartCreationContext: smartCreationContext, jiraIssueCommentEditor: jiraIssueCommentEditor, autocompletePageContentSource: autocompletePageContentSource, editorContentIdResolver: editorContentIdResolver, contextualPromptAnalyticsMetadata: contextualPromptAnalyticsMetadata, moduleAnalyticsContext: moduleAnalyticsContext, analyticsProductHeader: analyticsProductHeader, loadLocalModelAutocomplete: loadLocalModelAutocomplete, useCurrentBrowsingContext: useCurrentBrowsingContext, requestedSkills: requestedSkills, creationContextOverrides: creationContextOverrides })=>({
        profileData: profileData,
        feedbackCollector: {
            entryPointId: (0, $oV0CU.FEEDBACK_COLLECTOR_ENTRYPOINT_ID),
            displaySubmitFlag: displaySubmitFlag
        },
        siteId: siteId,
        activationId: activationId,
        experienceId: experienceId,
        workspaceId: workspaceId,
        productKey: (0, $hJ1ww.serviceProductToProductKey)(product),
        productHeader: analyticsProductHeader ?? product,
        orgId: orgId,
        assistanceServiceConfig: assistanceServiceConfig,
        closeChat: closeChat,
        emojiProvider: emojiProvider,
        preventAbortRequestsOnStagingModalClose: preventAbortRequestsOnStagingModalClose,
        preventAbortRequestsOnStandaloneChatClose: preventAbortRequestsOnStandaloneChatClose,
        renderingTouchpoint: renderingTouchpoint,
        inProductExperience: inProductExperience,
        smartCreationContext: smartCreationContext,
        jiraIssueCommentEditor: jiraIssueCommentEditor,
        autocompletePageContentSource: autocompletePageContentSource,
        editorContentIdResolver: editorContentIdResolver,
        contextualPromptAnalyticsMetadata: contextualPromptAnalyticsMetadata,
        moduleAnalyticsContext: moduleAnalyticsContext,
        analyticsProductHeader: analyticsProductHeader,
        loadLocalModelAutocomplete: loadLocalModelAutocomplete,
        useCurrentBrowsingContext: useCurrentBrowsingContext,
        requestedSkills: requestedSkills,
        creationContextOverrides: creationContextOverrides
    });



var $6H2Ay = parcelRequire("6H2Ay");

const $b6e4c82a4164acfc$export$920227929045c1b5 = (0, $6H2Ay.globalConfig).Provider;


// NOTE: Global `Window` augmentations merge across the entire program. The sibling
// package `@atlassian/conversation-assistant-service` declares this same
// `__ROVO_CHAT_CONFIG_PRODUCT__` global; keep the modifier (`?: string`) identical to
// that declaration, otherwise TS2687 ("All declarations of X must have identical
// modifiers") will fail at the program level.
const $de717ae3a7549f1b$export$caa27b16709bc2df = (product)=>{
    if (window) window.__ROVO_CHAT_CONFIG_PRODUCT__ = product;
};












var $atEX8 = parcelRequire("atEX8");

const $557d858394512263$export$b0b2d9624bbf3936 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { children: children } = t0;
    const [isSideNavOpen, setSideNavOpen] = (0, $cozmU.useState)(false);
    let t1;
    if ($[0] !== isSideNavOpen) {
        t1 = {
            isSideNavOpen: isSideNavOpen,
            setSideNavOpen: setSideNavOpen
        };
        $[0] = isSideNavOpen;
        $[1] = t1;
    } else t1 = $[1];
    const value = t1;
    let t2;
    if ($[2] !== children || $[3] !== value) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $atEX8.SideNavContext).Provider, {
            value: value
        }, children);
        $[2] = children;
        $[3] = value;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ children: children })=>{
    const [isSideNavOpen, setSideNavOpen] = (0, $cozmU.useState)(false);
    const value = (0, $cozmU.useMemo)(()=>({
            isSideNavOpen: isSideNavOpen,
            setSideNavOpen: setSideNavOpen
        }), [
        isSideNavOpen,
        setSideNavOpen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $atEX8.SideNavContext).Provider, {
        value: value
    }, children);
};



var $blKf8 = parcelRequire("blKf8");

const $735ca6a936ab5049$export$3063519296e335bf = (0, $blKf8.uiConfig).Provider;



var $c69qG = parcelRequire("c69qG");

const $31f0ba1c2c4d97e2$export$51f901728a02d39c = (0, $c69qG.agentVersioningConfigContext).Provider;



var $j180q = parcelRequire("j180q");





var $c6StJ = parcelRequire("c6StJ");


var $cXtTj = parcelRequire("cXtTj");


var $4o0zT = parcelRequire("4o0zT");








var $ieeJu = parcelRequire("ieeJu");


var $i7OAD = parcelRequire("i7OAD");


var $lUXDc = parcelRequire("lUXDc");


var $gYfOr = parcelRequire("gYfOr");


var $aJU2k = parcelRequire("aJU2k");


var $6rwn6 = parcelRequire("6rwn6");





var $Ou0Zz = parcelRequire("Ou0Zz");




const $d91d74abbb95cf45$var$SEND_MESSAGE_EXPERIENCE_NAMES = new Set([
    (0, $irnO2.ExperienceName).SEND_MESSAGE
]);
const $d91d74abbb95cf45$var$toError = (error)=>error ?? new Error('aiMateSendMessage failed');
const $d91d74abbb95cf45$var$matchesSendMessageFailure = (event, context)=>{
    if (!$d91d74abbb95cf45$var$SEND_MESSAGE_EXPERIENCE_NAMES.has(event.name) || event.action !== 'taskFail') return false;
    const attributes = event.attributes;
    const isRemixRegenerate = attributes?.isRemixRegenerate === true;
    if (!isRemixRegenerate) return false;
    const requestSource = attributes?.remixRegenerateSource;
    if (context.regenerateSource && requestSource !== context.regenerateSource) return false;
    const requestConversationId = attributes?.conversationId;
    if (context.conversationChannelId && requestConversationId === context.conversationChannelId) return true;
    // For now, if allowCollectFallback is true, we will assume there's only one conversation stream at a time
    // and that this failure event is related to the inflight Remix request
    return Boolean(context.allowCollectFallback && context.regenerateSource === 'inline-existing-node');
};
const $d91d74abbb95cf45$export$a9538f4db585a467 = (context)=>{
    return (events, experience)=>{
        for (const event of events){
            if (!$d91d74abbb95cf45$var$matchesSendMessageFailure(event, context)) continue;
            const attributes = event.attributes;
            experience.fail({
                error: $d91d74abbb95cf45$var$toError(event.error),
                attributes: {
                    ...attributes ?? {},
                    ...context.featureArea ? {
                        featureArea: context.featureArea
                    } : {},
                    failureSource: 'send_message_collect',
                    failureStage: 'request',
                    upstreamExperience: event.name,
                    ...context.regenerateSource ? {
                        regenerateSource: context.regenerateSource
                    } : {},
                    ...context.targetIds ?? {}
                }
            });
            return;
        }
    };
};






var $4m5jb = parcelRequire("4m5jb");


var $gzMZq = parcelRequire("gzMZq");


var $k4g8h = parcelRequire("k4g8h");


var $igOtY = parcelRequire("igOtY");


var $iW40i = parcelRequire("iW40i");


var $8akfd = parcelRequire("8akfd");


var $lTU4O = parcelRequire("lTU4O");


var $2yWJZ = parcelRequire("2yWJZ");


var $5Tn11 = parcelRequire("5Tn11");


var $j1J3n = parcelRequire("j1J3n");


var $8gcBG = parcelRequire("8gcBG");


var $ah4h4 = parcelRequire("ah4h4");


var $a6gXC = parcelRequire("a6gXC");


var $2BLI8 = parcelRequire("2BLI8");


var $xHMAX = parcelRequire("xHMAX");


var $6yHkF = parcelRequire("6yHkF");


var $3MoJD = parcelRequire("3MoJD");


var $2YoG8 = parcelRequire("2YoG8");


var $dlR4F = parcelRequire("dlR4F");


var $95cHD = parcelRequire("95cHD");


var $85mU8 = parcelRequire("85mU8");


var $c7So7 = parcelRequire("c7So7");


var $eKjv9 = parcelRequire("eKjv9");


var $dSCNl = parcelRequire("dSCNl");


var $lulv8 = parcelRequire("lulv8");


var $lx3cN = parcelRequire("lx3cN");


var $n71o5 = parcelRequire("n71o5");


var $3TxKn = parcelRequire("3TxKn");


var $hlvTd = parcelRequire("hlvTd");


var $7lXV4 = parcelRequire("7lXV4");


var $3wccB = parcelRequire("3wccB");


var $5OXoi = parcelRequire("5OXoi");


var $6isLN = parcelRequire("6isLN");





var $4nKqn = parcelRequire("4nKqn");





var $jb3zd = parcelRequire("jb3zd");

const $e4efc8cb7e22be34$export$ff6a2981a5436d75 = (status, streamId, content)=>{
    if (!content) return;
    const api = (0, $85mU8.getBrowserBridgeAPI)();
    const id = String(content.id);
    const receiverId = (()=>{
        switch(content.type){
            case 'page':
                return (0, $5OXoi.getConfluenceEditorClientId)(id);
            case 'database':
                return (0, $7lXV4.getConfluenceDatabaseClientId)(id);
            case 'whiteboard':
                return (0, $6isLN.getConfluenceWhiteboardClientId)(id);
            case 'slide':
                return (0, $3wccB.getConfluenceSlidesClientId)(id);
            default:
                return undefined;
        }
    })();
    try {
        if (!receiverId) return;
        switch(status){
            case (0, $jb3zd.StreamLifecycleState).SEND_CONTEXT_READY:
                api.send((0, $4nKqn.RovoSendContextReadyCommand), {
                    streamId: streamId,
                    contentId: content.id,
                    senderId: (0, $5Tn11.ROVO_CHAT_CLIENT_ID),
                    receiverId: receiverId,
                    ...content.inlineRovoEditAttemptId && {
                        inlineRovoEditAttemptId: content.inlineRovoEditAttemptId
                    }
                });
                break;
            case (0, $jb3zd.StreamLifecycleState).COMPLETED:
                api.send((0, $4nKqn.RovoStreamCompletedCommand), {
                    streamId: streamId,
                    contentId: content.id,
                    senderId: (0, $5Tn11.ROVO_CHAT_CLIENT_ID),
                    receiverId: receiverId,
                    ...content.inlineRovoEditAttemptId && {
                        inlineRovoEditAttemptId: content.inlineRovoEditAttemptId
                    }
                });
                break;
            case (0, $jb3zd.StreamLifecycleState).ERRORED:
                api.send((0, $4nKqn.RovoStreamErroredCommand), {
                    streamId: streamId,
                    contentId: content.id,
                    senderId: (0, $5Tn11.ROVO_CHAT_CLIENT_ID),
                    receiverId: receiverId,
                    ...content.inlineRovoEditAttemptId && {
                        inlineRovoEditAttemptId: content.inlineRovoEditAttemptId
                    }
                });
                break;
            case (0, $jb3zd.StreamLifecycleState).ABORTED:
                api.send((0, $4nKqn.RovoStreamAbortedCommand), {
                    streamId: streamId,
                    contentId: content.id,
                    senderId: (0, $5Tn11.ROVO_CHAT_CLIENT_ID),
                    receiverId: receiverId,
                    ...content.inlineRovoEditAttemptId && {
                        inlineRovoEditAttemptId: content.inlineRovoEditAttemptId
                    }
                });
                break;
            default:
                (0, $hlvTd.logException)({
                    exception: new Error(`Unknown stream lifecycle state: ${status}`),
                    name: 'UnknownStreamLifecycleState'
                });
        }
    } catch (error) {
        (0, $hlvTd.logException)({
            exception: error,
            name: 'SendStreamLifecycleCommandError'
        });
    }
};















var $dw75i = parcelRequire("dw75i");


var $7eUSO = parcelRequire("7eUSO");


var $b8lE8 = parcelRequire("b8lE8");


var $bxkJA = parcelRequire("bxkJA");




const $99c71ced7475a049$var$MAX_SESSIONS = 20;
const $99c71ced7475a049$var$hasString = (value)=>typeof value === 'string' && value.trim().length > 0;
const $99c71ced7475a049$var$hasData = (action, fields)=>typeof action.data === 'object' && action.data !== null && fields.every((field)=>$99c71ced7475a049$var$hasString(action.data[field]));
const $99c71ced7475a049$var$commentActionForPublication = (action, resolution)=>{
    if (resolution !== 'confirmed') return action;
    const data = action.data;
    const comment = data.comment;
    if (typeof comment !== 'string') return action;
    try {
        return {
            ...action,
            data: {
                ...data,
                comment: JSON.stringify((0, $6rwn6.encodeAdf)(comment))
            }
        };
    } catch  {
        // Preserve the previous behavior if ADF conversion fails
        return action;
    }
};
const $99c71ced7475a049$var$canResume = (action)=>(0, $b8lE8.shouldUseResumption)(action) && // Native Rovo tools have no tool-definition ID; confirmation uses their invocation ID.
    (action.toolSource === 'CONVO_AI' || $99c71ced7475a049$var$hasString(action.actionId)) && $99c71ced7475a049$var$hasString(action.toolSource) && $99c71ced7475a049$var$hasString(action.humanMessageId);
const $99c71ced7475a049$var$usesResumption = (action)=>(0, $4o0zT.isExperimentEnabled)('rovo_tools_resumption_migration_exp') && (0, $b8lE8.shouldUseResumption)(action);
const $99c71ced7475a049$var$pendingActions = (assistant)=>(assistant.content.message.message.actions ?? []).filter((action)=>{
        // Match the Chat renderer: edits without ADF were streamed into the editor already.
        if (action.key === (0, $dw75i.ActionKeys).AifcAdfUpdate && typeof action.data === 'object' && action.data !== null && !action.data.adf) return false;
        const invoked = assistant.invokedActions?.[action.invocationId];
        return (action.status === undefined || action.status === 'planned') && (invoked === undefined || invoked === 'planned');
    });
// Page comment actions never evaluate the gate.
const $99c71ced7475a049$var$isCommentAction = (action)=>action.key === (0, $dw75i.ActionKeys).ConfluencePageComment || action.key === (0, $dw75i.ActionKeys).ConfluenceComment && (0, $iDrrr.fg)('canvas-rovo-comment-sessions');
const $99c71ced7475a049$var$isSupported = (action)=>{
    return $99c71ced7475a049$var$isCommentAction(action) && $99c71ced7475a049$var$hasString(action.invocationId) && $99c71ced7475a049$var$hasData(action, [
        'parentCommentId',
        'contentId',
        'comment'
    ]) && (!$99c71ced7475a049$var$usesResumption(action) || $99c71ced7475a049$var$canResume(action));
};
function $99c71ced7475a049$var$latestAssistant(messages) {
    for(let index = messages.length - 1; index >= 0; index--){
        const message = messages[index];
        if ((0, $igOtY.isStoreHuman)(message) || (0, $igOtY.isStoreError)(message)) return undefined;
        if ((0, $igOtY.isStoreAssistant)(message)) return message;
    }
    return undefined;
}
/**
 * A finished action is recorded only after a successful confirmed execution; cancelled and failed
 * actions retain their distinct states. Restrict the decision to the latest human turn so a prior
 * reply, a continuation, or another tool can never hide the current Chat result after reload.
 */ function $99c71ced7475a049$var$hasCompletedReplyOnlyLatestTurn(messages, commentId) {
    let latestHumanIndex = -1;
    for(let index = messages.length - 1; index >= 0; index--)if ((0, $igOtY.isStoreHuman)(messages[index])) {
        latestHumanIndex = index;
        break;
    }
    if (latestHumanIndex < 0) return false;
    const latestHuman = messages[latestHumanIndex];
    if (!(0, $igOtY.isStoreHuman)(latestHuman) || !$99c71ced7475a049$var$hasString(latestHuman.content.id)) return false;
    const humanMessageId = String(latestHuman.content.id);
    let foundReply = false;
    for(let index = latestHumanIndex + 1; index < messages.length; index++){
        const message = messages[index];
        if ((0, $igOtY.isStoreError)(message) || !(0, $igOtY.isStoreAssistant)(message)) return false;
        if (message.isAborted || message.content.streamingComplete === false || message.content.message.message.async_status === 'IN_PROGRESS') return false;
        if (message.content.message.message.plugin_invocations?.length) return false;
        const actions = message.content.message.message.actions ?? [];
        for (const action of actions){
            if (action.humanMessageId !== humanMessageId || action.status !== 'finished' || !$99c71ced7475a049$var$isSupported(action) || action.data.parentCommentId !== commentId) return false;
            foundReply = true;
        }
    }
    return foundReply;
}
class $99c71ced7475a049$export$b4901a24ae3e40f {
    register(session) {
        if (!$99c71ced7475a049$var$hasString(session.sourceId) || !$99c71ced7475a049$var$hasString(session.conversationId) || !$99c71ced7475a049$var$hasString(session.agentId)) return;
        const existing = this.sessions.get(session.conversationId);
        if (existing) return;
        this.sessions.set(session.conversationId, {
            ...session,
            acceptedMessages: new Set(),
            lockedMessages: new Set()
        });
        // Keep only recent same-tab sessions; an evicted approval can still continue in Chat.
        const oldest = this.sessions.keys().next().value;
        if (this.sessions.size > $99c71ced7475a049$var$MAX_SESSIONS && oldest) this.sessions.delete(oldest);
    }
    clear() {
        this.recoveryGeneration++;
        this.sessions.clear();
        this.recoveries.clear();
        this.terminalRecoveries.clear();
    }
    get(sourceId, conversationId, commentId) {
        const registered = this.sessions.get(conversationId);
        const conversation = this.getConversation(conversationId);
        if (!registered && commentId && $99c71ced7475a049$var$hasString(sourceId) && $99c71ced7475a049$var$hasString(conversationId)) {
            // After a reload, hydrate the read-only history before binding it to this comment.
            const recoveryKey = `${sourceId}:${conversationId}:${commentId}`;
            const terminalRecovery = this.terminalRecoveries.get(recoveryKey);
            if (terminalRecovery) return {
                status: terminalRecovery
            };
            if (conversation?.sourceId && conversation.sourceId !== sourceId) return {
                status: 'unavailable'
            };
            if (!this.recoveries.has(recoveryKey)) {
                const recovery = this.recover(sourceId, conversationId, commentId, this.recoveryGeneration);
                this.recoveries.set(recoveryKey, recovery);
                recovery.finally(()=>{
                    if (this.recoveries.get(recoveryKey) === recovery) this.recoveries.delete(recoveryKey);
                });
            }
            return {
                status: 'loading'
            };
        }
        if (!registered || registered.sourceId !== sourceId || conversation?.sourceId !== sourceId || conversation.lastAgentMessageStatus === 'FAILED') return {
            status: 'unavailable'
        };
        // Session status can precede the final Chat message; wait before inspecting its actions.
        if (conversation.status !== (0, $igOtY.CHAT_STORE_STATUS).idle) return {
            status: 'loading'
        };
        const messages = this.getMessages(conversationId);
        if (commentId && $99c71ced7475a049$var$hasCompletedReplyOnlyLatestTurn(messages, commentId)) return {
            status: 'completed'
        };
        const assistant = $99c71ced7475a049$var$latestAssistant(messages);
        if (assistant && registered.acceptedMessages.has(assistant.content.message.message.id)) return {
            status: 'resolved'
        };
        if (!assistant || assistant.content.streamingComplete === false) return {
            status: 'loading'
        };
        if (assistant.isAborted) return {
            status: 'unavailable'
        };
        const pending = $99c71ced7475a049$var$pendingActions(assistant);
        if (!pending.length) return {
            status: 'resolved'
        };
        const descriptor = this.describe(registered);
        if (descriptor) return {
            status: 'ready',
            descriptor: descriptor
        };
        const replies = pending.filter($99c71ced7475a049$var$isSupported);
        // A preview is not an approval descriptor. Mixed actions still resolve only in Chat.
        if (pending.length > 1 && replies.length === 1 && $99c71ced7475a049$var$hasString(assistant.content.message.message.id)) return {
            status: 'unavailable',
            review: {
                messageId: assistant.content.message.message.id,
                reply: JSON.parse(JSON.stringify(replies[0]))
            }
        };
        return {
            status: 'unavailable'
        };
    }
    async recover(sourceId, conversationId, commentId, generation) {
        try {
            let failed = false;
            // Hydrate without selecting Chat or executing an action; explicit resolve remains separate.
            await this.actions.warmConversationCache({
                conversation: {
                    id: conversationId
                },
                forceRefresh: true,
                onError: ()=>{
                    failed = true;
                }
            });
            if (generation !== this.recoveryGeneration) return;
            // History fetch errors are retryable; the Confluence caller polls for a bounded window.
            if (failed) {
                // Some cache errors leave the store in loadingChat, which blocks the next fetch.
                if (this.getConversation(conversationId)?.status === (0, $igOtY.CHAT_STORE_STATUS).loadingChat) this.actions.setConversationData({
                    conversationId: conversationId,
                    data: {
                        status: (0, $igOtY.CHAT_STORE_STATUS).idle
                    }
                });
                return;
            }
            const conversation = this.getConversation(conversationId);
            const messages = this.getMessages(conversationId);
            const assistant = $99c71ced7475a049$var$latestAssistant(messages);
            if (conversation?.status !== (0, $igOtY.CHAT_STORE_STATUS).idle || conversation.sourceId && conversation.sourceId !== sourceId || !assistant) {
                if (generation === this.recoveryGeneration && conversation?.status === (0, $igOtY.CHAT_STORE_STATUS).idle) this.terminalRecoveries.set(`${sourceId}:${conversationId}:${commentId}`, 'unavailable');
                return;
            }
            // In-progress history is retryable; do not cache it as a terminal recovery failure.
            if (messages.some((message)=>(0, $igOtY.isStoreAssistant)(message) && message.content.message.message.async_status === 'IN_PROGRESS')) return;
            // Bind only history whose proposed action belongs to the requested comment.
            if (!this.hasMatchingCommentAction(messages, commentId)) {
                this.terminalRecoveries.set(`${sourceId}:${conversationId}:${commentId}`, 'unavailable');
                return;
            }
            const agentId = $99c71ced7475a049$var$hasString(conversation.sourceAgentId) ? conversation.sourceAgentId : assistant.content.message.message.author_id;
            if (!$99c71ced7475a049$var$hasString(agentId)) {
                this.terminalRecoveries.set(`${sourceId}:${conversationId}:${commentId}`, 'unavailable');
                return;
            }
            this.actions.setConversationData({
                conversationId: conversationId,
                data: {
                    sourceId: sourceId
                }
            });
            this.register({
                sourceId: sourceId,
                conversationId: conversationId,
                agentId: agentId
            });
        } catch  {
        // Leave unexpected cache errors retryable as well.
        }
    }
    hasMatchingCommentAction(messages, commentId) {
        return messages.some((message)=>(0, $igOtY.isStoreAssistant)(message) && (message.content.message.message.actions ?? []).some((action)=>$99c71ced7475a049$var$isCommentAction(action) && typeof action.data === 'object' && action.data !== null && action.data.parentCommentId === commentId));
    }
    async resolve(command) {
        const session = this.session(command.sourceId, command.conversationId);
        const descriptor = session && this.describe(session);
        if (!session || !descriptor || descriptor.messageId !== command.messageId || descriptor.revision !== command.revision || !this.hasExactResolution(descriptor, command)) return {
            status: 'stale'
        };
        // Lock before the first await. Keep it after uncertain failures; recovery belongs in Chat.
        session.lockedMessages.add(descriptor.messageId);
        try {
            const action = descriptor.action;
            const resolution = command.resolution;
            const publicationAction = $99c71ced7475a049$var$commentActionForPublication(action, resolution.resolution);
            if ($99c71ced7475a049$var$usesResumption(action)) return await new Promise((complete)=>{
                let accepted = false;
                this.actions.sendMessageConfirmedTools({
                    conversationId: session.conversationId,
                    agentId: session.agentId,
                    messageSources: {
                        interactionSource: 'followUps',
                        followUpSource: 'agentMentionComment'
                    },
                    confirmed_tools: {
                        message_id: descriptor.messageId,
                        tools: [
                            (0, $7eUSO.buildToolFromAction)(publicationAction, resolution.resolution)
                        ]
                    },
                    resolutionType: resolution.resolution,
                    onResponseComplete: ()=>{
                        accepted = true;
                        session.acceptedMessages.add(descriptor.messageId);
                        complete({
                            status: 'accepted'
                        });
                    }
                }).then(()=>{
                    if (!accepted) complete({
                        status: 'failed'
                    });
                }).catch(()=>complete({
                        status: 'failed'
                    }));
            });
            else {
                let failed = false;
                await this.actions.resolveConversationAction({
                    conversationId: session.conversationId,
                    messageId: descriptor.messageId,
                    payload: {
                        context: {
                            ...publicationAction,
                            messageId: descriptor.messageId,
                            resolution: {
                                type: resolution.resolution === 'confirmed' ? 'confirm' : 'cancel'
                            }
                        }
                    },
                    skipSuccessOptimisticAssistantResponse: true,
                    actionContentProcessor: (message)=>{
                        failed = !(0, $bxkJA.isActionExecutedSuccessfully)(message);
                    },
                    onError: ()=>{
                        failed = true;
                    }
                });
                if (failed) return {
                    status: 'failed'
                };
            }
            // This acknowledges resolution handling, not that a tool's mutation succeeded.
            return {
                status: 'accepted'
            };
        } catch  {
            return {
                status: 'failed'
            };
        }
    }
    session(sourceId, conversationId) {
        const session = this.sessions.get(conversationId);
        const conversation = this.getConversation(conversationId);
        return session?.sourceId === sourceId && conversation?.sourceId === sourceId && conversation.status === (0, $igOtY.CHAT_STORE_STATUS).idle && conversation.lastAgentMessageStatus !== 'FAILED' ? session : undefined;
    }
    describe(session) {
        const assistant = $99c71ced7475a049$var$latestAssistant(this.getMessages(session.conversationId));
        if (!assistant || assistant.isAborted || assistant.content.streamingComplete === false) return undefined;
        const { id: id } = assistant.content.message.message;
        if (!id || session.lockedMessages.has(id)) return undefined;
        const pending = $99c71ced7475a049$var$pendingActions(assistant);
        const supported = pending.filter($99c71ced7475a049$var$isSupported);
        if (supported.length !== 1) return undefined;
        const action = supported[0];
        // History hydration may reorder properties or add presentation metadata without
        // changing the proposed operation. Bind approval to execution identity and full data.
        const revision = JSON.stringify({
            key: action.key,
            invocationId: action.invocationId,
            actionId: action.actionId ?? null,
            toolSource: action.toolSource ?? null,
            humanMessageId: action.humanMessageId ?? null,
            usesResumption: $99c71ced7475a049$var$usesResumption(action),
            data: action.data
        }, (_key, value)=>{
            if (!value || typeof value !== 'object' || Array.isArray(value)) return value;
            const record = value;
            return Object.fromEntries(Object.keys(record).sort().map((key)=>[
                    key,
                    record[key]
                ]));
        });
        // A same-window transport must not give consumers mutable references into the chat store.
        return {
            messageId: id,
            action: JSON.parse(JSON.stringify(action)),
            revision: revision
        };
    }
    hasExactResolution(descriptor, command) {
        const resolution = command.resolution;
        return resolution?.invocationId === descriptor.action.invocationId && (resolution.resolution === 'confirmed' || resolution.resolution === 'cancelled');
    }
    constructor(getMessages, actions, getConversation){
        this.getMessages = getMessages;
        this.actions = actions;
        this.getConversation = getConversation;
        this.sessions = new Map();
        this.recoveries = new Map();
        this.terminalRecoveries = new Map();
        this.recoveryGeneration = 0;
    }
}









var $2VSIF = parcelRequire("2VSIF");

async function $d5be571e0b5700f1$export$ad95f38ada7fa268(command, { createSeededConversation: createSeededConversation, sendMessage: sendMessage }, storeUserMessages, publish, onCreated) {
    let conversationId;
    const openChat = ()=>{
        if (conversationId) {
            // Never send the prompt twice when creation succeeded but sending failed.
            publish({
                type: 'chat-open',
                source: command.source,
                data: {
                    channelId: conversationId
                }
            });
            return;
        }
        publish({
            type: 'chat-new',
            source: command.source,
            openChat: true,
            consumeOnce: true,
            data: {
                agentId: command.agentId,
                name: command.name,
                sourceId: command.sourceId,
                tags: command.tags,
                ...command.commentMentionContext ? {
                    commentMentionContext: command.commentMentionContext
                } : {},
                prompt: command.prompt,
                dialogues: [],
                mode: {
                    useCurrentPageContext: command.useCurrentPageContext
                }
            }
        });
    };
    try {
        conversationId = await createSeededConversation({
            name: command.name,
            sourceId: command.sourceId,
            tags: command.tags,
            dialogues: [],
            agentId: command.agentId,
            followUpSource: command.source,
            selectConversation: false,
            mode: {
                useCurrentPageContext: command.useCurrentPageContext
            }
        });
        if (!conversationId) {
            (0, $hlvTd.addSentryBreadcrumb)('Background comment invocation: seeded conversation unavailable');
            openChat();
            return;
        }
        onCreated?.({
            sourceId: command.sourceId,
            conversationId: conversationId,
            agentId: command.agentId
        });
        if ((0, $2VSIF.isConversationCancelled)(conversationId)) return;
        // An explicit ID leaves any visible Chat conversation alone. Deliberately omit the
        // inline-input stream hook: CAP supplies comment progress and action handoff instead.
        await sendMessage({
            conversationId: conversationId,
            prompt: (0, $6rwn6.encodeAdf)(command.prompt),
            storeUserMessages: storeUserMessages,
            agentId: command.agentId,
            agentName: command.agentName,
            agentNamedId: command.agentNamedId,
            agentIdentityAccountId: command.agentIdentityAccountId,
            isThirdPartyAgent: command.isThirdPartyAgent,
            productKey: command.productKey,
            source: command.source,
            messageSources: {
                interactionSource: 'followUps',
                followUpSource: command.source
            },
            addCurrentPageAsContextUserPreference: command.useCurrentPageContext,
            ...command.commentMentionContext ? {
                commentMentionContext: command.commentMentionContext
            } : {}
        });
    } catch  {
        // Chat still handles some send errors internally; only escaping errors reach this fallback.
        (0, $hlvTd.addSentryBreadcrumb)('Background comment invocation failed; opening visible Chat');
        openChat();
    }
}
























var $aYC8J = parcelRequire("aYC8J");








var $2zvMw = parcelRequire("2zvMw");


var $jgLU9 = parcelRequire("jgLU9");


var $9jFb0 = parcelRequire("9jFb0");


var $2lEwc = parcelRequire("2lEwc");


var $i35QN = parcelRequire("i35QN");





var $3Ak5G = parcelRequire("3Ak5G");








var $dE5YE = parcelRequire("dE5YE");


var $jkAry = parcelRequire("jkAry");

const $4a71479a1e1aaf2c$var$UNKNOWN_AGENT_TYPE = 'unknown';
function $4a71479a1e1aaf2c$export$cb00071f594190c2(sendCommand, { contentId: contentId, groupId: groupId, traceId: traceId }) {
    const resolvedContentId = contentId || (0, $jkAry.getCurrentPageId)();
    if (!resolvedContentId) return;
    sendCommand((0, $dE5YE.ConfluenceUpdatePageCommand), {
        agentType: $4a71479a1e1aaf2c$var$UNKNOWN_AGENT_TYPE,
        key: (0, $aYC8J.IMAGE_CREATE_KEY),
        agentId: undefined,
        data: {
            __isError: true
        },
        isStreamComplete: false,
        receiverId: (0, $5OXoi.getConfluenceEditorClientId)(resolvedContentId),
        groupId: groupId,
        buffer: false,
        traceId: traceId
    });
}


const $c1435cb431a8c757$export$ef93491bca821fa2 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(34);
    const { sendCommand: sendCommand } = (0, $3Ak5G.useBridgeSendCommand)();
    const [t0] = (0, $gzMZq.useChatContextEditorContext)();
    let t1;
    if ($[0] !== t0) {
        t1 = t0 === undefined ? {} : t0;
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const { isViewMode: editorIsViewMode } = t1;
    const publish = (0, $hdBxM.usePublish)("ai-mate");
    const { mounted: mounted } = (0, $bGNkz.useUIStore)();
    const { elements: elements } = (0, $dSCNl.useUIConfig)();
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = new Set();
        $[2] = t2;
    } else t2 = $[2];
    const publishedMessagesRef = (0, $cozmU.useRef)(t2);
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = new Set();
        $[3] = t3;
    } else t3 = $[3];
    const messagesWithUpdateActionsRef = (0, $cozmU.useRef)(t3);
    elements?.stagingAreaEnabled;
    const stagingAreaEnabled = elements?.stagingAreaEnabled;
    let t4;
    if ($[4] !== mounted || $[5] !== publish || $[6] !== stagingAreaEnabled) {
        t4 = (conversationId, messageId, openChat)=>{
            if (!publishedMessagesRef.current.has(messageId) && !mounted && !stagingAreaEnabled) {
                publishedMessagesRef.current.add(messageId);
                publish({
                    type: "chat-open",
                    source: "input-prompt-box",
                    openChat: openChat,
                    data: {
                        channelId: conversationId
                    }
                });
            }
        };
        $[4] = mounted;
        $[5] = publish;
        $[6] = stagingAreaEnabled;
        $[7] = t4;
    } else t4 = $[7];
    const publishChatOpen = t4;
    let t5;
    if ($[8] !== mounted || $[9] !== publish || $[10] !== stagingAreaEnabled) {
        t5 = (conversationId_0, messageId_0)=>{
            if (!publishedMessagesRef.current.has(messageId_0) && !mounted && !stagingAreaEnabled) {
                publishedMessagesRef.current.add(messageId_0);
                publish({
                    type: "open-smart-creation-modal",
                    source: "input-prompt-box",
                    openChat: false,
                    data: {
                        channelId: conversationId_0,
                        entryPoint: "dynamicUiFromInlineEditorToolbarAskRovo",
                        stagingAreaActive: true,
                        isFloating: true,
                        shouldShowBackButton: false
                    }
                });
            }
        };
        $[8] = mounted;
        $[9] = publish;
        $[10] = stagingAreaEnabled;
        $[11] = t5;
    } else t5 = $[11];
    const publishEphemeralPreviewOpen = t5;
    let t6;
    if ($[12] !== sendCommand) {
        t6 = (t7, invocationId)=>{
            const { message: message } = t7;
            const command = sendCommand((0, $i35QN.InlineInputBoxTraceMessageCommand), {
                message: message,
                receiverId: (0, $2zvMw.ROVO_INLINE_INPUT_BOX_CLIENT_ID),
                groupId: invocationId,
                buffer: false
            });
            return command.result();
        };
        $[12] = sendCommand;
        $[13] = t6;
    } else t6 = $[13];
    const onTraceMessage = t6;
    let t7;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = (action, messageId_1)=>new Promise((resolve)=>{
                if (!(0, $i7OAD.isEphemeralCreateAction)(action.message) && (0, $i7OAD.isUpdatableAction)(action.message)) messagesWithUpdateActionsRef.current.add(messageId_1);
                resolve();
            });
        $[14] = t7;
    } else t7 = $[14];
    const onActionComplete = t7;
    let t8;
    if ($[15] !== editorIsViewMode || $[16] !== publishChatOpen || $[17] !== publishEphemeralPreviewOpen) {
        t8 = (actionPart, messageId_2, conversationId_1, openChat_0)=>new Promise((resolve_0)=>{
                if ((0, $i7OAD.isEphemeralCreateAction)(actionPart.message)) {
                    if (!editorIsViewMode && (0, $iDrrr.fg)("cc-maui-phase-2")) messagesWithUpdateActionsRef.current.add(messageId_2);
                    else publishEphemeralPreviewOpen(conversationId_1, messageId_2);
                } else if ((0, $i7OAD.isUpdatableAction)(actionPart.message)) messagesWithUpdateActionsRef.current.add(messageId_2);
                else publishChatOpen(conversationId_1, messageId_2, openChat_0);
                resolve_0();
            });
        $[15] = editorIsViewMode;
        $[16] = publishChatOpen;
        $[17] = publishEphemeralPreviewOpen;
        $[18] = t8;
    } else t8 = $[18];
    const onActionPart = t8;
    let t9;
    if ($[19] !== publishChatOpen) {
        t9 = (_, messageId_3, conversationId_2, openChat_1)=>new Promise((resolve_1)=>{
                if (!messagesWithUpdateActionsRef.current.has(messageId_3)) publishChatOpen(conversationId_2, messageId_3, (0, $4o0zT.isExperimentEnabled)("platform_editor_agent_mentions_nudge_indication") ? openChat_1 : undefined);
                resolve_1();
            });
        $[19] = publishChatOpen;
        $[20] = t9;
    } else t9 = $[20];
    const onAnswerPart = t9;
    let t10;
    if ($[21] !== sendCommand) {
        t10 = (response, invocationId_0)=>{
            const command_0 = sendCommand((0, $2lEwc.InlineInputBoxFinalResponseMessageCommand), {
                receiverId: (0, $2zvMw.ROVO_INLINE_INPUT_BOX_CLIENT_ID),
                groupId: invocationId_0,
                buffer: false
            });
            messagesWithUpdateActionsRef.current.delete(invocationId_0);
            return command_0.result();
        };
        $[21] = sendCommand;
        $[22] = t10;
    } else t10 = $[22];
    const onFinalResponse = t10;
    let t11;
    if ($[23] !== sendCommand) {
        t11 = (error, invocationId_1, options)=>{
            if ("message" in error && error.message && typeof error.message === "object" && "key" in error.message && error.message.key === (0, $aYC8J.IMAGE_CREATE_KEY)) {
                const errorData = "data" in error.message ? error.message.data : undefined;
                (0, $4a71479a1e1aaf2c$export$cb00071f594190c2)(sendCommand, {
                    contentId: errorData?.contentId,
                    groupId: invocationId_1,
                    traceId: options?.traceId
                });
            }
            const command_1 = sendCommand((0, $9jFb0.InlineInputBoxErrorMessageCommand), {
                error: {
                    message: error.message,
                    metadata: error.metadata
                },
                receiverId: (0, $2zvMw.ROVO_INLINE_INPUT_BOX_CLIENT_ID),
                groupId: invocationId_1,
                buffer: false,
                openChatOnError: options?.openChatOnError,
                conversationId: options?.conversationId
            });
            messagesWithUpdateActionsRef.current.delete(invocationId_1);
            return command_1.result();
        };
        $[23] = sendCommand;
        $[24] = t11;
    } else t11 = $[24];
    const onError = t11;
    let t12;
    if ($[25] !== sendCommand) {
        t12 = (invocationId_2, inlineRovoEditAttemptId)=>{
            sendCommand((0, $jgLU9.InlineInputBoxAbortedMessageCommand), {
                receiverId: (0, $2zvMw.ROVO_INLINE_INPUT_BOX_CLIENT_ID),
                groupId: invocationId_2,
                buffer: false,
                inlineRovoEditAttemptId: inlineRovoEditAttemptId
            });
        };
        $[25] = sendCommand;
        $[26] = t12;
    } else t12 = $[26];
    const onAbort = t12;
    let t13;
    if ($[27] !== onAbort || $[28] !== onActionPart || $[29] !== onAnswerPart || $[30] !== onError || $[31] !== onFinalResponse || $[32] !== onTraceMessage) {
        t13 = {
            onTraceMessage: onTraceMessage,
            onActionPart: onActionPart,
            onActionComplete: onActionComplete,
            onAnswerPart: onAnswerPart,
            onFinalResponse: onFinalResponse,
            onError: onError,
            onAbort: onAbort
        };
        $[27] = onAbort;
        $[28] = onActionPart;
        $[29] = onAnswerPart;
        $[30] = onError;
        $[31] = onFinalResponse;
        $[32] = onTraceMessage;
        $[33] = t13;
    } else t13 = $[33];
    return t13;
} : ()=>{
    const { sendCommand: sendCommand } = (0, $3Ak5G.useBridgeSendCommand)();
    const [{ isViewMode: editorIsViewMode } = {}] = (0, $gzMZq.useChatContextEditorContext)();
    const publish = (0, $hdBxM.usePublish)('ai-mate');
    const { mounted: mounted } = (0, $bGNkz.useUIStore)();
    const { elements: elements } = (0, $dSCNl.useUIConfig)();
    // Track which messages have already called publish to avoid duplicate calls
    const publishedMessagesRef = (0, $cozmU.useRef)(new Set());
    // Track which messages have update actions to prevent processing publishChatOpen
    const messagesWithUpdateActionsRef = (0, $cozmU.useRef)(new Set());
    const stagingAreaEnabled = (0, $cozmU.useMemo)(()=>elements?.stagingAreaEnabled, [
        elements?.stagingAreaEnabled
    ]);
    const publishChatOpen = (0, $cozmU.useCallback)((conversationId, messageId, openChat)=>{
        if (!publishedMessagesRef.current.has(messageId) && !mounted && !stagingAreaEnabled) {
            publishedMessagesRef.current.add(messageId);
            publish({
                type: 'chat-open',
                source: 'input-prompt-box',
                openChat: openChat,
                data: {
                    channelId: conversationId
                }
            });
        }
    }, [
        publish,
        stagingAreaEnabled,
        mounted
    ]);
    const publishEphemeralPreviewOpen = (0, $cozmU.useCallback)((conversationId_0, messageId_0)=>{
        if (!publishedMessagesRef.current.has(messageId_0) && !mounted && !stagingAreaEnabled) {
            publishedMessagesRef.current.add(messageId_0);
            publish({
                type: 'open-smart-creation-modal',
                source: 'input-prompt-box',
                openChat: false,
                data: {
                    channelId: conversationId_0,
                    entryPoint: 'dynamicUiFromInlineEditorToolbarAskRovo',
                    stagingAreaActive: true,
                    isFloating: true,
                    shouldShowBackButton: false
                }
            });
        }
    }, [
        publish,
        stagingAreaEnabled,
        mounted
    ]);
    const onTraceMessage = (0, $cozmU.useCallback)(({ message: message }, invocationId)=>{
        const command = sendCommand((0, $i35QN.InlineInputBoxTraceMessageCommand), {
            message: message,
            receiverId: (0, $2zvMw.ROVO_INLINE_INPUT_BOX_CLIENT_ID),
            groupId: invocationId,
            buffer: false
        });
        return command.result();
    }, [
        sendCommand
    ]);
    const onActionComplete = (0, $cozmU.useCallback)((action, messageId_1)=>{
        return new Promise((resolve)=>{
            // Backend-persisted edits stream no incremental action parts, so completion is the
            // only signal that the document was updated before the answer arrives.
            // Ephemeral create actions are left to the action part flow, which opens a preview.
            if (!(0, $i7OAD.isEphemeralCreateAction)(action.message) && (0, $i7OAD.isUpdatableAction)(action.message)) messagesWithUpdateActionsRef.current.add(messageId_1);
            resolve();
        });
    }, []);
    const onActionPart = (0, $cozmU.useCallback)((actionPart, messageId_2, conversationId_1, openChat_0)=>{
        return new Promise((resolve_0)=>{
            // Ephemeral create actions must be checked before update actions, since they are update actions too.
            if ((0, $i7OAD.isEphemeralCreateAction)(actionPart.message)) {
                if (!editorIsViewMode && (0, $iDrrr.fg)('cc-maui-phase-2')) // When phase-2 is enabled and in edit mode, suppress ephemeral preview —
                // the inline editor handles it. In view mode, always open the preview.
                messagesWithUpdateActionsRef.current.add(messageId_2);
                else // When phase-2 is disabled, open the AIFC modal in ephemeral preview mode
                publishEphemeralPreviewOpen(conversationId_1, messageId_2);
            } else if ((0, $i7OAD.isUpdatableAction)(actionPart.message)) // Temporary Patch to not open Rovo Chat on update actions
            messagesWithUpdateActionsRef.current.add(messageId_2);
            else publishChatOpen(conversationId_1, messageId_2, openChat_0);
            resolve_0();
        });
    }, [
        publishChatOpen,
        publishEphemeralPreviewOpen,
        editorIsViewMode
    ]);
    const onAnswerPart = (0, $cozmU.useCallback)((_, messageId_3, conversationId_2, openChat_1)=>{
        return new Promise((resolve_1)=>{
            if (!messagesWithUpdateActionsRef.current.has(messageId_3)) publishChatOpen(conversationId_2, messageId_3, (0, $4o0zT.isExperimentEnabled)('platform_editor_agent_mentions_nudge_indication') ? openChat_1 : undefined);
            resolve_1();
        });
    }, [
        publishChatOpen
    ]);
    const onFinalResponse = (0, $cozmU.useCallback)((response, invocationId_0)=>{
        const command_0 = sendCommand((0, $2lEwc.InlineInputBoxFinalResponseMessageCommand), {
            receiverId: (0, $2zvMw.ROVO_INLINE_INPUT_BOX_CLIENT_ID),
            groupId: invocationId_0,
            buffer: false
        });
        // Clean up message tracking for this invocation
        messagesWithUpdateActionsRef.current.delete(invocationId_0);
        return command_0.result();
    }, [
        sendCommand
    ]);
    const onError = (0, $cozmU.useCallback)((error, invocationId_1, options)=>{
        // If the error is for an image-create action, signal the editor bridge to
        // clear the AI generating state from the existing image node
        if ('message' in error && error.message && typeof error.message === 'object' && 'key' in error.message && error.message.key === (0, $aYC8J.IMAGE_CREATE_KEY)) {
            const errorData = 'data' in error.message ? error.message.data : undefined;
            (0, $4a71479a1e1aaf2c$export$cb00071f594190c2)(sendCommand, {
                contentId: errorData?.contentId,
                groupId: invocationId_1,
                traceId: options?.traceId
            });
        }
        const command_1 = sendCommand((0, $9jFb0.InlineInputBoxErrorMessageCommand), {
            error: {
                message: error.message,
                metadata: error.metadata
            },
            receiverId: (0, $2zvMw.ROVO_INLINE_INPUT_BOX_CLIENT_ID),
            groupId: invocationId_1,
            buffer: false,
            openChatOnError: options?.openChatOnError,
            conversationId: options?.conversationId
        });
        // Clean up message tracking for this invocation
        messagesWithUpdateActionsRef.current.delete(invocationId_1);
        return command_1.result();
    }, [
        sendCommand
    ]);
    const onAbort = (0, $cozmU.useCallback)((invocationId_2, inlineRovoEditAttemptId)=>{
        // Sent in both cohorts of `cc_ce_mau_inline_rovo_edit_sync_abort`, so the inline input box
        // can fire balanced exposure for eligible aborts. It only acts on them in treatment.
        sendCommand((0, $jgLU9.InlineInputBoxAbortedMessageCommand), {
            receiverId: (0, $2zvMw.ROVO_INLINE_INPUT_BOX_CLIENT_ID),
            groupId: invocationId_2,
            buffer: false,
            inlineRovoEditAttemptId: inlineRovoEditAttemptId
        });
    }, [
        sendCommand
    ]);
    return (0, $cozmU.useMemo)(()=>({
            onTraceMessage: onTraceMessage,
            onActionPart: onActionPart,
            onActionComplete: onActionComplete,
            onAnswerPart: onAnswerPart,
            onFinalResponse: onFinalResponse,
            onError: onError,
            onAbort: onAbort
        }), [
        onTraceMessage,
        onActionPart,
        onActionComplete,
        onAnswerPart,
        onFinalResponse,
        onError,
        onAbort
    ]);
};


const $cd23f59678a0acda$export$4ae751989dace185 = ()=>{
    const publish = (0, $hdBxM.usePublish)('ai-mate');
    const [{ status: status }] = (0, $k4g8h.useChatSignals)();
    const statusRef = (0, $cozmU.useRef)(status);
    statusRef.current = status;
    const [{ currentConversationId: currentConversationId, conversations: conversations }] = (0, $n71o5.useChatStore)();
    const currentConversationIdRef = (0, $cozmU.useRef)(currentConversationId);
    currentConversationIdRef.current = currentConversationId;
    const currentConversationRef = (0, $cozmU.useRef)(currentConversationId ? conversations[currentConversationId] : undefined);
    currentConversationRef.current = currentConversationId ? conversations[currentConversationId] : undefined;
    const { sendMessage: sendMessage, abortRequests: abortRequests, createSeededConversation: createSeededConversation, sendMessageConfirmedTools: sendMessageConfirmedTools, resolveConversationAction: resolveConversationAction, warmConversationCache: warmConversationCache, setConversationData: setConversationData } = (0, $3TxKn.useChatStoreActions)();
    const { getChatMode: getChatMode } = (0, $aJU2k.useChatModeStoreActions)();
    const { productKey: productKey } = (0, $eKjv9.useGlobalConfig)();
    const { browserContextSanitizer: browserContextSanitizer } = (0, $dSCNl.useUIConfig)();
    const { preferences: preferences } = (0, $lTU4O.useUserPreferences)();
    const { storeUserMessages: storeUserMessages } = preferences;
    const confirmedToolsContextRef = (0, $cozmU.useRef)({
        getChatMode: getChatMode,
        sendMessageConfirmedTools: sendMessageConfirmedTools,
        productKey: productKey,
        browserContextSanitizer: browserContextSanitizer,
        storeUserMessages: storeUserMessages
    });
    confirmedToolsContextRef.current = {
        getChatMode: getChatMode,
        sendMessageConfirmedTools: sendMessageConfirmedTools,
        productKey: productKey,
        browserContextSanitizer: browserContextSanitizer,
        storeUserMessages: storeUserMessages
    };
    const sendBackgroundConfirmedTools = (params)=>{
        const context = confirmedToolsContextRef.current;
        const chatMode = context.getChatMode(params.conversationId ?? '');
        return context.sendMessageConfirmedTools({
            ...params,
            storeUserMessages: context.storeUserMessages,
            webSearchEnabled: chatMode.webSearchEnabled,
            deepResearchEnabled: chatMode.deepResearchEnabled,
            thinkDeeperEnabled: chatMode.thinkDeeperEnabled,
            conciergeEnabled: chatMode.conciergeEnabled,
            alphaExtendedThinkingMode: chatMode.alphaExtendedThinkingMode,
            fastModeEnabled: chatMode.fastModeEnabled,
            taskModeEnabled: chatMode.taskModeEnabled,
            productKey: context.productKey,
            addCurrentPageAsContextUserPreference: chatMode.useCurrentPageContext,
            browserContextSanitizer: context.browserContextSanitizer
        });
    };
    const { getTarget: getTarget, getContentContext: getContentContext, getCurrentTargetId: getCurrentTargetId, setTarget: setTarget, clearTarget: clearTarget, getActiveContext: getActiveContext, setCurrentTargetId: setCurrentTargetId } = (0, $gzMZq.useChatContextStoreActions)();
    const { setPreviewSelection: setPreviewSelection } = (0, $8akfd.useStagingAreaActions)();
    const promptStreamHook = (0, $c1435cb431a8c757$export$ef93491bca821fa2)();
    const experienceTracker = (0, $bjY3F.useAIMateExperienceTracker)();
    const { trackAIMAUEvent: trackAIMAUEvent } = (0, $Ou0Zz.useAnalytics)();
    const { registerCopy: registerCopy } = (0, $lulv8.useCopyPasteAdopted)({
        usePersistentPasteListener: true
    });
    const [messageIdSelectedForPreview] = (0, $8akfd.useMessageIdSelectedForPreview)();
    const { stagingAreaEntryPoint: stagingAreaEntryPoint, invocationIdSelectedForPreview: invocationIdSelectedForPreview } = (0, $8akfd.useStagingAreaState)();
    const { getMessages: getMessages } = (0, $iW40i.useChatMessagesActions)();
    const backgroundActionsCoordinatorRef = (0, $cozmU.useRef)(undefined);
    if (!backgroundActionsCoordinatorRef.current) backgroundActionsCoordinatorRef.current = new (0, $99c71ced7475a049$export$b4901a24ae3e40f)(getMessages, {
        sendMessageConfirmedTools: sendBackgroundConfirmedTools,
        resolveConversationAction: resolveConversationAction,
        warmConversationCache: warmConversationCache,
        setConversationData: setConversationData
    }, // Recovery runs after cache hydration, so read the store at command time rather than render time.
    (conversationId)=>(0, $c6StJ.defaultRegistry).getStore((0, $lx3cN.chatStore)).storeState.getState().conversations[conversationId]);
    const isMountedRef = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        isMountedRef.current = true;
        return ()=>{
            isMountedRef.current = false;
            backgroundActionsCoordinatorRef.current?.clear();
        };
    }, []);
    const messageIdSelectedForPreviewRef = (0, $cozmU.useRef)(messageIdSelectedForPreview);
    messageIdSelectedForPreviewRef.current = messageIdSelectedForPreview;
    const invocationIdSelectedForPreviewRef = (0, $cozmU.useRef)(invocationIdSelectedForPreview);
    invocationIdSelectedForPreviewRef.current = invocationIdSelectedForPreview;
    const stagingAreaEntryPointRef = (0, $cozmU.useRef)(stagingAreaEntryPoint);
    stagingAreaEntryPointRef.current = stagingAreaEntryPoint;
    const trackAIMAUEventRef = (0, $cozmU.useRef)(trackAIMAUEvent);
    trackAIMAUEventRef.current = trackAIMAUEvent;
    const bridgeAPI = (0, $85mU8.getBrowserBridgeAPI)();
    const isFirstInlineMessageOnGlobalContent = (0, $cozmU.useRef)(false);
    const storeUserMessagesRef = (0, $cozmU.useRef)(storeUserMessages);
    storeUserMessagesRef.current = storeUserMessages;
    (0, $cozmU.useEffect)(()=>{
        // we don't want to clash between the rovo chat client which is offered and implemented in desktop
        // and web; in a future iteration, we will re-use the below code in desktop itself.
        if ((0, $95cHD.isWebviewContext)()) return;
        bridgeAPI.on((0, $5Tn11.ROVO_CHAT_CLIENT_ID), (0, $2BLI8.ContentReadyCommand), (command)=>{
            const ctx = command.contentContext;
            setTarget(ctx, {
                id: command.contentId,
                type: command.contentType,
                canProvideContext: command.canProvideContext
            });
            const currentContext = getActiveContext();
            isFirstInlineMessageOnGlobalContent.current = currentContext === 'global';
            // Mark this content as the active target for staging-area context.
            // This ensures broadcasts and follow-up messages use the correct content
            // even if the modal re-sets the page target.
            if ((ctx === 'staging-area' || currentContext === 'staging-area') && (0, $ieeJu.expValEquals)('cc-maui-experiment', 'isEnabled', true)) setCurrentTargetId(command.contentId);
        });
        bridgeAPI.on((0, $5Tn11.ROVO_CHAT_CLIENT_ID), (0, $2BLI8.ContentDestroyCommand), (command_0)=>{
            const ctx_0 = command_0.contentContext;
            // Targets are stored as arrays; clear by specific ID for the target content.
            clearTarget(ctx_0, command_0.contentId);
            // ContentDestroyCommand means this content no longer exists, so if currentTargetId was
            // pointing at it, release it here too — otherwise it outlives the content it names and
            // the next page's SPA navigation reads from a bridge that no longer exists. This can't
            // live inside clearTarget itself: other callers (e.g.
            // conversation-assistant-blank-object-experience) clear a target using the same id
            // currentTargetId still legitimately points at when content graduates to a real page
            // rather than being destroyed, so only a caller that specifically means "gone" can
            // safely make this call.
            if (getCurrentTargetId() === command_0.contentId && (0, $4o0zT.isExperimentEnabled)('aifc_creation_context_stale_target_fix')) setCurrentTargetId(undefined);
            const currentContext_0 = getActiveContext();
            isFirstInlineMessageOnGlobalContent.current = currentContext_0 === 'global';
        });
        bridgeAPI.on((0, $5Tn11.ROVO_CHAT_CLIENT_ID), (0, $dlR4F.StartBackgroundAgentConversationCommand), (command_1)=>{
            if (!(0, $4o0zT.isExperimentEnabled)('platform_editor_inline_agentic_comments') || statusRef.current !== 'online' || !command_1.prompt || !command_1.agentId) return false;
            (0, $d5be571e0b5700f1$export$ad95f38ada7fa268)(command_1, {
                createSeededConversation: createSeededConversation,
                sendMessage: sendMessage
            }, storeUserMessagesRef.current, publish, (session)=>{
                if (isMountedRef.current) backgroundActionsCoordinatorRef.current?.register(session);
            });
            return true;
        });
        bridgeAPI.on((0, $5Tn11.ROVO_CHAT_CLIENT_ID), (0, $a6gXC.GetBackgroundConversationActionsCommand), (command_2)=>{
            if (!(0, $4o0zT.isExperimentEnabled)('platform_editor_inline_agentic_comments')) return undefined;
            return backgroundActionsCoordinatorRef.current?.get(command_2.sourceId, command_2.conversationId, command_2.commentId);
        });
        bridgeAPI.on((0, $5Tn11.ROVO_CHAT_CLIENT_ID), (0, $a6gXC.ResolveBackgroundConversationActionsCommand), (command_3)=>{
            if (!(0, $4o0zT.isExperimentEnabled)('platform_editor_inline_agentic_comments')) return {
                status: 'stale'
            };
            return backgroundActionsCoordinatorRef.current?.resolve(command_3) ?? {
                status: 'stale'
            };
        });
        bridgeAPI.on((0, $5Tn11.ROVO_CHAT_CLIENT_ID), (0, $3MoJD.InlineInputBoxSendMessageCommand), (command_4)=>{
            if (!command_4.prompt || !command_4.contentId) return;
            setCurrentTargetId(command_4.contentId);
            const encodedPrompt = command_4.skillMetadata ? (0, $6rwn6.encodePromptToAdf)(command_4.prompt, command_4.skillMetadata).adf : (0, $6rwn6.encodeAdf)(command_4.prompt);
            const reusesMatchingDefaultRovoConversation = command_4.reuseMatchingConversation && (0, $2yWJZ.isDefaultRovoChat)({
                agentId: currentConversationRef.current?.agent?.agent_id,
                agentNamedId: currentConversationRef.current?.agent?.agent_named_id
            });
            sendMessage({
                ...command_4,
                prompt: encodedPrompt,
                // TODO(ai_mate_store_messages_be_driven): remove this local storeUserMessages payload
                // value when BE user settings are fully rolled out; BE overrides it via the capability header.
                storeUserMessages: storeUserMessagesRef.current,
                promptStreamHook: promptStreamHook,
                messageSources: {
                    interactionSource: command_4.source === 'CONFLUENCE_MAUI_INLINE_EDITOR' ? 'inlineRovoFromRemix' : 'inlineRovo',
                    followUpSource: command_4.source === 'CONFLUENCE_MAUI_INLINE_EDITOR' ? 'inlineRovoFromRemix' : 'inlineRovo',
                    // Mark the Create with Rovo blank-object route on AIMAU events.
                    entryPoint: command_4.source === 'CONFLUENCE_CWR_BLANK_OBJECT' ? 'cwrBlankObject' : undefined
                },
                // Using an explicitly selected agent with inline prompt should always start a new chat,
                // unless a scoped default-Rovo request already has a matching Rovo conversation.
                // The first inline prompt message on a new content ID should always start a new chat.
                conversationId: command_4.agentId && !reusesMatchingDefaultRovoConversation || command_4.shouldStartNewConversation || isFirstInlineMessageOnGlobalContent.current ? (0, $4m5jb.EMPTY_CONVERSATION_ID) : undefined
            });
            isFirstInlineMessageOnGlobalContent.current = false;
        });
        bridgeAPI.on((0, $5Tn11.ROVO_CHAT_CLIENT_ID), (0, $6yHkF.InlineInputBoxAbortMessageCommand), (command_5)=>{
            abortRequests({
                conversationId: command_5.conversationId ?? currentConversationIdRef.current
            });
            if ((0, $ieeJu.expValEquals)('platform_editor_remove_pause_streaming', 'isEnabled', true)) {
                const currentTargetId = getCurrentTargetId();
                const currentTargetContext = currentTargetId ? getContentContext(currentTargetId) ?? getActiveContext() : getActiveContext();
                const activeTarget = getTarget(currentTargetContext, currentTargetId);
                const activeTargetType = activeTarget?.type;
                if (activeTarget?.id && activeTargetType === 'page') (0, $e4efc8cb7e22be34$export$ff6a2981a5436d75)((0, $jb3zd.StreamLifecycleState).ABORTED, `inline-abort-${Date.now()}`, {
                    id: activeTarget.id,
                    type: activeTargetType
                });
            }
            experienceTracker.abort({
                name: (0, $irnO2.ExperienceName).REMIX_REGENERATE,
                reason: 'User cancelled remix thinking'
            });
        });
        bridgeAPI.on((0, $5Tn11.ROVO_CHAT_CLIENT_ID), (0, $8gcBG.AifcExperienceTrackingCommand), (command_6)=>{
            if (!command_6?.status || !command_6.experienceName) return;
            const featureArea = command_6.attributes?.featureArea;
            if (command_6.status === 'start') {
                const attributes = {
                    ...command_6.attributes || {},
                    ...featureArea !== undefined && {
                        featureArea: featureArea
                    },
                    ...command_6.actionType && {
                        actionType: command_6.actionType
                    },
                    ...command_6.actionId && {
                        actionId: command_6.actionId
                    },
                    ...command_6.contentContext && {
                        contentContext: command_6.contentContext
                    },
                    ...command_6.dynamicUiSubtype && {
                        dynamicUiSubtype: command_6.dynamicUiSubtype
                    },
                    ...command_6.remixType && {
                        remixType: command_6.remixType
                    },
                    ...command_6.remixSubtype && {
                        remixSubtype: command_6.remixSubtype
                    },
                    ...currentConversationIdRef.current && {
                        conversationChannelId: currentConversationIdRef.current
                    }
                };
                let collect;
                // Collect callbacks have to be constructed parent-side because functions are
                // not serializable and cannot be sent over the bridge as command payload data.
                switch(command_6.experienceName){
                    case (0, $irnO2.ExperienceName).REMIX_REGENERATE:
                        collect = (0, $d91d74abbb95cf45$export$a9538f4db585a467)({
                            conversationChannelId: currentConversationIdRef.current,
                            regenerateSource: command_6.attributes?.regenerateSource,
                            featureArea: featureArea,
                            allowCollectFallback: true,
                            targetIds: {
                                actionId: command_6.actionId ?? undefined,
                                selectionLocalId: command_6.actionId ?? undefined
                            }
                        });
                        break;
                    default:
                        break;
                }
                experienceTracker.start({
                    name: command_6.experienceName,
                    id: command_6.messageId ?? command_6.actionId ?? command_6.experienceName,
                    attributes: attributes,
                    ...collect ? {
                        collect: collect
                    } : {}
                });
            } else if (command_6.status === 'success') experienceTracker.succeed({
                name: command_6.experienceName,
                ...command_6.messageId && {
                    id: command_6.messageId
                },
                attributes: {
                    ...command_6.attributes || {},
                    ...featureArea !== undefined && {
                        featureArea: featureArea
                    },
                    ...command_6.actionType && {
                        actionType: command_6.actionType
                    },
                    ...command_6.actionId && {
                        actionId: command_6.actionId
                    },
                    ...command_6.contentContext && {
                        contentContext: command_6.contentContext
                    },
                    ...command_6.dynamicUiSubtype && {
                        dynamicUiSubtype: command_6.dynamicUiSubtype
                    },
                    ...command_6.remixType && {
                        remixType: command_6.remixType
                    },
                    ...command_6.remixSubtype && {
                        remixSubtype: command_6.remixSubtype
                    },
                    ...command_6.isSafetyViolation && {
                        isSafetyViolation: command_6.isSafetyViolation
                    }
                }
            });
            else if (command_6.status === 'fail') experienceTracker.fail({
                name: command_6.experienceName,
                ...command_6.messageId && {
                    id: command_6.messageId
                },
                error: new Error(command_6.error ?? 'Unknown error'),
                attributes: {
                    ...command_6.attributes || {},
                    ...featureArea !== undefined && {
                        featureArea: featureArea
                    },
                    ...command_6.actionType && {
                        actionType: command_6.actionType
                    },
                    ...command_6.actionId && {
                        actionId: command_6.actionId
                    },
                    ...command_6.contentContext && {
                        contentContext: command_6.contentContext
                    },
                    ...command_6.dynamicUiSubtype && {
                        dynamicUiSubtype: command_6.dynamicUiSubtype
                    },
                    ...command_6.remixType && {
                        remixType: command_6.remixType
                    },
                    ...command_6.remixSubtype && {
                        remixSubtype: command_6.remixSubtype
                    }
                }
            });
            else if (command_6.status === 'abort') {
                const isKillswitchEnabled = (0, $cXtTj.default).getExperimentValue('platform_aifc_bridge_experience_tracker_fix_aborts', 'value', false);
                const attributes_0 = {
                    ...command_6.attributes || {},
                    ...featureArea !== undefined && {
                        featureArea: featureArea
                    },
                    ...command_6.actionType && {
                        actionType: command_6.actionType
                    },
                    ...command_6.actionId && {
                        actionId: command_6.actionId
                    },
                    ...command_6.contentContext && {
                        contentContext: command_6.contentContext
                    },
                    ...command_6.dynamicUiSubtype && {
                        dynamicUiSubtype: command_6.dynamicUiSubtype
                    }
                };
                if (isKillswitchEnabled) experienceTracker.fail({
                    name: command_6.experienceName,
                    ...command_6.messageId && {
                        id: command_6.messageId
                    },
                    error: new Error(command_6.reason ?? 'Aborted'),
                    attributes: attributes_0
                });
                else experienceTracker.abort({
                    name: command_6.experienceName,
                    ...command_6.messageId && {
                        id: command_6.messageId
                    },
                    reason: command_6.reason ?? 'Aborted',
                    attributes: attributes_0
                });
            }
        });
        bridgeAPI.on((0, $5Tn11.ROVO_CHAT_CLIENT_ID), (0, $2YoG8.SmartCreationModalActivatedCommand), (command_7)=>{
            setTarget('staging-area', {
                id: command_7.type,
                // Currently, there is only Jira is using this Command and Jira doesn't have a content id for the smart creation modal
                type: command_7.type,
                canProvideContext: true
            });
        });
        bridgeAPI.on((0, $5Tn11.ROVO_CHAT_CLIENT_ID), (0, $2YoG8.SmartCreationModalDeactivatedCommand), (command_8)=>{
            if (getTarget('staging-area')?.id === command_8.type) {
                clearTarget('staging-area', command_8.type);
                setPreviewSelection(undefined);
                if ((0, $ieeJu.expValEquals)('cc-maui-experiment', 'isEnabled', true)) setCurrentTargetId(undefined);
            }
        });
        bridgeAPI.on((0, $5Tn11.ROVO_CHAT_CLIENT_ID), (0, $ah4h4.AifcStagingSelectionStateCommand), (command_9)=>{
            setPreviewSelection({
                hasSelection: command_9.hasSelection
            });
        });
        bridgeAPI.on((0, $5Tn11.ROVO_CHAT_CLIENT_ID), (0, $j1J3n.AifcContentCopiedCommand), (command_10)=>{
            const messages = getMessages(currentConversationIdRef.current ?? '');
            const isPreviewActionCorrelationAnalyticsEnabled = (0, $iDrrr.fg)('aifc_preview_action_correlation_analytics');
            // Match preview resolution: an invocation selection takes priority over a message selection.
            const selectedMessage = invocationIdSelectedForPreviewRef.current ? (0, $i7OAD.findMessageByInvocationId)(messages, invocationIdSelectedForPreviewRef.current) : messages.find((message)=>(0, $igOtY.isStoreAssistant)(message) && message.content.message.message.id === messageIdSelectedForPreviewRef.current);
            const selectedActions = selectedMessage?.content.message.message.actions ?? [];
            const selectedAction = invocationIdSelectedForPreviewRef.current ? (0, $c7So7.resolvePreviewAction)(selectedMessage, invocationIdSelectedForPreviewRef.current) : selectedActions.find((action)=>(0, $gYfOr.getActionContentId)(action) === command_10.contentId);
            const analyticsMessageId = isPreviewActionCorrelationAnalyticsEnabled ? selectedMessage?.content.message.message.id ?? messageIdSelectedForPreviewRef.current ?? undefined : messageIdSelectedForPreviewRef.current ?? undefined;
            const selectedActionKey = selectedAction?.key;
            const shouldIncludeCwrAnalyticsUpdates = (0, $iDrrr.fg)('cwr_ai_result_analytics_updates');
            const selectedActionForCorrelation = isPreviewActionCorrelationAnalyticsEnabled && invocationIdSelectedForPreviewRef.current ? selectedMessage?.content.message.message.actions?.find((action_0)=>action_0.invocationId === invocationIdSelectedForPreviewRef.current) : undefined;
            let requestId;
            let traceId;
            if ((0, $iDrrr.fg)('aifc_request_id_analytics') || (0, $iDrrr.fg)('aifc_trace_id_analytics')) {
                if (selectedMessage) {
                    traceId = selectedMessage.traceId;
                    requestId = selectedMessage.content.metadata?.request_id ?? selectedMessage.content.message.message.message_metadata?.requestId;
                }
            }
            const askQuestionAttributes = (0, $lUXDc.getConfluenceResultAcceptanceAttributesForAskQuestion)({
                messages: getMessages(currentConversationIdRef.current ?? ''),
                contentId: command_10.contentId
            });
            trackAIMAUEventRef.current({
                type: 'actioned',
                actionResult: 'copy',
                source: 'AIMate',
                invokedFrom: 'AIFC',
                proactive: false,
                userGenerated: true,
                singleInstrumentationID: analyticsMessageId,
                ...shouldIncludeCwrAnalyticsUpdates && selectedActionKey ? {
                    messageActions: [
                        selectedActionKey
                    ]
                } : {},
                attributes: {
                    ...(0, $iDrrr.fg)('aifc_request_id_analytics') && requestId ? {
                        request_id: requestId
                    } : {},
                    ...(0, $iDrrr.fg)('aifc_trace_id_analytics') && traceId ? {
                        trace_id: traceId
                    } : {},
                    ...selectedActionForCorrelation?.key ? {
                        actionKey: selectedActionForCorrelation.key
                    } : {},
                    isInSmartCreateFlow: true,
                    createdContentProduct: 'confluence',
                    createdContentType: command_10.contentType,
                    copiedCharCount: command_10.copiedCharCount,
                    copiedWordCount: command_10.copiedWordCount,
                    totalDocCharCount: command_10.totalDocCharCount,
                    copiedPercentage: command_10.copiedPercentage,
                    entryPoint: stagingAreaEntryPointRef.current || undefined,
                    ...(0, $xHMAX.getGeneratedVisualBlockCounts)(selectedAction?.data),
                    ...shouldIncludeCwrAnalyticsUpdates && selectedActionKey ? {
                        actionKey: selectedActionKey,
                        userConfirmedActions: [
                            {
                                actionKey: selectedActionKey,
                                objectId: command_10.contentId
                            }
                        ]
                    } : {},
                    ...askQuestionAttributes ?? {}
                }
            });
            if (shouldIncludeCwrAnalyticsUpdates && selectedActionKey) registerCopy({
                messageId: analyticsMessageId,
                analyticsMessageActions: [
                    selectedActionKey
                ],
                trackAIMAUEvent: trackAIMAUEventRef.current,
                deferClipboardReadToNextTask: true
            });
        });
        // handlers have been setup - now we can mark ourselves as 'ready' to handle incoming messages
        bridgeAPI.ready((0, $5Tn11.ROVO_CHAT_CLIENT_ID));
        return ()=>{
            // Unregister the background-conversation handlers on effect restart or unmount.
            bridgeAPI.off((0, $5Tn11.ROVO_CHAT_CLIENT_ID), (0, $dlR4F.StartBackgroundAgentConversationCommand));
            bridgeAPI.off((0, $5Tn11.ROVO_CHAT_CLIENT_ID), (0, $a6gXC.GetBackgroundConversationActionsCommand));
            bridgeAPI.off((0, $5Tn11.ROVO_CHAT_CLIENT_ID), (0, $a6gXC.ResolveBackgroundConversationActionsCommand));
        };
    }, [
        bridgeAPI,
        publish,
        createSeededConversation,
        sendMessage,
        abortRequests,
        promptStreamHook,
        setTarget,
        clearTarget,
        getTarget,
        getContentContext,
        getCurrentTargetId,
        getActiveContext,
        setCurrentTargetId,
        setPreviewSelection,
        experienceTracker,
        currentConversationId,
        getMessages,
        registerCopy
    ]);
    return null;
};



var $j8on0 = parcelRequire("j8on0");








var $4tJut = parcelRequire("4tJut");





var $7eGGZ = parcelRequire("7eGGZ");




const $1dee8c8ed79f4a5c$var$INITIAL_LOAD_THROTTLE_MS = 500;
// Keyed by the store's `getState`. Every container sharing the global store receives the same getState.
const $1dee8c8ed79f4a5c$var$initialLoads = new WeakMap();
const $1dee8c8ed79f4a5c$export$d2d149ac6e45741c = ()=>async ({ getState: getState, dispatch: dispatch }, { siteId: siteId })=>{
        const initialLoad = $1dee8c8ed79f4a5c$var$initialLoads.get(getState);
        if (initialLoad?.siteId === siteId) {
            // Already a fetch in progress
            if (initialLoad.request) return initialLoad.request;
            // Already had a fetch complete within the throttle window
            if (initialLoad.settledAt !== undefined && Date.now() - initialLoad.settledAt < $1dee8c8ed79f4a5c$var$INITIAL_LOAD_THROTTLE_MS) return;
        }
        const request = dispatch((0, $7eGGZ.fetchConversationChannelsData)({
            isInitialLoad: true
        }));
        $1dee8c8ed79f4a5c$var$initialLoads.set(getState, {
            siteId: siteId,
            request: request
        });
        try {
            await request;
        } finally{
            if ($1dee8c8ed79f4a5c$var$initialLoads.get(getState)?.request === request) $1dee8c8ed79f4a5c$var$initialLoads.set(getState, {
                siteId: siteId,
                settledAt: Date.now()
            });
        }
    };



var $dHz2q = parcelRequire("dHz2q");


var $3z1p5 = parcelRequire("3z1p5");





var $5SS4O = parcelRequire("5SS4O");





var $8OiFS = parcelRequire("8OiFS");

const $af50a3081521b9ff$export$ca0820b729763025 = ({ siteId: siteId })=>async ({ setState: setState, dispatch: dispatch }, { setConversationError: setConversationError })=>{
        (0, $hlvTd.addSentryBreadcrumb)('resetChatStoresForSite: clearing chat state for the new site');
        await dispatch((0, $8OiFS.abortRequests)());
        setState({
            ...(0, $4m5jb.createInitialChatState)(),
            liveChatMetadata: null,
            hydratedSiteId: siteId
        });
        setConversationError(undefined);
        (0, $3z1p5.resetAgentStores)();
        (0, $5SS4O.clearQueryCache)();
    };


/**
 * ************************************************************
 * Container
 * ************************************************************
 */ const $07964e27dfae7b36$var$storeInit = ()=>async ({ dispatch: dispatch, getState: getState, setState: setState }, { setChatStatus: setChatStatus, skipAutoConversationSelection: skipAutoConversationSelection, siteId: siteId, forceRestoreConversationId: forceRestoreConversationId })=>{
        (0, $hlvTd.addSentryBreadcrumb)('ChatStoreContainer: storeInit');
        setChatStatus('launching');
        const isSiteSwitchResetEnabled = (0, $iDrrr.fg)('rovo_chat_site_switch_reset');
        const previousSiteId = getState().hydratedSiteId;
        const isSiteChange = isSiteSwitchResetEnabled && Boolean(siteId) && previousSiteId !== undefined && previousSiteId !== siteId;
        if (isSiteSwitchResetEnabled) Promise.resolve().then(()=>{
            setState({
                hydratedSiteId: siteId
            });
        });
        // Init conversation hydrates the chat store with conversation from URL or Storage
        // and fetches conversations list (however, fetching conversations list is performed "in the background")
        // conversations list is fetched to be later on displayed in the sidebar/conversation list to remove/minimize
        // visual delay when user opens the side-navigation; or in full-screen mode to fetch conversations as early as possible;
        const initConversation = async ()=>{
            if (isSiteChange) await dispatch((0, $af50a3081521b9ff$export$ca0820b729763025)({
                siteId: siteId
            }));
            dispatch((0, $dHz2q.hydrateConversationWithExternalParams)({
                autoSelectConversation: !skipAutoConversationSelection,
                forceRestoreConversationId: forceRestoreConversationId
            }));
            (0, $4tJut.interactionMetrics).initializeChannels.start();
            if ((0, $iDrrr.fg)('rovo_chat_dedupe_initial_conversations_fetch')) await dispatch((0, $1dee8c8ed79f4a5c$export$d2d149ac6e45741c)());
            else await dispatch((0, $7eGGZ.fetchConversationChannelsData)({
                isInitialLoad: true
            }));
            (0, $4tJut.interactionMetrics).initializeChannels.stop();
        };
        initConversation();
        (0, $hlvTd.addSentryBreadcrumb)('ChatStoreContainer: storeInit completed');
    };
const $07964e27dfae7b36$var$storeInitOnUpdate = ()=>async ({ getState: getState, setState: setState, dispatch: dispatch }, { siteId: siteId })=>{
        if (!(0, $iDrrr.fg)('rovo_chat_site_switch_reset')) return;
        const { hydratedSiteId: hydratedSiteId } = getState();
        if (!siteId || siteId === hydratedSiteId) return;
        await Promise.resolve();
        if (getState().hydratedSiteId === siteId) return;
        setState({
            hydratedSiteId: siteId
        });
        if (hydratedSiteId === undefined) return;
        (0, $hlvTd.addSentryBreadcrumb)('ChatStoreContainer: site changed, re-initialising chat');
        await dispatch((0, $af50a3081521b9ff$export$ca0820b729763025)({
            siteId: siteId
        }));
        await dispatch($07964e27dfae7b36$var$storeInit());
    };
const $07964e27dfae7b36$var$chatStoreContainerOptions = {
    onInit: $07964e27dfae7b36$var$storeInit,
    onUpdate: $07964e27dfae7b36$var$storeInitOnUpdate
};
const $07964e27dfae7b36$export$9b7b433b0520b82b = (0, $j8on0.createContainer)((0, $lx3cN.chatStore), $07964e27dfae7b36$var$chatStoreContainerOptions);



var $kYruZ = parcelRequire("kYruZ");





var $1FOPM = parcelRequire("1FOPM");


var $ipkS0 = parcelRequire("ipkS0");

const $ccc7a37bcb1eb3eb$export$a04da3780397ecbb = (0, $cozmU.lazy)((0, $ipkS0.trackReactLazy)("rl-20P1_l", ()=>(0, $1FOPM.importConversationAssistantUI)().then((module)=>({
            default: module.ConversationAssistantUI
        }))));









var $cha5E = parcelRequire("cha5E");





var $iA8l9 = parcelRequire("iA8l9");


var $aQWBL = parcelRequire("aQWBL");





var $hOUgz = parcelRequire("hOUgz");


























var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $d59150c4763cb391$var$initialReconnectionState = {
    isReconnecting: false,
    messageId: null
};
const $d59150c4763cb391$var$initialState = {
    reconnections: {}
};
const $d59150c4763cb391$var$store = (0, $8s9DV.createStore)({
    name: 'rovoReconnect',
    initialState: $d59150c4763cb391$var$initialState,
    actions: {
        startReconnection: (conversationId, messageId)=>({ getState: getState, setState: setState })=>{
                const state = getState();
                // Guard: already reconnecting
                if (state.reconnections[conversationId]?.isReconnecting) return false;
                setState({
                    reconnections: {
                        ...state.reconnections,
                        [conversationId]: {
                            isReconnecting: true,
                            messageId: messageId
                        }
                    }
                });
                return true;
            },
        endReconnection: (conversationId)=>({ getState: getState, setState: setState })=>{
                const state = getState();
                setState({
                    reconnections: {
                        ...state.reconnections,
                        [conversationId]: $d59150c4763cb391$var$initialReconnectionState
                    }
                });
            },
        isReconnecting: (conversationId)=>({ getState: getState })=>{
                return getState().reconnections[conversationId]?.isReconnecting ?? false;
            }
    }
});
const $d59150c4763cb391$export$2d5e21bcae15bf2 = (0, $kBr4q.createHook)($d59150c4763cb391$var$store);
const $d59150c4763cb391$export$bec843ddf321b89b = (0, $kBr4q.createActionsHook)($d59150c4763cb391$var$store);
const $d59150c4763cb391$export$489be5bbb9bfa3f2 = (0, $kBr4q.createHook)($d59150c4763cb391$var$store, {
    selector: (state, conversationId)=>state.reconnections[conversationId] ?? $d59150c4763cb391$var$initialReconnectionState
});









var $9qJ1N = parcelRequire("9qJ1N");


var $8VrqA = parcelRequire("8VrqA");


var $12shJ = parcelRequire("12shJ");








var $cgxs9 = parcelRequire("cgxs9");

const $bd4e57972be9e4ca$export$e0427dd13bcccf1b = ()=>{
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const capabilities = (0, $cozmU.useMemo)(()=>[
            'ask-question-enabled',
            'interaction-conclusion-v1',
            ...(0, $iDrrr.fg)('rovo_chat_enable_inline_lumina') ? [
                'inline_lumina_enabled'
            ] : [],
            // Not in the service-level GATED_CAPABILITIES, which would opt in callers that
            // don't handle typed Answer UI events.
            ...(0, $cgxs9.isAnswerUiPartsEnabled)() ? [
                'answer_ui_parts_v1'
            ] : [],
            'tool_resumption_enabled',
            'actionable-follow-ups-stacked'
        ], // fg() values are static at runtime — gates don't change between renders
    []);
    return capabilities;
};












var $20Kr8 = parcelRequire("20Kr8");

const $e2d7843b3ff1bcdd$export$47f0b7e1efb22e0f = (0, $gtMdU.isReactCompilerActivePlatform)() ? function BackBehaviorOverrideProvider(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { children: children } = t0;
    const [override, setOverride] = (0, $cozmU.useState)(null);
    let t1;
    if ($[0] !== override) {
        t1 = {
            override: override,
            setOverride: setOverride
        };
        $[0] = override;
        $[1] = t1;
    } else t1 = $[1];
    const value = t1;
    let t2;
    if ($[2] !== children || $[3] !== value) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $20Kr8.BackBehaviorOverrideContext).Provider, {
            value: value
        }, children);
        $[2] = children;
        $[3] = value;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : function BackBehaviorOverrideProvider({ children: children }) {
    const [override, setOverride] = (0, $cozmU.useState)(null);
    const value = (0, $cozmU.useMemo)(()=>({
            override: override,
            setOverride: setOverride
        }), [
        override
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $20Kr8.BackBehaviorOverrideContext).Provider, {
        value: value
    }, children);
};












var $hJC44 = parcelRequire("hJC44");

const $83df2c4d369ade6b$export$1ea8b76066893345 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { showFlag: showFlag, children: children } = t0;
    let t1;
    if ($[0] !== children || $[1] !== showFlag) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hJC44.default).Provider, {
            value: showFlag
        }, children);
        $[0] = children;
        $[1] = showFlag;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ showFlag: showFlag, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hJC44.default).Provider, {
        value: showFlag
    }, children);












var $kSwu1 = parcelRequire("kSwu1");


var $4MnFz = parcelRequire("4MnFz");


var $24dy7 = parcelRequire("24dy7");


var $8KiU9 = parcelRequire("8KiU9");


var $idzM5 = parcelRequire("idzM5");

const $55592f6773d96032$export$4610738c067a7645 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(3);
    const { showFlag: showFlagFromFlags } = (0, $4MnFz.useFlags)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t0;
    if ($[0] !== formatMessage || $[1] !== showFlagFromFlags) {
        t0 = (flagId)=>{
            bb2: switch(flagId){
                case (0, $idzM5.StoreErrorFlagId).CONVERSATION_FORBIDDEN:
                    showFlagFromFlags({
                        id: "conversation-assistant.conversation-forbidden",
                        title: formatMessage((0, $8KiU9.default).conversationForbiddenTitle),
                        description: formatMessage((0, $8KiU9.default).conversationForbiddenDescription),
                        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($24dy7))), {
                            color: "var(--ds-icon-danger, #C9372C)",
                            label: ""
                        }),
                        isAutoDismiss: true
                    });
                    break bb2;
                case (0, $idzM5.StoreErrorFlagId).CONVERSATION_HISTORY_LOAD_FAILED:
                    showFlagFromFlags({
                        id: "conversation-assistant.conversation-history-load-failed",
                        title: formatMessage((0, $8KiU9.default).conversationHistoryLoadFailedTitle),
                        description: formatMessage((0, $8KiU9.default).conversationHistoryLoadFailedDescription),
                        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($24dy7))), {
                            color: "var(--ds-icon-danger, #C9372C)",
                            label: ""
                        }),
                        isAutoDismiss: true
                    });
                    break bb2;
                case (0, $idzM5.StoreErrorFlagId).FOLLOW_UP_AGENT_UNAVAILABLE:
                    showFlagFromFlags({
                        id: "ai-mate.follow-up-agent-unavailable",
                        title: formatMessage((0, $8KiU9.default).followUpAgentUnavailableTitle),
                        description: formatMessage((0, $8KiU9.default).followUpAgentUnavailableDescription),
                        appearance: "error",
                        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($24dy7))), {
                            color: "var(--ds-icon-danger, #C9372C)",
                            label: ""
                        }),
                        isAutoDismiss: true
                    });
            }
        };
        $[0] = formatMessage;
        $[1] = showFlagFromFlags;
        $[2] = t0;
    } else t0 = $[2];
    const showFlag = t0;
    return showFlag;
} : ()=>{
    const { showFlag: showFlagFromFlags } = (0, $4MnFz.useFlags)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const showFlag = (0, $cozmU.useCallback)((flagId)=>{
        switch(flagId){
            case (0, $idzM5.StoreErrorFlagId).CONVERSATION_FORBIDDEN:
                showFlagFromFlags({
                    id: 'conversation-assistant.conversation-forbidden',
                    title: formatMessage((0, $8KiU9.default).conversationForbiddenTitle),
                    description: formatMessage((0, $8KiU9.default).conversationForbiddenDescription),
                    icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($24dy7))), {
                        color: "var(--ds-icon-danger, #C9372C)",
                        label: ""
                    }),
                    isAutoDismiss: true
                });
                break;
            case (0, $idzM5.StoreErrorFlagId).CONVERSATION_HISTORY_LOAD_FAILED:
                showFlagFromFlags({
                    id: 'conversation-assistant.conversation-history-load-failed',
                    title: formatMessage((0, $8KiU9.default).conversationHistoryLoadFailedTitle),
                    description: formatMessage((0, $8KiU9.default).conversationHistoryLoadFailedDescription),
                    icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($24dy7))), {
                        color: "var(--ds-icon-danger, #C9372C)",
                        label: ""
                    }),
                    isAutoDismiss: true
                });
                break;
            case (0, $idzM5.StoreErrorFlagId).FOLLOW_UP_AGENT_UNAVAILABLE:
                showFlagFromFlags({
                    id: 'ai-mate.follow-up-agent-unavailable',
                    title: formatMessage((0, $8KiU9.default).followUpAgentUnavailableTitle),
                    description: formatMessage((0, $8KiU9.default).followUpAgentUnavailableDescription),
                    appearance: 'error',
                    icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($24dy7))), {
                        color: "var(--ds-icon-danger, #C9372C)",
                        label: ""
                    }),
                    isAutoDismiss: true
                });
                break;
        }
    }, [
        showFlagFromFlags,
        formatMessage
    ]);
    return showFlag;
};









var $5BOJB = parcelRequire("5BOJB");








var $4MASx = parcelRequire("4MASx");


var $8vae9 = parcelRequire("8vae9");




const $0e8cab1d0778bbd2$export$4fbf4621651f722d = ()=>{
    const { sendCommand: sendCommand } = (0, $3Ak5G.useBridgeSendCommand)();
    const requestJiraContext = (0, $cozmU.useCallback)(async ()=>{
        try {
            const invocation = await sendCommand((0, $8vae9.JiraContextCommand), {
                receiverId: (0, $4MASx.JIRA_SMART_CREATE_TABLE_CLIENT_ID),
                buffer: false
            });
            return await invocation.result() ?? undefined;
        } catch (error) {
            (0, $hlvTd.logException)({
                exception: error,
                name: 'SendJiraContextCommandError'
            });
            return undefined;
        }
    }, [
        sendCommand
    ]);
    return {
        requestJiraContext: requestJiraContext
    };
};















var $1qXpt = parcelRequire("1qXpt");


var $457kL = parcelRequire("457kL");




const $cb145149c0b90d17$export$46457d11c8328445 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(4);
    const { sendCommand: sendCommand } = (0, $3Ak5G.useBridgeSendCommand)();
    let t0;
    if ($[0] !== sendCommand) {
        t0 = async ()=>{
            try {
                const invocation = await sendCommand((0, $457kL.BrowserContextCommand), {
                    receiverId: (0, $1qXpt.ROVO_EXTENSION_CLIENT_ID),
                    buffer: false
                });
                const result = await invocation.result();
                return result;
            } catch (t1) {
                const error = t1;
                (0, $hlvTd.logException)({
                    exception: error,
                    name: "SendBridgeCommandError"
                });
                return;
            }
        };
        $[0] = sendCommand;
        $[1] = t0;
    } else t0 = $[1];
    const requestBrowserContent = t0;
    let t1;
    if ($[2] !== requestBrowserContent) {
        t1 = {
            requestBrowserContent: requestBrowserContent
        };
        $[2] = requestBrowserContent;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : ()=>{
    const { sendCommand: sendCommand } = (0, $3Ak5G.useBridgeSendCommand)();
    const requestBrowserContent = (0, $cozmU.useCallback)(async ()=>{
        try {
            const invocation = await sendCommand((0, $457kL.BrowserContextCommand), {
                receiverId: (0, $1qXpt.ROVO_EXTENSION_CLIENT_ID),
                buffer: false
            });
            const result = await invocation.result();
            return result;
        } catch (error) {
            (0, $hlvTd.logException)({
                exception: error,
                name: 'SendBridgeCommandError'
            });
            return undefined;
        }
    }, [
        sendCommand
    ]);
    return {
        requestBrowserContent: requestBrowserContent
    };
};


















var $eTCWv = parcelRequire("eTCWv");

















var $1teNl = parcelRequire("1teNl");











var $4Y660 = parcelRequire("4Y660");





var $lzoay = parcelRequire("lzoay");


var $dSoGR = parcelRequire("dSoGR");

const $3198e830c76ae77b$export$afe0f8c15b322bae = (0, $dSoGR.createCommand)('avp-chart-create-command');





const $36224131a47080f4$export$8e7b6355e5c9f9b8 = (0, $dSoGR.createCommand)('avp-chart-delete-command');





const $5c20a362f938841b$export$bf9f3058c24acaf7 = (0, $dSoGR.createCommand)('avp-chart-update-command');





const $2d7555c6a20a6e0d$export$30119ee169641415 = (0, $dSoGR.createCommand)('avp_dashboard_remove_element');





const $33b1e48b44bef4bc$export$1043d497905355c5 = (0, $dSoGR.createCommand)('avp_dashboard_remove_row');





const $a7e4d48d0be08f3f$export$60aa7d56c60ccf3 = (0, $dSoGR.createCommand)('avp-filter-expression-create-command');





const $75314bd107214525$export$8bcde83747cc4995 = (0, $dSoGR.createCommand)('avp-filter-expression-delete-command');





const $913d8206dd988764$export$70ff4e7a2a918421 = (0, $dSoGR.createCommand)('avp-filter-expression-update-command');



var $1HNcu = parcelRequire("1HNcu");


var $hwIq7 = parcelRequire("hwIq7");




const $9304f1c94bc0e75e$export$41fae3f948f80e82 = (0, $dSoGR.createCommand)('confluence-slides-create-command');



var $eDZUH = parcelRequire("eDZUH");


var $iL3p7 = parcelRequire("iL3p7");


var $6HplX = parcelRequire("6HplX");


var $3elg8 = parcelRequire("3elg8");


var $kFVAr = parcelRequire("kFVAr");







const $c835c164f3a5f5c5$export$1e1d6631b3e74025 = (0, $dSoGR.createCommand)('confluence-slides-update-command');



var $jd9s8 = parcelRequire("jd9s8");


var $joJ6c = parcelRequire("joJ6c");


var $j0orF = parcelRequire("j0orF");


var $irHFv = parcelRequire("irHFv");


var $1r5s7 = parcelRequire("1r5s7");


var $l3qz4 = parcelRequire("l3qz4");


var $2xH7b = parcelRequire("2xH7b");














var $2xjCL = parcelRequire("2xjCL");







const $3d563edd0e5ff26e$export$1fbbb7c0119badfd = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $85mU8.getBrowserBridgeAPI)();
        $[0] = t0;
    } else t0 = $[0];
    const bridgeAPI = t0;
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (command, params)=>{
            const paramsWithRovoSenderId = {
                ...params,
                senderId: (0, $5Tn11.ROVO_CHAT_CLIENT_ID)
            };
            return bridgeAPI.broadcast(command, paramsWithRovoSenderId, {
                filter: (0, $2xjCL.isRovoBroadcastConfirmedActions)
            });
        };
        $[1] = t1;
    } else t1 = $[1];
    const broadcastConfirmedActionCommand = t1;
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {
            broadcastConfirmedActionCommand: broadcastConfirmedActionCommand
        };
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : ()=>{
    const bridgeAPI = (0, $85mU8.getBrowserBridgeAPI)();
    const broadcastConfirmedActionCommand = (0, $cozmU.useCallback)((command, params)=>{
        const paramsWithRovoSenderId = {
            ...params,
            senderId: (0, $5Tn11.ROVO_CHAT_CLIENT_ID)
        };
        return bridgeAPI.broadcast(command, paramsWithRovoSenderId, {
            filter: (0, $2xjCL.isRovoBroadcastConfirmedActions)
        });
    }, [
        bridgeAPI
    ]);
    return {
        broadcastConfirmedActionCommand: broadcastConfirmedActionCommand
    };
};







var $jIWEY = parcelRequire("jIWEY");

// Shape-only diagnostics for blank AIFC database rows. AFM only sends the
// `document`; this records its shape at stream completion, never its raw content.
// At or below this length a finalized `document` is treated as effectively blank.
const $1f143c6f1fbb4300$var$BLANK_DOCUMENT_LENGTH_THRESHOLD = 2;
// The database `document` is XML-tagged CSV: a `<fields>` block (header
// `field_name,type,configuration` + one line per column) then data rows.
const $1f143c6f1fbb4300$var$FIELDS_OPEN_TAG = '<fields>';
const $1f143c6f1fbb4300$var$FIELDS_CLOSE_TAG = '</fields>';
const $1f143c6f1fbb4300$var$FIELDS_HEADER = 'field_name,type,configuration';
const $1f143c6f1fbb4300$var$firstNonWhitespaceChar = (value)=>{
    const match = value.match(/\S/);
    return match ? match[0] : null;
};
const $1f143c6f1fbb4300$var$isBlankDocument = (rawDocument)=>rawDocument.trim().length <= $1f143c6f1fbb4300$var$BLANK_DOCUMENT_LENGTH_THRESHOLD;
const $1f143c6f1fbb4300$var$extractBlock = (rawDocument, openTag, closeTag)=>{
    const start = rawDocument.indexOf(openTag);
    if (start === -1) return null;
    const end = rawDocument.indexOf(closeTag, start + openTag.length);
    if (end === -1) return null;
    return rawDocument.slice(start + openTag.length, end);
};
const $1f143c6f1fbb4300$var$nonEmptyLines = (block)=>block.split('\n').map((line)=>line.trim()).filter((line)=>line.length > 0);
/** Splits a CSV line into cells, respecting simple double-quoted fields. */ const $1f143c6f1fbb4300$var$splitCsvLine = (line)=>{
    const cells = [];
    let current = '';
    let inQuotes = false;
    for (const char of line){
        if (char === '"') inQuotes = !inQuotes;
        else if (char === ',' && !inQuotes) {
            cells.push(current);
            current = '';
        } else current += char;
    }
    cells.push(current);
    return cells;
};
/** True when every cell in the row is blank. */ const $1f143c6f1fbb4300$var$rowHasNoValues = (line)=>$1f143c6f1fbb4300$var$splitCsvLine(line).every((cell)=>cell.trim().length === 0);
const $1f143c6f1fbb4300$export$dd8651a13acea708 = (rawDocument, contentId)=>{
    const firstChar = $1f143c6f1fbb4300$var$firstNonWhitespaceChar(rawDocument);
    const base = {
        source: 'aifcDatabaseDocumentCategory',
        documentLength: String(rawDocument.length),
        contentId: contentId
    };
    const build = (category, fieldCount = 0, dataRowCount = 0, emptyDataRowCount = 0)=>({
            ...base,
            category: category,
            fieldCount: String(fieldCount),
            dataRowCount: String(dataRowCount),
            emptyDataRowCount: String(emptyDataRowCount)
        });
    if ($1f143c6f1fbb4300$var$isBlankDocument(rawDocument)) return build('emptyDocument');
    if (firstChar === ',') return build('commaPrefixed');
    const fieldsBlock = $1f143c6f1fbb4300$var$extractBlock(rawDocument, $1f143c6f1fbb4300$var$FIELDS_OPEN_TAG, $1f143c6f1fbb4300$var$FIELDS_CLOSE_TAG);
    if (fieldsBlock === null) return build('missingFieldsBlock');
    const fieldsLines = $1f143c6f1fbb4300$var$nonEmptyLines(fieldsBlock);
    if (fieldsLines.length === 0 || fieldsLines[0] !== $1f143c6f1fbb4300$var$FIELDS_HEADER) return build('malformedFieldsHeader');
    const fieldCount = fieldsLines.length - 1; // exclude the header line
    if (fieldCount === 0) return build('malformedFieldsHeader', fieldCount);
    // Data rows: non-empty, non-XML-tag lines after the </fields> tag.
    const afterFields = rawDocument.slice(rawDocument.indexOf($1f143c6f1fbb4300$var$FIELDS_CLOSE_TAG) + $1f143c6f1fbb4300$var$FIELDS_CLOSE_TAG.length);
    const dataLines = $1f143c6f1fbb4300$var$nonEmptyLines(afterFields).filter((line)=>!line.startsWith('<') && !line.startsWith('</'));
    if (dataLines.length === 0) return build('noDataRows', fieldCount);
    const emptyDataRowCount = dataLines.filter($1f143c6f1fbb4300$var$rowHasNoValues).length;
    if (emptyDataRowCount === dataLines.length) return build('emptyDataCells', fieldCount, dataLines.length, emptyDataRowCount);
    const mismatchedRow = dataLines.some((line)=>$1f143c6f1fbb4300$var$splitCsvLine(line).length !== fieldCount);
    if (mismatchedRow) return build('columnCountMismatch', fieldCount, dataLines.length, emptyDataRowCount);
    return build('ok', fieldCount, dataLines.length, emptyDataRowCount);
};





const $571372d50c430197$var$ADDITIONAL_CONTEXT_TIMEOUT_MS = 2000;
const $571372d50c430197$var$getAgentTypeCommandProperties = (agentId)=>({
        agentType: agentId && !(0, $2yWJZ.isDefaultRovoChat)({
            agentId: agentId
        }) ? 'convo-ai' : 'rovo_chat'
    });
const $571372d50c430197$var$isRovoChatEditExperience = (experience)=>experience === 'chat_edit' || experience === 'cwr' || experience === 'cwr_type' || experience === 'cwr_edit';
const $571372d50c430197$var$getCwrRemixInvokedFrom = (experience)=>(0, $dE5YE.isCwrRemixInvokedFrom)(experience) ? experience : undefined;
const $571372d50c430197$var$cloneSerializableValue = (value)=>{
    if (value === undefined || value === null || typeof value !== 'object') return value;
    return typeof window !== 'undefined' && typeof window.structuredClone === 'function' ? window.structuredClone(value) : JSON.parse(JSON.stringify(value));
};
const $571372d50c430197$export$392dcf789ba32ca6 = ()=>{
    const { sendCommand: sendCommand } = (0, $3Ak5G.useBridgeSendCommand)();
    const { broadcastConfirmedActionCommand: broadcastConfirmedActionCommand } = (0, $3d563edd0e5ff26e$export$1fbbb7c0119badfd)();
    const { productKey: productKey, smartCreationContext: smartCreationContext, editorContentIdResolver: editorContentIdResolver } = (0, $eKjv9.useGlobalConfig)();
    const sendBridgeCommand = (0, $cozmU.useCallback)(({ invocationId: invocationId, key: key, data: data, status: status, prompt: prompt, traceId: traceId, requestId: requestId, singleInstrumentationId: singleInstrumentationId, isFinalResponse: isFinalResponse = false, agent: agent, experience: experience, entryPoint: entryPoint, conversationChannelId: conversationChannelId })=>{
        const resolveEditorContentId = (contentId)=>// `||` not `??`: an empty id builds the unroutable `confluence-editor-`, so it must fall through.
            (contentId || undefined) ?? // Falls through unchanged if the resolver has no opinion.
            (editorContentIdResolver?.() || undefined) ?? (productKey !== 'confluence' && (0, $iDrrr.fg)('platform_editor_maui_jira_updates_1') ? smartCreationContext?.editor?.editorId : undefined) ?? (0, $jkAry.getCurrentPageId)();
        try {
            switch(key){
                case 0, $aYC8J.CONFLUENCE_AIFC_WHITEBOARD_TO_PAGE_KEY:
                case 0, $aYC8J.CONFLUENCE_AIFC_PAGE_CREATE_KEY:
                    if ((0, $aYC8J.isConfluenceAIFCPageCreateActionData)(data)) {
                        sendCommand((0, $hwIq7.ConfluencePageCreateCommand), {
                            key: key,
                            data: data,
                            isStreamComplete: isFinalResponse,
                            receiverId: (0, $5OXoi.getConfluenceEditorClientId)(data.contentId),
                            groupId: invocationId,
                            traceId: traceId,
                            singleInstrumentationId: singleInstrumentationId,
                            ...entryPoint !== undefined && {
                                entryPoint: entryPoint
                            },
                            ...conversationChannelId !== undefined && {
                                conversationChannelId: conversationChannelId
                            }
                        });
                        if (status === 'PREPARING' && prompt) sendCommand((0, $3elg8.ConfluenceSubmitPromptOnPageCreateCommand), {
                            receiverId: (0, $5OXoi.getConfluenceEditorClientId)(data.contentId),
                            userPrompt: (0, $jIWEY.extractTextFromDocNode)(prompt)
                        });
                    }
                    break;
                case 0, $aYC8J.AIFC_ADF_UPDATE_KEY:
                    if ((0, $aYC8J.isAIFCADFUpdateActionData)(data)) {
                        const contentId_2 = resolveEditorContentId(data.contentId);
                        if (!contentId_2) break;
                        const cwrRemixInvokedFrom = $571372d50c430197$var$getCwrRemixInvokedFrom(experience);
                        sendCommand((0, $dE5YE.ConfluenceUpdatePageCommand), {
                            key: key,
                            data: data,
                            isStreamComplete: isFinalResponse,
                            receiverId: (0, $5OXoi.getConfluenceEditorClientId)(contentId_2),
                            groupId: invocationId,
                            traceId: traceId,
                            requestId: requestId,
                            singleInstrumentationId: singleInstrumentationId,
                            ...$571372d50c430197$var$getAgentTypeCommandProperties(agent?.id),
                            agentId: agent?.id,
                            agentName: agent?.name,
                            agentIdentityAccountId: agent?.identityAccountId,
                            agentNamedId: agent?.namedId,
                            isThirdParty: agent?.isThirdParty,
                            // Editor Ask Rovo (`inline_edit`) → editor modal Review moment.
                            // Rovo chat (`chat_edit` / CWR) → headless Review moment in chat.
                            isInlineEdit: experience === 'inline_edit',
                            isChatEdit: $571372d50c430197$var$isRovoChatEditExperience(experience),
                            ...(0, $4o0zT.isExperimentEnabled)('platform_editor_cwr_remix_acceptance') && cwrRemixInvokedFrom && {
                                isCwrRemixEdit: true,
                                cwrRemixInvokedFrom: cwrRemixInvokedFrom
                            }
                        });
                    }
                    break;
                case 0, $aYC8J.DYNAMIC_UI_CREATE_KEY:
                case 0, $aYC8J.IMAGE_CREATE_KEY:
                    if ((0, $aYC8J.isDynamicUiUpdateActionData)(data) || (0, $aYC8J.isImageUpdateActionData)(data) || (0, $aYC8J.isImageCreateData)(data)) {
                        const contentId_0 = resolveEditorContentId(data.contentId);
                        if (!contentId_0) break;
                        sendCommand((0, $dE5YE.ConfluenceUpdatePageCommand), {
                            key: key,
                            data: data,
                            isStreamComplete: isFinalResponse,
                            receiverId: (0, $5OXoi.getConfluenceEditorClientId)(contentId_0),
                            groupId: invocationId,
                            traceId: traceId,
                            requestId: requestId,
                            singleInstrumentationId: singleInstrumentationId,
                            ...$571372d50c430197$var$getAgentTypeCommandProperties(agent?.id),
                            ...experience === 'inline_edit' && {
                                isInlineEdit: true
                            },
                            agentId: (0, $iDrrr.fg)('confluence_rovo_update_feedback_agent_filter') ? agent?.id : undefined
                        });
                    } else if (key === (0, $aYC8J.IMAGE_CREATE_KEY) && (0, $aYC8J.isImageUpdatePrepareData)(data) && !isFinalResponse) {
                        const contentId_1 = resolveEditorContentId(data.contentId);
                        if (!contentId_1) break;
                        // ACTION_PREPARE: send partial data to trigger loading state on the existing image
                        sendCommand((0, $dE5YE.ConfluenceUpdatePageCommand), {
                            key: key,
                            data: data,
                            isStreamComplete: false,
                            receiverId: (0, $5OXoi.getConfluenceEditorClientId)(contentId_1),
                            groupId: invocationId,
                            traceId: traceId,
                            requestId: requestId,
                            singleInstrumentationId: singleInstrumentationId,
                            ...$571372d50c430197$var$getAgentTypeCommandProperties(agent?.id),
                            ...experience === 'inline_edit' && {
                                isInlineEdit: true
                            },
                            agentId: (0, $iDrrr.fg)('confluence_rovo_update_feedback_agent_filter') ? agent?.id : undefined
                        });
                    }
                    break;
                case 0, $aYC8J.AIFC_ACTION_CLASSIFICATION_METADATA:
                    if ((0, $iDrrr.fg)('platform_editor_ai_promptversion_in_analytics')) {
                        if ((0, $aYC8J.isAIFCADFSetActionClassificationActionData)(data)) sendCommand((0, $lzoay.ActionClassificationCommand), {
                            data: data,
                            receiverId: (0, $5OXoi.getConfluenceEditorClientId)(data.contentId),
                            groupId: invocationId
                        });
                    }
                    break;
                case 0, $aYC8J.CONFLUENCE_AIFC_DEEP_RESEARCH_PAGE_CREATE_KEY:
                    if ((0, $aYC8J.isConfluenceAIFCDeepResearchPageCreateActionData)(data)) sendCommand((0, $6HplX.ConfluenceDeepResearchPageCreateCommand), {
                        key: key,
                        data: data,
                        isStreamComplete: isFinalResponse,
                        receiverId: (0, $5OXoi.getConfluenceEditorClientId)(data.contentId),
                        groupId: invocationId
                    });
                    // TODO: Remove isConfluenceAIFCDeepResearchPageCreateActionPrepare condition and type once BE fix is in
                    // https://hello.jira.atlassian.cloud/browse/CCI-12965
                    if ((0, $aYC8J.isConfluenceAIFCDeepResearchPageCreateActionPrepare)(data) || (0, $aYC8J.isConfluenceAIFCDeepResearchPageCreateActionData)(data)) {
                        if (status === 'PREPARING' && prompt) sendCommand((0, $3elg8.ConfluenceSubmitPromptOnPageCreateCommand), {
                            receiverId: (0, $5OXoi.getConfluenceEditorClientId)(data?.contentId),
                            userPrompt: (0, $jIWEY.extractTextFromDocNode)(prompt)
                        });
                    }
                    break;
                case 0, $aYC8J.CONFLUENCE_AIFC_WHITEBOARD_CREATE_KEY:
                    if ((0, $aYC8J.isConfluenceAIFCWhiteboardCreateActionData)(data)) {
                        const receiverId_0 = (0, $6isLN.getConfluenceWhiteboardClientId)(data.contentId);
                        sendCommand((0, $iL3p7.ConfluenceWhiteboardCreateCommand), {
                            key: key,
                            data: data,
                            isStreamComplete: isFinalResponse,
                            receiverId: receiverId_0,
                            groupId: invocationId,
                            singleInstrumentationID: singleInstrumentationId
                        });
                    }
                    break;
                case 0, $aYC8J.CONFLUENCE_AIFC_SLIDES_CREATE_KEY:
                    if ((0, $aYC8J.isConfluenceAIFCSlidesCreateActionData)(data)) sendCommand((0, $9304f1c94bc0e75e$export$41fae3f948f80e82), {
                        key: key,
                        data: data,
                        isStreamComplete: isFinalResponse,
                        receiverId: (0, $3wccB.getConfluenceSlidesClientId)(data.contentId),
                        groupId: invocationId,
                        singleInstrumentationID: singleInstrumentationId
                    });
                    break;
                case 0, $aYC8J.CONFLUENCE_AIFC_SLIDES_UPDATE_KEY:
                    if ((0, $aYC8J.isConfluenceAIFCSlidesUpdateActionData)(data)) sendCommand((0, $c835c164f3a5f5c5$export$1e1d6631b3e74025), {
                        key: key,
                        data: data,
                        isStreamComplete: isFinalResponse,
                        receiverId: (0, $3wccB.getConfluenceSlidesClientId)(data.contentId),
                        groupId: invocationId,
                        singleInstrumentationID: singleInstrumentationId
                    });
                    break;
                case 0, $aYC8J.CONFLUENCE_AIFC_DATABASE_CREATE_KEY:
                    if ((0, $aYC8J.isConfluenceAIFCDatabaseCreateActionData)(data)) {
                        // Shape-only blank-row diagnostic; does not change flow.
                        if (isFinalResponse) {
                            const diagnostics = (0, $1f143c6f1fbb4300$export$dd8651a13acea708)(data.document, data.contentId);
                            if (diagnostics.category !== 'ok') (0, $hlvTd.logException)({
                                exception: new Error(`AIFC database create finalized with problematic document: ${diagnostics.category}`),
                                name: 'AifcDatabaseCreateDocumentIssue',
                                tags: diagnostics
                            });
                        }
                        sendCommand((0, $1HNcu.ConfluenceDatabaseCreateCommand), {
                            key: key,
                            data: data,
                            isStreamComplete: isFinalResponse,
                            receiverId: (0, $7lXV4.getConfluenceDatabaseClientId)(data.contentId),
                            groupId: invocationId,
                            singleInstrumentationID: singleInstrumentationId
                        });
                    }
                    break;
                case 0, $aYC8J.CONFLUENCE_AIFC_DATABASE_UPDATE_KEY:
                    if ((0, $aYC8J.isConfluenceAIFCDatabaseUpdateActionData)(data)) sendCommand((0, $kFVAr.ConfluenceDatabaseUpdateCommand), {
                        key: key,
                        data: data,
                        isStreamComplete: isFinalResponse,
                        receiverId: (0, $7lXV4.getConfluenceDatabaseClientId)(data.contentId),
                        groupId: invocationId,
                        singleInstrumentationID: singleInstrumentationId
                    });
                    break;
                case 0, $aYC8J.CONFLUENCE_AIFC_WHITEBOARD_UPDATE_KEY:
                    if ((0, $aYC8J.isConfluenceAIFCWhiteboardUpdateActionData)(data)) sendCommand((0, $joJ6c.ConfluenceWhiteboardUpdateCommand), {
                        key: key,
                        data: data,
                        isStreamComplete: isFinalResponse,
                        receiverId: (0, $6isLN.getConfluenceWhiteboardClientId)(data.contentId),
                        groupId: invocationId,
                        singleInstrumentationID: singleInstrumentationId
                    });
                    break;
                case 0, $aYC8J.CONFLUENCE_WHITEBOARD_BRAINSTORMING_KEY:
                    if ((0, $aYC8J.isConfluenceWhiteboardBrainstormingActionData)(data)) sendCommand((0, $j0orF.ConfluenceWhiteboardBrainstormingCommand), {
                        key: key,
                        data: data,
                        status: status,
                        // Brainst. agent sends `status=SUCCESS` in the last message of the stream to mark end of data
                        isStreamComplete: isFinalResponse,
                        receiverId: (0, $6isLN.getConfluenceWhiteboardClientId)(data.contentId),
                        groupId: invocationId
                    });
                    break;
                case 0, $aYC8J.LEGACY_CONFLUENCE_WHITEBOARD_DIAGRAMMING_KEY:
                    if ((0, $aYC8J.isConfluenceWhiteboardDiagrammingActionData)(data)) sendCommand((0, $irHFv.ConfluenceWhiteboardDiagrammingCommand), {
                        key: key,
                        data: data,
                        status: status,
                        // Diag. agent sends `status=SUCCESS` in the last message of the stream to mark end of data
                        isStreamComplete: isFinalResponse,
                        receiverId: (0, $6isLN.getConfluenceWhiteboardClientId)(data.contentId),
                        groupId: invocationId
                    });
                    break;
                case 0, $aYC8J.AIFC_CONFLUENCE_WHITEBOARD_DIAGRAMMING_KEY:
                    // This new key goes through the new AIFC flow for diagramming
                    // Before we were going through the legacy flow, LEGACY_CONFLUENCE_WHITEBOARD_DIAGRAMMING_KEY
                    if ((0, $aYC8J.isConfluenceAIFCWhiteboardCreateActionData)(data)) {
                        const receiverId = (0, $6isLN.getConfluenceWhiteboardClientId)(data.contentId);
                        sendCommand((0, $iL3p7.ConfluenceWhiteboardCreateCommand), {
                            key: key,
                            data: data,
                            isStreamComplete: isFinalResponse,
                            receiverId: receiverId,
                            groupId: invocationId,
                            singleInstrumentationID: singleInstrumentationId
                        });
                    }
                    break;
                case 0, $aYC8J.CONFLUENCE_AIFC_SPACE_CREATE_KEY:
                    if ((0, $aYC8J.isConfluenceAIFCSpaceCreateActionData)(data)) sendCommand((0, $eDZUH.ConfluenceSpaceCreateCommand), {
                        key: key,
                        data: data,
                        isStreamComplete: isFinalResponse,
                        receiverId: (0, $4Y660.CONFLUENCE_SPACE_CLIENT_ID),
                        groupId: invocationId
                    });
                    break;
                case 0, $aYC8J.CONFLUENCE_AIFC_SPACE_UPDATE_KEY:
                    if ((0, $aYC8J.isConfluenceAIFCSpaceUpdateActionData)(data)) sendCommand((0, $jd9s8.ConfluenceSpaceUpdateCommand), {
                        key: key,
                        data: data,
                        isStreamComplete: isFinalResponse,
                        receiverId: (0, $4Y660.CONFLUENCE_SPACE_CLIENT_ID),
                        groupId: invocationId
                    });
                    break;
                case 0, $eTCWv.AVP_CHART_CREATE_KEY:
                    if ((0, $eTCWv.isAvpChartCreateActionData)(data)) sendCommand((0, $3198e830c76ae77b$export$afe0f8c15b322bae), {
                        key: key,
                        data: data,
                        isStreamComplete: isFinalResponse,
                        receiverId: (0, $1teNl.getAvpDashboardClientId)(data.dashboardAri),
                        groupId: invocationId
                    });
                    break;
                case 0, $eTCWv.AVP_CHART_DELETE_KEY:
                    if ((0, $eTCWv.isAvpChartDeleteActionData)(data)) sendCommand((0, $36224131a47080f4$export$8e7b6355e5c9f9b8), {
                        key: key,
                        data: data,
                        isStreamComplete: isFinalResponse,
                        receiverId: (0, $1teNl.getAvpDashboardClientId)(data.dashboardAri),
                        groupId: invocationId
                    });
                    break;
                case 0, $eTCWv.AVP_CHART_UPDATE_KEY:
                    if ((0, $eTCWv.isAvpChartUpdateActionData)(data)) sendCommand((0, $5c20a362f938841b$export$bf9f3058c24acaf7), {
                        key: key,
                        data: data,
                        isStreamComplete: isFinalResponse,
                        receiverId: (0, $1teNl.getAvpDashboardClientId)(data.dashboardAri),
                        groupId: invocationId
                    });
                    break;
                case 0, $eTCWv.AVP_DASHBOARD_REMOVE_ROW_KEY:
                    if ((0, $eTCWv.isAvpDashboardRemoveRowActionData)(data)) sendCommand((0, $33b1e48b44bef4bc$export$1043d497905355c5), {
                        key: key,
                        data: data,
                        isStreamComplete: isFinalResponse,
                        receiverId: (0, $1teNl.getAvpDashboardClientId)(data.dashboardAri),
                        groupId: invocationId
                    });
                    break;
                case 0, $eTCWv.AVP_DASHBOARD_REMOVE_ELEMENT_KEY:
                    if ((0, $eTCWv.isAvpDashboardRemoveElementActionData)(data)) sendCommand((0, $2d7555c6a20a6e0d$export$30119ee169641415), {
                        key: key,
                        data: data,
                        isStreamComplete: isFinalResponse,
                        receiverId: (0, $1teNl.getAvpDashboardClientId)(data.dashboardAri),
                        groupId: invocationId
                    });
                    break;
                case 0, $eTCWv.AVP_FILTER_EXPRESSION_CREATE_KEY:
                    if ((0, $eTCWv.isAvpFilterExpressionCreateActionData)(data)) sendCommand((0, $a7e4d48d0be08f3f$export$60aa7d56c60ccf3), {
                        key: key,
                        data: data,
                        isStreamComplete: isFinalResponse,
                        receiverId: (0, $1teNl.getAvpDashboardClientId)(data.dashboardAri),
                        groupId: invocationId
                    });
                    break;
                case 0, $eTCWv.AVP_FILTER_EXPRESSION_DELETE_KEY:
                    if ((0, $eTCWv.isAvpFilterExpressionDeleteActionData)(data)) sendCommand((0, $75314bd107214525$export$8bcde83747cc4995), {
                        key: key,
                        data: data,
                        isStreamComplete: isFinalResponse,
                        receiverId: (0, $1teNl.getAvpDashboardClientId)(data.dashboardAri),
                        groupId: invocationId
                    });
                    break;
                case 0, $eTCWv.AVP_FILTER_EXPRESSION_UPDATE_KEY:
                    if ((0, $eTCWv.isAvpFilterExpressionUpdateActionData)(data)) sendCommand((0, $913d8206dd988764$export$70ff4e7a2a918421), {
                        key: key,
                        data: data,
                        isStreamComplete: isFinalResponse,
                        receiverId: (0, $1teNl.getAvpDashboardClientId)(data.dashboardAri),
                        groupId: invocationId
                    });
                    break;
                default:
                    (0, $hlvTd.logException)({
                        exception: new Error(`Unsupported action key: ${key}`),
                        name: 'SendBridgeCommandUnsupportedActionKey'
                    });
                    break;
            }
        } catch (error) {
            (0, $hlvTd.logException)({
                exception: error,
                name: 'SendBridgeCommandError'
            });
        }
    }, [
        sendCommand,
        productKey,
        smartCreationContext,
        editorContentIdResolver
    ]);
    // receiver
    const processMessageStreamAction = (0, $cozmU.useCallback)((invocationId_0, streamAction, agent_0, traceId_0, requestId_0, prompt_0, attributes)=>{
        const { message: action } = streamAction;
        if (!(0, $i7OAD.isSupportedStreamAction)(action)) return;
        // serverSideExecution persists content server-side and the iframe loads it by contentId. no FE based streaming
        if ((0, $aYC8J.isServerSideExecutionAction)(action) && ((0, $cXtTj.default).getExperimentValue('cwr-be-based-multi-creation-v0', 'isEnabled', false) || (0, $iDrrr.fg)('cwr-be-based-multi-creation-v0-missing-apps'))) return;
        sendBridgeCommand({
            invocationId: invocationId_0,
            key: action.key,
            data: action.data,
            status: action.status,
            prompt: prompt_0,
            isFinalResponse: false,
            traceId: traceId_0,
            requestId: requestId_0,
            singleInstrumentationId: attributes?.singleInstrumentationId,
            agent: agent_0,
            experience: attributes?.experience
        });
    }, [
        sendBridgeCommand
    ]);
    const processMessageStreamComplete = (0, $cozmU.useCallback)((invocationId_1, streamAction_0, agent_1, traceId_1, requestId_1, attributes_0)=>{
        const { message: action_0 } = streamAction_0;
        if (!(0, $i7OAD.isSupportedStreamAction)(action_0)) return;
        // serverSideExecution persists content server-side and the iframe loads it by contentId. no FE based streaming
        if ((0, $aYC8J.isServerSideExecutionAction)(action_0) && ((0, $cXtTj.default).getExperimentValue('cwr-be-based-multi-creation-v0', 'isEnabled', false) || (0, $iDrrr.fg)('cwr-be-based-multi-creation-v0-missing-apps'))) return;
        // metadata is only available on ACTION_COMPLETE for editing remix.
        if (action_0.key === 'dynamic-ui-create' || action_0.key === 'image-create') {
            (0, $irnO2.remixEditExistingExperience).mark((0, $irnO2.REMIX_EDIT_EXISTING_MARKS).ACTION_COMPLETE_RECEIVED);
            const actionData = action_0.data;
            // marking image create to infographic to be same as generating preview
            if (action_0.key === 'image-create') (0, $irnO2.remixEditExistingExperience).addMetadata({
                remixType: 'infographic'
            });
            else (0, $irnO2.remixEditExistingExperience).addMetadata({
                remixType: actionData?.contentType,
                remixSubtype: actionData?.dynamicUiSubtype
            });
        }
        sendBridgeCommand({
            invocationId: invocationId_1,
            key: action_0.key,
            data: action_0.data,
            isFinalResponse: true,
            traceId: traceId_1,
            requestId: requestId_1,
            singleInstrumentationId: attributes_0?.singleInstrumentationId,
            agent: (0, $iDrrr.fg)('confluence_rovo_update_feedback_agent_filter') ? agent_1 : undefined,
            experience: attributes_0?.experience,
            entryPoint: attributes_0?.entryPoint,
            conversationChannelId: attributes_0?.conversationChannelId
        });
    }, [
        sendBridgeCommand
    ]);
    const processMessageStreamError = (0, $cozmU.useCallback)((errorInfo)=>{
        // Fail the remix-edit-existing UFO experience when the stream errors.
        // .failure() is a no-op on a non-started experience, so this is safe
        // for non-remix-edit-existing flows.
        if (errorInfo.actionKey === 'dynamic-ui-create' || errorInfo.actionKey === 'image-create') (0, $irnO2.remixEditExistingExperience).failure({
            metadata: {
                errorType: errorInfo.errorType,
                errorMessage: errorInfo.errorMessage,
                traceId: errorInfo.traceId
            }
        });
    }, []);
    const processMessageStreamActionClassification = (0, $cozmU.useCallback)((invocationId_2, streamActionClassification, agent_2, traceId_2, requestId_2, attributes_1)=>{
        if (streamActionClassification.message.metadata && (0, $iDrrr.fg)('platform_editor_ai_promptversion_in_analytics')) sendBridgeCommand({
            invocationId: invocationId_2,
            key: (0, $aYC8J.AIFC_ACTION_CLASSIFICATION_METADATA),
            agent: agent_2,
            data: streamActionClassification.message.metadata,
            isFinalResponse: false,
            traceId: traceId_2,
            requestId: requestId_2,
            singleInstrumentationId: attributes_1?.singleInstrumentationId
        });
    }, [
        sendBridgeCommand
    ]);
    /**
   * Broadcasts confirmed message actions to subscribed clients.
   *
   * Iterates over the provided list of actions, and for each action that is confirmed
   * (as determined by `isConfirmAction`), it sends a broadcast command using
   * `broadcastConfirmedActionCommand`. The broadcast includes the action's key and
   * the provided invocation ID as the group identifier, plus a content ID when available.
   *
   * @param invocationId - The unique identifier for the current invocation or group.
   * @param actions - An array of message action payload contexts to be checked and broadcasted if confirmed.
   */ const broadcastConfirmedActions = (0, $cozmU.useCallback)((invocationId_3, actions)=>{
        for (const action_1 of actions)if ((0, $bxkJA.isConfirmAction)(action_1)) {
            const contentId_3 = (0, $aYC8J.isAIFCADFUpdateActionData)(action_1.data) ? action_1.data.contentId : undefined;
            broadcastConfirmedActionCommand((0, $2xH7b.RovoBroadcastConfirmedActionsCommand), {
                key: action_1.key,
                groupId: invocationId_3,
                ...contentId_3 ? {
                    contentId: contentId_3
                } : {}
            });
        }
    }, [
        broadcastConfirmedActionCommand
    ]);
    const getContentBody = (0, $cozmU.useCallback)(async ({ type: type, id: id, source: source, prompt: prompt_1 })=>{
        const identifier = String(id);
        let receiverId_1;
        switch(type){
            case 'page':
                receiverId_1 = (0, $5OXoi.getConfluenceEditorClientId)(identifier);
                break;
            case 'whiteboard':
                receiverId_1 = (0, $6isLN.getConfluenceWhiteboardClientId)(identifier);
                break;
            case 'slide':
                receiverId_1 = (0, $3wccB.getConfluenceSlidesClientId)(identifier);
                break;
            case 'database':
                receiverId_1 = (0, $7lXV4.getConfluenceDatabaseClientId)(identifier);
                break;
            case 'dashboard':
                receiverId_1 = (0, $1teNl.getAvpDashboardClientId)(identifier);
                break;
            default:
                receiverId_1 = (0, $5OXoi.getConfluenceEditorClientId)(identifier);
        }
        const shouldSendFastPathInputs = (0, $4o0zT.isExperimentEnabled)('platform_editor_ai_minion_skip_orchestrator');
        const shouldSendSource = source !== undefined && shouldSendFastPathInputs;
        const shouldSendPrompt = prompt_1 !== undefined && shouldSendFastPathInputs;
        const invocation = sendCommand((0, $1r5s7.ReadContentCommand), {
            receiverId: receiverId_1,
            buffer: false,
            ...shouldSendSource ? {
                source: source
            } : {},
            ...shouldSendPrompt ? {
                // eslint-disable-next-line @atlaskit/platform/no-double-type-assertions -- DocNode is serializable ADF, but its type does not satisfy the bridge SerializableValue index signature.
                prompt: $571372d50c430197$var$cloneSerializableValue(prompt_1)
            } : {}
        });
        return invocation.result();
    }, [
        sendCommand
    ]);
    const getStagingSpace = (0, $cozmU.useCallback)((id_0)=>sendCommand((0, $l3qz4.ReadSpaceCommand), {
            id: id_0,
            receiverId: (0, $4Y660.CONFLUENCE_SPACE_CLIENT_ID),
            buffer: false
        }).result(), [
        sendCommand
    ]);
    const getAdditionalContext = (0, $cozmU.useCallback)(async (receiverId_2)=>{
        let timeoutId;
        try {
            const result = await Promise.race([
                sendCommand((0, $1r5s7.ReadContentCommand), {
                    receiverId: receiverId_2,
                    buffer: false
                }).result(),
                new Promise((resolve)=>{
                    timeoutId = setTimeout(resolve, $571372d50c430197$var$ADDITIONAL_CONTEXT_TIMEOUT_MS);
                })
            ]);
            return result?.contentType === 'page' ? result.additionalContext : undefined;
        } catch  {
            return undefined;
        } finally{
            if (timeoutId !== undefined) clearTimeout(timeoutId);
        }
    }, [
        sendCommand
    ]);
    return {
        getContentBody: getContentBody,
        getAdditionalContext: getAdditionalContext,
        getStagingSpace: getStagingSpace,
        processMessageStreamAction: processMessageStreamAction,
        processMessageStreamComplete: processMessageStreamComplete,
        processMessageStreamError: processMessageStreamError,
        processMessageStreamActionClassification: processMessageStreamActionClassification,
        broadcastStreamStatus: $e4efc8cb7e22be34$export$ff6a2981a5436d75,
        broadcastConfirmedActions: broadcastConfirmedActions
    };
};








const $8447bc9ff2b3f038$export$6f57813fe9f31bf9 = (0, $8s9DV.createStore)({
    initialState: {
        initiator: 'unknown',
        initiatorApplied: false
    },
    actions: {
        initChatInitiator: (initiator)=>({ setState: setState, getState: getState })=>{
                if (!getState().initiatorApplied) setState({
                    initiator: initiator ?? 'unknown',
                    initiatorApplied: true
                });
            },
        getChatInitiator: ()=>({ getState: getState })=>{
                return getState().initiator;
            }
    }
});


const $70f03fc4cd84995c$export$8a56a4af5643d61b = (0, $kBr4q.createActionsHook)((0, $8447bc9ff2b3f038$export$6f57813fe9f31bf9));



var $guRLk = parcelRequire("guRLk");










const $37f0dfcbe79a956a$export$1e02c4fe277d3d74 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(2);
    const { setChatMode: setChatMode } = (0, $aJU2k.useChatModeStoreActions)();
    let t0;
    if ($[0] !== setChatMode) {
        t0 = (newConversationId, mode)=>{
            setChatMode(newConversationId, {
                autoActionApprovalMode: mode.autoActionApprovalMode ?? "ALWAYS_HUMAN",
                reasoningMode: mode.deepResearchEnabled ? "deep-research" : mode.thinkDeeperEnabled ? mode.alphaExtendedThinkingMode === "LONG_HORIZON" ? "think-deeper-orchestrator" : mode.alphaExtendedThinkingMode === "MARATHON" ? "think-deeper-marathon" : "think-deeper" : mode.planModeEnabled ? "task" : mode.fastModeEnabled ? "fast" : "auto",
                webSearchEnabled: mode.webSearchEnabled ?? false,
                conciergeEnabled: mode.conciergeEnabled ?? false,
                sourceMode: mode.sourceMode ?? "GENERAL",
                useCurrentPageContext: mode.useCurrentPageContext ?? false,
                spaceSourceCount: mode.spaceSourceCount,
                appFilters: mode.appFilters,
                selectedCloudIds: mode.selectedCloudIds ?? []
            });
        };
        $[0] = setChatMode;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : ()=>{
    const { setChatMode: setChatMode } = (0, $aJU2k.useChatModeStoreActions)();
    return (newConversationId, mode)=>{
        setChatMode(newConversationId, {
            autoActionApprovalMode: mode.autoActionApprovalMode ?? 'ALWAYS_HUMAN',
            // TODO: ROVOFE-1411 - refactor into passing the reasoningMode directly
            reasoningMode: mode.deepResearchEnabled ? 'deep-research' : mode.thinkDeeperEnabled ? mode.alphaExtendedThinkingMode === 'LONG_HORIZON' ? 'think-deeper-orchestrator' : mode.alphaExtendedThinkingMode === 'MARATHON' ? 'think-deeper-marathon' : 'think-deeper' : mode.planModeEnabled ? 'task' : mode.fastModeEnabled ? 'fast' : 'auto',
            webSearchEnabled: mode.webSearchEnabled ?? false,
            conciergeEnabled: mode.conciergeEnabled ?? false,
            sourceMode: mode.sourceMode ?? 'GENERAL',
            useCurrentPageContext: mode.useCurrentPageContext ?? false,
            spaceSourceCount: mode.spaceSourceCount,
            appFilters: mode.appFilters,
            selectedCloudIds: mode.selectedCloudIds ?? []
        });
    };
};




var $iDdTC = parcelRequire("iDdTC");

const $67bde2f896c04cc0$export$d077ccae10682bac = {
    createViewDeadAirMetrics: ()=>{
        return (0, $iDdTC.metrics).interaction({
            key: 'ai-mate.view-dead-air'
        });
    }
};


/**
 * Calculates the total excess dead air time above a given threshold.
 * For each interval exceeding the threshold, only the portion above the threshold is summed.
 * Example: threshold=3000, intervals=[2000, 4000, 5000] => (4000-3000) + (5000-3000) = 3000
 */ function $ed4bda8939492652$export$f21d08fe326f3fd8(intervals, thresholdMs) {
    return intervals.filter((interval)=>interval > thresholdMs).reduce((sum, interval)=>sum + (interval - thresholdMs), 0);
}


const $af849802a7ce9421$export$d679f89c82173941 = (conditions)=>{
    return(// AIFC: Not tracking the full extent of AIFC flow. Visual changes in the staging area
    // (where content is created/modified) are not instrumented, resulting in incomplete metrics.
    conditions.isAIFC || // Deep Research: Has a separate research steps view/handler not tracked by ViewDeadAirTracker.
    // Requires additional instrumentation work to capture accurately.
    conditions.isDeepResearch);
};



var $cWJWG = parcelRequire("cWJWG");

const $3a2dcf28cd216b6e$var$createInitialState = ()=>({
        isActive: false,
        sessionConfig: null,
        startTimestamp: 0,
        previousMark: null,
        intervals: [],
        maxDeadAirMs: 0,
        finishedOnce: false,
        identity: null
    });
const $3a2dcf28cd216b6e$var$LOG_PREFIX = '[ViewDeadAir]';
const $3a2dcf28cd216b6e$var$DEBUG_LOGGING = false; // Set to true for debugging
// Threshold constants in milliseconds
const $3a2dcf28cd216b6e$var$THRESHOLD_3_SECONDS = 3000;
const $3a2dcf28cd216b6e$var$THRESHOLD_5_SECONDS = 5000;
const $3a2dcf28cd216b6e$var$THRESHOLD_7_SECONDS = 7000;
function $3a2dcf28cd216b6e$export$e75a25d5c6776a72(brokerConfig) {
    let state = $3a2dcf28cd216b6e$var$createInitialState();
    function start(config) {
        // If a session was active and never finished, finish it first to avoid losing data
        if (state.isActive && !state.finishedOnce) {
            if ($3a2dcf28cd216b6e$var$DEBUG_LOGGING) // eslint-disable-next-line no-console
            console.log(`${$3a2dcf28cd216b6e$var$LOG_PREFIX} interrupting active session to start new one`);
            finish('interrupted');
        }
        // Preserve identity across session resets
        const currentIdentity = state.identity;
        state = $3a2dcf28cd216b6e$var$createInitialState();
        state.identity = currentIdentity;
        state.isActive = true;
        state.sessionConfig = config;
        state.startTimestamp = performance.now();
        if ($3a2dcf28cd216b6e$var$DEBUG_LOGGING) // eslint-disable-next-line no-console
        console.log(`${$3a2dcf28cd216b6e$var$LOG_PREFIX} Session started:`, config);
    }
    function mark({ id: id, contentType: contentType }) {
        if (!state.isActive) return;
        const now = performance.now();
        const currentMark = {
            id: id,
            contentType: contentType,
            timestamp: now
        };
        if (!state.previousMark) {
            // First mark — interval from session start
            const interval = now - state.startTimestamp;
            if ((0, $cWJWG.shouldExcludeInterval)(interval)) {
                state.previousMark = currentMark;
                return;
            }
            state.intervals.push(interval);
            state.maxDeadAirMs = interval;
            state.previousMark = currentMark;
            if ($3a2dcf28cd216b6e$var$DEBUG_LOGGING) // eslint-disable-next-line no-console
            console.log(`${$3a2dcf28cd216b6e$var$LOG_PREFIX} interval: ${interval.toFixed(1)}ms Mark: id=${id}, contentType=${contentType}`);
            return;
        }
        // Aggregate consecutive stream marks with same id and same contentType
        if (contentType === 'stream' && state.previousMark.id === id && state.previousMark.contentType === 'stream') {
            state.previousMark.timestamp = now;
            return;
        }
        const interval = now - state.previousMark.timestamp;
        if ((0, $cWJWG.shouldExcludeInterval)(interval)) {
            state.previousMark = currentMark;
            return;
        }
        state.intervals.push(interval);
        if (interval > state.maxDeadAirMs) state.maxDeadAirMs = interval;
        state.previousMark = currentMark;
        if ($3a2dcf28cd216b6e$var$DEBUG_LOGGING) // eslint-disable-next-line no-console
        console.log(`${$3a2dcf28cd216b6e$var$LOG_PREFIX} interval: ${interval.toFixed(1)}ms Mark: id=${id}, contentType=${contentType}`);
    }
    function finish(reason) {
        if (state.finishedOnce || !state.isActive) return;
        state.finishedOnce = true;
        state.isActive = false;
        const { intervals: intervals, maxDeadAirMs: maxDeadAirMs, sessionConfig: sessionConfig } = state;
        // Calculate excess dead air time above thresholds
        const excessDeadAirAbove3s = (0, $ed4bda8939492652$export$f21d08fe326f3fd8)(intervals, $3a2dcf28cd216b6e$var$THRESHOLD_3_SECONDS);
        const excessDeadAirAbove5s = (0, $ed4bda8939492652$export$f21d08fe326f3fd8)(intervals, $3a2dcf28cd216b6e$var$THRESHOLD_5_SECONDS);
        const excessDeadAirAbove7s = (0, $ed4bda8939492652$export$f21d08fe326f3fd8)(intervals, $3a2dcf28cd216b6e$var$THRESHOLD_7_SECONDS);
        const result = {
            sessionConfig: sessionConfig,
            reason: reason,
            intervals: intervals,
            maxDeadAirMs: maxDeadAirMs
        };
        brokerConfig?.onEmit?.(result);
        const shouldSkip = (0, $af849802a7ce9421$export$d679f89c82173941)({
            isAIFC: sessionConfig?.isAIFCEnabled ?? false,
            isDeepResearch: sessionConfig?.reasoningMode === 'deep-research'
        });
        if (shouldSkip) {
            if ($3a2dcf28cd216b6e$var$DEBUG_LOGGING) // eslint-disable-next-line no-console
            console.log(`${$3a2dcf28cd216b6e$var$LOG_PREFIX} Skipping metrics (AIFC=${sessionConfig?.isAIFCEnabled}, reasoningMode=${sessionConfig?.reasoningMode})`);
            return;
        }
        // Send browser metric - truncate all numeric values to integers before egress
        const metric = (0, $67bde2f896c04cc0$export$d077ccae10682bac).createViewDeadAirMetrics();
        const now = performance.now();
        const intervalsInt = intervals.map((i)=>Math.trunc(i));
        metric.start({
            startTime: now - maxDeadAirMs
        });
        metric.stop({
            stopTime: now,
            customData: {
                // Session config
                messageId: sessionConfig?.messageId ?? '',
                conversationId: sessionConfig?.conversationId ?? '',
                traceId: sessionConfig?.traceId ?? '',
                productKey: sessionConfig?.productKey ?? '',
                reasoningMode: sessionConfig?.reasoningMode ?? '',
                isAIFCEnabled: sessionConfig?.isAIFCEnabled ?? false,
                isWebSearchEnabled: sessionConfig?.isWebSearchEnabled ?? false,
                reason: // Result data
                reason,
                maxDeadAirMs: Math.trunc(maxDeadAirMs),
                intervalCount: intervalsInt.length,
                intervals: JSON.stringify(intervalsInt),
                // Excess dead air time above thresholds
                excessDeadAirAbove3s: Math.trunc(excessDeadAirAbove3s),
                excessDeadAirAbove5s: Math.trunc(excessDeadAirAbove5s),
                excessDeadAirAbove7s: Math.trunc(excessDeadAirAbove7s)
            }
        });
        if ($3a2dcf28cd216b6e$var$DEBUG_LOGGING) // eslint-disable-next-line no-console
        console.log(`${$3a2dcf28cd216b6e$var$LOG_PREFIX} Session finished (${reason}):`, {
            intervals: result.intervals,
            maxDeadAirMs: result.maxDeadAirMs,
            excessDeadAirAbove3s: excessDeadAirAbove3s,
            excessDeadAirAbove5s: excessDeadAirAbove5s,
            excessDeadAirAbove7s: excessDeadAirAbove7s
        });
    }
    function updateIdentity(newIdentity) {
        // If session is active and identity changed, finish the current session
        if (state.isActive && state.identity !== null && state.identity !== newIdentity) {
            if ($3a2dcf28cd216b6e$var$DEBUG_LOGGING) // eslint-disable-next-line no-console
            console.log(`${$3a2dcf28cd216b6e$var$LOG_PREFIX} identity changed from ${state.identity} to ${newIdentity}, finishing session`);
            finish('identity-changed');
        }
        state.identity = newIdentity;
    }
    return {
        start: start,
        mark: mark,
        finish: finish,
        updateIdentity: updateIdentity
    };
}















var $4KNZy = parcelRequire("4KNZy");

const $fb3a263627da0e72$export$8218c921a415cac1 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(3);
    const handlerRef = (0, $cozmU.useRef)();
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (handler)=>{
            handlerRef.current = handler;
            return ()=>{
                if (handlerRef.current === handler) handlerRef.current = undefined;
            };
        };
        $[0] = t0;
    } else t0 = $[0];
    const registerHumanMessageIdReplacementHandler = t0;
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (conversationId, oldId, newId)=>{
            (0, $4KNZy.userSubmissionLifecycle).replaceHumanMessageId({
                conversationId: conversationId,
                oldId: oldId,
                newId: newId
            });
            handlerRef.current?.({
                conversationId: conversationId,
                oldId: oldId,
                newId: newId
            });
        };
        $[1] = t1;
    } else t1 = $[1];
    const onHumanMessageIdReplaced = t1;
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {
            onHumanMessageIdReplaced: onHumanMessageIdReplaced,
            registerHumanMessageIdReplacementHandler: registerHumanMessageIdReplacementHandler
        };
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : ()=>{
    const handlerRef = (0, $cozmU.useRef)();
    const registerHumanMessageIdReplacementHandler = (0, $cozmU.useCallback)((handler)=>{
        handlerRef.current = handler;
        return ()=>{
            if (handlerRef.current === handler) handlerRef.current = undefined;
        };
    }, []);
    const onHumanMessageIdReplaced = (0, $cozmU.useCallback)((conversationId, oldId, newId)=>{
        (0, $4KNZy.userSubmissionLifecycle).replaceHumanMessageId({
            conversationId: conversationId,
            oldId: oldId,
            newId: newId
        });
        handlerRef.current?.({
            conversationId: conversationId,
            oldId: oldId,
            newId: newId
        });
    }, []);
    return {
        onHumanMessageIdReplaced: onHumanMessageIdReplaced,
        registerHumanMessageIdReplacementHandler: registerHumanMessageIdReplacementHandler
    };
};












var $cRubi = parcelRequire("cRubi");


var $gB5in = parcelRequire("gB5in");


var $cC5sC = parcelRequire("cC5sC");

async function $9efff1c82a0288bb$export$6227c2682e216a37({ chatContextStoreActions: chatContextStoreActions, productKey: productKey = 'confluence', creationContextParams: creationContextParams, contentContext: contentContext, sendAnalyticsEvent: sendAnalyticsEvent = ()=>undefined }) {
    const contentContextValue = contentContext ?? chatContextStoreActions.getActiveContext() ?? 'global';
    const activeTargetId = chatContextStoreActions.getCurrentTargetId();
    const populated = await (0, $cC5sC.populateSendMessageContext)(chatContextStoreActions, // Treat as a non-first prompt so staging-area / CwR follow-up context rules apply.
    false, // Source that is eligible for AIFC context requirements across CwR surfaces.
    'CONFLUENCE_CWR_BLANK_OBJECT', undefined, // Always include current page / surface context for Voice pull.
    true, contentContextValue, creationContextParams, productKey, sendAnalyticsEvent, activeTargetId);
    const browserUrl = populated.browserContext?.context?.browserUrl ?? window.location.href;
    return (0, $gB5in.buildMessageStreamRequestContext)({
        browserUrl: browserUrl,
        // Voice CwR needs browsing context for placement and surface resolution.
        useCurrentBrowsingContext: true,
        editorContext: populated.editorContext,
        whiteboardContext: populated.whiteboardContext,
        slidesContext: populated.slidesContext,
        databaseContext: populated.databaseContext,
        dashboardEditorContext: populated.dashboardEditorContext,
        browserContext: populated.browserContext,
        additionalContext: populated.additionalContext,
        aiFeatureContext: populated.aiFeatureContext,
        jiraWorkflowContext: populated.jiraWorkflowContext,
        dashboardContext: populated.dashboardContext
    });
}


const $f88a73356e9d1aca$export$af9b701d05e4ed42 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useRegisterRovoChatContextProviderForEnterpriseHer(chatContextStoreActions, productKey) {
    const $ = (0, $bDgLe.c)(4);
    let t0;
    let t1;
    if ($[0] !== chatContextStoreActions || $[1] !== productKey) {
        t0 = ()=>{
            (0, $cRubi.setRovoChatContextProvider)(()=>(0, $9efff1c82a0288bb$export$6227c2682e216a37)({
                    chatContextStoreActions: chatContextStoreActions,
                    productKey: productKey
                }));
            return $f88a73356e9d1aca$var$_temp;
        };
        t1 = [
            chatContextStoreActions,
            productKey
        ];
        $[0] = chatContextStoreActions;
        $[1] = productKey;
        $[2] = t0;
        $[3] = t1;
    } else {
        t0 = $[2];
        t1 = $[3];
    }
    (0, $cozmU.useEffect)(t0, t1);
} : function useRegisterRovoChatContextProviderForEnterpriseHer(chatContextStoreActions, productKey) {
    (0, $cozmU.useEffect)(()=>{
        (0, $cRubi.setRovoChatContextProvider)(()=>(0, $9efff1c82a0288bb$export$6227c2682e216a37)({
                chatContextStoreActions: chatContextStoreActions,
                productKey: productKey
            }));
        return ()=>{
            (0, $cRubi.setRovoChatContextProvider)(null);
        };
    }, [
        chatContextStoreActions,
        productKey
    ]);
};
function $f88a73356e9d1aca$var$_temp() {
    (0, $cRubi.setRovoChatContextProvider)(null);
}


const $b1c23cecabb25d6f$export$fa770f2a78bdd2f7 = ({ enableBrowserContextBanner: enableBrowserContextBanner, shouldShowContextBanner: shouldShowContextBanner = true, pageType: pageType })=>{
    if (!shouldShowContextBanner) return false;
    // Using browser context (rovo extension sidebar) return true
    if (enableBrowserContextBanner) return true;
    // if user is viewing a 1p atlassian page in mini modal or in product side panel return true else return undefined
    return pageType === 'current_page' ? true : undefined;
};















var $O96nq = parcelRequire("O96nq");

const $c036c439c40c28d8$export$c1e7a155a036a9ec = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ViewDeadAirProvider(t0) {
    const $ = (0, $bDgLe.c)(10);
    const { value: value, identity: identity, children: children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $iDrrr.fg)("rovo_chat_track_view_dead_air");
        $[0] = t1;
    } else t1 = $[0];
    const isEnabled = t1;
    let t2;
    let t3;
    if ($[1] !== identity || $[2] !== value) {
        t2 = ()=>{
            if (!isEnabled) return;
            if (identity !== undefined && value) value.updateIdentity(identity);
        };
        t3 = [
            identity,
            value,
            isEnabled
        ];
        $[1] = identity;
        $[2] = value;
        $[3] = t2;
        $[4] = t3;
    } else {
        t2 = $[3];
        t3 = $[4];
    }
    (0, $cozmU.useEffect)(t2, t3);
    if (!isEnabled) {
        let t4;
        if ($[5] !== children) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
            $[5] = children;
            $[6] = t4;
        } else t4 = $[6];
        return t4;
    }
    let t4;
    if ($[7] !== children || $[8] !== value) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $O96nq.ViewDeadAirContext).Provider, {
            value: value
        }, children);
        $[7] = children;
        $[8] = value;
        $[9] = t4;
    } else t4 = $[9];
    return t4;
} : function ViewDeadAirProvider({ value: value, identity: identity, children: children }) {
    const isEnabled = (0, $iDrrr.fg)('rovo_chat_track_view_dead_air');
    (0, $cozmU.useEffect)(()=>{
        if (!isEnabled) return;
        if (identity !== undefined && value) value.updateIdentity(identity);
    }, [
        identity,
        value,
        isEnabled
    ]);
    if (!isEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $O96nq.ViewDeadAirContext).Provider, {
        value: value
    }, children);
};


function $37f8d57d84bed17b$export$cd17d76da7967240() {
    // return packageInfo;
    return {
        name: '@atlassian/conversation-assistant',
        version: 'unavailable'
    };
}


const $8b089c26465af0fa$export$de9a15d22e1ad816 = ({ onPromptSent: onPromptSent, forceRestoreConversationId: forceRestoreConversationId, children: children })=>{
    (0, $6cFsl.di)((0, $bjY3F.useAIMateExperienceTracker), (0, $eKjv9.useGlobalConfig));
    const showFlag = (0, $55592f6773d96032$export$4610738c067a7645)();
    const { getContentBody: getContentBody, getAdditionalContext: getAdditionalContext, getStagingSpace: getStagingSpace, processMessageStreamAction: processMessageStreamAction, processMessageStreamComplete: processMessageStreamComplete, processMessageStreamError: processMessageStreamError, processMessageStreamActionClassification: processMessageStreamActionClassification, broadcastConfirmedActions: broadcastConfirmedActions, broadcastStreamStatus: broadcastStreamStatus } = (0, $571372d50c430197$export$392dcf789ba32ca6)();
    const { requestBrowserContent: requestBrowserContent } = (0, $cb145149c0b90d17$export$46457d11c8328445)();
    const { requestJiraContext: requestJiraContext } = (0, $0e8cab1d0778bbd2$export$4fbf4621651f722d)();
    const experienceTracker = (0, $bjY3F.useAIMateExperienceTracker)();
    const assistanceService = (0, $lJ6db.useAssistanceService)();
    const { getIsMounted: getIsChatMounted } = (0, $bGNkz.useUIStoreActions)();
    const { sendAnalyticsEvent: sendAnalyticsEvent, trackAIMAUEvent: trackAIMAUEvent } = (0, $Ou0Zz.useAnalytics)();
    const { browserContextSanitizer: browserContextSanitizer, enableBrowserContextBanner: enableBrowserContextBanner, elements: elements, preserveUrlConversationId: preserveUrlConversationId, skipAutoConversationSelection: skipAutoConversationSelectionFromConfig } = (0, $dSCNl.useUIConfig)();
    const { productHeader: productHeader, siteId: siteId, profileData: profileData, useCurrentBrowsingContext: useCurrentBrowsingContext } = (0, $eKjv9.useGlobalConfig)();
    const conversationHydrationScopeKey = JSON.stringify([
        siteId,
        profileData.aaid ?? ''
    ]);
    const conversationHydrationScopeKeyRef = (0, $cozmU.useRef)(conversationHydrationScopeKey);
    conversationHydrationScopeKeyRef.current = conversationHydrationScopeKey;
    (0, $cozmU.useEffect)(()=>{
        conversationHydrationScopeKeyRef.current = conversationHydrationScopeKey;
        return ()=>{
            conversationHydrationScopeKeyRef.current = undefined;
        };
    }, [
        conversationHydrationScopeKey
    ]);
    const getConversationHydrationScopeKey = (0, $cozmU.useCallback)(()=>conversationHydrationScopeKeyRef.current, []);
    const { currentContext: currentContext } = (0, $hOUgz.useCurrentPageAsContext)();
    const [{ currentConversationId: currentConversationId }] = (0, $n71o5.useChatStore)();
    // Read the active conversation's "use current page as context" toggle from the
    // chat mode store so the chat-context provider can derive useCurrentBrowsingContext.
    const { useCurrentPageContext: useCurrentPageContext } = (0, $aQWBL.useChatModeState)(currentConversationId);
    const chatContextStoreActions = (0, $gzMZq.useChatContextProvider)({
        requestBrowserContent: requestBrowserContent,
        requestJiraContext: requestJiraContext,
        getContentBody: getContentBody,
        getAdditionalContext: getAdditionalContext,
        getStagingSpace: getStagingSpace,
        useCurrentNonEditingPageAsContext: (0, $b1c23cecabb25d6f$export$fa770f2a78bdd2f7)({
            enableBrowserContextBanner: enableBrowserContextBanner,
            shouldShowContextBanner: elements?.shouldShowContextBanner,
            pageType: currentContext?.type
        }),
        useCurrentPageContext: useCurrentPageContext,
        useCurrentBrowsingContext: useCurrentBrowsingContext
    });
    (0, $f88a73356e9d1aca$export$af9b701d05e4ed42)(chatContextStoreActions, productHeader);
    const { setStatus: setStatus, setConversationError: setConversationError } = (0, $k4g8h.useChatSignalsActions)();
    const { getMessages: getMessages, setMessages: setMessages } = (0, $iW40i.useChatMessagesActions)();
    const { setIsRovoEnabled: setIsRovoEnabled } = (0, $8lt5O.useRovoEntitlementActions)();
    const { startReconnection: startReconnection, endReconnection: endReconnection, isReconnecting: isReconnecting } = (0, $d59150c4763cb391$export$bec843ddf321b89b)();
    (0, $cozmU.useEffect)(()=>{
        (0, $hlvTd.setupSentryClient)({
            packageVersion: (0, $37f8d57d84bed17b$export$cd17d76da7967240)().version,
            product: productHeader
        });
    }, [
        productHeader
    ]);
    const { processStreamResearch: processStreamResearch, updateResearchMessageId: updateResearchMessageId, markIncompleteResearchesErrored: markIncompleteResearchesErrored, completeAllSteps: completeAllSteps, clearMessageResearch: clearMessageResearch, addImplicitResearchPlan: addImplicitResearchPlan, resetHasReceivedAnswerPart: resetHasReceivedAnswerPart } = (0, $guRLk.useChatMessageResearchActions)();
    const { getChatInitiator: getChatInitiator, initChatInitiator: initChatInitiator } = (0, $70f03fc4cd84995c$export$8a56a4af5643d61b)();
    const { insertHighlightActionsEditorPlaceholder: insertHighlightActionsEditorPlaceholder } = (0, $8VrqA.useHighlightActionsEditorPlaceholder)();
    const { setMessageIdSelectedForPreview: setMessageIdSelectedForPreview, setStagingAreaMode: setStagingAreaMode, setInvocationIdSelectedForPreview: setInvocationIdSelectedForPreview, getMessageIdSelectedForPreview: getMessageIdSelectedForPreview, getInvocationIdSelectedForPreview: getInvocationIdSelectedForPreview } = (0, $8akfd.useStagingAreaActions)();
    const { forceSkipAutoConversationSelection: forceSkipAutoConversationSelection } = (0, $8akfd.useStagingAreaState)();
    const onNewConversationStartingWithSendMessage = (0, $37f0dfcbe79a956a$export$1e02c4fe277d3d74)();
    const { activeAction: activeAction } = (0, $5BOJB.useActiveAction)();
    // Skip auto conversation selection if the host opted out via uiConfig, we're already previewing
    // a message, or an action is pending. When an action is set, the chat store must start with
    // EMPTY_CONVERSATION_ID rather than restoring the previous conversation from localStorage via
    // autoSelectConversation. Matters only on initialization.
    const skipAutoConversationSelection = !!skipAutoConversationSelectionFromConfig && (0, $cha5E.expVal)('jira_preserve_rovo_chat_on_create_agent', 'isEnabled', false) || !!getMessageIdSelectedForPreview?.() || !!getInvocationIdSelectedForPreview?.() || forceSkipAutoConversationSelection || !!activeAction;
    const onTempMessageIdReplaced = (0, $cozmU.useCallback)((oldId, newId)=>{
        // Update messageIdSelectedForPreview when the message ID changes during streaming
        if (oldId === getMessageIdSelectedForPreview?.()) setMessageIdSelectedForPreview(newId);
    }, [
        getMessageIdSelectedForPreview,
        setMessageIdSelectedForPreview
    ]);
    const { onHumanMessageIdReplaced: onHumanMessageIdReplaced, registerHumanMessageIdReplacementHandler: registerHumanMessageIdReplacementHandler } = (0, $fb3a263627da0e72$export$8218c921a415cac1)();
    const { trackAgentEvent: trackAgentEvent } = (0, $iA8l9.useRovoAgentActionAnalytics)({});
    const { setReasoningMode: setReasoningMode, getBrowserDisplayContextActive: getBrowserDisplayContextActive } = (0, $aJU2k.useChatModeStoreActions)();
    const { setSmartContextLinkRecommendations: setSmartContextLinkRecommendations, upsertConversationSpace: upsertConversationSpace } = (0, $12shJ.useSpaceStoreActions)();
    const onConversationSpacesHydrated = (0, $cozmU.useCallback)((_conversationId, spaces)=>{
        spaces.forEach((space)=>upsertConversationSpace(space));
    }, [
        upsertConversationSpace
    ]);
    // Build the unified tasks container dep consumed by chat-store actions.
    // Always assembled (cheap) so the container shape is stable across renders.
    // All read accessors are sweet-state actions so the dep object identity does not depend on store
    // state — chat-store consumers won't re-render on every task mutation.
    const unifiedTasksActions = (0, $9qJ1N.useTasksStoreActions)();
    const unifiedTasksContainerDep = (0, $cozmU.useMemo)(()=>({
            removeTasksForConversation: unifiedTasksActions.removeTasksForConversation,
            createTaskFromStream: unifiedTasksActions.createTaskFromStream,
            setTaskProgressState: unifiedTasksActions.setTaskProgressState,
            setTaskTodoSnapshot: unifiedTasksActions.setTaskTodoSnapshot,
            ackTaskCompleted: unifiedTasksActions.ackTaskCompleted,
            mergeConversationChannelTasks: unifiedTasksActions.mergeConversationChannelTasks,
            getTaskById: unifiedTasksActions.getTaskById,
            getActiveTaskForConversation: unifiedTasksActions.getActiveTaskForConversation
        }), [
        unifiedTasksActions
    ]);
    const isViewDeadAirEnabled = (0, $iDrrr.fg)('rovo_chat_track_view_dead_air');
    const viewDeadAirBroker = (0, $cozmU.useMemo)(()=>isViewDeadAirEnabled ? (0, $3a2dcf28cd216b6e$export$e75a25d5c6776a72)() : null, [
        isViewDeadAirEnabled
    ]);
    const capabilities = (0, $bd4e57972be9e4ca$export$e0427dd13bcccf1b)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $07964e27dfae7b36$export$9b7b433b0520b82b), {
        isGlobal: true,
        preserveUrlConversationId: (0, $iDrrr.fg)('rovo_chat_preserve_url_conversation_id') && preserveUrlConversationId,
        siteId: siteId,
        onPromptSent: onPromptSent,
        forceRestoreConversationId: forceRestoreConversationId,
        assistanceService: assistanceService,
        experienceTracker: experienceTracker,
        sendAnalyticsEvent: sendAnalyticsEvent,
        trackAIMAUEvent: trackAIMAUEvent,
        chatContextStoreActions: chatContextStoreActions,
        capabilities: capabilities,
        setChatStatus: setStatus,
        setConversationError: setConversationError,
        getMessages: getMessages,
        setMessages: setMessages,
        getIsChatMounted: getIsChatMounted,
        startReconnection: startReconnection,
        endReconnection: endReconnection,
        isReconnecting: isReconnecting,
        setRovoEnabled: setIsRovoEnabled,
        processStreamResearch: processStreamResearch,
        markIncompleteResearchesErrored: markIncompleteResearchesErrored,
        completeAllSteps: completeAllSteps,
        updateResearchMessageId: updateResearchMessageId,
        clearMessageResearch: clearMessageResearch,
        addImplicitResearchPlan: addImplicitResearchPlan,
        resetHasReceivedAnswerPart: resetHasReceivedAnswerPart,
        initChatInitiator: initChatInitiator,
        getChatInitiator: getChatInitiator,
        insertHighlightActionsEditorPlaceholder: insertHighlightActionsEditorPlaceholder,
        processMessageStreamAction: processMessageStreamAction,
        processMessageStreamComplete: processMessageStreamComplete,
        processMessageStreamError: processMessageStreamError,
        processMessageStreamActionClassification: processMessageStreamActionClassification,
        broadcastStreamStatus: broadcastStreamStatus,
        broadcastConfirmedActions: broadcastConfirmedActions,
        setStagingAreaMode: setStagingAreaMode,
        setMessageIdSelectedForPreview: setMessageIdSelectedForPreview,
        setInvocationIdSelectedForPreview: setInvocationIdSelectedForPreview,
        onTempMessageIdReplaced: onTempMessageIdReplaced,
        onHumanMessageIdReplaced: onHumanMessageIdReplaced,
        registerHumanMessageIdReplacementHandler: registerHumanMessageIdReplacementHandler,
        skipAutoConversationSelection: skipAutoConversationSelection,
        onNewConversationStartingWithSendMessage: onNewConversationStartingWithSendMessage,
        browserContextSanitizer: browserContextSanitizer,
        trackAgentEvent: trackAgentEvent,
        viewDeadAirBroker: viewDeadAirBroker,
        showFlag: showFlag,
        getConversationHydrationScopeKey: getConversationHydrationScopeKey,
        setReasoningMode: setReasoningMode,
        getBrowserDisplayContextActive: getBrowserDisplayContextActive,
        unifiedTasksActions: unifiedTasksContainerDep,
        onSpaceSourceRecommendations: setSmartContextLinkRecommendations,
        onConversationSpacesHydrated: onConversationSpacesHydrated
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $83df2c4d369ade6b$export$1ea8b76066893345), {
        showFlag: showFlag
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c036c439c40c28d8$export$c1e7a155a036a9ec), {
        value: viewDeadAirBroker,
        identity: currentConversationId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e2d7843b3ff1bcdd$export$47f0b7e1efb22e0f), null, children)))));
};



var $dPoYT = parcelRequire("dPoYT");

const $ad68d77a48a38e4c$export$d4f9eca8f56c7ee5 = (mode, isFullScreen)=>isFullScreen ? 'rovo-chat.fullscreen' : `rovo-chat.${mode ?? (0, $dPoYT.ConversationAssistantUIModes).SIDEBAR}`;


const $0f2cd6a53c0a2177$export$6e73203ac85a4798 = ({ mode: mode, isFullScreen: isFullScreen, xpcBridge: xpcBridge, xpcProduct: xpcProduct, xpcSubProduct: xpcSubProduct, productKey: productKey })=>({
        bridgeProduct: xpcBridge || (0, $ad68d77a48a38e4c$export$d4f9eca8f56c7ee5)(mode, isFullScreen),
        xpcProduct: xpcProduct || productKey,
        xpcSubProduct: xpcSubProduct
    });












var $dqxOF = parcelRequire("dqxOF");





var $jqg1p = parcelRequire("jqg1p");





var $2zlSy = parcelRequire("2zlSy");

const $53ffa4edfba5c089$export$3e623b13d2da727a = (config)=>{
    // Allow fullscreen override for branch deploy testing purposes
    const processedConfig = // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.getItem('DEBUG_rovo_chat_fullscreen') === 'true' && (0, $iDrrr.fg)('rovo_chat_show_local_frontend_components') ? {
        ...config,
        fullScreen: true
    } : config;
    return {
        ...{
            ...(0, $2zlSy.initialState),
            ...processedConfig,
            enableSkills: processedConfig?.enableSkills ?? (0, $2zlSy.initialState).enableSkills,
            enableAgentMentions: processedConfig?.enableAgentMentions,
            enableAutoSuggest: processedConfig?.enableAutoSuggest ?? (0, $2zlSy.initialState).enableAutoSuggest,
            enableBrowserContextBanner: processedConfig?.enableBrowserContextBanner ?? (0, $2zlSy.initialState).enableBrowserContextBanner,
            disableSettingsModal: processedConfig?.disableSettingsModal ?? (0, $2zlSy.initialState).disableSettingsModal,
            browserContextSanitizer: processedConfig?.browserContextSanitizer,
            elements: {
                ...(0, $2zlSy.initialState).elements,
                ...processedConfig?.elements
            },
            promptInputDroppableUrls: processedConfig?.promptInputDroppableUrls
        }
    };
};



var $jAZYc = parcelRequire("jAZYc");

const $2af21e7e5be03781$var$areAgentsConfigsEqual = (current, next)=>current?.defaultAgentId === next?.defaultAgentId && (0, $jqg1p.areStringArraysEqual)(current?.filter, next?.filter);
const $2af21e7e5be03781$var$getUIConfigForShallowCompare = (config)=>{
    const { customHandlers: _customHandlers, elements: _elements, ...shallowConfig } = config ?? {};
    return shallowConfig;
};
const $2af21e7e5be03781$var$hasCustomHandlersProperty = (config)=>Object.prototype.hasOwnProperty.call(config ?? {}, 'customHandlers');
const $2af21e7e5be03781$var$areUIConfigsEqual = (current, next)=>(0, $dqxOF.shallowEqualObjects)($2af21e7e5be03781$var$getUIConfigForShallowCompare(current), $2af21e7e5be03781$var$getUIConfigForShallowCompare(next)) && (0, $dqxOF.shallowEqualObjects)(current?.elements ?? {}, next?.elements ?? {}) && $2af21e7e5be03781$var$hasCustomHandlersProperty(current) === $2af21e7e5be03781$var$hasCustomHandlersProperty(next) && (0, $dqxOF.shallowEqualObjects)(current?.customHandlers, next?.customHandlers);
const $2af21e7e5be03781$export$1d5179b714ffcf31 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { agentsConfig: agentsConfig, uiConfig: uiConfig } = t0;
    const stableAgentsConfig = (0, $jAZYc.useSemanticStableValue)(agentsConfig, $2af21e7e5be03781$var$areAgentsConfigsEqual);
    const stableUIConfig = (0, $jAZYc.useSemanticStableValue)(uiConfig, $2af21e7e5be03781$var$areUIConfigsEqual);
    let t1;
    if ($[0] !== stableAgentsConfig) {
        t1 = (0, $37RgG.createAgentsConfig)(stableAgentsConfig);
        $[0] = stableAgentsConfig;
        $[1] = t1;
    } else t1 = $[1];
    const agentOverriderValue = t1;
    let t2;
    if ($[2] !== stableUIConfig) {
        t2 = (0, $53ffa4edfba5c089$export$3e623b13d2da727a)(stableUIConfig);
        $[2] = stableUIConfig;
        $[3] = t2;
    } else t2 = $[3];
    const uiConfigValue = t2;
    let t3;
    if ($[4] !== agentOverriderValue || $[5] !== uiConfigValue) {
        t3 = {
            agentOverriderValue: agentOverriderValue,
            uiConfigValue: uiConfigValue
        };
        $[4] = agentOverriderValue;
        $[5] = uiConfigValue;
        $[6] = t3;
    } else t3 = $[6];
    return t3;
} : ({ agentsConfig: agentsConfig, uiConfig: uiConfig })=>{
    const stableAgentsConfig = (0, $jAZYc.useSemanticStableValue)(agentsConfig, $2af21e7e5be03781$var$areAgentsConfigsEqual);
    const stableUIConfig = (0, $jAZYc.useSemanticStableValue)(uiConfig, $2af21e7e5be03781$var$areUIConfigsEqual);
    const agentOverriderValue = (0, $cozmU.useMemo)(()=>(0, $37RgG.createAgentsConfig)(stableAgentsConfig), [
        stableAgentsConfig
    ]);
    const uiConfigValue = (0, $cozmU.useMemo)(()=>(0, $53ffa4edfba5c089$export$3e623b13d2da727a)(stableUIConfig), [
        stableUIConfig
    ]);
    return {
        agentOverriderValue: agentOverriderValue,
        uiConfigValue: uiConfigValue
    };
};












var $cMyWi = parcelRequire("cMyWi");


var $bI14T = parcelRequire("bI14T");

const $6390d7b9d52b6817$export$94b280d16f0eef6b = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { bridgeProduct: bridgeProduct, xpcProduct: xpcProduct, xpcSubProduct: xpcSubProduct, children: children } = t0;
    const smartLinkContext = (0, $bI14T.useSmartLinkContext)();
    let t1;
    if ($[0] !== bridgeProduct || $[1] !== smartLinkContext || $[2] !== xpcProduct || $[3] !== xpcSubProduct) {
        t1 = {
            ...smartLinkContext,
            bridgeProduct: bridgeProduct,
            xpcProduct: xpcProduct,
            xpcSubProduct: xpcSubProduct
        };
        $[0] = bridgeProduct;
        $[1] = smartLinkContext;
        $[2] = xpcProduct;
        $[3] = xpcSubProduct;
        $[4] = t1;
    } else t1 = $[4];
    const smartCardContextValue = t1;
    let t2;
    if ($[5] !== children || $[6] !== smartCardContextValue) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cMyWi.SmartCardContext).Provider, {
            value: smartCardContextValue
        }, children);
        $[5] = children;
        $[6] = smartCardContextValue;
        $[7] = t2;
    } else t2 = $[7];
    return t2;
} : ({ bridgeProduct: bridgeProduct, xpcProduct: xpcProduct, xpcSubProduct: xpcSubProduct, children: children })=>{
    const smartLinkContext = (0, $bI14T.useSmartLinkContext)();
    const smartCardContextValue = (0, $cozmU.useMemo)(()=>({
            ...smartLinkContext,
            bridgeProduct: bridgeProduct,
            xpcProduct: xpcProduct,
            xpcSubProduct: xpcSubProduct
        }), [
        smartLinkContext,
        bridgeProduct,
        xpcProduct,
        xpcSubProduct
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cMyWi.SmartCardContext).Provider, {
        value: smartCardContextValue
    }, children);
};












var $1Pvvv = parcelRequire("1Pvvv");


























var $6e8qW = parcelRequire("6e8qW");

const $ee822672c6924f73$var$DAY_MS = 86400000;
const $ee822672c6924f73$var$SITE_ACTIVITY_PATTERN = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?(?:Z|[+-]\d{2}:\d{2})$/;
const $ee822672c6924f73$export$ed3eb62f9a87ae39 = (value)=>{
    if (typeof value !== 'string' || !$ee822672c6924f73$var$SITE_ACTIVITY_PATTERN.test(value)) return undefined;
    const [year, month, day] = value.slice(0, 10).split('-').map(Number);
    const date = new Date(Date.UTC(year, month - 1, day));
    if (date.getUTCFullYear() !== year || date.getUTCMonth() !== month - 1 || date.getUTCDate() !== day) return undefined;
    const timestamp = Date.parse(value);
    return Number.isFinite(timestamp) ? timestamp : undefined;
};
const $ee822672c6924f73$export$9edbb9ebac0b895a = (activeDays, lastActive, minimumActiveDays, maximumActiveDays, now = Date.now())=>{
    if (!Number.isInteger(minimumActiveDays) || !Number.isInteger(maximumActiveDays) || minimumActiveDays < 0 || minimumActiveDays > 28 || maximumActiveDays < 0 || maximumActiveDays > 28 || minimumActiveDays > maximumActiveDays) return {
        outcome: 'unavailable',
        signal: 'none',
        reason: 'invalid'
    };
    const missingUsage = activeDays === undefined;
    const missingActivity = lastActive === undefined;
    const timestamp = $ee822672c6924f73$export$ed3eb62f9a87ae39(lastActive);
    const invalidUsage = typeof activeDays !== 'number' || !Number.isInteger(activeDays) || activeDays < 0 || activeDays > 28;
    const invalidActivity = timestamp === undefined || timestamp > now;
    if (missingUsage || missingActivity || invalidUsage || invalidActivity) {
        const badUsage = missingUsage || invalidUsage;
        const badActivity = missingActivity || invalidActivity;
        const presentInvalidSignal = !missingUsage && invalidUsage || !missingActivity && invalidActivity;
        return {
            outcome: 'unavailable',
            signal: badUsage && badActivity ? 'both' : badUsage ? 'usage' : 'siteActivity',
            reason: presentInvalidSignal ? 'invalid' : 'missing'
        };
    }
    const nowDate = new Date(now);
    const todayUtc = Date.UTC(nowDate.getUTCFullYear(), nowDate.getUTCMonth(), nowDate.getUTCDate());
    const recent = timestamp >= todayUtc - 27 * $ee822672c6924f73$var$DAY_MS;
    const eligible = activeDays >= minimumActiveDays && activeDays <= maximumActiveDays && recent;
    return {
        outcome: eligible ? 'eligible' : 'ineligible',
        signal: 'none',
        reason: 'none'
    };
};


const $8b66833e5c526a28$export$78ba24bae5a286e = ({ outcome: outcome, rollout: rollout, signal: signal, reason: reason, durationMs: durationMs })=>({
        type: 'sendOperationalEvent',
        data: {
            source: 'rovoTargeting',
            action: 'evaluated',
            actionSubject: 'rovoTargeting',
            attributes: {
                outcome: outcome,
                rollout: rollout,
                definitionVersion: 'v1',
                signal: signal,
                reason: reason,
                ...durationMs === undefined ? {} : {
                    durationMs: durationMs
                }
            }
        }
    });







const $dde33b12803a3fc0$var$store = (0, $8s9DV.createStore)({
    initialState: {
        byScope: {}
    },
    name: 'RovoTargetingAudienceStore',
    actions: {
        setSnapshot: (snapshot)=>({ getState: getState, setState: setState })=>setState({
                    byScope: {
                        ...getState().byScope,
                        [snapshot.scopeKey]: snapshot
                    }
                }),
        clearSnapshot: (scopeKey)=>({ getState: getState, setState: setState })=>{
                const { [scopeKey]: _removed, ...byScope } = getState().byScope;
                setState({
                    byScope: byScope
                });
            }
    }
});
const $dde33b12803a3fc0$export$2b9d72a34c3b0cd = (0, $kBr4q.createStateHook)($dde33b12803a3fc0$var$store);
const $dde33b12803a3fc0$export$a93a40f020109d38 = (0, $kBr4q.createActionsHook)($dde33b12803a3fc0$var$store);


const $7a2d6591def7c397$export$e96b0d9fd4c3a922 = (productKey)=>productKey === 'confluence' || productKey === 'jira' || productKey === 'jsm';


const $8e52f4303f0a8224$var$REQUEST_TIMEOUT_MS = 3000;
const $8e52f4303f0a8224$var$CONFLUENCE_PROFILE = {
    usageTrait: 'ai_chat_confluence_active_days_28d',
    activityTrait: 'confluence_last_active'
};
const $8e52f4303f0a8224$var$TARGETING_PROFILES = {
    confluence: $8e52f4303f0a8224$var$CONFLUENCE_PROFILE,
    jira: {
        usageTrait: 'ai_chat_jira_active_days_28d',
        activityTrait: 'jira_last_active'
    },
    jsm: {
        usageTrait: 'ai_chat_jsm_active_days_28d',
        activityTrait: 'jira-servicedesk_last_active'
    }
};
const $8e52f4303f0a8224$var$getTargetingProfile = (productKey)=>{
    if ((0, $7a2d6591def7c397$export$e96b0d9fd4c3a922)(productKey)) return $8e52f4303f0a8224$var$TARGETING_PROFILES[productKey];
    return undefined;
};
// Populated only by client effects. Completed signals survive hidden/visible Chat remounts,
// but inactive scopes are discarded when a different identity, site or gate state initializes.
const $8e52f4303f0a8224$var$entries = new Map();
const $8e52f4303f0a8224$export$9ff231eba9eeb959 = (scope)=>JSON.stringify([
        scope.productKey,
        scope.accountId ?? '',
        scope.siteId ?? '',
        scope.hasRovoAccess,
        scope.gateEnabled
    ]);
const $8e52f4303f0a8224$var$emitSafely = (entry, evaluation, rollout)=>{
    const handler = entry.owners.values().next().value;
    try {
        handler?.((0, $8b66833e5c526a28$export$78ba24bae5a286e)({
            ...evaluation,
            rollout: rollout
        }));
    } catch  {
    // Analytics must not change eligibility or trigger another completion event.
    }
};
const $8e52f4303f0a8224$var$startRequests = (entry, accountId, siteId, profile, actions)=>{
    const controller = new AbortController();
    const startedAt = Date.now();
    const scopeKey = entry.snapshot.scopeKey;
    let cancelled = false;
    let usageSettled = false;
    let activitySettled = false;
    let timeoutId;
    const finish = (snapshot, evaluation)=>{
        if (cancelled || entry.settled || $8e52f4303f0a8224$var$entries.get(scopeKey) !== entry) return;
        entry.settled = true;
        entry.snapshot = snapshot;
        entry.cancel = undefined;
        clearTimeout(timeoutId);
        actions.setSnapshot(snapshot);
        $8e52f4303f0a8224$var$emitSafely(entry, {
            ...evaluation,
            durationMs: Date.now() - startedAt
        }, 'enabled');
    };
    entry.cancel = ()=>{
        cancelled = true;
        clearTimeout(timeoutId);
        controller.abort();
    };
    timeoutId = setTimeout(()=>{
        const signal = !usageSettled && !activitySettled ? 'both' : !usageSettled ? 'usage' : 'siteActivity';
        finish({
            scopeKey: scopeKey,
            phase: 'unavailable'
        }, {
            outcome: 'unavailable',
            signal: signal,
            reason: 'timeout'
        });
        controller.abort();
    }, $8e52f4303f0a8224$var$REQUEST_TIMEOUT_MS);
    const usageRequest = (0, $6e8qW.fetchUserTraits)(accountId, controller.signal).finally(()=>{
        usageSettled = true;
    });
    const activityRequest = (0, $6e8qW.fetchSiteUserTraits)(siteId, accountId, controller.signal).finally(()=>{
        activitySettled = true;
    });
    Promise.allSettled([
        usageRequest,
        activityRequest
    ]).then(([usage, activity])=>{
        if (cancelled || entry.settled) return;
        if (usage.status === 'rejected' || activity.status === 'rejected') {
            const failedUsage = usage.status === 'rejected';
            const failedActivity = activity.status === 'rejected';
            const signal = failedUsage && failedActivity ? 'both' : failedUsage ? 'usage' : 'siteActivity';
            finish({
                scopeKey: scopeKey,
                phase: 'unavailable'
            }, {
                outcome: 'unavailable',
                signal: signal,
                reason: 'requestFailure'
            });
            return;
        }
        const activeDays = (0, $6e8qW.findTraitValue)(usage.value, profile.usageTrait);
        const lastActive = (0, $6e8qW.findTraitValue)(activity.value, profile.activityTrait);
        const evaluatedAt = Date.now();
        finish({
            scopeKey: scopeKey,
            phase: 'ready',
            activeDays: activeDays,
            lastActive: lastActive,
            evaluatedAt: evaluatedAt
        }, (0, $ee822672c6924f73$export$9edbb9ebac0b895a)(activeDays, lastActive, 2, 3, evaluatedAt));
    });
};
const $8e52f4303f0a8224$export$2254f5393f10ddbe = (0, $gtMdU.isReactCompilerActivePlatform)() ? (scope, emit)=>{
    const $ = (0, $bDgLe.c)(13);
    let t0;
    if ($[0] !== scope) {
        t0 = $8e52f4303f0a8224$export$9ff231eba9eeb959(scope);
        $[0] = scope;
        $[1] = t0;
    } else t0 = $[1];
    const scopeKey = t0;
    const { setSnapshot: setSnapshot, clearSnapshot: clearSnapshot } = (0, $dde33b12803a3fc0$export$a93a40f020109d38)();
    let t1;
    let t2;
    if ($[2] !== clearSnapshot || $[3] !== emit || $[4] !== scope.accountId || $[5] !== scope.gateEnabled || $[6] !== scope.hasRovoAccess || $[7] !== scope.productKey || $[8] !== scope.siteId || $[9] !== scopeKey || $[10] !== setSnapshot) {
        t1 = ()=>{
            const profile = $8e52f4303f0a8224$var$getTargetingProfile(scope.productKey);
            for (const [otherKey, previous] of $8e52f4303f0a8224$var$entries)if (otherKey !== scopeKey && previous.owners.size === 0) {
                previous.cancel?.();
                $8e52f4303f0a8224$var$entries.delete(otherKey);
                clearSnapshot(otherKey);
            }
            if (!profile || !scope.hasRovoAccess || !scope.accountId || !scope.siteId) return;
            const owner = (event)=>emit(event);
            let entry = $8e52f4303f0a8224$var$entries.get(scopeKey);
            if (entry) {
                entry.owners.add(owner);
                setSnapshot(entry.snapshot);
            } else {
                entry = {
                    owners: new Set([
                        owner
                    ]),
                    snapshot: {
                        scopeKey: scopeKey,
                        phase: scope.gateEnabled ? "loading" : "outsideRollout"
                    },
                    settled: !scope.gateEnabled
                };
                $8e52f4303f0a8224$var$entries.set(scopeKey, entry);
                setSnapshot(entry.snapshot);
                if (scope.gateEnabled) $8e52f4303f0a8224$var$startRequests(entry, scope.accountId, scope.siteId, profile, {
                    setSnapshot: setSnapshot,
                    clearSnapshot: clearSnapshot
                });
                else $8e52f4303f0a8224$var$emitSafely(entry, {
                    outcome: "outsideRollout",
                    signal: "none",
                    reason: "none"
                }, "disabled");
            }
            const ownedEntry = entry;
            return ()=>{
                ownedEntry.owners.delete(owner);
                Promise.resolve().then(()=>{
                    if (ownedEntry.owners.size === 0 && !ownedEntry.settled && $8e52f4303f0a8224$var$entries.get(scopeKey) === ownedEntry) {
                        ownedEntry.cancel?.();
                        $8e52f4303f0a8224$var$entries.delete(scopeKey);
                        clearSnapshot(scopeKey);
                    }
                });
            };
        };
        t2 = [
            clearSnapshot,
            emit,
            scope.accountId,
            scope.gateEnabled,
            scope.hasRovoAccess,
            scope.productKey,
            scope.siteId,
            scopeKey,
            setSnapshot
        ];
        $[2] = clearSnapshot;
        $[3] = emit;
        $[4] = scope.accountId;
        $[5] = scope.gateEnabled;
        $[6] = scope.hasRovoAccess;
        $[7] = scope.productKey;
        $[8] = scope.siteId;
        $[9] = scopeKey;
        $[10] = setSnapshot;
        $[11] = t1;
        $[12] = t2;
    } else {
        t1 = $[11];
        t2 = $[12];
    }
    (0, $cozmU.useEffect)(t1, t2);
} : (scope, emit)=>{
    const scopeKey = $8e52f4303f0a8224$export$9ff231eba9eeb959(scope);
    const { setSnapshot: setSnapshot, clearSnapshot: clearSnapshot } = (0, $dde33b12803a3fc0$export$a93a40f020109d38)();
    (0, $cozmU.useEffect)(()=>{
        const profile = $8e52f4303f0a8224$var$getTargetingProfile(scope.productKey);
        for (const [otherKey, previous] of $8e52f4303f0a8224$var$entries)if (otherKey !== scopeKey && previous.owners.size === 0) {
            previous.cancel?.();
            $8e52f4303f0a8224$var$entries.delete(otherKey);
            clearSnapshot(otherKey);
        }
        // Unsupported products and missing host access/identity are not rollout exclusions.
        if (!profile || !scope.hasRovoAccess || !scope.accountId || !scope.siteId) return;
        // Every mount has its own lease, even when mounts share an analytics callback.
        const owner = (event)=>emit(event);
        let entry = $8e52f4303f0a8224$var$entries.get(scopeKey);
        if (entry) {
            entry.owners.add(owner);
            setSnapshot(entry.snapshot);
        } else {
            entry = {
                owners: new Set([
                    owner
                ]),
                snapshot: {
                    scopeKey: scopeKey,
                    phase: scope.gateEnabled ? 'loading' : 'outsideRollout'
                },
                settled: !scope.gateEnabled
            };
            $8e52f4303f0a8224$var$entries.set(scopeKey, entry);
            setSnapshot(entry.snapshot);
            if (scope.gateEnabled) $8e52f4303f0a8224$var$startRequests(entry, scope.accountId, scope.siteId, profile, {
                setSnapshot: setSnapshot,
                clearSnapshot: clearSnapshot
            });
            else $8e52f4303f0a8224$var$emitSafely(entry, {
                outcome: 'outsideRollout',
                signal: 'none',
                reason: 'none'
            }, 'disabled');
        }
        const ownedEntry = entry;
        return ()=>{
            ownedEntry.owners.delete(owner);
            // StrictMode and sibling remounts can reacquire the same request before cleanup.
            Promise.resolve().then(()=>{
                if (ownedEntry.owners.size === 0 && !ownedEntry.settled && $8e52f4303f0a8224$var$entries.get(scopeKey) === ownedEntry) {
                    ownedEntry.cancel?.();
                    $8e52f4303f0a8224$var$entries.delete(scopeKey);
                    clearSnapshot(scopeKey);
                }
            });
        };
    }, [
        clearSnapshot,
        emit,
        scope.accountId,
        scope.gateEnabled,
        scope.hasRovoAccess,
        scope.productKey,
        scope.siteId,
        scopeKey,
        setSnapshot
    ]);
};





const $2235dbf3d34a5191$export$cce032607bea29fa = (0, $cozmU.createContext)({
    productKey: '',
    hasRovoAccess: false,
    gateEnabled: false,
    scopeKey: 'unsupported'
});


const $f3561b6cec922c89$export$7d243948bdede292 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    const { children: children, productKey: productKey, accountId: accountId, siteId: siteId, hasRovoAccess: hasRovoAccess, gateEnabled: gateEnabled } = t0;
    let t1;
    if ($[0] !== accountId || $[1] !== gateEnabled || $[2] !== hasRovoAccess || $[3] !== productKey || $[4] !== siteId) {
        const scope = {
            productKey: productKey,
            accountId: accountId,
            siteId: siteId,
            hasRovoAccess: hasRovoAccess,
            gateEnabled: gateEnabled
        };
        t1 = {
            ...scope,
            scopeKey: (0, $8e52f4303f0a8224$export$9ff231eba9eeb959)(scope)
        };
        $[0] = accountId;
        $[1] = gateEnabled;
        $[2] = hasRovoAccess;
        $[3] = productKey;
        $[4] = siteId;
        $[5] = t1;
    } else t1 = $[5];
    const contextValue = t1;
    let t2;
    if ($[6] !== children || $[7] !== contextValue) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2235dbf3d34a5191$export$cce032607bea29fa).Provider, {
            value: contextValue
        }, children);
        $[6] = children;
        $[7] = contextValue;
        $[8] = t2;
    } else t2 = $[8];
    return t2;
} : ({ children: children, productKey: productKey, accountId: accountId, siteId: siteId, hasRovoAccess: hasRovoAccess, gateEnabled: gateEnabled })=>{
    const contextValue = (0, $cozmU.useMemo)(()=>{
        const scope = {
            productKey: productKey,
            accountId: accountId,
            siteId: siteId,
            hasRovoAccess: hasRovoAccess,
            gateEnabled: gateEnabled
        };
        return {
            ...scope,
            scopeKey: (0, $8e52f4303f0a8224$export$9ff231eba9eeb959)(scope)
        };
    }, [
        productKey,
        accountId,
        siteId,
        hasRovoAccess,
        gateEnabled
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2235dbf3d34a5191$export$cce032607bea29fa).Provider, {
        value: contextValue
    }, children);
};
const $f3561b6cec922c89$export$4e56e8c70a3eba80 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const { emit: emit } = t0;
    const scope = (0, $cozmU.useContext)((0, $2235dbf3d34a5191$export$cce032607bea29fa));
    (0, $8e52f4303f0a8224$export$2254f5393f10ddbe)(scope, emit);
    return null;
} : ({ emit: emit })=>{
    const scope = (0, $cozmU.useContext)((0, $2235dbf3d34a5191$export$cce032607bea29fa));
    (0, $8e52f4303f0a8224$export$2254f5393f10ddbe)(scope, emit);
    return null;
};


const $30e6e2bae0242b24$var$ReadinessInitializer = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(4);
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    let t0;
    if ($[0] !== sendAnalyticsEvent) {
        t0 = (event)=>{
            sendAnalyticsEvent({
                eventType: "operational",
                ...event.data
            });
        };
        $[0] = sendAnalyticsEvent;
        $[1] = t0;
    } else t0 = $[1];
    const emit = t0;
    let t1;
    if ($[2] !== emit) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f3561b6cec922c89$export$4e56e8c70a3eba80), {
            emit: emit
        });
        $[2] = emit;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : ()=>{
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const emit = (0, $cozmU.useCallback)((event)=>{
        sendAnalyticsEvent({
            eventType: 'operational',
            ...event.data
        });
    }, [
        sendAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f3561b6cec922c89$export$4e56e8c70a3eba80), {
        emit: emit
    });
};
const $30e6e2bae0242b24$export$d42e57918dc315c8 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(11);
    const { children: children, productKey: productKey, accountId: accountId, siteId: siteId, hasRovoAccess: hasRovoAccess } = t0;
    let t1;
    if ($[0] !== hasRovoAccess || $[1] !== productKey) {
        t1 = hasRovoAccess && (productKey === "confluence" && (0, $iDrrr.fg)("confluence_rovo_chat_targeting_readiness") || productKey === "jira" && (0, $iDrrr.fg)("jira_rovo_chat_targeting_readiness") || productKey === "jsm" && (0, $iDrrr.fg)("jsm_rovo_chat_targeting_readiness"));
        $[0] = hasRovoAccess;
        $[1] = productKey;
        $[2] = t1;
    } else t1 = $[2];
    const gateEnabled = t1;
    let t2;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1Pvvv.AIMateAnalyticsContext), {
            data: {
                source: "rovoTargeting"
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($30e6e2bae0242b24$var$ReadinessInitializer, null));
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== accountId || $[5] !== children || $[6] !== gateEnabled || $[7] !== hasRovoAccess || $[8] !== productKey || $[9] !== siteId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f3561b6cec922c89$export$7d243948bdede292), {
            productKey: productKey,
            accountId: accountId,
            siteId: siteId,
            hasRovoAccess: hasRovoAccess,
            gateEnabled: gateEnabled
        }, t2, children);
        $[4] = accountId;
        $[5] = children;
        $[6] = gateEnabled;
        $[7] = hasRovoAccess;
        $[8] = productKey;
        $[9] = siteId;
        $[10] = t3;
    } else t3 = $[10];
    return t3;
} : ({ children: children, productKey: productKey, accountId: accountId, siteId: siteId, hasRovoAccess: hasRovoAccess })=>{
    const gateEnabled = hasRovoAccess && (productKey === 'confluence' && (0, $iDrrr.fg)('confluence_rovo_chat_targeting_readiness') || productKey === 'jira' && (0, $iDrrr.fg)('jira_rovo_chat_targeting_readiness') || productKey === 'jsm' && (0, $iDrrr.fg)('jsm_rovo_chat_targeting_readiness'));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f3561b6cec922c89$export$7d243948bdede292), {
        productKey: productKey,
        accountId: accountId,
        siteId: siteId,
        hasRovoAccess: hasRovoAccess,
        gateEnabled: gateEnabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1Pvvv.AIMateAnalyticsContext), {
        data: {
            source: 'rovoTargeting'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($30e6e2bae0242b24$var$ReadinessInitializer, null)), children);
};





















var $7SkLu = parcelRequire("7SkLu");


var $gXfti = parcelRequire("gXfti");


var $3PNw6 = parcelRequire("3PNw6");








var $hd4Ag = parcelRequire("hd4Ag");

const $d53b47274490f517$export$b0f54970cfd52c5b = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    const { fullscreen: fullscreen, mode: mode, shouldPublishChatOpenOnTransitionData: t1 } = t0;
    const shouldPublishChatOpenOnTransitionData = t1 === undefined ? true : t1;
    const location = (0, $hd4Ag.useWindowLocation)();
    const previousLocationRef = (0, $cozmU.useRef)(location);
    const [isChatMountedAcrossTransition, setIsChatMountedAcrossTransition] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState(false);
    let conversationAssistantMode = "unknown";
    const [t2] = (0, $8akfd.useStagingArea)();
    const { stagingAreaMode: stagingAreaMode } = t2;
    const [smartCreationModalSurface] = (0, $gzMZq.useSmartCreationModalSurface)();
    const isSmartCreationSurfaceTrackingEnabled = (0, $4o0zT.isExperimentEnabled)("cwr_entrypoint_parity_staging_area_mode_enum");
    if (isSmartCreationSurfaceTrackingEnabled && smartCreationModalSurface === "prompt") conversationAssistantMode = "aifc-prompt";
    else {
        if (isSmartCreationSurfaceTrackingEnabled && smartCreationModalSurface === "staging" || stagingAreaMode === "modal" || stagingAreaMode === "ephemeralModal") conversationAssistantMode = "aifc-modal";
        else if (fullscreen) conversationAssistantMode = "fullscreen";
        else {
            if (mode === "mini-modal") conversationAssistantMode = "mini-modal";
            else if (mode === "sidebar") conversationAssistantMode = "sidebar";
        }
    }
    let t3;
    let t4;
    if ($[0] !== fullscreen || $[1] !== location) {
        t3 = ()=>{
            if (!fullscreen) (0, $iDrrr.fg)("platform_ufo_custom_cohort_data_migration") ? (0, $7SkLu.addUFOCustomCohortData)("isRovoSidebarVisible", true) : (0, $gXfti.addUFOCustomData)({
                isRovoSidebarVisible: true
            });
            if (previousLocationRef.current !== location) {
                previousLocationRef.current = location;
                setIsChatMountedAcrossTransition(true);
            }
            return $d53b47274490f517$var$_temp;
        };
        t4 = [
            fullscreen,
            location
        ];
        $[0] = fullscreen;
        $[1] = location;
        $[2] = t3;
        $[3] = t4;
    } else {
        t3 = $[2];
        t4 = $[3];
    }
    (0, $cozmU.useLayoutEffect)(t3, t4);
    let t5;
    if ($[4] !== isChatMountedAcrossTransition || $[5] !== shouldPublishChatOpenOnTransitionData) {
        t5 = shouldPublishChatOpenOnTransitionData ? {
            isChatMountedAcrossTransition: isChatMountedAcrossTransition
        } : undefined;
        $[4] = isChatMountedAcrossTransition;
        $[5] = shouldPublishChatOpenOnTransitionData;
        $[6] = t5;
    } else t5 = $[6];
    let t6;
    if ($[7] !== conversationAssistantMode || $[8] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3PNw6.default), {
            data: {
                conversationAssistantMode: conversationAssistantMode,
                ...t5
            }
        });
        $[7] = conversationAssistantMode;
        $[8] = t5;
        $[9] = t6;
    } else t6 = $[9];
    return t6;
} : ({ fullscreen: fullscreen, mode: mode, shouldPublishChatOpenOnTransitionData: shouldPublishChatOpenOnTransitionData = true })=>{
    const location = (0, $hd4Ag.useWindowLocation)();
    const previousLocationRef = (0, $cozmU.useRef)(location);
    const [isChatMountedAcrossTransition, setIsChatMountedAcrossTransition] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState(false);
    let conversationAssistantMode = 'unknown';
    const [{ stagingAreaMode: stagingAreaMode }] = (0, $8akfd.useStagingArea)();
    const [smartCreationModalSurface] = (0, $gzMZq.useSmartCreationModalSurface)();
    const isSmartCreationSurfaceTrackingEnabled = (0, $4o0zT.isExperimentEnabled)('cwr_entrypoint_parity_staging_area_mode_enum');
    if (isSmartCreationSurfaceTrackingEnabled && smartCreationModalSurface === 'prompt') conversationAssistantMode = 'aifc-prompt';
    else if (isSmartCreationSurfaceTrackingEnabled && smartCreationModalSurface === 'staging' || stagingAreaMode === 'modal' || stagingAreaMode === 'ephemeralModal') conversationAssistantMode = 'aifc-modal';
    else if (fullscreen) conversationAssistantMode = 'fullscreen';
    else if (mode === 'mini-modal') conversationAssistantMode = 'mini-modal';
    else if (mode === 'sidebar') conversationAssistantMode = 'sidebar';
    (0, $cozmU.useLayoutEffect)(()=>{
        if (!fullscreen) (0, $iDrrr.fg)('platform_ufo_custom_cohort_data_migration') ? (0, $7SkLu.addUFOCustomCohortData)('isRovoSidebarVisible', true) : (0, $gXfti.addUFOCustomData)({
            isRovoSidebarVisible: true
        });
        if (previousLocationRef.current !== location) {
            previousLocationRef.current = location;
            setIsChatMountedAcrossTransition(true);
        }
        return ()=>{
            (0, $iDrrr.fg)('platform_ufo_custom_cohort_data_migration') ? (0, $7SkLu.addUFOCustomCohortData)('isRovoSidebarVisible', false) : (0, $gXfti.addUFOCustomData)({
                isRovoSidebarVisible: false
            });
        };
    }, [
        fullscreen,
        location
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3PNw6.default), {
        data: {
            conversationAssistantMode: conversationAssistantMode,
            ...shouldPublishChatOpenOnTransitionData ? {
                isChatMountedAcrossTransition: isChatMountedAcrossTransition
            } : undefined
        }
    });
};
function $d53b47274490f517$var$_temp() {
    (0, $iDrrr.fg)("platform_ufo_custom_cohort_data_migration") ? (0, $7SkLu.addUFOCustomCohortData)("isRovoSidebarVisible", false) : (0, $gXfti.addUFOCustomData)({
        isRovoSidebarVisible: false
    });
}


const $8065a799419bdbe8$var$ChatUILoadingBoundary = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { children: children } = t0;
    const hasOuterLoadingBoundary = (0, $cozmU.useContext)((0, $kYruZ.ConversationAssistantLoadingContext));
    if (hasOuterLoadingBoundary) {
        let t1;
        if ($[0] !== children) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
            $[0] = children;
            $[1] = t1;
        } else t1 = $[1];
        return t1;
    }
    let t1;
    if ($[2] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $91ZZN.default), {
            fallback: null,
            interactionName: "LoadingConversationAssistantUIBundle"
        }, children);
        $[2] = children;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : ({ children: children })=>{
    const hasOuterLoadingBoundary = (0, $cozmU.useContext)((0, $kYruZ.ConversationAssistantLoadingContext));
    if (hasOuterLoadingBoundary) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $91ZZN.default), {
        fallback: null,
        interactionName: "LoadingConversationAssistantUIBundle"
    }, children);
};
const $8065a799419bdbe8$export$e4ac8b50628685c4 = ({ testId: testId, onCloseChat: onCloseChat, config: config, uiConfig: uiConfig, agentsConfig: agentsConfig, agentVersioningConfig: agentVersioningConfig, isNav4Enabled: isNav4Enabled, sitePickerRender: sitePickerRender, overridingChildren: overridingChildren, modeConfig: modeConfig, getActions: getActions, prioritizeCustomActionResults: prioritizeCustomActionResults, numStartersToShow: numStartersToShow, stagingAreaRef: stagingAreaRef, topOffset: topOffset = 0, tags: tags, initialPrompt: initialPrompt, suppressInitialFocus: suppressInitialFocus, skipChatUI: skipChatUI, forceRestoreConversationId: forceRestoreConversationId })=>{
    (0, $6cFsl.di)((0, $lJ6db.AssistanceServiceProvider), (0, $07964e27dfae7b36$export$9b7b433b0520b82b), (0, $c2Doe.SmartCardProvider), (0, $89QZA.AnalyticsContextWithSourceAndProperties));
    const shouldSkipChatUI = skipChatUI ?? Boolean(overridingChildren);
    (0, $cozmU.useMemo)(()=>{
        // Setting devtools in useMemo to make sure we catch the first render.
        // ReactSweetStateDefaults may be undefined when bundlers tree-shake or when the
        // module isn't available at runtime. Guard access to avoid runtime exceptions.
        try {
            if (// eslint-disable-next-line @atlaskit/platform/no-preconditioning
            (0, $iDrrr.fg)('ai_mate_react_sweet_state_devtools') && typeof (0, $kiAM2.default) !== 'undefined' && (0, $kiAM2.default) && 'devtools' in (0, $kiAM2.default)) (0, $kiAM2.default).devtools = true;
        } catch  {
        // swallow errors intentionally — best-effort only
        }
    }, []);
    const ufoContext = (0, $dUAp3.useInteractionContext)();
    const ufoLabelStack = (0, $cozmU.useMemo)(()=>ufoContext?.labelStack ?? [
            {
                name: 'rovo-conversation-assistant'
            }
        ], [
        ufoContext?.labelStack
    ]);
    const setUFOLabelStack = (0, $bjY3F.useUFOLabelStackSetter)();
    (0, $cozmU.useMemo)(()=>{
        setUFOLabelStack(ufoLabelStack);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        ufoLabelStack
    ]);
    const profileData = (0, $isp1U.useProfileController)();
    const { isRovoEnabled: isRovoEnabled } = (0, $8lt5O.useRovoEntitlement)();
    const { setIsChatOnboardingMiniModalOpen: setIsChatOnboardingMiniModalOpen } = (0, $bGNkz.useUIStoreActions)();
    const { isChatOnboardingMiniModalOpen: isChatOnboardingMiniModalOpen } = (0, $bGNkz.useUIStore)();
    (0, $cozmU.useEffect)(()=>{
        (0, $de717ae3a7549f1b$export$caa27b16709bc2df)(config.product);
    }, [
        config.product
    ]);
    const [sharedFeaturesInstrumentationId, setSharedFeaturesInstrumentationId] = (0, $cozmU.useState)(undefined);
    const assistanceService = (0, $cozmU.useMemo)(()=>new (0, $lJ6db.AssistanceServiceImpl)({
            baseUrl: config.assistanceServiceConfig?.baseUrl,
            headers: config.assistanceServiceConfig?.headers,
            channelId: config.assistanceServiceConfig?.channelId,
            product: config.product,
            siteId: config.siteId,
            experienceId: config.experienceId ?? (0, $oV0CU.AI_MATE_EXPERIENCE_ID),
            minionAlias: config.assistanceServiceConfig?.minionAlias,
            labelStack: ufoLabelStack
        }), [
        config.assistanceServiceConfig?.baseUrl,
        config.assistanceServiceConfig?.headers,
        config.assistanceServiceConfig?.channelId,
        config.product,
        config.siteId,
        config.experienceId,
        config.assistanceServiceConfig?.minionAlias,
        ufoLabelStack
    ]);
    const globalConfig = (0, $cozmU.useMemo)(()=>(0, $58f16686a4f70667$export$b9c35db6980960f2)({
            ...config,
            profileData: profileData,
            closeChat: ()=>{
                onCloseChat?.();
                if (isChatOnboardingMiniModalOpen) setIsChatOnboardingMiniModalOpen(false);
            }
        }), [
        config,
        profileData,
        onCloseChat,
        setIsChatOnboardingMiniModalOpen,
        isChatOnboardingMiniModalOpen
    ]);
    const { agentOverriderValue: agentOverriderValue, uiConfigValue: uiConfigValue } = (0, $2af21e7e5be03781$export$1d5179b714ffcf31)({
        agentsConfig: agentsConfig,
        uiConfig: uiConfig
    });
    // When initialPrompt is provided, self-publish a chat-new PubSub event
    // to trigger the existing PubSubListener handler which creates a seeded
    // conversation and auto-sends the prompt.
    const initialPromptFiredRef = (0, $cozmU.useRef)(false);
    const publish = (0, $hdBxM.usePublish)('ai-mate');
    (0, $cozmU.useEffect)(()=>{
        if (!initialPrompt || initialPromptFiredRef.current) return;
        initialPromptFiredRef.current = true;
        // Use requestAnimationFrame to ensure PubSubListener has subscribed
        requestAnimationFrame(()=>{
            publish({
                type: 'chat-new',
                source: 'linkedConfluenceDocRovoNudge',
                data: {
                    prompt: initialPrompt,
                    dialogues: [],
                    mode: {
                        useCurrentPageContext: config.useCurrentBrowsingContext ?? true
                    }
                }
            });
        });
    }, [
        config.useCurrentBrowsingContext,
        initialPrompt,
        publish
    ]);
    const rovoChatXpcContextValues = (0, $cozmU.useMemo)(()=>(0, $0f2cd6a53c0a2177$export$6e73203ac85a4798)({
            mode: modeConfig?.mode,
            isFullScreen: uiConfig?.fullScreen,
            xpcBridge: config.xpcBridge,
            xpcProduct: config.xpcProduct,
            xpcSubProduct: config.xpcSubProduct,
            productKey: globalConfig.productKey
        }), [
        config.xpcBridge,
        config.xpcProduct,
        config.xpcSubProduct,
        globalConfig.productKey,
        modeConfig?.mode,
        uiConfig?.fullScreen
    ]);
    return(// The order of analytics properties context and experienceTracker matters here
    // for experience tracker to send correct analytics properties, it needs to be under analyticsContext
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $89QZA.AnalyticsContextWithSourceAndProperties), {
        source: "AIMate",
        mode: modeConfig?.mode ?? (0, $dPoYT.ConversationAssistantUIModes).SIDEBAR,
        sharedFeaturesInstrumentationId: sharedFeaturesInstrumentationId,
        isAlwaysInSmartCreateFlow: sharedFeaturesInstrumentationId !== undefined ? true : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $30e6e2bae0242b24$export$d42e57918dc315c8), {
        productKey: config.rovoTargetingContext?.productKey ?? globalConfig.productKey,
        accountId: config.rovoTargetingContext ? config.rovoTargetingContext.accountId : config.userId,
        siteId: config.rovoTargetingContext ? config.rovoTargetingContext.siteId : config.siteId,
        hasRovoAccess: config.rovoTargetingContext?.hasRovoAccess ?? isRovoEnabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8lt5O.RovoEntitlementSetter), {
        isRovoEnabled: isRovoEnabled
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gyWKg.ErrorBoundary), {
        experienceName: (0, $irnO2.ExperienceName).LOAD_PANEL,
        rethrowErrors: config.rethrowErrors ?? false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b6e4c82a4164acfc$export$920227929045c1b5), {
        value: globalConfig
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $37RgG.AgentOverriderProvider), {
        value: agentOverriderValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $31f0ba1c2c4d97e2$export$51f901728a02d39c), {
        value: agentVersioningConfig
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $735ca6a936ab5049$export$3063519296e335bf), {
        value: uiConfigValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c2Doe.SmartCardProvider), {
        bridgeProduct: rovoChatXpcContextValues.bridgeProduct,
        xpcProduct: rovoChatXpcContextValues.xpcProduct,
        xpcSubProduct: rovoChatXpcContextValues.xpcSubProduct
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6390d7b9d52b6817$export$94b280d16f0eef6b), rovoChatXpcContextValues, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7akNQ.FlagsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lJ6db.AssistanceServiceProvider), {
        value: assistanceService
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $557d858394512263$export$b0b2d9624bbf3936), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d53b47274490f517$export$b0f54970cfd52c5b), {
        fullscreen: uiConfig?.fullScreen,
        mode: modeConfig?.mode ?? (0, $dPoYT.ConversationAssistantUIModes).SIDEBAR,
        shouldPublishChatOpenOnTransitionData: !shouldSkipChatUI
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8b089c26465af0fa$export$de9a15d22e1ad816), {
        onPromptSent: config.onPromptSent,
        forceRestoreConversationId: forceRestoreConversationId
    }, shouldSkipChatUI ? // NOTE: `overridingChildren` consumers (e.g. CwR staging-area-modal,
    // chat-only-creation-modal) are responsible for wrapping their own
    // subtree with `RovoSettingsModalProvider` so entrypoints to the
    // settings modal work via useSideNavModal(). The provider is
    // idempotent, so defensive wrapping is safe. See ASIMO-3977.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $j180q.AnalyticsPropertiesUpdater), null), overridingChildren) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8065a799419bdbe8$var$ChatUILoadingBoundary, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ccc7a37bcb1eb3eb$export$a04da3780397ecbb), {
        config: config,
        getActions: getActions,
        isNav4Enabled: isNav4Enabled,
        modeConfig: modeConfig,
        numStartersToShow: numStartersToShow,
        prioritizeCustomActionResults: prioritizeCustomActionResults,
        setSharedFeaturesInstrumentationId: setSharedFeaturesInstrumentationId,
        sitePickerRender: sitePickerRender,
        stagingAreaRef: stagingAreaRef,
        suppressInitialFocus: suppressInitialFocus,
        tags: tags,
        testId: testId,
        topOffset: topOffset,
        uiConfig: uiConfig
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cd23f59678a0acda$export$4ae751989dace185), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $741693f1d6085f6e$export$1f35aa17211e523d), null)))))))))))))));
};


const $4bc8868ee45f5b87$export$9777b121d71c4de1 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(11);
    let props;
    let skipRelayProvider;
    if ($[0] !== t0) {
        ({ skipRelayProvider: skipRelayProvider, ...props } = t0);
        $[0] = t0;
        $[1] = props;
        $[2] = skipRelayProvider;
    } else {
        props = $[1];
        skipRelayProvider = $[2];
    }
    const shouldSkipChatUI = props.skipChatUI ?? Boolean(props.overridingChildren);
    const rootSegmentName = shouldSkipChatUI ? "rovo-conversation-assistant-wOverriddenChildren" : "rovo-conversation-assistant";
    let t1;
    if ($[3] !== props) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8065a799419bdbe8$export$e4ac8b50628685c4), props);
        $[3] = props;
        $[4] = t1;
    } else t1 = $[4];
    const content = t1;
    let t2;
    if ($[5] !== content || $[6] !== skipRelayProvider) {
        t2 = skipRelayProvider ? content : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d5gEx.AtlassianRelayEnvironmentProvider), null, content);
        $[5] = content;
        $[6] = skipRelayProvider;
        $[7] = t2;
    } else t2 = $[7];
    let t3;
    if ($[8] !== rootSegmentName || $[9] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $65DSU.default), {
            name: rootSegmentName
        }, t2);
        $[8] = rootSegmentName;
        $[9] = t2;
        $[10] = t3;
    } else t3 = $[10];
    return t3;
} : ({ skipRelayProvider: skipRelayProvider, ...props })=>{
    // Mounts that skip the chat UI still initialise the shared providers, the global chat store and the
    // bridge API handlers. `overridingChildren` is the legacy signal for the same intent, so it keeps
    // implying the chat UI is skipped.
    const shouldSkipChatUI = props.skipChatUI ?? Boolean(props.overridingChildren);
    const rootSegmentName = shouldSkipChatUI ? 'rovo-conversation-assistant-wOverriddenChildren' : 'rovo-conversation-assistant';
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8065a799419bdbe8$export$e4ac8b50628685c4), props);
    return(// The UFOSegment has to be absolute top, please do not introduce any side effects in this parent level component,
    // otherwise it may not get captured with performance metrics
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $65DSU.default), {
        name: rootSegmentName
    }, skipRelayProvider ? content : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d5gEx.AtlassianRelayEnvironmentProvider), null, content)));
};
module.exports["ConversationAssistant"] = $4bc8868ee45f5b87$export$9777b121d71c4de1;

});

parcelRegister("7akNQ", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $a2foB = parcelRequire("a2foB");


var $FKQbh = parcelRequire("FKQbh");


var $iXRmn = parcelRequire("iXRmn");


var $lqtHz = parcelRequire("lqtHz");

const $08beb25a8c4ef160$var$getUniqueId = (()=>{
    let count = 0;
    return ()=>`flag-provider-unique-id:${count++}`;
})();
const $08beb25a8c4ef160$export$a4270ab432ac8a58 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function FlagsProvider(t0) {
    const $ = (0, $bDgLe.c)(13);
    const { children: children, shouldRenderToParent: shouldRenderToParent } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [];
        $[0] = t1;
    } else t1 = $[0];
    const [flags, setFlags] = (0, $cozmU.useState)(t1);
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (id)=>{
            setFlags((current)=>current.slice(0).filter((flag)=>flag.id !== id));
        };
        $[1] = t2;
    } else t2 = $[1];
    const removeFlag = t2;
    let t3;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = {
            showFlag: function show(value) {
                const flag_0 = {
                    ...value,
                    id: value.id || $08beb25a8c4ef160$var$getUniqueId()
                };
                setFlags((current_0)=>{
                    const index = current_0.findIndex((value_0)=>value_0.id === flag_0.id);
                    if (index === -1) return [
                        flag_0,
                        ...current_0
                    ];
                    const shallow = [
                        ...current_0
                    ];
                    shallow[index] = flag_0;
                    return shallow;
                });
                return function dismiss() {
                    removeFlag(flag_0.id);
                };
            },
            hideFlag: removeFlag
        };
        $[2] = t3;
    } else t3 = $[2];
    const api = t3;
    let t4;
    if ($[3] !== children) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iXRmn.FlagContext).Provider, {
            value: api,
            children: children
        });
        $[3] = children;
        $[4] = t4;
    } else t4 = $[4];
    let t5;
    if ($[5] !== flags) {
        t5 = flags.map($08beb25a8c4ef160$var$_temp);
        $[5] = flags;
        $[6] = t5;
    } else t5 = $[6];
    let t6;
    if ($[7] !== shouldRenderToParent || $[8] !== t5) {
        t6 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lqtHz.default), {
            onDismissed: removeFlag,
            shouldRenderToParent: shouldRenderToParent,
            children: t5
        });
        $[7] = shouldRenderToParent;
        $[8] = t5;
        $[9] = t6;
    } else t6 = $[9];
    let t7;
    if ($[10] !== t4 || $[11] !== t6) {
        t7 = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8aG6j.Fragment), {
            children: [
                t4,
                t6
            ]
        });
        $[10] = t4;
        $[11] = t6;
        $[12] = t7;
    } else t7 = $[12];
    return t7;
} : function FlagsProvider({ children: children, shouldRenderToParent: shouldRenderToParent }) {
    const [flags, setFlags] = (0, $cozmU.useState)([]);
    const removeFlag = (0, $cozmU.useCallback)((id)=>{
        setFlags((current)=>{
            return current.slice(0).filter((flag)=>flag.id !== id);
        });
    }, []);
    const api = (0, $cozmU.useMemo)(()=>({
            showFlag: function show(value) {
                const flag_0 = {
                    ...value,
                    id: value.id || $08beb25a8c4ef160$var$getUniqueId()
                };
                setFlags((current_0)=>{
                    const index = current_0.findIndex((value_0)=>value_0.id === flag_0.id);
                    // If flag is not found add it
                    if (index === -1) return [
                        flag_0,
                        ...current_0
                    ];
                    // If flag already exists with the same id, then replace it
                    const shallow = [
                        ...current_0
                    ];
                    shallow[index] = flag_0;
                    return shallow;
                });
                return function dismiss() {
                    removeFlag(flag_0.id);
                };
            },
            hideFlag: removeFlag
        }), [
        removeFlag
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8aG6j.Fragment), {
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iXRmn.FlagContext).Provider, {
                value: api,
                children: children
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lqtHz.default), {
                onDismissed: removeFlag,
                shouldRenderToParent: shouldRenderToParent,
                children: flags.map((flag_1)=>{
                    const { isAutoDismiss: isAutoDismiss, ...restProps } = flag_1;
                    const FlagType = isAutoDismiss ? (0, $a2foB.default) : (0, $FKQbh.default);
                    return /*#__PURE__*/ (0, $cozmU.createElement)(FlagType, {
                        ...restProps,
                        key: flag_1.id
                    });
                })
            })
        ]
    });
};
function $08beb25a8c4ef160$var$_temp(flag_1) {
    const { isAutoDismiss: isAutoDismiss, ...restProps } = flag_1;
    const FlagType = isAutoDismiss ? (0, $a2foB.default) : (0, $FKQbh.default);
    return /*#__PURE__*/ (0, $cozmU.createElement)(FlagType, {
        ...restProps,
        key: flag_1.id
    });
}
module.exports["FlagsProvider"] = $08beb25a8c4ef160$export$a4270ab432ac8a58;

});

parcelRegister("iXRmn", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $bbe556224ecd1c1b$export$2eb95677cf2465e1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext(null);
module.exports["FlagContext"] = $bbe556224ecd1c1b$export$2eb95677cf2465e1;

});

parcelRegister("37RgG", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");

const $cd2bff7865b1d155$export$ccc6603eb027f48b = /*#__PURE__*/ (0, $cozmU.createContext)({});
const $cd2bff7865b1d155$export$7b61e11d4e81ba17 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)($cd2bff7865b1d155$export$ccc6603eb027f48b);
} : ()=>(0, $cozmU.useContext)($cd2bff7865b1d155$export$ccc6603eb027f48b);
const $cd2bff7865b1d155$export$aa582af5b4b72bb2 = $cd2bff7865b1d155$export$ccc6603eb027f48b.Provider;
const $cd2bff7865b1d155$export$6aab84dc399ad753 = (config)=>({
        agentDefaultIdOverride: config?.defaultAgentId,
        agentIdFiltersOverride: config?.filter
    });
module.exports["useAgentOverrider"] = $cd2bff7865b1d155$export$7b61e11d4e81ba17;
module.exports["AgentOverriderProvider"] = $cd2bff7865b1d155$export$aa582af5b4b72bb2;
module.exports["createAgentsConfig"] = $cd2bff7865b1d155$export$6aab84dc399ad753;

});

parcelRegister("8lt5O", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $464fa95e1d18f18e$var$rovoEntitlementStore = (0, $8s9DV.createStore)({
    initialState: {
        isRovoEnabled: false
    },
    name: 'RovoEntitlementStore',
    actions: {
        setIsRovoEnabled: (isRovoEnabled, reason)=>({ setState: setState })=>{
                setState({
                    isRovoEnabled: isRovoEnabled,
                    reason: reason
                });
            }
    }
});
const $464fa95e1d18f18e$var$useStateHook = (0, $kBr4q.createStateHook)($464fa95e1d18f18e$var$rovoEntitlementStore);
const $464fa95e1d18f18e$export$66d5dd4be64dea43 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(2);
    const result = $464fa95e1d18f18e$var$useStateHook();
    let t0;
    if ($[0] !== result) {
        t0 = {
            ...result,
            isRovoEnabled: result.isRovoEnabled
        };
        $[0] = result;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : ()=>{
    const result = $464fa95e1d18f18e$var$useStateHook();
    return {
        ...result,
        isRovoEnabled: result.isRovoEnabled
    };
};
const $464fa95e1d18f18e$export$8004893135276275 = (0, $kBr4q.createActionsHook)($464fa95e1d18f18e$var$rovoEntitlementStore);
const $464fa95e1d18f18e$export$d03a05ad8547472c = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const { isRovoEnabled: isRovoEnabled } = t0;
    const { setIsRovoEnabled: setIsRovoEnabled } = $464fa95e1d18f18e$export$8004893135276275();
    setIsRovoEnabled(isRovoEnabled);
    return null;
} : ({ isRovoEnabled: isRovoEnabled })=>{
    const { setIsRovoEnabled: setIsRovoEnabled } = $464fa95e1d18f18e$export$8004893135276275();
    (0, $cozmU.useMemo)(()=>{
        setIsRovoEnabled(isRovoEnabled);
    }, [
        isRovoEnabled,
        setIsRovoEnabled
    ]);
    return null;
};
module.exports["useRovoEntitlement"] = $464fa95e1d18f18e$export$66d5dd4be64dea43;
module.exports["useRovoEntitlementActions"] = $464fa95e1d18f18e$export$8004893135276275;
module.exports["RovoEntitlementSetter"] = $464fa95e1d18f18e$export$d03a05ad8547472c;

});

parcelRegister("irnO2", function(module, exports) {

var $cNAch = parcelRequire("cNAch");


var $4MiWC = parcelRequire("4MiWC");

const $b6334bd5b5c71b1c$export$b881bd9f00ed8ed1 = {
    LOAD_PANEL: 'aiMateLoadPanel',
    LOAD_PANEL_COMPOSABLE_EDITOR: 'aiMateLoadPanelComposableEditor',
    LOAD_INLINE_EDITOR: 'aiMateLoadInlineComposableEditor',
    LOAD_BROWSE_AGENTS: 'aiMateLoadBrowseAgents',
    SEARCH_BROWSE_AGENTS: 'aiMateSearchBrowseAgents',
    LOAD_CREATE_AGENT: 'aiMateLoadCreateAgent',
    LOAD_AUTO_SUGGEST_SKILLS_UNIFIED: 'aiMateAutoSuggestSkillsUnified',
    LOAD_CHAT_PROMPT_INPUT_SKILLS: 'aiMateChatPromptInputSkillsLoad',
    LOAD_INLINE_CHAT_PROMPT_INPUT_SKILLS: 'aiMateInlineChatPromptInputSkillsLoad',
    FETCH_CHAT: 'aiMateFetchChat',
    PREFETCH_CHAT: 'aiMatePrefetchChat',
    FETCH_AGENTS: 'aiMateFetchAgents',
    FETCH_AGENTS_PAGINATED: 'aiMateFetchAgentsPaginated',
    FETCH_AGENTS_OVERRIDES: 'aiMateFetchAgentsOverrides',
    FETCH_AGENT_BY_AGENT_ID: 'aiMateFetchAgentByAgentId',
    FETCH_SCENARIO_LIST: 'aiMateFetchScenarioList',
    FETCH_AGENT_BY_IDENTITY_ACCOUNT_ID: 'aiMateFetchAgentByIdentityAccountId',
    FETCH_AGENT_BY_EXTERNAL_CONFIG_REFERENCE: 'aiMateFetchAgentByExternalConfigReference',
    FETCH_AGENT_DEBUG_MODAL_DATA: 'aiMateFetchAgentDebugModalData',
    FETCH_AGENT_DEBUG_MODAL_CONVERSATION_REVIEW: 'aiMateFetchAgentDebugModalDataConversationReview',
    CREATE_AGENT: 'aiMateCreateAgent',
    UPDATE_AGENT: 'aiMateUpdateAgent',
    DELETE_AGENT: 'aiMateDeleteAgent',
    DUPLICATE_AGENT: 'aiMateDuplicateAgent',
    HYDRATE_AGENT_DATA: 'aiMateHydrateAgentData',
    HYDRATE_SKILL_METADATA: 'aiMateHydrateSkillMetadata',
    FAVOURITE_AGENT: 'aiMateFavouriteAgent',
    UNFAVOURITE_AGENT: 'aiMateUnfavouriteAgent',
    CLEAR_CHAT: 'aiMateClearChat',
    SEND_MESSAGE: 'aiMateSendMessage',
    SEND_MESSAGE_ROVO_CUSTOM_AGENT: 'aiMateSendMessageRovoCustomAgent',
    SEND_DR_MESSAGE: 'aiMateSendDRMessage',
    SEND_TD_MESSAGE: 'aiMateSendThinkDeeperMessage',
    SEND_TASK_MODE_MESSAGE: 'aiMateSendTaskModeMessage',
    SEND_CONFIRMED_TOOLS_MESSAGE: 'aiMateSendConfirmedToolsMessage',
    SEND_CONFIRMED_TOOLS_TASK_MODE_MESSAGE: 'aiMateSendConfirmedToolsTaskModeMessage',
    SEND_A2UI_ACTION: 'aiMateSendA2UIAction',
    RECONNECT_TO_ACTIVE_STREAM: 'aiMateReconnectToActiveStream',
    ABORT_AGENT_STREAM: 'aiMateAbortAgentStream',
    ANSWER_NOW: 'aiMateAnswerNow',
    HYDRATE_CONVERSATION: 'aiMateHydrateConversation',
    GET_CONVERSATION_CHANNELS: 'aiMateGetConversationChannels',
    GET_CONVERSATION_CHANNELS_INITIAL_LOAD: 'aiMateGetConversationChannelsInitialLoad',
    LOAD_MORE_CONVERSATION_CHANNELS: 'aiMateLoadMoreConversationChannels',
    UPDATE_CONVERSATION_CHANNEL: 'aiMateUpdateConversationChannel',
    CREATE_SEEDED_CONVERSATION_CHANNEL: 'aiMateCreateSeededConversationChannel',
    PUBSUB_LISTENER: 'aiMatePubSubListener',
    FETCH_AGENT_TENANT_DATA: 'aiMateFetchAgentTenantData',
    RESOLVE_CONVERSATION_ACTION: 'aiMateResolveConversationAction',
    BULK_RESOLVE_CONVERSATION_ACTIONS: 'aiMateBulkResolveConversationActions',
    MESSAGE_RENDERER: 'aiMateMessageRenderer',
    FETCH_CONTEXTUAL_STARTERS: 'aiMateFetchContextualStarters',
    FETCH_DYNAMIC_CONVERSATION_STARTERS: 'aiMateFetchDynamicConversationStarters',
    GENERATE_CONVERSATION_STARTERS: 'aiMateGenerateConversationStarters',
    FETCH_AGENT_TEAM_DATA: 'aiMateFetchAgentTeamData',
    FETCH_CONNECTED_KNOWLEDGE_SOURCES: 'aiMateFetchConnectedKnowledgeSources',
    FETCH_CONNECTED_KNOWLEDGE_SOURCES_STORE: 'aiMateFetchKnowledgeSourcesStore',
    PREFETCH_CONNECTED_KNOWLEDGE_SOURCES_STORE: 'aiMatePrefetchKnowledgeSourcesStore',
    FETCH_AGENT_ACTIONS: 'aiMateFetchAgentActions',
    CHANGE_AGENT_OWNER: 'aiMateChangeAgentOwner',
    GET_AGENT_PERMISSIONS: 'aiMateGetAgentPermissions',
    AIFC_FINALIZE_CONTENT: 'aiMateAIFCFinalizeContent',
    PREVIEW_CONTENT: 'aiMatePreviewContent',
    PREVIEW_CARD_RENDER: 'aiMatePreviewCardRender',
    JIRA_PREVIEW_CARD_RENDER: 'aiMateJiraPreviewCardRender',
    JSM_PREVIEW_CARD_RENDER: 'aiMateJsmPreviewCardRender',
    FETCH_AGENT_SITE_PERMISSIONS: 'aiMateFetchAgentSitePermissions',
    PREFETCH_AGENT_SITE_PERMISSIONS: 'aiMatePrefetchAgentSitePermissions',
    SEND_MESSAGE_NL_AGENT: 'aiMateSendMessageNLAgent',
    FILTERED_CLIENT_ERROR: 'aiMateFilteredClientError',
    GET_RECOMMENDED_AGENTS: 'aiMateGetRecommendedAgents',
    PREFETCH_RECOMMENDED_AGENTS: 'aiMatePrefetchRecommendedAgents',
    PREFETCH_RECOMMENDED_SPACES: 'aiMatePrefetchRecommendedSpaces',
    OPEN_RECOMMENDED_SPACES: 'aiMateOpenRecommendedSpaces',
    UPLOAD_FILES_TO_CONVERSATION: 'aiMateUploadFilesToConversation',
    VALIDATE_FILES: 'aiMateValidateFiles',
    GET_CONVERSATION_FILES: 'aiMateGetConversationFiles',
    AIFC_MESSAGE: 'aiMateAifcMessage',
    AIFC_LOAD_STAGING_AREA_MODAL: 'aiMateLoadStagingAreaModal',
    AIFC_TWC_ONBOARDING_MODAL_LAUNCH: 'aiMateTwcAifcOnboardingModalLaunch',
    AIFC_LOAD_CHAT_ONLY_CREATION_MODAL: 'aiMateLoadChatOnlyCreationModal',
    AIFC_LOAD_DRAFTS_SECTION: 'aiMateLoadDraftsSection',
    AIFC_GENERATE_CONTENT: 'aiMateAifcGenerateContent',
    AIFC_GENERATE_CONTENT_IN_CHAT: 'aiMateAifcGenerateContentInChat',
    AIFC_INITIAL_DATA_RECEIVED: 'aiMateAifcInitialDataReceived',
    AIFC_ALL_DATA_HANDLED: 'aiMateAifcAllDataHandled',
    AIFC_UPDATE_CONTENT: 'aiMateAifcUpdateContent',
    UPDATE_CONTENT_IN_CHAT: 'aiMateUpdateContentInChat',
    AIFC_MODAL_SESSION: 'aiMateAifcModalSession',
    CSM_WIDGET_RENDER: 'csmWidgetRender',
    CSM_AGENT_IDENTITY_NAME: 'csmAgentIdentityName',
    CSM_AGENT_IDENTITY_COMPANY: 'csmAgentIdentityCompany',
    CSM_AGENT_IDENTITY_TONE: 'csmAgentIdentityTone',
    CSM_AGENT_IDENTITY_GREETING_MESSAGE: 'csmAgentIdentityGreetingMessage',
    CSM_AGENT_IDENTITY_CONVERSATION_STARTERS: 'csmAgentIdentityConversationStarters',
    CSM_AGENT_IDENTITY_GENERATE_CONVERSATION_STARTERS: 'csmAgentIdentityGenerateConversationStarters',
    GET_AUTO_APPLY_STATE: 'aiMateGetAutoApplyState',
    SET_AUTO_APPLY_STATE: 'aiMateSetAutoApplyState',
    AGENTS_MODAL_AND_SIDEBAR_LIST: 'aiMateAgentsModalAndSidebarList',
    AGENTS_MODAL_FAVOURITE_AGENTS: 'aiMateAgentsModalFavouriteAgents',
    AGENTS_FULLSCREEN_AGENT_LIST: 'aiMateAgentsFullscreenAgentList',
    STUDIO_TRIGGER_SOLUTION_PLAN: 'aiMateStudioTriggerSolutionPlan',
    MY_PROJECTS_LIST_QUERY: 'aiMateMyProjectsListQuery',
    STUDIO_UPDATE_AGENT: 'aiMateStudioUpdateAgent',
    STUDIO_LOAD_AGENT_CARD: 'aiMateStudioLoadAgentCard',
    STUDIO_LOAD_AGENT_EDITOR: 'aiMateStudioLoadAgentEditor',
    STUDIO_CREATE_AGENT_TRIGGER: 'aiMateStudioCreateAgentTrigger',
    STUDIO_UPDATE_AGENT_TRIGGER: 'aiMateStudioUpdateAgentTrigger',
    STUDIO_SET_AGENT_TRIGGER_ENABLED: 'aiMateStudioSetAgentTriggerEnabled',
    STUDIO_REMOVE_AGENT_TRIGGER: 'aiMateStudioRemoveAgentTrigger',
    STUDIO_AUTOMATION_CREATE_RULE: 'aiMateStudioAutomationCreateRule',
    THREADS_LIST_QUERY: 'aiMateThreadsListQuery',
    PROACTIVE_ACTION_ITEMS_LOAD: 'aiMateProactiveActionItemsLoad',
    WARM_CONVERSATION_CACHE: 'aiMateWarmConversationCache',
    WARM_CONTEXT_BANNER_LINK: 'aiMateWarmContextBannerLink',
    AIFC_LOAD_PROMPT_SUGGESTIONS: 'aiMateAifcLoadPromptSuggestions',
    REMIX_START: 'aiMateRemixStart',
    REMIX_AIFC_HANDOFF: 'aiMateRemixAifcHandoff',
    FETCH_INSIGHTS_STATUS: 'aiMateFetchInsightsStatus',
    FETCH_INSIGHTS_FEED: 'aiMateFetchInsightsFeed',
    REMIX_RENDERS_IN_MODAL: 'aiMateRemixRendersInModal',
    REMIX_CREATE: 'aiMateRemixCreate',
    REMIX_OPEN_MENU: 'aiMateRemixOpenMenu',
    REMIX_SELECT_OPTION: 'aiMateRemixSelectOption',
    REMIX_SHOW_LOADING: 'aiMateRemixShowLoading',
    // VIEW waits for all embeds' readiness without a timeout.
    // LIMITED requires readiness within each embed's existing deadline.
    REMIX_VIEW: 'aiMateRemixView',
    REMIX_VIEW_LIMITED: 'aiMateRemixViewLimited',
    REMIX_REGENERATE: 'aiMateRemixRegenerate',
    REMIX_INSERT: 'aiMateRemixInsert',
    REMIX_INSERT_LIMITED: 'aiMateRemixInsertLimited',
    REMIX_PASTE: 'aiMateRemixPaste',
    REMIX_COPY_FROM_PREVIEW: 'aiMateRemixCopyFromPreview',
    REMIX_DIAGRAM_PASTE_FINALIZE: 'aiMateRemixDiagramPasteFinalize',
    FETCH_TASKS: 'aiMateFetchTasks',
    FETCH_ARTIFACT_LIBRARY: 'aiMateFetchArtifactLibrary',
    SHARE_ARTIFACT: 'aiMateShareArtifact',
    SHARE_ARTIFACT_ACCESS_CHANGE: 'aiMateShareArtifactAccessChange',
    SHARE_ARTIFACT_SHARE_AUDIENCES: 'aiMateShareArtifactShareAudiences',
    SHARE_ARTIFACT_REVOKE_AUDIENCES: 'aiMateShareArtifactRevokeAudiences',
    DOWNLOAD_ARTIFACT: 'aiMateDownloadArtifact',
    PREVIEW_ARTIFACT_SMART_LINK_RESOLVED: 'aiMatePreviewArtifactSmartLinkResolved',
    LOAD_STICKY_SKILL_LISTENER: 'aiMateLoadStickySkillListener',
    /**
   * Tracks duplicating a Remix/MAUI app when its link is pasted into another
   * Confluence page. Started when the editor plugin detects a MAUI link in
   * the paste, succeeded once the duplicated app's URL has been swapped into
   * the editor doc, and failed if the duplicate API call (or any JS error in
   * the duplication flow) fails. When this experience fails, the
   * REMIX_INSERT experience is also failed so the overall paste-and-insert
   * flow is reflected in the SLO.
   */ REMIX_DUPLICATE_APP: 'aiMateRemixDuplicateApp',
    STUDIO_CREATE_AGENT: 'aiMateStudioCreateAgent',
    STUDIO_CREATE_AGENT_ASSIGN: 'aiMateStudioCreateAgentAssign',
    STUDIO_CREATE_AGENT_INVOKE: 'aiMateStudioCreateAgentInvoke',
    STUDIO_CREATE_AGENT_BUILD_AND_CHAT: 'aiMateStudioCreateAgentBuildAndChat',
    STUDIO_CREATE_AGENT_REFINE_IN_STUDIO: 'aiMateStudioCreateAgentRefineInStudio',
    STUDIO_CREATE_AGENT_RENDER: 'aiMateStudioCreateAgentRender',
    JIRA_SAVE_DRAFT_WORK_ITEM: 'aiMateJiraSaveDraftWorkItem',
    JIRA_RESOLVE_DRAFT_WORK_ITEM: 'aiMateJiraResolveDraftWorkItem',
    JIRA_CREATE_WORK_ITEMS_BULK: 'aiMateJiraCreateWorkItemsBulk',
    ROVO_SKILLS_PLAN_WORK_ITEM_CREATE: 'RovoSkillsPlanWorkItemCreate',
    ROVO_SKILLS_EXECUTION_WORK_ITEM_CREATE: 'RovoSkillsExecutionWorkItemCreate',
    ROVO_SKILLS_PLAN_WORK_ITEM_UPDATE: 'RovoSkillsPlanWorkItemUpdate',
    ROVO_SKILLS_EXECUTION_WORK_ITEM_UPDATE: 'RovoSkillsExecutionWorkItemUpdate',
    /**
   * Tracks the sender's end-to-end conversation-sharing funnel as a single
   * experience. Started when the share modal opens and succeeded only after
   * an existing or newly created share link is copied to the clipboard.
   * Unexpected hydration, persistence, share-creation, and clipboard errors
   * fail the experience. A `404` when loading existing share details is the
   * expected "not shared yet" state and does not fail the experience. Closing
   * the modal before any terminal state is recorded aborts the experience so
   * abandonment is excluded from the SLO.
   */ SHARE_CONVERSATION_SESSION: 'aiMateShareConversationSession',
    /**
   * Tracks the first action that reaches a terminal event while the Shared
   * chats tab in Rovo settings is active. Preview succeeds with `action` set
   * to `preview`; deleting a share or conversation succeeds or fails with
   * `action` set to `delete`. Later or overlapping terminal calls are ignored
   * by the underlying tracker. Closing the tab first aborts the experience.
   */ MANAGE_CONVERSATION_SHARES: 'aiMateManageConversationShares',
    /**
   * Tracks loading a shared conversation on the shared conversation preview
   * page, for both the sender previewing their own share and a recipient
   * opening a share link. Started when the route mounts and succeeded only
   * after the conversation has rendered. HTTP 404 responses abort the experience;
   * other errors retrieving or mapping the share fail it. A link that never
   * carried the parameters needed to request a share aborts the experience,
   * as does leaving the page before the conversation renders. Missing shares,
   * malformed links and abandonment are recorded without counting against the SLO.
   */ VIEW_CONVERSATION_SHARE: 'aiMateViewConversationShare',
    /**
   * Tracks rendering the skill detail view of the skills directory, from either
   * Atlassian Studio or the Rovo Chat skills modal. Started when the detail
   * segment mounts and succeeded once the skill has rendered. Errors thrown
   * while loading or rendering the skill fail the experience.
   */ LOAD_SKILL_DETAIL_IN_SKILL_DIRECTORY: 'aiMateLoadSkillDetailInSkillDirectory',
    /**
   * Tracks rendering the products filter of the skills directory. Started when
   * the filter segment mounts and succeeded once the product list has
   * rendered. Errors loading the product dimension metadata fail the
   * experience.
   */ LOAD_SKILLS_DIRECTORY_PRODUCTS_FILTER: 'aiMateLoadSkillsDirectoryProductsFilter',
    AIFC_DEEP_LINK_LAUNCH: 'aiMateAifcDeepLinkLaunch'
};
const $b6334bd5b5c71b1c$export$97bfa295b10f6f9e = ({ deepResearchEnabled: deepResearchEnabled, thinkDeeperEnabled: thinkDeeperEnabled, taskModeEnabled: taskModeEnabled, fastModeEnabled: fastModeEnabled, isCustomRovoAgent: isCustomRovoAgent })=>{
    if (isCustomRovoAgent) return $b6334bd5b5c71b1c$export$b881bd9f00ed8ed1.SEND_MESSAGE_ROVO_CUSTOM_AGENT;
    if (deepResearchEnabled) return $b6334bd5b5c71b1c$export$b881bd9f00ed8ed1.SEND_DR_MESSAGE;
    if (thinkDeeperEnabled) return $b6334bd5b5c71b1c$export$b881bd9f00ed8ed1.SEND_TD_MESSAGE;
    if (taskModeEnabled) return $b6334bd5b5c71b1c$export$b881bd9f00ed8ed1.SEND_TASK_MODE_MESSAGE;
    if (fastModeEnabled) // Sending the same experience name for fast mode as it is the same as the default (auto) mode
    return $b6334bd5b5c71b1c$export$b881bd9f00ed8ed1.SEND_MESSAGE;
    return $b6334bd5b5c71b1c$export$b881bd9f00ed8ed1.SEND_MESSAGE;
};
const $b6334bd5b5c71b1c$export$233a4307e330ea30 = [
    $b6334bd5b5c71b1c$export$b881bd9f00ed8ed1.AIFC_GENERATE_CONTENT,
    $b6334bd5b5c71b1c$export$b881bd9f00ed8ed1.AIFC_GENERATE_CONTENT_IN_CHAT,
    $b6334bd5b5c71b1c$export$b881bd9f00ed8ed1.AIFC_UPDATE_CONTENT,
    $b6334bd5b5c71b1c$export$b881bd9f00ed8ed1.AIFC_FINALIZE_CONTENT,
    $b6334bd5b5c71b1c$export$b881bd9f00ed8ed1.AIFC_LOAD_STAGING_AREA_MODAL,
    $b6334bd5b5c71b1c$export$b881bd9f00ed8ed1.AIFC_MODAL_SESSION,
    $b6334bd5b5c71b1c$export$b881bd9f00ed8ed1.REMIX_REGENERATE
];
const $b6334bd5b5c71b1c$export$1b8ade75bafe2a6d = {
    /** Browser-level network failure — request never reached Atlassian servers (e.g. VPN, firewall, no connectivity) */ CLIENT_FETCH_ERROR: 'clientFetchError',
    /** Rovo is not enabled for the user's organisation (product-not-active stream error) */ PRODUCT_NOT_ACTIVE: 'productNotActive',
    /** User is not authenticated or lacks permission (HTTP 401/403) */ AUTH_OR_PERMISSION_ERROR: 'authOrPermissionError',
    /** Request was rejected by rate limiting or quota admission control (HTTP 429) */ RATE_LIMIT_ERROR: 'rateLimitError'
};
const $b6334bd5b5c71b1c$export$315c6d415b08d278 = {
    /** Experience started (intent detection decided on a creatable/Remix action) */ STARTED_AT: 'previewCardRenderStartedAtMs',
    /** Most recent ACTION_PART received */ ACTION_PART_AT: 'previewCardRenderActionPartAtMs',
    /** ACTION_COMPLETE received */ ACTION_COMPLETE_AT: 'previewCardRenderActionCompleteAtMs',
    /** SmartCreatePreviewCard mounted */ CARD_MOUNTED_AT: 'previewCardRenderCardMountedAtMs',
    /** SmartCreatePreviewCard mounted but used a non-instrumented branch. */ ROUTED_TO_NON_INSTRUMENTED_BRANCH_AT: 'previewCardRenderRoutedToNonInstrumentedBranchAtMs'
};
const $b6334bd5b5c71b1c$export$754812bba125b4c4 = {
    /** Why the experience succeeded or aborted. */ TERMINAL_REASON: 'previewCardRenderTerminalReason'
};
const $b6334bd5b5c71b1c$export$51e40ef74b0123bc = {
    /** Action status on the ACTION_PREPARE chunk */ ACTION_PREPARE_STATUS: 'previewCardRenderActionPrepareStatus',
    /** Action status on the most recent ACTION_PART chunk */ ACTION_PART_STATUS: 'previewCardRenderActionPartStatus',
    /** Action status on the ACTION_COMPLETE chunk */ ACTION_COMPLETE_STATUS: 'previewCardRenderActionCompleteStatus',
    /** Action key on the ACTION_COMPLETE chunk */ ACTION_COMPLETE_KEY: 'previewCardRenderActionCompleteKey'
};
const $b6334bd5b5c71b1c$export$b49585ccbc2980b5 = {
    STARTED_AT: 'previewContentStartedAtMs',
    EMBED_URL_RESOLVED_AT: 'previewContentEmbedUrlResolvedAtMs',
    IFRAME_MOUNTED_AT: 'previewContentIframeMountedAtMs',
    HANDSHAKE_RECEIVED_AT: 'previewContentHandshakeReceivedAtMs',
    IFRAME_LOADED_AT: 'previewContentIframeLoadedAtMs'
};
const $b6334bd5b5c71b1c$export$449b821dadec8760 = [
    $b6334bd5b5c71b1c$export$b881bd9f00ed8ed1.AIFC_DEEP_LINK_LAUNCH,
    $b6334bd5b5c71b1c$export$b881bd9f00ed8ed1.AIFC_INITIAL_DATA_RECEIVED,
    $b6334bd5b5c71b1c$export$b881bd9f00ed8ed1.AIFC_ALL_DATA_HANDLED,
    $b6334bd5b5c71b1c$export$b881bd9f00ed8ed1.PREVIEW_CONTENT,
    ...$b6334bd5b5c71b1c$export$233a4307e330ea30
];
const $b6334bd5b5c71b1c$export$ebde7a14f059b67f = {
    SUBMIT: 'submit',
    ACTION_COMPLETE_RECEIVED: 'action_complete_received',
    PREVIEW_VISIBLE: 'preview_visible'
};
const $b6334bd5b5c71b1c$export$35724980a513a99d = [
    {
        key: 'backend_latency',
        startMark: $b6334bd5b5c71b1c$export$ebde7a14f059b67f.SUBMIT,
        endMark: $b6334bd5b5c71b1c$export$ebde7a14f059b67f.ACTION_COMPLETE_RECEIVED
    },
    {
        key: 'render_latency',
        startMark: $b6334bd5b5c71b1c$export$ebde7a14f059b67f.ACTION_COMPLETE_RECEIVED,
        endMark: $b6334bd5b5c71b1c$export$ebde7a14f059b67f.PREVIEW_VISIBLE
    }
];
const $b6334bd5b5c71b1c$export$13437d7a030ee3e7 = new (0, $cNAch.UFOExperience)('remix-generate-preview', {
    type: (0, $4MiWC.ExperienceTypes).Experience,
    performanceType: (0, $4MiWC.ExperiencePerformanceTypes).InlineResult,
    timings: [
        ...$b6334bd5b5c71b1c$export$35724980a513a99d
    ]
});
const $b6334bd5b5c71b1c$export$bef09d36689d0f74 = {
    SUBMIT: 'submit',
    // mark the start of the experience when the user submits the edit request
    ACTION_COMPLETE_RECEIVED: 'action_complete_received',
    // mark when we receive the ACTION_COMPLETE event from the backend
    NODE_INSERTED: 'node_inserted' // mark when the new app node is inserted into the editor
};
const $b6334bd5b5c71b1c$export$222a56424ec38dc0 = [
    {
        key: 'backend_latency',
        startMark: $b6334bd5b5c71b1c$export$bef09d36689d0f74.SUBMIT,
        endMark: $b6334bd5b5c71b1c$export$bef09d36689d0f74.ACTION_COMPLETE_RECEIVED
    },
    {
        key: 'insertion_latency',
        startMark: $b6334bd5b5c71b1c$export$bef09d36689d0f74.ACTION_COMPLETE_RECEIVED,
        endMark: $b6334bd5b5c71b1c$export$bef09d36689d0f74.NODE_INSERTED
    }
];
const $b6334bd5b5c71b1c$export$a143927e9fe401a2 = new (0, $cNAch.UFOExperience)('remix-edit-existing', {
    type: (0, $4MiWC.ExperienceTypes).Experience,
    performanceType: (0, $4MiWC.ExperiencePerformanceTypes).InlineResult,
    timings: [
        ...$b6334bd5b5c71b1c$export$222a56424ec38dc0
    ]
});
const $b6334bd5b5c71b1c$export$5806cfefce9dc0ad = {
    PASTE_DETECTED: 'paste_detected',
    EMBED_LOADED: 'embed_loaded'
};
const $b6334bd5b5c71b1c$export$c39e7538132ae645 = [
    {
        key: 'render_latency',
        startMark: $b6334bd5b5c71b1c$export$5806cfefce9dc0ad.PASTE_DETECTED,
        endMark: $b6334bd5b5c71b1c$export$5806cfefce9dc0ad.EMBED_LOADED
    }
];
const $b6334bd5b5c71b1c$export$cf4d370f87e7f73d = new (0, $cNAch.UFOExperience)('remix-paste-render-embed', {
    type: (0, $4MiWC.ExperienceTypes).Experience,
    performanceType: (0, $4MiWC.ExperiencePerformanceTypes).InlineResult,
    timings: [
        ...$b6334bd5b5c71b1c$export$c39e7538132ae645
    ]
});
let $b6334bd5b5c71b1c$var$isRemixPasteRenderEmbedExperienceActive = false;
const $b6334bd5b5c71b1c$export$c0c3ed9d934fa9fe = (metadata)=>{
    if ($b6334bd5b5c71b1c$var$isRemixPasteRenderEmbedExperienceActive) return;
    $b6334bd5b5c71b1c$var$isRemixPasteRenderEmbedExperienceActive = true;
    $b6334bd5b5c71b1c$export$cf4d370f87e7f73d.start();
    $b6334bd5b5c71b1c$export$cf4d370f87e7f73d.mark($b6334bd5b5c71b1c$export$5806cfefce9dc0ad.PASTE_DETECTED);
    if (metadata) $b6334bd5b5c71b1c$export$cf4d370f87e7f73d.addMetadata(metadata);
};
const $b6334bd5b5c71b1c$export$aa07d60d01b2c5e3 = (metadata)=>{
    if (!$b6334bd5b5c71b1c$var$isRemixPasteRenderEmbedExperienceActive) return;
    $b6334bd5b5c71b1c$export$cf4d370f87e7f73d.mark($b6334bd5b5c71b1c$export$5806cfefce9dc0ad.EMBED_LOADED);
    if (metadata) $b6334bd5b5c71b1c$export$cf4d370f87e7f73d.addMetadata(metadata);
    $b6334bd5b5c71b1c$export$cf4d370f87e7f73d.success();
    $b6334bd5b5c71b1c$var$isRemixPasteRenderEmbedExperienceActive = false;
};
const $b6334bd5b5c71b1c$export$2ed37a75e20c9dc7 = (error, metadata)=>{
    if (!$b6334bd5b5c71b1c$var$isRemixPasteRenderEmbedExperienceActive) return;
    if (metadata) $b6334bd5b5c71b1c$export$cf4d370f87e7f73d.addMetadata(metadata);
    $b6334bd5b5c71b1c$export$cf4d370f87e7f73d.failure({
        metadata: {
            reason: error.message
        }
    });
    $b6334bd5b5c71b1c$var$isRemixPasteRenderEmbedExperienceActive = false;
};
module.exports["ExperienceName"] = $b6334bd5b5c71b1c$export$b881bd9f00ed8ed1;
module.exports["sendMessageExperienceName"] = $b6334bd5b5c71b1c$export$97bfa295b10f6f9e;
module.exports["AIFC_EXPERIENCES_TO_FAIL"] = $b6334bd5b5c71b1c$export$233a4307e330ea30;
module.exports["SLOExclusionReason"] = $b6334bd5b5c71b1c$export$1b8ade75bafe2a6d;
module.exports["PreviewCardRenderStage"] = $b6334bd5b5c71b1c$export$315c6d415b08d278;
module.exports["PreviewCardRenderDiagnosticAttribute"] = $b6334bd5b5c71b1c$export$754812bba125b4c4;
module.exports["PreviewCardRenderActionAttribute"] = $b6334bd5b5c71b1c$export$51e40ef74b0123bc;
module.exports["PreviewContentStage"] = $b6334bd5b5c71b1c$export$b49585ccbc2980b5;
module.exports["AIFC_EXPERIENCES_TO_ABORT"] = $b6334bd5b5c71b1c$export$449b821dadec8760;
module.exports["REMIX_GENERATE_PREVIEW_MARKS"] = $b6334bd5b5c71b1c$export$ebde7a14f059b67f;
module.exports["remixGeneratePreviewExperience"] = $b6334bd5b5c71b1c$export$13437d7a030ee3e7;
module.exports["REMIX_EDIT_EXISTING_MARKS"] = $b6334bd5b5c71b1c$export$bef09d36689d0f74;
module.exports["remixEditExistingExperience"] = $b6334bd5b5c71b1c$export$a143927e9fe401a2;
module.exports["startRemixPasteRenderEmbedExperience"] = $b6334bd5b5c71b1c$export$c0c3ed9d934fa9fe;
module.exports["succeedRemixPasteRenderEmbedExperience"] = $b6334bd5b5c71b1c$export$aa07d60d01b2c5e3;
module.exports["failRemixPasteRenderEmbedExperience"] = $b6334bd5b5c71b1c$export$2ed37a75e20c9dc7;

});

parcelRegister("cNAch", function(module, exports) {

var $YHNTN = parcelRequire("YHNTN");

class $c65b2e96b7a8c980$export$c00d22927c60484a extends (0, $YHNTN.UFOAbstractExperience) {
}
module.exports["UFOExperience"] = $c65b2e96b7a8c980$export$c00d22927c60484a;

});

parcelRegister("YHNTN", function(module, exports) {
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead

var $03RpJ = parcelRequire("03RpJ");


var $dd3JJ = parcelRequire("dd3JJ");


var $gDr1n = parcelRequire("gDr1n");


var $11QNa = parcelRequire("11QNa");


var $i3Cqs = parcelRequire("i3Cqs");


var $8D8OR = parcelRequire("8D8OR");


var $3Ww6H = parcelRequire("3Ww6H");


var $bdTYA = parcelRequire("bdTYA");


var $aNeq3 = parcelRequire("aNeq3");


var $f07wD = parcelRequire("f07wD");


var $e22Cc = parcelRequire("e22Cc");


var $j7Sza = parcelRequire("j7Sza");


var $g8bWJ = parcelRequire("g8bWJ");


var $4MiWC = parcelRequire("4MiWC");


var $DJFHw = parcelRequire("DJFHw");

const $35f46dabe2d905ec$var$getPageVisibleState = ()=>{
    return !(0, $e22Cc.isWindowObjectAvailable)() || !window.document || window.document.visibilityState === 'visible' ? (0, $f07wD.PageVisibleState).VISIBLE : (0, $f07wD.PageVisibleState).HIDDEN;
};
class $35f46dabe2d905ec$export$d31c89db257648c {
    async transition(newState, timestamp) {
        (0, $3Ww6H.ufolog)('async transition', this.id, this.state.id, newState.id);
        if ((0, $g8bWJ.canTransition)(this.state, newState)) {
            (0, $3Ww6H.ufolog)(`TRANSITION: ${this.id} from ${this.state.id} to ${newState.id} successful`, this.state.final, !newState.final);
            if (newState === (0, $j7Sza.UFOExperienceState).STARTED) this._reset();
            if (this.state.final && !newState.final) {
                this.metrics.startTime = (0, $DJFHw.perfNowOrTimestamp)(timestamp);
                // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
                this.uuid = (0, $03RpJ.default)();
            }
            this.state = newState;
            if (newState.final) {
                this.metrics.endTime = (0, $DJFHw.perfNowOrTimestamp)(timestamp);
                if (!this._isManualStateEnabled()) (0, $11QNa.getGlobalEventStream)().push((0, $8D8OR.unsubscribeEvent)((0, $f07wD.SUBSCRIBE_ALL), this.handleDoneBind));
                const data = await this.exportData();
                (0, $3Ww6H.ufolog)('this.parent', this.parent);
                (0, $11QNa.getGlobalEventStream)().push((0, $gDr1n.experiencePayloadEvent)(data));
            }
            return true;
        }
        (0, $3Ww6H.ufolog)(`TRANSITION: ${this.id} from ${this.state.id} to ${newState.id} unsuccessful`);
        (0, $bdTYA.ufowarn)(`transition of ${this.id} from ${this.state} to ${newState} is not possible`);
        return false;
    }
    async start(startTime) {
        const transitionSuccessful = await this.transition((0, $j7Sza.UFOExperienceState).STARTED, startTime);
        if (transitionSuccessful) {
            this.pageVisibleState = $35f46dabe2d905ec$var$getPageVisibleState();
            (0, $aNeq3.visibilityChangeObserver).subscribe(this.setPageVisibleStateToMixed);
            if (!this._isManualStateEnabled()) {
                (0, $3Ww6H.ufolog)('subscribed', this.id);
                (0, $11QNa.getGlobalEventStream)().push((0, $i3Cqs.subscribeEvent)((0, $f07wD.SUBSCRIBE_ALL), this.handleDoneBind));
            }
        }
    }
    mark(name, timestamp) {
        if (name !== (0, $f07wD.FMP_MARK) && name !== (0, $f07wD.INLINE_RESPONSE_MARK)) this._mark(name, timestamp);
        else (0, $bdTYA.ufowarn)('please use markFMP or markInlineResponse for specialised marks');
    }
    _mark(name, timestamp) {
        this.metrics.marks.push({
            name: name,
            time: (0, $DJFHw.perfNowOrTimestamp)(timestamp)
        });
        this.transition((0, $j7Sza.UFOExperienceState).IN_PROGRESS);
    }
    markFMP(timestamp) {
        this._mark((0, $f07wD.FMP_MARK), timestamp);
    }
    markInlineResponse(timestamp) {
        this._mark((0, $f07wD.INLINE_RESPONSE_MARK), timestamp);
    }
    _isManualStateEnabled() {
        return this.until === null;
    }
    _validateManualState() {
        if (!this._isManualStateEnabled()) {
            (0, $bdTYA.ufowarn)('manual change of state not allowed as "until" is defined');
            return false;
        }
        return true;
    }
    switchToEndState(state, config) {
        if (!config?.force && !this._validateManualState()) return null;
        if (config?.metadata) this.addMetadata(config.metadata);
        (0, $aNeq3.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
        return this.transition(state);
    }
    async success(config) {
        return this.switchToEndState((0, $j7Sza.UFOExperienceState).SUCCEEDED, config);
    }
    async failure(config) {
        return this.switchToEndState((0, $j7Sza.UFOExperienceState).FAILED, config);
    }
    async abort(config) {
        return this.switchToEndState((0, $j7Sza.UFOExperienceState).ABORTED, config);
    }
    addMetadata(data) {
        Object.assign(this.metadata, data);
    }
    _handleDoneExperience(data) {
        (0, $3Ww6H.ufolog)('_handleDoneExperience in', this.id, data.state, data, this._until);
        if (data.state.final) {
            if (this._until !== null) {
                const { done: done, state: state } = this._until(data);
                if (done && !this.state.final) this.transition(state);
            }
        }
    }
    async getId() {
        return this.id;
    }
    async exportData() {
        return {
            id: await this.getId(),
            uuid: this.uuid,
            type: this.type,
            schemaVersion: (0, $dd3JJ.UFO_EXPERIMENTAL_BUILD_VERSION) || 'unknown',
            performanceType: this.performanceType,
            category: this.category,
            state: this.state,
            metadata: {
                ...this.metadata
            },
            metrics: {
                ...this.metrics
            },
            children: [
                ...this.childExperiences
            ],
            result: {
                success: !!this.state.success,
                startTime: this.metrics.startTime,
                duration: (this.metrics.endTime || 0) - (this.metrics.startTime || 0)
            },
            platform: this.config.platform || null,
            pageVisibleState: this.pageVisibleState,
            featureFlags: this.featureFlags,
            isSSROutputAsFMP: this.isSSROutputAsFMP,
            timings: this.timings,
            explicitTimings: this.explicitTimings,
            performanceConfig: this.performanceConfig
        };
    }
    _reset() {
        this.parent = null;
        this.metadata = {};
        this.onDoneCallbacks = [];
        this.childExperiences = [];
        this.metrics = {
            startTime: null,
            endTime: null,
            marks: []
        };
        this._until = this.until ? this.until() : null;
    }
    constructor(id, config, instanceId = null){
        this.state = (0, $j7Sza.UFOExperienceState).NOT_STARTED;
        this.id = void 0;
        this.instanceId = null;
        // for concurrent
        this.parent = null;
        this.category = null;
        this.type = void 0;
        this.performanceType = void 0;
        this.metadata = {};
        this.onDoneCallbacks = [];
        this.childExperiences = [];
        this.featureFlags = void 0;
        this.timings = void 0;
        this.explicitTimings = {};
        // @todo move to page load experience when proper classes/inheritance prepared
        this.isSSROutputAsFMP = false;
        this.handleDoneBind = void 0;
        this.uuid = null;
        this.until = void 0;
        this._until = null;
        this.pageVisibleState = void 0;
        this.metrics = {
            startTime: null,
            endTime: null,
            marks: []
        };
        this.performanceConfig = {};
        this.config = void 0;
        this.setPageVisibleStateToMixed = ()=>{
            this.pageVisibleState = (0, $f07wD.PageVisibleState).MIXED;
            (0, $aNeq3.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
        };
        this.id = id;
        this.category = config?.category || null;
        this.until = config?.until || null;
        this.instanceId = instanceId;
        this.handleDoneBind = this._handleDoneExperience.bind(this);
        this.type = config.type;
        this.performanceType = config.performanceType;
        this.performanceConfig = config.performanceConfig || {};
        this.config = config;
        this.pageVisibleState = $35f46dabe2d905ec$var$getPageVisibleState();
        this.featureFlags = config.featureFlags || [];
        this.timings = config.timings || [];
        if (config.performanceType === (0, $4MiWC.ExperiencePerformanceTypes).PageLoad || config.performanceType === (0, $4MiWC.ExperiencePerformanceTypes).PageSegmentLoad) this.isSSROutputAsFMP = config.isSSROutputAsFMP || false;
    }
}
module.exports["UFOAbstractExperience"] = $35f46dabe2d905ec$export$d31c89db257648c;

});

parcelRegister("dd3JJ", function(module, exports) {
// temp solution until we can get it automated
const $79d018f255564301$export$2295b861f318254a = '0.1.5';
module.exports["UFO_EXPERIMENTAL_BUILD_VERSION"] = $79d018f255564301$export$2295b861f318254a;

});

parcelRegister("gDr1n", function(module, exports) {

var $f07wD = parcelRequire("f07wD");

const $7cdf9804f4fb0f15$export$7c957416596ca127 = (data)=>{
    return {
        type: (0, $f07wD.UFOGlobalEventStreamEventType).EXPERIENCE_PAYLOAD,
        payload: data
    };
};
module.exports["experiencePayloadEvent"] = $7cdf9804f4fb0f15$export$7c957416596ca127;

});

parcelRegister("f07wD", function(module, exports) {
var $ff3bb8d57004c3c7$export$96253c35c37cf96b = /*#__PURE__*/ function(UFOGlobalEventStreamEventType) {
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["EXPERIENCE_PAYLOAD"] = 0] = "EXPERIENCE_PAYLOAD";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["SUBSCRIBE"] = 1] = "SUBSCRIBE";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["UNSUBSCRIBE"] = 2] = "UNSUBSCRIBE";
    return UFOGlobalEventStreamEventType;
}({});
var $ff3bb8d57004c3c7$export$a12c67b37a306b13 = /*#__PURE__*/ function(PageVisibleState) {
    PageVisibleState["VISIBLE"] = "visible";
    PageVisibleState["HIDDEN"] = "hidden";
    PageVisibleState["MIXED"] = "mixed";
    return PageVisibleState;
}({});
var $ff3bb8d57004c3c7$export$66b33c055cbb625e = /*#__PURE__*/ function(PageLoadMetrics) {
    PageLoadMetrics["fmp"] = "fmp";
    PageLoadMetrics["tti"] = "tti";
    return PageLoadMetrics;
}({});
var $ff3bb8d57004c3c7$export$3ce489cbe02dc21b = /*#__PURE__*/ function(PageSegmentLoadMetrics) {
    PageSegmentLoadMetrics["fmp"] = "fmp";
    PageSegmentLoadMetrics["tti"] = "tti";
    return PageSegmentLoadMetrics;
}({});
var $ff3bb8d57004c3c7$export$341b330828bd3906 = /*#__PURE__*/ function(InteractionMetrics) {
    InteractionMetrics["response"] = "response";
    InteractionMetrics["result"] = "result";
    return InteractionMetrics;
}({});
var $ff3bb8d57004c3c7$export$b9b20160f581e4f8 = /*#__PURE__*/ function(CustomMetrics) {
    CustomMetrics["duration"] = "duration";
    return CustomMetrics;
}({});
const $ff3bb8d57004c3c7$export$79bf131685ad41d7 = '__SUBSCRIBE_ALL__';
const $ff3bb8d57004c3c7$export$9f2bf58999404c75 = 'fmp';
const $ff3bb8d57004c3c7$export$837e0f79a8056912 = 'inline-response';
module.exports["UFOGlobalEventStreamEventType"] = $ff3bb8d57004c3c7$export$96253c35c37cf96b;
module.exports["PageVisibleState"] = $ff3bb8d57004c3c7$export$a12c67b37a306b13;
module.exports["SUBSCRIBE_ALL"] = $ff3bb8d57004c3c7$export$79bf131685ad41d7;
module.exports["FMP_MARK"] = $ff3bb8d57004c3c7$export$9f2bf58999404c75;
module.exports["INLINE_RESPONSE_MARK"] = $ff3bb8d57004c3c7$export$837e0f79a8056912;

});

parcelRegister("11QNa", function(module, exports) {

var $7Ce5m = parcelRequire("7Ce5m");

const $c1569a93aa4391e4$export$6123a44dc2384540 = ()=>{
    if (!globalThis.__UFO_GLOBAL_EVENT_STREAM__) {
        const earlyStream = (()=>{
            const stream = [];
            return {
                __buffer_only__: true,
                push: (event)=>{
                    if (stream.length < (0, $7Ce5m.MAX_EARLY_QUEUE_LENGTH)) stream.push(event);
                },
                getStream: ()=>stream
            };
        })();
        globalThis.__UFO_GLOBAL_EVENT_STREAM__ = earlyStream;
    }
    return globalThis.__UFO_GLOBAL_EVENT_STREAM__;
};
module.exports["getGlobalEventStream"] = $c1569a93aa4391e4$export$6123a44dc2384540;

});

parcelRegister("7Ce5m", function(module, exports) {
const $0cc5590ab6f8b46e$export$d8b468db8a225bc9 = 250;
module.exports["MAX_EARLY_QUEUE_LENGTH"] = $0cc5590ab6f8b46e$export$d8b468db8a225bc9;

});

parcelRegister("i3Cqs", function(module, exports) {

var $f07wD = parcelRequire("f07wD");

const $a239602ece96b732$export$37863216db4b714d = (experienceId, callback)=>{
    return {
        type: (0, $f07wD.UFOGlobalEventStreamEventType).SUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};
module.exports["subscribeEvent"] = $a239602ece96b732$export$37863216db4b714d;

});

parcelRegister("8D8OR", function(module, exports) {

var $f07wD = parcelRequire("f07wD");

const $0a3f0389a9961f72$export$ee1a7bd1fc9ea85e = (experienceId, callback)=>{
    return {
        type: (0, $f07wD.UFOGlobalEventStreamEventType).UNSUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};
module.exports["unsubscribeEvent"] = $0a3f0389a9961f72$export$ee1a7bd1fc9ea85e;

});

parcelRegister("3Ww6H", function(module, exports) {

var $jmjuG = parcelRequire("jmjuG");

const $50aee1cd0289a711$export$b4958caff08a0960 = (...args)=>{
    (0, $jmjuG.ufologger).log(...args);
};
module.exports["ufolog"] = $50aee1cd0289a711$export$b4958caff08a0960;

});

parcelRegister("jmjuG", function(module, exports) {
class $fdaa18971c6567c6$var$UFOLogger {
    log(...args) {
        // eslint-disable-next-line no-console
        this.enabled && console.log($fdaa18971c6567c6$var$UFOLogger.UFOprefix, ...args);
    }
    warn(...args) {
        // eslint-disable-next-line no-console
        this.enabled && console.warn($fdaa18971c6567c6$var$UFOLogger.UFOprefix, ...args);
    }
    enable() {
        this.enabled = true;
    }
    disable() {
        this.enabled = false;
    }
    constructor(){
        this.enabled = false;
    }
}
$fdaa18971c6567c6$var$UFOLogger.UFOprefix = "[ufo\uD83D\uDEF8]";
const $fdaa18971c6567c6$export$4ab84f6f04f6566d = new $fdaa18971c6567c6$var$UFOLogger();
module.exports["ufologger"] = $fdaa18971c6567c6$export$4ab84f6f04f6566d;

});

parcelRegister("bdTYA", function(module, exports) {

var $jmjuG = parcelRequire("jmjuG");

const $5c1c0b03503ca679$export$d53d07b6034c4560 = (...args)=>{
    (0, $jmjuG.ufologger).warn(...args);
};
module.exports["ufowarn"] = $5c1c0b03503ca679$export$d53d07b6034c4560;

});

parcelRegister("aNeq3", function(module, exports) {

var $e22Cc = parcelRequire("e22Cc");

class $1043fc05a880bbb3$var$VisibilityChangeObserver {
    start() {
        if (this.started) return;
        this.started = true;
        document.addEventListener('visibilitychange', this.broadcast);
        /**
     * According to https://developer.mozilla.org/en-US/docs/Web/API/Document/visibilitychange_event
     * Safari doesn’t fire visibilitychange as expected when the value of the visibilityState property transitions to hidden;
     * so for that case, you need to also include code to listen for the pagehide event.
     */ if ((0, $e22Cc.isWindowObjectAvailable)()) window.addEventListener('pagehide', this.broadcast);
    }
    subscribe(callback) {
        this.observers.push(callback);
    }
    unsubscribe(callback) {
        this.observers = this.observers.filter((fn)=>fn !== callback);
    }
    constructor(){
        this.started = false;
        this.observers = [];
        this.broadcast = ()=>{
            this.observers.forEach((fn)=>fn());
            this.observers = [];
        };
    }
}
const $1043fc05a880bbb3$export$13e680397ec8f3eb = new $1043fc05a880bbb3$var$VisibilityChangeObserver();
module.exports["visibilityChangeObserver"] = $1043fc05a880bbb3$export$13e680397ec8f3eb;

});

parcelRegister("e22Cc", function(module, exports) {
const $0f617bf44fb531ac$export$15e172712955e18f = ()=>{
    return typeof window !== 'undefined';
};
module.exports["isWindowObjectAvailable"] = $0f617bf44fb531ac$export$15e172712955e18f;

});

parcelRegister("j7Sza", function(module, exports) {
const $f267d4a3139d0594$export$81b70111112841a0 = {
    NOT_STARTED: {
        id: 'NOT_STARTED',
        final: true
    },
    STARTED: {
        id: 'STARTED'
    },
    IN_PROGRESS: {
        id: 'IN_PROGRESS'
    },
    BLOCKED: {
        id: 'BLOCKED'
    },
    RECOVERED: {
        id: 'RECOVERED'
    },
    SUCCEEDED: {
        id: 'SUCCEEDED',
        final: true,
        success: true
    },
    SUCCEEDED_WAITING_FOR_DEPS: {
        id: 'SUCCEEDED_WAITING_FOR_DEPS'
    },
    FAILED: {
        id: 'FAILED',
        final: true
    },
    ABORTED: {
        id: 'ABORTED',
        final: true
    }
};
module.exports["UFOExperienceState"] = $f267d4a3139d0594$export$81b70111112841a0;

});

parcelRegister("g8bWJ", function(module, exports) {

var $j7Sza = parcelRequire("j7Sza");

const $59fdb64e04330d55$var$UFOStateAvailableTransitions = {
    [(0, $j7Sza.UFOExperienceState).NOT_STARTED.id]: [
        (0, $j7Sza.UFOExperienceState).STARTED.id
    ],
    [(0, $j7Sza.UFOExperienceState).STARTED.id]: [
        (0, $j7Sza.UFOExperienceState).IN_PROGRESS.id,
        (0, $j7Sza.UFOExperienceState).BLOCKED.id,
        (0, $j7Sza.UFOExperienceState).SUCCEEDED.id,
        (0, $j7Sza.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $j7Sza.UFOExperienceState).FAILED.id,
        (0, $j7Sza.UFOExperienceState).ABORTED.id
    ],
    [(0, $j7Sza.UFOExperienceState).IN_PROGRESS.id]: [
        (0, $j7Sza.UFOExperienceState).BLOCKED.id,
        (0, $j7Sza.UFOExperienceState).SUCCEEDED.id,
        (0, $j7Sza.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $j7Sza.UFOExperienceState).FAILED.id,
        (0, $j7Sza.UFOExperienceState).ABORTED.id
    ],
    [(0, $j7Sza.UFOExperienceState).BLOCKED.id]: [
        (0, $j7Sza.UFOExperienceState).RECOVERED.id,
        (0, $j7Sza.UFOExperienceState).ABORTED.id
    ],
    [(0, $j7Sza.UFOExperienceState).RECOVERED.id]: [
        (0, $j7Sza.UFOExperienceState).STARTED.id,
        (0, $j7Sza.UFOExperienceState).SUCCEEDED.id,
        (0, $j7Sza.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $j7Sza.UFOExperienceState).FAILED.id,
        (0, $j7Sza.UFOExperienceState).ABORTED.id
    ],
    [(0, $j7Sza.UFOExperienceState).SUCCEEDED.id]: [
        (0, $j7Sza.UFOExperienceState).STARTED.id
    ],
    [(0, $j7Sza.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id]: [
        (0, $j7Sza.UFOExperienceState).SUCCEEDED.id,
        (0, $j7Sza.UFOExperienceState).FAILED.id,
        (0, $j7Sza.UFOExperienceState).ABORTED.id
    ],
    [(0, $j7Sza.UFOExperienceState).FAILED.id]: [
        (0, $j7Sza.UFOExperienceState).STARTED.id
    ],
    [(0, $j7Sza.UFOExperienceState).ABORTED.id]: [
        (0, $j7Sza.UFOExperienceState).STARTED.id
    ]
};
const $59fdb64e04330d55$export$178881f329fdb81f = (state1, state2)=>{
    return $59fdb64e04330d55$var$UFOStateAvailableTransitions[state1.id] && $59fdb64e04330d55$var$UFOStateAvailableTransitions[state1.id].includes(state2.id);
};
module.exports["canTransition"] = $59fdb64e04330d55$export$178881f329fdb81f;

});

parcelRegister("4MiWC", function(module, exports) {
var $d8444ff033f3362a$export$994164cf3ae1cc9a = /*#__PURE__*/ function(ExperienceTypes) {
    ExperienceTypes["Load"] = "load";
    ExperienceTypes["Experience"] = "experience";
    ExperienceTypes["Operation"] = "operation";
    return ExperienceTypes;
}({});
var $d8444ff033f3362a$export$cc26007c03242fff = /*#__PURE__*/ function(ExperiencePerformanceTypes) {
    ExperiencePerformanceTypes["PageLoad"] = "page-load";
    ExperiencePerformanceTypes["PageSegmentLoad"] = "page-segment-load";
    ExperiencePerformanceTypes["InlineResult"] = "inline-result";
    ExperiencePerformanceTypes["Custom"] = "custom";
    return ExperiencePerformanceTypes;
}({});
module.exports["ExperienceTypes"] = $d8444ff033f3362a$export$994164cf3ae1cc9a;
module.exports["ExperiencePerformanceTypes"] = $d8444ff033f3362a$export$cc26007c03242fff;

});

parcelRegister("DJFHw", function(module, exports) {
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead

var $2xhEb = parcelRequire("2xhEb");

const $56570a8acedc1b5f$export$c753e8669d30c8ad = (timestamp)=>{
    if (timestamp !== undefined) return ~~timestamp;
    return (0, $2xhEb.roundPerfNow)();
};
module.exports["perfNowOrTimestamp"] = $56570a8acedc1b5f$export$c753e8669d30c8ad;

});

parcelRegister("2xhEb", function(module, exports) {
const $a279419ecc31ce6a$export$5f490af6b2b115cf = ()=>~~performance.now();
module.exports["roundPerfNow"] = $a279419ecc31ce6a$export$5f490af6b2b115cf;

});

parcelRegister("89QZA", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $gBjHb = parcelRequire("gBjHb");

const $87e579b14b793016$var$initialState = {
    conversationChannelId: '',
    chatEntryPoint: undefined,
    experienceId: '',
    product: '',
    productHeader: '',
    inProductExperience: '',
    agentId: null,
    agentExternalConfigReference: null,
    agentActions: [],
    agentIsDefault: null,
    agentIsVerified: null,
    fullScreen: false,
    agentCreatorType: '',
    agentVisibility: '',
    singleInstrumentationID: '',
    mode: undefined
};
const $87e579b14b793016$var$AnalyticsPropertiesContext = /*#__PURE__*/ (0, $cozmU.createContext)({
    propertiesRef: {
        current: {
            ...$87e579b14b793016$var$initialState
        }
    },
    mode: undefined,
    setAnalyticsPropertiesWithoutRerender: ()=>{}
});
const $87e579b14b793016$export$5ae3634fdb64882c = /*#__PURE__*/ (0, $cozmU.createContext)({
    sharedFeaturesInstrumentationId: undefined,
    isInSmartCreateFlow: undefined
});
const $87e579b14b793016$export$1aefd27d2ed3c1c9 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(15);
    const { children: children, mode: mode, launchSource: launchSource, rovoJourneyId: rovoJourneyId } = t0;
    let t1;
    if ($[0] !== launchSource || $[1] !== rovoJourneyId) {
        t1 = {
            ...$87e579b14b793016$var$initialState,
            launchSource: launchSource,
            rovoJourneyId: rovoJourneyId
        };
        $[0] = launchSource;
        $[1] = rovoJourneyId;
        $[2] = t1;
    } else t1 = $[2];
    const propertiesRef = (0, $cozmU.useRef)(t1);
    let t2;
    let t3;
    if ($[3] !== launchSource) {
        t2 = ()=>{
            propertiesRef.current.launchSource = launchSource;
        };
        t3 = [
            launchSource
        ];
        $[3] = launchSource;
        $[4] = t2;
        $[5] = t3;
    } else {
        t2 = $[4];
        t3 = $[5];
    }
    (0, $cozmU.useEffect)(t2, t3);
    let t4;
    let t5;
    if ($[6] !== rovoJourneyId) {
        t4 = ()=>{
            propertiesRef.current.rovoJourneyId = rovoJourneyId;
        };
        t5 = [
            rovoJourneyId
        ];
        $[6] = rovoJourneyId;
        $[7] = t4;
        $[8] = t5;
    } else {
        t4 = $[7];
        t5 = $[8];
    }
    (0, $cozmU.useEffect)(t4, t5);
    let t6;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = (properties)=>{
            propertiesRef.current = {
                ...propertiesRef.current,
                ...properties
            };
        };
        $[9] = t6;
    } else t6 = $[9];
    const setAnalyticsPropertiesWithoutRerender = t6;
    let t7;
    if ($[10] !== mode) {
        t7 = {
            propertiesRef: propertiesRef,
            mode: mode,
            setAnalyticsPropertiesWithoutRerender: setAnalyticsPropertiesWithoutRerender
        };
        $[10] = mode;
        $[11] = t7;
    } else t7 = $[11];
    const value = t7;
    let t8;
    if ($[12] !== children || $[13] !== value) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($87e579b14b793016$var$AnalyticsPropertiesContext.Provider, {
            value: value
        }, children);
        $[12] = children;
        $[13] = value;
        $[14] = t8;
    } else t8 = $[14];
    return t8;
} : ({ children: children, mode: mode, launchSource: launchSource, rovoJourneyId: rovoJourneyId })=>{
    const propertiesRef = (0, $cozmU.useRef)({
        ...$87e579b14b793016$var$initialState,
        launchSource: launchSource,
        rovoJourneyId: rovoJourneyId
    });
    // Sync the (possibly late/changing) prop into the ref after commit, so concurrent
    // renders that are paused or discarded never leak an uncommitted launch source.
    (0, $cozmU.useEffect)(()=>{
        propertiesRef.current.launchSource = launchSource;
    }, [
        launchSource
    ]);
    (0, $cozmU.useEffect)(()=>{
        propertiesRef.current.rovoJourneyId = rovoJourneyId;
    }, [
        rovoJourneyId
    ]);
    const setAnalyticsPropertiesWithoutRerender = (0, $cozmU.useCallback)((properties)=>{
        propertiesRef.current = {
            ...propertiesRef.current,
            ...properties
        };
    }, []);
    const value = (0, $cozmU.useMemo)(()=>({
            propertiesRef: propertiesRef,
            mode: mode,
            setAnalyticsPropertiesWithoutRerender: setAnalyticsPropertiesWithoutRerender
        }), [
        setAnalyticsPropertiesWithoutRerender,
        mode
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($87e579b14b793016$var$AnalyticsPropertiesContext.Provider, {
        value: value
    }, children);
};
const $87e579b14b793016$export$a00cd3c213413389 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(21);
    const { source: source, sharedFeaturesInstrumentationId: sharedFeaturesInstrumentationId, iframeHostProduct: iframeHostProduct, children: children, mode: mode, isAlwaysInSmartCreateFlow: isAlwaysInSmartCreateFlow, launchSource: launchSource, rovoJourneyId: rovoJourneyId } = t0;
    const { sharedFeaturesInstrumentationId: parentSharedFeaturesInstrumentationId, isInSmartCreateFlow: parentIsInSmartCreateFlow } = (0, $cozmU.useContext)($87e579b14b793016$export$5ae3634fdb64882c);
    const isInSmartCreateFlow = isAlwaysInSmartCreateFlow === undefined ? parentIsInSmartCreateFlow : isAlwaysInSmartCreateFlow;
    const t1 = sharedFeaturesInstrumentationId ?? parentSharedFeaturesInstrumentationId;
    let t2;
    if ($[0] !== iframeHostProduct || $[1] !== isInSmartCreateFlow || $[2] !== t1) {
        t2 = {
            sharedFeaturesInstrumentationId: t1,
            isInSmartCreateFlow: isInSmartCreateFlow,
            iframeHostProduct: iframeHostProduct
        };
        $[0] = iframeHostProduct;
        $[1] = isInSmartCreateFlow;
        $[2] = t1;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== source || $[5] !== t2) {
        t3 = {
            source: source,
            attributes: t2
        };
        $[4] = source;
        $[5] = t2;
        $[6] = t3;
    } else t3 = $[6];
    const data = t3;
    const t4 = sharedFeaturesInstrumentationId ?? parentSharedFeaturesInstrumentationId;
    let t5;
    if ($[7] !== isInSmartCreateFlow || $[8] !== t4) {
        t5 = {
            sharedFeaturesInstrumentationId: t4,
            isInSmartCreateFlow: isInSmartCreateFlow
        };
        $[7] = isInSmartCreateFlow;
        $[8] = t4;
        $[9] = t5;
    } else t5 = $[9];
    let t6;
    if ($[10] !== children || $[11] !== launchSource || $[12] !== mode || $[13] !== rovoJourneyId) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($87e579b14b793016$export$1aefd27d2ed3c1c9, {
            mode: mode,
            launchSource: launchSource,
            rovoJourneyId: rovoJourneyId
        }, children);
        $[10] = children;
        $[11] = launchSource;
        $[12] = mode;
        $[13] = rovoJourneyId;
        $[14] = t6;
    } else t6 = $[14];
    let t7;
    if ($[15] !== t5 || $[16] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($87e579b14b793016$export$5ae3634fdb64882c.Provider, {
            value: t5
        }, t6);
        $[15] = t5;
        $[16] = t6;
        $[17] = t7;
    } else t7 = $[17];
    let t8;
    if ($[18] !== data || $[19] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gBjHb.default), {
            data: data
        }, t7);
        $[18] = data;
        $[19] = t7;
        $[20] = t8;
    } else t8 = $[20];
    return t8;
} : ({ source: source, sharedFeaturesInstrumentationId: sharedFeaturesInstrumentationId, iframeHostProduct: iframeHostProduct, children: children, mode: mode, isAlwaysInSmartCreateFlow: isAlwaysInSmartCreateFlow, launchSource: launchSource, rovoJourneyId: rovoJourneyId })=>{
    const { sharedFeaturesInstrumentationId: parentSharedFeaturesInstrumentationId, isInSmartCreateFlow: parentIsInSmartCreateFlow } = (0, $cozmU.useContext)($87e579b14b793016$export$5ae3634fdb64882c);
    const isInSmartCreateFlow = isAlwaysInSmartCreateFlow === undefined ? parentIsInSmartCreateFlow : isAlwaysInSmartCreateFlow;
    const data = (0, $cozmU.useMemo)(()=>({
            source: source,
            attributes: {
                sharedFeaturesInstrumentationId: sharedFeaturesInstrumentationId ?? parentSharedFeaturesInstrumentationId,
                isInSmartCreateFlow: isInSmartCreateFlow,
                iframeHostProduct: iframeHostProduct
            }
        }), [
        source,
        sharedFeaturesInstrumentationId,
        parentSharedFeaturesInstrumentationId,
        isInSmartCreateFlow,
        iframeHostProduct
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gBjHb.default), {
        data: data
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($87e579b14b793016$export$5ae3634fdb64882c.Provider, {
        value: {
            sharedFeaturesInstrumentationId: sharedFeaturesInstrumentationId ?? parentSharedFeaturesInstrumentationId,
            isInSmartCreateFlow: isInSmartCreateFlow
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($87e579b14b793016$export$1aefd27d2ed3c1c9, {
        mode: mode,
        launchSource: launchSource,
        rovoJourneyId: rovoJourneyId
    }, children)));
};
const $87e579b14b793016$export$ab8aa3dfd687f012 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)($87e579b14b793016$var$AnalyticsPropertiesContext);
} : ()=>{
    return (0, $cozmU.useContext)($87e579b14b793016$var$AnalyticsPropertiesContext);
};
module.exports["SharedFeaturesInstrumentationIdContext"] = $87e579b14b793016$export$5ae3634fdb64882c;
module.exports["AnalyticsContextWithSourceAndProperties"] = $87e579b14b793016$export$a00cd3c213413389;
module.exports["useAnalyticsPropertiesContext"] = $87e579b14b793016$export$ab8aa3dfd687f012;

});

parcelRegister("bjY3F", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $cbY7C = parcelRequire("cbY7C");


var $6cFsl = parcelRequire("6cFsl");


var $1hQ0e = parcelRequire("1hQ0e");


var $cha5E = parcelRequire("cha5E");


var $iDrrr = parcelRequire("iDrrr");


var $a33Aa = parcelRequire("a33Aa");


var $boaiH = parcelRequire("boaiH");


var $1mEm4 = parcelRequire("1mEm4");


var $10XTN = parcelRequire("10XTN");


var $hlvTd = parcelRequire("hlvTd");


var $Ou0Zz = parcelRequire("Ou0Zz");


var $irnO2 = parcelRequire("irnO2");


var $1XM8n = parcelRequire("1XM8n");


var $8YL3U = parcelRequire("8YL3U");

var $78cafaa44d513db0$var$_ExperienceTrackerHandler;
const $78cafaa44d513db0$var$WORK_ITEM_EXPERIENCES = new Set([
    (0, $irnO2.ExperienceName).ROVO_SKILLS_PLAN_WORK_ITEM_CREATE,
    (0, $irnO2.ExperienceName).ROVO_SKILLS_EXECUTION_WORK_ITEM_CREATE,
    (0, $irnO2.ExperienceName).ROVO_SKILLS_PLAN_WORK_ITEM_UPDATE,
    (0, $irnO2.ExperienceName).ROVO_SKILLS_EXECUTION_WORK_ITEM_UPDATE
]);
const $78cafaa44d513db0$var$isRovoInstrumentedError = (error)=>error !== null && error !== undefined && typeof error === 'object' && 'errorAttributes' in error && typeof error.errorAttributes === 'object';
const $78cafaa44d513db0$var$isTerminalEvent = (event)=>event.action === 'taskSuccess' || event.action === 'taskFail' || event.action === 'taskAbort';
const $78cafaa44d513db0$var$isAbortEvent = (event)=>event.action === 'taskAbort';
const $78cafaa44d513db0$var$isHelloShard = (shard)=>{
    const shardName = shard.split('.')[0];
    return /-hello(?:-\d+)?$/.test(shardName);
};
class $78cafaa44d513db0$export$5a92a056565f01cc {
    destroy() {
        this.experienceTracker.abort({
            reason: 'Experience tracker destroyed'
        });
        this.unsubscribe?.();
        this.unsubscribe = undefined;
        this.unbindVisibility?.();
        this.unbindVisibility = undefined;
        this.tabVisibilityByExperience.clear();
    }
    setSendAnalyticsEvent(sendAnalyticsEvent) {
        this.sendAnalyticsEvent = sendAnalyticsEvent;
    }
    static getInstance() {
        if (!$78cafaa44d513db0$export$5a92a056565f01cc.instance) $78cafaa44d513db0$export$5a92a056565f01cc.instance = new $78cafaa44d513db0$export$5a92a056565f01cc();
        // instance is guaranteed to be set after the guard above
        return $78cafaa44d513db0$export$5a92a056565f01cc.instance;
    }
    /**
   * @internal For tests only.
   */ static resetInstance() {
        $78cafaa44d513db0$export$5a92a056565f01cc.instance = undefined;
    }
    static setLabelStack(labelStack) {
        $78cafaa44d513db0$export$5a92a056565f01cc.labelStack = labelStack;
    }
    constructor(){
        this.experienceTracker = new (0, $boaiH.ExperienceTracker)();
        this.sendAnalyticsEvent = null;
        this.tabVisibilityByExperience = new Map();
        this.unbindVisibility = void 0;
        this.unsubscribe = void 0;
        const doc = (0, $1hQ0e.getDocument)();
        if (doc) this.unbindVisibility = (0, $cbY7C.bind)(doc, {
            type: 'visibilitychange',
            listener: ()=>{
                const isHidden = doc.visibilityState === 'hidden';
                this.tabVisibilityByExperience.forEach((tracker)=>{
                    tracker.onVisibilityChange(isHidden);
                });
            }
        });
        if (!(0, $cha5E.expVal)('platform_ai_drop_instrumentation_tracking', 'value', false)) {
            if ((0, $iDrrr.fg)('rovo_work_item_reliability_shard')) (0, $1mEm4.getCurrentTenantShard)();
            this.unsubscribe = this.experienceTracker.subscribe((event)=>{
                if (event.action === 'taskStart') this.tabVisibilityByExperience.set(event.name, new (0, $8YL3U.TabVisibilityTracker)(doc));
                let filteredErrorAttributes = {};
                let preventSendingLogException = false;
                // When non-null, converts taskFail → taskAbort so the error is excluded from SLO
                // failure counts but still recorded for anomaly detection purposes.
                let sloExclusion = null;
                const isErrorEvent = 'error' in event;
                // Skip SLO exclusion logic for the aiMateFilteredClientError experience itself
                // to avoid re-processing and potential infinite loops.
                const isFilteredClientErrorExperience = event.name === (0, $irnO2.ExperienceName).FILTERED_CLIENT_ERROR;
                if (isErrorEvent && !isFilteredClientErrorExperience) {
                    // Classify common non-service errors so they can be tracked separately from
                    // real backend failures:
                    //   - client fetch errors (e.g. "Failed to fetch") — request never reached Atlassian
                    //   - product-not-active — HTTP 200 but SSE payload contains an errorCode
                    //   - auth/permission — HTTP 401/403 (session expired, HIPAA, IP allowlist, etc.)
                    if ((0, $10XTN.isClientFetchError)(event.error)) {
                        preventSendingLogException = true;
                        sloExclusion = {
                            reason: (0, $irnO2.SLOExclusionReason).CLIENT_FETCH_ERROR
                        };
                    } else if ((0, $10XTN.isProductNotActiveError)(event.error)) {
                        preventSendingLogException = true;
                        sloExclusion = {
                            reason: (0, $irnO2.SLOExclusionReason).PRODUCT_NOT_ACTIVE
                        };
                    } else if ((0, $10XTN.isAuthOrPermissionError)(event.error)) {
                        preventSendingLogException = true;
                        sloExclusion = {
                            reason: (0, $irnO2.SLOExclusionReason).AUTH_OR_PERMISSION_ERROR
                        };
                    } else if ((0, $10XTN.isRateLimitError)(event.error)) {
                        preventSendingLogException = true;
                        sloExclusion = {
                            reason: (0, $irnO2.SLOExclusionReason).RATE_LIMIT_ERROR
                        };
                    }
                    if (event.attributes) {
                        const { webSearchEnabled: webSearchEnabled, deepResearchEnabled: deepResearchEnabled, thinkDeeperEnabled: thinkDeeperEnabled, fastModeEnabled: fastModeEnabled } = event.attributes;
                        if (webSearchEnabled !== undefined) filteredErrorAttributes = {
                            ...filteredErrorAttributes,
                            webSearchEnabled: webSearchEnabled
                        };
                        if (deepResearchEnabled !== undefined) filteredErrorAttributes = {
                            ...filteredErrorAttributes,
                            deepResearchEnabled: deepResearchEnabled
                        };
                        if (fastModeEnabled !== undefined) filteredErrorAttributes = {
                            ...filteredErrorAttributes,
                            fastModeEnabled: fastModeEnabled
                        };
                        if (thinkDeeperEnabled !== undefined) filteredErrorAttributes = {
                            ...filteredErrorAttributes,
                            thinkDeeperEnabled: thinkDeeperEnabled
                        };
                    }
                    if ($78cafaa44d513db0$var$isRovoInstrumentedError(event.error)) {
                        const errorAttributes = event.error.errorAttributes;
                        // Remove undefined properties
                        filteredErrorAttributes = Object.fromEntries(Object.entries(errorAttributes).filter(([, value])=>value !== undefined));
                    }
                    const teamName = (0, $1XM8n.getOwningTeam)(event.error.message ?? '', event.name);
                    filteredErrorAttributes = {
                        teamName: teamName,
                        // We intentionally put this first so a `teamName` attribute can override this.
                        ...filteredErrorAttributes
                    };
                    if (!preventSendingLogException) {
                        const error = event.error instanceof Error ? event.error : new Error(JSON.stringify(event.error));
                        const attributes = event.attributes;
                        // this is added by `useExperienceTracker` below
                        const touchpointSource = typeof attributes?.touchpointSource === 'string' ? attributes.touchpointSource : undefined;
                        const teamName = typeof attributes?.teamName === 'string' ? attributes.teamName : undefined;
                        const { traceId: traceIdFromErrorObject, ...filteredErrorAttributesRest } = filteredErrorAttributes;
                        const altTraceId = attributes?.traceId || traceIdFromErrorObject;
                        (0, $hlvTd.logException)({
                            exception: error,
                            name: event.name,
                            // eslint-disable-next-line @atlaskit/platform/no-double-type-assertions -- Existing experience-tracker baseline: legacy UFO attributes are assembled from mixed attribute sources before being passed to a string map API.
                            tags: {
                                source: 'aiMateExperienceTracker',
                                ...filteredErrorAttributesRest,
                                ...touchpointSource && {
                                    touchpointSource: touchpointSource
                                },
                                ...teamName && {
                                    teamName: teamName
                                },
                                // Rename traceId to atlTraceId if present in attributes to distinguish from Sentry's Trace ID
                                ...altTraceId && {
                                    altTraceId: altTraceId
                                }
                            }
                        });
                    }
                }
                if ($78cafaa44d513db0$var$isTerminalEvent(event)) // the experience tracker already uses performance.now() to calculate the duration, so we can just piggyback on that,
                // we will loose some precision due to rounding of duration, but it's good enough for our purposes
                (0, $a33Aa.addSpanToAll)('custom', `exp-${event.name}`, $78cafaa44d513db0$export$5a92a056565f01cc.labelStack, event.startTime, event.startTime + event.duration);
                const tabVisibilityAttributes = $78cafaa44d513db0$var$isTerminalEvent(event) ? this.tabVisibilityByExperience.get(event.name)?.getAttributes(doc) ?? {} : {};
                // If the error should be excluded from SLO, report it as taskAbort instead of taskFail.
                // taskAbort events are not counted as failures in the SLO but are still recorded
                // so anomaly detectors can track spikes in these error types.
                const effectiveAction = sloExclusion && event.action === 'taskFail' ? 'taskAbort' : event.action;
                const sendEvent = (shard)=>this.sendAnalyticsEvent?.({
                        eventType: 'operational',
                        action: effectiveAction,
                        actionSubject: 'ui',
                        attributes: {
                            task: event.name,
                            taskId: event.id,
                            startTime: event.startTime,
                            ...$78cafaa44d513db0$var$isTerminalEvent(event) && {
                                duration: event.duration
                            },
                            // Include error info on both taskFail and taskAbort (for excluded errors)
                            // so analytics/anomaly detectors can distinguish error types.
                            ...isErrorEvent && {
                                error: event.error.message,
                                ...filteredErrorAttributes
                            },
                            // Surface why the error was excluded from the SLO so the raw analytics
                            // event can be queried/grouped without joining to the synthetic experience.
                            ...sloExclusion && {
                                sloExclusionReason: sloExclusion.reason
                            },
                            // `abort()` takes its reason as a top-level field rather than inside
                            // `attributes`, so it is otherwise dropped here and aborts land in
                            // analytics with no indication of why they happened. Spread before
                            // `event.attributes` so callers that already nest their own `reason`
                            // keep precedence.
                            ...$78cafaa44d513db0$var$isAbortEvent(event) && {
                                reason: event.reason
                            },
                            ...event.attributes,
                            ...tabVisibilityAttributes,
                            ...shard && {
                                shard: shard,
                                is_hello: $78cafaa44d513db0$var$isHelloShard(shard)
                            }
                        }
                    }, {
                        removeDefaultTags: true
                    });
                // Platform cannot reliably read shard information for every host product. Most work-item
                // event traffic comes from Jira and Confluence, so shard enrichment is scoped to these events.
                if ($78cafaa44d513db0$var$WORK_ITEM_EXPERIENCES.has(event.name) && (0, $iDrrr.fg)('rovo_work_item_reliability_shard')) (0, $1mEm4.getCurrentTenantShard)().then(sendEvent).catch(()=>{
                // Best-effort analytics must not produce an unhandled rejection.
                });
                else sendEvent();
                // When a client error is excluded from the main SLO (ie. converted to taskAbort),
                // track a separate experience so the volume of these errors can be monitored with its own SLO threshold.
                if (sloExclusion && isErrorEvent) {
                    this.experienceTracker.start({
                        name: (0, $irnO2.ExperienceName).FILTERED_CLIENT_ERROR,
                        id: (0, $irnO2.ExperienceName).FILTERED_CLIENT_ERROR,
                        startTime: event.startTime
                    });
                    this.experienceTracker.fail({
                        name: (0, $irnO2.ExperienceName).FILTERED_CLIENT_ERROR,
                        error: event.error,
                        attributes: {
                            // Preserve the original experience name, error, and exclusion reason for queryability
                            originalTask: event.name,
                            error: event.error.message,
                            sloExclusionReason: sloExclusion.reason,
                            ...filteredErrorAttributes
                        }
                    });
                }
                if ($78cafaa44d513db0$var$isTerminalEvent(event)) this.tabVisibilityByExperience.delete(event.name);
            });
        }
    }
}
$78cafaa44d513db0$var$_ExperienceTrackerHandler = $78cafaa44d513db0$export$5a92a056565f01cc;
$78cafaa44d513db0$export$5a92a056565f01cc.instance = void 0;
$78cafaa44d513db0$export$5a92a056565f01cc.labelStack = [];
const $78cafaa44d513db0$export$63af6e7bbb4f375d = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return $78cafaa44d513db0$var$_temp;
} : ()=>{
    return (0, $cozmU.useCallback)((componentLabelStack)=>{
        $78cafaa44d513db0$export$5a92a056565f01cc.setLabelStack(componentLabelStack);
    }, []);
};
const $78cafaa44d513db0$export$412c53791574f6f0 = (params, handler = $78cafaa44d513db0$export$5a92a056565f01cc.getInstance())=>{
    (0, $6cFsl.di)((0, $Ou0Zz.useAnalytics));
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    (0, $cozmU.useMemo)(()=>{
        // this is not ideal, okay just because `sendAnalyticsEvent` is never change
        // since every hook using the same handler will override its sendAnalyticsEvent
        handler.setSendAnalyticsEvent(sendAnalyticsEvent);
    }, [
        handler,
        sendAnalyticsEvent
    ]);
    const experienceTrackerProxy = (0, $cozmU.useMemo)(()=>{
        const proxyHandler = {
            get: (target, prop)=>{
                // Overriding the experienceTracker target methods to add additional attributes
                if (prop === 'fail') return (failParams)=>{
                    target.fail({
                        ...failParams,
                        attributes: {
                            ...failParams.attributes,
                            touchpointSource: params?.touchpointSource,
                            teamName: failParams.teamName
                        }
                    });
                };
                if (prop === 'succeed') return (succeedParams)=>{
                    target.succeed({
                        ...succeedParams,
                        attributes: {
                            ...succeedParams.attributes,
                            touchpointSource: params?.touchpointSource
                        }
                    });
                };
                return typeof target[prop] === 'function' ? target[prop].bind(target) : target[prop];
            }
        };
        return new Proxy(handler.experienceTracker, proxyHandler);
    }, [
        handler,
        params?.touchpointSource
    ]);
    return experienceTrackerProxy;
};
function $78cafaa44d513db0$var$_temp(componentLabelStack) {
    $78cafaa44d513db0$export$5a92a056565f01cc.setLabelStack(componentLabelStack);
}
module.exports["ExperienceTrackerHandler"] = $78cafaa44d513db0$export$5a92a056565f01cc;
module.exports["useUFOLabelStackSetter"] = $78cafaa44d513db0$export$63af6e7bbb4f375d;
module.exports["useAIMateExperienceTracker"] = $78cafaa44d513db0$export$412c53791574f6f0;

});

parcelRegister("cha5E", function(module, exports) {

var $a4RZV = parcelRequire("a4RZV");

function $62f475419a76226b$export$9db1624a8af791a4(experimentName, param, defaultValue) {
    return (0, $a4RZV.expValInternal)(experimentName, param, defaultValue, true);
}
module.exports["expVal"] = $62f475419a76226b$export$9db1624a8af791a4;

});

parcelRegister("a4RZV", function(module, exports) {

var $cXtTj = parcelRequire("cXtTj");


var $7OZjB = parcelRequire("7OZjB");


var $gvJlB = parcelRequire("gvJlB");

function $9b4163a3d03875dc$export$48708229abf6ab93(experimentName, param, defaultValue, fireExperimentExposure) {
    // Dev-mode override (platform website dev panel, Gemini VR test harness).
    if ((0, $gvJlB.devOverrides).has(experimentName)) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const overrideParams = (0, $gvJlB.devOverrides).get(experimentName);
        const overrideValue = overrideParams[param];
        if (overrideValue !== undefined) {
            (0, $7OZjB.addFeatureFlagAccessed)(`${experimentName}:${param}`, overrideValue);
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return overrideValue;
        }
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return defaultValue;
    }
    // If Statsig is not initialized, return the default.
    if (!(0, $cXtTj.default).initializeCompleted()) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return defaultValue;
    // Live Statsig value.
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    const value = (0, $cXtTj.default).getExperimentValue(experimentName, param, defaultValue, {
        fireExperimentExposure: fireExperimentExposure
    });
    (0, $7OZjB.addFeatureFlagAccessed)(`${experimentName}:${param}`, value);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return value;
}
module.exports["expValInternal"] = $9b4163a3d03875dc$export$48708229abf6ab93;

});

parcelRegister("gvJlB", function(module, exports) {
const $bd07fe7ea4e784d1$export$89f9222be8849d61 = new Map();
let $bd07fe7ea4e784d1$export$1443858d5f82511f = false;
function $bd07fe7ea4e784d1$export$6bce865e33a255c3(value) {
    $bd07fe7ea4e784d1$export$1443858d5f82511f = value;
}
module.exports["devOverrides"] = $bd07fe7ea4e784d1$export$89f9222be8849d61;

});

parcelRegister("boaiH", function(module, exports) {

var $2gr4B = parcelRequire("2gr4B");

class $ffade2ccf1ecf3ef$export$12b6b072930fd68f {
    start({ name: name, id: id, timeout: timeout, startTime: startTime, attributes: attributes, onSuccess: onSuccess, onFailure: onFailure, onAbort: onAbort, collect: collect }) {
        const current = this.experiences[name];
        if (current && !current.hasStopped && current.id === id) return;
        // Before replacing a current experience, abort it to ensure
        // it is cleaned up.
        if (current) current.abort({
            reason: 'Aborted because the same experience was started with a new id'
        });
        const experience = new (0, $2gr4B.Experience)({
            name: name,
            id: id,
            timeout: timeout,
            startTime: startTime,
            attributes: attributes,
            onSuccess: onSuccess,
            onFailure: onFailure,
            onAbort: onAbort,
            onStart: (startEvent)=>{
                this.emit(startEvent);
                let disposeCollectSubscription = ()=>{};
                if (collect) {
                    const events = [];
                    disposeCollectSubscription = this.subscribe((event)=>{
                        // Ignore already running experiences that started before this
                        // experience started
                        if (event.action === 'taskStart' || events.some((previousEvent)=>previousEvent.name === event.name && previousEvent.action === 'taskStart')) {
                            events.push(event);
                            collect(events, experience);
                        }
                    });
                }
                return (stopEvent)=>{
                    disposeCollectSubscription();
                    this.emit(stopEvent);
                };
            }
        });
        this.experiences[name] = experience;
    }
    succeed({ name: name, attributes: attributes }) {
        const current = this.experiences[name];
        if (!current) return;
        current.succeed(attributes);
    }
    fail({ name: name, error: error, attributes: attributes }) {
        Object.values(this.experiences).forEach((current)=>{
            if (name != null && current.name !== name) return;
            current.fail({
                error: error,
                attributes: attributes
            });
        });
    }
    abort({ name: name, reason: reason, attributes: attributes, checkForTimeout: checkForTimeout }) {
        function abort(experience) {
            if (name != null && experience.name !== name) return;
            experience.abort({
                reason: reason,
                checkForTimeout: checkForTimeout,
                attributes: attributes
            });
        }
        const experiencesWithTimeouts = Object.values(this.experiences).filter((experience)=>experience.timeout);
        const experiencesWithoutTimeouts = Object.values(this.experiences).filter((experience)=>!experience.timeout);
        // We need to abort all experiences with timeouts first in order to properly
        // capture compound experiences composed of sub-experiences which have timeouts
        experiencesWithTimeouts.forEach(abort);
        experiencesWithoutTimeouts.forEach(abort);
    }
    subscribe(subscriber) {
        if (typeof subscriber !== 'function') throw new Error('Subscriber must be a function');
        this.subscribers.push(subscriber);
        return ()=>{
            this.subscribers = this.subscribers.filter((x)=>x !== subscriber);
        };
    }
    stopOnError({ name: name, error: error, attributes: attributes }) {
        if (this.isNetworkOfflineError(error)) {
            this.abort({
                name: name,
                reason: `Aborted ${name} because of network error: ${error.toString()}`,
                checkForTimeout: false,
                attributes: attributes
            });
            return;
        }
        return this.fail({
            name: name,
            error: error,
            attributes: attributes
        });
    }
    updateAttributes({ name: name, attributes: attributes }) {
        const current = this.experiences[name];
        if (!current) return;
        current.updateAttributes(attributes);
    }
    emit(event) {
        this.subscribers.forEach((subscriber)=>{
            try {
                subscriber(event);
            } catch (e) {}
        });
    }
    constructor(options){
        this.experiences = {};
        this.subscribers = [];
        this.isNetworkOfflineError = void 0;
        this.isNetworkOfflineError = options && options.isNetworkOfflineError || (()=>false);
    }
}
module.exports["ExperienceTracker"] = $ffade2ccf1ecf3ef$export$12b6b072930fd68f;

});

parcelRegister("2gr4B", function(module, exports) {

var $apqal = parcelRequire("apqal");

function $8617e1b2001e7e7c$var$mergeAttributes(first, last) {
    if (first === undefined) return last;
    if (last === undefined) return first;
    return {
        ...first,
        ...last
    };
}
class $8617e1b2001e7e7c$export$c90b54e658fc4d7c {
    get hasStopped() {
        return this._hasStopped;
    }
    succeed(attributes) {
        if (this._hasStopped) return;
        this.onSuccess && this.onSuccess();
        this.stop({
            action: 'taskSuccess',
            name: this.name,
            id: this.id,
            startTime: this.startTime,
            duration: this.getDuration(),
            attributes: $8617e1b2001e7e7c$var$mergeAttributes(this.attributes, attributes)
        });
    }
    fail({ error: error, attributes: attributes }) {
        if (this._hasStopped) return;
        this.onFailure && this.onFailure();
        this.stop({
            action: 'taskFail',
            name: this.name,
            id: this.id,
            startTime: this.startTime,
            duration: this.getDuration(),
            error: error,
            attributes: $8617e1b2001e7e7c$var$mergeAttributes(this.attributes, attributes)
        });
    }
    abort({ reason: reason, attributes: attributes, checkForTimeout: checkForTimeout = true }) {
        if (this._hasStopped) return;
        // Check if the experience should have failed due to timeout
        if (checkForTimeout && this.timeout != null && this.getDuration() >= this.timeout) {
            this.fail({
                attributes: attributes,
                error: new (0, $apqal.ExperienceTimeoutError)(`${this.name} failed to complete in ${this.timeout}ms`)
            });
            return;
        }
        this.onAbort && this.onAbort();
        this.stop({
            action: 'taskAbort',
            name: this.name,
            id: this.id,
            startTime: this.startTime,
            duration: this.getDuration(),
            reason: reason,
            checkForTimeout: checkForTimeout,
            attributes: $8617e1b2001e7e7c$var$mergeAttributes(this.attributes, attributes)
        });
    }
    stopOn(event) {
        if (!event) return;
        if (event.action === 'taskSuccess') this.succeed();
        else if (event.action === 'taskAbort') this.abort({
            reason: event.reason,
            checkForTimeout: event.checkForTimeout
        });
        else if (event.action === 'taskFail') this.fail({
            error: event.error
        });
    }
    updateAttributes(attributes) {
        this.attributes = {
            ...this.attributes,
            ...attributes
        };
    }
    stop(event) {
        this._hasStopped = true;
        if (this.onStop) this.onStop(event);
    }
    getDuration() {
        return Math.round(window.performance.now() - this.startTime);
    }
    constructor({ name: name, id: id, timeout: timeout, startTime: startTime = window.performance.now(), attributes: attributes, onStart: onStart, onSuccess: onSuccess, onFailure: onFailure, onAbort: onAbort }){
        this.name = void 0;
        this.id = void 0;
        this.timeout = void 0;
        this._hasStopped = false;
        this.startTime = void 0;
        this.attributes = void 0;
        this.onStop = void 0;
        this.onSuccess = void 0;
        this.onFailure = void 0;
        this.onAbort = void 0;
        this.name = name;
        this.id = id;
        this.timeout = timeout;
        this.startTime = startTime;
        this.attributes = attributes;
        this.onSuccess = onSuccess;
        this.onFailure = onFailure;
        this.onAbort = onAbort;
        const startEvent = {
            action: 'taskStart',
            name: name,
            id: id,
            startTime: startTime,
            timeout: timeout,
            attributes: attributes
        };
        if (onStart) this.onStop = onStart(startEvent);
    }
}
module.exports["Experience"] = $8617e1b2001e7e7c$export$c90b54e658fc4d7c;

});

parcelRegister("apqal", function(module, exports) {
class $f9800b995ac71735$export$d27a2b6293f7631c extends Error {
    constructor(message){
        super(message);
        this.name = 'ExperienceTimeoutError';
    }
}
module.exports["ExperienceTimeoutError"] = $f9800b995ac71735$export$d27a2b6293f7631c;

});

parcelRegister("1mEm4", function(module, exports) {
let $e35602fa899ad8d0$var$cachedShard;
let $e35602fa899ad8d0$var$currentLookup;
const $e35602fa899ad8d0$var$normalizeShard = (shard)=>typeof shard === 'string' ? shard.trim() || undefined : undefined;
const $e35602fa899ad8d0$var$readJiraShard = ()=>$e35602fa899ad8d0$var$normalizeShard(window.document.querySelector('meta[name="ajs-shard"]')?.getAttribute('content'));
const $e35602fa899ad8d0$var$readSiteInformationShard = async (value)=>{
    let timeout;
    try {
        const data = await Promise.race([
            value,
            new Promise((resolve)=>{
                timeout = setTimeout(()=>resolve(undefined), 5000);
            })
        ]);
        return $e35602fa899ad8d0$var$normalizeShard(data?.tenant?.shard ?? data?.shard);
    } catch  {
        // Tenant metadata is best effort and must never break instrumentation.
        return undefined;
    } finally{
        clearTimeout(timeout);
    }
};
const $e35602fa899ad8d0$var$readConfluenceShard = async ()=>{
    try {
        const browser = window;
        const siteShard = $e35602fa899ad8d0$var$readSiteInformationShard(browser.__SITEINFORMATION__);
        const sessionShard = $e35602fa899ad8d0$var$readSiteInformationShard(browser.__SITEINFORMATION_PROMISE__);
        return await siteShard ?? await sessionShard;
    } catch  {
        return undefined;
    }
};
const $e35602fa899ad8d0$var$readCurrentTenantShard = async ()=>{
    try {
        if (typeof window === 'undefined') return undefined;
        return $e35602fa899ad8d0$var$readJiraShard() ?? $e35602fa899ad8d0$var$readConfluenceShard();
    } catch  {
        return undefined;
    }
};
const $e35602fa899ad8d0$export$4662865aec5bc074 = ()=>{
    if (typeof window === 'undefined') return Promise.resolve(undefined);
    if ($e35602fa899ad8d0$var$cachedShard !== undefined) return Promise.resolve($e35602fa899ad8d0$var$cachedShard ?? undefined);
    if ($e35602fa899ad8d0$var$currentLookup) return $e35602fa899ad8d0$var$currentLookup;
    $e35602fa899ad8d0$var$currentLookup = $e35602fa899ad8d0$var$readCurrentTenantShard().then((shard)=>{
        $e35602fa899ad8d0$var$cachedShard = shard ?? null;
        return shard;
    }).finally(()=>{
        $e35602fa899ad8d0$var$currentLookup = undefined;
    });
    return $e35602fa899ad8d0$var$currentLookup;
};
module.exports["getCurrentTenantShard"] = $e35602fa899ad8d0$export$4662865aec5bc074;

});

parcelRegister("10XTN", function(module, exports) {

var $3PJhM = parcelRequire("3PJhM");

// Referenced from jira/src/packages/platform/utils/fetch/src/utils/is-error.tsx
// Issues we are not gonna track in Sentry
const $ab109556016fa76e$var$KNOWN_NETWORK_ERRORS_LIMITED = [
    'server with the specified hostname could not be found',
    'connection failure',
    'Failed to fetch',
    'Load failed',
    // Safari equivalent of "Failed to fetch"
    'Network request failed',
    'NetworkError',
    'The request timed out',
    'The network connection was lost',
    'The operation was aborted'
];
const $ab109556016fa76e$var$isClientFetchErrorMessage = (message)=>{
    const errorTypes = $ab109556016fa76e$var$KNOWN_NETWORK_ERRORS_LIMITED;
    return Boolean(message) && !!errorTypes.find((networkErrorMessage)=>// Using `includes` here because the underlying fetch error messages
        // are sometimes wrapped to provide additional context, e.g.
        // "Something went wrong: ${error.message}"
        message.includes(networkErrorMessage));
};
const $ab109556016fa76e$var$KNOWN_NETWORK_ERRORS_TYPES = [
    'AbortError',
    'AuthError',
    'ChunkLoadError',
    'NetworkError'
];
const $ab109556016fa76e$var$MAX_ERROR_CAUSE_DEPTH = 3;
const $ab109556016fa76e$var$getErrorAndCauseRecords = (error)=>{
    const records = [];
    let currentError = error;
    for(let depth = 0; depth < $ab109556016fa76e$var$MAX_ERROR_CAUSE_DEPTH && (0, $3PJhM.isRecord)(currentError); depth++){
        records.push(currentError);
        currentError = currentError.cause;
    }
    return records;
};
const $ab109556016fa76e$var$getErrorStatusCode = (error)=>{
    const errorAttributes = (0, $3PJhM.isRecord)(error.errorAttributes) ? error.errorAttributes : undefined;
    const attributes = (0, $3PJhM.isRecord)(error.attributes) ? error.attributes : undefined;
    const status = errorAttributes?.statusCode ?? error.status ?? attributes?.status;
    return typeof status === 'number' ? status : undefined;
};
const $ab109556016fa76e$var$getErrorCode = (error)=>{
    const errorAttributes = (0, $3PJhM.isRecord)(error.errorAttributes) ? error.errorAttributes : undefined;
    return typeof errorAttributes?.errorCode === 'string' ? errorAttributes.errorCode.toLowerCase() : undefined;
};
const $ab109556016fa76e$export$2e7adc44463c3f4f = (error)=>{
    if (!(0, $3PJhM.isRecord)(error)) return false;
    // Check top-level error name and message
    const hasKnownName = typeof error.name === 'string' && $ab109556016fa76e$var$KNOWN_NETWORK_ERRORS_TYPES.includes(error.name);
    const hasKnownMessage = typeof error.message === 'string' && $ab109556016fa76e$var$isClientFetchErrorMessage(error.message);
    if (hasKnownName || hasKnownMessage) return true;
    // Also check the nested cause (e.g. wrapped fetch errors)
    if (!(0, $3PJhM.isRecord)(error.cause)) return false;
    return typeof error.cause.name === 'string' && $ab109556016fa76e$var$KNOWN_NETWORK_ERRORS_TYPES.includes(error.cause.name) || typeof error.cause.message === 'string' && $ab109556016fa76e$var$isClientFetchErrorMessage(error.cause.message);
};
const $ab109556016fa76e$export$de229d5c9394f905 = (error)=>{
    return $ab109556016fa76e$var$getErrorAndCauseRecords(error).some((errorRecord)=>{
        const status = $ab109556016fa76e$var$getErrorStatusCode(errorRecord);
        return status === 401 || status === 403;
    });
};
const $ab109556016fa76e$export$a8908c3867f6f20b = (error)=>{
    return $ab109556016fa76e$var$getErrorAndCauseRecords(error).some((errorRecord)=>$ab109556016fa76e$var$getErrorStatusCode(errorRecord) === 429);
};
const $ab109556016fa76e$export$9f0dca42eff14720 = (error)=>{
    return $ab109556016fa76e$var$getErrorAndCauseRecords(error).some((errorRecord)=>{
        const errorCode = $ab109556016fa76e$var$getErrorCode(errorRecord) ?? '';
        return errorCode.includes('product.not.active') || errorCode.includes('product_not_active');
    });
};
module.exports["isClientFetchError"] = $ab109556016fa76e$export$2e7adc44463c3f4f;
module.exports["isAuthOrPermissionError"] = $ab109556016fa76e$export$de229d5c9394f905;
module.exports["isRateLimitError"] = $ab109556016fa76e$export$a8908c3867f6f20b;
module.exports["isProductNotActiveError"] = $ab109556016fa76e$export$9f0dca42eff14720;

});

parcelRegister("3PJhM", function(module, exports) {
/**
 * Type guard that checks whether a value is a plain record object.
 */ const $99d6458d8ffffa8f$export$6ba840931da50680 = (value)=>typeof value === 'object' && value !== null && !Array.isArray(value);
module.exports["isRecord"] = $99d6458d8ffffa8f$export$6ba840931da50680;

});

parcelRegister("hlvTd", function(module, exports) {

var $jTKfH = parcelRequire("jTKfH");


var $cj7GQ = parcelRequire("cj7GQ");


var $8DeC3 = parcelRequire("8DeC3");


const $024249913f1d8b5b$var$importPrivateSentryAsync = async ()=>{
    const sentry = await (parcelRequire("55apF"));
    return {
        BrowserClient: sentry.BrowserClient,
        eventFromException: sentry.eventFromException
    };
};
const $024249913f1d8b5b$var$DEFAULT_PACKAGE_NAME = '@atlassian/conversation-assistant';
const $024249913f1d8b5b$var$DEFAULT_SENTRY_DSN = 'https://0d679a1c0fe3816e2b2e34d4ca85d5da@o55978.ingest.sentry.io/4506794008903680';
let $024249913f1d8b5b$var$privateReporter;
let $024249913f1d8b5b$var$accountIdPromise;
const $024249913f1d8b5b$var$defaultAccountIdProvider = ()=>new Promise((resolve, reject)=>{
        (0, $jTKfH.performHttpFetch)({
            path: '/gateway/api/me',
            options: {
                method: 'GET'
            }
        }).then((profileData)=>{
            if (profileData?.account_id) resolve(profileData.account_id);
            else reject(new Error('Profile data not loaded'));
        }).catch((error)=>{
            reject(error);
        });
    });
let $024249913f1d8b5b$var$accountIdProvider = $024249913f1d8b5b$var$defaultAccountIdProvider;
const $024249913f1d8b5b$export$59333a3d3d770a30 = (fn)=>{
    $024249913f1d8b5b$var$accountIdProvider = fn;
    $024249913f1d8b5b$var$accountIdPromise = undefined;
};
const $024249913f1d8b5b$export$e941c8ce80d1ac70 = ()=>{
    $024249913f1d8b5b$var$accountIdProvider = $024249913f1d8b5b$var$defaultAccountIdProvider;
    $024249913f1d8b5b$var$accountIdPromise = undefined;
};
const $024249913f1d8b5b$export$388db6ab9ccbe151 = ()=>{
    $024249913f1d8b5b$var$privateReporter?.resetForTests();
    $024249913f1d8b5b$var$privateReporter = undefined;
    $024249913f1d8b5b$var$accountIdPromise = undefined;
    $024249913f1d8b5b$var$accountIdProvider = $024249913f1d8b5b$var$defaultAccountIdProvider;
};
const $024249913f1d8b5b$var$getEnvironment = ()=>{
    return 'production';
};
const $024249913f1d8b5b$var$getRelease = ()=>{
    if (typeof window === 'undefined') return;
    return window.SENTRY_RELEASE?.id;
};
const $024249913f1d8b5b$var$setupPrivateReporter = async ({ accountId: accountId, customSentryDsn: customSentryDsn, ignoreErrors: ignoreErrors, packageName: packageName, packageVersion: packageVersion, product: product })=>{
    const dsn = customSentryDsn || $024249913f1d8b5b$var$DEFAULT_SENTRY_DSN;
    if ($024249913f1d8b5b$var$privateReporter) {
        $024249913f1d8b5b$var$privateReporter.updateContext({
            accountId: accountId,
            packageVersion: packageVersion,
            product: product
        });
        return;
    }
    try {
        const importedSentry = await $024249913f1d8b5b$var$importPrivateSentryAsync();
        $024249913f1d8b5b$var$privateReporter = new (0, $8DeC3.ConversationAssistantPrivateReporter)({
            accountId: accountId,
            dsn: dsn,
            environment: $024249913f1d8b5b$var$getEnvironment(),
            ignoreErrors: ignoreErrors,
            packageName: packageName,
            packageVersion: packageVersion,
            product: product,
            release: $024249913f1d8b5b$var$getRelease(),
            sentry: importedSentry
        });
    } catch  {
    // Private reporting is best effort and must not affect Sentry callers.
    }
};
const $024249913f1d8b5b$export$d8bd0edf6c978788 = async ({ customSentryDsn: customSentryDsn, packageName: packageName, product: productOverride, ignoreErrors: ignoreErrors, packageVersion: packageVersion } = {})=>{
    let accountId = 'UNKNOWN_AAID';
    const product = productOverride ?? (0, $cj7GQ.getRovoChatProduct)();
    const resolvedPackageName = packageName || $024249913f1d8b5b$var$DEFAULT_PACKAGE_NAME;
    try {
        if (!$024249913f1d8b5b$var$accountIdPromise) $024249913f1d8b5b$var$accountIdPromise = $024249913f1d8b5b$var$accountIdProvider();
        accountId = await $024249913f1d8b5b$var$accountIdPromise;
    } catch  {
    // do nothing
    }
    await $024249913f1d8b5b$var$setupPrivateReporter({
        accountId: accountId,
        customSentryDsn: customSentryDsn,
        ignoreErrors: ignoreErrors,
        packageName: resolvedPackageName,
        packageVersion: packageVersion,
        product: product
    });
};
const $024249913f1d8b5b$export$f86b2a1a2ce291b3 = async ({ exception: exception, name: name, tags: tags })=>{
    if (!$024249913f1d8b5b$var$privateReporter) await $024249913f1d8b5b$export$d8bd0edf6c978788();
    try {
        await $024249913f1d8b5b$var$privateReporter?.captureException({
            exception: exception,
            name: name,
            tags: tags
        });
    } catch  {
    // Private reporting is best effort and must not affect Sentry callers.
    }
};
async function $024249913f1d8b5b$export$de29810e0b4aa46e(crumb) {
    if (!$024249913f1d8b5b$var$privateReporter) await $024249913f1d8b5b$export$d8bd0edf6c978788();
    try {
        $024249913f1d8b5b$var$privateReporter?.addBreadcrumb(crumb);
    } catch  {
    // Breadcrumb collection is best effort and must never affect the caller.
    }
}
const $024249913f1d8b5b$export$2a10cc65cb1c6167 = (...args)=>{
    console.error(...args); // eslint-disable-line no-console
    if ($024249913f1d8b5b$var$privateReporter) try {
        $024249913f1d8b5b$var$privateReporter.addBreadcrumb({
            category: 'console',
            level: 'error',
            message: args.map(String).join(' ')
        });
    } catch  {
    // Mirroring selected console output is best effort.
    }
};
const $024249913f1d8b5b$export$b9f335638bb5225f = (...args)=>{
    console.warn(...args); // eslint-disable-line no-console
    if ($024249913f1d8b5b$var$privateReporter) try {
        $024249913f1d8b5b$var$privateReporter.addBreadcrumb({
            category: 'console',
            level: 'warning',
            message: args.map(String).join(' ')
        });
    } catch  {
    // Mirroring selected console output is best effort.
    }
};
module.exports["setupSentryClient"] = $024249913f1d8b5b$export$d8bd0edf6c978788;
module.exports["logException"] = $024249913f1d8b5b$export$f86b2a1a2ce291b3;
module.exports["addSentryBreadcrumb"] = $024249913f1d8b5b$export$de29810e0b4aa46e;
module.exports["logSentryConsoleError"] = $024249913f1d8b5b$export$2a10cc65cb1c6167;
module.exports["logSentryConsoleWarning"] = $024249913f1d8b5b$export$b9f335638bb5225f;

});

parcelRegister("jTKfH", function(module, exports) {

var $5rzIE = parcelRequire("5rzIE");

const $93101e1e1df3fd55$export$9f229e40eb65abfc = (response)=>response?.headers?.get('x-trace-id') ?? response?.headers?.get('atl-traceid') ?? response?.headers?.get('x-b3-traceid') ?? undefined;
class $93101e1e1df3fd55$export$26e841bcf1aeb894 extends Error {
    constructor(message, errorAttributes){
        super(message), this.errorAttributes = errorAttributes;
        this.name = 'FetchError';
    }
}
class $93101e1e1df3fd55$var$HttpApiError extends Error {
    constructor(message, errorAttributes){
        super(message), this.message = message, this.errorAttributes = errorAttributes;
    }
}
const $93101e1e1df3fd55$export$a38d93aa782475f6 = async ({ path: path, options: options })=>{
    const startedAt = (0, $5rzIE.hasRequestObservationSubscribers)() ? (0, $5rzIE.requestObservationNow)() : undefined;
    try {
        const response = await fetch(path, options);
        if (!response.ok || response.status >= 400) await $93101e1e1df3fd55$var$processHttpErrorResponse({
            response: response
        });
        const result = await response.json();
        if (startedAt !== undefined) (0, $5rzIE.publishRequestObservation)({
            kind: 'http',
            method: (options.method ?? 'GET').toUpperCase(),
            route: (0, $5rzIE.normalizeRequestRoute)(path),
            durationMs: (0, $5rzIE.requestObservationDuration)(startedAt),
            outcome: 'success',
            status: response.status
        });
        return result;
    } catch (err) {
        const outcome = err instanceof $93101e1e1df3fd55$var$HttpApiError ? 'httpError' : err instanceof Error && err.name === 'AbortError' ? 'abort' : 'networkError';
        const statusCode = err instanceof $93101e1e1df3fd55$var$HttpApiError ? err.errorAttributes.statusCode : undefined;
        if (startedAt !== undefined) (0, $5rzIE.publishRequestObservation)({
            kind: 'http',
            method: (options.method ?? 'GET').toUpperCase(),
            route: (0, $5rzIE.normalizeRequestRoute)(path),
            durationMs: (0, $5rzIE.requestObservationDuration)(startedAt),
            outcome: outcome,
            status: statusCode
        });
        const originalErrorMessage = err instanceof Error ? 'Original error: ' + err.message : 'Unknown error';
        throw new $93101e1e1df3fd55$export$26e841bcf1aeb894(`performHttpFetch error while fetching ${path}. ${originalErrorMessage}`, {
            errorCode: 'performHttpFetchError',
            statusCode: statusCode
        });
    }
};
const $93101e1e1df3fd55$var$processHttpErrorResponse = async ({ response: response })=>{
    throw new $93101e1e1df3fd55$var$HttpApiError(`[Code ${response.status}] ${await response.text()}`, {
        statusCode: response.status,
        traceId: $93101e1e1df3fd55$export$9f229e40eb65abfc(response)
    });
};
module.exports["getTraceIdFromResponse"] = $93101e1e1df3fd55$export$9f229e40eb65abfc;
module.exports["FetchError"] = $93101e1e1df3fd55$export$26e841bcf1aeb894;
module.exports["performHttpFetch"] = $93101e1e1df3fd55$export$a38d93aa782475f6;

});

parcelRegister("5rzIE", function(module, exports) {
const $40a8b1f594239208$var$listeners = new Set();
const $40a8b1f594239208$var$UUID_SEGMENT_PATTERN = /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/gi;
const $40a8b1f594239208$var$NUMERIC_SEGMENT_PATTERN = /\/\d+(?=\/|$)/g;
const $40a8b1f594239208$export$eb91308c925b64ce = ()=>{
    if (typeof performance !== 'undefined' && typeof performance.now === 'function') return performance.now();
    return Date.now();
};
const $40a8b1f594239208$export$327998895df08b85 = (startedAt)=>Math.max(0, Math.round($40a8b1f594239208$export$eb91308c925b64ce() - startedAt));
const $40a8b1f594239208$export$c805539eac489f93 = (path)=>{
    try {
        const parsed = new URL(path, 'https://conversation-assistant.invalid');
        return parsed.pathname.replace($40a8b1f594239208$var$UUID_SEGMENT_PATTERN, '{id}').replace($40a8b1f594239208$var$NUMERIC_SEGMENT_PATTERN, '/{id}');
    } catch  {
        return '/unparseable';
    }
};
const $40a8b1f594239208$export$d23c16bc33c579b9 = (listener)=>{
    $40a8b1f594239208$var$listeners.add(listener);
    return ()=>{
        $40a8b1f594239208$var$listeners.delete(listener);
    };
};
const $40a8b1f594239208$export$1914d1896389da95 = ()=>$40a8b1f594239208$var$listeners.size > 0;
const $40a8b1f594239208$export$58e155918d09bf5f = (observation)=>{
    for (const listener of Array.from($40a8b1f594239208$var$listeners))try {
        listener(observation);
    } catch  {
    // Observability must never change the request's result or error behavior.
    }
};
const $40a8b1f594239208$export$ef42b2d680ea8d8d = ()=>{
    $40a8b1f594239208$var$listeners.clear();
};
module.exports["requestObservationNow"] = $40a8b1f594239208$export$eb91308c925b64ce;
module.exports["requestObservationDuration"] = $40a8b1f594239208$export$327998895df08b85;
module.exports["normalizeRequestRoute"] = $40a8b1f594239208$export$c805539eac489f93;
module.exports["subscribeToRequestObservations"] = $40a8b1f594239208$export$d23c16bc33c579b9;
module.exports["hasRequestObservationSubscribers"] = $40a8b1f594239208$export$1914d1896389da95;
module.exports["publishRequestObservation"] = $40a8b1f594239208$export$58e155918d09bf5f;

});

parcelRegister("cj7GQ", function(module, exports) {
const $cfb262a7d2b032b8$export$d4fdfa93c283ffc = ()=>{
    let product = 'UNKNOWN';
    const win = window;
    if (win.__ROVO_CHAT_CONFIG_PRODUCT__) product = win.__ROVO_CHAT_CONFIG_PRODUCT__;
    return product;
};
module.exports["getRovoChatProduct"] = $cfb262a7d2b032b8$export$d4fdfa93c283ffc;

});

parcelRegister("8DeC3", function(module, exports) {

var $5rzIE = parcelRequire("5rzIE");


var $10XTN = parcelRequire("10XTN");


var $u3ka6 = parcelRequire("u3ka6");


var $fPSAz = parcelRequire("fPSAz");

const $0e0107334ae89504$var$MAX_LINKED_ERRORS = 5;
const $0e0107334ae89504$var$MAX_MATCHED_UUID_TAG_LENGTH = 200;
const $0e0107334ae89504$var$BLOCKED_LOCATION_PARTS = [
    'localhost',
    'jira-dev.com',
    'stg.atlassian.com',
    'stg.internal.atlassian.com',
    'stg-east.frontend.public.atl-paas.net'
];
const $0e0107334ae89504$var$eventId = ()=>crypto.randomUUID().replace(/-/g, '');
const $0e0107334ae89504$var$matchesIgnorePattern = (value, patterns)=>patterns?.some((pattern)=>typeof pattern === 'string' ? value.includes(pattern) : (()=>{
            pattern.lastIndex = 0;
            const matches = pattern.test(value);
            pattern.lastIndex = 0;
            return matches;
        })()) ?? false;
const $0e0107334ae89504$var$isBlockedLocation = ()=>{
    if (typeof window === 'undefined') return false;
    return $0e0107334ae89504$var$BLOCKED_LOCATION_PARTS.some((part)=>window.location.href.includes(part));
};
const $0e0107334ae89504$var$requestObservationToBreadcrumb = (observation)=>({
        category: observation.kind === 'graphql' ? 'conversation-assistant.request.graphql' : 'conversation-assistant.request.http',
        data: observation,
        level: observation.outcome === 'success' || observation.outcome === 'abort' ? 'info' : 'warning',
        message: observation.kind === 'graphql' ? `${observation.operation} ${observation.outcome}` : `${observation.method} ${observation.route} ${observation.outcome}`,
        type: 'http'
    });
const $0e0107334ae89504$var$toPrivateBreadcrumb = (breadcrumb)=>({
        ...breadcrumb,
        level: breadcrumb.level
    });
const $0e0107334ae89504$var$getCause = (error)=>{
    const cause = error.cause;
    return cause instanceof Error ? cause : undefined;
};
class $0e0107334ae89504$export$7c63502cdfeff038 {
    updateContext({ accountId: accountId, packageVersion: packageVersion, product: product }) {
        this.accountId = accountId;
        if (this.packageVersion === undefined && packageVersion !== undefined) this.packageVersion = packageVersion;
        this.product = product;
    }
    addBreadcrumb(crumb) {
        this.breadcrumbGateway.add(crumb);
    }
    async captureException({ exception: exception, name: name, tags: tags }) {
        if (!this.enabled || (0, $10XTN.isClientFetchError)(exception) || $0e0107334ae89504$var$isBlockedLocation()) return;
        const rootMessage = exception instanceof Error ? exception.message : String(exception);
        if ($0e0107334ae89504$var$matchesIgnorePattern(rootMessage, this.ignoreErrors)) return;
        const id = $0e0107334ae89504$var$eventId();
        const event = await this.sentry.eventFromException(exception, {
            event_id: id
        }, true);
        await this.addLinkedErrors(event, exception);
        const eventTags = {
            experience: tags?.source === 'aiMateExperienceTracker' ? name : undefined,
            name: name,
            packageName: this.packageName,
            packageVersion: this.packageVersion,
            product: this.product,
            sentryOwner: 'conversation-assistant',
            ...tags
        };
        event.tags = {
            ...event.tags,
            ...eventTags
        };
        event.user = {
            id: this.accountId
        };
        event.breadcrumbs = this.breadcrumbGateway.snapshot().map($0e0107334ae89504$var$toPrivateBreadcrumb);
        if (typeof window !== 'undefined') event.request = {
            ...event.request,
            url: (0, $fPSAz.normaliseUrl)(window.location.href)
        };
        this.normalizeEventUUIDs(event);
        // Do not pass `originalException`: BaseClient otherwise consults the SDK-wide
        // already-caught registry shared through Sentry's global carrier.
        this.client.captureEvent(event, {
            event_id: id
        });
    }
    resetForTests() {
        this.unsubscribeFromRequestObservations();
        this.breadcrumbGateway.reset();
    }
    async addLinkedErrors(event, exception) {
        if (!(exception instanceof Error) || !event.exception?.values) return;
        const linkedValues = [];
        let current = $0e0107334ae89504$var$getCause(exception);
        const seen = new Set([
            exception
        ]);
        while(current && linkedValues.length < $0e0107334ae89504$var$MAX_LINKED_ERRORS - 1 && !seen.has(current)){
            seen.add(current);
            const linkedEvent = await this.sentry.eventFromException(current, undefined, true);
            if (linkedEvent.exception?.values?.[0]) linkedValues.unshift(linkedEvent.exception.values[0]);
            current = $0e0107334ae89504$var$getCause(current);
        }
        event.exception.values = [
            ...linkedValues,
            ...event.exception.values
        ];
    }
    normalizeEventUUIDs(event) {
        if (!event.exception?.values) return;
        const matchedUUIDs = new Set();
        event.exception.values = event.exception.values.map((exceptionValue)=>{
            const { normalized: normalized, matchedUUIDs: matches } = (0, $fPSAz.normalizeUUID)(exceptionValue.value);
            matches.forEach((match)=>matchedUUIDs.add(match));
            return {
                ...exceptionValue,
                stacktrace: exceptionValue.stacktrace ? {
                    ...exceptionValue.stacktrace,
                    frames: exceptionValue.stacktrace.frames?.map((frame)=>{
                        const normalizedFrame = {
                            ...frame
                        };
                        [
                            'abs_path',
                            'filename',
                            'function',
                            'module'
                        ].forEach((key)=>{
                            if (typeof normalizedFrame[key] !== 'string') return;
                            const normalizedStackValue = (0, $fPSAz.normalizeUUID)(normalizedFrame[key]);
                            normalizedStackValue.matchedUUIDs.forEach((match)=>matchedUUIDs.add(match));
                            normalizedFrame[key] = normalizedStackValue.normalized;
                        });
                        return normalizedFrame;
                    })
                } : undefined,
                value: normalized
            };
        });
        if (matchedUUIDs.size === 0) return;
        const boundedMatches = [];
        for (const match of matchedUUIDs){
            const candidate = [
                ...boundedMatches,
                match
            ];
            if (JSON.stringify(candidate).length > $0e0107334ae89504$var$MAX_MATCHED_UUID_TAG_LENGTH) break;
            boundedMatches.push(match);
        }
        event.tags = {
            ...event.tags,
            matchedUUID: JSON.stringify(boundedMatches)
        };
    }
    constructor({ accountId: accountId, dsn: dsn, environment: environment, ignoreErrors: ignoreErrors, packageName: packageName, packageVersion: packageVersion, product: product, release: release, sentry: sentry }){
        this.breadcrumbGateway = new (0, $u3ka6.ConversationAssistantBreadcrumbGateway)();
        this.client = void 0;
        this.enabled = void 0;
        this.ignoreErrors = void 0;
        this.sentry = void 0;
        this.accountId = void 0;
        this.packageName = void 0;
        this.packageVersion = void 0;
        this.product = void 0;
        this.unsubscribeFromRequestObservations = void 0;
        this.accountId = accountId;
        this.enabled = environment === 'production';
        this.ignoreErrors = ignoreErrors;
        this.packageName = packageName;
        this.packageVersion = packageVersion;
        this.product = product;
        this.sentry = sentry;
        this.client = new sentry.BrowserClient({
            attachStacktrace: true,
            autoSessionTracking: false,
            dsn: dsn,
            enabled: this.enabled,
            environment: environment,
            integrations: [],
            maxBreadcrumbs: 100,
            release: release,
            sendClientReports: true
        });
        this.unsubscribeFromRequestObservations = (0, $5rzIE.subscribeToRequestObservations)((observation)=>{
            this.breadcrumbGateway.add($0e0107334ae89504$var$requestObservationToBreadcrumb(observation));
        });
    }
}
module.exports["ConversationAssistantPrivateReporter"] = $0e0107334ae89504$export$7c63502cdfeff038;

});

parcelRegister("u3ka6", function(module, exports) {

var $fPSAz = parcelRequire("fPSAz");

const $e73c9a6ea29f4dd8$var$MAX_BREADCRUMBS = 100;
const $e73c9a6ea29f4dd8$var$MAX_MESSAGE_LENGTH = 500;
const $e73c9a6ea29f4dd8$var$MAX_DATA_VALUE_LENGTH = 200;
const $e73c9a6ea29f4dd8$var$COALESCE_WINDOW_MS = 5000;
const $e73c9a6ea29f4dd8$var$ALLOWED_DATA_KEYS = new Set([
    'action',
    'actionSubject',
    'actionSubjectId',
    'durationMs',
    'experience',
    'kind',
    'lifecycle',
    'method',
    'nextState',
    'operation',
    'outcome',
    'previousState',
    'repeatCount',
    'route',
    'screen',
    'state',
    'status',
    'surface',
    'touchpoint'
]);
const $e73c9a6ea29f4dd8$var$truncate = (value, maxLength)=>value.length > maxLength ? `${value.slice(0, maxLength - 1)}\u{2026}` : value;
const $e73c9a6ea29f4dd8$var$sanitizeString = (value, maxLength = $e73c9a6ea29f4dd8$var$MAX_DATA_VALUE_LENGTH)=>{
    const { normalized: normalized } = (0, $fPSAz.normalizeUUID)(value);
    const withoutQuery = normalized.replace(/([a-z][a-z0-9+.-]*:\/\/[^?\s]+)\?[^\s]*/gi, '$1');
    return $e73c9a6ea29f4dd8$var$truncate(withoutQuery, maxLength);
};
const $e73c9a6ea29f4dd8$var$sanitizeData = (data)=>{
    if (!data) return;
    const sanitized = Object.entries(data).reduce((result, [key, value])=>{
        if (!$e73c9a6ea29f4dd8$var$ALLOWED_DATA_KEYS.has(key) || value !== null && typeof value !== 'string' && typeof value !== 'number' && typeof value !== 'boolean') return result;
        if (typeof value === 'string') {
            const sanitizedValue = $e73c9a6ea29f4dd8$var$sanitizeString(value);
            result[key] = sanitizedValue;
        } else if (value !== null) result[key] = value;
        return result;
    }, {});
    return Object.keys(sanitized).length > 0 ? sanitized : undefined;
};
const $e73c9a6ea29f4dd8$var$sanitizeCategory = (category)=>{
    if (!category) return 'conversation-assistant.custom';
    const safeCategory = category.toLowerCase().replace(/[^a-z0-9._-]+/g, '-').slice(0, 80);
    return safeCategory.startsWith('conversation-assistant.') ? safeCategory : `conversation-assistant.${safeCategory}`;
};
const $e73c9a6ea29f4dd8$var$isCoalescable = (breadcrumb)=>breadcrumb.level === 'warning' || breadcrumb.level === 'error' || breadcrumb.category?.includes('store') === true;
class $e73c9a6ea29f4dd8$export$78d89786cb79630b {
    add(crumb) {
        const breadcrumb = this.sanitize(typeof crumb === 'string' ? {
            message: crumb
        } : crumb);
        if (!$e73c9a6ea29f4dd8$var$isCoalescable(breadcrumb)) {
            this.push(breadcrumb);
            return;
        }
        const key = JSON.stringify({
            category: breadcrumb.category,
            data: breadcrumb.data,
            level: breadcrumb.level,
            message: breadcrumb.message,
            type: breadcrumb.type
        });
        const pending = this.pendingCoalescedBreadcrumb;
        if (pending?.key === key) {
            pending.repeatCount += 1;
            return;
        }
        this.flushCoalescedSummary();
        this.push(breadcrumb);
        this.pendingCoalescedBreadcrumb = {
            key: key,
            breadcrumb: breadcrumb,
            repeatCount: 1,
            timer: setTimeout(()=>this.flushCoalescedSummary(), $e73c9a6ea29f4dd8$var$COALESCE_WINDOW_MS)
        };
    }
    snapshot() {
        this.flushCoalescedSummary();
        return this.breadcrumbs.map((breadcrumb)=>({
                ...breadcrumb,
                data: breadcrumb.data ? {
                    ...breadcrumb.data
                } : undefined
            }));
    }
    reset() {
        if (this.pendingCoalescedBreadcrumb) clearTimeout(this.pendingCoalescedBreadcrumb.timer);
        this.pendingCoalescedBreadcrumb = undefined;
        this.breadcrumbs = [];
    }
    sanitize(breadcrumb) {
        const category = $e73c9a6ea29f4dd8$var$sanitizeCategory(breadcrumb.category);
        const data = $e73c9a6ea29f4dd8$var$sanitizeData(breadcrumb.data);
        const message = typeof breadcrumb.message === 'string' ? $e73c9a6ea29f4dd8$var$sanitizeString(breadcrumb.message, $e73c9a6ea29f4dd8$var$MAX_MESSAGE_LENGTH) : undefined;
        return {
            category: category,
            data: data,
            level: breadcrumb.level,
            message: message,
            timestamp: breadcrumb.timestamp ?? Date.now() / 1000,
            type: breadcrumb.type
        };
    }
    flushCoalescedSummary() {
        const pending = this.pendingCoalescedBreadcrumb;
        if (!pending) return;
        clearTimeout(pending.timer);
        this.pendingCoalescedBreadcrumb = undefined;
        if (pending.repeatCount <= 1) return;
        this.push({
            ...pending.breadcrumb,
            data: {
                ...pending.breadcrumb.data,
                repeatCount: pending.repeatCount
            },
            message: pending.breadcrumb.message ? `${pending.breadcrumb.message} (repeated ${pending.repeatCount} times)` : `Breadcrumb repeated ${pending.repeatCount} times`,
            timestamp: Date.now() / 1000
        });
    }
    push(breadcrumb) {
        this.breadcrumbs.push(breadcrumb);
        if (this.breadcrumbs.length > $e73c9a6ea29f4dd8$var$MAX_BREADCRUMBS) this.breadcrumbs.splice(0, this.breadcrumbs.length - $e73c9a6ea29f4dd8$var$MAX_BREADCRUMBS);
    }
    constructor(){
        this.breadcrumbs = [];
        this.pendingCoalescedBreadcrumb = void 0;
    }
}
module.exports["ConversationAssistantBreadcrumbGateway"] = $e73c9a6ea29f4dd8$export$78d89786cb79630b;

});

parcelRegister("fPSAz", function(module, exports) {
const $155164db85c7fae0$var$pathnamePrefixes = [
    '/jira/',
    '/wiki/',
    '/browse/'
];
const $155164db85c7fae0$var$ATLAS_HOST = 'home.atlassian.com';
const $155164db85c7fae0$var$ATLAS_TEAM_HOST = 'team.atlassian.com';
const $155164db85c7fae0$var$UUID_REGEX = /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/gi;
const $155164db85c7fae0$export$d57ae76c6dc57a5 = (url)=>{
    try {
        let parsedUrl = new URL(url);
        let normalizedPath = '/any/';
        if (parsedUrl.host === $155164db85c7fae0$var$ATLAS_HOST || parsedUrl.host === $155164db85c7fae0$var$ATLAS_TEAM_HOST) // Replace org ID with "orgId" in the path
        normalizedPath = parsedUrl.pathname.replace(/\/o\/[^/]+/, '/o/orgId');
        const prefixRegex = new RegExp(`^(${$155164db85c7fae0$var$pathnamePrefixes.join('|')})`);
        if (prefixRegex.test(parsedUrl.pathname)) normalizedPath = parsedUrl.pathname.match(prefixRegex)[0];
        const normalizedUrl = `${parsedUrl.protocol}//${parsedUrl.host}${normalizedPath}`;
        return normalizedUrl;
    } catch (error) {
        return 'https://could-not-parse.example.com';
    }
};
const $155164db85c7fae0$export$5efaf8444170fe75 = (str)=>{
    if (!str) return {
        normalized: '',
        matchedUUIDs: []
    };
    const matchedUUIDs = str.match($155164db85c7fae0$var$UUID_REGEX) || [];
    const normalized = str.replace($155164db85c7fae0$var$UUID_REGEX, '{uuid}');
    return {
        normalized: normalized,
        matchedUUIDs: matchedUUIDs
    };
};
module.exports["normaliseUrl"] = $155164db85c7fae0$export$d57ae76c6dc57a5;
module.exports["normalizeUUID"] = $155164db85c7fae0$export$5efaf8444170fe75;

});

parcelRegister("55apF", function(module, exports) {

let $3b357f295bbe6b1c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $3b357f295bbe6b1c$var$load("kT6dz"),
    $3b357f295bbe6b1c$var$load("aAWLw")
]).then(()=>parcelRequire('eieXD'));

});

parcelRegister("Ou0Zz", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $7TCQz = parcelRequire("7TCQz");


var $9DHhW = parcelRequire("9DHhW");


var $iDrrr = parcelRequire("iDrrr");


var $cFVPs = parcelRequire("cFVPs");


var $hlvTd = parcelRequire("hlvTd");


var $89QZA = parcelRequire("89QZA");


var $eMlr8 = parcelRequire("eMlr8");


var $1jIs1 = parcelRequire("1jIs1");


var $nl5f2 = parcelRequire("nl5f2");

const $0fbd029e2a18e798$var$isTownSquareEvent = ()=>[
        'home.atlassian.com',
        'team.atlassian.com'
    ].some((host)=>window.location?.host?.includes(host));
const $0fbd029e2a18e798$var$DEFAULT_TAGS = [
    'atlaskit',
    'aiMate'
];
const $0fbd029e2a18e798$export$f30c856a07c48ee5 = ({ action: action, actionSubject: actionSubject, type: type })=>// message sent (client) — sendAnalyticsEvent only, no trackAIMAUEvent equivalent.
    action === 'sent' && actionSubject === 'message' || // aiMateActions displayed (client) — sendAnalyticsEvent only, no trackAIMAUEvent equivalent.
    action === 'displayed' && actionSubject === 'aiMateActions' || // aiInteraction initiated — via sendAnalyticsEvent or trackAIMAUEvent({ type: 'initiated' }).
    action === 'initiated' && actionSubject === 'aiInteraction' || type === 'initiated' || // aiResult viewed — via sendAnalyticsEvent or trackAIMAUEvent({ type: 'viewed' }).
    action === 'viewed' && actionSubject === 'aiResult' || type === 'viewed' || // aiResult actioned (client) — via sendAnalyticsEvent or trackAIMAUEvent({ type: 'actioned' }).
    action === 'actioned' && actionSubject === 'aiResult' || type === 'actioned';
const $0fbd029e2a18e798$var$getRovoJourneyEventAttributes = ({ eventPayload: eventPayload, attributes: attributes, contextRovoJourneyId: contextRovoJourneyId })=>{
    const { [(0, $eMlr8.AI_MATE_ATTRIBUTES).rovoJourneyId]: suppliedRovoJourneyId, ...attributesWithoutRovoJourneyId } = attributes;
    const rovoJourneyId = suppliedRovoJourneyId ?? contextRovoJourneyId;
    return {
        ...attributesWithoutRovoJourneyId,
        ...$0fbd029e2a18e798$export$f30c856a07c48ee5(eventPayload) && rovoJourneyId ? {
            [(0, $eMlr8.AI_MATE_ATTRIBUTES).rovoJourneyId]: rovoJourneyId
        } : {}
    };
};
const $0fbd029e2a18e798$var$SENTRY_ANALYTICS_ATTRIBUTE_KEYS = [
    'experience',
    'nextState',
    'outcome',
    'previousState',
    'screen',
    'state',
    'surface',
    'touchpoint'
];
const $0fbd029e2a18e798$var$getSentryAnalyticsBreadcrumb = (event)=>{
    const payload = event.payload;
    const attributes = payload?.attributes ?? {};
    const safeAttributes = $0fbd029e2a18e798$var$SENTRY_ANALYTICS_ATTRIBUTE_KEYS.reduce((result, key)=>{
        const value = attributes[key];
        if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') result[key] = value;
        return result;
    }, {});
    return {
        category: 'analytics',
        data: {
            action: payload?.action,
            actionSubject: payload?.actionSubject,
            actionSubjectId: payload?.actionSubjectId,
            ...safeAttributes
        },
        message: [
            payload?.action,
            payload?.actionSubject,
            payload?.actionSubjectId
        ].filter(Boolean).join(' ')
    };
};
const $0fbd029e2a18e798$export$e955abb82869dc84 = (options)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { propertiesRef: propertiesRef, mode: mode } = (0, $89QZA.useAnalyticsPropertiesContext)();
    // TODO: Improve this functionality, potentially with a higher order provider for tags or similar
    // This is a temporary solution to add the 'townsquare' tag to operational events so Experience Tracker works in Atlas
    const maybeAtlasOperationalTags = (0, $cozmU.useCallback)((inputPayload)=>{
        const payload = (0, $7TCQz.isUIAnalyticsEvent)(inputPayload) ? inputPayload.payload : inputPayload;
        if (payload.actionSubject === 'ui' && payload.eventType === 'operational' && $0fbd029e2a18e798$var$isTownSquareEvent()) return [
            'townsquare'
        ];
        return [];
    }, []);
    const tagsForAIAnalytics = [
        ...$0fbd029e2a18e798$var$DEFAULT_TAGS
    ];
    if ($0fbd029e2a18e798$var$isTownSquareEvent()) tagsForAIAnalytics.push('townsquare');
    const { trackAIInteractionInit: trackAIInteractionInit, trackAIResultView: trackAIResultView, trackAIResultError: trackAIResultError, trackAIInteractionDismiss: trackAIInteractionDismiss, trackAIResultAction: trackAIResultAction, trackAIResultAdopted: trackAIResultAdopted, trackAIFeedbackSubmit: trackAIFeedbackSubmit } = (0, $cFVPs.useAIEventsInstrumentation)({
        // Required configruation
        product: propertiesRef.current.product,
        subproduct: propertiesRef.current.product,
        aiFeatureName: 'aiChat',
        proactiveGeneratedAI: 0,
        userGeneratedAI: 1,
        enablePlatformEvents: true,
        tags: tagsForAIAnalytics,
        skipAISessionValidation: options?.skipAISessionValidation,
        customAnalyticsFire: (rawEvent, _createdEvent)=>{
            // Build event and apply context attributes
            const event = createAnalyticsEvent(rawEvent);
            if (!event) // In SSR / no-listener environments, `createAnalyticsEvent` can return `undefined`.
            // Nothing to fire.
            return;
            const aiMateContextAttributes = (0, $nl5f2.getAttributesFromContexts)(event.context);
            // Fire. `event.update(...)` returns `undefined` for stub events (no `<AnalyticsListener>`
            // mounted, e.g. during SSR), so fall back to the original event and guard `.fire` with
            // optional chaining.
            const updatedEvent = event.update({
                attributes: $0fbd029e2a18e798$var$getRovoJourneyEventAttributes({
                    eventPayload: event.payload ?? rawEvent,
                    attributes: {
                        ...event.payload?.attributes ?? {},
                        ...aiMateContextAttributes
                    },
                    contextRovoJourneyId: propertiesRef.current.rovoJourneyId
                })
            }) ?? event;
            updatedEvent?.fire?.((0, $1jIs1.ANALYTICS_CHANNEL));
        }
    });
    const getDefaultAttributes = (0, $cozmU.useCallback)(()=>{
        const { agentCreatorType: agentCreatorType, agentId: agentId, agentVisibility: agentVisibility, agentExternalConfigReference: agentExternalConfigReference, agentActions: agentActions, agentIsDefault: agentIsDefault, agentIsVerified: agentIsVerified, conversationChannelId: conversationChannelId, chatEntryPoint: chatEntryPoint, experienceId: experienceId, fullScreen: fullScreen, product: product, productHeader: productHeader, inProductExperience: inProductExperience, mode: mode_0, assistanceServiceConfigMinionAlias: assistanceServiceConfigMinionAlias, spaceId: spaceId, isThirdPartyPromptConversation: isThirdPartyPromptConversation, thirdPartyPromptCohort: thirdPartyPromptCohort, thirdPartyConnectCount: thirdPartyConnectCount } = propertiesRef.current;
        return {
            [(0, $eMlr8.AI_MATE_ATTRIBUTES).agentCreatorType]: agentCreatorType,
            [(0, $eMlr8.AI_MATE_ATTRIBUTES).agentId]: agentId,
            [(0, $eMlr8.AI_MATE_ATTRIBUTES).agentVisibility]: agentVisibility,
            [(0, $eMlr8.AI_MATE_ATTRIBUTES).conversationChannelId]: conversationChannelId,
            [(0, $eMlr8.AI_MATE_ATTRIBUTES).chatEntryPoint]: chatEntryPoint,
            [(0, $eMlr8.AI_MATE_ATTRIBUTES).experienceId]: experienceId,
            [(0, $eMlr8.AI_MATE_ATTRIBUTES).fullScreen]: fullScreen,
            [(0, $eMlr8.AI_MATE_ATTRIBUTES).product]: product,
            [(0, $eMlr8.AI_MATE_ATTRIBUTES).productHeader]: productHeader,
            [(0, $eMlr8.AI_MATE_ATTRIBUTES).inProductExperience]: inProductExperience,
            [(0, $eMlr8.AI_MATE_ATTRIBUTES).singleInstrumentationID]: conversationChannelId,
            [(0, $eMlr8.AI_MATE_ATTRIBUTES).agentExternalConfigReference]: agentExternalConfigReference,
            [(0, $eMlr8.AI_MATE_ATTRIBUTES).agentActions]: agentActions,
            [(0, $eMlr8.AI_MATE_ATTRIBUTES).agentIsDefault]: agentIsDefault,
            [(0, $eMlr8.AI_MATE_ATTRIBUTES).agentIsVerified]: agentIsVerified,
            [(0, $eMlr8.AI_MATE_ATTRIBUTES).mode]: mode_0,
            [(0, $eMlr8.AI_MATE_ATTRIBUTES).assistanceServiceConfigMinionAlias]: assistanceServiceConfigMinionAlias,
            [(0, $eMlr8.AI_MATE_ATTRIBUTES).spaceId]: spaceId,
            // Gated on TRUE, not merely defined: the modal stamps `false` on every submit to clear
            // a previous 3P conversation, so a defined-check would let every later conversation
            // carry these keys with two `undefined`s.
            ...isThirdPartyPromptConversation ? {
                [(0, $eMlr8.AI_MATE_ATTRIBUTES).isThirdPartyPromptConversation]: isThirdPartyPromptConversation,
                [(0, $eMlr8.AI_MATE_ATTRIBUTES).thirdPartyPromptCohort]: thirdPartyPromptCohort,
                [(0, $eMlr8.AI_MATE_ATTRIBUTES).thirdPartyConnectCount]: thirdPartyConnectCount
            } : {}
        };
    }, [
        propertiesRef
    ]);
    const trackAIMAUEvent = (0, $cozmU.useCallback)((payload_0)=>{
        // Handle tags
        const tags = [
            ...$0fbd029e2a18e798$var$DEFAULT_TAGS
        ];
        if ($0fbd029e2a18e798$var$isTownSquareEvent()) tags.push('townsquare');
        const { source: sourceUnknown, subjectId: subjectIdUnknown, proactive: proactive, userGenerated: userGenerated, doesNotMeetMAUCriteria: doesNotMeetMAUCriteria, messageId: messageId, messageActions: messageActions, singleInstrumentationID: singleInstrumentationID, deepResearchEnabled: deepResearchEnabled, webSearchEnabled: webSearchEnabled, thinkDeeperEnabled: thinkDeeperEnabled, fastModeEnabled: fastModeEnabled, timestamp: timestamp, citedProductList: citedProductList, citedProduct: citedProduct, connectorInfo: connectorInfo, sourceProducts: sourceProducts, sourceProduct: sourceProduct, pluginsInvoked: pluginsInvoked, tools: tools, skillsInvoked: skillsInvoked, executedStratusSkill: executedStratusSkill, responseSources: responseSources, usesJsm: usesJsm, invokedFrom: invokedFrom, conversationChannelId: conversationChannelId_0, assistanceServiceConfigMinionAlias: assistanceServiceConfigMinionAlias_0, scenarioId: scenarioId, pageContext: pageContext, viewContext: viewContext, attributes: customAttributes } = payload_0;
        // source and subjectId are optional in the payload type but trackAI* functions require string.
        // The runtime value (including undefined) is intentionally passed through as-is.
        // eslint-disable-next-line @atlaskit/platform/no-double-type-assertions -- Existing analytics baseline: preserves the runtime value while satisfying a string-only downstream API type.
        const source = sourceUnknown;
        // eslint-disable-next-line @atlaskit/platform/no-double-type-assertions -- Existing analytics baseline: preserves the runtime value while satisfying a string-only downstream API type.
        const subjectId = subjectIdUnknown;
        const customAttributesRecord = customAttributes ?? {};
        const actionKey = payload_0.actionKey || customAttributesRecord.actionKey;
        const { [(0, $eMlr8.AI_MATE_ATTRIBUTES).rovoJourneyId]: customRovoJourneyId, ...customAttributesWithoutRovoJourneyId } = customAttributesRecord;
        const contextRovoJourneyId = propertiesRef.current.rovoJourneyId;
        let attributes = {
            ...getDefaultAttributes(),
            isAIFeature: 1,
            proactiveAIGenerated: proactive ? 1 : 0,
            userGeneratedAI: userGenerated ? 1 : 0,
            citedProductList: citedProductList,
            citedProduct: citedProduct,
            sourceProducts: sourceProducts,
            sourceProduct: sourceProduct,
            ...customAttributesWithoutRovoJourneyId,
            ...$0fbd029e2a18e798$export$f30c856a07c48ee5(payload_0) && (customRovoJourneyId || contextRovoJourneyId) ? {
                [(0, $eMlr8.AI_MATE_ATTRIBUTES).rovoJourneyId]: customRovoJourneyId ?? contextRovoJourneyId
            } : {},
            aiFeatureName: customAttributesRecord.aiFeatureName || 'aiChat'
        };
        if (messageId) attributes.messageId = messageId;
        if (messageActions) attributes.messageActions = messageActions;
        else if ((payload_0.type === 'actioned' || payload_0.type === 'viewed' || payload_0.type === 'adopted') && typeof actionKey === 'string' && actionKey.length > 0 && (0, $iDrrr.fg)('cwr_ai_result_analytics_updates')) attributes.messageActions = [
            actionKey
        ];
        if (invokedFrom) attributes.invokedFrom = invokedFrom;
        if (timestamp) attributes.timestamp = timestamp;
        if (singleInstrumentationID) attributes.singleInstrumentationID = singleInstrumentationID;
        if (pluginsInvoked) attributes.pluginsInvoked = pluginsInvoked;
        if (tools) attributes.tools = tools;
        if (skillsInvoked) attributes.skillsInvoked = skillsInvoked;
        if (executedStratusSkill !== undefined) attributes.executedStratusSkill = executedStratusSkill;
        if (responseSources) attributes.responseSources = responseSources;
        if (connectorInfo && (payload_0.type === 'actioned' ? (0, $iDrrr.fg)('rovo_chat_connector_info_analytics_on_click') : (0, $iDrrr.fg)('rovo_chat_connector_info_analytics'))) attributes.connectorInfo = connectorInfo;
        if (usesJsm !== undefined) attributes.usesJsm = usesJsm;
        if (deepResearchEnabled) attributes.deepResearchEnabled = deepResearchEnabled;
        if (fastModeEnabled) attributes.fastModeEnabled = fastModeEnabled;
        if (thinkDeeperEnabled) attributes.thinkDeeperEnabled = thinkDeeperEnabled;
        if (webSearchEnabled) attributes.webSearchEnabled = webSearchEnabled;
        if (conversationChannelId_0) attributes.conversationChannelId = conversationChannelId_0;
        if (assistanceServiceConfigMinionAlias_0) attributes.assistanceServiceConfigMinionAlias = assistanceServiceConfigMinionAlias_0;
        if (pageContext) attributes.pageContext = pageContext;
        if (scenarioId) attributes.scenarioId = scenarioId;
        if (viewContext) attributes.viewContext = viewContext;
        let libAttributes = {
            ...attributes,
            aiFeatureName: customAttributesRecord.aiFeatureName || 'aiChat',
            proactiveGeneratedAI: proactive ? 1 : 0
        };
        const launchSource = propertiesRef.current.launchSource;
        const launchSourceAttribute = launchSource ? {
            [(0, $eMlr8.AI_MATE_ATTRIBUTES).launchSource]: launchSource
        } : {};
        switch(payload_0.type){
            case 'initiated':
                trackAIInteractionInit({
                    attributes: libAttributes,
                    tags: tags,
                    source: source,
                    actionSubjectId: subjectId
                });
                break;
            case 'viewed':
                trackAIResultView({
                    attributes: libAttributes,
                    tags: tags,
                    source: source,
                    actionSubjectId: subjectId,
                    doesNotMeetMAUCriteria: doesNotMeetMAUCriteria
                });
                break;
            case 'error':
                trackAIResultError({
                    aiErrorMessage: payload_0.errorMessage
                }, {
                    attributes: libAttributes,
                    tags: tags,
                    source: source,
                    actionSubjectId: subjectId
                });
                break;
            case 'dismissed':
                trackAIInteractionDismiss({
                    attributes: libAttributes,
                    tags: tags,
                    source: source,
                    actionSubjectId: subjectId
                });
                break;
            case 'actioned':
                {
                    const actionedPayload = payload_0;
                    trackAIResultAction(actionedPayload.actionResult, {
                        attributes: {
                            ...libAttributes,
                            ...launchSourceAttribute
                        },
                        tags: tags,
                        source: source,
                        actionSubjectId: subjectId
                    });
                    break;
                }
            case 'adopted':
                {
                    const adoptedPayload = payload_0;
                    trackAIResultAdopted(adoptedPayload.actionResult, {
                        attributes: {
                            ...libAttributes,
                            actionKey: adoptedPayload.actionKey,
                            rovoModifiedObjects: adoptedPayload.rovoModifiedObjects,
                            ...launchSourceAttribute
                        },
                        tags: tags,
                        source: source,
                        actionSubjectId: subjectId
                    });
                    break;
                }
            case 'feedback':
                {
                    const feedbackPayload = payload_0;
                    trackAIFeedbackSubmit(feedbackPayload.feedbackResult, {
                        attributes: libAttributes,
                        tags: tags,
                        source: source,
                        actionSubjectId: subjectId
                    });
                    break;
                }
        }
    // Handle specific AI MAU events
    }, [
        getDefaultAttributes,
        propertiesRef,
        trackAIInteractionInit,
        trackAIResultView,
        trackAIResultError,
        trackAIInteractionDismiss,
        trackAIResultAction,
        trackAIResultAdopted,
        trackAIFeedbackSubmit
    ]);
    const sendAnalyticsEvent = (0, $cozmU.useCallback)((payload_1, options_0)=>{
        const extraTags = options_0?.removeDefaultTags ? [] : $0fbd029e2a18e798$var$DEFAULT_TAGS;
        const allTags = Array.from(new Set([
            ...extraTags,
            ...'tags' in payload_1 && Array.isArray(payload_1.tags) ? payload_1.tags : [],
            ...maybeAtlasOperationalTags(payload_1)
        ]));
        const defaultAttributes = getDefaultAttributes();
        // `UIAnalyticsEvent | undefined` because in SSR (no `<AnalyticsListener>`),
        // `createAnalyticsEvent` and `event.update(...)` may return `undefined` stubs.
        let eventToBeLoggedWithSentry;
        if ((0, $7TCQz.isUIAnalyticsEvent)(payload_1)) {
            const aiMateContextAttributes_0 = (0, $nl5f2.getAttributesFromContexts)(payload_1.context);
            // `payload.update(...)` can return `undefined` for stub events in SSR / no-listener
            // contexts. Fall back to the original event and guard `.fire` with optional chaining.
            const updatedEvent_0 = payload_1.update({
                ...payload_1.payload,
                tags: allTags,
                attributes: $0fbd029e2a18e798$var$getRovoJourneyEventAttributes({
                    eventPayload: payload_1.payload ?? {},
                    attributes: {
                        ...defaultAttributes,
                        // `payload.payload` is typed as defined on a UIAnalyticsEvent, but during SSR
                        // (and other no-listener contexts) the underlying event can be a stub whose
                        // `payload` is `undefined`. Guard the spread so the subscriber does not throw
                        // `Cannot read properties of undefined (reading 'attributes')`.
                        ...payload_1.payload?.attributes ?? {},
                        ...aiMateContextAttributes_0
                    },
                    contextRovoJourneyId: propertiesRef.current.rovoJourneyId
                })
            }) ?? payload_1;
            updatedEvent_0?.fire?.((0, $1jIs1.ANALYTICS_CHANNEL));
            eventToBeLoggedWithSentry = updatedEvent_0;
        } else {
            const event_0 = createAnalyticsEvent({
                ...payload_1,
                tags: allTags,
                attributes: $0fbd029e2a18e798$var$getRovoJourneyEventAttributes({
                    eventPayload: payload_1,
                    attributes: {
                        ...defaultAttributes,
                        ...payload_1.attributes
                    },
                    contextRovoJourneyId: propertiesRef.current.rovoJourneyId
                })
            });
            if (!event_0) // In SSR / no-listener environments, `createAnalyticsEvent` can return `undefined`.
            // Nothing to fire or log.
            return;
            const aiMateContextAttributes_1 = (0, $nl5f2.getAttributesFromContexts)(event_0.context);
            // `event.update(...)` can return `undefined` for stub events in SSR / no-listener
            // contexts (previously crashed with `Cannot read properties of undefined (reading
            // 'fire')`). Fall back to the original event and guard `.fire` with optional chaining.
            const updatedEvent_1 = event_0.update({
                attributes: $0fbd029e2a18e798$var$getRovoJourneyEventAttributes({
                    eventPayload: event_0.payload ?? payload_1,
                    attributes: {
                        // `event.payload` is normally defined when `createAnalyticsEvent` is wired up
                        // via `<AnalyticsListener>`, but in SSR (where no listener is mounted) the
                        // returned event can be a stub whose `payload` is `undefined`. Spreading
                        // without a guard previously crashed the ExperienceTracker subscriber with
                        // `Cannot read properties of undefined (reading 'attributes')`.
                        ...event_0.payload?.attributes ?? {},
                        ...aiMateContextAttributes_1
                    },
                    contextRovoJourneyId: propertiesRef.current.rovoJourneyId
                })
            }) ?? event_0;
            updatedEvent_1?.fire?.((0, $1jIs1.ANALYTICS_CHANNEL));
            eventToBeLoggedWithSentry = updatedEvent_1;
        }
        if (eventToBeLoggedWithSentry && eventToBeLoggedWithSentry.payload?.eventType !== 'operational') // choosing to log the event with Sentry if it is not an operational event to prevent noise in Sentry and not eat up the Sentry quota
        (0, $hlvTd.addSentryBreadcrumb)($0fbd029e2a18e798$var$getSentryAnalyticsBreadcrumb(eventToBeLoggedWithSentry));
    }, [
        createAnalyticsEvent,
        maybeAtlasOperationalTags,
        getDefaultAttributes,
        propertiesRef
    ]);
    return {
        sendAnalyticsEvent: sendAnalyticsEvent,
        trackAIMAUEvent: trackAIMAUEvent,
        mode: mode
    };
};
module.exports["isRovoJourneyAllowlistedEvent"] = $0fbd029e2a18e798$export$f30c856a07c48ee5;
module.exports["useAnalytics"] = $0fbd029e2a18e798$export$e955abb82869dc84;

});

parcelRegister("7TCQz", function(module, exports) {
/// <reference types="node" />

var $dgpXm = parcelRequire("dgpXm");

const $6cd011fc484d182c$export$35f8383928ba8d7 = (obj)=>obj instanceof (0, $dgpXm.default) || !!obj?._isUIAnalyticsEvent || // Backwards compatibility with older analytics-next packages
    obj?.constructor?.name === 'UIAnalyticsEvent';
module.exports["isUIAnalyticsEvent"] = $6cd011fc484d182c$export$35f8383928ba8d7;

});

parcelRegister("cFVPs", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $3U8XR = parcelRequire("3U8XR");


var $iTJtk = parcelRequire("iTJtk");


var $9DHhW = parcelRequire("9DHhW");


var $jU6s6 = parcelRequire("jU6s6");


var $4dW9D = parcelRequire("4dW9D");


var $96Ikf = parcelRequire("96Ikf");


var $iCEWf = parcelRequire("iCEWf");


var $jLdbZ = parcelRequire("jLdbZ");

const $a12da25560425c44$export$ddf49ad062368ad2 = (customConfig)=>{
    let context = (0, $cozmU.useContext)((0, $jU6s6.AIEventsInstrumentationContext));
    const aiEventAttributesOverride = (0, $cozmU.useRef)({});
    if (customConfig) context = {
        config: {
            ...(0, $4dW9D.defaultAIEventsInstrumentationConfigValues),
            ...customConfig
        },
        // eslint-disable-next-line react-hooks/rules-of-hooks
        ...(0, $jLdbZ.useAIInstrumentationSetup)(customConfig.singleInstrumentationID, customConfig.cookieSingleInstrumentationConfig)
    };
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    if (context === null) throw new Error('useAIEventsInstrumentation must be used within a AIEventsInstrumentationProvider');
    const { config: { source: source, aiExperienceName: aiExperienceName, aiFeatureName: aiFeatureName, aiFeatureId: aiFeatureId, proactiveGeneratedAI: proactiveGeneratedAI, userGeneratedAI: userGeneratedAI, isAIFeature: isAIFeature, channel: channel, subproduct: subproduct, actionSubjectId: actionSubjectId, tags: tags, product: product, eventDispatcherSource: eventDispatcherSource, skipAISessionValidation: skipAISessionValidation, customAnalyticsFire: customAnalyticsFire, additionalAttributes: additionalAttributes, useDefaultGASv3EventSchema: useDefaultGASv3EventSchema, enablePlatformEvents: enablePlatformEvents }, refreshSingleInstrumentationID: refreshSingleInstrumentationID, getSingleInstrumentationID: getSingleInstrumentationID, setAISessionState: setAISessionState, getAISessionState: getAISessionState } = context;
    const validateAndUpdateAISession = (0, $cozmU.useCallback)((nextState)=>{
        const currentAISessionState = getAISessionState();
        return (0, $3U8XR.match)({
            currentState: currentAISessionState,
            nextState: nextState,
            skipAISessionValidation: skipAISessionValidation
        }).with({
            skipAISessionValidation: true
        }, ()=>true).with({
            currentState: (0, $iCEWf.AISessionState).unset,
            nextState: (0, $3U8XR.P).union((0, $iCEWf.AISessionState).viewed, (0, $iCEWf.AISessionState).error, (0, $iCEWf.AISessionState).dismissed)
        }, ()=>{
            // eslint-disable-next-line no-console
            console.error(`[@atlassian/ai-analytics]: ${nextState} event should be called only after trackAIInteractionInit()`);
            return false;
        }).with({
            currentState: (0, $iCEWf.AISessionState).initiated,
            nextState: (0, $3U8XR.P).union((0, $iCEWf.AISessionState).submitted, (0, $iCEWf.AISessionState).actioned, (0, $iCEWf.AISessionState).adopted, (0, $iCEWf.AISessionState).discarded)
        }, ()=>{
            // eslint-disable-next-line no-console
            console.error(`[@atlassian/ai-analytics]: ${nextState} event should be called only after trackAIResultView()`);
            return false;
        }).otherwise(()=>{
            setAISessionState(nextState);
            return true;
        });
    }, [
        setAISessionState,
        getAISessionState,
        skipAISessionValidation
    ]);
    const fireEventWithOptionalChannel = (0, $cozmU.useCallback)((event)=>{
        if (typeof customAnalyticsFire === 'function') {
            customAnalyticsFire(event, createAnalyticsEvent({}));
            return;
        }
        if (enablePlatformEvents) {
            // it goes thru the aiMate analytics listener to avoid validation per prodcut listener
            // https://bitbucket.org/atlassian/atlassian-frontend-mirror/src/f904f690cf57ef84acad6c7bf1b5bd90ad9cada2/analytics/analytics-listeners/src/atlaskit/process-event.ts#lines-58
            createAnalyticsEvent(event).fire((0, $iTJtk.FabricChannel).aiMate);
            return;
        }
        if (channel) {
            createAnalyticsEvent(event).fire(channel);
            return;
        }
        createAnalyticsEvent(event).fire();
    }, [
        channel,
        customAnalyticsFire,
        createAnalyticsEvent,
        enablePlatformEvents
    ]);
    const createAndMergeEventPayload = (0, $cozmU.useCallback)((payload, partialPayload)=>{
        const singleInstrumentationID = getSingleInstrumentationID();
        const eventPayload = {
            action: payload.action,
            actionSubject: payload.actionSubject,
            actionSubjectId: partialPayload?.actionSubjectId ?? actionSubjectId,
            attributes: {
                aiExperienceName: aiExperienceName,
                aiFeatureName: aiFeatureName,
                aiFeatureId: aiFeatureId,
                proactiveGeneratedAI: proactiveGeneratedAI,
                userGeneratedAI: userGeneratedAI,
                isAIFeature: isAIFeature,
                eventDispatcherSource: eventDispatcherSource,
                singleInstrumentationID: singleInstrumentationID,
                ...payload.attributes,
                ...partialPayload?.attributes,
                ...additionalAttributes,
                ...aiEventAttributesOverride.current
            }
        };
        return (0, $3U8XR.match)({
            product: product,
            channel: channel,
            useDefaultGASv3EventSchema: useDefaultGASv3EventSchema,
            enablePlatformEvents: enablePlatformEvents
        }).with({
            enablePlatformEvents: true
        }, ()=>{
            return {
                eventType: 'track',
                ...eventPayload,
                tags: (0, $96Ikf.getTagsWithPlatformTag)(tags),
                source: partialPayload?.source ?? source,
                subproduct: subproduct,
                product: product
            };
        }).with({
            product: 'confluence',
            channel: (0, $3U8XR.P).nullish,
            useDefaultGASv3EventSchema: false
        }, ()=>{
            // confluence event validation fronted logic
            // https://bitbucket.org/atlassian/atlassian-frontend-monorepo/src/f8bf8ba8c7b54c6e2764d85551b3f989b69d28d8/confluence/next/packages/analytics/src/analyticsListener.tsx#lines-53
            return {
                type: 'sendTrackEvent',
                data: {
                    ...eventPayload,
                    tags: partialPayload?.tags ?? tags,
                    source: partialPayload?.source ?? source,
                    subproduct: subproduct
                }
            };
        }).with({
            product: 'jira',
            channel: (0, $3U8XR.P).nullish,
            useDefaultGASv3EventSchema: false
        }, ()=>{
            // jira event validation fronted logic
            // https://bitbucket.org/atlassian/atlassian-frontend-monorepo/src/f8bf8ba8c7b54c6e2764d85551b3f989b69d28d8/jira/src/packages/platform/observability/product-analytics-bridge/src/utils/extract-data-from-event.tsx#lines-164
            // it requires to use no more than 4 properties on the top level of event shape for custom event fire.
            return eventPayload;
        }).otherwise(()=>{
            // for any other product type we should use the default event shape
            // also if there is a custom event channel, we also should use the default event shape
            return {
                eventType: 'track',
                ...eventPayload,
                tags: partialPayload?.tags ?? tags,
                source: partialPayload?.source ?? source,
                subproduct: subproduct,
                product: product
            };
        });
    }, [
        subproduct,
        channel,
        product,
        getSingleInstrumentationID,
        useDefaultGASv3EventSchema,
        source,
        tags,
        eventDispatcherSource,
        actionSubjectId,
        additionalAttributes,
        enablePlatformEvents,
        aiExperienceName,
        aiFeatureName,
        aiFeatureId,
        proactiveGeneratedAI,
        userGeneratedAI,
        isAIFeature
    ]);
    const trackAIInteractionInit = (0, $cozmU.useCallback)((payload)=>{
        if (!validateAndUpdateAISession((0, $iCEWf.AISessionState).initiated)) return;
        refreshSingleInstrumentationID(payload?.attributes?.singleInstrumentationID);
        const event = createAndMergeEventPayload({
            action: 'initiated',
            actionSubject: 'aiInteraction'
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        refreshSingleInstrumentationID,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel,
        validateAndUpdateAISession
    ]);
    const trackAIResultView = (0, $cozmU.useCallback)((payload)=>{
        if (!validateAndUpdateAISession((0, $iCEWf.AISessionState).viewed)) return;
        const { doesNotMeetMAUCriteria: doesNotMeetMAUCriteria, attributes: attributes, ...payloadRest } = payload || {};
        const event = createAndMergeEventPayload({
            action: 'viewed',
            actionSubject: 'aiResult'
        }, {
            ...payloadRest,
            attributes: {
                ...attributes,
                doesNotMeetMAUCriteria: !!doesNotMeetMAUCriteria
            }
        });
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const trackAIResultError = (0, $cozmU.useCallback)((error, payload)=>{
        if (!validateAndUpdateAISession((0, $iCEWf.AISessionState).error)) return;
        const event = createAndMergeEventPayload({
            action: 'error',
            actionSubject: 'aiResult',
            attributes: {
                ...error
            }
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const trackAIInteractionDismiss = (0, $cozmU.useCallback)((payload)=>{
        if (!validateAndUpdateAISession((0, $iCEWf.AISessionState).dismissed)) return;
        const event = createAndMergeEventPayload({
            action: 'dismissed',
            actionSubject: 'aiInteraction'
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const trackAIResultAction = (0, $cozmU.useCallback)((aiResultAction, payload)=>{
        if (!validateAndUpdateAISession((0, $iCEWf.AISessionState).actioned)) return;
        const event = createAndMergeEventPayload({
            action: 'actioned',
            actionSubject: 'aiResult',
            attributes: {
                aiResultAction: aiResultAction
            }
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const trackAIResultDiscarded = (0, $cozmU.useCallback)((aiResultAction, payload)=>{
        if (!validateAndUpdateAISession((0, $iCEWf.AISessionState).discarded)) return;
        const event = createAndMergeEventPayload({
            action: 'discarded',
            actionSubject: 'aiResult',
            attributes: {
                aiResultAction: aiResultAction
            }
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const trackAIResultAdopted = (0, $cozmU.useCallback)((aiResultAction, payload)=>{
        if (!validateAndUpdateAISession((0, $iCEWf.AISessionState).adopted)) return;
        const event = createAndMergeEventPayload({
            action: 'adopted',
            actionSubject: 'aiResult',
            attributes: {
                aiResultAction: aiResultAction
            }
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const trackAIFeedbackSubmit = (0, $cozmU.useCallback)((aiFeedbackResult, payload)=>{
        if (!validateAndUpdateAISession((0, $iCEWf.AISessionState).submitted)) return;
        const event = createAndMergeEventPayload({
            action: 'submitted',
            actionSubject: 'aiFeedback',
            attributes: {
                aiFeedbackResult: aiFeedbackResult
            }
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const updateAIAttributes = (0, $cozmU.useCallback)((newAttributes)=>{
        aiEventAttributesOverride.current = {
            ...aiEventAttributesOverride.current,
            ...newAttributes
        };
    }, []);
    const baseReturn = {
        updateAIAttributes: updateAIAttributes,
        trackAIInteractionInit: trackAIInteractionInit,
        trackAIResultView: trackAIResultView,
        trackAIResultError: trackAIResultError,
        trackAIResultDiscarded: trackAIResultDiscarded,
        trackAIInteractionDismiss: trackAIInteractionDismiss,
        trackAIResultAction: trackAIResultAction,
        trackAIResultAdopted: trackAIResultAdopted,
        trackAIFeedbackSubmit: trackAIFeedbackSubmit,
        refreshSingleInstrumentationID: refreshSingleInstrumentationID
    };
    return $a12da25560425c44$var$useStableMethods(baseReturn);
};
/**
 * Returns an object with the same shape as `methods`, but with every method
 * replaced by a stable wrapper that delegates to the latest version. The
 * wrappers are created once on mount; they always read the freshest closure
 * via a ref, so calls observe the same behaviour as calling the unstable
 * methods directly.
 */ function $a12da25560425c44$var$useStableMethods(methods) {
    const ref = (0, $cozmU.useRef)(methods);
    ref.current = methods;
    return (0, $cozmU.useMemo)(()=>{
        const out = {};
        for (const key of Object.keys(ref.current))out[key] = (...args)=>ref.current[key](...args);
        return out;
    // Wrappers always read from `ref.current`; no deps needed.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}
module.exports["useAIEventsInstrumentation"] = $a12da25560425c44$export$ddf49ad062368ad2;

});

parcelRegister("3U8XR", function(module, exports) {
const $2d7d8e3cc345803e$var$t = Symbol.for("@ts-pattern/matcher"), $2d7d8e3cc345803e$var$e = Symbol.for("@ts-pattern/isVariadic"), $2d7d8e3cc345803e$var$n = "@ts-pattern/anonymous-select-key", $2d7d8e3cc345803e$var$r = (t)=>Boolean(t && "object" == typeof t), $2d7d8e3cc345803e$var$i = (e)=>e && !!e[$2d7d8e3cc345803e$var$t], $2d7d8e3cc345803e$var$o = (n, s, c)=>{
    if ($2d7d8e3cc345803e$var$i(n)) {
        const e = n[$2d7d8e3cc345803e$var$t](), { matched: r, selections: i } = e.match(s);
        return r && i && Object.keys(i).forEach((t)=>c(t, i[t])), r;
    }
    if ($2d7d8e3cc345803e$var$r(n)) {
        if (!$2d7d8e3cc345803e$var$r(s)) return !1;
        if (Array.isArray(n)) {
            if (!Array.isArray(s)) return !1;
            let t = [], r = [], a = [];
            for (const o of n.keys()){
                const s = n[o];
                $2d7d8e3cc345803e$var$i(s) && s[$2d7d8e3cc345803e$var$e] ? a.push(s) : a.length ? r.push(s) : t.push(s);
            }
            if (a.length) {
                if (a.length > 1) throw new Error("Pattern error: Using `...P.array(...)` several times in a single pattern is not allowed.");
                if (s.length < t.length + r.length) return !1;
                const e = s.slice(0, t.length), n = 0 === r.length ? [] : s.slice(-r.length), i = s.slice(t.length, 0 === r.length ? Infinity : -r.length);
                return t.every((t, n)=>$2d7d8e3cc345803e$var$o(t, e[n], c)) && r.every((t, e)=>$2d7d8e3cc345803e$var$o(t, n[e], c)) && (0 === a.length || $2d7d8e3cc345803e$var$o(a[0], i, c));
            }
            return n.length === s.length && n.every((t, e)=>$2d7d8e3cc345803e$var$o(t, s[e], c));
        }
        return Reflect.ownKeys(n).every((e)=>{
            const r = n[e];
            var a;
            return (e in s || $2d7d8e3cc345803e$var$i(a = r) && "optional" === a[$2d7d8e3cc345803e$var$t]().matcherType) && $2d7d8e3cc345803e$var$o(r, s[e], c);
        });
    }
    return Object.is(s, n);
}, $2d7d8e3cc345803e$var$s = (e)=>{
    var n, o, a;
    return $2d7d8e3cc345803e$var$r(e) ? $2d7d8e3cc345803e$var$i(e) ? null != (n = null == (o = (a = e[$2d7d8e3cc345803e$var$t]()).getSelectionKeys) ? void 0 : o.call(a)) ? n : [] : Array.isArray(e) ? $2d7d8e3cc345803e$var$c(e, $2d7d8e3cc345803e$var$s) : $2d7d8e3cc345803e$var$c(Object.values(e), $2d7d8e3cc345803e$var$s) : [];
}, $2d7d8e3cc345803e$var$c = (t, e)=>t.reduce((t, n)=>t.concat(e(n)), []);
function $2d7d8e3cc345803e$export$ce1e7a33533a73d9(...t) {
    if (1 === t.length) {
        const [e] = t;
        return (t)=>$2d7d8e3cc345803e$var$o(e, t, ()=>{});
    }
    if (2 === t.length) {
        const [e, n] = t;
        return $2d7d8e3cc345803e$var$o(e, n, ()=>{});
    }
    throw new Error(`isMatching wasn't given the right number of arguments: expected 1 or 2, received ${t.length}.`);
}
function $2d7d8e3cc345803e$var$u(t) {
    return Object.assign(t, {
        optional: ()=>$2d7d8e3cc345803e$var$l(t),
        and: (e)=>$2d7d8e3cc345803e$var$m(t, e),
        or: (e)=>$2d7d8e3cc345803e$var$d(t, e),
        select: (e)=>void 0 === e ? $2d7d8e3cc345803e$var$y(t) : $2d7d8e3cc345803e$var$y(e, t)
    });
}
function $2d7d8e3cc345803e$var$h(t) {
    return Object.assign(((t)=>Object.assign(t, {
            [Symbol.iterator] () {
                let n = 0;
                const r = [
                    {
                        value: Object.assign(t, {
                            [$2d7d8e3cc345803e$var$e]: !0
                        }),
                        done: !1
                    },
                    {
                        done: !0,
                        value: void 0
                    }
                ];
                return {
                    next: ()=>{
                        var t;
                        return null != (t = r[n++]) ? t : r.at(-1);
                    }
                };
            }
        }))(t), {
        optional: ()=>$2d7d8e3cc345803e$var$h($2d7d8e3cc345803e$var$l(t)),
        select: (e)=>$2d7d8e3cc345803e$var$h(void 0 === e ? $2d7d8e3cc345803e$var$y(t) : $2d7d8e3cc345803e$var$y(e, t))
    });
}
function $2d7d8e3cc345803e$var$l(e) {
    return $2d7d8e3cc345803e$var$u({
        [$2d7d8e3cc345803e$var$t]: ()=>({
                match: (t)=>{
                    let n = {};
                    const r = (t, e)=>{
                        n[t] = e;
                    };
                    return void 0 === t ? ($2d7d8e3cc345803e$var$s(e).forEach((t)=>r(t, void 0)), {
                        matched: !0,
                        selections: n
                    }) : {
                        matched: $2d7d8e3cc345803e$var$o(e, t, r),
                        selections: n
                    };
                },
                getSelectionKeys: ()=>$2d7d8e3cc345803e$var$s(e),
                matcherType: "optional"
            })
    });
}
const $2d7d8e3cc345803e$var$f = (t, e)=>{
    for (const n of t)if (!e(n)) return !1;
    return !0;
}, $2d7d8e3cc345803e$var$g = (t, e)=>{
    for (const [n, r] of t.entries())if (!e(r, n)) return !1;
    return !0;
};
function $2d7d8e3cc345803e$var$m(...e) {
    return $2d7d8e3cc345803e$var$u({
        [$2d7d8e3cc345803e$var$t]: ()=>({
                match: (t)=>{
                    let n = {};
                    const r = (t, e)=>{
                        n[t] = e;
                    };
                    return {
                        matched: e.every((e)=>$2d7d8e3cc345803e$var$o(e, t, r)),
                        selections: n
                    };
                },
                getSelectionKeys: ()=>$2d7d8e3cc345803e$var$c(e, $2d7d8e3cc345803e$var$s),
                matcherType: "and"
            })
    });
}
function $2d7d8e3cc345803e$var$d(...e) {
    return $2d7d8e3cc345803e$var$u({
        [$2d7d8e3cc345803e$var$t]: ()=>({
                match: (t)=>{
                    let n = {};
                    const r = (t, e)=>{
                        n[t] = e;
                    };
                    return $2d7d8e3cc345803e$var$c(e, $2d7d8e3cc345803e$var$s).forEach((t)=>r(t, void 0)), {
                        matched: e.some((e)=>$2d7d8e3cc345803e$var$o(e, t, r)),
                        selections: n
                    };
                },
                getSelectionKeys: ()=>$2d7d8e3cc345803e$var$c(e, $2d7d8e3cc345803e$var$s),
                matcherType: "or"
            })
    });
}
function $2d7d8e3cc345803e$var$p(e) {
    return {
        [$2d7d8e3cc345803e$var$t]: ()=>({
                match: (t)=>({
                        matched: Boolean(e(t))
                    })
            })
    };
}
function $2d7d8e3cc345803e$var$y(...e) {
    const r = "string" == typeof e[0] ? e[0] : void 0, i = 2 === e.length ? e[1] : "string" == typeof e[0] ? void 0 : e[0];
    return $2d7d8e3cc345803e$var$u({
        [$2d7d8e3cc345803e$var$t]: ()=>({
                match: (t)=>{
                    let e = {
                        [null != r ? r : $2d7d8e3cc345803e$var$n]: t
                    };
                    return {
                        matched: void 0 === i || $2d7d8e3cc345803e$var$o(i, t, (t, n)=>{
                            e[t] = n;
                        }),
                        selections: e
                    };
                },
                getSelectionKeys: ()=>[
                        null != r ? r : $2d7d8e3cc345803e$var$n
                    ].concat(void 0 === i ? [] : $2d7d8e3cc345803e$var$s(i))
            })
    });
}
function $2d7d8e3cc345803e$var$v(t) {
    return "number" == typeof t;
}
function $2d7d8e3cc345803e$var$b(t) {
    return "string" == typeof t;
}
function $2d7d8e3cc345803e$var$w(t) {
    return "bigint" == typeof t;
}
const $2d7d8e3cc345803e$var$S = $2d7d8e3cc345803e$var$u($2d7d8e3cc345803e$var$p(function(t) {
    return !0;
})), $2d7d8e3cc345803e$var$O = $2d7d8e3cc345803e$var$S, $2d7d8e3cc345803e$var$j = (t)=>Object.assign($2d7d8e3cc345803e$var$u(t), {
        startsWith: (e)=>{
            var n;
            return $2d7d8e3cc345803e$var$j($2d7d8e3cc345803e$var$m(t, (n = e, $2d7d8e3cc345803e$var$p((t)=>$2d7d8e3cc345803e$var$b(t) && t.startsWith(n)))));
        },
        endsWith: (e)=>{
            var n;
            return $2d7d8e3cc345803e$var$j($2d7d8e3cc345803e$var$m(t, (n = e, $2d7d8e3cc345803e$var$p((t)=>$2d7d8e3cc345803e$var$b(t) && t.endsWith(n)))));
        },
        minLength: (e)=>$2d7d8e3cc345803e$var$j($2d7d8e3cc345803e$var$m(t, ((t)=>$2d7d8e3cc345803e$var$p((e)=>$2d7d8e3cc345803e$var$b(e) && e.length >= t))(e))),
        length: (e)=>$2d7d8e3cc345803e$var$j($2d7d8e3cc345803e$var$m(t, ((t)=>$2d7d8e3cc345803e$var$p((e)=>$2d7d8e3cc345803e$var$b(e) && e.length === t))(e))),
        maxLength: (e)=>$2d7d8e3cc345803e$var$j($2d7d8e3cc345803e$var$m(t, ((t)=>$2d7d8e3cc345803e$var$p((e)=>$2d7d8e3cc345803e$var$b(e) && e.length <= t))(e))),
        includes: (e)=>{
            var n;
            return $2d7d8e3cc345803e$var$j($2d7d8e3cc345803e$var$m(t, (n = e, $2d7d8e3cc345803e$var$p((t)=>$2d7d8e3cc345803e$var$b(t) && t.includes(n)))));
        },
        regex: (e)=>{
            var n;
            return $2d7d8e3cc345803e$var$j($2d7d8e3cc345803e$var$m(t, (n = e, $2d7d8e3cc345803e$var$p((t)=>$2d7d8e3cc345803e$var$b(t) && Boolean(t.match(n))))));
        }
    }), $2d7d8e3cc345803e$var$K = $2d7d8e3cc345803e$var$j($2d7d8e3cc345803e$var$p($2d7d8e3cc345803e$var$b)), $2d7d8e3cc345803e$var$x = (t)=>Object.assign($2d7d8e3cc345803e$var$u(t), {
        between: (e, n)=>$2d7d8e3cc345803e$var$x($2d7d8e3cc345803e$var$m(t, ((t, e)=>$2d7d8e3cc345803e$var$p((n)=>$2d7d8e3cc345803e$var$v(n) && t <= n && e >= n))(e, n))),
        lt: (e)=>$2d7d8e3cc345803e$var$x($2d7d8e3cc345803e$var$m(t, ((t)=>$2d7d8e3cc345803e$var$p((e)=>$2d7d8e3cc345803e$var$v(e) && e < t))(e))),
        gt: (e)=>$2d7d8e3cc345803e$var$x($2d7d8e3cc345803e$var$m(t, ((t)=>$2d7d8e3cc345803e$var$p((e)=>$2d7d8e3cc345803e$var$v(e) && e > t))(e))),
        lte: (e)=>$2d7d8e3cc345803e$var$x($2d7d8e3cc345803e$var$m(t, ((t)=>$2d7d8e3cc345803e$var$p((e)=>$2d7d8e3cc345803e$var$v(e) && e <= t))(e))),
        gte: (e)=>$2d7d8e3cc345803e$var$x($2d7d8e3cc345803e$var$m(t, ((t)=>$2d7d8e3cc345803e$var$p((e)=>$2d7d8e3cc345803e$var$v(e) && e >= t))(e))),
        int: ()=>$2d7d8e3cc345803e$var$x($2d7d8e3cc345803e$var$m(t, $2d7d8e3cc345803e$var$p((t)=>$2d7d8e3cc345803e$var$v(t) && Number.isInteger(t)))),
        finite: ()=>$2d7d8e3cc345803e$var$x($2d7d8e3cc345803e$var$m(t, $2d7d8e3cc345803e$var$p((t)=>$2d7d8e3cc345803e$var$v(t) && Number.isFinite(t)))),
        positive: ()=>$2d7d8e3cc345803e$var$x($2d7d8e3cc345803e$var$m(t, $2d7d8e3cc345803e$var$p((t)=>$2d7d8e3cc345803e$var$v(t) && t > 0))),
        negative: ()=>$2d7d8e3cc345803e$var$x($2d7d8e3cc345803e$var$m(t, $2d7d8e3cc345803e$var$p((t)=>$2d7d8e3cc345803e$var$v(t) && t < 0)))
    }), $2d7d8e3cc345803e$var$E = $2d7d8e3cc345803e$var$x($2d7d8e3cc345803e$var$p($2d7d8e3cc345803e$var$v)), $2d7d8e3cc345803e$var$A = (t)=>Object.assign($2d7d8e3cc345803e$var$u(t), {
        between: (e, n)=>$2d7d8e3cc345803e$var$A($2d7d8e3cc345803e$var$m(t, ((t, e)=>$2d7d8e3cc345803e$var$p((n)=>$2d7d8e3cc345803e$var$w(n) && t <= n && e >= n))(e, n))),
        lt: (e)=>$2d7d8e3cc345803e$var$A($2d7d8e3cc345803e$var$m(t, ((t)=>$2d7d8e3cc345803e$var$p((e)=>$2d7d8e3cc345803e$var$w(e) && e < t))(e))),
        gt: (e)=>$2d7d8e3cc345803e$var$A($2d7d8e3cc345803e$var$m(t, ((t)=>$2d7d8e3cc345803e$var$p((e)=>$2d7d8e3cc345803e$var$w(e) && e > t))(e))),
        lte: (e)=>$2d7d8e3cc345803e$var$A($2d7d8e3cc345803e$var$m(t, ((t)=>$2d7d8e3cc345803e$var$p((e)=>$2d7d8e3cc345803e$var$w(e) && e <= t))(e))),
        gte: (e)=>$2d7d8e3cc345803e$var$A($2d7d8e3cc345803e$var$m(t, ((t)=>$2d7d8e3cc345803e$var$p((e)=>$2d7d8e3cc345803e$var$w(e) && e >= t))(e))),
        positive: ()=>$2d7d8e3cc345803e$var$A($2d7d8e3cc345803e$var$m(t, $2d7d8e3cc345803e$var$p((t)=>$2d7d8e3cc345803e$var$w(t) && t > 0))),
        negative: ()=>$2d7d8e3cc345803e$var$A($2d7d8e3cc345803e$var$m(t, $2d7d8e3cc345803e$var$p((t)=>$2d7d8e3cc345803e$var$w(t) && t < 0)))
    }), $2d7d8e3cc345803e$var$P = $2d7d8e3cc345803e$var$A($2d7d8e3cc345803e$var$p($2d7d8e3cc345803e$var$w)), $2d7d8e3cc345803e$var$T = $2d7d8e3cc345803e$var$u($2d7d8e3cc345803e$var$p(function(t) {
    return "boolean" == typeof t;
})), $2d7d8e3cc345803e$var$B = $2d7d8e3cc345803e$var$u($2d7d8e3cc345803e$var$p(function(t) {
    return "symbol" == typeof t;
})), $2d7d8e3cc345803e$var$_ = $2d7d8e3cc345803e$var$u($2d7d8e3cc345803e$var$p(function(t) {
    return null == t;
})), $2d7d8e3cc345803e$var$k = $2d7d8e3cc345803e$var$u($2d7d8e3cc345803e$var$p(function(t) {
    return null != t;
}));
var $2d7d8e3cc345803e$export$56c0d5a1e737357d = {
    __proto__: null,
    matcher: $2d7d8e3cc345803e$var$t,
    optional: $2d7d8e3cc345803e$var$l,
    array: function(...e) {
        return $2d7d8e3cc345803e$var$h({
            [$2d7d8e3cc345803e$var$t]: ()=>({
                    match: (t)=>{
                        if (!Array.isArray(t)) return {
                            matched: !1
                        };
                        if (0 === e.length) return {
                            matched: !0
                        };
                        const n = e[0];
                        let r = {};
                        if (0 === t.length) return $2d7d8e3cc345803e$var$s(n).forEach((t)=>{
                            r[t] = [];
                        }), {
                            matched: !0,
                            selections: r
                        };
                        const i = (t, e)=>{
                            r[t] = (r[t] || []).concat([
                                e
                            ]);
                        };
                        return {
                            matched: t.every((t)=>$2d7d8e3cc345803e$var$o(n, t, i)),
                            selections: r
                        };
                    },
                    getSelectionKeys: ()=>0 === e.length ? [] : $2d7d8e3cc345803e$var$s(e[0])
                })
        });
    },
    set: function(...e) {
        return $2d7d8e3cc345803e$var$u({
            [$2d7d8e3cc345803e$var$t]: ()=>({
                    match: (t)=>{
                        if (!(t instanceof Set)) return {
                            matched: !1
                        };
                        let n = {};
                        if (0 === t.size) return {
                            matched: !0,
                            selections: n
                        };
                        if (0 === e.length) return {
                            matched: !0
                        };
                        const r = (t, e)=>{
                            n[t] = (n[t] || []).concat([
                                e
                            ]);
                        }, i = e[0];
                        return {
                            matched: $2d7d8e3cc345803e$var$f(t, (t)=>$2d7d8e3cc345803e$var$o(i, t, r)),
                            selections: n
                        };
                    },
                    getSelectionKeys: ()=>0 === e.length ? [] : $2d7d8e3cc345803e$var$s(e[0])
                })
        });
    },
    map: function(...e) {
        return $2d7d8e3cc345803e$var$u({
            [$2d7d8e3cc345803e$var$t]: ()=>({
                    match: (t)=>{
                        if (!(t instanceof Map)) return {
                            matched: !1
                        };
                        let n = {};
                        if (0 === t.size) return {
                            matched: !0,
                            selections: n
                        };
                        const r = (t, e)=>{
                            n[t] = (n[t] || []).concat([
                                e
                            ]);
                        };
                        if (0 === e.length) return {
                            matched: !0
                        };
                        var i;
                        if (1 === e.length) throw new Error(`\`P.map\` wasn't given enough arguments. Expected (key, value), received ${null == (i = e[0]) ? void 0 : i.toString()}`);
                        const [s, c] = e;
                        return {
                            matched: $2d7d8e3cc345803e$var$g(t, (t, e)=>{
                                const n = $2d7d8e3cc345803e$var$o(s, e, r), i = $2d7d8e3cc345803e$var$o(c, t, r);
                                return n && i;
                            }),
                            selections: n
                        };
                    },
                    getSelectionKeys: ()=>0 === e.length ? [] : [
                            ...$2d7d8e3cc345803e$var$s(e[0]),
                            ...$2d7d8e3cc345803e$var$s(e[1])
                        ]
                })
        });
    },
    intersection: $2d7d8e3cc345803e$var$m,
    union: $2d7d8e3cc345803e$var$d,
    not: function(e) {
        return $2d7d8e3cc345803e$var$u({
            [$2d7d8e3cc345803e$var$t]: ()=>({
                    match: (t)=>({
                            matched: !$2d7d8e3cc345803e$var$o(e, t, ()=>{})
                        }),
                    getSelectionKeys: ()=>[],
                    matcherType: "not"
                })
        });
    },
    when: $2d7d8e3cc345803e$var$p,
    select: $2d7d8e3cc345803e$var$y,
    any: $2d7d8e3cc345803e$var$S,
    _: $2d7d8e3cc345803e$var$O,
    string: $2d7d8e3cc345803e$var$K,
    number: $2d7d8e3cc345803e$var$E,
    bigint: $2d7d8e3cc345803e$var$P,
    boolean: $2d7d8e3cc345803e$var$T,
    symbol: $2d7d8e3cc345803e$var$B,
    nullish: $2d7d8e3cc345803e$var$_,
    nonNullable: $2d7d8e3cc345803e$var$k,
    instanceOf: function(t) {
        return $2d7d8e3cc345803e$var$u($2d7d8e3cc345803e$var$p(function(t) {
            return (e)=>e instanceof t;
        }(t)));
    },
    shape: function(t) {
        return $2d7d8e3cc345803e$var$u($2d7d8e3cc345803e$var$p($2d7d8e3cc345803e$export$ce1e7a33533a73d9(t)));
    }
};
class $2d7d8e3cc345803e$export$6c1467edb54d3773 extends Error {
    constructor(t){
        let e;
        try {
            e = JSON.stringify(t);
        } catch (n) {
            e = t;
        }
        super(`Pattern matching error: no pattern matches value ${e}`), this.input = void 0, this.input = t;
    }
}
const $2d7d8e3cc345803e$var$$ = {
    matched: !1,
    value: void 0
};
function $2d7d8e3cc345803e$export$4659b591c19bdf3d(t) {
    return new $2d7d8e3cc345803e$var$I(t, $2d7d8e3cc345803e$var$$);
}
class $2d7d8e3cc345803e$var$I {
    with(...t) {
        if (this.state.matched) return this;
        const e = t[t.length - 1], r = [
            t[0]
        ];
        let i;
        3 === t.length && "function" == typeof t[1] ? i = t[1] : t.length > 2 && r.push(...t.slice(1, t.length - 1));
        let s = !1, c = {};
        const a = (t, e)=>{
            s = !0, c[t] = e;
        }, u = !r.some((t)=>$2d7d8e3cc345803e$var$o(t, this.input, a)) || i && !Boolean(i(this.input)) ? $2d7d8e3cc345803e$var$$ : {
            matched: !0,
            value: e(s ? $2d7d8e3cc345803e$var$n in c ? c[$2d7d8e3cc345803e$var$n] : c : this.input, this.input)
        };
        return new $2d7d8e3cc345803e$var$I(this.input, u);
    }
    when(t, e) {
        if (this.state.matched) return this;
        const n = Boolean(t(this.input));
        return new $2d7d8e3cc345803e$var$I(this.input, n ? {
            matched: !0,
            value: e(this.input, this.input)
        } : $2d7d8e3cc345803e$var$$);
    }
    otherwise(t) {
        return this.state.matched ? this.state.value : t(this.input);
    }
    exhaustive(t = $2d7d8e3cc345803e$var$L) {
        return this.state.matched ? this.state.value : t(this.input);
    }
    run() {
        return this.exhaustive();
    }
    returnType() {
        return this;
    }
    narrow() {
        return this;
    }
    constructor(t, e){
        this.input = void 0, this.state = void 0, this.input = t, this.state = e;
    }
}
function $2d7d8e3cc345803e$var$L(t) {
    throw new $2d7d8e3cc345803e$export$6c1467edb54d3773(t);
}
 //# sourceMappingURL=index.js.map
module.exports["P"] = $2d7d8e3cc345803e$export$56c0d5a1e737357d;
module.exports["match"] = $2d7d8e3cc345803e$export$4659b591c19bdf3d;

});

parcelRegister("jU6s6", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $1f90c1a79bae927c$export$4f059feb37b5835e = (0, $cozmU.createContext)(null);
module.exports["AIEventsInstrumentationContext"] = $1f90c1a79bae927c$export$4f059feb37b5835e;

});

parcelRegister("4dW9D", function(module, exports) {

var $iCEWf = parcelRequire("iCEWf");

const $7545c0c100898f47$export$5013b36eeed4ec19 = {
    isAIFeature: 1,
    actionSubjectId: 'client',
    eventDispatcherSource: (0, $iCEWf.EventDispatcherSources).JSLib,
    skipAISessionValidation: false,
    useDefaultGASv3EventSchema: false,
    enablePlatformEvents: false
};
module.exports["defaultAIEventsInstrumentationConfigValues"] = $7545c0c100898f47$export$5013b36eeed4ec19;

});

parcelRegister("iCEWf", function(module, exports) {
var $d6416e2c87d11da8$export$af92e0e920a45719 = /*#__PURE__*/ function(AISessionState) {
    AISessionState["unset"] = "[AIInteraction]:UNSET";
    AISessionState["initiated"] = "[AIInteraction]:INITIATED";
    AISessionState["viewed"] = "[AIInteraction]:VIEWED";
    AISessionState["error"] = "[AIInteraction]:ERROR";
    AISessionState["dismissed"] = "[AIInteraction]:DISMISSED";
    AISessionState["actioned"] = "[AIInteraction]:ACTIONED";
    AISessionState["adopted"] = "[AIInteraction]:ADOPTED";
    AISessionState["discarded"] = "[AIInteraction]:DISCARDED";
    AISessionState["submitted"] = "[AIInteraction]:SUBMITTED";
    return AISessionState;
}({});
var $d6416e2c87d11da8$export$7052d5b66e36f60f = /*#__PURE__*/ function(EventDispatcherSources) {
    EventDispatcherSources["JSLib"] = "name:@atlassian/ai-analytics|language:javascript";
    return EventDispatcherSources;
}({});
module.exports["AISessionState"] = $d6416e2c87d11da8$export$af92e0e920a45719;
module.exports["EventDispatcherSources"] = $d6416e2c87d11da8$export$7052d5b66e36f60f;

});

parcelRegister("96Ikf", function(module, exports) {
const $3836d38b50a38c42$export$e053e424fcbfebe9 = (tags)=>{
    const defaultTags = [
        'atlaskit'
    ];
    if (!tags) return defaultTags;
    return defaultTags.concat(tags);
};
module.exports["getTagsWithPlatformTag"] = $3836d38b50a38c42$export$e053e424fcbfebe9;

});

parcelRegister("jLdbZ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $1r1cI = parcelRequire("1r1cI");


var $7mJer = parcelRequire("7mJer");


var $iCEWf = parcelRequire("iCEWf");

const $e5d5cfe1f6d4c858$export$259576f4e7ac6488 = (customSingleInstrumentationIDFromUserConfig, cookieSingleInstrumentationConfig)=>{
    const singleInstrumentationIDRef = (0, $cozmU.useRef)(undefined);
    const aiSessionStateRef = (0, $cozmU.useRef)((0, $iCEWf.AISessionState).unset);
    const setAISessionState = (0, $cozmU.useCallback)((nextState)=>{
        aiSessionStateRef.current = nextState;
    }, []);
    const getAISessionState = (0, $cozmU.useCallback)(()=>{
        return aiSessionStateRef.current;
    }, []);
    const refreshSingleInstrumentationID = (0, $cozmU.useCallback)((customSingleInstrumentationIDFromEvent)=>{
        const nextSingleInstrumentationID = (0, $1r1cI.getNewSingleInstrumentationID)(customSingleInstrumentationIDFromEvent, customSingleInstrumentationIDFromUserConfig);
        singleInstrumentationIDRef.current = nextSingleInstrumentationID;
        if (cookieSingleInstrumentationConfig) (0, $7mJer.setSingleInstrumentationIDCookie)(cookieSingleInstrumentationConfig.uniqueCookieFeatureName, nextSingleInstrumentationID);
    }, [
        customSingleInstrumentationIDFromUserConfig,
        cookieSingleInstrumentationConfig
    ]);
    const getSingleInstrumentationID = (0, $cozmU.useCallback)(()=>{
        // this handles a race condition when we have a new singleInstrumentationID from the user config
        // but Provider knows only about the initial singleInstrumentationID. In this case we need to update
        // singleInstrumentationID at first step and then return a new one.
        if (customSingleInstrumentationIDFromUserConfig && customSingleInstrumentationIDFromUserConfig !== singleInstrumentationIDRef.current) {
            refreshSingleInstrumentationID();
            return singleInstrumentationIDRef.current;
        }
        if (cookieSingleInstrumentationConfig) return (0, $7mJer.readSingleInstrumentationIDCookie)(cookieSingleInstrumentationConfig.uniqueCookieFeatureName);
        return singleInstrumentationIDRef.current;
    }, [
        customSingleInstrumentationIDFromUserConfig,
        cookieSingleInstrumentationConfig,
        refreshSingleInstrumentationID
    ]);
    return {
        refreshSingleInstrumentationID: refreshSingleInstrumentationID,
        getSingleInstrumentationID: getSingleInstrumentationID,
        setAISessionState: setAISessionState,
        getAISessionState: getAISessionState
    };
};
module.exports["useAIInstrumentationSetup"] = $e5d5cfe1f6d4c858$export$259576f4e7ac6488;

});

parcelRegister("1r1cI", function(module, exports) {

var $3U8XR = parcelRequire("3U8XR");


var $03RpJ = parcelRequire("03RpJ");

function $d83e4e74e28b2b37$export$cee2a1482be61648(customSingleInstrumentationIDFromEvent, customSingleInstrumentationIDFromUserConfig) {
    // priority for setting singleInstrumentationID override rule
    // 1. from consumer event attribute
    // 2. from consumer configuration
    // 3. from cookie lib
    // 4. default behaviour generates through the crypto API
    return (0, $3U8XR.match)({
        customSingleInstrumentationIDFromEvent: customSingleInstrumentationIDFromEvent,
        customSingleInstrumentationIDFromUserConfig: customSingleInstrumentationIDFromUserConfig
    }).with({
        customSingleInstrumentationIDFromEvent: (0, $3U8XR.P).string
    }, (result)=>result.customSingleInstrumentationIDFromEvent).with({
        customSingleInstrumentationIDFromUserConfig: (0, $3U8XR.P).string
    }, (result)=>result.customSingleInstrumentationIDFromUserConfig)// we can't use the crypto API in the browser due to SSR issues?
    // https://atlassian.slack.com/archives/C051ARA9QGH/p1749587419868869
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    .otherwise(()=>(0, $03RpJ.default)());
}
module.exports["getNewSingleInstrumentationID"] = $d83e4e74e28b2b37$export$cee2a1482be61648;

});

parcelRegister("7mJer", function(module, exports) {

var $1Qi0Q = parcelRequire("1Qi0Q");

var $lnexi = parcelRequire("lnexi");

const $0ca840bf5f9ee98d$export$72d8c154d3f75075 = 'SINGLE_INSTRUMENTATION_ID_IS_NOT_SET';
const $0ca840bf5f9ee98d$export$35ae1861d13fb6c8 = (uniqueCookieFeatureName)=>`AI_INSTRUMENTATION_FEATURE_ID_${uniqueCookieFeatureName}`;
const $0ca840bf5f9ee98d$export$9a4eaf99327c19fe = (uniqueCookieFeatureName, nextSingleInstrumentationID)=>(0, $lnexi.setCookie)($0ca840bf5f9ee98d$export$35ae1861d13fb6c8(uniqueCookieFeatureName), nextSingleInstrumentationID, {
        expires: 7,
        domain: location.hostname,
        sameSite: 'strict'
    });
const $0ca840bf5f9ee98d$export$d6fb1caea334c7c7 = (uniqueCookieFeatureName)=>(0, $1Qi0Q.getCookie)($0ca840bf5f9ee98d$export$35ae1861d13fb6c8(uniqueCookieFeatureName)) || $0ca840bf5f9ee98d$export$72d8c154d3f75075;
module.exports["setSingleInstrumentationIDCookie"] = $0ca840bf5f9ee98d$export$9a4eaf99327c19fe;
module.exports["readSingleInstrumentationIDCookie"] = $0ca840bf5f9ee98d$export$d6fb1caea334c7c7;

});

parcelRegister("eMlr8", function(module, exports) {
/**
 * NOTE: Some of these fields are used to track AI MAU
 * See this page for more details: https://hello.atlassian.net/wiki/spaces/AAI/pages/3770721410/Unified+event+Instrumentation+for+AI
 */ const $49f89fe5a40ece12$export$8cffc8b2c93affd4 = {
    agentCreatorType: 'agentCreatorType',
    agentId: 'agentId',
    agentVisibility: 'agentVisibility',
    agentExternalConfigReference: 'agentExternalConfigReference',
    agentActions: 'agentActions',
    agentIsDefault: 'agentIsDefault',
    agentIsVerified: 'agentIsVerified',
    conversationChannelId: 'conversationChannelId',
    chatEntryPoint: 'chatEntryPoint',
    experienceId: 'experienceId',
    fullScreen: 'fullScreen',
    mode: 'mode',
    product: 'product',
    productHeader: 'productHeader',
    inProductExperience: 'inProductExperience',
    singleInstrumentationID: 'singleInstrumentationID',
    sharedFeaturesInstrumentationId: 'sharedFeaturesInstrumentationId',
    assistanceServiceConfigMinionAlias: 'assistanceServiceConfigMinionAlias',
    skillSelectionSource: 'skillSelectionSource',
    // The Rovo Space a chat is scoped to (when any). Set on every event fired
    // while a space-scoped chat is active so "Space MAU" (unique users who
    // initiate a chat in a space) can be measured downstream.
    spaceId: 'spaceId',
    // Source surface that launched the conversation; emitted on result events only.
    // Runtime-validated against the launch-source allowlists at the pubsub boundary, so
    // only closed-vocabulary values ever reach analytics despite FollowUpSource's
    // `| string` fallback.
    launchSource: 'launchSource',
    // Quick Find-to-Chat journey correlation. Emitted only on the five funnel events
    // allowlisted by the analytics controller while the attributed conversation is active.
    rovoJourneyId: 'rovoJourneyId',
    // Set once a conversation is started from a third-party suggested prompt in the
    // Create-with-Rovo modal, so downstream events the 3P experiment does not own
    // (`message/sent`, `adopted/contentFinalized`) can be segmented by cohort.
    isThirdPartyPromptConversation: 'isThirdPartyPromptConversation',
    thirdPartyPromptCohort: 'thirdPartyPromptCohort',
    // Third-party apps connected from the in-thread connect prompt so far in this
    // conversation, so a later message can be read as post-connect without a join.
    thirdPartyConnectCount: 'thirdPartyConnectCount'
};
module.exports["AI_MATE_ATTRIBUTES"] = $49f89fe5a40ece12$export$8cffc8b2c93affd4;

});

parcelRegister("1jIs1", function(module, exports) {

var $iTJtk = parcelRequire("iTJtk");

const $70c81957c9ee94b4$export$85183a312807388d = (0, $iTJtk.FabricChannel).aiMate;
const $70c81957c9ee94b4$var$REMIX_SOURCES = [
    'remix',
    'inlineRovoFromRemix',
    'remixModalFromToolbar',
    'remixModalFromBlockControls',
    'remixModalFromBlockMenu',
    'remixModalFromFloatingToolbar',
    'remixModalFromViewPageFloatingToolbar',
    'remixModalFromViewPageNudge',
    'remixModalFromNudge',
    'remixModalFromObjectLevelSidebar',
    'remixModalFromPasteMenu',
    'remixStagingArea',
    'remixModalFromMediaInserts'
];
const $70c81957c9ee94b4$export$e86f3aae41de8a7 = 'smartLinkRovoButton';
const $70c81957c9ee94b4$export$5a1bc70923e441e9 = new Set($70c81957c9ee94b4$var$REMIX_SOURCES);
const $70c81957c9ee94b4$export$c576fc434c88316f = new Set([
    'agentMentionEditorNudge',
    'automation-discovery-meeting-notes-nudge',
    'automation-discovery-content-reviewer-nudge',
    'jiraAddViewCreateWithRovo',
    'jiraListChildCreateRovo',
    'jiraListEmptyStateCreateRovo',
    'jiraSummaryActivityFeedEmptyState',
    'jiraSummaryRovoCreateRecommendation',
    'jiraSummaryWorkPulseConversationStarter',
    'jiraTimelineChildCreateRovo',
    'jsmSurveyAggregatedInsights',
    'recommendation-card-nudge'
]);
const $70c81957c9ee94b4$export$f57fd972b3024068 = (value)=>value !== undefined && $70c81957c9ee94b4$export$c576fc434c88316f.has(value);
var $70c81957c9ee94b4$export$406073150b1a408 = /*#__PURE__*/ function(AUTOSUGGEST_SOURCE) {
    AUTOSUGGEST_SOURCE["ROVO_CHAT"] = "rovo-chat";
    AUTOSUGGEST_SOURCE["CONFLUENCE_AIFC"] = "confluence-aifc";
    AUTOSUGGEST_SOURCE["CONFLUENCE_AIFC_SLIDES"] = "confluence-aifc-slides";
    AUTOSUGGEST_SOURCE["CONFLUENCE_AIFC_WHITEBOARD"] = "confluence-aifc-whiteboard";
    AUTOSUGGEST_SOURCE["CONFLUENCE_AIFC_DATABASE"] = "confluence-aifc-database";
    AUTOSUGGEST_SOURCE["CONFLUENCE_AIFC_LIVE_DOC"] = "confluence-aifc-live-doc";
    return AUTOSUGGEST_SOURCE;
}({});
const $70c81957c9ee94b4$export$f3c4b70a2cbe1eb3 = 'thirdPartyConnectPrompt';
module.exports["ANALYTICS_CHANNEL"] = $70c81957c9ee94b4$export$85183a312807388d;
module.exports["SMART_LINK_ROVO_BUTTON_INTERACTION_SOURCE"] = $70c81957c9ee94b4$export$e86f3aae41de8a7;
module.exports["REMIX_INTERACTION_SOURCES"] = $70c81957c9ee94b4$export$5a1bc70923e441e9;
module.exports["isAllowedLaunchSource"] = $70c81957c9ee94b4$export$f57fd972b3024068;
module.exports["AUTOSUGGEST_SOURCE"] = $70c81957c9ee94b4$export$406073150b1a408;
module.exports["THIRD_PARTY_CONNECT_PROMPT_SUBJECT"] = $70c81957c9ee94b4$export$f3c4b70a2cbe1eb3;

});

parcelRegister("nl5f2", function(module, exports) {

var $1Pvvv = parcelRequire("1Pvvv");


var $5oT0d = parcelRequire("5oT0d");

const $0e75beeba4a8395f$var$isSourceAndAttributes = (x)=>{
    if (typeof x !== 'object' || x === null) return false;
    if (!('source' in x) || !('attributes' in x) || typeof x.attributes !== 'object' || x.attributes === null) return false;
    return (0, $5oT0d.ALLOWED_AI_MATE_SOURCES).includes(x.source);
};
const $0e75beeba4a8395f$export$d97c97ed77ff09e8 = (context)=>{
    if (!context || !Array.isArray(context)) return {};
    let contextsThatHaveAttributes = context.filter((x)=>$0e75beeba4a8395f$var$isSourceAndAttributes(x) || x[0, $1Pvvv.AI_MATE_CONTEXT]);
    return contextsThatHaveAttributes.reduce((acc, x)=>{
        return {
            ...acc,
            ...x[0, $1Pvvv.AI_MATE_CONTEXT]?.attributes ?? {},
            ...x.attributes ?? {}
        };
    }, {});
};
module.exports["getAttributesFromContexts"] = $0e75beeba4a8395f$export$d97c97ed77ff09e8;

});

parcelRegister("5oT0d", function(module, exports) {
const $19fd3c58da81b4e5$export$e31e24b63b7085fd = [
    'AIMate',
    'smart-create',
    'CSMAI',
    'CSMAIEmbed',
    'rovoServiceAgent',
    'solutionComposer'
];
module.exports["ALLOWED_AI_MATE_SOURCES"] = $19fd3c58da81b4e5$export$e31e24b63b7085fd;

});

parcelRegister("1XM8n", function(module, exports) {
/**
 * Determines the owning team for a failure event based on the experience task name,
 * error message, and optional attributes (e.g. actionKey).
 *
 * The rules are derived from the AIFC Top Baseline Errors report and use regex matching
 * to handle error messages that contain dynamic values (UUIDs, IDs, hashes, etc).
 *
 * @see https://hello.atlassian.net/wiki/spaces/ac8/pages/6822974693/Apr+13-14+2026+-+AIFC+Top+Baseline+Errors
 */ 
var $irnO2 = parcelRequire("irnO2");

var $8fc2212d0df9a0a6$export$e196c5257e9c94dd = /*#__PURE__*/ function(OwningTeam) {
    OwningTeam["AifcFoundations"] = "AIFC Foundations";
    OwningTeam["EditorAi"] = "Editor AI";
    OwningTeam["RovoChat"] = "Rovo Chat";
    OwningTeam["Whiteboards"] = "Whiteboards";
    OwningTeam["Databases"] = "Databases";
    OwningTeam["JiraAifc"] = "Jira AIFC";
    OwningTeam["Pulsar"] = "Pulsar";
    return OwningTeam;
}({});
/**
 * Step 1 — Experience-specific error rules.
 * These are checked first and only when the experience name matches.
 */ const $8fc2212d0df9a0a6$var$RULES_FOR_SPECIFIC_EXPERIENCES = [
    {
        pattern: /Something went wrong on Rovo's end. Please try sending your message again./i,
        team: "AIFC Foundations",
        experiences: [
            (0, $irnO2.ExperienceName).AIFC_GENERATE_CONTENT
        ]
    },
    {
        pattern: /The ConfluenceCreationTool was invoked, but valid content was not created for action key:.*whiteboard/i,
        team: "Whiteboards",
        experiences: [
            (0, $irnO2.ExperienceName).AIFC_GENERATE_CONTENT
        ]
    },
    {
        pattern: /The ConfluenceCreationTool was invoked, but valid content was not created for action key:.*database/i,
        team: "Databases",
        experiences: [
            (0, $irnO2.ExperienceName).AIFC_GENERATE_CONTENT
        ]
    },
    {
        pattern: /The ConfluenceCreationTool was invoked, but valid content was not created for action key:.*page/i,
        team: "AIFC Foundations",
        experiences: [
            (0, $irnO2.ExperienceName).AIFC_GENERATE_CONTENT
        ]
    },
    {
        pattern: /The orchestrator reached its depth limit and the ConfluenceCreationTool was not invoked./i,
        team: "AIFC Foundations",
        experiences: [
            (0, $irnO2.ExperienceName).AIFC_GENERATE_CONTENT
        ]
    },
    {
        pattern: /Could not create content of type \w+ in the Confluence staging area./i,
        team: "AIFC Foundations",
        experiences: [
            (0, $irnO2.ExperienceName).AIFC_GENERATE_CONTENT,
            (0, $irnO2.ExperienceName).AIFC_GENERATE_CONTENT_IN_CHAT
        ]
    },
    {
        pattern: /Message action error: [Code 400] convoai.rest.bad.request - Failed to update page: missing pageId and ADF content for actionKey:.*/i,
        team: "AIFC Foundations",
        experiences: [
            (0, $irnO2.ExperienceName).AIFC_UPDATE_CONTENT
        ]
    },
    {
        pattern: /Message action error: [Code 400] convoai.rest.bad.request - Failed to update page: missing pageId and ADF content for actionKey:.*/i,
        team: "Editor AI",
        experiences: [
            (0, $irnO2.ExperienceName).UPDATE_CONTENT_IN_CHAT
        ]
    },
    {
        pattern: /AIFC stream received edit tags but no elements were affected/i,
        team: "Whiteboards",
        experiences: [
            (0, $irnO2.ExperienceName).AIFC_UPDATE_CONTENT
        ]
    }
];
/**
 * Step 2 — Global error rules that apply across all experiences.
 */ const $8fc2212d0df9a0a6$var$GLOBAL_ERROR_MESSAGE_RULES = [
    {
        pattern: /network error/i,
        team: "Rovo Chat"
    },
    {
        pattern: /An error occurred. Please try again later./i,
        team: "Rovo Chat"
    },
    {
        pattern: /Failed to fetch/i,
        team: "Rovo Chat"
    },
    {
        pattern: /An unknown error occurred/i,
        team: "Rovo Chat"
    },
    {
        pattern: /\[Code 403\] {"code":403,"message":"You're unable to access content because your IP address is not listed in the IP allowlist. Contact your admin for help."}/i,
        team: "Rovo Chat"
    },
    {
        pattern: /AIFC stream received only preamble but no <todo_list>, SVG or whiteboards XML.*/i,
        team: "Whiteboards"
    },
    {
        pattern: /No sizing converter defined for element type 'mindmap'/i,
        team: "Whiteboards"
    },
    {
        pattern: /AIFC stream received edit tags but no elements were affected/i,
        team: "Whiteboards"
    },
    {
        pattern: /Could not find database:/i,
        team: "Databases"
    }
];
/**
 * Step 3 — Default team ownership per experience.
 * Used as a fallback when no error-pattern rule matches.
 */ const $8fc2212d0df9a0a6$var$DEFAULT_TEAM_FOR_EXPERIENCE = new Map([
    [
        (0, $irnO2.ExperienceName).AIFC_FINALIZE_CONTENT,
        "AIFC Foundations"
    ],
    [
        (0, $irnO2.ExperienceName).AIFC_ALL_DATA_HANDLED,
        "AIFC Foundations"
    ],
    [
        (0, $irnO2.ExperienceName).AIFC_GENERATE_CONTENT,
        "AIFC Foundations"
    ],
    [
        (0, $irnO2.ExperienceName).AIFC_GENERATE_CONTENT_IN_CHAT,
        "AIFC Foundations"
    ],
    [
        (0, $irnO2.ExperienceName).AIFC_INITIAL_DATA_RECEIVED,
        "AIFC Foundations"
    ],
    [
        (0, $irnO2.ExperienceName).AIFC_MODAL_SESSION,
        "AIFC Foundations"
    ],
    [
        (0, $irnO2.ExperienceName).AIFC_UPDATE_CONTENT,
        "AIFC Foundations"
    ],
    [
        (0, $irnO2.ExperienceName).UPDATE_CONTENT_IN_CHAT,
        "Editor AI"
    ],
    [
        (0, $irnO2.ExperienceName).PREVIEW_CARD_RENDER,
        "AIFC Foundations"
    ],
    [
        (0, $irnO2.ExperienceName).PREVIEW_CONTENT,
        "AIFC Foundations"
    ],
    [
        (0, $irnO2.ExperienceName).SEND_MESSAGE,
        "Rovo Chat"
    ],
    [
        (0, $irnO2.ExperienceName).SEND_TASK_MODE_MESSAGE,
        "Rovo Chat"
    ],
    [
        (0, $irnO2.ExperienceName).SEND_CONFIRMED_TOOLS_TASK_MODE_MESSAGE,
        "Rovo Chat"
    ],
    [
        (0, $irnO2.ExperienceName).LOAD_AUTO_SUGGEST_SKILLS_UNIFIED,
        "Rovo Chat"
    ],
    [
        (0, $irnO2.ExperienceName).LOAD_CHAT_PROMPT_INPUT_SKILLS,
        "Rovo Chat"
    ],
    [
        (0, $irnO2.ExperienceName).LOAD_INLINE_CHAT_PROMPT_INPUT_SKILLS,
        "Rovo Chat"
    ],
    [
        (0, $irnO2.ExperienceName).JIRA_SAVE_DRAFT_WORK_ITEM,
        "Jira AIFC"
    ],
    [
        (0, $irnO2.ExperienceName).JIRA_CREATE_WORK_ITEMS_BULK,
        "Jira AIFC"
    ],
    [
        (0, $irnO2.ExperienceName).ROVO_SKILLS_PLAN_WORK_ITEM_CREATE,
        "Jira AIFC"
    ],
    [
        (0, $irnO2.ExperienceName).ROVO_SKILLS_EXECUTION_WORK_ITEM_CREATE,
        "Jira AIFC"
    ],
    [
        (0, $irnO2.ExperienceName).SHARE_ARTIFACT_ACCESS_CHANGE,
        "Rovo Chat"
    ],
    [
        (0, $irnO2.ExperienceName).SHARE_ARTIFACT_SHARE_AUDIENCES,
        "Rovo Chat"
    ],
    [
        (0, $irnO2.ExperienceName).SHARE_ARTIFACT_REVOKE_AUDIENCES,
        "Rovo Chat"
    ],
    [
        (0, $irnO2.ExperienceName).DOWNLOAD_ARTIFACT,
        "Rovo Chat"
    ],
    [
        (0, $irnO2.ExperienceName).PREVIEW_ARTIFACT_SMART_LINK_RESOLVED,
        "Rovo Chat"
    ],
    [
        (0, $irnO2.ExperienceName).SHARE_CONVERSATION_SESSION,
        "Rovo Chat"
    ],
    [
        (0, $irnO2.ExperienceName).MANAGE_CONVERSATION_SHARES,
        "Rovo Chat"
    ],
    [
        (0, $irnO2.ExperienceName).VIEW_CONVERSATION_SHARE,
        "Rovo Chat"
    ],
    [
        (0, $irnO2.ExperienceName).ROVO_SKILLS_PLAN_WORK_ITEM_UPDATE,
        "Pulsar"
    ],
    [
        (0, $irnO2.ExperienceName).ROVO_SKILLS_EXECUTION_WORK_ITEM_UPDATE,
        "Pulsar"
    ]
]);
const $8fc2212d0df9a0a6$export$d6e429d0895093 = (errorMessage, experienceName)=>{
    if (!errorMessage) return $8fc2212d0df9a0a6$var$DEFAULT_TEAM_FOR_EXPERIENCE.get(experienceName);
    // Step 1: Experience-specific error-pattern rules
    if (experienceName) for (const rule of $8fc2212d0df9a0a6$var$RULES_FOR_SPECIFIC_EXPERIENCES){
        if (rule.experiences.includes(experienceName) && rule.pattern.test(errorMessage)) return rule.team;
    }
    // Step 2: Global error-pattern rules
    for (const rule of $8fc2212d0df9a0a6$var$GLOBAL_ERROR_MESSAGE_RULES){
        if (rule.pattern.test(errorMessage)) return rule.team;
    }
    // Step 3: Default team for this experience
    if (experienceName) return $8fc2212d0df9a0a6$var$DEFAULT_TEAM_FOR_EXPERIENCE.get(experienceName);
    return undefined;
};
module.exports["getOwningTeam"] = $8fc2212d0df9a0a6$export$d6e429d0895093;

});

parcelRegister("8YL3U", function(module, exports) {
class $f2446ffb8af04183$export$79c3dc6f15d36f18 {
    onVisibilityChange(isHidden) {
        const now = performance.now();
        if (isHidden) {
            if (this.lastHiddenAt === null) this.lastHiddenAt = now;
            if (this.firstHiddenOffsetMs === null) this.firstHiddenOffsetMs = now - this.startTime;
        } else if (this.lastHiddenAt !== null) {
            this.totalHiddenMs += now - this.lastHiddenAt;
            this.lastHiddenAt = null;
        }
    }
    getAttributes(doc) {
        const now = performance.now();
        const elapsed = now - this.startTime;
        let totalHiddenMs = this.totalHiddenMs;
        if (this.lastHiddenAt !== null) totalHiddenMs += now - this.lastHiddenAt;
        const tabHiddenProportion = elapsed > 0 ? totalHiddenMs / elapsed : 0;
        return {
            isActiveTab: doc ? doc.visibilityState === 'visible' : true,
            tabHiddenProportion: tabHiddenProportion,
            tabFirstHiddenOffsetMs: this.firstHiddenOffsetMs
        };
    }
    constructor(doc){
        this.startTime = void 0;
        this.totalHiddenMs = 0;
        this.lastHiddenAt = void 0;
        this.firstHiddenOffsetMs = void 0;
        this.startTime = performance.now();
        const isHidden = doc?.visibilityState === 'hidden';
        this.lastHiddenAt = isHidden ? this.startTime : null;
        this.firstHiddenOffsetMs = isHidden ? 0 : null;
    }
}
module.exports["TabVisibilityTracker"] = $f2446ffb8af04183$export$79c3dc6f15d36f18;

});

parcelRegister("lJ6db", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");



var $cozmU = parcelRequire("cozmU");


var $6cFsl = parcelRequire("6cFsl");


var $cXtTj = parcelRequire("cXtTj");


var $iDrrr = parcelRequire("iDrrr");


var $a33Aa = parcelRequire("a33Aa");


var $bjY3F = parcelRequire("bjY3F");


var $hlvTd = parcelRequire("hlvTd");


var $5XWbo = parcelRequire("5XWbo");


var $bxkJA = parcelRequire("bxkJA");


var $8A2GO = parcelRequire("8A2GO");


var $jTKfH = parcelRequire("jTKfH");


var $5rzIE = parcelRequire("5rzIE");


var $7zss8 = parcelRequire("7zss8");


var $gB5in = parcelRequire("gB5in");


var $12PUp = parcelRequire("12PUp");


var $fDfQA = parcelRequire("fDfQA");


var $emCLk = parcelRequire("emCLk");


var $bQQtO = parcelRequire("bQQtO");


var $5suST = parcelRequire("5suST");


var $irsyK = parcelRequire("irsyK");


var $7td41 = parcelRequire("7td41");


var $bkEBw = parcelRequire("bkEBw");

const $a1ccb2b7a1450c9c$var$addRequestBreadcrumb = ({ durationMs: durationMs, lifecycle: lifecycle, options: options, status: status })=>{
    (0, $hlvTd.addSentryBreadcrumb)({
        category: 'request',
        data: {
            durationMs: durationMs === undefined ? undefined : Math.round(durationMs),
            lifecycle: lifecycle,
            method: (options.options.method ?? 'GET').toUpperCase(),
            operation: options.holdName,
            route: (0, $5rzIE.normalizeRequestRoute)(options.path),
            status: status
        },
        message: `${options.options.method ?? 'GET'} ${options.holdName ?? (0, $5rzIE.normalizeRequestRoute)(options.path)} ${lifecycle}`,
        type: 'http'
    });
};
const $a1ccb2b7a1450c9c$var$observeStreamLifecycle = async function*(generator, options) {
    const startedAt = performance.now();
    let firstDataReceived = false;
    let lifecycleEnded = false;
    $a1ccb2b7a1450c9c$var$addRequestBreadcrumb({
        lifecycle: 'started',
        options: options
    });
    try {
        for await (const value of generator){
            if (!firstDataReceived) {
                firstDataReceived = true;
                $a1ccb2b7a1450c9c$var$addRequestBreadcrumb({
                    durationMs: performance.now() - startedAt,
                    lifecycle: 'firstData',
                    options: options
                });
            }
            yield value;
        }
        lifecycleEnded = true;
        $a1ccb2b7a1450c9c$var$addRequestBreadcrumb({
            durationMs: performance.now() - startedAt,
            lifecycle: options.options.signal?.aborted ? 'abort' : 'completed',
            options: options
        });
    } catch (error) {
        lifecycleEnded = true;
        $a1ccb2b7a1450c9c$var$addRequestBreadcrumb({
            durationMs: performance.now() - startedAt,
            lifecycle: error instanceof Error && error.name === 'AbortError' ? 'abort' : error instanceof Error && /timeout/i.test(error.name) ? 'timedOut' : 'error',
            options: options
        });
        throw error;
    } finally{
        if (!lifecycleEnded) $a1ccb2b7a1450c9c$var$addRequestBreadcrumb({
            durationMs: performance.now() - startedAt,
            lifecycle: options.options.signal?.aborted ? 'abort' : 'cancelled',
            options: options
        });
    }
};
const $a1ccb2b7a1450c9c$var$PRODUCT_HEADER = 'x-product';
/** Number of tasks to request per page when using cursor-based pagination. */ const $a1ccb2b7a1450c9c$var$TASKS_PAGE_SIZE = 25;
const $a1ccb2b7a1450c9c$var$LIBRARY_PAGE_SIZE = 25;
const $a1ccb2b7a1450c9c$var$EXPERIENCE_ID_HEADER = 'x-experience-id';
const $a1ccb2b7a1450c9c$var$CHANNEL_ID_HEADER = 'X-Channel-Id';
const $a1ccb2b7a1450c9c$var$CLOUD_ID_HEADER = 'x-cloudid';
const $a1ccb2b7a1450c9c$var$AGENT_SESSION_STATE_VALUES = new Set([
    'WORKING',
    'INPUT_REQUIRED',
    'ARTEFACT_READY',
    'AUTH_REQUIRED',
    'FAILED',
    'REJECTED',
    'COMPLETED',
    'CANCELLED',
    'UNKNOWN'
]);
const $a1ccb2b7a1450c9c$var$isAgentSessionState = (value)=>$a1ccb2b7a1450c9c$var$AGENT_SESSION_STATE_VALUES.has(value);
const $a1ccb2b7a1450c9c$var$hasCloudIdHeader = (headers)=>Object.keys(headers).some((name)=>name.toLowerCase() === $a1ccb2b7a1450c9c$var$CLOUD_ID_HEADER);
const $a1ccb2b7a1450c9c$var$DEFAULT_FILE_VALIDATE_PATH = '/rovo/v1/chat/message/file/validate';
const $a1ccb2b7a1450c9c$var$DEFAULT_FILE_UPLOAD_PATH = '/rovo/v1/chat/message/file';
class $a1ccb2b7a1450c9c$export$40a7802808e2fbe3 {
    createHeaders(init) {
        const configHeaders = this.config.headers || {};
        return new Headers({
            [$a1ccb2b7a1450c9c$var$PRODUCT_HEADER]: this.config.product,
            [$a1ccb2b7a1450c9c$var$EXPERIENCE_ID_HEADER]: this.config.experienceId,
            ...this.config.siteId && (0, $iDrrr.fg)('rovo_chat_site_switch_reset') && !$a1ccb2b7a1450c9c$var$hasCloudIdHeader(configHeaders) ? {
                [$a1ccb2b7a1450c9c$var$CLOUD_ID_HEADER]: this.config.siteId
            } : {},
            ...configHeaders,
            ...this.config.channelId ? {
                [$a1ccb2b7a1450c9c$var$CHANNEL_ID_HEADER]: this.config.channelId
            } : {},
            ...init
        });
    }
    getChannelId(defaultChannelId) {
        return this.config.channelId || defaultChannelId;
    }
    async fetch({ path: path, options: options, holdName: holdName, baseUrl: requestBaseUrl }) {
        const { baseUrl: configBaseUrl, credentials: configCredentials } = this.config;
        const baseUrl = requestBaseUrl ?? configBaseUrl;
        const requestUrl = (0, $irsyK.addPath)(baseUrl, path);
        const startTime = performance.now();
        try {
            const response = await window.fetch(requestUrl, {
                credentials: configCredentials,
                ...options
            });
            if (this.config.labelStack) {
                // Please note that the recorded duration of this hold may differ from the time spent actually fetching the data.
                // This is because the browser may schedule network calls and JavaScript execution at its own discrection based
                // on available resources, the main thread being blocked, etc... Still, it is a helpful approximation.
                const endTime = performance.now();
                (0, $a33Aa.addSpanToAll)('fetch', holdName ? `${options.method}-${holdName}` : 'unknown', this.config.labelStack, startTime, endTime);
            }
            const processedResponse = await (0, $irsyK.processResponse)({
                response: response
            });
            $a1ccb2b7a1450c9c$var$addRequestBreadcrumb({
                durationMs: performance.now() - startTime,
                lifecycle: 'success',
                options: {
                    path: path,
                    options: options,
                    holdName: holdName
                },
                status: response.status
            });
            return processedResponse;
        } catch (error) {
            $a1ccb2b7a1450c9c$var$addRequestBreadcrumb({
                durationMs: performance.now() - startTime,
                lifecycle: error instanceof (0, $8A2GO.ApiError) ? 'httpError' : error instanceof Error && error.name === 'AbortError' ? 'abort' : 'networkError',
                options: {
                    path: path,
                    options: options,
                    holdName: holdName
                },
                status: error instanceof (0, $8A2GO.ApiError) ? error.errorAttributes.statusCode : undefined
            });
            throw error;
        }
    }
    async fetchJson(options) {
        const response = await this.fetch(options);
        const json = await response.json();
        return json;
    }
    async getConversationSharePreview(_payload) {
        throw new (0, $8A2GO.ApiError)('Share preview not found', {
            statusCode: 404
        });
    }
    async getConversationShareMetadata(_payload) {
        throw new (0, $8A2GO.ApiError)('Share metadata not found', {
            statusCode: 404
        });
    }
    async fetchStream(options, config) {
        const response = await this.fetch(options);
        const contentType = response.headers.get('content-type') ?? '';
        const headerSuggestsSSE = config?.useSSE && contentType.includes('text/event-stream');
        return {
            responseData: {
                traceId: (0, $jTKfH.getTraceIdFromResponse)(response)
            },
            generator: headerSuggestsSSE ? $a1ccb2b7a1450c9c$var$observeStreamLifecycle((0, $emCLk.readSSEStream)(response), options) : $a1ccb2b7a1450c9c$var$observeStreamLifecycle((0, $fDfQA.readJsonStream)(response), options)
        };
    }
    constructor(props){
        this.config = void 0;
        this.getConfig = ()=>{
            return {
                ...this.config
            };
        };
        const defaultBaseUrl = '/gateway/api/assist';
        const defaultConfig = {
            baseUrl: defaultBaseUrl,
            headers: {}
        };
        this.config = {
            ...props,
            baseUrl: props.baseUrl || defaultConfig.baseUrl,
            credentials: props.credentials,
            headers: {
                ...props.headers || defaultConfig.headers
            }
        };
    }
}
class $a1ccb2b7a1450c9c$export$a522c5f4ccda1c94 extends $a1ccb2b7a1450c9c$export$40a7802808e2fbe3 {
    async sendMessageStream({ agentNamedId: agentNamedId, agentId: agentId, message: message, autoActionApprovalMode: autoActionApprovalMode, mimeType: mimeType, conversationId: conversationId, controller: controller, storeMessage: storeMessage = false, citationsEnabled: citationsEnabled = true, aiFeatureContext: aiFeatureContext, jiraWorkflowContext: jiraWorkflowContext, editorContext: editorContext, whiteboardContext: whiteboardContext, slidesContext: slidesContext, databaseContext: databaseContext, browserContext: browserContext, additionalContext: additionalContext, writingStyleContext: writingStyleContext, dashboardContext: dashboardContext, dashboardEditorContext: dashboardEditorContext, fileIds: fileIds, webSearchEnabled: webSearchEnabled, sourceMode: sourceMode, deepResearchEnabled: deepResearchEnabled, thinkDeeperEnabled: thinkDeeperEnabled, alphaExtendedThinkingMode: alphaExtendedThinkingMode, fastModeEnabled: fastModeEnabled, planModeEnabled: planModeEnabled, conciergeEnabled: conciergeEnabled, appFilters: appFilters, selectedCloudIds: selectedCloudIds, useCurrentBrowsingContext: useCurrentBrowsingContext, minionAliasConfig: minionAliasConfig, optInToDeepResearchV2: optInToDeepResearchV2 = false, optInThinkDeeperMessages: optInThinkDeeperMessages = false, optInAnsNow: optInAnsNow = false, optInNewToolTraces: optInNewToolTraces = false, optInNewTeamworkTraceIcons: optInNewTeamworkTraceIcons = false, browserContextSanitizer: browserContextSanitizer, optInSSEStream: optInSSEStream = false, agentVersion: agentVersion, spaceId: spaceId, capabilities: capabilities, shouldExtractConversationScopes: shouldExtractConversationScopes, browserDisplayContextActive: browserDisplayContextActive, searchArtifact: searchArtifact, artifactContext: artifactContext, parentMessageId: parentMessageId, requestedSkills: requestedSkills, commentMentionContext: commentMentionContext }) {
        const effectiveCapabilities = (0, $5suST.buildEffectiveCapabilities)(capabilities);
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8',
            [$a1ccb2b7a1450c9c$var$CHANNEL_ID_HEADER]: this.getChannelId('rovo-chat'),
            // This header is used to opt-in to Deep Research v2 on the BE.
            // This is to ensure that we don't use v2 deep research when we are using the old Rovo Chat UI prior to the refresh..
            ...optInToDeepResearchV2 && {
                'X-Deep-Research-V2-Opt-In': 'true'
            },
            // Opt in to using RESEARCH_STEP, RESEARCH_PLAN, and similar messages for "think deeper".
            // Ensures backward compatibility with legacy clients and allows application targeting within the experiment.
            ...optInThinkDeeperMessages && {
                'X-Think-Deeper-Messages-Opt-In': 'true'
            },
            ...optInAnsNow && {
                'X-Answer-Now-UI-Opt-In': 'true'
            },
            ...optInNewToolTraces && {
                'X-New-Tool-Traces-Opt-In': 'true'
            },
            ...optInNewTeamworkTraceIcons && {
                'X-New-Teamwork-Trace-Icons-Opt-In': 'true'
            },
            ...effectiveCapabilities && effectiveCapabilities.length > 0 && {
                'X-Rovo-Chat-Capabilities': JSON.stringify(effectiveCapabilities)
            }
        });
        let knowledgeOverride = {};
        // not setting knowledgeEnabled and filters means all org knowledge is applied by default.
        if (appFilters) {
            if (appFilters.length === 0) knowledgeOverride = {
                knowledgeEnabled: false
            };
            else knowledgeOverride = {
                knowledgeEnabled: true,
                filters: {
                    knowledgeSources: appFilters
                }
            };
        }
        const selectedCloudIdsOverride = (0, $iDrrr.fg)((0, $5XWbo.ROVO_CHAT_SITES_SOURCE_FILTER_GATE)) && selectedCloudIds && selectedCloudIds.length > 0 ? {
            selectedCloudIds: selectedCloudIds.map((cloudId)=>({
                    cloudId: cloudId
                }))
        } : {};
        const { browserUrl: url, isBrowserContextBlocklisted: isBrowserContextBlocklisted } = (0, $bQQtO.resolveMessageStreamBrowserUrl)({
            browserContext: browserContext,
            browserContextSanitizer: browserContextSanitizer,
            product: this.getConfig().product
        });
        const defaultMimeType = typeof message === 'string' ? 'text/markdown' : 'text/adf';
        const body = {
            content: message,
            context: (0, $gB5in.buildMessageStreamRequestContext)({
                browserUrl: url,
                autoActionApprovalMode: autoActionApprovalMode,
                useCurrentBrowsingContext: useCurrentBrowsingContext,
                webSearchEnabled: webSearchEnabled,
                sourceMode: sourceMode,
                deepResearchEnabled: deepResearchEnabled,
                thinkDeeperEnabled: thinkDeeperEnabled,
                alphaExtendedThinkingMode: alphaExtendedThinkingMode,
                fastModeEnabled: fastModeEnabled,
                planModeEnabled: planModeEnabled,
                editorContext: editorContext,
                whiteboardContext: whiteboardContext,
                slidesContext: slidesContext,
                databaseContext: databaseContext,
                dashboardEditorContext: dashboardEditorContext,
                browserContext: browserContext,
                isBrowserContextBlocklisted: isBrowserContextBlocklisted,
                jiraWorkflowContext: jiraWorkflowContext,
                additionalContext: additionalContext,
                writingStyleContext: writingStyleContext,
                dashboardContext: dashboardContext,
                aiFeatureContext: aiFeatureContext,
                fileIds: fileIds,
                knowledgeOverride: knowledgeOverride,
                selectedCloudIdsOverride: selectedCloudIdsOverride,
                searchArtifact: searchArtifact,
                artifactContext: artifactContext,
                shouldExtractConversationScopes: shouldExtractConversationScopes
            }),
            recipient_agent_named_id: agentNamedId,
            agent_id: agentId,
            // Preserve omitted Concierge state for clients that use default routing; serialize
            // explicit false because the UI toggle is an opt-in control.
            ...conciergeEnabled !== undefined ? {
                concierge_enabled: conciergeEnabled
            } : {},
            mimeType: mimeType && (0, $iDrrr.fg)('jira_ai_rendering_a2ui') ? mimeType : defaultMimeType,
            ...agentVersion ? {
                agent_version: agentVersion
            } : {},
            // don't allow store message if feature flag is off
            store_message: (0, $iDrrr.fg)('ai_mate_show_store_messages') ? storeMessage : false,
            citations_enabled: citationsEnabled,
            ...minionAliasConfig ?? (this.getConfig().minionAlias ? {
                stratus_config: {
                    minion_alias: this.getConfig().minionAlias
                }
            } : {}),
            ...spaceId ? {
                space_id: spaceId
            } : {},
            ...parentMessageId ? {
                parent_message_id: parentMessageId
            } : {},
            ...requestedSkills?.length ? {
                skills: requestedSkills
            } : {},
            ...commentMentionContext ? {
                comment_mention_context: commentMentionContext
            } : {},
            ...browserDisplayContextActive !== undefined ? {
                browser_display_context_active: browserDisplayContextActive
            } : {}
        };
        const options = {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(body),
            signal: controller?.signal
        };
        return this.fetchStream({
            path: optInSSEStream ? `/rovo/v1/chat/conversation/${conversationId}/message/stream/sse` : `/rovo/v1/chat/conversation/${conversationId}/message/stream`,
            options: options
        }, {
            useSSE: optInSSEStream
        });
    }
    async reconnectToMessageStream({ conversationId: conversationId, messageId: messageId, lastEventId: lastEventId, controller: controller }) {
        const headers = this.createHeaders();
        // Add Last-Event-ID header if available
        if (lastEventId) headers.set('Last-Event-ID', lastEventId);
        const options = {
            method: 'GET',
            headers: headers,
            signal: controller?.signal
        };
        return this.fetchStream({
            path: `/rovo/v1/chat/conversation/${conversationId}/message/${messageId}/stream/sse`,
            options: options
        }, {
            useSSE: true
        });
    }
    // Only takes effect if the stream is a Deep Research stream
    async cancelMessageStream({ conversationId: conversationId, messageId: messageId }) {
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8'
        });
        const options = {
            method: 'POST',
            headers: headers
        };
        await this.fetch({
            path: `/rovo/v1/chat/conversation/${conversationId}/message/${messageId}/cancel`,
            options: options
        });
    }
    async sendMessageConfirmedTools({ conversationId: conversationId, agentId: agentId, controller: controller, confirmed_tools: confirmed_tools, optInSSEStream: optInSSEStream = false, storeMessage: storeMessage = false, webSearchEnabled: webSearchEnabled, deepResearchEnabled: deepResearchEnabled, thinkDeeperEnabled: thinkDeeperEnabled, alphaExtendedThinkingMode: alphaExtendedThinkingMode, fastModeEnabled: fastModeEnabled, planModeEnabled: planModeEnabled, conciergeEnabled: conciergeEnabled, aiFeatureContext: aiFeatureContext, agentVersion: agentVersion, optInToDeepResearchV2: optInToDeepResearchV2 = false, optInThinkDeeperMessages: optInThinkDeeperMessages = false, optInAnsNow: optInAnsNow = false, optInNewToolTraces: optInNewToolTraces = false, optInNewTeamworkTraceIcons: optInNewTeamworkTraceIcons = false, capabilities: capabilities, searchArtifact: searchArtifact, jiraWorkflowContext: jiraWorkflowContext, editorContext: editorContext, whiteboardContext: whiteboardContext, slidesContext: slidesContext, databaseContext: databaseContext, browserContext: browserContext, additionalContext: additionalContext, dashboardContext: dashboardContext, dashboardEditorContext: dashboardEditorContext, useCurrentBrowsingContext: useCurrentBrowsingContext, browserContextSanitizer: browserContextSanitizer }) {
        const effectiveCapabilities = (0, $5suST.buildEffectiveCapabilities)(capabilities);
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8',
            [$a1ccb2b7a1450c9c$var$CHANNEL_ID_HEADER]: this.getChannelId('rovo-chat'),
            ...optInToDeepResearchV2 && {
                'X-Deep-Research-V2-Opt-In': 'true'
            },
            ...optInThinkDeeperMessages && {
                'X-Think-Deeper-Messages-Opt-In': 'true'
            },
            ...optInAnsNow && {
                'X-Answer-Now-UI-Opt-In': 'true'
            },
            ...optInNewToolTraces && {
                'X-New-Tool-Traces-Opt-In': 'true'
            },
            ...optInNewTeamworkTraceIcons && {
                'X-New-Teamwork-Trace-Icons-Opt-In': 'true'
            },
            ...effectiveCapabilities && effectiveCapabilities.length > 0 && {
                'X-Rovo-Chat-Capabilities': JSON.stringify(effectiveCapabilities)
            }
        });
        // browser_url is historically the current window location. The blocklist gates the page
        // browser context added when a browserContext is supplied. The NO-URL sentinel under the
        // `jira_free_gen_editor` experiment suppresses the URL (matching sendMessageStream) so that
        // cohort does not leak a URL.
        const browserUrl = browserContext?.context?.browserUrl;
        const isBrowserContextBlocklisted = !!(browserUrl && browserContextSanitizer?.isBlocklisted(browserUrl));
        const isBrowserUrlSuppressed = browserUrl === 'NO-URL' && (0, $cXtTj.default).getExperimentValue('jira_free_gen_editor', 'isEnabled', false);
        const url = isBrowserUrlSuppressed ? '' : window?.location?.href;
        const isBrowserSelectionContextGateEnabled = (0, $iDrrr.fg)('rovo_chat_browser_selection_context');
        const browserSelection = isBrowserSelectionContextGateEnabled ? browserContext?.context?.selection : undefined;
        const body = {
            conversation_id: conversationId,
            agent_id: agentId,
            ...conciergeEnabled !== undefined ? {
                concierge_enabled: conciergeEnabled
            } : {},
            confirmed_tools: confirmed_tools,
            ...agentVersion ? {
                agent_version: agentVersion
            } : {},
            context: {
                browser_url: url,
                webSearchEnabled: webSearchEnabled,
                ...deepResearchEnabled ? {
                    deepResearchEnabled: deepResearchEnabled
                } : {},
                ...thinkDeeperEnabled ? {
                    extendedThinkingEnabled: thinkDeeperEnabled
                } : {},
                ...alphaExtendedThinkingMode ? {
                    alphaExtendedThinkingMode: alphaExtendedThinkingMode
                } : {},
                ...planModeEnabled ? {
                    planModeEnabled: planModeEnabled,
                    alphaExtendedThinkingMode: 'MARATHON',
                    extendedThinkingEnabled: true
                } : {},
                ...fastModeEnabled ? {
                    fastModeEnabled: fastModeEnabled
                } : {},
                ...aiFeatureContext ? {
                    aiFeatureContext: aiFeatureContext
                } : {},
                ...searchArtifact ? {
                    search_artifact: searchArtifact
                } : {},
                // Full request context — supplied by the store action so the backend receives
                // the same page/whiteboard/creation context as a regular sendMessage. Every
                // field is omitted when undefined, so the slim request above is unaffected.
                ...useCurrentBrowsingContext === undefined ? {} : {
                    useCurrentBrowsingContext: useCurrentBrowsingContext
                },
                // Content-context objects. Inlined to mirror sendMessageStream's serialization
                // exactly; a unit test (the drift guard) asserts the two stay in sync. Each is
                // omitted when undefined, so the slim request above is unaffected.
                ...editorContext ? {
                    editor: editorContext
                } : {},
                ...whiteboardContext ? {
                    whiteboardContext: whiteboardContext
                } : {},
                ...slidesContext ? {
                    slidesContext: slidesContext
                } : {},
                ...databaseContext ? {
                    databaseContext: databaseContext
                } : {},
                ...dashboardEditorContext ? {
                    dashboardEditorContext: dashboardEditorContext
                } : {},
                ...browserContext && !isBrowserContextBlocklisted ? {
                    browser: {
                        htmlBody: browserContext.context?.htmlBody,
                        canvasText: browserContext.context?.canvasText,
                        ...browserSelection ? {
                            selection: browserSelection
                        } : {}
                    }
                } : {},
                jiraWorkflowContext: jiraWorkflowContext,
                ...additionalContext,
                dashboardContext: dashboardContext
            },
            // These values are hardcoded because they are not used in backend, but required in the contract
            content: '',
            mimeType: 'text/markdown',
            // don't allow store message if feature flag is off
            store_message: (0, $iDrrr.fg)('ai_mate_show_store_messages') ? storeMessage : false,
            citations_enabled: false
        };
        const options = {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(body),
            signal: controller?.signal
        };
        return this.fetchStream({
            path: optInSSEStream ? `/rovo/v1/chat/conversation/${conversationId}/message/stream/sse` : `/rovo/v1/chat/conversation/${conversationId}/message/stream`,
            options: options
        }, {
            useSSE: optInSSEStream
        });
    }
    async nlCreateAgentStream({ controller: controller, latest_user_message: latest_user_message, draft_agent: draft_agent, conversation_history: conversation_history }) {
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8'
        });
        const body = {
            latest_user_message: latest_user_message,
            draft_agent: draft_agent,
            conversation_history: conversation_history
        };
        const options = {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(body),
            signal: controller?.signal
        };
        return this.fetchStream({
            path: `/rovo/v1/agents/nlcreate`,
            options: options
        });
    }
    async getChat(conversationId, capabilities) {
        // Forward the caller-provided chat capabilities (e.g. `inline_lumina_enabled`,
        // which is gated behind `rovo_chat_enable_inline_lumina`) so that fetching a
        // chat from history renders the same rich (Lumina) components as a live stream,
        // rather than downgrading to basic markdown.
        //
        // Forward capabilities as-is: buildEffectiveCapabilities adds send-only
        // capabilities that should not be attached to a history read.
        const headers = this.createHeaders({
            ...capabilities && capabilities.length > 0 && {
                'X-Rovo-Chat-Capabilities': JSON.stringify(capabilities)
            }
        });
        const options = {
            method: 'GET',
            headers: headers
        };
        const path = `/rovo/v1/chat/conversation/${conversationId}/messages`;
        const rawChat = await this.fetchJson({
            path: path,
            options: options,
            holdName: 'rovo-v1-chat-conversation-[conversationId]-messages'
        });
        const chatArray = rawChat.items;
        return chatArray.map((message)=>(0, $bxkJA.isHumanMessage)(message) ? message : (0, $bkEBw.toStreamResponse)(message));
    }
    async deleteChat(conversationId, controller) {
        const headers = this.createHeaders();
        const options = {
            method: 'DELETE',
            headers: headers,
            signal: controller?.signal
        };
        await this.fetch({
            path: `/rovo/v1/chat/conversation/${conversationId}`,
            options: options,
            holdName: 'rovo-v1-chat-conversation-[conversationId]'
        });
    }
    async getAgents(controller) {
        const headers = this.createHeaders();
        const options = {
            method: 'GET',
            headers: headers,
            signal: controller?.signal
        };
        const response = await this.fetchJson({
            path: '/rovo/v1/agents',
            options: options,
            holdName: 'rovo-v1-agents'
        });
        return response.items;
    }
    async getAgentDetails(id, controller) {
        const headers = this.createHeaders();
        const options = {
            method: 'GET',
            headers: headers,
            signal: controller?.signal
        };
        return this.fetchJson({
            path: `/rovo/v1/agents/${id}`,
            options: options,
            holdName: 'rovo-v1-agents-[id]'
        });
    }
    async getAgentDetailsByIdentityAccountId(identityAccountId, controller) {
        const headers = this.createHeaders();
        const options = {
            method: 'GET',
            headers: headers,
            signal: controller?.signal
        };
        return this.fetchJson({
            path: `/rovo/v1/agents/accountid/${identityAccountId}`,
            options: options,
            holdName: 'rovo-v1-agents-accountid-[identityAccountId]'
        });
    }
    async createAgent(payload, controller) {
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8'
        });
        const options = {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(payload),
            signal: controller?.signal
        };
        return this.fetchJson({
            path: '/rovo/v1/agents',
            options: options,
            holdName: 'rovo-v1-agents'
        });
    }
    async updateAgent(id, payload, controller) {
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8'
        });
        const options = {
            method: 'PUT',
            headers: headers,
            body: JSON.stringify(payload),
            signal: controller?.signal
        };
        const response = await this.fetchJson({
            path: `/rovo/v1/agents/${id}`,
            options: options,
            holdName: 'rovo-v1-agents-[id]'
        });
        return response;
    }
    async deleteAgent(id, controller) {
        const headers = this.createHeaders();
        const options = {
            method: 'DELETE',
            headers: headers,
            signal: controller?.signal
        };
        return this.fetchJson({
            path: `/rovo/v1/agents/${id}`,
            options: options,
            holdName: 'rovo-v1-agents-[id]'
        });
    }
    async favouriteAgent(id, controller) {
        const headers = this.createHeaders();
        const options = {
            method: 'POST',
            headers: headers,
            signal: controller?.signal
        };
        this.fetch({
            path: `/rovo/v1/agents/${id}/favourite`,
            options: options,
            holdName: 'rovo-v1-agents-[id]-favourite'
        });
    }
    async unfavouriteAgent(id, controller) {
        const headers = this.createHeaders();
        const options = {
            method: 'DELETE',
            headers: headers,
            signal: controller?.signal
        };
        this.fetch({
            path: `/rovo/v1/agents/${id}/favourite`,
            options: options,
            holdName: 'rovo-v1-agents-[id]-favourite'
        });
    }
    async createConversationChannel(options) {
        const name = options && 'name' in options ? options.name : (0, $7td41.generateConversationName)();
        return this.fetchJson({
            path: `/rovo/v1/chat/conversation`,
            options: {
                method: 'POST',
                headers: this.createHeaders({
                    'content-type': 'application/json;charset=UTF-8',
                    [$a1ccb2b7a1450c9c$var$CHANNEL_ID_HEADER]: this.getChannelId('rovo-chat')
                }),
                body: JSON.stringify({
                    name: name,
                    dialogues: options?.dialogues ?? undefined,
                    tags: options?.tags,
                    agent_id: options?.agentId
                })
            },
            holdName: 'rovo-v1-chat-conversation'
        });
    }
    async getConversationChannels(options) {
        const searchParams = new URLSearchParams();
        if (options?.limit !== undefined) searchParams.set('limit', String(options.limit));
        if (options?.cursor !== undefined) searchParams.set('cursor', options.cursor);
        const queryString = searchParams.toString();
        const result = await this.fetchJson({
            path: `/rovo/v1/chat/conversations${queryString ? `?${queryString}` : ''}`,
            options: {
                method: 'GET',
                headers: this.createHeaders()
            },
            holdName: 'rovo-v1-chat-conversations'
        });
        // Transform snake_case fields to camelCase
        return {
            items: result.items.map((item)=>this.transformSnakeCaseToCamelCase(item)),
            hasNext: result.hasNext ?? false,
            cursor: result.cursor ?? null
        };
    }
    async getPinnedConversationSummary() {
        try {
            const result = await this.fetchJson({
                path: '/rovo/v1/chat/conversations/pinned-summary',
                options: {
                    method: 'GET',
                    headers: this.createHeaders()
                },
                holdName: 'rovo-v1-chat-conversations-pinned-summary'
            });
            return {
                pinnedCount: result.pinned_count ?? 0,
                maxPinnedConversations: result.max_pinned_conversations ?? 0
            };
        } catch (error) {
            // The endpoint not being deployed yet surfaces as a 404 — ignore that (callers fall back to
            // the local pinned count). Any other failure is genuine, so rethrow rather than swallow it
            // silently, letting the caller report/handle it.
            const statusCode = error instanceof (0, $8A2GO.ApiError) ? error.errorAttributes?.statusCode : undefined;
            if (statusCode === 404) return undefined;
            throw error;
        }
    }
    updateConversationChannel(id, payload) {
        // Transform camelCase field names to snake_case for the REST API
        const apiPayload = this.transformCamelCaseToSnakeCase(payload);
        return this.fetchJson({
            path: `/rovo/v1/chat/conversation/${id}`,
            options: {
                method: 'PUT',
                headers: this.createHeaders({
                    'content-type': 'application/json;charset=UTF-8'
                }),
                body: JSON.stringify(apiPayload)
            },
            holdName: 'rovo-v1-chat-conversation-[id]'
        }).then((response)=>this.transformSnakeCaseToCamelCase(response));
    }
    transformCamelCaseToSnakeCase(payload) {
        const result = {};
        for (const [key, value] of Object.entries(payload)){
            if (key === 'readStatus') result['read_status'] = value;
            else if (key === 'isPinned') result['is_pinned'] = value;
            else if (key === 'pinnedAt') result['pinned_at'] = value;
            else if (key === 'sourceMode') result['source_mode'] = value;
            else result[key] = value;
        }
        return result;
    }
    transformSnakeCaseToCamelCase(item) {
        if (item == null || typeof item !== 'object') throw new Error(`Expected an object from conversation channel API, got: ${typeof item}`);
        const result = {
            ...item
        };
        if ('read_status' in result) {
            result['readStatus'] = result['read_status'];
            delete result['read_status'];
        }
        if ('is_pinned' in result) {
            result['isPinned'] = result['is_pinned'];
            delete result['is_pinned'];
        }
        if ('pinned_at' in result) {
            result['pinnedAt'] = result['pinned_at'];
            delete result['pinned_at'];
        }
        if ('source_mode' in result) {
            result['sourceMode'] = result['source_mode'];
            delete result['source_mode'];
        }
        const agentSessionState = result['agent_session_state'];
        delete result['agent_session_state'];
        delete result['agentSessionState'];
        if ($a1ccb2b7a1450c9c$var$isAgentSessionState(agentSessionState)) result['agentSessionState'] = agentSessionState;
        else if (agentSessionState != null) (0, $hlvTd.logSentryConsoleWarning)('Unknown agent session state returned by conversation channel API:', agentSessionState);
        return result;
    }
    async resolveConversationAction(id, payload) {
        return this.fetchJson({
            path: `/rovo/v1/chat/conversation/${id}/action`,
            options: {
                method: 'POST',
                headers: this.createHeaders({
                    'content-type': 'application/json;charset=UTF-8'
                }),
                body: JSON.stringify({
                    ...payload,
                    context: {
                        ...payload.context,
                        browser_url: window.location.href
                    }
                })
            },
            holdName: 'rovo-v1-chat-conversation-[id]-action'
        });
    }
    async bulkResolveConversationUIActions(conversationId, messageId, payload) {
        // The bulk API supports a maximum of 50 items per request.
        // Split into batches and process them sequentially.
        const BATCH_SIZE = 50;
        const allResponses = [];
        for(let batchStart = 0; batchStart < payload.items.length; batchStart += BATCH_SIZE){
            const batchItems = payload.items.slice(batchStart, batchStart + BATCH_SIZE);
            const batchResponses = await this.fetchJson({
                path: `/rovo/v1/chat/conversation/${conversationId}/message/${messageId}/tools/resolution`,
                options: {
                    method: 'POST',
                    headers: this.createHeaders({
                        'content-type': 'application/json;charset=UTF-8'
                    }),
                    body: JSON.stringify({
                        items: batchItems.map((item)=>({
                                ...item,
                                context: {
                                    ...item.context,
                                    browser_url: window.location.href
                                }
                            }))
                    })
                },
                holdName: 'rovo-v1-chat-conversation-[id]-message-[messageId]-tools-resolution'
            });
            allResponses.push(...batchResponses);
        }
        return allResponses;
    }
    // REST starters, newer API
    async generateAgentStarters(payload) {
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8'
        });
        const options = {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(payload)
        };
        return this.fetchJson({
            path: '/rovo/v1/conversation-starters/agent-starter-suggestion',
            options: options,
            holdName: 'rovo-v1-conversation-starters-agent-starter-suggestion'
        });
    }
    // REST conversation starters, newer API
    async generateContextualStarters(payload) {
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8'
        });
        const options = {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(payload)
        };
        return this.fetchJson({
            path: '/rovo/v1/conversation-starters/page-contextual',
            options: options,
            holdName: 'rovo-v1-conversation-starters-page-contextual'
        });
    }
    // REST dynamic conversation starters (new endpoint)
    async getDynamicConvoStartersNew(payload) {
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8',
            'x-experience-id': 'convo-starter-for-rovo-button'
        });
        const options = {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(payload)
        };
        return this.fetchJson({
            path: '/api/ai/v2/ai-feature/convo-starters',
            options: options,
            holdName: 'api-ai-v2-ai-feature-convo-starters'
        });
    }
    async getWebSearchConfiguration() {
        const headers = this.createHeaders();
        const options = {
            method: 'GET',
            headers: headers
        };
        const result = await this.fetchJson({
            path: '/api/v2/configuration/web-search-ai',
            options: options,
            holdName: 'api-v2-configuration-web-search-ai'
        });
        return result;
    }
    async upsertConversationShare(payload) {
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8'
        });
        const options = {
            method: 'PATCH',
            headers: headers,
            body: JSON.stringify(payload)
        };
        return this.fetchJson({
            path: '/api/v2/share',
            options: options,
            holdName: 'api-v2-share-upsert'
        });
    }
    async ensureConversationShare(payload) {
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8'
        });
        const options = {
            method: 'PATCH',
            headers: headers,
            body: JSON.stringify(payload)
        };
        return this.fetchJson({
            path: '/api/v2/share',
            options: options,
            holdName: 'api-v2-share-ensure'
        });
    }
    async replaceConversationShare(payload) {
        const { conversationId: conversationId, messageId: messageId, shareType: shareType, allowedUserAris: allowedUserAris } = payload;
        const query = new URLSearchParams({
            conversationId: conversationId,
            messageId: messageId
        });
        const body = {
            conversationId: conversationId,
            messageId: messageId,
            shareType: shareType,
            ...shareType === 'SPECIFIC_USERS' ? {
                allowedUserAris: allowedUserAris ?? []
            } : {}
        };
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8'
        });
        const options = {
            method: 'PUT',
            headers: headers,
            body: JSON.stringify(body)
        };
        return this.fetchJson({
            path: `/api/v2/share?${query.toString()}`,
            options: options,
            holdName: 'api-v2-share-replace'
        });
    }
    async getConversationShare(shareToken) {
        return this.fetchJson({
            path: `/api/v2/share/${encodeURIComponent(shareToken)}`,
            options: {
                method: 'GET',
                headers: this.createHeaders()
            },
            holdName: 'api-v2-share-get'
        });
    }
    async getConversationShareMetadata({ conversationId: conversationId, messageId: messageId }) {
        const query = new URLSearchParams({
            conversationId: conversationId,
            messageId: messageId
        });
        return this.fetchJson({
            path: `/api/v2/share?${query.toString()}`,
            options: {
                method: 'GET',
                headers: this.createHeaders()
            },
            holdName: 'api-v2-share-metadata-get'
        });
    }
    async getConversationSharePreview({ conversationId: conversationId, messageId: messageId }) {
        const query = new URLSearchParams({
            conversationId: conversationId,
            messageId: messageId
        });
        return this.fetchJson({
            path: `/api/v2/share/preview?${query.toString()}`,
            options: {
                method: 'GET',
                headers: this.createHeaders()
            },
            holdName: 'api-v2-share-preview-get'
        });
    }
    async forkSharedConversation(shareToken) {
        return this.fetchJson({
            path: `/api/v2/share/${encodeURIComponent(shareToken)}/fork`,
            options: {
                method: 'POST',
                headers: this.createHeaders()
            },
            holdName: 'api-v2-share-fork'
        });
    }
    async deleteConversationShare(shareToken) {
        await this.fetch({
            path: `/api/v2/share/${encodeURIComponent(shareToken)}`,
            options: {
                method: 'DELETE',
                headers: this.createHeaders()
            },
            holdName: 'api-v2-share-delete'
        });
    }
    async deleteAllSharesForConversation(conversationId) {
        await this.fetch({
            path: `/api/v2/shares/conversation/${encodeURIComponent(conversationId)}`,
            options: {
                method: 'DELETE',
                headers: this.createHeaders()
            },
            holdName: 'api-v2-shares-conversation-delete'
        });
    }
    async getPromptHistory(options) {
        return (0, $12PUp.getPromptHistory)({
            ...options,
            headers: this.createHeaders(),
            fetchJson: (request)=>this.fetchJson(request)
        });
    }
    constructor(props){
        super(props);
        // Defined as an arrow property so `this` stays bound when the reference is
        // passed directly to data-fetching hooks (e.g. useQuery's queryFn).
        this.getGroupedConversationShares = async ()=>{
            return this.fetchJson({
                path: '/api/v2/shares/grouped',
                options: {
                    method: 'GET',
                    headers: this.createHeaders()
                },
                holdName: 'api-v2-shares-grouped-get'
            });
        };
        this.getAgentActions = async ()=>{
            const response = await this.fetchJson({
                path: '/rovo/v1/agents/configuration/actions',
                options: {
                    method: 'GET',
                    headers: this.createHeaders()
                },
                holdName: 'rovo-v1-agents-configuration-actions'
            });
            return response.actions;
        };
        this.getAgentKnowledgeConfiguration = (agentCreatorType)=>{
            const queryParams = agentCreatorType ? `?agentCreatorType=${agentCreatorType}` : '';
            return this.fetchJson({
                path: `/rovo/v1/agents/configuration/knowledge${queryParams}`,
                options: {
                    method: 'GET',
                    headers: this.createHeaders()
                },
                holdName: 'rovo-v1-agents-configuration-knowledge'
            });
        };
        this.getAgentPermissions = (agentId, payload)=>{
            return this.fetchJson({
                path: `/rovo/v2/permissions/agents/${agentId}`,
                options: {
                    method: 'POST',
                    headers: this.createHeaders({
                        'content-type': 'application/json;charset=UTF-8'
                    }),
                    body: JSON.stringify(payload)
                },
                holdName: 'rovo-v2-permissions-agents-[agentId]'
            });
        };
        this.getRecommendedAgents = ({ limit: limit, pageUrl: pageUrl })=>{
            const urlParams = new URLSearchParams({
                limit: limit.toString()
            });
            if (pageUrl) urlParams.append('pageUrl', pageUrl);
            const fullPath = `/rovo/v1/agents/recommend/v2?${urlParams.toString()}`;
            return this.fetchJson({
                path: fullPath,
                options: {
                    method: 'GET',
                    headers: this.createHeaders()
                },
                holdName: 'rovo-v1-agents-recommend-v2'
            });
        };
        this.getConversationDebugLogs = async (conversationId)=>{
            const response = await this.fetchJson({
                path: `/rovo/v1/chat/conversation/${conversationId}/debug-logs`,
                options: {
                    method: 'GET',
                    headers: this.createHeaders()
                },
                holdName: 'rovo-v1-chat-conversation-[conversationId]-debug-logs'
            });
            return response.items;
        };
        this.validateFiles = async (payload)=>{
            const headers = this.createHeaders({
                'content-type': 'application/json;charset=UTF-8'
            });
            return this.fetchJson({
                path: this.config.fileValidatePath ?? $a1ccb2b7a1450c9c$var$DEFAULT_FILE_VALIDATE_PATH,
                options: {
                    method: 'POST',
                    headers: headers,
                    body: JSON.stringify(payload)
                },
                holdName: 'rovo-v1-chat-message-file-validate'
            });
        };
        this.uploadFiles = async (payload)=>{
            const formData = new FormData();
            for (const file of payload.files)formData.append('files', file);
            const response = await this.fetchJson({
                path: this.config.fileUploadPath ?? $a1ccb2b7a1450c9c$var$DEFAULT_FILE_UPLOAD_PATH,
                options: {
                    method: 'POST',
                    headers: this.createHeaders(),
                    body: formData
                },
                holdName: 'rovo-v1-chat-message-file'
            });
            return response;
        };
        this.rovoLabsSendMessage = (payload)=>{
            return this.fetchStream({
                path: '/rovo/v1/agent-playground/chat/stream',
                options: {
                    method: 'POST',
                    headers: this.createHeaders({
                        'content-type': 'application/json;charset=UTF-8'
                    }),
                    body: JSON.stringify(payload)
                },
                holdName: 'rovo-v1-agent-playground-chat-stream'
            });
        };
        this.rovoLabsGetConversations = ()=>{
            return this.fetchJson({
                path: '/rovo/v1/agent-playground/chat/conversations',
                options: {
                    method: 'GET',
                    headers: this.createHeaders()
                },
                holdName: 'rovo-v1-agent-playground-chat-conversations'
            });
        };
        this.rovoLabsGetTools = ()=>{
            return this.fetchJson({
                path: '/rovo/v1/agent-playground/tools',
                options: {
                    method: 'GET',
                    headers: this.createHeaders()
                },
                holdName: 'rovo-v1-agent-playground-tools'
            });
        };
        this.rovoLabsGetLanguageModels = ()=>{
            return this.fetchJson({
                path: '/rovo/v1/agent-playground/language-models',
                options: {
                    method: 'GET',
                    headers: this.createHeaders()
                },
                holdName: 'rovo-v1-agent-playground-language-models'
            });
        };
        this.rovoLabsGetPrompts = ()=>{
            return this.fetchJson({
                path: '/rovo/v1/agent-playground/prompts',
                options: {
                    method: 'GET',
                    headers: this.createHeaders()
                },
                holdName: 'rovo-v1-agent-playground-prompts'
            });
        };
        this.getGeneratedContent = (payload)=>{
            const queryParams = [];
            if (payload?.actions && payload.actions.length > 0) queryParams.push(`actionKeys=${payload.actions.join(',')}`);
            if (payload?.statuses && payload.statuses.length > 0) queryParams.push(`statuses=${payload.statuses.join(',')}`);
            if (payload?.limit !== undefined) queryParams.push(`limit=${payload.limit}`);
            const queryString = queryParams.length > 0 ? `?${queryParams.join('&')}` : '';
            return this.fetchJson({
                path: `/rovo/v1/chat/generated-content${queryString}`,
                options: {
                    method: 'GET',
                    headers: this.createHeaders()
                },
                holdName: 'rovo-v1-chat-generated-content'
            });
        };
        this.getRovoUserSettings = async ()=>{
            return this.fetchJson({
                path: '/rovo/v1/chat/user-settings',
                options: {
                    method: 'GET',
                    headers: this.createHeaders({
                        'Content-Type': 'application/json'
                    })
                },
                holdName: 'rovo-v1-chat-user-settings'
            });
        };
        this.updateRovoUserSettings = async (settings)=>{
            return this.fetchJson({
                path: '/rovo/v1/chat/user-settings',
                options: {
                    method: 'PUT',
                    headers: this.createHeaders({
                        'Content-Type': 'application/json'
                    }),
                    body: JSON.stringify(settings)
                },
                holdName: 'rovo-v1-chat-user-settings'
            });
        };
        this.getAgentConciergeAvailability = async ()=>{
            return this.fetchJson({
                path: '/rovo/v1/chat/agent-concierge/availability',
                options: {
                    method: 'GET',
                    headers: this.createHeaders({
                        'Content-Type': 'application/json'
                    })
                },
                holdName: 'agent-concierge-availability'
            });
        };
        this.getAgentConciergeSettings = async ()=>{
            return this.fetchJson({
                path: '/rovo/v1/chat/agent-concierge/settings',
                options: {
                    method: 'GET',
                    headers: this.createHeaders({
                        'Content-Type': 'application/json'
                    })
                },
                holdName: 'agent-concierge-settings-get'
            });
        };
        this.updateAgentConciergeSettings = async (availability)=>{
            await this.fetch({
                path: '/rovo/v1/chat/agent-concierge/settings',
                options: {
                    method: 'PUT',
                    headers: this.createHeaders({
                        'Content-Type': 'application/json'
                    }),
                    body: JSON.stringify({
                        availability: availability
                    })
                },
                holdName: 'agent-concierge-settings-put'
            });
        };
        this.getRovoMemories = async ()=>{
            return this.fetchJson({
                path: '/rovo/v1/chat/memories',
                options: {
                    method: 'GET',
                    headers: this.createHeaders({
                        'Content-Type': 'application/json'
                    })
                },
                holdName: 'rovo-v1-chat-memories'
            });
        };
        this.getRovoMemoryBlurb = async ()=>{
            return this.fetchJson({
                path: '/rovo/v1/chat/memories/blurb',
                options: {
                    method: 'GET',
                    headers: this.createHeaders({
                        'Content-Type': 'application/json'
                    })
                },
                holdName: 'rovo-v1-chat-memories-blurb'
            });
        };
        this.answerNow = async (conversationId, messageId)=>{
            const headers = this.createHeaders({
                'content-type': 'application/json;charset=UTF-8'
            });
            const options = {
                method: 'POST',
                headers: headers
            };
            await this.fetch({
                path: `/rovo/v1/chat/conversation/${conversationId}/message/${messageId}/answer-now`,
                options: options,
                holdName: 'rovo-v1-chat-conversation-message-answer-now'
            });
        };
        this.deleteRovoMemory = async (memoryId)=>{
            const headers = this.createHeaders();
            const options = {
                method: 'DELETE',
                headers: headers
            };
            await this.fetch({
                path: `/rovo/v1/chat/memories/${memoryId}`,
                options: options,
                holdName: 'rovo-v1-chat-memories-[memoryId]'
            });
        };
        this.getRovoMemoryEdits = async ()=>{
            return this.fetchJson({
                path: '/rovo/v1/chat/memories/memory-edits',
                options: {
                    method: 'GET',
                    headers: this.createHeaders({
                        'Content-Type': 'application/json'
                    })
                },
                holdName: 'rovo-v1-chat-memories-memory-edits'
            });
        };
        this.createMemoryEdit = async (payload)=>{
            return this.fetchJson({
                path: '/rovo/v1/chat/memories/memory-edits',
                options: {
                    method: 'POST',
                    headers: this.createHeaders({
                        'Content-Type': 'application/json'
                    }),
                    body: JSON.stringify(payload)
                },
                holdName: 'rovo-v1-chat-memories-memory-edits'
            });
        };
        this.createMemory = async (payload)=>{
            await this.fetch({
                path: '/rovo/v1/chat/memories/create',
                options: {
                    method: 'POST',
                    headers: this.createHeaders({
                        'Content-Type': 'application/json'
                    }),
                    body: JSON.stringify(payload)
                },
                holdName: 'rovo-v1-chat-memories-create'
            });
        };
        this.getRovoMemoryEditsCount = async ()=>{
            return this.fetchJson({
                path: '/rovo/v1/chat/memories/memory-edits/count',
                options: {
                    method: 'GET',
                    headers: this.createHeaders({
                        'Content-Type': 'application/json'
                    })
                },
                holdName: 'rovo-v1-chat-memories-memory-edits-count'
            });
        };
        this.deleteRovoMemoryEdit = async (editId)=>{
            const headers = this.createHeaders();
            const options = {
                method: 'DELETE',
                headers: headers
            };
            await this.fetch({
                path: `/rovo/v1/chat/memories/memory-edits/${editId}`,
                options: options,
                holdName: 'rovo-v1-chat-memories-memory-edits-[editId]'
            });
        };
        this.fetchConversationMetadata = async (conversationId)=>{
            const result = await this.fetchJson({
                path: `/rovo/v1/chat/conversation/${conversationId}`,
                options: {
                    method: 'GET',
                    headers: this.createHeaders()
                },
                holdName: 'rovo-v1-chat-conversation-[conversationId]'
            });
            return this.transformSnakeCaseToCamelCase(result);
        };
        this.fetchPersonalizedPromptSuggestions = async (config)=>{
            const { offset: offset = 0, limit: limit = 9, contentType: contentType, entryPoint: entryPoint } = config;
            const headers = this.createHeaders({
                'Content-Type': 'application/json'
            });
            const options = {
                method: 'POST',
                headers: headers,
                body: JSON.stringify({
                    ai_feature_input: {
                        offset: offset,
                        limit: limit,
                        ...contentType ? {
                            contentType: contentType
                        } : {},
                        ...entryPoint ? {
                            entryPoint: entryPoint
                        } : {}
                    }
                })
            };
            const result = await this.fetchJson({
                path: '/api/ai/v2/ai-feature/confluence-prompt-tiles',
                options: options,
                holdName: 'api-ai-v2-ai-feature-confluence-prompt-tiles'
            });
            return result?.ai_feature_output?.prompt_tiles ?? [];
        };
        this.getTasks = async (params)=>{
            const searchParams = new URLSearchParams();
            searchParams.set('limit', String(params?.limit ?? $a1ccb2b7a1450c9c$var$TASKS_PAGE_SIZE));
            if (params?.cursor) searchParams.set('cursor', params.cursor);
            return this.fetchJson({
                path: `/rovo/v1/tasks?${searchParams.toString()}`,
                options: {
                    method: 'GET',
                    headers: this.createHeaders({
                        'Content-Type': 'application/json'
                    })
                },
                holdName: 'rovo-v1-tasks'
            });
        };
        this.getLibraryEntries = async (params)=>{
            const searchParams = new URLSearchParams();
            searchParams.set('limit', String(params?.limit ?? $a1ccb2b7a1450c9c$var$LIBRARY_PAGE_SIZE));
            if (params?.cursor) searchParams.set('cursor', params.cursor);
            if (params?.query) searchParams.set('query', params.query);
            if (params?.type) searchParams.set('type', params.type);
            if (params?.kind) searchParams.set('kind', params.kind);
            const options = {
                method: 'GET',
                headers: this.createHeaders(),
                signal: params?.controller?.signal
            };
            return this.fetchJson({
                path: `/rovo/v1/library?${searchParams.toString()}`,
                options: options,
                holdName: 'rovo-chat-v1-library'
            });
        };
        this.getTasksStream = async (controller)=>{
            return this.fetchStream({
                path: '/rovo/v1/tasks/stream',
                options: {
                    method: 'GET',
                    headers: this.createHeaders({
                        Accept: 'text/event-stream'
                    }),
                    signal: controller?.signal
                },
                holdName: 'rovo-v1-tasks-stream'
            }, {
                useSSE: true
            });
        };
        this.cancelTask = async (taskId)=>{
            const headers = this.createHeaders({
                'content-type': 'application/json;charset=UTF-8'
            });
            const options = {
                method: 'POST',
                headers: headers
            };
            await this.fetch({
                path: `/rovo/v1/tasks/${taskId}/cancel`,
                options: options,
                holdName: 'rovo-v1-tasks-[taskId]-cancel'
            });
        };
        this.deleteTask = async (taskId)=>{
            const headers = this.createHeaders({
                'content-type': 'application/json;charset=UTF-8'
            });
            const options = {
                method: 'DELETE',
                headers: headers
            };
            await this.fetch({
                path: `/rovo/v1/tasks/${taskId}`,
                options: options,
                holdName: 'rovo-v1-tasks-[taskId]-delete'
            });
        };
        this.renameTask = async (taskId, title)=>{
            return this.fetchJson({
                path: `/rovo/v1/tasks/${taskId}`,
                options: {
                    method: 'PUT',
                    headers: this.createHeaders({
                        'Content-Type': 'application/json'
                    }),
                    body: JSON.stringify({
                        title: title
                    })
                },
                holdName: 'rovo-v1-tasks-[taskId]'
            });
        };
        this.fetchPersonalizedPromptSuggestionsStream = async (config)=>{
            const { offset: offset = 0, limit: limit = 9, contentType: contentType, entryPoint: entryPoint, enable3pPrompt: enable3pPrompt } = config;
            const headers = this.createHeaders({
                'Content-Type': 'application/json'
            });
            const options = {
                method: 'POST',
                headers: headers,
                body: JSON.stringify({
                    ai_feature_input: {
                        offset: offset,
                        limit: limit,
                        ...contentType ? {
                            contentType: contentType
                        } : {},
                        ...entryPoint ? {
                            entryPoint: entryPoint
                        } : {},
                        // Only sent for experiment variants A/B; omitted for everyone else so the
                        // request is byte-identical to the pre-3P-feature request.
                        ...enable3pPrompt ? {
                            enable_3p_prompt: true
                        } : {}
                    }
                })
            };
            return this.fetchStream({
                path: '/api/ai/v2/ai-feature/confluence-prompt-tiles/stream',
                options: options,
                holdName: 'api-ai-v2-ai-feature-confluence-prompt-tiles-stream'
            });
        };
    }
}
const $a1ccb2b7a1450c9c$var$AssistanceServiceContext = /*#__PURE__*/ (0, $cozmU.createContext)(new $a1ccb2b7a1450c9c$export$a522c5f4ccda1c94({
    baseUrl: '',
    product: '',
    experienceId: ''
}));
const $a1ccb2b7a1450c9c$export$8fe647eb935c33db = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { value: value, children: children } = t0;
    let t1;
    if ($[0] !== children || $[1] !== value) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a1ccb2b7a1450c9c$var$AssistanceServiceContext.Provider, {
            value: value
        }, children);
        $[0] = children;
        $[1] = value;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ value: value, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a1ccb2b7a1450c9c$var$AssistanceServiceContext.Provider, {
        value: value
    }, children);
const $a1ccb2b7a1450c9c$export$7e31a1844ebbaf85 = (props)=>{
    (0, $6cFsl.di)((0, $cozmU.useContext), $a1ccb2b7a1450c9c$export$a522c5f4ccda1c94);
    const service = (0, $cozmU.useContext)($a1ccb2b7a1450c9c$var$AssistanceServiceContext);
    (0, $7zss8.setRovoChatProduct)(props?.product ?? service.getConfig().product);
    if (!props || !props.experienceId && !props.product && !props.headers && !props.channelId) return service;
    const product = props.product ?? service.getConfig().product;
    const experienceId = props.experienceId ?? service.getConfig().experienceId;
    const headers = props.headers ?? service.getConfig().headers;
    const channelId = props.channelId ?? service.getConfig().channelId;
    return new $a1ccb2b7a1450c9c$export$a522c5f4ccda1c94({
        ...service.getConfig(),
        product: product,
        experienceId: experienceId,
        headers: headers,
        channelId: channelId
    });
};
const $a1ccb2b7a1450c9c$export$5a9ea20fc196ec62 = (originalHook)=>{
    return (props)=>{
        (0, $6cFsl.di)($a1ccb2b7a1450c9c$export$a522c5f4ccda1c94, (0, $bjY3F.useAIMateExperienceTracker));
        const { assistanceServiceParams: assistanceServiceParams, ...restProps } = props;
        const experienceTracker = (0, $bjY3F.useAIMateExperienceTracker)({
            touchpointSource: assistanceServiceParams.touchpointSource
        });
        const headers = (0, $cozmU.useMemo)(()=>{
            // even though AssistanceServiceInputParam enforces lowercase header keys,
            // it is possible to get a non lowercase key if a prebuilt object was assigned to headers at runtime,
            // so this is an additional safety net, without this duplicate headers keys with different case
            // can get appended during header normalization causing request to fail
            // Relevant thread: https://atlassian.slack.com/archives/C0677M19GU9/p1748531977923069?thread_ts=1747336061.856749&cid=C0677M19GU9
            const inputHeaders = props.assistanceServiceParams.headers ? Object.fromEntries(Object.entries(props.assistanceServiceParams.headers).map(([key, value])=>[
                    key.toLowerCase(),
                    value
                ])) : undefined;
            return {
                'x-cloudid': props.assistanceServiceParams.siteId,
                ...inputHeaders
            };
        }, [
            props.assistanceServiceParams.siteId,
            props.assistanceServiceParams.headers
        ]);
        const assistanceService = (0, $cozmU.useMemo)(()=>{
            return new $a1ccb2b7a1450c9c$export$a522c5f4ccda1c94({
                product: assistanceServiceParams.product,
                experienceId: assistanceServiceParams.experienceId,
                headers: headers,
                channelId: assistanceServiceParams.channelId,
                baseUrl: assistanceServiceParams.baseUrl,
                minionAlias: assistanceServiceParams.minionAlias,
                fileValidatePath: assistanceServiceParams.fileValidatePath,
                fileUploadPath: assistanceServiceParams.fileUploadPath
            });
        }, [
            assistanceServiceParams.baseUrl,
            assistanceServiceParams.experienceId,
            assistanceServiceParams.product,
            assistanceServiceParams.channelId,
            headers,
            assistanceServiceParams.minionAlias,
            assistanceServiceParams.fileValidatePath,
            assistanceServiceParams.fileUploadPath
        ]);
        // eslint-disable-next-line @atlaskit/platform/no-double-type-assertions -- Existing assistance-service baseline: injected hook params are adapted to the generic hook parameter type.
        const result = originalHook({
            ...restProps,
            assistanceServiceInjectedParams: {
                ...assistanceServiceParams,
                headers: headers,
                experienceTracker: experienceTracker,
                assistanceService: assistanceService
            }
        });
        return result;
    };
};
module.exports["AssistanceServiceBase"] = $a1ccb2b7a1450c9c$export$40a7802808e2fbe3;
module.exports["AssistanceServiceImpl"] = $a1ccb2b7a1450c9c$export$a522c5f4ccda1c94;
module.exports["AssistanceServiceProvider"] = $a1ccb2b7a1450c9c$export$8fe647eb935c33db;
module.exports["useAssistanceService"] = $a1ccb2b7a1450c9c$export$7e31a1844ebbaf85;
module.exports["createHookWithAssistanceService"] = $a1ccb2b7a1450c9c$export$5a9ea20fc196ec62;

});

parcelRegister("5XWbo", function(module, exports) {
const $8801d8511b175030$export$e0744546db5b6189 = 'rovo_chat_sites_source_filter';
module.exports["ROVO_CHAT_SITES_SOURCE_FILTER_GATE"] = $8801d8511b175030$export$e0744546db5b6189;

});

parcelRegister("bxkJA", function(module, exports) {

var $fCunh = parcelRequire("fCunh");


var $8A2GO = parcelRequire("8A2GO");

const $c3ad42ae8c5c5089$export$f78edfe5a93b58af = (message)=>{
    return message !== null && typeof message === 'object' && '__isSSEWrapper' in message && message.__isSSEWrapper === true;
};
const $c3ad42ae8c5c5089$export$5945515082cc2cbf = 'convoai.rest.not.found';
const $c3ad42ae8c5c5089$export$c424fe9570a5f2d9 = 'ACCEPTABLE_USE_VIOLATIONS';
const $c3ad42ae8c5c5089$export$c162f3e7456e473f = [
    'rovo_default',
    'professional',
    'creative',
    'empathetic'
];
const $c3ad42ae8c5c5089$export$a461d78149e66005 = [
    'shorter',
    'neutral',
    'longer'
];
const $c3ad42ae8c5c5089$export$42a434f431015fce = [
    'less_structured',
    'neutral',
    'more_structured'
];
const $c3ad42ae8c5c5089$export$312f4aeec9b65640 = [
    'none',
    'neutral',
    'more'
];
const $c3ad42ae8c5c5089$export$f3430750c3a3992d = [
    'enabled',
    'disabled'
];
var $c3ad42ae8c5c5089$export$2e28f9aa1dcf9823 = /*#__PURE__*/ function(PromptCategory) {
    PromptCategory["ANALYZE"] = "Analyze";
    PromptCategory["BRAINSTORM"] = "Brainstorm";
    PromptCategory["REVIEW"] = "Review";
    PromptCategory["SUMMARIZE"] = "Summarize";
    PromptCategory["CREATE"] = "Create";
    PromptCategory["EXECUTE"] = "Execute";
    PromptCategory["FIND"] = "Find";
    PromptCategory["LEARN"] = "Learn";
    return PromptCategory;
}({});
var $c3ad42ae8c5c5089$export$bd1535eb0caf2683 = /*#__PURE__*/ function(PromptRole) {
    PromptRole["GENERAL"] = "General";
    PromptRole["ENGINEERING"] = "Engineering";
    PromptRole["PRODUCT"] = "Product";
    PromptRole["PROGRAM_MANAGEMENT"] = "Program Management";
    PromptRole["DESIGN"] = "Design";
    PromptRole["MARKETING"] = "Marketing";
    PromptRole["IT_OPS"] = "IT Ops";
    PromptRole["SALES"] = "Sales";
    PromptRole["CUSTOMER_SUPPORT"] = "Customer Support";
    PromptRole["HELPDESK_SUPPORT"] = "Helpdesk Support";
    PromptRole["SECURITY"] = "Security";
    return PromptRole;
}({});
const $c3ad42ae8c5c5089$export$77c9504201bdfdea = 'PROMPT_TILE';
const $c3ad42ae8c5c5089$export$7fe06c6ae176663 = 'third-party';
const $c3ad42ae8c5c5089$var$entityTypeMap = {
    person: 'Person',
    Person: 'Person',
    inferred_project: 'InferredProject',
    InferredProject: 'InferredProject'
};
const $c3ad42ae8c5c5089$export$d6de2556d50e53b4 = (message)=>({
        sentence: message.sentence,
        entities: message.entities.map((entity)=>({
                type: $c3ad42ae8c5c5089$var$entityTypeMap[entity.type],
                mention: entity.mention,
                start: entity.start,
                end: entity.end,
                ari: entity.ari,
                canonicalName: entity.canonical_name,
                confidenceScore: entity.confidence_score
            }))
    });
const $c3ad42ae8c5c5089$export$fb661125ffb29bd6 = (message)=>{
    return $c3ad42ae8c5c5089$export$a69fab2afb88c2eb(message) || $c3ad42ae8c5c5089$export$6f965deda7f0960c(message) || $c3ad42ae8c5c5089$export$b4631726cbc1440a(message);
};
const $c3ad42ae8c5c5089$export$a69fab2afb88c2eb = (message)=>message instanceof Object && message.role === 'HUMAN';
const $c3ad42ae8c5c5089$export$6f965deda7f0960c = (message)=>message instanceof Object && message.role === 'ASSISTANT';
const $c3ad42ae8c5c5089$export$1af37a4715539580 = (message)=>Boolean(message.message_metadata?.sharedFromMessageId);
const $c3ad42ae8c5c5089$export$a6e5100ca2770191 = (message)=>message instanceof Object && $c3ad42ae8c5c5089$export$6f965deda7f0960c(message.message);
const $c3ad42ae8c5c5089$export$2403e128f2e81f8f = (message)=>message instanceof Object && message.message instanceof Object;
const $c3ad42ae8c5c5089$export$5c1c15675df13ae5 = (message)=>$c3ad42ae8c5c5089$export$b4631726cbc1440a(message) && message.message?.message?.async_status === 'IN_PROGRESS';
const $c3ad42ae8c5c5089$export$b4631726cbc1440a = (message)=>message instanceof Object && message.type === 'FINAL_RESPONSE';
const $c3ad42ae8c5c5089$var$isRecord = (value)=>typeof value === 'object' && value !== null;
const $c3ad42ae8c5c5089$var$isOptionalNullableString = (value)=>value === undefined || value === null || typeof value === 'string';
const $c3ad42ae8c5c5089$export$2d3cb9d520902824 = (message)=>{
    if (!$c3ad42ae8c5c5089$var$isRecord(message) || message.type !== 'INTERACTION_CONCLUSION' || !$c3ad42ae8c5c5089$var$isRecord(message.message) || message.message.outcome !== 'SUCCEEDED' && message.message.outcome !== 'FAILED') return false;
    if (message.millisOffset !== undefined && typeof message.millisOffset !== 'number') return false;
    if (message.metadata != null && (!$c3ad42ae8c5c5089$var$isRecord(message.metadata) || !$c3ad42ae8c5c5089$var$isOptionalNullableString(message.metadata.request_id) || !$c3ad42ae8c5c5089$var$isOptionalNullableString(message.metadata.message_id))) return false;
    return true;
};
const $c3ad42ae8c5c5089$export$d422a2733a3b5def = (message)=>message instanceof Object && message.type === 'ERROR';
const $c3ad42ae8c5c5089$export$1e1cf807ece63df4 = (message)=>$c3ad42ae8c5c5089$export$d422a2733a3b5def(message) && message.message?.message_template === $c3ad42ae8c5c5089$export$c424fe9570a5f2d9;
const $c3ad42ae8c5c5089$export$e45102edbc73b240 = (message)=>message instanceof Object && message.type === 'ANSWER_PART';
const $c3ad42ae8c5c5089$var$isNonEmptyString = (value)=>typeof value === 'string' && value.length > 0;
const $c3ad42ae8c5c5089$export$a29b8eb13b54e91f = (message)=>$c3ad42ae8c5c5089$var$isRecord(message) && message.type === 'ANSWER_UI_PART' && $c3ad42ae8c5c5089$var$isNonEmptyString(message.part_id);
const $c3ad42ae8c5c5089$export$eee53d3475c29169 = (message)=>{
    if (!$c3ad42ae8c5c5089$var$isRecord(message) || message.type !== 'ANSWER_UI_CONTENT' || !$c3ad42ae8c5c5089$var$isNonEmptyString(message.part_id)) return false;
    if (message.state === 'failed') return true;
    return message.state === 'ready' && $c3ad42ae8c5c5089$var$isRecord(message.message) && message.message.format === 'lumina_v1' && $c3ad42ae8c5c5089$var$isNonEmptyString(message.message.content);
};
const $c3ad42ae8c5c5089$var$isRawEntityAnnotation = (value)=>$c3ad42ae8c5c5089$var$isRecord(value) && (value.type === 'person' || value.type === 'Person' || value.type === 'inferred_project' || value.type === 'InferredProject') && typeof value.mention === 'string' && typeof value.start === 'number' && Number.isFinite(value.start) && typeof value.end === 'number' && Number.isFinite(value.end) && typeof value.ari === 'string' && typeof value.canonical_name === 'string' && typeof value.confidence_score === 'number' && Number.isFinite(value.confidence_score);
const $c3ad42ae8c5c5089$export$6fb760a9d35f0551 = (message)=>$c3ad42ae8c5c5089$var$isRecord(message) && message.type === 'ENTITY_ANNOTATIONS' && $c3ad42ae8c5c5089$var$isRecord(message.message) && typeof message.message.sentence === 'string' && Array.isArray(message.message.entities) && message.message.entities.every($c3ad42ae8c5c5089$var$isRawEntityAnnotation);
const $c3ad42ae8c5c5089$export$51a109436d382715 = (message)=>message instanceof Object && message.type === 'REASONING_PART';
const $c3ad42ae8c5c5089$export$dbf4211c9117b9bc = (message)=>message instanceof Object && message.type === 'ACTION_PART';
const $c3ad42ae8c5c5089$export$3d7b0b359441d5a6 = (message)=>message instanceof Object && message.type === 'ACTION_CLASSIFICATION';
const $c3ad42ae8c5c5089$export$584e11c2903f4ed6 = (message)=>message instanceof Object && message.type === 'ACTION_PREPARE';
const $c3ad42ae8c5c5089$export$7d94ce53d589f586 = (message)=>message instanceof Object && message.type === 'ACTION_COMPLETE';
const $c3ad42ae8c5c5089$var$AUTO_ACTION_APPROVAL_STATUSES = new Set([
    'REVIEWING',
    'AUTO_APPROVED',
    'AUTO_APPROVED_REQUIRES_HUMAN',
    'REQUIRES_HUMAN'
]);
const $c3ad42ae8c5c5089$var$isNullableString = (value)=>value === null || typeof value === 'string';
const $c3ad42ae8c5c5089$export$9082a8e48d820016 = (message)=>{
    if (!$c3ad42ae8c5c5089$var$isRecord(message) || message.type !== 'AUTO_ACTION_APPROVAL' || !$c3ad42ae8c5c5089$var$isRecord(message.message)) return false;
    const payload = message.message;
    const metadataIsValid = message.metadata === undefined || message.metadata === null || $c3ad42ae8c5c5089$var$isRecord(message.metadata) && (message.metadata.request_id === undefined || $c3ad42ae8c5c5089$var$isNullableString(message.metadata.request_id));
    const sequenceIdIsValid = message.sequence_id === undefined || typeof message.sequence_id === 'string';
    return typeof message.millisOffset === 'number' && Number.isFinite(message.millisOffset) && typeof payload.content === 'string' && typeof payload.status === 'string' && $c3ad42ae8c5c5089$var$AUTO_ACTION_APPROVAL_STATUSES.has(payload.status) && typeof payload.action_display_name === 'string' && typeof payload.tool_name === 'string' && $c3ad42ae8c5c5089$var$isNullableString(payload.action_key) && $c3ad42ae8c5c5089$var$isNullableString(payload.reason) && typeof payload.source === 'string' && typeof payload.risk_category === 'string' && typeof payload.policy_version === 'string' && $c3ad42ae8c5c5089$var$isNullableString(payload.model_id) && metadataIsValid && sequenceIdIsValid;
};
const $c3ad42ae8c5c5089$export$abec64f24e2ec3e7 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH_START';
const $c3ad42ae8c5c5089$export$9c1f93971e9e3fbe = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH';
const $c3ad42ae8c5c5089$export$79a0ed7d987faa8f = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH_STEP';
const $c3ad42ae8c5c5089$export$7b1c8227569f1a92 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH_STEP_TITLE';
const $c3ad42ae8c5c5089$export$cde91b49af35d559 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH_PLAN';
const $c3ad42ae8c5c5089$export$4a6a601f69cf3c74 = (message)=>message instanceof Object && message.type === 'TODO_SNAPSHOT';
const $c3ad42ae8c5c5089$export$6b0058543411cb3a = (message)=>message instanceof Object && message.type === 'TASK_STATUS';
const $c3ad42ae8c5c5089$export$5cfcb66b0fc392d6 = (message)=>typeof message === 'object' && message !== null && 'type' in message && message.type === 'CONCIERGE_AGENT_SELECTED';
const $c3ad42ae8c5c5089$export$ac74da022f74040a = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH_STEP_TITLE_SHORT';
const $c3ad42ae8c5c5089$export$7898cc38956b9052 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'SKILL_START';
const $c3ad42ae8c5c5089$export$bb608d13a1268633 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'SKILL_END';
const $c3ad42ae8c5c5089$export$b65c73c7e2d8d96f = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'FAST_MODE_RESPONSE_AVAILABLE';
const $c3ad42ae8c5c5089$export$40cf419186312161 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'FAST_MODE_ENABLED';
const $c3ad42ae8c5c5089$export$a83708fc4401682d = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'REMOVE_ANSWER_NOW';
const $c3ad42ae8c5c5089$export$68192da24ac8c141 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH_STEP_SOURCE';
const $c3ad42ae8c5c5089$export$cfccfd17b68ccb0 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH_STEP_COMPLETE';
const $c3ad42ae8c5c5089$export$1fd230d6956c2575 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH_STEP_ICONS';
const $c3ad42ae8c5c5089$export$3bc697eeff31bdf6 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH_STEP_DOCUMENT';
const $c3ad42ae8c5c5089$export$c679ee34f7312895 = (message)=>message instanceof Object && message.type === 'RECONNECT_SUPPORTED';
const $c3ad42ae8c5c5089$export$46e0fb5e4b019a49 = (message)=>message instanceof Object && message.type === 'TRACE' && (message.message.message_template === 'RESEARCH' || message.message.message_template === 'RESEARCH_STEP' || message.message.message_template === 'RESEARCH_STEP_TITLE' || message.message.message_template === 'RESEARCH_STEP_TITLE_SHORT' || message.message.message_template === 'RESEARCH_STEP_SOURCE' || message.message.message_template === 'RESEARCH_STEP_COMPLETE' || message.message.message_template === 'RESEARCH_STEP_ICONS' || message.message.message_template === 'RESEARCH_STEP_DOCUMENT');
const $c3ad42ae8c5c5089$export$6f74311d40862a9f = (message)=>message instanceof Object && message.type === 'TRACE' && ($c3ad42ae8c5c5089$export$7898cc38956b9052(message) || $c3ad42ae8c5c5089$export$bb608d13a1268633(message));
const $c3ad42ae8c5c5089$export$d95e474df0d530df = (message)=>message instanceof Object && message.type === 'TRACE' && message.message?.message_template === 'MEMORY_UPDATE';
const $c3ad42ae8c5c5089$export$fd5a05be03f147a0 = (message)=>{
    // TRACE and research steps are sharing the same type, but we want to separate them
    if ($c3ad42ae8c5c5089$export$46e0fb5e4b019a49(message)) return false;
    if ($c3ad42ae8c5c5089$export$cde91b49af35d559(message)) return false;
    if ($c3ad42ae8c5c5089$export$6f74311d40862a9f(message)) return false;
    if ($c3ad42ae8c5c5089$export$b65c73c7e2d8d96f(message)) return false;
    if ($c3ad42ae8c5c5089$export$682514f3a8131b98(message)) return false;
    return message instanceof Object && message.type === 'TRACE';
};
const $c3ad42ae8c5c5089$export$682514f3a8131b98 = (message)=>{
    return message instanceof Object && message.type === 'TRACE' && message.message?.message_template === 'THINK_DEEPER_TRIGGERED';
};
const $c3ad42ae8c5c5089$export$aeae5b4fda357302 = (message)=>message !== undefined && message !== null && typeof message === 'object' && 'type' in message && message.type === 'FOLLOW_UP_QUERIES';
const $c3ad42ae8c5c5089$export$6275ff996073145e = (message)=>{
    if (!$c3ad42ae8c5c5089$export$f78edfe5a93b58af(message) || message.eventType !== 'AGENTIC_UI') return false;
    if (message.data === null || typeof message.data !== 'object') return false;
    const data = message.data;
    return Array.isArray(data.message?.content);
};
const $c3ad42ae8c5c5089$export$b46beea5c82aa1b9 = (message)=>message instanceof Object && message.type === 'HEART_BEAT';
const $c3ad42ae8c5c5089$export$b8391261162989d9 = (message)=>$c3ad42ae8c5c5089$export$6f965deda7f0960c(message) && (message?.message_metadata?.is_action_execution ?? false) && message?.message_metadata?.action_execution_result === 'SUCCESS';
const $c3ad42ae8c5c5089$export$1060c4fa97e34fa7 = (payloadContext)=>{
    return payloadContext?.resolution?.type === 'cancel';
};
const $c3ad42ae8c5c5089$export$6ce1ccc24e75456f = (error)=>(0, $8A2GO.isApiError)(error) && error.errorAttributes?.errorCode === $c3ad42ae8c5c5089$export$5945515082cc2cbf;
const $c3ad42ae8c5c5089$export$c3c933dad2745d3f = (msg)=>msg && msg.type === 'ACTION_ERROR' && msg.message && msg.message.status === 'ERRORED';
const $c3ad42ae8c5c5089$export$bc96a6a479480590 = (error)=>(0, $8A2GO.isApiError)(error) && error.errorAttributes.statusCode === 429;
const $c3ad42ae8c5c5089$export$f8b1b75846492611 = (error)=>(0, $8A2GO.isApiError)(error) && !!error.errorAttributes.errorCode && error.errorAttributes.errorCode === (0, $fCunh.ASSISTANCE_SERVICE_ERROR_CODES).HAS_HIPAA_ENABLED;
const $c3ad42ae8c5c5089$export$d263dc5d64f36d48 = (error)=>error instanceof Object && error?.detail?.type === 'ERROR' && !!error.errorAttributes.errorCode && error.errorAttributes.errorCode === $c3ad42ae8c5c5089$export$c424fe9570a5f2d9;
const $c3ad42ae8c5c5089$export$b454081350f4a578 = (message)=>message instanceof Object && message.type === 'CONVERSATION_CHANNEL_DATA';
const $c3ad42ae8c5c5089$export$145ab74998a54a20 = (message)=>message instanceof Object && message.type === 'SCOPE_DETERMINED';
const $c3ad42ae8c5c5089$export$75ceabc5bb9500e4 = (message)=>message instanceof Object && message.type === 'SPACE_SOURCE_RECOMMENDATIONS' && message.message instanceof Object;
const $c3ad42ae8c5c5089$export$f4111656f23d9b9b = (message)=>message instanceof Object && (message.type === 'PROMPT_REDACTION' || message.type === 'PROMPT_REDACTED');
const $c3ad42ae8c5c5089$export$c43cf9ba6a2176ef = (message)=>message instanceof Object && (message.type === 'PROMPT_BLOCKED' || message.type === 'PROMPT_BLOCK');
const $c3ad42ae8c5c5089$export$f16ff8eb19967a97 = (message)=>message instanceof Object && message.type === 'RESPONSE_REDACTION';
const $c3ad42ae8c5c5089$export$55f7bd80eacbc51b = (message)=>message instanceof Object && message.type === 'RESPONSE_BLOCKED';
const $c3ad42ae8c5c5089$export$a1be74470d3c1fe9 = (message)=>message instanceof Object && message.type === 'ATTACHMENT_BLOCKED';
function $c3ad42ae8c5c5089$export$4af48296a8d61cec(payloadContext) {
    return payloadContext?.resolution?.type === 'confirm';
}
module.exports["isSSEMessage"] = $c3ad42ae8c5c5089$export$f78edfe5a93b58af;
module.exports["ACCEPTABLE_USE_VIOLATIONS_ERROR"] = $c3ad42ae8c5c5089$export$c424fe9570a5f2d9;
module.exports["RESPONSE_TONES"] = $c3ad42ae8c5c5089$export$c162f3e7456e473f;
module.exports["RESPONSE_LENGTHS"] = $c3ad42ae8c5c5089$export$a461d78149e66005;
module.exports["RESPONSE_STRUCTURES"] = $c3ad42ae8c5c5089$export$42a434f431015fce;
module.exports["RESPONSE_EMOJIS"] = $c3ad42ae8c5c5089$export$312f4aeec9b65640;
module.exports["RESPONSE_TLDR_OPTIONS"] = $c3ad42ae8c5c5089$export$f3430750c3a3992d;
module.exports["SUGGESTED_PROMPT_TILE_STREAM_MESSAGE_TYPE"] = $c3ad42ae8c5c5089$export$77c9504201bdfdea;
module.exports["THIRD_PARTY_PROMPT_SOURCE_CONTENT_TYPE"] = $c3ad42ae8c5c5089$export$7fe06c6ae176663;
module.exports["normalizeEntityAnnotationsMessage"] = $c3ad42ae8c5c5089$export$d6de2556d50e53b4;
module.exports["isHumanMessage"] = $c3ad42ae8c5c5089$export$a69fab2afb88c2eb;
module.exports["isAssistantMessage"] = $c3ad42ae8c5c5089$export$6f965deda7f0960c;
module.exports["isStreamResponse"] = $c3ad42ae8c5c5089$export$b4631726cbc1440a;
module.exports["isSharedSnapshotMessage"] = $c3ad42ae8c5c5089$export$1af37a4715539580;
module.exports["isAgentResponse"] = $c3ad42ae8c5c5089$export$a6e5100ca2770191;
module.exports["isStreamMessageWithMessage"] = $c3ad42ae8c5c5089$export$2403e128f2e81f8f;
module.exports["isInProgressStreamResponse"] = $c3ad42ae8c5c5089$export$5c1c15675df13ae5;
module.exports["isStreamInteractionConclusion"] = $c3ad42ae8c5c5089$export$2d3cb9d520902824;
module.exports["isStreamError"] = $c3ad42ae8c5c5089$export$d422a2733a3b5def;
module.exports["isStreamAUPError"] = $c3ad42ae8c5c5089$export$1e1cf807ece63df4;
module.exports["isStreamAnswerPart"] = $c3ad42ae8c5c5089$export$e45102edbc73b240;
module.exports["isStreamAnswerUiPart"] = $c3ad42ae8c5c5089$export$a29b8eb13b54e91f;
module.exports["isStreamAnswerUiContent"] = $c3ad42ae8c5c5089$export$eee53d3475c29169;
module.exports["isStreamEntityAnnotations"] = $c3ad42ae8c5c5089$export$6fb760a9d35f0551;
module.exports["isStreamReasoningPart"] = $c3ad42ae8c5c5089$export$51a109436d382715;
module.exports["isStreamActionPart"] = $c3ad42ae8c5c5089$export$dbf4211c9117b9bc;
module.exports["isStreamActionClassification"] = $c3ad42ae8c5c5089$export$3d7b0b359441d5a6;
module.exports["isStreamActionPrepare"] = $c3ad42ae8c5c5089$export$584e11c2903f4ed6;
module.exports["isStreamActionComplete"] = $c3ad42ae8c5c5089$export$7d94ce53d589f586;
module.exports["isStreamAutoActionApproval"] = $c3ad42ae8c5c5089$export$9082a8e48d820016;
module.exports["isStreamResearchStart"] = $c3ad42ae8c5c5089$export$abec64f24e2ec3e7;
module.exports["isStreamResearchBeginningTrace"] = $c3ad42ae8c5c5089$export$9c1f93971e9e3fbe;
module.exports["isStreamResearchStepContent"] = $c3ad42ae8c5c5089$export$79a0ed7d987faa8f;
module.exports["isStreamResearchStepTitle"] = $c3ad42ae8c5c5089$export$7b1c8227569f1a92;
module.exports["isStreamResearchPlan"] = $c3ad42ae8c5c5089$export$cde91b49af35d559;
module.exports["isStreamTodoSnapshot"] = $c3ad42ae8c5c5089$export$4a6a601f69cf3c74;
module.exports["isStreamTaskStatus"] = $c3ad42ae8c5c5089$export$6b0058543411cb3a;
module.exports["isStreamConciergeAgentSelected"] = $c3ad42ae8c5c5089$export$5cfcb66b0fc392d6;
module.exports["isStreamResearchStepTitleShort"] = $c3ad42ae8c5c5089$export$ac74da022f74040a;
module.exports["isStreamSkillStart"] = $c3ad42ae8c5c5089$export$7898cc38956b9052;
module.exports["isStreamSkillEnd"] = $c3ad42ae8c5c5089$export$bb608d13a1268633;
module.exports["isStreamFastModeResponseAvailable"] = $c3ad42ae8c5c5089$export$b65c73c7e2d8d96f;
module.exports["isStreamFastModeEnabled"] = $c3ad42ae8c5c5089$export$40cf419186312161;
module.exports["isStreamRemoveAnswerNow"] = $c3ad42ae8c5c5089$export$a83708fc4401682d;
module.exports["isStreamResearchStepSource"] = $c3ad42ae8c5c5089$export$68192da24ac8c141;
module.exports["isStreamResearchStepCompleted"] = $c3ad42ae8c5c5089$export$cfccfd17b68ccb0;
module.exports["isStreamResearchStepIcons"] = $c3ad42ae8c5c5089$export$1fd230d6956c2575;
module.exports["isStreamResearchStepDocument"] = $c3ad42ae8c5c5089$export$3bc697eeff31bdf6;
module.exports["isStreamReconnectSupportPart"] = $c3ad42ae8c5c5089$export$c679ee34f7312895;
module.exports["isStreamResearchPayload"] = $c3ad42ae8c5c5089$export$46e0fb5e4b019a49;
module.exports["isStreamSkill"] = $c3ad42ae8c5c5089$export$6f74311d40862a9f;
module.exports["isStreamMemoryUpdate"] = $c3ad42ae8c5c5089$export$d95e474df0d530df;
module.exports["isStreamTrace"] = $c3ad42ae8c5c5089$export$fd5a05be03f147a0;
module.exports["isStreamThinkDeeperTriggered"] = $c3ad42ae8c5c5089$export$682514f3a8131b98;
module.exports["isFollowUpMessage"] = $c3ad42ae8c5c5089$export$aeae5b4fda357302;
module.exports["isStreamAgenticUi"] = $c3ad42ae8c5c5089$export$6275ff996073145e;
module.exports["isStreamHeartbeat"] = $c3ad42ae8c5c5089$export$b46beea5c82aa1b9;
module.exports["isActionExecutedSuccessfully"] = $c3ad42ae8c5c5089$export$b8391261162989d9;
module.exports["isActionResolutionCancelled"] = $c3ad42ae8c5c5089$export$1060c4fa97e34fa7;
module.exports["isChannelNotFoundError"] = $c3ad42ae8c5c5089$export$6ce1ccc24e75456f;
module.exports["isStreamActionError"] = $c3ad42ae8c5c5089$export$c3c933dad2745d3f;
module.exports["isRateLimitedError"] = $c3ad42ae8c5c5089$export$bc96a6a479480590;
module.exports["isHipaaError"] = $c3ad42ae8c5c5089$export$f8b1b75846492611;
module.exports["isAUPViolationError"] = $c3ad42ae8c5c5089$export$d263dc5d64f36d48;
module.exports["isConversationChannelDataMessage"] = $c3ad42ae8c5c5089$export$b454081350f4a578;
module.exports["isScopeDeterminedMessage"] = $c3ad42ae8c5c5089$export$145ab74998a54a20;
module.exports["isSpaceSourceRecommendationsMessage"] = $c3ad42ae8c5c5089$export$75ceabc5bb9500e4;
module.exports["isStreamPromptRedaction"] = $c3ad42ae8c5c5089$export$f4111656f23d9b9b;
module.exports["isStreamPromptBlock"] = $c3ad42ae8c5c5089$export$c43cf9ba6a2176ef;
module.exports["isStreamResponseRedaction"] = $c3ad42ae8c5c5089$export$f16ff8eb19967a97;
module.exports["isStreamResponseBlock"] = $c3ad42ae8c5c5089$export$55f7bd80eacbc51b;
module.exports["isStreamAttachmentBlock"] = $c3ad42ae8c5c5089$export$a1be74470d3c1fe9;
module.exports["isConfirmAction"] = $c3ad42ae8c5c5089$export$4af48296a8d61cec;

});

parcelRegister("fCunh", function(module, exports) {
const $885d54b804b288bc$export$e8114853eca81277 = 'ai-mate';
const $885d54b804b288bc$export$1106bf31edf2a9b8 = {
    AGENT_DOES_NOT_EXIST: 'errorAgentNotFound',
    USER_NOT_CREATOR: 'errorIncorrectOwner',
    AGENT_HAS_CONVERSATIONS: 'errorAgentInUse',
    AGENT_DEACTIVATED: 'convoai.rest.bad.request.archived.agent',
    AGENT_FORBIDDEN: 'convoai.rest.agent-forbidden',
    ROVO_PRODUCT_NOT_ACTIVE: 'convoai.rest.rovo.product.not.active',
    HAS_HIPAA_ENABLED: 'convoai.rest.browsing.product.has.hipaa.enabled',
    FILE_SIZE_TOO_LARGE: 'convoai.rest.bad.request.file.size.too.large'
};
const $885d54b804b288bc$export$333e4f57333eadfa = {
    UNSUPPORTED_FILE_TYPE: 415,
    FILE_RAI_POLICY_VIOLATION: 406
};
module.exports["ASSISTANCE_SERVICE_ERROR_CODES"] = $885d54b804b288bc$export$1106bf31edf2a9b8;
module.exports["STATUS_CODES"] = $885d54b804b288bc$export$333e4f57333eadfa;

});

parcelRegister("8A2GO", function(module, exports) {
const $a4d06b5ca4d94b78$export$8de5b7b1f5c5cfb7 = 'convoai.rest.pinned.conversation.limit.exceeded';
class $a4d06b5ca4d94b78$export$f2e832acab1bdd79 extends Error {
    constructor(message, errorAttributes, data){
        super(message), this.message = message, this.errorAttributes = errorAttributes;
        /** Structured, non-user-facing details supplied by the API. */ this.data = void 0;
        this.data = data;
    }
}
const $a4d06b5ca4d94b78$export$89d83cc97c52a37 = (error)=>error instanceof $a4d06b5ca4d94b78$export$f2e832acab1bdd79;
const $a4d06b5ca4d94b78$var$getRecord = (value)=>typeof value === 'object' && value !== null && !Array.isArray(value) ? value : undefined;
const $a4d06b5ca4d94b78$var$getApiErrorAttributes = (error)=>{
    if ($a4d06b5ca4d94b78$export$89d83cc97c52a37(error)) return error.errorAttributes;
    return $a4d06b5ca4d94b78$var$getRecord($a4d06b5ca4d94b78$var$getRecord(error)?.errorAttributes);
};
const $a4d06b5ca4d94b78$var$getStructuredErrorData = (error)=>{
    const errorRecord = $a4d06b5ca4d94b78$var$getRecord(error);
    return $a4d06b5ca4d94b78$var$getRecord(errorRecord?.data) ?? $a4d06b5ca4d94b78$var$getRecord($a4d06b5ca4d94b78$var$getRecord(errorRecord?.errorAttributes)?.data);
};
const $a4d06b5ca4d94b78$var$getValidCount = (value, minimum)=>typeof value === 'number' && Number.isInteger(value) && value >= minimum ? value : undefined;
const $a4d06b5ca4d94b78$export$45f7ada0fbd007df = (error)=>{
    const errorAttributes = $a4d06b5ca4d94b78$var$getApiErrorAttributes(error);
    if (errorAttributes?.errorCode !== $a4d06b5ca4d94b78$export$8de5b7b1f5c5cfb7) return undefined;
    const data = $a4d06b5ca4d94b78$var$getStructuredErrorData(error);
    if (!data) return {};
    const maxPinnedConversations = $a4d06b5ca4d94b78$var$getValidCount(data.maxPinnedConversations, 1);
    const pinnedCount = $a4d06b5ca4d94b78$var$getValidCount(data.pinnedCount, 0);
    return {
        ...maxPinnedConversations !== undefined && {
            maxPinnedConversations: maxPinnedConversations
        },
        ...pinnedCount !== undefined && {
            pinnedCount: pinnedCount
        }
    };
};
const $a4d06b5ca4d94b78$export$3c02d1a328d4d808 = (error)=>{
    if ($a4d06b5ca4d94b78$export$89d83cc97c52a37(error)) return error;
    // Fallback since we expect the error to be an instance of ApiError
    return new $a4d06b5ca4d94b78$export$f2e832acab1bdd79(error.message, {
        statusCode: 0
    });
};
module.exports["ApiError"] = $a4d06b5ca4d94b78$export$f2e832acab1bdd79;
module.exports["isApiError"] = $a4d06b5ca4d94b78$export$89d83cc97c52a37;
module.exports["getPinnedConversationLimitErrorData"] = $a4d06b5ca4d94b78$export$45f7ada0fbd007df;
module.exports["mapErrorToApiError"] = $a4d06b5ca4d94b78$export$3c02d1a328d4d808;

});

parcelRegister("7zss8", function(module, exports) {

const $b3b3d72d5c15ae5d$export$caa27b16709bc2df = (product)=>{
    if (window) window.__ROVO_CHAT_CONFIG_PRODUCT__ = product;
};
module.exports["setRovoChatProduct"] = $b3b3d72d5c15ae5d$export$caa27b16709bc2df;

});

parcelRegister("gB5in", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");

function $344aa3e9f3db9c3d$export$693ae5fbaa444eeb(params) {
    const { browserUrl: browserUrl, autoActionApprovalMode: autoActionApprovalMode, useCurrentBrowsingContext: useCurrentBrowsingContext, webSearchEnabled: webSearchEnabled, sourceMode: sourceMode, deepResearchEnabled: deepResearchEnabled, thinkDeeperEnabled: thinkDeeperEnabled, alphaExtendedThinkingMode: alphaExtendedThinkingMode, fastModeEnabled: fastModeEnabled, planModeEnabled: planModeEnabled, editorContext: editorContext, whiteboardContext: whiteboardContext, slidesContext: slidesContext, databaseContext: databaseContext, dashboardEditorContext: dashboardEditorContext, browserContext: browserContext, isBrowserContextBlocklisted: isBrowserContextBlocklisted = false, jiraWorkflowContext: jiraWorkflowContext, additionalContext: additionalContext, writingStyleContext: writingStyleContext, dashboardContext: dashboardContext, aiFeatureContext: aiFeatureContext, fileIds: fileIds, knowledgeOverride: knowledgeOverride, selectedCloudIdsOverride: selectedCloudIdsOverride, searchArtifact: searchArtifact, artifactContext: artifactContext, shouldExtractConversationScopes: shouldExtractConversationScopes } = params;
    const isBrowserSelectionContextGateEnabled = (0, $iDrrr.fg)('rovo_chat_browser_selection_context');
    const browserSelection = isBrowserSelectionContextGateEnabled ? browserContext?.context?.selection : undefined;
    return {
        // without useCurrentBrowsingContext browser_url is not always used by the Rovo,
        // instead it depends on prompt intent to use it,
        // with useCurrentBrowsingContext we can ensure it is always used
        browser_url: browserUrl,
        ...autoActionApprovalMode ? {
            auto_action_approval_mode: autoActionApprovalMode
        } : {},
        ...useCurrentBrowsingContext === undefined ? {} : {
            useCurrentBrowsingContext: useCurrentBrowsingContext
        },
        webSearchEnabled: webSearchEnabled,
        ...sourceMode ? {
            sourceMode: sourceMode
        } : {},
        deepResearchEnabled: deepResearchEnabled,
        ...thinkDeeperEnabled ? {
            extendedThinkingEnabled: thinkDeeperEnabled
        } : {},
        ...alphaExtendedThinkingMode ? {
            alphaExtendedThinkingMode: alphaExtendedThinkingMode
        } : {},
        ...fastModeEnabled ? {
            fastModeEnabled: fastModeEnabled
        } : {},
        ...planModeEnabled ? {
            planModeEnabled: planModeEnabled,
            alphaExtendedThinkingMode: 'MARATHON',
            extendedThinkingEnabled: true
        } : {},
        ...editorContext ? {
            editor: editorContext
        } : {},
        ...whiteboardContext ? {
            whiteboardContext: whiteboardContext
        } : {},
        ...slidesContext ? {
            slidesContext: slidesContext
        } : {},
        ...databaseContext ? {
            databaseContext: databaseContext
        } : {},
        ...dashboardEditorContext ? {
            dashboardEditorContext: dashboardEditorContext
        } : {},
        // If browserUrl is inaccessible, fallback to htmlBody or canvasText if they exist
        // Do not send htmlBody or canvasText if the URL is blocklisted to ensure the site is truly not sent to the backend
        ...browserContext && !isBrowserContextBlocklisted ? {
            browser: {
                htmlBody: browserContext.context?.htmlBody,
                canvasText: browserContext.context?.canvasText,
                ...browserSelection ? {
                    selection: browserSelection
                } : {}
            }
        } : {},
        jiraWorkflowContext: jiraWorkflowContext,
        ...additionalContext,
        ...writingStyleContext ? {
            writingStyleContext: writingStyleContext
        } : {},
        dashboardContext: dashboardContext,
        aiFeatureContext: aiFeatureContext,
        fileIds: fileIds,
        ...knowledgeOverride,
        ...selectedCloudIdsOverride,
        ...searchArtifact ? {
            search_artifact: searchArtifact
        } : {},
        ...artifactContext ? {
            artifact_context: artifactContext
        } : {},
        ...shouldExtractConversationScopes !== undefined ? {
            shouldExtractConversationScopes: shouldExtractConversationScopes
        } : {}
    };
}
module.exports["buildMessageStreamRequestContext"] = $344aa3e9f3db9c3d$export$693ae5fbaa444eeb;

});

parcelRegister("12PUp", function(module, exports) {
async function $0c157c1f6834d6ef$export$42d9632e135ee324({ limit: limit, signal: signal, headers: headers, fetchJson: fetchJson }) {
    const searchParams = new URLSearchParams();
    searchParams.set('limit', String(limit));
    const result = await fetchJson({
        baseUrl: '/gateway/api/acps',
        path: `/rovo/v1/session/prompt-history?${searchParams.toString()}`,
        options: {
            method: 'GET',
            headers: headers,
            signal: signal
        },
        holdName: 'rovo-v1-session-prompt-history'
    });
    return {
        items: result.items.map((item)=>({
                messageId: item.message_id,
                sessionId: item.session_id,
                displayText: item.display_text,
                truncated: item.truncated,
                createdAt: item.created_at,
                isOpeningPrompt: item.is_opening_prompt === true
            })),
        cursor: result.cursor ?? null,
        hasNext: result.hasNext
    };
}
module.exports["getPromptHistory"] = $0c157c1f6834d6ef$export$42d9632e135ee324;

});

parcelRegister("fDfQA", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $k046L = parcelRequire("k046L");

async function* $6c7eb7a39a02f1c4$export$1f24b2b263bcfa75(response) {
    const reader = (0, $k046L.getBufferReader)(response);
    let doneStreaming = false;
    let remainder = '';
    do try {
        const { value: value, done: done } = await reader.read();
        doneStreaming = done;
        if (value) try {
            const processedChunks = `${remainder}${value}`.split('\n'); // assumes that all JSON chunks are separated by a new-line;
            remainder = '';
            for (let chunk of processedChunks)try {
                const json = chunk.startsWith('data: ') && (0, $iDrrr.fg)('rovo-guard-ui-redaction-and-blocking') ? chunk.slice(6) : chunk;
                yield JSON.parse(json);
            } catch (e) {
                // the chunk may be incomplete, so we'll save it for the next iteration.
                remainder = chunk;
            }
        } catch (e) {
            const error = new Error(`Error Processing Stream Data: ${value}`);
            throw error;
        }
    } catch (e) {
        // If we abort the call, this exception bubbles up, so we want to catch it and exit gracefully
        if (e instanceof DOMException && e.name === 'AbortError') doneStreaming = true;
        else throw e;
    }
    while (!doneStreaming);
}
module.exports["readJsonStream"] = $6c7eb7a39a02f1c4$export$1f24b2b263bcfa75;

});

parcelRegister("k046L", function(module, exports) {
const $c70dfd75c754b14f$export$f6383c3ea1307da9 = (response)=>{
    if (!response.body) throw new Error('Response body is empty');
    return response.body.pipeThrough(new TextDecoderStream()).getReader();
};
module.exports["getBufferReader"] = $c70dfd75c754b14f$export$f6383c3ea1307da9;

});

parcelRegister("emCLk", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $k046L = parcelRequire("k046L");

const $b3957af9ca78f17a$var$parseSSEMessage = (message)=>{
    const parsed = {};
    const dataLines = [];
    for (const line of message.split('\n')){
        const trimmedLine = line.trim();
        const colonIndex = trimmedLine.indexOf(':');
        if (trimmedLine && colonIndex !== -1) {
            const field = trimmedLine.substring(0, colonIndex);
            const value = trimmedLine.substring(colonIndex + 1).trimStart();
            switch(field){
                case 'event':
                    parsed.eventType = value;
                    break;
                case 'data':
                    dataLines.push(value);
                    break;
                case 'id':
                    parsed.id = value;
                    break;
                default:
                    break;
            }
        }
    }
    if (dataLines.length) parsed.data = dataLines.join('\n');
    return parsed;
};
async function* $b3957af9ca78f17a$export$6dab2f647580dc69(response) {
    const reader = (0, $k046L.getBufferReader)(response);
    let doneStreaming = false;
    let remainder = '';
    const reliableContracts = (0, $iDrrr.fg)('rovo_ai_mate_reliability_contracts');
    let pendingCarriageReturn = false;
    try {
        do try {
            const { value: value, done: done } = await reader.read();
            doneStreaming = done;
            let text = value ?? '';
            if (reliableContracts) {
                // Preserve a trailing CR until the next read so a split CRLF is one
                // newline, not an accidental event boundary. Lone CR is also valid SSE.
                text = `${pendingCarriageReturn ? '\r' : ''}${text}`;
                pendingCarriageReturn = !done && text.endsWith('\r');
                if (pendingCarriageReturn) text = text.slice(0, -1);
                text = text.replace(/\r\n?/g, '\n');
            }
            if (text) {
                const combined = `${remainder}${text}`;
                const parts = combined.split('\n\n'); // SSE messages are separated by double newlines
                // the last part may be incomplete — keep it for the next read
                remainder = parts.pop() ?? '';
                for (const chunk of parts)try {
                    const parsed = $b3957af9ca78f17a$var$parseSSEMessage(chunk);
                    if (parsed.data) {
                        const parsedData = JSON.parse(parsed.data);
                        yield {
                            __isSSEWrapper: true,
                            data: parsedData,
                            id: parsed.id,
                            eventType: parsed.eventType
                        };
                    }
                } catch  {
                // ignore malformed JSON; keep streaming future valid messages
                }
            }
            // If the stream just ended and we still have a remainder, try to parse it once.
            if (doneStreaming && remainder) try {
                const parsed = $b3957af9ca78f17a$var$parseSSEMessage(remainder);
                if (parsed.data) {
                    const parsedData = JSON.parse(parsed.data);
                    yield {
                        __isSSEWrapper: true,
                        data: parsedData,
                        id: parsed.id,
                        eventType: parsed.eventType
                    };
                }
            } catch  {
            // ignore malformed tail
            } finally{
                remainder = '';
            }
        } catch (e) {
            // If we abort the call, this exception bubbles up, so we want to catch it and exit gracefully
            if (e instanceof DOMException && e.name === 'AbortError') doneStreaming = true;
            else throw e;
        }
        while (!doneStreaming);
    } finally{
        if (reliableContracts) try {
            if (!doneStreaming) await reader.cancel();
        } catch  {
        // Cleanup must not replace the original read error or consumer outcome.
        } finally{
            reader.releaseLock();
        }
    }
}
module.exports["readSSEStream"] = $b3957af9ca78f17a$export$6dab2f647580dc69;

});

parcelRegister("bQQtO", function(module, exports) {

var $4o0zT = parcelRequire("4o0zT");

const $c1455ae7f1250686$var$getMessageStreamHref = (product)=>{
    const backendOriginHost = window?.__backendOriginHost;
    if (product === 'confluence' && window.location.hostname === 'localhost' && typeof backendOriginHost === 'string') {
        const urlWithLocalhost = new URL(window.location.href);
        urlWithLocalhost.hostname = backendOriginHost;
        urlWithLocalhost.port = '';
        urlWithLocalhost.protocol = 'https:';
        return urlWithLocalhost.toString();
    }
    return window?.location?.href;
};
const $c1455ae7f1250686$export$d272e1989c4ab4bf = ({ browserContext: browserContext, browserContextSanitizer: browserContextSanitizer, product: product })=>{
    const browserContextUrl = browserContext?.context?.browserUrl;
    const isBrowserContextBlocklisted = Boolean(browserContextUrl && browserContextSanitizer?.isBlocklisted(browserContextUrl));
    const isBrowserUrlSuppressed = browserContextUrl === 'NO-URL' && (0, $4o0zT.isExperimentEnabled)('jira_free_gen_editor');
    if (isBrowserContextBlocklisted || isBrowserUrlSuppressed) return {
        browserUrl: '',
        isBrowserContextBlocklisted: isBrowserContextBlocklisted
    };
    return {
        browserUrl: browserContextUrl || $c1455ae7f1250686$var$getMessageStreamHref(product) || '',
        isBrowserContextBlocklisted: isBrowserContextBlocklisted
    };
};
module.exports["resolveMessageStreamBrowserUrl"] = $c1455ae7f1250686$export$d272e1989c4ab4bf;

});

parcelRegister("4o0zT", function(module, exports) {

var $cha5E = parcelRequire("cha5E");

function $36a5a3af492bc91f$export$336b018592dc9972(experimentName) {
    return (0, $cha5E.expVal)(experimentName, 'isEnabled', false) === true;
}
module.exports["isExperimentEnabled"] = $36a5a3af492bc91f$export$336b018592dc9972;

});

parcelRegister("5suST", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");

const $751ca72a9993528e$export$3b20549d55cda4db = 'store-message-from-user-settings';
const $751ca72a9993528e$export$bd10ff38e53e4101 = 'actionable-follow-ups';
const $751ca72a9993528e$export$f447b2e2b8f0d61e = 'actionable-follow-ups-stacked';
/**
 * Maps each gated capability to the gate that enables it. Add new
 * capability/gate pairs here rather than introducing nested ternaries at the
 * call sites.
 */ const $751ca72a9993528e$var$GATED_CAPABILITIES = [
    {
        capability: $751ca72a9993528e$export$3b20549d55cda4db,
        isEnabled: ()=>(0, $iDrrr.fg)('ai_mate_store_messages_be_driven')
    }
];
const $751ca72a9993528e$export$6656e8be041b8747 = (capabilities)=>{
    const enabledCapabilities = $751ca72a9993528e$var$GATED_CAPABILITIES.filter(({ isEnabled: isEnabled })=>isEnabled()).map(({ capability: capability })=>capability);
    // Preserve older UIs' inline opt-in, but never request both formats.
    const callerCapabilities = capabilities?.includes($751ca72a9993528e$export$f447b2e2b8f0d61e) ? capabilities.filter((capability)=>capability !== $751ca72a9993528e$export$bd10ff38e53e4101) : capabilities;
    if (callerCapabilities === undefined && enabledCapabilities.length === 0) return undefined;
    return Array.from(new Set([
        ...callerCapabilities ?? [],
        ...enabledCapabilities
    ]));
};
module.exports["buildEffectiveCapabilities"] = $751ca72a9993528e$export$6656e8be041b8747;

});

parcelRegister("irsyK", function(module, exports) {

var $8A2GO = parcelRequire("8A2GO");


var $jTKfH = parcelRequire("jTKfH");

const $c641c5a09bfdfc34$export$4c25481b843feb0b = (baseUrl, path)=>{
    if (path === '') // return base url without trailing slash
    return baseUrl;
    const urlWithTrailingSlash = baseUrl.endsWith('/') ? baseUrl : `${baseUrl}/`;
    const pathWithoutLeadingSlash = !path.startsWith('/') ? path : path.substring(1, path.length);
    const url = [
        urlWithTrailingSlash,
        pathWithoutLeadingSlash
    ].join('');
    return url;
};
const $c641c5a09bfdfc34$var$removeTimestampFromErrorMessage = (errorBodyJson)=>{
    const { timestamp: _timestamp, ...rest } = errorBodyJson;
    return JSON.stringify(rest);
};
const $c641c5a09bfdfc34$var$processErrorResponse = async ({ response: response })=>{
    let errorCode;
    let outputErrorMessage;
    const responseText = await response.text();
    let rawErrorMessage;
    let data;
    try {
        const errorBodyJson = JSON.parse(responseText);
        const { data: responseData, error_code: error_code, error_message: error_message, message_template: message_template, errors: errors, errorMessage: errorMessage, timestamp: timestamp } = errorBodyJson;
        data = typeof responseData === 'object' && responseData !== null && !Array.isArray(responseData) ? responseData : undefined;
        rawErrorMessage = errorMessage ?? error_message;
        if (errors?.length) // Use a single error code for now
        errorCode = errors[0];
        else if (error_code) errorCode = error_code;
        else errorCode = message_template;
        if (!errorCode || !rawErrorMessage) outputErrorMessage = timestamp ? $c641c5a09bfdfc34$var$removeTimestampFromErrorMessage(errorBodyJson) : responseText;
        else outputErrorMessage = `${errorCode} - ${rawErrorMessage}`;
    } catch  {
        outputErrorMessage = responseText;
    }
    const errorMessage = `[Code ${response.status}] ${outputErrorMessage}`;
    const errorAttributes = {
        errorCode: errorCode,
        statusCode: response.status,
        rawErrorMessage: rawErrorMessage,
        traceId: (0, $jTKfH.getTraceIdFromResponse)(response)
    };
    throw new (0, $8A2GO.ApiError)(errorMessage, errorAttributes, data);
};
const $c641c5a09bfdfc34$export$21fcb6cfd5628534 = async ({ response: response })=>{
    if (!response.ok || response.status >= 400) await $c641c5a09bfdfc34$var$processErrorResponse({
        response: response
    });
    return response;
};
module.exports["addPath"] = $c641c5a09bfdfc34$export$4c25481b843feb0b;
module.exports["processResponse"] = $c641c5a09bfdfc34$export$21fcb6cfd5628534;

});

parcelRegister("7td41", function(module, exports) {
const $00fdf2622c1683af$export$11cc4786742ed7c2 = ()=>{
    const date = new Date();
    const formattedDate = date.toLocaleDateString(undefined, {
        year: '2-digit',
        month: '2-digit',
        day: '2-digit'
    });
    const formattedTime = date.toLocaleTimeString(undefined, {
        hour: '2-digit',
        minute: '2-digit',
        hour12: true
    });
    const name = `${formattedDate} ${formattedTime}`;
    return name;
};
module.exports["generateConversationName"] = $00fdf2622c1683af$export$11cc4786742ed7c2;

});

parcelRegister("bkEBw", function(module, exports) {

var $bxkJA = parcelRequire("bxkJA");


var $3PJhM = parcelRequire("3PJhM");

const $ac118120c3114919$export$218c8c3169c024d2 = (streamResponse)=>streamResponse.message.message.id;
const $ac118120c3114919$var$addAnswerPartAssistantMessage = (response, answerPart)=>{
    const content = `${response.content}${answerPart.message.content}`;
    // Remove source indexes, e.g [^1^] from the content
    const cleanedContent = content.replace(/\[\^\d+\^\]/g, '');
    return {
        ...response,
        content: cleanedContent
    };
};
const $ac118120c3114919$var$addAnswerPartAgentResponse = (response, answerPart)=>({
        ...response,
        message: $ac118120c3114919$var$addAnswerPartAssistantMessage(response.message, answerPart)
    });
// ****************************************************************************
// Action streaming accumulation configuration
// ****************************************************************************
const $ac118120c3114919$var$toPathArr = (path)=>Array.isArray(path) ? path : path.split('.').filter(Boolean);
const $ac118120c3114919$var$getAtPath = (obj, path)=>{
    let cur = obj;
    for (const key of path){
        if (!(0, $3PJhM.isRecord)(cur)) return undefined;
        cur = cur[key];
    }
    return cur;
};
const $ac118120c3114919$var$setAtPath = (obj, path, value)=>{
    if (path.length === 0) return value;
    const [head, ...rest] = path;
    const base = (0, $3PJhM.isRecord)(obj) ? obj : {};
    return {
        ...base,
        [head]: $ac118120c3114919$var$setAtPath(base[head], rest, value)
    };
};
// Defines which sub-field(s) of a message action's data should be accumulated by string appending.
// Keyed by action key. Values can be a dot path or an array path, or an array of multiple paths.
// E.g.:
// {
//   'create-document-action': 'content',
//   'update-document-action': ['content', 'meta.subtitle']
// }
let $ac118120c3114919$var$actionDataAccumulationConfig = {
    ['aifc-confluence-page-create']: 'adf'
};
const $ac118120c3114919$export$a1715e22f3105088 = (prev, next)=>{
    const key = next.key;
    const rulePaths = $ac118120c3114919$var$actionDataAccumulationConfig[key];
    const prevData = prev?.data;
    const newData = next?.data;
    if (rulePaths && typeof prevData === 'object' && prevData !== null && typeof newData === 'object' && newData !== null) {
        const paths = Array.isArray(rulePaths) ? rulePaths : [
            rulePaths
        ];
        let base = {
            ...newData
        };
        for (const p of paths){
            const pathArr = $ac118120c3114919$var$toPathArr(p);
            const prevVal = $ac118120c3114919$var$getAtPath(prevData, pathArr);
            const nextVal = $ac118120c3114919$var$getAtPath(newData, pathArr);
            const accumulated = String(prevVal ?? '') + String(nextVal ?? '');
            const updated = $ac118120c3114919$var$setAtPath(base, pathArr, accumulated);
            // `setAtPath` only returns the raw `value` when the path is empty; here
            // `pathArr` is always non-empty (derived from a configured rule path), so
            // the result is always the spread record branch.
            if ((0, $3PJhM.isRecord)(updated)) base = updated;
        }
        return {
            ...prev,
            data: base,
            status: next.status
        };
    }
    // Default: replace only data from next, keep other fields from prev
    return {
        ...prev,
        data: next.data,
        status: next.status
    };
};
const $ac118120c3114919$export$6554ad578994a75f = (actions, actionPart, actionUpdaterOverride)=>{
    const { key: key, invocationId: invocationId } = actionPart.message;
    // Accumulate by `invocationId` when the part has one, so multiple same-`key` actions (e.g. several
    // page creates in a single message) stream independently; fall back to `key` for parts without an
    // invocationId. For single-action messages both resolve to the same action, so no experiment gate
    // is needed here.
    const existingActionIndex = invocationId ? actions.findIndex((action)=>action.invocationId === invocationId) : actions.findIndex((action)=>action.key === key);
    if (existingActionIndex === -1) return [
        ...actions || [],
        actionPart.message
    ];
    const updatedActions = [
        ...actions
    ];
    const prevAction = updatedActions[existingActionIndex];
    const nextAction = actionPart.message;
    updatedActions[existingActionIndex] = actionUpdaterOverride ? actionUpdaterOverride(prevAction, nextAction) : $ac118120c3114919$export$a1715e22f3105088(prevAction, nextAction);
    return updatedActions;
};
const $ac118120c3114919$export$6e5609c05ab74cc7 = (response, answerPart)=>({
        ...response,
        message: $ac118120c3114919$var$addAnswerPartAgentResponse(response.message, answerPart)
    });
const $ac118120c3114919$export$13b6a4e4e3704011 = (response, actionPart, actionUpdaterOverride)=>{
    const { message: message } = response.message;
    const { actions: actions } = message;
    const isActionsArrayPresent = actions && actions.length > 0;
    return {
        ...response,
        message: {
            ...response.message,
            message: {
                ...message,
                actions: !isActionsArrayPresent ? [
                    actionPart.message
                ] : $ac118120c3114919$export$6554ad578994a75f(actions, actionPart, actionUpdaterOverride)
            }
        }
    };
};
const $ac118120c3114919$var$removeSensitiveDataAssistantMessage = (message)=>{
    const { plugin_invocations: plugin_invocations, ...rest } = message;
    return {
        ...rest,
        plugin_invocations: plugin_invocations.map((pluginInvocation)=>({
                ...pluginInvocation,
                plugin_output: '--PRIVATE--'
            }))
    };
};
const $ac118120c3114919$var$removeSensitiveDataAgentResponse = (message)=>({
        ...message,
        message: $ac118120c3114919$var$removeSensitiveDataAssistantMessage(message.message)
    });
const $ac118120c3114919$export$efd4f6b5d168b654 = (message)=>({
        ...message,
        message: $ac118120c3114919$var$removeSensitiveDataAgentResponse(message.message)
    });
const $ac118120c3114919$export$4c47ae95c311c518 = '00000000-0000-0000-0000-000000000000';
const $ac118120c3114919$export$4010f996e89e886a = (id, content, isFromSeededConversation, requestId, fileUploads, displayContext)=>{
    return {
        role: 'HUMAN',
        id: id,
        content: content,
        time_created: new Date().toISOString(),
        user_ari: 'unknown',
        plugin_invocations: [],
        isFromSeededConversation: isFromSeededConversation,
        requestId: requestId,
        file_uploads: fileUploads,
        ...displayContext ? {
            display_context: displayContext
        } : {}
    };
};
const $ac118120c3114919$export$3220a4ff7b3a96df = (message)=>{
    if ((0, $bxkJA.isAgentResponse)(message)) return {
        type: 'FINAL_RESPONSE',
        message: message
    };
    return {
        type: 'FINAL_RESPONSE',
        message: {
            message: message
        }
    };
};
module.exports["getId"] = $ac118120c3114919$export$218c8c3169c024d2;
module.exports["addAnswerPart"] = $ac118120c3114919$export$6e5609c05ab74cc7;
module.exports["addActionPart"] = $ac118120c3114919$export$13b6a4e4e3704011;
module.exports["removeSensitiveData"] = $ac118120c3114919$export$efd4f6b5d168b654;
module.exports["NO_PARENT_MESSAGE_ID"] = $ac118120c3114919$export$4c47ae95c311c518;
module.exports["createHumanMessage"] = $ac118120c3114919$export$4010f996e89e886a;
module.exports["toStreamResponse"] = $ac118120c3114919$export$3220a4ff7b3a96df;

});

parcelRegister("isp1U", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $dOBRD = parcelRequire("dOBRD");


var $iDrrr = parcelRequire("iDrrr");


var $2A9fJ = parcelRequire("2A9fJ");

const $2def26aed08f588d$var$fetchProfileData = (0, $dOBRD.default)(async ()=>{
    const data = await (0, $2A9fJ.me)();
    return {
        aaid: data.account_id,
        name: data.name || '',
        displayName: data.nickname,
        avatarUrl: data.picture,
        email: data.email
    };
});
const $2def26aed08f588d$export$2d8258e5f5afe915 = async ()=>(await $2def26aed08f588d$var$fetchProfileData()).aaid;
const $2def26aed08f588d$export$3c814b55c7cbb1fb = (0, $cozmU.createContext)(null);
const $2def26aed08f588d$var$emptyProfileData = {
    name: '',
    displayName: '',
    avatarUrl: ''
};
const $2def26aed08f588d$var$toProfileControllerData = (profileData, profileStatus, isProfileStatusEnabled)=>isProfileStatusEnabled ? {
        ...profileData,
        profileStatus: profileStatus
    } : profileData;
const $2def26aed08f588d$export$68afc71177137005 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (preFetchedProfileData)=>{
    const $ = (0, $bDgLe.c)(6);
    const profileContextData = (0, $cozmU.useContext)($2def26aed08f588d$export$3c814b55c7cbb1fb);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $iDrrr.fg)("rovo-chat-ai-inbox");
        $[0] = t0;
    } else t0 = $[0];
    const isProfileStatusEnabled = t0;
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>$2def26aed08f588d$var$toProfileControllerData($2def26aed08f588d$var$emptyProfileData, "loading", isProfileStatusEnabled);
        $[1] = t1;
    } else t1 = $[1];
    const [profileData, setProfileData] = (0, $cozmU.useState)(t1);
    let t2;
    let t3;
    if ($[2] !== preFetchedProfileData || $[3] !== profileContextData) {
        t2 = ()=>{
            if (preFetchedProfileData) setProfileData($2def26aed08f588d$var$toProfileControllerData(preFetchedProfileData, preFetchedProfileData.aaid ? "ready" : "unavailable", isProfileStatusEnabled));
            else if (profileContextData) setProfileData($2def26aed08f588d$var$toProfileControllerData(profileContextData, profileContextData.aaid ? "ready" : "unavailable", isProfileStatusEnabled));
            else $2def26aed08f588d$var$fetchProfileData().then((data)=>setProfileData($2def26aed08f588d$var$toProfileControllerData(data, data.aaid ? "ready" : "unavailable", isProfileStatusEnabled))).catch(()=>setProfileData($2def26aed08f588d$var$toProfileControllerData($2def26aed08f588d$var$emptyProfileData, "unavailable", isProfileStatusEnabled)));
        };
        t3 = [
            setProfileData,
            isProfileStatusEnabled,
            profileContextData,
            preFetchedProfileData
        ];
        $[2] = preFetchedProfileData;
        $[3] = profileContextData;
        $[4] = t2;
        $[5] = t3;
    } else {
        t2 = $[4];
        t3 = $[5];
    }
    (0, $cozmU.useEffect)(t2, t3);
    return profileData;
} : (preFetchedProfileData)=>{
    const profileContextData = (0, $cozmU.useContext)($2def26aed08f588d$export$3c814b55c7cbb1fb);
    const isProfileStatusEnabled = (0, $iDrrr.fg)('rovo-chat-ai-inbox');
    const [profileData, setProfileData] = (0, $cozmU.useState)(()=>$2def26aed08f588d$var$toProfileControllerData($2def26aed08f588d$var$emptyProfileData, 'loading', isProfileStatusEnabled));
    (0, $cozmU.useEffect)(()=>{
        if (preFetchedProfileData) setProfileData($2def26aed08f588d$var$toProfileControllerData(preFetchedProfileData, preFetchedProfileData.aaid ? 'ready' : 'unavailable', isProfileStatusEnabled));
        else if (profileContextData) setProfileData($2def26aed08f588d$var$toProfileControllerData(profileContextData, profileContextData.aaid ? 'ready' : 'unavailable', isProfileStatusEnabled));
        else $2def26aed08f588d$var$fetchProfileData().then((data)=>setProfileData($2def26aed08f588d$var$toProfileControllerData(data, data.aaid ? 'ready' : 'unavailable', isProfileStatusEnabled))).catch(()=>setProfileData($2def26aed08f588d$var$toProfileControllerData($2def26aed08f588d$var$emptyProfileData, 'unavailable', isProfileStatusEnabled)));
    }, [
        setProfileData,
        isProfileStatusEnabled,
        profileContextData,
        preFetchedProfileData
    ]);
    return profileData;
};
module.exports["fetchProfileAaid"] = $2def26aed08f588d$export$2d8258e5f5afe915;
module.exports["ProfileContext"] = $2def26aed08f588d$export$3c814b55c7cbb1fb;
module.exports["useProfileController"] = $2def26aed08f588d$export$68afc71177137005;

});

parcelRegister("2A9fJ", function(module, exports) {

var $jTKfH = parcelRequire("jTKfH");

const $baf5ee02956fd5a8$export$3e32638432616b6 = async ()=>{
    const response = await (0, $jTKfH.performHttpFetch)({
        path: '/gateway/api/me',
        options: {
            method: 'GET'
        }
    });
    return response;
};
module.exports["me"] = $baf5ee02956fd5a8$export$3e32638432616b6;

});

parcelRegister("gyWKg", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $1l0kj = parcelRequire("1l0kj");


var $4aRua = parcelRequire("4aRua");


var $1VhsF = parcelRequire("1VhsF");


var $hlvTd = parcelRequire("hlvTd");


var $iuCeV = parcelRequire("iuCeV");

function $e5d42e7967be8c63$var$_defineProperty(e, r, t) {
    return (r = $e5d42e7967be8c63$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $e5d42e7967be8c63$var$_toPropertyKey(t) {
    var i = $e5d42e7967be8c63$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $e5d42e7967be8c63$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $e5d42e7967be8c63$var$styles = {
    wrapper: "_0jFU0VN91d _39xV02N91d _0KLXruhH7k"
};
const $e5d42e7967be8c63$var$ErrorView = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { error: error } = t0;
    let t1;
    if ($[0] !== error) {
        t1 = error?.message ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            as: "p"
        }, "[", error.message, "]") : null;
        $[0] = error;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            alignBlock: "center",
            alignInline: "center",
            xcss: $e5d42e7967be8c63$var$styles.wrapper,
            testId: "ai-mate-error-boundary"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1VhsF.default), {
            title: "Oops. We've got an error.",
            appearance: "error"
        }, t1)));
        $[2] = t1;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : ({ error: error })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        alignInline: "center",
        xcss: $e5d42e7967be8c63$var$styles.wrapper,
        testId: "ai-mate-error-boundary"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1VhsF.default), {
        title: "Oops. We've got an error.",
        appearance: "error"
    }, error?.message ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        as: "p"
    }, "[", error.message, "]") : null)));
};
class $e5d42e7967be8c63$export$e926676385687eaf extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    componentDidCatch(error) {
        (0, $hlvTd.addSentryBreadcrumb)(`ErrorBoundary: componentDidCatch: ${error.message}`);
        this.setState({
            error: error
        });
        if (this.props.rethrowErrors) throw error;
    }
    render() {
        const { error: error } = this.state;
        const { children: children, experienceName: experienceName, experienceNameList: experienceNameList, teamName: teamName } = this.props;
        if (!!error) {
            const combinedExperienceNameList = [
                ...new Set([
                    ...experienceNameList || [],
                    experienceName
                ])
            ].filter((experienceName)=>experienceName !== undefined);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, this.props.fallback ? this.props.fallback : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e5d42e7967be8c63$var$ErrorView, {
                error: error
            }), combinedExperienceNameList.map((experienceName)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iuCeV.ExperienceFailure), {
                    error: error,
                    name: experienceName,
                    teamName: teamName
                })));
        }
        return children;
    }
    constructor(...args){
        super(...args);
        $e5d42e7967be8c63$var$_defineProperty(this, "state", {});
    }
}
$e5d42e7967be8c63$var$_defineProperty($e5d42e7967be8c63$export$e926676385687eaf, "displayName", 'ConversationAssistantErrorBoundary');
module.exports["ErrorBoundary"] = $e5d42e7967be8c63$export$e926676385687eaf;

});

parcelRegister("iuCeV", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6cFsl = parcelRequire("6cFsl");


var $bjY3F = parcelRequire("bjY3F");

const $4726ba45c1bca0cb$export$4962f3898bd5c829 = ({ name: name, trigger: trigger = 'mount', attributes: attributes })=>{
    (0, $6cFsl.di)((0, $bjY3F.useAIMateExperienceTracker));
    const successTriggerRef = (0, $cozmU.useRef)(trigger);
    const attributesRef = (0, $cozmU.useRef)(attributes);
    const experienceTracker = (0, $bjY3F.useAIMateExperienceTracker)();
    (0, $cozmU.useEffect)(()=>{
        const successAttributes = attributesRef.current;
        if (successTriggerRef.current === 'mount') experienceTracker.succeed({
            name: name,
            ...successAttributes && {
                attributes: successAttributes
            }
        });
        if (successTriggerRef.current === 'unmount') return ()=>{
            experienceTracker.succeed({
                name: name,
                ...successAttributes && {
                    attributes: successAttributes
                }
            });
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return null;
};
const $4726ba45c1bca0cb$export$eed1d73ebdd8c7ab = ({ error: error, name: name, teamName: teamName })=>{
    (0, $6cFsl.di)((0, $bjY3F.useAIMateExperienceTracker));
    const experienceTracker = (0, $bjY3F.useAIMateExperienceTracker)();
    (0, $cozmU.useEffect)(()=>{
        experienceTracker.fail({
            name: name,
            error: error,
            teamName: teamName
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return null;
};
const $4726ba45c1bca0cb$export$f20b867e738a222c = ({ name: name, attributes: attributes })=>{
    (0, $6cFsl.di)((0, $bjY3F.useAIMateExperienceTracker));
    const experienceTracker = (0, $bjY3F.useAIMateExperienceTracker)();
    (0, $cozmU.useMemo)(()=>{
        experienceTracker.start({
            id: name,
            name: name,
            attributes: attributes
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return null;
};
module.exports["ExperienceSuccess"] = $4726ba45c1bca0cb$export$4962f3898bd5c829;
module.exports["ExperienceFailure"] = $4726ba45c1bca0cb$export$eed1d73ebdd8c7ab;
module.exports["ExperienceStart"] = $4726ba45c1bca0cb$export$f20b867e738a222c;

});

parcelRegister("hJ1ww", function(module, exports) {
const $66b2cc9d5a9f46b4$export$d41865d5350d9e0a = (product)=>{
    switch(product){
        case 'confluence':
            return 'confluence';
        case 'jira-software':
        case 'jira-core':
        case 'jsm':
        case 'jpd':
        case 'jira':
            return 'jira';
        case 'atlassian-studio':
        case 'rovo':
        case 'atlas':
            return 'atlas';
        case 'bitbucket':
            return 'bitbucket';
        case 'trello':
            return 'trello';
        case 'admin':
            return 'admin';
        case 'store':
            return 'store';
        case 'loom':
            return 'loom';
        default:
            return 'unknown';
    }
};
module.exports["serviceProductToProductKey"] = $66b2cc9d5a9f46b4$export$d41865d5350d9e0a;

});

parcelRegister("6H2Ay", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $8wqiw = parcelRequire("8wqiw");

const $e3dfb33e54e47641$export$f9cd1e43211d8a4a = (0, $cozmU.createContext)((0, $8wqiw.initialState));
module.exports["globalConfig"] = $e3dfb33e54e47641$export$f9cd1e43211d8a4a;

});

parcelRegister("8wqiw", function(module, exports) {
const $fc6f73f3a32dac3c$export$d4c72bab9d6cc13a = {
    profileData: {
        name: 'John Doe'
    },
    feedbackCollector: {
        entryPointId: ''
    },
    siteId: '',
    experienceId: '',
    productKey: '',
    productHeader: '',
    orgId: '',
    assistanceServiceConfig: undefined,
    closeChat: ()=>{},
    emojiProvider: undefined,
    preventAbortRequestsOnStagingModalClose: false,
    preventAbortRequestsOnStandaloneChatClose: false,
    inProductExperience: '',
    smartCreationContext: undefined,
    autocompletePageContentSource: undefined,
    contextualPromptAnalyticsMetadata: undefined,
    moduleAnalyticsContext: undefined,
    analyticsProductHeader: undefined
};
module.exports["initialState"] = $fc6f73f3a32dac3c$export$d4c72bab9d6cc13a;

});

parcelRegister("atEX8", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $a771a20ee041d8be$export$33f9eded602e3caf = (0, $cozmU.createContext)(undefined);
module.exports["SideNavContext"] = $a771a20ee041d8be$export$33f9eded602e3caf;

});

parcelRegister("blKf8", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $2zlSy = parcelRequire("2zlSy");

const $25b69de57535dd1e$export$c85ba824665b708f = (0, $cozmU.createContext)((0, $2zlSy.initialState));
module.exports["uiConfig"] = $25b69de57535dd1e$export$c85ba824665b708f;

});

parcelRegister("2zlSy", function(module, exports) {
const $25fc89fcc6d2e62b$export$d4c72bab9d6cc13a = {
    fullScreen: false,
    externalEmbed: false,
    preserveUrlConversationId: false,
    skipAutoConversationSelection: false,
    isContextPanelEnabled: false,
    customHandlers: {
        handleDeepLinkClick: undefined,
        handleSubmitSmartCreate: ()=>{}
    },
    isBitbucketBetaEnabled: false,
    customFeedbackCategories: undefined,
    stagingAreaRef: undefined,
    promptInputDroppableUrls: undefined,
    enableBrowserContextBanner: false,
    disableSettingsModal: false,
    enableSkills: true,
    enableAutoSuggest: true,
    enableMiniModalResize: true,
    browserContextSanitizer: undefined,
    elements: {
        closeButton: true,
        backButton: true,
        newChatButton: true,
        fullscreenButton: true,
        createAgentButton: true,
        browseAgentsButton: true,
        agentsMenu: true,
        navbar: true,
        mainChatHeader: true,
        stagingAreaEnabled: false,
        voiceDictationButton: false,
        fileUploadButton: true,
        chatModeMenuButton: true,
        maxModeButton: true,
        shouldShowConversationActions: true,
        shouldShowContextBanner: true
    }
};
module.exports["initialState"] = $25fc89fcc6d2e62b$export$d4c72bab9d6cc13a;

});

parcelRegister("c69qG", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $12fb09f9899d13ab$export$dfdd5bb3b7412d6d = (0, $cozmU.createContext)(undefined);
module.exports["agentVersioningConfigContext"] = $12fb09f9899d13ab$export$dfdd5bb3b7412d6d;

});

parcelRegister("j180q", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cXtTj = parcelRequire("cXtTj");


var $iDrrr = parcelRequire("iDrrr");


var $89QZA = parcelRequire("89QZA");


var $bGNkz = parcelRequire("bGNkz");


var $eKjv9 = parcelRequire("eKjv9");


var $dSCNl = parcelRequire("dSCNl");


var $n71o5 = parcelRequire("n71o5");


var $5wAPd = parcelRequire("5wAPd");

const $044e4eae4d9054a7$export$18774f6b5154d8f2 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const { mode: mode } = t0;
    const [t1] = (0, $n71o5.useChatStore)();
    const { currentConversationId: currentConversationId } = t1;
    const { experienceId: experienceId, productKey: productKey, productHeader: productHeader, assistanceServiceConfig: assistanceServiceConfig, inProductExperience: inProductExperience } = (0, $eKjv9.useGlobalConfig)();
    const { selectedAgent: selectedAgent, conversation: conversation } = (0, $5wAPd.useConversation)();
    const { setAnalyticsPropertiesWithoutRerender: setAnalyticsPropertiesWithoutRerender } = (0, $89QZA.useAnalyticsPropertiesContext)();
    const { fullScreen: fullScreen } = (0, $dSCNl.useUIConfig)();
    const [t2] = (0, $bGNkz.useSelectedSpaceSelector)();
    const { selectedSpace: selectedSpace } = t2;
    const modeVal = fullScreen ? "fullscreen" : mode;
    const resolvedSpaceId = (0, $cXtTj.default).getExperimentValue("rovo_chat_spaces_experiment", "isEnabled", false) ? selectedSpace?.id ?? conversation?.rovoSpaceId : undefined;
    const agentAttributes = {
        agentCreatorType: selectedAgent?.creator_type ?? null,
        agentId: selectedAgent?.id ?? null,
        agentVisibility: selectedAgent?.visibility ?? null,
        agentExternalConfigReference: selectedAgent?.external_config_reference ?? null,
        agentActions: ((0, $iDrrr.fg)("rovo_autodev_analytics_track_actions") ? selectedAgent?.action_config?.map($044e4eae4d9054a7$var$_temp) : []) ?? [],
        agentIsDefault: selectedAgent?.is_default ?? null,
        agentIsVerified: selectedAgent?.is_verified ?? null
    };
    setAnalyticsPropertiesWithoutRerender({
        ...agentAttributes,
        conversationChannelId: currentConversationId,
        experienceId: experienceId,
        fullScreen: fullScreen,
        mode: modeVal,
        product: productKey,
        productHeader: productHeader,
        inProductExperience: inProductExperience,
        singleInstrumentationID: currentConversationId,
        assistanceServiceConfigMinionAlias: assistanceServiceConfig?.minionAlias ?? null,
        spaceId: resolvedSpaceId,
        ...(0, $iDrrr.fg)("rovo_chat_entry_point_foundation") ? {
            chatEntryPoint: conversation?.chatEntryPoint
        } : {},
        launchSource: conversation?.resultAttributionContext?.launchSource,
        rovoJourneyId: conversation?.rovoJourneyId,
        isThirdPartyPromptConversation: conversation?.thirdPartyPrompt ? true : undefined,
        thirdPartyPromptCohort: conversation?.thirdPartyPrompt?.cohort,
        thirdPartyConnectCount: conversation?.thirdPartyPrompt?.connectCount
    });
    return null;
} : ({ mode: mode })=>{
    const [{ currentConversationId: currentConversationId }] = (0, $n71o5.useChatStore)();
    const { experienceId: experienceId, productKey: productKey, productHeader: productHeader, assistanceServiceConfig: assistanceServiceConfig, inProductExperience: inProductExperience } = (0, $eKjv9.useGlobalConfig)();
    const { selectedAgent: selectedAgent, conversation: conversation } = (0, $5wAPd.useConversation)();
    const { setAnalyticsPropertiesWithoutRerender: setAnalyticsPropertiesWithoutRerender } = (0, $89QZA.useAnalyticsPropertiesContext)();
    const { fullScreen: fullScreen } = (0, $dSCNl.useUIConfig)();
    const [{ selectedSpace: selectedSpace }] = (0, $bGNkz.useSelectedSpaceSelector)();
    const modeVal = fullScreen ? 'fullscreen' : mode;
    // When the chat is scoped to a Rovo Space, tag every fired event with the
    // spaceId (mirrors the resolution used at message-send time in
    // chat-input-refresh) so "Space MAU" — unique users who initiate a chat in a
    // space — is measurable from the standard AI MAU `initiated`/`viewed` events.
    // Resolves to `undefined` (never `null`) when there is no active space so the
    // attribute is omitted from non-space events, and — because it is always
    // written below — a previously-set spaceId is cleared when the user moves from
    // a space-scoped chat back to a general one.
    const resolvedSpaceId = (0, $cXtTj.default).getExperimentValue('rovo_chat_spaces_experiment', 'isEnabled', false) ? selectedSpace?.id ?? conversation?.rovoSpaceId : undefined;
    const agentAttributes = {
        agentCreatorType: selectedAgent?.creator_type ?? null,
        agentId: selectedAgent?.id ?? null,
        agentVisibility: selectedAgent?.visibility ?? null,
        agentExternalConfigReference: selectedAgent?.external_config_reference ?? null,
        agentActions: ((0, $iDrrr.fg)('rovo_autodev_analytics_track_actions') ? selectedAgent?.action_config?.map((config)=>config.id) : []) ?? [],
        agentIsDefault: selectedAgent?.is_default ?? null,
        agentIsVerified: selectedAgent?.is_verified ?? null
    };
    setAnalyticsPropertiesWithoutRerender({
        ...agentAttributes,
        conversationChannelId: currentConversationId,
        experienceId: experienceId,
        fullScreen: fullScreen,
        mode: modeVal,
        product: productKey,
        productHeader: productHeader,
        inProductExperience: inProductExperience,
        singleInstrumentationID: currentConversationId,
        assistanceServiceConfigMinionAlias: assistanceServiceConfig?.minionAlias ?? null,
        // Always written (not conditionally spread) so switching away from a space
        // clears the previous spaceId; `undefined` is omitted from event payloads.
        spaceId: resolvedSpaceId,
        // Always write this while the gate is enabled so a conversation without an entry point
        // clears the value inherited from the previous conversation.
        ...(0, $iDrrr.fg)('rovo_chat_entry_point_foundation') ? {
            chatEntryPoint: conversation?.chatEntryPoint
        } : {},
        // Launch source from the conversation, surfaced on all fired events.
        launchSource: conversation?.resultAttributionContext?.launchSource,
        // Always write this so switching conversations also clears stale journey attribution.
        rovoJourneyId: conversation?.rovoJourneyId,
        // Mirrored from the conversation, always written for the same reason as `spaceId`: this is
        // what clears the attributes when the chat moves to a conversation that did not come from
        // a 3P prompt (CCINT-8714).
        isThirdPartyPromptConversation: conversation?.thirdPartyPrompt ? true : undefined,
        thirdPartyPromptCohort: conversation?.thirdPartyPrompt?.cohort,
        thirdPartyConnectCount: conversation?.thirdPartyPrompt?.connectCount
    });
    return null;
};
function $044e4eae4d9054a7$var$_temp(config) {
    return config.id;
}
module.exports["AnalyticsPropertiesUpdater"] = $044e4eae4d9054a7$export$18774f6b5154d8f2;

});

parcelRegister("eKjv9", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $6H2Ay = parcelRequire("6H2Ay");

const $964b2b4aa2fb5756$export$29031ce8b4e54e85 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)((0, $6H2Ay.globalConfig));
} : ()=>(0, $cozmU.useContext)((0, $6H2Ay.globalConfig));
module.exports["useGlobalConfig"] = $964b2b4aa2fb5756$export$29031ce8b4e54e85;

});

parcelRegister("dSCNl", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $blKf8 = parcelRequire("blKf8");

const $78dfed354051ab06$export$e83755c3ab7a4493 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)((0, $blKf8.uiConfig));
} : ()=>(0, $cozmU.useContext)((0, $blKf8.uiConfig));
module.exports["useUIConfig"] = $78dfed354051ab06$export$e83755c3ab7a4493;

});

parcelRegister("n71o5", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");


var $lx3cN = parcelRequire("lx3cN");


var $3TrVh = parcelRequire("3TrVh");

/**
 * ************************************************************
 * Main Hook
 * ************************************************************
 */ const $cea7beaf4fdf86cd$var$publicStateSelector = (state)=>{
    return {
        ...state,
        checkActiveConversationMatchesSource: (id)=>{
            return (0, $3TrVh.checkActiveConversationMatchesSource)(state, id);
        }
    };
};
const $cea7beaf4fdf86cd$export$5ca9bbfceeb3b458 = (0, $kBr4q.createHook)((0, $lx3cN.chatStore), {
    selector: $cea7beaf4fdf86cd$var$publicStateSelector
});
module.exports["useChatStore"] = $cea7beaf4fdf86cd$export$5ca9bbfceeb3b458;

});

parcelRegister("3TrVh", function(module, exports) {
const $8991d15323cea08f$export$80b847bfebcaa3fd = (state, id)=>{
    return !!id && state.conversations[state.currentConversationId]?.sourceId === id;
};
module.exports["checkActiveConversationMatchesSource"] = $8991d15323cea08f$export$80b847bfebcaa3fd;

});

parcelRegister("5wAPd", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $n71o5 = parcelRequire("n71o5");


var $i4nJ0 = parcelRequire("i4nJ0");

const $2344621fd00df2c4$export$626f7ff9a7747889 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    let t1;
    if ($[0] !== t0) {
        t1 = t0 === undefined ? {} : t0;
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const { conversationId: conversationIdParam, assistanceServiceParams: assistanceServiceParams } = t1;
    const [t2] = (0, $n71o5.useChatStore)();
    const { currentConversationId: currentConversationId, conversations: conversations } = t2;
    const conversationId = conversationIdParam ?? currentConversationId;
    const conversation = conversations[conversationId];
    let t3;
    if ($[2] !== assistanceServiceParams || $[3] !== conversation || $[4] !== conversationId) {
        t3 = {
            conversationId: conversationId,
            conversation: conversation,
            assistanceServiceParams: assistanceServiceParams
        };
        $[2] = assistanceServiceParams;
        $[3] = conversation;
        $[4] = conversationId;
        $[5] = t3;
    } else t3 = $[5];
    return (0, $i4nJ0.useConversationData)(t3);
} : ({ conversationId: conversationIdParam, assistanceServiceParams: assistanceServiceParams } = {})=>{
    const [{ currentConversationId: currentConversationId, conversations: conversations }] = (0, $n71o5.useChatStore)();
    const conversationId = conversationIdParam ?? currentConversationId;
    const conversation = conversations[conversationId];
    return (0, $i4nJ0.useConversationData)({
        conversationId: conversationId,
        conversation: conversation,
        assistanceServiceParams: assistanceServiceParams
    });
};
module.exports["useConversation"] = $2344621fd00df2c4$export$626f7ff9a7747889;

});

parcelRegister("i4nJ0", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4o0zT = parcelRequire("4o0zT");


var $iDrrr = parcelRequire("iDrrr");


var $37RgG = parcelRequire("37RgG");


var $3z1p5 = parcelRequire("3z1p5");


var $igOtY = parcelRequire("igOtY");


var $iW40i = parcelRequire("iW40i");


var $6YdPR = parcelRequire("6YdPR");


var $gn6Jj = parcelRequire("gn6Jj");


var $222kR = parcelRequire("222kR");


var $1IZrU = parcelRequire("1IZrU");


var $dvUlt = parcelRequire("dvUlt");

const $daf188600e0350bc$var$createProvisionalSelectedAgent = (conversationAgent)=>{
    const conversationAgentId = conversationAgent?.agent_id;
    if (!conversationAgentId) return undefined;
    const conversationAgentCreatorType = conversationAgent?.creator_type;
    return {
        id: conversationAgentId,
        named_id: conversationAgent?.agent_named_id || conversationAgentId,
        name: conversationAgent?.agent_name || conversationAgentId,
        description: null,
        creator_type: conversationAgentCreatorType || 'CUSTOMER',
        available_plugins: {},
        is_default: conversationAgent?.is_default ?? false,
        actor_type: 'AGENT',
        user_defined_conversation_starters: null,
        favourite: false,
        deactivated: false,
        identity_account_id: conversationAgent?.identity_account_id,
        execution_config: conversationAgent?.execution_config
    };
};
const $daf188600e0350bc$export$23f34d314e5eff9c = ({ conversationId: conversationId, conversation: conversation, assistanceServiceParams: assistanceServiceParams })=>{
    const fallbackParams = (0, $6YdPR.useAssistanceServiceParams)({
        touchpointSource: 'useConversationHook'
    });
    const serviceParams = assistanceServiceParams || fallbackParams;
    const [messages] = (0, $iW40i.useChatMessages)({
        conversationId: conversationId
    });
    const { agentDefaultIdOverride: agentDefaultIdOverride } = (0, $37RgG.useAgentOverrider)();
    // Read only the specific conversation fields the derivation needs as locals,
    // so the memo below depends on these primitives rather than the whole
    // `conversation` object. A whole-object dependency would re-run the memo (and
    // the downstream `useAgentsPaginatedByAgentId` fetch) on unrelated per-turn
    // conversation writes during streaming, even though neither derivation branch
    // reads those fields here.
    const conversationBackendAgentId = conversation?.agent?.agent_id;
    const conversationSourceAgentId = conversation?.sourceAgentId;
    const selectedAgentId = (0, $cozmU.useMemo)(()=>{
        if ((0, $4o0zT.isExperimentEnabled)('rovo_chat_mention_agents')) // CONVERSATION identity shown in the agent selector header. Prefer the
        // canonical backend/store conversation agent when present. Before the first
        // turn is sent, use the surface-level default agent so that first turn is
        // routed to it and the backend persists it as the conversation agent.
        return conversationBackendAgentId || agentDefaultIdOverride || undefined;
        const firstAssistantAuthorId = (0, $222kR.getFirstMessageOfType)(messages ?? [], 'ASSISTANT')?.content.message.message.author_id;
        const agentIdFromConversation = conversationSourceAgentId ?? firstAssistantAuthorId;
        // the final fallback correctly selects an agent if a user cancels a session
        return agentIdFromConversation ?? conversationBackendAgentId ?? agentDefaultIdOverride;
    }, [
        agentDefaultIdOverride,
        conversationSourceAgentId,
        conversationBackendAgentId,
        messages
    ]);
    const { agent: agent, error: agentError } = (0, $3z1p5.useAgentsPaginatedByAgentId)({
        agentId: selectedAgentId,
        assistanceServiceParams: serviceParams
    });
    const agentErrorCode = agentError?.errorAttributes?.errorCode;
    /**
   * if agent fetch failed with status code AGENT_FORBIDDEN or AGENT_DEACTIVATED, extract agent name from messages because user has no access to the agent endpoint anymore
   * scenario: user has access to an agent, created a conversation with it, but then lost access to the agent, this will be triggered when user tries to reopen the conversation;
   * scenario: user has access to an agent, created a conversation with it, but then the agent was deactivated, this will be triggered when user tries to reopen the conversation;
   */ const fallbackAgent = (0, $cozmU.useMemo)(()=>{
        // Don't create fallback agent for empty conversations (new chats)
        if ((0, $1IZrU.isEmptyConversation)(conversationId) || !selectedAgentId) return undefined;
        // Only create fallback agent when agent fetch failed (to extract agent name from messages for display)
        // If agent was successfully fetched, no need for fallback
        if (!(0, $dvUlt.isAgentUnavailable)(agentErrorCode)) return undefined;
        // Try to extract agent metadata from the first assistant message
        const firstAssistantMessage = (0, $222kR.getFirstMessageOfType)(messages ?? [], 'ASSISTANT');
        const author = firstAssistantMessage?.content.message.message.author;
        if (!author?.name) return undefined;
        // Create a minimal Agent object with only required fields from message metadata
        // This allows the UI to display the agent name even when access is denied
        return {
            id: selectedAgentId,
            named_id: author.named_id ?? selectedAgentId,
            name: author.name,
            description: null,
            creator_type: 'CUSTOMER',
            available_plugins: {},
            is_default: false,
            actor_type: 'AGENT',
            user_defined_conversation_starters: null,
            favourite: false,
            deactivated: false
        };
    }, [
        selectedAgentId,
        messages,
        agentErrorCode,
        conversationId
    ]);
    const conversationAgentNamedId = conversation?.agent?.agent_named_id;
    const conversationAgentName = conversation?.agent?.agent_name;
    const conversationAgentCreatorType = conversation?.agent?.creator_type;
    const conversationAgentIdentityAccountId = conversation?.agent?.identity_account_id;
    const conversationAgentIsDefault = conversation?.agent?.is_default;
    const conversationAgentExecutionTier = conversation?.agent?.execution_config?.execution_tier;
    const provisionalSelectedAgent = (0, $cozmU.useMemo)(()=>{
        if (!(0, $4o0zT.isExperimentEnabled)('rovo_chat_mention_agents') || !conversationBackendAgentId) return undefined;
        const conversationAgentForFallback = {
            agent_id: conversationBackendAgentId
        };
        if (conversationAgentNamedId) conversationAgentForFallback.agent_named_id = conversationAgentNamedId;
        if (conversationAgentName) conversationAgentForFallback.agent_name = conversationAgentName;
        if (conversationAgentCreatorType) conversationAgentForFallback.creator_type = conversationAgentCreatorType;
        if (conversationAgentIdentityAccountId) conversationAgentForFallback.identity_account_id = conversationAgentIdentityAccountId;
        if (typeof conversationAgentIsDefault === 'boolean') conversationAgentForFallback.is_default = conversationAgentIsDefault;
        if (conversationAgentExecutionTier) conversationAgentForFallback.execution_config = {
            execution_tier: conversationAgentExecutionTier
        };
        return $daf188600e0350bc$var$createProvisionalSelectedAgent(conversationAgentForFallback);
    }, [
        conversationBackendAgentId,
        conversationAgentNamedId,
        conversationAgentName,
        conversationAgentCreatorType,
        conversationAgentIdentityAccountId,
        conversationAgentIsDefault,
        conversationAgentExecutionTier
    ]);
    const selectedAgent = agent ?? fallbackAgent ?? provisionalSelectedAgent;
    const isFetching = (0, $4o0zT.isExperimentEnabled)('rovo_chat_mention_agents') && Boolean(selectedAgentId && !selectedAgent && !agentError);
    // Calculate agentIdForNewChat: only use valid agents (not fallback/error state) for new chats
    const agentIdForNewChat = (0, $cozmU.useMemo)(()=>{
        // No agent selected
        if (!selectedAgent?.id) return undefined;
        // If agent fetch failed with forbidden/deactivated error, don't use it for new chats
        if ((0, $dvUlt.isAgentUnavailable)(agentErrorCode)) return undefined;
        // If conversation has an error state, the agent is a fallback - don't use it for new chats
        if (conversation?.status === (0, $igOtY.CHAT_STORE_STATUS).deactivatedAgentError) return undefined;
        // Valid agent - safe to use for new chats
        return selectedAgent?.id;
    }, [
        agentErrorCode,
        selectedAgent?.id,
        conversation?.status
    ]);
    const agentVersioningConfig = (0, $gn6Jj.useAgentVersioningConfig)();
    const agentVersion = (0, $cozmU.useMemo)(()=>{
        if (!(0, $iDrrr.fg)('rovo_agent_versioning_enabled')) return undefined;
        // Prefer version stored on conversation (from chat-new event)
        if (conversation?.agentVersion) return conversation.agentVersion;
        // Fall back to version from first assistant message author (from BE response)
        const firstAssistantMessage_0 = (0, $222kR.getFirstMessageOfType)(messages ?? [], 'ASSISTANT');
        const author_0 = firstAssistantMessage_0?.content.message.message.author;
        if (author_0?.versionId || author_0?.versionType) return {
            versionId: author_0.versionId,
            versionType: author_0.versionType,
            versionNumber: author_0.versionNumber
        };
        return undefined;
    }, [
        conversation?.agentVersion,
        messages
    ]);
    const agentVersionForNewChat = (0, $cozmU.useMemo)(()=>{
        if (!agentVersioningConfig?.preserveVersionOnNewChat) return undefined;
        return agentVersion;
    }, [
        agentVersioningConfig?.preserveVersionOnNewChat,
        agentVersion
    ]);
    return {
        conversation: conversation,
        selectedAgent: selectedAgent,
        selectedAgentId: selectedAgentId,
        isFetching: isFetching,
        agentErrorCode: agentErrorCode,
        agentIdForNewChat: agentIdForNewChat,
        agentVersion: agentVersion,
        agentVersionForNewChat: agentVersionForNewChat
    };
};
module.exports["useConversationData"] = $daf188600e0350bc$export$23f34d314e5eff9c;

});

parcelRegister("3z1p5", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6cFsl = parcelRequire("6cFsl");


var $6SsN4 = parcelRequire("6SsN4");


var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

var $c6StJ = parcelRequire("c6StJ");


var $4o0zT = parcelRequire("4o0zT");


var $iDrrr = parcelRequire("iDrrr");


var $8lt5O = parcelRequire("8lt5O");


var $irnO2 = parcelRequire("irnO2");


var $bxkJA = parcelRequire("bxkJA");


var $8A2GO = parcelRequire("8A2GO");


var $5SS4O = parcelRequire("5SS4O");


var $lJ6db = parcelRequire("lJ6db");


var $bJzbV = parcelRequire("bJzbV");


var $33DP2 = parcelRequire("33DP2");


var $ig6TM = parcelRequire("ig6TM");


var $aihbI = parcelRequire("aihbI");


var $h6LPv = parcelRequire("h6LPv");


var $3ay5Z = parcelRequire("3ay5Z");


var $37RgG = parcelRequire("37RgG");


var $5Vuk7 = parcelRequire("5Vuk7");


var $8reXX = parcelRequire("8reXX");


var $fU4xN = parcelRequire("fU4xN");

const $808992f64c91fd00$var$categoriseAgents = (agents)=>agents.reduce((categorisedAgents, agent)=>{
        if (agent.creator_type === 'SYSTEM') categorisedAgents.system.push(agent);
        else if (agent.visibility === 'PUBLIC') categorisedAgents.public.push(agent);
        else if (agent.visibility === 'PRIVATE') categorisedAgents.private.push(agent);
        else if (!agent.visibility && agent.creator_type === 'CUSTOMER') categorisedAgents.private.push(agent);
        return categorisedAgents;
    }, {
        public: [],
        private: [],
        system: []
    });
const $808992f64c91fd00$var$connectionContainsNode = (connection, nodeId)=>(connection.getLinkedRecords('edges') ?? []).some((edge)=>edge?.getLinkedRecord('node')?.getDataID() === nodeId);
const $808992f64c91fd00$var$createInitialAgentsState = ()=>({
        availableAgents: [],
        categorisedAgents: {
            private: [],
            public: [],
            system: []
        },
        agentsInitialized: false,
        agentsError: undefined
    });
/**
 * @private
 * @deprecated Please use `useAgentsPaginated...` hooks instead
 * @TODO move to different folder https://product-fabric.atlassian.net/browse/RAGE-1562
 */ const $808992f64c91fd00$var$agentsStore = (0, $8s9DV.createStore)({
    initialState: $808992f64c91fd00$var$createInitialAgentsState(),
    name: 'AgentsStore',
    actions: {
        setAgents: (availableAgents)=>({ setState: setState })=>{
                setState({
                    availableAgents: availableAgents,
                    categorisedAgents: $808992f64c91fd00$var$categoriseAgents(availableAgents)
                });
            },
        setAgentsInitialized: ()=>({ setState: setState })=>{
                setState({
                    agentsInitialized: true
                });
            },
        setAgentsError: (agentsError)=>({ setState: setState })=>{
                setState({
                    agentsError: agentsError
                });
            },
        resetAgentStore: ()=>({ setState: setState })=>{
                setState($808992f64c91fd00$var$createInitialAgentsState());
            }
    }
});
/**
 * @private
 * @deprecated Please use `useAgentsPaginated...` instead
 * @TODO move to different folder https://product-fabric.atlassian.net/browse/RAGE-1562
 */ const $808992f64c91fd00$var$useAgentsStore = (0, $kBr4q.createHook)($808992f64c91fd00$var$agentsStore);
const $808992f64c91fd00$export$f5b1109ecd7858c1 = (0, $lJ6db.createHookWithAssistanceService)(({ onError: onError, assistanceServiceInjectedParams: { assistanceService: assistanceService, experienceTracker: experienceTracker, experienceId: experienceId, product: product, siteId: siteId, touchpointSource: touchpointSource } })=>{
    // TODO remove `isRovoEnabled`
    const { isRovoEnabled: isRovoEnabled } = (0, $8lt5O.useRovoEntitlement)();
    const { agentIdFiltersOverride: agentIdFiltersOverride, agentDefaultIdOverride: agentDefaultIdOverride } = (0, $37RgG.useAgentOverrider)();
    const [{ availableAgents: availableAgents, categorisedAgents: categorisedAgents, agentsInitialized: agentsInitialized, agentsError: agentsError }, { setAgents: setAgents, setAgentsInitialized: setAgentsInitialized, setAgentsError: setAgentsError }] = $808992f64c91fd00$var$useAgentsStore();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { favouriteAgent: favouriteAgent, unfavouriteAgent: unfavouriteAgent } = (0, $3ay5Z.useAgentFavourites)({
        assistanceServiceParams: {
            experienceId: experienceId,
            product: product,
            siteId: siteId,
            touchpointSource: touchpointSource
        }
    });
    const favouritedAgents = availableAgents.filter((agent)=>agent.favourite);
    const defaultAgent = (0, $cozmU.useMemo)(()=>availableAgents.find((agent)=>agent.is_default), [
        availableAgents
    ]);
    const nonDefaultAgents = (0, $cozmU.useMemo)(()=>availableAgents.filter((agent)=>!agent.is_default), [
        availableAgents
    ]);
    const nonDefaultFavouriteAgents = (0, $cozmU.useMemo)(()=>nonDefaultAgents.filter((agent)=>!agent.favourite), [
        nonDefaultAgents
    ]);
    const fetchAndStoreAvailableAgents = (0, $5SS4O.useQuery)({
        queryKey: (0, $iDrrr.fg)('rovo_chat_site_switch_reset') ? [
            'fetchAgents',
            siteId
        ] : [
            'fetchAgents'
        ],
        queryFn: async ()=>{
            const isSiteSwitchResetEnabled = (0, $iDrrr.fg)('rovo_chat_site_switch_reset');
            const generationAtRequestStart = $808992f64c91fd00$var$getAgentStoresGeneration();
            try {
                experienceTracker.start({
                    id: (0, $irnO2.ExperienceName).FETCH_AGENTS,
                    name: (0, $irnO2.ExperienceName).FETCH_AGENTS
                });
                const agents = await assistanceService.getAgents();
                if (isSiteSwitchResetEnabled && $808992f64c91fd00$var$isStaleAgentStoresGeneration(generationAtRequestStart)) {
                    experienceTracker.succeed({
                        name: (0, $irnO2.ExperienceName).FETCH_AGENTS
                    });
                    return;
                }
                const transformedAgents = agents.map((agent)=>{
                    // Rename default agent to Chat, which is displayed in the UI
                    if (agent.is_default) {
                        agent.name = formatMessage((0, $fU4xN.default).defaultAgentName);
                        agent.description = formatMessage((0, $fU4xN.default).defaultAgentDescription);
                    }
                    return agent;
                });
                const overriddenAgents = (0, $5Vuk7.getOverridenAgents)(transformedAgents, agentIdFiltersOverride, agentDefaultIdOverride);
                setAgents(overriddenAgents);
                experienceTracker.succeed({
                    name: (0, $irnO2.ExperienceName).FETCH_AGENTS
                });
                setAgentsInitialized();
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                //Filter out HIPAA errors from experience tracker https://product-fabric.atlassian.net/browse/ROVOFE-543
                if ((0, $8reXX.isHipaaError)(error)) {
                    experienceTracker.succeed({
                        name: (0, $irnO2.ExperienceName).FETCH_AGENTS
                    });
                    return;
                }
                const isStaleSite = isSiteSwitchResetEnabled && $808992f64c91fd00$var$isStaleAgentStoresGeneration(generationAtRequestStart);
                if ((0, $bxkJA.isRateLimitedError)(error) && !isStaleSite) setAgentsError(error);
                experienceTracker.fail({
                    teamName: (0, $33DP2.ROVO_AGENTS_FE_TEAM_NAME),
                    name: (0, $irnO2.ExperienceName).FETCH_AGENTS,
                    error: error
                });
                throw error;
            }
        },
        onError: onError,
        enabled: isRovoEnabled,
        refetchOnWindowFocus: false
    });
    const { deleteAgent: deleteAgent } = (0, $h6LPv.useDeleteAgent)({
        onSuccess: ()=>{
            fetchAndStoreAvailableAgents.refetch();
        },
        assistanceServiceParams: {
            experienceId: experienceId,
            product: product,
            siteId: siteId,
            touchpointSource: touchpointSource
        },
        onInit: (id)=>{
            setAgents(availableAgents.filter((agent)=>agent.id !== id));
        },
        onError: ()=>{
            setAgents(availableAgents);
        }
    });
    const setFavouriteAgent = (0, $cozmU.useCallback)(async (id, isFavourite)=>{
        const updatedAgent = availableAgents.find((a)=>a.id === id);
        const setUpdatedAgent = (shouldBeFavourite)=>{
            if (updatedAgent) {
                updatedAgent.favourite = shouldBeFavourite;
                setAgents(availableAgents.map((a)=>{
                    // If the current agent's id matches the new agent's id, return the new agent.
                    // Otherwise, return the current agent.
                    return a.id === updatedAgent.id ? updatedAgent : a;
                }));
            }
        };
        //Optimistically update favourite value before we mutate
        setUpdatedAgent(isFavourite);
        //Pass callback to roll back optimistic update if mutation fails
        const errorCallback = {
            onError: ()=>{
                setUpdatedAgent(!isFavourite);
            }
        };
        if (isFavourite) return await favouriteAgent.mutate(id, errorCallback);
        else return await unfavouriteAgent.mutate(id, errorCallback);
    }, [
        availableAgents,
        setAgents,
        favouriteAgent,
        unfavouriteAgent
    ]);
    /** This updates the agent on the client side only
   * Useful for updating the agent after a successful mutation
   */ const updateAgentLocally = (0, $cozmU.useCallback)((agentId, updatedAgent)=>{
        const updatedAgents = availableAgents.map((agent)=>{
            if (agent.id === agentId) return {
                ...agent,
                ...updatedAgent
            };
            return agent;
        });
        setAgents(updatedAgents);
    }, [
        availableAgents,
        setAgents
    ]);
    return {
        availableAgents: availableAgents,
        favouritedAgents: favouritedAgents,
        categorisedAgents: categorisedAgents,
        fetchAndStoreAvailableAgents: fetchAndStoreAvailableAgents,
        deleteAgent: deleteAgent,
        setFavouriteAgent: setFavouriteAgent,
        defaultAgent: defaultAgent,
        agentsInitialized: agentsInitialized,
        nonDefaultAgents: nonDefaultAgents,
        nonDefaultFavouriteAgents: nonDefaultFavouriteAgents,
        updateAgentLocally: updateAgentLocally,
        agentsError: agentsError
    };
});
const $808992f64c91fd00$var$createEmptyAgentCategory = ()=>({
        agentIds: [],
        pageInfo: {
            ...(0, $ig6TM.DEFAULT_PAGE_INFO)
        },
        abortController: new AbortController()
    });
const $808992f64c91fd00$var$agentsPaginatedStore = (0, $8s9DV.createStore)({
    initialState: {
        /*
    Hash map which is the source of truth for agent data
    agent categories simply hold the agent ids to perform a lookup
    */ agentsMap: {},
        loadingCategories: new Set(),
        agentCategories: {
            ['all-agents']: {
                agentIds: [],
                pageInfo: (0, $ig6TM.DEFAULT_PAGE_INFO),
                abortController: new AbortController()
            },
            ['starred-agents']: {
                agentIds: [],
                pageInfo: (0, $ig6TM.DEFAULT_PAGE_INFO),
                abortController: new AbortController()
            },
            ['my-agents']: {
                agentIds: [],
                pageInfo: (0, $ig6TM.DEFAULT_PAGE_INFO),
                abortController: new AbortController()
            },
            ['templates']: {
                agentIds: [],
                pageInfo: (0, $ig6TM.DEFAULT_PAGE_INFO),
                abortController: new AbortController()
            },
            ['verified-agents']: {
                agentIds: [],
                pageInfo: (0, $ig6TM.DEFAULT_PAGE_INFO),
                abortController: new AbortController()
            },
            ['available-for-jira']: {
                agentIds: [],
                pageInfo: (0, $ig6TM.DEFAULT_PAGE_INFO),
                abortController: new AbortController()
            }
        }
    },
    name: 'AgentsPaginatedStore',
    actions: {
        /**
     * This action populates a specific category with backend data
     * it will store the ids in `agentCategories` and the agents in `agentsMap`
     */ populateAgentCategories: ({ agentsList: agentsList, pageInfo: pageInfo, category: category = 'all-agents' })=>({ setState: setState, getState: getState })=>{
                const { agentsMap: agentsMap, agentCategories: agentCategories } = getState();
                const updatedAgentsMap = {
                    ...agentsMap
                };
                const updatedAgentCategories = {
                    ...agentCategories
                };
                updatedAgentCategories[category].pageInfo = pageInfo;
                if (!agentsList.length) updatedAgentCategories[category].agentIds = [];
                else agentsList.forEach((agent)=>{
                    // Ensure isPlaceholder is cleared when hydrating with real BE data
                    const { isPlaceholder: _isPlaceholder, ...existingData } = updatedAgentsMap[agent.id] ?? {};
                    updatedAgentsMap[agent.id] = {
                        ...existingData,
                        ...agent
                    };
                    updatedAgentCategories[category].agentIds.push(agent.id);
                });
                setState({
                    agentsMap: updatedAgentsMap,
                    agentCategories: updatedAgentCategories
                });
            },
        setAgentCategoriesByCategory: ({ categoryName: categoryName, agentCategoryData: agentCategoryData })=>({ getState: getState, setState: setState })=>{
                const { agentCategories: agentCategories } = getState();
                const updatedAgentCategories = {
                    ...agentCategories,
                    [categoryName]: agentCategoryData
                };
                setState({
                    agentCategories: updatedAgentCategories
                });
            },
        setCategoryError: (categoryName, agentsError)=>({ getState: getState, setState: setState })=>{
                const { agentCategories: agentCategories } = getState();
                const updatedAgentCategories = {
                    ...agentCategories,
                    [categoryName]: {
                        ...agentCategories[categoryName],
                        agentsError: agentsError
                    }
                };
                setState({
                    agentCategories: updatedAgentCategories
                });
            },
        getAgentCategoriesByCategory: (category)=>({ getState: getState })=>{
                const state = getState();
                const { agentCategories: agentCategories } = state;
                return agentCategories[category];
            },
        removeAgent: (id)=>({ setState: setState, getState: getState })=>{
                const { agentsMap: agentsMap, agentCategories: agentCategories } = getState();
                const catsImpacted = new Set();
                let agentToReturn;
                const updatedAgentsMap = {
                    ...agentsMap
                };
                const updatedAgentCategories = {
                    ...agentCategories
                };
                if (agentsMap[id]) {
                    agentToReturn = agentsMap[id];
                    delete updatedAgentsMap[id];
                }
                Object.keys(agentCategories).forEach((category)=>{
                    if (updatedAgentCategories[category]?.agentIds.includes(id)) {
                        updatedAgentCategories[category].agentIds = updatedAgentCategories[category].agentIds.filter((agentId)=>agentId !== id);
                        catsImpacted.add(category);
                    }
                });
                setState({
                    agentsMap: updatedAgentsMap,
                    agentCategories: updatedAgentCategories
                });
                return {
                    agent: agentToReturn,
                    categories: Array.from(catsImpacted)
                };
            },
        addAgent: (agent, categories = [
            'all-agents'
        ])=>({ setState: setState, getState: getState })=>{
                const { agentsMap: agentsMap, agentCategories: agentCategories } = getState();
                const updatedAgentsMap = {
                    ...agentsMap
                };
                const updatedAgentCategories = {
                    ...agentCategories
                };
                categories.forEach((category)=>{
                    updatedAgentCategories?.[category]?.agentIds.push(agent.id);
                });
                // Ensure isPlaceholder is cleared when adding full agent data
                const { isPlaceholder: _isPlaceholder, ...existingData } = updatedAgentsMap[agent.id] ?? {};
                updatedAgentsMap[agent.id] = {
                    ...existingData,
                    ...agent
                };
                setState({
                    agentsMap: updatedAgentsMap,
                    agentCategories: updatedAgentCategories
                });
            },
        updateAgent: (id, data)=>({ setState: setState, getState: getState })=>{
                const { agentsMap: agentsMap } = getState();
                const updatedAgentsMap = {
                    ...agentsMap
                };
                const prevData = agentsMap[id] ?? {};
                const updatedData = {
                    ...prevData,
                    ...data
                };
                // Clean up placeholder flag when real agent data arrives
                // Keep placeholderAvatarUrl to avoid avatar flicker (same image, stable source)
                if (prevData.isPlaceholder) delete updatedData.isPlaceholder;
                updatedAgentsMap[id] = updatedData;
                setState({
                    agentsMap: updatedAgentsMap
                });
                return updatedData;
            },
        setCategoryLoading: (category, loading)=>({ setState: setState, getState: getState })=>{
                const { loadingCategories: loadingCategories } = getState();
                const updatedLoadingCategories = new Set(loadingCategories);
                if (loading) updatedLoadingCategories.add(category);
                else updatedLoadingCategories.delete(category);
                setState({
                    loadingCategories: updatedLoadingCategories
                });
            },
        abortCategoryFetch: (category)=>({ getState: getState })=>{
                const { agentCategories: agentCategories } = getState();
                agentCategories[category].abortController.abort();
                agentCategories[category].abortController = new AbortController();
            },
        /**
     * Sets a placeholder agent in the agentsMap with partial data for immediate rendering.
     * The agent is marked with `isPlaceholder: true` so that `useAgentsPaginatedByAgentId`
     * still fetches full details from the network to replace it.
     * Used for optimistic rendering of agent name/avatar from pubsub payloads.
     */ setPlaceholderAgent: (agentId, data)=>({ setState: setState, getState: getState })=>{
                const { agentsMap: agentsMap } = getState();
                // Only set placeholder if agent doesn't already exist with full data
                if (!agentsMap[agentId]) {
                    const updatedAgentsMap = {
                        ...agentsMap
                    };
                    updatedAgentsMap[agentId] = {
                        ...data,
                        id: agentId,
                        isPlaceholder: true
                    };
                    setState({
                        agentsMap: updatedAgentsMap
                    });
                }
            },
        getCachedAgentByExternalConfigReference: (externalConfigReference)=>({ getState: getState })=>{
                const { agentsMap: agentsMap } = getState();
                return Object.values(agentsMap).find((agent)=>agent.external_config_reference === externalConfigReference);
            },
        resetPaginatedAgents: ()=>({ getState: getState, setState: setState })=>{
                const agentCategories = {
                    ...getState().agentCategories
                };
                Object.keys(agentCategories).forEach((category)=>{
                    agentCategories[category].abortController.abort();
                    agentCategories[category] = $808992f64c91fd00$var$createEmptyAgentCategory();
                });
                setState({
                    agentsMap: {},
                    loadingCategories: new Set(),
                    agentCategories: agentCategories
                });
            }
    }
});
/**
 * Both agent stores are page-level singletons, so switching site can only clear them, never replace
 * them. `agentStoresGeneration` is the version of the data they currently hold: async writers read
 * it before their request and compare afterwards, so a response belonging to the site we just left
 * is dropped instead of repopulating the cleared store.
 */ let $808992f64c91fd00$var$agentStoresGeneration = 0;
const $808992f64c91fd00$var$getAgentStoresGeneration = ()=>$808992f64c91fd00$var$agentStoresGeneration;
const $808992f64c91fd00$var$isStaleAgentStoresGeneration = (generation)=>generation !== $808992f64c91fd00$var$agentStoresGeneration;
const $808992f64c91fd00$export$242eb13d25184007 = ()=>{
    $808992f64c91fd00$var$agentStoresGeneration += 1;
    (0, $c6StJ.defaultRegistry).getStore($808992f64c91fd00$var$agentsStore).actions.resetAgentStore();
    (0, $c6StJ.defaultRegistry).getStore($808992f64c91fd00$var$agentsPaginatedStore).actions.resetPaginatedAgents();
};
const $808992f64c91fd00$export$1553678862324ff0 = (0, $kBr4q.createActionsHook)($808992f64c91fd00$var$agentsPaginatedStore);
const $808992f64c91fd00$export$cea603150faaa56f = (0, $kBr4q.createHook)($808992f64c91fd00$var$agentsPaginatedStore, {
    // TODO https://product-fabric.atlassian.net/browse/RAGE-618
    // change `{ agentId }` to `agentId`
    selector: (state, agentId)=>({
            agent: state.agentsMap[agentId],
            doesAgentExist: Boolean(state.agentsMap[agentId]),
            isPlaceholder: Boolean(state.agentsMap[agentId]?.isPlaceholder)
        })
});
const $808992f64c91fd00$export$44c2e95a7a8b47c9 = (0, $lJ6db.createHookWithAssistanceService)(({ agentId: agentId, assistanceServiceInjectedParams: { assistanceService: assistanceService, experienceTracker: experienceTracker, siteId: siteId } })=>{
    (0, $6cFsl.di)($808992f64c91fd00$export$44c2e95a7a8b47c9, $808992f64c91fd00$export$cea603150faaa56f, $808992f64c91fd00$export$1553678862324ff0);
    const [{ agent: agent, doesAgentExist: doesAgentExist, isPlaceholder: isPlaceholder }] = $808992f64c91fd00$export$cea603150faaa56f(agentId ?? '');
    const { updateAgent: updateAgent } = $808992f64c91fd00$export$1553678862324ff0();
    const { error: error } = (0, $5SS4O.useQuery)({
        queryKey: (0, $iDrrr.fg)('rovo_chat_site_switch_reset') ? [
            'agentHydration',
            agentId ?? '',
            siteId ?? ''
        ] : [
            'agentHydration',
            agentId ?? ''
        ],
        queryFn: async ()=>{
            if (!agentId) // this throw won't happen because the `enabled` field below
            throw new Error('Agent ID is required');
            const generation = $808992f64c91fd00$var$getAgentStoresGeneration();
            experienceTracker.start({
                name: (0, $irnO2.ExperienceName).HYDRATE_AGENT_DATA,
                id: (0, $irnO2.ExperienceName).HYDRATE_AGENT_DATA
            });
            return {
                agentDetails: await assistanceService.getAgentDetails(agentId),
                generation: generation
            };
        },
        enabled: Boolean(agentId) && (!doesAgentExist || isPlaceholder),
        onSuccess: ({ agentDetails: agentDetails, generation: generation })=>{
            if (!agentId) return;
            experienceTracker.succeed({
                name: (0, $irnO2.ExperienceName).HYDRATE_AGENT_DATA
            });
            if ((0, $iDrrr.fg)('rovo_chat_site_switch_reset') && $808992f64c91fd00$var$isStaleAgentStoresGeneration(generation)) return;
            updateAgent(agentId ?? '', agentDetails);
        },
        onError: (error)=>{
            if (!agentId) return;
            const is404Error = error.errorAttributes.statusCode === 404;
            const is403Error = error.errorAttributes.statusCode === 403;
            if (!(is404Error || is403Error)) experienceTracker.fail({
                name: (0, $irnO2.ExperienceName).HYDRATE_AGENT_DATA,
                error: error,
                teamName: (0, $33DP2.ROVO_AGENTS_FE_TEAM_NAME)
            });
        }
    });
    if (!agentId) return {
        agent: undefined,
        error: undefined
    };
    return {
        agent: agent,
        error: error ?? undefined
    };
});
const $808992f64c91fd00$export$eae59c91509947e4 = (0, $lJ6db.createHookWithAssistanceService)(({ assistanceServiceInjectedParams: assistanceServiceInjectedParams })=>{
    const environment = (0, $6SsN4.useRelayEnvironment)();
    const removedAgentCache = (0, $cozmU.useRef)({
        categories: [],
        agent: undefined,
        generation: 0
    });
    const { removeAgent: removeAgent, addAgent: addAgent, updateAgent: updateAgent } = $808992f64c91fd00$export$1553678862324ff0();
    const { favouriteAgent: favouriteAgent, unfavouriteAgent: unfavouriteAgent } = (0, $3ay5Z.useAgentFavourites)({
        assistanceServiceParams: assistanceServiceInjectedParams
    });
    // Note: Experience Tracker events implemented in useDeleteAgent
    const { deleteAgent: deleteAgent } = (0, $h6LPv.useDeleteAgent)({
        assistanceServiceParams: assistanceServiceInjectedParams,
        onInit: (id)=>{
            const { categories: categories, agent: agent } = removeAgent(id);
            // The generation is cached alongside the agent so the rollback below is judged against the
            // state this particular removal was made from.
            removedAgentCache.current = {
                categories: categories,
                agent: agent,
                generation: $808992f64c91fd00$var$getAgentStoresGeneration()
            };
        },
        onError: ()=>{
            // Restoring after a reset would put a complete agent from the previous site back into the
            // new site's map and its category lists.
            if ((0, $iDrrr.fg)('rovo_chat_site_switch_reset') && $808992f64c91fd00$var$isStaleAgentStoresGeneration(removedAgentCache.current.generation)) return;
            if (removedAgentCache.current.agent) addAgent(removedAgentCache.current.agent, removedAgentCache.current.categories);
        }
    });
    // Note: Experience Tracker events implemented in useAgentFavourites
    const setFavouriteAgent = (0, $cozmU.useCallback)(async (id, favourite, agentAri)=>{
        const generationAtMutationStart = $808992f64c91fd00$var$getAgentStoresGeneration();
        // Optimistic update
        updateAgent(id, {
            favourite: favourite
        });
        const localRelayUpdate = async (isFavourite)=>{
            if (agentAri) (0, $6SsN4.commitLocalUpdate)(environment, (store)=>{
                const id = (0, $bJzbV.default)({
                    id: agentAri
                }, 'AgentStudioAssistant');
                if (!id) return;
                const agentRecord = store.get(id);
                if (agentRecord) agentRecord.setValue(isFavourite, 'isFavourite');
                const root = store.getRoot();
                const connection = (0, $6SsN4.ConnectionHandler).getConnection(root, 'paginatedAgentsList_agentStudio_getAgents', {
                    cloudId: assistanceServiceInjectedParams.siteId,
                    input: {
                        onlyFavouriteAgents: true
                    },
                    product: assistanceServiceInjectedParams.product
                });
                const agentDataID = agentRecord?.getDataID();
                if (!connection || !agentDataID || !agentRecord) return;
                if (isFavourite) {
                    if ((0, $4o0zT.isExperimentEnabled)('jira_agent_recommendations_m1') && $808992f64c91fd00$var$connectionContainsNode(connection, agentDataID)) return;
                    const edge = (0, $6SsN4.ConnectionHandler).createEdge(store, connection, agentRecord, 'AgentStudioAgentEdge');
                    (0, $6SsN4.ConnectionHandler).insertEdgeAfter(connection, edge);
                } else (0, $6SsN4.ConnectionHandler).deleteNode(connection, agentDataID);
            });
        };
        localRelayUpdate(favourite);
        const errorCallback = {
            onError: ()=>{
                // Reverse optimistic update, unless the stores were reset for another site while the
                // mutation was in flight — `updateAgent` creates the entry when the id is absent, so
                // rolling back would insert a partial agent from the previous site into the new one.
                if (!((0, $iDrrr.fg)('rovo_chat_site_switch_reset') && $808992f64c91fd00$var$isStaleAgentStoresGeneration(generationAtMutationStart))) updateAgent(id, {
                    favourite: !favourite
                });
                // The Relay rollback is safe either way: its connection is keyed by cloudId.
                localRelayUpdate(!favourite);
            }
        };
        if (favourite) return await favouriteAgent.mutate(id, errorCallback);
        else return await unfavouriteAgent.mutate(id, errorCallback);
    }, [
        assistanceServiceInjectedParams.product,
        assistanceServiceInjectedParams.siteId,
        environment,
        favouriteAgent,
        unfavouriteAgent,
        updateAgent
    ]);
    /**
   * Function that updates the verified status of an agent.
   * This can be removed once the dropdown has converted over to relay.
   */ const setVerifiedAgent = (0, $cozmU.useCallback)((id, isVerified)=>{
        updateAgent(id, {
            is_verified: isVerified
        });
    }, [
        updateAgent
    ]);
    // Local cache update function for optimistic delete
    // This only handles cache updates, not API calls or analytics
    const deleteAgentLocally = (0, $cozmU.useCallback)((id)=>{
        const generationAtRemoval = $808992f64c91fd00$var$getAgentStoresGeneration();
        // Optimistically remove from cache
        const { categories: categories, agent: agent } = removeAgent(id);
        // Return restore function for error handling
        return {
            restore: ()=>{
                if ((0, $iDrrr.fg)('rovo_chat_site_switch_reset') && $808992f64c91fd00$var$isStaleAgentStoresGeneration(generationAtRemoval)) return;
                if (agent) addAgent(agent, categories);
            }
        };
    }, [
        removeAgent,
        addAgent
    ]);
    return {
        deleteAgent: deleteAgent,
        setFavouriteAgent: setFavouriteAgent,
        setVerifiedAgent: setVerifiedAgent,
        deleteAgentLocally: deleteAgentLocally
    };
});
const $808992f64c91fd00$export$cc3deb815b1c179b = (0, $kBr4q.createHook)($808992f64c91fd00$var$agentsPaginatedStore, {
    selector: (state, category)=>({
            agentsByCategory: state.agentCategories[category].agentIds.map((agentId)=>state.agentsMap[agentId]),
            isCategoryInitialized: state.agentCategories[category].pageInfo.startCursor !== undefined && state.agentCategories[category].pageInfo.endCursor !== undefined,
            isCategoryLoading: state.loadingCategories.has(category),
            isCategoryEmpty: state.agentCategories[category].agentIds.length === 0,
            hasNextPage: state.agentCategories[category].pageInfo.hasNextPage,
            nextPageCursor: state.agentCategories[category].pageInfo.endCursor,
            agentsError: state.agentCategories[category].agentsError
        })
});
const $808992f64c91fd00$export$e6997ec35c535c54 = (0, $lJ6db.createHookWithAssistanceService)(({ assistanceServiceInjectedParams: { assistanceService: assistanceService, experienceTracker: experienceTracker, siteId: siteId } })=>{
    (0, $6cFsl.di)((0, $37RgG.useAgentOverrider), $808992f64c91fd00$export$1553678862324ff0);
    const { agentDefaultIdOverride: agentDefaultIdOverride, agentIdFiltersOverride: agentIdFiltersOverride } = (0, $37RgG.useAgentOverrider)();
    const { addAgent: addAgent, populateAgentCategories: populateAgentCategories } = $808992f64c91fd00$export$1553678862324ff0();
    const fetchOverriddenAgentsAndPopulateStoreQuery = (0, $5SS4O.useQuery)({
        queryKey: (0, $iDrrr.fg)('rovo_chat_site_switch_reset') ? [
            'fetchOverriddenAgentsAndPopulateStore',
            agentDefaultIdOverride ?? '',
            agentIdFiltersOverride?.join(',') ?? '',
            siteId ?? ''
        ] : [
            'fetchOverriddenAgentsAndPopulateStore',
            agentDefaultIdOverride ?? '',
            agentIdFiltersOverride?.join(',') ?? ''
        ],
        queryFn: async ()=>{
            const isSiteSwitchResetEnabled = (0, $iDrrr.fg)('rovo_chat_site_switch_reset');
            const generationAtRequestStart = $808992f64c91fd00$var$getAgentStoresGeneration();
            const agentIdsToFetchSet = new Set();
            if (agentDefaultIdOverride) agentIdsToFetchSet.add(agentDefaultIdOverride);
            if (agentIdFiltersOverride?.length) agentIdFiltersOverride.forEach((agentId)=>{
                agentIdsToFetchSet.add(agentId);
            });
            if (agentIdsToFetchSet.size === 0) return;
            const agentIdsToFetch = Array.from(agentIdsToFetchSet);
            populateAgentCategories({
                category: 'all-agents',
                agentsList: [],
                pageInfo: (0, $ig6TM.DEFAULT_PAGE_INFO)
            });
            experienceTracker.start({
                name: (0, $irnO2.ExperienceName).FETCH_AGENTS_OVERRIDES,
                id: (0, $irnO2.ExperienceName).FETCH_AGENTS_OVERRIDES
            });
            const agents = await Promise.all(agentIdsToFetch.map(async (agentId)=>{
                return await assistanceService.getAgentDetails(agentId);
            }));
            if (isSiteSwitchResetEnabled && $808992f64c91fd00$var$isStaleAgentStoresGeneration(generationAtRequestStart)) return agentIdsToFetch;
            // then add the agents into "All agents" category
            agents.forEach((agent)=>{
                addAgent(agent, [
                    'all-agents'
                ]);
            });
            return agentIdsToFetch;
        },
        onSuccess: ()=>{
            experienceTracker.succeed({
                name: (0, $irnO2.ExperienceName).FETCH_AGENTS_OVERRIDES
            });
        },
        onError: (error)=>{
            experienceTracker.fail({
                name: (0, $irnO2.ExperienceName).FETCH_AGENTS_OVERRIDES,
                error: error,
                teamName: (0, $33DP2.ROVO_AGENTS_FE_TEAM_NAME)
            });
        },
        enabled: false
    });
    return {
        fetchOverriddenAgentsAndPopulateStore: fetchOverriddenAgentsAndPopulateStoreQuery.refetch
    };
});
const $808992f64c91fd00$export$94c2040c41639ede = (0, $lJ6db.createHookWithAssistanceService)(({ onError: onError, assistanceServiceInjectedParams: assistanceServiceInjectedParams })=>{
    (0, $6cFsl.di)($808992f64c91fd00$export$1553678862324ff0, (0, $37RgG.useAgentOverrider), $808992f64c91fd00$export$e6997ec35c535c54);
    const { experienceTracker: experienceTracker, siteId: siteId, product: product, headers: assistanceServiceHeaders } = assistanceServiceInjectedParams;
    const actions = $808992f64c91fd00$export$1553678862324ff0();
    const { setCategoryLoading: setCategoryLoading, setCategoryError: setCategoryError, populateAgentCategories: populateAgentCategories, getAgentCategoriesByCategory: getAgentCategoriesByCategory, setAgentCategoriesByCategory: setAgentCategoriesByCategory } = actions;
    const { agentDefaultIdOverride: agentDefaultIdOverride, agentIdFiltersOverride: agentIdFiltersOverride } = (0, $37RgG.useAgentOverrider)();
    const { fetchOverriddenAgentsAndPopulateStore: fetchOverriddenAgentsAndPopulateStore } = $808992f64c91fd00$export$e6997ec35c535c54({
        assistanceServiceParams: assistanceServiceInjectedParams
    });
    const fetchAgentsByCategory = (0, $cozmU.useCallback)(async ({ category: category = 'all-agents', after: after, query: query })=>{
        // if there are any overrides, cancel the normal fetchByCategory and instead fetch the overridden agents
        if (agentDefaultIdOverride || agentIdFiltersOverride?.length) return await fetchOverriddenAgentsAndPopulateStore() ?? [];
        const isSiteSwitchResetEnabled = (0, $iDrrr.fg)('rovo_chat_site_switch_reset');
        const generationAtRequestStart = $808992f64c91fd00$var$getAgentStoresGeneration();
        const dataBeforeFetch = getAgentCategoriesByCategory(category);
        experienceTracker.start({
            name: (0, $irnO2.ExperienceName).FETCH_AGENTS_PAGINATED,
            id: (0, $irnO2.ExperienceName).FETCH_AGENTS_PAGINATED
        });
        let queryInput = {};
        switch(category){
            case 'starred-agents':
                queryInput.onlyFavouriteAgents = true;
                break;
            case 'my-agents':
                queryInput.onlyMyAgents = true;
                break;
            case 'templates':
                queryInput.onlyTemplateAgents = true;
                break;
            case 'verified-agents':
                queryInput.onlyVerifiedAgents = true;
                break;
        }
        if (query) queryInput.name = query;
        // for rolling back data in case of abort/failure
        const resetData = ()=>{
            setAgentCategoriesByCategory({
                categoryName: category,
                agentCategoryData: dataBeforeFetch
            });
            return dataBeforeFetch.agentIds;
        };
        // No after means we're requesting the first page so the category data is reset
        if (!after) populateAgentCategories({
            category: category,
            agentsList: [],
            pageInfo: (0, $ig6TM.DEFAULT_PAGE_INFO)
        });
        setCategoryLoading(category, true);
        setCategoryError(category, undefined);
        const headers = new Headers(assistanceServiceHeaders);
        const maybeWorkspaceId = headers.get('x-workspace-id');
        try {
            const response = await (0, $ig6TM.fetchPaginatedAgents)({
                after: after ?? undefined,
                cloudId: siteId,
                count: 10,
                input: Object.keys(queryInput).length > 0 ? queryInput : undefined,
                product: product,
                abortController: getAgentCategoriesByCategory(category).abortController,
                workspaceId: maybeWorkspaceId
            });
            if (isSiteSwitchResetEnabled && $808992f64c91fd00$var$isStaleAgentStoresGeneration(generationAtRequestStart)) {
                experienceTracker.abort({
                    reason: 'Aborted',
                    name: (0, $irnO2.ExperienceName).FETCH_AGENTS_PAGINATED
                });
                return [];
            }
            setCategoryLoading(category, false);
            if (getAgentCategoriesByCategory(category).abortController.signal?.aborted) {
                experienceTracker.abort({
                    reason: 'Aborted',
                    name: (0, $irnO2.ExperienceName).FETCH_AGENTS_PAGINATED
                });
                return resetData();
            }
            if (response) {
                populateAgentCategories({
                    category: category,
                    agentsList: response.agents,
                    pageInfo: response.pageInfo
                });
                experienceTracker.succeed({
                    name: (0, $irnO2.ExperienceName).FETCH_AGENTS_PAGINATED
                });
            }
            return response?.agents.map((agent)=>agent.id);
        } catch (error) {
            if (isSiteSwitchResetEnabled && $808992f64c91fd00$var$isStaleAgentStoresGeneration(generationAtRequestStart)) {
                experienceTracker.abort({
                    reason: 'Aborted',
                    name: (0, $irnO2.ExperienceName).FETCH_AGENTS_PAGINATED
                });
                return [];
            }
            experienceTracker.fail({
                name: (0, $irnO2.ExperienceName).FETCH_AGENTS_PAGINATED,
                error: error,
                teamName: (0, $33DP2.ROVO_AGENTS_FE_TEAM_NAME)
            });
            const prevAgentIds = resetData();
            setCategoryError(category, error);
            setCategoryLoading(category, false);
            if (error instanceof (0, $8A2GO.ApiError)) onError?.(error);
            return prevAgentIds;
        }
    }, [
        agentDefaultIdOverride,
        agentIdFiltersOverride?.length,
        getAgentCategoriesByCategory,
        experienceTracker,
        setCategoryLoading,
        setCategoryError,
        assistanceServiceHeaders,
        fetchOverriddenAgentsAndPopulateStore,
        setAgentCategoriesByCategory,
        populateAgentCategories,
        siteId,
        product,
        onError
    ]);
    return {
        ...actions,
        fetchAgentsByCategory: fetchAgentsByCategory
    };
});
const $808992f64c91fd00$export$65c6565d33cf8f4f = (0, $kBr4q.createHook)($808992f64c91fd00$var$agentsPaginatedStore, {
    selector: (state)=>state.agentsMap
});
const $808992f64c91fd00$var$DEFAULT_RECOMMENDED_AGENTS_LIMIT = 3;
const $808992f64c91fd00$var$getRecommendedAgentsQueryKey = ({ limit: limit, pageUrl: pageUrl, siteId: siteId })=>(0, $iDrrr.fg)('rovo_chat_site_switch_reset') ? [
        'recommendedAgents',
        limit,
        pageUrl ?? '',
        siteId ?? ''
    ] : [
        'recommendedAgents',
        limit,
        pageUrl ?? ''
    ];
const $808992f64c91fd00$var$fetchRecommendedAgents = async ({ assistanceService: assistanceService, limit: limit, pageUrl: pageUrl, updateAgent: updateAgent })=>{
    const isSiteSwitchResetEnabled = (0, $iDrrr.fg)('rovo_chat_site_switch_reset');
    const generationAtRequestStart = $808992f64c91fd00$var$getAgentStoresGeneration();
    const response = await assistanceService.getRecommendedAgents({
        limit: limit,
        pageUrl: pageUrl
    });
    if (isSiteSwitchResetEnabled && $808992f64c91fd00$var$isStaleAgentStoresGeneration(generationAtRequestStart)) return response;
    // Store the agents in the paginated store for optimistic updates etc.
    // Not adding them to a specific category in local cache on purpose.
    response.agents.forEach((agent)=>{
        updateAgent(agent.id, agent);
    });
    return response;
};
const $808992f64c91fd00$export$100f85e1b969f92e = ({ assistanceService: assistanceService, limit: limit = $808992f64c91fd00$var$DEFAULT_RECOMMENDED_AGENTS_LIMIT, pageUrl: pageUrl, updateAgent: updateAgent, onStart: onStart, onSuccess: onSuccess, onError: onError })=>{
    (0, $5SS4O.prefetchQuery)({
        queryKey: $808992f64c91fd00$var$getRecommendedAgentsQueryKey({
            limit: limit,
            pageUrl: pageUrl,
            siteId: assistanceService.getConfig().siteId
        }),
        queryFn: ()=>$808992f64c91fd00$var$fetchRecommendedAgents({
                assistanceService: assistanceService,
                limit: limit,
                pageUrl: pageUrl,
                updateAgent: updateAgent
            }),
        onStart: onStart,
        onSuccess: onSuccess,
        onError: onError
    });
};
const $808992f64c91fd00$export$631401679afcb10f = (0, $lJ6db.createHookWithAssistanceService)(({ assistanceServiceInjectedParams: assistanceServiceInjectedParams, limit: limit = $808992f64c91fd00$var$DEFAULT_RECOMMENDED_AGENTS_LIMIT, pageUrl: pageUrl })=>{
    (0, $6cFsl.di)($808992f64c91fd00$export$65c6565d33cf8f4f);
    const { assistanceService: assistanceService, experienceTracker: experienceTracker, siteId: siteId } = assistanceServiceInjectedParams;
    const [agentsMap, { updateAgent: updateAgent }] = $808992f64c91fd00$export$65c6565d33cf8f4f();
    const { isFetching: isFetching, data: data } = (0, $5SS4O.useQuery)({
        queryKey: $808992f64c91fd00$var$getRecommendedAgentsQueryKey({
            limit: limit,
            pageUrl: pageUrl,
            siteId: siteId
        }),
        queryFn: async ()=>{
            experienceTracker.start({
                id: (0, $irnO2.ExperienceName).GET_RECOMMENDED_AGENTS,
                name: (0, $irnO2.ExperienceName).GET_RECOMMENDED_AGENTS
            });
            return $808992f64c91fd00$var$fetchRecommendedAgents({
                assistanceService: assistanceService,
                limit: limit,
                pageUrl: pageUrl,
                updateAgent: updateAgent
            });
        },
        enabled: Boolean(siteId),
        onSuccess: ()=>{
            experienceTracker.succeed({
                name: (0, $irnO2.ExperienceName).GET_RECOMMENDED_AGENTS
            });
        },
        onError: (error)=>{
            if ((0, $8reXX.isHipaaError)(error)) {
                experienceTracker.succeed({
                    name: (0, $irnO2.ExperienceName).GET_RECOMMENDED_AGENTS
                });
                return;
            }
            experienceTracker.fail({
                name: (0, $irnO2.ExperienceName).GET_RECOMMENDED_AGENTS,
                error: error,
                teamName: (0, $33DP2.ROVO_AGENTS_FE_TEAM_NAME)
            });
        }
    });
    return {
        isFetching: isFetching,
        recommendedAgents: data?.agents.map((agent)=>agentsMap[agent.id]).filter(Boolean) ?? [],
        recommendationKey: data?.metadata?.recommendationKey
    };
});
const $808992f64c91fd00$export$71d3696dcc60eb2d = (0, $lJ6db.createHookWithAssistanceService)(({ assistanceServiceInjectedParams: { experienceTracker: experienceTracker, siteId: siteId } })=>{
    (0, $6cFsl.di)($808992f64c91fd00$export$1553678862324ff0, (0, $ig6TM.fetchAgentByExternalConfigReference));
    const { updateAgent: updateAgent, getCachedAgentByExternalConfigReference: getCachedAgentByExternalConfigReference } = $808992f64c91fd00$export$1553678862324ff0();
    const getAndStoreAgentByExternalConfigReference = (0, $cozmU.useCallback)(async ({ externalConfigReference: externalConfigReference })=>{
        const cachedAgent = getCachedAgentByExternalConfigReference(externalConfigReference);
        if (cachedAgent) return cachedAgent;
        const isSiteSwitchResetEnabled = (0, $iDrrr.fg)('rovo_chat_site_switch_reset');
        const generationAtRequestStart = $808992f64c91fd00$var$getAgentStoresGeneration();
        try {
            experienceTracker.start({
                name: (0, $irnO2.ExperienceName).FETCH_AGENT_BY_EXTERNAL_CONFIG_REFERENCE,
                id: (0, $irnO2.ExperienceName).FETCH_AGENT_BY_EXTERNAL_CONFIG_REFERENCE
            });
            const agentData = await (0, $ig6TM.fetchAgentByExternalConfigReference)({
                cloudId: siteId,
                externalConfigReference: externalConfigReference
            });
            if (!agentData) {
                if (!(0, $iDrrr.fg)('rovo_agents_external_reference_lookup_killswitch')) {
                    experienceTracker.succeed({
                        name: (0, $irnO2.ExperienceName).FETCH_AGENT_BY_EXTERNAL_CONFIG_REFERENCE
                    });
                    return undefined;
                }
                throw new Error('Agent lookup returned no data');
            }
            if (!(isSiteSwitchResetEnabled && $808992f64c91fd00$var$isStaleAgentStoresGeneration(generationAtRequestStart))) // cache the data
            updateAgent(agentData.id, agentData);
            experienceTracker.succeed({
                name: (0, $irnO2.ExperienceName).FETCH_AGENT_BY_EXTERNAL_CONFIG_REFERENCE
            });
            return agentData;
        } catch (error) {
            experienceTracker.fail({
                name: (0, $irnO2.ExperienceName).FETCH_AGENT_BY_EXTERNAL_CONFIG_REFERENCE,
                error: error,
                teamName: (0, $33DP2.ROVO_AGENTS_FE_TEAM_NAME)
            });
            return undefined;
        }
    }, [
        getCachedAgentByExternalConfigReference,
        experienceTracker,
        siteId,
        updateAgent
    ]);
    return {
        getAndStoreAgentByExternalConfigReference: getAndStoreAgentByExternalConfigReference
    };
});
const $808992f64c91fd00$export$eee66751ca85dbf7 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (param)=>{
    return $808992f64c91fd00$export$f5b1109ecd7858c1(param);
} : (param)=>{
    return $808992f64c91fd00$export$f5b1109ecd7858c1(param);
};
const $808992f64c91fd00$export$6553fa633373a34 = (0, $lJ6db.createHookWithAssistanceService)(({ assistanceServiceInjectedParams: { product: product, experienceId: experienceId, headers: headers, touchpointSource: touchpointSource, siteId: siteId }, filter: filter })=>{
    const { availableAgents: availableAgents, favouritedAgents: favouritedAgents } = $808992f64c91fd00$export$eee66751ca85dbf7({
        assistanceServiceParams: {
            product: product,
            experienceId: experienceId,
            headers: headers,
            touchpointSource: touchpointSource,
            siteId: siteId
        }
    });
    const defaultAgents = (0, $aihbI.getSuggestedOotbAgents)({
        availableAgents: availableAgents,
        product: product
    });
    const defaultAgentsOutsideUserFavourites = defaultAgents.filter((defaultAgent)=>!favouritedAgents.find((favAgent)=>favAgent.id === defaultAgent.id));
    const favouritedAgentsWithDefault = [
        ...favouritedAgents,
        ...defaultAgentsOutsideUserFavourites.slice(0, Math.max(3 - favouritedAgents.length, 0))
    ];
    return filter === 'favourites' ? favouritedAgentsWithDefault : availableAgents;
});
module.exports["resetAgentStores"] = $808992f64c91fd00$export$242eb13d25184007;
module.exports["useAgentsPaginatedStoreActions"] = $808992f64c91fd00$export$1553678862324ff0;
module.exports["useAgentsPaginatedByAgentIdStoreHook"] = $808992f64c91fd00$export$cea603150faaa56f;
module.exports["useAgentsPaginatedByAgentId"] = $808992f64c91fd00$export$44c2e95a7a8b47c9;
module.exports["useAgentsPaginatedActionsWithOptimistic"] = $808992f64c91fd00$export$eae59c91509947e4;
module.exports["usePaginatedAgentsByCategory"] = $808992f64c91fd00$export$cc3deb815b1c179b;
module.exports["usePaginatedAgentsActions"] = $808992f64c91fd00$export$94c2040c41639ede;
module.exports["useRecommendedAgents"] = $808992f64c91fd00$export$631401679afcb10f;
module.exports["usePaginatedAgentByConfigReference"] = $808992f64c91fd00$export$71d3696dcc60eb2d;
module.exports["useAgentsList"] = $808992f64c91fd00$export$6553fa633373a34;

});

parcelRegister("5SS4O", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $cbY7C = parcelRequire("cbY7C");


var $kBr4q = parcelRequire("kBr4q");

var $fjHkB = parcelRequire("fjHkB");

var $8s9DV = parcelRequire("8s9DV");

var $c6StJ = parcelRequire("c6StJ");


var $8A2GO = parcelRequire("8A2GO");

const $65e219e9f9df9520$var$store = (0, $8s9DV.createStore)({
    initialState: {
        cache: {},
        epoch: 0
    },
    actions: {
        updateCacheEntry: (key, value)=>({ setState: setState, getState: getState })=>{
                const state = getState();
                const currentCacheEntry = state.cache[key] ?? {
                    data: null,
                    error: null,
                    isFetching: false
                };
                const newCacheEntry = {
                    ...currentCacheEntry,
                    ...value
                };
                setState({
                    cache: {
                        ...state.cache,
                        [key]: newCacheEntry
                    }
                });
            },
        getCacheEntry: (key)=>({ getState: getState })=>{
                const state = getState();
                return state.cache[key];
            },
        deleteCacheEntry: (key)=>({ setState: setState, getState: getState })=>{
                const state = getState();
                const cache = {
                    ...state.cache
                };
                delete cache[key];
                setState({
                    cache: cache
                });
            },
        clearCache: ()=>({ setState: setState, getState: getState })=>{
                setState({
                    cache: {},
                    epoch: getState().epoch + 1
                });
            }
    }
});
const $65e219e9f9df9520$var$getCacheEpoch = ()=>(0, $c6StJ.defaultRegistry).getStore($65e219e9f9df9520$var$store).storeState.getState().epoch;
const $65e219e9f9df9520$export$467f2e03eb04239a = ()=>{
    const storeApi = (0, $c6StJ.defaultRegistry).getStore($65e219e9f9df9520$var$store);
    storeApi.actions.clearCache();
};
const $65e219e9f9df9520$var$selector = (0, $fjHkB.createSelector)((state)=>state.cache, (state)=>state.epoch, (_, props)=>props.key, (_, props)=>props.initialQueryEnabled, /**
 * Based on testing, the result of this selector will be compared with previous result using `shallowEqual`
 * and it will determine whether to rerender the component
 * and also after looking at docs in https://github.com/atlassian/react-sweet-state/blob/master/src/utils/memoize.js#L38
 *
 * e.g. for `enabled` true condition:
 * -> 1st call -> cache[key] === undefined; so it will return { data: null, error: null, isFetching: true }
 * -> 2nd call -> cache[key] !== undefined; so it will return cache[key]; however shallowEqual(cache[key], previousResult) will return true -> so no rerender
 *
 * To test this, run the unit test, and then force this function to return new stuff on every call
 * e.g. `return { ...result, random: Math.random() };`
 * it will result in increase renderCount in the unit test
 */ (cache, epoch, key, initialQueryEnabled)=>({
        ...cache[key] ?? {
            data: null,
            error: null,
            isFetching: initialQueryEnabled
        },
        epoch: epoch
    }));
const $65e219e9f9df9520$var$useCacheEntry = (0, $kBr4q.createHook)($65e219e9f9df9520$var$store, {
    selector: $65e219e9f9df9520$var$selector
});
const $65e219e9f9df9520$export$96097db97bddd5cd = ({ queryKey: queryKeyParts, queryFn: queryFn, onStart: onStart, onSuccess: onSuccess, onError: onError })=>{
    const queryKey = queryKeyParts.map((x)=>x?.toString()).join('_');
    const storeApi = (0, $c6StJ.defaultRegistry).getStore($65e219e9f9df9520$var$store);
    const actions = storeApi.actions;
    if (actions.getCacheEntry(queryKey) !== undefined) return;
    onStart?.();
    const epochAtRequestStart = $65e219e9f9df9520$var$getCacheEpoch();
    actions.updateCacheEntry(queryKey, {
        isFetching: true,
        data: null,
        error: null
    });
    queryFn().then((response)=>{
        if ($65e219e9f9df9520$var$getCacheEpoch() !== epochAtRequestStart) return;
        actions.updateCacheEntry(queryKey, {
            data: response,
            error: null,
            isFetching: false
        });
        onSuccess?.(response);
    }).catch((error)=>{
        // Cache-side errors are intentionally swallowed: a downstream `useQuery`
        // observer (if any) must refetch and surface the error via its normal
        // path. Remove the warm entry so the failed prefetch does not poison the
        // shared cache for the cold path — unless the key has since been cleared
        // and refilled, in which case the entry is another request's to remove.
        if ($65e219e9f9df9520$var$getCacheEpoch() === epochAtRequestStart) actions.deleteCacheEntry(queryKey);
        onError?.(error);
    });
};
const $65e219e9f9df9520$export$dd0a697e1782aedd = ({ queryKey: queryKeyParts, queryFn: queryFn, onSuccess: onSuccess, onError: onError, enabled: enabled = true, refetchOnWindowFocus: refetchOnWindowFocus = false })=>{
    const queryKey = queryKeyParts.map((x)=>x?.toString()).join('_');
    const queryFnRef = (0, $cozmU.useRef)(queryFn);
    queryFnRef.current = queryFn;
    const onSuccessRef = (0, $cozmU.useRef)(onSuccess);
    onSuccessRef.current = onSuccess;
    const onErrorRef = (0, $cozmU.useRef)(onError);
    onErrorRef.current = onError;
    const [cache, { updateCacheEntry: updateCacheEntry, getCacheEntry: getCacheEntry }] = $65e219e9f9df9520$var$useCacheEntry({
        key: queryKey,
        initialQueryEnabled: enabled
    });
    const fetchData = (0, $cozmU.useCallback)(async ()=>{
        const epochAtRequestStart = $65e219e9f9df9520$var$getCacheEpoch();
        updateCacheEntry(queryKey, {
            isFetching: true
        });
        try {
            const response = await queryFnRef.current();
            // The clear already dropped this request's entry, and whatever is under the key now
            // belongs to a later request — so write nothing at all, including `isFetching: false`.
            if ($65e219e9f9df9520$var$getCacheEpoch() !== epochAtRequestStart) return null;
            updateCacheEntry(queryKey, {
                data: response,
                error: null
            });
            onSuccessRef.current?.(response);
            return response;
        } catch (error) {
            const apiError = (0, $8A2GO.mapErrorToApiError)(error);
            if ($65e219e9f9df9520$var$getCacheEpoch() !== epochAtRequestStart) return null;
            updateCacheEntry(queryKey, {
                error: apiError
            });
            onErrorRef.current?.(apiError);
        } finally{
            if ($65e219e9f9df9520$var$getCacheEpoch() === epochAtRequestStart) updateCacheEntry(queryKey, {
                isFetching: false
            });
        }
        return null;
    }, [
        updateCacheEntry,
        queryKey
    ]);
    const updateCache = (0, $cozmU.useCallback)((data)=>{
        updateCacheEntry(queryKey, {
            data: data
        });
    }, [
        updateCacheEntry,
        queryKey
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (enabled && refetchOnWindowFocus) {
            const unbind = (0, $cbY7C.bind)(window, {
                // We use visibilitychange instead of focus to prevent triggering refetch when moving between iframes such as agent embed
                type: 'visibilitychange',
                listener: ()=>{
                    if (enabled && refetchOnWindowFocus && !getCacheEntry(queryKey)?.isFetching) {
                        if (document.visibilityState === 'visible') fetchData();
                    }
                }
            });
            return unbind;
        }
    }, [
        enabled,
        fetchData,
        getCacheEntry,
        queryKey,
        refetchOnWindowFocus
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!getCacheEntry(queryKey) && enabled) fetchData();
    }, [
        queryKey,
        fetchData,
        enabled,
        getCacheEntry,
        cache.epoch
    ]);
    return {
        data: cache.data,
        error: cache.error,
        isFetching: cache.isFetching,
        refetch: fetchData,
        updateCache: updateCache
    };
};
module.exports["clearQueryCache"] = $65e219e9f9df9520$export$467f2e03eb04239a;
module.exports["prefetchQuery"] = $65e219e9f9df9520$export$96097db97bddd5cd;
module.exports["useQuery"] = $65e219e9f9df9520$export$dd0a697e1782aedd;

});

parcelRegister("33DP2", function(module, exports) {
const $1034fab58a3f1117$export$73b400613798970e = 'rovo-agents-fe';
module.exports["ROVO_AGENTS_FE_TEAM_NAME"] = $1034fab58a3f1117$export$73b400613798970e;

});

parcelRegister("ig6TM", function(module, exports) {

var $6cFsl = parcelRequire("6cFsl");


var $iDrrr = parcelRequire("iDrrr");


var $haiCi = parcelRequire("haiCi");


var $hkokM = parcelRequire("hkokM");

const $23d23aea84aebb6d$export$cf57de7718965ae3 = {
    hasNextPage: false,
    hasPreviousPage: false,
    startCursor: undefined,
    endCursor: undefined
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $23d23aea84aebb6d$var$transformAgentListToGqlResponse = (response)=>{
    try {
        // data can be null if the `abortController` is aborted
        const { edges: edges, pageInfo: pageInfo } = response?.data?.agentStudio_getAgents ?? {
            pageInfo: $23d23aea84aebb6d$export$cf57de7718965ae3
        };
        const agents = edges?.map((edge)=>(0, $hkokM.transformAgentGqlResponse)(edge.node)).filter((agent)=>!!agent.id) ?? [];
        return {
            agents: agents,
            pageInfo: pageInfo
        };
    } catch  {
        return {
            agents: [],
            pageInfo: {
                hasNextPage: false,
                hasPreviousPage: false,
                startCursor: undefined,
                endCursor: undefined
            }
        };
    }
};
const $23d23aea84aebb6d$var$agentStudioAssistantFragment = `
fragment conversationAssistantAgent_agentStudioAssistant on AgentStudioAssistant {
  id
  name
  description
  conversationStarters
  isFavourite
  creatorType
  identityAccountId
  externalConfigReference
  creator {
    id
  }
  icon
  authoringTeam @skip(if: $skipAuthoringTeam) {
    id
    profileUrl
    displayName
		smallAvatarImageUrl
  }
  isVerified
  executionConfig @include(if: $includeExecutionConfig) {
    executionTier
    modelId
  }
}
`;
const $23d23aea84aebb6d$export$44f796a68d9bc9f1 = async ({ cloudId: cloudId, count: count = 10, after: after, product: product, input: input, abortController: abortController, workspaceId: workspaceId })=>{
    (0, $6cFsl.di)((0, $haiCi.performGqlFetch));
    const gqlQuery = `
	query agentStudioGetAgents($cloudId: String!, $first: Int, $input: AgentStudioAgentQueryInput, $after: String, $product: String, $workspaceId: String, $skipAuthoringTeam: Boolean = false, $includeExecutionConfig: Boolean = false) {
		agentStudio_getAgents(
			cloudId: $cloudId
			first: $first
			input: $input
			after: $after
			product: $product
			workspaceId: $workspaceId
		) @optIn(to: "AgentStudio") {
			edges {
				node {
					...conversationAssistantAgent_agentStudioAssistant
				}
			}
			pageInfo {
				startCursor
				endCursor
				hasNextPage
				hasPreviousPage
			}
		}
	}

	${$23d23aea84aebb6d$var$agentStudioAssistantFragment}
	`;
    const variables = {
        cloudId: cloudId,
        first: count,
        after: after,
        product: product,
        input: input,
        workspaceId: workspaceId,
        skipAuthoringTeam: (0, $iDrrr.fg)('rovo_agents_fetch_agents_without_authoring_team'),
        includeExecutionConfig: (0, $iDrrr.fg)('rovo_marathon_as_agent_enabled')
    };
    const response = await (0, $haiCi.performGqlFetch)({
        gqlQuery: gqlQuery,
        variables: variables,
        abortController: abortController
    });
    return $23d23aea84aebb6d$var$transformAgentListToGqlResponse(response);
};
const $23d23aea84aebb6d$export$fce04ce5e2fe57d3 = async ({ cloudId: cloudId, externalConfigReference: externalConfigReference })=>{
    (0, $6cFsl.di)((0, $haiCi.performGqlFetch));
    const gqlQuery = `
	query agentStudioGetAgentByExternalConfigReference($cloudId: String!, $externalConfigReference: String!, $skipAuthoringTeam: Boolean = false, $includeExecutionConfig: Boolean = false) {
		agentStudio_getByExternalReference(cloudId: $cloudId, externalReference: $externalConfigReference) @optIn(to: "AgentStudio") {
			__typename
			...conversationAssistantAgent_agentStudioAssistant
			}
		}

		${$23d23aea84aebb6d$var$agentStudioAssistantFragment}
		`;
    const variables = {
        cloudId: cloudId,
        externalConfigReference: externalConfigReference,
        skipAuthoringTeam: (0, $iDrrr.fg)('rovo_agents_fetch_agents_without_authoring_team'),
        includeExecutionConfig: (0, $iDrrr.fg)('rovo_marathon_as_agent_enabled')
    };
    const response = await (0, $haiCi.performGqlFetch)({
        gqlQuery: gqlQuery,
        variables: variables
    });
    const agent = response.data?.agentStudio_getByExternalReference;
    if (!(0, $iDrrr.fg)('rovo_agents_external_reference_lookup_killswitch') && agent?.__typename !== 'AgentStudioAssistant') return undefined;
    return (0, $hkokM.transformAgentGqlResponse)(agent);
};
module.exports["DEFAULT_PAGE_INFO"] = $23d23aea84aebb6d$export$cf57de7718965ae3;
module.exports["fetchPaginatedAgents"] = $23d23aea84aebb6d$export$44f796a68d9bc9f1;
module.exports["fetchAgentByExternalConfigReference"] = $23d23aea84aebb6d$export$fce04ce5e2fe57d3;

});

parcelRegister("haiCi", function(module, exports) {

var $jTKfH = parcelRequire("jTKfH");


var $5rzIE = parcelRequire("5rzIE");

const $a406323faf455711$var$extractQueryName = (gqlQuery)=>{
    const operationMatch = gqlQuery.match(/(?:query|mutation)\s+(\w+)/);
    return operationMatch ? operationMatch[1] : undefined;
};
const $a406323faf455711$export$f602b5befecb0b84 = async ({ gqlQuery: gqlQuery, headerOptions: headerOptions, variables: variables, abortController: abortController })=>{
    const startedAt = (0, $5rzIE.hasRequestObservationSubscribers)() ? (0, $5rzIE.requestObservationNow)() : undefined;
    const operation = startedAt === undefined ? undefined : $a406323faf455711$var$extractQueryName(gqlQuery);
    try {
        const response = await fetch('/gateway/api/graphql', {
            headers: {
                'Content-Type': 'application/json',
                ...headerOptions
            },
            method: 'POST',
            body: JSON.stringify({
                query: gqlQuery,
                variables: variables
            }),
            signal: abortController?.signal
        });
        const json = await response.json();
        if (json?.errors?.length) await $a406323faf455711$var$processGqlErrorResponse({
            errors: json.errors,
            gqlQuery: gqlQuery
        });
        if (startedAt !== undefined) (0, $5rzIE.publishRequestObservation)({
            kind: 'graphql',
            method: 'POST',
            operation: operation,
            durationMs: (0, $5rzIE.requestObservationDuration)(startedAt),
            outcome: 'success',
            status: response.status
        });
        return json;
    } catch (err) {
        // GqlApiError is already processed
        if (err instanceof $a406323faf455711$export$ba203f24e0131ba7) {
            if (startedAt !== undefined) (0, $5rzIE.publishRequestObservation)({
                kind: 'graphql',
                method: 'POST',
                operation: operation,
                durationMs: (0, $5rzIE.requestObservationDuration)(startedAt),
                outcome: 'graphqlError'
            });
            throw err;
        }
        // Handle abort signal gracefully, it shouldn't be considered an error despite being caught
        if (err instanceof Error && err.name === 'AbortError') {
            if (startedAt !== undefined) (0, $5rzIE.publishRequestObservation)({
                kind: 'graphql',
                method: 'POST',
                operation: operation,
                durationMs: (0, $5rzIE.requestObservationDuration)(startedAt),
                outcome: 'abort'
            });
            return {
                // eslint-disable-next-line @atlaskit/platform/no-double-type-assertions -- Existing GraphQL abort baseline: abort returns an empty typed success shape for generic callers.
                data: null,
                errors: undefined
            };
        }
        const originalErrorMessage = err instanceof Error ? err.message : 'Unknown error';
        if (startedAt !== undefined) (0, $5rzIE.publishRequestObservation)({
            kind: 'graphql',
            method: 'POST',
            operation: operation,
            durationMs: (0, $5rzIE.requestObservationDuration)(startedAt),
            outcome: 'networkError'
        });
        throw new (0, $jTKfH.FetchError)(`GraphQL query failed (promise rejected): ${originalErrorMessage}`, {
            errorCode: 'performGqlFetchError'
        });
    }
};
class $a406323faf455711$export$ba203f24e0131ba7 extends Error {
    constructor({ errors: errors, queryName: queryName }){
        const errorsString = errors.map((error)=>error.message).join(', ');
        const errorMessage = `GraphQL API error: ${errorsString}`;
        super(errorMessage);
        this.message = void 0;
        this.errorAttributes = void 0;
        this.message = errorMessage;
        this.name = 'GraphQLError';
        this.errorAttributes = {
            errorCode: 'GqlApiError',
            queryName: queryName,
            rawErrorMessage: errorMessage,
            errors: errorsString
        };
    }
}
const $a406323faf455711$var$processGqlErrorResponse = async ({ errors: errors, gqlQuery: gqlQuery })=>{
    const errorsToThrow = [];
    errors.forEach((error)=>{
        errorsToThrow.push({
            message: error.message,
            status_code: error.extensions.statusCode,
            classification: error.extensions.classification
        });
    });
    throw new $a406323faf455711$export$ba203f24e0131ba7({
        errors: errorsToThrow,
        queryName: $a406323faf455711$var$extractQueryName(gqlQuery)
    });
};
module.exports["performGqlFetch"] = $a406323faf455711$export$f602b5befecb0b84;
module.exports["GqlApiError"] = $a406323faf455711$export$ba203f24e0131ba7;

});

parcelRegister("hkokM", function(module, exports) {
const $296d37b9c9e504ab$export$92f11cf4e802b166 = (ari)=>{
    // Pattern: ari:cloud:rovo::agent/activation/{uuid}/{uuid}
    const ariPattern = /^ari:cloud:rovo::agent\/activation\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}\/([^/]+)$/;
    const match = ari.match(ariPattern);
    if (!match) return null;
    // Return the second UUID (agent ID)
    return match[1];
};
const $296d37b9c9e504ab$export$91e35509133d1cc1 = (agentNode)=>({
        creator_type: agentNode.creatorType,
        creator: agentNode.creator?.id,
        description: agentNode.description,
        external_config_reference: agentNode.externalConfigReference,
        favourite: agentNode.isFavourite,
        id: $296d37b9c9e504ab$export$92f11cf4e802b166(agentNode.id) ?? '',
        agentAri: agentNode.id,
        identity_account_id: agentNode.identityAccountId,
        name: agentNode.name,
        user_defined_conversation_starters: agentNode.conversationStarters,
        icon: agentNode.icon,
        // We need named_id here as the FE requires it for certain features
        named_id: $296d37b9c9e504ab$export$92f11cf4e802b166(agentNode.id) ?? '',
        authoring_team: agentNode?.authoringTeam ? {
            id: agentNode.authoringTeam.id,
            profile_url: agentNode.authoringTeam.profileUrl,
            display_name: agentNode.authoringTeam.displayName,
            avatar_url: agentNode.authoringTeam.smallAvatarImageUrl
        } : null,
        is_verified: agentNode.isVerified,
        execution_config: agentNode.executionConfig ? {
            execution_tier: agentNode.executionConfig.executionTier
        } : null
    });
module.exports["transformAgentGqlResponse"] = $296d37b9c9e504ab$export$91e35509133d1cc1;

});

parcelRegister("aihbI", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6cFsl = parcelRequire("6cFsl");


var $i1t43 = parcelRequire("i1t43");


var $NlHoa = parcelRequire("NlHoa");


var $12QCz = parcelRequire("12QCz");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");


var $1l0kj = parcelRequire("1l0kj");


var $hSs5g = parcelRequire("hSs5g");


var $hq9Cp = parcelRequire("hq9Cp");


var $a9aSv = parcelRequire("a9aSv");


var $hlvTd = parcelRequire("hlvTd");


var $5SS4O = parcelRequire("5SS4O");


var $fi4Un = parcelRequire("fi4Un");


var $ji12t = parcelRequire("ji12t");


var $8reXX = parcelRequire("8reXX");


var $aaPn1 = parcelRequire("aaPn1");


var $fjlCA = parcelRequire("fjlCA");


var $cKhij = parcelRequire("cKhij");

const $117d671412ecf119$export$3761e66a04602cbd = (ari)=>{
    const matched = ari.match(/\/([a-zA-Z0-9_\|\-\:]{1,128})$/);
    return matched ? matched[1] : undefined;
};
const $117d671412ecf119$export$acf3e1bcf222b00d = (aaid)=>{
    return `ari:cloud:identity::user/${aaid}`;
};
const $117d671412ecf119$export$1565ea9a9fb7ad67 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(14);
    const { agent: agent, siteId: siteId, simplified: simplified, onClick: onClick } = t0;
    if ((0, $ji12t.isSystemAgent)(agent) || (0, $ji12t.isOOTBAgent)(agent) || !agent.creator) {
        let t1;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
                alignBlock: "center",
                testId: "atlassian-icon"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $NlHoa.AtlassianIcon), {
                label: "",
                appearance: "brand",
                size: "small"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, "Atlassian"));
            $[0] = t1;
        } else t1 = $[0];
        return t1;
    }
    if ((0, $ji12t.isCustomerAgent)(agent)) {
        const authoringTeam = agent.authoring_team;
        if (authoringTeam?.id) {
            let t1;
            if ($[1] !== authoringTeam.display_name || $[2] !== authoringTeam.profile_url || $[3] !== onClick) {
                t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
                    alignBlock: "center",
                    testId: "atlassian-icon"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
                    href: authoringTeam.profile_url,
                    target: "_blank",
                    onClick: onClick
                }, authoringTeam.display_name));
                $[1] = authoringTeam.display_name;
                $[2] = authoringTeam.profile_url;
                $[3] = onClick;
                $[4] = t1;
            } else t1 = $[4];
            return t1;
        }
        let t1;
        if ($[5] !== agent.creator) {
            t1 = agent.creator ? $117d671412ecf119$export$3761e66a04602cbd(agent.creator) : undefined;
            $[5] = agent.creator;
            $[6] = t1;
        } else t1 = $[6];
        const aaid = t1;
        if (!aaid) return null;
        let t2;
        if ($[7] !== aaid || $[8] !== onClick || $[9] !== simplified || $[10] !== siteId) {
            t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($117d671412ecf119$var$ResolvingMention, {
                userId: aaid,
                siteId: siteId,
                profileCard: true,
                simplified: simplified,
                onClick: onClick
            });
            $[7] = aaid;
            $[8] = onClick;
            $[9] = simplified;
            $[10] = siteId;
            $[11] = t2;
        } else t2 = $[11];
        return t2;
    }
    if ((0, $iDrrr.fg)("rovo_agent_support_a2a_avatar") ? (0, $hq9Cp.isForgeAgentByCreatorType)(agent.creator_type) : (0, $ji12t.isForgeAgent)(agent)) {
        let t1;
        if ($[12] !== agent.creator) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, agent.creator);
            $[12] = agent.creator;
            $[13] = t1;
        } else t1 = $[13];
        return t1;
    }
    return null;
} : ({ agent: agent, siteId: siteId, simplified: simplified, onClick: onClick })=>{
    if ((0, $ji12t.isSystemAgent)(agent) || (0, $ji12t.isOOTBAgent)(agent) || !agent.creator) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        testId: "atlassian-icon"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $NlHoa.AtlassianIcon), {
        label: "",
        appearance: "brand",
        size: "small"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, "Atlassian"));
    if ((0, $ji12t.isCustomerAgent)(agent)) {
        const authoringTeam = agent.authoring_team;
        if (authoringTeam?.id) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            alignBlock: "center",
            testId: "atlassian-icon"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
            href: authoringTeam.profile_url,
            target: "_blank",
            onClick: onClick
        }, authoringTeam.display_name));
        const aaid = agent.creator ? $117d671412ecf119$export$3761e66a04602cbd(agent.creator) : undefined;
        if (!aaid) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($117d671412ecf119$var$ResolvingMention, {
            userId: aaid,
            siteId: siteId,
            profileCard: true,
            simplified: simplified,
            onClick: onClick
        });
    }
    if ((0, $iDrrr.fg)('rovo_agent_support_a2a_avatar') ? (0, $hq9Cp.isForgeAgentByCreatorType)(agent.creator_type) : (0, $ji12t.isForgeAgent)(agent)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, agent.creator);
    return null;
};
// TODO consolidate this with `AgentCreator` component `platform/packages/ai-mate/conversation-assistant-agent/src/common/ui/creator/index.tsx`
const $117d671412ecf119$var$ResolvingMention = ({ userId: userId, siteId: siteId, profileCard: profileCard = false, simplified: simplified = false, onClick: onClick })=>{
    (0, $6cFsl.di)($117d671412ecf119$export$5d980898591175e, (0, $fi4Un.useAgentCrossProductUrlWrapper));
    const { profile: profile, client: client } = $117d671412ecf119$export$5d980898591175e(userId, siteId);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { atlasURL: atlasURL } = (0, $aaPn1.useAtlasURL)(siteId);
    const wrapCrossProductUrl = (0, $fi4Un.useAgentCrossProductUrlWrapper)({
        xpcBridge: 'rovoAgents-browseAgentsModal'
    });
    const fullName = profile.data?.status === 'inactive' && profile.data.fullName ? formatMessage((0, $cKhij.default).deactivatedCreatorName, {
        name: profile.data.fullName
    }) : profile.data?.fullName;
    if (profile.isFetching || !profile.data) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        isShimmering: true,
        height: 18,
        width: 100,
        borderRadius: "var(--ds-radius-small, 4px)"
    });
    if (simplified) {
        const profileUrl = wrapCrossProductUrl(atlasURL(`/people/${userId}`));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
            href: profileUrl,
            target: "_blank",
            onClick: onClick
        }, fullName);
    }
    return profileCard ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hSs5g.default), {
        userId: userId,
        resourceClient: client,
        ariaLabel: fullName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $12QCz.default), {
        id: userId,
        isHighlighted: profile.data.isCurrentUser,
        text: `@${fullName}`
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $12QCz.default), {
        id: userId,
        isHighlighted: profile.data.isCurrentUser,
        text: `@${fullName}`
    });
};
const $117d671412ecf119$export$5d980898591175e = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useProfileResolution(userId, siteId, t0) {
    const $ = (0, $bDgLe.c)(14);
    const shouldFetch = t0 === undefined ? true : t0;
    const profileClient = (0, $fjlCA.useProfileClient)();
    let t1;
    if ($[0] !== siteId || $[1] !== userId) {
        t1 = [
            "fetchProfile",
            siteId,
            userId
        ];
        $[0] = siteId;
        $[1] = userId;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== profileClient || $[4] !== siteId || $[5] !== userId) {
        t2 = async ()=>{
            try {
                const response = await profileClient.getProfile(siteId, userId);
                return response;
            } catch (t3) {
                const error = t3;
                (0, $hlvTd.logException)({
                    exception: error,
                    name: "ConversationAssistantAgentUseProfileResolutionError"
                });
                return {};
            }
        };
        $[3] = profileClient;
        $[4] = siteId;
        $[5] = userId;
        $[6] = t2;
    } else t2 = $[6];
    let t3;
    if ($[7] !== shouldFetch || $[8] !== t1 || $[9] !== t2) {
        t3 = {
            queryKey: t1,
            queryFn: t2,
            enabled: shouldFetch
        };
        $[7] = shouldFetch;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
    } else t3 = $[10];
    const profile = (0, $5SS4O.useQuery)(t3);
    let t4;
    if ($[11] !== profile || $[12] !== profileClient) {
        t4 = {
            profile: profile,
            client: profileClient
        };
        $[11] = profile;
        $[12] = profileClient;
        $[13] = t4;
    } else t4 = $[13];
    return t4;
} : function useProfileResolution(userId, siteId, shouldFetch = true) {
    const profileClient = (0, $fjlCA.useProfileClient)();
    const profile = (0, $5SS4O.useQuery)({
        queryKey: [
            'fetchProfile',
            siteId,
            userId
        ],
        queryFn: async ()=>{
            try {
                const response = await profileClient.getProfile(siteId, userId);
                return response;
            } catch (error) {
                (0, $hlvTd.logException)({
                    exception: error,
                    name: 'ConversationAssistantAgentUseProfileResolutionError'
                });
                return {};
            }
        },
        enabled: shouldFetch
    });
    return {
        profile: profile,
        client: profileClient
    };
};
const $117d671412ecf119$export$13d60404a0dddebd = (agents, filters)=>{
    return agents.filter((agent)=>agent.name.toLocaleLowerCase().includes(filters.searchValue.toLocaleLowerCase()) || agent.description?.toLocaleLowerCase().includes(filters.searchValue.toLocaleLowerCase())).sort((a, b)=>a.name.localeCompare(b.name));
};
const $117d671412ecf119$export$a6e36c224ec3c0cb = (agent)=>{
    const enabledSources = agent.scenarios?.filter((scenario)=>scenario.isActive && scenario.isValid?.value)?.flatMap((scenario)=>scenario.knowledgeSources).filter((source)=>source?.enabled).flatMap((source)=>source?.sources).filter((source)=>source?.enabled);
    if (!enabledSources?.length) return [];
    const allAris = enabledSources.reduce((acc, cur)=>{
        const allFilters = [
            ...cur?.filters?.parentFilter ?? [],
            ...cur?.filters?.spaceFilter ?? [],
            ...cur?.filters?.projectFilter ?? []
        ];
        allFilters.forEach((item)=>acc.add(item));
        return acc;
    }, new Set());
    return Array.from(allAris);
};
const $117d671412ecf119$export$4aa0ac5d998cf08e = (agent)=>{
    const enabledSources = agent.scenarios?.filter((scenario)=>scenario.isActive && scenario.isValid?.value)?.flatMap((scenario)=>scenario.knowledgeSources).filter((source)=>source?.enabled).flatMap((source)=>source?.sources).filter((source)=>source?.enabled === true);
    const filtersByAri = new Map();
    enabledSources?.forEach((source)=>{
        const sourceAris = [
            ...source.filters?.parentFilter ?? [],
            ...source.filters?.spaceFilter ?? [],
            ...source.filters?.projectFilter ?? []
        ];
        sourceAris.forEach((ari)=>{
            if (!filtersByAri.has(ari)) filtersByAri.set(ari, {
                ari: ari,
                cloudId: source.cloudId ?? null
            });
        });
    });
    return [
        ...filtersByAri.values()
    ];
};
const $117d671412ecf119$export$6d876204c5d593ac = ({ availableAgents: availableAgents, product: product })=>{
    // If no product is provided / product is not supported, fallback to using default agents
    const defaultAgentsNamedIds = product ? (0, $8reXX.DEFAULT_OOTB_AGENTS_NAMED_IDS)[product] ?? (0, $8reXX.DEFAULT_AGENTS_NAMED_ID_LIST) : (0, $8reXX.DEFAULT_AGENTS_NAMED_ID_LIST);
    const defaultAgents = availableAgents.filter((agent)=>defaultAgentsNamedIds.has(agent.named_id) || agent.external_config_reference && defaultAgentsNamedIds.has(agent.external_config_reference));
    return defaultAgents;
};
module.exports["getAAIDFromARI"] = $117d671412ecf119$export$3761e66a04602cbd;
module.exports["AgentCreatedBy"] = $117d671412ecf119$export$1565ea9a9fb7ad67;
module.exports["useProfileResolution"] = $117d671412ecf119$export$5d980898591175e;
module.exports["getEnabledKnowlegeArisFromAgent"] = $117d671412ecf119$export$a6e36c224ec3c0cb;
module.exports["getEnabledKnowledgeFiltersFromAgent"] = $117d671412ecf119$export$4aa0ac5d998cf08e;
module.exports["getSuggestedOotbAgents"] = $117d671412ecf119$export$6d876204c5d593ac;

});

parcelRegister("i1t43", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $w6R6I = parcelRequire("w6R6I");


var $7vK9E = parcelRequire("7vK9E");


var $iMnC5 = parcelRequire("iMnC5");

const $7e44050607850249$var$styles = {
    base: "_0bjKvDcjp5 _0WKd3G4z3T",
    visitedLink: "_2nTuUYWfPD _3ADzdEWfPD _1warJ9WfPD _4scvAwWyeI",
    defaultAppearance: "_00uqCY98eZ _3xtjKN0Rl6 _0H9qDF6wH8 _23rrnHo10F _1UtDYzM7Tp _32C2rk98eZ _0i9AWA0Rl6 _0mm6KQ6wH8 _10n1R5M7Tp _0DCa9DjOvk _3932vv0Rl6 _02cRtH6wH8 _1B4rbIo10F _0clgaMM7Tp _3WzCGijOvk _0NqVRt0Rl6 _3BKYwu6wH8 _3sFUREDdj4 _0CMRbkAwSC",
    subtleAppearance: "_00uqCYjOvk _3xtjKN0Rl6 _0H9qDF6wH8 _23rrnHo10F _1UtDYzZpcK _32C2rkjOvk _0i9AWA0Rl6 _0mm6KQ6wH8 _10n1R5ZpcK _0DCa9D98eZ _3932vv0Rl6 _02cRtH6wH8 _1B4rbIo10F _0clgaMZpcK _3WzCGi98eZ _0NqVRt0Rl6 _3BKYwu6wH8 _3sFUREDdj4 _0CMRbky7kJ",
    inverseAppearance: "_00uqCY98eZ _3xtjKN0Rl6 _0H9qDF6wH8 _23rrnHo10F _1UtDYze5R3 _2nTuUYe5R3 _32C2rk98eZ _0i9AWA0Rl6 _0mm6KQ6wH8 _10n1R5e5R3 _0DCa9DjOvk _3932vv0Rl6 _02cRtH6wH8 _1B4rbIo10F _0clgaMe5R3 _3WzCGijOvk _0NqVRt0Rl6 _3BKYwu6wH8 _3sFUREDdj4 _0CMRbke5R3",
    iconWrapper: "_3iDTPbS8kF _1ANEUSLRg7 _1RrJLiQame _1mT5xdRAKS _2I62gzVQEB"
};
const $7e44050607850249$var$iconStyles = null;
const $7e44050607850249$var$LinkWithoutRef = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(24);
    let children;
    let htmlAttributes;
    let newWindowLabel;
    let t1;
    let target;
    let testId;
    if ($[0] !== t0) {
        const { children: t2, testId: t3, appearance: t4, newWindowLabel: t5, target: t6, className: _preventedClassName, style: _preventedStyle, ...t7 } = t0;
        children = t2;
        testId = t3;
        t1 = t4;
        newWindowLabel = t5;
        target = t6;
        htmlAttributes = t7;
        $[0] = t0;
        $[1] = children;
        $[2] = htmlAttributes;
        $[3] = newWindowLabel;
        $[4] = t1;
        $[5] = target;
        $[6] = testId;
    } else {
        children = $[1];
        htmlAttributes = $[2];
        newWindowLabel = $[3];
        t1 = $[4];
        target = $[5];
        testId = $[6];
    }
    const appearance = t1 === undefined ? "default" : t1;
    const t2 = appearance === "default" && $7e44050607850249$var$styles.defaultAppearance;
    const t3 = appearance === "subtle" && $7e44050607850249$var$styles.subtleAppearance;
    const t4 = appearance === "inverse" && $7e44050607850249$var$styles.inverseAppearance;
    const t5 = appearance !== "inverse" && $7e44050607850249$var$styles.visitedLink;
    let t6;
    if ($[7] !== t2 || $[8] !== t3 || $[9] !== t4 || $[10] !== t5) {
        t6 = (0, $w6R6I.cx)($7e44050607850249$var$styles.base, t2, t3, t4, t5);
        $[7] = t2;
        $[8] = t3;
        $[9] = t4;
        $[10] = t5;
        $[11] = t6;
    } else t6 = $[11];
    let t7;
    if ($[12] !== target || $[13] !== testId) {
        t7 = target === "_blank" && /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $iMnC5.Box), {
            as: "span",
            xcss: $7e44050607850249$var$styles.iconWrapper,
            testId: testId && `${testId}__icon`,
            children: [
                "\uFEFF",
                /*#__PURE__*/ (0, $8aG6j.jsx)("svg", {
                    width: "12",
                    height: "12",
                    viewBox: "0 0 12 12",
                    fill: "none",
                    className: (0, $hekY6.default)([
                        "_39xV02YsW8 _0jFU0VYsW8 _0GTcwRu3qR"
                    ]),
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M0 1.82609C0 0.817938 0.817938 0 1.82609 0H3.91304V1.04348H1.82609C1.39424 1.04348 1.04348 1.39424 1.04348 1.82609V10.1739C1.04348 10.6058 1.39424 10.9565 1.82609 10.9565H10.1739C10.6058 10.9565 10.9565 10.6058 10.9565 10.1739V8.08696H12V10.1739C12 11.1821 11.1821 12 10.1739 12H1.82609C0.817938 12 0 11.1821 0 10.1739V1.82609ZM7.04348 0H12V4.95652H10.9565V1.78133L6.36893 6.36893L5.63107 5.63107L10.2187 1.04348H7.04348V0Z",
                        fill: "currentColor"
                    })
                })
            ]
        });
        $[12] = target;
        $[13] = testId;
        $[14] = t7;
    } else t7 = $[14];
    let t8;
    if ($[15] !== children || $[16] !== htmlAttributes || $[17] !== newWindowLabel || $[18] !== ref || $[19] !== t6 || $[20] !== t7 || $[21] !== target || $[22] !== testId) {
        t8 = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $7vK9E.Anchor), {
            ...htmlAttributes,
            target: target,
            ref: ref,
            xcss: t6,
            testId: testId,
            componentName: "Link",
            newWindowLabel: newWindowLabel,
            children: [
                children,
                t7
            ]
        });
        $[15] = children;
        $[16] = htmlAttributes;
        $[17] = newWindowLabel;
        $[18] = ref;
        $[19] = t6;
        $[20] = t7;
        $[21] = target;
        $[22] = testId;
        $[23] = t8;
    } else t8 = $[23];
    return t8;
} : ({ children: children, testId: testId, appearance: appearance = 'default', newWindowLabel: newWindowLabel, target: target, // @ts-expect-error
className: _preventedClassName, // @ts-expect-error
style: _preventedStyle, ...htmlAttributes }, ref)=>/*#__PURE__*/ (0, $8aG6j.jsxs)((0, $7vK9E.Anchor // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    ), {
        ...htmlAttributes,
        target: target,
        ref: ref,
        xcss: (0, $w6R6I.cx)($7e44050607850249$var$styles.base, appearance === 'default' && $7e44050607850249$var$styles.defaultAppearance, appearance === 'subtle' && $7e44050607850249$var$styles.subtleAppearance, appearance === 'inverse' && $7e44050607850249$var$styles.inverseAppearance, // Visited styles are not supported for inverse links due to contrast issues
        appearance !== 'inverse' && $7e44050607850249$var$styles.visitedLink),
        testId: testId,
        componentName: "Link",
        newWindowLabel: newWindowLabel,
        children: [
            children,
            target === '_blank' && /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $iMnC5.Box), {
                as: "span",
                xcss: $7e44050607850249$var$styles.iconWrapper,
                testId: testId && `${testId}__icon`,
                children: [
                    "\uFEFF",
                    /*#__PURE__*/ (0, $8aG6j.jsx)("svg", {
                        width: "12",
                        height: "12",
                        viewBox: "0 0 12 12",
                        fill: "none",
                        className: (0, $hekY6.default)([
                            "_39xV02YsW8 _0jFU0VYsW8 _0GTcwRu3qR"
                        ]),
                        children: /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M0 1.82609C0 0.817938 0.817938 0 1.82609 0H3.91304V1.04348H1.82609C1.39424 1.04348 1.04348 1.39424 1.04348 1.82609V10.1739C1.04348 10.6058 1.39424 10.9565 1.82609 10.9565H10.1739C10.6058 10.9565 10.9565 10.6058 10.9565 10.1739V8.08696H12V10.1739C12 11.1821 11.1821 12 10.1739 12H1.82609C0.817938 12 0 11.1821 0 10.1739V1.82609ZM7.04348 0H12V4.95652H10.9565V1.78133L6.36893 6.36893L5.63107 5.63107L10.2187 1.04348H7.04348V0Z",
                            fill: "currentColor"
                        })
                    })
                ]
            })
        ]
    }); // Workarounds to support generic types with forwardRef
/**
 * __Link__
 *
 * A link is an inline text element that navigates to a new location when clicked.
 *
 * - [Examples](https://atlassian.design/components/primitives/link/examples)
 * - [Code](https://atlassian.design/components/primitives/link/code)
 * - [Usage](https://atlassian.design/components/primitives/link/usage)
 */ const $7e44050607850249$var$Link = /*#__PURE__*/ (0, $cozmU.forwardRef)($7e44050607850249$var$LinkWithoutRef);
var $7e44050607850249$export$2e2bcd8739ae039 = $7e44050607850249$var$Link;
module.exports["default"] = $7e44050607850249$export$2e2bcd8739ae039;

});

parcelRegister("12QCz", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $bPBcn = parcelRequire("bPBcn");


var $kpMMm = parcelRequire("kpMMm");


var $9jOz9 = parcelRequire("9jOz9");


var $4cczm = parcelRequire("4cczm");

const $1b57c88557e5831b$export$7452d7062a4d0634 = 1000;
const $1b57c88557e5831b$var$mentionEventMap = {
    onClick: (createEvent, props)=>{
        const { id: id, text: text, accessLevel: accessLevel } = props;
        const event = (0, $kpMMm.fireAnalyticsMentionEvent)(createEvent)('mention', 'selected', text, id, accessLevel);
        return event;
    },
    onHover: (createEvent, props)=>{
        const { id: id, text: text, accessLevel: accessLevel } = props;
        const event = (0, $kpMMm.fireAnalyticsMentionEvent)(createEvent)('mention', 'hovered', text, id, accessLevel);
        return event;
    }
};
// oxlint-disable-next-line eslint/no-redeclare
const $1b57c88557e5831b$var$Mention = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).forwardRef((0, $gtMdU.isReactCompilerActivePlatform)() ? (props, ref)=>{
    const $ = (0, $bDgLe.c)(5);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { patchedEventProps: patchedEventProps } = (0, $bPBcn.usePatchedProps)($1b57c88557e5831b$var$mentionEventMap, props);
    let t0;
    if ($[0] !== createAnalyticsEvent || $[1] !== patchedEventProps || $[2] !== props || $[3] !== ref) {
        t0 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9jOz9.MentionInternal), {
            ...props,
            ...patchedEventProps,
            createAnalyticsEvent: createAnalyticsEvent,
            ref: ref
        });
        $[0] = createAnalyticsEvent;
        $[1] = patchedEventProps;
        $[2] = props;
        $[3] = ref;
        $[4] = t0;
    } else t0 = $[4];
    return t0;
} : (props, ref)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    // Keep the existing event decoration, including the analytics argument passed to callbacks.
    const { patchedEventProps: patchedEventProps } = (0, $bPBcn.usePatchedProps)($1b57c88557e5831b$var$mentionEventMap, props);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9jOz9.MentionInternal), {
        ...props,
        ...patchedEventProps,
        createAnalyticsEvent: createAnalyticsEvent,
        ref: ref
    });
});
$1b57c88557e5831b$var$Mention.displayName = 'Mention';
var $1b57c88557e5831b$export$2e2bcd8739ae039 = $1b57c88557e5831b$var$Mention;
module.exports["ANALYTICS_HOVER_DELAY"] = $1b57c88557e5831b$export$7452d7062a4d0634;
module.exports["default"] = $1b57c88557e5831b$export$2e2bcd8739ae039;

});

parcelRegister("kpMMm", function(module, exports) {

var $852mP = parcelRequire("852mP");


var $4cczm = parcelRequire("4cczm");


var $vF2ex = parcelRequire("vF2ex");


var $caelp = parcelRequire("caelp");


var $4B8nE = parcelRequire("4B8nE");


var $iu9yU = parcelRequire("iu9yU");

const $e585dda4db4ca4b7$export$44902bc7b3f0b09f = (createEvent)=>(actionSubject, action, text, id, accessLevel)=>{
        const payload = {
            action: action,
            actionSubject: actionSubject,
            eventType: (0, $852mP.UI_EVENT_TYPE),
            attributes: {
                packageName: $4B8nE.packageName,
                packageVersion: $iu9yU.packageVersion,
                componentName: (0, $caelp.ComponentNames).MENTION,
                accessLevel: accessLevel,
                isSpecial: (0, $vF2ex.isSpecialMentionText)(text),
                userId: id
            }
        };
        const event = createEvent(payload);
        event.fire((0, $4cczm.ELEMENTS_CHANNEL));
        return event;
    };
module.exports["fireAnalyticsMentionEvent"] = $e585dda4db4ca4b7$export$44902bc7b3f0b09f;

});

parcelRegister("4cczm", function(module, exports) {
const $577b7b0c5e75a3c1$export$d821aa4c8afb384e = 'fabric-elements';
const $577b7b0c5e75a3c1$export$af8124aa496797f2 = '_|unknown|_';
module.exports["ELEMENTS_CHANNEL"] = $577b7b0c5e75a3c1$export$d821aa4c8afb384e;
module.exports["UNKNOWN_USER_ID"] = $577b7b0c5e75a3c1$export$af8124aa496797f2;

});

parcelRegister("vF2ex", function(module, exports) {
function $e97fcd08477c8114$export$d13d4f976b36a397(mentionText) {
    return mentionText && (mentionText === '@all' || mentionText === '@here');
}
module.exports["isSpecialMentionText"] = $e97fcd08477c8114$export$d13d4f976b36a397;

});

parcelRegister("caelp", function(module, exports) {
const $c573a2458006a7eb$export$43bc8ec87115a7b3 = '__agent-mentions-load-error__';
var $c573a2458006a7eb$export$2102863a3c660c6b = /*#__PURE__*/ function(MentionType) {
    MentionType[MentionType["SELF"] = 0] = "SELF";
    MentionType[MentionType["RESTRICTED"] = 1] = "RESTRICTED";
    MentionType[MentionType["DEFAULT"] = 2] = "DEFAULT";
    MentionType[MentionType["DISABLED"] = 3] = "DISABLED";
    return MentionType;
}({});
var $c573a2458006a7eb$export$81124e6148ca5db0 = /*#__PURE__*/ function(UserAccessLevel) {
    UserAccessLevel[UserAccessLevel["NONE"] = 0] = "NONE";
    UserAccessLevel[UserAccessLevel["SITE"] = 1] = "SITE";
    UserAccessLevel[UserAccessLevel["APPLICATION"] = 2] = "APPLICATION";
    UserAccessLevel[UserAccessLevel["CONTAINER"] = 3] = "CONTAINER";
    return UserAccessLevel;
}({});
var $c573a2458006a7eb$export$8436e53e45ffe15b = /*#__PURE__*/ function(UserType) {
    UserType[UserType["DEFAULT"] = 0] = "DEFAULT";
    UserType[UserType["SPECIAL"] = 1] = "SPECIAL";
    UserType[UserType["APP"] = 2] = "APP";
    UserType[UserType["TEAM"] = 3] = "TEAM";
    UserType[UserType["SYSTEM"] = 4] = "SYSTEM";
    return UserType;
}({});
var $c573a2458006a7eb$export$7afb0727c7d7e8af = /*#__PURE__*/ function(SliNames) {
    SliNames["SEARCH"] = "searchUser";
    SliNames["SEARCH_TEAM"] = "searchTeam";
    SliNames["INITIAL_STATE"] = "initialState";
    SliNames["SELECT"] = "select";
    SliNames["SELECT_TEAM"] = "selectTeam";
    return SliNames;
}({});
var $c573a2458006a7eb$export$5c42d9dea6d035c1 = /*#__PURE__*/ function(ComponentNames) {
    ComponentNames["TYPEAHEAD"] = "mentionTypeahead";
    ComponentNames["MENTION"] = "mention";
    return ComponentNames;
}({});
var $c573a2458006a7eb$export$b52183d5cfb26dc9 = /*#__PURE__*/ function(Actions) {
    Actions["VIEWED"] = "viewed";
    Actions["CLICKED"] = "clicked";
    Actions["CLOSED"] = "closed";
    Actions["SUCCEEDED"] = "succeeded";
    Actions["FAILED"] = "failed";
    return Actions;
}({});
var $c573a2458006a7eb$export$b8fa67dc54502853 = /*#__PURE__*/ function(MentionNameStatus) {
    MentionNameStatus[MentionNameStatus["UNKNOWN"] = 0] = "UNKNOWN";
    MentionNameStatus[MentionNameStatus["SERVICE_ERROR"] = 1] = "SERVICE_ERROR";
    MentionNameStatus[MentionNameStatus["OK"] = 2] = "OK";
    return MentionNameStatus;
}({});
module.exports["AGENT_MENTION_LOAD_ERROR_ID"] = $c573a2458006a7eb$export$43bc8ec87115a7b3;
module.exports["MentionType"] = $c573a2458006a7eb$export$2102863a3c660c6b;
module.exports["UserAccessLevel"] = $c573a2458006a7eb$export$81124e6148ca5db0;
module.exports["UserType"] = $c573a2458006a7eb$export$8436e53e45ffe15b;
module.exports["SliNames"] = $c573a2458006a7eb$export$7afb0727c7d7e8af;
module.exports["ComponentNames"] = $c573a2458006a7eb$export$5c42d9dea6d035c1;
module.exports["Actions"] = $c573a2458006a7eb$export$b52183d5cfb26dc9;
module.exports["MentionNameStatus"] = $c573a2458006a7eb$export$b8fa67dc54502853;

});

parcelRegister("4B8nE", function(module, exports) {
const $d00b5c54493e40b2$export$9345d7360ffe0722 = "platform-pkg";
module.exports["packageName"] = $d00b5c54493e40b2$export$9345d7360ffe0722;

});

parcelRegister("iu9yU", function(module, exports) {
const $d5e04dfa126c7e5e$export$91546b032799aa40 = "0.0.0-use.local";
module.exports["packageVersion"] = $d5e04dfa126c7e5e$export$91546b032799aa40;

});

parcelRegister("9jOz9", function(module, exports) {
/* MentionInternal.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $8aG6j = parcelRequire("8aG6j");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $b1FLc = parcelRequire("b1FLc");


var $4o0zT = parcelRequire("4o0zT");


var $iDrrr = parcelRequire("iDrrr");


var $j7Sza = parcelRequire("j7Sza");


var $4cczm = parcelRequire("4cczm");


var $8auAj = parcelRequire("8auAj");


var $caelp = parcelRequire("caelp");


var $j1Rvl = parcelRequire("j1Rvl");


var $gcaru = parcelRequire("gcaru");


var $21cx5 = parcelRequire("21cx5");


var $iD1Wv = parcelRequire("iD1Wv");


var $12QCz = parcelRequire("12QCz");


var $cK6Td = parcelRequire("cK6Td");


var $27ALb = parcelRequire("27ALb");

function $23dc050c3f4ddea0$var$_defineProperty(e, r, t) {
    return (r = $23dc050c3f4ddea0$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $23dc050c3f4ddea0$var$_toPropertyKey(t) {
    var i = $23dc050c3f4ddea0$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $23dc050c3f4ddea0$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $23dc050c3f4ddea0$var$avatarStyles = null;
const $23dc050c3f4ddea0$var$avatarFallbackStyles = null;
const $23dc050c3f4ddea0$var$avatarImageStyles = null;
const $23dc050c3f4ddea0$var$agentAvatarStyles = null;
const $23dc050c3f4ddea0$var$fixedAgentAvatarStyles = null;
class $23dc050c3f4ddea0$export$92ab8442e7a15cef extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).PureComponent {
    componentDidMount() {
        (0, $27ALb.mentionRenderedUfoExperience).getInstance(this.props.id).success();
        this.reportCompletedAvatarFailure();
    }
    componentDidUpdate(previousProps) {
        if (previousProps.avatarUrl !== this.props.avatarUrl || previousProps.id !== this.props.id || previousProps.renderAvatarSlot !== this.props.renderAvatarSlot || previousProps.text === `@${0, $4cczm.UNKNOWN_USER_ID}` !== (this.props.text === `@${0, $4cczm.UNKNOWN_USER_ID}`)) this.avatarFailureReported = false;
        this.reportCompletedAvatarFailure();
    }
    static getDerivedStateFromProps(props, state) {
        if (props.avatarUrl !== state.avatarUrl) return {
            avatarUrl: props.avatarUrl,
            hasAvatarError: false
        };
        return null;
    }
    componentWillUnmount() {
        if (this.hoverTimeout) clearTimeout(this.hoverTimeout);
        const ufoInstance = (0, $27ALb.mentionRenderedUfoExperience).getInstance(this.props.id);
        if ([
            (0, $j7Sza.UFOExperienceState)['STARTED'],
            (0, $j7Sza.UFOExperienceState)['IN_PROGRESS']
        ].includes(ufoInstance.state)) ufoInstance.abort();
    }
    renderUnknownUserError(id) {
        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $j1Rvl.UnknownUserError), {
            values: {
                userId: id.slice(-5)
            },
            children: (message)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
                    children: `@${message}`
                })
        });
    }
    render() {
        const { handleAvatarError: handleAvatarError, handleOnClick: handleOnClick, handleOnMouseEnter: handleOnMouseEnter, handleOnMouseLeave: handleOnMouseLeave, props: props } = this;
        const { appType: appType, avatarUrl: avatarUrl, text: text, id: id, accessLevel: accessLevel, localId: localId, disabledTooltip: disabledTooltip, isAvatarImagePreShaped: isAvatarImagePreShaped, renderAvatarSlot: renderAvatarSlot, isRovoChat: isRovoChat } = props;
        const mentionType = this.getMentionType();
        const failedMention = text === `@${0, $4cczm.UNKNOWN_USER_ID}`;
        const showAvatarSlot = Boolean(renderAvatarSlot) && !failedMention;
        const visibleText = showAvatarSlot && text.startsWith('@') ? text.slice(1) : text;
        const shouldApplyAgentShape = appType === 'agent' && !isAvatarImagePreShaped;
        const shouldApplyFixedAgentShape = shouldApplyAgentShape && (0, $4o0zT.isExperimentEnabled)('platform_editor_agent_hexagon_ui_fix');
        const shouldRenderAvatar = avatarUrl && !this.state.hasAvatarError;
        const showRestrictedTooltip = mentionType === (0, $caelp.MentionType).RESTRICTED;
        const showDisabledTooltip = mentionType === (0, $caelp.MentionType).DISABLED && !!disabledTooltip; // A11y: when the chip is in the disabled visual state, expose
        // `aria-disabled` so assistive tech announces it as such. The
        // disabled-tooltip text is mirrored into `aria-label` so the
        // announcement carries the reason even without portal-id wiring for
        // `aria-describedby`.
        const isDisabledChip = mentionType === (0, $caelp.MentionType).DISABLED;
        const disabledA11yProps = isDisabledChip ? {
            'aria-disabled': true,
            tabIndex: 0,
            ...disabledTooltip ? {
                'aria-label': `${text || '@...'} \u{2014} ${disabledTooltip}`
            } : {}
        } : {};
        const mentionComponent = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $b1FLc.default), {
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cK6Td.default), {
                isAvatarVisible: showAvatarSlot,
                mentionType: mentionType,
                onClick: handleOnClick,
                onMouseEnter: handleOnMouseEnter,
                onMouseLeave: handleOnMouseLeave,
                spellCheck: false,
                "data-testid": `mention-${id}`,
                "data-mention-type": mentionType,
                "data-mention-tooltip": showRestrictedTooltip || showDisabledTooltip,
                isRovoChat: isRovoChat,
                ...disabledA11yProps,
                children: failedMention ? this.renderUnknownUserError(id) : showAvatarSlot ? /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8aG6j.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                            "aria-hidden": "true",
                            "data-testid": "mention-avatar-slot",
                            className: (0, $hekY6.default)([
                                "_4bt5LAnQyn _2WAcuGnQyn _0bjKvDS5Zs _3iDTPbccYA _39xV02R4Xu _0jFU0VR4Xu _0hPCNLDIqT _37wbyuDIqT _3YEZNOdnbC _2xTnZx1Y8M _1RrJLiVdJo",
                                shouldApplyAgentShape && "_0bjKvDdnbC _1uo2ZfnV0Y",
                                shouldApplyFixedAgentShape && "_1uo2ZfTcEg",
                                this.state.hasAvatarError && "_1RrJLixiOt"
                            ]),
                            children: shouldRenderAvatar ? /*#__PURE__*/ (0, $8aG6j.jsx)("img", {
                                alt: "",
                                ref: this.avatarImageRef,
                                decoding: "async",
                                draggable: false,
                                height: 16,
                                loading: "lazy",
                                onError: handleAvatarError,
                                src: avatarUrl,
                                "data-testid": "mention-avatar",
                                width: 16,
                                className: (0, $hekY6.default)([
                                    "_3iDTPbvLZJ _39xV02N91d _0jFU0VN91d _00EA0eiObl"
                                ])
                            }) : this.state.hasAvatarError ? '@' : null
                        }),
                        /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                            children: visibleText || '...'
                        })
                    ]
                }) : text || '@...'
            })
        });
        const ssrPlaceholderProp = props.ssrPlaceholderId ? {
            'data-ssr-placeholder': props.ssrPlaceholderId
        } : {};
        const wrappedMention = (()=>{
            if (showRestrictedTooltip) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Suspense, {
                fallback: mentionComponent,
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iD1Wv.default), {
                    name: text,
                    children: mentionComponent
                })
            });
            if (showDisabledTooltip) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Suspense, {
                fallback: mentionComponent,
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gcaru.default), {
                    tooltip: disabledTooltip,
                    children: mentionComponent
                })
            });
            return mentionComponent;
        })();
        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $27ALb.UfoErrorBoundary), {
            id: id,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                id: localId,
                "data-mention-id": id,
                "data-local-id": localId,
                "data-access-level": accessLevel,
                spellCheck: false,
                ...ssrPlaceholderProp,
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $21cx5.default), {
                    children: wrappedMention
                })
            })
        });
    }
    constructor(props){
        super(props);
        $23dc050c3f4ddea0$var$_defineProperty(this, "hoverTimeout", void 0);
        $23dc050c3f4ddea0$var$_defineProperty(this, "avatarFailureReported", false);
        $23dc050c3f4ddea0$var$_defineProperty(this, "avatarImageRef", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createRef());
        $23dc050c3f4ddea0$var$_defineProperty(this, "state", {
            hasAvatarError: false
        });
        $23dc050c3f4ddea0$var$_defineProperty(this, "reportCompletedAvatarFailure", ()=>{
            const image = this.avatarImageRef.current;
            if (image && (0, $iDrrr.fg)('platform_editor_mention_avatar_observability') && image.complete && image.getAttribute('src')) {
                if (image.naturalWidth === 0 && !this.state.hasAvatarError) this.reportAvatarFailure();
            }
        });
        $23dc050c3f4ddea0$var$_defineProperty(this, "reportAvatarFailure", ()=>{
            if (!(0, $iDrrr.fg)('platform_editor_mention_avatar_observability') || this.avatarFailureReported) return;
            this.avatarFailureReported = true;
            this.props.createAnalyticsEvent?.({
                action: 'failed',
                actionSubject: 'mentionAvatar',
                eventType: 'operational',
                attributes: {
                    componentName: 'mention',
                    reason: 'image_load_failed',
                    surface: 'renderer'
                }
            })?.fire((0, $4cczm.ELEMENTS_CHANNEL));
        });
        $23dc050c3f4ddea0$var$_defineProperty(this, "handleAvatarError", ()=>{
            this.reportAvatarFailure();
            this.setState({
                hasAvatarError: true
            });
        });
        $23dc050c3f4ddea0$var$_defineProperty(this, "handleOnClick", (e)=>{
            const { id: id, text: text, onClick: onClick, isDisabled: isDisabled } = this.props;
            if (isDisabled) // Disabled chips do not invoke their click handler.
            return;
            if (onClick) onClick(id, text, e);
        });
        $23dc050c3f4ddea0$var$_defineProperty(this, "handleOnMouseEnter", (e)=>{
            const { id: id, text: text, onMouseEnter: onMouseEnter, onHover: onHover } = this.props;
            if (onMouseEnter) onMouseEnter(id, text, e);
            this.hoverTimeout = window.setTimeout(()=>{
                if (onHover) onHover();
                this.hoverTimeout = undefined;
            }, (0, $12QCz.ANALYTICS_HOVER_DELAY));
        });
        $23dc050c3f4ddea0$var$_defineProperty(this, "handleOnMouseLeave", (e)=>{
            const { id: id, text: text, onMouseLeave: onMouseLeave } = this.props;
            if (onMouseLeave) onMouseLeave(id, text, e);
            if (this.hoverTimeout) clearTimeout(this.hoverTimeout);
        });
        $23dc050c3f4ddea0$var$_defineProperty(this, "getMentionType", ()=>{
            const { accessLevel: accessLevel, isHighlighted: isHighlighted, isDisabled: isDisabled } = this.props;
            if (isDisabled) return (0, $caelp.MentionType).DISABLED;
            if (isHighlighted) return (0, $caelp.MentionType).SELF;
            if ((0, $8auAj.isRestricted)(accessLevel)) return (0, $caelp.MentionType).RESTRICTED;
            return (0, $caelp.MentionType).DEFAULT;
        });
        (0, $27ALb.mentionRenderedUfoExperience).getInstance(props.id).start();
    }
}
module.exports["MentionInternal"] = $23dc050c3f4ddea0$export$92ab8442e7a15cef;

});

parcelRegister("8auAj", function(module, exports) {

var $caelp = parcelRequire("caelp");

function $34b824decffaa688$export$dbaa15dc1820b89a(accessLevel) {
    return !!accessLevel && accessLevel === (0, $caelp.UserAccessLevel)[(0, $caelp.UserAccessLevel).NONE];
}
module.exports["isRestricted"] = $34b824decffaa688$export$dbaa15dc1820b89a;

});

parcelRegister("j1Rvl", function(module, exports) {
parcelRequire("cozmU");


var $92AHJ = parcelRequire("92AHJ");


var $7n3BL = parcelRequire("7n3BL");

const $878ccfcc8552aaa6$export$98e06fe7a6174253 = (0, $7n3BL.propFormatter)((0, $92AHJ.messages).unknownUserError);
const $878ccfcc8552aaa6$export$58bd5a2057b6b855 = (0, $7n3BL.propFormatter)((0, $92AHJ.messages).noAccessWarning);
const $878ccfcc8552aaa6$export$da9f8ce14593162f = (0, $7n3BL.propFormatter)((0, $92AHJ.messages).noAccessLabel);
const $878ccfcc8552aaa6$export$4a258ffee7316766 = (0, $7n3BL.propFormatter)((0, $92AHJ.messages).defaultHeadline);
const $878ccfcc8552aaa6$export$702321a50d74536e = (0, $7n3BL.propFormatter)((0, $92AHJ.messages).defaultAdvisedAction);
const $878ccfcc8552aaa6$export$ed7f16088a93ae9d = (0, $7n3BL.propFormatter)((0, $92AHJ.messages).loginAgain);
const $878ccfcc8552aaa6$export$3ab158df56460d1c = (0, $7n3BL.propFormatter)((0, $92AHJ.messages).differentText);
module.exports["UnknownUserError"] = $878ccfcc8552aaa6$export$98e06fe7a6174253;
module.exports["NoAccessWarning"] = $878ccfcc8552aaa6$export$58bd5a2057b6b855;
module.exports["NoAccessLabel"] = $878ccfcc8552aaa6$export$da9f8ce14593162f;
module.exports["DefaultHeadline"] = $878ccfcc8552aaa6$export$4a258ffee7316766;
module.exports["DefaultAdvisedAction"] = $878ccfcc8552aaa6$export$702321a50d74536e;
module.exports["LoginAgain"] = $878ccfcc8552aaa6$export$ed7f16088a93ae9d;
module.exports["DifferentText"] = $878ccfcc8552aaa6$export$3ab158df56460d1c;

});

parcelRegister("92AHJ", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $fb7b952708721b37$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    unknownUserError: {
        id: "fabric.mention.unknow.user.error",
        defaultMessage: "Unknown user {userId}"
    },
    noAccessWarning: {
        id: "fabric.mention.noAccess.warning",
        defaultMessage: "{name} won't be notified as they have no access"
    },
    noAccessLabel: {
        id: "fabric.mention.noAccess.label",
        defaultMessage: "No access"
    },
    defaultHeadline: {
        id: "fabric.mention.error.defaultHeadline",
        defaultMessage: "Something went wrong"
    },
    defaultAdvisedAction: {
        id: "fabric.mention.error.defaultAction",
        defaultMessage: "Try again in a few seconds"
    },
    loginAgain: {
        id: "fabric.mention.error.loginAgain",
        defaultMessage: "Try logging out then in again"
    },
    differentText: {
        id: "fabric.mention.error.differentText",
        defaultMessage: "Try entering different text"
    },
    memberCountWithoutYou: {
        id: "fabric.elements.mentions.team.member.count",
        defaultMessage: "Team \u2022 {0, plural, one {1 member} other {{0} members}}"
    },
    memberCountWithYou: {
        id: "fabric.elements.mentions.team.member.count.including.you",
        defaultMessage: "Team \u2022 {0, plural, one {1 member} other {{0} members}}, including you"
    },
    plus50MembersWithoutYou: {
        id: "fabric.elements.mentions.team.member.50plus",
        defaultMessage: "Team \u2022 50+ members"
    },
    plus50MembersWithYou: {
        id: "fabric.elements.mentions.team.member.50plus.including.you",
        defaultMessage: "Team \u2022 50+ members, including you"
    },
    xProductMentionDescription: {
        id: "fabric.elements.mentions.xproduct.mention.description",
        defaultMessage: "Needs access to Confluence"
    },
    loadingPlaceholder: {
        id: "fabric.elements.mentions.loading.placeholder",
        defaultMessage: "Loading"
    }
});
module.exports["messages"] = $fb7b952708721b37$export$defe85febe8b728c;

});

parcelRegister("7n3BL", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");

const $bb06cdc27dbcd8cb$export$392a0c6a82ab0e50 = (messageDescriptor)=>({ values: values, children: children })=>{
        const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
        const message = formatMessage(messageDescriptor, values);
        if (typeof children === 'function') return children(message);
        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
            values: values,
            ...messageDescriptor
        });
    };
module.exports["propFormatter"] = $bb06cdc27dbcd8cb$export$392a0c6a82ab0e50;

});

parcelRegister("gcaru", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $ipkS0 = parcelRequire("ipkS0");


const $139bcf7839d1a883$var$AsyncDisabledMentionTooltip = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).lazy((0, $ipkS0.trackReactLazy)("rl-AZOIL4", ()=>(parcelRequire("2GsKr")).then((module)=>{
        return {
            default: module.DisabledMentionTooltip
        };
    })));
var $139bcf7839d1a883$export$2e2bcd8739ae039 = $139bcf7839d1a883$var$AsyncDisabledMentionTooltip;
module.exports["default"] = $139bcf7839d1a883$export$2e2bcd8739ae039;

});

parcelRegister("ipkS0", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6mKj3 = parcelRequire("6mKj3");


var $7W8i8 = parcelRequire("7W8i8");


var $3GQl6 = parcelRequire("3GQl6");

const $689b0be44fd5c2f8$var$logger = (0, $7W8i8.getLogger)('trackReactLazy');
// Marks a subtree whose code only loads when a render-time lazy component renders. The client
// cannot load it before hydration, so lazy components inside it must not hold hydration.
const $689b0be44fd5c2f8$var$RenderTimeLazyAncestor = /*#__PURE__*/ (0, $cozmU.createContext)(false);
const $689b0be44fd5c2f8$var$warnedRenderTimeIds = new Set();
// React 18's lazy initializer checks the component's status as soon as `then` returns, and suspends
// unless `then` has already called back. `Promise.resolve(loaded)` always calls back in a
// microtask, so it would suspend even for a loaded module. This Promise overrides `then` to call
// back synchronously. The rest of the Promise API goes through `then`, so `catch`, `finally` and
// `Promise.all` still work.
const $689b0be44fd5c2f8$var$resolvedThenable = (value)=>{
    const promise = new Promise((resolve)=>resolve(value));
    promise.then = (onFulfilled)=>Promise.resolve(onFulfilled ? onFulfilled(value) : value);
    return promise;
};
function $689b0be44fd5c2f8$var$withServerTracking(id, module, { renderTime: renderTime, source: source }) {
    const Original = module.default;
    const TrackedLazy = /*#__PURE__*/ (0, $cozmU.forwardRef)((props, ref)=>{
        const hasRenderTimeAncestor = (0, $cozmU.useContext)($689b0be44fd5c2f8$var$RenderTimeLazyAncestor);
        const element = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Original, {
            ...props,
            ref: ref
        });
        if (renderTime) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($689b0be44fd5c2f8$var$RenderTimeLazyAncestor.Provider, {
            value: true
        }, element);
        // Effects do not run during SSR, so render is the only place to record the rendered split.
        if (!hasRenderTimeAncestor && (0, $6mKj3.expValEquals)('confluence_ssr_react_lazy_preload', 'isEnabled', true)) (0, $3GQl6.addLoadableId)(id);
        return element;
    });
    TrackedLazy.displayName = `TrackedLazy(${Original.displayName || Original.name || 'Component'})`;
    return {
        ...module,
        default: TrackedLazy
    };
}
function $689b0be44fd5c2f8$export$fb5c897fe5d03fec(id, loader, options = {}) {
    // process.env.REACT_SSR is read inline so each build can drop the other side's branch. None of
    // these branches changes rendered markup, so they cannot cause a hydration mismatch.
    const prepare = (module)=>module;
    if (options.renderTime) // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    return loader;
    let loaded;
    let pending;
    const load = ()=>{
        pending ?? (pending = loader().then((module)=>{
            loaded = prepare(module);
            return loaded;
        }, (error)=>{
            pending = undefined;
            throw error;
        }));
        return pending;
    };
    let preloaded = false;
    // preloadIfNeeded can start loading at once. Waiting a microtask lets the defining module
    // finish evaluating before the loader reads any of its bindings.
    (0, $3GQl6.preloadIfNeeded)(id, undefined, ()=>Promise.resolve().then(load).then(()=>{
            preloaded = true;
        }));
    return ()=>{
        if (!loaded) return load();
        // The client only answers synchronously after the preload the server asked for, so lazy
        // components behave as before when the experiment is off.
        const canResolveSynchronously = preloaded;
        return canResolveSynchronously ? $689b0be44fd5c2f8$var$resolvedThenable(loaded) : load();
    };
}
module.exports["trackReactLazy"] = $689b0be44fd5c2f8$export$fb5c897fe5d03fec;

});

parcelRegister("2GsKr", function(module, exports) {

let $1f45cdcc4b463c3d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1f45cdcc4b463c3d$var$load("5bU1Y").then(()=>parcelRequire('eZafG'));

});

parcelRegister("21cx5", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $hI76F = parcelRequire("hI76F");

const $f497c875f65a609f$var$EMPTY = {};
const $f497c875f65a609f$var$useI18n = (0, $gtMdU.isReactCompilerActivePlatform)() ? (locale)=>{
    const $ = (0, $bDgLe.c)(3);
    const [messages, setMessages] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState($f497c875f65a609f$var$EMPTY);
    let t0;
    let t1;
    if ($[0] !== locale) {
        t0 = ()=>{
            let aborted = false;
            setMessages($f497c875f65a609f$var$EMPTY);
            (0, $hI76F.getMessagesForLocale)(locale).then((messages_0)=>{
                if (!aborted) setMessages(messages_0);
            }).catch($f497c875f65a609f$var$_temp);
            return ()=>{
                aborted = true;
            };
        };
        t1 = [
            locale
        ];
        $[0] = locale;
        $[1] = t0;
        $[2] = t1;
    } else {
        t0 = $[1];
        t1 = $[2];
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(t0, t1);
    return messages;
} : (locale)=>{
    const [messages, setMessages] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState($f497c875f65a609f$var$EMPTY);
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(()=>{
        let aborted = false;
        setMessages($f497c875f65a609f$var$EMPTY);
        (0, $hI76F.getMessagesForLocale)(locale).then((messages_0)=>{
            if (!aborted) setMessages(messages_0);
        }).catch((error)=>{
            // eslint-disable-next-line no-console
            console.error(error);
        });
        return ()=>{
            aborted = true;
        };
    }, [
        locale
    ]);
    return messages;
};
const $f497c875f65a609f$var$MessagesIntlProvider = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(4);
    const { children: children } = props;
    const intl = (0, $kSwu1.useIntl)();
    const messages = $f497c875f65a609f$var$useI18n(intl.locale);
    let t0;
    if ($[0] !== children || $[1] !== intl || $[2] !== messages) {
        t0 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.IntlProvider), {
            ...intl,
            messages: messages,
            children: children
        });
        $[0] = children;
        $[1] = intl;
        $[2] = messages;
        $[3] = t0;
    } else t0 = $[3];
    return t0;
} : (props)=>{
    const { children: children } = props;
    const intl = (0, $kSwu1.useIntl)();
    const messages = $f497c875f65a609f$var$useI18n(intl.locale);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.IntlProvider), {
        ...intl,
        messages: messages,
        children: children
    });
};
var $f497c875f65a609f$export$2e2bcd8739ae039 = $f497c875f65a609f$var$MessagesIntlProvider;
function $f497c875f65a609f$var$_temp(error) {
    console.error(error);
}
module.exports["default"] = $f497c875f65a609f$export$2e2bcd8739ae039;

});

parcelRegister("hI76F", function(module, exports) {
/**
 * Tries to get the most specific messages bundle for a given locale.
 *
 * Strategy:
 * 1. Try to find messages with the exact string (i.e. 'fr_FR')
 * 2. If that doesn't work, try to find messages for the country locale (i.e. 'fr')
 * 3. If that doesn't work, return english messages as a fallback.
 *
 * @param locale string specifying the locale like 'en_GB', or 'fr'.
 */ 






























const $27fa02be5ce1169a$export$d0a3169680473b6c = async (locale)=>{
    switch(locale){
        case 'cs':
            return (parcelRequire("iIInt")).then((mod)=>mod.default);
        case 'da':
            return (parcelRequire("9Mtn5")).then((mod)=>mod.default);
        case 'de':
            return (parcelRequire("b6QCc")).then((mod)=>mod.default);
        case 'en':
            return (parcelRequire("iaMmn")).then((mod)=>mod.default);
        case 'en_GB':
            return (parcelRequire("aR0Aq")).then((mod)=>mod.default);
        case 'en_ZZ':
            return (parcelRequire("1nLLM")).then((mod)=>mod.default);
        case 'es':
            return (parcelRequire("gIoNC")).then((mod)=>mod.default);
        case 'et':
            return (parcelRequire("ijMmr")).then((mod)=>mod.default);
        case 'fi':
            return (parcelRequire("5os67")).then((mod)=>mod.default);
        case 'fr':
            return (parcelRequire("iR75H")).then((mod)=>mod.default);
        case 'hu':
            return (parcelRequire("48Uqm")).then((mod)=>mod.default);
        case 'is':
            return (parcelRequire("1lX2v")).then((mod)=>mod.default);
        case 'it':
            return (parcelRequire("ftnXB")).then((mod)=>mod.default);
        case 'ja':
            return (parcelRequire("9VGie")).then((mod)=>mod.default);
        case 'ko':
            return (parcelRequire("eyPNi")).then((mod)=>mod.default);
        case 'nb':
            return (parcelRequire("azEgN")).then((mod)=>mod.default);
        case 'nl':
            return (parcelRequire("lJywU")).then((mod)=>mod.default);
        case 'pl':
            return (parcelRequire("lUEen")).then((mod)=>mod.default);
        case 'pt_BR':
        case 'pt-BR':
            return (parcelRequire("iGXxf")).then((mod)=>mod.default);
        case 'pt_PT':
        case 'pt-PT':
            return (parcelRequire("6paIk")).then((mod)=>mod.default);
        case 'ro':
            return (parcelRequire("8Ul7q")).then((mod)=>mod.default);
        case 'ru':
            return (parcelRequire("1PKS6")).then((mod)=>mod.default);
        case 'sk':
            return (parcelRequire("cx1wp")).then((mod)=>mod.default);
        case 'sv':
            return (parcelRequire("d70Xw")).then((mod)=>mod.default);
        case 'th':
            return (parcelRequire("bMkyl")).then((mod)=>mod.default);
        case 'tr':
            return (parcelRequire("dLPG4")).then((mod)=>mod.default);
        case 'uk':
            return (parcelRequire("486Xk")).then((mod)=>mod.default);
        case 'vi':
            return (parcelRequire("6bLNM")).then((mod)=>mod.default);
        case 'zh_TW':
            return (parcelRequire("dK87a")).then((mod)=>mod.default);
        case 'zh':
            return (parcelRequire("iPSN9")).then((mod)=>mod.default);
        default:
            {
                const fragments = locale.split(/[_-]/);
                if (fragments.length === 2) return $27fa02be5ce1169a$export$d0a3169680473b6c(fragments[0]);
                else return (parcelRequire("iaMmn")).then((mod)=>mod.default);
            }
    }
};
module.exports["getMessagesForLocale"] = $27fa02be5ce1169a$export$d0a3169680473b6c;

});

parcelRegister("iIInt", function(module, exports) {

let $da0ec283dd2ece93$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $da0ec283dd2ece93$var$load("1JYrd"),
    $da0ec283dd2ece93$var$load("cip6w"),
    $da0ec283dd2ece93$var$load("gAG2n"),
    $da0ec283dd2ece93$var$load("3feYV"),
    $da0ec283dd2ece93$var$load("cwjU2"),
    $da0ec283dd2ece93$var$load("7rL7C"),
    $da0ec283dd2ece93$var$load("3Ff1R"),
    $da0ec283dd2ece93$var$load("423Ga")
]).then(()=>parcelRequire('aIUTc'));

});

parcelRegister("9Mtn5", function(module, exports) {

let $71ef614ff6d71b72$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $71ef614ff6d71b72$var$load("30242"),
    $71ef614ff6d71b72$var$load("3qBwQ"),
    $71ef614ff6d71b72$var$load("cYGDU"),
    $71ef614ff6d71b72$var$load("7Q1SM"),
    $71ef614ff6d71b72$var$load("33Iaa"),
    $71ef614ff6d71b72$var$load("1RSxn"),
    $71ef614ff6d71b72$var$load("blA7x"),
    $71ef614ff6d71b72$var$load("gJroP")
]).then(()=>parcelRequire('aK3gp'));

});

parcelRegister("b6QCc", function(module, exports) {

let $8169118091a4ee75$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $8169118091a4ee75$var$load("15aAJ"),
    $8169118091a4ee75$var$load("8rREG"),
    $8169118091a4ee75$var$load("dgXJL"),
    $8169118091a4ee75$var$load("7JdzX"),
    $8169118091a4ee75$var$load("6681T"),
    $8169118091a4ee75$var$load("ghT31"),
    $8169118091a4ee75$var$load("3dn3H"),
    $8169118091a4ee75$var$load("cYXvt")
]).then(()=>parcelRequire('d43Vk'));

});

parcelRegister("iaMmn", function(module, exports) {

let $d3aeac6f44441a4b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $d3aeac6f44441a4b$var$load("7I4uK"),
    $d3aeac6f44441a4b$var$load("hUbK8")
]).then(()=>parcelRequire('6BJ6x'));

});

parcelRegister("aR0Aq", function(module, exports) {

let $7e6f4f1622f23b5b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $7e6f4f1622f23b5b$var$load("l5BBd"),
    $7e6f4f1622f23b5b$var$load("93ASN"),
    $7e6f4f1622f23b5b$var$load("htu5t"),
    $7e6f4f1622f23b5b$var$load("24LNf"),
    $7e6f4f1622f23b5b$var$load("lM2G0"),
    $7e6f4f1622f23b5b$var$load("iYQCc"),
    $7e6f4f1622f23b5b$var$load("nBJth")
]).then(()=>parcelRequire('9BUhf'));

});

parcelRegister("1nLLM", function(module, exports) {

let $101cfe7dbd81b445$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $101cfe7dbd81b445$var$load("bbv9t"),
    $101cfe7dbd81b445$var$load("9fQoJ"),
    $101cfe7dbd81b445$var$load("lTboH"),
    $101cfe7dbd81b445$var$load("cnlNg"),
    $101cfe7dbd81b445$var$load("d3Phe"),
    $101cfe7dbd81b445$var$load("lTP5S"),
    $101cfe7dbd81b445$var$load("lASLx"),
    $101cfe7dbd81b445$var$load("bIXgz")
]).then(()=>parcelRequire('3u3mj'));

});

parcelRegister("gIoNC", function(module, exports) {

let $c2b3fe01651665c0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $c2b3fe01651665c0$var$load("7p4je"),
    $c2b3fe01651665c0$var$load("8SZbD"),
    $c2b3fe01651665c0$var$load("iE05k"),
    $c2b3fe01651665c0$var$load("9Uf61"),
    $c2b3fe01651665c0$var$load("3Yk1e"),
    $c2b3fe01651665c0$var$load("jZqyp"),
    $c2b3fe01651665c0$var$load("5lJyy"),
    $c2b3fe01651665c0$var$load("9w9df")
]).then(()=>parcelRequire('dWF5g'));

});

parcelRegister("ijMmr", function(module, exports) {

let $d55f83d4930a3a37$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $d55f83d4930a3a37$var$load("5ZQnr"),
    $d55f83d4930a3a37$var$load("lJyww"),
    $d55f83d4930a3a37$var$load("2hqQb"),
    $d55f83d4930a3a37$var$load("8RVFi")
]).then(()=>parcelRequire('33aAd'));

});

parcelRegister("5os67", function(module, exports) {

let $3ed4fd41cff57fd5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $3ed4fd41cff57fd5$var$load("1jQRQ"),
    $3ed4fd41cff57fd5$var$load("5pOQA"),
    $3ed4fd41cff57fd5$var$load("5GSny"),
    $3ed4fd41cff57fd5$var$load("fJSEb"),
    $3ed4fd41cff57fd5$var$load("ajzkj"),
    $3ed4fd41cff57fd5$var$load("kIcDP"),
    $3ed4fd41cff57fd5$var$load("eyysG"),
    $3ed4fd41cff57fd5$var$load("27gvR")
]).then(()=>parcelRequire('hDeI8'));

});

parcelRegister("iR75H", function(module, exports) {

let $dba2ad51795d67a0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $dba2ad51795d67a0$var$load("km37l"),
    $dba2ad51795d67a0$var$load("gbksI"),
    $dba2ad51795d67a0$var$load("j2X7f"),
    $dba2ad51795d67a0$var$load("9TeWr"),
    $dba2ad51795d67a0$var$load("kUZ7k"),
    $dba2ad51795d67a0$var$load("8e8NT"),
    $dba2ad51795d67a0$var$load("dJQL7"),
    $dba2ad51795d67a0$var$load("czj6d")
]).then(()=>parcelRequire('dvQoK'));

});

parcelRegister("48Uqm", function(module, exports) {

let $3043ad7025cdf9d1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $3043ad7025cdf9d1$var$load("lTbXI"),
    $3043ad7025cdf9d1$var$load("a98cw"),
    $3043ad7025cdf9d1$var$load("e40mE"),
    $3043ad7025cdf9d1$var$load("fOGnR"),
    $3043ad7025cdf9d1$var$load("cDQOq"),
    $3043ad7025cdf9d1$var$load("gznax"),
    $3043ad7025cdf9d1$var$load("8upye"),
    $3043ad7025cdf9d1$var$load("GlmUM")
]).then(()=>parcelRequire('cvpu0'));

});

parcelRegister("1lX2v", function(module, exports) {

let $0fc58c977e435e13$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0fc58c977e435e13$var$load("8wMQe").then(()=>parcelRequire('LjIsh'));

});

parcelRegister("ftnXB", function(module, exports) {

let $b43c267a86687752$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $b43c267a86687752$var$load("iUyZj"),
    $b43c267a86687752$var$load("4PDaO"),
    $b43c267a86687752$var$load("lMhbw"),
    $b43c267a86687752$var$load("8nEeY"),
    $b43c267a86687752$var$load("kLZKK"),
    $b43c267a86687752$var$load("2gIpG"),
    $b43c267a86687752$var$load("c7GMc"),
    $b43c267a86687752$var$load("bnhJ1")
]).then(()=>parcelRequire('e4VAB'));

});

parcelRegister("9VGie", function(module, exports) {

let $73aa3e717cda5aa3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $73aa3e717cda5aa3$var$load("kPlMQ"),
    $73aa3e717cda5aa3$var$load("ervs7"),
    $73aa3e717cda5aa3$var$load("8CX31"),
    $73aa3e717cda5aa3$var$load("fzzMQ"),
    $73aa3e717cda5aa3$var$load("33S6H"),
    $73aa3e717cda5aa3$var$load("iZiNp"),
    $73aa3e717cda5aa3$var$load("kFae4"),
    $73aa3e717cda5aa3$var$load("iZWpE")
]).then(()=>parcelRequire('96CT4'));

});

parcelRegister("eyPNi", function(module, exports) {

let $a99c6aeae109c869$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $a99c6aeae109c869$var$load("iT2sv"),
    $a99c6aeae109c869$var$load("iMMtn"),
    $a99c6aeae109c869$var$load("23VWs"),
    $a99c6aeae109c869$var$load("3gNEO"),
    $a99c6aeae109c869$var$load("93obY"),
    $a99c6aeae109c869$var$load("6Bgnb"),
    $a99c6aeae109c869$var$load("6Y9jE"),
    $a99c6aeae109c869$var$load("cUTaY")
]).then(()=>parcelRequire('2YvEH'));

});

parcelRegister("azEgN", function(module, exports) {

let $7b2c6907963fc762$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $7b2c6907963fc762$var$load("lyPpF"),
    $7b2c6907963fc762$var$load("eX5n7"),
    $7b2c6907963fc762$var$load("aiYuN"),
    $7b2c6907963fc762$var$load("gvylW"),
    $7b2c6907963fc762$var$load("bxfRe"),
    $7b2c6907963fc762$var$load("43PKJ"),
    $7b2c6907963fc762$var$load("ed6s8"),
    $7b2c6907963fc762$var$load("lAuJd")
]).then(()=>parcelRequire('6VUXz'));

});

parcelRegister("lJywU", function(module, exports) {

let $fd2895d9addda65f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $fd2895d9addda65f$var$load("iN3cj"),
    $fd2895d9addda65f$var$load("3nHdy"),
    $fd2895d9addda65f$var$load("gDEvm"),
    $fd2895d9addda65f$var$load("80OLx"),
    $fd2895d9addda65f$var$load("1EVcg"),
    $fd2895d9addda65f$var$load("fqoiV"),
    $fd2895d9addda65f$var$load("96q1k"),
    $fd2895d9addda65f$var$load("XQtfV")
]).then(()=>parcelRequire('4D1c2'));

});

parcelRegister("lUEen", function(module, exports) {

let $ff3e08f750648dc8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $ff3e08f750648dc8$var$load("eC1OL"),
    $ff3e08f750648dc8$var$load("ilL9c"),
    $ff3e08f750648dc8$var$load("64nco"),
    $ff3e08f750648dc8$var$load("e4s0V"),
    $ff3e08f750648dc8$var$load("28EXy"),
    $ff3e08f750648dc8$var$load("dHzvE"),
    $ff3e08f750648dc8$var$load("7RZp5"),
    $ff3e08f750648dc8$var$load("leyTH")
]).then(()=>parcelRequire('htiZ2'));

});

parcelRegister("iGXxf", function(module, exports) {

let $d9ba54b994021e44$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $d9ba54b994021e44$var$load("4NJ49"),
    $d9ba54b994021e44$var$load("bfOZL"),
    $d9ba54b994021e44$var$load("jLbRX"),
    $d9ba54b994021e44$var$load("4dPO1"),
    $d9ba54b994021e44$var$load("gg8tK"),
    $d9ba54b994021e44$var$load("1SbqQ"),
    $d9ba54b994021e44$var$load("eF54W"),
    $d9ba54b994021e44$var$load("3hnPt")
]).then(()=>parcelRequire('6FDlX'));

});

parcelRegister("6paIk", function(module, exports) {

let $4a9d6374e12b3eab$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4a9d6374e12b3eab$var$load("3zH5p").then(()=>parcelRequire('9VK7h'));

});

parcelRegister("8Ul7q", function(module, exports) {

let $67c3ef6c1d579887$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $67c3ef6c1d579887$var$load("fsCDU"),
    $67c3ef6c1d579887$var$load("kuolm"),
    $67c3ef6c1d579887$var$load("apVmx"),
    $67c3ef6c1d579887$var$load("5xPg2")
]).then(()=>parcelRequire('0aYYd'));

});

parcelRegister("1PKS6", function(module, exports) {

let $155ee994b975cbb8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $155ee994b975cbb8$var$load("g9gkE"),
    $155ee994b975cbb8$var$load("jYdbS"),
    $155ee994b975cbb8$var$load("6ncWv"),
    $155ee994b975cbb8$var$load("ltrgi"),
    $155ee994b975cbb8$var$load("fu25G"),
    $155ee994b975cbb8$var$load("di9bz"),
    $155ee994b975cbb8$var$load("iQGcz"),
    $155ee994b975cbb8$var$load("ar4uw")
]).then(()=>parcelRequire('fHwYp'));

});

parcelRegister("cx1wp", function(module, exports) {

let $91f9bf4454da4b7f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $91f9bf4454da4b7f$var$load("dKdA9").then(()=>parcelRequire('6IGZA'));

});

parcelRegister("d70Xw", function(module, exports) {

let $98bcac46b8e4f144$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $98bcac46b8e4f144$var$load("jhikU"),
    $98bcac46b8e4f144$var$load("f0i3H"),
    $98bcac46b8e4f144$var$load("bvBAp"),
    $98bcac46b8e4f144$var$load("69YlM"),
    $98bcac46b8e4f144$var$load("cyTsc"),
    $98bcac46b8e4f144$var$load("iL6r3"),
    $98bcac46b8e4f144$var$load("kXCsp"),
    $98bcac46b8e4f144$var$load("disCG")
]).then(()=>parcelRequire('cycD1'));

});

parcelRegister("bMkyl", function(module, exports) {

let $89341eca9b757efd$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $89341eca9b757efd$var$load("52XP1").then(()=>parcelRequire('klwXC'));

});

parcelRegister("dLPG4", function(module, exports) {

let $a067c042541b01c9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $a067c042541b01c9$var$load("fSsz4"),
    $a067c042541b01c9$var$load("kWOpS"),
    $a067c042541b01c9$var$load("9tUAi"),
    $a067c042541b01c9$var$load("kgHzZ"),
    $a067c042541b01c9$var$load("k56dn"),
    $a067c042541b01c9$var$load("j4ur8"),
    $a067c042541b01c9$var$load("fF7Id")
]).then(()=>parcelRequire('9kSto'));

});

parcelRegister("486Xk", function(module, exports) {

let $301d4e1521a68fed$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $301d4e1521a68fed$var$load("k3bMq").then(()=>parcelRequire('5pQz0'));

});

parcelRegister("6bLNM", function(module, exports) {

let $4818d99fabfc5b23$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4818d99fabfc5b23$var$load("lF2HI").then(()=>parcelRequire('dPXRL'));

});

parcelRegister("dK87a", function(module, exports) {

let $a015dda4f1ad87f5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $a015dda4f1ad87f5$var$load("d91RK"),
    $a015dda4f1ad87f5$var$load("f7hfJ"),
    $a015dda4f1ad87f5$var$load("QI1kr"),
    $a015dda4f1ad87f5$var$load("brdRT"),
    $a015dda4f1ad87f5$var$load("lWBlc"),
    $a015dda4f1ad87f5$var$load("ZkI53"),
    $a015dda4f1ad87f5$var$load("s2EmI"),
    $a015dda4f1ad87f5$var$load("jc0YL")
]).then(()=>parcelRequire('AOOMd'));

});

parcelRegister("iPSN9", function(module, exports) {

let $db677deb966b470a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $db677deb966b470a$var$load("708J7"),
    $db677deb966b470a$var$load("kVqUf"),
    $db677deb966b470a$var$load("2IMxh"),
    $db677deb966b470a$var$load("j03Pa"),
    $db677deb966b470a$var$load("kke1I"),
    $db677deb966b470a$var$load("dJQNS"),
    $db677deb966b470a$var$load("gOwMq"),
    $db677deb966b470a$var$load("6GfaN")
]).then(()=>parcelRequire('gMQJr'));

});

parcelRegister("iD1Wv", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $ipkS0 = parcelRequire("ipkS0");


const $70ab48cd50028ae1$var$AsyncNoAccessTooltip = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).lazy((0, $ipkS0.trackReactLazy)("rl-r9Te99", ()=>(parcelRequire("bfi3l")).then((module)=>{
        return {
            default: module.NoAccessTooltip
        };
    })));
var $70ab48cd50028ae1$export$2e2bcd8739ae039 = $70ab48cd50028ae1$var$AsyncNoAccessTooltip;
module.exports["default"] = $70ab48cd50028ae1$export$2e2bcd8739ae039;

});

parcelRegister("bfi3l", function(module, exports) {

let $021ce3818119c131$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $021ce3818119c131$var$load("akbkC").then(()=>parcelRequire('d7Uen'));

});

parcelRegister("cK6Td", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $cozmU = parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $4o0zT = parcelRequire("4o0zT");


var $3U6po = parcelRequire("3U6po");

const $ef75f214d8da3bca$var$getStyle = ({ mentionType: mentionType, isRovoChat: isRovoChat }, property)=>{
    const isRovoChatEnabled = isRovoChat && (0, $4o0zT.isExperimentEnabled)('platform_editor_mention_rovo');
    if (isRovoChatEnabled) {
        if (property === 'text') return "var(--ds-text-inverse, #FFFFFF)";
        if (property === 'background') return "var(--ds-background-neutral-bold, #292A2E)";
        if (property === 'hoveredBackground') return "var(--ds-background-neutral-bold-hovered, #3B3D42)";
        if (property === 'pressedBackground') return "var(--ds-background-neutral-bold-pressed, #505258)";
    }
    return (0, $3U6po.mentionStyle)[mentionType][property];
};
const $ef75f214d8da3bca$var$PrimitiveMention = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ isAvatarVisible: isAvatarVisible = false, isRovoChat: isRovoChat = false, mentionType: mentionType, ...other }, ref)=>{
    return /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
        ref: ref,
        "data-avatar-visible": isAvatarVisible || undefined,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        css: (0, $lOiVq.css)("display:inline;border:var(--ds-border-width, 1px) solid ", $ef75f214d8da3bca$var$getStyle({
            mentionType: mentionType
        }, 'borderColor'), ";background:", $ef75f214d8da3bca$var$getStyle({
            mentionType: mentionType,
            isRovoChat: isRovoChat
        }, 'background'), ";color:", $ef75f214d8da3bca$var$getStyle({
            mentionType: mentionType,
            isRovoChat: isRovoChat
        }, 'text'), ";border-radius:20px;cursor:pointer;padding:0 0.3em 2px 0.23em;line-height:1.714;font-size:1em;font-weight:var(--ds-font-weight-regular, 400);word-break:break-word;&[data-avatar-visible='true']{padding:1px 0.3em 1px 0.23em;}&:hover{background:", $ef75f214d8da3bca$var$getStyle({
            mentionType: mentionType,
            isRovoChat: isRovoChat
        }, 'hoveredBackground'), ";color:", $ef75f214d8da3bca$var$getStyle({
            mentionType: mentionType,
            isRovoChat: isRovoChat
        }, 'text'), ";}&:active{background:", $ef75f214d8da3bca$var$getStyle({
            mentionType: mentionType,
            isRovoChat: isRovoChat
        }, 'pressedBackground'), ";color:", $ef75f214d8da3bca$var$getStyle({
            mentionType: mentionType,
            isRovoChat: isRovoChat
        }, 'text'), ";}"),
        ...other
    });
});
var $ef75f214d8da3bca$export$2e2bcd8739ae039 = $ef75f214d8da3bca$var$PrimitiveMention;
module.exports["default"] = $ef75f214d8da3bca$export$2e2bcd8739ae039;

});

parcelRegister("3U6po", function(module, exports) {

var $caelp = parcelRequire("caelp");

const $4789bd4e087c7edf$export$b0888661f7c77ab5 = {
    [(0, $caelp.MentionType).SELF]: {
        background: "var(--ds-background-brand-bold, #1868DB)",
        borderColor: 'transparent',
        text: "var(--ds-text-inverse, #FFFFFF)",
        hoveredBackground: "var(--ds-background-brand-bold-hovered, #1558BC)",
        pressedBackground: "var(--ds-background-brand-bold-pressed, #144794)"
    },
    [(0, $caelp.MentionType).RESTRICTED]: {
        background: 'transparent',
        borderColor: "var(--ds-border-bold, #7D818A)",
        text: "var(--ds-text, #292A2E)",
        hoveredBackground: 'transparent',
        pressedBackground: 'transparent'
    },
    [(0, $caelp.MentionType).DEFAULT]: {
        background: "var(--ds-background-neutral, #0515240F)",
        borderColor: 'transparent',
        text: "var(--ds-text-subtle, #505258)",
        hoveredBackground: "var(--ds-background-neutral-hovered, #0B120E24)",
        pressedBackground: "var(--ds-background-neutral-pressed, #080F214A)"
    },
    [(0, $caelp.MentionType).DISABLED]: {
        background: "var(--ds-background-disabled, #0515240F)",
        borderColor: 'transparent',
        text: "var(--ds-text-disabled, #080F214A)",
        // Disabled chips do not change on hover / press.
        hoveredBackground: "var(--ds-background-disabled, #0515240F)",
        pressedBackground: "var(--ds-background-disabled, #0515240F)"
    }
};
module.exports["mentionStyle"] = $4789bd4e087c7edf$export$b0888661f7c77ab5;

});

parcelRegister("27ALb", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $fh15z = parcelRequire("fh15z");


var $4MiWC = parcelRequire("4MiWC");

const $0f53e930d80d4c74$export$1d011e4240507c78 = new (0, $fh15z.ConcurrentExperience)('mention-rendered', {
    platform: {
        component: 'mention'
    },
    type: (0, $4MiWC.ExperienceTypes).Load,
    performanceType: (0, $4MiWC.ExperiencePerformanceTypes).PageSegmentLoad
});
class $0f53e930d80d4c74$export$5ef1c2550074a375 extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    static getDerivedStateFromProps(props, state) {
        // Preserve the original boundary's retry on parent updates, even when children are memoized.
        // Error recovery uses the same props, so it must retain the fallback instead of retrying.
        return props !== state.previousProps ? {
            hasError: false,
            previousProps: props
        } : null;
    }
    static getDerivedStateFromError() {
        return {
            hasError: true
        };
    }
    componentDidCatch() {
        $0f53e930d80d4c74$export$1d011e4240507c78.getInstance(this.props.id).failure();
    }
    render() {
        return this.state.hasError ? null : this.props.children;
    }
    constructor(...args){
        super(...args);
        this.state = {
            hasError: false,
            previousProps: this.props
        };
    }
}
module.exports["mentionRenderedUfoExperience"] = $0f53e930d80d4c74$export$1d011e4240507c78;
module.exports["UfoErrorBoundary"] = $0f53e930d80d4c74$export$5ef1c2550074a375;

});

parcelRegister("fh15z", function(module, exports) {

var $3Ww6H = parcelRequire("3Ww6H");


var $cNAch = parcelRequire("cNAch");

class $235e9e63ec7037ae$export$ac1cddfee07ba6ac {
    getInstance(instanceId) {
        if (!this.instances[instanceId]) this.instances[instanceId] = new (0, $cNAch.UFOExperience)(this.experienceId, this.config, instanceId);
        return this.instances[instanceId];
    }
    release(instanceId) {
        (0, $3Ww6H.ufolog)('instanceId', instanceId);
        if (this.instances[instanceId]) this.instances[instanceId].abort();
        delete this.instances[instanceId];
    }
    constructor(experienceId, config){
        this.experienceId = void 0;
        this.config = void 0;
        this.instances = {};
        this.experienceId = experienceId;
        this.config = config;
    }
}
module.exports["ConcurrentExperience"] = $235e9e63ec7037ae$export$ac1cddfee07ba6ac;

});

parcelRegister("hq9Cp", function(module, exports) {
const $84118747f7725463$export$3055eac4de8cbd2b = (creatorType)=>creatorType === 'THIRD_PARTY' || creatorType === 'FORGE' || creatorType === 'REMOTE_A2A';
module.exports["isForgeAgentByCreatorType"] = $84118747f7725463$export$3055eac4de8cbd2b;

});

parcelRegister("a9aSv", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $5EzLH = parcelRequire("5EzLH");


var $iDrrr = parcelRequire("iDrrr");

const $19ad0c297e7cfe22$var$shimmerKeyframes = null;
const $19ad0c297e7cfe22$var$skeletonStyles = null;
const $19ad0c297e7cfe22$var$activeShimmerStyles = null; /**
                                   * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
                                   * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
                                   * which makes things simpler than doing an `isServer` check or a `null` check.
                                   *
                                   * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
                                   */ 
const $19ad0c297e7cfe22$var$useLayoutEffect = typeof window === 'undefined' ? (0, $cozmU.useEffect) : (0, $cozmU.useLayoutEffect); /**
                                                                                          * __Skeleton__
                                                                                          *
                                                                                          * A skeleton acts as a placeholder for content, usually while the content loads.
                                                                                          *
                                                                                          * - [Examples](https://atlassian.design/components/skeleton/examples)
                                                                                          * - [Code](https://atlassian.design/components/skeleton/code)
                                                                                          */ 
const $19ad0c297e7cfe22$var$Skeleton = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(21);
    const { width: width, height: height, borderRadius: t1, color: color, ShimmeringEndColor: ShimmeringEndColor, isShimmering: t2, groupName: groupName, interactionName: interactionName, testId: testId } = t0;
    const borderRadius = t1 === undefined ? "var(--ds-radius-small, 4px)" : t1;
    const isShimmering = t2 === undefined ? false : t2;
    const groupDataAttribute = groupName && `data-${groupName}`;
    const context = (0, $cozmU.useContext)((0, $5EzLH.default));
    let t3;
    let t4;
    if ($[0] !== context || $[1] !== interactionName) {
        t3 = ()=>{
            if (context != null && (0, $iDrrr.fg)("platform-dst-skeleton-ufo-hold")) return context.hold(interactionName);
        };
        t4 = [
            context,
            interactionName
        ];
        $[0] = context;
        $[1] = interactionName;
        $[2] = t3;
        $[3] = t4;
    } else {
        t3 = $[2];
        t4 = $[3];
    }
    $19ad0c297e7cfe22$var$useLayoutEffect(t3, t4);
    const t5 = color && ShimmeringEndColor ? color : undefined;
    const t6 = color && ShimmeringEndColor ? ShimmeringEndColor : undefined;
    let t7;
    if ($[4] !== borderRadius || $[5] !== color || $[6] !== height || $[7] !== t5 || $[8] !== t6 || $[9] !== width) {
        t7 = {
            width: width,
            height: height,
            borderRadius: borderRadius,
            backgroundColor: color,
            "--ds-skeleton-from-color": t5,
            "--ds-skeleton-to-color": t6
        };
        $[4] = borderRadius;
        $[5] = color;
        $[6] = height;
        $[7] = t5;
        $[8] = t6;
        $[9] = width;
        $[10] = t7;
    } else t7 = $[10];
    const t8 = t7;
    let t9;
    if ($[11] !== groupDataAttribute) {
        t9 = groupDataAttribute && {
            [groupDataAttribute]: "true"
        };
        $[11] = groupDataAttribute;
        $[12] = t9;
    } else t9 = $[12];
    const t10 = isShimmering && "";
    const t11 = isShimmering && "_1gBibyKB6V";
    let t12;
    if ($[13] !== t10 || $[14] !== t11) {
        t12 = (0, $hekY6.default)([
            "_0uDzWjkSs3 _0nFVCGfONH _03m2nySHWH _43vdfTHVQb _0KLXruGsB2",
            t10,
            t11
        ]);
        $[13] = t10;
        $[14] = t11;
        $[15] = t12;
    } else t12 = $[15];
    let t13;
    if ($[16] !== t12 || $[17] !== t8 || $[18] !== t9 || $[19] !== testId) {
        t13 = /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            "data-testid": testId,
            style: t8,
            ...t9,
            className: t12
        });
        $[16] = t12;
        $[17] = t8;
        $[18] = t9;
        $[19] = testId;
        $[20] = t13;
    } else t13 = $[20];
    return t13;
} : ({ width: width, height: height, borderRadius: borderRadius = "var(--ds-radius-small, 4px)", color: color, ShimmeringEndColor: ShimmeringEndColor, isShimmering: isShimmering = false, groupName: groupName, interactionName: interactionName, testId: testId })=>{
    const groupDataAttribute = groupName && `data-${groupName}`;
    const context = (0, $cozmU.useContext)((0, $5EzLH.default));
    $19ad0c297e7cfe22$var$useLayoutEffect(()=>{
        if (context != null && (0, $iDrrr.fg)('platform-dst-skeleton-ufo-hold')) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        "data-testid": testId,
        style: {
            width: width,
            height: height,
            borderRadius: borderRadius,
            backgroundColor: color,
            // Override the keyframes if both colors are provided, otherwise use the CSS variable fallbacks in our keyframes
            '--ds-skeleton-from-color': color && ShimmeringEndColor ? color : undefined,
            '--ds-skeleton-to-color': color && ShimmeringEndColor ? ShimmeringEndColor : undefined
        },
        ...groupDataAttribute && {
            [groupDataAttribute]: 'true'
        },
        className: (0, $hekY6.default)([
            "_0uDzWjkSs3 _0nFVCGfONH _03m2nySHWH _43vdfTHVQb _0KLXruGsB2",
            isShimmering && "",
            isShimmering && "_1gBibyKB6V"
        ])
    });
};
var $19ad0c297e7cfe22$export$2e2bcd8739ae039 = $19ad0c297e7cfe22$var$Skeleton;
module.exports["default"] = $19ad0c297e7cfe22$export$2e2bcd8739ae039;

});

parcelRegister("fi4Un", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $aIlZA = parcelRequire("aIlZA");


var $6cFsl = parcelRequire("6cFsl");


var $cMyWi = parcelRequire("cMyWi");


var $iDrrr = parcelRequire("iDrrr");

const $bfd9cfc426836244$var$identity = (url)=>url;
const $bfd9cfc426836244$var$isRovoChatUrl = (pathname)=>pathname === '/chat' || /^\/o\/[^/]+\/chat(?:\/|$)/.test(pathname);
const $bfd9cfc426836244$var$stripFirstPartyDatasource = (url)=>{
    try {
        const parsed = new URL(url);
        if (parsed.searchParams.get('datasource') !== '1p') return url;
        parsed.searchParams.delete('datasource');
        return parsed.toString();
    } catch  {
        return url;
    }
};
const $bfd9cfc426836244$var$isSameProductUrl = (url, xpcProduct)=>{
    if (typeof window === 'undefined') return false;
    try {
        const destination = new URL(url, window.location.href);
        if (destination.origin !== window.location.origin) return false;
        if (xpcProduct === 'confluence') return destination.pathname === '/wiki' || destination.pathname.startsWith('/wiki/');
        if (xpcProduct === 'jira') return destination.pathname !== '/wiki' && !destination.pathname.startsWith('/wiki/');
        if (xpcProduct === 'townsquare') return !$bfd9cfc426836244$var$isRovoChatUrl(destination.pathname);
        return true;
    } catch  {
        return false;
    }
};
const $bfd9cfc426836244$export$3c82e87d2696be5a = ({ xpcBridge: xpcBridge, gate: gate })=>{
    (0, $6cFsl.di)((0, $aIlZA.default));
    // Not `useSmartLinkContext()`, which throws without a provider — these render outside one.
    const cardContext = (0, $cozmU.useContext)((0, $cMyWi.SmartCardContext));
    const xpcProduct = cardContext?.xpcProduct;
    // Called unconditionally for the Rules of Hooks; the result goes unused when returning identity.
    const wrapUrl = (0, $aIlZA.default)({
        bridge: xpcBridge,
        product: xpcProduct ?? ''
    });
    const wrapCrossProductUrl = (0, $cozmU.useCallback)((url)=>{
        const strippedUrl = $bfd9cfc426836244$var$stripFirstPartyDatasource(url);
        return $bfd9cfc426836244$var$isSameProductUrl(strippedUrl, xpcProduct ?? '') ? strippedUrl : wrapUrl(strippedUrl);
    }, [
        wrapUrl,
        xpcProduct
    ]);
    if (!xpcProduct || !(0, $iDrrr.fg)('ai-mate-xpc') || gate && !(0, $iDrrr.fg)(gate)) return $bfd9cfc426836244$var$identity;
    return wrapCrossProductUrl;
};
module.exports["useAgentCrossProductUrlWrapper"] = $bfd9cfc426836244$export$3c82e87d2696be5a;

});

parcelRegister("ji12t", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");

const $ee0754b6a3322402$export$7c120b233d4844c6 = (agent)=>agent.creator_type === 'SYSTEM';
const $ee0754b6a3322402$export$f817e52cf2c5cc8c = (agent)=>agent.creator_type === 'CUSTOMER';
const $ee0754b6a3322402$export$2149adda3d8a5807 = (agent)=>agent.creator_type === 'THIRD_PARTY' || agent.creator_type === 'FORGE' || agent.creator_type === 'REMOTE_A2A' && (0, $iDrrr.fg)('rovo_agent_support_a2a_avatar');
const $ee0754b6a3322402$export$95433d0f8c6ad323 = (agent)=>agent.visibility === 'PRIVATE';
const $ee0754b6a3322402$export$7091e3bee2adaacb = (agent)=>agent.creator_type === 'OOTB';
const $ee0754b6a3322402$export$916e4870f74f205b = {
    ALL_AGENTS: 'all-agents',
    STARRED_AGENTS: 'starred-agents',
    MY_AGENTS: 'my-agents',
    TEMPLATES: 'templates',
    VERIFIED_AGENTS: 'verified-agents',
    /** Jira browse tab: agents available for Jira (UI label localized in product). */ AVAILABLE_FOR_JIRA: 'available-for-jira',
    /** Jira browse tab: 3P marketplace coding agents (UI label localized in product). */ CODING_AGENTS: 'coding-agents'
};
module.exports["isSystemAgent"] = $ee0754b6a3322402$export$7c120b233d4844c6;
module.exports["isCustomerAgent"] = $ee0754b6a3322402$export$f817e52cf2c5cc8c;
module.exports["isForgeAgent"] = $ee0754b6a3322402$export$2149adda3d8a5807;
module.exports["isOOTBAgent"] = $ee0754b6a3322402$export$7091e3bee2adaacb;
module.exports["BrowseCategories"] = $ee0754b6a3322402$export$916e4870f74f205b;

});

parcelRegister("8reXX", function(module, exports) {
const $631eae7ab6cb77ba$export$48783720d93c2d26 = {
    id: 'ai_mate_agent',
    named_id: 'ai_mate_agent',
    name: 'AI Mate',
    description: 'AI Mate',
    creator_type: 'SYSTEM',
    available_plugins: {},
    is_default: true,
    visibility: 'PUBLIC'
};
const $631eae7ab6cb77ba$export$2d0163867590928d = new Set([
    'decision_director_agent',
    'user_manual_writer_agent',
    'product_requirements_expert_agent'
]);
const $631eae7ab6cb77ba$export$804d9ee5f4cc40a8 = {
    ['confluence']: new Set([
        'decision_director_agent',
        'product_requirements_expert_agent',
        'rovo_expert_agent'
    ]),
    ['jira']: new Set([
        'rovo_expert_agent',
        'issue_organizer_agent',
        'jira_theme_analyzer_agent'
    ]),
    ['atlas']: new Set([
        'progress_tracker_agent',
        'product_requirements_expert_agent',
        'rovo_expert_agent'
    ])
};
const $631eae7ab6cb77ba$var$AGENT_AUP_ERROR_CODE = `convoai.agent.responsible-ai.failure`;
const $631eae7ab6cb77ba$var$HIPAA_ERROR_CODE = 'convoai.rest.browsing.product.has.hipaa.enabled';
const $631eae7ab6cb77ba$export$a08ace1426fa4a9e = (error)=>Boolean(error) && typeof error === 'object' && error.errorAttributes && error.errorAttributes.errorCode === $631eae7ab6cb77ba$var$AGENT_AUP_ERROR_CODE;
const $631eae7ab6cb77ba$export$f8b1b75846492611 = (error)=>Boolean(error) && typeof error === 'object' && error.errorAttributes && error.errorAttributes.errorCode === $631eae7ab6cb77ba$var$HIPAA_ERROR_CODE;
const $631eae7ab6cb77ba$export$429080cfef3412f2 = 'browse-agents-container';
module.exports["DEFAULT_AGENTS_NAMED_ID_LIST"] = $631eae7ab6cb77ba$export$2d0163867590928d;
module.exports["DEFAULT_OOTB_AGENTS_NAMED_IDS"] = $631eae7ab6cb77ba$export$804d9ee5f4cc40a8;
module.exports["isHipaaError"] = $631eae7ab6cb77ba$export$f8b1b75846492611;
module.exports["AGENTS_CONTAINER_ID"] = $631eae7ab6cb77ba$export$429080cfef3412f2;

});

parcelRegister("aaPn1", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $7cQjw = parcelRequire("7cQjw");


var $iTxmV = parcelRequire("iTxmV");

const $bebfe5469a5e55d3$export$8a1abb7c176bd202 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (siteId)=>{
    const $ = (0, $bDgLe.c)(5);
    const { data: tenantData } = (0, $iTxmV.useTenantDataController)(siteId);
    let t0;
    if ($[0] !== siteId || $[1] !== tenantData?.orgId) {
        t0 = (path)=>(0, $7cQjw.getAtlasURL)(siteId, path, tenantData?.orgId);
        $[0] = siteId;
        $[1] = tenantData?.orgId;
        $[2] = t0;
    } else t0 = $[2];
    tenantData?.orgId;
    const atlasURL = t0;
    let t1;
    if ($[3] !== atlasURL) {
        t1 = {
            atlasURL: atlasURL
        };
        $[3] = atlasURL;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
} : (siteId)=>{
    const { data: tenantData } = (0, $iTxmV.useTenantDataController)(siteId);
    const atlasURL = (0, $cozmU.useCallback)((path)=>(0, $7cQjw.getAtlasURL)(siteId, path, tenantData?.orgId), [
        siteId,
        tenantData?.orgId
    ]);
    return {
        atlasURL: atlasURL
    };
};
const $bebfe5469a5e55d3$export$b61b99f9ac0264be = (0, $gtMdU.isReactCompilerActivePlatform)() ? (siteId)=>{
    const $ = (0, $bDgLe.c)(2);
    const { atlasURL: atlasURL } = $bebfe5469a5e55d3$export$8a1abb7c176bd202(siteId);
    let t0;
    if ($[0] !== atlasURL) {
        t0 = atlasURL("/chat/agents/new");
        $[0] = atlasURL;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (siteId)=>{
    const { atlasURL: atlasURL } = $bebfe5469a5e55d3$export$8a1abb7c176bd202(siteId);
    return atlasURL('/chat/agents/new');
};
module.exports["useAtlasURL"] = $bebfe5469a5e55d3$export$8a1abb7c176bd202;

});

parcelRegister("7cQjw", function(module, exports) {

var $9joJM = parcelRequire("9joJM");


var $i3S9F = parcelRequire("i3S9F");


var $dTEBe = parcelRequire("dTEBe");


var $2J4Io = parcelRequire("2J4Io");

const $4c09219c949e06e3$var$ATLAS_PROD_URL = 'https://home.atlassian.com';
const $4c09219c949e06e3$var$ATLAS_STAGING_URL = 'https://home.stg.atlassian.com';
const $4c09219c949e06e3$export$5105758c0e772381 = ()=>{
    if ((0, $i3S9F.isIsolatedCloud)()) return (0, $9joJM.getUrlForDomainInContext)('home', 'prod') ?? $4c09219c949e06e3$var$ATLAS_PROD_URL;
    return (0, $2J4Io.isStaging)() ? $4c09219c949e06e3$var$ATLAS_STAGING_URL : $4c09219c949e06e3$var$ATLAS_PROD_URL;
};
const $4c09219c949e06e3$export$bfee0f88bf621ad3 = (siteId, path, orgId)=>{
    let argConcat = '?';
    let processedPath = path.startsWith('/') ? path : `/${path}`;
    if (processedPath.includes('?')) argConcat = '&';
    const basePath = orgId ? `${$4c09219c949e06e3$export$5105758c0e772381()}/o/${orgId}` : $4c09219c949e06e3$export$5105758c0e772381();
    return (0, $dTEBe.addRovoParamsToUrl)(`${basePath}${processedPath}${argConcat}cloudId=${siteId}`, {
        cloudId: siteId
    });
};
module.exports["getAtlasHost"] = $4c09219c949e06e3$export$5105758c0e772381;
module.exports["getAtlasURL"] = $4c09219c949e06e3$export$bfee0f88bf621ad3;

});

parcelRegister("2J4Io", function(module, exports) {
const $d610f1a90044572d$export$23da1d24a38b0bde = ()=>{
    const host = window.location.host;
    return host.includes('localhost') || host.includes('.stg.atlassian') || host.includes('.stg-east.frontend.public.atl-paas.net') || host.includes('jira-dev.com');
};
module.exports["isStaging"] = $d610f1a90044572d$export$23da1d24a38b0bde;

});

parcelRegister("iTxmV", function(module, exports) {

var $6cFsl = parcelRequire("6cFsl");


var $irnO2 = parcelRequire("irnO2");


var $bjY3F = parcelRequire("bjY3F");


var $5SS4O = parcelRequire("5SS4O");


var $33DP2 = parcelRequire("33DP2");


var $fBeNh = parcelRequire("fBeNh");

const $a5b67b50b6da9994$export$b863fec6791eae25 = (siteId)=>{
    (0, $6cFsl.di)((0, $5SS4O.useQuery));
    const experience = (0, $bjY3F.useAIMateExperienceTracker)();
    const { data: data, isFetching: isFetching, error: error_0 } = (0, $5SS4O.useQuery)({
        queryKey: [
            'viewAgentTenantData',
            siteId
        ],
        queryFn: async ()=>{
            experience.start({
                id: (0, $irnO2.ExperienceName).FETCH_AGENT_TENANT_DATA,
                name: (0, $irnO2.ExperienceName).FETCH_AGENT_TENANT_DATA
            });
            const result = await (0, $fBeNh.getCloudUrlFromId)(siteId);
            return result;
        },
        onSuccess: ()=>{
            experience.succeed({
                name: (0, $irnO2.ExperienceName).FETCH_AGENT_TENANT_DATA
            });
        },
        onError: (error)=>{
            experience.fail({
                teamName: (0, $33DP2.ROVO_AGENTS_FE_TEAM_NAME),
                name: (0, $irnO2.ExperienceName).FETCH_AGENT_TENANT_DATA,
                error: error
            });
        }
    });
    return {
        data: data,
        isFetching: isFetching,
        error: error_0
    };
};
module.exports["useTenantDataController"] = $a5b67b50b6da9994$export$b863fec6791eae25;

});

parcelRegister("fBeNh", function(module, exports) {

var $haiCi = parcelRequire("haiCi");


var $8JTh2 = parcelRequire("8JTh2");

const $c818cddb4b471711$var$CloudIdLookupQuery = `
query tenantQuery($cloudIds: [ID!]) {
  tenantContexts(cloudIds: $cloudIds) {
    cloudUrl
    orgId
    customDomains {
      product
      hostName
    }
  }
}
`;
// Cached per `cloudId` — the raw AGG payload is product-agnostic, so we fetch
// once per tenant and let the rewrite step branch on product. The cache stores
// the in-flight Promise so concurrent product lookups dedupe to one request.
const $c818cddb4b471711$var$rawTenantCache = new Map();
const $c818cddb4b471711$var$fetchTenantContext = async (cloudId)=>{
    const response = await (0, $haiCi.performGqlFetch)({
        gqlQuery: $c818cddb4b471711$var$CloudIdLookupQuery,
        variables: {
            cloudIds: [
                cloudId
            ]
        }
    });
    return response.data?.tenantContexts?.[0];
};
const $c818cddb4b471711$export$d4ace54df9bd6bb1 = async (cloudId, product)=>{
    let inFlight = $c818cddb4b471711$var$rawTenantCache.get(cloudId);
    if (!inFlight) {
        inFlight = $c818cddb4b471711$var$fetchTenantContext(cloudId);
        $c818cddb4b471711$var$rawTenantCache.set(cloudId, inFlight);
        inFlight.then((result)=>{
            if (result === undefined) $c818cddb4b471711$var$rawTenantCache.delete(cloudId);
        }, ()=>{
            $c818cddb4b471711$var$rawTenantCache.delete(cloudId);
        });
    }
    const raw = await inFlight;
    if (!raw) return undefined;
    return {
        cloudUrl: product ? (0, $8JTh2.rewriteBaseToCustomDomain)(raw.cloudUrl, product, raw.customDomains) : raw.cloudUrl,
        orgId: raw.orgId
    };
};
module.exports["getCloudUrlFromId"] = $c818cddb4b471711$export$d4ace54df9bd6bb1;

});

parcelRegister("8JTh2", function(module, exports) {
const $43581a61b5d6dd12$export$432453592155ebf4 = (base, product, customDomains)=>{
    const match = customDomains?.find((domain)=>domain.product === product && Boolean(domain.hostName));
    if (!match) return base;
    try {
        const url = new URL(base);
        url.hostname = match.hostName;
        // url.toString() normalises bare-root URLs to include a trailing slash
        // (e.g. 'https://wiki.starbucks.com/'). All handlers concatenate a
        // leading-slash path, so we strip the trailing slash to avoid double-slashes
        // (e.g. 'https://wiki.starbucks.com//wiki/spaces/...' → correct).
        return url.toString().replace(/\/$/, '');
    } catch  {
        return base;
    }
};
module.exports["rewriteBaseToCustomDomain"] = $43581a61b5d6dd12$export$432453592155ebf4;

});

parcelRegister("fjlCA", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6cFsl = parcelRequire("6cFsl");


var $5hJlu = parcelRequire("5hJlu");

const $b39593d68f627ba8$var$DIRECTORY_URL = '/gateway/api/directory/graphql';
let $b39593d68f627ba8$var$client;
const $b39593d68f627ba8$export$d43dc22a8337ee9f = ()=>{
    (0, $6cFsl.di)((0, $5hJlu.default));
    const profileClient = (0, $cozmU.useMemo)(()=>{
        if (!$b39593d68f627ba8$var$client) // To support di
        $b39593d68f627ba8$var$client = new (0, $5hJlu.default)({
            url: $b39593d68f627ba8$var$DIRECTORY_URL,
            cacheSize: 1000,
            // 1 day
            cacheMaxAge: 86400000
        });
        return $b39593d68f627ba8$var$client;
    }, []);
    return profileClient;
};
module.exports["useProfileClient"] = $b39593d68f627ba8$export$d43dc22a8337ee9f;

});

parcelRegister("cKhij", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $f61c2cb3f029b6ef$var$message = (0, $kSwu1.defineMessages)({
    deactivatedCreatorName: {
        id: "rovo-chat.agent-card.deactivated-name",
        defaultMessage: "{name} (deactivated)"
    }
});
var $f61c2cb3f029b6ef$export$2e2bcd8739ae039 = $f61c2cb3f029b6ef$var$message;
module.exports["default"] = $f61c2cb3f029b6ef$export$2e2bcd8739ae039;

});

parcelRegister("h6LPv", function(module, exports) {

var $irnO2 = parcelRequire("irnO2");


var $kuIhJ = parcelRequire("kuIhJ");


var $lJ6db = parcelRequire("lJ6db");


var $33DP2 = parcelRequire("33DP2");

const $ceec91f359597657$export$89877d4f8d8790ca = (0, $lJ6db.createHookWithAssistanceService)(({ onSuccess: onSuccess, onError: onError, assistanceServiceInjectedParams: { assistanceService: assistanceService, experienceTracker: experienceTracker }, onInit: onInit })=>{
    const deleteAgent = (0, $kuIhJ.useMutation)({
        mutationFn: async (id)=>{
            experienceTracker.start({
                id: (0, $irnO2.ExperienceName).DELETE_AGENT,
                name: (0, $irnO2.ExperienceName).DELETE_AGENT
            });
            onInit?.(id);
            return await assistanceService.deleteAgent(id);
        },
        onSuccess: async (data)=>{
            experienceTracker.succeed({
                name: (0, $irnO2.ExperienceName).DELETE_AGENT
            });
            onSuccess?.();
            return data;
        },
        onError: (error)=>{
            experienceTracker.fail({
                name: (0, $irnO2.ExperienceName).DELETE_AGENT,
                error: error,
                teamName: (0, $33DP2.ROVO_AGENTS_FE_TEAM_NAME)
            });
            onError?.();
        }
    });
    return {
        deleteAgent: deleteAgent
    };
});
module.exports["useDeleteAgent"] = $ceec91f359597657$export$89877d4f8d8790ca;

});

parcelRegister("kuIhJ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");


var $hlvTd = parcelRequire("hlvTd");


var $8A2GO = parcelRequire("8A2GO");

const $b4a77d21276ce51d$export$609860bf8b0084c = ({ mutationFn: mutationFn, onSuccess: onSuccess, onError: onError, throwOnError: throwOnError = false })=>{
    const mutationFnRef = (0, $cozmU.useRef)(mutationFn);
    mutationFnRef.current = mutationFn;
    const onSuccessRef = (0, $cozmU.useRef)(onSuccess);
    onSuccessRef.current = onSuccess;
    const onErrorRef = (0, $cozmU.useRef)(onError);
    onErrorRef.current = onError;
    const throwOnErrorRef = (0, $cozmU.useRef)(throwOnError);
    throwOnErrorRef.current = throwOnError;
    const [data, setData] = (0, $cozmU.useState)(null);
    const [error, setError] = (0, $cozmU.useState)(null);
    const [isSubmitting, setIsSubmitting] = (0, $cozmU.useState)(false);
    const mutate = (0, $cozmU.useCallback)(async (payload, mutateCallback)=>{
        const reliableContracts = (0, $iDrrr.fg)('rovo_ai_mate_reliability_contracts');
        const shouldThrow = reliableContracts && throwOnErrorRef.current;
        const handleSuccess = onSuccessRef.current;
        const handleError = onErrorRef.current;
        setIsSubmitting(true);
        if (reliableContracts) setError(null);
        try {
            const response = await mutationFnRef.current(payload);
            setData(response);
            if (reliableContracts) {
                // The write has succeeded. An observer failure must not trigger rollback or
                // encourage callers to repeat an already committed operation.
                for (const callback of [
                    handleSuccess,
                    mutateCallback?.onSuccess
                ])try {
                    await callback?.(response);
                } catch (callbackError) {
                    (0, $hlvTd.logException)({
                        exception: callbackError,
                        name: 'aiMateMutationSuccessCallback'
                    }).catch(()=>undefined);
                }
            } else {
                onSuccessRef.current?.(response);
                mutateCallback?.onSuccess?.(response);
            }
            return response;
        } catch (error_0) {
            const apiError = (0, $8A2GO.mapErrorToApiError)(error_0);
            setError(apiError);
            (reliableContracts ? handleError : onErrorRef.current)?.(apiError, payload);
            mutateCallback?.onError?.(apiError);
            if (shouldThrow) throw apiError;
        } finally{
            setIsSubmitting(false);
        }
    }, []);
    return {
        data: data,
        error: error,
        isSubmitting: isSubmitting,
        mutate: mutate
    };
};
module.exports["useMutation"] = $b4a77d21276ce51d$export$609860bf8b0084c;

});

parcelRegister("3ay5Z", function(module, exports) {

var $irnO2 = parcelRequire("irnO2");


var $kuIhJ = parcelRequire("kuIhJ");


var $lJ6db = parcelRequire("lJ6db");


var $33DP2 = parcelRequire("33DP2");

const $852df1b03fff5c54$export$5c4c46b1f93a6e69 = (0, $lJ6db.createHookWithAssistanceService)(({ onError: onError, onSuccess: onSuccess, assistanceServiceInjectedParams: { assistanceService: assistanceService, experienceTracker: experienceTracker } })=>{
    const favouriteAgent = (0, $kuIhJ.useMutation)({
        mutationFn: async (id)=>{
            experienceTracker.start({
                id: (0, $irnO2.ExperienceName).FAVOURITE_AGENT,
                name: (0, $irnO2.ExperienceName).FAVOURITE_AGENT
            });
            return await assistanceService.favouriteAgent(id);
        },
        onSuccess: async ()=>{
            experienceTracker.succeed({
                name: (0, $irnO2.ExperienceName).FAVOURITE_AGENT
            });
            onSuccess?.({
                favourite: true
            });
        },
        onError: (error)=>{
            experienceTracker.fail({
                name: (0, $irnO2.ExperienceName).FAVOURITE_AGENT,
                error: error,
                teamName: (0, $33DP2.ROVO_AGENTS_FE_TEAM_NAME)
            });
            onError?.({
                favourite: true
            });
        }
    });
    const unfavouriteAgent = (0, $kuIhJ.useMutation)({
        mutationFn: async (id)=>{
            experienceTracker.start({
                id: (0, $irnO2.ExperienceName).UNFAVOURITE_AGENT,
                name: (0, $irnO2.ExperienceName).UNFAVOURITE_AGENT
            });
            return await assistanceService.unfavouriteAgent(id);
        },
        onSuccess: async ()=>{
            experienceTracker.succeed({
                name: (0, $irnO2.ExperienceName).UNFAVOURITE_AGENT
            });
            onSuccess?.({
                favourite: false
            });
        },
        onError: (error)=>{
            experienceTracker.fail({
                name: (0, $irnO2.ExperienceName).UNFAVOURITE_AGENT,
                error: error,
                teamName: (0, $33DP2.ROVO_AGENTS_FE_TEAM_NAME)
            });
            onError?.({
                favourite: false
            });
        }
    });
    return {
        favouriteAgent: favouriteAgent,
        unfavouriteAgent: unfavouriteAgent
    };
});
module.exports["useAgentFavourites"] = $852df1b03fff5c54$export$5c4c46b1f93a6e69;

});

parcelRegister("5Vuk7", function(module, exports) {
const $17fc5339fe3ee56f$export$b873e2166b2a4c4f = (agents, agentIdFiltersOverride, agentDefaultIdOverride)=>{
    const defaultOverrideAgentsIndex = agents.findIndex((agent)=>agentDefaultIdOverride === agent.id);
    let overridenAgents = [];
    if (defaultOverrideAgentsIndex !== -1) overridenAgents = agents.map((agent, index)=>({
            ...agent,
            is_default: index === defaultOverrideAgentsIndex
        }));
    else overridenAgents = agents;
    if (Array.isArray(agentIdFiltersOverride)) return overridenAgents.filter((agent)=>agentIdFiltersOverride?.includes(agent.id) || agent.is_default);
    return overridenAgents;
};
module.exports["getOverridenAgents"] = $17fc5339fe3ee56f$export$b873e2166b2a4c4f;

});

parcelRegister("fU4xN", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $4657aea77ee8f7d7$var$message = (0, $kSwu1.defineMessages)({
    defaultAgentName: {
        id: "ai-mate.agent-selector.default-agent-name",
        defaultMessage: "Chat"
    },
    defaultAgentDescription: {
        id: "ai-mate.agent-selector.default-agent-description",
        defaultMessage: "Get answers, generate new ideas, and accelerate everyday work."
    }
});
var $4657aea77ee8f7d7$export$2e2bcd8739ae039 = $4657aea77ee8f7d7$var$message;
module.exports["default"] = $4657aea77ee8f7d7$export$2e2bcd8739ae039;

});

parcelRegister("6YdPR", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $eKjv9 = parcelRequire("eKjv9");

const $8640d528854286da$export$2a9125424215710e = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { touchpointSource: touchpointSource } = t0;
    const { productHeader: productHeader, siteId: siteId, experienceId: experienceId, assistanceServiceConfig: assistanceServiceConfig } = (0, $eKjv9.useGlobalConfig)();
    assistanceServiceConfig?.headers;
    assistanceServiceConfig?.channelId;
    const t1 = assistanceServiceConfig?.headers;
    const t2 = assistanceServiceConfig?.channelId;
    let t3;
    if ($[0] !== experienceId || $[1] !== productHeader || $[2] !== siteId || $[3] !== t1 || $[4] !== t2 || $[5] !== touchpointSource) {
        t3 = {
            product: productHeader,
            experienceId: experienceId,
            touchpointSource: touchpointSource,
            siteId: siteId,
            headers: t1,
            channelId: t2
        };
        $[0] = experienceId;
        $[1] = productHeader;
        $[2] = siteId;
        $[3] = t1;
        $[4] = t2;
        $[5] = touchpointSource;
        $[6] = t3;
    } else t3 = $[6];
    return t3;
} : ({ touchpointSource: touchpointSource })=>{
    const { productHeader: productHeader, siteId: siteId, experienceId: experienceId, assistanceServiceConfig: assistanceServiceConfig } = (0, $eKjv9.useGlobalConfig)();
    return (0, $cozmU.useMemo)(()=>({
            product: productHeader,
            experienceId: experienceId,
            touchpointSource: touchpointSource,
            siteId: siteId,
            headers: assistanceServiceConfig?.headers,
            channelId: assistanceServiceConfig?.channelId
        }), [
        productHeader,
        experienceId,
        touchpointSource,
        siteId,
        assistanceServiceConfig?.headers,
        assistanceServiceConfig?.channelId
    ]);
};
module.exports["useAssistanceServiceParams"] = $8640d528854286da$export$2a9125424215710e;

});

parcelRegister("gn6Jj", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $c69qG = parcelRequire("c69qG");

const $397d0442e822624b$export$e2f65d68917ec2b1 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)((0, $c69qG.agentVersioningConfigContext));
} : ()=>(0, $cozmU.useContext)((0, $c69qG.agentVersioningConfigContext));
module.exports["useAgentVersioningConfig"] = $397d0442e822624b$export$e2f65d68917ec2b1;

});

parcelRegister("222kR", function(module, exports) {
const $925623d692bcf893$export$d669251a312339ff = (chat, type)=>{
    const lastIndex = chat.map((item)=>item.type).indexOf(type);
    if (lastIndex >= 0) return chat[lastIndex];
};
module.exports["getFirstMessageOfType"] = $925623d692bcf893$export$d669251a312339ff;

});

parcelRegister("dvUlt", function(module, exports) {

var $fCunh = parcelRequire("fCunh");

const $90bfb4e6c87059a4$export$8d253468a0039e81 = (errorCode)=>{
    return errorCode === (0, $fCunh.ASSISTANCE_SERVICE_ERROR_CODES).AGENT_FORBIDDEN || errorCode === (0, $fCunh.ASSISTANCE_SERVICE_ERROR_CODES).AGENT_DEACTIVATED;
};
module.exports["isAgentUnavailable"] = $90bfb4e6c87059a4$export$8d253468a0039e81;

});

parcelRegister("gYfOr", function(module, exports) {
const $6473a3daf4438662$var$getCreatedContentActionData = (action)=>action.data;
const $6473a3daf4438662$export$32f3c2791170494a = (action)=>$6473a3daf4438662$var$getCreatedContentActionData(action)?.title ?? '';
const $6473a3daf4438662$export$1b968a6b473955a8 = (action)=>String($6473a3daf4438662$var$getCreatedContentActionData(action)?.contentId ?? '');
module.exports["getActionTitle"] = $6473a3daf4438662$export$32f3c2791170494a;
module.exports["getActionContentId"] = $6473a3daf4438662$export$1b968a6b473955a8;

});

parcelRegister("aJU2k", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");


var $fiVb2 = parcelRequire("fiVb2");

const $5436fb6e01d0eb8e$export$aaf871ddd4ec7885 = (0, $kBr4q.createActionsHook)((0, $fiVb2.store));
module.exports["useChatModeStoreActions"] = $5436fb6e01d0eb8e$export$aaf871ddd4ec7885;

});

parcelRegister("fiVb2", function(module, exports) {

var $8s9DV = parcelRequire("8s9DV");


var $gchVc = parcelRequire("gchVc");


var $5osBM = parcelRequire("5osBM");


var $eu92c = parcelRequire("eu92c");


var $8XyiW = parcelRequire("8XyiW");

const $485b379839d8bc9f$var$getDefaultChatMode = (options)=>{
    const defaultChatMode = (0, $5osBM.getDerivedDefaultChatMode)();
    if (options?.webSearchDefaultEnabled === undefined) return defaultChatMode;
    return {
        ...defaultChatMode,
        webSearchEnabled: options.webSearchDefaultEnabled
    };
};
const $485b379839d8bc9f$var$actions = {
    setAutoActionApprovalMode: (key, autoActionApprovalMode)=>({ dispatch: dispatch })=>{
            dispatch((0, $8XyiW.updateMode)(key, {
                autoActionApprovalMode: autoActionApprovalMode
            }));
        },
    setReasoningMode: (key, reasoningMode)=>({ dispatch: dispatch })=>{
            dispatch((0, $8XyiW.updateMode)(key, {
                reasoningMode: reasoningMode
            }));
        },
    resetReasoningMode: (key)=>({ dispatch: dispatch })=>{
            dispatch((0, $8XyiW.updateMode)(key, {
                reasoningMode: (0, $5osBM.getDerivedDefaultChatMode)().reasoningMode
            }));
        },
    setDeepResearchEnabled: (key, isEnabled)=>({ dispatch: dispatch })=>{
            dispatch((0, $8XyiW.updateMode)(key, {
                reasoningMode: isEnabled ? 'deep-research' : 'auto'
            }));
        },
    setWebSearchEnabled: (key, isEnabled)=>({ dispatch: dispatch })=>{
            dispatch((0, $8XyiW.updateMode)(key, {
                webSearchEnabled: isEnabled,
                webSearchEnabledOverridden: true
            }));
        },
    setConciergeEnabled: (key, isEnabled)=>({ dispatch: dispatch })=>{
            dispatch((0, $8XyiW.updateMode)(key, {
                conciergeEnabled: isEnabled
            }));
        },
    seedWebSearchDefault: (key, webSearchDefaultEnabled)=>({ dispatch: dispatch, getState: getState })=>{
            const state = getState()[key];
            if (state?.webSearchEnabledOverridden) return false;
            if (state?.rovoControlsSnapshot) {
                dispatch((0, $8XyiW.updateMode)(key, {
                    rovoControlsSnapshot: {
                        ...state.rovoControlsSnapshot,
                        webSearchEnabled: webSearchDefaultEnabled
                    }
                }));
                return false;
            }
            dispatch((0, $8XyiW.updateMode)(key, {
                webSearchEnabled: webSearchDefaultEnabled
            }));
            return true;
        },
    setSourceMode: (key, sourceMode)=>({ dispatch: dispatch })=>{
            dispatch((0, $8XyiW.updateMode)(key, {
                sourceMode: sourceMode
            }));
        },
    setOrgKnowledge: (key, orgKnowledge)=>({ dispatch: dispatch })=>{
            dispatch((0, $8XyiW.updateMode)(key, {
                orgKnowledge: orgKnowledge,
                appFiltersSetByPrompt: false
            }));
        },
    setAppFiltersFromPrompt: (key, filteredApps)=>({ dispatch: dispatch })=>{
            dispatch((0, $8XyiW.updateMode)(key, {
                orgKnowledge: {
                    filteredApps: filteredApps
                },
                appFiltersSetByPrompt: true
            }));
        },
    addAppFilter: (key, app)=>({ getState: getState, dispatch: dispatch })=>{
            const { orgKnowledge: orgKnowledge } = getState()[key] || (0, $5osBM.getDerivedDefaultChatMode)();
            // An empty filter means "all connected apps apply" (see getAppFilters), so a
            // just-connected app is already included. Writing it in explicitly would turn
            // "all apps" into "only this app" and silently drop the rest — leave it be. Same
            // for 'disabled' (org knowledge off entirely). Only a narrowed filter needs the
            // app appended so it isn't excluded from the next message.
            if (orgKnowledge === 'disabled' || orgKnowledge.filteredApps.length === 0) return;
            if (orgKnowledge.filteredApps.some((a)=>a.source === app.source)) return;
            // Preserve appFiltersSetByPrompt (don't force it true): appending on connect must
            // not turn a manually-narrowed filter into a prompt-set one, which the input-clear
            // handler (RovoChatPromptInput) would then discard back to "all apps".
            dispatch((0, $8XyiW.updateMode)(key, {
                orgKnowledge: {
                    filteredApps: [
                        ...orgKnowledge.filteredApps,
                        app
                    ]
                }
            }));
        },
    setUseCurrentPageContext: (key, isEnabled)=>({ dispatch: dispatch })=>{
            dispatch((0, $8XyiW.updateMode)(key, {
                useCurrentPageContext: isEnabled
            }));
        },
    setSpaceSourceCount: (key, count)=>({ dispatch: dispatch })=>{
            dispatch((0, $8XyiW.updateMode)(key, {
                spaceSourceCount: count
            }));
        },
    setBrowserDisplayContextActive: (key, active)=>({ dispatch: dispatch })=>{
            dispatch((0, $8XyiW.updateMode)(key, {
                browserDisplayContextActive: active
            }));
        },
    getBrowserDisplayContextActive: (key)=>({ getState: getState })=>getState()[key]?.browserDisplayContextActive === true,
    setSelectedCloudIds: (key, selectedCloudIds)=>({ dispatch: dispatch })=>{
            dispatch((0, $8XyiW.updateMode)(key, {
                selectedCloudIds: selectedCloudIds
            }));
        },
    setChatMode: (key, chatMode)=>({ dispatch: dispatch })=>{
            let updatedChatMode = chatMode;
            let orgKnowledge = (0, $5osBM.getDerivedDefaultChatMode)().orgKnowledge;
            if (chatMode.appFilters === undefined) orgKnowledge = (0, $5osBM.getDerivedDefaultChatMode)().orgKnowledge;
            else if (chatMode.appFilters.length > 0) orgKnowledge = {
                filteredApps: chatMode.appFilters
            };
            else orgKnowledge = 'disabled';
            updatedChatMode = {
                ...chatMode,
                orgKnowledge: orgKnowledge,
                ...chatMode.webSearchEnabled !== undefined ? {
                    webSearchEnabledOverridden: true
                } : {}
            };
            dispatch((0, $8XyiW.updateMode)(key, {
                ...updatedChatMode,
                appFiltersSetByPrompt: false
            }));
        },
    getChatMode: (key)=>({ getState: getState })=>{
            const state = getState()[key] || (0, $5osBM.getDerivedDefaultChatMode)();
            return {
                ...state,
                ...(0, $eu92c.getDerivedReasoningMode)(state.reasoningMode),
                appFilters: (0, $gchVc.getAppFilters)(state.orgKnowledge)
            };
        },
    clearMode: (key, options)=>({ dispatch: dispatch, getState: getState })=>{
            const currentMode = getState()[key];
            const shouldPreserveWebSearchEnabled = options?.preserveWebSearchEnabled === true && currentMode?.webSearchEnabledOverridden === true;
            const shouldPreserveUseCurrentPageContext = options?.preserveUseCurrentPageContext === true && currentMode?.useCurrentPageContext === false;
            const defaultChatMode = $485b379839d8bc9f$var$getDefaultChatMode(options);
            dispatch((0, $8XyiW.updateMode)(key, {
                ...defaultChatMode,
                webSearchEnabled: shouldPreserveWebSearchEnabled ? currentMode.webSearchEnabled : defaultChatMode.webSearchEnabled,
                webSearchEnabledOverridden: shouldPreserveWebSearchEnabled,
                useCurrentPageContext: shouldPreserveUseCurrentPageContext ? currentMode.useCurrentPageContext : defaultChatMode.useCurrentPageContext
            }));
        },
    /**
   * Keeps the Rovo-owned controls (reasoning mode, web search, app filters) in
   * sync with who owns the next turn, and is the single owner of the
   * snapshot/restore state.
   *
   * The stored `rovoControlsSnapshot` doubles as the edge-detector so callers
   * can invoke this idempotently every render without tracking previous state:
   *  - `suppressed` with no snapshot: a specialist just took the turn — stash the
   *    current controls and reset them to defaults so the specialist's own
   *    reasoning/sources apply.
   *  - not `suppressed` with a snapshot: the turn returned to Rovo — restore the
   *    stashed controls and clear the snapshot.
   *  - otherwise: no-op.
   *
   * Returns `RovoControlsSnapshot | null`: the effective control values it applied
   * (or `null` when nothing changed) so the caller can forward them to its
   * `on*Change` props. On the reset path `appFilters` is `[]`; on the restore path
   * it is the stashed value, which may be `undefined` (meaning "no filter / all
   * apps"). Callers coalesce with `?? []` before calling `onFilteredAppsChange`.
   */ setRovoControlsSuppressed: (key, { suppressed: suppressed })=>({ dispatch: dispatch, getState: getState })=>{
            const state = getState()[key] || (0, $5osBM.getDerivedDefaultChatMode)();
            const snapshot = state.rovoControlsSnapshot ?? null;
            if (suppressed && snapshot === null) {
                const derived = {
                    ...state,
                    ...(0, $eu92c.getDerivedReasoningMode)(state.reasoningMode),
                    appFilters: (0, $gchVc.getAppFilters)(state.orgKnowledge)
                };
                dispatch((0, $8XyiW.updateMode)(key, {
                    rovoControlsSnapshot: {
                        reasoningMode: state.reasoningMode,
                        autoActionApprovalMode: state.autoActionApprovalMode,
                        webSearchEnabled: derived.webSearchEnabled,
                        sourceMode: state.sourceMode,
                        appFilters: derived.appFilters,
                        selectedCloudIds: state.selectedCloudIds
                    },
                    reasoningMode: (0, $5osBM.getDerivedDefaultChatMode)().reasoningMode,
                    autoActionApprovalMode: 'ALWAYS_HUMAN',
                    webSearchEnabled: false,
                    sourceMode: (0, $5osBM.getDerivedDefaultChatMode)().sourceMode,
                    orgKnowledge: (0, $5osBM.getDerivedDefaultChatMode)().orgKnowledge,
                    selectedCloudIds: [],
                    appFiltersSetByPrompt: false
                }));
                return {
                    reasoningMode: (0, $5osBM.getDerivedDefaultChatMode)().reasoningMode,
                    autoActionApprovalMode: 'ALWAYS_HUMAN',
                    webSearchEnabled: false,
                    sourceMode: (0, $5osBM.getDerivedDefaultChatMode)().sourceMode,
                    appFilters: [],
                    selectedCloudIds: []
                };
            }
            if (!suppressed && snapshot !== null) {
                dispatch((0, $8XyiW.updateMode)(key, {
                    rovoControlsSnapshot: null,
                    reasoningMode: snapshot.reasoningMode,
                    autoActionApprovalMode: snapshot.autoActionApprovalMode,
                    webSearchEnabled: snapshot.webSearchEnabled,
                    sourceMode: snapshot.sourceMode,
                    orgKnowledge: snapshot.appFilters === undefined ? (0, $5osBM.getDerivedDefaultChatMode)().orgKnowledge : snapshot.appFilters.length > 0 ? {
                        filteredApps: snapshot.appFilters
                    } : 'disabled',
                    selectedCloudIds: snapshot.selectedCloudIds,
                    appFiltersSetByPrompt: false
                }));
                return snapshot;
            }
            return null;
        }
};
const $485b379839d8bc9f$export$6f57813fe9f31bf9 = (0, $8s9DV.createStore)({
    initialState: {},
    actions: $485b379839d8bc9f$var$actions
});
module.exports["store"] = $485b379839d8bc9f$export$6f57813fe9f31bf9;

});

parcelRegister("gchVc", function(module, exports) {
const $3b98ce1c6aca161d$export$6c9b22c84a96fd6c = (orgKnowledge)=>{
    if (orgKnowledge === 'disabled') // no org knowledge applied at all.
    return [];
    else if (orgKnowledge.filteredApps.length === 0) // all org knowledge applied and no apps filtered.
    return undefined;
    else // org knowledge applied and apps filtered.
    return orgKnowledge.filteredApps;
};
module.exports["getAppFilters"] = $3b98ce1c6aca161d$export$6c9b22c84a96fd6c;

});

parcelRegister("5osBM", function(module, exports) {

var $cXtTj = parcelRequire("cXtTj");


var $iDrrr = parcelRequire("iDrrr");

const $075476664b139afe$var$getWebSearchDefaultFromStorage = ()=>{
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    if (typeof globalThis === 'undefined' || !globalThis.document || !globalThis.localStorage) return null;
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    const value = globalThis.localStorage.getItem('rovo-chat-web-search-default-on');
    if (value === null) return null;
    return value !== 'false';
};
const $075476664b139afe$export$99faa9801df051b0 = ()=>{
    const storageValue = $075476664b139afe$var$getWebSearchDefaultFromStorage();
    // If localStorage explicitly says it's off, default should be off
    // Otherwise, use the experiment flag value
    const webSearchEnabled = storageValue === false ? false : (0, $cXtTj.default).getExperimentValue('rovo_web_search_default_on', 'isEnabled', false);
    return {
        reasoningMode: 'auto',
        autoActionApprovalMode: 'ALWAYS_HUMAN',
        webSearchEnabled: webSearchEnabled,
        conciergeEnabled: false,
        sourceMode: 'GENERAL',
        orgKnowledge: {
            filteredApps: []
        },
        selectedCloudIds: [],
        autoApplyEnabled: true,
        appFiltersSetByPrompt: false,
        useCurrentPageContext: (0, $iDrrr.fg)('disable_default_on_current_page_as_context') ? false : true
    };
};
module.exports["getDerivedDefaultChatMode"] = $075476664b139afe$export$99faa9801df051b0;

});

parcelRegister("eu92c", function(module, exports) {

var $ePmEF = parcelRequire("ePmEF");

const $dcc4545520df4d8c$export$d6ea7bd50e1b3540 = (reasoningMode)=>{
    const isThinkDeeperMode = reasoningMode === 'think-deeper' || reasoningMode === 'think-deeper-marathon' || reasoningMode === 'think-deeper-orchestrator';
    return {
        deepResearchEnabled: reasoningMode === 'deep-research',
        thinkDeeperEnabled: isThinkDeeperMode,
        fastModeEnabled: reasoningMode === 'fast',
        autoReasoningEnabled: reasoningMode === 'auto',
        alphaExtendedThinkingMode: (0, $ePmEF.getAlphaExtendedThinkingMode)(reasoningMode),
        taskModeEnabled: reasoningMode === 'task'
    };
};
module.exports["getDerivedReasoningMode"] = $dcc4545520df4d8c$export$d6ea7bd50e1b3540;

});

parcelRegister("ePmEF", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");

const $f28d0c39486e1a59$export$61a509aba0cee914 = (reasoningMode)=>{
    if (!(0, $iDrrr.fg)('rovo_chat_marathon_orchestrator_reasoning_modes')) return undefined;
    switch(reasoningMode){
        case 'think-deeper-marathon':
            return 'MARATHON';
        case 'think-deeper-orchestrator':
            return 'LONG_HORIZON';
        default:
            return undefined;
    }
};
module.exports["getAlphaExtendedThinkingMode"] = $f28d0c39486e1a59$export$61a509aba0cee914;

});

parcelRegister("8XyiW", function(module, exports) {

var $5osBM = parcelRequire("5osBM");

const $3fc1c590f304ee0c$export$f80026ff7d109add = (key, mode)=>{
    return ({ setState: setState, getState: getState })=>{
        const state = getState()[key] || (0, $5osBM.getDerivedDefaultChatMode)();
        setState({
            [key]: {
                ...state,
                ...mode
            }
        });
    };
};
module.exports["updateMode"] = $3fc1c590f304ee0c$export$f80026ff7d109add;

});

parcelRegister("gzMZq", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");


var $cXtTj = parcelRequire("cXtTj");


var $4o0zT = parcelRequire("4o0zT");


var $2pQiO = parcelRequire("2pQiO");


var $iDrrr = parcelRequire("iDrrr");


var $8akfd = parcelRequire("8akfd");

/**
 * Whether the extension context bridge is relaying. Same experiment the bridge's own halves read,
 * without exposure: this runs on every send in every host, and the extension owns the exposure call.
 */ const $2a83073b2ae5e0c1$var$isBridgeRelayedEditorContextEnabled = ()=>(0, $2pQiO.UNSAFE_expValNoExposure)('rovo-ext_context_bridge_exp', 'isEnabled', false) === true;
const $2a83073b2ae5e0c1$export$6f57813fe9f31bf9 = (0, $8s9DV.createStore)({
    initialState: {
        editorContext: undefined,
        whiteboardContext: undefined,
        slidesContext: undefined,
        databaseContext: undefined,
        browserContext: undefined,
        dashboardContext: undefined,
        jiraWorkflowContext: undefined,
        artifactContext: undefined,
        aiFeatureContext: {},
        isAIFeatureContextDismissed: false,
        contentTargets: {},
        currentTargetId: undefined,
        pageSmartLinks: undefined,
        smartCreationModalSurface: undefined
    },
    actions: {
        getAllContext: ()=>({ getState: getState })=>getState(),
        getAIFeatureContext: ()=>({ getState: getState })=>{
                const currentState = getState().aiFeatureContext;
                // Delete all properties that are undefined
                Object.keys(currentState).forEach((key)=>currentState[key] === undefined && delete currentState[key]);
                // Avoid sending an empty object
                return Object.keys(currentState).length ? currentState : undefined;
            },
        setAIFeatureContext: (chatContextData)=>({ getState: getState, setState: setState })=>{
                const state = getState();
                // Honour the user's explicit "Remove context" action
                if (state.isAIFeatureContextDismissed) return;
                const currentAIFeatureContextState = state.aiFeatureContext;
                const { contextKey: contextKey, setContext: setContext } = chatContextData;
                if (contextKey) {
                    const contextUpdated = setContext(currentAIFeatureContextState[contextKey]);
                    setState({
                        aiFeatureContext: {
                            ...currentAIFeatureContextState,
                            [contextKey]: contextUpdated
                        }
                    });
                }
            },
        setAIFeatureContextDismissed: (isDismissed)=>({ setState: setState })=>{
                setState(isDismissed ? {
                    aiFeatureContext: {},
                    isAIFeatureContextDismissed: true
                } : {
                    isAIFeatureContextDismissed: false
                });
            },
        getDashboardContext: ()=>({ getState: getState })=>getState().dashboardContext,
        setDashboardContext: (dashboardContext)=>({ setState: setState })=>{
                setState({
                    dashboardContext: dashboardContext
                });
            },
        getJiraWorkflowContext: ()=>({ getState: getState })=>getState().jiraWorkflowContext,
        setJiraWorkflowContext: (jiraWorkflowContext)=>({ setState: setState })=>{
                setState({
                    jiraWorkflowContext: jiraWorkflowContext
                });
            },
        getJiraCreateContext: ()=>({ getState: getState })=>getState().jiraCreateContext,
        setJiraCreateContext: (jiraCreateContext)=>({ setState: setState })=>{
                setState({
                    jiraCreateContext: jiraCreateContext
                });
            },
        getArtifactContext: ()=>({ getState: getState })=>getState().artifactContext,
        setArtifactContext: (artifactContext)=>({ setState: setState })=>{
                setState({
                    artifactContext: artifactContext
                });
            },
        getEditorContext: ()=>({ getState: getState })=>getState().editorContext,
        setEditorContext: (editorContext)=>({ setState: setState })=>{
                setState({
                    editorContext: editorContext
                });
            },
        updateEditorContextIsViewMode: (isViewMode)=>({ setState: setState, getState: getState })=>{
                const { editorContext: editorContext } = getState();
                if (editorContext) setState({
                    editorContext: {
                        ...editorContext,
                        isViewMode: isViewMode
                    }
                });
            },
        getWhiteboardContext: ()=>({ getState: getState })=>getState().whiteboardContext,
        setWhiteboardContext: (whiteboardContext)=>({ setState: setState })=>{
                setState({
                    whiteboardContext: whiteboardContext
                });
            },
        getSlidesContext: ()=>({ getState: getState })=>getState().slidesContext,
        setSlidesContext: (slidesContext)=>({ setState: setState })=>{
                setState({
                    slidesContext: slidesContext
                });
            },
        getDatabaseContext: ()=>({ getState: getState })=>getState().databaseContext,
        setDatabaseContext: (databaseContext)=>({ setState: setState })=>{
                setState({
                    databaseContext: databaseContext
                });
            },
        mergeDatabaseContext: (partial)=>({ getState: getState, setState: setState })=>{
                // If no selected elements published, clean up the database context
                if (!partial?.selectedElementIds) {
                    setState({
                        databaseContext: undefined
                    });
                    return;
                }
                const current = getState().databaseContext;
                setState({
                    databaseContext: current ? {
                        ...current,
                        ...partial
                    } : partial
                });
            },
        getBrowserContext: ()=>({ getState: getState })=>getState().browserContext,
        setBrowserContext: (browserContext)=>({ setState: setState })=>{
                setState({
                    browserContext: browserContext
                });
            },
        setPageSmartLinks: (pageSmartLinks, status, contextKey)=>({ setState: setState })=>{
                setState({
                    pageSmartLinks: pageSmartLinks,
                    ...status ? {
                        pageSmartLinksStatus: status
                    } : {},
                    ...contextKey !== undefined ? {
                        pageSmartLinksContextKey: contextKey
                    } : {}
                });
            },
        getTarget: (contentContext, activeTargetId)=>({ getState: getState })=>{
                const targets = getState().contentTargets[contentContext];
                if (!targets) return undefined;
                // targets is always an array
                const targetList = targets;
                // If activeTargetId provided, find it; otherwise return first target
                if (activeTargetId) return targetList.find((t)=>t.id === activeTargetId);
                return targetList[0];
            },
        getContentContext: (contentId)=>({ getState: getState })=>{
                const entries = Object.entries(getState().contentTargets);
                for (const [context, targets] of entries){
                    const targetList = targets;
                    if (targetList.some((t)=>t.id === contentId)) return context;
                }
                return undefined;
            },
        getActiveContext: ()=>({ getState: getState })=>{
                const state = getState();
                // The rules here determine the 'rank' in which Rovo layers are resolved into "which layer is currently active".
                // They map to intended UX - in AIFC, the staging area is a modal-powered experience, on top of global experiences.
                // Consider the scenario of sending a message - the user will be interacting with the topmost layer.
                // `smartCreationModalSurface` covers the window before any staging-area content target
                // exists yet (e.g. a clarifying question asked before content generation starts) —
                // without it, this would incorrectly resolve to 'global' for that window.
                if (state.contentTargets['staging-area'] || state.smartCreationModalSurface === 'staging') return 'staging-area';
                if (state.contentTargets['agent-builder'] && (0, $4o0zT.isExperimentEnabled)('sltns-1425-add-ask-question-design-solution')) return 'agent-builder';
                return 'global';
            },
        hasTarget: (contentContext)=>({ getState: getState })=>!!getState().contentTargets[contentContext],
        setTarget: (toAdd, target)=>({ getState: getState, setState: setState })=>{
                const currentTargets = getState().contentTargets;
                // Store as array, append if not already present
                const existing = currentTargets[toAdd];
                const targetList = existing ?? [];
                // Avoid duplicates by checking if target with same id exists
                // & filter out any targets with empty IDs to avoid stale targets
                const filtered = targetList.filter((t)=>t.id !== '' && t.id !== target.id);
                filtered.push(target);
                setState({
                    contentTargets: {
                        ...currentTargets,
                        [toAdd]: filtered
                    }
                });
            },
        clearTarget: (toRemove, targetId)=>({ getState: getState, setState: setState })=>{
                const currentState = getState().contentTargets;
                const nextState = {};
                for (const key of Object.keys(currentState)){
                    const k = key;
                    if (k !== toRemove) nextState[k] = currentState[k];
                    else if (targetId) {
                        // If a specific targetId is provided, filter out that target
                        const targetList = currentState[k];
                        const filtered = targetList.filter((t)=>t.id !== targetId);
                        if (filtered.length > 0) nextState[k] = filtered;
                    }
                }
                setState({
                    contentTargets: nextState
                });
            },
        setCurrentTargetId: (targetId)=>({ setState: setState })=>{
                setState({
                    currentTargetId: targetId
                });
            },
        getCurrentTargetId: ()=>({ getState: getState })=>getState().currentTargetId,
        setSmartCreationModalSurface: (surface)=>({ setState: setState })=>{
                setState({
                    smartCreationModalSurface: surface
                });
            },
        getSmartCreationModalSurface: ()=>({ getState: getState })=>getState().smartCreationModalSurface
    }
});
const $2a83073b2ae5e0c1$export$53bf948a400e8426 = (0, $kBr4q.createActionsHook)($2a83073b2ae5e0c1$export$6f57813fe9f31bf9);
const $2a83073b2ae5e0c1$export$9465f65715425f1b = (0, $kBr4q.createHook)($2a83073b2ae5e0c1$export$6f57813fe9f31bf9, {
    selector: (state)=>state.editorContext
});
const $2a83073b2ae5e0c1$export$eea520981851a092 = (0, $kBr4q.createHook)($2a83073b2ae5e0c1$export$6f57813fe9f31bf9, {
    selector: (state)=>state.whiteboardContext
});
const $2a83073b2ae5e0c1$export$c517e9a5e436c401 = (0, $kBr4q.createHook)($2a83073b2ae5e0c1$export$6f57813fe9f31bf9, {
    selector: (state)=>state.slidesContext
});
const $2a83073b2ae5e0c1$export$debe3dc2612d2a8e = (0, $kBr4q.createHook)($2a83073b2ae5e0c1$export$6f57813fe9f31bf9, {
    selector: (state)=>state.databaseContext
});
const $2a83073b2ae5e0c1$export$376b2a7bf70dad8 = (0, $kBr4q.createHook)($2a83073b2ae5e0c1$export$6f57813fe9f31bf9, {
    selector: (state)=>state.browserContext
});
const $2a83073b2ae5e0c1$export$6280f21050465fe4 = (0, $kBr4q.createHook)($2a83073b2ae5e0c1$export$6f57813fe9f31bf9, {
    selector: (state)=>state.pageSmartLinks
});
const $2a83073b2ae5e0c1$export$3794ec8d9f571031 = (0, $kBr4q.createHook)($2a83073b2ae5e0c1$export$6f57813fe9f31bf9, {
    selector: (state)=>state.aiFeatureContext
});
const $2a83073b2ae5e0c1$export$3d0a0ac192a7df7e = (0, $kBr4q.createHook)($2a83073b2ae5e0c1$export$6f57813fe9f31bf9, {
    selector: (state)=>state.artifactContext
});
const $2a83073b2ae5e0c1$export$c6b34f9422255776 = (0, $kBr4q.createHook)($2a83073b2ae5e0c1$export$6f57813fe9f31bf9, {
    selector: (state)=>state.smartCreationModalSurface
});
const $2a83073b2ae5e0c1$export$904052abb7b98535 = ({ requestBrowserContent: requestBrowserContent, getContentBody: getContentBody, getAdditionalContext: getAdditionalContext = async ()=>undefined, getStagingSpace: getStagingSpace, useCurrentNonEditingPageAsContext: useCurrentNonEditingPageAsContext, requestJiraContext: requestJiraContext, useCurrentPageContext: useCurrentPageContext, useCurrentBrowsingContext: configuredUseCurrentBrowsingContext })=>{
    const { getStagingAreaEntryPoint: getStagingAreaEntryPoint } = (0, $8akfd.useStagingAreaActions)();
    const actions = $2a83073b2ae5e0c1$export$53bf948a400e8426();
    const { getTarget: getTarget, getCurrentTargetId: getCurrentTargetId } = actions;
    const fetchContent = (0, $cozmU.useCallback)(async ({ type: type, contentContext: contentContext, activeTargetId: activeTargetId, source: source, prompt: prompt })=>{
        const currentTargetId = getCurrentTargetId();
        const contentTarget = getTarget(contentContext, activeTargetId);
        if (!contentTarget) {
            /*
       * No target normally means there is genuinely no content to read.
       *
       * The browser extension is the exception. A target is only registered from
       * `ContentReadyCommand`, and the Confluence page hosts its own chat, so `rovo-chat` is a
       * local client there and the command is invoked in-process instead of crossing the
       * extension transport. The bus context the bridge relays is all the extension ever gets,
       * so use it rather than sending the backend no document and silently dropping the edit.
       *
       * Narrow, because the relayed context is always the whole global page and carries no id
       * to check it against: pages only, global context only, never while a staging area exists
       * (same reason as `shouldUseCurrentTargetId` below - do not touch content behind the
       * modal), and never as a substitute for an explicit target that was not found.
       * The bridge's own experiment gates it, but the experiment is on for the product half of
       * the bridge too, so it does not scope this to the extension by itself.
       */ if (type === 'page' && contentContext === 'global' && activeTargetId === undefined && !getTarget('staging-area') && $2a83073b2ae5e0c1$var$isBridgeRelayedEditorContextEnabled()) {
                const relayedEditorContext = actions.getEditorContext();
                if (relayedEditorContext?.document?.content) return relayedEditorContext;
            }
            return undefined;
        }
        // Only use currentTargetId when staging-area doesn't exist
        // to avoid changing any content open behind the staging
        // area modal
        const shouldUseCurrentTargetId = type === 'page' && !getTarget('staging-area');
        // A bridge torn down during SPA navigation may leave currentTargetId pointing at
        // content that no longer exists. A follow-up can also explicitly select a different
        // registered target. In the experiment, use the selected contentTarget in either case.
        const shouldIgnoreCurrentTargetId = shouldUseCurrentTargetId && !!currentTargetId && (!getTarget(contentContext, currentTargetId) || activeTargetId !== undefined && currentTargetId !== activeTargetId) && (0, $4o0zT.isExperimentEnabled)('aifc_creation_context_stale_target_fix');
        const selectedTargetId = shouldUseCurrentTargetId && !shouldIgnoreCurrentTargetId ? currentTargetId || contentTarget.id : contentTarget.id;
        const contentBody = await getContentBody({
            type: type,
            id: selectedTargetId,
            source: source,
            prompt: prompt
        });
        if (!contentBody || contentBody.contentType !== type) return undefined;
        switch(contentBody.contentType){
            case 'page':
                if (!contentBody.pageBody) return undefined;
                return {
                    contentId: contentBody.contentId,
                    editorStreamingContractVersion: contentBody.editorStreamingContractVersion,
                    hasRealTimeCollab: contentBody.hasRealTimeCollab,
                    useFastPath: contentBody.useFastPath,
                    document: {
                        type: 'text/adf',
                        content: contentBody.pageBody
                    },
                    selection: {
                        type: 'text/markdown',
                        content: contentBody.selectionMarkdown || ''
                    },
                    selectionFragment: contentBody.selectionFragment,
                    selectionLocalIds: contentBody.selectionLocalIds,
                    contentMauiId: contentBody.contentMauiId,
                    dynamicUiSource: contentBody.dynamicUiSource,
                    dynamicUiType: contentBody.dynamicUiType,
                    dynamicUiSubtype: contentBody.dynamicUiSubtype,
                    mediaFileId: contentBody.mediaFileId,
                    mediaCollection: contentBody.mediaCollection,
                    isViewMode: contentBody.isViewMode,
                    isDraftLockedForEditing: contentBody.isDraftLockedForEditing,
                    useGenericEditorSkill: contentBody.useGenericEditorSkill,
                    additionalContext: contentBody.additionalContext
                };
            case 'whiteboard':
                if (!contentBody.svg || !contentBody.wdf) return undefined;
                return {
                    contentId: contentBody.contentId,
                    type: 'image/svg+xml',
                    svg: contentBody.svg,
                    title: contentBody.title ?? null,
                    url: contentBody.url ?? null,
                    wdf: contentBody.wdf,
                    selectedElementIds: contentBody.selectedElementIds,
                    isViewMode: contentBody.isViewMode
                };
            case 'slide':
                if (!contentBody.xml) return undefined;
                return {
                    contentId: contentBody.contentId,
                    xml: contentBody.xml,
                    title: contentBody.title,
                    url: contentBody.url,
                    selectedSlideIndex: contentBody.selectedSlideIndex,
                    selectedElementIds: contentBody.selectedElementIds,
                    selectedTargets: contentBody.selectedTargets,
                    isViewMode: contentBody.isViewMode
                };
            case 'database':
                if (!contentBody.csv) return undefined;
                return {
                    contentId: contentBody.contentId,
                    csv: contentBody.csv,
                    title: contentBody.title,
                    url: contentBody.url,
                    isViewMode: contentBody.isViewMode
                };
            case 'dashboard':
                if (!contentBody.content) return undefined;
                return {
                    content: contentBody.content,
                    dashboardAri: contentBody.dashboardAri,
                    isEditing: contentBody.isEditing,
                    chartResponseData: contentBody.chartResponseData,
                    location: contentBody.location,
                    products: contentBody.products,
                    subProducts: contentBody.subProducts
                };
            default:
                return undefined;
        }
    }, [
        actions,
        getContentBody,
        getTarget,
        getCurrentTargetId
    ]);
    /**
   * Fetches the context of a currently live page with Rovo chat open.
   *
   * @description see full list of cases to consider in {@link getContextRequirements}
   */ const getEditorContext = (0, $cozmU.useCallback)(async ({ source: source_0, prompt: prompt_0, contentContext: contentContext_0, isFirstPrompt: isFirstPrompt, addCurrentPageAsContextUserPreference: addCurrentPageAsContextUserPreference, activeTargetId: activeTargetId_0 })=>{
        const shouldProvideContext = $2a83073b2ae5e0c1$export$86d7678a1db25436({
            contentContext: contentContext_0,
            source: source_0,
            isFirstPrompt: isFirstPrompt,
            isAifcEnabled: true,
            userPreference: addCurrentPageAsContextUserPreference
        });
        if (!shouldProvideContext) return undefined;
        return await fetchContent({
            type: 'page',
            contentContext: contentContext_0,
            activeTargetId: activeTargetId_0,
            source: source_0,
            prompt: prompt_0
        });
    }, [
        fetchContent
    ]);
    /**
   * Fetches the context of a currently live page with Rovo chat open.
   *
   * @description see full list of cases to consider in {@link getContextRequirements}
   */ const getWhiteboardContext = (0, $cozmU.useCallback)(async ({ source: source_1, contentContext: contentContext_1, isFirstPrompt: isFirstPrompt_0, addCurrentPageAsContextUserPreference: addCurrentPageAsContextUserPreference_0, activeTargetId: activeTargetId_1 })=>{
        const shouldProvideContext_0 = $2a83073b2ae5e0c1$export$86d7678a1db25436({
            contentContext: contentContext_1,
            source: source_1,
            isFirstPrompt: isFirstPrompt_0,
            isAifcEnabled: true,
            userPreference: addCurrentPageAsContextUserPreference_0
        });
        if (!shouldProvideContext_0) return undefined;
        return await fetchContent({
            type: 'whiteboard',
            contentContext: contentContext_1,
            activeTargetId: activeTargetId_1
        });
    }, [
        fetchContent
    ]);
    const getSlidesContext = (0, $cozmU.useCallback)(async ({ source: source_2, contentContext: contentContext_2, isFirstPrompt: isFirstPrompt_1, addCurrentPageAsContextUserPreference: addCurrentPageAsContextUserPreference_1, activeTargetId: activeTargetId_2 })=>{
        const isAifcEnabled = !(0, $iDrrr.fg)('cc-mui-slides-opted-out') && (0, $cXtTj.default).getExperimentValue('cc-mui-slides-experiment', 'isEnabled', false);
        const shouldProvideContext_1 = $2a83073b2ae5e0c1$export$86d7678a1db25436({
            contentContext: contentContext_2,
            source: source_2,
            isFirstPrompt: isFirstPrompt_1,
            isAifcEnabled: isAifcEnabled,
            userPreference: addCurrentPageAsContextUserPreference_1
        });
        if (!shouldProvideContext_1) return undefined;
        return isAifcEnabled ? await fetchContent({
            type: 'slide',
            contentContext: contentContext_2,
            activeTargetId: activeTargetId_2
        }) : actions.getSlidesContext();
    }, [
        actions,
        fetchContent
    ]);
    const getDatabaseContext = (0, $cozmU.useCallback)(async ({ source: source_3, contentContext: contentContext_3, isFirstPrompt: isFirstPrompt_2, addCurrentPageAsContextUserPreference: addCurrentPageAsContextUserPreference_2, activeTargetId: activeTargetId_3 })=>{
        const shouldProvideContext_2 = $2a83073b2ae5e0c1$export$86d7678a1db25436({
            contentContext: contentContext_3,
            source: source_3,
            isFirstPrompt: isFirstPrompt_2,
            isAifcEnabled: true,
            userPreference: addCurrentPageAsContextUserPreference_2
        });
        if (!shouldProvideContext_2) return undefined;
        return await fetchContent({
            type: 'database',
            contentContext: contentContext_3,
            activeTargetId: activeTargetId_3
        });
    }, [
        fetchContent
    ]);
    const getDashboardEditorContext = (0, $cozmU.useCallback)(async ({ contentContext: contentContext_4, activeTargetId: activeTargetId_4 })=>{
        return await fetchContent({
            type: 'dashboard',
            contentContext: contentContext_4,
            activeTargetId: activeTargetId_4
        });
    }, [
        fetchContent
    ]);
    const getSpaceCreateContext = (0, $cozmU.useCallback)(({ contentContext: contentContext_5, isFirstPrompt: isFirstPrompt_3 })=>{
        if (contentContext_5 === 'staging-area' && !isFirstPrompt_3 && (0, $iDrrr.fg)('aifc_space_creation_enabled')) return getStagingSpace(String(getTarget(contentContext_5)?.id));
    }, [
        getStagingSpace,
        getTarget
    ]);
    const getIsStagingArea = (0, $cozmU.useCallback)(()=>actions.getActiveContext() === 'staging-area', [
        actions
    ]);
    /**
   * Whether the chat was launched about one specific linked thing, rather than about the page the
   * user is on. Pinned items use `context_resource`; existing linked-entity flows such as the
   * Smart Link toolbar and onboarding use `projectContext`.
   *
   * Rovo Spaces launches populate `projectContext` too, but with `projectUrl: ''`, because a space
   * has no canonical URL. Those should still offer the current page, hence the non-empty check.
   */ const hasEntityContext = (0, $cozmU.useCallback)(()=>{
        const aiFeatureContext = actions.getAIFeatureContext();
        const contextResourceAri = aiFeatureContext?.context_resource?.ari;
        const hasContextResource = (0, $4o0zT.isExperimentEnabled)('rovo_your_work_tab_pin_objects') && typeof contextResourceAri === 'string' && contextResourceAri !== '';
        const projectUrl = aiFeatureContext?.projectContext?.projectUrl;
        const hasProjectContext = typeof projectUrl === 'string' && projectUrl !== '';
        return hasContextResource || hasProjectContext;
    }, [
        actions
    ]);
    const useCurrentBrowsingContext = (0, $cozmU.useCallback)((addCurrentPageAsContextUserPreference_3)=>{
        if (configuredUseCurrentBrowsingContext !== undefined) return configuredUseCurrentBrowsingContext;
        // Drive useCurrentBrowsingContext directly from the chat mode store's
        // `useCurrentPageContext` toggle: when the user has current-page context
        // enabled we treat the current page as usable context, and off otherwise.
        if ((0, $iDrrr.fg)('rovo_browsing_context_from_banner')) {
            // The CwR modal shows no current page context in the UI, so never send it.
            if (getIsStagingArea() && (0, $iDrrr.fg)('cwr_isolate_smart_create_agent_selection')) return false;
            // A `true` here tells the backend to use `browser_url`, so a chat launched about a
            // link would answer about the host page instead of the link. `useCurrentPageContext`
            // cannot be used to spot that case: such launches force it on, because the context
            // banner only renders while it is true.
            if (hasEntityContext()) return false;
            return useCurrentPageContext;
        }
        // If the user has explicitly turned off "use current page as context" (e.g.
        // by dismissing the context banner), send false rather than undefined so the
        // backend is explicitly told not to use the browserUrl as context. This is
        // required in edit mode, where useCurrentNonEditingPageAsContext is undefined
        // but the user preference is set to false on dismiss. the value is sent as true
        // when the context is enabled in the chat banner.
        if (addCurrentPageAsContextUserPreference_3) return addCurrentPageAsContextUserPreference_3;
        // undefined means don't send useCurrentBrowsingContext at all. false tells backend to explicitly not use the browserUrl as context.
        if (useCurrentNonEditingPageAsContext === undefined) return undefined;
        const stagingAreaEnabled = getIsStagingArea();
        return !stagingAreaEnabled && addCurrentPageAsContextUserPreference_3 && useCurrentNonEditingPageAsContext;
    }, [
        configuredUseCurrentBrowsingContext,
        useCurrentNonEditingPageAsContext,
        getIsStagingArea,
        useCurrentPageContext,
        hasEntityContext
    ]);
    const getBrowserContext = (0, $cozmU.useCallback)(async ({ addCurrentPageAsContextUserPreference: addCurrentPageAsContextUserPreference_4, enabled: enabled })=>{
        // if the feature is not enabled, we return the original context resolution.
        if (!enabled && !(0, $cXtTj.default).getExperimentValue('jira_free_gen_editor', 'isEnabled', false)) return actions.getBrowserContext();
        if (!addCurrentPageAsContextUserPreference_4) return undefined;
        const storedBrowserContext = actions.getBrowserContext();
        // Request browser content from the extension
        const browserContextResult = await requestBrowserContent();
        if (!browserContextResult) return storedBrowserContext;
        if (browserContextResult.selection) return {
            context: browserContextResult
        };
        const storedSelection = storedBrowserContext?.context?.selection;
        return {
            context: storedSelection ? {
                ...browserContextResult,
                selection: storedSelection
            } : browserContextResult
        };
    }, [
        requestBrowserContent,
        actions
    ]);
    const getJiraContext = (0, $cozmU.useCallback)(async ()=>{
        const isStagingArea = getIsStagingArea();
        if (!isStagingArea) {
            const jiraCreateContext = actions.getJiraCreateContext();
            if (jiraCreateContext?.draftWorkItems) return jiraCreateContext;
        }
        // Fallback to bridge API if available (staging area doesn't have the state in sync with the chat store)
        if (!requestJiraContext) return undefined;
        try {
            const result = await requestJiraContext();
            return result?.success ? result.context : undefined;
        // eslint-disable-next-line no-unused-vars
        } catch (error) {
            return undefined;
        }
    }, [
        requestJiraContext,
        actions,
        getIsStagingArea
    ]);
    return {
        ...actions,
        getAdditionalContext: getAdditionalContext,
        getEditorContext: getEditorContext,
        getWhiteboardContext: getWhiteboardContext,
        getSlidesContext: getSlidesContext,
        getSpaceCreateContext: getSpaceCreateContext,
        getIsStagingArea: getIsStagingArea,
        getStagingAreaEntryPoint: getStagingAreaEntryPoint,
        useCurrentBrowsingContext: useCurrentBrowsingContext,
        getDatabaseContext: getDatabaseContext,
        getDashboardEditorContext: getDashboardEditorContext,
        getBrowserContext: getBrowserContext,
        getJiraContext: getJiraContext
    };
};
function $2a83073b2ae5e0c1$export$86d7678a1db25436({ contentContext: contentContext, source: source, isFirstPrompt: isFirstPrompt, isAifcEnabled: isAifcEnabled, userPreference: userPreference }) {
    /**
   * If AIFC is not enabled, we default to the user's preference.
   */ if (!isAifcEnabled) return userPreference;
    /**
   * In the staging area, we always want to provide context if the source is the
   * inline editor, from the blank object experience, or if the prompt is not the
   * first in a new conversation.
   */ const sourceEligible = source === 'CONFLUENCE_INLINE_EDITOR' || source === 'INLINE_EDITOR' || source === 'CONFLUENCE_MAUI_INLINE_EDITOR' || source === 'CONFLUENCE_WHITEBOARD_TO_PAGE_BUTTON' || source === 'CONFLUENCE_WHITEBOARD_BRAINSTORMING_FOLLOW_UP' || source === 'CONFLUENCE_CWR_TEMPLATE' || source === 'CONFLUENCE_CWR_BLANK_OBJECT';
    if (contentContext === 'staging-area') return sourceEligible || !isFirstPrompt;
    else /**
     * On real content when AIFC is enabled, we only want to default to true
     * if the source of the content is the inline editing experience. Otherwise,
     * we want to respect the preference chosen by the user.
     */ return sourceEligible || userPreference;
}
module.exports["store"] = $2a83073b2ae5e0c1$export$6f57813fe9f31bf9;
module.exports["useChatContextStoreActions"] = $2a83073b2ae5e0c1$export$53bf948a400e8426;
module.exports["useChatContextEditorContext"] = $2a83073b2ae5e0c1$export$9465f65715425f1b;
module.exports["useChatContextDatabaseContext"] = $2a83073b2ae5e0c1$export$debe3dc2612d2a8e;
module.exports["useChatContextBrowserContext"] = $2a83073b2ae5e0c1$export$376b2a7bf70dad8;
module.exports["useChatContextPageSmartLinks"] = $2a83073b2ae5e0c1$export$6280f21050465fe4;
module.exports["useChatContextAIFeatureContext"] = $2a83073b2ae5e0c1$export$3794ec8d9f571031;
module.exports["useChatContextArtifactContext"] = $2a83073b2ae5e0c1$export$3d0a0ac192a7df7e;
module.exports["useSmartCreationModalSurface"] = $2a83073b2ae5e0c1$export$c6b34f9422255776;
module.exports["useChatContextProvider"] = $2a83073b2ae5e0c1$export$904052abb7b98535;

});

parcelRegister("2pQiO", function(module, exports) {

var $a4RZV = parcelRequire("a4RZV");

function $1295d9cf79f622cc$export$da472ee01c19d92e(experimentName, param, defaultValue) {
    return (0, $a4RZV.expValInternal)(experimentName, param, defaultValue, false);
}
module.exports["UNSAFE_expValNoExposure"] = $1295d9cf79f622cc$export$da472ee01c19d92e;

});

parcelRegister("8akfd", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $d9cc5462c799c5c3$var$initialState = {
    messageIdSelectedForPreview: null,
    invocationIdSelectedForPreview: null,
    stagingAreaMode: undefined,
    stagingAreaEntryPoint: '',
    prompt: '',
    promptAppConnectorSources: [],
    isThirdPartyPromptStaged: false,
    dynamicUiType: undefined,
    dynamicUiSubtype: undefined,
    userSelectedDynamicUiSubtype: undefined,
    userSelectedDynamicUiSubtypeConversationId: undefined,
    dynamicUiSource: undefined,
    interactionSource: undefined,
    isRemixUpdating: false,
    forceSkipAutoConversationSelection: false,
    currentDisplayMessageId: undefined,
    closeModalCallback: null,
    previewSelection: undefined
};
const $d9cc5462c799c5c3$var$actions = {
    setMessageIdSelectedForPreview: (messageId)=>({ setState: setState })=>{
            setState({
                messageIdSelectedForPreview: messageId
            });
        },
    getMessageIdSelectedForPreview: ()=>({ getState: getState })=>{
            return getState().messageIdSelectedForPreview;
        },
    setStagingAreaMode: (mode, entryPoint)=>({ setState: setState })=>{
            setState({
                stagingAreaMode: mode,
                stagingAreaEntryPoint: entryPoint ?? ''
            });
        },
    openStagingAreaPreview: ({ entryPoint: entryPoint, invocationId: invocationId, messageId: messageId, mode: mode })=>({ setState: setState })=>{
            setState({
                invocationIdSelectedForPreview: invocationId,
                messageIdSelectedForPreview: messageId,
                stagingAreaEntryPoint: entryPoint,
                stagingAreaMode: mode
            });
        },
    closeStagingAreaPreview: (entryPoint)=>({ getState: getState, setState: setState })=>{
            if (getState().stagingAreaEntryPoint !== entryPoint) return;
            setState({
                invocationIdSelectedForPreview: null,
                messageIdSelectedForPreview: null,
                stagingAreaEntryPoint: '',
                stagingAreaMode: undefined
            });
        },
    getStagingAreaEntryPoint: ()=>({ getState: getState })=>getState().stagingAreaEntryPoint,
    setStagingAreaEntryPoint: (entryPoint)=>({ setState: setState })=>{
            setState({
                stagingAreaEntryPoint: entryPoint ?? ''
            });
        },
    setPrompt: (prompt)=>({ setState: setState })=>{
            setState({
                prompt: prompt
            });
        },
    /**
   * Writes `isThirdPartyPromptStaged` in the same update, so the flag cannot drift from the
   * source list. Omitting `isThirdPartyPrompt` derives it from the list, which is what the
   * one-argument call has always meant: before this experiment a non-empty list was the only way
   * to stage a 3P prompt. Pass it for a 3P tile that carried no connectors — an empty list the
   * reader must still attribute to the experiment (CCINT-8714).
   */ setPromptAppConnectorSources: (promptAppConnectorSources, options)=>({ setState: setState })=>{
            setState({
                promptAppConnectorSources: promptAppConnectorSources,
                isThirdPartyPromptStaged: options?.isThirdPartyPrompt ?? promptAppConnectorSources.length > 0
            });
        },
    setInvocationIdSelectedForPreview: (invocationId)=>({ setState: setState })=>{
            setState({
                invocationIdSelectedForPreview: invocationId
            });
        },
    getInvocationIdSelectedForPreview: ()=>({ getState: getState })=>{
            return getState().invocationIdSelectedForPreview;
        },
    setIsRemixUpdating: (isUpdating)=>({ setState: setState })=>{
            setState({
                isRemixUpdating: isUpdating
            });
        },
    setDynamicUiContext: (dynamicUiType, dynamicUiSubtype, dynamicUiSource)=>({ setState: setState })=>{
            setState({
                dynamicUiType: dynamicUiType,
                dynamicUiSubtype: dynamicUiSubtype,
                dynamicUiSource: dynamicUiSource
            });
        },
    setUserSelectedDynamicUiSubtype: (userSelectedDynamicUiSubtype, conversationId)=>({ setState: setState })=>{
            setState({
                userSelectedDynamicUiSubtype: userSelectedDynamicUiSubtype,
                userSelectedDynamicUiSubtypeConversationId: userSelectedDynamicUiSubtype ? conversationId : undefined
            });
        },
    setInteractionSource: (interactionSource)=>({ setState: setState })=>{
            setState({
                interactionSource: interactionSource
            });
        },
    resetStagingArea: (options)=>({ getState: getState, setState: setState })=>{
            const state = getState();
            // A Remix can seed its pick before opening Rovo for disambiguation. Reset the old
            // preview on that switch, but retain the pick only when it belongs to the destination.
            const preserveRequestedSubtype = options?.preserveRequestedSubtypeForConversationId !== undefined && options.preserveRequestedSubtypeForConversationId === state.userSelectedDynamicUiSubtypeConversationId;
            setState({
                messageIdSelectedForPreview: null,
                invocationIdSelectedForPreview: null,
                isRemixUpdating: false,
                stagingAreaMode: undefined,
                stagingAreaEntryPoint: '',
                promptAppConnectorSources: [],
                isThirdPartyPromptStaged: false,
                dynamicUiType: undefined,
                dynamicUiSubtype: undefined,
                userSelectedDynamicUiSubtype: preserveRequestedSubtype ? state.userSelectedDynamicUiSubtype : undefined,
                userSelectedDynamicUiSubtypeConversationId: preserveRequestedSubtype ? state.userSelectedDynamicUiSubtypeConversationId : undefined,
                dynamicUiSource: undefined,
                interactionSource: undefined,
                forceSkipAutoConversationSelection: false,
                currentDisplayMessageId: undefined,
                previewSelection: undefined
            });
        },
    setForceSkipAutoConversationSelection: (forceSkip)=>({ setState: setState })=>{
            setState({
                forceSkipAutoConversationSelection: forceSkip
            });
        },
    setCurrentDisplayMessageId: (messageId)=>({ setState: setState })=>{
            setState({
                currentDisplayMessageId: messageId
            });
        },
    setCloseModalCallback: (closeModalCallback)=>({ setState: setState })=>{
            setState({
                closeModalCallback: closeModalCallback
            });
        },
    closeStagingAreaModal: ()=>({ getState: getState })=>{
            getState().closeModalCallback?.();
        },
    setPreviewSelection: (previewSelection)=>({ setState: setState })=>{
            setState({
                previewSelection: previewSelection
            });
        }
};
const $d9cc5462c799c5c3$var$store = (0, $8s9DV.createStore)({
    initialState: $d9cc5462c799c5c3$var$initialState,
    actions: $d9cc5462c799c5c3$var$actions
});
const $d9cc5462c799c5c3$export$a2795b51ce92008f = (0, $kBr4q.createHook)($d9cc5462c799c5c3$var$store, {
    selector: (state)=>state.messageIdSelectedForPreview
});
const $d9cc5462c799c5c3$export$a5e7db37858cd8ed = (0, $kBr4q.createStateHook)($d9cc5462c799c5c3$var$store, {
    selector: (state)=>state.previewSelection
});
const $d9cc5462c799c5c3$export$916334da9df8d04 = (0, $kBr4q.createHook)($d9cc5462c799c5c3$var$store);
const $d9cc5462c799c5c3$export$8f9a13b17bec42d5 = (0, $kBr4q.createActionsHook)($d9cc5462c799c5c3$var$store);
const $d9cc5462c799c5c3$export$5a57f796673aabea = (0, $kBr4q.createStateHook)($d9cc5462c799c5c3$var$store);
module.exports["useMessageIdSelectedForPreview"] = $d9cc5462c799c5c3$export$a2795b51ce92008f;
module.exports["usePreviewSelection"] = $d9cc5462c799c5c3$export$a5e7db37858cd8ed;
module.exports["useStagingArea"] = $d9cc5462c799c5c3$export$916334da9df8d04;
module.exports["useStagingAreaActions"] = $d9cc5462c799c5c3$export$8f9a13b17bec42d5;
module.exports["useStagingAreaState"] = $d9cc5462c799c5c3$export$5a57f796673aabea;

});

parcelRegister("k4g8h", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

function $c96a99d0f4ee3b3b$export$6c91fec22056810a(error) {
    return error?.type === 'rateLimited';
}
function $c96a99d0f4ee3b3b$export$f2905d128e30c457(error) {
    return error ? [
        'conversationNotFound',
        'conversationEmptyOrNotPresentInStore',
        'hipaa',
        'generic'
    ].includes(error.type) : false;
}
function $c96a99d0f4ee3b3b$export$a44d3d1877743c92(error) {
    return $c96a99d0f4ee3b3b$export$6c91fec22056810a(error) ? error.rateLimitedActionType : undefined;
}
const $c96a99d0f4ee3b3b$var$store = (0, $8s9DV.createStore)({
    name: 'rovoChatSignals',
    initialState: {
        conversationError: undefined,
        status: 'launching'
    },
    actions: {
        setConversationError: (conversationError)=>({ setState: setState })=>{
                setState({
                    conversationError: conversationError
                });
            },
        setStatus: (status)=>({ setState: setState })=>{
                setState({
                    status: status
                });
            }
    }
});
const $c96a99d0f4ee3b3b$export$63ceb69e3e2574ee = (0, $kBr4q.createActionsHook)($c96a99d0f4ee3b3b$var$store);
const $c96a99d0f4ee3b3b$export$4eeff361c6b400be = (0, $kBr4q.createHook)($c96a99d0f4ee3b3b$var$store, {
    selector: (state)=>({
            conversationError: state.conversationError,
            status: state.status
        })
});
module.exports["isRateLimited"] = $c96a99d0f4ee3b3b$export$6c91fec22056810a;
module.exports["isFullScreenError"] = $c96a99d0f4ee3b3b$export$f2905d128e30c457;
module.exports["getRateLimitedActionType"] = $c96a99d0f4ee3b3b$export$a44d3d1877743c92;
module.exports["useChatSignalsActions"] = $c96a99d0f4ee3b3b$export$63ceb69e3e2574ee;
module.exports["useChatSignals"] = $c96a99d0f4ee3b3b$export$4eeff361c6b400be;

});

parcelRegister("lTU4O", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");


var $cXtTj = parcelRequire("cXtTj");


var $iDrrr = parcelRequire("iDrrr");


var $iWk4y = parcelRequire("iWk4y");


var $2TZSo = parcelRequire("2TZSo");


var $isp1U = parcelRequire("isp1U");

const $1dccc6823e49008a$export$205c270e325a7524 = (aaid)=>{
    if ((0, $iDrrr.fg)('rovo_ai_mate_reliability_contracts')) try {
        const stored = (0, $iWk4y.withNonEssentialLocalStorage)((0, $2TZSo.LS_USER_PREFERENCES_KEY), ()=>// eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- guarded optional preference storage
            localStorage.getItem((0, $2TZSo.LS_USER_PREFERENCES_KEY)));
        const preferences = JSON.parse(stored || '{}');
        if (!preferences || typeof preferences !== 'object' || Array.isArray(preferences)) return undefined;
        const candidate = Object.prototype.hasOwnProperty.call(preferences, aaid) ? preferences[aaid] : undefined;
        if (!candidate || typeof candidate !== 'object' || Array.isArray(candidate)) return undefined;
        const values = candidate;
        // Old records may contain only storeUserMessages. Keep the existing defaults
        // for missing fields and never restore unknown or incorrectly typed values.
        return {
            storeUserMessages: typeof values.storeUserMessages === 'boolean' ? values.storeUserMessages : (0, $cXtTj.default).initializeCalled() && (0, $cXtTj.default).checkGate('ai_mate_show_store_messages'),
            useEditorContext: typeof values.useEditorContext === 'boolean' ? values.useEditorContext : true,
            ...typeof values.storeUserMessageMigratedToBE === 'boolean' ? {
                storeUserMessageMigratedToBE: values.storeUserMessageMigratedToBE
            } : {},
            ...typeof values.hasSeenFeedbackOptInPrompt === 'boolean' ? {
                hasSeenFeedbackOptInPrompt: values.hasSeenFeedbackOptInPrompt
            } : {}
        };
    } catch  {
        // Corrupt JSON, denied storage and unavailable browser globals must not
        // prevent chat from loading. In-memory defaults remain authoritative.
        return undefined;
    }
    const preferences = JSON.parse(// eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.getItem((0, $2TZSo.LS_USER_PREFERENCES_KEY)) || '{}');
    return preferences[aaid];
};
const $1dccc6823e49008a$var$store = (0, $8s9DV.createStore)({
    initialState: {
        preferences: {
            // ideally we want to set the preference in the react component because
            // FF evaluated in module level may not resolve to correct value during SSR
            // however because there is localStorage setting and `firstLoad`, it requires a bit of refactoring to do it
            // this feature is only needed for dogfooding, so may not worth the refactor
            storeUserMessages: // eslint-disable-next-line @atlaskit/platform/no-module-level-eval
            (0, $cXtTj.default).initializeCalled() && (0, $cXtTj.default).checkGate('ai_mate_show_store_messages'),
            // default is undefined because we do not want migration to be started until we read from local storage value
            storeUserMessageMigratedToBE: undefined,
            useEditorContext: true
        },
        firstLoad: true
    },
    actions: {
        updatePreferences: (data)=>({ setState: setState, getState: getState })=>{
                setState({
                    preferences: {
                        ...getState().preferences,
                        ...data
                    },
                    firstLoad: false
                });
            }
    }
});
const $1dccc6823e49008a$var$useStore = (0, $kBr4q.createHook)($1dccc6823e49008a$var$store);
const $1dccc6823e49008a$export$b6472e0d8983f5f5 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(27);
    const { aaid: aaid } = (0, $isp1U.useProfileController)();
    const [t0, t1] = $1dccc6823e49008a$var$useStore();
    const { preferences: preferences, firstLoad: firstLoad } = t0;
    const { updatePreferences: storeUpdatePreferences } = t1;
    let t2;
    if ($[0] !== aaid || $[1] !== preferences || $[2] !== storeUpdatePreferences) {
        t2 = (data)=>{
            if (!aaid) return;
            storeUpdatePreferences(data);
            if ((0, $iDrrr.fg)("rovo_ai_mate_reliability_contracts")) {
                try {
                    (0, $iWk4y.withNonEssentialLocalStorage)((0, $2TZSo.LS_USER_PREFERENCES_KEY), ()=>localStorage.setItem((0, $2TZSo.LS_USER_PREFERENCES_KEY), JSON.stringify({
                            [aaid]: {
                                ...preferences,
                                ...data
                            }
                        })));
                } catch  {}
                return;
            }
            localStorage.setItem((0, $2TZSo.LS_USER_PREFERENCES_KEY), JSON.stringify({
                [aaid]: {
                    ...preferences,
                    ...data
                }
            }));
        };
        $[0] = aaid;
        $[1] = preferences;
        $[2] = storeUpdatePreferences;
        $[3] = t2;
    } else t2 = $[3];
    const updatePreferences = t2;
    let t3;
    if ($[4] !== updatePreferences) {
        t3 = (storeUserMessages)=>{
            updatePreferences({
                storeUserMessages: storeUserMessages
            });
        };
        $[4] = updatePreferences;
        $[5] = t3;
    } else t3 = $[5];
    const setStoreUserMessages = t3;
    let t4;
    if ($[6] !== updatePreferences) {
        t4 = (useEditorContext)=>{
            updatePreferences({
                useEditorContext: useEditorContext
            });
        };
        $[6] = updatePreferences;
        $[7] = t4;
    } else t4 = $[7];
    const setUseEditorContext = t4;
    let t5;
    if ($[8] !== aaid || $[9] !== updatePreferences) {
        t5 = ()=>{
            if (!aaid) return;
            updatePreferences({
                storeUserMessageMigratedToBE: true
            });
        };
        $[8] = aaid;
        $[9] = updatePreferences;
        $[10] = t5;
    } else t5 = $[10];
    const markStoreUserMessageMigratedToBE = t5;
    let t6;
    if ($[11] !== updatePreferences) {
        t6 = (hasSeenFeedbackOptInPrompt)=>{
            updatePreferences({
                hasSeenFeedbackOptInPrompt: hasSeenFeedbackOptInPrompt
            });
        };
        $[11] = updatePreferences;
        $[12] = t6;
    } else t6 = $[12];
    const setHasSeenFeedbackOptInPrompt = t6;
    let t7;
    let t8;
    if ($[13] !== aaid || $[14] !== firstLoad || $[15] !== updatePreferences) {
        t7 = ()=>{
            if (aaid && firstLoad) {
                const preferences_0 = $1dccc6823e49008a$export$205c270e325a7524(aaid);
                if (preferences_0) updatePreferences({
                    ...preferences_0,
                    ...preferences_0.storeUserMessageMigratedToBE ? {} : {
                        storeUserMessageMigratedToBE: false
                    }
                });
            }
        };
        t8 = [
            aaid,
            firstLoad,
            updatePreferences
        ];
        $[13] = aaid;
        $[14] = firstLoad;
        $[15] = updatePreferences;
        $[16] = t7;
        $[17] = t8;
    } else {
        t7 = $[16];
        t8 = $[17];
    }
    (0, $cozmU.useEffect)(t7, t8);
    const t9 = aaid ? preferences.storeUserMessageMigratedToBE : undefined;
    let t10;
    if ($[18] !== preferences || $[19] !== t9) {
        t10 = {
            ...preferences,
            storeUserMessageMigratedToBE: t9
        };
        $[18] = preferences;
        $[19] = t9;
        $[20] = t10;
    } else t10 = $[20];
    let t11;
    if ($[21] !== markStoreUserMessageMigratedToBE || $[22] !== setHasSeenFeedbackOptInPrompt || $[23] !== setStoreUserMessages || $[24] !== setUseEditorContext || $[25] !== t10) {
        t11 = {
            preferences: t10,
            setStoreUserMessages: setStoreUserMessages,
            setUseEditorContext: setUseEditorContext,
            setHasSeenFeedbackOptInPrompt: setHasSeenFeedbackOptInPrompt,
            markStoreUserMessageMigratedToBE: markStoreUserMessageMigratedToBE
        };
        $[21] = markStoreUserMessageMigratedToBE;
        $[22] = setHasSeenFeedbackOptInPrompt;
        $[23] = setStoreUserMessages;
        $[24] = setUseEditorContext;
        $[25] = t10;
        $[26] = t11;
    } else t11 = $[26];
    return t11;
} : ()=>{
    const { aaid: aaid } = (0, $isp1U.useProfileController)();
    const [{ preferences: preferences, firstLoad: firstLoad }, { updatePreferences: storeUpdatePreferences }] = $1dccc6823e49008a$var$useStore();
    const updatePreferences = (0, $cozmU.useCallback)((data)=>{
        if (!aaid) return;
        storeUpdatePreferences(data);
        if ((0, $iDrrr.fg)('rovo_ai_mate_reliability_contracts')) {
            try {
                (0, $iWk4y.withNonEssentialLocalStorage)((0, $2TZSo.LS_USER_PREFERENCES_KEY), ()=>// eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- guarded optional preference storage
                    localStorage.setItem((0, $2TZSo.LS_USER_PREFERENCES_KEY), JSON.stringify({
                        [aaid]: {
                            ...preferences,
                            ...data
                        }
                    })));
            } catch  {
            // Persistence is best-effort; the in-memory preference already changed.
            }
            return;
        }
        // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
        localStorage.setItem((0, $2TZSo.LS_USER_PREFERENCES_KEY), JSON.stringify({
            [aaid]: {
                ...preferences,
                ...data
            }
        }));
    }, [
        aaid,
        preferences,
        storeUpdatePreferences
    ]);
    const setStoreUserMessages = (0, $cozmU.useCallback)((storeUserMessages)=>{
        updatePreferences({
            storeUserMessages: storeUserMessages
        });
    }, [
        updatePreferences
    ]);
    const setUseEditorContext = (0, $cozmU.useCallback)((useEditorContext)=>{
        updatePreferences({
            useEditorContext: useEditorContext
        });
    }, [
        updatePreferences
    ]);
    const markStoreUserMessageMigratedToBE = (0, $cozmU.useCallback)(()=>{
        if (!aaid) return;
        updatePreferences({
            storeUserMessageMigratedToBE: true
        });
    }, [
        updatePreferences,
        aaid
    ]);
    const setHasSeenFeedbackOptInPrompt = (0, $cozmU.useCallback)((hasSeenFeedbackOptInPrompt)=>{
        updatePreferences({
            hasSeenFeedbackOptInPrompt: hasSeenFeedbackOptInPrompt
        });
    }, [
        updatePreferences
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (aaid && firstLoad) {
            const preferences_0 = $1dccc6823e49008a$export$205c270e325a7524(aaid);
            if (preferences_0) updatePreferences({
                ...preferences_0,
                ...preferences_0.storeUserMessageMigratedToBE ? {} : {
                    storeUserMessageMigratedToBE: false
                }
            });
        }
    }, [
        aaid,
        firstLoad,
        updatePreferences
    ]);
    return {
        preferences: {
            ...preferences,
            storeUserMessageMigratedToBE: aaid ? preferences.storeUserMessageMigratedToBE : undefined
        },
        setStoreUserMessages: setStoreUserMessages,
        setUseEditorContext: setUseEditorContext,
        setHasSeenFeedbackOptInPrompt: setHasSeenFeedbackOptInPrompt,
        markStoreUserMessageMigratedToBE: markStoreUserMessageMigratedToBE
    };
};
module.exports["useUserPreferences"] = $1dccc6823e49008a$export$b6472e0d8983f5f5;

});

parcelRegister("2TZSo", function(module, exports) {
const $9ca4df0845d80c9e$export$97d0beb2ccc70a4d = 'aiMateUserPreferences';
module.exports["LS_USER_PREFERENCES_KEY"] = $9ca4df0845d80c9e$export$97d0beb2ccc70a4d;

});

parcelRegister("2yWJZ", function(module, exports) {

var $2khPJ = parcelRequire("2khPJ");

const $7f640ed30a5677e6$export$62a80b577b02c670 = 'ai_mate_agent';
const $7f640ed30a5677e6$export$eaedd3c4d259c3db = 'f3a534d9-1498-e0d4-8b50-e058a8fb8156';
const $7f640ed30a5677e6$export$d4e191820de5cb9e = $7f640ed30a5677e6$export$62a80b577b02c670;
const $7f640ed30a5677e6$export$cf40b355c500b3f7 = $7f640ed30a5677e6$export$eaedd3c4d259c3db;
const $7f640ed30a5677e6$export$84f2221dfd1486e2 = 'SYSTEM';
const $7f640ed30a5677e6$export$d54b716922cade63 = (value)=>{
    const trimmed = value?.trim();
    return trimmed ? trimmed : undefined;
};
const $7f640ed30a5677e6$export$4529494ee013eb50 = ({ agentId: agentId, agentNamedId: agentNamedId })=>$7f640ed30a5677e6$export$d54b716922cade63(agentId) === $7f640ed30a5677e6$export$eaedd3c4d259c3db || $7f640ed30a5677e6$export$d54b716922cade63(agentNamedId) === $7f640ed30a5677e6$export$62a80b577b02c670;
const $7f640ed30a5677e6$export$71c4912d3c1bf3e3 = (value)=>{
    const normalizedValue = $7f640ed30a5677e6$export$d54b716922cade63(value);
    if (!normalizedValue) return undefined;
    if (!normalizedValue.includes('ari:')) return normalizedValue;
    try {
        return $7f640ed30a5677e6$export$d54b716922cade63((0, $2khPJ.IdentityUserAri).parse(normalizedValue).userId);
    } catch  {
        return undefined;
    }
};
module.exports["ROVO_AGENT_NAMED_ID"] = $7f640ed30a5677e6$export$62a80b577b02c670;
module.exports["ROVO_AGENT_UUID"] = $7f640ed30a5677e6$export$eaedd3c4d259c3db;
module.exports["DEFAULT_AGENT_NAMED_ID"] = $7f640ed30a5677e6$export$d4e191820de5cb9e;
module.exports["DEFAULT_AGENT_UUID"] = $7f640ed30a5677e6$export$cf40b355c500b3f7;
module.exports["DEFAULT_AGENT_CREATOR_TYPE"] = $7f640ed30a5677e6$export$84f2221dfd1486e2;
module.exports["trimToUndefined"] = $7f640ed30a5677e6$export$d54b716922cade63;
module.exports["isDefaultRovoChat"] = $7f640ed30a5677e6$export$4529494ee013eb50;
module.exports["normalizeAccountIdFromIdentityAri"] = $7f640ed30a5677e6$export$71c4912d3c1bf3e3;

});

parcelRegister("2khPJ", function(module, exports) {

var $aQ0yV = parcelRequire("aQ0yV");


var $9j37t = parcelRequire("9j37t");


var $glA79 = parcelRequire("glA79");

// src/identity/user/manifest.ts
var $1b1b4861ffbabf45$var$identityUserAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    resourceOwner: (0, $aQ0yV.IdentityUserAriResourceOwner),
    resourceType: (0, $aQ0yV.IdentityUserAriResourceType),
    resourceIdSlug: "{userId}",
    resourceIdSegmentFormats: {
        userId: /[a-zA-Z0-9_\-\:]{1,128}/
    }
};
// src/identity/user/index.ts
var $1b1b4861ffbabf45$export$1e9d09c2be53e55e = class _IdentityUserAri extends (0, $9j37t.RegisteredAri) {
    get userId() {
        return this._userId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $1b1b4861ffbabf45$var$identityUserAriStaticOpts.qualifier,
            platformQualifier: $1b1b4861ffbabf45$var$identityUserAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $1b1b4861ffbabf45$var$identityUserAriStaticOpts.resourceOwner,
            resourceType: $1b1b4861ffbabf45$var$identityUserAriStaticOpts.resourceType,
            resourceId: `${opts.userId}`,
            resourceIdSegmentValues: {
                userId: opts.userId
            }
        }, ariOpts = (0, $glA79.AriParser).fromOpts(derivedOpts, $1b1b4861ffbabf45$var$identityUserAriStaticOpts);
        return new _IdentityUserAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $glA79.AriParser).fromString(maybeAri, $1b1b4861ffbabf45$var$identityUserAriStaticOpts);
        return new _IdentityUserAri(opts);
    }
    getVariables() {
        return {
            userId: this.userId
        };
    }
    constructor(opts){
        super(opts), this._userId = opts.resourceIdSegmentValues.userId;
    }
};
module.exports["IdentityUserAri"] = $1b1b4861ffbabf45$export$1e9d09c2be53e55e;

});

parcelRegister("aQ0yV", function(module, exports) {
// src/identity/user/types.ts
var $7e3f325f95b56bab$export$b4c14c54282a779d = "identity", $7e3f325f95b56bab$export$e9b50e20f4fbfb71 = "user";
module.exports["IdentityUserAriResourceOwner"] = $7e3f325f95b56bab$export$b4c14c54282a779d;
module.exports["IdentityUserAriResourceType"] = $7e3f325f95b56bab$export$e9b50e20f4fbfb71;

});

parcelRegister("j1J3n", function(module, exports) {

var $dSoGR = parcelRequire("dSoGR");

const $76129364d697533a$export$5ea0e7c17cb45f8e = (0, $dSoGR.createCommand)('aifc-content-copied');
module.exports["AifcContentCopiedCommand"] = $76129364d697533a$export$5ea0e7c17cb45f8e;

});

parcelRegister("ah4h4", function(module, exports) {

var $dSoGR = parcelRequire("dSoGR");

const $76c053edffa0262f$export$55a0756191c25c0 = (0, $dSoGR.createCommand)('aifc-staging-selection-state');
module.exports["AifcStagingSelectionStateCommand"] = $76c053edffa0262f$export$55a0756191c25c0;

});

parcelRegister("a6gXC", function(module, exports) {

var $dSoGR = parcelRequire("dSoGR");

const $235e62ade8ea705d$export$54926cfc344e172b = (0, $dSoGR.createCommand)('get-background-conversation-actions-command');
const $235e62ade8ea705d$export$b6bc379197b9d7b8 = (0, $dSoGR.createCommand)('resolve-background-conversation-actions-command');
module.exports["GetBackgroundConversationActionsCommand"] = $235e62ade8ea705d$export$54926cfc344e172b;
module.exports["ResolveBackgroundConversationActionsCommand"] = $235e62ade8ea705d$export$b6bc379197b9d7b8;

});

parcelRegister("dlR4F", function(module, exports) {

var $dSoGR = parcelRequire("dSoGR");

const $3116f884d3c1f788$export$19044a29afb3da0c = (0, $dSoGR.createCommand)('start-background-agent-conversation-command');
module.exports["StartBackgroundAgentConversationCommand"] = $3116f884d3c1f788$export$19044a29afb3da0c;

});

parcelRegister("lulv8", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $cbY7C = parcelRequire("cbY7C");


var $1hQ0e = parcelRequire("1hQ0e");


var $hd4Ag = parcelRequire("hd4Ag");

/**
 * Ordered list of URL patterns for recognized Atlassian content objects.
 * Each entry maps a regex (with one capture group for the object ID) to an
 * objectType. The first matching entry wins.
 */ const $ebc3500d61452c04$var$URL_PATTERNS = [
    // Jira issue: /browse/PROJ-123
    {
        pattern: /\/browse\/([A-Z][A-Z0-9_]+-\d+)/,
        objectType: 'work-item'
    },
    // Jira project board with selected issue: /jira/.../projects/...?selectedIssue=PROJ-123
    {
        pattern: /\/jira\/.+\/projects\/.+[?&]selectedIssue=([A-Z][A-Z0-9_]+-\d+)/,
        objectType: 'work-item',
        includeSearch: true
    },
    // Confluence page. Supports view and editor URL shapes:
    //   /wiki/spaces/SPACE/pages/123456
    //   /wiki/spaces/SPACE/pages/123456/Page+Title
    //   /wiki/spaces/SPACE/pages/edit-v2/123456     (editor)
    //   /wiki/spaces/SPACE/pages/live-edit/123456   (live editor)
    // The optional non-capturing group only matches a non-numeric mode segment,
    // so it can never accidentally consume the page ID itself.
    {
        pattern: /\/wiki\/spaces\/[^/]+\/pages\/(?:[a-z][a-z0-9-]*\/)?(\d+)/i,
        objectType: 'page'
    },
    // Confluence blog post. Similar to pages but with /blog/ instead of /pages/
    {
        pattern: /\/wiki\/spaces\/[^/]+\/blog\/(?:[a-z][a-z0-9-]*\/)?(\d+)/i,
        objectType: 'blog'
    },
    /**
 * NOTE: This methodology does not work for Confluence whiteboards, slides, databases (or anything rendered in an iframe) because events cannot bubble from within iframes due to cross-origin restrictions.
 * Whiteboard and database teams to log this information themselves.
 */ // Bitbucket pull request: /repos/<repo>/pull-requests/123 or /pull-requests/123
    {
        pattern: /\/pull-requests\/(\d+)/,
        objectType: 'pull-request'
    }
];
function $ebc3500d61452c04$export$296659e5d6c89475(href) {
    try {
        const url = new URL(href);
        for (const { pattern: pattern, objectType: objectType, includeSearch: includeSearch } of $ebc3500d61452c04$var$URL_PATTERNS){
            const subject = includeSearch ? url.pathname + url.search : url.pathname;
            const match = subject.match(pattern);
            if (match) return {
                objectType: objectType,
                objectId: match[1]
            };
        }
        return null;
    } catch  {
        return null;
    }
}


const $2a049f27e8be6707$var$SENTINEL_ATTR = 'data-rovo-chat-copy-id';
// Bridge-owned copies must keep their paste listener after the modal's hook unmounts.
// Share its cleanup across hook instances so the next copy can replace it.
let $2a049f27e8be6707$var$removePersistentPasteListener = null;
function $2a049f27e8be6707$export$f018dffa6c2a806a({ usePersistentPasteListener: usePersistentPasteListener = false } = {}) {
    // Stores the current sentinel ID — set on copy, cleared after paste or unmount
    const sentinelIdRef = (0, $cozmU.useRef)(null);
    // Stores the cleanup fn for the active paste listener
    const removeListenerRef = (0, $cozmU.useRef)(null);
    const location = (0, $hd4Ag.useWindowLocation)();
    // Mirror `location` in a ref so the paste listener (created at copy-time)
    // always reads the *current* URL when the user actually pastes, instead
    // of the URL that was active when registerCopy was invoked. The user
    // virtually always navigates between copying in Rovo chat and pasting
    // into the destination Atlassian object, so without this the parsed URL
    // would be stale (and typically resolve to `null`, suppressing the event).
    const locationRef = (0, $cozmU.useRef)(location);
    (0, $cozmU.useEffect)(()=>{
        locationRef.current = location;
    }, [
        location
    ]);
    // Clean up any pending listener on unmount
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            if (!usePersistentPasteListener) removeListenerRef.current?.();
        };
    }, [
        usePersistentPasteListener
    ]);
    const registerCopy = (0, $cozmU.useCallback)(({ messageId: messageId, analyticsMessageActions: analyticsMessageActions, trackAIMAUEvent: trackAIMAUEvent, interactionModeExecuted: interactionModeExecuted, deferClipboardReadToNextTask: deferClipboardReadToNextTask = false })=>{
        // Remove any existing pending paste listener before registering a new one
        if (usePersistentPasteListener) {
            $2a049f27e8be6707$var$removePersistentPasteListener?.();
            $2a049f27e8be6707$var$removePersistentPasteListener = null;
        } else {
            removeListenerRef.current?.();
            removeListenerRef.current = null;
        }
        // Generate a unique sentinel ID for this copy event
        const sentinelId = crypto.randomUUID();
        sentinelIdRef.current = sentinelId;
        // Append our sentinel to the clipboard HTML asynchronously.
        // We read the current clipboard HTML content first, then rewrite it
        // with the sentinel appended. If the clipboard doesn't support HTML
        // (e.g. only text was written), we skip the sentinel — the paste
        // listener will simply not match and will clean itself up.
        (async ()=>{
            try {
                if (deferClipboardReadToNextTask) // A copy event can reach registerCopy before the browser writes the selection.
                // Read the clipboard in the next task so that write can complete first.
                await new Promise((resolve)=>setTimeout(resolve, 0));
                const clipboardItems = await navigator.clipboard.read();
                for (const item of clipboardItems)if (item.types.includes('text/html')) {
                    const htmlBlob = await item.getType('text/html');
                    const htmlText = await htmlBlob.text();
                    const sentinel = `<span ${$2a049f27e8be6707$var$SENTINEL_ATTR}="${sentinelId}" style="font-size:0;display:inline-block;width:0;height:0;overflow:hidden"></span>`;
                    const newHtml = htmlText + sentinel;
                    // Preserve text/plain if present
                    let textBlob;
                    if (item.types.includes('text/plain')) textBlob = await item.getType('text/plain');
                    const newItem = textBlob ? new ClipboardItem({
                        'text/html': new Blob([
                            newHtml
                        ], {
                            type: 'text/html'
                        }),
                        'text/plain': textBlob
                    }) : new ClipboardItem({
                        'text/html': new Blob([
                            newHtml
                        ], {
                            type: 'text/html'
                        })
                    });
                    await navigator.clipboard.write([
                        newItem
                    ]);
                    break;
                }
            } catch  {
            // If we can't read/write the clipboard (e.g. permissions denied,
            // or only plain text was copied), just skip the sentinel write.
            // The paste listener will not find a matching sentinel and will
            // clean itself up harmlessly.
            }
            // Register paste listener regardless — if clipboard read failed,
            // the sentinel won't match and the listener removes itself cleanly.
            const handlePaste = (event)=>{
                // The persistent listener may outlive this hook and its refs.
                const currentSentinelId = usePersistentPasteListener ? sentinelId : sentinelIdRef.current;
                const pasteLocation = usePersistentPasteListener ? window.location.href : locationRef.current;
                // Always remove listener after first paste attempt
                if (usePersistentPasteListener) {
                    $2a049f27e8be6707$var$removePersistentPasteListener?.();
                    $2a049f27e8be6707$var$removePersistentPasteListener = null;
                } else {
                    removeListenerRef.current?.();
                    removeListenerRef.current = null;
                }
                sentinelIdRef.current = null;
                if (!currentSentinelId) return;
                // Only fire if the paste landed in an editable element — this rules
                // out accidental pastes into non-editable areas (e.g. the address bar,
                // search inputs that are not content editors, read-only sections).
                const target = event.target;
                const isEditable = target?.isContentEditable || target?.getAttribute?.('contenteditable') === 'true' || target?.tagName === 'TEXTAREA' || target?.tagName === 'INPUT';
                if (!isEditable) return;
                // Don't fire if the paste landed inside the Rovo chat panel itself
                // (e.g. the user pasted back into the chat input), or into a search
                // input — neither of these constitutes a modification of an Atlassian
                // content object.
                const isInsideChatPanel = !!target?.closest?.('[data-rovo-chat-panel]');
                const isSearchInput = target?.getAttribute?.('role') === 'search' || target?.type === 'search';
                if (isInsideChatPanel || isSearchInput) return;
                const html = event.clipboardData?.getData('text/html') ?? '';
                // Validate that this paste originated from our chat copy
                if (!html.includes(`${$2a049f27e8be6707$var$SENTINEL_ATTR}="${currentSentinelId}"`)) return;
                // Parse the current page URL (read at PASTE time, not copy time) to
                // identify the Atlassian object the user is pasting into.
                const rovoModifiedObject = (0, $ebc3500d61452c04$export$296659e5d6c89475)(pasteLocation);
                if (!rovoModifiedObject) // Not on a recognized Atlassian product page — don't fire
                return;
                trackAIMAUEvent({
                    type: 'adopted',
                    actionKey: 'copy',
                    rovoModifiedObjects: [
                        rovoModifiedObject
                    ],
                    proactive: false,
                    messageId: messageId,
                    messageActions: analyticsMessageActions,
                    singleInstrumentationID: messageId,
                    ...interactionModeExecuted ? {
                        attributes: {
                            interactionModeExecuted: interactionModeExecuted
                        }
                    } : {}
                });
            };
            const doc = (0, $1hQ0e.getDocument)();
            if (doc) {
                const unbind = (0, $cbY7C.bind)(doc, {
                    type: 'paste',
                    listener: handlePaste,
                    options: {
                        capture: true
                    }
                });
                const removePasteListener = ()=>{
                    unbind();
                    sentinelIdRef.current = null;
                };
                if (usePersistentPasteListener) $2a049f27e8be6707$var$removePersistentPasteListener = removePasteListener;
                else removeListenerRef.current = removePasteListener;
            }
        })();
    }, // `location` is read via locationRef at paste time, so this callback
    // can be stable across navigations.
    [
        usePersistentPasteListener
    ]);
    return {
        registerCopy: registerCopy
    };
}
module.exports["useCopyPasteAdopted"] = $2a049f27e8be6707$export$f018dffa6c2a806a;

});

parcelRegister("hd4Ag", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $9Yqfz = parcelRequire("9Yqfz");


var $eriCt = parcelRequire("eriCt");

const $1f69189ce877419f$export$6fa751d66e55d2e1 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const contextValue = (0, $cozmU.useContext)((0, $eriCt.WindowLocationContext));
    const location = (0, $cozmU.useSyncExternalStore)((0, $9Yqfz.subscribeToLocation), (0, $9Yqfz.getLocationSnapshot), (0, $9Yqfz.getLocationServerSnapshot));
    return contextValue ?? location;
} : ()=>{
    const contextValue = (0, $cozmU.useContext)((0, $eriCt.WindowLocationContext));
    const location = (0, $cozmU.useSyncExternalStore)((0, $9Yqfz.subscribeToLocation), (0, $9Yqfz.getLocationSnapshot), (0, $9Yqfz.getLocationServerSnapshot));
    return contextValue ?? location;
};
module.exports["useWindowLocation"] = $1f69189ce877419f$export$6fa751d66e55d2e1;

});

parcelRegister("9Yqfz", function(module, exports) {

var $cbY7C = parcelRequire("cbY7C");

const $35332082f96c50ad$var$locationListeners = new Set();
const $35332082f96c50ad$var$titleListeners = new Set();
let $35332082f96c50ad$var$patched = false;
let $35332082f96c50ad$var$currentHref = '';
let $35332082f96c50ad$var$currentTitle = '';
let $35332082f96c50ad$var$titleMutationObserver;
const $35332082f96c50ad$var$isBrowser = ()=>typeof window !== 'undefined';
const $35332082f96c50ad$var$hasDocument = ()=>typeof document !== 'undefined';
const $35332082f96c50ad$var$readHref = ()=>$35332082f96c50ad$var$isBrowser() ? window.location.href : '';
const $35332082f96c50ad$var$readTitle = ()=>$35332082f96c50ad$var$hasDocument() ? document.title : '';
// Snapshot the set so a listener that (un)subscribes during notification does
// not mutate the collection we are iterating.
const $35332082f96c50ad$var$emit = (set)=>{
    for (const listener of Array.from(set))listener();
};
const $35332082f96c50ad$var$notifyLocation = ()=>{
    const nextHref = $35332082f96c50ad$var$readHref();
    if (nextHref === $35332082f96c50ad$var$currentHref) return;
    $35332082f96c50ad$var$currentHref = nextHref;
    $35332082f96c50ad$var$emit($35332082f96c50ad$var$locationListeners);
};
const $35332082f96c50ad$var$notifyTitle = ()=>{
    const nextTitle = $35332082f96c50ad$var$readTitle();
    if (nextTitle === $35332082f96c50ad$var$currentTitle) return;
    $35332082f96c50ad$var$currentTitle = nextTitle;
    $35332082f96c50ad$var$emit($35332082f96c50ad$var$titleListeners);
};
const $35332082f96c50ad$var$installOnce = ()=>{
    if ($35332082f96c50ad$var$patched || !$35332082f96c50ad$var$isBrowser()) return;
    $35332082f96c50ad$var$patched = true;
    $35332082f96c50ad$var$currentHref = $35332082f96c50ad$var$readHref();
    $35332082f96c50ad$var$currentTitle = $35332082f96c50ad$var$readTitle();
    const nativePushState = window.history.pushState.bind(window.history);
    const nativeReplaceState = window.history.replaceState.bind(window.history);
    // Intentionally permanent: we never restore these. See module docblock.
    window.history.pushState = function(...args) {
        nativePushState(...args);
        $35332082f96c50ad$var$notifyLocation();
    };
    window.history.replaceState = function(...args) {
        nativeReplaceState(...args);
        $35332082f96c50ad$var$notifyLocation();
    };
    (0, $cbY7C.bindAll)(window, [
        {
            type: 'popstate',
            listener: $35332082f96c50ad$var$notifyLocation
        },
        {
            type: 'hashchange',
            listener: $35332082f96c50ad$var$notifyLocation
        }
    ]);
    // Watch the <title> element for changes. The shell updates `document.title`
    // after the location change, so this is what keeps title-derived UI fresh.
    if ($35332082f96c50ad$var$hasDocument() && typeof MutationObserver !== 'undefined') {
        const titleEl = document.querySelector('title');
        if (titleEl) {
            $35332082f96c50ad$var$titleMutationObserver = new MutationObserver($35332082f96c50ad$var$notifyTitle);
            $35332082f96c50ad$var$titleMutationObserver.observe(titleEl, {
                childList: true,
                characterData: true,
                subtree: true
            });
        }
    }
};
const $35332082f96c50ad$export$9dcd3b3f4f8a572f = (listener)=>{
    $35332082f96c50ad$var$installOnce();
    $35332082f96c50ad$var$locationListeners.add(listener);
    return ()=>{
        $35332082f96c50ad$var$locationListeners.delete(listener);
    };
};
const $35332082f96c50ad$export$c6a96cf4e0abf9ac = (listener)=>{
    $35332082f96c50ad$var$installOnce();
    $35332082f96c50ad$var$titleListeners.add(listener);
    return ()=>{
        $35332082f96c50ad$var$titleListeners.delete(listener);
    };
};
const $35332082f96c50ad$export$ef3949f6f6b35a98 = ()=>$35332082f96c50ad$var$readHref();
const $35332082f96c50ad$export$1296b6401b011699 = ()=>'';
const $35332082f96c50ad$export$b8645558bd27590a = ()=>$35332082f96c50ad$var$readTitle();
const $35332082f96c50ad$export$60c631f42ecb55a7 = ()=>'';
const $35332082f96c50ad$export$9f0e18eb4b88e00d = ()=>{
    $35332082f96c50ad$var$patched = false;
    $35332082f96c50ad$var$currentHref = '';
    $35332082f96c50ad$var$currentTitle = '';
    $35332082f96c50ad$var$locationListeners.clear();
    $35332082f96c50ad$var$titleListeners.clear();
    $35332082f96c50ad$var$titleMutationObserver?.disconnect();
    $35332082f96c50ad$var$titleMutationObserver = undefined;
};
module.exports["subscribeToLocation"] = $35332082f96c50ad$export$9dcd3b3f4f8a572f;
module.exports["subscribeToTitle"] = $35332082f96c50ad$export$c6a96cf4e0abf9ac;
module.exports["getLocationSnapshot"] = $35332082f96c50ad$export$ef3949f6f6b35a98;
module.exports["getLocationServerSnapshot"] = $35332082f96c50ad$export$1296b6401b011699;
module.exports["getTitleSnapshot"] = $35332082f96c50ad$export$b8645558bd27590a;
module.exports["getTitleServerSnapshot"] = $35332082f96c50ad$export$60c631f42ecb55a7;

});

parcelRegister("eriCt", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $34391591fc09bf27$export$46133998910543ac = (0, $cozmU.createContext)(null);
module.exports["WindowLocationContext"] = $34391591fc09bf27$export$46133998910543ac;

});

parcelRegister("3wccB", function(module, exports) {

var $feawE = parcelRequire("feawE");

const $da25b812d7492535$var$CONFLUENCE_SLIDE_CLIENT_ID_PREFIX = 'confluence-slide';
const $da25b812d7492535$export$8ad4475ac322bb70 = (contentId)=>(0, $feawE.client)(`${$da25b812d7492535$var$CONFLUENCE_SLIDE_CLIENT_ID_PREFIX}-${contentId}`);
module.exports["getConfluenceSlidesClientId"] = $da25b812d7492535$export$8ad4475ac322bb70;

});

parcelRegister("7eUSO", function(module, exports) {
const $eb42c349b4f6ce76$export$64aa7f11204484dc = (action, resolutionType, args)=>({
        key: action.key,
        tool_id: action.actionId,
        tool_source: action.toolSource,
        invocation_id: action.invocationId,
        resolution: {
            type: resolutionType
        },
        data: {
            human_message_id: action.humanMessageId ?? '',
            arguments: args ?? action.data
        }
    });
module.exports["buildToolFromAction"] = $eb42c349b4f6ce76$export$64aa7f11204484dc;

});

parcelRegister("b8lE8", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");

const $4b9e83b36a00bf88$var$RESUMPTION_AVAILABLE_GATE = 'rovo_chat_use_resumption_available';
const $4b9e83b36a00bf88$export$af2356309b3025bc = (action)=>(0, $iDrrr.fg)($4b9e83b36a00bf88$var$RESUMPTION_AVAILABLE_GATE) || (0, $iDrrr.fg)('rovo_extension_use_resumption_available') ? action.resumptionAvailable === true : Boolean(action.toolSource);
const $4b9e83b36a00bf88$export$cf48145ffee4d31c = (actions)=>actions.length > 0 && actions.every($4b9e83b36a00bf88$export$af2356309b3025bc);
module.exports["shouldUseResumption"] = $4b9e83b36a00bf88$export$af2356309b3025bc;
module.exports["resolveResumptionEligibility"] = $4b9e83b36a00bf88$export$cf48145ffee4d31c;

});

parcelRegister("aYC8J", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $7lXV4 = parcelRequire("7lXV4");


var $3wccB = parcelRequire("3wccB");


var $5OXoi = parcelRequire("5OXoi");


var $6isLN = parcelRequire("6isLN");

function $4f22b85ba3ca0c76$export$a4068a52445901dc(data, props) {
    return data !== null && typeof data === 'object' && props.every((prop)=>data.hasOwnProperty(prop));
}
const $4f22b85ba3ca0c76$export$740b9b28cb05ebd6 = 'dynamic-ui-create';
function $4f22b85ba3ca0c76$export$6da360af78d7e3dd(data) {
    return $4f22b85ba3ca0c76$export$a4068a52445901dc(data, [
        'id'
    ]);
}
function $4f22b85ba3ca0c76$export$da7aa926fc604bd7(data) {
    return $4f22b85ba3ca0c76$export$a4068a52445901dc(data, [
        'id',
        'previousMauiId',
        'contentType'
    ]) && data.previousMauiId != null;
}
function $4f22b85ba3ca0c76$export$3147e11228ebc102(action) {
    return $4f22b85ba3ca0c76$export$6da360af78d7e3dd(action.data);
}
const $4f22b85ba3ca0c76$export$440c8d4309cb1c9 = (data)=>{
    if (data?.id) return `${window.location.origin}/remix/ui/${encodeURIComponent(data.id)}`;
    return null;
};
const $4f22b85ba3ca0c76$export$4a9884303bce30ff = 'image-create';
function $4f22b85ba3ca0c76$export$ce86c52462376ef2(data) {
    return $4f22b85ba3ca0c76$export$a4068a52445901dc(data, [
        'mediaFileId'
    ]);
}
function $4f22b85ba3ca0c76$export$3b2fa4f5aa307773(data) {
    return $4f22b85ba3ca0c76$export$a4068a52445901dc(data, [
        'mediaFileId',
        'previousMediaFileId',
        'mediaCollection'
    ]) && data.previousMediaFileId != null;
}
function $4f22b85ba3ca0c76$export$ef033f677befc7d4(action) {
    return action.key === $4f22b85ba3ca0c76$export$4a9884303bce30ff && $4f22b85ba3ca0c76$export$ce86c52462376ef2(action.data);
}
function $4f22b85ba3ca0c76$export$3bb9ace6cd5cc74a(data) {
    return $4f22b85ba3ca0c76$export$a4068a52445901dc(data, [
        'previousMediaFileId'
    ]);
}
const $4f22b85ba3ca0c76$export$3fe1804ad3d5b936 = (remixSubtype)=>{
    if (!remixSubtype) return 'remix';
    // Unlike remixSubtype, dynamicUiType isn't available on the image-create backend payload or the insert
    // content command. Sourcing it would require either a backend change or importing from malleable-ui-components.
    // This simple inference avoids both while producing the correct result, at least until additional 'image'
    // subtypes are added. Ticket: https://hello.jira.atlassian.cloud/jira/browse/A4C-7193
    const remixType = remixSubtype === 'image' ? 'image' : 'infographic';
    return `remix:${remixType}:${remixSubtype}`;
};
const $4f22b85ba3ca0c76$export$444100e6917dbc93 = (source)=>{
    if (!source) return undefined;
    const [prefix, type, subtype, ...rest] = source.split(':');
    if (prefix !== 'remix' || !type || !subtype || rest.length > 0) return undefined;
    return {
        subtype: subtype,
        type: type
    };
};
const $4f22b85ba3ca0c76$var$MEDIA_BASE_URL_STAGING = 'https://media.staging.atl-paas.net';
const $4f22b85ba3ca0c76$var$MEDIA_BASE_URL_PROD = 'https://media-cdn.atlassian.com';
const $4f22b85ba3ca0c76$export$4e8e610ccc58ae5b = ({ fileId: fileId, token: token, collection: collection, clientId: clientId, isStaging: isStaging })=>{
    const baseUrl = isStaging ? $4f22b85ba3ca0c76$var$MEDIA_BASE_URL_STAGING : $4f22b85ba3ca0c76$var$MEDIA_BASE_URL_PROD;
    const url = new URL(`${baseUrl}/file/${fileId}/image`);
    url.searchParams.set('token', token);
    url.searchParams.set('issuer', 'micros/convo-ai');
    url.searchParams.set('collection', collection);
    url.searchParams.set('client', clientId);
    return url.toString();
};
const $4f22b85ba3ca0c76$export$7afb9b8acd50eb4e = 'aifc-confluence-page-create';
function $4f22b85ba3ca0c76$export$77c5629325e9aaaf(data) {
    return typeof data === 'object' && data !== null && 'title' in data && 'adf' in data && 'contentId' in data;
}
const $4f22b85ba3ca0c76$export$b632d4bc1af2f7d3 = 'aifc-deep-research-confluence-page-create';
function $4f22b85ba3ca0c76$export$3bd74956949aecbc(data) {
    return typeof data === 'object' && data !== null && 'title' in data && 'content' in data && 'contentId' in data;
}
function $4f22b85ba3ca0c76$export$d6ad19367a51fe7a(data) {
    return typeof data === 'object' && data !== null && 'contentId' in data;
}
const $4f22b85ba3ca0c76$export$88028308fe524b8a = 'aifc-confluence-page-update';
const $4f22b85ba3ca0c76$export$bb3d6eff667f4678 = 'aifc-adf-update';
const $4f22b85ba3ca0c76$export$7cca3e34118747ef = 'aifc-action-classification-metadata';
function $4f22b85ba3ca0c76$export$4f41f9d38097cf0a(data) {
    return typeof data === 'object' && data !== null && 'document' in data && 'contentId' in data;
}
function $4f22b85ba3ca0c76$export$1cf42b66f457bc6c(data) {
    return typeof data === 'object' && data !== null && 'toolCalls' in data && 'contentId' in data && typeof data.toolCalls === 'string' && typeof data.contentId === 'string';
}
function $4f22b85ba3ca0c76$export$fbc8213fc156433a(data) {
    return typeof data === 'object' && data !== null && 'promptVersion' in data && typeof data.promptVersion === 'string' && 'contentId' in data && typeof data.contentId === 'string';
}
const $4f22b85ba3ca0c76$export$279c9cc61f7f510a = 'aifc-confluence-whiteboard-create';
function $4f22b85ba3ca0c76$export$392158ed2444b56b(data) {
    return typeof data === 'object' && data !== null && 'document' in data && 'title' in data && typeof data.title === 'string' && 'contentId' in data && typeof data.contentId === 'string';
}
const $4f22b85ba3ca0c76$export$823e13f43093123d = 'aifc-confluence-slides-create';
function $4f22b85ba3ca0c76$export$ae4ad515c9dd259d(data) {
    return typeof data === 'object' && data !== null && 'document' in data && 'title' in data && typeof data.title === 'string' && 'contentId' in data && typeof data.contentId === 'string';
}
const $4f22b85ba3ca0c76$export$49b21a7401bcc85 = 'aifc-confluence-slides-update';
function $4f22b85ba3ca0c76$export$3d6de0a3c3e39cbf(data) {
    return typeof data === 'object' && data !== null && 'document' in data && 'contentId' in data && typeof data.contentId === 'string';
}
const $4f22b85ba3ca0c76$export$d5d2204eeb3fde50 = 'aifc-confluence-whiteboard-update';
function $4f22b85ba3ca0c76$export$35d2029c1a7b307c(data) {
    return typeof data === 'object' && data !== null && 'document' in data && 'contentId' in data && typeof data.contentId === 'string';
}
const $4f22b85ba3ca0c76$export$771989b0afde4911 = 'aifc-confluence-whiteboard-to-page';
const $4f22b85ba3ca0c76$export$325918e7af3a74aa = 'confluence-whiteboard-brainstorming';
function $4f22b85ba3ca0c76$export$48e8bcda6802129c(data) {
    return typeof data === 'object' && data !== null && 'content' in data && 'contentId' in data && typeof data.contentId === 'string';
}
const $4f22b85ba3ca0c76$export$e3c19505945cf210 = 'confluence-whiteboard-diagramming';
const $4f22b85ba3ca0c76$export$c8f288feec1641d9 = 'aifc-confluence-whiteboard-diagramming';
function $4f22b85ba3ca0c76$export$f3a918f4f62365b2(data) {
    return typeof data === 'object' && data !== null && 'content' in data && 'diagramType' in data && 'contentId' in data && typeof data.contentId === 'string';
}
const $4f22b85ba3ca0c76$export$9f1bd612d6abcf5c = 'aifc-confluence-database-create';
function $4f22b85ba3ca0c76$export$4dec930442f5ade2(data) {
    return typeof data === 'object' && data !== null && 'document' in data && 'title' in data && typeof data.title === 'string' && 'contentId' in data && typeof data.contentId === 'string';
}
const $4f22b85ba3ca0c76$export$ee0a705006a79cfe = 'aifc-confluence-database-update';
function $4f22b85ba3ca0c76$export$dbed60ca289ab1f3(data) {
    return typeof data === 'object' && data !== null && 'document' in data && 'contentId' in data;
}
const $4f22b85ba3ca0c76$export$691e9b05e574e32c = 'aifc-confluence-space-create';
function $4f22b85ba3ca0c76$export$545244afe3ae2546(data) {
    return typeof data === 'object' && data !== null && 'jsonSpace' in data;
}
const $4f22b85ba3ca0c76$export$af91dd9bf235f890 = 'aifc-confluence-space-update';
function $4f22b85ba3ca0c76$export$38f648644a8b3072(data) {
    return typeof data === 'object' && data !== null && 'jsonSpace' in data;
}
const $4f22b85ba3ca0c76$export$9f62c3ae716c44b2 = new Set([
    $4f22b85ba3ca0c76$export$7afb9b8acd50eb4e,
    $4f22b85ba3ca0c76$export$771989b0afde4911,
    $4f22b85ba3ca0c76$export$b632d4bc1af2f7d3
]);
const $4f22b85ba3ca0c76$export$aba0c096f5cdcaca = new Set([
    $4f22b85ba3ca0c76$export$279c9cc61f7f510a
]);
const $4f22b85ba3ca0c76$export$b9c5aef93dba02df = new Set([
    $4f22b85ba3ca0c76$export$823e13f43093123d
]);
const $4f22b85ba3ca0c76$export$45a7157715c10f20 = new Set([
    $4f22b85ba3ca0c76$export$9f1bd612d6abcf5c
]);
const $4f22b85ba3ca0c76$var$SPACE_CREATE_ACTIONS = new Set([
    $4f22b85ba3ca0c76$export$691e9b05e574e32c
]);
const $4f22b85ba3ca0c76$var$CREATABLE_ACTION_KEYS = new Set([
    ...$4f22b85ba3ca0c76$export$9f62c3ae716c44b2,
    ...$4f22b85ba3ca0c76$export$aba0c096f5cdcaca,
    ...$4f22b85ba3ca0c76$export$b9c5aef93dba02df,
    ...$4f22b85ba3ca0c76$export$45a7157715c10f20,
    ...$4f22b85ba3ca0c76$var$SPACE_CREATE_ACTIONS
]);
const $4f22b85ba3ca0c76$var$PAGE_UPDATE_ACTIONS = new Set([
    $4f22b85ba3ca0c76$export$88028308fe524b8a,
    $4f22b85ba3ca0c76$export$bb3d6eff667f4678,
    $4f22b85ba3ca0c76$export$740b9b28cb05ebd6,
    $4f22b85ba3ca0c76$export$4a9884303bce30ff
]);
const $4f22b85ba3ca0c76$var$WHITEBOARD_UPDATE_ACTIONS = new Set([
    $4f22b85ba3ca0c76$export$d5d2204eeb3fde50,
    $4f22b85ba3ca0c76$export$325918e7af3a74aa,
    $4f22b85ba3ca0c76$export$e3c19505945cf210,
    $4f22b85ba3ca0c76$export$c8f288feec1641d9
]);
const $4f22b85ba3ca0c76$var$SLIDES_UPDATE_ACTIONS = new Set([
    $4f22b85ba3ca0c76$export$49b21a7401bcc85
]);
const $4f22b85ba3ca0c76$var$DATABASE_UPDATE_ACTIONS = new Set([
    $4f22b85ba3ca0c76$export$ee0a705006a79cfe
]);
const $4f22b85ba3ca0c76$var$SPACE_UPDATE_ACTIONS = new Set([
    $4f22b85ba3ca0c76$export$af91dd9bf235f890
]);
const $4f22b85ba3ca0c76$var$UPDATABLE_ACTION_KEYS = new Set([
    ...$4f22b85ba3ca0c76$var$PAGE_UPDATE_ACTIONS,
    ...$4f22b85ba3ca0c76$var$WHITEBOARD_UPDATE_ACTIONS,
    ...$4f22b85ba3ca0c76$var$SLIDES_UPDATE_ACTIONS,
    ...$4f22b85ba3ca0c76$var$DATABASE_UPDATE_ACTIONS,
    ...$4f22b85ba3ca0c76$var$SPACE_UPDATE_ACTIONS
]);
const $4f22b85ba3ca0c76$export$6c0ed26dac146a75 = (action)=>$4f22b85ba3ca0c76$export$9f62c3ae716c44b2.has(action.key);
const $4f22b85ba3ca0c76$export$eac4577c3e50732a = (action)=>$4f22b85ba3ca0c76$var$CREATABLE_ACTION_KEYS.has(action.key);
const $4f22b85ba3ca0c76$export$a70db46a9e5e9e4a = (action)=>$4f22b85ba3ca0c76$export$eac4577c3e50732a(action) && !!action.data?.metadata?.isExistingContent && (0, $iDrrr.fg)('confluence_aifc_create_on_existing');
const $4f22b85ba3ca0c76$export$79fc6c76b9755410 = (action)=>$4f22b85ba3ca0c76$export$eac4577c3e50732a(action) && !$4f22b85ba3ca0c76$export$a70db46a9e5e9e4a(action);
const $4f22b85ba3ca0c76$export$6b900ddfe8315d64 = (action)=>!!action?.data?.metadata?.serverSideExecution;
const $4f22b85ba3ca0c76$export$53f0114d9f187b14 = (action)=>action.key === $4f22b85ba3ca0c76$export$740b9b28cb05ebd6;
const $4f22b85ba3ca0c76$export$b3dfc475c0b1ff86 = (action)=>action.key === $4f22b85ba3ca0c76$export$4a9884303bce30ff;
const $4f22b85ba3ca0c76$export$dfda1ac7e19cab7b = (action)=>$4f22b85ba3ca0c76$var$PAGE_UPDATE_ACTIONS.has(action.key);
const $4f22b85ba3ca0c76$export$dcbfc8a9b613cd00 = (action)=>$4f22b85ba3ca0c76$var$WHITEBOARD_UPDATE_ACTIONS.has(action.key);
const $4f22b85ba3ca0c76$export$5d2d4e8984b13e00 = (action)=>$4f22b85ba3ca0c76$var$SLIDES_UPDATE_ACTIONS.has(action.key);
const $4f22b85ba3ca0c76$export$399c9116e9984ca3 = (action)=>$4f22b85ba3ca0c76$var$DATABASE_UPDATE_ACTIONS.has(action.key);
const $4f22b85ba3ca0c76$export$73dc9ed6ed2373f = (action)=>$4f22b85ba3ca0c76$var$UPDATABLE_ACTION_KEYS.has(action.key);
const $4f22b85ba3ca0c76$export$54716060fc6e52ee = (action)=>$4f22b85ba3ca0c76$export$eac4577c3e50732a(action) || $4f22b85ba3ca0c76$export$73dc9ed6ed2373f(action);
// ============================================================================
// CONFLUENCE PREVIEW CARDS
// ============================================================================
const $4f22b85ba3ca0c76$var$PREVIEW_CARD_ACTION_KEYS = new Set([
    $4f22b85ba3ca0c76$export$7afb9b8acd50eb4e,
    $4f22b85ba3ca0c76$export$b632d4bc1af2f7d3,
    $4f22b85ba3ca0c76$export$279c9cc61f7f510a,
    $4f22b85ba3ca0c76$export$823e13f43093123d,
    $4f22b85ba3ca0c76$export$771989b0afde4911,
    $4f22b85ba3ca0c76$export$9f1bd612d6abcf5c
]);
const $4f22b85ba3ca0c76$export$5cb5e5f4b4ce0a33 = (action)=>$4f22b85ba3ca0c76$var$PREVIEW_CARD_ACTION_KEYS.has(action.key) && !$4f22b85ba3ca0c76$export$a70db46a9e5e9e4a(action);
const $4f22b85ba3ca0c76$export$681cf9ea58de88fd = (action, selectedPreviewContentId)=>{
    if (!action?.key) return;
    switch(action.key){
        case $4f22b85ba3ca0c76$export$279c9cc61f7f510a:
            return (0, $6isLN.getConfluenceWhiteboardClientId)(selectedPreviewContentId);
        case $4f22b85ba3ca0c76$export$823e13f43093123d:
        case $4f22b85ba3ca0c76$export$49b21a7401bcc85:
            return (0, $3wccB.getConfluenceSlidesClientId)(selectedPreviewContentId);
        case $4f22b85ba3ca0c76$export$9f1bd612d6abcf5c:
            return (0, $7lXV4.getConfluenceDatabaseClientId)(selectedPreviewContentId);
        default:
            return (0, $5OXoi.getConfluenceEditorClientId)(selectedPreviewContentId);
    }
};
const $4f22b85ba3ca0c76$export$bb9f6b0763834612 = (action)=>{
    const actionKey = action.key;
    if ($4f22b85ba3ca0c76$export$9f62c3ae716c44b2.has(actionKey) || $4f22b85ba3ca0c76$var$PAGE_UPDATE_ACTIONS.has(actionKey)) return 'confluence-page';
    if ($4f22b85ba3ca0c76$export$aba0c096f5cdcaca.has(actionKey) || $4f22b85ba3ca0c76$var$WHITEBOARD_UPDATE_ACTIONS.has(actionKey)) return 'confluence-whiteboard';
    if ($4f22b85ba3ca0c76$export$b9c5aef93dba02df.has(actionKey) || $4f22b85ba3ca0c76$var$SLIDES_UPDATE_ACTIONS.has(actionKey)) return 'confluence-slide';
    if ($4f22b85ba3ca0c76$export$45a7157715c10f20.has(actionKey) || $4f22b85ba3ca0c76$var$DATABASE_UPDATE_ACTIONS.has(actionKey)) return 'confluence-database';
    if ($4f22b85ba3ca0c76$var$SPACE_CREATE_ACTIONS.has(actionKey) || $4f22b85ba3ca0c76$var$SPACE_UPDATE_ACTIONS.has(actionKey)) return 'confluence-space';
    return undefined;
};
// This mapping should contain the type guards of those actions that support data
// accumulation as defined below in `getPrimaryAccumulatedValue`.
const $4f22b85ba3ca0c76$var$CONFLUENCE_AIFC_ACCUMULATED_DATA_TYPE_GUARDS = {
    [$4f22b85ba3ca0c76$export$7afb9b8acd50eb4e]: $4f22b85ba3ca0c76$export$77c5629325e9aaaf,
    [$4f22b85ba3ca0c76$export$b632d4bc1af2f7d3]: $4f22b85ba3ca0c76$export$3bd74956949aecbc,
    [$4f22b85ba3ca0c76$export$9f1bd612d6abcf5c]: $4f22b85ba3ca0c76$export$4dec930442f5ade2,
    [$4f22b85ba3ca0c76$export$279c9cc61f7f510a]: $4f22b85ba3ca0c76$export$392158ed2444b56b,
    [$4f22b85ba3ca0c76$export$823e13f43093123d]: $4f22b85ba3ca0c76$export$ae4ad515c9dd259d
};
const $4f22b85ba3ca0c76$export$b95f9369e33f3b4a = (key)=>{
    return key in $4f22b85ba3ca0c76$var$CONFLUENCE_AIFC_ACCUMULATED_DATA_TYPE_GUARDS;
};
const $4f22b85ba3ca0c76$export$898d9c03b4eb5dd5 = (key)=>{
    return $4f22b85ba3ca0c76$var$CONFLUENCE_AIFC_ACCUMULATED_DATA_TYPE_GUARDS[key];
};
const $4f22b85ba3ca0c76$export$240debd921ff9f65 = (action)=>{
    if (!action.data) return undefined;
    if (action.key === $4f22b85ba3ca0c76$export$7afb9b8acd50eb4e && $4f22b85ba3ca0c76$export$77c5629325e9aaaf(action.data)) {
        const key = 'adf';
        return {
            key: key,
            value: action.data[key]
        };
    } else if (action.key === $4f22b85ba3ca0c76$export$b632d4bc1af2f7d3 && $4f22b85ba3ca0c76$export$3bd74956949aecbc(action.data)) {
        const key = 'content';
        return {
            key: key,
            value: action.data[key]
        };
    } else if (action.key === $4f22b85ba3ca0c76$export$279c9cc61f7f510a && $4f22b85ba3ca0c76$export$392158ed2444b56b(action.data)) {
        const key = 'document';
        return {
            key: key,
            value: action.data[key]
        };
    } else if (action.key === $4f22b85ba3ca0c76$export$823e13f43093123d && $4f22b85ba3ca0c76$export$ae4ad515c9dd259d(action.data)) {
        const key = 'document';
        return {
            key: key,
            value: action.data[key]
        };
    } else if (action.key === $4f22b85ba3ca0c76$export$9f1bd612d6abcf5c && $4f22b85ba3ca0c76$export$4dec930442f5ade2(action.data)) {
        const key = 'document';
        return {
            key: key,
            value: action.data[key]
        };
    }
    return undefined;
};
const $4f22b85ba3ca0c76$var$getAccumulatedData = (prevAction, nextAction)=>{
    const prevPrimary = $4f22b85ba3ca0c76$export$240debd921ff9f65(prevAction);
    const nextPrimary = $4f22b85ba3ca0c76$export$240debd921ff9f65(nextAction);
    if (!prevPrimary || !nextPrimary || prevPrimary.key !== nextPrimary.key) return undefined;
    return {
        [nextPrimary.key]: String(prevPrimary.value ?? '') + String(nextPrimary.value ?? '')
    };
};
function $4f22b85ba3ca0c76$export$5b30faa0f696991d(data) {
    return typeof data === 'object' && data !== null && 'isRemixGenerated' in data && data.isRemixGenerated === true;
}
const $4f22b85ba3ca0c76$var$REMIX_GENERATED_ACTION_KEYS = new Set([
    $4f22b85ba3ca0c76$export$740b9b28cb05ebd6,
    $4f22b85ba3ca0c76$export$4a9884303bce30ff
]);
function $4f22b85ba3ca0c76$export$8eb2b74d04c8d455(action) {
    if ($4f22b85ba3ca0c76$var$REMIX_GENERATED_ACTION_KEYS.has(action.key)) return true;
    if (action.key === $4f22b85ba3ca0c76$export$279c9cc61f7f510a || action.key === $4f22b85ba3ca0c76$export$d5d2204eeb3fde50) return $4f22b85ba3ca0c76$export$5b30faa0f696991d(action.data);
    return false;
}
function $4f22b85ba3ca0c76$export$31b2392386905e76(action) {
    if (!action) return undefined;
    const { key: key, data: data } = action;
    if ($4f22b85ba3ca0c76$export$da7aa926fc604bd7(data)) return 'edit';
    if ($4f22b85ba3ca0c76$export$6da360af78d7e3dd(data)) return 'create';
    if ($4f22b85ba3ca0c76$export$3b2fa4f5aa307773(data)) return 'edit';
    if ($4f22b85ba3ca0c76$export$ce86c52462376ef2(data)) return 'create';
    if (key === $4f22b85ba3ca0c76$export$d5d2204eeb3fde50) return 'edit';
    if (key === $4f22b85ba3ca0c76$export$279c9cc61f7f510a) return 'create';
    return undefined;
}
function $4f22b85ba3ca0c76$export$a549b965e1dff398(action) {
    if (action?.key === $4f22b85ba3ca0c76$export$4a9884303bce30ff) return 'infographic';
    if (action?.data?.type === 'whiteboard') return 'diagram';
    return action?.data?.contentType;
}
function $4f22b85ba3ca0c76$export$90cf5cf844c2f3b0(action) {
    return action?.data?.dynamicUiSubtype;
}
function $4f22b85ba3ca0c76$export$ff1c2950f6d5486f({ action: action, selectedRemixMetadata: selectedRemixMetadata }) {
    return {
        metadataActionKey: action?.key,
        metadataActionType: $4f22b85ba3ca0c76$export$31b2392386905e76(action),
        backendDynamicUiType: $4f22b85ba3ca0c76$export$a549b965e1dff398(action),
        backendDynamicUiSubtype: $4f22b85ba3ca0c76$export$90cf5cf844c2f3b0(action),
        ...selectedRemixMetadata
    };
}
const $4f22b85ba3ca0c76$export$64e13fa6a74f5f86 = (prevAction, nextAction)=>{
    if (prevAction.data && nextAction.data) {
        const accumulatedData = $4f22b85ba3ca0c76$var$getAccumulatedData(prevAction, nextAction);
        if (accumulatedData !== undefined) {
            const updatedData = {
                ...nextAction.data,
                ...accumulatedData
            };
            return {
                ...prevAction,
                data: updatedData,
                status: nextAction.status
            };
        }
    }
    return {
        ...prevAction,
        data: nextAction.data,
        status: nextAction.status
    };
};
module.exports["DYNAMIC_UI_CREATE_KEY"] = $4f22b85ba3ca0c76$export$740b9b28cb05ebd6;
module.exports["isDynamicUiCreateData"] = $4f22b85ba3ca0c76$export$6da360af78d7e3dd;
module.exports["isDynamicUiUpdateActionData"] = $4f22b85ba3ca0c76$export$da7aa926fc604bd7;
module.exports["isDynamicUiCreateAction"] = $4f22b85ba3ca0c76$export$3147e11228ebc102;
module.exports["buildDynamicUiPageUrl"] = $4f22b85ba3ca0c76$export$440c8d4309cb1c9;
module.exports["IMAGE_CREATE_KEY"] = $4f22b85ba3ca0c76$export$4a9884303bce30ff;
module.exports["isImageCreateData"] = $4f22b85ba3ca0c76$export$ce86c52462376ef2;
module.exports["isImageUpdateActionData"] = $4f22b85ba3ca0c76$export$3b2fa4f5aa307773;
module.exports["isImageCreateAction"] = $4f22b85ba3ca0c76$export$ef033f677befc7d4;
module.exports["isImageUpdatePrepareData"] = $4f22b85ba3ca0c76$export$3bb9ace6cd5cc74a;
module.exports["getRemixDataConsumerSource"] = $4f22b85ba3ca0c76$export$3fe1804ad3d5b936;
module.exports["parseRemixDataConsumerSource"] = $4f22b85ba3ca0c76$export$444100e6917dbc93;
module.exports["buildImageUrl"] = $4f22b85ba3ca0c76$export$4e8e610ccc58ae5b;
module.exports["CONFLUENCE_AIFC_PAGE_CREATE_KEY"] = $4f22b85ba3ca0c76$export$7afb9b8acd50eb4e;
module.exports["isConfluenceAIFCPageCreateActionData"] = $4f22b85ba3ca0c76$export$77c5629325e9aaaf;
module.exports["CONFLUENCE_AIFC_DEEP_RESEARCH_PAGE_CREATE_KEY"] = $4f22b85ba3ca0c76$export$b632d4bc1af2f7d3;
module.exports["isConfluenceAIFCDeepResearchPageCreateActionData"] = $4f22b85ba3ca0c76$export$3bd74956949aecbc;
module.exports["isConfluenceAIFCDeepResearchPageCreateActionPrepare"] = $4f22b85ba3ca0c76$export$d6ad19367a51fe7a;
module.exports["CONFLUENCE_AIFC_PAGE_UPDATE_KEY"] = $4f22b85ba3ca0c76$export$88028308fe524b8a;
module.exports["AIFC_ADF_UPDATE_KEY"] = $4f22b85ba3ca0c76$export$bb3d6eff667f4678;
module.exports["AIFC_ACTION_CLASSIFICATION_METADATA"] = $4f22b85ba3ca0c76$export$7cca3e34118747ef;
module.exports["isAIFCADFUpdateActionData"] = $4f22b85ba3ca0c76$export$1cf42b66f457bc6c;
module.exports["isAIFCADFSetActionClassificationActionData"] = $4f22b85ba3ca0c76$export$fbc8213fc156433a;
module.exports["CONFLUENCE_AIFC_WHITEBOARD_CREATE_KEY"] = $4f22b85ba3ca0c76$export$279c9cc61f7f510a;
module.exports["isConfluenceAIFCWhiteboardCreateActionData"] = $4f22b85ba3ca0c76$export$392158ed2444b56b;
module.exports["CONFLUENCE_AIFC_SLIDES_CREATE_KEY"] = $4f22b85ba3ca0c76$export$823e13f43093123d;
module.exports["isConfluenceAIFCSlidesCreateActionData"] = $4f22b85ba3ca0c76$export$ae4ad515c9dd259d;
module.exports["CONFLUENCE_AIFC_SLIDES_UPDATE_KEY"] = $4f22b85ba3ca0c76$export$49b21a7401bcc85;
module.exports["isConfluenceAIFCSlidesUpdateActionData"] = $4f22b85ba3ca0c76$export$3d6de0a3c3e39cbf;
module.exports["CONFLUENCE_AIFC_WHITEBOARD_UPDATE_KEY"] = $4f22b85ba3ca0c76$export$d5d2204eeb3fde50;
module.exports["isConfluenceAIFCWhiteboardUpdateActionData"] = $4f22b85ba3ca0c76$export$35d2029c1a7b307c;
module.exports["CONFLUENCE_AIFC_WHITEBOARD_TO_PAGE_KEY"] = $4f22b85ba3ca0c76$export$771989b0afde4911;
module.exports["CONFLUENCE_WHITEBOARD_BRAINSTORMING_KEY"] = $4f22b85ba3ca0c76$export$325918e7af3a74aa;
module.exports["isConfluenceWhiteboardBrainstormingActionData"] = $4f22b85ba3ca0c76$export$48e8bcda6802129c;
module.exports["LEGACY_CONFLUENCE_WHITEBOARD_DIAGRAMMING_KEY"] = $4f22b85ba3ca0c76$export$e3c19505945cf210;
module.exports["AIFC_CONFLUENCE_WHITEBOARD_DIAGRAMMING_KEY"] = $4f22b85ba3ca0c76$export$c8f288feec1641d9;
module.exports["isConfluenceWhiteboardDiagrammingActionData"] = $4f22b85ba3ca0c76$export$f3a918f4f62365b2;
module.exports["CONFLUENCE_AIFC_DATABASE_CREATE_KEY"] = $4f22b85ba3ca0c76$export$9f1bd612d6abcf5c;
module.exports["isConfluenceAIFCDatabaseCreateActionData"] = $4f22b85ba3ca0c76$export$4dec930442f5ade2;
module.exports["CONFLUENCE_AIFC_DATABASE_UPDATE_KEY"] = $4f22b85ba3ca0c76$export$ee0a705006a79cfe;
module.exports["isConfluenceAIFCDatabaseUpdateActionData"] = $4f22b85ba3ca0c76$export$dbed60ca289ab1f3;
module.exports["CONFLUENCE_AIFC_SPACE_CREATE_KEY"] = $4f22b85ba3ca0c76$export$691e9b05e574e32c;
module.exports["isConfluenceAIFCSpaceCreateActionData"] = $4f22b85ba3ca0c76$export$545244afe3ae2546;
module.exports["CONFLUENCE_AIFC_SPACE_UPDATE_KEY"] = $4f22b85ba3ca0c76$export$af91dd9bf235f890;
module.exports["isConfluenceAIFCSpaceUpdateActionData"] = $4f22b85ba3ca0c76$export$38f648644a8b3072;
module.exports["PAGE_CREATE_ACTIONS"] = $4f22b85ba3ca0c76$export$9f62c3ae716c44b2;
module.exports["WHITEBOARD_CREATE_ACTIONS"] = $4f22b85ba3ca0c76$export$aba0c096f5cdcaca;
module.exports["SLIDES_CREATE_ACTIONS"] = $4f22b85ba3ca0c76$export$b9c5aef93dba02df;
module.exports["DATABASE_CREATE_ACTIONS"] = $4f22b85ba3ca0c76$export$45a7157715c10f20;
module.exports["isConfluencePageCreateAction"] = $4f22b85ba3ca0c76$export$6c0ed26dac146a75;
module.exports["isConfluenceCreatableAction"] = $4f22b85ba3ca0c76$export$eac4577c3e50732a;
module.exports["isConfluenceCreateNewAction"] = $4f22b85ba3ca0c76$export$79fc6c76b9755410;
module.exports["isServerSideExecutionAction"] = $4f22b85ba3ca0c76$export$6b900ddfe8315d64;
module.exports["isDynamicUiCreatableAction"] = $4f22b85ba3ca0c76$export$53f0114d9f187b14;
module.exports["isImageCreatableAction"] = $4f22b85ba3ca0c76$export$b3dfc475c0b1ff86;
module.exports["isConfluencePageUpdateAction"] = $4f22b85ba3ca0c76$export$dfda1ac7e19cab7b;
module.exports["isConfluenceWhiteboardUpdateAction"] = $4f22b85ba3ca0c76$export$dcbfc8a9b613cd00;
module.exports["isConfluenceSlidesUpdateAction"] = $4f22b85ba3ca0c76$export$5d2d4e8984b13e00;
module.exports["isConfluenceDatabaseUpdateAction"] = $4f22b85ba3ca0c76$export$399c9116e9984ca3;
module.exports["isConfluenceUpdatableAction"] = $4f22b85ba3ca0c76$export$73dc9ed6ed2373f;
module.exports["isConfluenceStreamAction"] = $4f22b85ba3ca0c76$export$54716060fc6e52ee;
module.exports["isConfluencePreviewCardAction"] = $4f22b85ba3ca0c76$export$5cb5e5f4b4ce0a33;
module.exports["generateRovoReceiverId"] = $4f22b85ba3ca0c76$export$681cf9ea58de88fd;
module.exports["getConfluenceContentType"] = $4f22b85ba3ca0c76$export$bb9f6b0763834612;
module.exports["isAccumulatedAction"] = $4f22b85ba3ca0c76$export$b95f9369e33f3b4a;
module.exports["getAccumulatedActionTypeGuard"] = $4f22b85ba3ca0c76$export$898d9c03b4eb5dd5;
module.exports["getPrimaryAccumulatedValue"] = $4f22b85ba3ca0c76$export$240debd921ff9f65;
module.exports["isRemixGeneratedAction"] = $4f22b85ba3ca0c76$export$5b30faa0f696991d;
module.exports["isRemixGeneratedFlow"] = $4f22b85ba3ca0c76$export$8eb2b74d04c8d455;
module.exports["getDynamicUiType"] = $4f22b85ba3ca0c76$export$a549b965e1dff398;
module.exports["getDynamicUiSubtype"] = $4f22b85ba3ca0c76$export$90cf5cf844c2f3b0;
module.exports["getRemixMetadata"] = $4f22b85ba3ca0c76$export$ff1c2950f6d5486f;
module.exports["customActionUpdater"] = $4f22b85ba3ca0c76$export$64e13fa6a74f5f86;

});

parcelRegister("jgLU9", function(module, exports) {

var $dSoGR = parcelRequire("dSoGR");

const $e730b19886d98d25$export$70ef311846fe6cee = (0, $dSoGR.createCommand)('inline-input-box-aborted-message-command');
module.exports["InlineInputBoxAbortedMessageCommand"] = $e730b19886d98d25$export$70ef311846fe6cee;

});

parcelRegister("3Ak5G", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5Tn11 = parcelRequire("5Tn11");


var $85mU8 = parcelRequire("85mU8");

const $80d108dec70fe388$export$ff8fdce0b2574720 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $85mU8.getBrowserBridgeAPI)();
        $[0] = t0;
    } else t0 = $[0];
    const bridgeAPI = t0;
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (command, params)=>{
            const fullParams = {
                ...params,
                senderId: (0, $5Tn11.ROVO_CHAT_CLIENT_ID)
            };
            return bridgeAPI.send(command, fullParams);
        };
        $[1] = t1;
    } else t1 = $[1];
    const sendCommand = t1;
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {
            sendCommand: sendCommand
        };
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : ()=>{
    const bridgeAPI = (0, $85mU8.getBrowserBridgeAPI)();
    const sendCommand = (0, $cozmU.useCallback)((command, params)=>{
        // Automatically inject senderId while preserving all other params
        const fullParams = {
            ...params,
            senderId: (0, $5Tn11.ROVO_CHAT_CLIENT_ID)
        };
        return bridgeAPI.send(command, fullParams);
    }, [
        bridgeAPI
    ]);
    return {
        sendCommand: sendCommand
    };
};
module.exports["useBridgeSendCommand"] = $80d108dec70fe388$export$ff8fdce0b2574720;

});

parcelRegister("kYruZ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $5660d388ea5e45af$export$cc43ac18fa8b23d = (0, $cozmU.createContext)(false);
module.exports["ConversationAssistantLoadingContext"] = $5660d388ea5e45af$export$cc43ac18fa8b23d;

});

parcelRegister("1FOPM", function(module, exports) {
// Single-source dynamic import factory for the chat UI chunk.
// Mirrors `import-conversation-assistant.ts`: the `lazy()` boundary
// (`ConversationAssistantUILazy`) and the intent-time preload both go through here so they share
// one chunk identity.

const $9c885de35cb434ea$export$94646181d4dabf90 = ()=>(parcelRequire("6dDoo"));
module.exports["importConversationAssistantUI"] = $9c885de35cb434ea$export$94646181d4dabf90;

});

parcelRegister("6dDoo", function(module, exports) {

let $48728382342c234e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $48728382342c234e$var$load("khIi2"),
    $48728382342c234e$var$load("eEjUf"),
    $48728382342c234e$var$load("mRQTa"),
    $48728382342c234e$var$load("7I4uK"),
    $48728382342c234e$var$load("hUbK8"),
    $48728382342c234e$var$load("aM1Vm"),
    $48728382342c234e$var$load("8eGGc"),
    $48728382342c234e$var$load("j2sFR"),
    $48728382342c234e$var$load("8PDKl"),
    $48728382342c234e$var$load("b5NUu"),
    $48728382342c234e$var$load("gcI6u"),
    $48728382342c234e$var$load("7TMgc"),
    $48728382342c234e$var$load("4M5us"),
    $48728382342c234e$var$load("aVpwX"),
    $48728382342c234e$var$load("kXzPm"),
    $48728382342c234e$var$load("7BUZH"),
    $48728382342c234e$var$load("03zSE"),
    $48728382342c234e$var$load("b9Ivi"),
    $48728382342c234e$var$load("lPKve"),
    $48728382342c234e$var$load("dmzjI"),
    $48728382342c234e$var$load("f7eY1"),
    $48728382342c234e$var$load("kedWY"),
    $48728382342c234e$var$load("2o5fZ"),
    $48728382342c234e$var$load("5ZbCn"),
    $48728382342c234e$var$load("3zwpG"),
    $48728382342c234e$var$load("ennNB"),
    $48728382342c234e$var$load("9Hr92"),
    $48728382342c234e$var$load("iYvvi"),
    $48728382342c234e$var$load("eWXZF"),
    $48728382342c234e$var$load("kfGHh"),
    $48728382342c234e$var$load("lIiD7"),
    $48728382342c234e$var$load("bJbqV"),
    $48728382342c234e$var$load("hLB9K"),
    $48728382342c234e$var$load("hpDuu"),
    $48728382342c234e$var$load("lWstc"),
    $48728382342c234e$var$load("5ns6c"),
    $48728382342c234e$var$load("6TLS9"),
    $48728382342c234e$var$load("dxcsb"),
    $48728382342c234e$var$load("cZjWF"),
    $48728382342c234e$var$load("lIK0s"),
    $48728382342c234e$var$load("5tz0J"),
    $48728382342c234e$var$load("8exG0"),
    $48728382342c234e$var$load("gnocL"),
    $48728382342c234e$var$load("4g6rd"),
    $48728382342c234e$var$load("kT6dz"),
    $48728382342c234e$var$load("2jERw"),
    $48728382342c234e$var$load("b7144"),
    $48728382342c234e$var$load("ep2Eq"),
    $48728382342c234e$var$load("9LDVS"),
    $48728382342c234e$var$load("kiMHu"),
    $48728382342c234e$var$load("cKDij"),
    $48728382342c234e$var$load("45r7q"),
    $48728382342c234e$var$load("6wr18"),
    $48728382342c234e$var$load("7SteV"),
    $48728382342c234e$var$load("5JmXn"),
    $48728382342c234e$var$load("ffEVr"),
    $48728382342c234e$var$load("Wowvf"),
    $48728382342c234e$var$load("cGkFm"),
    $48728382342c234e$var$load("dYUYM"),
    $48728382342c234e$var$load("lgRS0"),
    $48728382342c234e$var$load("ce05o"),
    $48728382342c234e$var$load("hhss7"),
    $48728382342c234e$var$load("7EorR"),
    $48728382342c234e$var$load("9SEo9")
]).then(()=>parcelRequire('8RDrG'));

});

parcelRegister("iA8l9", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $6CGVr = parcelRequire("6CGVr");


var $9DHhW = parcelRequire("9DHhW");


var $iGwRU = parcelRequire("iGwRU");


var $3Uocj = parcelRequire("3Uocj");


var $l9F99 = parcelRequire("l9F99");


var $i8NpI = parcelRequire("i8NpI");

const $65d9609224d5a714$var$globalEventConfig = (0, $i8NpI.getDefaultTrackEventConfig)();
const $65d9609224d5a714$export$885784b0858eefcc = (0, $gtMdU.isReactCompilerActivePlatform)() ? (commonAttributes)=>{
    const $ = (0, $bDgLe.c)(7);
    const analyticsContext = (0, $cozmU.useContext)((0, $6CGVr.default));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const commonAttributesRef = (0, $cozmU.useRef)(commonAttributes);
    let t0;
    if ($[0] !== analyticsContext || $[1] !== createAnalyticsEvent) {
        t0 = (event)=>{
            const attributes = {
                ...(0, $l9F99.getAttributesFromContexts)(analyticsContext.getAtlaskitAnalyticsContext()),
                ...commonAttributesRef.current,
                library: (0, $3Uocj.LIBRARY_ATTRIBUTE),
                ...event.attributes
            };
            createAnalyticsEvent({
                ...$65d9609224d5a714$var$globalEventConfig,
                ...event,
                attributes: attributes
            }).fire((0, $iGwRU.ANALYTICS_CHANNEL));
        };
        $[0] = analyticsContext;
        $[1] = createAnalyticsEvent;
        $[2] = t0;
    } else t0 = $[2];
    const fireAnalyticsEvent = t0;
    let t1;
    if ($[3] !== fireAnalyticsEvent) {
        t1 = (payload)=>{
            const { action: action, actionSubject: actionSubject, attributes: attributes_0, ...eventProps } = payload;
            fireAnalyticsEvent({
                actionSubject: actionSubject,
                action: action,
                ...eventProps,
                attributes: attributes_0
            });
        };
        $[3] = fireAnalyticsEvent;
        $[4] = t1;
    } else t1 = $[4];
    const trackAgentEvent = t1;
    let t2;
    if ($[5] !== trackAgentEvent) {
        t2 = {
            trackAgentEvent: trackAgentEvent
        };
        $[5] = trackAgentEvent;
        $[6] = t2;
    } else t2 = $[6];
    return t2;
} : (commonAttributes)=>{
    const analyticsContext = (0, $cozmU.useContext)((0, $6CGVr.default));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const commonAttributesRef = (0, $cozmU.useRef)(commonAttributes);
    const fireAnalyticsEvent = (0, $cozmU.useCallback)((event)=>{
        const attributes = {
            ...(0, $l9F99.getAttributesFromContexts)(analyticsContext.getAtlaskitAnalyticsContext()),
            ...commonAttributesRef.current,
            library: (0, $3Uocj.LIBRARY_ATTRIBUTE),
            ...event.attributes
        };
        createAnalyticsEvent({
            ...$65d9609224d5a714$var$globalEventConfig,
            ...event,
            attributes: attributes
        }).fire((0, $iGwRU.ANALYTICS_CHANNEL));
    }, [
        createAnalyticsEvent,
        analyticsContext
    ] // keep number of dependencies minimal to prevent re-rendering
    );
    /**
   * Fully-typed event tracking using discriminated union payload types.
   * The payload type enforces correct action, actionSubject, and attributes.
   */ const trackAgentEvent = (0, $cozmU.useCallback)((payload)=>{
        const { action: action, actionSubject: actionSubject, attributes: attributes_0, ...eventProps } = payload;
        fireAnalyticsEvent({
            actionSubject: actionSubject,
            action: action,
            ...eventProps,
            attributes: attributes_0
        });
    }, [
        fireAnalyticsEvent
    ]);
    return {
        trackAgentEvent: trackAgentEvent
    };
};
module.exports["useRovoAgentActionAnalytics"] = $65d9609224d5a714$export$885784b0858eefcc;

});

parcelRegister("6CGVr", function(module, exports) {
$parcel$export(module.exports, "default", () => $34a107ebb1ee65d2$export$2e2bcd8739ae039);

var $3ge84 = parcelRequire("3ge84");

var $34a107ebb1ee65d2$export$2e2bcd8739ae039 = (0, $3ge84.default);

});

parcelRegister("iGwRU", function(module, exports) {

var $iTJtk = parcelRequire("iTJtk");

const $3011e158d8129415$export$85183a312807388d = (0, $iTJtk.FabricChannel).aiMate;
module.exports["ANALYTICS_CHANNEL"] = $3011e158d8129415$export$85183a312807388d;

});

parcelRegister("3Uocj", function(module, exports) {
const $22c81417b0ee1e9b$export$88bd91d3e490ceb5 = 'agents-analytics';
module.exports["LIBRARY_ATTRIBUTE"] = $22c81417b0ee1e9b$export$88bd91d3e490ceb5;

});

parcelRegister("l9F99", function(module, exports) {
const $9a048168f718fa86$export$d97c97ed77ff09e8 = (context)=>{
    if (!context || !Array.isArray(context)) return {};
    return context.reduce((acc, x)=>{
        return {
            ...acc,
            ...x.attributes ?? {}
        };
    }, {});
};
module.exports["getAttributesFromContexts"] = $9a048168f718fa86$export$d97c97ed77ff09e8;

});

parcelRegister("i8NpI", function(module, exports) {
const $5912f9d7fe53faa6$export$f6abe2eda5c1912f = ()=>({
        eventType: 'track',
        tags: [
            'atlaskit'
        ]
    });
module.exports["getDefaultTrackEventConfig"] = $5912f9d7fe53faa6$export$f6abe2eda5c1912f;

});

parcelRegister("aQWBL", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $7685l = parcelRequire("7685l");

const $e2fc5133d9d39a50$export$e8c93422b36ab121 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (key)=>{
    const state = (0, $7685l.useChatModeStore)(key)[0];
    return state;
} : (key)=>{
    const state = (0, $7685l.useChatModeStore)(key)[0];
    return state;
};
module.exports["useChatModeState"] = $e2fc5133d9d39a50$export$e8c93422b36ab121;

});

parcelRegister("7685l", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");


var $gchVc = parcelRequire("gchVc");


var $5osBM = parcelRequire("5osBM");


var $eu92c = parcelRequire("eu92c");


var $fiVb2 = parcelRequire("fiVb2");

const $69cb0d12a6c3bd0b$var$selector = (state, key)=>{
    const chatMode = state[key] || (0, $5osBM.getDerivedDefaultChatMode)();
    return {
        ...chatMode,
        ...(0, $eu92c.getDerivedReasoningMode)(chatMode.reasoningMode),
        appFilters: (0, $gchVc.getAppFilters)(chatMode.orgKnowledge)
    };
};
const $69cb0d12a6c3bd0b$export$cdc6dc7c4e8829fa = (0, $kBr4q.createHook)((0, $fiVb2.store), {
    selector: $69cb0d12a6c3bd0b$var$selector
});
module.exports["useChatModeStore"] = $69cb0d12a6c3bd0b$export$cdc6dc7c4e8829fa;

});

parcelRegister("hOUgz", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $iDrrr = parcelRequire("iDrrr");


var $gzMZq = parcelRequire("gzMZq");


var $aJU2k = parcelRequire("aJU2k");


var $4TNMQ = parcelRequire("4TNMQ");


var $d9k9Z = parcelRequire("d9k9Z");

const $0893a5bb718d1a9a$var$JIRA_VIEW_CONTEXT_KEY = 'jira_view_context';
const $0893a5bb718d1a9a$var$TRELLO_VIEW_CONTEXT_KEY = 'trello_view_context';
function $0893a5bb718d1a9a$var$hasValidJiraViewContextData(value) {
    if (value == null || typeof value !== 'object') return false;
    const selected = Object.getOwnPropertyDescriptor(value, 'selectedIssueIdentifiers')?.value;
    return Array.isArray(selected);
}
function $0893a5bb718d1a9a$var$hasValidTrelloViewContextData(value) {
    if (value == null || typeof value !== 'object') return false;
    const url = Object.getOwnPropertyDescriptor(value, 'url')?.value;
    return typeof url === 'string';
}
const $0893a5bb718d1a9a$export$a96e0fbf256603d8 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(26);
    const pageContextType = (0, $d9k9Z.usePageContextType)();
    const { getChatMode: getChatMode, setUseCurrentPageContext: setUseCurrentPageContext } = (0, $aJU2k.useChatModeStoreActions)();
    const [editorContext] = (0, $gzMZq.useChatContextEditorContext)();
    const [artifactContext] = (0, $gzMZq.useChatContextArtifactContext)();
    const [databaseContext] = (0, $gzMZq.useChatContextDatabaseContext)();
    const [aiFeatureContext] = (0, $gzMZq.useChatContextAIFeatureContext)();
    const rawJiraViewContext = aiFeatureContext?.[$0893a5bb718d1a9a$var$JIRA_VIEW_CONTEXT_KEY];
    let t0;
    if ($[0] !== rawJiraViewContext) {
        t0 = $0893a5bb718d1a9a$var$hasValidJiraViewContextData(rawJiraViewContext) ? rawJiraViewContext : undefined;
        $[0] = rawJiraViewContext;
        $[1] = t0;
    } else t0 = $[1];
    const jiraViewContextData = t0;
    const rawTrelloViewContext = aiFeatureContext?.[$0893a5bb718d1a9a$var$TRELLO_VIEW_CONTEXT_KEY];
    let t1;
    if ($[2] !== rawTrelloViewContext) {
        t1 = $0893a5bb718d1a9a$var$hasValidTrelloViewContextData(rawTrelloViewContext) ? rawTrelloViewContext : undefined;
        $[2] = rawTrelloViewContext;
        $[3] = t1;
    } else t1 = $[3];
    const trelloViewContextData = t1;
    let t2;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {
            type: "none"
        };
        $[4] = t2;
    } else t2 = $[4];
    let currentContext = t2;
    if (trelloViewContextData && (0, $iDrrr.fg)("trello_enterprise_rovo_trello_context")) {
        let t3;
        if ($[5] !== trelloViewContextData) {
            t3 = {
                type: "trello_view_context",
                payload: trelloViewContextData
            };
            $[5] = trelloViewContextData;
            $[6] = t3;
        } else t3 = $[6];
        currentContext = t3;
    } else if (artifactContext) {
        let t3;
        if ($[7] !== artifactContext) {
            t3 = {
                type: "artifact_context",
                payload: artifactContext
            };
            $[7] = artifactContext;
            $[8] = t3;
        } else t3 = $[8];
        currentContext = t3;
    } else {
        if (editorContext) {
            let t3;
            if ($[9] !== editorContext) {
                t3 = {
                    type: "editor_context",
                    payload: editorContext
                };
                $[9] = editorContext;
                $[10] = t3;
            } else t3 = $[10];
            currentContext = t3;
        } else if (databaseContext) {
            let t3;
            if ($[11] !== databaseContext.selectedElementIds) {
                t3 = databaseContext.selectedElementIds ?? [];
                $[11] = databaseContext.selectedElementIds;
                $[12] = t3;
            } else t3 = $[12];
            let t4;
            if ($[13] !== t3) {
                t4 = {
                    type: "database_context",
                    selectedElementIds: t3
                };
                $[13] = t3;
                $[14] = t4;
            } else t4 = $[14];
            currentContext = t4;
        } else {
            if (jiraViewContextData) {
                let t3;
                if ($[15] !== jiraViewContextData) {
                    t3 = {
                        type: "jira_view_context",
                        payload: jiraViewContextData
                    };
                    $[15] = jiraViewContextData;
                    $[16] = t3;
                } else t3 = $[16];
                currentContext = t3;
            } else if (pageContextType !== (0, $4TNMQ.PageContextType).UNKNOWN) {
                let t3;
                if ($[17] !== pageContextType) {
                    t3 = {
                        type: "current_page",
                        pageContextType: pageContextType
                    };
                    $[17] = pageContextType;
                    $[18] = t3;
                } else t3 = $[18];
                currentContext = t3;
            }
        }
    }
    let t3;
    if ($[19] !== getChatMode) {
        t3 = (key)=>getChatMode(key).useCurrentPageContext;
        $[19] = getChatMode;
        $[20] = t3;
    } else t3 = $[20];
    let t4;
    if ($[21] !== currentContext || $[22] !== jiraViewContextData || $[23] !== setUseCurrentPageContext || $[24] !== t3) {
        t4 = {
            canUseCurrentPageContextUserPreference: t3,
            setUseCurrentPageContextUserPreference: setUseCurrentPageContext,
            currentContext: currentContext,
            jiraViewContextData: jiraViewContextData
        };
        $[21] = currentContext;
        $[22] = jiraViewContextData;
        $[23] = setUseCurrentPageContext;
        $[24] = t3;
        $[25] = t4;
    } else t4 = $[25];
    return t4;
} : ()=>{
    const pageContextType = (0, $d9k9Z.usePageContextType)();
    const { getChatMode: getChatMode, setUseCurrentPageContext: setUseCurrentPageContext } = (0, $aJU2k.useChatModeStoreActions)();
    const [editorContext] = (0, $gzMZq.useChatContextEditorContext)();
    const [artifactContext] = (0, $gzMZq.useChatContextArtifactContext)();
    const [databaseContext] = (0, $gzMZq.useChatContextDatabaseContext)();
    const [aiFeatureContext] = (0, $gzMZq.useChatContextAIFeatureContext)();
    const rawJiraViewContext = aiFeatureContext?.[$0893a5bb718d1a9a$var$JIRA_VIEW_CONTEXT_KEY];
    const jiraViewContextData = $0893a5bb718d1a9a$var$hasValidJiraViewContextData(rawJiraViewContext) ? rawJiraViewContext : undefined;
    const rawTrelloViewContext = aiFeatureContext?.[$0893a5bb718d1a9a$var$TRELLO_VIEW_CONTEXT_KEY];
    const trelloViewContextData = $0893a5bb718d1a9a$var$hasValidTrelloViewContextData(rawTrelloViewContext) ? rawTrelloViewContext : undefined;
    let currentContext = {
        type: 'none'
    };
    if (trelloViewContextData && (0, $iDrrr.fg)('trello_enterprise_rovo_trello_context')) // prefer trello context over page context if available
    currentContext = {
        type: 'trello_view_context',
        payload: trelloViewContextData
    };
    else if (artifactContext) currentContext = {
        type: 'artifact_context',
        payload: artifactContext
    };
    else if (editorContext) // prefer editor context over page context if available
    currentContext = {
        type: 'editor_context',
        payload: editorContext
    };
    else if (databaseContext) currentContext = {
        type: 'database_context',
        selectedElementIds: databaseContext.selectedElementIds ?? []
    };
    else if (jiraViewContextData) currentContext = {
        type: 'jira_view_context',
        payload: jiraViewContextData
    };
    else if (pageContextType !== (0, $4TNMQ.PageContextType).UNKNOWN) // if no editor context, use page context if available
    currentContext = {
        type: 'current_page',
        pageContextType: pageContextType
    };
    return {
        canUseCurrentPageContextUserPreference: (key)=>{
            return getChatMode(key).useCurrentPageContext;
        },
        setUseCurrentPageContextUserPreference: setUseCurrentPageContext,
        currentContext: currentContext,
        jiraViewContextData: jiraViewContextData
    };
};
module.exports["useCurrentPageAsContext"] = $0893a5bb718d1a9a$export$a96e0fbf256603d8;

});

parcelRegister("4TNMQ", function(module, exports) {
var $4d02c50d752d2f92$export$7f7a6f1c2ab5127 = /*#__PURE__*/ function(PageContextType) {
    PageContextType["BITBUCKET"] = "bitbucket";
    PageContextType["CONFLUENCE_HOME"] = "confluence-home";
    PageContextType["CONFLUENCE_PAGE_VIEW"] = "confluence-page-view";
    PageContextType["CONFLUENCE_PAGE_EDIT"] = "confluence-page-edit";
    PageContextType["CONFLUENCE_WHITEBOARD"] = "confluence-whiteboard";
    PageContextType["CONFLUENCE_DATABASE"] = "confluence-database";
    PageContextType["CONFLUENCE_FOLDER"] = "confluence-folder";
    PageContextType["JIRA_HOME"] = "jira-home";
    PageContextType["JIRA_ISSUE_VIEW"] = "jira-issue-view";
    PageContextType["JIRA_BACKLOG"] = "jira-backlog";
    PageContextType["JIRA_BOARD"] = "jira-board-view";
    PageContextType["JIRA_PROJECT"] = "jira-project";
    PageContextType["JIRA_SERVICE_DESK"] = "jira-service-desk";
    PageContextType["JIRA_PLAN"] = "jira-plan";
    PageContextType["JIRA_CMP_SPACE_SETTINGS_PEOPLE_LEGACY"] = "jira-cmp-space-settings-people-legacy";
    PageContextType["JIRA_CMP_SPACE_SETTINGS_PERMISSIONS_LEGACY"] = "jira-cmp-space-settings-permissions-legacy";
    PageContextType["JIRA_ISSUES_LIST"] = "jira-issues-list";
    PageContextType["JIRA_ITAM_HAM"] = "jira-itam-ham";
    PageContextType["ATLAS_HOME"] = "atlas-home";
    PageContextType["ATLAS_PROJECT"] = "atlas-project";
    PageContextType["ATLAS_GOAL"] = "atlas-goal";
    PageContextType["FEEDBACK_APP"] = "feedback-app";
    PageContextType["STORE_HOME"] = "store-home";
    PageContextType["TRELLO_BOARD"] = "trello-board";
    PageContextType["TRELLO_CARD"] = "trello-card";
    PageContextType["LOOM_VIDEO"] = "loom-video";
    PageContextType["TEAM_PROFILE"] = "team-profile";
    PageContextType["USER_PROFILE"] = "user-profile";
    PageContextType["TALENT"] = "talent";
    PageContextType["UNKNOWN"] = "unknown";
    return PageContextType;
}({});
module.exports["PageContextType"] = $4d02c50d752d2f92$export$7f7a6f1c2ab5127;

});

parcelRegister("d9k9Z", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $izud5 = parcelRequire("izud5");


var $lN13T = parcelRequire("lN13T");


var $hywIT = parcelRequire("hywIT");

const $050ca14b256e7a37$export$bc4bf2ff8e40b690 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const useCase = t0 === undefined ? (0, $lN13T.UseCase).THINKING_VIEW : t0;
    const location = (0, $hywIT.useWindowLocation)();
    let t1;
    if ($[0] !== location || $[1] !== useCase) {
        t1 = (0, $izud5.determinePageType)(location, useCase);
        $[0] = location;
        $[1] = useCase;
        $[2] = t1;
    } else t1 = $[2];
    const [pageContextType, setPageContextType] = (0, $cozmU.useState)(t1);
    let t2;
    let t3;
    if ($[3] !== location || $[4] !== useCase) {
        t2 = ()=>{
            setPageContextType((0, $izud5.determinePageType)(location, useCase));
        };
        t3 = [
            location,
            useCase
        ];
        $[3] = location;
        $[4] = useCase;
        $[5] = t2;
        $[6] = t3;
    } else {
        t2 = $[5];
        t3 = $[6];
    }
    (0, $cozmU.useEffect)(t2, t3);
    return pageContextType;
} : (useCase = (0, $lN13T.UseCase).THINKING_VIEW)=>{
    const location = (0, $hywIT.useWindowLocation)();
    const [pageContextType, setPageContextType] = (0, $cozmU.useState)((0, $izud5.determinePageType)(location, useCase));
    (0, $cozmU.useEffect)(()=>{
        setPageContextType((0, $izud5.determinePageType)(location, useCase));
    }, [
        location,
        useCase
    ]);
    return pageContextType;
};
module.exports["usePageContextType"] = $050ca14b256e7a37$export$bc4bf2ff8e40b690;

});

parcelRegister("izud5", function(module, exports) {

var $4o0zT = parcelRequire("4o0zT");


var $iDrrr = parcelRequire("iDrrr");


var $4TNMQ = parcelRequire("4TNMQ");


var $lN13T = parcelRequire("lN13T");

const $9f65aecae4ace5e7$var$ALLOWED_PAGE_CONTEXT_TYPES = {
    [(0, $lN13T.UseCase).THINKING_VIEW]: [
        (0, $4TNMQ.PageContextType).CONFLUENCE_PAGE_EDIT,
        (0, $4TNMQ.PageContextType).CONFLUENCE_PAGE_VIEW,
        (0, $4TNMQ.PageContextType).CONFLUENCE_WHITEBOARD,
        (0, $4TNMQ.PageContextType).CONFLUENCE_DATABASE,
        (0, $4TNMQ.PageContextType).CONFLUENCE_FOLDER,
        (0, $4TNMQ.PageContextType).JIRA_ISSUE_VIEW,
        (0, $4TNMQ.PageContextType).JIRA_SERVICE_DESK,
        (0, $4TNMQ.PageContextType).JIRA_PROJECT,
        (0, $4TNMQ.PageContextType).JIRA_PLAN,
        (0, $4TNMQ.PageContextType).JIRA_CMP_SPACE_SETTINGS_PEOPLE_LEGACY,
        (0, $4TNMQ.PageContextType).JIRA_CMP_SPACE_SETTINGS_PERMISSIONS_LEGACY,
        (0, $4TNMQ.PageContextType).JIRA_ISSUES_LIST,
        (0, $4TNMQ.PageContextType).JIRA_ITAM_HAM,
        (0, $4TNMQ.PageContextType).ATLAS_PROJECT,
        (0, $4TNMQ.PageContextType).ATLAS_GOAL,
        (0, $4TNMQ.PageContextType).FEEDBACK_APP,
        (0, $4TNMQ.PageContextType).STORE_HOME,
        (0, $4TNMQ.PageContextType).TRELLO_BOARD,
        (0, $4TNMQ.PageContextType).TRELLO_CARD,
        (0, $4TNMQ.PageContextType).LOOM_VIDEO,
        (0, $4TNMQ.PageContextType).TEAM_PROFILE,
        (0, $4TNMQ.PageContextType).USER_PROFILE,
        (0, $4TNMQ.PageContextType).TALENT
    ],
    [(0, $lN13T.UseCase).AUTOCOMPLETE]: [
        (0, $4TNMQ.PageContextType).BITBUCKET,
        (0, $4TNMQ.PageContextType).CONFLUENCE_HOME,
        (0, $4TNMQ.PageContextType).CONFLUENCE_PAGE_EDIT,
        (0, $4TNMQ.PageContextType).CONFLUENCE_PAGE_VIEW,
        (0, $4TNMQ.PageContextType).CONFLUENCE_WHITEBOARD,
        (0, $4TNMQ.PageContextType).CONFLUENCE_DATABASE,
        (0, $4TNMQ.PageContextType).JIRA_BACKLOG,
        (0, $4TNMQ.PageContextType).JIRA_HOME,
        (0, $4TNMQ.PageContextType).JIRA_ISSUE_VIEW,
        (0, $4TNMQ.PageContextType).ATLAS_HOME,
        (0, $4TNMQ.PageContextType).STORE_HOME,
        (0, $4TNMQ.PageContextType).TRELLO_BOARD,
        (0, $4TNMQ.PageContextType).TRELLO_CARD
    ]
};
const $9f65aecae4ace5e7$var$FALLBACK_PAGE_CONTEXT_TYPE = {
    [(0, $lN13T.UseCase).THINKING_VIEW]: (0, $4TNMQ.PageContextType).UNKNOWN,
    [(0, $lN13T.UseCase).AUTOCOMPLETE]: (0, $4TNMQ.PageContextType).ATLAS_HOME
};
const $9f65aecae4ace5e7$var$TALENT_PAGE_PATTERN = /^(?:[^:/?#]+:\/\/[^/?#]+)?\/talent(?:[/?#]|$)/;
const $9f65aecae4ace5e7$export$a905239756c1fbae = (location, useCase = (0, $lN13T.UseCase).THINKING_VIEW)=>{
    const allowedTypes = new Set($9f65aecae4ace5e7$var$ALLOWED_PAGE_CONTEXT_TYPES[useCase]);
    const allUrlPatterns = [
        [
            (0, $4TNMQ.PageContextType).BITBUCKET,
            /bitbucket\.org\/.*/
        ],
        [
            (0, $4TNMQ.PageContextType).CONFLUENCE_PAGE_EDIT,
            /\/wiki\/spaces\/[^\/]+\/(?:pages|blog)\/edit-v2\//
        ],
        [
            (0, $4TNMQ.PageContextType).CONFLUENCE_PAGE_VIEW,
            /\/wiki\/spaces\/[^\/]+\/(?:pages|blog)\//
        ],
        // Support whiteboard url
        [
            (0, $4TNMQ.PageContextType).CONFLUENCE_WHITEBOARD,
            /\/wiki\/spaces\/[^\/]+\/whiteboard\//
        ],
        // Support whiteboard iframe url
        [
            (0, $4TNMQ.PageContextType).CONFLUENCE_WHITEBOARD,
            /\/whiteboards\/whiteboard\/[^\/\?]+/
        ],
        // Support whiteboard internal url after spa transition
        [
            (0, $4TNMQ.PageContextType).CONFLUENCE_WHITEBOARD,
            /\/whiteboard\/[a-f0-9-]+/
        ],
        // Support database url
        [
            (0, $4TNMQ.PageContextType).CONFLUENCE_DATABASE,
            /\/wiki\/spaces\/[^\/]+\/database\//
        ],
        // Support database internal url after spa transition
        [
            (0, $4TNMQ.PageContextType).CONFLUENCE_DATABASE,
            /\/database\/[a-f0-9-]+/
        ],
        // Support folder url
        ...(0, $4o0zT.isExperimentEnabled)('folder_content_wrapper') ? [
            [
                (0, $4TNMQ.PageContextType).CONFLUENCE_FOLDER,
                /\/wiki\/spaces\/[^\/]+\/folder\//
            ]
        ] : [],
        [
            (0, $4TNMQ.PageContextType).JIRA_BACKLOG,
            /\/jira\/.*\/backlog$/
        ],
        [
            (0, $4TNMQ.PageContextType).JIRA_BOARD,
            /\/jira\/.*\/boards\//
        ],
        [
            (0, $4TNMQ.PageContextType).JIRA_ISSUE_VIEW,
            /\/browse\/[^\/]+$/
        ],
        [
            (0, $4TNMQ.PageContextType).JIRA_ISSUE_VIEW,
            /\/jira\/.+\/projects\/.+\?selectedIssue/
        ],
        [
            (0, $4TNMQ.PageContextType).JIRA_HOME,
            /\/jira\/dashboards\/last-visited$/
        ],
        [
            (0, $4TNMQ.PageContextType).JIRA_SERVICE_DESK,
            /\/jira(?:\/.+)?\/servicedesk\/projects\/.+\/queues\/issue\//
        ],
        [
            (0, $4TNMQ.PageContextType).JIRA_PROJECT,
            /\/jira\/.+\/projects\//
        ],
        [
            (0, $4TNMQ.PageContextType).JIRA_ISSUES_LIST,
            /\/issues\/\?jql=/
        ],
        ...(0, $iDrrr.fg)('itam_ftw') ? [
            [
                (0, $4TNMQ.PageContextType).JIRA_ITAM_HAM,
                /\/jira\/itam\/ham(\/|$)/
            ]
        ] : [],
        ...(0, $iDrrr.fg)('rovo_chat_jira_plans_minion') ? [
            [
                (0, $4TNMQ.PageContextType).JIRA_PLAN,
                /\/jira\/plans\/\d+\//
            ]
        ] : [],
        [
            (0, $4TNMQ.PageContextType).JIRA_HOME,
            /\/jira\/dashboards\/last-visited$/
        ],
        [
            (0, $4TNMQ.PageContextType).JIRA_CMP_SPACE_SETTINGS_PEOPLE_LEGACY,
            /\/plugins\/servlet\/project-config\/[^\/]+\/people/
        ],
        [
            (0, $4TNMQ.PageContextType).JIRA_CMP_SPACE_SETTINGS_PERMISSIONS_LEGACY,
            /\/plugins\/servlet\/project-config\/[^\/]+\/permissions/
        ],
        // atlas home is either home.atlassian.com, home.stg.atlassian.com, team.atlassian.com, or team.stg.atlassian.com
        [
            (0, $4TNMQ.PageContextType).ATLAS_HOME,
            /\/(home|team)\./
        ],
        [
            (0, $4TNMQ.PageContextType).ATLAS_PROJECT,
            /\/(home|team).+\/project\/ATLAS-/
        ],
        [
            (0, $4TNMQ.PageContextType).ATLAS_GOAL,
            /\/(home|team).+\/goal\/ATLAS-/
        ],
        // Store and Marketplace surfaces can appear on both internal and production domains.
        [
            (0, $4TNMQ.PageContextType).STORE_HOME,
            /(?:store\.stg\.atlassian\.com|marketplace-store\.atlassian\.com).*\/(?:(?:objects|categories)\/|search(?:\/|\?|$))/
        ],
        [
            (0, $4TNMQ.PageContextType).TEAM_PROFILE,
            /\/(home|team)\..+\/people\/team/
        ],
        [
            (0, $4TNMQ.PageContextType).USER_PROFILE,
            /\/(home|team)\..+\/people\/(?!team)/
        ],
        [
            (0, $4TNMQ.PageContextType).FEEDBACK_APP,
            /\/feedback-app/
        ],
        // Trello: trello.com and trellis.coffee (enterprise)
        [
            (0, $4TNMQ.PageContextType).TRELLO_CARD,
            /(?:trello\.com|trellis\.coffee)\/c\/[^/]+/
        ],
        [
            (0, $4TNMQ.PageContextType).TRELLO_BOARD,
            /(?:trello\.com|trellis\.coffee)\/b\/[^/]+/
        ],
        // Loom share URLs: www.loom.com, stage.loom.com, loomlocal.com:<port>
        [
            (0, $4TNMQ.PageContextType).LOOM_VIDEO,
            /(?:(?:www|stage)\.loom\.com|loomlocal\.com(?::\d+)?)\/share\/[^\/?#]+/
        ],
        ...(0, $iDrrr.fg)('rovo_chat_talent_context_pill') ? [
            [
                (0, $4TNMQ.PageContextType).TALENT,
                $9f65aecae4ace5e7$var$TALENT_PAGE_PATTERN
            ]
        ] : []
    ];
    const urlPatterns = allUrlPatterns.filter(([type])=>allowedTypes.has(type));
    for (const [type, pattern] of urlPatterns){
        const matched = pattern.test(location);
        if (!matched) continue;
        return type;
    }
    return $9f65aecae4ace5e7$var$FALLBACK_PAGE_CONTEXT_TYPE[useCase];
};
module.exports["determinePageType"] = $9f65aecae4ace5e7$export$a905239756c1fbae;

});

parcelRegister("lN13T", function(module, exports) {
var $60986b1218619e0e$export$59961d6586ccfd15 = /*#__PURE__*/ function(UseCase) {
    UseCase["THINKING_VIEW"] = "thinking-view";
    UseCase["AUTOCOMPLETE"] = "autocomplete";
    return UseCase;
}({});
module.exports["UseCase"] = $60986b1218619e0e$export$59961d6586ccfd15;

});

parcelRegister("hywIT", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $9Yqfz = parcelRequire("9Yqfz");


var $jR5eS = parcelRequire("jR5eS");

const $e75d45e703058f92$export$6fa751d66e55d2e1 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const contextValue = (0, $cozmU.useContext)((0, $jR5eS.WindowLocationContext));
    const location = (0, $cozmU.useSyncExternalStore)((0, $9Yqfz.subscribeToLocation), (0, $9Yqfz.getLocationSnapshot), (0, $9Yqfz.getLocationServerSnapshot));
    return contextValue ?? location;
} : ()=>{
    const contextValue = (0, $cozmU.useContext)((0, $jR5eS.WindowLocationContext));
    const location = (0, $cozmU.useSyncExternalStore)((0, $9Yqfz.subscribeToLocation), (0, $9Yqfz.getLocationSnapshot), (0, $9Yqfz.getLocationServerSnapshot));
    return contextValue ?? location;
};
module.exports["useWindowLocation"] = $e75d45e703058f92$export$6fa751d66e55d2e1;

});

parcelRegister("jR5eS", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $9519c4d899a3b020$export$46133998910543ac = (0, $cozmU.createContext)(null);
module.exports["WindowLocationContext"] = $9519c4d899a3b020$export$46133998910543ac;

});

parcelRegister("8VrqA", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");


var $kMkDS = parcelRequire("kMkDS");


var $cGJsZ = parcelRequire("cGJsZ");

const $e14a5679e33f0f1b$var$state = (0, $8s9DV.createStore)({
    initialState: {
        highlightActionsEditorPlaceholder: null,
        highlightActionsEditorPlaceholderSource: null,
        highlightActionsEditorPlaceholderConversationId: null
    },
    actions: {
        setHighlightActionsEditorPlaceholder: (highlightActionsEditorPlaceholder, highlightActionsEditorPlaceholderSource = null, highlightActionsEditorPlaceholderConversationId = null)=>({ setState: setState })=>{
                setState({
                    highlightActionsEditorPlaceholder: highlightActionsEditorPlaceholder,
                    highlightActionsEditorPlaceholderSource: highlightActionsEditorPlaceholderSource,
                    highlightActionsEditorPlaceholderConversationId: highlightActionsEditorPlaceholderConversationId
                });
            }
    }
});
const $e14a5679e33f0f1b$export$e638cf26ae51308d = (0, $kBr4q.createHook)($e14a5679e33f0f1b$var$state);
const $e14a5679e33f0f1b$var$getHighlightActionPlaceholderData = (prompt, placeholderText)=>{
    const promptContent = (0, $kMkDS.appendADFContent)(prompt, placeholderText);
    return promptContent;
};
const $e14a5679e33f0f1b$export$21b2d5ca0689f678 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(11);
    const [t0, t1] = $e14a5679e33f0f1b$export$e638cf26ae51308d();
    const { highlightActionsEditorPlaceholder: highlightActionsEditorPlaceholder, highlightActionsEditorPlaceholderSource: highlightActionsEditorPlaceholderSource, highlightActionsEditorPlaceholderConversationId: highlightActionsEditorPlaceholderConversationId } = t0;
    const { setHighlightActionsEditorPlaceholder: setHighlightActionsEditorPlaceholder } = t1;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t2;
    if ($[0] !== formatMessage || $[1] !== setHighlightActionsEditorPlaceholder) {
        t2 = (prompt, options)=>{
            const adfDocument = options?.skipPlaceholderPrompt ? prompt : $e14a5679e33f0f1b$var$getHighlightActionPlaceholderData(prompt, formatMessage((0, $cGJsZ.default).highlightActionsPlaceholderPrompt));
            setHighlightActionsEditorPlaceholder(adfDocument, options?.source ?? null, options?.conversationId ?? null);
        };
        $[0] = formatMessage;
        $[1] = setHighlightActionsEditorPlaceholder;
        $[2] = t2;
    } else t2 = $[2];
    const insertHighlightActionsEditorPlaceholder = t2;
    let t3;
    if ($[3] !== setHighlightActionsEditorPlaceholder) {
        t3 = ()=>{
            setHighlightActionsEditorPlaceholder(null);
        };
        $[3] = setHighlightActionsEditorPlaceholder;
        $[4] = t3;
    } else t3 = $[4];
    const clearHighlightActionsEditorPlaceholder = t3;
    let t4;
    if ($[5] !== clearHighlightActionsEditorPlaceholder || $[6] !== highlightActionsEditorPlaceholder || $[7] !== highlightActionsEditorPlaceholderConversationId || $[8] !== highlightActionsEditorPlaceholderSource || $[9] !== insertHighlightActionsEditorPlaceholder) {
        t4 = {
            highlightActionsEditorPlaceholder: highlightActionsEditorPlaceholder,
            highlightActionsEditorPlaceholderSource: highlightActionsEditorPlaceholderSource,
            highlightActionsEditorPlaceholderConversationId: highlightActionsEditorPlaceholderConversationId,
            insertHighlightActionsEditorPlaceholder: insertHighlightActionsEditorPlaceholder,
            clearHighlightActionsEditorPlaceholder: clearHighlightActionsEditorPlaceholder
        };
        $[5] = clearHighlightActionsEditorPlaceholder;
        $[6] = highlightActionsEditorPlaceholder;
        $[7] = highlightActionsEditorPlaceholderConversationId;
        $[8] = highlightActionsEditorPlaceholderSource;
        $[9] = insertHighlightActionsEditorPlaceholder;
        $[10] = t4;
    } else t4 = $[10];
    return t4;
} : ()=>{
    const [{ highlightActionsEditorPlaceholder: highlightActionsEditorPlaceholder, highlightActionsEditorPlaceholderSource: highlightActionsEditorPlaceholderSource, highlightActionsEditorPlaceholderConversationId: highlightActionsEditorPlaceholderConversationId }, { setHighlightActionsEditorPlaceholder: setHighlightActionsEditorPlaceholder }] = $e14a5679e33f0f1b$export$e638cf26ae51308d();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const insertHighlightActionsEditorPlaceholder = (0, $cozmU.useCallback)((prompt, options)=>{
        // When `skipPlaceholderPrompt` is set, seed the editor with the prompt
        // exactly as provided instead of appending the highlight-action
        // "Ask a question about this." trailer. This lets non-highlight callers
        // (e.g. a prompt supplied via URL param) pre-fill the input as an
        // editable draft without injecting extra text.
        const adfDocument = options?.skipPlaceholderPrompt ? prompt : $e14a5679e33f0f1b$var$getHighlightActionPlaceholderData(prompt, formatMessage((0, $cGJsZ.default).highlightActionsPlaceholderPrompt));
        setHighlightActionsEditorPlaceholder(adfDocument, options?.source ?? null, options?.conversationId ?? null);
    }, [
        setHighlightActionsEditorPlaceholder,
        formatMessage
    ]);
    const clearHighlightActionsEditorPlaceholder = (0, $cozmU.useCallback)(()=>{
        setHighlightActionsEditorPlaceholder(null);
    }, [
        setHighlightActionsEditorPlaceholder
    ]);
    return {
        highlightActionsEditorPlaceholder: highlightActionsEditorPlaceholder,
        highlightActionsEditorPlaceholderSource: highlightActionsEditorPlaceholderSource,
        highlightActionsEditorPlaceholderConversationId: highlightActionsEditorPlaceholderConversationId,
        insertHighlightActionsEditorPlaceholder: insertHighlightActionsEditorPlaceholder,
        clearHighlightActionsEditorPlaceholder: clearHighlightActionsEditorPlaceholder
    };
};
module.exports["useHighlightActionsEditorPlaceholder"] = $e14a5679e33f0f1b$export$21b2d5ca0689f678;

});

parcelRegister("kMkDS", function(module, exports) {
const $00de4dd959d7802e$export$f00236a854eaa848 = (content, suggestionContent)=>{
    const updatedContent = Array.isArray(content.content) ? content.content : [
        content.content
    ];
    // Append the new paragraph node
    updatedContent.push({
        type: 'paragraph',
        content: [
            {
                type: 'text',
                text: suggestionContent
            }
        ]
    });
    // Return the updated DocNode
    return {
        ...content,
        content: updatedContent
    };
};
module.exports["appendADFContent"] = $00de4dd959d7802e$export$f00236a854eaa848;

});

parcelRegister("cGJsZ", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $12b4cc67f5ec0d6d$var$message = (0, $kSwu1.defineMessages)({
    highlightActionsPlaceholderPrompt: {
        id: "highlight-actions.rovo-chat.placeholder-prompt",
        defaultMessage: "Ask a question about this."
    }
});
var $12b4cc67f5ec0d6d$export$2e2bcd8739ae039 = $12b4cc67f5ec0d6d$var$message;
module.exports["default"] = $12b4cc67f5ec0d6d$export$2e2bcd8739ae039;

});

parcelRegister("12shJ", function(module, exports) {
/** Sweet-state hooks for the spaces store. */ 
var $kBr4q = parcelRequire("kBr4q");


var $9k1Oq = parcelRequire("9k1Oq");

const $05a1a54631ae3038$export$d71442297730a984 = (0, $kBr4q.createHook)((0, $9k1Oq.spaceStore));
const $05a1a54631ae3038$export$c0aa94e8be00c505 = (0, $kBr4q.createStateHook)((0, $9k1Oq.spaceStore));
const $05a1a54631ae3038$export$995700e1beba27e2 = (0, $kBr4q.createActionsHook)((0, $9k1Oq.spaceStore));
const $05a1a54631ae3038$export$4a0158bb8391bcb = (0, $kBr4q.createStateHook)((0, $9k1Oq.spaceStore), {
    selector: (state)=>state.spaces
});
const $05a1a54631ae3038$export$40840f9e6173b9a6 = (0, $kBr4q.createStateHook)((0, $9k1Oq.spaceStore), {
    selector: (state)=>state.isListLoading
});
const $05a1a54631ae3038$export$98766e9d1f093889 = (0, $kBr4q.createStateHook)((0, $9k1Oq.spaceStore), {
    selector: (state)=>state.listError
});
const $05a1a54631ae3038$export$3939f7e557578ce8 = (0, $kBr4q.createStateHook)((0, $9k1Oq.spaceStore), {
    selector: (state)=>state.hasFetchedList
});
const $05a1a54631ae3038$export$be7cd4af1e0d2a9f = (0, $kBr4q.createStateHook)((0, $9k1Oq.spaceStore), {
    selector: (state)=>state.conversationIds
});
const $05a1a54631ae3038$export$d021bec3570c33bf = (0, $kBr4q.createStateHook)((0, $9k1Oq.spaceStore), {
    selector: (state, spaceId)=>state.spaceDetails.get(spaceId)
});
const $05a1a54631ae3038$export$a3814fef5b67c2b2 = (0, $kBr4q.createStateHook)((0, $9k1Oq.spaceStore), {
    selector: (state, spaceId)=>state.detailLoading.get(spaceId) ?? false
});
const $05a1a54631ae3038$export$70f1b26c4cbf89d = (0, $kBr4q.createStateHook)((0, $9k1Oq.spaceStore), {
    selector: (state, spaceId)=>state.detailErrors.get(spaceId) ?? null
});
const $05a1a54631ae3038$export$2cd2cb4a55b2965d = (0, $kBr4q.createStateHook)((0, $9k1Oq.spaceStore), {
    selector: (state, spaceId)=>state.spaceConversations.get(spaceId) ?? null
});
const $05a1a54631ae3038$export$ed4ca1f1560fcd15 = (0, $kBr4q.createStateHook)((0, $9k1Oq.spaceStore), {
    selector: (state, spaceId)=>state.conversationsLoading.get(spaceId) ?? false
});
const $05a1a54631ae3038$export$24e28f766ba9071e = (0, $kBr4q.createStateHook)((0, $9k1Oq.spaceStore), {
    selector: (state, spaceId)=>state.conversationsErrors.get(spaceId) ?? null
});
const $05a1a54631ae3038$export$c2f6acacddd0717f = (0, $kBr4q.createStateHook)((0, $9k1Oq.spaceStore), {
    selector: (state, spaceId)=>state.spaceMemories.get(spaceId) ?? []
});
const $05a1a54631ae3038$export$fa3b9f71961b2b87 = (0, $kBr4q.createStateHook)((0, $9k1Oq.spaceStore), {
    selector: (state, spaceId)=>state.memoriesLoading.get(spaceId) ?? false
});
const $05a1a54631ae3038$export$70ff4bf3a8bd3e16 = (0, $kBr4q.createStateHook)((0, $9k1Oq.spaceStore), {
    selector: (state, spaceId)=>state.memoriesErrors.get(spaceId) ?? null
});
const $05a1a54631ae3038$export$9a7c6df39e4e5fd4 = (0, $kBr4q.createStateHook)((0, $9k1Oq.spaceStore), {
    selector: (state, spaceId)=>state.smartContextLinkRecommendations.get(spaceId) ?? []
});
module.exports["useSpaceStoreActions"] = $05a1a54631ae3038$export$995700e1beba27e2;
module.exports["useSpaces"] = $05a1a54631ae3038$export$4a0158bb8391bcb;
module.exports["useSpacesLoading"] = $05a1a54631ae3038$export$40840f9e6173b9a6;
module.exports["useSpacesError"] = $05a1a54631ae3038$export$98766e9d1f093889;
module.exports["useHasFetchedSpaces"] = $05a1a54631ae3038$export$3939f7e557578ce8;
module.exports["useSpaceConversationIds"] = $05a1a54631ae3038$export$be7cd4af1e0d2a9f;
module.exports["useSpaceById"] = $05a1a54631ae3038$export$d021bec3570c33bf;
module.exports["useSpaceDetailLoading"] = $05a1a54631ae3038$export$a3814fef5b67c2b2;
module.exports["useSpaceDetailError"] = $05a1a54631ae3038$export$70f1b26c4cbf89d;
module.exports["useSpaceConversationsPage"] = $05a1a54631ae3038$export$2cd2cb4a55b2965d;
module.exports["useSpaceConversationsLoading"] = $05a1a54631ae3038$export$ed4ca1f1560fcd15;
module.exports["useSpaceConversationsError"] = $05a1a54631ae3038$export$24e28f766ba9071e;
module.exports["useSpaceMemories"] = $05a1a54631ae3038$export$c2f6acacddd0717f;
module.exports["useSpaceMemoriesLoading"] = $05a1a54631ae3038$export$fa3b9f71961b2b87;
module.exports["useSpaceMemoriesError"] = $05a1a54631ae3038$export$70ff4bf3a8bd3e16;
module.exports["useSmartContextLinkRecommendations"] = $05a1a54631ae3038$export$9a7c6df39e4e5fd4;

});

parcelRegister("9k1Oq", function(module, exports) {
/**
 * react-sweet-state singleton store for Rovo Spaces. Mutating actions keep the
 * list and detail slices in sync so all consumers see a consistent view.
 */ 
var $8s9DV = parcelRequire("8s9DV");


var $73iDe = parcelRequire("73iDe");


var $1RoaH = parcelRequire("1RoaH");


var $6OvwE = parcelRequire("6OvwE");


var $2Z9WR = parcelRequire("2Z9WR");


var $10p5Q = parcelRequire("10p5Q");


var $9RoLt = parcelRequire("9RoLt");


var $2IYpC = parcelRequire("2IYpC");

// --- Initial state ---
/** Derives a stable flat deduplicated conversationIds array from a spaces list. */ const $c7f6d0062ae88238$var$computeConversationIds = (spaces)=>{
    const ids = new Set();
    for (const space of spaces){
        if (!space.sources) continue;
        for (const source of space.sources){
            if (!source.conversationIds) continue;
            for (const id of source.conversationIds)ids.add(id);
        }
    }
    return Array.from(ids);
};
/** Fresh initial state on every call so `reset()` doesn't share Set/Map refs. */ const $c7f6d0062ae88238$var$makeInitialState = ()=>({
        spaces: [],
        conversationIds: [],
        isListLoading: false,
        listError: null,
        hasFetchedList: false,
        deletedIds: new Set(),
        pendingAdds: new Map(),
        lastFetchedListParams: null,
        spaceDetails: new Map(),
        detailLoading: new Map(),
        detailErrors: new Map(),
        spaceConversations: new Map(),
        conversationsLoading: new Map(),
        conversationsErrors: new Map(),
        spaceMemories: new Map(),
        memoriesLoading: new Map(),
        memoriesErrors: new Map(),
        smartContextLinkRecommendations: new Map()
    });
/** Project a {@link SpaceResponse} down to the lighter {@link Space} list shape. */ const $c7f6d0062ae88238$var$detailToListShape = (response)=>({
        name: response.name,
        emoji: response.emoji ?? null,
        description: response.description ?? null,
        owner: response.owner,
        createdAt: response.createdAt,
        updatedAt: response.updatedAt
    });
/** Build a `Space` from a `CreateSpaceResponse`, defaulting fields not yet present. */ const $c7f6d0062ae88238$var$createResponseToSpace = (response, emojiId)=>({
        id: response.id,
        name: response.name,
        owner: response.owner,
        description: response.description ?? null,
        emoji: emojiId ?? null,
        threadId: null,
        createdAt: response.createdAt,
        updatedAt: response.updatedAt,
        conversationPage: null
    });
/** Immutable Map setter — returns a new Map so sweet-state equality checks fire. */ const $c7f6d0062ae88238$var$mapSet = (map, key, value)=>{
    const next = new Map(map);
    next.set(key, value);
    return next;
};
const $c7f6d0062ae88238$var$mapDelete = (map, key)=>{
    if (!map.has(key)) return map;
    const next = new Map(map);
    next.delete(key);
    return next;
};
const $c7f6d0062ae88238$var$replaceOrAppend = (arr, item, getKey)=>{
    const key = getKey(item);
    const idx = arr.findIndex((it)=>getKey(it) === key);
    if (idx < 0) return [
        ...arr,
        item
    ];
    const next = arr.slice();
    next[idx] = item;
    return next;
};
// --- Actions ---
const $c7f6d0062ae88238$var$actions = {
    /** Test-only — restores the store to its initial empty state. */ reset: ()=>({ setState: setState })=>{
            setState($c7f6d0062ae88238$var$makeInitialState());
        },
    /**
   * Merge spaces into the store (applies tombstones, re-injects pending adds).
   * `{ isLoading: true }` = loading snapshot; `{ error }` = record fetch failure.
   */ setSpaces: (nextSpaces, { isLoading: nextIsLoading = false, error: nextError = null } = {})=>({ getState: getState, setState: setState })=>{
            const { deletedIds: deletedIds, pendingAdds: pendingAdds, hasFetchedList: hasFetchedList } = getState();
            // 1. Drop any rows that have been optimistically deleted client-side.
            const withoutDeleted = deletedIds.size === 0 ? nextSpaces : nextSpaces.filter((s)=>!deletedIds.has(s.id));
            // 2. Reconcile pending adds. On a real server response, drop pending
            //    entries that the server now knows about; on a loading snapshot,
            //    leave them untouched.
            let merged = withoutDeleted;
            let nextPendingAdds = pendingAdds;
            if (pendingAdds.size > 0) {
                const serverIds = new Set(withoutDeleted.map((s)=>s.id));
                const stillPending = [];
                const isServerResponse = !nextIsLoading && nextError === null;
                if (isServerResponse) nextPendingAdds = new Map(pendingAdds);
                pendingAdds.forEach((space, id)=>{
                    if (serverIds.has(id)) {
                        if (isServerResponse) nextPendingAdds.delete(id);
                    } else stillPending.push(space);
                });
                if (stillPending.length > 0) merged = [
                    ...withoutDeleted,
                    ...stillPending
                ];
            }
            setState({
                spaces: merged,
                conversationIds: $c7f6d0062ae88238$var$computeConversationIds(merged),
                isListLoading: nextIsLoading,
                listError: nextError,
                hasFetchedList: !nextIsLoading && nextError === null ? true : hasFetchedList,
                pendingAdds: nextPendingAdds
            });
        },
    addSpace: (response, emojiId)=>({ getState: getState, setState: setState })=>{
            const space = $c7f6d0062ae88238$var$createResponseToSpace(response, emojiId);
            const { spaces: spaces, deletedIds: deletedIds, pendingAdds: pendingAdds } = getState();
            // If a space with this id was previously tombstoned, clear it so the
            // new space (potentially reusing an id) is allowed to surface again.
            const nextDeletedIds = deletedIds.has(response.id) ? new Set(Array.from(deletedIds).filter((id)=>id !== response.id)) : deletedIds;
            // Idempotent guard: if a space with this id is already in the list
            // (e.g. because another `addSpace` call has already run for the same
            // `CreateSpaceModal.onCreated` event, or a server list-fetch landed
            // before us), DO NOT append a duplicate row. We still want to
            // (a) clear any tombstone (handled above) and
            // (b) keep the entry in `pendingAdds` so a subsequent `setSpaces`
            //     loading-snapshot can't drop it before the server confirms it.
            if (spaces.some((s)=>s.id === response.id)) {
                if (deletedIds.has(response.id) || !pendingAdds.has(response.id)) setState({
                    deletedIds: nextDeletedIds,
                    pendingAdds: $c7f6d0062ae88238$var$mapSet(pendingAdds, response.id, space)
                });
                return;
            }
            const nextPendingAdds = $c7f6d0062ae88238$var$mapSet(pendingAdds, response.id, space);
            const nextSpacesAdd = [
                ...spaces,
                space
            ];
            setState({
                spaces: nextSpacesAdd,
                conversationIds: $c7f6d0062ae88238$var$computeConversationIds(nextSpacesAdd),
                deletedIds: nextDeletedIds,
                pendingAdds: nextPendingAdds
            });
        },
    removeSpace: (spaceId)=>({ getState: getState, setState: setState })=>{
            const { spaces: spaces, deletedIds: deletedIds, pendingAdds: pendingAdds } = getState();
            const nextDeletedIds = new Set(deletedIds);
            nextDeletedIds.add(spaceId);
            const nextPendingAdds = $c7f6d0062ae88238$var$mapDelete(pendingAdds, spaceId);
            const nextSpacesRemove = spaces.filter((s)=>s.id !== spaceId);
            setState({
                spaces: nextSpacesRemove,
                conversationIds: $c7f6d0062ae88238$var$computeConversationIds(nextSpacesRemove),
                deletedIds: nextDeletedIds,
                pendingAdds: nextPendingAdds
            });
        },
    restoreSpace: (space)=>({ getState: getState, setState: setState })=>{
            const { spaces: spaces, deletedIds: deletedIds } = getState();
            const nextDeletedIds = new Set(deletedIds);
            nextDeletedIds.delete(space.id);
            const nextSpacesRestore = spaces.some((s)=>s.id === space.id) ? spaces : [
                ...spaces,
                space
            ];
            setState({
                spaces: nextSpacesRestore,
                conversationIds: $c7f6d0062ae88238$var$computeConversationIds(nextSpacesRestore),
                deletedIds: nextDeletedIds
            });
        },
    patchSpace: (spaceId, patch)=>({ getState: getState, setState: setState })=>{
            const { spaces: spaces, spaceDetails: spaceDetails } = getState();
            // Mirror the patch into the detail slice if a detail entry exists, so
            // any open ManageSpaceModal stays consistent with the side-nav list.
            let nextDetails = spaceDetails;
            const existing = spaceDetails.get(spaceId);
            if (existing) {
                // Only mirror fields that exist on the detail shape. The list-only
                // `sources` field intentionally has a different element type
                // (`SpaceSource` vs `SpaceSourceResponse`) and is owned by the
                // dedicated `upsertSpaceSource` / `removeSpaceSource` actions.
                const { sources: _ignoredSources, conversationPage: _ignoredCP, threadId: _ignoredTid, ...detailPatch } = patch;
                nextDetails = $c7f6d0062ae88238$var$mapSet(spaceDetails, spaceId, {
                    ...existing,
                    ...detailPatch
                });
            }
            const nextSpacesPatch = spaces.map((s)=>s.id === spaceId ? {
                    ...s,
                    ...patch
                } : s);
            setState({
                spaces: nextSpacesPatch,
                conversationIds: $c7f6d0062ae88238$var$computeConversationIds(nextSpacesPatch),
                spaceDetails: nextDetails
            });
        },
    /**
   * Fetches the list of spaces from the BE and merges into the store. Marks
   * `isListLoading=true` *without* clearing the existing list so any
   * optimistic state is preserved while the request is in flight.
   *
   * Idempotent: if the store has already fetched for the same params, this
   * is a no-op unless `force=true`.
   */ fetchSpaces: (params)=>async ({ getState: getState, setState: setState, dispatch: dispatch })=>{
            const { cloudId: cloudId, product: product, experienceId: experienceId, force: force = false } = params;
            const key = `${cloudId}|${product}|${experienceId}`;
            const { hasFetchedList: hasFetchedList, lastFetchedListParams: lastFetchedListParams, spaces: spaces } = getState();
            if (!force && hasFetchedList && lastFetchedListParams === key) return;
            dispatch($c7f6d0062ae88238$var$actions.setSpaces(spaces, {
                isLoading: true
            }));
            try {
                const response = await (0, $9RoLt.listSpacesFetchAction)({
                    cloudId: cloudId,
                    product: product,
                    experienceId: experienceId
                });
                dispatch($c7f6d0062ae88238$var$actions.setSpaces(response.data));
                setState({
                    lastFetchedListParams: key
                });
            } catch (err) {
                const error = err instanceof Error ? err : new Error(String(err));
                dispatch($c7f6d0062ae88238$var$actions.setSpaces(getState().spaces, {
                    error: error
                }));
            }
        },
    setSpaceDetail: (spaceId, response)=>({ getState: getState, setState: setState })=>{
            const { spaces: spaces, spaceDetails: spaceDetails, detailLoading: detailLoading, detailErrors: detailErrors } = getState();
            setState({
                spaceDetails: $c7f6d0062ae88238$var$mapSet(spaceDetails, spaceId, response),
                detailLoading: $c7f6d0062ae88238$var$mapSet(detailLoading, spaceId, false),
                detailErrors: $c7f6d0062ae88238$var$mapSet(detailErrors, spaceId, null),
                spaces: spaces.some((s)=>s.id === spaceId) ? spaces.map((s)=>s.id === spaceId ? {
                        ...s,
                        ...$c7f6d0062ae88238$var$detailToListShape(response)
                    } : s) : spaces
            });
        },
    /**
   * Hydrate the list and detail slices from the full space metadata embedded in
   * GET /chat/conversation/{id}. This is server-confirmed data, so unlike
   * `addSpace` it must not be tracked as an optimistic pending creation.
   */ upsertConversationSpace: (response)=>({ getState: getState, setState: setState })=>{
            const { spaces: spaces, spaceDetails: spaceDetails, detailLoading: detailLoading, detailErrors: detailErrors, deletedIds: deletedIds } = getState();
            if (deletedIds.has(response.id)) return;
            const createdAt = new Date(response.createdAt).toISOString();
            const updatedAt = new Date(response.updatedAt).toISOString();
            const sources = response.sources.map((source)=>({
                    ...source,
                    name: source.name ?? undefined
                }));
            const detail = {
                id: response.id,
                name: response.name,
                owner: response.owner,
                description: response.description ?? null,
                emoji: response.emoji ?? null,
                threadId: response.threadId ?? null,
                createdAt: createdAt,
                updatedAt: updatedAt,
                sources: sources
            };
            const listSpace = {
                ...detail,
                conversationPage: null
            };
            const nextSpaces = spaces.some((space)=>space.id === response.id) ? spaces.map((space)=>space.id === response.id ? {
                    ...space,
                    ...listSpace
                } : space) : [
                ...spaces,
                listSpace
            ];
            setState({
                spaces: nextSpaces,
                conversationIds: $c7f6d0062ae88238$var$computeConversationIds(nextSpaces),
                spaceDetails: $c7f6d0062ae88238$var$mapSet(spaceDetails, response.id, detail),
                detailLoading: $c7f6d0062ae88238$var$mapSet(detailLoading, response.id, false),
                detailErrors: $c7f6d0062ae88238$var$mapSet(detailErrors, response.id, null)
            });
        },
    setSpaceDetailLoading: (spaceId, isLoading)=>({ getState: getState, setState: setState })=>{
            setState({
                detailLoading: $c7f6d0062ae88238$var$mapSet(getState().detailLoading, spaceId, isLoading)
            });
        },
    setSpaceDetailError: (spaceId, error)=>({ getState: getState, setState: setState })=>{
            setState({
                detailErrors: $c7f6d0062ae88238$var$mapSet(getState().detailErrors, spaceId, error),
                detailLoading: $c7f6d0062ae88238$var$mapSet(getState().detailLoading, spaceId, false)
            });
        },
    /**
   * Fetches a single space by id and populates the detail slice. Always
   * fetches when called (consumers wanting cache-only reads should use
   * `useSpaceById`).
   */ fetchSpace: (params)=>async ({ dispatch: dispatch })=>{
            const { spaceId: spaceId } = params;
            dispatch($c7f6d0062ae88238$var$actions.setSpaceDetailLoading(spaceId, true));
            dispatch($c7f6d0062ae88238$var$actions.setSpaceDetailError(spaceId, null));
            try {
                const response = await (0, $6OvwE.getSpaceFetchAction)(params);
                dispatch($c7f6d0062ae88238$var$actions.setSpaceDetail(spaceId, response));
            } catch (err) {
                const error = err instanceof Error ? err : new Error(String(err));
                dispatch($c7f6d0062ae88238$var$actions.setSpaceDetailError(spaceId, error));
            }
        },
    /**
   * Performs a PUT against the spaces API and, on success, patches both the
   * list and detail slices so all consumers see the change immediately.
   */ updateSpace: (params)=>async ({ dispatch: dispatch })=>{
            const response = await (0, $2IYpC.updateSpaceFetchAction)(params);
            dispatch($c7f6d0062ae88238$var$actions.patchSpace(params.spaceId, {
                name: response.name,
                emoji: response.emoji ?? null,
                description: response.description ?? null,
                updatedAt: response.updatedAt
            }));
            return response;
        },
    /**
   * Patches a source into the detail slice's `sources` array (and the list
   * slice's `sources` array if present). Used by `addSpaceSource` after a
   * successful POST to keep the open ManageSpaceModal in sync.
   */ upsertSpaceSource: (spaceId, source)=>({ getState: getState, setState: setState })=>{
            const { spaces: spaces, spaceDetails: spaceDetails } = getState();
            const detail = spaceDetails.get(spaceId);
            const nextDetails = detail !== undefined ? $c7f6d0062ae88238$var$mapSet(spaceDetails, spaceId, {
                ...detail,
                sources: $c7f6d0062ae88238$var$replaceOrAppend(detail.sources ?? [], source, (s)=>s.id)
            }) : spaceDetails;
            const nextSpaces = spaces.map((s)=>s.id === spaceId ? {
                    ...s,
                    sources: $c7f6d0062ae88238$var$replaceOrAppend(s.sources ?? [], {
                        id: source.id,
                        ari: source.ari,
                        url: source.url,
                        sourceType: source.sourceType,
                        name: source.name ?? null
                    }, (it)=>it.id)
                } : s);
            setState({
                spaces: nextSpaces,
                conversationIds: $c7f6d0062ae88238$var$computeConversationIds(nextSpaces),
                spaceDetails: nextDetails
            });
        },
    removeSpaceSource: (spaceId, sourceId)=>({ getState: getState, setState: setState })=>{
            const { spaces: spaces, spaceDetails: spaceDetails } = getState();
            const detail = spaceDetails.get(spaceId);
            const nextDetails = detail !== undefined ? $c7f6d0062ae88238$var$mapSet(spaceDetails, spaceId, {
                ...detail,
                sources: (detail.sources ?? []).filter((s)=>s.id !== sourceId)
            }) : spaceDetails;
            const nextSpaces = spaces.map((s)=>s.id === spaceId ? {
                    ...s,
                    sources: (s.sources ?? []).filter((it)=>it.id !== sourceId)
                } : s);
            setState({
                spaces: nextSpaces,
                conversationIds: $c7f6d0062ae88238$var$computeConversationIds(nextSpaces),
                spaceDetails: nextDetails
            });
        },
    setSpaceConversations: (spaceId, page, isLoading, error)=>({ getState: getState, setState: setState })=>{
            const { spaceConversations: spaceConversations, conversationsLoading: conversationsLoading, conversationsErrors: conversationsErrors } = getState();
            setState({
                spaceConversations: page !== null ? $c7f6d0062ae88238$var$mapSet(spaceConversations, spaceId, page) : spaceConversations,
                conversationsLoading: $c7f6d0062ae88238$var$mapSet(conversationsLoading, spaceId, isLoading),
                conversationsErrors: $c7f6d0062ae88238$var$mapSet(conversationsErrors, spaceId, error)
            });
        },
    removeConversationFromSpaceConversations: (conversationIds)=>({ getState: getState, setState: setState })=>{
            if (conversationIds.length === 0) return;
            const idsToRemove = new Set(conversationIds);
            const { spaceConversations: spaceConversations } = getState();
            let nextSpaceConversations = spaceConversations;
            spaceConversations.forEach((page, spaceId)=>{
                const nextConversations = page.conversations.filter((conversation)=>!idsToRemove.has(conversation.id) && !(conversation.backendConversationId && idsToRemove.has(conversation.backendConversationId)));
                if (nextConversations.length !== page.conversations.length) nextSpaceConversations = $c7f6d0062ae88238$var$mapSet(nextSpaceConversations, spaceId, {
                    ...page,
                    conversations: nextConversations,
                    totalCount: Math.max(0, page.totalCount - (page.conversations.length - nextConversations.length))
                });
            });
            if (nextSpaceConversations !== spaceConversations) setState({
                spaceConversations: nextSpaceConversations
            });
        },
    fetchSpaceConversations: (params)=>async ({ dispatch: dispatch })=>{
            const { spaceId: spaceId } = params;
            dispatch($c7f6d0062ae88238$var$actions.setSpaceConversations(spaceId, null, true, null));
            try {
                const response = await (0, $2Z9WR.getSpaceConversationsFetchAction)(params);
                dispatch($c7f6d0062ae88238$var$actions.setSpaceConversations(spaceId, response, false, null));
            } catch (err) {
                const error = err instanceof Error ? err : new Error(String(err));
                dispatch($c7f6d0062ae88238$var$actions.setSpaceConversations(spaceId, null, false, error));
            }
        },
    /** Internal setter — drives loading/error state and populates the memory list. */ setSpaceMemories: (spaceId, items, isLoading, error)=>({ getState: getState, setState: setState })=>{
            const { spaceMemories: spaceMemories, memoriesLoading: memoriesLoading, memoriesErrors: memoriesErrors } = getState();
            setState({
                spaceMemories: items !== null ? $c7f6d0062ae88238$var$mapSet(spaceMemories, spaceId, items) : spaceMemories,
                memoriesLoading: $c7f6d0062ae88238$var$mapSet(memoriesLoading, spaceId, isLoading),
                memoriesErrors: $c7f6d0062ae88238$var$mapSet(memoriesErrors, spaceId, error)
            });
        },
    /**
   * Lazily fetches the memory list for a space from GET /spaces/{spaceId}/memory.
   * Only fires a network request the first time it's called for a given spaceId
   * (or if a previous fetch errored).
   */ fetchSpaceMemories: (params)=>async ({ getState: getState, dispatch: dispatch })=>{
            const { spaceId: spaceId } = params;
            const { memoriesLoading: memoriesLoading, spaceMemories: spaceMemories } = getState();
            if (memoriesLoading.get(spaceId) || spaceMemories.has(spaceId)) return;
            dispatch($c7f6d0062ae88238$var$actions.setSpaceMemories(spaceId, null, true, null));
            try {
                const response = await (0, $10p5Q.getSpaceMemoryFetchAction)(params);
                const items = response.items.map((item)=>({
                        id: item.id,
                        text: item.content
                    }));
                dispatch($c7f6d0062ae88238$var$actions.setSpaceMemories(spaceId, items, false, null));
            } catch (err) {
                const error = err instanceof Error ? err : new Error(String(err));
                dispatch($c7f6d0062ae88238$var$actions.setSpaceMemories(spaceId, null, false, error));
            }
        },
    /**
   * POSTs a new memory item and optimistically inserts it at the end of the
   * list so the UI updates immediately without a refetch.
   */ createSpaceMemory: (params)=>async ({ getState: getState, setState: setState })=>{
            const response = await (0, $73iDe.createSpaceMemoryFetchAction)(params);
            const { spaceMemories: spaceMemories } = getState();
            const { spaceId: spaceId } = params;
            const existing = spaceMemories.get(spaceId) ?? [];
            setState({
                spaceMemories: $c7f6d0062ae88238$var$mapSet(spaceMemories, spaceId, [
                    ...existing,
                    {
                        id: response.id,
                        text: response.content
                    }
                ])
            });
        },
    /**
   * Optimistically removes a memory item from the store, then fires the
   * DELETE request. Rolls back on failure.
   */ removeSpaceMemory: (spaceId, memoryId, cloudId, product, experienceId)=>async ({ getState: getState, setState: setState })=>{
            const { spaceMemories: spaceMemories } = getState();
            const existing = spaceMemories.get(spaceId) ?? [];
            const optimistic = existing.filter((m)=>m.id !== memoryId);
            setState({
                spaceMemories: $c7f6d0062ae88238$var$mapSet(spaceMemories, spaceId, optimistic)
            });
            try {
                await (0, $1RoaH.deleteSpaceMemoryFetchAction)({
                    spaceId: spaceId,
                    memoryId: memoryId,
                    cloudId: cloudId,
                    product: product,
                    experienceId: experienceId
                });
            } catch (err) {
                setState({
                    spaceMemories: $c7f6d0062ae88238$var$mapSet(getState().spaceMemories, spaceId, existing)
                });
                throw err;
            }
        },
    setSmartContextLinkRecommendations: (spaceId, recommendations)=>({ getState: getState, setState: setState })=>{
            setState({
                smartContextLinkRecommendations: $c7f6d0062ae88238$var$mapSet(getState().smartContextLinkRecommendations, spaceId, recommendations)
            });
        },
    clearSmartContextLinkRecommendations: (spaceId)=>({ getState: getState, setState: setState })=>{
            setState({
                smartContextLinkRecommendations: $c7f6d0062ae88238$var$mapDelete(getState().smartContextLinkRecommendations, spaceId)
            });
        },
    removeSmartContextLinkRecommendation: (spaceId, recommendationId)=>({ getState: getState, setState: setState })=>{
            const { smartContextLinkRecommendations: smartContextLinkRecommendations } = getState();
            const existing = smartContextLinkRecommendations.get(spaceId);
            if (!existing) return;
            setState({
                smartContextLinkRecommendations: $c7f6d0062ae88238$var$mapSet(smartContextLinkRecommendations, spaceId, existing.filter((recommendation)=>recommendation.recommendationId !== recommendationId))
            });
        }
};
const $c7f6d0062ae88238$export$34ecf36458142176 = (0, $8s9DV.createStore)({
    name: 'spaceStore',
    initialState: $c7f6d0062ae88238$var$makeInitialState(),
    actions: $c7f6d0062ae88238$var$actions
});
module.exports["spaceStore"] = $c7f6d0062ae88238$export$34ecf36458142176;

});

parcelRegister("73iDe", function(module, exports) {

var $jTKfH = parcelRequire("jTKfH");


var $98i9C = parcelRequire("98i9C");

const $f1fa406f69b22b7e$export$1b63f5338cb50250 = ({ spaceId: spaceId, content: content, cloudId: cloudId, product: product, experienceId: experienceId })=>{
    return (0, $jTKfH.performHttpFetch)({
        path: `${(0, $98i9C.SPACES_API_PATH)}/${spaceId}/memory`,
        options: {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'x-cloudid': cloudId,
                'x-product': product,
                'x-experience-id': experienceId
            },
            credentials: 'include',
            body: JSON.stringify({
                content: content
            })
        }
    });
};
module.exports["createSpaceMemoryFetchAction"] = $f1fa406f69b22b7e$export$1b63f5338cb50250;

});

parcelRegister("98i9C", function(module, exports) {
/** Base path for the ConvoAI Spaces REST API. */ const $8ef18f344ac2d2f3$export$472fb0d2ff1c7d85 = '/gateway/api/assist/rovo/v1/spaces';
const $8ef18f344ac2d2f3$export$1dd3d5c121ebda25 = 100;
const $8ef18f344ac2d2f3$export$33d45ef69b8a7178 = 500;
module.exports["SPACES_API_PATH"] = $8ef18f344ac2d2f3$export$472fb0d2ff1c7d85;
module.exports["SPACE_NAME_MAX_LENGTH"] = $8ef18f344ac2d2f3$export$1dd3d5c121ebda25;
module.exports["SPACE_ABOUT_MAX_LENGTH"] = $8ef18f344ac2d2f3$export$33d45ef69b8a7178;

});

parcelRegister("1RoaH", function(module, exports) {
/**
 * The DELETE endpoint returns 204 No Content; `performHttpFetch` would
 * attempt `response.json()` and throw on an empty body, so we use the
 * manual `fetch` here instead.
 */ 
var $jTKfH = parcelRequire("jTKfH");


var $98i9C = parcelRequire("98i9C");

const $11c6d2f4dd10a9f1$export$53573fd484f1b3c3 = async ({ spaceId: spaceId, memoryId: memoryId, cloudId: cloudId, product: product, experienceId: experienceId })=>{
    const path = `${(0, $98i9C.SPACES_API_PATH)}/${spaceId}/memory/${memoryId}`;
    let response;
    try {
        response = await fetch(path, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'x-cloudid': cloudId,
                'x-product': product,
                'x-experience-id': experienceId
            },
            credentials: 'include'
        });
    } catch (err) {
        const originalErrorMessage = err instanceof Error ? err.message : 'Unknown error';
        throw new (0, $jTKfH.FetchError)(`deleteSpaceMemoryFetch error while fetching ${path}. Original error: ${originalErrorMessage}`, {
            errorCode: 'deleteSpaceMemoryFetchError'
        });
    }
    if (!response.ok || response.status >= 400) {
        const body = await response.text().catch(()=>'');
        throw new (0, $jTKfH.FetchError)(`deleteSpaceMemoryFetch error while fetching ${path}. Original error: [Code ${response.status}] ${body}`, {
            errorCode: 'deleteSpaceMemoryFetchError',
            statusCode: response.status
        });
    }
// 204 No Content — no body to parse.
};
module.exports["deleteSpaceMemoryFetchAction"] = $11c6d2f4dd10a9f1$export$53573fd484f1b3c3;

});

parcelRegister("6OvwE", function(module, exports) {
/**
 * Pure fetch helper extracted from `useGetSpace` so the spaces sweet-state
 * store can call it from inside an action without depending on React or on
 * the hook itself.
 */ 
var $jTKfH = parcelRequire("jTKfH");

const $51d5e1a1500b2e17$var$SPACES_API_PATH = '/gateway/api/assist/rovo/v1/spaces';
const $51d5e1a1500b2e17$export$fbca0b4b208eec07 = async ({ spaceId: spaceId, cloudId: cloudId, product: product, experienceId: experienceId })=>(0, $jTKfH.performHttpFetch)({
        path: `${$51d5e1a1500b2e17$var$SPACES_API_PATH}/${spaceId}`,
        options: {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'x-cloudid': cloudId,
                'x-product': product,
                'x-experience-id': experienceId
            },
            credentials: 'include'
        }
    });
module.exports["getSpaceFetchAction"] = $51d5e1a1500b2e17$export$fbca0b4b208eec07;

});

parcelRegister("2Z9WR", function(module, exports) {
/**
 * Pure fetch helper extracted from `useGetSpaceConversations` so the spaces
 * sweet-state store can call it from inside an action without depending on
 * React or on the hook itself.
 */ 
var $igOtY = parcelRequire("igOtY");


var $jTKfH = parcelRequire("jTKfH");

const $3cc16f24d97017b7$var$SPACES_API_PATH = '/gateway/api/assist/rovo/v1/spaces';
const $3cc16f24d97017b7$var$mapSpaceConversationFromApi = (channel, spaceId)=>{
    const lastMessage = channel.last_message ?? undefined;
    return {
        id: channel.id,
        name: channel.name ?? '',
        messages: [],
        status: (0, $igOtY.CHAT_STORE_STATUS).idle,
        traces: [],
        timeCreated: channel.time_created,
        lastMessage: lastMessage,
        lastMessageType: channel.last_message_type ?? [],
        lastMessageTimestamp: channel.last_message_timestamp,
        lastAgentMessageStatus: channel.last_agent_message_status,
        readStatus: channel.readStatus ?? channel.read_status ?? null,
        agent: channel.agent,
        scopes: channel.scopes,
        tags: channel.tags,
        rovoSpaceId: spaceId,
        isEmpty: !lastMessage?.trim(),
        isPinned: channel.isPinned ?? channel.is_pinned ?? undefined,
        pinnedAt: channel.pinnedAt ?? channel.pinned_at ?? null
    };
};
const $3cc16f24d97017b7$export$539f16f68a4805bb = async ({ spaceId: spaceId, cloudId: cloudId, product: product, experienceId: experienceId, offset: offset, count: count })=>{
    const params = new URLSearchParams();
    if (offset !== undefined) params.set('offset', String(offset));
    if (count !== undefined) params.set('count', String(count));
    const query = params.toString();
    const raw = await (0, $jTKfH.performHttpFetch)({
        path: `${$3cc16f24d97017b7$var$SPACES_API_PATH}/${spaceId}/conversations${query ? `?${query}` : ''}`,
        options: {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'x-cloudid': cloudId,
                'x-product': product,
                'x-experience-id': experienceId
            },
            credentials: 'include'
        }
    });
    return {
        ...raw,
        conversations: raw.conversations.map((row)=>$3cc16f24d97017b7$var$mapSpaceConversationFromApi(row, spaceId))
    };
};
module.exports["getSpaceConversationsFetchAction"] = $3cc16f24d97017b7$export$539f16f68a4805bb;

});

parcelRegister("10p5Q", function(module, exports) {
/**
 * Pure fetch helper for GET /spaces/{spaceId}/memory.
 * Extracted from `useGetSpaceMemory` so callers (e.g. the sweet-state store)
 * can invoke it without depending on React or the hook lifecycle.
 */ 
var $jTKfH = parcelRequire("jTKfH");


var $98i9C = parcelRequire("98i9C");

const $4aa5bad3aecdc97a$export$8149ce67f430cbb = ({ spaceId: spaceId, cloudId: cloudId, product: product, experienceId: experienceId })=>(0, $jTKfH.performHttpFetch)({
        path: `${(0, $98i9C.SPACES_API_PATH)}/${spaceId}/memory`,
        options: {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'x-cloudid': cloudId,
                'x-product': product,
                'x-experience-id': experienceId
            },
            credentials: 'include'
        }
    });
module.exports["getSpaceMemoryFetchAction"] = $4aa5bad3aecdc97a$export$8149ce67f430cbb;

});

parcelRegister("9RoLt", function(module, exports) {

var $jTKfH = parcelRequire("jTKfH");


var $98i9C = parcelRequire("98i9C");

const $296439ad4ec4b4aa$export$6c7ca5b71363fc06 = async ({ cloudId: cloudId, product: product, experienceId: experienceId })=>(0, $jTKfH.performHttpFetch)({
        path: (0, $98i9C.SPACES_API_PATH),
        options: {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'x-cloudid': cloudId,
                'x-product': product,
                'x-experience-id': experienceId
            },
            credentials: 'include'
        }
    });
module.exports["listSpacesFetchAction"] = $296439ad4ec4b4aa$export$6c7ca5b71363fc06;

});

parcelRegister("2IYpC", function(module, exports) {
/**
 * Pure fetch helper extracted from `useUpdateSpace` so the spaces sweet-state
 * store can call it from inside an action without depending on React or on
 * the hook itself.
 */ 
var $jTKfH = parcelRequire("jTKfH");

const $078217057a30f7df$var$SPACES_API_PATH = '/gateway/api/assist/rovo/v1/spaces';
const $078217057a30f7df$export$9c961ef5c3a31b95 = async ({ spaceId: spaceId, request: request, cloudId: cloudId, product: product, experienceId: experienceId })=>(0, $jTKfH.performHttpFetch)({
        path: `${$078217057a30f7df$var$SPACES_API_PATH}/${spaceId}`,
        options: {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'x-cloudid': cloudId,
                'x-product': product,
                'x-experience-id': experienceId
            },
            credentials: 'include',
            body: JSON.stringify(request)
        }
    });
module.exports["updateSpaceFetchAction"] = $078217057a30f7df$export$9c961ef5c3a31b95;

});

parcelRegister("20Kr8", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $dab591e1852df37c$export$4c9ccf8a18d8ec6e = {
    override: null,
    setOverride: ()=>{}
};


const $ced7807ecaf30a36$export$a01f89f33dbfe1bd = (0, $cozmU.createContext)((0, $dab591e1852df37c$export$4c9ccf8a18d8ec6e));
module.exports["BackBehaviorOverrideContext"] = $ced7807ecaf30a36$export$a01f89f33dbfe1bd;

});

parcelRegister("hJC44", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $00c33fe8f91cd74f$var$StoreErrorFlagContext = (0, $cozmU.createContext)(undefined);
var $00c33fe8f91cd74f$export$2e2bcd8739ae039 = $00c33fe8f91cd74f$var$StoreErrorFlagContext;
module.exports["default"] = $00c33fe8f91cd74f$export$2e2bcd8739ae039;

});

parcelRegister("4MnFz", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $iXRmn = parcelRequire("iXRmn");

const $878d7a55fd1744f7$export$2879604e6aec4ab = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useFlags() {
    const api = (0, $cozmU.useContext)((0, $iXRmn.FlagContext));
    if (api == null) throw new Error("Unable to find FlagProviderContext");
    return api;
} : function useFlags() {
    const api = (0, $cozmU.useContext)((0, $iXRmn.FlagContext));
    if (api == null) throw new Error('Unable to find FlagProviderContext');
    return api;
};
module.exports["useFlags"] = $878d7a55fd1744f7$export$2879604e6aec4ab;

});

parcelRegister("8KiU9", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $4b7a70d334529286$var$message = (0, $kSwu1.defineMessages)({
    conversationForbiddenTitle: {
        id: "ai-mate.conversation-assistant.flag.conversation-forbidden.title",
        defaultMessage: "This conversation is not available"
    },
    conversationForbiddenDescription: {
        id: "ai-mate.conversation-assistant.flag.conversation-forbidden.description",
        defaultMessage: "The conversation you tried to open may belong to another user or you may not have permission to view it."
    },
    conversationHistoryLoadFailedTitle: {
        id: "ai-mate.conversation-assistant.flag.conversation-history-load-failed.title",
        defaultMessage: "We couldn't load your conversations"
    },
    conversationHistoryLoadFailedDescription: {
        id: "ai-mate.conversation-assistant.flag.conversation-history-load-failed.description",
        defaultMessage: "You can keep chatting with Rovo, but your conversation history may be out of date."
    },
    followUpAgentUnavailableTitle: {
        id: "conversation-assistant.followUpAgentUnavailableTitle",
        defaultMessage: "This follow-up can't be sent"
    },
    followUpAgentUnavailableDescription: {
        id: "conversation-assistant.followUpAgentUnavailableDescription",
        defaultMessage: "The responding agent is unavailable. Choose an agent and try again."
    },
    autoConversationPrompt: {
        id: "ai-mate.conversation-assistant.auto-conversation.prompt",
        defaultMessage: "Hey Rovo, list three things you can do with my work that will make me more effective this week."
    }
});
var $4b7a70d334529286$export$2e2bcd8739ae039 = $4b7a70d334529286$var$message;
module.exports["default"] = $4b7a70d334529286$export$2e2bcd8739ae039;

});

parcelRegister("5BOJB", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6cFsl = parcelRequire("6cFsl");


var $4m5jb = parcelRequire("4m5jb");


var $bGNkz = parcelRequire("bGNkz");


var $9aRNV = parcelRequire("9aRNV");


var $6iQ4q = parcelRequire("6iQ4q");


var $3TxKn = parcelRequire("3TxKn");


var $iLyZq = parcelRequire("iLyZq");

const $ebee8f54e12cc0bd$var$dismissActiveAction = (action, clearAction)=>{
    try {
        (0, $iLyZq.getActionOnDismiss)(action)?.();
    } finally{
        clearAction();
    }
};
const $ebee8f54e12cc0bd$export$e60c4e7dea337eb3 = ()=>{
    (0, $6cFsl.di)((0, $3TxKn.useChatStoreActions), (0, $9aRNV.useConversationActionsStoreActions), (0, $9aRNV.useConversationActionsStore), (0, $bGNkz.useUIStoreActions));
    const { setActiveAction_UNSAFE: setActiveAction_UNSAFE } = (0, $9aRNV.useConversationActionsStoreActions)();
    const { setSelectedConversation: setSelectedConversation } = (0, $3TxKn.useChatStoreActions)();
    const { setActiveMenu: setActiveMenu } = (0, $bGNkz.useUIStoreActions)();
    const [{ activeAction: activeAction }] = (0, $9aRNV.useConversationActionsStore)();
    const activeActionRef = (0, $cozmU.useRef)(activeAction);
    // Keep clearActiveAction safe for hook instances that did not set the action.
    (0, $cozmU.useEffect)(()=>{
        activeActionRef.current = activeAction;
    }, [
        activeAction
    ]);
    const setActiveAction = (0, $cozmU.useCallback)((action, options)=>{
        activeActionRef.current = action;
        setActiveAction_UNSAFE(action);
        if (action) {
            if (!options?.preserveSelectedConversation) setSelectedConversation({
                conversationId: (0, $4m5jb.EMPTY_CONVERSATION_ID),
                sourceAgentId: (0, $6iQ4q.DEFAULT_AGENT).id
            });
            setActiveMenu('none');
        }
    }, [
        setActiveAction_UNSAFE,
        setSelectedConversation,
        setActiveMenu
    ]);
    const clearActiveAction = (0, $cozmU.useCallback)(()=>{
        $ebee8f54e12cc0bd$var$dismissActiveAction(activeActionRef.current, ()=>{
            activeActionRef.current = undefined;
            setActiveAction_UNSAFE(undefined);
        });
    }, [
        setActiveAction_UNSAFE
    ]);
    return {
        activeAction: activeAction,
        setActiveAction: setActiveAction,
        clearActiveAction: clearActiveAction
    };
};
module.exports["useActiveAction"] = $ebee8f54e12cc0bd$export$e60c4e7dea337eb3;

});

parcelRegister("9aRNV", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $09ecffa85d56d9ae$var$store = (0, $8s9DV.createStore)({
    initialState: {
        actionFilter: undefined,
        actions: [],
        jiraIssueViewActions: undefined,
        input: '',
        activeAction: undefined,
        buttonClickedTimestamp: undefined
    },
    actions: {
        setConversationActions: (actions)=>({ setState: setState })=>{
                setState({
                    actions: actions
                });
            },
        /*
     * Jira Issue View does not use the provider pattern yet, so we need to skip the provider action fetching.
     * When Jira Issue View is migrated to set actions using provider pattern, we can remove this setter.
     */ setJiraIssueViewActions: (actions)=>({ setState: setState })=>{
                setState({
                    jiraIssueViewActions: actions
                });
            },
        setInput: (input)=>({ setState: setState })=>{
                setState({
                    input: input
                });
            },
        setActionFilter: (actionFilter)=>({ setState: setState })=>{
                setState({
                    actionFilter: actionFilter
                });
            },
        /*
     * Do not use this setter directly. Use setActiveAction from useActiveAction hook in conversation-assistant instead.
     */ setActiveAction_UNSAFE: (activeAction)=>({ setState: setState })=>{
                setState({
                    activeAction: activeAction
                });
            },
        setActiveActionFollowUpContext: (customFollowUpContext)=>({ getState: getState, setState: setState })=>{
                const activeAction = getState().activeAction;
                if (!activeAction || !('customFollowUpContext' in activeAction)) return;
                setState({
                    activeAction: {
                        ...activeAction,
                        customFollowUpContext: customFollowUpContext
                    }
                });
            },
        setButtonClickedTimestamp: (buttonClickedTimestamp)=>({ setState: setState })=>{
                setState({
                    buttonClickedTimestamp: buttonClickedTimestamp
                });
            },
        getConversationActions: ()=>({ getState: getState })=>{
                return getState().actions;
            },
        getActionFilter: ()=>({ getState: getState })=>{
                return getState().actionFilter;
            },
        getInput: ()=>({ getState: getState })=>{
                return getState().input;
            },
        getActiveAction: ()=>({ getState: getState })=>{
                return getState().activeAction;
            },
        getButtonClickedTimestamp: ()=>({ getState: getState })=>{
                return getState().buttonClickedTimestamp;
            },
        setConvoStarterActionPrompt: (convoStarterActionPrompt)=>({ setState: setState })=>{
                setState({
                    convoStarterActionPrompt: convoStarterActionPrompt
                });
            }
    }
});
const $09ecffa85d56d9ae$export$83a8985e8d377ba1 = (0, $kBr4q.createHook)($09ecffa85d56d9ae$var$store);
const $09ecffa85d56d9ae$export$74d7aed167e24a67 = (0, $kBr4q.createActionsHook)($09ecffa85d56d9ae$var$store);
const $09ecffa85d56d9ae$export$d6ed3fb83640b335 = (0, $kBr4q.createStateHook)($09ecffa85d56d9ae$var$store);
const $09ecffa85d56d9ae$export$4be353558b8b8a37 = (0, $kBr4q.createStateHook)($09ecffa85d56d9ae$var$store, {
    selector: (state)=>state.convoStarterActionPrompt
});
module.exports["useConversationActionsStore"] = $09ecffa85d56d9ae$export$83a8985e8d377ba1;
module.exports["useConversationActionsStoreActions"] = $09ecffa85d56d9ae$export$74d7aed167e24a67;
module.exports["useConversationActionsStoreState"] = $09ecffa85d56d9ae$export$d6ed3fb83640b335;

});

parcelRegister("iLyZq", function(module, exports) {

var $gR7ri = parcelRequire("gR7ri");

const $3bc7276fe39ce470$export$42c34726e4093ea = (action)=>(0, $gR7ri.getConversationActionWithAssistantMetadata)(action)?.onDismiss;
module.exports["getActionOnDismiss"] = $3bc7276fe39ce470$export$42c34726e4093ea;

});

parcelRegister("gR7ri", function(module, exports) {
const $e7fea99b17cf91ca$export$89c94a468e7458db = (action)=>action;
module.exports["getConversationActionWithAssistantMetadata"] = $e7fea99b17cf91ca$export$89c94a468e7458db;

});

parcelRegister("lzoay", function(module, exports) {

var $dSoGR = parcelRequire("dSoGR");

const $6b458841b18d92d3$export$2d48a0bb3ca90998 = (0, $dSoGR.createCommand)('action-classification-command');
module.exports["ActionClassificationCommand"] = $6b458841b18d92d3$export$2d48a0bb3ca90998;

});

parcelRegister("jIWEY", function(module, exports) {

var $4EPzQ = parcelRequire("4EPzQ");

const $6a4afb8ff5c7a0df$export$91924c1e64eedc26 = (docNode)=>{
    if (!docNode) return '';
    const text = (0, $4EPzQ.reduce)(docNode, (acc, node)=>node.type === 'text' ? acc + (node.text || '') : acc, '');
    return text.trim();
};
module.exports["extractTextFromDocNode"] = $6a4afb8ff5c7a0df$export$91924c1e64eedc26;

});

parcelRegister("guRLk", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");


var $bWJgt = parcelRequire("bWJgt");

const $94ac7e79844e2709$export$b2f14d06b1eb724e = (0, $kBr4q.createActionsHook)((0, $bWJgt.store));
module.exports["useChatMessageResearchActions"] = $94ac7e79844e2709$export$b2f14d06b1eb724e;

});

parcelRegister("bWJgt", function(module, exports) {

var $8s9DV = parcelRequire("8s9DV");


var $iDrrr = parcelRequire("iDrrr");


var $bxkJA = parcelRequire("bxkJA");

const $0ae2e85c06c407f6$export$d4032e5b8e7b1dac = 0.01;


const $80497cf038e22e03$export$62617f3d98f45616 = ({ messageId: messageId, content: content, title: title = 'Research Plan', roundId: roundId })=>({ getState: getState, setState: setState })=>{
        const currentState = getState();
        const message = currentState[messageId];
        // Set the research plan on the message
        setState({
            ...currentState,
            [messageId]: {
                ...message ?? {
                    currentProgress: (0, $0ae2e85c06c407f6$export$d4032e5b8e7b1dac),
                    steps: {},
                    researchPlans: {}
                },
                researchPlans: {
                    ...message?.researchPlans,
                    [roundId]: {
                        title: title,
                        content: content,
                        roundId: roundId
                    }
                }
            }
        });
    };


const $d33209bbb5b85d5e$export$590dff6126d55b43 = 0.05;


const $bc7bf914d1a438d1$export$4c442435645f2043 = (currentProgress, weight = (0, $d33209bbb5b85d5e$export$590dff6126d55b43))=>Math.min(0.95, currentProgress + 0.95 * weight);


const $7e39e718c4e877b6$export$62ce0cc0b5f9371c = (steps)=>{
    return steps.length ? Math.max(...steps.map((step)=>step.order)) : 0;
};



const $37a7a07adcd579ae$export$b9dd42b4e24f01b4 = ({ messageId: messageId, stepId: stepId, updater: updater })=>({ getState: getState, setState: setState })=>{
        const message = getState()[messageId];
        const step = message?.steps[stepId];
        const isNewStep = !step;
        // reuse existing order if the step exists, otherwise create a new one with the next order
        const order = step?.order ?? (0, $7e39e718c4e877b6$export$62ce0cc0b5f9371c)(Object.values(message?.steps ?? {})) + 1;
        const separatedContent = step?.separatedContent ?? [];
        const updatedStep = updater({
            ...message?.steps[stepId],
            separatedContent: separatedContent,
            stepId: stepId,
            order: order
        }, isNewStep);
        setState({
            [messageId]: {
                ...message ?? {
                    currentProgress: (0, $0ae2e85c06c407f6$export$d4032e5b8e7b1dac)
                },
                steps: {
                    ...message?.steps,
                    [stepId]: updatedStep
                },
                // Consider total researchCompleted:false if any step is updated to completed:false
                // This covers any new rounds that may stream in after the others have been completed
                ...!updatedStep.completed ? {
                    researchCompleted: false
                } : {},
                ...updatedStep.completed ? {
                    currentProgress: (0, $bc7bf914d1a438d1$export$4c442435645f2043)(message?.currentProgress ?? (0, $0ae2e85c06c407f6$export$d4032e5b8e7b1dac))
                } : {}
            }
        });
    };


const $52c6649b0e0b7a84$export$a55635553828f889 = ({ messageId: messageId, stepId: stepId, content: content, isStreamed: isStreamed, immediate: immediate, roundId: roundId })=>({ dispatch: dispatch })=>{
        dispatch((0, $37a7a07adcd579ae$export$b9dd42b4e24f01b4)({
            messageId: messageId,
            stepId: stepId,
            updater: (step, isNewStep)=>{
                // Concat once and reuse to halve per-event allocation.
                const concatenatedContent = (step.content ?? '') + content;
                // streamed: single concatenated child; non-streamed: each chunk as a separate array item
                const separatedContent = isStreamed ? [
                    concatenatedContent
                ] : [
                    ...step.separatedContent,
                    content
                ];
                return {
                    ...step,
                    roundId: roundId,
                    content: concatenatedContent,
                    separatedContent: separatedContent,
                    immediate: immediate,
                    // If a step content arrives for a step that was never introduced with a title,
                    // consider it completed immediately — it's an orphan content step that won't
                    // receive a RESEARCH_STEP_COMPLETE message.
                    // Otherwise, it cannot be complete if we're still appending content.
                    completed: isNewStep && !step.title ? true : false,
                    isStreamed: // Track whether this step's content is streamed or discrete
                    isStreamed
                };
            }
        }));
    };



const $c0ef94996608e7a5$export$7d99c23b07ac0974 = ({ messageId: messageId, stepId: stepId, document: document })=>({ dispatch: dispatch })=>{
        dispatch((0, $37a7a07adcd579ae$export$b9dd42b4e24f01b4)({
            messageId: messageId,
            stepId: stepId,
            updater: (step)=>({
                    ...step,
                    documents: [
                        ...step.documents ?? [],
                        document
                    ]
                })
        }));
    };


const $627ddeb671c41e26$export$872f148557cf8bf5 = 0.001;



const $bd90b8a8856f3dc3$export$207e76e63c9c4227 = ({ messageId: messageId })=>({ getState: getState, setState: setState })=>{
        const currentState = getState();
        const message = currentState[messageId];
        if (!message?.researchPlans) return;
        const clearedPlans = {};
        for (const [roundId, plan] of Object.entries(message.researchPlans))clearedPlans[Number(roundId)] = {
            ...plan,
            content: ''
        };
        setState({
            ...currentState,
            [messageId]: {
                ...message,
                researchPlans: clearedPlans
            }
        });
    };


const $6a418f740b9b0640$export$2e0130e7f5800320 = ({ messageId: messageId })=>({ getState: getState, setState: setState })=>{
        const currentState = getState();
        const message = currentState[messageId];
        if (message && !message.researchCompleted) {
            const updatedSteps = Object.entries(message.steps).reduce((acc, [stepId, step])=>({
                    ...acc,
                    [stepId]: {
                        ...step,
                        completed: true
                    }
                }), {});
            setState({
                ...currentState,
                [messageId]: {
                    ...message,
                    steps: updatedSteps,
                    currentProgress: undefined,
                    researchCompleted: true
                }
            });
        }
    };



const $a874628146faf38d$export$fd530ec9d7995e3e = ({ messageId: messageId })=>({ getState: getState, setState: setState })=>{
        const message = getState()[messageId];
        if (!message) setState({
            [messageId]: {
                currentProgress: (0, $0ae2e85c06c407f6$export$d4032e5b8e7b1dac),
                steps: {},
                researchPlans: {}
            }
        });
    };


const $af1e39fe228c220f$export$6514c23d684eadd8 = ({ messageId: messageId })=>({ getState: getState, setState: setState })=>{
        const message = getState()[messageId];
        if (message && !message.hasReceivedAnswerPart) setState({
            [messageId]: {
                ...message,
                hasReceivedAnswerPart: true
            }
        });
    };


const $0fd66ab30ab57c5a$export$8f77fbc4cfe15534 = ({ messageId: messageId })=>({ getState: getState, setState: setState })=>{
        const message = getState()[messageId];
        if (message && message.hasReceivedAnswerPart) setState({
            [messageId]: {
                ...message,
                hasReceivedAnswerPart: false
            }
        });
    };


const $06f681cd30867526$export$5cf35e65df857124 = ({ messageId: messageId, triggered: triggered })=>({ getState: getState, setState: setState })=>{
        const currentState = getState();
        const message = currentState[messageId];
        setState({
            [messageId]: {
                ...message ?? {
                    steps: {},
                    researchPlans: {}
                },
                hasThinkDeeperTriggered: triggered
            }
        });
    };


const $5ff0c09ec43395a4$export$d035a949bdd52aff = ({ messageId: messageId })=>({ getState: getState, setState: setState })=>{
        const currentState = getState();
        const message = currentState[messageId];
        setState({
            [messageId]: {
                ...message ?? {
                    steps: {},
                    researchPlans: {}
                },
                isDeepResearch: true
            }
        });
    };



const $8d246a514926505b$export$b9aadbf5032a78e5 = ({ messageId: messageId, stepId: stepId, sourceIcons: sourceIcons })=>({ dispatch: dispatch })=>{
        dispatch((0, $37a7a07adcd579ae$export$b9dd42b4e24f01b4)({
            messageId: messageId,
            stepId: stepId,
            updater: (step)=>({
                    ...step,
                    sourceIcons: sourceIcons
                })
        }));
    };



const $445c0b1f98ced811$export$32f8a965bfa76f84 = ({ messageId: messageId, stepId: stepId, sources: sources })=>({ dispatch: dispatch })=>{
        dispatch((0, $37a7a07adcd579ae$export$b9dd42b4e24f01b4)({
            messageId: messageId,
            stepId: stepId,
            updater: (step)=>({
                    ...step,
                    sources: sources
                })
        }));
    };



const $37e6411255737e57$export$f6ef21396b0d3d6d = ({ messageId: messageId, stepId: stepId, title: title, roundId: roundId, immediate: immediate, isSkill: isSkill = false, toolIcon: toolIcon, toolName: toolName, renderMode: renderMode, completed: completed = false })=>({ dispatch: dispatch })=>{
        dispatch((0, $37a7a07adcd579ae$export$b9dd42b4e24f01b4)({
            messageId: messageId,
            stepId: stepId,
            updater: (step)=>({
                    ...step,
                    title: title,
                    roundId: roundId,
                    isSkill: isSkill,
                    immediate: immediate,
                    completed: completed,
                    toolIcon: toolIcon,
                    toolName: toolName,
                    renderMode: renderMode
                })
        }));
    };




// Tool icon suffix for the trailing "Guard redacting" step. The guard emits it as a
// RESEARCH_STEP_TITLE with this icon and no completion trace (PRGD-520).
const $a88caf8a3c6dcb78$var$GUARD_TOOL_ICON_SUFFIX = '/tool/guard';
const $a88caf8a3c6dcb78$export$6f57813fe9f31bf9 = (0, $8s9DV.createStore)({
    initialState: {},
    actions: {
        resetHasReceivedAnswerPart: ({ messageId: messageId })=>({ dispatch: dispatch })=>{
                dispatch((0, $0fd66ab30ab57c5a$export$8f77fbc4cfe15534)({
                    messageId: messageId
                }));
            },
        addImplicitResearchPlan: ({ messageId: messageId, content: content, roundId: roundId })=>({ dispatch: dispatch })=>{
                dispatch((0, $a874628146faf38d$export$fd530ec9d7995e3e)({
                    messageId: messageId
                }));
                dispatch((0, $80497cf038e22e03$export$62617f3d98f45616)({
                    messageId: messageId,
                    content: content,
                    title: 'Research Plan',
                    roundId: roundId
                }));
            },
        processStreamResearch: ({ messageId: messageId, streamMessage: streamMessage, isDeepResearch: isDeepResearch = false })=>({ dispatch: dispatch, getState: getState })=>{
                // Guard fired RESPONSE_REDACTION: blank the accumulated response text that
                // streamed into each research round (the "answer above the response") while
                // keeping the step breakdown, so the unredacted text is not left in the store
                // (PRGD-488). Only routed here when the redaction feature gate is on.
                if ((0, $bxkJA.isStreamResponseRedaction)(streamMessage)) {
                    dispatch((0, $bd90b8a8856f3dc3$export$207e76e63c9c4227)({
                        messageId: messageId
                    }));
                    // The guard emits a trailing "Guard redacting" step AFTER FINAL_RESPONSE, which
                    // flips researchCompleted back to false (see updateStep) and revives the "Rovo is
                    // thinking" animation. The turn is over once we are redacting, so complete the
                    // steps to settle research and stop the indicator (PRGD-488).
                    dispatch((0, $6a418f740b9b0640$export$2e0130e7f5800320)({
                        messageId: messageId
                    }));
                }
                // Check if this is a THINK_DEEPER_TRIGGERED trace
                if ((0, $bxkJA.isStreamThinkDeeperTriggered)(streamMessage)) dispatch((0, $06f681cd30867526$export$5cf35e65df857124)({
                    messageId: messageId,
                    triggered: true
                }));
                if ((0, $bxkJA.isStreamResearchPlan)(streamMessage)) {
                    dispatch((0, $a874628146faf38d$export$fd530ec9d7995e3e)({
                        messageId: messageId
                    }));
                    dispatch((0, $80497cf038e22e03$export$62617f3d98f45616)({
                        messageId: messageId,
                        content: streamMessage.message.content,
                        title: 'Research Plan',
                        roundId: streamMessage.message.roundId
                    }));
                }
                if ((0, $bxkJA.isStreamAnswerPart)(streamMessage)) dispatch((0, $af1e39fe228c220f$export$6514c23d684eadd8)({
                    messageId: messageId
                }));
                if ((0, $bxkJA.isStreamResearchBeginningTrace)(streamMessage)) dispatch((0, $a874628146faf38d$export$fd530ec9d7995e3e)({
                    messageId: messageId
                }));
                if ((0, $bxkJA.isStreamResearchStepContent)(streamMessage) || (0, $bxkJA.isStreamReasoningPart)(streamMessage)) {
                    const { stepId: stepId, content: content } = streamMessage.message;
                    const roundId = (0, $bxkJA.isStreamResearchStepContent)(streamMessage) ? streamMessage.message.roundId : getState()[messageId]?.steps[stepId]?.roundId ?? 0;
                    // append the stream chunk content to the correct step data
                    dispatch((0, $52c6649b0e0b7a84$export$a55635553828f889)({
                        messageId: messageId,
                        stepId: stepId,
                        roundId: Number(roundId),
                        isStreamed: (0, $bxkJA.isStreamReasoningPart)(streamMessage),
                        // Show reasoning parts steps (e.g. "Creating a plan") immediately
                        // to avoid artificial delays in UI from queued step logic
                        immediate: (0, $bxkJA.isStreamReasoningPart)(streamMessage),
                        content: content
                    }));
                }
                if ((0, $bxkJA.isStreamResearchStepTitle)(streamMessage) || (0, $bxkJA.isStreamResearchStepTitleShort)(streamMessage)) {
                    const { roundId: roundId, stepId: stepId, title: title, toolIcon: toolIcon, toolName: toolName } = streamMessage.message;
                    const renderMode = (0, $bxkJA.isStreamResearchStepTitle)(streamMessage) ? streamMessage.message.renderMode : undefined;
                    // The guard emits a "Guard redacting" step (guard tool icon, empty stepId) that never
                    // receives a RESEARCH_STEP_COMPLETE. Mark it complete on arrival so it can't flip
                    // researchCompleted back to false and revive the "Rovo is thinking" indicator (PRGD-520).
                    // Gated on the same flag as the rest of the guard redaction UX so behavior is unchanged
                    // when off.
                    const isGuardRedactingStep = (toolIcon?.endsWith($a88caf8a3c6dcb78$var$GUARD_TOOL_ICON_SUFFIX) ?? false) && (0, $iDrrr.fg)('rovo-guard-ui-redaction-and-blocking');
                    dispatch((0, $37e6411255737e57$export$f6ef21396b0d3d6d)({
                        messageId: messageId,
                        stepId: stepId,
                        title: title,
                        roundId: Number(roundId),
                        immediate: false,
                        toolIcon: toolIcon,
                        toolName: toolName,
                        renderMode: renderMode,
                        completed: isGuardRedactingStep
                    }));
                    // The guard redacting step is terminal. The turn ends either with a redacted
                    // FINAL_RESPONSE (which settles research), or — when guard redacts the prompt — with a
                    // PROMPT_REDACTION followed by an AUP ERROR that never runs completeAllSteps. In that
                    // latter case the guard step is the only research trace, so marking it complete is not
                    // enough: researchCompleted stays false and the "Rovo is thinking" indicator keeps
                    // spinning under the error message. Settle the whole research on arrival so the indicator
                    // stops regardless of what terminates the stream, on the same entry the step was written
                    // to (immune to the tmp->server messageId re-key) (PRGD-520).
                    if (isGuardRedactingStep) dispatch((0, $6a418f740b9b0640$export$2e0130e7f5800320)({
                        messageId: messageId
                    }));
                }
                if ((0, $bxkJA.isStreamSkillStart)(streamMessage)) {
                    const { skill_status_metadata: skill_status_metadata } = streamMessage.message;
                    dispatch((0, $37e6411255737e57$export$f6ef21396b0d3d6d)({
                        messageId: messageId,
                        // random UUID since skills do not send stepIds, this should not matter for the step title
                        stepId: '68df4a4e-a42b-4d77-851f-6ac5d91bf38a',
                        title: skill_status_metadata?.aliases?.[0],
                        roundId: 0,
                        immediate: true,
                        isSkill: true
                    }));
                }
                if ((0, $bxkJA.isStreamSkillEnd)(streamMessage)) dispatch((0, $37a7a07adcd579ae$export$b9dd42b4e24f01b4)({
                    messageId: messageId,
                    stepId: '12345',
                    updater: (step)=>({
                            ...step,
                            completed: true
                        })
                }));
                if ((0, $bxkJA.isStreamResearchStepSource)(streamMessage)) {
                    const { message: { sources: sources, stepId: stepId } } = streamMessage;
                    dispatch((0, $445c0b1f98ced811$export$32f8a965bfa76f84)({
                        messageId: messageId,
                        stepId: stepId,
                        sources: sources
                    }));
                }
                if ((0, $bxkJA.isStreamResearchStepIcons)(streamMessage)) {
                    const { products: products, stepId: stepId } = streamMessage.message;
                    const ICON_BASE_URL = '/gateway/api/assist/rovo/v1/resources/icon/';
                    dispatch((0, $8d246a514926505b$export$b9aadbf5032a78e5)({
                        messageId: messageId,
                        stepId: stepId,
                        // Backend returns short names like "jira" — prepend the full gateway path.
                        // If the path already starts with "/" or is a data URI, use it as-is.
                        sourceIcons: products.map((product)=>product.startsWith('/') || product.startsWith('data:') ? product : `${ICON_BASE_URL}${product}`)
                    }));
                }
                if ((0, $bxkJA.isStreamResearchStepDocument)(streamMessage)) {
                    const { title: title, url: url, product: product, toolName: toolName, stepId: stepId } = streamMessage.message;
                    dispatch((0, $c0ef94996608e7a5$export$7d99c23b07ac0974)({
                        messageId: messageId,
                        stepId: stepId,
                        document: {
                            stepId: stepId,
                            title: title,
                            url: url,
                            product: product,
                            toolName: toolName
                        }
                    }));
                }
                if ((0, $bxkJA.isStreamResearchStepCompleted)(streamMessage)) {
                    const { stepId: stepId } = streamMessage.message;
                    dispatch((0, $37a7a07adcd579ae$export$b9dd42b4e24f01b4)({
                        messageId: messageId,
                        stepId: stepId,
                        updater: (step)=>({
                                ...step,
                                completed: true
                            })
                    }));
                }
                // Fail safe to complete all steps so the UI doesn't appear incomplete if there are missing chunks in the payload
                if ((0, $bxkJA.isStreamResponse)(streamMessage)) dispatch((0, $6a418f740b9b0640$export$2e0130e7f5800320)({
                    messageId: messageId
                }));
                if (isDeepResearch) dispatch((0, $5ff0c09ec43395a4$export$d035a949bdd52aff)({
                    messageId: messageId
                }));
            },
        updateResearchMessageId: ({ messageId: messageId, newMessageId: newMessageId })=>({ getState: getState, setState: setState })=>{
                setState({
                    ...getState(),
                    [newMessageId]: getState()[messageId],
                    [messageId]: undefined
                });
            },
        incrementProgressArtificially: ({ messageId: messageId })=>({ getState: getState, setState: setState })=>{
                const currentState = getState();
                const currentMessage = currentState[messageId];
                setState({
                    ...currentState,
                    [messageId]: {
                        ...currentMessage,
                        currentProgress: (0, $bc7bf914d1a438d1$export$4c442435645f2043)(currentMessage?.currentProgress ?? (0, $0ae2e85c06c407f6$export$d4032e5b8e7b1dac), (0, $627ddeb671c41e26$export$872f148557cf8bf5))
                    }
                });
            },
        markIncompleteResearchesErrored: ({ messageId: messageId })=>({ getState: getState, setState: setState })=>{
                const currentState = getState();
                const message = currentState[messageId];
                if (message && (message.currentProgress ?? 0) > 0 && !message.researchCompleted && !message.errored) setState({
                    ...currentState,
                    [messageId]: {
                        ...message,
                        errored: true
                    }
                });
            },
        completeAllSteps: ({ messageId: messageId })=>({ dispatch: dispatch })=>{
                dispatch((0, $6a418f740b9b0640$export$2e0130e7f5800320)({
                    messageId: messageId
                }));
            },
        getMessageResearchById: ({ messageId: messageId })=>({ getState: getState })=>{
                return getState()[messageId];
            },
        /**
     * Clears all research data for a specific message.
     * Used when Answer Now is triggered to reset the research state.
     */ clearMessageResearch: ({ messageId: messageId })=>({ getState: getState, setState: setState })=>{
                const currentState = getState();
                const { [messageId]: _, ...rest } = currentState;
                setState({
                    [messageId]: undefined,
                    ...rest
                });
            }
    }
});
module.exports["store"] = $a88caf8a3c6dcb78$export$6f57813fe9f31bf9;

});

parcelRegister("iDdTC", function(module, exports) {

var $9aI7t = parcelRequire("9aI7t");


var $b5593 = parcelRequire("b5593");


var $b90aI = parcelRequire("b90aI");


var $1Ht4b = parcelRequire("1Ht4b");


var $aaEQD = parcelRequire("aaEQD");

const $ffb05ca8baf9d9e1$export$b0c5c2fac8144e54 = {
    pageLoad: $1Ht4b.pageLoad,
    pageSegmentLoad: $aaEQD.pageSegmentLoad,
    interaction: $b90aI.interaction,
    custom: $b5593.custom,
    concurrent: $9aI7t.concurrent
};
module.exports["metrics"] = $ffb05ca8baf9d9e1$export$b0c5c2fac8144e54;

});

parcelRegister("9aI7t", function(module, exports) {

var $lCTbz = parcelRequire("lCTbz");


var $b5593 = parcelRequire("b5593");


var $b90aI = parcelRequire("b90aI");

const $95763ae236d73d99$var$concurrentMetrics = {};
const $95763ae236d73d99$var$getKey = (config, type)=>`${type}--${config.key}`;
const $95763ae236d73d99$var$validateConfig = (config)=>{
    if (config.include) throw new Error('"include" is not supported in concurrent actions');
    if (config.until) throw new Error('"until" is not supported in concurrent actions');
};
const $95763ae236d73d99$var$ensurePath = (config, type)=>{
    const key = $95763ae236d73d99$var$getKey(config, type);
    if (!(key in $95763ae236d73d99$var$concurrentMetrics)) $95763ae236d73d99$var$concurrentMetrics[key] = {};
};
const $95763ae236d73d99$var$getMetricFromCache = (concurrentId, config, type)=>{
    const concurrentKey = $95763ae236d73d99$var$getKey(config, type);
    if (concurrentKey in $95763ae236d73d99$var$concurrentMetrics && $95763ae236d73d99$var$concurrentMetrics[concurrentKey][String(concurrentId)]) return $95763ae236d73d99$var$concurrentMetrics[concurrentKey][String(concurrentId)];
    if (!(concurrentKey in $95763ae236d73d99$var$concurrentMetrics)) $95763ae236d73d99$var$concurrentMetrics[concurrentKey] = {};
    return;
};
const $95763ae236d73d99$var$makeConcurrentMetric = (concurrentId, config, type)=>{
    $95763ae236d73d99$var$validateConfig(config);
    $95763ae236d73d99$var$ensurePath(config, type);
    const metricFromCache = $95763ae236d73d99$var$getMetricFromCache(concurrentId, config, type);
    if (metricFromCache) return metricFromCache;
    const metricFactory = type === (0, $lCTbz.BMEventsType).INLINE_RESULT ? (0, $b90aI.interaction) : (0, $b5593.custom);
    const metric = metricFactory(config);
    $95763ae236d73d99$var$concurrentMetrics[$95763ae236d73d99$var$getKey(config, type)][String(concurrentId)] = metric;
    return metric;
};
const $95763ae236d73d99$export$370df09ecc3de059 = {
    pageSegmentLoad: (config)=>(concurrentId)=>$95763ae236d73d99$var$makeConcurrentMetric(concurrentId, {
                ...config
            }, (0, $lCTbz.BMEventsType).PAGE_SEGMENT_LOAD),
    interaction: (config)=>(concurrentId)=>$95763ae236d73d99$var$makeConcurrentMetric(concurrentId, {
                ...config
            }, (0, $lCTbz.BMEventsType).INLINE_RESULT),
    custom: (config)=>(concurrentId)=>$95763ae236d73d99$var$makeConcurrentMetric(concurrentId, {
                ...config
            }, (0, $lCTbz.BMEventsType).CUSTOM)
};
module.exports["concurrent"] = $95763ae236d73d99$export$370df09ecc3de059;

});

parcelRegister("b5593", function(module, exports) {

var $ipFlS = parcelRequire("ipFlS");


var $lCTbz = parcelRequire("lCTbz");

const $39f57926a8ef795b$export$4c00f665f0d4b443 = (config)=>{
    return new (0, $ipFlS.Metric)({
        ...config,
        type: (0, $lCTbz.BMEventsType).CUSTOM
    });
};
module.exports["custom"] = $39f57926a8ef795b$export$4c00f665f0d4b443;

});

parcelRegister("ipFlS", function(module, exports) {

var $hvVQt = parcelRequire("hvVQt");


var $581yf = parcelRequire("581yf");


var $7IphZ = parcelRequire("7IphZ");

class $4db3d4178d03c3ea$export$efdd3e096bc27746 extends (0, $7IphZ.BaseMetric) {
    start({ startTime: startTime } = {}) {
        super.start({
            startTime: startTime
        });
        this.route = (0, $hvVQt.Route).getRoute();
    }
    stop(params = {}) {
        const stoppedSuccessfully = super.stop(params);
        if (stoppedSuccessfully && !this.config.virtual) (0, $581yf.submitter).queue(this.getData());
        return stoppedSuccessfully;
    }
}
module.exports["Metric"] = $4db3d4178d03c3ea$export$efdd3e096bc27746;

});

parcelRegister("b90aI", function(module, exports) {

var $ipFlS = parcelRequire("ipFlS");


var $lCTbz = parcelRequire("lCTbz");

const $060787d14b6a30d6$export$92473e6020ad89b4 = (config)=>{
    return new (0, $ipFlS.Metric)({
        ...config,
        type: (0, $lCTbz.BMEventsType).INLINE_RESULT
    });
};
module.exports["interaction"] = $060787d14b6a30d6$export$92473e6020ad89b4;

});

parcelRegister("1Ht4b", function(module, exports) {

var $3L5Pu = parcelRequire("3L5Pu");


var $lCTbz = parcelRequire("lCTbz");

const $a55ff36d094d83ef$export$791d520f7e8058a5 = (config)=>{
    return new (0, $3L5Pu.PageLoadMetric)({
        ...config,
        type: (0, $lCTbz.BMEventsType).PAGE_LOAD
    });
};
module.exports["pageLoad"] = $a55ff36d094d83ef$export$791d520f7e8058a5;

});

parcelRegister("3L5Pu", function(module, exports) {

var $97AWA = parcelRequire("97AWA");


var $jk8rA = parcelRequire("jk8rA");


var $hvVQt = parcelRequire("hvVQt");


var $581yf = parcelRequire("581yf");


var $lCTbz = parcelRequire("lCTbz");


var $2QFOI = parcelRequire("2QFOI");


var $wgCbG = parcelRequire("wgCbG");


var $eNslE = parcelRequire("eNslE");

class $bbca0ae0eaeecc15$export$3c51073271a9eac3 extends (0, $2QFOI.BasePageLoadMetric) {
    startPageLoad(params = {
        isInitial: false
    }) {
        (0, $wgCbG.pageLoadMetaMetric).startPageLoad({
            ...params,
            cancelStarted: 'startTime' in params
        });
        this.watchUntil();
    }
    stop(params = {}) {
        const stopTime = params.stopTime || window.performance.now();
        const pageLoadData = (0, $wgCbG.pageLoadMetaMetric).getDataToMerge();
        const metaMetricStopped = (0, $wgCbG.pageLoadMetaMetric).stop(params);
        if (!metaMetricStopped) return false;
        if (pageLoadData.isInitial && this.config.ssr?.doneAsFmp) {
            if (!this.marks[(0, $2QFOI.BasePageLoadMetric).FMP]) {
                const mark = (0, $97AWA.SSRGetDoneMark).getDoneMark();
                if (mark) (0, $wgCbG.pageLoadMetaMetric).markFMP(mark);
            } else (0, $wgCbG.pageLoadMetaMetric).markFMP(this.marks[(0, $2QFOI.BasePageLoadMetric).FMP]);
        }
        this.route = (0, $hvVQt.Route).getRoute();
        const metricStopped = this.stopPageLoad(pageLoadData, {
            ...params,
            stopTime: stopTime
        });
        if (!metricStopped) return false;
        const data = this.getData();
        if (!this.config.virtual) (0, $581yf.submitter).queue(data);
        (0, $jk8rA.logger).logCond(!!this.config.debug, 'page-load', 'stop', this.getData);
        this.enqueueWebVitals();
        return true;
    }
    mark(mark, timestamp = window.performance.now()) {
        (0, $wgCbG.pageLoadMetaMetric).mark(mark, timestamp);
    }
    markFMP(timestamp) {
        (0, $wgCbG.pageLoadMetaMetric).markFMP(timestamp);
    }
    getData() {
        const pageLoadMetaData = (0, $wgCbG.pageLoadMetaMetric).getData();
        return {
            ...super.getData(),
            // marks and explicitTimings are available only in pageLoadMeta
            marks: pageLoadMetaData.marks,
            explicitTimings: pageLoadMetaData.explicitTimings
        };
    }
    async enqueueWebVitals() {
        if (this.config.virtual || !this.isInitial) return false;
        const configChunk = await (0, $581yf.submitter).config.configChunk;
        if (!configChunk?.[(0, $lCTbz.BMEventsType).WEB_VITALS].webVitals?.enabled) return false;
        const webVitalMetric = new (0, $eNslE.WebVitalsMetric)({
            key: this.config.key,
            route: this.route,
            startTime: this.startTime,
            stopTime: this.stopTime,
            pageVisibleState: this.pageVisibleState
        });
        (0, $581yf.submitter).queue(webVitalMetric.getData());
        (0, $jk8rA.logger).logCond(!!this.config.debug, 'web-vitals', webVitalMetric.getData);
        return true;
    }
}
module.exports["PageLoadMetric"] = $bbca0ae0eaeecc15$export$3c51073271a9eac3;

});

parcelRegister("eNslE", function(module, exports) {

var $lCTbz = parcelRequire("lCTbz");


var $7IphZ = parcelRequire("7IphZ");

class $23d0f6650a8bd5e3$export$dc0d85d4d6503cd7 extends (0, $7IphZ.BaseMetric) {
    constructor({ key: key, route: route, startTime: startTime, stopTime: stopTime, pageVisibleState: pageVisibleState }){
        super({
            type: (0, $lCTbz.BMEventsType).WEB_VITALS,
            key: key
        });
        this.route = route;
        this.startTime = startTime;
        this.stopTime = stopTime;
        this.state = (0, $7IphZ.MetricState).FINISHED;
        this.pageVisibleState = pageVisibleState;
    }
}
module.exports["WebVitalsMetric"] = $23d0f6650a8bd5e3$export$dc0d85d4d6503cd7;

});

parcelRegister("aaEQD", function(module, exports) {

var $h51B5 = parcelRequire("h51B5");


var $lCTbz = parcelRequire("lCTbz");

const $2eb5124fdb2b6158$export$94114666844d5f66 = (config)=>{
    return new (0, $h51B5.PageSegmentLoadMetric)({
        ...config,
        type: (0, $lCTbz.BMEventsType).PAGE_SEGMENT_LOAD
    });
};
module.exports["pageSegmentLoad"] = $2eb5124fdb2b6158$export$94114666844d5f66;

});

parcelRegister("h51B5", function(module, exports) {

var $97AWA = parcelRequire("97AWA");


var $lCTbz = parcelRequire("lCTbz");


var $7IphZ = parcelRequire("7IphZ");


var $ipFlS = parcelRequire("ipFlS");


var $wgCbG = parcelRequire("wgCbG");

class $0f8d7af9cfafbf9f$export$24c8bfcd77494cc1 extends (0, $ipFlS.Metric) {
    startFromPageLoad() {
        const pageLoadMetaData = (0, $wgCbG.pageLoadMetaMetric).getData();
        this.start({
            startTime: pageLoadMetaData.start ?? undefined
        });
        this.isInitial = pageLoadMetaData.isInitial;
        this.pageVisibleState = pageLoadMetaData.pageVisibleState;
    }
    mark(mark, timestamp = window.performance.now()) {
        if (mark === $0f8d7af9cfafbf9f$export$24c8bfcd77494cc1.FMP) return;
        super.mark(mark, timestamp);
    }
    markFMP(timestamp) {
        super.mark($0f8d7af9cfafbf9f$export$24c8bfcd77494cc1.FMP, timestamp);
    }
    getPageSegmentLoadData() {
        return {
            isInitial: this.isInitial
        };
    }
    getData() {
        return {
            ...super.getData(),
            ...this.getPageSegmentLoadData()
        };
    }
    getDataToMerge() {
        return {
            ...super.getDataToMerge(),
            ...this.getPageSegmentLoadData()
        };
    }
    merge(mergeData) {
        super.merge(mergeData);
        this.isInitial = mergeData.isInitial;
    }
    stop(params = {}) {
        const pageLoadData = (0, $wgCbG.pageLoadMetaMetric).getData();
        if (pageLoadData.isInitial && this.config.ssr?.doneAsFmp) {
            if (!this.marks[$0f8d7af9cfafbf9f$export$24c8bfcd77494cc1.FMP]) {
                const mark = (0, $97AWA.SSRGetDoneMark).getDoneMark();
                if (mark) this.markFMP(mark);
            }
        }
        if (this.config.includePageLoadTimings !== (0, $lCTbz.PageSegmentPageLoadMetricsOptions).WAIT_UNTIL_PRESENT || pageLoadData.state === (0, $7IphZ.MetricState).FINISHED) return super.stop(params);
        const now = performance.now();
        if (pageLoadData.state === (0, $7IphZ.MetricState).STARTED) (0, $wgCbG.pageLoadMetaMetric).onStop(()=>{
            super.stop({
                ...params,
                stopTime: params.stopTime || now
            });
        }, ()=>{
            this.cancel();
        });
        return true;
    }
    constructor(config){
        super(config);
        this.isInitial = true;
        this.config = void 0;
        this.config = config;
    }
}
$0f8d7af9cfafbf9f$export$24c8bfcd77494cc1.FMP = 'fmp';
module.exports["PageSegmentLoadMetric"] = $0f8d7af9cfafbf9f$export$24c8bfcd77494cc1;

});

parcelRegister("cRubi", function(module, exports) {
/**
 * Module registry so Conversation Assistant (which owns chat-context bridge wiring)
 * can publish a canonical context provider for Enterprise HER without React tree coupling.
 */ let $8478e96dfac09728$var$registeredProvider = null;
function $8478e96dfac09728$export$4f41b66184515f3(provider) {
    $8478e96dfac09728$var$registeredProvider = provider;
}
function $8478e96dfac09728$export$53df788b6a579ad7() {
    return $8478e96dfac09728$var$registeredProvider;
}
module.exports["setRovoChatContextProvider"] = $8478e96dfac09728$export$4f41b66184515f3;
module.exports["getRovoChatContextProvider"] = $8478e96dfac09728$export$53df788b6a579ad7;

});

parcelRegister("O96nq", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $5c06eb0f3ede4a6c$export$ba3e2fddf5af0178 = (0, $cozmU.createContext)(null);
module.exports["ViewDeadAirContext"] = $5c06eb0f3ede4a6c$export$ba3e2fddf5af0178;

});

parcelRegister("dPoYT", function(module, exports) {
const $8dbc220cf14fe789$export$bc36ebf73899a71d = {
    SIDEBAR: 'sidebar',
    MINI_MODAL: 'mini-modal'
};
module.exports["ConversationAssistantUIModes"] = $8dbc220cf14fe789$export$bc36ebf73899a71d;

});

parcelRegister("dqxOF", function(module, exports) {
function $9c67ef4150ae4cb3$export$967a6b9924a689f7(arrA, arrB) {
    if (arrA === arrB) return true;
    if (!arrA || !arrB) return false;
    const len = arrA.length;
    if (arrB.length !== len) return false;
    for(let i = 0; i < len; i++){
        if (arrA[i] !== arrB[i]) return false;
    }
    return true;
}
function $9c67ef4150ae4cb3$export$3e67810a3f0e9f1c(objA, objB) {
    if (objA === objB) return true;
    if (!objA || !objB) return false;
    const aKeys = Object.keys(objA);
    const bKeys = Object.keys(objB);
    const len = aKeys.length;
    if (bKeys.length !== len) return false;
    for(let i = 0; i < len; i++){
        const key = aKeys[i];
        if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) return false;
    }
    return true;
}
function $9c67ef4150ae4cb3$export$d36bdfa510afb180(a, b) {
    const aIsArr = Array.isArray(a);
    const bIsArr = Array.isArray(b);
    if (aIsArr !== bIsArr) return false;
    if (aIsArr && bIsArr) return $9c67ef4150ae4cb3$export$967a6b9924a689f7(a, b);
    return $9c67ef4150ae4cb3$export$3e67810a3f0e9f1c(a, b);
}
 //# sourceMappingURL=index.modern.mjs.map
module.exports["shallowEqualObjects"] = $9c67ef4150ae4cb3$export$3e67810a3f0e9f1c;

});

parcelRegister("jqg1p", function(module, exports) {
const $cd16886f2e0e6e79$export$a89b9c1bf34c03e5 = (current, next)=>{
    if (current === next) return true;
    if (!current || !next || current.length !== next.length) return false;
    return current.every((value, index)=>value === next[index]);
};
module.exports["areStringArraysEqual"] = $cd16886f2e0e6e79$export$a89b9c1bf34c03e5;

});

parcelRegister("jAZYc", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $0165172f0f6448b6$export$8cc6a5423ea2e47d = (value, areEqual)=>{
    const stableValueRef = (0, $cozmU.useRef)(value);
    if (!areEqual(stableValueRef.current, value)) stableValueRef.current = value;
    return stableValueRef.current;
};
module.exports["useSemanticStableValue"] = $0165172f0f6448b6$export$8cc6a5423ea2e47d;

});

parcelRegister("6e8qW", function(module, exports) {
/**
 * Shared TAP (Traits and Personalization) delivery client.
 *
 * Provides fetch utilities for both user-level and site-level TAP traits,
 * along with common parsers for trait values.
 */ const $105b061879975503$var$getUserTraitsUrl = (userId)=>`/gateway/api/tap-delivery/api/v3/personalization/user/${userId}`;
const $105b061879975503$var$getSiteTraitsUrl = (siteId)=>`/gateway/api/tap-delivery/api/v3/personalization/site/${siteId}`;
const $105b061879975503$var$getSiteUserTraitsUrl = (siteId, userId)=>`/gateway/api/tap-delivery/api/v3/personalization/site/${siteId}/user/${userId}`;
const $105b061879975503$var$fetchTraits = async (url, signal)=>{
    const response = await fetch(url, {
        method: 'GET',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'x-atlassian-mau-ignore': 'true'
        },
        signal: signal
    });
    if (!response.ok) throw new Error(`TAP request failed with status ${response.status}`);
    const data = await response.json();
    return data.attributes ?? [];
};
const $105b061879975503$export$2a353ada541e501f = async (userId, signal)=>{
    return $105b061879975503$var$fetchTraits($105b061879975503$var$getUserTraitsUrl(userId), signal);
};
const $105b061879975503$export$954f05a5dfd487e4 = async (siteId, signal)=>{
    return $105b061879975503$var$fetchTraits($105b061879975503$var$getSiteTraitsUrl(siteId), signal);
};
const $105b061879975503$export$ce0490d52501284f = async (siteId, userId, signal)=>$105b061879975503$var$fetchTraits($105b061879975503$var$getSiteUserTraitsUrl(siteId, userId), signal);
const $105b061879975503$export$860b8ce93b9dfdcc = (traits, traitName)=>{
    const trait = traits.find((t)=>t.name === traitName);
    return trait?.value;
};
const $105b061879975503$export$f357d04e31823a19 = (traits, traitName)=>{
    const trait = traits.find((t)=>t.name === traitName);
    if (!trait || typeof trait.value !== 'string') return {};
    const result = {};
    const pairs = trait.value.split(',').map((s)=>s.trim());
    for (const pair of pairs){
        const [product, valueStr] = pair.split(':').map((s)=>s.trim());
        if (product && valueStr) {
            const value = Number(valueStr);
            if (Number.isFinite(value)) result[product] = value;
        }
    }
    return result;
};
/**
 * Maps TAP-trait product keys to the FE source keys returned by the
 * assistance-service AgentKnowledgeConfiguration API.
 * Source of truth: convoai-platform `KnowledgeSourceTypeValues`.
 */ const $105b061879975503$var$TAP_KEY_TO_FE_SOURCE = {
    adobexd: 'adobe_xd',
    'adobe-sign': 'adobe_sign',
    aha: 'aha',
    airtable: 'airtable',
    amplitude: 'amplitude',
    asana: 'asana',
    'atlassian-web-crawler': 'atlassian-web-crawler',
    'aws-s3': 'aws',
    'azure-devops': 'azure_devops',
    box: 'box',
    canva: 'canva',
    clickup: 'clickup',
    databricks: 'databricks',
    docusign: 'docusign',
    dovetail: 'dovetail',
    dropbox: 'dropbox',
    figma: 'figma',
    freshservice: 'freshservice',
    gcp: 'gcp',
    github: 'github',
    gitbook: 'gitbook',
    gitlab: 'gitlab',
    gmail: 'gmail',
    'google-calendar': 'google_calendar',
    drive: 'google_drive',
    hubspot: 'hubspot',
    launchdarkly: 'launchdarkly',
    loom: 'loom',
    lucid: 'lucid',
    miro: 'miro',
    monday: 'monday',
    mural: 'mural',
    notion: 'notion',
    onedrive: 'microsoft_onedrive',
    'outlook-calendar': 'microsoft_outlook_calendar',
    'outlook-mail': 'microsoft_outlook_mail',
    pagerduty: 'pagerduty',
    pipedrive: 'pipedrive',
    'power-bi': 'microsoft_power_bi',
    salesforce: 'salesforce',
    sentry: 'sentry',
    servicenow: 'servicenow',
    sharepoint: 'microsoft_sharepoint',
    slack: 'slack',
    smartsheet: 'smartsheet',
    stripe: 'stripe',
    teams: 'teams',
    todoist: 'todoist',
    webex: 'cisco_webex',
    zendesk: 'zendesk',
    zeplin: 'zeplin'
};
const $105b061879975503$export$75425aa5703db6b4 = (parsed)=>{
    const normalized = {};
    for (const [tapKey, value] of Object.entries(parsed)){
        const normalizedKey = $105b061879975503$var$TAP_KEY_TO_FE_SOURCE[tapKey] ?? tapKey;
        normalized[normalizedKey] = Math.max(normalized[normalizedKey] ?? Number.NEGATIVE_INFINITY, value);
    }
    return normalized;
};
const $105b061879975503$export$e8d0db1b887b304b = 'rovo_connector_authed_users_percentage_by_app';
module.exports["fetchUserTraits"] = $105b061879975503$export$2a353ada541e501f;
module.exports["fetchSiteTraits"] = $105b061879975503$export$954f05a5dfd487e4;
module.exports["fetchSiteUserTraits"] = $105b061879975503$export$ce0490d52501284f;
module.exports["findTraitValue"] = $105b061879975503$export$860b8ce93b9dfdcc;
module.exports["parseProductValueTrait"] = $105b061879975503$export$f357d04e31823a19;
module.exports["normalizeTapKeys"] = $105b061879975503$export$75425aa5703db6b4;
module.exports["CONNECTOR_AUTH_RATE_TRAIT"] = $105b061879975503$export$e8d0db1b887b304b;

});

parcelRegister("7SkLu", function(module, exports) {

var $E1QOf = parcelRequire("E1QOf");


var $a33Aa = parcelRequire("a33Aa");

function $c60ab42870e33b24$export$f9c6890b323d326b(key, value) {
    const interactionId = (0, $E1QOf.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    (0, $a33Aa.addCohortingCustomData)(currentInteractionId, key, value);
}
module.exports["addUFOCustomCohortData"] = $c60ab42870e33b24$export$f9c6890b323d326b;

});

parcelRegister("7Myh3", function(module, exports) {
// Single-source dynamic import factory for the conversation-assistant chunk.
// Mirrors the chunk-name used by the live lazy()/loadable() boundaries so preload
// and the live boundaries share the same chunk identity.

const $9d88e303fe02f351$export$24a887167476720c = ()=>(parcelRequire("5ZqEN"));
module.exports["importConversationAssistant"] = $9d88e303fe02f351$export$24a887167476720c;

});

parcelRegister("5ZqEN", function(module, exports) {

let $45c753cce7b89525$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $45c753cce7b89525$var$load("45r7q"),
    $45c753cce7b89525$var$load("6wr18"),
    $45c753cce7b89525$var$load("7SteV"),
    $45c753cce7b89525$var$load("5JmXn"),
    $45c753cce7b89525$var$load("ffEVr"),
    $45c753cce7b89525$var$load("Wowvf"),
    $45c753cce7b89525$var$load("cGkFm"),
    $45c753cce7b89525$var$load("dYUYM"),
    $45c753cce7b89525$var$load("lgRS0"),
    $45c753cce7b89525$var$load("hhss7"),
    $45c753cce7b89525$var$load("7EorR"),
    $45c753cce7b89525$var$load("ce05o")
]).then(()=>parcelRequire('iuVKP'));

});

parcelRegister("ir4h8", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $ac2J9 = parcelRequire("ac2J9");

const $abc73c6f5c74c436$export$6d558eab13290f59 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const { routerLinkComponent: routerLinkComponent } = (0, $cozmU.useContext)((0, $ac2J9.RouterLinkProviderContext));
    if (routerLinkComponent) return routerLinkComponent;
} : ()=>{
    const { routerLinkComponent: routerLinkComponent } = (0, $cozmU.useContext)((0, $ac2J9.RouterLinkProviderContext));
    if (routerLinkComponent) return routerLinkComponent;
    return;
};
module.exports["useRouterLink"] = $abc73c6f5c74c436$export$6d558eab13290f59;

});

parcelRegister("ac2J9", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $b797161b98bd0492$export$2931e0ee690eee88 = /*#__PURE__*/ (0, $cozmU.createContext)({});
/**
 * __RouterLinkProvider__
 *
 * Provides a configured router link component for use
 * within Design System components.
 */ const $b797161b98bd0492$var$RouterLinkProvider = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { routerLinkComponent: routerLinkComponent, children: children } = t0;
    let t1;
    if ($[0] !== routerLinkComponent) {
        t1 = {
            routerLinkComponent: routerLinkComponent
        };
        $[0] = routerLinkComponent;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== children || $[3] !== t1) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)($b797161b98bd0492$export$2931e0ee690eee88.Provider, {
            value: t1,
            children: children
        });
        $[2] = children;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ routerLinkComponent: routerLinkComponent, children: children })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)($b797161b98bd0492$export$2931e0ee690eee88.Provider, {
        value: {
            routerLinkComponent: routerLinkComponent
        },
        children: children
    });
};
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$b797161b98bd0492$export$2e2bcd8739ae039 = $b797161b98bd0492$var$RouterLinkProvider;
module.exports["RouterLinkProviderContext"] = $b797161b98bd0492$export$2931e0ee690eee88;

});

parcelRegister("jPzTX", function(module, exports) {

var $lyW2B = parcelRequire("lyW2B");


var $e7pPJ = parcelRequire("e7pPJ");


var $d246i = parcelRequire("d246i");

/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */ function $e6fea10dbb684687$var$flatRest(func) {
    return $d246i($e7pPJ(func, undefined, $lyW2B), func + '');
}
module.exports = $e6fea10dbb684687$var$flatRest;

});

parcelRegister("lyW2B", function(module, exports) {

var $avFJ9 = parcelRequire("avFJ9");

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */ function $fb29cba7dcd09042$var$flatten(array) {
    var length = array == null ? 0 : array.length;
    return length ? $avFJ9(array, 1) : [];
}
module.exports = $fb29cba7dcd09042$var$flatten;

});

parcelRegister("avFJ9", function(module, exports) {

var $8kPaX = parcelRequire("8kPaX");


var $eED1E = parcelRequire("eED1E");

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */ function $7a6d2ac83094702e$var$baseFlatten(array, depth, predicate, isStrict, result) {
    var index = -1, length = array.length;
    predicate || (predicate = $eED1E);
    result || (result = []);
    while(++index < length){
        var value = array[index];
        if (depth > 0 && predicate(value)) {
            if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
            $7a6d2ac83094702e$var$baseFlatten(value, depth - 1, predicate, isStrict, result);
            else $8kPaX(result, value);
        } else if (!isStrict) result[result.length] = value;
    }
    return result;
}
module.exports = $7a6d2ac83094702e$var$baseFlatten;

});

parcelRegister("eED1E", function(module, exports) {

var $2v1OR = parcelRequire("2v1OR");


var $bZ5J1 = parcelRequire("bZ5J1");


var $1ScXu = parcelRequire("1ScXu");

/** Built-in value references. */ var $aab312c604d1130a$var$spreadableSymbol = $2v1OR ? $2v1OR.isConcatSpreadable : undefined;
/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */ function $aab312c604d1130a$var$isFlattenable(value) {
    return $1ScXu(value) || $bZ5J1(value) || !!($aab312c604d1130a$var$spreadableSymbol && value && value[$aab312c604d1130a$var$spreadableSymbol]);
}
module.exports = $aab312c604d1130a$var$isFlattenable;

});

parcelRegister("89CKS", function(module, exports) {
/**
 * @generated SignedSource<<29d02a00238e986613f78bcab9812352>>
 * @relayHash 1c39b72e16854d19d11c51ceef0122b1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 57a186e10000ef184bec3a0e71a8dec9c1b57a66702d145178c98368d5d78434
const $76fac522acc3b282$var$node = function() {
    var v0 = [
        {
            "concreteType": "Entitlements",
            "kind": "LinkedField",
            "name": "entitlements",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ExternalCollaboratorFeature",
                    "kind": "LinkedField",
                    "name": "externalCollaborator",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isEntitled"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "fetchMentionsProviderDataQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "fetchMentionsProviderDataQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "1c39b72e16854d19d11c51ceef0122b1",
            "id": "57a186e10000ef184bec3a0e71a8dec9c1b57a66702d145178c98368d5d78434",
            "metadata": {},
            "name": "fetchMentionsProviderDataQuery",
            "operationKind": "query",
            "text": "query fetchMentionsProviderDataQuery{entitlements{externalCollaborator{isEntitled}}}"
        }
    };
}();
$76fac522acc3b282$var$node.hash = "97f5ab279ca8162d7d39b760a9aa8808";
var $76fac522acc3b282$export$2e2bcd8739ae039 = $76fac522acc3b282$var$node;
module.exports["default"] = $76fac522acc3b282$export$2e2bcd8739ae039;

});

parcelRegister("6Q8Dd", function(module, exports) {

var $1P2f3 = parcelRequire("1P2f3");

"use strict";
/**
 * Copyright (c) 2019-present, GraphQL Foundation
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */ // A Function, which when given an Array of keys, returns a Promise of an Array
// of values or Errors.
// Optionally turn off batching or caching or provide a cache key function or a
// custom cache instance.
// If a custom cache is provided, it must be of this type (a subset of ES6 Map).
/**
 * A `DataLoader` creates a public API for loading data from a particular
 * data back-end with unique keys such as the `id` column of a SQL table or
 * document name in a MongoDB database, given a batch loading function.
 *
 * Each `DataLoader` instance contains a unique memoized cache. Use caution when
 * used in long-lived applications or those which serve many users with
 * different access permissions and consider creating a new instance per
 * web request.
 */ var $4fae4b715d22864c$var$DataLoader = /*#__PURE__*/ function() {
    function DataLoader(batchLoadFn, options) {
        if (typeof batchLoadFn !== 'function') throw new TypeError('DataLoader must be constructed with a function which accepts ' + ("Array<key> and returns Promise<Array<value>>, but got: " + batchLoadFn + "."));
        this._batchLoadFn = batchLoadFn;
        this._maxBatchSize = $4fae4b715d22864c$var$getValidMaxBatchSize(options);
        this._batchScheduleFn = $4fae4b715d22864c$var$getValidBatchScheduleFn(options);
        this._cacheKeyFn = $4fae4b715d22864c$var$getValidCacheKeyFn(options);
        this._cacheMap = $4fae4b715d22864c$var$getValidCacheMap(options);
        this._batch = null;
        this.name = $4fae4b715d22864c$var$getValidName(options);
    } // Private
    var _proto = DataLoader.prototype;
    /**
   * Loads a key, returning a `Promise` for the value represented by that key.
   */ _proto.load = function load(key) {
        if (key === null || key === undefined) throw new TypeError('The loader.load() function must be called with a value, ' + ("but got: " + String(key) + "."));
        var batch = $4fae4b715d22864c$var$getCurrentBatch(this);
        var cacheMap = this._cacheMap;
        var cacheKey; // If caching and there is a cache-hit, return cached Promise.
        if (cacheMap) {
            cacheKey = this._cacheKeyFn(key);
            var cachedPromise = cacheMap.get(cacheKey);
            if (cachedPromise) {
                var cacheHits = batch.cacheHits || (batch.cacheHits = []);
                return new Promise(function(resolve) {
                    cacheHits.push(function() {
                        resolve(cachedPromise);
                    });
                });
            }
        } // Otherwise, produce a new Promise for this key, and enqueue it to be
        // dispatched along with the current batch.
        batch.keys.push(key);
        var promise = new Promise(function(resolve, reject) {
            batch.callbacks.push({
                resolve: resolve,
                reject: reject
            });
        }); // If caching, cache this promise.
        if (cacheMap) cacheMap.set(cacheKey, promise);
        return promise;
    };
    _proto.loadMany = function loadMany(keys) {
        if (!$4fae4b715d22864c$var$isArrayLike(keys)) throw new TypeError('The loader.loadMany() function must be called with Array<key> ' + ("but got: " + keys + "."));
         // Support ArrayLike by using only minimal property access
        var loadPromises = [];
        for(var i = 0; i < keys.length; i++)loadPromises.push(this.load(keys[i])["catch"](function(error) {
            return error;
        }));
        return Promise.all(loadPromises);
    };
    _proto.clear = function clear(key) {
        var cacheMap = this._cacheMap;
        if (cacheMap) {
            var cacheKey = this._cacheKeyFn(key);
            cacheMap["delete"](cacheKey);
        }
        return this;
    };
    _proto.clearAll = function clearAll() {
        var cacheMap = this._cacheMap;
        if (cacheMap) cacheMap.clear();
        return this;
    };
    _proto.prime = function prime(key, value) {
        var cacheMap = this._cacheMap;
        if (cacheMap) {
            var cacheKey = this._cacheKeyFn(key); // Only add the key if it does not already exist.
            if (cacheMap.get(cacheKey) === undefined) {
                // Cache a rejected promise if the value is an Error, in order to match
                // the behavior of load(key).
                var promise;
                if (value instanceof Error) {
                    promise = Promise.reject(value); // Since this is a case where an Error is intentionally being primed
                    // for a given key, we want to disable unhandled promise rejection.
                    promise["catch"](function() {});
                } else promise = Promise.resolve(value);
                cacheMap.set(cacheKey, promise);
            }
        }
        return this;
    };
    return DataLoader;
}(); // Private: Enqueue a Job to be executed after all "PromiseJobs" Jobs.
//
// ES6 JavaScript uses the concepts Job and JobQueue to schedule work to occur
// after the current execution context has completed:
// http://www.ecma-international.org/ecma-262/6.0/#sec-jobs-and-job-queues
//
// Node.js uses the `process.nextTick` mechanism to implement the concept of a
// Job, maintaining a global FIFO JobQueue for all Jobs, which is flushed after
// the current call stack ends.
//
// When calling `then` on a Promise, it enqueues a Job on a specific
// "PromiseJobs" JobQueue which is flushed in Node as a single Job on the
// global JobQueue.
//
// DataLoader batches all loads which occur in a single frame of execution, but
// should include in the batch all loads which occur during the flushing of the
// "PromiseJobs" JobQueue after that same execution frame.
//
// In order to avoid the DataLoader dispatch Job occuring before "PromiseJobs",
// A Promise Job is created with the sole purpose of enqueuing a global Job,
// ensuring that it always occurs after "PromiseJobs" ends.
//
// Node.js's job queue is unique. Browsers do not have an equivalent mechanism
// for enqueuing a job to be performed after promise microtasks and before the
// next macrotask. For browser environments, a macrotask is used (via
// setImmediate or setTimeout) at a potential performance penalty.
var $4fae4b715d22864c$var$enqueuePostPromiseJob = typeof $1P2f3 === 'object' && typeof $1P2f3.nextTick === 'function' ? function(fn) {
    if (!$4fae4b715d22864c$var$resolvedPromise) $4fae4b715d22864c$var$resolvedPromise = Promise.resolve();
    $4fae4b715d22864c$var$resolvedPromise.then(function() {
        $1P2f3.nextTick(fn);
    });
} : typeof setImmediate === 'function' ? function(fn) {
    setImmediate(fn);
} : function(fn) {
    setTimeout(fn);
}; // Private: cached resolved Promise instance
var $4fae4b715d22864c$var$resolvedPromise; // Private: Describes a batch of requests
// Private: Either returns the current batch, or creates and schedules a
// dispatch of a new batch for the given loader.
function $4fae4b715d22864c$var$getCurrentBatch(loader) {
    // If there is an existing batch which has not yet dispatched and is within
    // the limit of the batch size, then return it.
    var existingBatch = loader._batch;
    if (existingBatch !== null && !existingBatch.hasDispatched && existingBatch.keys.length < loader._maxBatchSize) return existingBatch;
     // Otherwise, create a new batch for this loader.
    var newBatch = {
        hasDispatched: false,
        keys: [],
        callbacks: []
    }; // Store it on the loader so it may be reused.
    loader._batch = newBatch; // Then schedule a task to dispatch this batch of requests.
    loader._batchScheduleFn(function() {
        $4fae4b715d22864c$var$dispatchBatch(loader, newBatch);
    });
    return newBatch;
}
function $4fae4b715d22864c$var$dispatchBatch(loader, batch) {
    // Mark this batch as having been dispatched.
    batch.hasDispatched = true; // If there's nothing to load, resolve any cache hits and return early.
    if (batch.keys.length === 0) {
        $4fae4b715d22864c$var$resolveCacheHits(batch);
        return;
    } // Call the provided batchLoadFn for this loader with the batch's keys and
    // with the loader as the `this` context.
    var batchPromise;
    try {
        batchPromise = loader._batchLoadFn(batch.keys);
    } catch (e) {
        return $4fae4b715d22864c$var$failedDispatch(loader, batch, new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function " + ("errored synchronously: " + String(e) + ".")));
    } // Assert the expected response from batchLoadFn
    if (!batchPromise || typeof batchPromise.then !== 'function') return $4fae4b715d22864c$var$failedDispatch(loader, batch, new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did " + ("not return a Promise: " + String(batchPromise) + ".")));
     // Await the resolution of the call to batchLoadFn.
    batchPromise.then(function(values) {
        // Assert the expected resolution from batchLoadFn.
        if (!$4fae4b715d22864c$var$isArrayLike(values)) throw new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did " + ("not return a Promise of an Array: " + String(values) + "."));
        if (values.length !== batch.keys.length) throw new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did not return a Promise of an Array of the same length as the Array of keys." + ("\n\nKeys:\n" + String(batch.keys)) + ("\n\nValues:\n" + String(values)));
         // Resolve all cache hits in the same micro-task as freshly loaded values.
        $4fae4b715d22864c$var$resolveCacheHits(batch); // Step through values, resolving or rejecting each Promise in the batch.
        for(var i = 0; i < batch.callbacks.length; i++){
            var _value = values[i];
            if (_value instanceof Error) batch.callbacks[i].reject(_value);
            else batch.callbacks[i].resolve(_value);
        }
    })["catch"](function(error) {
        $4fae4b715d22864c$var$failedDispatch(loader, batch, error);
    });
} // Private: do not cache individual loads if the entire batch dispatch fails,
// but still reject each request so they do not hang.
function $4fae4b715d22864c$var$failedDispatch(loader, batch, error) {
    // Cache hits are resolved, even though the batch failed.
    $4fae4b715d22864c$var$resolveCacheHits(batch);
    for(var i = 0; i < batch.keys.length; i++){
        loader.clear(batch.keys[i]);
        batch.callbacks[i].reject(error);
    }
} // Private: Resolves the Promises for any cache hits in this batch.
function $4fae4b715d22864c$var$resolveCacheHits(batch) {
    if (batch.cacheHits) for(var i = 0; i < batch.cacheHits.length; i++)batch.cacheHits[i]();
} // Private: given the DataLoader's options, produce a valid max batch size.
function $4fae4b715d22864c$var$getValidMaxBatchSize(options) {
    var shouldBatch = !options || options.batch !== false;
    if (!shouldBatch) return 1;
    var maxBatchSize = options && options.maxBatchSize;
    if (maxBatchSize === undefined) return Infinity;
    if (typeof maxBatchSize !== 'number' || maxBatchSize < 1) throw new TypeError("maxBatchSize must be a positive number: " + maxBatchSize);
    return maxBatchSize;
} // Private
function $4fae4b715d22864c$var$getValidBatchScheduleFn(options) {
    var batchScheduleFn = options && options.batchScheduleFn;
    if (batchScheduleFn === undefined) return $4fae4b715d22864c$var$enqueuePostPromiseJob;
    if (typeof batchScheduleFn !== 'function') throw new TypeError("batchScheduleFn must be a function: " + batchScheduleFn);
    return batchScheduleFn;
} // Private: given the DataLoader's options, produce a cache key function.
function $4fae4b715d22864c$var$getValidCacheKeyFn(options) {
    var cacheKeyFn = options && options.cacheKeyFn;
    if (cacheKeyFn === undefined) return function(key) {
        return key;
    };
    if (typeof cacheKeyFn !== 'function') throw new TypeError("cacheKeyFn must be a function: " + cacheKeyFn);
    return cacheKeyFn;
} // Private: given the DataLoader's options, produce a CacheMap to be used.
function $4fae4b715d22864c$var$getValidCacheMap(options) {
    var shouldCache = !options || options.cache !== false;
    if (!shouldCache) return null;
    var cacheMap = options && options.cacheMap;
    if (cacheMap === undefined) return new Map();
    if (cacheMap !== null) {
        var cacheFunctions = [
            'get',
            'set',
            'delete',
            'clear'
        ];
        var missingFunctions = cacheFunctions.filter(function(fnName) {
            return cacheMap && typeof cacheMap[fnName] !== 'function';
        });
        if (missingFunctions.length !== 0) throw new TypeError('Custom cacheMap missing methods: ' + missingFunctions.join(', '));
    }
    return cacheMap;
}
function $4fae4b715d22864c$var$getValidName(options) {
    if (options && options.name) return options.name;
    return null;
} // Private
function $4fae4b715d22864c$var$isArrayLike(x) {
    return typeof x === 'object' && x !== null && typeof x.length === 'number' && (x.length === 0 || x.length > 0 && Object.prototype.hasOwnProperty.call(x, x.length - 1));
}
module.exports = $4fae4b715d22864c$var$DataLoader;

});

parcelRegister("4yccB", function(module, exports) {

var $QO4PV = parcelRequire("QO4PV");


var $6Q8Dd = parcelRequire("6Q8Dd");


var $iKWdo = parcelRequire("iKWdo");


var $lPEt0 = parcelRequire("lPEt0");


var $axuex = parcelRequire("axuex");


var $j39Hd = parcelRequire("j39Hd");


var $ixC10 = parcelRequire("ixC10");


var $cXJjm = parcelRequire("cXJjm");


var $grief = parcelRequire("grief");


var $2g31M = parcelRequire("2g31M");


var $ggGdk = parcelRequire("ggGdk");


var $iDrrr = parcelRequire("iDrrr");


var $c2kDy = parcelRequire("c2kDy");


var $44Sj0 = parcelRequire("44Sj0");

const $614b823604b25d0c$var$MAX_BATCH_SIZE = 50;
const $614b823604b25d0c$var$MIN_TIME_BETWEEN_BATCHES = 250;
const $614b823604b25d0c$var$URL_RESPONSE_CACHE_SIZE = 100;
const $614b823604b25d0c$export$d6a66073b5d79eb3 = new (0, $lPEt0.LRUMap)($614b823604b25d0c$var$URL_RESPONSE_CACHE_SIZE);
const $614b823604b25d0c$var$urlResponseInFlightCache = new Map();
class $614b823604b25d0c$export$2e2bcd8739ae039 {
    setProduct(product) {
        this.product = product;
    }
    /**
   * Set custom headers to be sent with each request to the resolver.
   *
   * @param headers - Object containing headers to be sent with each request.
   */ setHeaders(headers) {
        this.headers = headers;
    }
    createUrlLoader() {
        const batchResolveThrottler = (0, (/*@__PURE__*/$parcel$interopDefault($axuex)))({
            limit: 1,
            interval: $614b823604b25d0c$var$MIN_TIME_BETWEEN_BATCHES
        });
        const throttledBatchResolve = batchResolveThrottler(this.batchResolveUrl);
        return new (0, (/*@__PURE__*/$parcel$interopDefault($6Q8Dd)))(// We place all calls to `batchResolve` in a limiter so we don't send off several simultaneous batch requests.
        // This is for two reasons:
        //  1: we want to avoid getting rate limited upstream (eg: forge and other APIs)
        //  2: we want to avoid sending out heaps of requests from the client at once
        (urls)=>throttledBatchResolve(urls), {
            maxBatchSize: $614b823604b25d0c$var$MAX_BATCH_SIZE,
            // NOTE: we turn off DataLoader's cache because it doesn't work for our use-case. Consider the following:
            // - a smartlink to a restricted item is resolved to "forbidden" with a "request access button"
            // - the user clicks "request access", and then following the auth prompts and gets access
            // - the frontend now re-renders the smartlink, but due to DataLoader's caching, the previous "forbidden" state is
            //   because the smartlink's URL (which is the cache key) is exactly the same
            //
            // For this reason, we disable DataLoader's cache.
            // This means that URLs will not be de-duplicated by DataLoader, so we perform the de-duplication logic
            // ourselves in `this.batchResolveUrl`.
            cache: false
        });
    }
    getUrlLoader(hostname) {
        if (!this.urlLoadersByDomain[hostname]) this.urlLoadersByDomain[hostname] = this.createUrlLoader();
        return this.urlLoadersByDomain[hostname];
    }
    getHostName(url) {
        try {
            return new URL(url).hostname;
        } catch (error) {
            throw new (0, $grief.InvalidUrlError)(error);
        }
    }
    async resolveUrlWithoutInlineOptimization(url, hostname, force) {
        let responsePromise = $614b823604b25d0c$export$d6a66073b5d79eb3.get(url);
        if (!responsePromise || force) {
            const urlLoader = this.getUrlLoader(hostname);
            responsePromise = urlLoader.load({
                resourceUrl: url,
                ignoreCachedValue: force || undefined
            });
            $614b823604b25d0c$export$d6a66073b5d79eb3.set(url, responsePromise);
        }
        let response;
        try {
            response = await responsePromise;
        } catch (e) {
            // Technically this never happens, since batchResolve handles errors and doesn't throw,
            // But just in case.
            $614b823604b25d0c$export$d6a66073b5d79eb3.delete(url);
            throw e;
        }
        const isUnresolvedLink = !(0, $44Sj0.isSuccessfulResponse)(response) || (0, $ggGdk.getStatus)(response.body) !== 'resolved';
        if (isUnresolvedLink) // We want consequent calls for fetchData() to cause actual http call
        $614b823604b25d0c$export$d6a66073b5d79eb3.delete(url);
        return response;
    }
    async resolveUrlWithInlineOptimization(url, hostname, force, appearance) {
        const cacheKey = `${url}|${appearance}`;
        const inFlightCacheKey = JSON.stringify([
            url,
            appearance,
            force
        ]);
        let responsePromise = $614b823604b25d0c$var$urlResponseInFlightCache.get(inFlightCacheKey);
        if (!responsePromise) {
            responsePromise = $614b823604b25d0c$export$d6a66073b5d79eb3.get(cacheKey);
            if (!responsePromise || force) {
                const urlLoader = this.getUrlLoader(hostname);
                responsePromise = urlLoader.load({
                    resourceUrl: url,
                    ignoreCachedValue: force || undefined,
                    appearance: appearance
                });
                $614b823604b25d0c$export$d6a66073b5d79eb3.set(cacheKey, responsePromise);
                $614b823604b25d0c$var$urlResponseInFlightCache.set(inFlightCacheKey, responsePromise);
            }
        }
        let response;
        try {
            response = await responsePromise;
        } catch (e) {
            // Technically this never happens, since batchResolve handles errors and doesn't throw,
            // But just in case.
            $614b823604b25d0c$export$d6a66073b5d79eb3.delete(cacheKey);
            throw e;
        } finally{
            if ($614b823604b25d0c$var$urlResponseInFlightCache.get(inFlightCacheKey) === responsePromise) $614b823604b25d0c$var$urlResponseInFlightCache.delete(inFlightCacheKey);
        }
        const isUnresolvedLink = !(0, $44Sj0.isSuccessfulResponse)(response) || (0, $ggGdk.getStatus)(response.body) !== 'resolved';
        if (isUnresolvedLink) // We want consequent calls for fetchData() to cause actual http call
        $614b823604b25d0c$export$d6a66073b5d79eb3.delete(cacheKey);
        return response;
    }
    async resolveUrl(url, force = false, appearance) {
        const hostname = this.getHostName(url);
        if (appearance !== undefined && (0, $iDrrr.fg)('platform_smartlink_inline_resolve_optimization')) return this.resolveUrlWithInlineOptimization(url, hostname, force, appearance);
        return this.resolveUrlWithoutInlineOptimization(url, hostname, force);
    }
    async prefetchData(url, appearance) {
        // 1. Queue the URL as part of a dataloader batch.
        const response = await this.resolveUrl(url, false, appearance);
        if ((0, $44Sj0.isSuccessfulResponse)(response)) // 2. If the URL resolves, send it back.
        return response.body;
        else try {
            // 3. If the URL does not resolve, retry it with exponential backoff.
            // This is done so that we avoid the scenario where users are unable to
            // see a resolved Smart Link, when their expectation is to be able to.
            const retriedResponse = await (0, (/*@__PURE__*/$parcel$interopDefault($QO4PV)))(async ()=>{
                // We check if the link has resolved in the cache and stop trying if so.
                // We do this by triggering an error that the link has already been resolved.
                // This cascades <retryCount> times after which it is handled like a normal
                // 'error', returning `undefined`.
                if (!this.resolvedCache[url]) {
                    const response = await this.resolveUrl(url, false, appearance);
                    if ((0, $44Sj0.isSuccessfulResponse)(response)) return response;
                    else throw new Error('Retry for URL failed');
                } else // Short-circuit each of the retries, as described above.
                throw new Error('Retry unneeded - link has been resolved.');
            }, this.retryConfig);
            // Trigger callback after successful backoff.
            return retriedResponse.body;
        } catch  {
            // Do nothing in the case of an error - prefetching
            // failures should be silent. Once a link is visible,
            // it will be re-fetched anyhow, in which case a
            // user-facing error is required.
            return undefined;
        }
    }
    isRateLimitError(response) {
        return (0, $c2kDy.isErrorResponse)(response) && response.error.status === 429;
    }
    /**
   * Fetch data from URL
   * @param url - The URL to fetch data for
   * @param force - Whether to force a fresh fetch, bypassing cache
   * @param appearance - Card appearance hint for ORS to optimize response payload.
   *                     When 'inline', ORS returns minimal data (title, status).
   *                     When 'block' or 'embed', ORS returns full data including summary.
   */ async fetchData(url, force, appearance) {
        let response = await this.resolveUrl(url, force, appearance);
        if (this.isRateLimitError(response)) response = await (0, (/*@__PURE__*/$parcel$interopDefault($QO4PV)))(async ()=>{
            const retryResponse = await this.resolveUrl(url, false, appearance);
            if (this.isRateLimitError(retryResponse)) throw this.mapErrorResponse(retryResponse, new URL(url).hostname);
            return retryResponse;
        }, this.retryConfig);
        if (!(0, $44Sj0.isSuccessfulResponse)(response)) throw this.mapErrorResponse(response, new URL(url).hostname);
        // Set a flag in the `resolvedCache` for this URL. The intent of this is
        // to ensure that the exponential backoff method in `prefetchData` does
        // not continue to retry fetching for this URL, especially if it was previously
        // in a failed state. Note: this scenario only occurs on initial page load, if the
        // user scrolls through the page very fast. Once the URL is visible, prefetching
        // no longer takes place.
        this.resolvedCache[url] = true;
        // Return the JSON-LD response back up!
        return response.body;
    }
    /**
   * Fetch data for multiple ARIs (batch) in one operation
   * @param aris Array of ARIs to fetch data for
   */ async fetchDataAris(aris) {
        return await this.batchResolveAris(aris);
    }
    async postData(data) {
        const requestData = {
            key: data.key,
            action: data.action,
            context: data.context
        };
        return await (0, $j39Hd.request)('post', `${this.resolverUrl}/invoke`, requestData);
    }
    /**
   * Make request to the Search endpoint See `InvocationRequest` in ORS openapi.yaml for backend
   * spec.
   * @param data Payload including the search provider key and query. An empty search query string
   * results in recent results being returned (pre-query).
   * @returns JsonLd collection of search results.
   */ async search(data) {
        const { key: key, action: action } = data;
        // Note: context in action is different to context in data, see types.
        const { query: query, context: context } = action;
        const requestData = {
            key: key,
            search: {
                query: query,
                context: context
            }
        };
        const response = await (0, $j39Hd.request)('post', `${this.resolverUrl}/invoke/search`, requestData);
        if ((0, $c2kDy.isErrorResponse)(response)) // There is no hostname/it is not known. Hostname is not logged anyway as it's considered PII.
        throw this.mapErrorResponse(response);
        return response;
    }
    async fetchAvailableSearchProviders() {
        const response = await (0, $j39Hd.request)('post', `${this.resolverUrl}/providers`, {
            type: 'search'
        });
        return response.providers;
    }
    mapErrorResponse(response, hostname = '') {
        // Catch non-200 server responses to fallback or return useful information.
        if (response?.error) {
            const errorType = response.error.type;
            const errorMessage = response.error.message;
            const extensionKey = response.error.extensionKey;
            // this means there was a network error and we fallback to blue link
            // without impacting SLO's
            if (response.error instanceof (0, $2g31M.NetworkError)) return new (0, $ixC10.APIError)('fallback', hostname, errorMessage, errorType);
            switch(errorType){
                // BadRequestError - indicative of an API error, render
                // a blue link to mitigate customer impact.
                case 'ResolveBadRequestError':
                case 'SearchBadRequestError':
                case 'BadRequestError':
                    return new (0, $ixC10.APIError)('fallback', hostname, errorMessage, errorType, extensionKey);
                // AuthError - if the user logs in, we may be able
                // to recover. Render an unauthorized card.
                case 'ResolveAuthError':
                case 'SearchAuthError':
                case 'AuthError':
                    return new (0, $ixC10.APIError)('auth', hostname, errorMessage, errorType, extensionKey);
                // UnsupportedError - we do not know how to render this URL.
                // Bail out and ask the Editor to render as a blue link.
                case 'ResolveUnsupportedError':
                case 'SearchUnsupportedError':
                case 'UnsupportedError':
                    // URL isn't supported
                    return new (0, $ixC10.APIError)('fatal', hostname, errorMessage, errorType, extensionKey);
                case 'ResolveFailedError':
                case 'SearchFailedError':
                case 'ResolveTimeoutError':
                case 'SearchTimeoutError':
                case 'SearchRateLimitError':
                case 'ResolveRateLimitError':
                case 'InternalServerError':
                case 'TimeoutError':
                case 'RateLimitError':
                    return new (0, $ixC10.APIError)('error', hostname, errorMessage, errorType, extensionKey);
            }
        }
        // Catch all: we don't know this error, bail out.
        const { error: error, ...rest } = response || {};
        return new (0, $ixC10.APIError)('fatal', hostname, // reason we stringify the error differently is because
        // JSON.stringify will return "{}" if it is an instance of Error
        // e.g. JSON.stringify(new Error('something went wrong')) will return '{}'
        // reason is JSON.stringify method only serializes enumerable properties but properties like "message" and "stack" are non enumerable
        // e.g. https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error/message
        // more info here https://stackoverflow.com/questions/18391212/is-it-not-possible-to-stringify-an-error-using-json-stringify
        // we assume 'rest'  to "serializable" meaning all its properties are enumerable
        response ? `${this.stringifyError(error)} ${JSON.stringify(rest)}` : 'Response undefined', 'UnexpectedError');
    }
    /**
   * This method will strigify both enumerable and  non enumerable properties of an object
   * @param err
   * @returns object serialized to JSON with both enumerable and non enumerable objects
   */ stringifyError(err) {
        /**
     * By default JSON.stringify only serializes enumerable properties of an object. In order for us to
     * serialize non enumerable properties out of an error we need to expclitily provide the non enumerable property names.
     * the second parameter to JSON.stringify gets the properties that will be serialized from the object passed in the first argument
     * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/getOwnPropertyNames
     */ return JSON.stringify(err, //In ES5, if the argument to getOwnPropertyNames method is not an object (a primitive), then it will cause a TypeError
        typeof err === 'object' ? Object.getOwnPropertyNames(err) : undefined);
    }
    constructor(envKey, baseUrlOverride){
        this.resolverUrl = void 0;
        this.envKey = void 0;
        this.baseUrlOverride = void 0;
        this.urlLoadersByDomain = void 0;
        this.retryConfig = void 0;
        this.resolvedCache = void 0;
        this.product = void 0;
        this.headers = void 0;
        this.postBatchResolveNew = async (resources, resourceType, keyGetter)=>{
            // De-duplicate requested URLs (see `this.createUrlLoader` for more detail).
            // Also de-duplicate requested ARIs as backend does not de-duplicate any requests.
            const deDuplicatedResources = (0, (/*@__PURE__*/$parcel$interopDefault($iKWdo)))(resources, keyGetter);
            let resolvedResources = [];
            const headers = {
                /**
         * This header exist to enable the backend to process relative time, eg: "today", with respect to the user timezone.
         * eg: used in "confluence-object-provider" to resolve confluence SLLV links that may involve relative time calculation.
         */ 'origin-timezone': Intl?.DateTimeFormat().resolvedOptions().timeZone,
                // send product source as header X-Product if defined
                ...this.product ? {
                    'X-Product': this.product
                } : {},
                // add custom headers if defined
                ...this.headers ?? {}
            };
            try {
                // Ask the backend to resolve the URLs for us.
                if (resourceType === 'URL') resolvedResources = await (0, $j39Hd.request)('post', `${this.resolverUrl}/resolve/batch`, deDuplicatedResources, headers);
                // Ask the backend to resolve the ARIs for us.
                if (resourceType === 'ARI') resolvedResources = await (0, $j39Hd.request)('post', `${this.resolverUrl}/resolve/ari/batch`, deDuplicatedResources, headers);
            } catch (error) {
                // we make sure we return a valid dataloader response by creating an error
                // response for each url/ari
                resolvedResources = resources.map(()=>{
                    // @ts-ignore
                    const status = (0, $c2kDy.isErrorResponse)(error) ? error.status : 500;
                    const errorResponse = {
                        status: status,
                        error: // @ts-ignore
                        error
                    };
                    return errorResponse;
                });
            }
            // Reduce into a map to make accessing faster and easier.
            const map = {};
            // NOTE: the batch endpoint returns the URLs/ARIs in the same order they were given.
            for(let i = 0; i < deDuplicatedResources.length; ++i){
                const resource = deDuplicatedResources[i];
                const data = resolvedResources[i];
                map[keyGetter(resource)] = data;
            }
            // Reconvert list back into the original order in which it was given to us.
            return resources.map((originalResource)=>map[keyGetter(originalResource)]);
        };
        this.postBatchResolve = async (resources, resourceType = 'URL')=>{
            // De-duplicate requested URLs (see `this.createUrlLoader` for more detail).
            // Also de-duplicate requested ARIs as backend does not de-duplicate any requests.
            const deDuplicatedResources = [
                ...new Set(resources)
            ];
            let resolvedResources = [];
            const headers = {
                /**
         * This header exist to enable the backend to process relative time, eg: "today", with respect to the user timezone.
         * eg: used in "confluence-object-provider" to resolve confluence SLLV links that may involve relative time calculation.
         */ 'origin-timezone': Intl?.DateTimeFormat().resolvedOptions().timeZone,
                // send product source as header X-Product if defined
                ...this.product ? {
                    'X-Product': this.product
                } : {},
                // add custom headers if defined
                ...this.headers ? this.headers : {}
            };
            try {
                // Ask the backend to resolve the URLs for us.
                if (resourceType === 'URL') resolvedResources = await (0, $j39Hd.request)('post', `${this.resolverUrl}/resolve/batch`, deDuplicatedResources.map((resourceUrl)=>({
                        resourceUrl: resourceUrl
                    })), headers);
                // Ask the backend to resolve the ARIs for us.
                if (resourceType === 'ARI') resolvedResources = await (0, $j39Hd.request)('post', `${this.resolverUrl}/resolve/ari/batch`, deDuplicatedResources.map((ari)=>({
                        ari: ari
                    })), headers);
            } catch (error) {
                // we make sure we return a valid dataloader response by creating an error
                // response for each url/ari
                resolvedResources = resources.map(()=>{
                    // @ts-ignore
                    const status = (0, $c2kDy.isErrorResponse)(error) ? error.status : 500;
                    const errorResponse = {
                        status: status,
                        error: // @ts-ignore
                        error
                    };
                    return errorResponse;
                });
            }
            // Reduce into a map to make accessing faster and easier.
            const map = {};
            // NOTE: the batch endpoint returns the URLs/ARIs in the same order they were given.
            for(let i = 0; i < deDuplicatedResources.length; ++i){
                const resource = deDuplicatedResources[i];
                const data = resolvedResources[i];
                map[resource] = data;
            }
            // Reconvert list back into the original order in which it was given to us.
            return resources.map((originalResource)=>map[originalResource]);
        };
        this.batchResolveUrl = async (urls)=>{
            return this.postBatchResolveNew(urls, 'URL', (resource)=>{
                // Appearance is only added to the payload when the inline resolve optimization gate is on.
                // Preserve differently shaped requests for the same URL so a reduced inline response cannot
                // be returned to a block request from the same batch.
                if (resource.appearance !== undefined && (0, $iDrrr.fg)('platform_smartlink_inline_resolve_optimization')) return JSON.stringify([
                    resource.resourceUrl,
                    resource.appearance,
                    resource.ignoreCachedValue === true
                ]);
                return resource.resourceUrl;
            });
        };
        // Endpoint for batch resolve ari
        this.batchResolveAris = async (aris)=>{
            return this.postBatchResolve(aris, 'ARI');
        };
        this.resolverUrl = (0, $cXJjm.getResolverUrl)(envKey, baseUrlOverride);
        this.urlLoadersByDomain = {};
        this.retryConfig = {
            retries: 2
        };
        this.resolvedCache = {};
        this.envKey = envKey;
        this.baseUrlOverride = baseUrlOverride;
    }
}
module.exports["default"] = $614b823604b25d0c$export$2e2bcd8739ae039;

});

parcelRegister("QO4PV", function(module, exports) {
// Packages

var $lbZ9z = parcelRequire("lbZ9z");

function $09ebb3b1b19cd625$var$retry(fn, opts) {
    function run(resolve, reject) {
        var options = opts || {};
        var op;
        // Default `randomize` to true
        if (!('randomize' in options)) options.randomize = true;
        op = $lbZ9z.operation(options);
        // We allow the user to abort retrying
        // this makes sense in the cases where
        // knowledge is obtained that retrying
        // would be futile (e.g.: auth errors)
        function bail(err) {
            reject(err || new Error('Aborted'));
        }
        function onError(err, num) {
            if (err.bail) {
                bail(err);
                return;
            }
            if (!op.retry(err)) reject(op.mainError());
            else if (options.onRetry) options.onRetry(err, num);
        }
        function runAttempt(num) {
            var val;
            try {
                val = fn(bail, num);
            } catch (err) {
                onError(err, num);
                return;
            }
            Promise.resolve(val).then(resolve).catch(function catchIt(err) {
                onError(err, num);
            });
        }
        op.attempt(runAttempt);
    }
    return new Promise(run);
}
module.exports = $09ebb3b1b19cd625$var$retry;

});

parcelRegister("lbZ9z", function(module, exports) {

module.exports = (parcelRequire("4co4r"));

});

parcelRegister("4co4r", function(module, exports) {

var $8xi9I = parcelRequire("8xi9I");

exports.operation = function(options) {
    var timeouts = exports.timeouts(options);
    return new $8xi9I(timeouts, {
        forever: options && (options.forever || options.retries === Infinity),
        unref: options && options.unref,
        maxRetryTime: options && options.maxRetryTime
    });
};
exports.timeouts = function(options) {
    if (options instanceof Array) return [].concat(options);
    var opts = {
        retries: 10,
        factor: 2,
        minTimeout: 1000,
        maxTimeout: Infinity,
        randomize: false
    };
    for(var key in options)opts[key] = options[key];
    if (opts.minTimeout > opts.maxTimeout) throw new Error('minTimeout is greater than maxTimeout');
    var timeouts = [];
    for(var i = 0; i < opts.retries; i++)timeouts.push(this.createTimeout(i, opts));
    if (options && options.forever && !timeouts.length) timeouts.push(this.createTimeout(i, opts));
    // sort the array numerically ascending
    timeouts.sort(function(a, b) {
        return a - b;
    });
    return timeouts;
};
exports.createTimeout = function(attempt, opts) {
    var random = opts.randomize ? Math.random() + 1 : 1;
    var timeout = Math.round(random * Math.max(opts.minTimeout, 1) * Math.pow(opts.factor, attempt));
    timeout = Math.min(timeout, opts.maxTimeout);
    return timeout;
};
exports.wrap = function(obj, options, methods) {
    if (options instanceof Array) {
        methods = options;
        options = null;
    }
    if (!methods) {
        methods = [];
        for(var key in obj)if (typeof obj[key] === 'function') methods.push(key);
    }
    for(var i = 0; i < methods.length; i++){
        var method = methods[i];
        var original = obj[method];
        obj[method] = (function retryWrapper(original) {
            var op = exports.operation(options);
            var args = Array.prototype.slice.call(arguments, 1);
            var callback = args.pop();
            args.push(function(err) {
                if (op.retry(err)) return;
                if (err) arguments[0] = op.mainError();
                callback.apply(this, arguments);
            });
            op.attempt(function() {
                original.apply(obj, args);
            });
        }).bind(obj, original);
        obj[method].options = options;
    }
};

});

parcelRegister("8xi9I", function(module, exports) {
function $636f7d2929f63478$var$RetryOperation(timeouts, options) {
    // Compatibility for the old (timeouts, retryForever) signature
    if (typeof options === 'boolean') options = {
        forever: options
    };
    this._originalTimeouts = JSON.parse(JSON.stringify(timeouts));
    this._timeouts = timeouts;
    this._options = options || {};
    this._maxRetryTime = options && options.maxRetryTime || Infinity;
    this._fn = null;
    this._errors = [];
    this._attempts = 1;
    this._operationTimeout = null;
    this._operationTimeoutCb = null;
    this._timeout = null;
    this._operationStart = null;
    this._timer = null;
    if (this._options.forever) this._cachedTimeouts = this._timeouts.slice(0);
}
module.exports = $636f7d2929f63478$var$RetryOperation;
$636f7d2929f63478$var$RetryOperation.prototype.reset = function() {
    this._attempts = 1;
    this._timeouts = this._originalTimeouts.slice(0);
};
$636f7d2929f63478$var$RetryOperation.prototype.stop = function() {
    if (this._timeout) clearTimeout(this._timeout);
    if (this._timer) clearTimeout(this._timer);
    this._timeouts = [];
    this._cachedTimeouts = null;
};
$636f7d2929f63478$var$RetryOperation.prototype.retry = function(err) {
    if (this._timeout) clearTimeout(this._timeout);
    if (!err) return false;
    var currentTime = new Date().getTime();
    if (err && currentTime - this._operationStart >= this._maxRetryTime) {
        this._errors.push(err);
        this._errors.unshift(new Error('RetryOperation timeout occurred'));
        return false;
    }
    this._errors.push(err);
    var timeout = this._timeouts.shift();
    if (timeout === undefined) {
        if (this._cachedTimeouts) {
            // retry forever, only keep last error
            this._errors.splice(0, this._errors.length - 1);
            timeout = this._cachedTimeouts.slice(-1);
        } else return false;
    }
    var self = this;
    this._timer = setTimeout(function() {
        self._attempts++;
        if (self._operationTimeoutCb) {
            self._timeout = setTimeout(function() {
                self._operationTimeoutCb(self._attempts);
            }, self._operationTimeout);
            if (self._options.unref) self._timeout.unref();
        }
        self._fn(self._attempts);
    }, timeout);
    if (this._options.unref) this._timer.unref();
    return true;
};
$636f7d2929f63478$var$RetryOperation.prototype.attempt = function(fn, timeoutOps) {
    this._fn = fn;
    if (timeoutOps) {
        if (timeoutOps.timeout) this._operationTimeout = timeoutOps.timeout;
        if (timeoutOps.cb) this._operationTimeoutCb = timeoutOps.cb;
    }
    var self = this;
    if (this._operationTimeoutCb) this._timeout = setTimeout(function() {
        self._operationTimeoutCb();
    }, self._operationTimeout);
    this._operationStart = new Date().getTime();
    this._fn(this._attempts);
};
$636f7d2929f63478$var$RetryOperation.prototype.try = function(fn) {
    console.log('Using RetryOperation.try() is deprecated');
    this.attempt(fn);
};
$636f7d2929f63478$var$RetryOperation.prototype.start = function(fn) {
    console.log('Using RetryOperation.start() is deprecated');
    this.attempt(fn);
};
$636f7d2929f63478$var$RetryOperation.prototype.start = $636f7d2929f63478$var$RetryOperation.prototype.try;
$636f7d2929f63478$var$RetryOperation.prototype.errors = function() {
    return this._errors;
};
$636f7d2929f63478$var$RetryOperation.prototype.attempts = function() {
    return this._attempts;
};
$636f7d2929f63478$var$RetryOperation.prototype.mainError = function() {
    if (this._errors.length === 0) return null;
    var counts = {};
    var mainError = null;
    var mainErrorCount = 0;
    for(var i = 0; i < this._errors.length; i++){
        var error = this._errors[i];
        var message = error.message;
        var count = (counts[message] || 0) + 1;
        counts[message] = count;
        if (count >= mainErrorCount) {
            mainError = error;
            mainErrorCount = count;
        }
    }
    return mainError;
};

});

parcelRegister("iKWdo", function(module, exports) {

var $j6gAQ = parcelRequire("j6gAQ");


var $1Rned = parcelRequire("1Rned");

/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */ function $da79ae2b1521df52$var$uniqBy(array, iteratee) {
    return array && array.length ? $1Rned(array, $j6gAQ(iteratee, 2)) : [];
}
module.exports = $da79ae2b1521df52$var$uniqBy;

});

parcelRegister("1Rned", function(module, exports) {

var $dLza3 = parcelRequire("dLza3");


var $gqaVn = parcelRequire("gqaVn");


var $3wyDU = parcelRequire("3wyDU");


var $jG16D = parcelRequire("jG16D");


var $4sYWJ = parcelRequire("4sYWJ");


var $j8WYy = parcelRequire("j8WYy");

/** Used as the size to enable large array optimizations. */ var $15acc2503c30cdc7$var$LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */ function $15acc2503c30cdc7$var$baseUniq(array, iteratee, comparator) {
    var index = -1, includes = $gqaVn, length = array.length, isCommon = true, result = [], seen = result;
    if (comparator) {
        isCommon = false;
        includes = $3wyDU;
    } else if (length >= $15acc2503c30cdc7$var$LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : $4sYWJ(array);
        if (set) return $j8WYy(set);
        isCommon = false;
        includes = $jG16D;
        seen = new $dLza3;
    } else seen = iteratee ? [] : result;
    outer: while(++index < length){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var seenIndex = seen.length;
            while(seenIndex--){
                if (seen[seenIndex] === computed) continue outer;
            }
            if (iteratee) seen.push(computed);
            result.push(value);
        } else if (!includes(seen, computed, comparator)) {
            if (seen !== result) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
module.exports = $15acc2503c30cdc7$var$baseUniq;

});

parcelRegister("gqaVn", function(module, exports) {

var $62lK8 = parcelRequire("62lK8");

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $bf478c6b28a93eba$var$arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && $62lK8(array, value, 0) > -1;
}
module.exports = $bf478c6b28a93eba$var$arrayIncludes;

});

parcelRegister("62lK8", function(module, exports) {

var $7jN2X = parcelRequire("7jN2X");


var $4Jcz7 = parcelRequire("4Jcz7");


var $jMyMb = parcelRequire("jMyMb");

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $4653cbb84a510850$var$baseIndexOf(array, value, fromIndex) {
    return value === value ? $jMyMb(array, value, fromIndex) : $7jN2X(array, $4Jcz7, fromIndex);
}
module.exports = $4653cbb84a510850$var$baseIndexOf;

});

parcelRegister("7jN2X", function(module, exports) {
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $55405a69ad8b093d$var$baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
module.exports = $55405a69ad8b093d$var$baseFindIndex;

});

parcelRegister("4Jcz7", function(module, exports) {
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */ function $37151c9a2b945fe4$var$baseIsNaN(value) {
    return value !== value;
}
module.exports = $37151c9a2b945fe4$var$baseIsNaN;

});

parcelRegister("jMyMb", function(module, exports) {
/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $e66d79db7455d8ea$var$strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (array[index] === value) return index;
    }
    return -1;
}
module.exports = $e66d79db7455d8ea$var$strictIndexOf;

});

parcelRegister("3wyDU", function(module, exports) {
/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $290f3b94ccd981c7$var$arrayIncludesWith(array, value, comparator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (comparator(value, array[index])) return true;
    }
    return false;
}
module.exports = $290f3b94ccd981c7$var$arrayIncludesWith;

});

parcelRegister("4sYWJ", function(module, exports) {

var $lE8ES = parcelRequire("lE8ES");


var $jEK83 = parcelRequire("jEK83");


var $j8WYy = parcelRequire("j8WYy");

/** Used as references for various `Number` constants. */ var $34090d9ff4ab3dd6$var$INFINITY = 1 / 0;
/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */ var $34090d9ff4ab3dd6$var$createSet = !($lE8ES && 1 / $j8WYy(new $lE8ES([
    ,
    -0
]))[1] == $34090d9ff4ab3dd6$var$INFINITY) ? $jEK83 : function(values) {
    return new $lE8ES(values);
};
module.exports = $34090d9ff4ab3dd6$var$createSet;

});

parcelRegister("jEK83", function(module, exports) {
/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */ function $e4f588fe3a77f67d$var$noop() {
// No operation performed.
}
module.exports = $e4f588fe3a77f67d$var$noop;

});

parcelRegister("lPEt0", function(module, exports) {
!function(g, c) {
    c(module.exports);
}(module.exports, function(g) {
    const c = Symbol("newer"), e = Symbol("older");
    class n {
        _markEntryAsUsed(a) {
            if (a === this.newest) return;
            a[c] && (a === this.oldest && (this.oldest = a[c]), a[c][e] = a[e]), a[e] && (a[e][c] = a[c]), a[c] = void 0, a[e] = this.newest, this.newest && (this.newest[c] = a), this.newest = a;
        }
        assign(a) {
            let b, d = this.limit || Number.MAX_VALUE;
            this._keymap.clear();
            let m = a[Symbol.iterator]();
            for(let h = m.next(); !h.done; h = m.next()){
                let f = new l(h.value[0], h.value[1]);
                this._keymap.set(f.key, f), b ? (b[c] = f, f[e] = b) : this.oldest = f, b = f;
                if (d-- == 0) throw new Error("overflow");
            }
            this.newest = b, this.size = this._keymap.size;
        }
        get(a) {
            var b = this._keymap.get(a);
            return b ? (this._markEntryAsUsed(b), b.value) : void 0;
        }
        set(a, b) {
            var d = this._keymap.get(a);
            return d ? (d.value = b, this._markEntryAsUsed(d), this) : (this._keymap.set(a, d = new l(a, b)), this.newest ? (this.newest[c] = d, d[e] = this.newest) : this.oldest = d, this.newest = d, ++this.size, this.size > this.limit && this.shift(), this);
        }
        shift() {
            var a = this.oldest;
            if (a) return this.oldest[c] ? (this.oldest = this.oldest[c], this.oldest[e] = void 0) : (this.oldest = void 0, this.newest = void 0), a[c] = a[e] = void 0, this._keymap.delete(a.key), --this.size, [
                a.key,
                a.value
            ];
        }
        find(a) {
            let b = this._keymap.get(a);
            return b ? b.value : void 0;
        }
        has(a) {
            return this._keymap.has(a);
        }
        delete(a) {
            var b = this._keymap.get(a);
            return b ? (this._keymap.delete(b.key), b[c] && b[e] ? (b[e][c] = b[c], b[c][e] = b[e]) : b[c] ? (b[c][e] = void 0, this.oldest = b[c]) : b[e] ? (b[e][c] = void 0, this.newest = b[e]) : this.oldest = this.newest = void 0, this.size--, b.value) : void 0;
        }
        clear() {
            this.oldest = this.newest = void 0, this.size = 0, this._keymap.clear();
        }
        keys() {
            return new j(this.oldest);
        }
        values() {
            return new k(this.oldest);
        }
        entries() {
            return this;
        }
        [Symbol.iterator]() {
            return new i(this.oldest);
        }
        forEach(a, b) {
            typeof b !== "object" && (b = this);
            let d = this.oldest;
            for(; d;)a.call(b, d.value, d.key, this), d = d[c];
        }
        toJSON() {
            for(var a = new Array(this.size), b = 0, d = this.oldest; d;)a[b++] = {
                key: d.key,
                value: d.value
            }, d = d[c];
            return a;
        }
        toString() {
            for(var a = "", b = this.oldest; b;)a += String(b.key) + ":" + b.value, b = b[c], b && (a += " < ");
            return a;
        }
        constructor(a, b){
            typeof a !== "number" && (b = a, a = 0), this.size = 0, this.limit = a, this.oldest = this.newest = void 0, this._keymap = new Map(), b && (this.assign(b), a < 1 && (this.limit = this.size));
        }
    }
    g.LRUMap = n;
    function l(a, b) {
        this.key = a, this.value = b, this[c] = void 0, this[e] = void 0;
    }
    function i(a) {
        this.entry = a;
    }
    i.prototype[Symbol.iterator] = function() {
        return this;
    }, i.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: [
                a.key,
                a.value
            ]
        }) : {
            done: !0,
            value: void 0
        };
    };
    function j(a) {
        this.entry = a;
    }
    j.prototype[Symbol.iterator] = function() {
        return this;
    }, j.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: a.key
        }) : {
            done: !0,
            value: void 0
        };
    };
    function k(a) {
        this.entry = a;
    }
    k.prototype[Symbol.iterator] = function() {
        return this;
    }, k.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: a.value
        }) : {
            done: !0,
            value: void 0
        };
    };
}); //# sourceMappingURL=lru.js.map

});

parcelRegister("axuex", function(module, exports) {
'use strict';
class $7ac4702e317338af$var$AbortError extends Error {
    constructor(){
        super('Throttled function aborted');
        this.name = 'AbortError';
    }
}
const $7ac4702e317338af$var$pThrottle = ({ limit: limit, interval: interval, strict: strict })=>{
    if (!Number.isFinite(limit)) throw new TypeError('Expected `limit` to be a finite number');
    if (!Number.isFinite(interval)) throw new TypeError('Expected `interval` to be a finite number');
    const queue = new Map();
    let currentTick = 0;
    let activeCount = 0;
    function windowedDelay() {
        const now = Date.now();
        if (now - currentTick > interval) {
            activeCount = 1;
            currentTick = now;
            return 0;
        }
        if (activeCount < limit) activeCount++;
        else {
            currentTick += interval;
            activeCount = 1;
        }
        return currentTick - now;
    }
    const strictTicks = [];
    function strictDelay() {
        const now = Date.now();
        if (strictTicks.length < limit) {
            strictTicks.push(now);
            return 0;
        }
        const earliestTime = strictTicks.shift() + interval;
        if (now >= earliestTime) {
            strictTicks.push(now);
            return 0;
        }
        strictTicks.push(earliestTime);
        return earliestTime - now;
    }
    const getDelay = strict ? strictDelay : windowedDelay;
    return (function_)=>{
        const throttled = function(...args) {
            if (!throttled.isEnabled) return (async ()=>function_.apply(this, args))();
            let timeout;
            return new Promise((resolve, reject)=>{
                const execute = ()=>{
                    resolve(function_.apply(this, args));
                    queue.delete(timeout);
                };
                timeout = setTimeout(execute, getDelay());
                queue.set(timeout, reject);
            });
        };
        throttled.abort = ()=>{
            for (const timeout of queue.keys()){
                clearTimeout(timeout);
                queue.get(timeout)(new $7ac4702e317338af$var$AbortError());
            }
            queue.clear();
            strictTicks.splice(0, strictTicks.length);
        };
        throttled.isEnabled = true;
        return throttled;
    };
};
module.exports = $7ac4702e317338af$var$pThrottle;
module.exports.AbortError = $7ac4702e317338af$var$AbortError;

});

parcelRegister("j39Hd", function(module, exports) {

var $2g31M = parcelRequire("2g31M");

const $53f448a1a60c9e76$var$ALLOWED_RESPONSE_STATUS_CODES = [
    200,
    401,
    404
];
async function $53f448a1a60c9e76$export$b5fe3f66a567bec0(method, url, data, headers, statuses = $53f448a1a60c9e76$var$ALLOWED_RESPONSE_STATUS_CODES) {
    const requestConfig = {
        method: method,
        credentials: 'include',
        headers: {
            Accept: 'application/json',
            'Cache-Control': 'no-cache',
            'Content-Type': 'application/json',
            ...headers
        },
        ...data ? {
            body: JSON.stringify(data)
        } : {}
    };
    try {
        const response = await fetch(url, requestConfig);
        if (response.ok || statuses?.includes(response.status)) {
            if (statuses.includes(204)) {
                const text = await response.text();
                // @ts-ignore - TS2322 TypeScript 5.9.2 upgrade
                return text ? JSON.parse(text) : undefined;
            } else return await response.json();
        }
        throw response;
    } catch (error) {
        if (typeof error === 'string' || error instanceof TypeError) throw new (0, $2g31M.NetworkError)(error);
        throw error;
    }
}
module.exports["request"] = $53f448a1a60c9e76$export$b5fe3f66a567bec0;

});

parcelRegister("2g31M", function(module, exports) {
class $70283a430bb4f4fe$export$bae979e68e4dc802 extends Error {
    constructor(error){
        super(error);
    }
}
module.exports["NetworkError"] = $70283a430bb4f4fe$export$bae979e68e4dc802;

});

parcelRegister("ixC10", function(module, exports) {
class $5661a24319617f8d$export$3e5b797e39668f84 extends Error {
    constructor(kind, hostname, message, type, extensionKey){
        super(`${kind}: ${message}`), this.kind = kind, this.hostname = hostname, this.message = message, this.type = type, this.extensionKey = extensionKey;
        this.name = 'APIError';
        // The error type received from the server.
        this.type = type;
        // The kind mapped to on the client.
        this.kind = kind;
        // The message received from the server.
        this.message = message;
        // The hostname of the URL which failed - do NOT log this (contains PII/UGC).
        this.hostname = hostname;
        // The extensionKey passed from the error response from ORS
        this.extensionKey = extensionKey;
    }
}
module.exports["APIError"] = $5661a24319617f8d$export$3e5b797e39668f84;

});

parcelRegister("cXJjm", function(module, exports) {

var $kzwaO = parcelRequire("kzwaO");

const $aee62c7b870e0d6a$export$dc37652c1696f231 = (envKey, baseUrlOverride)=>{
    // The `custom` environment is used if the full resolver URL is provided by the user.
    // It could be useful for SSR, where `CardClient` should use direct service URL instead of the Edge Proxy.
    if (envKey === 'custom') return baseUrlOverride ?? '/gateway/api/object-resolver';
    // If an environment is provided, then use Stargate directly for requests.
    if (envKey || baseUrlOverride) {
        const baseUrl = baseUrlOverride || (0, $kzwaO.getBaseUrl)(envKey);
        return `${baseUrl}/object-resolver`;
    } else // Otherwise, we fallback to using the Edge Proxy to access Stargate,
    // which fixes some cookie issues with strict Browser policies.
    return '/gateway/api/object-resolver';
};
module.exports["getResolverUrl"] = $aee62c7b870e0d6a$export$dc37652c1696f231;

});

parcelRegister("kzwaO", function(module, exports) {

var $4B79C = parcelRequire("4B79C");

const $445f8294ba7508fe$export$f654b28f82155665 = (envKey, baseUrlOverride)=>{
    // The `custom` environment is used if the full resolver URL is provided by the user.
    // It could be useful for SSR, where `CardClient` should use direct service URL instead of the Edge Proxy.
    if (envKey === 'custom') return baseUrlOverride ?? (0, $4B79C.prodBaseUrl);
    // If an environment is provided, then use Stargate.
    if (envKey) return envKey in (0, $4B79C.BaseUrls) ? (0, $4B79C.BaseUrls)[envKey] : (0, $4B79C.prodBaseUrl);
    return typeof window !== 'undefined' && typeof window.location !== 'undefined' ? window.location.origin : '';
};
module.exports["getBaseUrl"] = $445f8294ba7508fe$export$f654b28f82155665;

});

parcelRegister("4B79C", function(module, exports) {
const $ef9de7657ea9d2d2$var$devBaseUrl = 'https://api-private.dev.atlassian.com';
const $ef9de7657ea9d2d2$var$stgBaseUrl = 'https://pug.jira-dev.com/gateway/api';
const $ef9de7657ea9d2d2$export$7469f9cd9cda802c = 'https://api-private.atlassian.com';
const $ef9de7657ea9d2d2$export$e2b040f052407032 = {
    dev: $ef9de7657ea9d2d2$var$devBaseUrl,
    development: $ef9de7657ea9d2d2$var$devBaseUrl,
    stg: $ef9de7657ea9d2d2$var$stgBaseUrl,
    staging: $ef9de7657ea9d2d2$var$stgBaseUrl,
    prd: $ef9de7657ea9d2d2$export$7469f9cd9cda802c,
    prod: $ef9de7657ea9d2d2$export$7469f9cd9cda802c,
    production: $ef9de7657ea9d2d2$export$7469f9cd9cda802c
};
var $ef9de7657ea9d2d2$export$2e2bcd8739ae039 = $ef9de7657ea9d2d2$export$e2b040f052407032;
module.exports["prodBaseUrl"] = $ef9de7657ea9d2d2$export$7469f9cd9cda802c;
module.exports["BaseUrls"] = $ef9de7657ea9d2d2$export$e2b040f052407032;

});

parcelRegister("grief", function(module, exports) {
class $8165f67089b396cb$export$19fa02dd69bd4efd extends Error {
    constructor(error){
        super(error);
        this.name = 'InvalidUrlError';
    }
}
module.exports["InvalidUrlError"] = $8165f67089b396cb$export$19fa02dd69bd4efd;

});

parcelRegister("ggGdk", function(module, exports) {
const $b75c372cb2906748$var$getStatusForNotFoundVisibility = (meta)=>{
    const accessType = meta.requestAccess?.accessType;
    if (!accessType || accessType === 'ACCESS_EXISTS') return 'not_found';
    // for the rest of the accessTypes we will return forbidden,see https://product-fabric.atlassian.net/browse/EDM-7125
    return 'forbidden';
};
const $b75c372cb2906748$export$b70265791d2079d4 = ({ meta: meta })=>{
    const { access: access, visibility: visibility } = meta;
    switch(access){
        case 'forbidden':
            if (visibility === 'not_found') return $b75c372cb2906748$var$getStatusForNotFoundVisibility(meta);
            else return 'forbidden';
        case 'unauthorized':
            return 'unauthorized';
        default:
            return 'resolved';
    }
};
module.exports["getStatus"] = $b75c372cb2906748$export$b70265791d2079d4;

});

parcelRegister("c2kDy", function(module, exports) {
const $3cbc4520680d3a92$export$bea7bee8a87e7c52 = (response)=>{
    if (!response) return false;
    const hasStatus = 'status' in response && response.status >= 200;
    const hasErrorBody = 'error' in response;
    return hasStatus && hasErrorBody;
};
module.exports["isErrorResponse"] = $3cbc4520680d3a92$export$bea7bee8a87e7c52;

});

parcelRegister("44Sj0", function(module, exports) {
const $d86f0936ed92dc7f$export$1b59fe731a28a49d = (response)=>{
    if (!response) return false;
    const hasSuccessfulStatus = response.status === 200;
    const hasSuccessBody = 'body' in response;
    return hasSuccessfulStatus && hasSuccessBody;
};
module.exports["isSuccessfulResponse"] = $d86f0936ed92dc7f$export$1b59fe731a28a49d;

});

parcelRegister("1Zrg0", function(module, exports) {

var $dBzLE = parcelRequire("dBzLE");


var $dOBRD = parcelRequire("dOBRD");


var $eqEJl = parcelRequire("eqEJl");


var $2yWJZ = parcelRequire("2yWJZ");


var $dYU3e = parcelRequire("dYU3e");

const $b6ab6e265c8724de$var$RovoChatIdentityQuery = (0, $dBzLE.default);
// Keep only the last site's query metadata; identity data is always read from Relay.
const $b6ab6e265c8724de$var$getRovoChatIdentityOperation = (0, $dOBRD.default)((cloudId)=>(0, $eqEJl.createOperationDescriptor)((0, $eqEJl.getRequest)($b6ab6e265c8724de$var$RovoChatIdentityQuery), {
        cloudId: cloudId
    }));
const $b6ab6e265c8724de$export$cc5edb705a841b0b = async (cloudId)=>{
    const { data: data, errors: errors, hasErrors: hasErrors } = await (0, $dYU3e.queryAgg)({
        query: $b6ab6e265c8724de$var$RovoChatIdentityQuery,
        variables: {
            cloudId: cloudId
        },
        __callerPackage__: "fabric-media-support"
    });
    if (hasErrors) throw new Error('Failed to query Rovo mention identity', {
        cause: errors?.[0]
    });
    return $b6ab6e265c8724de$var$getRovoChatIdentity(data);
};
function $b6ab6e265c8724de$export$5df545c617ca8745(cloudId) {
    const environment = window.GLOBAL_RELAY_ENV;
    if (!environment) return undefined;
    const operation = $b6ab6e265c8724de$var$getRovoChatIdentityOperation(cloudId);
    const snapshot = environment.lookup(operation.fragment);
    const data = snapshot.isMissingData ? undefined : snapshot.data;
    // A failed lookup can cache a null connection; allow the async provider to retry it.
    return data?.agentStudio_getAgents ? $b6ab6e265c8724de$var$getRovoChatIdentity(data) ?? null : undefined;
}
function $b6ab6e265c8724de$var$getRovoChatIdentity(data) {
    return (0, $2yWJZ.normalizeAccountIdFromIdentityAri)(data?.agentStudio_getAgents?.edges?.[0]?.node?.identityAccountId);
}
module.exports["preloadRovoChatIdentity"] = $b6ab6e265c8724de$export$cc5edb705a841b0b;
module.exports["getRovoChatIdentityFromCache"] = $b6ab6e265c8724de$export$5df545c617ca8745;

});

parcelRegister("dBzLE", function(module, exports) {
/**
 * @generated SignedSource<<a7622c1da45247209d0d6a1b7cf91fe9>>
 * @relayHash 16c28e15764b9c1298d2d78d263a34de
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b1269fc385be5b93d5eea3490491c5319876d470c3d1f7f0003aa815299e3775
const $0b5c8035d15f5bd2$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Literal",
            "name": "first",
            "value": 1
        },
        {
            "kind": "Literal",
            "name": "input",
            "value": {
                "creatorTypes": [
                    "ROVO_CHAT"
                ]
            }
        },
        {
            "kind": "Literal",
            "name": "product",
            "value": "confluence"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "identityAccountId"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "preloadRovoChatIdentityQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "AgentStudioAgentsConnection",
                    "kind": "LinkedField",
                    "name": "agentStudio_getAgents",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "AgentStudioAgentEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "AgentStudioAssistant",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        v2 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "preloadRovoChatIdentityQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "AgentStudioAgentsConnection",
                    "kind": "LinkedField",
                    "name": "agentStudio_getAgents",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "AgentStudioAgentEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "AgentStudioAssistant",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "16c28e15764b9c1298d2d78d263a34de",
            "id": "b1269fc385be5b93d5eea3490491c5319876d470c3d1f7f0003aa815299e3775",
            "metadata": {},
            "name": "preloadRovoChatIdentityQuery",
            "operationKind": "query",
            "text": "query preloadRovoChatIdentityQuery($cloudId:String!){agentStudio_getAgents(cloudId:$cloudId,product:\"confluence\",first:1,input:{creatorTypes:[ROVO_CHAT]})@optIn(to:\"AgentStudio\"){edges{node{identityAccountId,id}}}}"
        }
    };
}();
$0b5c8035d15f5bd2$var$node.hash = "f13db943ec532a3a8f90ce36c4510c88";
var $0b5c8035d15f5bd2$export$2e2bcd8739ae039 = $0b5c8035d15f5bd2$var$node;
module.exports["default"] = $0b5c8035d15f5bd2$export$2e2bcd8739ae039;

});

parcelRegister("aR3ec", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $iDrrr = parcelRequire("iDrrr");


var $IQ4Dz = parcelRequire("IQ4Dz");

const $1f4e40c711db0c72$var$styles = {
    root: "_3iDTPbvbI6",
    TEMP_assets: "_0C0F9q1qiM"
}; /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ 
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ const $1f4e40c711db0c72$var$cloudLightAppearanceMap = {
    brand: "_36J4jyyL8i _0C0F9qyL8i",
    neutral: "_36J4jyBRVV _0C0F9q1qiM",
    inverse: "_36J4jyCl79 _0C0F9qt28M",
    legacy: "_36J4jyt28M _0C0F9q2bHZ"
}; /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ 
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ const $1f4e40c711db0c72$var$cloudDarkAppearanceMap = {
    brand: "_36J4jyyL8i _0C0F9qyL8i",
    neutral: "_36J4jynrF4 _0C0F9qMlgR",
    inverse: "_36J4jyt28M _0C0F9qCl79",
    legacy: "_36J4jyt28M _0C0F9q2bHZ"
}; /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ 
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ const $1f4e40c711db0c72$var$dataCenterLightAppearanceMap = {
    brand: "_36J4jy2bHZ _0C0F9qt28M _0g0wFM1qiM",
    neutral: "_36J4jyBRVV _0C0F9q1qiM _0g0wFMBRVV",
    inverse: "_36J4jyt28M _0C0F9qRvDB _0g0wFMt28M",
    legacy: "_36J4jy2bHZ _0C0F9qt28M _0g0wFM1qiM"
}; /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ 
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ const $1f4e40c711db0c72$var$dataCenterDarkAppearanceMap = {
    brand: "_36J4jy2bHZ _0C0F9qRvDB _0g0wFMMlgR",
    neutral: "_36J4jynrF4 _0C0F9qMlgR _0g0wFMnrF4",
    inverse: "_36J4jyMmzW _0C0F9qt28M _0g0wFMMmzW",
    legacy: "_36J4jy2bHZ _0C0F9qRvDB _0g0wFMMlgR"
};
const $1f4e40c711db0c72$var$rovoDarkAppearanceMap = {
    brand: "_2PY8Z6yL8i _05MzPYyL8i _0Yajk0yL8i _40KAGSyL8i",
    neutral: "_2PY8Z6nrF4 _05MzPYnrF4 _0Yajk0nrF4 _40KAGSnrF4",
    inverse: "_2PY8Z6RvDB _05MzPYRvDB _0Yajk0RvDB _40KAGSRvDB",
    legacy: "_2PY8Z62bHZ _05MzPY2bHZ _0Yajk02bHZ _40KAGS2bHZ"
};
const $1f4e40c711db0c72$var$rovoLightAppearanceMap = {
    brand: "_2PY8Z6yL8i _05MzPYyL8i _0Yajk0yL8i _40KAGSyL8i",
    neutral: "_2PY8Z6BRVV _05MzPYBRVV _0Yajk0BRVV _40KAGSBRVV",
    inverse: "_2PY8Z6t28M _05MzPYt28M _0Yajk0t28M _40KAGSt28M",
    legacy: "_2PY8Z62bHZ _05MzPY2bHZ _0Yajk02bHZ _40KAGS2bHZ"
}; /* eslint-enable @atlaskit/ui-styling-standard/no-imported-style-values */ 
/* eslint-enable @atlaskit/ui-styling-standard/no-unsafe-values */ const $1f4e40c711db0c72$var$sizeMap = {
    xxsmall: "_0jFU0Vey7F",
    xsmall: "_0jFU0VSPN1",
    small: "_0jFU0VoWWg",
    medium: "_0jFU0VUofl",
    large: "_0jFU0VUF4f",
    xlarge: "_0jFU0VpJKa",
    '12': "_0jFU0VxpxF",
    '16': "_0jFU0Vey7F",
    '20': "_0jFU0VSPN1",
    '24': "_0jFU0VoWWg",
    '32': "_0jFU0VUofl"
};
const $1f4e40c711db0c72$export$be58b4326e23250f = (0, $gtMdU.isReactCompilerActivePlatform)() ? function IconWrapper(t0) {
    const $ = (0, $bDgLe.c)(18);
    const { size: t1, label: label, svg: svg, customThemeSvg: customThemeSvg, testId: userDefinedTestId, appearance: t2, iconColor: customIconColor, isAssets: t3, type: t4 } = t0;
    const size = t1 === undefined ? "20" : t1;
    const appearance = t2 === undefined ? "brand" : t2;
    const isAssets = t3 === undefined ? false : t3;
    const type = t4 === undefined ? "tile" : t4;
    const testId = userDefinedTestId && `${userDefinedTestId}--wrapper`;
    const isCustomThemed = customThemeSvg && customIconColor;
    const { colorMode: colorMode } = (0, $IQ4Dz.useThemeObserver)();
    const t5 = customIconColor || "initial";
    let t6;
    if ($[0] !== t5) {
        t6 = {
            "--themed-icon-color": t5
        };
        $[0] = t5;
        $[1] = t6;
    } else t6 = $[1];
    const t7 = t6;
    const t8 = label ? label : undefined;
    const t9 = label ? "img" : undefined;
    const t10 = label === "" ? true : undefined;
    const t11 = isCustomThemed ? customThemeSvg : svg;
    let t12;
    if ($[2] !== t11) {
        t12 = {
            __html: t11
        };
        $[2] = t11;
        $[3] = t12;
    } else t12 = $[3];
    const t13 = $1f4e40c711db0c72$var$sizeMap[size];
    const t14 = colorMode === "dark" ? $1f4e40c711db0c72$var$dataCenterDarkAppearanceMap[appearance] : $1f4e40c711db0c72$var$dataCenterLightAppearanceMap[appearance];
    const t15 = type === "rovo" ? colorMode === "dark" ? $1f4e40c711db0c72$var$rovoDarkAppearanceMap[appearance] : $1f4e40c711db0c72$var$rovoLightAppearanceMap[appearance] : colorMode === "dark" ? $1f4e40c711db0c72$var$cloudDarkAppearanceMap[appearance] : $1f4e40c711db0c72$var$cloudLightAppearanceMap[appearance];
    let t16;
    if ($[4] !== appearance || $[5] !== isAssets || $[6] !== t13 || $[7] !== t14 || $[8] !== t15) {
        t16 = (0, $hekY6.default)([
            $1f4e40c711db0c72$var$styles.root,
            t13,
            t14,
            t15,
            isAssets && appearance === "brand" && ((0, $iDrrr.fg)("assets-platform-branding") || (0, $iDrrr.fg)("assets-platform-branding-v2")) && $1f4e40c711db0c72$var$styles.TEMP_assets
        ]);
        $[4] = appearance;
        $[5] = isAssets;
        $[6] = t13;
        $[7] = t14;
        $[8] = t15;
        $[9] = t16;
    } else t16 = $[9];
    let t17;
    if ($[10] !== t10 || $[11] !== t12 || $[12] !== t16 || $[13] !== t7 || $[14] !== t8 || $[15] !== t9 || $[16] !== testId) {
        t17 = /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            "data-testid": testId,
            style: t7,
            "aria-label": t8,
            role: t9,
            "aria-hidden": t10,
            dangerouslySetInnerHTML: t12,
            className: t16
        });
        $[10] = t10;
        $[11] = t12;
        $[12] = t16;
        $[13] = t7;
        $[14] = t8;
        $[15] = t9;
        $[16] = testId;
        $[17] = t17;
    } else t17 = $[17];
    return t17;
} : function IconWrapper({ size: size = '20', label: label, svg: svg, customThemeSvg: customThemeSvg, testId: userDefinedTestId, appearance: appearance = 'brand', iconColor: customIconColor, isAssets: isAssets = false, type: type = 'tile' }) {
    const testId = userDefinedTestId && `${userDefinedTestId}--wrapper`;
    const isCustomThemed = customThemeSvg && customIconColor;
    const { colorMode: colorMode } = (0, $IQ4Dz.useThemeObserver)();
    return /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
        "data-testid": testId,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            '--themed-icon-color': customIconColor || 'initial'
        },
        "aria-label": label ? label : undefined,
        role: label ? 'img' : undefined,
        "aria-hidden": label === '' ? true : undefined,
        // This is because the SVG elements are static and will not change, so we get a little performance benefit by
        // bypassing React.
        dangerouslySetInnerHTML: {
            __html: isCustomThemed ? customThemeSvg : svg
        },
        className: (0, $hekY6.default)([
            $1f4e40c711db0c72$var$styles.root,
            $1f4e40c711db0c72$var$sizeMap[size],
            colorMode === 'dark' ? $1f4e40c711db0c72$var$dataCenterDarkAppearanceMap[appearance] : $1f4e40c711db0c72$var$dataCenterLightAppearanceMap[appearance],
            type === 'rovo' ? colorMode === 'dark' ? $1f4e40c711db0c72$var$rovoDarkAppearanceMap[appearance] : $1f4e40c711db0c72$var$rovoLightAppearanceMap[appearance] : colorMode === 'dark' ? $1f4e40c711db0c72$var$cloudDarkAppearanceMap[appearance] : $1f4e40c711db0c72$var$cloudLightAppearanceMap[appearance],
            isAssets && appearance === 'brand' && ((0, $iDrrr.fg)('assets-platform-branding') || (0, $iDrrr.fg)('assets-platform-branding-v2')) && $1f4e40c711db0c72$var$styles.TEMP_assets
        ])
    });
};
module.exports["IconWrapper"] = $1f4e40c711db0c72$export$be58b4326e23250f;

});

parcelRegister("etoPX", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $aR3ec = parcelRequire("aR3ec");

// `height` is set to 100% to allow the SVG to scale with the parent element
const $63a5cd591bbe1860$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--rovo-blue-color, #1868db)" fill-rule="evenodd" d="m13.227 16.789-7.154 4.169-3.403-1.96a2.72 2.72 0 0 1-1.362-2.355V7.366c0-.973.518-1.87 1.361-2.354l6.044-3.487-.038.114a3.6 3.6 0 0 0-.172 1.088v9.278c0 1.274.68 2.45 1.786 3.085z" clip-rule="evenodd"/>
    <path fill="var(--rovo-green-color, #6a9a23)" fill-rule="evenodd" d="m11.296 15.671-7.193 4.153 6.607 3.812a2.73 2.73 0 0 0 2.676.026l.048-.033a2.73 2.73 0 0 0 1.232-1.525 2.7 2.7 0 0 0 .127-.822v-3.594z" clip-rule="evenodd"/>
    <path fill="var(--rovo-purple-color, #af59e1)" fill-rule="evenodd" d="m21.477 5.003-4.404-2.539-5.904 4.89 2.69 1.556a3.56 3.56 0 0 1 1.785 3.086v9.277a3.6 3.6 0 0 1-.21 1.202l6.044-3.486a2.71 2.71 0 0 0 1.362-2.355V7.357c0-.97-.521-1.87-1.363-2.354" clip-rule="evenodd"/>
    <path fill="var(--rovo-yellow-color, #fca700)" fill-rule="evenodd" d="M12.74 8.266 9.353 6.312V2.718c0-.283.044-.56.127-.821A2.73 2.73 0 0 1 10.71.372V.37a.4.4 0 0 0 .048-.033 2.73 2.73 0 0 1 2.676.026l6.499 3.75z" clip-rule="evenodd"/>
</svg>
`;
const $63a5cd591bbe1860$export$e23ae35269442b4f = (0, $gtMdU.isReactCompilerActivePlatform)() ? function RovoIcon(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { size: t1, appearance: t2, label: t3, testId: testId } = t0;
    const size = t1 === undefined ? "medium" : t1;
    const appearance = t2 === undefined ? "brand" : t2;
    const label = t3 === undefined ? "Rovo" : t3;
    let t4;
    if ($[0] !== appearance || $[1] !== label || $[2] !== size || $[3] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aR3ec.IconWrapper), {
            svg: $63a5cd591bbe1860$var$svg,
            label: label,
            type: "rovo",
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = label;
        $[2] = size;
        $[3] = testId;
        $[4] = t4;
    } else t4 = $[4];
    return t4;
} : function RovoIcon({ size: size = 'medium', appearance: appearance = 'brand', label: label = 'Rovo', testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aR3ec.IconWrapper), {
        svg: $63a5cd591bbe1860$var$svg,
        label: label,
        type: "rovo",
        appearance: appearance,
        size: size,
        testId: testId
    });
};
module.exports["RovoIcon"] = $63a5cd591bbe1860$export$e23ae35269442b4f;

});

parcelRegister("rECdA", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $8m50u = parcelRequire("8m50u");

const $71deccf66348f07d$export$cf56d0f54cfcce4 = (featureFlagName, ComponentTrue, ComponentFalse)=>(0, $8m50u.componentWithCondition)(()=>(0, $iDrrr.fg)(featureFlagName), ComponentTrue, ComponentFalse);
module.exports["componentWithFG"] = $71deccf66348f07d$export$cf56d0f54cfcce4;

});

parcelRegister("dDboE", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $6JrSr = parcelRequire("6JrSr");

const $92e077c22efcc597$export$6be90bcb437e928f = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ children: children, postfix: postfix = '', prefix: prefix = '' }, ref)=>{
    const id = `${prefix}${(0, $6JrSr.useId)()}${postfix}`;
    (0, $cozmU.useEffect)(()=>{
        if (!ref) return;
        switch(typeof ref){
            case 'function':
                ref(id);
                break;
            case 'object':
                ref.current = id;
                break;
            default:
                throw new Error(`Unreachable case for unsupported type of ref "${typeof ref}"`);
        }
    }, [
        id,
        ref
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
        children: typeof children === 'function' ? children({
            id: id
        }) : children
    });
});
module.exports["IdProvider"] = $92e077c22efcc597$export$6be90bcb437e928f;

});

parcelRegister("1TlML", function(module, exports) {
function $cc70dd2ba0f00d0d$export$e618dc39ac9ad607(source, target = {}) {
    // initialize with source styles
    const styles = {
        ...source
    };
    // massage in target styles
    Object.keys(target).forEach((keyAsString)=>{
        const key = keyAsString;
        if (source[key]) styles[key] = (rsCss, props)=>{
            return target[key](source[key](rsCss, props), props);
        };
        else styles[key] = target[key];
    });
    return styles;
}
module.exports["mergeStyles"] = $cc70dd2ba0f00d0d$export$e618dc39ac9ad607;

});

parcelRegister("nStJY", function(module, exports) {

var $gO7n9 = parcelRequire("gO7n9");


var $jPzTX = parcelRequire("jPzTX");

/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */ var $047c686ddfb588a6$var$pick = $jPzTX(function(object, paths) {
    return object == null ? {} : $gO7n9(object, paths);
});
module.exports = $047c686ddfb588a6$var$pick;

});

parcelRegister("gO7n9", function(module, exports) {

var $3Bix5 = parcelRequire("3Bix5");


var $h7loT = parcelRequire("h7loT");

/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */ function $c3c708e20cb40f59$var$basePick(object, paths) {
    return $3Bix5(object, paths, function(value, path) {
        return $h7loT(object, path);
    });
}
module.exports = $c3c708e20cb40f59$var$basePick;

});

parcelRegister("2SUNK", function(module, exports) {
$parcel$export(module.exports, "default", () => $1b516e3b9bd2f12c$export$2e2bcd8739ae039);
let $1b516e3b9bd2f12c$var$debugEnabled = false;
let $1b516e3b9bd2f12c$var$stacktracesEnabled = false;
function $1b516e3b9bd2f12c$export$748ada60eaf985cc(enable) {
    $1b516e3b9bd2f12c$var$debugEnabled = enable;
}
function $1b516e3b9bd2f12c$export$4f7017086af31c25(enable) {
    $1b516e3b9bd2f12c$var$stacktracesEnabled = enable;
}
function $1b516e3b9bd2f12c$export$2a858f450a2f66d() {
    if ($1b516e3b9bd2f12c$var$stacktracesEnabled) // eslint-disable-next-line no-console
    console.log(new Error().stack);
}
function $1b516e3b9bd2f12c$export$2e2bcd8739ae039(msg, ...args) {
    if ($1b516e3b9bd2f12c$var$debugEnabled) // eslint-disable-next-line no-console
    console.log(msg, ...args);
}

});

parcelRegister("lUcpS", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $k78uC = parcelRequire("k78uC");


var $8IfK6 = parcelRequire("8IfK6");

const $91b0a64470223be6$export$5bf35293e545f20c = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(4);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t0;
    if ($[0] !== createAnalyticsEvent) {
        t0 = (...t1)=>{
            const params = t1;
            const event = createAnalyticsEvent((0, $8IfK6.default)(...params));
            event.fire((0, $k78uC.EVENT_CHANNEL));
        };
        $[0] = createAnalyticsEvent;
        $[1] = t0;
    } else t0 = $[1];
    const fireEvent = t0;
    let t1;
    if ($[2] !== fireEvent) {
        t1 = {
            fireEvent: fireEvent
        };
        $[2] = fireEvent;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const fireEvent = (0, $cozmU.useCallback)((...params)=>{
        const event = createAnalyticsEvent((0, $8IfK6.default)(...params));
        event.fire((0, $k78uC.EVENT_CHANNEL));
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireEvent: fireEvent
    };
};
module.exports["useAnalyticsEvents"] = $91b0a64470223be6$export$5bf35293e545f20c;

});

parcelRegister("k78uC", function(module, exports) {
const $0de3cce3bcdfa361$export$3f072f06b90c3985 = 'peopleTeams';
module.exports["EVENT_CHANNEL"] = $0de3cce3bcdfa361$export$3f072f06b90c3985;

});

parcelRegister("8IfK6", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::378c0a04d2cca8641793d5a92fac3d1a>>
 * @codegenCommand afm workspace @atlassian/analytics-tooling analytics:codegen teams-app-internal-analytics
 */ const $fcb00cbaaafbad36$var$createEventPayload = (eventKey, ...[attributes])=>{
    const [eventType, actionSubject, action, actionSubjectId] = eventKey.split('.');
    if (eventType === 'screen') return {
        eventType: eventType,
        name: actionSubject,
        action: 'viewed',
        attributes: attributes
    };
    return {
        eventType: eventType,
        actionSubject: actionSubject,
        action: action,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    };
};
var $fcb00cbaaafbad36$export$2e2bcd8739ae039 = $fcb00cbaaafbad36$var$createEventPayload;
module.exports["default"] = $fcb00cbaaafbad36$export$2e2bcd8739ae039;

});

parcelRegister("cSSWJ", function(module, exports) {
const $e8b102093dcaac45$export$849551cf61929d4f = {
    packageName: "platform-pkg" ?? '',
    packageVersion: "0.0.0-use.local" ?? ''
};
const $e8b102093dcaac45$export$efd16d9cf43b6e97 = 'teamProfileCard';
const $e8b102093dcaac45$export$7611b3e6899481f9 = 'profilecard';
const $e8b102093dcaac45$export$4c23d6e68fa71371 = 'rovoAgentProfilecard';
module.exports["PACKAGE_META_DATA"] = $e8b102093dcaac45$export$849551cf61929d4f;
module.exports["TEAM_SUBJECT"] = $e8b102093dcaac45$export$efd16d9cf43b6e97;
module.exports["USER_SUBJECT"] = $e8b102093dcaac45$export$7611b3e6899481f9;
module.exports["AGENT_SUBJECT"] = $e8b102093dcaac45$export$4c23d6e68fa71371;

});

parcelRegister("4PAHv", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");


var $7G50J = parcelRequire("7G50J");


var $hMCZS = parcelRequire("hMCZS");


var $lUcpS = parcelRequire("lUcpS");


var $dSW04 = parcelRequire("dSW04");


var $dRAjC = parcelRequire("dRAjC");


var $4k5Wq = parcelRequire("4k5Wq");


var $kb2tZ = parcelRequire("kb2tZ");


var $hIwXM = parcelRequire("hIwXM");

const $fe1c8bc12e81e628$export$4b013ffffcb40af8 = (props)=>{
    const [agentData, setAgentData] = (0, $cozmU.useState)();
    const [isLoading, setIsLoading] = (0, $cozmU.useState)(true);
    const [error, setError] = (0, $cozmU.useState)();
    const [isPermitted, setIsPermitted] = (0, $cozmU.useState)(true);
    const { fireEvent: fireEvent } = (0, $lUcpS.useAnalyticsEvents)();
    const creatorUserId = (0, $cozmU.useMemo)(()=>agentData?.creator_type === 'CUSTOMER' && agentData.creator ? (0, $dRAjC.getAAIDFromARI)(agentData.creator) : '', [
        agentData?.creator_type,
        agentData?.creator
    ]);
    const navResult = (0, $hMCZS.navigateToTeamsApp)({
        type: 'USER',
        payload: {
            userId: creatorUserId || ''
        },
        cloudId: props.cloudId
    });
    let profileHref = navResult.href;
    const getCreator = (0, $cozmU.useCallback)(async ({ creator_type: creator_type, creator: creator, authoringTeam: authoringTeam })=>{
        try {
            let userCreatorInfo;
            const currentCreatorUserId = creator_type === 'CUSTOMER' && creator ? (0, $dRAjC.getAAIDFromARI)(creator) : undefined;
            if (currentCreatorUserId && props.cloudId) {
                userCreatorInfo = await props.resourceClient.getProfile(props.cloudId, currentCreatorUserId, fireEvent);
                profileHref = (0, $hMCZS.navigateToTeamsApp)({
                    type: 'USER',
                    payload: {
                        userId: currentCreatorUserId
                    },
                    cloudId: props.cloudId
                }).href;
            }
            const creatorInfo = (0, $7G50J.getAgentCreator)({
                creatorType: creator_type,
                authoringTeam: authoringTeam ? {
                    displayName: authoringTeam.displayName ?? '',
                    profileLink: authoringTeam.profileUrl ?? undefined
                } : undefined,
                userCreator: userCreatorInfo ? {
                    name: userCreatorInfo.fullName ?? '',
                    profileLink: (0, $iDrrr.fg)('platform-adopt-teams-nav-config') ? profileHref : `/people/${currentCreatorUserId}`
                } : undefined,
                forgeCreator: creator ?? undefined
            });
            return creatorInfo;
        } catch  {
            return undefined;
        }
    }, [
        fireEvent,
        props.cloudId,
        props.resourceClient,
        profileHref
    ]);
    const fetchData = (0, $cozmU.useCallback)(async ()=>{
        setIsLoading(true);
        try {
            const profileResult = await props.resourceClient.getRovoAgentProfile({
                type: 'identity',
                value: props.accountId
            }, fireEvent);
            const profileData = profileResult.restData;
            const creatorInfoProps = {
                creator_type: profileData?.creator_type,
                creator: profileData?.creator || undefined,
                authoringTeam: profileResult.aggData?.authoringTeam ?? undefined
            };
            const agentCreatorInfo = await getCreator(creatorInfoProps);
            setAgentData({
                ...profileData,
                creatorInfo: agentCreatorInfo
            });
        } catch (err) {
            if (err instanceof (0, $dSW04.AgentForbiddenError)) setIsPermitted(false);
            else setError(err);
        } finally{
            setIsLoading(false);
        }
    }, [
        fireEvent,
        getCreator,
        props.accountId,
        props.resourceClient
    ]);
    // Depend on accountId rather than fetchData to avoid a re-fetch loop:
    // agentData changes → creatorUserId → getCreator → fetchData ref changes → useEffect re-fires.
    // Reset state on accountId change so stale data from the previous agent isn't briefly shown.
    (0, $cozmU.useEffect)(()=>{
        setAgentData(undefined);
        setError(undefined);
        setIsLoading(true);
        fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        props.accountId
    ]);
    const forbiddenAgent = (0, $cozmU.useMemo)(()=>(0, $iDrrr.fg)('platform_editor_agent_mentions_drop_one_fixes') ? {
            id: '',
            named_id: '',
            name: props.agentName ?? '',
            description: '\u00A0',
            creator_type: 'CUSTOMER',
            is_default: false,
            actor_type: 'AGENT',
            user_defined_conversation_starters: null,
            favourite: false,
            favourite_count: 0,
            identity_account_id: props.accountId,
            creatorInfo: undefined
        } : undefined, [
        props.agentName,
        props.accountId
    ]);
    if (!isPermitted) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kb2tZ.AgentProfileCardWrapper), {
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cozmU.Suspense), {
            fallback: null,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $hIwXM.AgentProfileCardLazy), {
                agent: (0, $iDrrr.fg)('platform_editor_agent_mentions_drop_one_fixes') ? forbiddenAgent : {
                    id: '',
                    named_id: '',
                    name: props.agentName ?? '',
                    description: '\u00A0',
                    creator_type: 'CUSTOMER',
                    is_default: false,
                    actor_type: 'AGENT',
                    user_defined_conversation_starters: null,
                    favourite: false,
                    favourite_count: 0,
                    identity_account_id: props.accountId,
                    creatorInfo: undefined
                },
                isLoading: false,
                resourceClient: props.resourceClient,
                cloudId: props.cloudId,
                hideAgentActions: true,
                hideConversationStarters: true,
                hideAiDisclaimer: true,
                hideStarButton: props.hideStarButton,
                showCreatorNameWithoutLink: props.showCreatorNameWithoutLink,
                footerComponent: props.footerComponent
            })
        })
    });
    if (error || !isLoading && !agentData) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kb2tZ.AgentProfileCardWrapper), {
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4k5Wq.default), {
            reload: ()=>{
                fetchData();
            },
            errorType: error || null,
            fireAnalytics: fireEvent
        })
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cozmU.Suspense), {
        fallback: null,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $hIwXM.AgentProfileCardLazy), {
            agent: agentData,
            isLoading: isLoading,
            hasError: !!error,
            onConversationStartersClick: props.onConversationStartersClick,
            onChatClick: props.onChatClick,
            addFlag: props.addFlag,
            resourceClient: props.resourceClient,
            cloudId: props.cloudId,
            onDeleteAgent: props.onDeleteAgent,
            hideMoreActions: props.hideMoreActions,
            hideAiDisclaimer: props.hideAiDisclaimer,
            hideConversationStarters: props.hideConversationStarters,
            hideAgentActions: props.hideAgentActions,
            hideStarButton: props.hideStarButton,
            showCreatorNameWithoutLink: props.showCreatorNameWithoutLink,
            footerComponent: props.footerComponent
        })
    });
};
module.exports["AgentProfileCardResourced"] = $fe1c8bc12e81e628$export$4b013ffffcb40af8;

});

parcelRegister("7G50J", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $I7hWB = parcelRequire("I7hWB");


var $i1t43 = parcelRequire("i1t43");


var $NlHoa = parcelRequire("NlHoa");


var $etoPX = parcelRequire("etoPX");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");


var $1l0kj = parcelRequire("1l0kj");


var $dinVW = parcelRequire("dinVW");


var $a9aSv = parcelRequire("a9aSv");


var $ieeJu = parcelRequire("ieeJu");


var $lpNn5 = parcelRequire("lpNn5");


var $6h4xM = parcelRequire("6h4xM");


var $i4kCF = parcelRequire("i4kCF");


var $hq9Cp = parcelRequire("hq9Cp");


var $fNIRw = parcelRequire("fNIRw");

const $f5fec235121c7193$var$styles = {
    clickableItem: "_2mHwu81Y8M _3iDTPbQ4SZ _0hPCNLDIqT",
    rovoIconWrapper: "_3iDTPbQ4SZ",
    name: "_37wbyuI7V3 _0hPCNLchRC",
    description: "_3SamIHPgdg _3zvHkHdC7N _3W2Oc8wPeg",
    headingWrapper: "_1mT5xdRAKS",
    hiddenIconWrapper: "_313842FQfX"
};
const $f5fec235121c7193$export$7cbebf266a9bcc3c = ({ creatorType: creatorType, authoringTeam: authoringTeam, userCreator: userCreator, forgeCreator: forgeCreator })=>{
    if (creatorType === 'SYSTEM') return {
        type: 'SYSTEM'
    };
    if ((0, $iDrrr.fg)('rovo_agent_support_a2a_avatar') ? (0, $hq9Cp.isForgeAgentByCreatorType)(creatorType) : creatorType === 'FORGE' || creatorType === 'THIRD_PARTY' // THIRD_PARTY is deprecated in convo-ai, use FORGE instead
    ) return {
        // @todo: remove cast in rovo_agent_support_a2a_avatar cleanup
        type: (0, $iDrrr.fg)('jira_improve_agent_profile_for_a2a') ? creatorType : 'FORGE',
        name: forgeCreator ?? ''
    };
    if (creatorType === 'OOTB') return {
        type: 'OOTB'
    };
    if (creatorType === 'CUSTOMER') {
        if (authoringTeam) return {
            type: 'CUSTOMER',
            name: authoringTeam.displayName,
            profileLink: authoringTeam.profileLink ?? ''
        };
        if (!userCreator?.profileLink) return undefined;
        return {
            type: 'CUSTOMER',
            name: userCreator.name,
            profileLink: userCreator.profileLink,
            status: userCreator.status
        };
    }
    return;
};
const $f5fec235121c7193$export$f35b2eeaa7e3db15 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    const { creator: creator, onCreatorLinkClick: onCreatorLinkClick, isLoading: isLoading, showCreatorNameWithoutLink: t1 } = t0;
    const showCreatorNameWithoutLink = t1 === undefined ? false : t1;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t2;
    if ($[0] !== creator || $[1] !== formatMessage || $[2] !== isLoading || $[3] !== onCreatorLinkClick || $[4] !== showCreatorNameWithoutLink) {
        const getCreatorRender = ()=>{
            if (isLoading) return formatMessage((0, $fNIRw.messages).agentCreatedBy, {
                creatorNameWithLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
                    testId: "agent-profile-creator-skeleton",
                    isShimmering: true,
                    height: 18,
                    width: 100
                })
            });
            if (!creator) return null;
            if (creator.type === "SYSTEM" || creator.type === "OOTB") return formatMessage((0, $fNIRw.messages).agentCreatedBy, {
                creatorNameWithLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
                    alignBlock: "center",
                    testId: "atlassian-icon"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $NlHoa.AtlassianIcon), {
                    label: "",
                    size: "small",
                    appearance: "brand"
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, "Atlassian"))
            });
            if (creator.type === "CUSTOMER") {
                const creatorName = `${creator.name} ${creator.status === "inactive" ? formatMessage((0, $fNIRw.messages).agentDeactivated) : ""}`;
                return formatMessage((0, $fNIRw.messages).agentCreatedBy, {
                    creatorNameWithLink: showCreatorNameWithoutLink ? creatorName : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
                        href: creator.profileLink,
                        onClick: ()=>onCreatorLinkClick(),
                        target: "_blank"
                    }, creatorName)
                });
            }
            if (creator.type === "REMOTE_A2A") return formatMessage((0, $fNIRw.messages).remoteAgentCreatedBy, {
                creatorNameWithLink: creator.name
            });
            if (creator.type === "THIRD_PARTY" || creator.type === "FORGE") return formatMessage((0, $fNIRw.messages).agentCreatedBy, {
                creatorNameWithLink: creator.name
            });
            return null;
        };
        t2 = getCreatorRender();
        $[0] = creator;
        $[1] = formatMessage;
        $[2] = isLoading;
        $[3] = onCreatorLinkClick;
        $[4] = showCreatorNameWithoutLink;
        $[5] = t2;
    } else t2 = $[5];
    const creatorRender = t2;
    let t3;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = (0, $ieeJu.expValEquals)("platform_editor_agent_mentions", "isEnabled", true) && (0, $iDrrr.fg)("platform_editor_agent_mentions_drop_one_fixes") || (0, $iDrrr.fg)("platform_editor_agent_card_fixes");
        $[6] = t3;
    } else t3 = $[6];
    const hideCreatorIcon = t3;
    if ((0, $iDrrr.fg)("jira_improve_agent_profile_for_a2a")) {
        const showRovoIcon = !hideCreatorIcon && creator?.type !== "REMOTE_A2A";
        let t4;
        if ($[7] !== creatorRender || $[8] !== showRovoIcon) {
            t4 = creatorRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $f5fec235121c7193$var$styles.clickableItem
            }, showRovoIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $f5fec235121c7193$var$styles.rovoIconWrapper,
                testId: "rovo-icon-wrapper",
                "aria-hidden": "true"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $etoPX.RovoIcon), {
                appearance: "brand",
                size: "small"
            })) : null, creatorRender) : null;
            $[7] = creatorRender;
            $[8] = showRovoIcon;
            $[9] = t4;
        } else t4 = $[9];
        return t4;
    }
    let t4;
    if ($[10] !== creatorRender) {
        t4 = creatorRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $f5fec235121c7193$var$styles.clickableItem
        }, !hideCreatorIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $f5fec235121c7193$var$styles.rovoIconWrapper,
            testId: "rovo-icon-wrapper",
            "aria-hidden": "true"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $etoPX.RovoIcon), {
            appearance: "brand",
            size: "small"
        })), creatorRender) : null;
        $[10] = creatorRender;
        $[11] = t4;
    } else t4 = $[11];
    return t4;
} : ({ creator: creator, onCreatorLinkClick: onCreatorLinkClick, isLoading: isLoading, showCreatorNameWithoutLink: showCreatorNameWithoutLink = false })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const getCreatorRender = ()=>{
        if (isLoading) return formatMessage((0, $fNIRw.messages).agentCreatedBy, {
            creatorNameWithLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
                testId: "agent-profile-creator-skeleton",
                isShimmering: true,
                height: 18,
                width: 100
            })
        });
        if (!creator) return null;
        if (creator.type === 'SYSTEM' || creator.type === 'OOTB') return formatMessage((0, $fNIRw.messages).agentCreatedBy, {
            creatorNameWithLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
                alignBlock: "center",
                testId: "atlassian-icon"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $NlHoa.AtlassianIcon), {
                label: "",
                size: "small",
                appearance: "brand"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, "Atlassian"))
        });
        if (creator.type === 'CUSTOMER') {
            const creatorName = `${creator.name} ${creator.status === 'inactive' ? formatMessage((0, $fNIRw.messages).agentDeactivated) : ''}`;
            return formatMessage((0, $fNIRw.messages).agentCreatedBy, {
                creatorNameWithLink: showCreatorNameWithoutLink ? creatorName : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
                    href: creator.profileLink,
                    onClick: ()=>onCreatorLinkClick(),
                    target: "_blank"
                }, creatorName)
            });
        }
        if (creator.type === 'REMOTE_A2A') return formatMessage((0, $fNIRw.messages).remoteAgentCreatedBy, {
            creatorNameWithLink: creator.name
        });
         // THIRD_PARTY is deprecated in convo-ai, use FORGE instead
        if (creator.type === 'THIRD_PARTY' || creator.type === 'FORGE') return formatMessage((0, $fNIRw.messages).agentCreatedBy, {
            creatorNameWithLink: creator.name
        });
        return null;
    };
    const creatorRender = getCreatorRender();
    const hideCreatorIcon = (0, $ieeJu.expValEquals)('platform_editor_agent_mentions', 'isEnabled', true) && (0, $iDrrr.fg)('platform_editor_agent_mentions_drop_one_fixes') || (0, $iDrrr.fg)('platform_editor_agent_card_fixes');
    if ((0, $iDrrr.fg)('jira_improve_agent_profile_for_a2a')) {
        const showRovoIcon = !hideCreatorIcon && creator?.type !== 'REMOTE_A2A';
        return creatorRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $f5fec235121c7193$var$styles.clickableItem
        }, showRovoIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $f5fec235121c7193$var$styles.rovoIconWrapper,
            testId: "rovo-icon-wrapper",
            "aria-hidden": "true"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $etoPX.RovoIcon), {
            appearance: "brand",
            size: "small"
        })) : null, creatorRender) : null;
    }
    return creatorRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $f5fec235121c7193$var$styles.clickableItem
    }, !hideCreatorIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $f5fec235121c7193$var$styles.rovoIconWrapper,
        testId: "rovo-icon-wrapper",
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $etoPX.RovoIcon), {
        appearance: "brand",
        size: "small"
    })), creatorRender) : null;
};
const $f5fec235121c7193$export$e02348ba0b01a210 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(27);
    const { agentName: agentName, agentDescription: agentDescription, creatorRender: creatorRender, starCountRender: starCountRender, headingRender: headingRender, isStarred: isStarred, isHidden: isHidden, onStarToggle: onStarToggle, showStarButton: t1, renderAdditionalContent: renderAdditionalContent } = t0;
    const showStarButton = t1 === undefined ? true : t1;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t2;
    if ($[0] !== agentName) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            as: "h2",
            size: "medium"
        }, agentName);
        $[0] = agentName;
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== formatMessage || $[3] !== isHidden) {
        t3 = isHidden && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $f5fec235121c7193$var$styles.hiddenIconWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            content: formatMessage((0, $fNIRw.messages).hiddenTooltip),
            position: "top"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6h4xM.HiddenIcon), {
            label: formatMessage((0, $fNIRw.messages).hiddenIcon)
        })));
        $[2] = formatMessage;
        $[3] = isHidden;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== headingRender || $[6] !== t2 || $[7] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.075",
            xcss: $f5fec235121c7193$var$styles.headingWrapper
        }, t2, headingRender, t3);
        $[5] = headingRender;
        $[6] = t2;
        $[7] = t3;
        $[8] = t4;
    } else t4 = $[8];
    let t5;
    if ($[9] !== agentName || $[10] !== isStarred || $[11] !== onStarToggle || $[12] !== showStarButton) {
        t5 = showStarButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i4kCF.StarIconButton), {
            isStarred: isStarred,
            handleToggle: onStarToggle,
            agentName: agentName
        });
        $[9] = agentName;
        $[10] = isStarred;
        $[11] = onStarToggle;
        $[12] = showStarButton;
        $[13] = t5;
    } else t5 = $[13];
    let t6;
    if ($[14] !== t4 || $[15] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            xcss: $f5fec235121c7193$var$styles.name,
            space: "space.100",
            alignBlock: "center"
        }, t4, t5);
        $[14] = t4;
        $[15] = t5;
        $[16] = t6;
    } else t6 = $[16];
    let t7;
    if ($[17] !== agentDescription) {
        t7 = !!agentDescription && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $f5fec235121c7193$var$styles.description,
            as: "p"
        }, agentDescription);
        $[17] = agentDescription;
        $[18] = t7;
    } else t7 = $[18];
    let t8;
    if ($[19] !== renderAdditionalContent) {
        t8 = !!renderAdditionalContent && renderAdditionalContent();
        $[19] = renderAdditionalContent;
        $[20] = t8;
    } else t8 = $[20];
    let t9;
    if ($[21] !== creatorRender || $[22] !== starCountRender || $[23] !== t6 || $[24] !== t7 || $[25] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.100"
        }, t6, creatorRender, t7, starCountRender, t8);
        $[21] = creatorRender;
        $[22] = starCountRender;
        $[23] = t6;
        $[24] = t7;
        $[25] = t8;
        $[26] = t9;
    } else t9 = $[26];
    return t9;
} : ({ agentName: agentName, agentDescription: agentDescription, creatorRender: creatorRender, starCountRender: starCountRender, headingRender: headingRender, isStarred: isStarred, isHidden: isHidden, onStarToggle: onStarToggle, showStarButton: showStarButton = true, renderAdditionalContent: renderAdditionalContent })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        xcss: $f5fec235121c7193$var$styles.name,
        space: "space.100",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.075",
        xcss: $f5fec235121c7193$var$styles.headingWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        as: "h2",
        size: "medium"
    }, agentName), headingRender, isHidden && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $f5fec235121c7193$var$styles.hiddenIconWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: formatMessage((0, $fNIRw.messages).hiddenTooltip),
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6h4xM.HiddenIcon), {
        label: formatMessage((0, $fNIRw.messages).hiddenIcon)
    })))), showStarButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i4kCF.StarIconButton), {
        isStarred: isStarred,
        handleToggle: onStarToggle,
        agentName: agentName
    })), creatorRender, !!agentDescription && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $f5fec235121c7193$var$styles.description,
        as: "p"
    }, agentDescription), starCountRender, !!renderAdditionalContent && renderAdditionalContent());
};
module.exports["getAgentCreator"] = $f5fec235121c7193$export$7cbebf266a9bcc3c;
module.exports["AgentProfileCreator"] = $f5fec235121c7193$export$f35b2eeaa7e3db15;
module.exports["AgentProfileInfo"] = $f5fec235121c7193$export$e02348ba0b01a210;

});

parcelRegister("6h4xM", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $bsSbN = parcelRequire("bsSbN");

const $fc7d462f5dd0deaa$export$bce21421c351deb1 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bsSbN))), props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bsSbN))), props);
module.exports["HiddenIcon"] = $fc7d462f5dd0deaa$export$bce21421c351deb1;

});

parcelRegister("i4kCF", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $1sCHt = parcelRequire("1sCHt");


var $w6R6I = parcelRequire("w6R6I");


var $6Cex3 = parcelRequire("6Cex3");


var $lbT4j = parcelRequire("lbT4j");


var $iMnC5 = parcelRequire("iMnC5");


var $4ssVW = parcelRequire("4ssVW");

const $fbe2d7b3097e2d22$var$styles = {
    hidden: "_1YKVNsdnbC"
};
const $fbe2d7b3097e2d22$export$703abb8bd2abdfa5 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(18);
    const { isStarred: isStarred, handleToggle: handleToggle, visible: t1, agentName: agentName } = t0;
    const visible = t1 === undefined ? true : t1;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isHovered, setIsHovered] = (0, $cozmU.useState)(false);
    const t2 = !visible && $fbe2d7b3097e2d22$var$styles.hidden;
    let t3;
    if ($[0] !== t2) {
        t3 = (0, $w6R6I.cx)(t2);
        $[0] = t2;
        $[1] = t3;
    } else t3 = $[1];
    let t4;
    if ($[2] !== isHovered || $[3] !== isStarred) {
        t4 = (iconProps)=>isStarred || isHovered ? /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($6Cex3))), {
                ...iconProps,
                color: "var(--ds-icon-accent-orange, #E06C00)"
            }) : /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($lbT4j))), {
                ...iconProps,
                color: "var(--ds-icon, #292A2E)"
            });
        $[2] = isHovered;
        $[3] = isStarred;
        $[4] = t4;
    } else t4 = $[4];
    const t5 = isStarred ? (0, $4ssVW.default).removeFromFavouritesLabel : (0, $4ssVW.default).clickToFavouriteLabel;
    let t6;
    if ($[5] !== agentName || $[6] !== formatMessage || $[7] !== t5) {
        t6 = formatMessage(t5, {
            agentName: agentName
        });
        $[5] = agentName;
        $[6] = formatMessage;
        $[7] = t5;
        $[8] = t6;
    } else t6 = $[8];
    let t7;
    let t8;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = ()=>setIsHovered(true);
        t8 = ()=>setIsHovered(false);
        $[9] = t7;
        $[10] = t8;
    } else {
        t7 = $[9];
        t8 = $[10];
    }
    let t9;
    if ($[11] !== handleToggle || $[12] !== t4 || $[13] !== t6) {
        t9 = /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
            appearance: "subtle",
            spacing: "compact",
            icon: t4,
            label: t6,
            onClick: handleToggle,
            onMouseEnter: t7,
            onMouseLeave: t8
        });
        $[11] = handleToggle;
        $[12] = t4;
        $[13] = t6;
        $[14] = t9;
    } else t9 = $[14];
    let t10;
    if ($[15] !== t3 || $[16] !== t9) {
        t10 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: t3
        }, t9);
        $[15] = t3;
        $[16] = t9;
        $[17] = t10;
    } else t10 = $[17];
    return t10;
} : ({ isStarred: isStarred, handleToggle: handleToggle, visible: visible = true, agentName: agentName })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isHovered, setIsHovered] = (0, $cozmU.useState)(false);
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)(!visible && $fbe2d7b3097e2d22$var$styles.hidden)
    }, /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
        appearance: "subtle",
        spacing: "compact",
        icon: (iconProps)=>isStarred || isHovered ? /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($6Cex3))), {
                ...iconProps,
                color: "var(--ds-icon-accent-orange, #E06C00)"
            }) : /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($lbT4j))), {
                ...iconProps,
                color: "var(--ds-icon, #292A2E)"
            }),
        label: formatMessage(isStarred ? (0, $4ssVW.default).removeFromFavouritesLabel : (0, $4ssVW.default).clickToFavouriteLabel, {
            agentName: agentName
        }),
        onClick: handleToggle,
        onMouseEnter: ()=>setIsHovered(true),
        onMouseLeave: ()=>setIsHovered(false)
    }));
};
module.exports["StarIconButton"] = $fbe2d7b3097e2d22$export$703abb8bd2abdfa5;

});

parcelRegister("4ssVW", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $a47d9a7d981bdb91$var$message = (0, $kSwu1.defineMessages)({
    removeFromFavouritesLabel: {
        id: "rovo-chat.browse-agents.remove-from-favourites-label",
        defaultMessage: "Remove {agentName} from favourites"
    },
    clickToFavouriteLabel: {
        id: "rovo-chat.browse-agents.click-to-favourite-label",
        defaultMessage: "Add {agentName} to favourites"
    }
});
var $a47d9a7d981bdb91$export$2e2bcd8739ae039 = $a47d9a7d981bdb91$var$message;
module.exports["default"] = $a47d9a7d981bdb91$export$2e2bcd8739ae039;

});

parcelRegister("fNIRw", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $246a354bdf98d3ad$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    agentCreatedBy: {
        id: "ai-mate.agent-profile-info.created-by",
        defaultMessage: "Rovo Agent by {creatorNameWithLink}"
    },
    remoteAgentCreatedBy: {
        id: "ai-mate.agent-profile-info.agent-by",
        defaultMessage: "Agent by {creatorNameWithLink}"
    },
    agentDeactivated: {
        id: "ai-mate.agent-profile-info.deactivated",
        defaultMessage: "(deactivated)"
    },
    starredCount: {
        id: "ai-mate.agent-profile-info.starred-count",
        defaultMessage: "{count} starred"
    },
    hiddenIcon: {
        id: "ai-mate.agent-profile-info.hidden-icon",
        defaultMessage: "Hidden"
    },
    hiddenTooltip: {
        id: "ai-mate.agent-profile-info.hidden-tooltip",
        defaultMessage: "Agent won't show in search results"
    },
    starAgentTooltip: {
        id: "ai-mate.agent-profile-info.star-agent-tooltip",
        defaultMessage: "Star Agent"
    },
    creatorLabel: {
        id: "ai-mate.agent-profile-info.creator",
        defaultMessage: "Creator"
    }
});
module.exports["messages"] = $246a354bdf98d3ad$export$defe85febe8b728c;

});

parcelRegister("dSW04", function(module, exports) {
class $99c5d70c0df67415$export$a6d78d75d03919f1 extends Error {
    constructor(){
        super('Agent access forbidden');
        this.status = 403;
        this.name = 'AgentForbiddenError';
    }
}
module.exports["AgentForbiddenError"] = $99c5d70c0df67415$export$a6d78d75d03919f1;

});

parcelRegister("dRAjC", function(module, exports) {
const $d2643a1af3062f27$export$470b0d72e4fdc43a = 'ari:cloud:identity::user/';
const $d2643a1af3062f27$export$3761e66a04602cbd = (ari)=>{
    return ari.replace($d2643a1af3062f27$export$470b0d72e4fdc43a, '');
};
module.exports["USER_ARI_PREFIX"] = $d2643a1af3062f27$export$470b0d72e4fdc43a;
module.exports["getAAIDFromARI"] = $d2643a1af3062f27$export$3761e66a04602cbd;

});

parcelRegister("4k5Wq", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $ad7Ou = parcelRequire("ad7Ou");


var $5avUB = parcelRequire("5avUB");


var $4aRua = parcelRequire("4aRua");


var $eU2tf = parcelRequire("eU2tf");


var $hHYlx = parcelRequire("hHYlx");


var $cSSWJ = parcelRequire("cSSWJ");

const $0f12e30f7425acf6$var$ErrorMessage = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(18);
    let t0;
    if ($[0] !== props.errorType) {
        t0 = props.errorType || {
            reason: "default"
        };
        $[0] = props.errorType;
        $[1] = t0;
    } else t0 = $[1];
    const errorType = t0;
    const errorReason = errorType.reason;
    const { fireAnalytics: fireAnalytics, reload: reload } = props;
    const hasRetry = !!reload;
    let t1;
    let t2;
    if ($[2] !== errorReason || $[3] !== fireAnalytics || $[4] !== hasRetry) {
        t1 = ()=>{
            fireAnalytics("ui.profilecard.rendered.error", {
                hasRetry: hasRetry,
                errorType: errorReason,
                firedAt: Math.round(performance.now()),
                ...(0, $cSSWJ.PACKAGE_META_DATA)
            });
        };
        t2 = [
            errorReason,
            fireAnalytics,
            hasRetry
        ];
        $[2] = errorReason;
        $[3] = fireAnalytics;
        $[4] = hasRetry;
        $[5] = t1;
        $[6] = t2;
    } else {
        t1 = $[5];
        t2 = $[6];
    }
    (0, $cozmU.useEffect)(t1, t2);
    let t3;
    if ($[7] !== errorReason || $[8] !== reload) {
        t3 = ()=>{
            if (errorReason === "NotFound") return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $hHYlx.ErrorTitle), {
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                    ...(0, $eU2tf.default).errorUserNotFound
                })
            });
            return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $hHYlx.ErrorTitle), {
                children: [
                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                        ...(0, $eU2tf.default).errorGeneric
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsx)("br", {}),
                    reload && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                        color: "color.text.subtlest",
                        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                            ...(0, $eU2tf.default).errorRetrySuggestion
                        })
                    })
                ]
            });
        };
        $[7] = errorReason;
        $[8] = reload;
        $[9] = t3;
    } else t3 = $[9];
    const errorContent = t3;
    let t4;
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5avUB))), {
            label: "icon error"
        });
        $[10] = t4;
    } else t4 = $[10];
    let t5;
    if ($[11] !== errorContent) {
        t5 = errorContent();
        $[11] = errorContent;
        $[12] = t5;
    } else t5 = $[12];
    let t6;
    if ($[13] !== reload) {
        t6 = reload && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ad7Ou.default), {
            onClick: reload,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                ...(0, $eU2tf.default).errorTryAgain
            })
        });
        $[13] = reload;
        $[14] = t6;
    } else t6 = $[14];
    let t7;
    if ($[15] !== t5 || $[16] !== t6) {
        t7 = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $hHYlx.ErrorWrapper), {
            testId: "profilecard-error",
            children: [
                t4,
                t5,
                t6
            ]
        });
        $[15] = t5;
        $[16] = t6;
        $[17] = t7;
    } else t7 = $[17];
    return t7;
} : (props)=>{
    const errorType = props.errorType || {
        reason: 'default'
    };
    const errorReason = errorType.reason;
    const { fireAnalytics: fireAnalytics, reload: reload } = props;
    const hasRetry = !!reload;
    (0, $cozmU.useEffect)(()=>{
        fireAnalytics('ui.profilecard.rendered.error', {
            hasRetry: hasRetry,
            errorType: errorReason,
            firedAt: Math.round(performance.now()),
            ...(0, $cSSWJ.PACKAGE_META_DATA)
        });
    }, [
        errorReason,
        fireAnalytics,
        hasRetry
    ]);
    const errorContent = ()=>{
        if (errorReason === 'NotFound') return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $hHYlx.ErrorTitle), {
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                ...(0, $eU2tf.default).errorUserNotFound
            })
        });
        return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $hHYlx.ErrorTitle), {
            children: [
                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                    ...(0, $eU2tf.default).errorGeneric
                }),
                /*#__PURE__*/ (0, $8aG6j.jsx)("br", {}),
                reload && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                    color: "color.text.subtlest",
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                        ...(0, $eU2tf.default).errorRetrySuggestion
                    })
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $hHYlx.ErrorWrapper), {
        testId: "profilecard-error",
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5avUB))), {
                label: "icon error"
            }),
            errorContent(),
            reload && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ad7Ou.default), {
                onClick: reload,
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                    ...(0, $eU2tf.default).errorTryAgain
                })
            })
        ]
    });
};
var $0f12e30f7425acf6$export$2e2bcd8739ae039 = $0f12e30f7425acf6$var$ErrorMessage;
module.exports["default"] = $0f12e30f7425acf6$export$2e2bcd8739ae039;

});

parcelRegister("eU2tf", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $fe57f9d19e98fdc0$var$messages = (0, $kSwu1.defineMessages)({
    inactiveAccountMsg: {
        id: "pt.profile-card.inactive.account",
        defaultMessage: "Account deactivated"
    },
    generalDescMsgForDisabledUser: {
        id: "pt.profile-card.general.msg.disabled.user",
        defaultMessage: "You can no longer collaborate with this person."
    },
    inactiveAccountDescMsgNoDate: {
        id: "pt.profile-card.inactive.account.no.date",
        defaultMessage: "Their account has been deactivated."
    },
    inactiveAccountDescMsgHasDateThisWeek: {
        id: "pt.profile-card.inactive.account.has.date.this.week",
        defaultMessage: "Their account was deactivated this week."
    },
    inactiveAccountDescMsgHasDateThisMonth: {
        id: "pt.profile-card.inactive.account.has.date.this.month",
        defaultMessage: "Their account was deactivated this month."
    },
    inactiveAccountDescMsgHasDateLastMonth: {
        id: "pt.profile-card.inactive.account.has.date.last.month",
        defaultMessage: "Their account was deactivated last month."
    },
    inactiveAccountDescMsgHasDateAFewMonths: {
        id: "pt.profile-card.inactive.account.has.date.a.few.months",
        defaultMessage: "Their account has been deactivated for a few months."
    },
    inactiveAccountDescMsgHasDateSeveralMonths: {
        id: "pt.profile-card.inactive.account.has.date.several.months",
        defaultMessage: "Their account has been deactivated for several months."
    },
    inactiveAccountDescMsgHasDateMoreThanAYear: {
        id: "pt.profile-card.inactive.account.has.date.more.than.a.year",
        defaultMessage: "Their account has been deactivated for more than a year."
    },
    closedAccountMsg: {
        id: "pt.profile-card.closed.account",
        defaultMessage: "Account deleted"
    },
    closedAccountDescMsgNoDate: {
        id: "pt.profile-card.closed.account.no.date",
        defaultMessage: "Their account has been deleted."
    },
    closedAccountDescMsgHasDateThisWeek: {
        id: "pt.profile-card.closed.account.has.date.this.week",
        defaultMessage: "Their account was deleted this week."
    },
    closedAccountDescMsgHasDateThisMonth: {
        id: "pt.profile-card.closed.account.has.date.this.month",
        defaultMessage: "Their account was deleted this month."
    },
    closedAccountDescMsgHasDateLastMonth: {
        id: "pt.profile-card.closed.account.has.date.last.month",
        defaultMessage: "Their account was deleted last month."
    },
    closedAccountDescMsgHasDateAFewMonths: {
        id: "pt.profile-card.closed.account.has.date.a.few.months",
        defaultMessage: "Their account has been deleted for a few months."
    },
    closedAccountDescMsgHasDateSeveralMonths: {
        id: "pt.profile-card.closed.account.has.date.several.months",
        defaultMessage: "Their account has been deleted for several months."
    },
    closedAccountDescMsgHasDateMoreThanAYear: {
        id: "pt.profile-card.closed.account.has.date.more.than.a.year",
        defaultMessage: "Their account has been deleted for more than a year."
    },
    disabledAccountDefaultName: {
        id: "pt.profile-card.disabled.account.default.name",
        defaultMessage: "Former user"
    },
    teamViewProfile: {
        id: "pt.team-profile-card.team.action.view-profile",
        defaultMessage: "View profile"
    },
    memberCount: {
        id: "pt.team-profile-card.team.member.count",
        defaultMessage: "Team \u2022 {count} {count, plural, one {member} other {members}}"
    },
    memberCountIncludingYou: {
        id: "pt.team-profile-card.team.member.count-including-you",
        defaultMessage: "Team \u2022 {count} {count, plural, one {member} other {members}}, including you"
    },
    membersMoreThan50: {
        id: "pt.team-profile-card.team.member.many",
        defaultMessage: "Team \u2022 50+ members"
    },
    membersMoreThan50IncludingYou: {
        id: "pt.team-profile-card.team.member.many-including-you",
        defaultMessage: "Team \u2022 50+ members, including you"
    },
    teamErrorTitle: {
        id: "pt.team-profile-card.error.title",
        defaultMessage: "We\u2019re having trouble retrieving this teams information"
    },
    teamErrorText: {
        id: "pt.team-profile-card.error.suggestion",
        defaultMessage: "Wait a few moments, then try again."
    },
    teamErrorButton: {
        id: "pt.team-profile-card.error.refresh-button",
        defaultMessage: "Try again"
    },
    teamForbiddenErrorStateTitle: {
        id: "pt.team-profile-card.forbidden-error-state.title",
        defaultMessage: "We can\u2019t show you this team"
    },
    teamForbiddenErrorStateDescription: {
        id: "pt.team-profile-card.forbidden-error-state.description",
        defaultMessage: "You don\u2019t have access to view this team."
    },
    managerSectionHeading: {
        id: "pt.team-profile-card.manager.heading",
        defaultMessage: "Manager"
    },
    directReportsSectionHeading: {
        id: "pt.team-profile-card.directReports.heading",
        defaultMessage: "Direct reports"
    },
    teamProfileCardAriaLabel: {
        id: "pt.team-profile-card.aria-label",
        defaultMessage: "More information about this team"
    },
    giveKudosButton: {
        id: "pt.profile-card.give-kudos",
        defaultMessage: "Give kudos"
    },
    // Remove this as part of the FG Cleanup for jfp_a11y_team_profile_card_actions_label
    profileCardMoreIconLabel: {
        id: "pt.profile-card.more-icon-label",
        defaultMessage: "More"
    },
    profileCardMoreIconLabelWithName: {
        id: "pt.profile-card.more-icon-label-with-name",
        defaultMessage: "More actions for {fullName}"
    },
    profileCardMoreReportingLinesLabel: {
        id: "pt.user-profile-card.reporting-lines.more-icon-label",
        defaultMessage: "+{count} more {count, plural, one {profile} other {profiles}}"
    },
    profileCardMoreMembersLabel: {
        id: "pt.team.profile-card.members.more-icon-label",
        defaultMessage: "+{count} more {count, plural, one {members} other {members}}"
    },
    archivedLozenge: {
        id: "pt.team-profile-card.archived-lozenge",
        defaultMessage: "Archived"
    },
    errorUserNotFound: {
        id: "pt.profile-card.error.user-not-found",
        defaultMessage: "The user is no longer available for the site"
    },
    errorGeneric: {
        id: "pt.profile-card.error.generic",
        defaultMessage: "Oops, looks like we\u2019re having issues"
    },
    errorRetrySuggestion: {
        id: "pt.profile-card.error.retry-suggestion",
        defaultMessage: "Try again and we\u2019ll give it another shot"
    },
    errorTryAgain: {
        id: "pt.profile-card.error.try-again-button",
        defaultMessage: "Try again"
    },
    errorDialogLabel: {
        id: "pt.profile-card.error.dialog-label",
        defaultMessage: "Profile card error"
    },
    loadingDialogLabel: {
        id: "pt.profile-card.loading.dialog-label",
        defaultMessage: "Loading profile card"
    },
    serviceAccountLabel: {
        id: "pt.profile-card.service-account.label",
        defaultMessage: "SERVICE ACCOUNT"
    },
    botAccountLabel: {
        id: "pt.profile-card.bot-account.label",
        defaultMessage: "APP"
    },
    viewManagerProfile: {
        id: "pt.profile-card.view-manager-profile",
        defaultMessage: "View {name} profile"
    }
});
var $fe57f9d19e98fdc0$export$2e2bcd8739ae039 = $fe57f9d19e98fdc0$var$messages;
module.exports["default"] = $fe57f9d19e98fdc0$export$2e2bcd8739ae039;

});

parcelRegister("hHYlx", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $w6R6I = parcelRequire("w6R6I");


var $iMnC5 = parcelRequire("iMnC5");


var $4aRua = parcelRequire("4aRua");

const $3b2daa1fed2d9894$var$styles = {
    errorWrapper: "_2fwxA5DIqT _0Of8r2NHnM _1ZnuxbNHnM _1wydGWNHnM _2Zuz6QNHnM",
    errorTitle: "_3138422ADO",
    teamErrorText: "_1UtDYzKGUX _3138422ADO"
};
const $3b2daa1fed2d9894$export$bb27b7e39840238f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $w6R6I.cx)($3b2daa1fed2d9894$var$styles.errorWrapper);
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== props) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            xcss: t0,
            ...props
        });
        $[1] = props;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : (props)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($3b2daa1fed2d9894$var$styles.errorWrapper),
        ...props
    });
const $3b2daa1fed2d9894$export$b065fd053267ec81 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props.children) {
        t0 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            xcss: $3b2daa1fed2d9894$var$styles.errorTitle,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                color: "color.text",
                children: props.children
            })
        });
        $[0] = props.children;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        xcss: $3b2daa1fed2d9894$var$styles.errorTitle,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
            color: "color.text",
            children: props.children
        })
    });
const $3b2daa1fed2d9894$export$90d92ccfb27352c6 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $w6R6I.cx)($3b2daa1fed2d9894$var$styles.teamErrorText);
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== props.children) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            xcss: t0,
            children: props.children
        });
        $[1] = props.children;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : (props)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($3b2daa1fed2d9894$var$styles.teamErrorText),
        children: props.children
    });
module.exports["ErrorWrapper"] = $3b2daa1fed2d9894$export$bb27b7e39840238f;
module.exports["ErrorTitle"] = $3b2daa1fed2d9894$export$b065fd053267ec81;

});

parcelRegister("kb2tZ", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");


var $ieeJu = parcelRequire("ieeJu");

const $d107d3e886647d93$var$styles = {
    wrapper: "_0bjKvD8fU6 _39xV02wBC3 _0KLXruoI2d _2OUyjtGk8v",
    wrapperLegacy: "_0bjKvD8fU6 _39xV02wBC3 _0KLXruoI2d"
};
const $d107d3e886647d93$export$2c6604b50c274e6f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { children: children } = t0;
    if ((0, $ieeJu.expValEquals)("platform_editor_agent_mentions", "isEnabled", true) && (0, $iDrrr.fg)("platform_editor_agent_mentions_drop_one_fixes") || (0, $iDrrr.fg)("platform_editor_agent_card_fixes")) {
        let t1;
        if ($[0] !== children) {
            t1 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                xcss: $d107d3e886647d93$var$styles.wrapper,
                children: children
            });
            $[0] = children;
            $[1] = t1;
        } else t1 = $[1];
        return t1;
    }
    let t1;
    if ($[2] !== children) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            xcss: $d107d3e886647d93$var$styles.wrapperLegacy,
            children: children
        });
        $[2] = children;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : ({ children: children })=>{
    if ((0, $ieeJu.expValEquals)('platform_editor_agent_mentions', 'isEnabled', true) && (0, $iDrrr.fg)('platform_editor_agent_mentions_drop_one_fixes') || (0, $iDrrr.fg)('platform_editor_agent_card_fixes')) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        xcss: $d107d3e886647d93$var$styles.wrapper,
        children: children
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        xcss: $d107d3e886647d93$var$styles.wrapperLegacy,
        children: children
    });
};
module.exports["AgentProfileCardWrapper"] = $d107d3e886647d93$export$2c6604b50c274e6f;

});

parcelRegister("hIwXM", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $ipkS0 = parcelRequire("ipkS0");


const $795534535f4e0b8b$export$ed0ca9c1d49ea0bf = /*#__PURE__*/ (0, $cozmU.lazy)((0, $ipkS0.trackReactLazy)("rl-7xjQ31", ()=>(parcelRequire("fNCi2"))));
module.exports["AgentProfileCardLazy"] = $795534535f4e0b8b$export$ed0ca9c1d49ea0bf;

});

parcelRegister("fNCi2", function(module, exports) {

let $b809223073d7e649$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $b809223073d7e649$var$load("dYUYM"),
    $b809223073d7e649$var$load("lgRS0"),
    $b809223073d7e649$var$load("6wr18"),
    $b809223073d7e649$var$load("iYJZz"),
    $b809223073d7e649$var$load("jqoep"),
    $b809223073d7e649$var$load("ea3NB"),
    $b809223073d7e649$var$load("ffEVr"),
    $b809223073d7e649$var$load("7EorR"),
    $b809223073d7e649$var$load("hhss7"),
    $b809223073d7e649$var$load("68aog")
]).then(()=>parcelRequire('ark00'));

});

parcelRegister("8lhhf", function(module, exports) {
const $57d7e56ed333ab64$export$d0e832101df0ac96 = 'com.atlassian.rovo.skill';
const $57d7e56ed333ab64$export$d4f002c79ea2ad20 = 'skill';
const $57d7e56ed333ab64$export$e4d0b30afd49f7df = 'skillTag';
const $57d7e56ed333ab64$export$18f911e214c46d8 = /\/([a-zA-Z0-9-]+)/g;
const $57d7e56ed333ab64$export$aae1b80712c1b67b = `${$57d7e56ed333ab64$export$d4f002c79ea2ad20}:${$57d7e56ed333ab64$export$e4d0b30afd49f7df}`;
const $57d7e56ed333ab64$export$b22d8560058c60e1 = (extensionType, extensionKey)=>{
    return extensionType === $57d7e56ed333ab64$export$d0e832101df0ac96 && extensionKey === $57d7e56ed333ab64$export$aae1b80712c1b67b;
};
const $57d7e56ed333ab64$export$f88fd0c0ee7d509a = (skill)=>{
    return [
        {
            type: 'inlineExtension',
            attrs: {
                extensionKey: $57d7e56ed333ab64$export$aae1b80712c1b67b,
                extensionType: $57d7e56ed333ab64$export$d0e832101df0ac96,
                parameters: skill
            }
        },
        // render an empty space after the skill tag
        {
            type: 'text',
            text: ' '
        }
    ];
};
const $57d7e56ed333ab64$export$a425ebfe740d9932 = (skill)=>({
        type: 'doc',
        version: 1,
        content: [
            {
                type: 'paragraph',
                content: $57d7e56ed333ab64$export$f88fd0c0ee7d509a(skill)
            }
        ]
    });
module.exports["ROVO_SKILL_EXTENSION_TYPE"] = $57d7e56ed333ab64$export$d0e832101df0ac96;
module.exports["ROVO_SKILL_EXTENSION_KEY"] = $57d7e56ed333ab64$export$d4f002c79ea2ad20;
module.exports["ROVO_SKILL_TAG_PATTERN"] = $57d7e56ed333ab64$export$18f911e214c46d8;
module.exports["ROVO_SKILL_COMBINED_EXTENSION_KEY"] = $57d7e56ed333ab64$export$aae1b80712c1b67b;
module.exports["isSkillTagExtension"] = $57d7e56ed333ab64$export$b22d8560058c60e1;
module.exports["createSkillNode"] = $57d7e56ed333ab64$export$f88fd0c0ee7d509a;
module.exports["createSkillAdf"] = $57d7e56ed333ab64$export$a425ebfe740d9932;

});

parcelRegister("2j0AL", function(module, exports) {
'use strict';
// do not edit .js files directly - edit src/index.jst
module.exports = function equal(a, b) {
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        for(i = length; i-- !== 0;){
            var key = keys[i];
            if (!equal(a[key], b[key])) return false;
        }
        return true;
    }
    // true if both NaN, false otherwise
    return a !== a && b !== b;
};

});

parcelRegister("13PMQ", function(module, exports) {
// DEFLATE is a complex format; to read this code, you should probably check the RFC first:
// https://tools.ietf.org/html/rfc1951
// You may also wish to take a look at the guide I made about this program:
// https://gist.github.com/101arrowz/253f31eb5abc3d9275ab943003ffecad
// Some of the following code is similar to that of UZIP.js:
// https://github.com/photopea/UZIP.js
// However, the vast majority of the codebase has diverged from UZIP.js to increase performance and reduce bundle size.
// Sometimes 0 will appear where -1 would be more appropriate. This is because using a uint
// is better for memory in most engines (I *think*).
var $0c5e3e04f495ba65$var$ch2 = {};
var $0c5e3e04f495ba65$var$wk = function(c, id, msg, transfer, cb) {
    var w = new Worker($0c5e3e04f495ba65$var$ch2[id] || ($0c5e3e04f495ba65$var$ch2[id] = URL.createObjectURL(new Blob([
        c + ';addEventListener("error",function(e){e=e.error;postMessage({$e$:[e.message,e.code,e.stack]})})'
    ], {
        type: 'text/javascript'
    }))));
    w.onmessage = function(e) {
        var d = e.data, ed = d.$e$;
        if (ed) {
            var err = new Error(ed[0]);
            err['code'] = ed[1];
            err.stack = ed[2];
            cb(err, null);
        } else cb(null, d);
    };
    w.postMessage(msg, transfer);
    return w;
};
// aliases for shorter compressed code (most minifers don't do this)
var $0c5e3e04f495ba65$var$u8 = Uint8Array, $0c5e3e04f495ba65$var$u16 = Uint16Array, $0c5e3e04f495ba65$var$i32 = Int32Array;
// fixed length extra bits
var $0c5e3e04f495ba65$var$fleb = new $0c5e3e04f495ba65$var$u8([
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    4,
    4,
    4,
    4,
    5,
    5,
    5,
    5,
    0,
    /* unused */ 0,
    0,
    /* impossible */ 0
]);
// fixed distance extra bits
var $0c5e3e04f495ba65$var$fdeb = new $0c5e3e04f495ba65$var$u8([
    0,
    0,
    0,
    0,
    1,
    1,
    2,
    2,
    3,
    3,
    4,
    4,
    5,
    5,
    6,
    6,
    7,
    7,
    8,
    8,
    9,
    9,
    10,
    10,
    11,
    11,
    12,
    12,
    13,
    13,
    /* unused */ 0,
    0
]);
// code length index map
var $0c5e3e04f495ba65$var$clim = new $0c5e3e04f495ba65$var$u8([
    16,
    17,
    18,
    0,
    8,
    7,
    9,
    6,
    10,
    5,
    11,
    4,
    12,
    3,
    13,
    2,
    14,
    1,
    15
]);
// get base, reverse index map from extra bits
var $0c5e3e04f495ba65$var$freb = function(eb, start) {
    var b = new $0c5e3e04f495ba65$var$u16(31);
    for(var i = 0; i < 31; ++i)b[i] = start += 1 << eb[i - 1];
    // numbers here are at max 18 bits
    var r = new $0c5e3e04f495ba65$var$i32(b[30]);
    for(var i = 1; i < 30; ++i)for(var j = b[i]; j < b[i + 1]; ++j)r[j] = j - b[i] << 5 | i;
    return {
        b: b,
        r: r
    };
};
var $0c5e3e04f495ba65$var$_a = $0c5e3e04f495ba65$var$freb($0c5e3e04f495ba65$var$fleb, 2), $0c5e3e04f495ba65$var$fl = $0c5e3e04f495ba65$var$_a.b, $0c5e3e04f495ba65$var$revfl = $0c5e3e04f495ba65$var$_a.r;
// we can ignore the fact that the other numbers are wrong; they never happen anyway
$0c5e3e04f495ba65$var$fl[28] = 258, $0c5e3e04f495ba65$var$revfl[258] = 28;
var $0c5e3e04f495ba65$var$_b = $0c5e3e04f495ba65$var$freb($0c5e3e04f495ba65$var$fdeb, 0), $0c5e3e04f495ba65$var$fd = $0c5e3e04f495ba65$var$_b.b, $0c5e3e04f495ba65$var$revfd = $0c5e3e04f495ba65$var$_b.r;
// map of value to reverse (assuming 16 bits)
var $0c5e3e04f495ba65$var$rev = new $0c5e3e04f495ba65$var$u16(32768);
for(var $0c5e3e04f495ba65$var$i = 0; $0c5e3e04f495ba65$var$i < 32768; ++$0c5e3e04f495ba65$var$i){
    // reverse table algorithm from SO
    var $0c5e3e04f495ba65$var$x = ($0c5e3e04f495ba65$var$i & 0xAAAA) >> 1 | ($0c5e3e04f495ba65$var$i & 0x5555) << 1;
    $0c5e3e04f495ba65$var$x = ($0c5e3e04f495ba65$var$x & 0xCCCC) >> 2 | ($0c5e3e04f495ba65$var$x & 0x3333) << 2;
    $0c5e3e04f495ba65$var$x = ($0c5e3e04f495ba65$var$x & 0xF0F0) >> 4 | ($0c5e3e04f495ba65$var$x & 0x0F0F) << 4;
    $0c5e3e04f495ba65$var$rev[$0c5e3e04f495ba65$var$i] = (($0c5e3e04f495ba65$var$x & 0xFF00) >> 8 | ($0c5e3e04f495ba65$var$x & 0x00FF) << 8) >> 1;
}
// create huffman tree from u8 "map": index -> code length for code index
// mb (max bits) must be at most 15
// TODO: optimize/split up?
var $0c5e3e04f495ba65$var$hMap = function(cd, mb, r) {
    var s = cd.length;
    // index
    var i = 0;
    // u16 "map": index -> # of codes with bit length = index
    var l = new $0c5e3e04f495ba65$var$u16(mb);
    // length of cd must be 288 (total # of codes)
    for(; i < s; ++i)if (cd[i]) ++l[cd[i] - 1];
    // u16 "map": index -> minimum code for bit length = index
    var le = new $0c5e3e04f495ba65$var$u16(mb);
    for(i = 1; i < mb; ++i)le[i] = le[i - 1] + l[i - 1] << 1;
    var co;
    if (r) {
        // u16 "map": index -> number of actual bits, symbol for code
        co = new $0c5e3e04f495ba65$var$u16(1 << mb);
        // bits to remove for reverser
        var rvb = 15 - mb;
        for(i = 0; i < s; ++i)// ignore 0 lengths
        if (cd[i]) {
            // num encoding both symbol and bits read
            var sv = i << 4 | cd[i];
            // free bits
            var r_1 = mb - cd[i];
            // start value
            var v = le[cd[i] - 1]++ << r_1;
            // m is end value
            for(var m = v | (1 << r_1) - 1; v <= m; ++v)// every 16 bit value starting with the code yields the same result
            co[$0c5e3e04f495ba65$var$rev[v] >> rvb] = sv;
        }
    } else {
        co = new $0c5e3e04f495ba65$var$u16(s);
        for(i = 0; i < s; ++i)if (cd[i]) co[i] = $0c5e3e04f495ba65$var$rev[le[cd[i] - 1]++] >> 15 - cd[i];
    }
    return co;
};
// fixed length tree
var $0c5e3e04f495ba65$var$flt = new $0c5e3e04f495ba65$var$u8(288);
for(var $0c5e3e04f495ba65$var$i = 0; $0c5e3e04f495ba65$var$i < 144; ++$0c5e3e04f495ba65$var$i)$0c5e3e04f495ba65$var$flt[$0c5e3e04f495ba65$var$i] = 8;
for(var $0c5e3e04f495ba65$var$i = 144; $0c5e3e04f495ba65$var$i < 256; ++$0c5e3e04f495ba65$var$i)$0c5e3e04f495ba65$var$flt[$0c5e3e04f495ba65$var$i] = 9;
for(var $0c5e3e04f495ba65$var$i = 256; $0c5e3e04f495ba65$var$i < 280; ++$0c5e3e04f495ba65$var$i)$0c5e3e04f495ba65$var$flt[$0c5e3e04f495ba65$var$i] = 7;
for(var $0c5e3e04f495ba65$var$i = 280; $0c5e3e04f495ba65$var$i < 288; ++$0c5e3e04f495ba65$var$i)$0c5e3e04f495ba65$var$flt[$0c5e3e04f495ba65$var$i] = 8;
// fixed distance tree
var $0c5e3e04f495ba65$var$fdt = new $0c5e3e04f495ba65$var$u8(32);
for(var $0c5e3e04f495ba65$var$i = 0; $0c5e3e04f495ba65$var$i < 32; ++$0c5e3e04f495ba65$var$i)$0c5e3e04f495ba65$var$fdt[$0c5e3e04f495ba65$var$i] = 5;
// fixed length map
var $0c5e3e04f495ba65$var$flm = /*#__PURE__*/ $0c5e3e04f495ba65$var$hMap($0c5e3e04f495ba65$var$flt, 9, 0), $0c5e3e04f495ba65$var$flrm = /*#__PURE__*/ $0c5e3e04f495ba65$var$hMap($0c5e3e04f495ba65$var$flt, 9, 1);
// fixed distance map
var $0c5e3e04f495ba65$var$fdm = /*#__PURE__*/ $0c5e3e04f495ba65$var$hMap($0c5e3e04f495ba65$var$fdt, 5, 0), $0c5e3e04f495ba65$var$fdrm = /*#__PURE__*/ $0c5e3e04f495ba65$var$hMap($0c5e3e04f495ba65$var$fdt, 5, 1);
// find max of array
var $0c5e3e04f495ba65$var$max = function(a) {
    var m = a[0];
    for(var i = 1; i < a.length; ++i)if (a[i] > m) m = a[i];
    return m;
};
// read d, starting at bit p and mask with m
var $0c5e3e04f495ba65$var$bits = function(d, p, m) {
    var o = p / 8 | 0;
    return (d[o] | d[o + 1] << 8) >> (p & 7) & m;
};
// read d, starting at bit p continuing for at least 16 bits
var $0c5e3e04f495ba65$var$bits16 = function(d, p) {
    var o = p / 8 | 0;
    return (d[o] | d[o + 1] << 8 | d[o + 2] << 16) >> (p & 7);
};
// get end of byte
var $0c5e3e04f495ba65$var$shft = function(p) {
    return (p + 7) / 8 | 0;
};
// typed array slice - allows garbage collector to free original reference,
// while being more compatible than .slice
var $0c5e3e04f495ba65$var$slc = function(v, s, e) {
    if (s == null || s < 0) s = 0;
    if (e == null || e > v.length) e = v.length;
    // can't use .constructor in case user-supplied
    return new $0c5e3e04f495ba65$var$u8(v.subarray(s, e));
};
var $0c5e3e04f495ba65$export$ae5516a5a74c19a8 = {
    UnexpectedEOF: 0,
    InvalidBlockType: 1,
    InvalidLengthLiteral: 2,
    InvalidDistance: 3,
    StreamFinished: 4,
    NoStreamHandler: 5,
    InvalidHeader: 6,
    NoCallback: 7,
    InvalidUTF8: 8,
    ExtraFieldTooLong: 9,
    InvalidDate: 10,
    FilenameTooLong: 11,
    StreamFinishing: 12,
    InvalidZipData: 13,
    UnknownCompressionMethod: 14
};
// error codes
var $0c5e3e04f495ba65$var$ec = [
    'unexpected EOF',
    'invalid block type',
    'invalid length/literal',
    'invalid distance',
    'stream finished',
    'no stream handler',
    ,
    'no callback',
    'invalid UTF-8 data',
    'extra field too long',
    'date not in range 1980-2099',
    'filename too long',
    'stream finishing',
    'invalid zip data'
];
var $0c5e3e04f495ba65$var$err = function(ind, msg, nt) {
    var e = new Error(msg || $0c5e3e04f495ba65$var$ec[ind]);
    e.code = ind;
    if (Error.captureStackTrace) Error.captureStackTrace(e, $0c5e3e04f495ba65$var$err);
    if (!nt) throw e;
    return e;
};
// expands raw DEFLATE data
var $0c5e3e04f495ba65$var$inflt = function(dat, st, buf, dict) {
    // source length       dict length
    var sl = dat.length, dl = dict ? dict.length : 0;
    if (!sl || st.f && !st.l) return buf || new $0c5e3e04f495ba65$var$u8(0);
    var noBuf = !buf;
    // have to estimate size
    var resize = noBuf || st.i != 2;
    // no state
    var noSt = st.i;
    // Assumes roughly 33% compression ratio average
    if (noBuf) buf = new $0c5e3e04f495ba65$var$u8(sl * 3);
    // ensure buffer can fit at least l elements
    var cbuf = function(l) {
        var bl = buf.length;
        // need to increase size to fit
        if (l > bl) {
            // Double or set to necessary, whichever is greater
            var nbuf = new $0c5e3e04f495ba65$var$u8(Math.max(bl * 2, l));
            nbuf.set(buf);
            buf = nbuf;
        }
    };
    //  last chunk         bitpos           bytes
    var final = st.f || 0, pos = st.p || 0, bt = st.b || 0, lm = st.l, dm = st.d, lbt = st.m, dbt = st.n;
    // total bits
    var tbts = sl * 8;
    do {
        if (!lm) {
            // BFINAL - this is only 1 when last chunk is next
            final = $0c5e3e04f495ba65$var$bits(dat, pos, 1);
            // type: 0 = no compression, 1 = fixed huffman, 2 = dynamic huffman
            var type = $0c5e3e04f495ba65$var$bits(dat, pos + 1, 3);
            pos += 3;
            if (!type) {
                // go to end of byte boundary
                var s = $0c5e3e04f495ba65$var$shft(pos) + 4, l = dat[s - 4] | dat[s - 3] << 8, t = s + l;
                if (t > sl) {
                    if (noSt) $0c5e3e04f495ba65$var$err(0);
                    break;
                }
                // ensure size
                if (resize) cbuf(bt + l);
                // Copy over uncompressed data
                buf.set(dat.subarray(s, t), bt);
                // Get new bitpos, update byte count
                st.b = bt += l, st.p = pos = t * 8, st.f = final;
                continue;
            } else if (type == 1) lm = $0c5e3e04f495ba65$var$flrm, dm = $0c5e3e04f495ba65$var$fdrm, lbt = 9, dbt = 5;
            else if (type == 2) {
                //  literal                            lengths
                var hLit = $0c5e3e04f495ba65$var$bits(dat, pos, 31) + 257, hcLen = $0c5e3e04f495ba65$var$bits(dat, pos + 10, 15) + 4;
                var tl = hLit + $0c5e3e04f495ba65$var$bits(dat, pos + 5, 31) + 1;
                pos += 14;
                // length+distance tree
                var ldt = new $0c5e3e04f495ba65$var$u8(tl);
                // code length tree
                var clt = new $0c5e3e04f495ba65$var$u8(19);
                for(var i = 0; i < hcLen; ++i)// use index map to get real code
                clt[$0c5e3e04f495ba65$var$clim[i]] = $0c5e3e04f495ba65$var$bits(dat, pos + i * 3, 7);
                pos += hcLen * 3;
                // code lengths bits
                var clb = $0c5e3e04f495ba65$var$max(clt), clbmsk = (1 << clb) - 1;
                // code lengths map
                var clm = $0c5e3e04f495ba65$var$hMap(clt, clb, 1);
                for(var i = 0; i < tl;){
                    var r = clm[$0c5e3e04f495ba65$var$bits(dat, pos, clbmsk)];
                    // bits read
                    pos += r & 15;
                    // symbol
                    var s = r >> 4;
                    // code length to copy
                    if (s < 16) ldt[i++] = s;
                    else {
                        //  copy   count
                        var c = 0, n = 0;
                        if (s == 16) n = 3 + $0c5e3e04f495ba65$var$bits(dat, pos, 3), pos += 2, c = ldt[i - 1];
                        else if (s == 17) n = 3 + $0c5e3e04f495ba65$var$bits(dat, pos, 7), pos += 3;
                        else if (s == 18) n = 11 + $0c5e3e04f495ba65$var$bits(dat, pos, 127), pos += 7;
                        while(n--)ldt[i++] = c;
                    }
                }
                //    length tree                 distance tree
                var lt = ldt.subarray(0, hLit), dt = ldt.subarray(hLit);
                // max length bits
                lbt = $0c5e3e04f495ba65$var$max(lt);
                // max dist bits
                dbt = $0c5e3e04f495ba65$var$max(dt);
                lm = $0c5e3e04f495ba65$var$hMap(lt, lbt, 1);
                dm = $0c5e3e04f495ba65$var$hMap(dt, dbt, 1);
            } else $0c5e3e04f495ba65$var$err(1);
            if (pos > tbts) {
                if (noSt) $0c5e3e04f495ba65$var$err(0);
                break;
            }
        }
        // Make sure the buffer can hold this + the largest possible addition
        // Maximum chunk size (practically, theoretically infinite) is 2^17
        if (resize) cbuf(bt + 131072);
        var lms = (1 << lbt) - 1, dms = (1 << dbt) - 1;
        var lpos = pos;
        for(;; lpos = pos){
            // bits read, code
            var c = lm[$0c5e3e04f495ba65$var$bits16(dat, pos) & lms], sym = c >> 4;
            pos += c & 15;
            if (pos > tbts) {
                if (noSt) $0c5e3e04f495ba65$var$err(0);
                break;
            }
            if (!c) $0c5e3e04f495ba65$var$err(2);
            if (sym < 256) buf[bt++] = sym;
            else if (sym == 256) {
                lpos = pos, lm = null;
                break;
            } else {
                var add = sym - 254;
                // no extra bits needed if less
                if (sym > 264) {
                    // index
                    var i = sym - 257, b = $0c5e3e04f495ba65$var$fleb[i];
                    add = $0c5e3e04f495ba65$var$bits(dat, pos, (1 << b) - 1) + $0c5e3e04f495ba65$var$fl[i];
                    pos += b;
                }
                // dist
                var d = dm[$0c5e3e04f495ba65$var$bits16(dat, pos) & dms], dsym = d >> 4;
                if (!d) $0c5e3e04f495ba65$var$err(3);
                pos += d & 15;
                var dt = $0c5e3e04f495ba65$var$fd[dsym];
                if (dsym > 3) {
                    var b = $0c5e3e04f495ba65$var$fdeb[dsym];
                    dt += $0c5e3e04f495ba65$var$bits16(dat, pos) & (1 << b) - 1, pos += b;
                }
                if (pos > tbts) {
                    if (noSt) $0c5e3e04f495ba65$var$err(0);
                    break;
                }
                if (resize) cbuf(bt + 131072);
                var end = bt + add;
                if (bt < dt) {
                    var shift = dl - dt, dend = Math.min(dt, end);
                    if (shift + bt < 0) $0c5e3e04f495ba65$var$err(3);
                    for(; bt < dend; ++bt)buf[bt] = dict[shift + bt];
                }
                for(; bt < end; ++bt)buf[bt] = buf[bt - dt];
            }
        }
        st.l = lm, st.p = lpos, st.b = bt, st.f = final;
        if (lm) final = 1, st.m = lbt, st.d = dm, st.n = dbt;
    }while (!final);
    // don't reallocate for streams or user buffers
    return bt != buf.length && noBuf ? $0c5e3e04f495ba65$var$slc(buf, 0, bt) : buf.subarray(0, bt);
};
// starting at p, write the minimum number of bits that can hold v to d
var $0c5e3e04f495ba65$var$wbits = function(d, p, v) {
    v <<= p & 7;
    var o = p / 8 | 0;
    d[o] |= v;
    d[o + 1] |= v >> 8;
};
// starting at p, write the minimum number of bits (>8) that can hold v to d
var $0c5e3e04f495ba65$var$wbits16 = function(d, p, v) {
    v <<= p & 7;
    var o = p / 8 | 0;
    d[o] |= v;
    d[o + 1] |= v >> 8;
    d[o + 2] |= v >> 16;
};
// creates code lengths from a frequency table
var $0c5e3e04f495ba65$var$hTree = function(d, mb) {
    // Need extra info to make a tree
    var t = [];
    for(var i = 0; i < d.length; ++i)if (d[i]) t.push({
        s: i,
        f: d[i]
    });
    var s = t.length;
    var t2 = t.slice();
    if (!s) return {
        t: $0c5e3e04f495ba65$var$et,
        l: 0
    };
    if (s == 1) {
        var v = new $0c5e3e04f495ba65$var$u8(t[0].s + 1);
        v[t[0].s] = 1;
        return {
            t: v,
            l: 1
        };
    }
    t.sort(function(a, b) {
        return a.f - b.f;
    });
    // after i2 reaches last ind, will be stopped
    // freq must be greater than largest possible number of symbols
    t.push({
        s: -1,
        f: 25001
    });
    var l = t[0], r = t[1], i0 = 0, i1 = 1, i2 = 2;
    t[0] = {
        s: -1,
        f: l.f + r.f,
        l: l,
        r: r
    };
    // efficient algorithm from UZIP.js
    // i0 is lookbehind, i2 is lookahead - after processing two low-freq
    // symbols that combined have high freq, will start processing i2 (high-freq,
    // non-composite) symbols instead
    // see https://reddit.com/r/photopea/comments/ikekht/uzipjs_questions/
    while(i1 != s - 1){
        l = t[t[i0].f < t[i2].f ? i0++ : i2++];
        r = t[i0 != i1 && t[i0].f < t[i2].f ? i0++ : i2++];
        t[i1++] = {
            s: -1,
            f: l.f + r.f,
            l: l,
            r: r
        };
    }
    var maxSym = t2[0].s;
    for(var i = 1; i < s; ++i)if (t2[i].s > maxSym) maxSym = t2[i].s;
    // code lengths
    var tr = new $0c5e3e04f495ba65$var$u16(maxSym + 1);
    // max bits in tree
    var mbt = $0c5e3e04f495ba65$var$ln(t[i1 - 1], tr, 0);
    if (mbt > mb) {
        // more algorithms from UZIP.js
        // TODO: find out how this code works (debt)
        //  ind    debt
        var i = 0, dt = 0;
        //    left            cost
        var lft = mbt - mb, cst = 1 << lft;
        t2.sort(function(a, b) {
            return tr[b.s] - tr[a.s] || a.f - b.f;
        });
        for(; i < s; ++i){
            var i2_1 = t2[i].s;
            if (tr[i2_1] > mb) {
                dt += cst - (1 << mbt - tr[i2_1]);
                tr[i2_1] = mb;
            } else break;
        }
        dt >>= lft;
        while(dt > 0){
            var i2_2 = t2[i].s;
            if (tr[i2_2] < mb) dt -= 1 << mb - tr[i2_2]++ - 1;
            else ++i;
        }
        for(; i >= 0 && dt; --i){
            var i2_3 = t2[i].s;
            if (tr[i2_3] == mb) {
                --tr[i2_3];
                ++dt;
            }
        }
        mbt = mb;
    }
    return {
        t: new $0c5e3e04f495ba65$var$u8(tr),
        l: mbt
    };
};
// get the max length and assign length codes
var $0c5e3e04f495ba65$var$ln = function(n, l, d) {
    return n.s == -1 ? Math.max($0c5e3e04f495ba65$var$ln(n.l, l, d + 1), $0c5e3e04f495ba65$var$ln(n.r, l, d + 1)) : l[n.s] = d;
};
// length codes generation
var $0c5e3e04f495ba65$var$lc = function(c) {
    var s = c.length;
    // Note that the semicolon was intentional
    while(s && !c[--s]);
    var cl = new $0c5e3e04f495ba65$var$u16(++s);
    //  ind      num         streak
    var cli = 0, cln = c[0], cls = 1;
    var w = function(v) {
        cl[cli++] = v;
    };
    for(var i = 1; i <= s; ++i)if (c[i] == cln && i != s) ++cls;
    else {
        if (!cln && cls > 2) {
            for(; cls > 138; cls -= 138)w(32754);
            if (cls > 2) {
                w(cls > 10 ? cls - 11 << 5 | 28690 : cls - 3 << 5 | 12305);
                cls = 0;
            }
        } else if (cls > 3) {
            w(cln), --cls;
            for(; cls > 6; cls -= 6)w(8304);
            if (cls > 2) w(cls - 3 << 5 | 8208), cls = 0;
        }
        while(cls--)w(cln);
        cls = 1;
        cln = c[i];
    }
    return {
        c: cl.subarray(0, cli),
        n: s
    };
};
// calculate the length of output from tree, code lengths
var $0c5e3e04f495ba65$var$clen = function(cf, cl) {
    var l = 0;
    for(var i = 0; i < cl.length; ++i)l += cf[i] * cl[i];
    return l;
};
// writes a fixed block
// returns the new bit pos
var $0c5e3e04f495ba65$var$wfblk = function(out, pos, dat) {
    // no need to write 00 as type: TypedArray defaults to 0
    var s = dat.length;
    var o = $0c5e3e04f495ba65$var$shft(pos + 2);
    out[o] = s & 255;
    out[o + 1] = s >> 8;
    out[o + 2] = out[o] ^ 255;
    out[o + 3] = out[o + 1] ^ 255;
    for(var i = 0; i < s; ++i)out[o + i + 4] = dat[i];
    return (o + 4 + s) * 8;
};
// writes a block
var $0c5e3e04f495ba65$var$wblk = function(dat, out, final, syms, lf, df, eb, li, bs, bl, p) {
    $0c5e3e04f495ba65$var$wbits(out, p++, final);
    ++lf[256];
    var _a = $0c5e3e04f495ba65$var$hTree(lf, 15), dlt = _a.t, mlb = _a.l;
    var _b = $0c5e3e04f495ba65$var$hTree(df, 15), ddt = _b.t, mdb = _b.l;
    var _c = $0c5e3e04f495ba65$var$lc(dlt), lclt = _c.c, nlc = _c.n;
    var _d = $0c5e3e04f495ba65$var$lc(ddt), lcdt = _d.c, ndc = _d.n;
    var lcfreq = new $0c5e3e04f495ba65$var$u16(19);
    for(var i = 0; i < lclt.length; ++i)++lcfreq[lclt[i] & 31];
    for(var i = 0; i < lcdt.length; ++i)++lcfreq[lcdt[i] & 31];
    var _e = $0c5e3e04f495ba65$var$hTree(lcfreq, 7), lct = _e.t, mlcb = _e.l;
    var nlcc = 19;
    for(; nlcc > 4 && !lct[$0c5e3e04f495ba65$var$clim[nlcc - 1]]; --nlcc);
    var flen = bl + 5 << 3;
    var ftlen = $0c5e3e04f495ba65$var$clen(lf, $0c5e3e04f495ba65$var$flt) + $0c5e3e04f495ba65$var$clen(df, $0c5e3e04f495ba65$var$fdt) + eb;
    var dtlen = $0c5e3e04f495ba65$var$clen(lf, dlt) + $0c5e3e04f495ba65$var$clen(df, ddt) + eb + 14 + 3 * nlcc + $0c5e3e04f495ba65$var$clen(lcfreq, lct) + 2 * lcfreq[16] + 3 * lcfreq[17] + 7 * lcfreq[18];
    if (bs >= 0 && flen <= ftlen && flen <= dtlen) return $0c5e3e04f495ba65$var$wfblk(out, p, dat.subarray(bs, bs + bl));
    var lm, ll, dm, dl;
    $0c5e3e04f495ba65$var$wbits(out, p, 1 + (dtlen < ftlen)), p += 2;
    if (dtlen < ftlen) {
        lm = $0c5e3e04f495ba65$var$hMap(dlt, mlb, 0), ll = dlt, dm = $0c5e3e04f495ba65$var$hMap(ddt, mdb, 0), dl = ddt;
        var llm = $0c5e3e04f495ba65$var$hMap(lct, mlcb, 0);
        $0c5e3e04f495ba65$var$wbits(out, p, nlc - 257);
        $0c5e3e04f495ba65$var$wbits(out, p + 5, ndc - 1);
        $0c5e3e04f495ba65$var$wbits(out, p + 10, nlcc - 4);
        p += 14;
        for(var i = 0; i < nlcc; ++i)$0c5e3e04f495ba65$var$wbits(out, p + 3 * i, lct[$0c5e3e04f495ba65$var$clim[i]]);
        p += 3 * nlcc;
        var lcts = [
            lclt,
            lcdt
        ];
        for(var it = 0; it < 2; ++it){
            var clct = lcts[it];
            for(var i = 0; i < clct.length; ++i){
                var len = clct[i] & 31;
                $0c5e3e04f495ba65$var$wbits(out, p, llm[len]), p += lct[len];
                if (len > 15) $0c5e3e04f495ba65$var$wbits(out, p, clct[i] >> 5 & 127), p += clct[i] >> 12;
            }
        }
    } else lm = $0c5e3e04f495ba65$var$flm, ll = $0c5e3e04f495ba65$var$flt, dm = $0c5e3e04f495ba65$var$fdm, dl = $0c5e3e04f495ba65$var$fdt;
    for(var i = 0; i < li; ++i){
        var sym = syms[i];
        if (sym > 255) {
            var len = sym >> 18 & 31;
            $0c5e3e04f495ba65$var$wbits16(out, p, lm[len + 257]), p += ll[len + 257];
            if (len > 7) $0c5e3e04f495ba65$var$wbits(out, p, sym >> 23 & 31), p += $0c5e3e04f495ba65$var$fleb[len];
            var dst = sym & 31;
            $0c5e3e04f495ba65$var$wbits16(out, p, dm[dst]), p += dl[dst];
            if (dst > 3) $0c5e3e04f495ba65$var$wbits16(out, p, sym >> 5 & 8191), p += $0c5e3e04f495ba65$var$fdeb[dst];
        } else $0c5e3e04f495ba65$var$wbits16(out, p, lm[sym]), p += ll[sym];
    }
    $0c5e3e04f495ba65$var$wbits16(out, p, lm[256]);
    return p + ll[256];
};
// deflate options (nice << 13) | chain
var $0c5e3e04f495ba65$var$deo = /*#__PURE__*/ new $0c5e3e04f495ba65$var$i32([
    65540,
    131080,
    131088,
    131104,
    262176,
    1048704,
    1048832,
    2114560,
    2117632
]);
// empty
var $0c5e3e04f495ba65$var$et = /*#__PURE__*/ new $0c5e3e04f495ba65$var$u8(0);
// compresses data into a raw DEFLATE buffer
var $0c5e3e04f495ba65$var$dflt = function(dat, lvl, plvl, pre, post, st) {
    var s = st.z || dat.length;
    var o = new $0c5e3e04f495ba65$var$u8(pre + s + 5 * (1 + Math.ceil(s / 7000)) + post);
    // writing to this writes to the output buffer
    var w = o.subarray(pre, o.length - post);
    var lst = st.l;
    var pos = (st.r || 0) & 7;
    if (lvl) {
        if (pos) w[0] = st.r >> 3;
        var opt = $0c5e3e04f495ba65$var$deo[lvl - 1];
        var n = opt >> 13, c = opt & 8191;
        var msk_1 = (1 << plvl) - 1;
        //    prev 2-byte val map    curr 2-byte val map
        var prev = st.p || new $0c5e3e04f495ba65$var$u16(32768), head = st.h || new $0c5e3e04f495ba65$var$u16(msk_1 + 1);
        var bs1_1 = Math.ceil(plvl / 3), bs2_1 = 2 * bs1_1;
        var hsh = function(i) {
            return (dat[i] ^ dat[i + 1] << bs1_1 ^ dat[i + 2] << bs2_1) & msk_1;
        };
        // 24576 is an arbitrary number of maximum symbols per block
        // 424 buffer for last block
        var syms = new $0c5e3e04f495ba65$var$i32(25000);
        // length/literal freq   distance freq
        var lf = new $0c5e3e04f495ba65$var$u16(288), df = new $0c5e3e04f495ba65$var$u16(32);
        //  l/lcnt  exbits  index          l/lind  waitdx          blkpos
        var lc_1 = 0, eb = 0, i = st.i || 0, li = 0, wi = st.w || 0, bs = 0;
        for(; i + 2 < s; ++i){
            // hash value
            var hv = hsh(i);
            // index mod 32768    previous index mod
            var imod = i & 32767, pimod = head[hv];
            prev[imod] = pimod;
            head[hv] = imod;
            // We always should modify head and prev, but only add symbols if
            // this data is not yet processed ("wait" for wait index)
            if (wi <= i) {
                // bytes remaining
                var rem = s - i;
                if ((lc_1 > 7000 || li > 24576) && (rem > 423 || !lst)) {
                    pos = $0c5e3e04f495ba65$var$wblk(dat, w, 0, syms, lf, df, eb, li, bs, i - bs, pos);
                    li = lc_1 = eb = 0, bs = i;
                    for(var j = 0; j < 286; ++j)lf[j] = 0;
                    for(var j = 0; j < 30; ++j)df[j] = 0;
                }
                //  len    dist   chain
                var l = 2, d = 0, ch_1 = c, dif = imod - pimod & 32767;
                if (rem > 2 && hv == hsh(i - dif)) {
                    var maxn = Math.min(n, rem) - 1;
                    var maxd = Math.min(32767, i);
                    // max possible length
                    // not capped at dif because decompressors implement "rolling" index population
                    var ml = Math.min(258, rem);
                    while(dif <= maxd && --ch_1 && imod != pimod){
                        if (dat[i + l] == dat[i + l - dif]) {
                            var nl = 0;
                            for(; nl < ml && dat[i + nl] == dat[i + nl - dif]; ++nl);
                            if (nl > l) {
                                l = nl, d = dif;
                                // break out early when we reach "nice" (we are satisfied enough)
                                if (nl > maxn) break;
                                // now, find the rarest 2-byte sequence within this
                                // length of literals and search for that instead.
                                // Much faster than just using the start
                                var mmd = Math.min(dif, nl - 2);
                                var md = 0;
                                for(var j = 0; j < mmd; ++j){
                                    var ti = i - dif + j & 32767;
                                    var pti = prev[ti];
                                    var cd = ti - pti & 32767;
                                    if (cd > md) md = cd, pimod = ti;
                                }
                            }
                        }
                        // check the previous match
                        imod = pimod, pimod = prev[imod];
                        dif += imod - pimod & 32767;
                    }
                }
                // d will be nonzero only when a match was found
                if (d) {
                    // store both dist and len data in one int32
                    // Make sure this is recognized as a len/dist with 28th bit (2^28)
                    syms[li++] = 268435456 | $0c5e3e04f495ba65$var$revfl[l] << 18 | $0c5e3e04f495ba65$var$revfd[d];
                    var lin = $0c5e3e04f495ba65$var$revfl[l] & 31, din = $0c5e3e04f495ba65$var$revfd[d] & 31;
                    eb += $0c5e3e04f495ba65$var$fleb[lin] + $0c5e3e04f495ba65$var$fdeb[din];
                    ++lf[257 + lin];
                    ++df[din];
                    wi = i + l;
                    ++lc_1;
                } else {
                    syms[li++] = dat[i];
                    ++lf[dat[i]];
                }
            }
        }
        for(i = Math.max(i, wi); i < s; ++i){
            syms[li++] = dat[i];
            ++lf[dat[i]];
        }
        pos = $0c5e3e04f495ba65$var$wblk(dat, w, lst, syms, lf, df, eb, li, bs, i - bs, pos);
        if (!lst) {
            st.r = pos & 7 | w[pos / 8 | 0] << 3;
            // shft(pos) now 1 less if pos & 7 != 0
            pos -= 7;
            st.h = head, st.p = prev, st.i = i, st.w = wi;
        }
    } else {
        for(var i = st.w || 0; i < s + lst; i += 65535){
            // end
            var e = i + 65535;
            if (e >= s) {
                // write final block
                w[pos / 8 | 0] = lst;
                e = s;
            }
            pos = $0c5e3e04f495ba65$var$wfblk(w, pos + 1, dat.subarray(i, e));
        }
        st.i = s;
    }
    return $0c5e3e04f495ba65$var$slc(o, 0, pre + $0c5e3e04f495ba65$var$shft(pos) + post);
};
// CRC32 table
var $0c5e3e04f495ba65$var$crct = /*#__PURE__*/ function() {
    var t = new Int32Array(256);
    for(var i = 0; i < 256; ++i){
        var c = i, k = 9;
        while(--k)c = (c & 1 && -306674912) ^ c >>> 1;
        t[i] = c;
    }
    return t;
}();
// CRC32
var $0c5e3e04f495ba65$var$crc = function() {
    var c = -1;
    return {
        p: function(d) {
            // closures have awful performance
            var cr = c;
            for(var i = 0; i < d.length; ++i)cr = $0c5e3e04f495ba65$var$crct[cr & 255 ^ d[i]] ^ cr >>> 8;
            c = cr;
        },
        d: function() {
            return ~c;
        }
    };
};
// Adler32
var $0c5e3e04f495ba65$var$adler = function() {
    var a = 1, b = 0;
    return {
        p: function(d) {
            // closures have awful performance
            var n = a, m = b;
            var l = d.length | 0;
            for(var i = 0; i != l;){
                var e = Math.min(i + 2655, l);
                for(; i < e; ++i)m += n += d[i];
                n = (n & 65535) + 15 * (n >> 16), m = (m & 65535) + 15 * (m >> 16);
            }
            a = n, b = m;
        },
        d: function() {
            a %= 65521, b %= 65521;
            return (a & 255) << 24 | (a & 0xFF00) << 8 | (b & 255) << 8 | b >> 8;
        }
    };
};
// deflate with opts
var $0c5e3e04f495ba65$var$dopt = function(dat, opt, pre, post, st) {
    if (!st) {
        st = {
            l: 1
        };
        if (opt.dictionary) {
            var dict = opt.dictionary.subarray(-32768);
            var newDat = new $0c5e3e04f495ba65$var$u8(dict.length + dat.length);
            newDat.set(dict);
            newDat.set(dat, dict.length);
            dat = newDat;
            st.w = dict.length;
        }
    }
    return $0c5e3e04f495ba65$var$dflt(dat, opt.level == null ? 6 : opt.level, opt.mem == null ? st.l ? Math.ceil(Math.max(8, Math.min(13, Math.log(dat.length))) * 1.5) : 20 : 12 + opt.mem, pre, post, st);
};
// Walmart object spread
var $0c5e3e04f495ba65$var$mrg = function(a, b) {
    var o = {};
    for(var k in a)o[k] = a[k];
    for(var k in b)o[k] = b[k];
    return o;
};
// worker clone
// This is possibly the craziest part of the entire codebase, despite how simple it may seem.
// The only parameter to this function is a closure that returns an array of variables outside of the function scope.
// We're going to try to figure out the variable names used in the closure as strings because that is crucial for workerization.
// We will return an object mapping of true variable name to value (basically, the current scope as a JS object).
// The reason we can't just use the original variable names is minifiers mangling the toplevel scope.
// This took me three weeks to figure out how to do.
var $0c5e3e04f495ba65$var$wcln = function(fn, fnStr, td) {
    var dt = fn();
    var st = fn.toString();
    var ks = st.slice(st.indexOf('[') + 1, st.lastIndexOf(']')).replace(/\s+/g, '').split(',');
    for(var i = 0; i < dt.length; ++i){
        var v = dt[i], k = ks[i];
        if (typeof v == 'function') {
            fnStr += ';' + k + '=';
            var st_1 = v.toString();
            if (v.prototype) {
                // for global objects
                if (st_1.indexOf('[native code]') != -1) {
                    var spInd = st_1.indexOf(' ', 8) + 1;
                    fnStr += st_1.slice(spInd, st_1.indexOf('(', spInd));
                } else {
                    fnStr += st_1;
                    for(var t in v.prototype)fnStr += ';' + k + '.prototype.' + t + '=' + v.prototype[t].toString();
                }
            } else fnStr += st_1;
        } else td[k] = v;
    }
    return fnStr;
};
var $0c5e3e04f495ba65$var$ch = [];
// clone bufs
var $0c5e3e04f495ba65$var$cbfs = function(v) {
    var tl = [];
    for(var k in v)if (v[k].buffer) tl.push((v[k] = new v[k].constructor(v[k])).buffer);
    return tl;
};
// use a worker to execute code
var $0c5e3e04f495ba65$var$wrkr = function(fns, init, id, cb) {
    if (!$0c5e3e04f495ba65$var$ch[id]) {
        var fnStr = '', td_1 = {}, m = fns.length - 1;
        for(var i = 0; i < m; ++i)fnStr = $0c5e3e04f495ba65$var$wcln(fns[i], fnStr, td_1);
        $0c5e3e04f495ba65$var$ch[id] = {
            c: $0c5e3e04f495ba65$var$wcln(fns[m], fnStr, td_1),
            e: td_1
        };
    }
    var td = $0c5e3e04f495ba65$var$mrg({}, $0c5e3e04f495ba65$var$ch[id].e);
    return $0c5e3e04f495ba65$var$wk($0c5e3e04f495ba65$var$ch[id].c + ';onmessage=function(e){for(var k in e.data)self[k]=e.data[k];onmessage=' + init.toString() + '}', id, td, $0c5e3e04f495ba65$var$cbfs(td), cb);
};
// base async inflate fn
var $0c5e3e04f495ba65$var$bInflt = function() {
    return [
        $0c5e3e04f495ba65$var$u8,
        $0c5e3e04f495ba65$var$u16,
        $0c5e3e04f495ba65$var$i32,
        $0c5e3e04f495ba65$var$fleb,
        $0c5e3e04f495ba65$var$fdeb,
        $0c5e3e04f495ba65$var$clim,
        $0c5e3e04f495ba65$var$fl,
        $0c5e3e04f495ba65$var$fd,
        $0c5e3e04f495ba65$var$flrm,
        $0c5e3e04f495ba65$var$fdrm,
        $0c5e3e04f495ba65$var$rev,
        $0c5e3e04f495ba65$var$ec,
        $0c5e3e04f495ba65$var$hMap,
        $0c5e3e04f495ba65$var$max,
        $0c5e3e04f495ba65$var$bits,
        $0c5e3e04f495ba65$var$bits16,
        $0c5e3e04f495ba65$var$shft,
        $0c5e3e04f495ba65$var$slc,
        $0c5e3e04f495ba65$var$err,
        $0c5e3e04f495ba65$var$inflt,
        $0c5e3e04f495ba65$export$90366d8b308ba94a,
        $0c5e3e04f495ba65$var$pbf,
        $0c5e3e04f495ba65$var$gopt
    ];
};
var $0c5e3e04f495ba65$var$bDflt = function() {
    return [
        $0c5e3e04f495ba65$var$u8,
        $0c5e3e04f495ba65$var$u16,
        $0c5e3e04f495ba65$var$i32,
        $0c5e3e04f495ba65$var$fleb,
        $0c5e3e04f495ba65$var$fdeb,
        $0c5e3e04f495ba65$var$clim,
        $0c5e3e04f495ba65$var$revfl,
        $0c5e3e04f495ba65$var$revfd,
        $0c5e3e04f495ba65$var$flm,
        $0c5e3e04f495ba65$var$flt,
        $0c5e3e04f495ba65$var$fdm,
        $0c5e3e04f495ba65$var$fdt,
        $0c5e3e04f495ba65$var$rev,
        $0c5e3e04f495ba65$var$deo,
        $0c5e3e04f495ba65$var$et,
        $0c5e3e04f495ba65$var$hMap,
        $0c5e3e04f495ba65$var$wbits,
        $0c5e3e04f495ba65$var$wbits16,
        $0c5e3e04f495ba65$var$hTree,
        $0c5e3e04f495ba65$var$ln,
        $0c5e3e04f495ba65$var$lc,
        $0c5e3e04f495ba65$var$clen,
        $0c5e3e04f495ba65$var$wfblk,
        $0c5e3e04f495ba65$var$wblk,
        $0c5e3e04f495ba65$var$shft,
        $0c5e3e04f495ba65$var$slc,
        $0c5e3e04f495ba65$var$dflt,
        $0c5e3e04f495ba65$var$dopt,
        $0c5e3e04f495ba65$export$21533ff51b8a0b4a,
        $0c5e3e04f495ba65$var$pbf
    ];
};
// gzip extra
var $0c5e3e04f495ba65$var$gze = function() {
    return [
        $0c5e3e04f495ba65$var$gzh,
        $0c5e3e04f495ba65$var$gzhl,
        $0c5e3e04f495ba65$var$wbytes,
        $0c5e3e04f495ba65$var$crc,
        $0c5e3e04f495ba65$var$crct
    ];
};
// gunzip extra
var $0c5e3e04f495ba65$var$guze = function() {
    return [
        $0c5e3e04f495ba65$var$gzs,
        $0c5e3e04f495ba65$var$gzl
    ];
};
// zlib extra
var $0c5e3e04f495ba65$var$zle = function() {
    return [
        $0c5e3e04f495ba65$var$zlh,
        $0c5e3e04f495ba65$var$wbytes,
        $0c5e3e04f495ba65$var$adler
    ];
};
// unzlib extra
var $0c5e3e04f495ba65$var$zule = function() {
    return [
        $0c5e3e04f495ba65$var$zls
    ];
};
// post buf
var $0c5e3e04f495ba65$var$pbf = function(msg) {
    return postMessage(msg, [
        msg.buffer
    ]);
};
// get opts
var $0c5e3e04f495ba65$var$gopt = function(o) {
    return o && {
        out: o.size && new $0c5e3e04f495ba65$var$u8(o.size),
        dictionary: o.dictionary
    };
};
// async helper
var $0c5e3e04f495ba65$var$cbify = function(dat, opts, fns, init, id, cb) {
    var w = $0c5e3e04f495ba65$var$wrkr(fns, init, id, function(err, dat) {
        w.terminate();
        cb(err, dat);
    });
    w.postMessage([
        dat,
        opts
    ], opts.consume ? [
        dat.buffer
    ] : []);
    return function() {
        w.terminate();
    };
};
// auto stream
var $0c5e3e04f495ba65$var$astrm = function(strm) {
    strm.ondata = function(dat, final) {
        return postMessage([
            dat,
            final
        ], [
            dat.buffer
        ]);
    };
    return function(ev) {
        if (ev.data[0]) {
            strm.push(ev.data[0], ev.data[1]);
            postMessage([
                ev.data[0].length
            ]);
        } else strm.flush(ev.data[1]);
    };
};
// async stream attach
var $0c5e3e04f495ba65$var$astrmify = function(fns, strm, opts, init, id, flush, ext) {
    var t;
    var w = $0c5e3e04f495ba65$var$wrkr(fns, init, id, function(err, dat) {
        if (err) w.terminate(), strm.ondata.call(strm, err);
        else if (!Array.isArray(dat)) ext(dat);
        else if (dat.length == 1) {
            strm.queuedSize -= dat[0];
            if (strm.ondrain) strm.ondrain(dat[0]);
        } else {
            if (dat[1]) w.terminate();
            strm.ondata.call(strm, err, dat[0], dat[1]);
        }
    });
    w.postMessage(opts);
    strm.queuedSize = 0;
    strm.push = function(d, f) {
        if (!strm.ondata) $0c5e3e04f495ba65$var$err(5);
        if (t) strm.ondata($0c5e3e04f495ba65$var$err(4, 0, 1), null, !!f);
        strm.queuedSize += d.length;
        // can fail for cross-realm Uint8Array, but ok - only a small performance penalty
        w.postMessage([
            d,
            t = f
        ], d.buffer instanceof ArrayBuffer ? [
            d.buffer
        ] : []);
    };
    strm.terminate = function() {
        w.terminate();
    };
    if (flush) strm.flush = function(sync) {
        w.postMessage([
            0,
            sync
        ]);
    };
};
// read 2 bytes
var $0c5e3e04f495ba65$var$b2 = function(d, b) {
    return d[b] | d[b + 1] << 8;
};
// read 4 bytes
var $0c5e3e04f495ba65$var$b4 = function(d, b) {
    return (d[b] | d[b + 1] << 8 | d[b + 2] << 16 | d[b + 3] << 24) >>> 0;
};
// read 8 bytes
var $0c5e3e04f495ba65$var$b8 = function(d, b) {
    return $0c5e3e04f495ba65$var$b4(d, b) + $0c5e3e04f495ba65$var$b4(d, b + 4) * 4294967296;
};
// write bytes
var $0c5e3e04f495ba65$var$wbytes = function(d, b, v) {
    for(; v; ++b)d[b] = v, v >>>= 8;
};
// gzip header
var $0c5e3e04f495ba65$var$gzh = function(c, o) {
    var fn = o.filename;
    c[0] = 31, c[1] = 139, c[2] = 8, c[8] = o.level < 2 ? 4 : o.level == 9 ? 2 : 0, c[9] = 3; // assume Unix
    if (o.mtime != 0) $0c5e3e04f495ba65$var$wbytes(c, 4, Math.floor(new Date(o.mtime || Date.now()) / 1000));
    if (fn) {
        c[3] = 8;
        for(var i = 0; i <= fn.length; ++i)c[i + 10] = fn.charCodeAt(i);
    }
};
// gzip footer: -8 to -4 = CRC, -4 to -0 is length
// gzip start
var $0c5e3e04f495ba65$var$gzs = function(d) {
    if (d[0] != 31 || d[1] != 139 || d[2] != 8) $0c5e3e04f495ba65$var$err(6, 'invalid gzip data');
    var flg = d[3];
    var st = 10;
    if (flg & 4) st += (d[10] | d[11] << 8) + 2;
    for(var zs = (flg >> 3 & 1) + (flg >> 4 & 1); zs > 0; zs -= !d[st++]);
    return st + (flg & 2);
};
// gzip length
var $0c5e3e04f495ba65$var$gzl = function(d) {
    var l = d.length;
    return (d[l - 4] | d[l - 3] << 8 | d[l - 2] << 16 | d[l - 1] << 24) >>> 0;
};
// gzip header length
var $0c5e3e04f495ba65$var$gzhl = function(o) {
    return 10 + (o.filename ? o.filename.length + 1 : 0);
};
// zlib header
var $0c5e3e04f495ba65$var$zlh = function(c, o) {
    var lv = o.level, fl = lv == 0 ? 0 : lv < 6 ? 1 : lv == 9 ? 3 : 2;
    c[0] = 120, c[1] = fl << 6 | (o.dictionary && 32);
    c[1] |= 31 - (c[0] << 8 | c[1]) % 31;
    if (o.dictionary) {
        var h = $0c5e3e04f495ba65$var$adler();
        h.p(o.dictionary);
        $0c5e3e04f495ba65$var$wbytes(c, 2, h.d());
    }
};
// zlib start
var $0c5e3e04f495ba65$var$zls = function(d, dict) {
    if ((d[0] & 15) != 8 || d[0] >> 4 > 7 || (d[0] << 8 | d[1]) % 31) $0c5e3e04f495ba65$var$err(6, 'invalid zlib data');
    if ((d[1] >> 5 & 1) == +!dict) $0c5e3e04f495ba65$var$err(6, 'invalid zlib data: ' + (d[1] & 32 ? 'need' : 'unexpected') + ' dictionary');
    return (d[1] >> 3 & 4) + 2;
};
function $0c5e3e04f495ba65$var$StrmOpt(opts, cb) {
    if (typeof opts == 'function') cb = opts, opts = {};
    this.ondata = cb;
    return opts;
}
/**
 * Streaming DEFLATE compression
 */ var $0c5e3e04f495ba65$export$ae157b6234afe138 = /*#__PURE__*/ function() {
    function Deflate(opts, cb) {
        if (typeof opts == 'function') cb = opts, opts = {};
        this.ondata = cb;
        this.o = opts || {};
        this.s = {
            l: 0,
            i: 32768,
            w: 32768,
            z: 32768
        };
        // Buffer length must always be 0 mod 32768 for index calculations to be correct when modifying head and prev
        // 98304 = 32768 (lookback) + 65536 (common chunk size)
        this.b = new $0c5e3e04f495ba65$var$u8(98304);
        if (this.o.dictionary) {
            var dict = this.o.dictionary.subarray(-32768);
            this.b.set(dict, 32768 - dict.length);
            this.s.i = 32768 - dict.length;
        }
    }
    Deflate.prototype.p = function(c, f) {
        this.ondata($0c5e3e04f495ba65$var$dopt(c, this.o, 0, 0, this.s), f);
    };
    /**
     * Pushes a chunk to be deflated
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Deflate.prototype.push = function(chunk, final) {
        if (!this.ondata) $0c5e3e04f495ba65$var$err(5);
        if (this.s.l) $0c5e3e04f495ba65$var$err(4);
        var endLen = chunk.length + this.s.z;
        if (endLen > this.b.length) {
            if (endLen > 2 * this.b.length - 32768) {
                var newBuf = new $0c5e3e04f495ba65$var$u8(endLen & -32768);
                newBuf.set(this.b.subarray(0, this.s.z));
                this.b = newBuf;
            }
            var split = this.b.length - this.s.z;
            this.b.set(chunk.subarray(0, split), this.s.z);
            this.s.z = this.b.length;
            this.p(this.b, false);
            this.b.set(this.b.subarray(-32768));
            this.b.set(chunk.subarray(split), 32768);
            this.s.z = chunk.length - split + 32768;
            this.s.i = 32766, this.s.w = 32768;
        } else {
            this.b.set(chunk, this.s.z);
            this.s.z += chunk.length;
        }
        this.s.l = final & 1;
        if (this.s.z > this.s.w + 8191 || final) {
            this.p(this.b, final || false);
            this.s.w = this.s.i, this.s.i -= 2;
        }
        if (final) {
            // cleanup unneeded buffers/state to reduce memory usage
            this.s = this.o = {};
            this.b = $0c5e3e04f495ba65$var$et;
        }
    };
    /**
     * Flushes buffered uncompressed data. Useful to immediately retrieve the
     * deflated output for small inputs.
     * @param sync Whether to flush to a byte boundary. A sync flush takes 4-5
     *             extra bytes, but guarantees all pushed data is immediately
     *             decompressible. A separate DEFLATE stream may be concatenated
     *             with the current output after a sync flush.
     */ Deflate.prototype.flush = function(sync) {
        if (!this.ondata) $0c5e3e04f495ba65$var$err(5);
        if (this.s.l) $0c5e3e04f495ba65$var$err(4);
        this.p(this.b, false);
        this.s.w = this.s.i, this.s.i -= 2;
        // could technically skip writing the type-0 block for (this.s.r & 7) == 0,
        // but the deterministic trailer (00 00 FF FF) is useful in some situations
        if (sync) {
            var c = new $0c5e3e04f495ba65$var$u8(6);
            c[0] = this.s.r >> 3;
            // write empty, non-final type-0 block
            var ep = $0c5e3e04f495ba65$var$wfblk(c, this.s.r, $0c5e3e04f495ba65$var$et);
            this.s.r = 0;
            this.ondata(c.subarray(0, ep >> 3), false);
        }
    };
    return Deflate;
}();
/**
 * Asynchronous streaming DEFLATE compression
 */ var $0c5e3e04f495ba65$export$84e526fabcba03e3 = /*#__PURE__*/ function() {
    function AsyncDeflate(opts, cb) {
        $0c5e3e04f495ba65$var$astrmify([
            $0c5e3e04f495ba65$var$bDflt,
            function() {
                return [
                    $0c5e3e04f495ba65$var$astrm,
                    $0c5e3e04f495ba65$export$ae157b6234afe138
                ];
            }
        ], this, $0c5e3e04f495ba65$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $0c5e3e04f495ba65$export$ae157b6234afe138(ev.data);
            onmessage = $0c5e3e04f495ba65$var$astrm(strm);
        }, 6, 1);
    }
    return AsyncDeflate;
}();
function $0c5e3e04f495ba65$export$2316623ecd1285ab(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $0c5e3e04f495ba65$var$err(7);
    return $0c5e3e04f495ba65$var$cbify(data, opts, [
        $0c5e3e04f495ba65$var$bDflt
    ], function(ev) {
        return $0c5e3e04f495ba65$var$pbf($0c5e3e04f495ba65$export$21533ff51b8a0b4a(ev.data[0], ev.data[1]));
    }, 0, cb);
}
function $0c5e3e04f495ba65$export$21533ff51b8a0b4a(data, opts) {
    return $0c5e3e04f495ba65$var$dopt(data, opts || {}, 0, 0);
}
/**
 * Streaming DEFLATE decompression
 */ var $0c5e3e04f495ba65$export$d1de70a877d6e43c = /*#__PURE__*/ function() {
    function Inflate(opts, cb) {
        // no StrmOpt here to avoid adding to workerizer
        if (typeof opts == 'function') cb = opts, opts = {};
        this.ondata = cb;
        var dict = opts && opts.dictionary && opts.dictionary.subarray(-32768);
        this.s = {
            i: 0,
            b: dict ? dict.length : 0
        };
        this.o = new $0c5e3e04f495ba65$var$u8(32768);
        this.p = new $0c5e3e04f495ba65$var$u8(0);
        if (dict) this.o.set(dict);
    }
    Inflate.prototype.e = function(c) {
        if (!this.ondata) $0c5e3e04f495ba65$var$err(5);
        if (this.d) $0c5e3e04f495ba65$var$err(4);
        if (!this.p.length) this.p = c;
        else if (c.length) {
            var n = new $0c5e3e04f495ba65$var$u8(this.p.length + c.length);
            n.set(this.p), n.set(c, this.p.length), this.p = n;
        }
    };
    Inflate.prototype.c = function(final) {
        this.s.i = +(this.d = final || false);
        var bts = this.s.b;
        var dt = $0c5e3e04f495ba65$var$inflt(this.p, this.s, this.o);
        this.ondata($0c5e3e04f495ba65$var$slc(dt, bts, this.s.b), this.d);
        this.o = $0c5e3e04f495ba65$var$slc(dt, this.s.b - 32768), this.s.b = this.o.length;
        this.p = $0c5e3e04f495ba65$var$slc(this.p, this.s.p / 8 | 0), this.s.p &= 7;
    };
    /**
     * Pushes a chunk to be inflated
     * @param chunk The chunk to push
     * @param final Whether this is the final chunk
     */ Inflate.prototype.push = function(chunk, final) {
        this.e(chunk), this.c(final);
    };
    return Inflate;
}();
/**
 * Asynchronous streaming DEFLATE decompression
 */ var $0c5e3e04f495ba65$export$fff8358d6dbaa9cc = /*#__PURE__*/ function() {
    function AsyncInflate(opts, cb) {
        $0c5e3e04f495ba65$var$astrmify([
            $0c5e3e04f495ba65$var$bInflt,
            function() {
                return [
                    $0c5e3e04f495ba65$var$astrm,
                    $0c5e3e04f495ba65$export$d1de70a877d6e43c
                ];
            }
        ], this, $0c5e3e04f495ba65$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $0c5e3e04f495ba65$export$d1de70a877d6e43c(ev.data);
            onmessage = $0c5e3e04f495ba65$var$astrm(strm);
        }, 7, 0);
    }
    return AsyncInflate;
}();
function $0c5e3e04f495ba65$export$cae1ce83fe4a1782(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $0c5e3e04f495ba65$var$err(7);
    return $0c5e3e04f495ba65$var$cbify(data, opts, [
        $0c5e3e04f495ba65$var$bInflt
    ], function(ev) {
        return $0c5e3e04f495ba65$var$pbf($0c5e3e04f495ba65$export$90366d8b308ba94a(ev.data[0], $0c5e3e04f495ba65$var$gopt(ev.data[1])));
    }, 1, cb);
}
function $0c5e3e04f495ba65$export$90366d8b308ba94a(data, opts) {
    return $0c5e3e04f495ba65$var$inflt(data, {
        i: 2
    }, opts && opts.out, opts && opts.dictionary);
}
// before you yell at me for not just using extends, my reason is that TS inheritance is hard to workerize.
/**
 * Streaming GZIP compression
 */ var $0c5e3e04f495ba65$export$8e4b66d280bf8342 = /*#__PURE__*/ function() {
    function Gzip(opts, cb) {
        this.c = $0c5e3e04f495ba65$var$crc();
        this.l = 0;
        this.v = 1;
        $0c5e3e04f495ba65$export$ae157b6234afe138.call(this, opts, cb);
    }
    /**
     * Pushes a chunk to be GZIPped
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Gzip.prototype.push = function(chunk, final) {
        this.c.p(chunk);
        this.l += chunk.length;
        $0c5e3e04f495ba65$export$ae157b6234afe138.prototype.push.call(this, chunk, final);
    };
    Gzip.prototype.p = function(c, f) {
        var raw = $0c5e3e04f495ba65$var$dopt(c, this.o, this.v && $0c5e3e04f495ba65$var$gzhl(this.o), f && 8, this.s);
        if (this.v) $0c5e3e04f495ba65$var$gzh(raw, this.o), this.v = 0;
        if (f) $0c5e3e04f495ba65$var$wbytes(raw, raw.length - 8, this.c.d()), $0c5e3e04f495ba65$var$wbytes(raw, raw.length - 4, this.l);
        this.ondata(raw, f);
    };
    /**
     * Flushes buffered uncompressed data. Useful to immediately retrieve the
     * GZIPped output for small inputs.
     * @param sync Whether to flush to a byte boundary. A sync flush takes 4-5
     *             extra bytes, but guarantees all pushed data is immediately
     *             decompressible.
     */ Gzip.prototype.flush = function(sync) {
        $0c5e3e04f495ba65$export$ae157b6234afe138.prototype.flush.call(this, sync);
    };
    return Gzip;
}();
/**
 * Asynchronous streaming GZIP compression
 */ var $0c5e3e04f495ba65$export$b4c75ae96cdf708b = /*#__PURE__*/ function() {
    function AsyncGzip(opts, cb) {
        $0c5e3e04f495ba65$var$astrmify([
            $0c5e3e04f495ba65$var$bDflt,
            $0c5e3e04f495ba65$var$gze,
            function() {
                return [
                    $0c5e3e04f495ba65$var$astrm,
                    $0c5e3e04f495ba65$export$ae157b6234afe138,
                    $0c5e3e04f495ba65$export$8e4b66d280bf8342
                ];
            }
        ], this, $0c5e3e04f495ba65$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $0c5e3e04f495ba65$export$8e4b66d280bf8342(ev.data);
            onmessage = $0c5e3e04f495ba65$var$astrm(strm);
        }, 8, 1);
    }
    return AsyncGzip;
}();
function $0c5e3e04f495ba65$export$69f0ea7cf3a331a8(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $0c5e3e04f495ba65$var$err(7);
    return $0c5e3e04f495ba65$var$cbify(data, opts, [
        $0c5e3e04f495ba65$var$bDflt,
        $0c5e3e04f495ba65$var$gze,
        function() {
            return [
                $0c5e3e04f495ba65$export$3d616c3fb3e15483
            ];
        }
    ], function(ev) {
        return $0c5e3e04f495ba65$var$pbf($0c5e3e04f495ba65$export$3d616c3fb3e15483(ev.data[0], ev.data[1]));
    }, 2, cb);
}
function $0c5e3e04f495ba65$export$3d616c3fb3e15483(data, opts) {
    if (!opts) opts = {};
    var c = $0c5e3e04f495ba65$var$crc(), l = data.length;
    c.p(data);
    var d = $0c5e3e04f495ba65$var$dopt(data, opts, $0c5e3e04f495ba65$var$gzhl(opts), 8), s = d.length;
    return $0c5e3e04f495ba65$var$gzh(d, opts), $0c5e3e04f495ba65$var$wbytes(d, s - 8, c.d()), $0c5e3e04f495ba65$var$wbytes(d, s - 4, l), d;
}
/**
 * Streaming single or multi-member GZIP decompression
 */ var $0c5e3e04f495ba65$export$4cb607de6db70415 = /*#__PURE__*/ function() {
    function Gunzip(opts, cb) {
        this.v = 1;
        this.r = 0;
        $0c5e3e04f495ba65$export$d1de70a877d6e43c.call(this, opts, cb);
    }
    /**
     * Pushes a chunk to be GUNZIPped
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Gunzip.prototype.push = function(chunk, final) {
        $0c5e3e04f495ba65$export$d1de70a877d6e43c.prototype.e.call(this, chunk);
        this.r += chunk.length;
        if (this.v) {
            var p = this.p.subarray(this.v - 1);
            var s = p.length > 3 ? $0c5e3e04f495ba65$var$gzs(p) : 4;
            if (s > p.length) {
                if (!final) return;
            } else if (this.v > 1 && this.onmember) this.onmember(this.r - p.length);
            this.p = p.subarray(s), this.v = 0;
        }
        // necessary to prevent TS from using the closure value
        // This allows for workerization to function correctly
        $0c5e3e04f495ba65$export$d1de70a877d6e43c.prototype.c.call(this, 0);
        // process concatenated GZIP
        if (this.s.f && !this.s.l) {
            this.v = $0c5e3e04f495ba65$var$shft(this.s.p) + 9;
            this.s = {
                i: 0
            };
            this.o = new $0c5e3e04f495ba65$var$u8(0);
            this.push(new $0c5e3e04f495ba65$var$u8(0), final);
        } else if (final) $0c5e3e04f495ba65$export$d1de70a877d6e43c.prototype.c.call(this, final);
    };
    return Gunzip;
}();
/**
 * Asynchronous streaming single or multi-member GZIP decompression
 */ var $0c5e3e04f495ba65$export$d5adcdd968132151 = /*#__PURE__*/ function() {
    function AsyncGunzip(opts, cb) {
        var _this = this;
        $0c5e3e04f495ba65$var$astrmify([
            $0c5e3e04f495ba65$var$bInflt,
            $0c5e3e04f495ba65$var$guze,
            function() {
                return [
                    $0c5e3e04f495ba65$var$astrm,
                    $0c5e3e04f495ba65$export$d1de70a877d6e43c,
                    $0c5e3e04f495ba65$export$4cb607de6db70415
                ];
            }
        ], this, $0c5e3e04f495ba65$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $0c5e3e04f495ba65$export$4cb607de6db70415(ev.data);
            strm.onmember = function(offset) {
                return postMessage(offset);
            };
            onmessage = $0c5e3e04f495ba65$var$astrm(strm);
        }, 9, 0, function(offset) {
            return _this.onmember && _this.onmember(offset);
        });
    }
    return AsyncGunzip;
}();
function $0c5e3e04f495ba65$export$b6df3e950734d697(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $0c5e3e04f495ba65$var$err(7);
    return $0c5e3e04f495ba65$var$cbify(data, opts, [
        $0c5e3e04f495ba65$var$bInflt,
        $0c5e3e04f495ba65$var$guze,
        function() {
            return [
                $0c5e3e04f495ba65$export$c80456f7aaba691c
            ];
        }
    ], function(ev) {
        return $0c5e3e04f495ba65$var$pbf($0c5e3e04f495ba65$export$c80456f7aaba691c(ev.data[0], ev.data[1]));
    }, 3, cb);
}
function $0c5e3e04f495ba65$export$c80456f7aaba691c(data, opts) {
    var st = $0c5e3e04f495ba65$var$gzs(data);
    if (st + 8 > data.length) $0c5e3e04f495ba65$var$err(6, 'invalid gzip data');
    return $0c5e3e04f495ba65$var$inflt(data.subarray(st, -8), {
        i: 2
    }, opts && opts.out || new $0c5e3e04f495ba65$var$u8($0c5e3e04f495ba65$var$gzl(data)), opts && opts.dictionary);
}
/**
 * Streaming Zlib compression
 */ var $0c5e3e04f495ba65$export$4187ccf2467013b9 = /*#__PURE__*/ function() {
    function Zlib(opts, cb) {
        this.c = $0c5e3e04f495ba65$var$adler();
        this.v = 1;
        $0c5e3e04f495ba65$export$ae157b6234afe138.call(this, opts, cb);
    }
    /**
     * Pushes a chunk to be zlibbed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Zlib.prototype.push = function(chunk, final) {
        this.c.p(chunk);
        $0c5e3e04f495ba65$export$ae157b6234afe138.prototype.push.call(this, chunk, final);
    };
    Zlib.prototype.p = function(c, f) {
        var raw = $0c5e3e04f495ba65$var$dopt(c, this.o, this.v && (this.o.dictionary ? 6 : 2), f && 4, this.s);
        if (this.v) $0c5e3e04f495ba65$var$zlh(raw, this.o), this.v = 0;
        if (f) $0c5e3e04f495ba65$var$wbytes(raw, raw.length - 4, this.c.d());
        this.ondata(raw, f);
    };
    /**
     * Flushes buffered uncompressed data. Useful to immediately retrieve the
     * zlibbed output for small inputs.
     * @param sync Whether to flush to a byte boundary. A sync flush takes 4-5
     *             extra bytes, but guarantees all pushed data is immediately
     *             decompressible.
     */ Zlib.prototype.flush = function(sync) {
        $0c5e3e04f495ba65$export$ae157b6234afe138.prototype.flush.call(this, sync);
    };
    return Zlib;
}();
/**
 * Asynchronous streaming Zlib compression
 */ var $0c5e3e04f495ba65$export$bedbe3a2c2136490 = /*#__PURE__*/ function() {
    function AsyncZlib(opts, cb) {
        $0c5e3e04f495ba65$var$astrmify([
            $0c5e3e04f495ba65$var$bDflt,
            $0c5e3e04f495ba65$var$zle,
            function() {
                return [
                    $0c5e3e04f495ba65$var$astrm,
                    $0c5e3e04f495ba65$export$ae157b6234afe138,
                    $0c5e3e04f495ba65$export$4187ccf2467013b9
                ];
            }
        ], this, $0c5e3e04f495ba65$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $0c5e3e04f495ba65$export$4187ccf2467013b9(ev.data);
            onmessage = $0c5e3e04f495ba65$var$astrm(strm);
        }, 10, 1);
    }
    return AsyncZlib;
}();
function $0c5e3e04f495ba65$export$925212de7058410b(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $0c5e3e04f495ba65$var$err(7);
    return $0c5e3e04f495ba65$var$cbify(data, opts, [
        $0c5e3e04f495ba65$var$bDflt,
        $0c5e3e04f495ba65$var$zle,
        function() {
            return [
                $0c5e3e04f495ba65$export$f87121a6d50aff25
            ];
        }
    ], function(ev) {
        return $0c5e3e04f495ba65$var$pbf($0c5e3e04f495ba65$export$f87121a6d50aff25(ev.data[0], ev.data[1]));
    }, 4, cb);
}
function $0c5e3e04f495ba65$export$f87121a6d50aff25(data, opts) {
    if (!opts) opts = {};
    var a = $0c5e3e04f495ba65$var$adler();
    a.p(data);
    var d = $0c5e3e04f495ba65$var$dopt(data, opts, opts.dictionary ? 6 : 2, 4);
    return $0c5e3e04f495ba65$var$zlh(d, opts), $0c5e3e04f495ba65$var$wbytes(d, d.length - 4, a.d()), d;
}
/**
 * Streaming Zlib decompression
 */ var $0c5e3e04f495ba65$export$af2424f875ff1b17 = /*#__PURE__*/ function() {
    function Unzlib(opts, cb) {
        $0c5e3e04f495ba65$export$d1de70a877d6e43c.call(this, opts, cb);
        this.v = opts && opts.dictionary ? 2 : 1;
    }
    /**
     * Pushes a chunk to be unzlibbed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Unzlib.prototype.push = function(chunk, final) {
        $0c5e3e04f495ba65$export$d1de70a877d6e43c.prototype.e.call(this, chunk);
        if (this.v) {
            if (this.p.length < 6 && !final) return;
            this.p = this.p.subarray($0c5e3e04f495ba65$var$zls(this.p, this.v - 1)), this.v = 0;
        }
        if (final) {
            if (this.p.length < 4) $0c5e3e04f495ba65$var$err(6, 'invalid zlib data');
            this.p = this.p.subarray(0, -4);
        }
        // necessary to prevent TS from using the closure value
        // This allows for workerization to function correctly
        $0c5e3e04f495ba65$export$d1de70a877d6e43c.prototype.c.call(this, final);
    };
    return Unzlib;
}();
/**
 * Asynchronous streaming Zlib decompression
 */ var $0c5e3e04f495ba65$export$cf6668790220dcad = /*#__PURE__*/ function() {
    function AsyncUnzlib(opts, cb) {
        $0c5e3e04f495ba65$var$astrmify([
            $0c5e3e04f495ba65$var$bInflt,
            $0c5e3e04f495ba65$var$zule,
            function() {
                return [
                    $0c5e3e04f495ba65$var$astrm,
                    $0c5e3e04f495ba65$export$d1de70a877d6e43c,
                    $0c5e3e04f495ba65$export$af2424f875ff1b17
                ];
            }
        ], this, $0c5e3e04f495ba65$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $0c5e3e04f495ba65$export$af2424f875ff1b17(ev.data);
            onmessage = $0c5e3e04f495ba65$var$astrm(strm);
        }, 11, 0);
    }
    return AsyncUnzlib;
}();
function $0c5e3e04f495ba65$export$ca7cbb494e731274(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $0c5e3e04f495ba65$var$err(7);
    return $0c5e3e04f495ba65$var$cbify(data, opts, [
        $0c5e3e04f495ba65$var$bInflt,
        $0c5e3e04f495ba65$var$zule,
        function() {
            return [
                $0c5e3e04f495ba65$export$9ec8134f0f1b9fc6
            ];
        }
    ], function(ev) {
        return $0c5e3e04f495ba65$var$pbf($0c5e3e04f495ba65$export$9ec8134f0f1b9fc6(ev.data[0], $0c5e3e04f495ba65$var$gopt(ev.data[1])));
    }, 5, cb);
}
function $0c5e3e04f495ba65$export$9ec8134f0f1b9fc6(data, opts) {
    return $0c5e3e04f495ba65$var$inflt(data.subarray($0c5e3e04f495ba65$var$zls(data, opts && opts.dictionary), -4), {
        i: 2
    }, opts && opts.out, opts && opts.dictionary);
}
/**
 * Streaming GZIP, Zlib, or raw DEFLATE decompression
 */ var $0c5e3e04f495ba65$export$578fe199ef655b76 = /*#__PURE__*/ function() {
    function Decompress(opts, cb) {
        this.o = $0c5e3e04f495ba65$var$StrmOpt.call(this, opts, cb) || {};
        this.G = $0c5e3e04f495ba65$export$4cb607de6db70415;
        this.I = $0c5e3e04f495ba65$export$d1de70a877d6e43c;
        this.Z = $0c5e3e04f495ba65$export$af2424f875ff1b17;
    }
    // init substream
    // overriden by AsyncDecompress
    Decompress.prototype.i = function() {
        var _this = this;
        this.s.ondata = function(dat, final) {
            _this.ondata(dat, final);
        };
    };
    /**
     * Pushes a chunk to be decompressed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Decompress.prototype.push = function(chunk, final) {
        if (!this.ondata) $0c5e3e04f495ba65$var$err(5);
        if (!this.s) {
            if (this.p && this.p.length) {
                var n = new $0c5e3e04f495ba65$var$u8(this.p.length + chunk.length);
                n.set(this.p), n.set(chunk, this.p.length);
            } else this.p = chunk;
            if (this.p.length > 2) {
                this.s = this.p[0] == 31 && this.p[1] == 139 && this.p[2] == 8 ? new this.G(this.o) : (this.p[0] & 15) != 8 || this.p[0] >> 4 > 7 || (this.p[0] << 8 | this.p[1]) % 31 ? new this.I(this.o) : new this.Z(this.o);
                this.i();
                this.s.push(this.p, final);
                this.p = null;
            }
        } else this.s.push(chunk, final);
    };
    return Decompress;
}();
/**
 * Asynchronous streaming GZIP, Zlib, or raw DEFLATE decompression
 */ var $0c5e3e04f495ba65$export$ae2c1d81988d4b43 = /*#__PURE__*/ function() {
    function AsyncDecompress(opts, cb) {
        $0c5e3e04f495ba65$export$578fe199ef655b76.call(this, opts, cb);
        this.queuedSize = 0;
        this.G = $0c5e3e04f495ba65$export$d5adcdd968132151;
        this.I = $0c5e3e04f495ba65$export$fff8358d6dbaa9cc;
        this.Z = $0c5e3e04f495ba65$export$cf6668790220dcad;
    }
    AsyncDecompress.prototype.i = function() {
        var _this = this;
        this.s.ondata = function(err, dat, final) {
            _this.ondata(err, dat, final);
        };
        this.s.ondrain = function(size) {
            _this.queuedSize -= size;
            if (_this.ondrain) _this.ondrain(size);
        };
    };
    /**
     * Pushes a chunk to be decompressed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ AsyncDecompress.prototype.push = function(chunk, final) {
        this.queuedSize += chunk.length;
        $0c5e3e04f495ba65$export$578fe199ef655b76.prototype.push.call(this, chunk, final);
    };
    return AsyncDecompress;
}();
function $0c5e3e04f495ba65$export$678d868aab8fb3c7(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $0c5e3e04f495ba65$var$err(7);
    return data[0] == 31 && data[1] == 139 && data[2] == 8 ? $0c5e3e04f495ba65$export$b6df3e950734d697(data, opts, cb) : (data[0] & 15) != 8 || data[0] >> 4 > 7 || (data[0] << 8 | data[1]) % 31 ? $0c5e3e04f495ba65$export$cae1ce83fe4a1782(data, opts, cb) : $0c5e3e04f495ba65$export$ca7cbb494e731274(data, opts, cb);
}
function $0c5e3e04f495ba65$export$c4bdbbbc9a4faabe(data, opts) {
    return data[0] == 31 && data[1] == 139 && data[2] == 8 ? $0c5e3e04f495ba65$export$c80456f7aaba691c(data, opts) : (data[0] & 15) != 8 || data[0] >> 4 > 7 || (data[0] << 8 | data[1]) % 31 ? $0c5e3e04f495ba65$export$90366d8b308ba94a(data, opts) : $0c5e3e04f495ba65$export$9ec8134f0f1b9fc6(data, opts);
}
// flatten a directory structure
var $0c5e3e04f495ba65$var$fltn = function(d, p, t, o) {
    for(var k in d){
        var val = d[k], n = p + k, op = o;
        if (Array.isArray(val)) op = $0c5e3e04f495ba65$var$mrg(o, val[1]), val = val[0];
        if (ArrayBuffer.isView(val)) t[n] = [
            val,
            op
        ];
        else {
            t[n += '/'] = [
                new $0c5e3e04f495ba65$var$u8(0),
                op
            ];
            $0c5e3e04f495ba65$var$fltn(val, n, t, o);
        }
    }
};
// text encoder
var $0c5e3e04f495ba65$var$te = typeof TextEncoder != 'undefined' && /*#__PURE__*/ new TextEncoder();
// text decoder
var $0c5e3e04f495ba65$var$td = typeof TextDecoder != 'undefined' && /*#__PURE__*/ new TextDecoder();
// text decoder stream
var $0c5e3e04f495ba65$var$tds = 0;
try {
    $0c5e3e04f495ba65$var$td.decode($0c5e3e04f495ba65$var$et, {
        stream: true
    });
    $0c5e3e04f495ba65$var$tds = 1;
} catch (e) {}
// decode UTF8
var $0c5e3e04f495ba65$var$dutf8 = function(d) {
    for(var r = '', i = 0;;){
        var c = d[i++];
        var eb = (c > 127) + (c > 223) + (c > 239);
        if (i + eb > d.length) return {
            s: r,
            r: $0c5e3e04f495ba65$var$slc(d, i - 1)
        };
        if (!eb) r += String.fromCharCode(c);
        else if (eb == 3) c = ((c & 15) << 18 | (d[i++] & 63) << 12 | (d[i++] & 63) << 6 | d[i++] & 63) - 65536, r += String.fromCharCode(55296 | c >> 10, 56320 | c & 1023);
        else if (eb & 1) r += String.fromCharCode((c & 31) << 6 | d[i++] & 63);
        else r += String.fromCharCode((c & 15) << 12 | (d[i++] & 63) << 6 | d[i++] & 63);
    }
};
/**
 * Streaming UTF-8 decoding
 */ var $0c5e3e04f495ba65$export$ba46860a31c72e94 = /*#__PURE__*/ function() {
    /**
     * Creates a UTF-8 decoding stream
     * @param cb The callback to call whenever data is decoded
     */ function DecodeUTF8(cb) {
        this.ondata = cb;
        if ($0c5e3e04f495ba65$var$tds) this.t = new TextDecoder();
        else this.p = $0c5e3e04f495ba65$var$et;
    }
    /**
     * Pushes a chunk to be decoded from UTF-8 binary
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ DecodeUTF8.prototype.push = function(chunk, final) {
        if (!this.ondata) $0c5e3e04f495ba65$var$err(5);
        final = !!final;
        if (this.t) {
            this.ondata(this.t.decode(chunk, {
                stream: true
            }), final);
            if (final) {
                if (this.t.decode().length) $0c5e3e04f495ba65$var$err(8);
                this.t = null;
            }
            return;
        }
        if (!this.p) $0c5e3e04f495ba65$var$err(4);
        var dat = new $0c5e3e04f495ba65$var$u8(this.p.length + chunk.length);
        dat.set(this.p);
        dat.set(chunk, this.p.length);
        var _a = $0c5e3e04f495ba65$var$dutf8(dat), s = _a.s, r = _a.r;
        if (final) {
            if (r.length) $0c5e3e04f495ba65$var$err(8);
            this.p = null;
        } else this.p = r;
        this.ondata(s, final);
    };
    return DecodeUTF8;
}();
/**
 * Streaming UTF-8 encoding
 */ var $0c5e3e04f495ba65$export$283f13d12b1b210e = /*#__PURE__*/ function() {
    /**
     * Creates a UTF-8 decoding stream
     * @param cb The callback to call whenever data is encoded
     */ function EncodeUTF8(cb) {
        this.ondata = cb;
    }
    /**
     * Pushes a chunk to be encoded to UTF-8
     * @param chunk The string data to push
     * @param final Whether this is the last chunk
     */ EncodeUTF8.prototype.push = function(chunk, final) {
        if (!this.ondata) $0c5e3e04f495ba65$var$err(5);
        if (this.d) $0c5e3e04f495ba65$var$err(4);
        this.ondata($0c5e3e04f495ba65$export$366b39a6daa8ed7a(chunk), this.d = final || false);
    };
    return EncodeUTF8;
}();
function $0c5e3e04f495ba65$export$366b39a6daa8ed7a(str, latin1) {
    if (latin1) {
        var ar_1 = new $0c5e3e04f495ba65$var$u8(str.length);
        for(var i = 0; i < str.length; ++i)ar_1[i] = str.charCodeAt(i);
        return ar_1;
    }
    if ($0c5e3e04f495ba65$var$te) return $0c5e3e04f495ba65$var$te.encode(str);
    var l = str.length;
    var ar = new $0c5e3e04f495ba65$var$u8(str.length + (str.length >> 1));
    var ai = 0;
    var w = function(v) {
        ar[ai++] = v;
    };
    for(var i = 0; i < l; ++i){
        if (ai + 5 > ar.length) {
            var n = new $0c5e3e04f495ba65$var$u8(ai + 8 + (l - i << 1));
            n.set(ar);
            ar = n;
        }
        var c = str.charCodeAt(i);
        if (c < 128 || latin1) w(c);
        else if (c < 2048) w(192 | c >> 6), w(128 | c & 63);
        else if (c > 55295 && c < 57344) c = 65536 + (c & 1047552) | str.charCodeAt(++i) & 1023, w(240 | c >> 18), w(128 | c >> 12 & 63), w(128 | c >> 6 & 63), w(128 | c & 63);
        else w(224 | c >> 12), w(128 | c >> 6 & 63), w(128 | c & 63);
    }
    return $0c5e3e04f495ba65$var$slc(ar, 0, ai);
}
function $0c5e3e04f495ba65$export$adb211f8cb999894(dat, latin1) {
    if (latin1) {
        var r = '';
        for(var i = 0; i < dat.length; i += 16384)r += String.fromCharCode.apply(null, dat.subarray(i, i + 16384));
        return r;
    } else if ($0c5e3e04f495ba65$var$td) return $0c5e3e04f495ba65$var$td.decode(dat);
    else {
        var _a = $0c5e3e04f495ba65$var$dutf8(dat), s = _a.s, r = _a.r;
        if (r.length) $0c5e3e04f495ba65$var$err(8);
        return s;
    }
}
// deflate bit flag
var $0c5e3e04f495ba65$var$dbf = function(l) {
    return l == 1 ? 3 : l < 6 ? 2 : l == 9 ? 1 : 0;
};
// skip local zip header
var $0c5e3e04f495ba65$var$slzh = function(d, b) {
    return b + 30 + $0c5e3e04f495ba65$var$b2(d, b + 26) + $0c5e3e04f495ba65$var$b2(d, b + 28);
};
// read zip header
var $0c5e3e04f495ba65$var$zh = function(d, b, z) {
    var fnl = $0c5e3e04f495ba65$var$b2(d, b + 28), efl = $0c5e3e04f495ba65$var$b2(d, b + 30), fn = $0c5e3e04f495ba65$export$adb211f8cb999894(d.subarray(b + 46, b + 46 + fnl), !($0c5e3e04f495ba65$var$b2(d, b + 8) & 2048)), es = b + 46 + fnl;
    var _a = $0c5e3e04f495ba65$var$z64hs(d, es, efl, z, $0c5e3e04f495ba65$var$b4(d, b + 20), $0c5e3e04f495ba65$var$b4(d, b + 24), $0c5e3e04f495ba65$var$b4(d, b + 42)), sc = _a[0], su = _a[1], off = _a[2];
    return [
        $0c5e3e04f495ba65$var$b2(d, b + 10),
        sc,
        su,
        fn,
        es + efl + $0c5e3e04f495ba65$var$b2(d, b + 32),
        off
    ];
};
// read zip64 header sizes
var $0c5e3e04f495ba65$var$z64hs = function(d, b, l, z, sc, su, off) {
    var nsc = sc == 4294967295, nsu = su == 4294967295, noff = off == 4294967295, e = b + l;
    var nf = nsc + nsu + noff;
    if (z && nf) {
        for(; b + 4 < e; b += 4 + $0c5e3e04f495ba65$var$b2(d, b + 2)){
            if ($0c5e3e04f495ba65$var$b2(d, b) == 1) return [
                nsc ? $0c5e3e04f495ba65$var$b8(d, b + 4 + 8 * nsu) : sc,
                nsu ? $0c5e3e04f495ba65$var$b8(d, b + 4) : su,
                noff ? $0c5e3e04f495ba65$var$b8(d, b + 4 + 8 * (nsu + nsc)) : off,
                1
            ];
        }
        // z == 2 for unknown whether or not zip64
        if (z < 2) $0c5e3e04f495ba65$var$err(13);
    }
    return [
        sc,
        su,
        off,
        0
    ];
};
// extra field length
var $0c5e3e04f495ba65$var$exfl = function(ex) {
    var le = 0;
    if (ex) for(var k in ex){
        var l = ex[k].length;
        if (l > 65535) $0c5e3e04f495ba65$var$err(9);
        le += l + 4;
    }
    return le;
};
// write zip header
var $0c5e3e04f495ba65$var$wzh = function(d, b, f, fn, u, c, ce, co) {
    var fl = fn.length, ex = f.extra, col = co && co.length;
    var exl = $0c5e3e04f495ba65$var$exfl(ex);
    $0c5e3e04f495ba65$var$wbytes(d, b, ce != null ? 0x2014B50 : 0x4034B50), b += 4;
    if (ce != null) d[b++] = 20, d[b++] = f.os;
    d[b] = 20, b += 2; // spec compliance? what's that?
    d[b++] = f.flag << 1 | (c < 0 && 8), d[b++] = u && 8;
    d[b++] = f.compression & 255, d[b++] = f.compression >> 8;
    var dt = new Date(f.mtime == null ? Date.now() : f.mtime), y = dt.getFullYear() - 1980;
    if (y < 0 || y > 119) $0c5e3e04f495ba65$var$err(10);
    $0c5e3e04f495ba65$var$wbytes(d, b, y << 25 | dt.getMonth() + 1 << 21 | dt.getDate() << 16 | dt.getHours() << 11 | dt.getMinutes() << 5 | dt.getSeconds() >> 1), b += 4;
    if (c != -1) {
        $0c5e3e04f495ba65$var$wbytes(d, b, f.crc);
        $0c5e3e04f495ba65$var$wbytes(d, b + 4, c < 0 ? -c - 2 : c);
        $0c5e3e04f495ba65$var$wbytes(d, b + 8, f.size);
    }
    $0c5e3e04f495ba65$var$wbytes(d, b + 12, fl);
    $0c5e3e04f495ba65$var$wbytes(d, b + 14, exl), b += 16;
    if (ce != null) {
        $0c5e3e04f495ba65$var$wbytes(d, b, col);
        $0c5e3e04f495ba65$var$wbytes(d, b + 6, f.attrs);
        $0c5e3e04f495ba65$var$wbytes(d, b + 10, ce), b += 14;
    }
    d.set(fn, b);
    b += fl;
    if (exl) for(var k in ex){
        var exf = ex[k], l = exf.length;
        $0c5e3e04f495ba65$var$wbytes(d, b, +k);
        $0c5e3e04f495ba65$var$wbytes(d, b + 2, l);
        d.set(exf, b + 4), b += 4 + l;
    }
    if (col) d.set(co, b), b += col;
    return b;
};
// write zip footer (end of central directory)
var $0c5e3e04f495ba65$var$wzf = function(o, b, c, d, e) {
    $0c5e3e04f495ba65$var$wbytes(o, b, 0x6054B50); // skip disk
    $0c5e3e04f495ba65$var$wbytes(o, b + 8, c);
    $0c5e3e04f495ba65$var$wbytes(o, b + 10, c);
    $0c5e3e04f495ba65$var$wbytes(o, b + 12, d);
    $0c5e3e04f495ba65$var$wbytes(o, b + 16, e);
};
/**
 * A pass-through stream to keep data uncompressed in a ZIP archive.
 */ var $0c5e3e04f495ba65$export$2b25194e1767ea06 = /*#__PURE__*/ function() {
    /**
     * Creates a pass-through stream that can be added to ZIP archives
     * @param filename The filename to associate with this data stream
     */ function ZipPassThrough(filename) {
        this.filename = filename;
        this.c = $0c5e3e04f495ba65$var$crc();
        this.size = 0;
        this.compression = 0;
    }
    /**
     * Processes a chunk and pushes to the output stream. You can override this
     * method in a subclass for custom behavior, but by default this passes
     * the data through. You must call this.ondata(err, chunk, final) at some
     * point in this method.
     * @param chunk The chunk to process
     * @param final Whether this is the last chunk
     */ ZipPassThrough.prototype.process = function(chunk, final) {
        this.ondata(null, chunk, final);
    };
    /**
     * Pushes a chunk to be added. If you are subclassing this with a custom
     * compression algorithm, note that you must push data from the source
     * file only, pre-compression.
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ ZipPassThrough.prototype.push = function(chunk, final) {
        if (!this.ondata) $0c5e3e04f495ba65$var$err(5);
        this.c.p(chunk);
        this.size += chunk.length;
        if (final) this.crc = this.c.d();
        // we shouldn't really do this cast, but properly handling ArrayBufferLike
        // makes the API unergonomic with Buffer
        this.process(chunk, final || false);
    };
    return ZipPassThrough;
}();
// I don't extend because TypeScript extension adds 1kB of runtime bloat
/**
 * Streaming DEFLATE compression for ZIP archives. Prefer using AsyncZipDeflate
 * for better performance
 */ var $0c5e3e04f495ba65$export$f7e481ca646388b6 = /*#__PURE__*/ function() {
    /**
     * Creates a DEFLATE stream that can be added to ZIP archives
     * @param filename The filename to associate with this data stream
     * @param opts The compression options
     */ function ZipDeflate(filename, opts) {
        var _this = this;
        if (!opts) opts = {};
        $0c5e3e04f495ba65$export$2b25194e1767ea06.call(this, filename);
        this.d = new $0c5e3e04f495ba65$export$ae157b6234afe138(opts, function(dat, final) {
            _this.ondata(null, dat, final);
        });
        this.compression = 8;
        this.flag = $0c5e3e04f495ba65$var$dbf(opts.level);
    }
    ZipDeflate.prototype.process = function(chunk, final) {
        try {
            this.d.push(chunk, final);
        } catch (e) {
            this.ondata(e, null, final);
        }
    };
    /**
     * Pushes a chunk to be deflated
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ ZipDeflate.prototype.push = function(chunk, final) {
        $0c5e3e04f495ba65$export$2b25194e1767ea06.prototype.push.call(this, chunk, final);
    };
    return ZipDeflate;
}();
/**
 * Asynchronous streaming DEFLATE compression for ZIP archives
 */ var $0c5e3e04f495ba65$export$ffb5e59e179924b2 = /*#__PURE__*/ function() {
    /**
     * Creates an asynchronous DEFLATE stream that can be added to ZIP archives
     * @param filename The filename to associate with this data stream
     * @param opts The compression options
     */ function AsyncZipDeflate(filename, opts) {
        var _this = this;
        if (!opts) opts = {};
        $0c5e3e04f495ba65$export$2b25194e1767ea06.call(this, filename);
        this.d = new $0c5e3e04f495ba65$export$84e526fabcba03e3(opts, function(err, dat, final) {
            _this.ondata(err, dat, final);
        });
        this.compression = 8;
        this.flag = $0c5e3e04f495ba65$var$dbf(opts.level);
        this.terminate = this.d.terminate;
    }
    AsyncZipDeflate.prototype.process = function(chunk, final) {
        this.d.push(chunk, final);
    };
    /**
     * Pushes a chunk to be deflated
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ AsyncZipDeflate.prototype.push = function(chunk, final) {
        $0c5e3e04f495ba65$export$2b25194e1767ea06.prototype.push.call(this, chunk, final);
    };
    return AsyncZipDeflate;
}();
// TODO: Better tree shaking
/**
 * A zippable archive to which files can incrementally be added
 */ var $0c5e3e04f495ba65$export$9a4d4a7c32a75d2f = /*#__PURE__*/ function() {
    /**
     * Creates an empty ZIP archive to which files can be added
     * @param cb The callback to call whenever data for the generated ZIP archive
     *           is available
     */ function Zip(cb) {
        this.ondata = cb;
        this.u = [];
        this.d = 1;
    }
    /**
     * Adds a file to the ZIP archive
     * @param file The file stream to add
     */ Zip.prototype.add = function(file) {
        var _this = this;
        if (!this.ondata) $0c5e3e04f495ba65$var$err(5);
        // finishing or finished
        if (this.d & 2) this.ondata($0c5e3e04f495ba65$var$err(4 + (this.d & 1) * 8, 0, 1), null, false);
        else {
            var f = $0c5e3e04f495ba65$export$366b39a6daa8ed7a(file.filename), fl_1 = f.length;
            var com = file.comment, o = com && $0c5e3e04f495ba65$export$366b39a6daa8ed7a(com);
            var u = fl_1 != file.filename.length || o && com.length != o.length;
            var hl_1 = fl_1 + $0c5e3e04f495ba65$var$exfl(file.extra) + 30;
            if (fl_1 > 65535) this.ondata($0c5e3e04f495ba65$var$err(11, 0, 1), null, false);
            var header = new $0c5e3e04f495ba65$var$u8(hl_1);
            $0c5e3e04f495ba65$var$wzh(header, 0, file, f, u, -1);
            var chks_1 = [
                header
            ];
            var pAll_1 = function() {
                for(var _i = 0, chks_2 = chks_1; _i < chks_2.length; _i++){
                    var chk = chks_2[_i];
                    _this.ondata(null, chk, false);
                }
                chks_1 = [];
            };
            var tr_1 = this.d;
            this.d = 0;
            var ind_1 = this.u.length;
            var uf_1 = $0c5e3e04f495ba65$var$mrg(file, {
                f: f,
                u: u,
                o: o,
                t: function() {
                    if (file.terminate) file.terminate();
                },
                r: function() {
                    pAll_1();
                    if (tr_1) {
                        var nxt = _this.u[ind_1 + 1];
                        if (nxt) nxt.r();
                        else _this.d = 1;
                    }
                    tr_1 = 1;
                }
            });
            var cl_1 = 0;
            file.ondata = function(err, dat, final) {
                if (err) {
                    _this.ondata(err, dat, final);
                    _this.terminate();
                } else {
                    cl_1 += dat.length;
                    chks_1.push(dat);
                    if (final) {
                        var dd = new $0c5e3e04f495ba65$var$u8(16);
                        $0c5e3e04f495ba65$var$wbytes(dd, 0, 0x8074B50);
                        $0c5e3e04f495ba65$var$wbytes(dd, 4, file.crc);
                        $0c5e3e04f495ba65$var$wbytes(dd, 8, cl_1);
                        $0c5e3e04f495ba65$var$wbytes(dd, 12, file.size);
                        chks_1.push(dd);
                        uf_1.c = cl_1, uf_1.b = hl_1 + cl_1 + 16, uf_1.crc = file.crc, uf_1.size = file.size;
                        if (tr_1) uf_1.r();
                        tr_1 = 1;
                    } else if (tr_1) pAll_1();
                }
            };
            this.u.push(uf_1);
        }
    };
    /**
     * Ends the process of adding files and prepares to emit the final chunks.
     * This *must* be called after adding all desired files for the resulting
     * ZIP file to work properly.
     */ Zip.prototype.end = function() {
        var _this = this;
        if (this.d & 2) {
            this.ondata($0c5e3e04f495ba65$var$err(4 + (this.d & 1) * 8, 0, 1), null, true);
            return;
        }
        if (this.d) this.e();
        else this.u.push({
            r: function() {
                if (!(_this.d & 1)) return;
                _this.u.splice(-1, 1);
                _this.e();
            },
            t: function() {}
        });
        this.d = 3;
    };
    Zip.prototype.e = function() {
        var bt = 0, l = 0, tl = 0;
        for(var _i = 0, _a = this.u; _i < _a.length; _i++){
            var f = _a[_i];
            tl += 46 + f.f.length + $0c5e3e04f495ba65$var$exfl(f.extra) + (f.o ? f.o.length : 0);
        }
        var out = new $0c5e3e04f495ba65$var$u8(tl + 22);
        for(var _b = 0, _c = this.u; _b < _c.length; _b++){
            var f = _c[_b];
            $0c5e3e04f495ba65$var$wzh(out, bt, f, f.f, f.u, -f.c - 2, l, f.o);
            bt += 46 + f.f.length + $0c5e3e04f495ba65$var$exfl(f.extra) + (f.o ? f.o.length : 0), l += f.b;
        }
        $0c5e3e04f495ba65$var$wzf(out, bt, this.u.length, tl, l);
        this.ondata(null, out, true);
        this.d = 2;
    };
    /**
     * A method to terminate any internal workers used by the stream. Subsequent
     * calls to add() will fail.
     */ Zip.prototype.terminate = function() {
        for(var _i = 0, _a = this.u; _i < _a.length; _i++){
            var f = _a[_i];
            f.t();
        }
        this.d = 2;
    };
    return Zip;
}();
function $0c5e3e04f495ba65$export$8901015135f2fb22(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $0c5e3e04f495ba65$var$err(7);
    var r = {};
    $0c5e3e04f495ba65$var$fltn(data, '', r, opts);
    var k = Object.keys(r);
    var lft = k.length, o = 0, tot = 0;
    var slft = lft, files = new Array(lft);
    var term = [];
    var tAll = function() {
        for(var i = 0; i < term.length; ++i)term[i]();
    };
    var cbd = function(a, b) {
        $0c5e3e04f495ba65$var$mt(function() {
            cb(a, b);
        });
    };
    $0c5e3e04f495ba65$var$mt(function() {
        cbd = cb;
    });
    var cbf = function() {
        var out = new $0c5e3e04f495ba65$var$u8(tot + 22), oe = o, cdl = tot - o;
        tot = 0;
        for(var i = 0; i < slft; ++i){
            var f = files[i];
            try {
                var l = f.c.length;
                $0c5e3e04f495ba65$var$wzh(out, tot, f, f.f, f.u, l);
                var badd = 30 + f.f.length + $0c5e3e04f495ba65$var$exfl(f.extra);
                var loc = tot + badd;
                out.set(f.c, loc);
                $0c5e3e04f495ba65$var$wzh(out, o, f, f.f, f.u, l, tot, f.m), o += 16 + badd + (f.m ? f.m.length : 0), tot = loc + l;
            } catch (e) {
                return cbd(e, null);
            }
        }
        $0c5e3e04f495ba65$var$wzf(out, o, files.length, cdl, oe);
        cbd(null, out);
    };
    if (!lft) cbf();
    var _loop_1 = function(i) {
        var fn = k[i];
        var _a = r[fn], file = _a[0], p = _a[1];
        var c = $0c5e3e04f495ba65$var$crc(), size = file.length;
        c.p(file);
        var f = $0c5e3e04f495ba65$export$366b39a6daa8ed7a(fn), s = f.length;
        var com = p.comment, m = com && $0c5e3e04f495ba65$export$366b39a6daa8ed7a(com), ms = m && m.length;
        var exl = $0c5e3e04f495ba65$var$exfl(p.extra);
        var compression = p.level == 0 ? 0 : 8;
        var cbl = function(e, d) {
            if (e) {
                tAll();
                cbd(e, null);
            } else {
                var l = d.length;
                files[i] = $0c5e3e04f495ba65$var$mrg(p, {
                    size: size,
                    crc: c.d(),
                    c: d,
                    f: f,
                    m: m,
                    u: s != fn.length || m && com.length != ms,
                    compression: compression
                });
                o += 30 + s + exl + l;
                tot += 76 + 2 * (s + exl) + (ms || 0) + l;
                if (!--lft) cbf();
            }
        };
        if (s > 65535) cbl($0c5e3e04f495ba65$var$err(11, 0, 1), null);
        if (!compression) cbl(null, file);
        else if (size < 160000) try {
            cbl(null, $0c5e3e04f495ba65$export$21533ff51b8a0b4a(file, p));
        } catch (e) {
            cbl(e, null);
        }
        else term.push($0c5e3e04f495ba65$export$2316623ecd1285ab(file, p, cbl));
    };
    // Cannot use lft because it can decrease
    for(var i = 0; i < slft; ++i)_loop_1(i);
    return tAll;
}
function $0c5e3e04f495ba65$export$eb1654f146d54eb3(data, opts) {
    if (!opts) opts = {};
    var r = {};
    var files = [];
    $0c5e3e04f495ba65$var$fltn(data, '', r, opts);
    var o = 0;
    var tot = 0;
    for(var fn in r){
        var _a = r[fn], file = _a[0], p = _a[1];
        var compression = p.level == 0 ? 0 : 8;
        var f = $0c5e3e04f495ba65$export$366b39a6daa8ed7a(fn), s = f.length;
        var com = p.comment, m = com && $0c5e3e04f495ba65$export$366b39a6daa8ed7a(com), ms = m && m.length;
        var exl = $0c5e3e04f495ba65$var$exfl(p.extra);
        if (s > 65535) $0c5e3e04f495ba65$var$err(11);
        var d = compression ? $0c5e3e04f495ba65$export$21533ff51b8a0b4a(file, p) : file, l = d.length;
        var c = $0c5e3e04f495ba65$var$crc();
        c.p(file);
        files.push($0c5e3e04f495ba65$var$mrg(p, {
            size: file.length,
            crc: c.d(),
            c: d,
            f: f,
            m: m,
            u: s != fn.length || m && com.length != ms,
            o: o,
            compression: compression
        }));
        o += 30 + s + exl + l;
        tot += 76 + 2 * (s + exl) + (ms || 0) + l;
    }
    var out = new $0c5e3e04f495ba65$var$u8(tot + 22), oe = o, cdl = tot - o;
    for(var i = 0; i < files.length; ++i){
        var f = files[i];
        $0c5e3e04f495ba65$var$wzh(out, f.o, f, f.f, f.u, f.c.length);
        var badd = 30 + f.f.length + $0c5e3e04f495ba65$var$exfl(f.extra);
        out.set(f.c, f.o + badd);
        $0c5e3e04f495ba65$var$wzh(out, o, f, f.f, f.u, f.c.length, f.o, f.m), o += 16 + badd + (f.m ? f.m.length : 0);
    }
    $0c5e3e04f495ba65$var$wzf(out, o, files.length, cdl, oe);
    return out;
}
/**
 * Streaming pass-through decompression for ZIP archives
 */ var $0c5e3e04f495ba65$export$93f81d5bbbb7c6bf = /*#__PURE__*/ function() {
    function UnzipPassThrough() {}
    UnzipPassThrough.prototype.push = function(chunk, final) {
        // same as ZipPassThrough: cast to retain Buffer ergonomics
        this.ondata(null, chunk, final);
    };
    UnzipPassThrough.compression = 0;
    return UnzipPassThrough;
}();
/**
 * Streaming DEFLATE decompression for ZIP archives. Prefer AsyncZipInflate for
 * better performance.
 */ var $0c5e3e04f495ba65$export$eb188945cc39e642 = /*#__PURE__*/ function() {
    /**
     * Creates a DEFLATE decompression that can be used in ZIP archives
     */ function UnzipInflate() {
        var _this = this;
        this.i = new $0c5e3e04f495ba65$export$d1de70a877d6e43c(function(dat, final) {
            _this.ondata(null, dat, final);
        });
    }
    UnzipInflate.prototype.push = function(chunk, final) {
        try {
            this.i.push(chunk, final);
        } catch (e) {
            this.ondata(e, null, final);
        }
    };
    UnzipInflate.compression = 8;
    return UnzipInflate;
}();
/**
 * Asynchronous streaming DEFLATE decompression for ZIP archives
 */ var $0c5e3e04f495ba65$export$6235d84645dad4f9 = /*#__PURE__*/ function() {
    /**
     * Creates a DEFLATE decompression that can be used in ZIP archives
     */ function AsyncUnzipInflate(_, sz) {
        var _this = this;
        if (sz < 320000) this.i = new $0c5e3e04f495ba65$export$d1de70a877d6e43c(function(dat, final) {
            _this.ondata(null, dat, final);
        });
        else {
            this.i = new $0c5e3e04f495ba65$export$fff8358d6dbaa9cc(function(err, dat, final) {
                _this.ondata(err, dat, final);
            });
            this.terminate = this.i.terminate;
        }
    }
    AsyncUnzipInflate.prototype.push = function(chunk, final) {
        if (this.i.terminate) chunk = $0c5e3e04f495ba65$var$slc(chunk, 0);
        this.i.push(chunk, final);
    };
    AsyncUnzipInflate.compression = 8;
    return AsyncUnzipInflate;
}();
/**
 * A ZIP archive decompression stream that emits files as they are discovered
 */ var $0c5e3e04f495ba65$export$9b7485f84cbaaa56 = /*#__PURE__*/ function() {
    /**
     * Creates a ZIP decompression stream
     * @param cb The callback to call whenever a file in the ZIP archive is found
     */ function Unzip(cb) {
        this.onfile = cb;
        this.k = [];
        this.o = {
            0: $0c5e3e04f495ba65$export$93f81d5bbbb7c6bf
        };
        this.p = $0c5e3e04f495ba65$var$et;
    }
    /**
     * Pushes a chunk to be unzipped
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Unzip.prototype.push = function(chunk, final) {
        var _this = this;
        if (!this.onfile) $0c5e3e04f495ba65$var$err(5);
        if (!this.p) $0c5e3e04f495ba65$var$err(4);
        if (this.c > 0) {
            var len = Math.min(this.c, chunk.length);
            var toAdd = chunk.subarray(0, len);
            this.c -= len;
            if (this.d) this.d.push(toAdd, !this.c);
            else this.k[0].push(toAdd);
            chunk = chunk.subarray(len);
            if (chunk.length) return this.push(chunk, final);
        } else {
            var f = 0, i = 0, is = void 0, buf = void 0;
            if (!this.p.length) buf = chunk;
            else if (!chunk.length) buf = this.p;
            else {
                buf = new $0c5e3e04f495ba65$var$u8(this.p.length + chunk.length);
                buf.set(this.p), buf.set(chunk, this.p.length);
            }
            var l = buf.length, oc = this.c, add = oc && this.d;
            var _loop_2 = function() {
                var sig = $0c5e3e04f495ba65$var$b4(buf, i);
                if (sig == 0x4034B50) {
                    f = 1, is = i;
                    this_1.d = null;
                    this_1.c = 0;
                    var bf = $0c5e3e04f495ba65$var$b2(buf, i + 6), cmp_1 = $0c5e3e04f495ba65$var$b2(buf, i + 8), u = bf & 2048, dd = bf & 8, fnl = $0c5e3e04f495ba65$var$b2(buf, i + 26), es = $0c5e3e04f495ba65$var$b2(buf, i + 28);
                    if (l > i + 30 + fnl + es) {
                        var chks_3 = [];
                        this_1.k.unshift(chks_3);
                        f = 2;
                        var lsc = $0c5e3e04f495ba65$var$b4(buf, i + 18), lsu = $0c5e3e04f495ba65$var$b4(buf, i + 22);
                        var fn_1 = $0c5e3e04f495ba65$export$adb211f8cb999894(buf.subarray(i + 30, i += 30 + fnl), !u);
                        var _a = $0c5e3e04f495ba65$var$z64hs(buf, i, es, 2, lsc, lsu, 0), sc_1 = _a[0], su_1 = _a[1], z64 = _a[3];
                        if (dd) sc_1 = -1 - z64;
                        i += es;
                        this_1.c = sc_1;
                        var d_1;
                        var file_1 = {
                            name: fn_1,
                            compression: cmp_1,
                            start: function() {
                                if (!file_1.ondata) $0c5e3e04f495ba65$var$err(5);
                                if (!sc_1) file_1.ondata(null, $0c5e3e04f495ba65$var$et, true);
                                else {
                                    var ctr = _this.o[cmp_1];
                                    if (!ctr) file_1.ondata($0c5e3e04f495ba65$var$err(14, 'unknown compression type ' + cmp_1, 1), null, false);
                                    d_1 = sc_1 < 0 ? new ctr(fn_1) : new ctr(fn_1, sc_1, su_1);
                                    d_1.ondata = function(err, dat, final) {
                                        file_1.ondata(err, dat, final);
                                    };
                                    for(var _i = 0, chks_4 = chks_3; _i < chks_4.length; _i++){
                                        var dat = chks_4[_i];
                                        d_1.push(dat, false);
                                    }
                                    if (_this.k[0] == chks_3 && _this.c) _this.d = d_1;
                                    else d_1.push($0c5e3e04f495ba65$var$et, true);
                                }
                            },
                            terminate: function() {
                                if (d_1 && d_1.terminate) d_1.terminate();
                            }
                        };
                        if (sc_1 >= 0) file_1.size = sc_1, file_1.originalSize = su_1;
                        this_1.onfile(file_1);
                    }
                    return "break";
                } else if (oc) {
                    if (sig == 0x8074B50) {
                        is = i += 12 + (oc == -2 && 8), f = 3, this_1.c = 0;
                        return "break";
                    } else if (sig == 0x2014B50) {
                        is = i -= 4, f = 3, this_1.c = 0;
                        return "break";
                    }
                }
            };
            var this_1 = this;
            for(; i < l - 4; ++i){
                var state_1 = _loop_2();
                if (state_1 === "break") break;
            }
            this.p = $0c5e3e04f495ba65$var$et;
            if (oc < 0) {
                var dat = f ? buf.subarray(0, is - 12 - (oc == -2 && 8) - ($0c5e3e04f495ba65$var$b4(buf, is - 16) == 0x8074B50 && 4)) : buf.subarray(0, i);
                if (add) add.push(dat, !!f);
                else this.k[+(f == 2)].push(dat);
            }
            if (f & 2) return this.push(buf.subarray(i), final);
            this.p = buf.subarray(i);
        }
        if (final) {
            if (this.c) $0c5e3e04f495ba65$var$err(13);
            this.p = null;
        }
    };
    /**
     * Registers a decoder with the stream, allowing for files compressed with
     * the compression type provided to be expanded correctly
     * @param decoder The decoder constructor
     */ Unzip.prototype.register = function(decoder) {
        this.o[decoder.compression] = decoder;
    };
    return Unzip;
}();
var $0c5e3e04f495ba65$var$mt = typeof queueMicrotask == 'function' ? queueMicrotask : typeof setTimeout == 'function' ? setTimeout : function(fn) {
    fn();
};
function $0c5e3e04f495ba65$export$23c8d3f8757cab88(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $0c5e3e04f495ba65$var$err(7);
    var term = [];
    var tAll = function() {
        for(var i = 0; i < term.length; ++i)term[i]();
    };
    var files = {};
    var cbd = function(a, b) {
        $0c5e3e04f495ba65$var$mt(function() {
            cb(a, b);
        });
    };
    $0c5e3e04f495ba65$var$mt(function() {
        cbd = cb;
    });
    var e = data.length - 22;
    for(; $0c5e3e04f495ba65$var$b4(data, e) != 0x6054B50; --e)if (!e || data.length - e > 65558) {
        cbd($0c5e3e04f495ba65$var$err(13, 0, 1), null);
        return tAll;
    }
    var lft = $0c5e3e04f495ba65$var$b2(data, e + 8);
    if (lft) {
        var c = lft;
        var o = $0c5e3e04f495ba65$var$b4(data, e + 16);
        var z = $0c5e3e04f495ba65$var$b4(data, e - 20) == 0x7064B50;
        if (z) {
            var ze = $0c5e3e04f495ba65$var$b4(data, e - 12);
            z = $0c5e3e04f495ba65$var$b4(data, ze) == 0x6064B50;
            if (z) {
                c = lft = $0c5e3e04f495ba65$var$b4(data, ze + 32);
                o = $0c5e3e04f495ba65$var$b4(data, ze + 48);
            }
        }
        var fltr = opts && opts.filter;
        var _loop_3 = function(i) {
            var _a = $0c5e3e04f495ba65$var$zh(data, o, z), c_1 = _a[0], sc = _a[1], su = _a[2], fn = _a[3], no = _a[4], off = _a[5], b = $0c5e3e04f495ba65$var$slzh(data, off);
            o = no;
            var cbl = function(e, d) {
                if (e) {
                    tAll();
                    cbd(e, null);
                } else {
                    if (d) files[fn] = d;
                    if (!--lft) cbd(null, files);
                }
            };
            if (!fltr || fltr({
                name: fn,
                size: sc,
                originalSize: su,
                compression: c_1
            })) {
                if (!c_1) cbl(null, $0c5e3e04f495ba65$var$slc(data, b, b + sc));
                else if (c_1 == 8) {
                    var infl = data.subarray(b, b + sc);
                    // Synchronously decompress under 512KB, or barely-compressed data
                    if (su < 524288 || sc > 0.8 * su) try {
                        cbl(null, $0c5e3e04f495ba65$export$90366d8b308ba94a(infl, {
                            out: new $0c5e3e04f495ba65$var$u8(su)
                        }));
                    } catch (e) {
                        cbl(e, null);
                    }
                    else term.push($0c5e3e04f495ba65$export$cae1ce83fe4a1782(infl, {
                        size: su
                    }, cbl));
                } else cbl($0c5e3e04f495ba65$var$err(14, 'unknown compression type ' + c_1, 1), null);
            } else cbl(null, null);
        };
        for(var i = 0; i < c; ++i)_loop_3(i);
    } else cbd(null, {});
    return tAll;
}
function $0c5e3e04f495ba65$export$c757709326bb5901(data, opts) {
    var files = {};
    var e = data.length - 22;
    for(; $0c5e3e04f495ba65$var$b4(data, e) != 0x6054B50; --e)if (!e || data.length - e > 65558) $0c5e3e04f495ba65$var$err(13);
    var c = $0c5e3e04f495ba65$var$b2(data, e + 8);
    if (!c) return {};
    var o = $0c5e3e04f495ba65$var$b4(data, e + 16);
    var z = $0c5e3e04f495ba65$var$b4(data, e - 20) == 0x7064B50;
    if (z) {
        var ze = $0c5e3e04f495ba65$var$b4(data, e - 12);
        z = $0c5e3e04f495ba65$var$b4(data, ze) == 0x6064B50;
        if (z) {
            c = $0c5e3e04f495ba65$var$b4(data, ze + 32);
            o = $0c5e3e04f495ba65$var$b4(data, ze + 48);
        }
    }
    var fltr = opts && opts.filter;
    for(var i = 0; i < c; ++i){
        var _a = $0c5e3e04f495ba65$var$zh(data, o, z), c_2 = _a[0], sc = _a[1], su = _a[2], fn = _a[3], no = _a[4], off = _a[5], b = $0c5e3e04f495ba65$var$slzh(data, off);
        o = no;
        if (!fltr || fltr({
            name: fn,
            size: sc,
            originalSize: su,
            compression: c_2
        })) {
            if (!c_2) files[fn] = $0c5e3e04f495ba65$var$slc(data, b, b + sc);
            else if (c_2 == 8) files[fn] = $0c5e3e04f495ba65$export$90366d8b308ba94a(data.subarray(b, b + sc), {
                out: new $0c5e3e04f495ba65$var$u8(su)
            });
            else $0c5e3e04f495ba65$var$err(14, 'unknown compression type ' + c_2);
        }
    }
    return files;
}
module.exports["gzipSync"] = $0c5e3e04f495ba65$export$3d616c3fb3e15483;
module.exports["gunzipSync"] = $0c5e3e04f495ba65$export$c80456f7aaba691c;

});

parcelRegister("b3nqj", function(module, exports) {
const $39262f9932c4c2bd$export$245097525aef1262 = 'sli';
const $39262f9932c4c2bd$export$c724588856bbfbcf = 'smart';
const $39262f9932c4c2bd$export$990f5c29478a61aa = 'atlassian.fabric.mention';
module.exports["SLI_EVENT_TYPE"] = $39262f9932c4c2bd$export$245097525aef1262;
module.exports["SMART_EVENT_TYPE"] = $39262f9932c4c2bd$export$c724588856bbfbcf;

});

parcelRegister("dJKHF", function(module, exports) {

var $caelp = parcelRequire("caelp");

function $c171ae8007140e98$export$eb590c844d13454c(mention) {
    return mention.userType && mention.userType === (0, $caelp.UserType)[(0, $caelp.UserType).APP];
}
module.exports["isAppMention"] = $c171ae8007140e98$export$eb590c844d13454c;

});

parcelRegister("jymSm", function(module, exports) {

var $caelp = parcelRequire("caelp");

function $9c55ebf48e033037$export$803b1379348dbfd5(mention) {
    return mention.userType && mention.userType === (0, $caelp.UserType)[(0, $caelp.UserType).TEAM];
}
module.exports["isTeamMention"] = $9c55ebf48e033037$export$803b1379348dbfd5;

});

parcelRegister("iXlTL", function(module, exports) {

var $2SUNK = parcelRequire("2SUNK");


var $dvMxu = parcelRequire("dvMxu");

const $f6b0f26d443249fd$var$MAX_NOTIFIED_ITEMS = 20;
class $f6b0f26d443249fd$export$8576ba1ed2760927 extends (0, $dvMxu.AbstractResource) {
    shouldHighlightMention(_mention) {
        return false;
    }
    // eslint-disable-next-line class-methods-use-this
    filter(query) {
        throw new Error(`not yet implemented.\nParams: query=${query}`);
    }
    // eslint-disable-next-line class-methods-use-this, no-unused-vars
    recordMentionSelection(_mention) {
    // Do nothing
    }
    isFiltering(_query) {
        return false;
    }
    _notifyListeners(mentionsResult, stats) {
        (0, $2SUNK.default)('ak-mention-resource._notifyListeners', mentionsResult && mentionsResult.mentions && mentionsResult.mentions.length, this.changeListeners);
        this.changeListeners.forEach((listener, key)=>{
            try {
                listener(mentionsResult.mentions.slice(0, $f6b0f26d443249fd$var$MAX_NOTIFIED_ITEMS), mentionsResult.query, stats);
            } catch (e) {
                // ignore error from listener
                (0, $2SUNK.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
    _notifyAllResultsListeners(mentionsResult) {
        (0, $2SUNK.default)('ak-mention-resource._notifyAllResultsListeners', mentionsResult && mentionsResult.mentions && mentionsResult.mentions.length, this.changeListeners);
        this.allResultsListeners.forEach((listener, key)=>{
            try {
                listener(mentionsResult.mentions.slice(0, $f6b0f26d443249fd$var$MAX_NOTIFIED_ITEMS), mentionsResult.query);
            } catch (e) {
                // ignore error from listener
                (0, $2SUNK.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
    _notifyErrorListeners(error, query) {
        this.errListeners.forEach((listener, key)=>{
            try {
                listener(error, query);
            } catch (e) {
                // ignore error from listener
                (0, $2SUNK.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
    _notifyInfoListeners(info) {
        this.infoListeners.forEach((listener, key)=>{
            try {
                listener(info);
            } catch (e) {
                // ignore error fromr listener
                (0, $2SUNK.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
    _notifyAnalyticsListeners(event, actionSubject, action, attributes) {
        this.analyticsListeners.forEach((listener, key)=>{
            try {
                listener(event, actionSubject, action, attributes);
            } catch (e) {
                // ignore error from listener
                (0, $2SUNK.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
}
module.exports["AbstractMentionResource"] = $f6b0f26d443249fd$export$8576ba1ed2760927;

});

parcelRegister("dvMxu", function(module, exports) {
class $5c4239d07c0ef4c8$export$4529f10aed0950d4 {
    subscribe(key, callback, errCallback, infoCallback, allResultsCallback, analyticsListeners) {
        if (callback) this.changeListeners.set(key, callback);
        if (errCallback) this.errListeners.set(key, errCallback);
        if (infoCallback) this.infoListeners.set(key, infoCallback);
        if (allResultsCallback) this.allResultsListeners.set(key, allResultsCallback);
        if (analyticsListeners) this.analyticsListeners.set(key, analyticsListeners);
    }
    unsubscribe(key) {
        this.changeListeners.delete(key);
        this.errListeners.delete(key);
        this.infoListeners.delete(key);
        this.allResultsListeners.delete(key);
        this.analyticsListeners.delete(key);
    }
    constructor(){
        this.changeListeners = void 0;
        this.errListeners = void 0;
        this.infoListeners = void 0;
        this.allResultsListeners = void 0;
        this.analyticsListeners = void 0;
        this.changeListeners = new Map();
        this.allResultsListeners = new Map();
        this.errListeners = new Map();
        this.infoListeners = new Map();
        this.analyticsListeners = new Map();
    }
}
module.exports["AbstractResource"] = $5c4239d07c0ef4c8$export$4529f10aed0950d4;

});

parcelRegister("3ETCd", function(module, exports) {

var $2SUNK = parcelRequire("2SUNK");


var $dvMxu = parcelRequire("dvMxu");

class $4bf5f554e4571238$export$7b4524ed61cc8203 extends (0, $dvMxu.AbstractResource) {
    refreshPresence(userIds) {
        throw new Error(`not yet implemented.\nParams: userIds=${userIds}`);
    }
    notifyListeners(presences) {
        this.changeListeners.forEach((listener, key)=>{
            try {
                listener(presences);
            } catch (e) {
                // ignore error from listener
                (0, $2SUNK.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
}
module.exports["AbstractPresenceResource"] = $4bf5f554e4571238$export$7b4524ed61cc8203;

});

parcelRegister("bje9P", function(module, exports) {

var $caelp = parcelRequire("caelp");


var $d7tjP = parcelRequire("d7tjP");


var $fnGw7 = parcelRequire("fnGw7");

class $64c10b9731bd9a19$export$2ae0434dccdcb77e {
    lookupName(id) {
        const name = this.nameCache.get(id);
        if (name) {
            this.fireAnalytics(true, name);
            if (this.nameQueue.size === 0) this.scheduleOnAllResolved();
            return name;
        }
        return new Promise((resolve)=>{
            const processingItems = this.processingQueue.get(id);
            if (processingItems) this.processingQueue.set(id, [
                ...processingItems,
                resolve
            ]);
            const queuedItems = this.nameQueue.get(id) || [];
            this.nameQueue.set(id, [
                ...queuedItems,
                resolve
            ]);
            if (queuedItems.length === 0 && !processingItems) this.nameStartTime.set(id, Date.now());
            this.scheduleProcessQueue();
            if (this.isQueueAtLimit()) this.processQueue();
        });
    }
    cacheName(id, name) {
        this.nameCache.set(id, {
            id: id,
            name: name,
            status: (0, $caelp.MentionNameStatus).OK
        });
    }
    scheduleProcessQueue() {
        if (!this.debounce) this.debounce = window.setTimeout(this.processQueue, $64c10b9731bd9a19$export$2ae0434dccdcb77e.waitForBatch);
    }
    scheduleOnAllResolved() {
        if (this.debounceOnResolve) clearTimeout(this.debounceOnResolve);
        this.debounceOnResolve = window.setTimeout(()=>{
            if (this.isOnResolvedAllCalled) return;
            this.onResolvedAll();
            this.isOnResolvedAllCalled = true;
        }, $64c10b9731bd9a19$export$2ae0434dccdcb77e.waitForResolveAll);
    }
    isQueueAtLimit() {
        return this.nameQueue.size >= this.client.getLookupLimit();
    }
    splitQueueAtLimit() {
        const values = Array.from(this.nameQueue.entries());
        const splitPoint = this.client.getLookupLimit();
        return {
            queue: new Map(values.slice(0, splitPoint)),
            extraQueue: new Map(values.slice(splitPoint))
        };
    }
    resolveQueueItem(mentionDetail) {
        const { id: id } = mentionDetail;
        const resolvers = this.processingQueue.get(id);
        if (resolvers) {
            this.processingQueue.delete(id);
            this.nameCache.set(id, mentionDetail);
            resolvers.forEach((resolve)=>{
                try {
                    resolve(mentionDetail);
                } catch  {
                // ignore - exception in consumer
                }
            });
            this.fireAnalytics(false, mentionDetail);
        }
    }
    fireAnalytics(fromCache, mentionDetail) {
        const { id: id } = mentionDetail;
        const action = mentionDetail.status === (0, $caelp.MentionNameStatus).OK ? 'completed' : 'failed';
        const start = this.nameStartTime.get(id);
        const duration = start ? Date.now() - start : 0;
        this.nameStartTime.delete(id);
        this.fireHydrationEvent(action, id, fromCache, duration);
    }
    constructor(client, analyticsProps = {}, onResolvedAll = ()=>{}){
        // ms
        this.client = void 0;
        this.nameCache = new Map();
        this.nameQueue = new Map();
        this.nameStartTime = new Map();
        this.processingQueue = new Map();
        this.debounce = 0;
        this.debounceOnResolve = null;
        this.onResolvedAll = void 0;
        this.isOnResolvedAllCalled = false;
        this.fireHydrationEvent = void 0;
        this.processQueue = ()=>{
            clearTimeout(this.debounce);
            this.debounce = 0;
            const { queue: queue, extraQueue: extraQueue } = this.splitQueueAtLimit();
            this.nameQueue = extraQueue;
            this.processingQueue = (0, $fnGw7.mergeNameResolverQueues)(this.processingQueue, queue);
            this.client.lookupMentionNames(Array.from(queue.keys())).then((response)=>{
                response.forEach((mentionDetail)=>{
                    const { id: id } = mentionDetail;
                    queue.delete(id);
                    this.resolveQueueItem(mentionDetail);
                });
                queue.forEach((_callback, id)=>{
                    // No response from client for these ids treat as unknown
                    this.resolveQueueItem({
                        id: id,
                        status: (0, $caelp.MentionNameStatus).UNKNOWN
                    });
                });
            }).catch(()=>{
                // Service completely failed, reject all items in the queue
                queue.forEach((_callback, id)=>{
                    this.resolveQueueItem({
                        id: id,
                        status: (0, $caelp.MentionNameStatus).SERVICE_ERROR
                    });
                });
            });
            // Make sure anything left in the queue gets processed.
            if (this.nameQueue.size > 0) this.scheduleProcessQueue();
            else this.scheduleOnAllResolved();
        };
        this.client = client;
        this.fireHydrationEvent = (0, $d7tjP.fireAnalyticsMentionHydrationEvent)(analyticsProps);
        // If provided, this will be called once all pending mentions in the queue are resolved.
        // A sample usage is scrolling to a mention on page load, after the mentions have loadad.
        this.onResolvedAll = onResolvedAll;
    }
}
$64c10b9731bd9a19$export$2ae0434dccdcb77e.waitForBatch = 100;
// ms
$64c10b9731bd9a19$export$2ae0434dccdcb77e.waitForResolveAll = 800;
module.exports["DefaultMentionNameResolver"] = $64c10b9731bd9a19$export$2ae0434dccdcb77e;

});

parcelRegister("d7tjP", function(module, exports) {

var $852mP = parcelRequire("852mP");


var $4cczm = parcelRequire("4cczm");


var $caelp = parcelRequire("caelp");


var $4B8nE = parcelRequire("4B8nE");


var $iu9yU = parcelRequire("iu9yU");

const $7638fcfba6821dc7$export$91b2fa6a0fe06408 = (props)=>(action, userId, fromCache, duration)=>{
        if (props.createAnalyticsEvent) {
            const eventPayload = {
                action: action,
                actionSubject: (0, $caelp.ComponentNames).MENTION,
                actionSubjectId: 'hydration',
                attributes: {
                    packageName: $4B8nE.packageName,
                    packageVersion: $iu9yU.packageVersion,
                    componentName: (0, $caelp.ComponentNames).MENTION,
                    userId: userId,
                    fromCache: fromCache,
                    duration: Math.round(duration)
                },
                eventType: (0, $852mP.OPERATIONAL_EVENT_TYPE)
            };
            const analyticsEvent = props.createAnalyticsEvent(eventPayload);
            analyticsEvent.fire((0, $4cczm.ELEMENTS_CHANNEL));
        }
    };
module.exports["fireAnalyticsMentionHydrationEvent"] = $7638fcfba6821dc7$export$91b2fa6a0fe06408;

});

parcelRegister("fnGw7", function(module, exports) {
function $89691861f49f9b0f$export$71ea0798a8cad7d8(queueA, queueB) {
    const queueBeingMerged = new Map([
        ...queueA
    ]);
    // now add the items from the second queue that are not already in the
    //  merged queue being built
    [
        ...queueB
    ].forEach((item)=>{
        const [key, queueBCallbacks] = item;
        const itemAlreadyInMergedQueue = queueBeingMerged.has(key);
        if (!itemAlreadyInMergedQueue) queueBeingMerged.set(key, queueBCallbacks);
        else {
            // item already in merged queue, merge the callback arrays
            const queueACallbacks = queueBeingMerged.get(key) ?? [];
            const mergedCallbacks = new Set([
                ...queueBCallbacks,
                ...queueACallbacks
            ]);
            const deduplicatedCallbacks = Array.from(mergedCallbacks.values()); // prevents calling them twice
            queueBeingMerged.set(key, deduplicatedCallbacks);
        }
    });
    return queueBeingMerged;
}
module.exports["mergeNameResolverQueues"] = $89691861f49f9b0f$export$71ea0798a8cad7d8;

});

parcelRegister("bijHC", function(module, exports) {
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 
var $55fM8 = parcelRequire("55fM8");


var $fExfj = parcelRequire("fExfj");


var $dJKHF = parcelRequire("dJKHF");


var $jymSm = parcelRequire("jymSm");


var $caelp = parcelRequire("caelp");


var $b3nqj = parcelRequire("b3nqj");


var $2SUNK = parcelRequire("2SUNK");


var $iXlTL = parcelRequire("iXlTL");




const $ec39392517ed4807$var$MAX_QUERY_ITEMS = 100;
const $ec39392517ed4807$var$emptySecurityProvider = ()=>{
    return {
        params: {},
        headers: {}
    };
};
class $ec39392517ed4807$export$5a4331e3e1c43553 extends (0, $iXlTL.AbstractMentionResource) {
    shouldHighlightMention(mention) {
        if (this.config.shouldHighlightMention) return this.config.shouldHighlightMention(mention);
        return false;
    }
    getMentionDisabledState(mention) {
        return this.config.getMentionDisabledState?.(mention);
    }
    notify(searchTime, mentionResult, query) {
        if (searchTime > this.lastReturnedSearch) {
            this.lastReturnedSearch = searchTime;
            this._notifyListeners(mentionResult, {
                duration: Date.now() - searchTime
            });
        } else {
            const date = new Date(searchTime).toISOString().substr(17, 6);
            (0, $2SUNK.default)('Stale search result, skipping', date, query); // eslint-disable-line no-console, max-len
        }
        this._notifyAllResultsListeners(mentionResult);
    }
    notifyError(error, query) {
        this._notifyErrorListeners(error, query);
        if (query) this.activeSearches.delete(query);
    }
    async filter(query, contextIdentifier) {
        try {
            const searchTime = Date.now();
            let results;
            if (!query) results = await this.initialState(contextIdentifier);
            else {
                this.activeSearches.add(query);
                const searchResponse = this.search(query, contextIdentifier);
                results = await searchResponse.mentions;
            }
            this.notify(searchTime, results, query);
        } catch (error) {
            this.notifyError(error, query);
        }
    }
    isFiltering(query) {
        return this.activeSearches.has(query);
    }
    resolveMentionName(id) {
        if (!this.config.mentionNameResolver) return {
            id: id,
            name: '',
            status: (0, $caelp.MentionNameStatus).UNKNOWN
        };
        return this.config.mentionNameResolver.lookupName(id);
    }
    cacheMentionName(id, mentionName) {
        if (!this.config.mentionNameResolver) return;
        this.config.mentionNameResolver.cacheName(id, mentionName);
    }
    supportsMentionNameResolving() {
        return !!this.config.mentionNameResolver;
    }
    updateActiveSearches(query) {
        this.activeSearches.add(query);
    }
    verifyMentionConfig(config) {
        if (!config.url) throw new Error('config.url is a required parameter');
        if (!config.securityProvider) config.securityProvider = $ec39392517ed4807$var$emptySecurityProvider;
    }
    initialState(contextIdentifier) {
        return this.remoteInitialState(contextIdentifier);
    }
    /**
   * Clear a context object to generate query params by removing empty
   * strings, `undefined` and empty values.
   *
   * @param contextIdentifier the current context identifier
   * @returns a safe context for query encoding
   */ clearContext(contextIdentifier = {}) {
        return Object.keys(contextIdentifier).filter((key)=>contextIdentifier[key]).reduce((context, key)=>({
                [key]: contextIdentifier[key],
                ...context
            }), {});
    }
    getQueryParams(contextIdentifier) {
        const configParams = {};
        if (this.config.containerId) configParams['containerId'] = this.config.containerId;
        if (this.config.productId) configParams['productIdentifier'] = this.config.productId;
        // if contextParams exist then it will override configParams for containerId
        return {
            ...configParams,
            ...this.clearContext(contextIdentifier)
        };
    }
    /**
   * Returns the initial mention display list before a search is performed for the specified
   * container.
   *
   * @param contextIdentifier
   * @returns Promise
   */ async remoteInitialState(contextIdentifier) {
        const queryParams = this.getQueryParams(contextIdentifier);
        const configHeaders = this.config.headers;
        const options = {
            path: 'bootstrap',
            queryParams: queryParams,
            ...configHeaders && {
                requestInit: {
                    headers: configHeaders
                }
            }
        };
        try {
            const result = await (0, $fExfj.utils).requestService(this.config, options);
            this._notifyAnalyticsListeners((0, $b3nqj.SLI_EVENT_TYPE), (0, $caelp.SliNames).INITIAL_STATE, (0, $caelp.Actions).SUCCEEDED);
            return this.transformServiceResponse(result, '');
        } catch (error) {
            this._notifyAnalyticsListeners((0, $b3nqj.SLI_EVENT_TYPE), (0, $caelp.SliNames).INITIAL_STATE, (0, $caelp.Actions).FAILED);
            throw error;
        }
    }
    search(query, contextIdentifier) {
        return {
            mentions: this.remoteSearch(query, contextIdentifier)
        };
    }
    async remoteSearch(query, contextIdentifier) {
        const configHeaders = this.config.headers;
        const options = {
            path: 'search',
            queryParams: {
                query: query,
                limit: $ec39392517ed4807$var$MAX_QUERY_ITEMS,
                ...this.getQueryParams(contextIdentifier)
            },
            ...configHeaders && {
                requestInit: {
                    headers: configHeaders
                }
            }
        };
        try {
            const result = await (0, $fExfj.utils).requestService(this.config, options);
            this._notifyAnalyticsListeners((0, $b3nqj.SLI_EVENT_TYPE), (0, $caelp.SliNames).SEARCH, (0, $caelp.Actions).SUCCEEDED);
            return this.transformServiceResponse(result, query);
        } catch (error) {
            this._notifyAnalyticsListeners((0, $b3nqj.SLI_EVENT_TYPE), (0, $caelp.SliNames).SEARCH, (0, $caelp.Actions).FAILED);
            throw error;
        }
    }
    transformServiceResponse(result, query) {
        const mentions = result.mentions.map((mention)=>{
            // Loading placeholders carry none of these fields and pass through untouched.
            if (mention.isPlaceholder) return mention;
            let lozenge;
            if ((0, $dJKHF.isAppMention)(mention)) lozenge = mention.userType;
            else if ((0, $jymSm.isTeamMention)(mention)) lozenge = mention.userType;
            return {
                ...mention,
                lozenge: lozenge,
                query: query
            };
        });
        return {
            ...result,
            mentions: mentions,
            query: result.query || query
        };
    }
    constructor(config){
        super();
        this.config = void 0;
        this.lastReturnedSearch = void 0;
        this.activeSearches = void 0;
        this.productName = void 0;
        this.shouldEnableInvite = void 0;
        this.userRole = void 0;
        this.onInviteItemClick = void 0;
        this.inviteXProductUser = void 0;
        this.verifyMentionConfig(config);
        this.config = config;
        this.lastReturnedSearch = 0;
        this.activeSearches = new Set();
        this.productName = config.productName;
        this.shouldEnableInvite = !!config.shouldEnableInvite;
        this.onInviteItemClick = config.onInviteItemClick;
        this.inviteXProductUser = config.inviteXProductUser;
        this.userRole = config.userRole || 'basic';
        if (this.config.debounceTime) this.filter = (0, (/*@__PURE__*/$parcel$interopDefault($55fM8)))(this.filter, this.config.debounceTime);
    }
}
module.exports["MentionResource"] = $ec39392517ed4807$export$5a4331e3e1c43553;

});

parcelRegister("k9rxT", function(module, exports) {

var $eaCYh = parcelRequire("eaCYh");


var $3ETCd = parcelRequire("3ETCd");


var $anJMe = parcelRequire("anJMe");


var $fcFES = parcelRequire("fcFES");

class $f4cb6c0703060f5e$export$60449a906da67814 extends (0, $3ETCd.AbstractPresenceResource) {
    refreshPresence(userIds) {
        const cacheHits = this.presenceCache.getBulk(userIds);
        this.notifyListeners(cacheHits);
        const cacheMisses = this.presenceCache.getMissingUserIds(userIds);
        if (cacheMisses.length) this.retrievePresence(cacheMisses);
    }
    retrievePresence(userIds) {
        this.queryDirectoryForPresences(userIds).then((res)=>this.presenceParser.parse(res)).then((presences)=>{
            this.notifyListeners(presences);
            this.presenceCache.update(presences);
        });
    }
    queryDirectoryForPresences(userIds) {
        const query = {
            query: `query getPresenceForMentions($organizationId: String!, $userIds: [String!], $productId: String) {
                PresenceBulk(organizationId: $organizationId, product: $productId, userIds: $userIds) {
                  userId
                  state
                  stateMetadata
                }
              }`,
            variables: {
                organizationId: this.config.cloudId,
                userIds: userIds
            }
        };
        if (this.config.productId) query.variables['productId'] = this.config.productId;
        const atlAttributionHeader = (0, $eaCYh.buildAtlAttributionHeaderValue)({
            cloudId: this.config.cloudId,
            productId: this.config.productId,
            activationId: this.config.activationId
        });
        const options = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...atlAttributionHeader,
                ...this.config.headers
            },
            credentials: 'include',
            body: JSON.stringify(query)
        };
        return fetch(this.config.url, options).then((response)=>response.json());
    }
    static cleanUrl(url) {
        if (url.substr(-1) !== '/') url += '/';
        return url;
    }
    constructor(config){
        super();
        this.config = void 0;
        this.presenceCache = void 0;
        this.presenceParser = void 0;
        if (!config.url) throw new Error('config.url is a required parameter');
        if (!config.cloudId) throw new Error('config.cloudId is a required parameter');
        this.config = config;
        this.config.url = $f4cb6c0703060f5e$export$60449a906da67814.cleanUrl(config.url);
        this.presenceCache = config.cache || new (0, $anJMe.DefaultPresenceCache)(config.cacheExpiry);
        this.presenceParser = config.parser || new (0, $fcFES.DefaultPresenceParser)();
    }
}
module.exports["PresenceResource"] = $f4cb6c0703060f5e$export$60449a906da67814;

});

parcelRegister("eaCYh", function(module, exports) {
function $669159666a118337$export$9df8b8301f41e4b7(config) {
    const { cloudId: cloudId, activationId: activationId, productId: productId = 'platform' } = config;
    const value = {
        tenantId: cloudId,
        product: productId
    };
    if (activationId) value.atlWorkspaceId = `ari:cloud:${productId}:${cloudId}:workspace/${activationId}`;
    return {
        'atl-attribution': JSON.stringify(value)
    };
}
module.exports["buildAtlAttributionHeaderValue"] = $669159666a118337$export$9df8b8301f41e4b7;

});

parcelRegister("anJMe", function(module, exports) {
class $cb82e10138ad9a17$var$CacheEntry {
    expired() {
        return Date.now() > this.expiry;
    }
    constructor(pres, timeout){
        this.presence = void 0;
        this.expiry = void 0;
        this.presence = pres;
        this.expiry = Date.now() + timeout;
    }
}
class $cb82e10138ad9a17$export$f962b6f1aaaafaf5 {
    /**
   * Precondition: _delete is only called internally if userId exists in cache
   * Removes cache entry
   * @param userId
   */ _delete(userId) {
        delete this.cache[userId];
        this.size--;
    }
    /**
   * Checks a cache entry and calls delete if the info has expired
   * @param userId
   */ _deleteIfExpired(userId) {
        if (this.contains(userId) && this.cache[userId].expired()) this._delete(userId);
    }
    /**
   * Cleans expired entries from cache
   */ _removeExpired() {
        Object.keys(this.cache).forEach((id)=>{
            this._deleteIfExpired(id);
        });
    }
    /**
   * Checks if a user exists in the cache
   * @param userId
   */ contains(userId) {
        return this.cache.hasOwnProperty(userId);
    }
    /**
   * Retrieves a presence from the cache after checking for expired entries
   * @param userId - to index the cache
   * @returns Presence - the presence that matches the userId
   */ get(userId) {
        this._deleteIfExpired(userId);
        if (!this.contains(userId)) return {};
        return this.cache[userId].presence;
    }
    /**
   * Retrieve multiple presences at once from the cache
   * @param userIds - to index the cache
   * @returns PresenceMap - A map of userIds to cached Presences
   */ getBulk(userIds) {
        const presences = {};
        for (const userId of userIds)if (this.contains(userId)) presences[userId] = this.get(userId);
        return presences;
    }
    /**
   * For a given list of ids, returns a subset
   * of all the ids with missing cache entries.
   * @param userIds - to index the cache
   * @returns string[] - ids missing from the cache
   */ getMissingUserIds(userIds) {
        return userIds.filter((id)=>!this.contains(id));
    }
    /**
   * Precondition: presMap only contains ids of users not in cache
   *               expired users must first be removed then reinserted with updated presence
   * Updates the cache by adding the new Presence entries and setting the expiry time
   * @param presMap
   */ update(presMap) {
        if (this.size >= this.flushTrigger) this._removeExpired();
        Object.keys(presMap).forEach((userId)=>{
            this.cache[userId] = new $cb82e10138ad9a17$var$CacheEntry(presMap[userId], this.expiryInMillis);
            this.size++;
        });
    }
    constructor(cacheTimeout, cacheTrigger){
        this.cache = void 0;
        this.size = void 0;
        this.expiryInMillis = void 0;
        this.flushTrigger = void 0;
        this.expiryInMillis = cacheTimeout ? cacheTimeout : $cb82e10138ad9a17$export$f962b6f1aaaafaf5.defaultTimeout;
        this.flushTrigger = cacheTrigger ? cacheTrigger : $cb82e10138ad9a17$export$f962b6f1aaaafaf5.defaultFlushTrigger;
        this.cache = {};
        this.size = 0;
    }
}
$cb82e10138ad9a17$export$f962b6f1aaaafaf5.defaultTimeout = 20000;
$cb82e10138ad9a17$export$f962b6f1aaaafaf5.defaultFlushTrigger = 50;
module.exports["DefaultPresenceCache"] = $cb82e10138ad9a17$export$f962b6f1aaaafaf5;

});

parcelRegister("fcFES", function(module, exports) {
class $5a1745191e76205a$export$80bae4549cafd20d {
    mapState(state) {
        if (state === 'unavailable') return 'offline';
        else if (state === 'available') return 'online';
        else return state;
    }
    parse(response) {
        const presences = {};
        if (response.hasOwnProperty('data') && response['data'].hasOwnProperty('PresenceBulk')) {
            const results = response['data'].PresenceBulk;
            // Store map of state and time indexed by userId.  Ignore null results.
            for (const user of results){
                if (user.userId && user.state) {
                    const state = $5a1745191e76205a$export$80bae4549cafd20d.extractState(user) || user.state;
                    presences[user.userId] = {
                        status: this.mapState(state)
                    };
                } else if (!user.hasOwnProperty('userId') || !user.hasOwnProperty('state')) // eslint-disable-next-line no-console
                console.error('Unexpected response from presence service contains keys: ' + Object.keys(user));
            }
        }
        return presences;
    }
    static extractState(presence) {
        if ($5a1745191e76205a$export$80bae4549cafd20d.isFocusState(presence)) return $5a1745191e76205a$export$80bae4549cafd20d.FOCUS_STATE;
        return presence.state;
    }
    /*
     This is a bit of an odd exception. In the case where a user is in "Focus Mode", their presence state
     is returned as 'busy' along with a `stateMetadata` object containing a `focus` field.
     In this case we ignore the value of the `state` field and treat the presence as a 'focus' state.
    */ static isFocusState(presence) {
        if (presence.stateMetadata) try {
            const metadata = JSON.parse(presence.stateMetadata);
            return metadata && !!metadata.focus;
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(`Failed to parse presence's stateMetadata for user with id ${presence.userId}: ${presence.stateMetadata}`);
            // eslint-disable-next-line no-console
            console.error(e);
        }
        return false;
    }
}
$5a1745191e76205a$export$80bae4549cafd20d.FOCUS_STATE = 'focus';
module.exports["DefaultPresenceParser"] = $5a1745191e76205a$export$80bae4549cafd20d;

});

parcelRegister("cbxPV", function(module, exports) {
/// <reference lib="dom" />
/* eslint-env browser */ const $8df0c25ce2bb715f$var$element = document.createElement('i');
function $8df0c25ce2bb715f$export$289b6a6320f709b4(value) {
    const characterReference = '&' + value + ';';
    $8df0c25ce2bb715f$var$element.innerHTML = characterReference;
    const char = $8df0c25ce2bb715f$var$element.textContent;
    // Some named character references do not require the closing semicolon
    // (`&not`, for instance), which leads to situations where parsing the assumed
    // named reference of `&notit;` will result in the string `¬it;`.
    // When we encounter a trailing semicolon after parsing, and the character
    // reference to decode was not a semicolon (`&semi;`), we can assume that the
    // matching was not complete.
    // @ts-expect-error: TypeScript is wrong that `textContent` on elements can
    // yield `null`.
    if (char.charCodeAt(char.length - 1) === 59 /* `;` */  && value !== 'semi') return false;
    // If the decoded string is equal to the input, the character reference was
    // not valid.
    // @ts-expect-error: TypeScript is wrong that `textContent` on elements can
    // yield `null`.
    return char === characterReference ? false : char;
}
module.exports["decodeNamedCharacterReference"] = $8df0c25ce2bb715f$export$289b6a6320f709b4;

});

parcelRegister("6x5cj", function(module, exports) {
const $4c19db43d4ebe254$var$tab = 9 /* `\t` */ ;
const $4c19db43d4ebe254$var$space = 32 /* ` ` */ ;
function $4c19db43d4ebe254$export$a771f20bdd13def9(value) {
    const source = String(value);
    const search = /\r?\n|\r/g;
    let match = search.exec(source);
    let last = 0;
    /** @type {Array<string>} */ const lines = [];
    while(match){
        lines.push($4c19db43d4ebe254$var$trimLine(source.slice(last, match.index), last > 0, true), match[0]);
        last = match.index + match[0].length;
        match = search.exec(source);
    }
    lines.push($4c19db43d4ebe254$var$trimLine(source.slice(last), last > 0, false));
    return lines.join('');
}
/**
 * @param {string} value
 *   Line to trim.
 * @param {boolean} start
 *   Whether to trim the start of the line.
 * @param {boolean} end
 *   Whether to trim the end of the line.
 * @returns {string}
 *   Trimmed line.
 */ function $4c19db43d4ebe254$var$trimLine(value, start, end) {
    let startIndex = 0;
    let endIndex = value.length;
    if (start) {
        let code = value.codePointAt(startIndex);
        while(code === $4c19db43d4ebe254$var$tab || code === $4c19db43d4ebe254$var$space){
            startIndex++;
            code = value.codePointAt(startIndex);
        }
    }
    if (end) {
        let code = value.codePointAt(endIndex - 1);
        while(code === $4c19db43d4ebe254$var$tab || code === $4c19db43d4ebe254$var$space){
            endIndex--;
            code = value.codePointAt(endIndex - 1);
        }
    }
    return endIndex > startIndex ? value.slice(startIndex, endIndex) : '';
}
module.exports["trimLines"] = $4c19db43d4ebe254$export$a771f20bdd13def9;

});

parcelRegister("kQqCc", function(module, exports) {
// Exported through entry point /src/utils.
/**
 * Used as the identifier for container on the consumer side.
 *
 * Example:
 * ```
 * <div id={CONVERSATION_ASSISTANT_CONTAINER_ID}>
 *  <ConversationAssistant />
 * </div>
 * ```
 */ const $d52db76b74818184$export$dffb4ed44e20ea9a = 'ai-mate-container';
const $d52db76b74818184$export$64aee74ba59709e5 = 439; // px
const $d52db76b74818184$export$1c07393c5bb1bc27 = 439; // px
const $d52db76b74818184$export$aa3478deee7adbeb = 350; // px
const $d52db76b74818184$export$21e515a86cd1733b = 'Chat';
const $d52db76b74818184$export$e942bf04e23ff966 = 'Rovo';
const $d52db76b74818184$var$CONFLUENCE_AGENT_CREATION_ENTRY_POINTS = new Set([
    'globalCreateDropdown-inlineCreateAgent',
    'pageTreeItemContextualCreate-inlineCreateAgent',
    'spaceLevelContextualCreate-inlineCreateAgent',
    'endOfContentTreeContextualCreate-inlineCreateAgent',
    'globalCreateDropdown-smartCreate',
    'pageTreeItemContextualCreate-smartCreate',
    'spaceLevelContextualCreate-smartCreate',
    'endOfContentTreeContextualCreate-smartCreate',
    'confluence-rovo-agent-menu-create-agent'
]);
const $d52db76b74818184$export$f834c05603f390d3 = (source)=>$d52db76b74818184$var$CONFLUENCE_AGENT_CREATION_ENTRY_POINTS.has(source);
module.exports["CONVERSATION_ASSISTANT_CONTAINER_ID"] = $d52db76b74818184$export$dffb4ed44e20ea9a;
module.exports["CONVERSATION_ASSISTANT_CONTAINER_WIDTH"] = $d52db76b74818184$export$64aee74ba59709e5;
module.exports["CONVERSATION_ASSISTANT_MINIMUM_HEIGHT"] = $d52db76b74818184$export$aa3478deee7adbeb;
module.exports["CONVERSATION_ASSISTANT_BRAND_NAME"] = $d52db76b74818184$export$21e515a86cd1733b;
module.exports["DEFAULT_PAGE_TITLE"] = $d52db76b74818184$export$e942bf04e23ff966;
module.exports["isConfluenceAgentCreationEntryPoint"] = $d52db76b74818184$export$f834c05603f390d3;

});

parcelRegister("eXLWP", function(module, exports) {

var $96dZ7 = parcelRequire("96dZ7");

parcelRequire("e6Soq");

/**
 * Represents an actor created by `fromTransition`.
 *
 * The type of `self` within the actor's logic.
 *
 * @example
 *
 * ```ts
 * import {
 *   fromTransition,
 *   createActor,
 *   type AnyActorSystem
 * } from 'xstate';
 *
 * //* The actor's stored context.
 * type Context = {
 *   // The current count.
 *   count: number;
 *   // The amount to increase `count` by.
 *   step: number;
 * };
 * // The events the actor receives.
 * type Event = { type: 'increment' };
 * // The actor's input.
 * type Input = { step?: number };
 *
 * // Actor logic that increments `count` by `step` when it receives an event of
 * // type `increment`.
 * const logic = fromTransition<Context, Event, AnyActorSystem, Input>(
 *   (state, event, actorScope) => {
 *     actorScope.self;
 *     //         ^? TransitionActorRef<Context, Event>
 *
 *     if (event.type === 'increment') {
 *       return {
 *         ...state,
 *         count: state.count + state.step
 *       };
 *     }
 *     return state;
 *   },
 *   ({ input, self }) => {
 *     self;
 *     // ^? TransitionActorRef<Context, Event>
 *
 *     return {
 *       count: 0,
 *       step: input.step ?? 1
 *     };
 *   }
 * );
 *
 * const actor = createActor(logic, { input: { step: 10 } });
 * //    ^? TransitionActorRef<Context, Event>
 * ```
 *
 * @see {@link fromTransition}
 */ /**
 * Returns actor logic given a transition function and its initial state.
 *
 * A “transition function” is a function that takes the current `state` and
 * received `event` object as arguments, and returns the next state, similar to
 * a reducer.
 *
 * Actors created from transition logic (“transition actors”) can:
 *
 * - Receive events
 * - Emit snapshots of its state
 *
 * The transition function’s `state` is used as its transition actor’s
 * `context`.
 *
 * Note that the "state" for a transition function is provided by the initial
 * state argument, and is not the same as the State object of an actor or a
 * state within a machine configuration.
 *
 * @example
 *
 * ```ts
 * const transitionLogic = fromTransition(
 *   (state, event) => {
 *     if (event.type === 'increment') {
 *       return {
 *         ...state,
 *         count: state.count + 1
 *       };
 *     }
 *     return state;
 *   },
 *   { count: 0 }
 * );
 *
 * const transitionActor = createActor(transitionLogic);
 * transitionActor.subscribe((snapshot) => {
 *   console.log(snapshot);
 * });
 * transitionActor.start();
 * // => {
 * //   status: 'active',
 * //   context: { count: 0 },
 * //   ...
 * // }
 *
 * transitionActor.send({ type: 'increment' });
 * // => {
 * //   status: 'active',
 * //   context: { count: 1 },
 * //   ...
 * // }
 * ```
 *
 * @param transition The transition function used to describe the transition
 *   logic. It should return the next state given the current state and event.
 *   It receives the following arguments:
 *
 *   - `state` - the current state.
 *   - `event` - the received event.
 *   - `actorScope` - the actor scope object, with properties like `self` and
 *       `system`.
 *
 * @param initialContext The initial state of the transition function, either an
 *   object representing the state, or a function which returns a state object.
 *   If a function, it will receive as its only argument an object with the
 *   following properties:
 *
 *   - `input` - the `input` provided to its parent transition actor.
 *   - `self` - a reference to its parent transition actor.
 *
 * @returns Actor logic
 * @see {@link https://stately.ai/docs/input | Input docs} for more information about how input is passed
 */ function $ae4bc4d1d8af478f$export$439a4be7208a15ca(transition, initialContext) {
    return {
        config: transition,
        transition: (snapshot, event, actorScope)=>{
            return {
                ...snapshot,
                context: transition(snapshot.context, event, actorScope)
            };
        },
        getInitialSnapshot: (_, input)=>{
            return {
                status: 'active',
                output: undefined,
                error: undefined,
                context: typeof initialContext === 'function' ? initialContext({
                    input: input
                }) : initialContext
            };
        },
        getPersistedSnapshot: (snapshot)=>snapshot,
        restoreSnapshot: (snapshot)=>snapshot
    };
}
const $ae4bc4d1d8af478f$var$instanceStates = /* #__PURE__ */ new WeakMap();
/**
 * Represents an actor created by `fromCallback`.
 *
 * The type of `self` within the actor's logic.
 *
 * @example
 *
 * ```ts
 * import { fromCallback, createActor } from 'xstate';
 *
 * // The events the actor receives.
 * type Event = { type: 'someEvent' };
 * // The actor's input.
 * type Input = { name: string };
 *
 * // Actor logic that logs whenever it receives an event of type `someEvent`.
 * const logic = fromCallback<Event, Input>(({ self, input, receive }) => {
 *   self;
 *   // ^? CallbackActorRef<Event, Input>
 *
 *   receive((event) => {
 *     if (event.type === 'someEvent') {
 *       console.log(`${input.name}: received "someEvent" event`);
 *       // logs 'myActor: received "someEvent" event'
 *     }
 *   });
 * });
 *
 * const actor = createActor(logic, { input: { name: 'myActor' } });
 * //    ^? CallbackActorRef<Event, Input>
 * ```
 *
 * @see {@link fromCallback}
 */ /**
 * An actor logic creator which returns callback logic as defined by a callback
 * function.
 *
 * @remarks
 * Useful for subscription-based or other free-form logic that can send events
 * back to the parent actor.
 *
 * Actors created from callback logic (“callback actors”) can:
 *
 * - Receive events via the `receive` function
 * - Send events to the parent actor via the `sendBack` function
 *
 * Callback actors are a bit different from other actors in that they:
 *
 * - Do not work with `onDone`
 * - Do not produce a snapshot using `.getSnapshot()`
 * - Do not emit values when used with `.subscribe()`
 * - Can not be stopped with `.stop()`
 *
 * @example
 *
 * ```typescript
 * const callbackLogic = fromCallback(({ sendBack, receive }) => {
 *   let lockStatus = 'unlocked';
 *
 *   const handler = (event) => {
 *     if (lockStatus === 'locked') {
 *       return;
 *     }
 *     sendBack(event);
 *   };
 *
 *   receive((event) => {
 *     if (event.type === 'lock') {
 *       lockStatus = 'locked';
 *     } else if (event.type === 'unlock') {
 *       lockStatus = 'unlocked';
 *     }
 *   });
 *
 *   document.body.addEventListener('click', handler);
 *
 *   return () => {
 *     document.body.removeEventListener('click', handler);
 *   };
 * });
 * ```
 *
 * @param callback - The callback function used to describe the callback logic
 *   The callback function is passed an object with the following properties:
 *
 *   - `receive` - A function that can send events back to the parent actor; the
 *       listener is then called whenever events are received by the callback
 *       actor
 *   - `sendBack` - A function that can send events back to the parent actor
 *   - `input` - Data that was provided to the callback actor
 *   - `self` - The parent actor of the callback actor
 *   - `system` - The actor system to which the callback actor belongs The callback
 *       function can (optionally) return a cleanup function, which is called
 *       when the actor is stopped.
 *
 * @returns Callback logic
 * @see {@link CallbackLogicFunction} for more information about the callback function and its object argument
 * @see {@link https://stately.ai/docs/input | Input docs} for more information about how input is passed
 */ function $ae4bc4d1d8af478f$export$d0deb4828877173(callback) {
    const logic = {
        config: callback,
        start: (state, actorScope)=>{
            const { self: self, system: system, emit: emit } = actorScope;
            const callbackState = {
                receivers: undefined,
                dispose: undefined
            };
            $ae4bc4d1d8af478f$var$instanceStates.set(self, callbackState);
            callbackState.dispose = callback({
                input: state.input,
                system: system,
                self: self,
                sendBack: (event)=>{
                    if (self.getSnapshot().status === 'stopped') return;
                    if (self._parent) system._relay(self, self._parent, event);
                },
                receive: (listener)=>{
                    var _callbackState;
                    (_callbackState = callbackState).receivers ?? (_callbackState.receivers = new Set());
                    callbackState.receivers.add(listener);
                },
                emit: emit
            });
        },
        transition: (state, event, actorScope)=>{
            const callbackState = $ae4bc4d1d8af478f$var$instanceStates.get(actorScope.self);
            if (event.type === (0, $96dZ7.X)) {
                state = {
                    ...state,
                    status: 'stopped',
                    error: undefined
                };
                callbackState.dispose?.();
                return state;
            }
            callbackState.receivers?.forEach((receiver)=>receiver(event));
            return state;
        },
        getInitialSnapshot: (_, input)=>{
            return {
                status: 'active',
                output: undefined,
                error: undefined,
                input: input
            };
        },
        getPersistedSnapshot: (snapshot)=>snapshot,
        restoreSnapshot: (snapshot)=>snapshot
    };
    return logic;
}
const $ae4bc4d1d8af478f$var$XSTATE_OBSERVABLE_NEXT = 'xstate.observable.next';
const $ae4bc4d1d8af478f$var$XSTATE_OBSERVABLE_ERROR = 'xstate.observable.error';
const $ae4bc4d1d8af478f$var$XSTATE_OBSERVABLE_COMPLETE = 'xstate.observable.complete';
/**
 * Represents an actor created by `fromObservable` or `fromEventObservable`.
 *
 * The type of `self` within the actor's logic.
 *
 * @example
 *
 * ```ts
 * import { fromObservable, createActor } from 'xstate';
 * import { interval } from 'rxjs';
 *
 * // The type of the value observed by the actor's logic.
 * type Context = number;
 * // The actor's input.
 * type Input = { period?: number };
 *
 * // Actor logic that observes a number incremented every `input.period`
 * // milliseconds (default: 1_000).
 * const logic = fromObservable<Context, Input>(({ input, self }) => {
 *   self;
 *   // ^? ObservableActorRef<Event, Input>
 *
 *   return interval(input.period ?? 1_000);
 * });
 *
 * const actor = createActor(logic, { input: { period: 2_000 } });
 * //    ^? ObservableActorRef<Event, Input>
 * ```
 *
 * @see {@link fromObservable}
 * @see {@link fromEventObservable}
 */ /**
 * Observable actor logic is described by an observable stream of values. Actors
 * created from observable logic (“observable actors”) can:
 *
 * - Emit snapshots of the observable’s emitted value
 *
 * The observable’s emitted value is used as its observable actor’s `context`.
 *
 * Sending events to observable actors will have no effect.
 *
 * @example
 *
 * ```ts
 * import { fromObservable, createActor } from 'xstate';
 * import { interval } from 'rxjs';
 *
 * const logic = fromObservable((obj) => interval(1000));
 *
 * const actor = createActor(logic);
 *
 * actor.subscribe((snapshot) => {
 *   console.log(snapshot.context);
 * });
 *
 * actor.start();
 * // At every second:
 * // Logs 0
 * // Logs 1
 * // Logs 2
 * // ...
 * ```
 *
 * @param observableCreator A function that creates an observable. It receives
 *   one argument, an object with the following properties:
 *
 *   - `input` - Data that was provided to the observable actor
 *   - `self` - The parent actor
 *   - `system` - The actor system to which the observable actor belongs
 *
 *   It should return a {@link Subscribable}, which is compatible with an RxJS
 *   Observable, although RxJS is not required to create them.
 * @see {@link https://rxjs.dev} for documentation on RxJS Observable and observable creators.
 * @see {@link Subscribable} interface in XState, which is based on and compatible with RxJS Observable.
 */ function $ae4bc4d1d8af478f$export$4b2432e2d8723823(observableCreator) {
    // TODO: add event types
    const logic = {
        config: observableCreator,
        transition: (snapshot, event)=>{
            if (snapshot.status !== 'active') return snapshot;
            switch(event.type){
                case $ae4bc4d1d8af478f$var$XSTATE_OBSERVABLE_NEXT:
                    {
                        const newSnapshot = {
                            ...snapshot,
                            context: event.data
                        };
                        return newSnapshot;
                    }
                case $ae4bc4d1d8af478f$var$XSTATE_OBSERVABLE_ERROR:
                    return {
                        ...snapshot,
                        status: 'error',
                        error: event.data,
                        input: undefined,
                        _subscription: undefined
                    };
                case $ae4bc4d1d8af478f$var$XSTATE_OBSERVABLE_COMPLETE:
                    return {
                        ...snapshot,
                        status: 'done',
                        input: undefined,
                        _subscription: undefined
                    };
                case 0, $96dZ7.X:
                    snapshot._subscription.unsubscribe();
                    return {
                        ...snapshot,
                        status: 'stopped',
                        input: undefined,
                        _subscription: undefined
                    };
                default:
                    return snapshot;
            }
        },
        getInitialSnapshot: (_, input)=>{
            return {
                status: 'active',
                output: undefined,
                error: undefined,
                context: undefined,
                input: input,
                _subscription: undefined
            };
        },
        start: (state, { self: self, system: system, emit: emit })=>{
            if (state.status === 'done') // Do not restart a completed observable
            return;
            state._subscription = observableCreator({
                input: state.input,
                system: system,
                self: self,
                emit: emit
            }).subscribe({
                next: (value)=>{
                    system._relay(self, self, {
                        type: $ae4bc4d1d8af478f$var$XSTATE_OBSERVABLE_NEXT,
                        data: value
                    });
                },
                error: (err)=>{
                    system._relay(self, self, {
                        type: $ae4bc4d1d8af478f$var$XSTATE_OBSERVABLE_ERROR,
                        data: err
                    });
                },
                complete: ()=>{
                    system._relay(self, self, {
                        type: $ae4bc4d1d8af478f$var$XSTATE_OBSERVABLE_COMPLETE
                    });
                }
            });
        },
        getPersistedSnapshot: ({ _subscription: _subscription, ...state })=>state,
        restoreSnapshot: (state)=>({
                ...state,
                _subscription: undefined
            })
    };
    return logic;
}
/**
 * Creates event observable logic that listens to an observable that delivers
 * event objects.
 *
 * Event observable actor logic is described by an observable stream of
 * {@link https://stately.ai/docs/transitions#event-objects | event objects}.
 * Actors created from event observable logic (“event observable actors”) can:
 *
 * - Implicitly send events to its parent actor
 * - Emit snapshots of its emitted event objects
 *
 * Sending events to event observable actors will have no effect.
 *
 * @example
 *
 * ```ts
 * import {
 *   fromEventObservable,
 *   Subscribable,
 *   EventObject,
 *   createMachine,
 *   createActor
 * } from 'xstate';
 * import { fromEvent } from 'rxjs';
 *
 * const mouseClickLogic = fromEventObservable(
 *   () => fromEvent(document.body, 'click') as Subscribable<EventObject>
 * );
 *
 * const canvasMachine = createMachine({
 *   invoke: {
 *     // Will send mouse `click` events to the canvas actor
 *     src: mouseClickLogic
 *   }
 * });
 *
 * const canvasActor = createActor(canvasMachine);
 * canvasActor.start();
 * ```
 *
 * @param lazyObservable A function that creates an observable that delivers
 *   event objects. It receives one argument, an object with the following
 *   properties:
 *
 *   - `input` - Data that was provided to the event observable actor
 *   - `self` - The parent actor
 *   - `system` - The actor system to which the event observable actor belongs.
 *
 *   It should return a {@link Subscribable}, which is compatible with an RxJS
 *   Observable, although RxJS is not required to create them.
 */ function $ae4bc4d1d8af478f$export$32b16bdebc365919(lazyObservable) {
    // TODO: event types
    const logic = {
        config: lazyObservable,
        transition: (state, event)=>{
            if (state.status !== 'active') return state;
            switch(event.type){
                case $ae4bc4d1d8af478f$var$XSTATE_OBSERVABLE_ERROR:
                    return {
                        ...state,
                        status: 'error',
                        error: event.data,
                        input: undefined,
                        _subscription: undefined
                    };
                case $ae4bc4d1d8af478f$var$XSTATE_OBSERVABLE_COMPLETE:
                    return {
                        ...state,
                        status: 'done',
                        input: undefined,
                        _subscription: undefined
                    };
                case 0, $96dZ7.X:
                    state._subscription.unsubscribe();
                    return {
                        ...state,
                        status: 'stopped',
                        input: undefined,
                        _subscription: undefined
                    };
                default:
                    return state;
            }
        },
        getInitialSnapshot: (_, input)=>{
            return {
                status: 'active',
                output: undefined,
                error: undefined,
                context: undefined,
                input: input,
                _subscription: undefined
            };
        },
        start: (state, { self: self, system: system, emit: emit })=>{
            if (state.status === 'done') // Do not restart a completed observable
            return;
            state._subscription = lazyObservable({
                input: state.input,
                system: system,
                self: self,
                emit: emit
            }).subscribe({
                next: (value)=>{
                    if (self._parent) system._relay(self, self._parent, value);
                },
                error: (err)=>{
                    system._relay(self, self, {
                        type: $ae4bc4d1d8af478f$var$XSTATE_OBSERVABLE_ERROR,
                        data: err
                    });
                },
                complete: ()=>{
                    system._relay(self, self, {
                        type: $ae4bc4d1d8af478f$var$XSTATE_OBSERVABLE_COMPLETE
                    });
                }
            });
        },
        getPersistedSnapshot: ({ _subscription: _subscription, ...snapshot })=>snapshot,
        restoreSnapshot: (snapshot)=>({
                ...snapshot,
                _subscription: undefined
            })
    };
    return logic;
}
const $ae4bc4d1d8af478f$var$XSTATE_PROMISE_RESOLVE = 'xstate.promise.resolve';
const $ae4bc4d1d8af478f$var$XSTATE_PROMISE_REJECT = 'xstate.promise.reject';
/**
 * Represents an actor created by `fromPromise`.
 *
 * The type of `self` within the actor's logic.
 *
 * @example
 *
 * ```ts
 * import { fromPromise, createActor } from 'xstate';
 *
 * // The actor's resolved output
 * type Output = string;
 * // The actor's input.
 * type Input = { message: string };
 *
 * // Actor logic that fetches the url of an image of a cat saying `input.message`.
 * const logic = fromPromise<Output, Input>(async ({ input, self }) => {
 *   self;
 *   // ^? PromiseActorRef<Output, Input>
 *
 *   const data = await fetch(
 *     `https://cataas.com/cat/says/${input.message}`
 *   );
 *   const url = await data.json();
 *   return url;
 * });
 *
 * const actor = createActor(logic, { input: { message: 'hello world' } });
 * //    ^? PromiseActorRef<Output, Input>
 * ```
 *
 * @see {@link fromPromise}
 */ const $ae4bc4d1d8af478f$var$controllerMap = new WeakMap();
/**
 * An actor logic creator which returns promise logic as defined by an async
 * process that resolves or rejects after some time.
 *
 * Actors created from promise actor logic (“promise actors”) can:
 *
 * - Emit the resolved value of the promise
 * - Output the resolved value of the promise
 *
 * Sending events to promise actors will have no effect.
 *
 * @example
 *
 * ```ts
 * const promiseLogic = fromPromise(async () => {
 *   const result = await fetch('https://example.com/...').then((data) =>
 *     data.json()
 *   );
 *
 *   return result;
 * });
 *
 * const promiseActor = createActor(promiseLogic);
 * promiseActor.subscribe((snapshot) => {
 *   console.log(snapshot);
 * });
 * promiseActor.start();
 * // => {
 * //   output: undefined,
 * //   status: 'active'
 * //   ...
 * // }
 *
 * // After promise resolves
 * // => {
 * //   output: { ... },
 * //   status: 'done',
 * //   ...
 * // }
 * ```
 *
 * @param promiseCreator A function which returns a Promise, and accepts an
 *   object with the following properties:
 *
 *   - `input` - Data that was provided to the promise actor
 *   - `self` - The parent actor of the promise actor
 *   - `system` - The actor system to which the promise actor belongs
 *
 * @see {@link https://stately.ai/docs/input | Input docs} for more information about how input is passed
 */ function $ae4bc4d1d8af478f$export$60f45028237c39d1(promiseCreator) {
    const logic = {
        config: promiseCreator,
        transition: (state, event, scope)=>{
            if (state.status !== 'active') return state;
            switch(event.type){
                case $ae4bc4d1d8af478f$var$XSTATE_PROMISE_RESOLVE:
                    {
                        const resolvedValue = event.data;
                        return {
                            ...state,
                            status: 'done',
                            output: resolvedValue,
                            input: undefined
                        };
                    }
                case $ae4bc4d1d8af478f$var$XSTATE_PROMISE_REJECT:
                    return {
                        ...state,
                        status: 'error',
                        error: event.data,
                        input: undefined
                    };
                case 0, $96dZ7.X:
                    $ae4bc4d1d8af478f$var$controllerMap.get(scope.self)?.abort();
                    return {
                        ...state,
                        status: 'stopped',
                        input: undefined
                    };
                default:
                    return state;
            }
        },
        start: (state, { self: self, system: system, emit: emit })=>{
            // TODO: determine how to allow customizing this so that promises
            // can be restarted if necessary
            if (state.status !== 'active') return;
            const controller = new AbortController();
            $ae4bc4d1d8af478f$var$controllerMap.set(self, controller);
            const resolvedPromise = Promise.resolve(promiseCreator({
                input: state.input,
                system: system,
                self: self,
                signal: controller.signal,
                emit: emit
            }));
            resolvedPromise.then((response)=>{
                if (self.getSnapshot().status !== 'active') return;
                $ae4bc4d1d8af478f$var$controllerMap.delete(self);
                system._relay(self, self, {
                    type: $ae4bc4d1d8af478f$var$XSTATE_PROMISE_RESOLVE,
                    data: response
                });
            }, (errorData)=>{
                if (self.getSnapshot().status !== 'active') return;
                $ae4bc4d1d8af478f$var$controllerMap.delete(self);
                system._relay(self, self, {
                    type: $ae4bc4d1d8af478f$var$XSTATE_PROMISE_REJECT,
                    data: errorData
                });
            });
        },
        getInitialSnapshot: (_, input)=>{
            return {
                status: 'active',
                output: undefined,
                error: undefined,
                input: input
            };
        },
        getPersistedSnapshot: (snapshot)=>snapshot,
        restoreSnapshot: (snapshot)=>snapshot
    };
    return logic;
}
const $ae4bc4d1d8af478f$var$emptyLogic = $ae4bc4d1d8af478f$export$439a4be7208a15ca((_)=>undefined, undefined);
function $ae4bc4d1d8af478f$export$302970cd5518279b() {
    return (0, $96dZ7.A)($ae4bc4d1d8af478f$var$emptyLogic);
}
module.exports["fromCallback"] = $ae4bc4d1d8af478f$export$d0deb4828877173;
module.exports["fromObservable"] = $ae4bc4d1d8af478f$export$4b2432e2d8723823;
module.exports["fromPromise"] = $ae4bc4d1d8af478f$export$60f45028237c39d1;

});

parcelRegister("96dZ7", function(module, exports) {

var $e6Soq = parcelRequire("e6Soq");

class $69ff85b27d828958$var$Mailbox {
    start() {
        this._active = true;
        this.flush();
    }
    clear() {
        // we can't set _current to null because we might be currently processing
        // and enqueue following clear shouldnt start processing the enqueued item immediately
        if (this._current) {
            this._current.next = null;
            this._last = this._current;
        }
    }
    enqueue(event) {
        const enqueued = {
            value: event,
            next: null
        };
        if (this._current) {
            this._last.next = enqueued;
            this._last = enqueued;
            return;
        }
        this._current = enqueued;
        this._last = enqueued;
        if (this._active) this.flush();
    }
    flush() {
        while(this._current){
            // atm the given _process is responsible for implementing proper try/catch handling
            // we assume here that this won't throw in a way that can affect this mailbox
            const consumed = this._current;
            this._process(consumed.value);
            this._current = consumed.next;
        }
        this._last = null;
    }
    constructor(_process){
        this._process = _process;
        this._active = false;
        this._current = null;
        this._last = null;
    }
}
const $69ff85b27d828958$export$25ce5a424b770e84 = '.';
const $69ff85b27d828958$var$TARGETLESS_KEY = '';
const $69ff85b27d828958$export$a07804094c3ecf2d = '';
const $69ff85b27d828958$var$STATE_IDENTIFIER = '#';
const $69ff85b27d828958$var$WILDCARD = '*';
const $69ff85b27d828958$var$XSTATE_INIT = 'xstate.init';
const $69ff85b27d828958$export$e7c866399fa523f5 = 'xstate.error';
const $69ff85b27d828958$export$78acf4525d8a74c4 = 'xstate.stop';
/**
 * Returns an event that represents an implicit event that is sent after the
 * specified `delay`.
 *
 * @param delayRef The delay in milliseconds
 * @param id The state node ID where this event is handled
 */ function $69ff85b27d828958$var$createAfterEvent(delayRef, id) {
    return {
        type: `xstate.after.${delayRef}.${id}`
    };
}
/**
 * Returns an event that represents that a final state node has been reached in
 * the parent state node.
 *
 * @param id The final state node's parent state node `id`
 * @param output The data to pass into the event
 */ function $69ff85b27d828958$var$createDoneStateEvent(id, output) {
    return {
        type: `xstate.done.state.${id}`,
        output: output
    };
}
/**
 * Returns an event that represents that an invoked service has terminated.
 *
 * An invoked service is terminated when it has reached a top-level final state
 * node, but not when it is canceled.
 *
 * @param invokeId The invoked service ID
 * @param output The data to pass into the event
 */ function $69ff85b27d828958$var$createDoneActorEvent(invokeId, output) {
    return {
        type: `xstate.done.actor.${invokeId}`,
        output: output,
        actorId: invokeId
    };
}
function $69ff85b27d828958$export$71cec2538cb2c617(id, error) {
    return {
        type: `xstate.error.actor.${id}`,
        error: error,
        actorId: id
    };
}
function $69ff85b27d828958$export$9e5f44173e64f162(input) {
    return {
        type: $69ff85b27d828958$var$XSTATE_INIT,
        input: input
    };
}
/**
 * This function makes sure that unhandled errors are thrown in a separate
 * macrotask. It allows those errors to be detected by global error handlers and
 * reported to bug tracking services without interrupting our own stack of
 * execution.
 *
 * @param err Error to be thrown
 */ function $69ff85b27d828958$var$reportUnhandledError(err) {
    setTimeout(()=>{
        throw err;
    });
}
const $69ff85b27d828958$var$symbolObservable = (()=>typeof Symbol === 'function' && Symbol.observable || '@@observable')();
function $69ff85b27d828958$export$b4171a6734a65d42(parentStateId, childStateId) {
    const parentStateValue = $69ff85b27d828958$var$toStateValue(parentStateId);
    const childStateValue = $69ff85b27d828958$var$toStateValue(childStateId);
    if (typeof childStateValue === 'string') {
        if (typeof parentStateValue === 'string') return childStateValue === parentStateValue;
        // Parent more specific than child
        return false;
    }
    if (typeof parentStateValue === 'string') return parentStateValue in childStateValue;
    return Object.keys(parentStateValue).every((key)=>{
        if (!(key in childStateValue)) return false;
        return $69ff85b27d828958$export$b4171a6734a65d42(parentStateValue[key], childStateValue[key]);
    });
}
function $69ff85b27d828958$export$90a7f3efeed30595(stateId) {
    if ($69ff85b27d828958$var$isArray(stateId)) return stateId;
    const result = [];
    let segment = '';
    for(let i = 0; i < stateId.length; i++){
        const char = stateId.charCodeAt(i);
        switch(char){
            // \
            case 92:
                // consume the next character
                segment += stateId[i + 1];
                // and skip over it
                i++;
                continue;
            // .
            case 46:
                result.push(segment);
                segment = '';
                continue;
        }
        segment += stateId[i];
    }
    result.push(segment);
    return result;
}
function $69ff85b27d828958$var$toStateValue(stateValue) {
    if ($69ff85b27d828958$export$7f8ddf7c7c20b3cd(stateValue)) return stateValue.value;
    if (typeof stateValue !== 'string') return stateValue;
    const statePath = $69ff85b27d828958$export$90a7f3efeed30595(stateValue);
    return $69ff85b27d828958$export$3466f893ebf79586(statePath);
}
function $69ff85b27d828958$export$3466f893ebf79586(statePath) {
    if (statePath.length === 1) return statePath[0];
    const value = {};
    let marker = value;
    for(let i = 0; i < statePath.length - 1; i++)if (i === statePath.length - 2) marker[statePath[i]] = statePath[i + 1];
    else {
        const previous = marker;
        marker = {};
        previous[statePath[i]] = marker;
    }
    return value;
}
function $69ff85b27d828958$export$953cecd6e717a553(collection, iteratee) {
    const result = {};
    const collectionKeys = Object.keys(collection);
    for(let i = 0; i < collectionKeys.length; i++){
        const key = collectionKeys[i];
        result[key] = iteratee(collection[key], key, collection, i);
    }
    return result;
}
function $69ff85b27d828958$var$toArrayStrict(value) {
    if ($69ff85b27d828958$var$isArray(value)) return value;
    return [
        value
    ];
}
function $69ff85b27d828958$export$625550452a3fa3ec(value) {
    if (value === undefined) return [];
    return $69ff85b27d828958$var$toArrayStrict(value);
}
function $69ff85b27d828958$var$resolveOutput(mapper, context, event, self) {
    if (typeof mapper === 'function') return mapper({
        context: context,
        event: event,
        self: self
    });
    return mapper;
}
function $69ff85b27d828958$var$isArray(value) {
    return Array.isArray(value);
}
function $69ff85b27d828958$var$isErrorActorEvent(event) {
    return event.type.startsWith('xstate.error.actor');
}
function $69ff85b27d828958$export$407448d2b89b1813(configLike) {
    return $69ff85b27d828958$var$toArrayStrict(configLike).map((transitionLike)=>{
        if (typeof transitionLike === 'undefined' || typeof transitionLike === 'string') return {
            target: transitionLike
        };
        return transitionLike;
    });
}
function $69ff85b27d828958$var$normalizeTarget(target) {
    if (target === undefined || target === $69ff85b27d828958$var$TARGETLESS_KEY) return undefined;
    return $69ff85b27d828958$export$625550452a3fa3ec(target);
}
function $69ff85b27d828958$export$61196ced6d74a310(nextHandler, errorHandler, completionHandler) {
    const isObserver = typeof nextHandler === 'object';
    const self = isObserver ? nextHandler : undefined;
    return {
        next: (isObserver ? nextHandler.next : nextHandler)?.bind(self),
        error: (isObserver ? nextHandler.error : errorHandler)?.bind(self),
        complete: (isObserver ? nextHandler.complete : completionHandler)?.bind(self)
    };
}
function $69ff85b27d828958$export$db3b6bfb95261072(stateNodeId, index) {
    return `${index}.${stateNodeId}`;
}
function $69ff85b27d828958$export$df995fae86a55f06(machine, src) {
    const match = src.match(/^xstate\.invoke\.(\d+)\.(.*)/);
    if (!match) return machine.implementations.actors[src];
    const [, indexStr, nodeId] = match;
    const node = machine.getStateNodeById(nodeId);
    const invokeConfig = node.config.invoke;
    return (Array.isArray(invokeConfig) ? invokeConfig[indexStr] : invokeConfig).src;
}
function $69ff85b27d828958$export$9bb611d729802a56(snapshot) {
    return [
        ...new Set([
            ...snapshot._nodes.flatMap((sn)=>sn.ownEvents)
        ])
    ];
}
function $69ff85b27d828958$var$createScheduledEventId(actorRef, id) {
    return `${actorRef.sessionId}.${id}`;
}
let $69ff85b27d828958$var$idCounter = 0;
function $69ff85b27d828958$var$createSystem(rootActor, options) {
    const children = new Map();
    const keyedActors = new Map();
    const reverseKeyedActors = new WeakMap();
    const inspectionObservers = new Set();
    const timerMap = {};
    const { clock: clock, logger: logger } = options;
    const scheduler = {
        schedule: (source, target, event, delay, id = Math.random().toString(36).slice(2))=>{
            const scheduledEvent = {
                source: source,
                target: target,
                event: event,
                delay: delay,
                id: id,
                startedAt: Date.now()
            };
            const scheduledEventId = $69ff85b27d828958$var$createScheduledEventId(source, id);
            system._snapshot._scheduledEvents[scheduledEventId] = scheduledEvent;
            const timeout = clock.setTimeout(()=>{
                delete timerMap[scheduledEventId];
                delete system._snapshot._scheduledEvents[scheduledEventId];
                system._relay(source, target, event);
            }, delay);
            timerMap[scheduledEventId] = timeout;
        },
        cancel: (source, id)=>{
            const scheduledEventId = $69ff85b27d828958$var$createScheduledEventId(source, id);
            const timeout = timerMap[scheduledEventId];
            delete timerMap[scheduledEventId];
            delete system._snapshot._scheduledEvents[scheduledEventId];
            if (timeout !== undefined) clock.clearTimeout(timeout);
        },
        cancelAll: (actorRef)=>{
            for(const scheduledEventId in system._snapshot._scheduledEvents){
                const scheduledEvent = system._snapshot._scheduledEvents[scheduledEventId];
                if (scheduledEvent.source === actorRef) scheduler.cancel(actorRef, scheduledEvent.id);
            }
        }
    };
    const sendInspectionEvent = (event)=>{
        if (!inspectionObservers.size) return;
        const resolvedInspectionEvent = {
            ...event,
            rootId: rootActor.sessionId
        };
        inspectionObservers.forEach((observer)=>observer.next?.(resolvedInspectionEvent));
    };
    const system = {
        _snapshot: {
            _scheduledEvents: (options?.snapshot && options.snapshot.scheduler) ?? {}
        },
        _bookId: ()=>`x:${$69ff85b27d828958$var$idCounter++}`,
        _register: (sessionId, actorRef)=>{
            children.set(sessionId, actorRef);
            return sessionId;
        },
        _unregister: (actorRef)=>{
            children.delete(actorRef.sessionId);
            const systemId = reverseKeyedActors.get(actorRef);
            if (systemId !== undefined) {
                keyedActors.delete(systemId);
                reverseKeyedActors.delete(actorRef);
            }
        },
        get: (systemId)=>{
            return keyedActors.get(systemId);
        },
        _set: (systemId, actorRef)=>{
            const existing = keyedActors.get(systemId);
            if (existing && existing !== actorRef) throw new Error(`Actor with system ID '${systemId}' already exists.`);
            keyedActors.set(systemId, actorRef);
            reverseKeyedActors.set(actorRef, systemId);
        },
        inspect: (observerOrFn)=>{
            const observer = $69ff85b27d828958$export$61196ced6d74a310(observerOrFn);
            inspectionObservers.add(observer);
            return {
                unsubscribe () {
                    inspectionObservers.delete(observer);
                }
            };
        },
        _sendInspectionEvent: sendInspectionEvent,
        _relay: (source, target, event)=>{
            system._sendInspectionEvent({
                type: '@xstate.event',
                sourceRef: source,
                actorRef: target,
                event: event
            });
            target._send(event);
        },
        scheduler: scheduler,
        getSnapshot: ()=>{
            return {
                _scheduledEvents: {
                    ...system._snapshot._scheduledEvents
                }
            };
        },
        start: ()=>{
            const scheduledEvents = system._snapshot._scheduledEvents;
            system._snapshot._scheduledEvents = {};
            for(const scheduledId in scheduledEvents){
                const { source: source, target: target, event: event, delay: delay, id: id } = scheduledEvents[scheduledId];
                scheduler.schedule(source, target, event, delay, id);
            }
        },
        _clock: clock,
        _logger: logger
    };
    return system;
}
let $69ff85b27d828958$var$executingCustomAction = false;
const $69ff85b27d828958$export$3d8c2f653ac9d0b9 = 1;
// those values are currently used by @xstate/react directly so it's important to keep the assigned values in sync
let $69ff85b27d828958$export$971d5caa766a69d7 = /*#__PURE__*/ function(ProcessingStatus) {
    ProcessingStatus[ProcessingStatus["NotStarted"] = 0] = "NotStarted";
    ProcessingStatus[ProcessingStatus["Running"] = 1] = "Running";
    ProcessingStatus[ProcessingStatus["Stopped"] = 2] = "Stopped";
    return ProcessingStatus;
}({});
const $69ff85b27d828958$var$defaultOptions = {
    clock: {
        setTimeout: (fn, ms)=>{
            return setTimeout(fn, ms);
        },
        clearTimeout: (id)=>{
            return clearTimeout(id);
        }
    },
    logger: console.log.bind(console),
    devTools: false
};
/**
 * An Actor is a running process that can receive events, send events and change
 * its behavior based on the events it receives, which can cause effects outside
 * of the actor. When you run a state machine, it becomes an actor.
 */ class $69ff85b27d828958$export$ef35774e6d314e91 {
    _initState(persistedState) {
        try {
            this._snapshot = persistedState ? this.logic.restoreSnapshot ? this.logic.restoreSnapshot(persistedState, this._actorScope) : persistedState : this.logic.getInitialSnapshot(this._actorScope, this.options?.input);
        } catch (err) {
            // if we get here then it means that we assign a value to this._snapshot that is not of the correct type
            // we can't get the true `TSnapshot & { status: 'error'; }`, it's impossible
            // so right now this is a lie of sorts
            this._snapshot = {
                status: 'error',
                output: undefined,
                error: err
            };
        }
    }
    update(snapshot, event) {
        // Update state
        this._snapshot = snapshot;
        // Execute deferred effects
        let deferredFn;
        while(deferredFn = this._deferred.shift())try {
            deferredFn();
        } catch (err) {
            // this error can only be caught when executing *initial* actions
            // it's the only time when we call actions provided by the user through those deferreds
            // when the actor is already running we always execute them synchronously while transitioning
            // no "builtin deferred" should actually throw an error since they are either safe
            // or the control flow is passed through the mailbox and errors should be caught by the `_process` used by the mailbox
            this._deferred.length = 0;
            this._snapshot = {
                ...snapshot,
                status: 'error',
                error: err
            };
        }
        switch(this._snapshot.status){
            case 'active':
                for (const observer of this.observers)try {
                    observer.next?.(snapshot);
                } catch (err) {
                    $69ff85b27d828958$var$reportUnhandledError(err);
                }
                break;
            case 'done':
                // next observers are meant to be notified about done snapshots
                // this can be seen as something that is different from how observable work
                // but with observables `complete` callback is called without any arguments
                // it's more ergonomic for XState to treat a done snapshot as a "next" value
                // and the completion event as something that is separate,
                // something that merely follows emitting that done snapshot
                for (const observer of this.observers)try {
                    observer.next?.(snapshot);
                } catch (err) {
                    $69ff85b27d828958$var$reportUnhandledError(err);
                }
                this._stopProcedure();
                this._complete();
                this._doneEvent = $69ff85b27d828958$var$createDoneActorEvent(this.id, this._snapshot.output);
                if (this._parent) this.system._relay(this, this._parent, this._doneEvent);
                break;
            case 'error':
                this._error(this._snapshot.error);
                break;
        }
        this.system._sendInspectionEvent({
            type: '@xstate.snapshot',
            actorRef: this,
            event: event,
            snapshot: snapshot
        });
    }
    /**
   * Subscribe an observer to an actor’s snapshot values.
   *
   * @remarks
   * The observer will receive the actor’s snapshot value when it is emitted.
   * The observer can be:
   *
   * - A plain function that receives the latest snapshot, or
   * - An observer object whose `.next(snapshot)` method receives the latest
   *   snapshot
   *
   * @example
   *
   * ```ts
   * // Observer as a plain function
   * const subscription = actor.subscribe((snapshot) => {
   *   console.log(snapshot);
   * });
   * ```
   *
   * @example
   *
   * ```ts
   * // Observer as an object
   * const subscription = actor.subscribe({
   *   next(snapshot) {
   *     console.log(snapshot);
   *   },
   *   error(err) {
   *     // ...
   *   },
   *   complete() {
   *     // ...
   *   }
   * });
   * ```
   *
   * The return value of `actor.subscribe(observer)` is a subscription object
   * that has an `.unsubscribe()` method. You can call
   * `subscription.unsubscribe()` to unsubscribe the observer:
   *
   * @example
   *
   * ```ts
   * const subscription = actor.subscribe((snapshot) => {
   *   // ...
   * });
   *
   * // Unsubscribe the observer
   * subscription.unsubscribe();
   * ```
   *
   * When the actor is stopped, all of its observers will automatically be
   * unsubscribed.
   *
   * @param observer - Either a plain function that receives the latest
   *   snapshot, or an observer object whose `.next(snapshot)` method receives
   *   the latest snapshot
   */ subscribe(nextListenerOrObserver, errorListener, completeListener) {
        const observer = $69ff85b27d828958$export$61196ced6d74a310(nextListenerOrObserver, errorListener, completeListener);
        if (this._processingStatus !== $69ff85b27d828958$export$971d5caa766a69d7.Stopped) this.observers.add(observer);
        else switch(this._snapshot.status){
            case 'done':
                try {
                    observer.complete?.();
                } catch (err) {
                    $69ff85b27d828958$var$reportUnhandledError(err);
                }
                break;
            case 'error':
                {
                    const err = this._snapshot.error;
                    if (!observer.error) $69ff85b27d828958$var$reportUnhandledError(err);
                    else try {
                        observer.error(err);
                    } catch (err) {
                        $69ff85b27d828958$var$reportUnhandledError(err);
                    }
                    break;
                }
        }
        return {
            unsubscribe: ()=>{
                this.observers.delete(observer);
            }
        };
    }
    on(type, handler) {
        let listeners = this.eventListeners.get(type);
        if (!listeners) {
            listeners = new Set();
            this.eventListeners.set(type, listeners);
        }
        const wrappedHandler = handler.bind(undefined);
        listeners.add(wrappedHandler);
        return {
            unsubscribe: ()=>{
                listeners.delete(wrappedHandler);
            }
        };
    }
    /** Starts the Actor from the initial state */ start() {
        if (this._processingStatus === $69ff85b27d828958$export$971d5caa766a69d7.Running) // Do not restart the service if it is already started
        return this;
        if (this._syncSnapshot) this.subscribe({
            next: (snapshot)=>{
                if (snapshot.status === 'active') this.system._relay(this, this._parent, {
                    type: `xstate.snapshot.${this.id}`,
                    snapshot: snapshot
                });
            },
            error: ()=>{}
        });
        this.system._register(this.sessionId, this);
        if (this._systemId) this.system._set(this._systemId, this);
        this._processingStatus = $69ff85b27d828958$export$971d5caa766a69d7.Running;
        // TODO: this isn't correct when rehydrating
        const initEvent = $69ff85b27d828958$export$9e5f44173e64f162(this.options.input);
        this.system._sendInspectionEvent({
            type: '@xstate.event',
            sourceRef: this._parent,
            actorRef: this,
            event: initEvent
        });
        const status = this._snapshot.status;
        switch(status){
            case 'done':
                // a state machine can be "done" upon initialization (it could reach a final state using initial microsteps)
                // we still need to complete observers, flush deferreds etc
                this.update(this._snapshot, initEvent);
                // TODO: rethink cleanup of observers, mailbox, etc
                return this;
            case 'error':
                this._error(this._snapshot.error);
                return this;
        }
        if (!this._parent) this.system.start();
        if (this.logic.start) try {
            this.logic.start(this._snapshot, this._actorScope);
        } catch (err) {
            this._snapshot = {
                ...this._snapshot,
                status: 'error',
                error: err
            };
            this._error(err);
            return this;
        }
        // TODO: this notifies all subscribers but usually this is redundant
        // there is no real change happening here
        // we need to rethink if this needs to be refactored
        this.update(this._snapshot, initEvent);
        if (this.options.devTools) this.attachDevTools();
        this.mailbox.start();
        return this;
    }
    _process(event) {
        let nextState;
        let caughtError;
        try {
            nextState = this.logic.transition(this._snapshot, event, this._actorScope);
        } catch (err) {
            // we wrap it in a box so we can rethrow it later even if falsy value gets caught here
            caughtError = {
                err: err
            };
        }
        if (caughtError) {
            const { err: err } = caughtError;
            this._snapshot = {
                ...this._snapshot,
                status: 'error',
                error: err
            };
            this._error(err);
            return;
        }
        this.update(nextState, event);
        if (event.type === $69ff85b27d828958$export$78acf4525d8a74c4) {
            this._stopProcedure();
            this._complete();
        }
    }
    _stop() {
        if (this._processingStatus === $69ff85b27d828958$export$971d5caa766a69d7.Stopped) return this;
        this.mailbox.clear();
        if (this._processingStatus === $69ff85b27d828958$export$971d5caa766a69d7.NotStarted) {
            this._processingStatus = $69ff85b27d828958$export$971d5caa766a69d7.Stopped;
            return this;
        }
        this.mailbox.enqueue({
            type: $69ff85b27d828958$export$78acf4525d8a74c4
        });
        return this;
    }
    /** Stops the Actor and unsubscribe all listeners. */ stop() {
        if (this._parent) throw new Error('A non-root actor cannot be stopped directly.');
        return this._stop();
    }
    _complete() {
        for (const observer of this.observers)try {
            observer.complete?.();
        } catch (err) {
            $69ff85b27d828958$var$reportUnhandledError(err);
        }
        this.observers.clear();
    }
    _reportError(err) {
        if (!this.observers.size) {
            if (!this._parent) $69ff85b27d828958$var$reportUnhandledError(err);
            return;
        }
        let reportError = false;
        for (const observer of this.observers){
            const errorListener = observer.error;
            reportError || (reportError = !errorListener);
            try {
                errorListener?.(err);
            } catch (err2) {
                $69ff85b27d828958$var$reportUnhandledError(err2);
            }
        }
        this.observers.clear();
        if (reportError) $69ff85b27d828958$var$reportUnhandledError(err);
    }
    _error(err) {
        this._stopProcedure();
        this._reportError(err);
        if (this._parent) this.system._relay(this, this._parent, $69ff85b27d828958$export$71cec2538cb2c617(this.id, err));
    }
    // TODO: atm children don't belong entirely to the actor so
    // in a way - it's not even super aware of them
    // so we can't stop them from here but we really should!
    // right now, they are being stopped within the machine's transition
    // but that could throw and leave us with "orphaned" active actors
    _stopProcedure() {
        if (this._processingStatus !== $69ff85b27d828958$export$971d5caa766a69d7.Running) // Actor already stopped; do nothing
        return this;
        // Cancel all delayed events
        this.system.scheduler.cancelAll(this);
        // TODO: mailbox.reset
        this.mailbox.clear();
        // TODO: after `stop` we must prepare ourselves for receiving events again
        // events sent *after* stop signal must be queued
        // it seems like this should be the common behavior for all of our consumers
        // so perhaps this should be unified somehow for all of them
        this.mailbox = new $69ff85b27d828958$var$Mailbox(this._process.bind(this));
        this._processingStatus = $69ff85b27d828958$export$971d5caa766a69d7.Stopped;
        this.system._unregister(this);
        return this;
    }
    /** @internal */ _send(event) {
        if (this._processingStatus === $69ff85b27d828958$export$971d5caa766a69d7.Stopped) return;
        this.mailbox.enqueue(event);
    }
    /**
   * Sends an event to the running Actor to trigger a transition.
   *
   * @param event The event to send
   */ send(event) {
        this.system._relay(undefined, this, event);
    }
    attachDevTools() {
        const { devTools: devTools } = this.options;
        if (devTools) {
            const resolvedDevToolsAdapter = typeof devTools === 'function' ? devTools : (0, $e6Soq.devToolsAdapter);
            resolvedDevToolsAdapter(this);
        }
    }
    toJSON() {
        return {
            xstate$$type: $69ff85b27d828958$export$3d8c2f653ac9d0b9,
            id: this.id
        };
    }
    /**
   * Obtain the internal state of the actor, which can be persisted.
   *
   * @remarks
   * The internal state can be persisted from any actor, not only machines.
   *
   * Note that the persisted state is not the same as the snapshot from
   * {@link Actor.getSnapshot}. Persisted state represents the internal state of
   * the actor, while snapshots represent the actor's last emitted value.
   *
   * Can be restored with {@link ActorOptions.state}
   * @see https://stately.ai/docs/persistence
   */ getPersistedSnapshot(options) {
        return this.logic.getPersistedSnapshot(this._snapshot, options);
    }
    [$69ff85b27d828958$var$symbolObservable]() {
        return this;
    }
    /**
   * Read an actor’s snapshot synchronously.
   *
   * @remarks
   * The snapshot represent an actor's last emitted value.
   *
   * When an actor receives an event, its internal state may change. An actor
   * may emit a snapshot when a state transition occurs.
   *
   * Note that some actors, such as callback actors generated with
   * `fromCallback`, will not emit snapshots.
   * @see {@link Actor.subscribe} to subscribe to an actor’s snapshot values.
   * @see {@link Actor.getPersistedSnapshot} to persist the internal state of an actor (which is more than just a snapshot).
   */ getSnapshot() {
        return this._snapshot;
    }
    /**
   * Creates a new actor instance for the given logic with the provided options,
   * if any.
   *
   * @param logic The logic to create an actor from
   * @param options Actor options
   */ constructor(logic, options){
        this.logic = logic;
        /** The current internal state of the actor. */ this._snapshot = void 0;
        /**
     * The clock that is responsible for setting and clearing timeouts, such as
     * delayed events and transitions.
     */ this.clock = void 0;
        this.options = void 0;
        /** The unique identifier for this actor relative to its parent. */ this.id = void 0;
        this.mailbox = new $69ff85b27d828958$var$Mailbox(this._process.bind(this));
        this.observers = new Set();
        this.eventListeners = new Map();
        this.logger = void 0;
        /** @internal */ this._processingStatus = $69ff85b27d828958$export$971d5caa766a69d7.NotStarted;
        // Actor Ref
        this._parent = void 0;
        /** @internal */ this._syncSnapshot = void 0;
        this.ref = void 0;
        // TODO: add typings for system
        this._actorScope = void 0;
        this._systemId = void 0;
        /** The globally unique process ID for this invocation. */ this.sessionId = void 0;
        /** The system to which this actor belongs. */ this.system = void 0;
        this._doneEvent = void 0;
        this.src = void 0;
        // array of functions to defer
        this._deferred = [];
        const resolvedOptions = {
            ...$69ff85b27d828958$var$defaultOptions,
            ...options
        };
        const { clock: clock, logger: logger, parent: parent, syncSnapshot: syncSnapshot, id: id, systemId: systemId, inspect: inspect } = resolvedOptions;
        this.system = parent ? parent.system : $69ff85b27d828958$var$createSystem(this, {
            clock: clock,
            logger: logger
        });
        if (inspect && !parent) // Always inspect at the system-level
        this.system.inspect($69ff85b27d828958$export$61196ced6d74a310(inspect));
        this.sessionId = this.system._bookId();
        this.id = id ?? this.sessionId;
        this.logger = options?.logger ?? this.system._logger;
        this.clock = options?.clock ?? this.system._clock;
        this._parent = parent;
        this._syncSnapshot = syncSnapshot;
        this.options = resolvedOptions;
        this.src = resolvedOptions.src ?? logic;
        this.ref = this;
        this._actorScope = {
            self: this,
            id: this.id,
            sessionId: this.sessionId,
            logger: this.logger,
            defer: (fn)=>{
                this._deferred.push(fn);
            },
            system: this.system,
            stopChild: (child)=>{
                if (child._parent !== this) throw new Error(`Cannot stop child actor ${child.id} of ${this.id} because it is not a child`);
                child._stop();
            },
            emit: (emittedEvent)=>{
                const listeners = this.eventListeners.get(emittedEvent.type);
                const wildcardListener = this.eventListeners.get('*');
                if (!listeners && !wildcardListener) return;
                const allListeners = [
                    ...listeners ? listeners.values() : [],
                    ...wildcardListener ? wildcardListener.values() : []
                ];
                for (const handler of allListeners)handler(emittedEvent);
            },
            actionExecutor: (action)=>{
                const exec = ()=>{
                    this._actorScope.system._sendInspectionEvent({
                        type: '@xstate.action',
                        actorRef: this,
                        action: {
                            type: action.type,
                            params: action.params
                        }
                    });
                    if (!action.exec) return;
                    const saveExecutingCustomAction = $69ff85b27d828958$var$executingCustomAction;
                    try {
                        $69ff85b27d828958$var$executingCustomAction = true;
                        action.exec(action.info, action.params);
                    } finally{
                        $69ff85b27d828958$var$executingCustomAction = saveExecutingCustomAction;
                    }
                };
                if (this._processingStatus === $69ff85b27d828958$export$971d5caa766a69d7.Running) exec();
                else this._deferred.push(exec);
            }
        };
        // Ensure that the send method is bound to this Actor instance
        // if destructured
        this.send = this.send.bind(this);
        this.system._sendInspectionEvent({
            type: '@xstate.actor',
            actorRef: this
        });
        if (systemId) {
            this._systemId = systemId;
            this.system._set(systemId, this);
        }
        this._initState(options?.snapshot ?? options?.state);
        if (systemId && this._snapshot.status !== 'active') this.system._unregister(this);
    }
}
/**
 * Creates a new actor instance for the given actor logic with the provided
 * options, if any.
 *
 * @remarks
 * When you create an actor from actor logic via `createActor(logic)`, you
 * implicitly create an actor system where the created actor is the root actor.
 * Any actors spawned from this root actor and its descendants are part of that
 * actor system.
 * @example
 *
 * ```ts
 * import { createActor } from 'xstate';
 * import { someActorLogic } from './someActorLogic.ts';
 *
 * // Creating the actor, which implicitly creates an actor system with itself as the root actor
 * const actor = createActor(someActorLogic);
 *
 * actor.subscribe((snapshot) => {
 *   console.log(snapshot);
 * });
 *
 * // Actors must be started by calling `actor.start()`, which will also start the actor system.
 * actor.start();
 *
 * // Actors can receive events
 * actor.send({ type: 'someEvent' });
 *
 * // You can stop root actors by calling `actor.stop()`, which will also stop the actor system and all actors in that system.
 * actor.stop();
 * ```
 *
 * @param logic - The actor logic to create an actor from. For a state machine
 *   actor logic creator, see {@link createMachine}. Other actor logic creators
 *   include {@link fromCallback}, {@link fromEventObservable},
 *   {@link fromObservable}, {@link fromPromise}, and {@link fromTransition}.
 * @param options - Actor options
 */ function $69ff85b27d828958$export$ebd11618f299a286(logic, ...[options]) {
    return new $69ff85b27d828958$export$ef35774e6d314e91(logic, options);
}
/**
 * Creates a new Interpreter instance for the given machine with the provided
 * options, if any.
 *
 * @deprecated Use `createActor` instead
 * @alias
 */ const $69ff85b27d828958$export$e7094788287c5e9b = $69ff85b27d828958$export$ebd11618f299a286;
/**
 * @deprecated Use `Actor` instead.
 * @alias
 */ function $69ff85b27d828958$var$resolveCancel(_, snapshot, actionArgs, actionParams, { sendId: sendId }) {
    const resolvedSendId = typeof sendId === 'function' ? sendId(actionArgs, actionParams) : sendId;
    return [
        snapshot,
        {
            sendId: resolvedSendId
        },
        undefined
    ];
}
function $69ff85b27d828958$var$executeCancel(actorScope, params) {
    actorScope.defer(()=>{
        actorScope.system.scheduler.cancel(actorScope.self, params.sendId);
    });
}
/**
 * Cancels a delayed `sendTo(...)` action that is waiting to be executed. The
 * canceled `sendTo(...)` action will not send its event or execute, unless the
 * `delay` has already elapsed before `cancel(...)` is called.
 *
 * @example
 *
 * ```ts
 * import { createMachine, sendTo, cancel } from 'xstate';
 *
 * const machine = createMachine({
 *   // ...
 *   on: {
 *     sendEvent: {
 *       actions: sendTo(
 *         'some-actor',
 *         { type: 'someEvent' },
 *         {
 *           id: 'some-id',
 *           delay: 1000
 *         }
 *       )
 *     },
 *     cancelEvent: {
 *       actions: cancel('some-id')
 *     }
 *   }
 * });
 * ```
 *
 * @param sendId The `id` of the `sendTo(...)` action to cancel.
 */ function $69ff85b27d828958$export$3a1a48c8f6ef640e(sendId) {
    function cancel(_args, _params) {}
    cancel.type = 'xstate.cancel';
    cancel.sendId = sendId;
    cancel.resolve = $69ff85b27d828958$var$resolveCancel;
    cancel.execute = $69ff85b27d828958$var$executeCancel;
    return cancel;
}
function $69ff85b27d828958$var$resolveSpawn(actorScope, snapshot, actionArgs, _actionParams, { id: id, systemId: systemId, src: src, input: input, syncSnapshot: syncSnapshot }) {
    const logic = typeof src === 'string' ? $69ff85b27d828958$export$df995fae86a55f06(snapshot.machine, src) : src;
    const resolvedId = typeof id === 'function' ? id(actionArgs) : id;
    let actorRef;
    let resolvedInput = undefined;
    if (logic) {
        resolvedInput = typeof input === 'function' ? input({
            context: snapshot.context,
            event: actionArgs.event,
            self: actorScope.self
        }) : input;
        actorRef = $69ff85b27d828958$export$ebd11618f299a286(logic, {
            id: resolvedId,
            src: src,
            parent: actorScope.self,
            syncSnapshot: syncSnapshot,
            systemId: systemId,
            input: resolvedInput
        });
    }
    return [
        $69ff85b27d828958$export$3a6d5c9ae78a2c08(snapshot, {
            children: {
                ...snapshot.children,
                [resolvedId]: actorRef
            }
        }),
        {
            id: id,
            systemId: systemId,
            actorRef: actorRef,
            src: src,
            input: resolvedInput
        },
        undefined
    ];
}
function $69ff85b27d828958$var$executeSpawn(actorScope, { actorRef: actorRef }) {
    if (!actorRef) return;
    actorScope.defer(()=>{
        if (actorRef._processingStatus === $69ff85b27d828958$export$971d5caa766a69d7.Stopped) return;
        actorRef.start();
    });
}
function $69ff85b27d828958$export$56c0d5a1e737357d(...[src, { id: id, systemId: systemId, input: input, syncSnapshot: syncSnapshot = false } = {}]) {
    function spawnChild1(_args, _params) {}
    spawnChild1.type = 'xstate.spawnChild';
    spawnChild1.id = id;
    spawnChild1.systemId = systemId;
    spawnChild1.src = src;
    spawnChild1.input = input;
    spawnChild1.syncSnapshot = syncSnapshot;
    spawnChild1.resolve = $69ff85b27d828958$var$resolveSpawn;
    spawnChild1.execute = $69ff85b27d828958$var$executeSpawn;
    return spawnChild1;
}
function $69ff85b27d828958$var$resolveStop(_, snapshot, args, actionParams, { actorRef: actorRef }) {
    const actorRefOrString = typeof actorRef === 'function' ? actorRef(args, actionParams) : actorRef;
    const resolvedActorRef = typeof actorRefOrString === 'string' ? snapshot.children[actorRefOrString] : actorRefOrString;
    let children = snapshot.children;
    if (resolvedActorRef) {
        children = {
            ...children
        };
        delete children[resolvedActorRef.id];
    }
    return [
        $69ff85b27d828958$export$3a6d5c9ae78a2c08(snapshot, {
            children: children
        }),
        resolvedActorRef,
        undefined
    ];
}
function $69ff85b27d828958$var$executeStop(actorScope, actorRef) {
    if (!actorRef) return;
    // we need to eagerly unregister it here so a new actor with the same systemId can be registered immediately
    // since we defer actual stopping of the actor but we don't defer actor creations (and we can't do that)
    // this could throw on `systemId` collision, for example, when dealing with reentering transitions
    actorScope.system._unregister(actorRef);
    // this allows us to prevent an actor from being started if it gets stopped within the same macrostep
    // this can happen, for example, when the invoking state is being exited immediately by an always transition
    if (actorRef._processingStatus !== $69ff85b27d828958$export$971d5caa766a69d7.Running) {
        actorScope.stopChild(actorRef);
        return;
    }
    // stopping a child enqueues a stop event in the child actor's mailbox
    // we need for all of the already enqueued events to be processed before we stop the child
    // the parent itself might want to send some events to a child (for example from exit actions on the invoking state)
    // and we don't want to ignore those events
    actorScope.defer(()=>{
        actorScope.stopChild(actorRef);
    });
}
/**
 * Stops a child actor.
 *
 * @param actorRef The actor to stop.
 */ function $69ff85b27d828958$export$db202ddc8be9136(actorRef) {
    function stop(_args, _params) {}
    stop.type = 'xstate.stopChild';
    stop.actorRef = actorRef;
    stop.resolve = $69ff85b27d828958$var$resolveStop;
    stop.execute = $69ff85b27d828958$var$executeStop;
    return stop;
}
/**
 * Stops a child actor.
 *
 * @deprecated Use `stopChild(...)` instead
 * @alias
 */ const $69ff85b27d828958$export$3722cfe417b6ed86 = $69ff85b27d828958$export$db202ddc8be9136;
function $69ff85b27d828958$var$checkStateIn(snapshot, _, { stateValue: stateValue }) {
    if (typeof stateValue === 'string' && $69ff85b27d828958$export$efccba1c4a2ef57b(stateValue)) {
        const target = snapshot.machine.getStateNodeById(stateValue);
        return snapshot._nodes.some((sn)=>sn === target);
    }
    return snapshot.matches(stateValue);
}
function $69ff85b27d828958$export$2329c99376c9d0a4(stateValue) {
    function stateIn() {
        return false;
    }
    stateIn.check = $69ff85b27d828958$var$checkStateIn;
    stateIn.stateValue = stateValue;
    return stateIn;
}
function $69ff85b27d828958$var$checkNot(snapshot, { context: context, event: event }, { guards: guards }) {
    return !$69ff85b27d828958$export$f1e1789686576879(guards[0], context, event, snapshot);
}
/**
 * Higher-order guard that evaluates to `true` if the `guard` passed to it
 * evaluates to `false`.
 *
 * @category Guards
 * @example
 *
 * ```ts
 * import { setup, not } from 'xstate';
 *
 * const machine = setup({
 *   guards: {
 *     someNamedGuard: () => false
 *   }
 * }).createMachine({
 *   on: {
 *     someEvent: {
 *       guard: not('someNamedGuard'),
 *       actions: () => {
 *         // will be executed if guard in `not(...)`
 *         // evaluates to `false`
 *       }
 *     }
 *   }
 * });
 * ```
 *
 * @returns A guard
 */ function $69ff85b27d828958$export$a9c23c6ac3fc3eca(guard) {
    function not(_args, _params) {
        return false;
    }
    not.check = $69ff85b27d828958$var$checkNot;
    not.guards = [
        guard
    ];
    return not;
}
function $69ff85b27d828958$var$checkAnd(snapshot, { context: context, event: event }, { guards: guards }) {
    return guards.every((guard)=>$69ff85b27d828958$export$f1e1789686576879(guard, context, event, snapshot));
}
/**
 * Higher-order guard that evaluates to `true` if all `guards` passed to it
 * evaluate to `true`.
 *
 * @category Guards
 * @example
 *
 * ```ts
 * import { setup, and } from 'xstate';
 *
 * const machine = setup({
 *   guards: {
 *     someNamedGuard: () => true
 *   }
 * }).createMachine({
 *   on: {
 *     someEvent: {
 *       guard: and([({ context }) => context.value > 0, 'someNamedGuard']),
 *       actions: () => {
 *         // will be executed if all guards in `and(...)`
 *         // evaluate to true
 *       }
 *     }
 *   }
 * });
 * ```
 *
 * @returns A guard action object
 */ function $69ff85b27d828958$export$96f57966bedc81b4(guards) {
    function and(_args, _params) {
        return false;
    }
    and.check = $69ff85b27d828958$var$checkAnd;
    and.guards = guards;
    return and;
}
function $69ff85b27d828958$var$checkOr(snapshot, { context: context, event: event }, { guards: guards }) {
    return guards.some((guard)=>$69ff85b27d828958$export$f1e1789686576879(guard, context, event, snapshot));
}
/**
 * Higher-order guard that evaluates to `true` if any of the `guards` passed to
 * it evaluate to `true`.
 *
 * @category Guards
 * @example
 *
 * ```ts
 * import { setup, or } from 'xstate';
 *
 * const machine = setup({
 *   guards: {
 *     someNamedGuard: () => true
 *   }
 * }).createMachine({
 *   on: {
 *     someEvent: {
 *       guard: or([({ context }) => context.value > 0, 'someNamedGuard']),
 *       actions: () => {
 *         // will be executed if any of the guards in `or(...)`
 *         // evaluate to true
 *       }
 *     }
 *   }
 * });
 * ```
 *
 * @returns A guard action object
 */ function $69ff85b27d828958$export$d66501df72047452(guards) {
    function or(_args, _params) {
        return false;
    }
    or.check = $69ff85b27d828958$var$checkOr;
    or.guards = guards;
    return or;
}
// TODO: throw on cycles (depth check should be enough)
function $69ff85b27d828958$export$f1e1789686576879(guard, context, event, snapshot) {
    const { machine: machine } = snapshot;
    const isInline = typeof guard === 'function';
    const resolved = isInline ? guard : machine.implementations.guards[typeof guard === 'string' ? guard : guard.type];
    if (!isInline && !resolved) throw new Error(`Guard '${typeof guard === 'string' ? guard : guard.type}' is not implemented.'.`);
    if (typeof resolved !== 'function') return $69ff85b27d828958$export$f1e1789686576879(resolved, context, event, snapshot);
    const guardArgs = {
        context: context,
        event: event
    };
    const guardParams = isInline || typeof guard === 'string' ? undefined : 'params' in guard ? typeof guard.params === 'function' ? guard.params({
        context: context,
        event: event
    }) : guard.params : undefined;
    if (!('check' in resolved)) // the existing type of `.guards` assumes non-nullable `TExpressionGuard`
    // inline guards expect `TExpressionGuard` to be set to `undefined`
    // it's fine to cast this here, our logic makes sure that we call those 2 "variants" correctly
    return resolved(guardArgs, guardParams);
    const builtinGuard = resolved;
    return builtinGuard.check(snapshot, guardArgs, resolved // this holds all params
    );
}
const $69ff85b27d828958$var$isAtomicStateNode = (stateNode)=>stateNode.type === 'atomic' || stateNode.type === 'final';
function $69ff85b27d828958$var$getChildren(stateNode) {
    return Object.values(stateNode.states).filter((sn)=>sn.type !== 'history');
}
function $69ff85b27d828958$var$getProperAncestors(stateNode, toStateNode) {
    const ancestors = [];
    if (toStateNode === stateNode) return ancestors;
    // add all ancestors
    let m = stateNode.parent;
    while(m && m !== toStateNode){
        ancestors.push(m);
        m = m.parent;
    }
    return ancestors;
}
function $69ff85b27d828958$export$23f2a1d2818174ef(stateNodes) {
    const nodeSet = new Set(stateNodes);
    const adjList = $69ff85b27d828958$var$getAdjList(nodeSet);
    // add descendants
    for (const s of nodeSet)// if previously active, add existing child nodes
    if (s.type === 'compound' && (!adjList.get(s) || !adjList.get(s).length)) $69ff85b27d828958$var$getInitialStateNodesWithTheirAncestors(s).forEach((sn)=>nodeSet.add(sn));
    else {
        if (s.type === 'parallel') for (const child of $69ff85b27d828958$var$getChildren(s)){
            if (child.type === 'history') continue;
            if (!nodeSet.has(child)) {
                const initialStates = $69ff85b27d828958$var$getInitialStateNodesWithTheirAncestors(child);
                for (const initialStateNode of initialStates)nodeSet.add(initialStateNode);
            }
        }
    }
    // add all ancestors
    for (const s of nodeSet){
        let m = s.parent;
        while(m){
            nodeSet.add(m);
            m = m.parent;
        }
    }
    return nodeSet;
}
function $69ff85b27d828958$var$getValueFromAdj(baseNode, adjList) {
    const childStateNodes = adjList.get(baseNode);
    if (!childStateNodes) return {}; // todo: fix?
    if (baseNode.type === 'compound') {
        const childStateNode = childStateNodes[0];
        if (childStateNode) {
            if ($69ff85b27d828958$var$isAtomicStateNode(childStateNode)) return childStateNode.key;
        } else return {};
    }
    const stateValue = {};
    for (const childStateNode of childStateNodes)stateValue[childStateNode.key] = $69ff85b27d828958$var$getValueFromAdj(childStateNode, adjList);
    return stateValue;
}
function $69ff85b27d828958$var$getAdjList(stateNodes) {
    const adjList = new Map();
    for (const s of stateNodes){
        if (!adjList.has(s)) adjList.set(s, []);
        if (s.parent) {
            if (!adjList.has(s.parent)) adjList.set(s.parent, []);
            adjList.get(s.parent).push(s);
        }
    }
    return adjList;
}
function $69ff85b27d828958$var$getStateValue(rootNode, stateNodes) {
    const config = $69ff85b27d828958$export$23f2a1d2818174ef(stateNodes);
    return $69ff85b27d828958$var$getValueFromAdj(rootNode, $69ff85b27d828958$var$getAdjList(config));
}
function $69ff85b27d828958$export$882b5998b3b9117c(stateNodeSet, stateNode) {
    if (stateNode.type === 'compound') return $69ff85b27d828958$var$getChildren(stateNode).some((s)=>s.type === 'final' && stateNodeSet.has(s));
    if (stateNode.type === 'parallel') return $69ff85b27d828958$var$getChildren(stateNode).every((sn)=>$69ff85b27d828958$export$882b5998b3b9117c(stateNodeSet, sn));
    return stateNode.type === 'final';
}
const $69ff85b27d828958$export$efccba1c4a2ef57b = (str)=>str[0] === $69ff85b27d828958$var$STATE_IDENTIFIER;
function $69ff85b27d828958$export$dda1d9f60106f0e9(stateNode, receivedEventType) {
    const candidates = stateNode.transitions.get(receivedEventType) || [
        ...stateNode.transitions.keys()
    ].filter((eventDescriptor)=>{
        // check if transition is a wildcard transition,
        // which matches any non-transient events
        if (eventDescriptor === $69ff85b27d828958$var$WILDCARD) return true;
        if (!eventDescriptor.endsWith('.*')) return false;
        const partialEventTokens = eventDescriptor.split('.');
        const eventTokens = receivedEventType.split('.');
        for(let tokenIndex = 0; tokenIndex < partialEventTokens.length; tokenIndex++){
            const partialEventToken = partialEventTokens[tokenIndex];
            const eventToken = eventTokens[tokenIndex];
            if (partialEventToken === '*') {
                const isLastToken = tokenIndex === partialEventTokens.length - 1;
                return isLastToken;
            }
            if (partialEventToken !== eventToken) return false;
        }
        return true;
    }).sort((a, b)=>b.length - a.length).flatMap((key)=>stateNode.transitions.get(key));
    return candidates;
}
/** All delayed transitions from the config. */ function $69ff85b27d828958$export$39b482c5e57630a8(stateNode) {
    const afterConfig = stateNode.config.after;
    if (!afterConfig) return [];
    const mutateEntryExit = (delay)=>{
        const afterEvent = $69ff85b27d828958$var$createAfterEvent(delay, stateNode.id);
        const eventType = afterEvent.type;
        stateNode.entry.push($69ff85b27d828958$export$c4ce752e73470fba(afterEvent, {
            id: eventType,
            delay: delay
        }));
        stateNode.exit.push($69ff85b27d828958$export$3a1a48c8f6ef640e(eventType));
        return eventType;
    };
    const delayedTransitions = Object.keys(afterConfig).flatMap((delay)=>{
        const configTransition = afterConfig[delay];
        const resolvedTransition = typeof configTransition === 'string' ? {
            target: configTransition
        } : configTransition;
        const resolvedDelay = Number.isNaN(+delay) ? delay : +delay;
        const eventType = mutateEntryExit(resolvedDelay);
        return $69ff85b27d828958$export$625550452a3fa3ec(resolvedTransition).map((transition)=>({
                ...transition,
                event: eventType,
                delay: resolvedDelay
            }));
    });
    return delayedTransitions.map((delayedTransition)=>{
        const { delay: delay } = delayedTransition;
        return {
            ...$69ff85b27d828958$export$8b22cf2602fb60ce(stateNode, delayedTransition.event, delayedTransition),
            delay: delay
        };
    });
}
function $69ff85b27d828958$export$8b22cf2602fb60ce(stateNode, descriptor, transitionConfig) {
    const normalizedTarget = $69ff85b27d828958$var$normalizeTarget(transitionConfig.target);
    const reenter = transitionConfig.reenter ?? false;
    const target = $69ff85b27d828958$var$resolveTarget(stateNode, normalizedTarget);
    const transition = {
        ...transitionConfig,
        actions: $69ff85b27d828958$export$625550452a3fa3ec(transitionConfig.actions),
        guard: transitionConfig.guard,
        target: target,
        source: stateNode,
        reenter: reenter,
        eventType: descriptor,
        toJSON: ()=>({
                ...transition,
                source: `#${stateNode.id}`,
                target: target ? target.map((t)=>`#${t.id}`) : undefined
            })
    };
    return transition;
}
function $69ff85b27d828958$export$2d1720544b23b823(stateNode) {
    const transitions = new Map();
    if (stateNode.config.on) for (const descriptor of Object.keys(stateNode.config.on)){
        if (descriptor === $69ff85b27d828958$export$a07804094c3ecf2d) throw new Error('Null events ("") cannot be specified as a transition key. Use `always: { ... }` instead.');
        const transitionsConfig = stateNode.config.on[descriptor];
        transitions.set(descriptor, $69ff85b27d828958$export$407448d2b89b1813(transitionsConfig).map((t)=>$69ff85b27d828958$export$8b22cf2602fb60ce(stateNode, descriptor, t)));
    }
    if (stateNode.config.onDone) {
        const descriptor = `xstate.done.state.${stateNode.id}`;
        transitions.set(descriptor, $69ff85b27d828958$export$407448d2b89b1813(stateNode.config.onDone).map((t)=>$69ff85b27d828958$export$8b22cf2602fb60ce(stateNode, descriptor, t)));
    }
    for (const invokeDef of stateNode.invoke){
        if (invokeDef.onDone) {
            const descriptor = `xstate.done.actor.${invokeDef.id}`;
            transitions.set(descriptor, $69ff85b27d828958$export$407448d2b89b1813(invokeDef.onDone).map((t)=>$69ff85b27d828958$export$8b22cf2602fb60ce(stateNode, descriptor, t)));
        }
        if (invokeDef.onError) {
            const descriptor = `xstate.error.actor.${invokeDef.id}`;
            transitions.set(descriptor, $69ff85b27d828958$export$407448d2b89b1813(invokeDef.onError).map((t)=>$69ff85b27d828958$export$8b22cf2602fb60ce(stateNode, descriptor, t)));
        }
        if (invokeDef.onSnapshot) {
            const descriptor = `xstate.snapshot.${invokeDef.id}`;
            transitions.set(descriptor, $69ff85b27d828958$export$407448d2b89b1813(invokeDef.onSnapshot).map((t)=>$69ff85b27d828958$export$8b22cf2602fb60ce(stateNode, descriptor, t)));
        }
    }
    for (const delayedTransition of stateNode.after){
        let existing = transitions.get(delayedTransition.eventType);
        if (!existing) {
            existing = [];
            transitions.set(delayedTransition.eventType, existing);
        }
        existing.push(delayedTransition);
    }
    return transitions;
}
function $69ff85b27d828958$export$4368d992c4eafac0(stateNode, _target) {
    const resolvedTarget = typeof _target === 'string' ? stateNode.states[_target] : _target ? stateNode.states[_target.target] : undefined;
    if (!resolvedTarget && _target) throw new Error(// eslint-disable-next-line @typescript-eslint/restrict-template-expressions, @typescript-eslint/no-base-to-string
    `Initial state node "${_target}" not found on parent state node #${stateNode.id}`);
    const transition = {
        source: stateNode,
        actions: !_target || typeof _target === 'string' ? [] : $69ff85b27d828958$export$625550452a3fa3ec(_target.actions),
        eventType: null,
        reenter: false,
        target: resolvedTarget ? [
            resolvedTarget
        ] : [],
        toJSON: ()=>({
                ...transition,
                source: `#${stateNode.id}`,
                target: resolvedTarget ? [
                    `#${resolvedTarget.id}`
                ] : []
            })
    };
    return transition;
}
function $69ff85b27d828958$var$resolveTarget(stateNode, targets) {
    if (targets === undefined) // an undefined target signals that the state node should not transition from that state when receiving that event
    return undefined;
    return targets.map((target)=>{
        if (typeof target !== 'string') return target;
        if ($69ff85b27d828958$export$efccba1c4a2ef57b(target)) return stateNode.machine.getStateNodeById(target);
        const isInternalTarget = target[0] === $69ff85b27d828958$export$25ce5a424b770e84;
        // If internal target is defined on machine,
        // do not include machine key on target
        if (isInternalTarget && !stateNode.parent) return $69ff85b27d828958$export$d141bba7fdc215a3(stateNode, target.slice(1));
        const resolvedTarget = isInternalTarget ? stateNode.key + target : target;
        if (stateNode.parent) try {
            const targetStateNode = $69ff85b27d828958$export$d141bba7fdc215a3(stateNode.parent, resolvedTarget);
            return targetStateNode;
        } catch (err) {
            throw new Error(`Invalid transition definition for state node '${stateNode.id}':\n${err.message}`);
        }
        else throw new Error(`Invalid target: "${target}" is not a valid target from the root node. Did you mean ".${target}"?`);
    });
}
function $69ff85b27d828958$var$resolveHistoryDefaultTransition(stateNode) {
    const normalizedTarget = $69ff85b27d828958$var$normalizeTarget(stateNode.config.target);
    if (!normalizedTarget) return stateNode.parent.initial;
    return {
        target: normalizedTarget.map((t)=>typeof t === 'string' ? $69ff85b27d828958$export$d141bba7fdc215a3(stateNode.parent, t) : t)
    };
}
function $69ff85b27d828958$var$isHistoryNode(stateNode) {
    return stateNode.type === 'history';
}
function $69ff85b27d828958$var$getInitialStateNodesWithTheirAncestors(stateNode) {
    const states = $69ff85b27d828958$export$3b14a55fb2447963(stateNode);
    for (const initialState of states)for (const ancestor of $69ff85b27d828958$var$getProperAncestors(initialState, stateNode))states.add(ancestor);
    return states;
}
function $69ff85b27d828958$export$3b14a55fb2447963(stateNode) {
    const set = new Set();
    function iter(descStateNode) {
        if (set.has(descStateNode)) return;
        set.add(descStateNode);
        if (descStateNode.type === 'compound') iter(descStateNode.initial.target[0]);
        else if (descStateNode.type === 'parallel') for (const child of $69ff85b27d828958$var$getChildren(descStateNode))iter(child);
    }
    iter(stateNode);
    return set;
}
/** Returns the child state node from its relative `stateKey`, or throws. */ function $69ff85b27d828958$var$getStateNode(stateNode, stateKey) {
    if ($69ff85b27d828958$export$efccba1c4a2ef57b(stateKey)) return stateNode.machine.getStateNodeById(stateKey);
    if (!stateNode.states) throw new Error(`Unable to retrieve child state '${stateKey}' from '${stateNode.id}'; no child states exist.`);
    const result = stateNode.states[stateKey];
    if (!result) throw new Error(`Child state '${stateKey}' does not exist on '${stateNode.id}'`);
    return result;
}
/**
 * Returns the relative state node from the given `statePath`, or throws.
 *
 * @param statePath The string or string array relative path to the state node.
 */ function $69ff85b27d828958$export$d141bba7fdc215a3(stateNode, statePath) {
    if (typeof statePath === 'string' && $69ff85b27d828958$export$efccba1c4a2ef57b(statePath)) try {
        return stateNode.machine.getStateNodeById(statePath);
    } catch  {
    // try individual paths
    // throw e;
    }
    const arrayStatePath = $69ff85b27d828958$export$90a7f3efeed30595(statePath).slice();
    let currentStateNode = stateNode;
    while(arrayStatePath.length){
        const key = arrayStatePath.shift();
        if (!key.length) break;
        currentStateNode = $69ff85b27d828958$var$getStateNode(currentStateNode, key);
    }
    return currentStateNode;
}
/**
 * Returns the state nodes represented by the current state value.
 *
 * @param stateValue The state value or State instance
 */ function $69ff85b27d828958$export$35e795649ee09318(stateNode, stateValue) {
    if (typeof stateValue === 'string') {
        const childStateNode = stateNode.states[stateValue];
        if (!childStateNode) throw new Error(`State '${stateValue}' does not exist on '${stateNode.id}'`);
        return [
            stateNode,
            childStateNode
        ];
    }
    const childStateKeys = Object.keys(stateValue);
    const childStateNodes = childStateKeys.map((subStateKey)=>$69ff85b27d828958$var$getStateNode(stateNode, subStateKey)).filter(Boolean);
    return [
        stateNode.machine.root,
        stateNode
    ].concat(childStateNodes, childStateKeys.reduce((allSubStateNodes, subStateKey)=>{
        const subStateNode = $69ff85b27d828958$var$getStateNode(stateNode, subStateKey);
        if (!subStateNode) return allSubStateNodes;
        const subStateNodes = $69ff85b27d828958$export$35e795649ee09318(subStateNode, stateValue[subStateKey]);
        return allSubStateNodes.concat(subStateNodes);
    }, []));
}
function $69ff85b27d828958$var$transitionAtomicNode(stateNode, stateValue, snapshot, event) {
    const childStateNode = $69ff85b27d828958$var$getStateNode(stateNode, stateValue);
    const next = childStateNode.next(snapshot, event);
    if (!next || !next.length) return stateNode.next(snapshot, event);
    return next;
}
function $69ff85b27d828958$var$transitionCompoundNode(stateNode, stateValue, snapshot, event) {
    const subStateKeys = Object.keys(stateValue);
    const childStateNode = $69ff85b27d828958$var$getStateNode(stateNode, subStateKeys[0]);
    const next = $69ff85b27d828958$export$ae1af26003f05816(childStateNode, stateValue[subStateKeys[0]], snapshot, event);
    if (!next || !next.length) return stateNode.next(snapshot, event);
    return next;
}
function $69ff85b27d828958$var$transitionParallelNode(stateNode, stateValue, snapshot, event) {
    const allInnerTransitions = [];
    for (const subStateKey of Object.keys(stateValue)){
        const subStateValue = stateValue[subStateKey];
        if (!subStateValue) continue;
        const subStateNode = $69ff85b27d828958$var$getStateNode(stateNode, subStateKey);
        const innerTransitions = $69ff85b27d828958$export$ae1af26003f05816(subStateNode, subStateValue, snapshot, event);
        if (innerTransitions) allInnerTransitions.push(...innerTransitions);
    }
    if (!allInnerTransitions.length) return stateNode.next(snapshot, event);
    return allInnerTransitions;
}
function $69ff85b27d828958$export$ae1af26003f05816(stateNode, stateValue, snapshot, event) {
    // leaf node
    if (typeof stateValue === 'string') return $69ff85b27d828958$var$transitionAtomicNode(stateNode, stateValue, snapshot, event);
    // compound node
    if (Object.keys(stateValue).length === 1) return $69ff85b27d828958$var$transitionCompoundNode(stateNode, stateValue, snapshot, event);
    // parallel node
    return $69ff85b27d828958$var$transitionParallelNode(stateNode, stateValue, snapshot, event);
}
function $69ff85b27d828958$var$getHistoryNodes(stateNode) {
    return Object.keys(stateNode.states).map((key)=>stateNode.states[key]).filter((sn)=>sn.type === 'history');
}
function $69ff85b27d828958$var$isDescendant(childStateNode, parentStateNode) {
    let marker = childStateNode;
    while(marker.parent && marker.parent !== parentStateNode)marker = marker.parent;
    return marker.parent === parentStateNode;
}
function $69ff85b27d828958$var$hasIntersection(s1, s2) {
    const set1 = new Set(s1);
    const set2 = new Set(s2);
    for (const item of set1){
        if (set2.has(item)) return true;
    }
    for (const item of set2){
        if (set1.has(item)) return true;
    }
    return false;
}
function $69ff85b27d828958$var$removeConflictingTransitions(enabledTransitions, stateNodeSet, historyValue) {
    const filteredTransitions = new Set();
    for (const t1 of enabledTransitions){
        let t1Preempted = false;
        const transitionsToRemove = new Set();
        for (const t2 of filteredTransitions)if ($69ff85b27d828958$var$hasIntersection($69ff85b27d828958$var$computeExitSet([
            t1
        ], stateNodeSet, historyValue), $69ff85b27d828958$var$computeExitSet([
            t2
        ], stateNodeSet, historyValue))) {
            if ($69ff85b27d828958$var$isDescendant(t1.source, t2.source)) transitionsToRemove.add(t2);
            else {
                t1Preempted = true;
                break;
            }
        }
        if (!t1Preempted) {
            for (const t3 of transitionsToRemove)filteredTransitions.delete(t3);
            filteredTransitions.add(t1);
        }
    }
    return Array.from(filteredTransitions);
}
function $69ff85b27d828958$var$findLeastCommonAncestor(stateNodes) {
    const [head, ...tail] = stateNodes;
    for (const ancestor of $69ff85b27d828958$var$getProperAncestors(head, undefined)){
        if (tail.every((sn)=>$69ff85b27d828958$var$isDescendant(sn, ancestor))) return ancestor;
    }
}
function $69ff85b27d828958$var$getEffectiveTargetStates(transition, historyValue) {
    if (!transition.target) return [];
    const targets = new Set();
    for (const targetNode of transition.target)if ($69ff85b27d828958$var$isHistoryNode(targetNode)) {
        if (historyValue[targetNode.id]) for (const node of historyValue[targetNode.id])targets.add(node);
        else for (const node of $69ff85b27d828958$var$getEffectiveTargetStates($69ff85b27d828958$var$resolveHistoryDefaultTransition(targetNode), historyValue))targets.add(node);
    } else targets.add(targetNode);
    return [
        ...targets
    ];
}
function $69ff85b27d828958$var$getTransitionDomain(transition, historyValue) {
    const targetStates = $69ff85b27d828958$var$getEffectiveTargetStates(transition, historyValue);
    if (!targetStates) return;
    if (!transition.reenter && targetStates.every((target)=>target === transition.source || $69ff85b27d828958$var$isDescendant(target, transition.source))) return transition.source;
    const lca = $69ff85b27d828958$var$findLeastCommonAncestor(targetStates.concat(transition.source));
    if (lca) return lca;
    // at this point we know that it's a root transition since LCA couldn't be found
    if (transition.reenter) return;
    return transition.source.machine.root;
}
function $69ff85b27d828958$var$computeExitSet(transitions, stateNodeSet, historyValue) {
    const statesToExit = new Set();
    for (const t of transitions)if (t.target?.length) {
        const domain = $69ff85b27d828958$var$getTransitionDomain(t, historyValue);
        if (t.reenter && t.source === domain) statesToExit.add(domain);
        for (const stateNode of stateNodeSet)if ($69ff85b27d828958$var$isDescendant(stateNode, domain)) statesToExit.add(stateNode);
    }
    return [
        ...statesToExit
    ];
}
function $69ff85b27d828958$var$areStateNodeCollectionsEqual(prevStateNodes, nextStateNodeSet) {
    if (prevStateNodes.length !== nextStateNodeSet.size) return false;
    for (const node of prevStateNodes){
        if (!nextStateNodeSet.has(node)) return false;
    }
    return true;
}
/** https://www.w3.org/TR/scxml/#microstepProcedure */ function $69ff85b27d828958$export$2408f22a0fab9ae5(transitions, currentSnapshot, actorScope, event, isInitial, internalQueue) {
    if (!transitions.length) return currentSnapshot;
    const mutStateNodeSet = new Set(currentSnapshot._nodes);
    let historyValue = currentSnapshot.historyValue;
    const filteredTransitions = $69ff85b27d828958$var$removeConflictingTransitions(transitions, mutStateNodeSet, historyValue);
    let nextState = currentSnapshot;
    // Exit states
    if (!isInitial) [nextState, historyValue] = $69ff85b27d828958$var$exitStates(nextState, event, actorScope, filteredTransitions, mutStateNodeSet, historyValue, internalQueue, actorScope.actionExecutor);
    // Execute transition content
    nextState = $69ff85b27d828958$export$ffb5f4729a158638(nextState, event, actorScope, filteredTransitions.flatMap((t)=>t.actions), internalQueue, undefined);
    // Enter states
    nextState = $69ff85b27d828958$var$enterStates(nextState, event, actorScope, filteredTransitions, mutStateNodeSet, internalQueue, historyValue, isInitial);
    const nextStateNodes = [
        ...mutStateNodeSet
    ];
    if (nextState.status === 'done') nextState = $69ff85b27d828958$export$ffb5f4729a158638(nextState, event, actorScope, nextStateNodes.sort((a, b)=>b.order - a.order).flatMap((state)=>state.exit), internalQueue, undefined);
    // eslint-disable-next-line no-useless-catch
    try {
        if (historyValue === currentSnapshot.historyValue && $69ff85b27d828958$var$areStateNodeCollectionsEqual(currentSnapshot._nodes, mutStateNodeSet)) return nextState;
        return $69ff85b27d828958$export$3a6d5c9ae78a2c08(nextState, {
            _nodes: nextStateNodes,
            historyValue: historyValue
        });
    } catch (e) {
        // TODO: Refactor this once proper error handling is implemented.
        // See https://github.com/statelyai/rfcs/pull/4
        throw e;
    }
}
function $69ff85b27d828958$var$getMachineOutput(snapshot, event, actorScope, rootNode, rootCompletionNode) {
    if (rootNode.output === undefined) return;
    const doneStateEvent = $69ff85b27d828958$var$createDoneStateEvent(rootCompletionNode.id, rootCompletionNode.output !== undefined && rootCompletionNode.parent ? $69ff85b27d828958$var$resolveOutput(rootCompletionNode.output, snapshot.context, event, actorScope.self) : undefined);
    return $69ff85b27d828958$var$resolveOutput(rootNode.output, snapshot.context, doneStateEvent, actorScope.self);
}
function $69ff85b27d828958$var$enterStates(currentSnapshot, event, actorScope, filteredTransitions, mutStateNodeSet, internalQueue, historyValue, isInitial) {
    let nextSnapshot = currentSnapshot;
    const statesToEnter = new Set();
    // those are states that were directly targeted or indirectly targeted by the explicit target
    // in other words, those are states for which initial actions should be executed
    // when we target `#deep_child` initial actions of its ancestors shouldn't be executed
    const statesForDefaultEntry = new Set();
    $69ff85b27d828958$var$computeEntrySet(filteredTransitions, historyValue, statesForDefaultEntry, statesToEnter);
    // In the initial state, the root state node is "entered".
    if (isInitial) statesForDefaultEntry.add(currentSnapshot.machine.root);
    const completedNodes = new Set();
    for (const stateNodeToEnter of [
        ...statesToEnter
    ].sort((a, b)=>a.order - b.order)){
        mutStateNodeSet.add(stateNodeToEnter);
        const actions = [];
        // Add entry actions
        actions.push(...stateNodeToEnter.entry);
        for (const invokeDef of stateNodeToEnter.invoke)actions.push($69ff85b27d828958$export$56c0d5a1e737357d(invokeDef.src, {
            ...invokeDef,
            syncSnapshot: !!invokeDef.onSnapshot
        }));
        if (statesForDefaultEntry.has(stateNodeToEnter)) {
            const initialActions = stateNodeToEnter.initial.actions;
            actions.push(...initialActions);
        }
        nextSnapshot = $69ff85b27d828958$export$ffb5f4729a158638(nextSnapshot, event, actorScope, actions, internalQueue, stateNodeToEnter.invoke.map((invokeDef)=>invokeDef.id));
        if (stateNodeToEnter.type === 'final') {
            const parent = stateNodeToEnter.parent;
            let ancestorMarker = parent?.type === 'parallel' ? parent : parent?.parent;
            let rootCompletionNode = ancestorMarker || stateNodeToEnter;
            if (parent?.type === 'compound') internalQueue.push($69ff85b27d828958$var$createDoneStateEvent(parent.id, stateNodeToEnter.output !== undefined ? $69ff85b27d828958$var$resolveOutput(stateNodeToEnter.output, nextSnapshot.context, event, actorScope.self) : undefined));
            while(ancestorMarker?.type === 'parallel' && !completedNodes.has(ancestorMarker) && $69ff85b27d828958$export$882b5998b3b9117c(mutStateNodeSet, ancestorMarker)){
                completedNodes.add(ancestorMarker);
                internalQueue.push($69ff85b27d828958$var$createDoneStateEvent(ancestorMarker.id));
                rootCompletionNode = ancestorMarker;
                ancestorMarker = ancestorMarker.parent;
            }
            if (ancestorMarker) continue;
            nextSnapshot = $69ff85b27d828958$export$3a6d5c9ae78a2c08(nextSnapshot, {
                status: 'done',
                output: $69ff85b27d828958$var$getMachineOutput(nextSnapshot, event, actorScope, nextSnapshot.machine.root, rootCompletionNode)
            });
        }
    }
    return nextSnapshot;
}
function $69ff85b27d828958$var$computeEntrySet(transitions, historyValue, statesForDefaultEntry, statesToEnter) {
    for (const t of transitions){
        const domain = $69ff85b27d828958$var$getTransitionDomain(t, historyValue);
        for (const s of t.target || []){
            if (!$69ff85b27d828958$var$isHistoryNode(s) && // if the target is different than the source then it will *definitely* be entered
            (t.source !== s || // we know that the domain can't lie within the source
            // if it's different than the source then it's outside of it and it means that the target has to be entered as well
            t.source !== domain || // reentering transitions always enter the target, even if it's the source itself
            t.reenter)) {
                statesToEnter.add(s);
                statesForDefaultEntry.add(s);
            }
            $69ff85b27d828958$var$addDescendantStatesToEnter(s, historyValue, statesForDefaultEntry, statesToEnter);
        }
        const targetStates = $69ff85b27d828958$var$getEffectiveTargetStates(t, historyValue);
        for (const s of targetStates){
            const ancestors = $69ff85b27d828958$var$getProperAncestors(s, domain);
            if (domain?.type === 'parallel') ancestors.push(domain);
            $69ff85b27d828958$var$addAncestorStatesToEnter(statesToEnter, historyValue, statesForDefaultEntry, ancestors, !t.source.parent && t.reenter ? undefined : domain);
        }
    }
}
function $69ff85b27d828958$var$addDescendantStatesToEnter(stateNode, historyValue, statesForDefaultEntry, statesToEnter) {
    if ($69ff85b27d828958$var$isHistoryNode(stateNode)) {
        if (historyValue[stateNode.id]) {
            const historyStateNodes = historyValue[stateNode.id];
            for (const s of historyStateNodes){
                statesToEnter.add(s);
                $69ff85b27d828958$var$addDescendantStatesToEnter(s, historyValue, statesForDefaultEntry, statesToEnter);
            }
            for (const s of historyStateNodes)$69ff85b27d828958$var$addProperAncestorStatesToEnter(s, stateNode.parent, statesToEnter, historyValue, statesForDefaultEntry);
        } else {
            const historyDefaultTransition = $69ff85b27d828958$var$resolveHistoryDefaultTransition(stateNode);
            for (const s of historyDefaultTransition.target){
                statesToEnter.add(s);
                if (historyDefaultTransition === stateNode.parent?.initial) statesForDefaultEntry.add(stateNode.parent);
                $69ff85b27d828958$var$addDescendantStatesToEnter(s, historyValue, statesForDefaultEntry, statesToEnter);
            }
            for (const s of historyDefaultTransition.target)$69ff85b27d828958$var$addProperAncestorStatesToEnter(s, stateNode.parent, statesToEnter, historyValue, statesForDefaultEntry);
        }
    } else {
        if (stateNode.type === 'compound') {
            const [initialState] = stateNode.initial.target;
            if (!$69ff85b27d828958$var$isHistoryNode(initialState)) {
                statesToEnter.add(initialState);
                statesForDefaultEntry.add(initialState);
            }
            $69ff85b27d828958$var$addDescendantStatesToEnter(initialState, historyValue, statesForDefaultEntry, statesToEnter);
            $69ff85b27d828958$var$addProperAncestorStatesToEnter(initialState, stateNode, statesToEnter, historyValue, statesForDefaultEntry);
        } else if (stateNode.type === 'parallel') {
            for (const child of $69ff85b27d828958$var$getChildren(stateNode).filter((sn)=>!$69ff85b27d828958$var$isHistoryNode(sn)))if (![
                ...statesToEnter
            ].some((s)=>$69ff85b27d828958$var$isDescendant(s, child))) {
                if (!$69ff85b27d828958$var$isHistoryNode(child)) {
                    statesToEnter.add(child);
                    statesForDefaultEntry.add(child);
                }
                $69ff85b27d828958$var$addDescendantStatesToEnter(child, historyValue, statesForDefaultEntry, statesToEnter);
            }
        }
    }
}
function $69ff85b27d828958$var$addAncestorStatesToEnter(statesToEnter, historyValue, statesForDefaultEntry, ancestors, reentrancyDomain) {
    for (const anc of ancestors){
        if (!reentrancyDomain || $69ff85b27d828958$var$isDescendant(anc, reentrancyDomain)) statesToEnter.add(anc);
        if (anc.type === 'parallel') {
            for (const child of $69ff85b27d828958$var$getChildren(anc).filter((sn)=>!$69ff85b27d828958$var$isHistoryNode(sn)))if (![
                ...statesToEnter
            ].some((s)=>$69ff85b27d828958$var$isDescendant(s, child))) {
                statesToEnter.add(child);
                $69ff85b27d828958$var$addDescendantStatesToEnter(child, historyValue, statesForDefaultEntry, statesToEnter);
            }
        }
    }
}
function $69ff85b27d828958$var$addProperAncestorStatesToEnter(stateNode, toStateNode, statesToEnter, historyValue, statesForDefaultEntry) {
    $69ff85b27d828958$var$addAncestorStatesToEnter(statesToEnter, historyValue, statesForDefaultEntry, $69ff85b27d828958$var$getProperAncestors(stateNode, toStateNode));
}
function $69ff85b27d828958$var$exitStates(currentSnapshot, event, actorScope, transitions, mutStateNodeSet, historyValue, internalQueue, _actionExecutor) {
    let nextSnapshot = currentSnapshot;
    const statesToExit = $69ff85b27d828958$var$computeExitSet(transitions, mutStateNodeSet, historyValue);
    statesToExit.sort((a, b)=>b.order - a.order);
    let changedHistory;
    // From SCXML algorithm: https://www.w3.org/TR/scxml/#exitStates
    for (const exitStateNode of statesToExit)for (const historyNode of $69ff85b27d828958$var$getHistoryNodes(exitStateNode)){
        let predicate;
        if (historyNode.history === 'deep') predicate = (sn)=>$69ff85b27d828958$var$isAtomicStateNode(sn) && $69ff85b27d828958$var$isDescendant(sn, exitStateNode);
        else predicate = (sn)=>{
            return sn.parent === exitStateNode;
        };
        changedHistory ?? (changedHistory = {
            ...historyValue
        });
        changedHistory[historyNode.id] = Array.from(mutStateNodeSet).filter(predicate);
    }
    for (const s of statesToExit){
        nextSnapshot = $69ff85b27d828958$export$ffb5f4729a158638(nextSnapshot, event, actorScope, [
            ...s.exit,
            ...s.invoke.map((def)=>$69ff85b27d828958$export$db202ddc8be9136(def.id))
        ], internalQueue, undefined);
        mutStateNodeSet.delete(s);
    }
    return [
        nextSnapshot,
        changedHistory || historyValue
    ];
}
function $69ff85b27d828958$var$getAction(machine, actionType) {
    return machine.implementations.actions[actionType];
}
function $69ff85b27d828958$var$resolveAndExecuteActionsWithContext(currentSnapshot, event, actorScope, actions, extra, retries) {
    const { machine: machine } = currentSnapshot;
    let intermediateSnapshot = currentSnapshot;
    for (const action of actions){
        const isInline = typeof action === 'function';
        const resolvedAction = isInline ? action : // the existing type of `.actions` assumes non-nullable `TExpressionAction`
        // it's fine to cast this here to get a common type and lack of errors in the rest of the code
        // our logic below makes sure that we call those 2 "variants" correctly
        $69ff85b27d828958$var$getAction(machine, typeof action === 'string' ? action : action.type);
        const actionArgs = {
            context: intermediateSnapshot.context,
            event: event,
            self: actorScope.self,
            system: actorScope.system
        };
        const actionParams = isInline || typeof action === 'string' ? undefined : 'params' in action ? typeof action.params === 'function' ? action.params({
            context: intermediateSnapshot.context,
            event: event
        }) : action.params : undefined;
        if (!resolvedAction || !('resolve' in resolvedAction)) {
            actorScope.actionExecutor({
                type: typeof action === 'string' ? action : typeof action === 'object' ? action.type : action.name || '(anonymous)',
                info: actionArgs,
                params: actionParams,
                exec: resolvedAction
            });
            continue;
        }
        const builtinAction = resolvedAction;
        const [nextState, params, actions] = builtinAction.resolve(actorScope, intermediateSnapshot, actionArgs, actionParams, resolvedAction, // this holds all params
        extra);
        intermediateSnapshot = nextState;
        if ('retryResolve' in builtinAction) retries?.push([
            builtinAction,
            params
        ]);
        if ('execute' in builtinAction) actorScope.actionExecutor({
            type: builtinAction.type,
            info: actionArgs,
            params: params,
            exec: builtinAction.execute.bind(null, actorScope, params)
        });
        if (actions) intermediateSnapshot = $69ff85b27d828958$var$resolveAndExecuteActionsWithContext(intermediateSnapshot, event, actorScope, actions, extra, retries);
    }
    return intermediateSnapshot;
}
function $69ff85b27d828958$export$ffb5f4729a158638(currentSnapshot, event, actorScope, actions, internalQueue, deferredActorIds) {
    const retries = deferredActorIds ? [] : undefined;
    const nextState = $69ff85b27d828958$var$resolveAndExecuteActionsWithContext(currentSnapshot, event, actorScope, actions, {
        internalQueue: internalQueue,
        deferredActorIds: deferredActorIds
    }, retries);
    retries?.forEach(([builtinAction, params])=>{
        builtinAction.retryResolve(actorScope, nextState, params);
    });
    return nextState;
}
function $69ff85b27d828958$export$7ccc53e8f1e7dfc5(snapshot, event, actorScope, internalQueue) {
    let nextSnapshot = snapshot;
    const microstates = [];
    function addMicrostate(microstate, event, transitions) {
        actorScope.system._sendInspectionEvent({
            type: '@xstate.microstep',
            actorRef: actorScope.self,
            event: event,
            snapshot: microstate,
            _transitions: transitions
        });
        microstates.push(microstate);
    }
    // Handle stop event
    if (event.type === $69ff85b27d828958$export$78acf4525d8a74c4) {
        nextSnapshot = $69ff85b27d828958$export$3a6d5c9ae78a2c08($69ff85b27d828958$var$stopChildren(nextSnapshot, event, actorScope), {
            status: 'stopped'
        });
        addMicrostate(nextSnapshot, event, []);
        return {
            snapshot: nextSnapshot,
            microstates: microstates
        };
    }
    let nextEvent = event;
    // Assume the state is at rest (no raised events)
    // Determine the next state based on the next microstep
    if (nextEvent.type !== $69ff85b27d828958$var$XSTATE_INIT) {
        const currentEvent = nextEvent;
        const isErr = $69ff85b27d828958$var$isErrorActorEvent(currentEvent);
        const transitions = $69ff85b27d828958$var$selectTransitions(currentEvent, nextSnapshot);
        if (isErr && !transitions.length) {
            // TODO: we should likely only allow transitions selected by very explicit descriptors
            // `*` shouldn't be matched, likely `xstate.error.*` shouldnt be either
            // similarly `xstate.error.actor.*` and `xstate.error.actor.todo.*` have to be considered too
            nextSnapshot = $69ff85b27d828958$export$3a6d5c9ae78a2c08(snapshot, {
                status: 'error',
                error: currentEvent.error
            });
            addMicrostate(nextSnapshot, currentEvent, []);
            return {
                snapshot: nextSnapshot,
                microstates: microstates
            };
        }
        nextSnapshot = $69ff85b27d828958$export$2408f22a0fab9ae5(transitions, snapshot, actorScope, nextEvent, false, // isInitial
        internalQueue);
        addMicrostate(nextSnapshot, currentEvent, transitions);
    }
    let shouldSelectEventlessTransitions = true;
    while(nextSnapshot.status === 'active'){
        let enabledTransitions = shouldSelectEventlessTransitions ? $69ff85b27d828958$var$selectEventlessTransitions(nextSnapshot, nextEvent) : [];
        // eventless transitions should always be selected after selecting *regular* transitions
        // by assigning `undefined` to `previousState` we ensure that `shouldSelectEventlessTransitions` gets always computed to true in such a case
        const previousState = enabledTransitions.length ? nextSnapshot : undefined;
        if (!enabledTransitions.length) {
            if (!internalQueue.length) break;
            nextEvent = internalQueue.shift();
            enabledTransitions = $69ff85b27d828958$var$selectTransitions(nextEvent, nextSnapshot);
        }
        nextSnapshot = $69ff85b27d828958$export$2408f22a0fab9ae5(enabledTransitions, nextSnapshot, actorScope, nextEvent, false, internalQueue);
        shouldSelectEventlessTransitions = nextSnapshot !== previousState;
        addMicrostate(nextSnapshot, nextEvent, enabledTransitions);
    }
    if (nextSnapshot.status !== 'active') $69ff85b27d828958$var$stopChildren(nextSnapshot, nextEvent, actorScope);
    return {
        snapshot: nextSnapshot,
        microstates: microstates
    };
}
function $69ff85b27d828958$var$stopChildren(nextState, event, actorScope) {
    return $69ff85b27d828958$export$ffb5f4729a158638(nextState, event, actorScope, Object.values(nextState.children).map((child)=>$69ff85b27d828958$export$db202ddc8be9136(child)), [], undefined);
}
function $69ff85b27d828958$var$selectTransitions(event, nextState) {
    return nextState.machine.getTransitionData(nextState, event);
}
function $69ff85b27d828958$var$selectEventlessTransitions(nextState, event) {
    const enabledTransitionSet = new Set();
    const atomicStates = nextState._nodes.filter($69ff85b27d828958$var$isAtomicStateNode);
    for (const stateNode of atomicStates)loop: for (const s of [
        stateNode
    ].concat($69ff85b27d828958$var$getProperAncestors(stateNode, undefined))){
        if (!s.always) continue;
        for (const transition of s.always)if (transition.guard === undefined || $69ff85b27d828958$export$f1e1789686576879(transition.guard, nextState.context, event, nextState)) {
            enabledTransitionSet.add(transition);
            break loop;
        }
    }
    return $69ff85b27d828958$var$removeConflictingTransitions(Array.from(enabledTransitionSet), new Set(nextState._nodes), nextState.historyValue);
}
/**
 * Resolves a partial state value with its full representation in the state
 * node's machine.
 *
 * @param stateValue The partial state value to resolve.
 */ function $69ff85b27d828958$export$43caf9889c228507(rootNode, stateValue) {
    const allStateNodes = $69ff85b27d828958$export$23f2a1d2818174ef($69ff85b27d828958$export$35e795649ee09318(rootNode, stateValue));
    return $69ff85b27d828958$var$getStateValue(rootNode, [
        ...allStateNodes
    ]);
}
function $69ff85b27d828958$export$7f8ddf7c7c20b3cd(value) {
    return !!value && typeof value === 'object' && 'machine' in value && 'value' in value;
}
const $69ff85b27d828958$var$machineSnapshotMatches = function matches(testValue) {
    return $69ff85b27d828958$export$b4171a6734a65d42(testValue, this.value);
};
const $69ff85b27d828958$var$machineSnapshotHasTag = function hasTag(tag) {
    return this.tags.has(tag);
};
const $69ff85b27d828958$var$machineSnapshotCan = function can(event) {
    const transitionData = this.machine.getTransitionData(this, event);
    return !!transitionData?.length && // Check that at least one transition is not forbidden
    transitionData.some((t)=>t.target !== undefined || t.actions.length);
};
const $69ff85b27d828958$var$machineSnapshotToJSON = function toJSON() {
    const { _nodes: nodes, tags: tags, machine: machine, getMeta: getMeta, toJSON: toJSON, can: can, hasTag: hasTag, matches: matches, ...jsonValues } = this;
    return {
        ...jsonValues,
        tags: Array.from(tags)
    };
};
const $69ff85b27d828958$var$machineSnapshotGetMeta = function getMeta() {
    return this._nodes.reduce((acc, stateNode)=>{
        if (stateNode.meta !== undefined) acc[stateNode.id] = stateNode.meta;
        return acc;
    }, {});
};
function $69ff85b27d828958$export$342063e11d6c3cad(config, machine) {
    return {
        status: config.status,
        output: config.output,
        error: config.error,
        machine: machine,
        context: config.context,
        _nodes: config._nodes,
        value: $69ff85b27d828958$var$getStateValue(machine.root, config._nodes),
        tags: new Set(config._nodes.flatMap((sn)=>sn.tags)),
        children: config.children,
        historyValue: config.historyValue || {},
        matches: $69ff85b27d828958$var$machineSnapshotMatches,
        hasTag: $69ff85b27d828958$var$machineSnapshotHasTag,
        can: $69ff85b27d828958$var$machineSnapshotCan,
        getMeta: $69ff85b27d828958$var$machineSnapshotGetMeta,
        toJSON: $69ff85b27d828958$var$machineSnapshotToJSON
    };
}
function $69ff85b27d828958$export$3a6d5c9ae78a2c08(snapshot, config = {}) {
    return $69ff85b27d828958$export$342063e11d6c3cad({
        ...snapshot,
        ...config
    }, snapshot.machine);
}
function $69ff85b27d828958$export$4a5767248b18ef41(snapshot, options) {
    const { _nodes: nodes, tags: tags, machine: machine, children: children, context: context, can: can, hasTag: hasTag, matches: matches, getMeta: getMeta, toJSON: toJSON, ...jsonValues } = snapshot;
    const childrenJson = {};
    for(const id in children){
        const child = children[id];
        childrenJson[id] = {
            snapshot: child.getPersistedSnapshot(options),
            src: child.src,
            systemId: child._systemId,
            syncSnapshot: child._syncSnapshot
        };
    }
    const persisted = {
        ...jsonValues,
        context: $69ff85b27d828958$var$persistContext(context),
        children: childrenJson
    };
    return persisted;
}
function $69ff85b27d828958$var$persistContext(contextPart) {
    let copy;
    for(const key in contextPart){
        const value = contextPart[key];
        if (value && typeof value === 'object') {
            if ('sessionId' in value && 'send' in value && 'ref' in value) {
                copy ?? (copy = Array.isArray(contextPart) ? contextPart.slice() : {
                    ...contextPart
                });
                copy[key] = {
                    xstate$$type: $69ff85b27d828958$export$3d8c2f653ac9d0b9,
                    id: value.id
                };
            } else {
                const result = $69ff85b27d828958$var$persistContext(value);
                if (result !== value) {
                    copy ?? (copy = Array.isArray(contextPart) ? contextPart.slice() : {
                        ...contextPart
                    });
                    copy[key] = result;
                }
            }
        }
    }
    return copy ?? contextPart;
}
function $69ff85b27d828958$var$resolveRaise(_, snapshot, args, actionParams, { event: eventOrExpr, id: id, delay: delay }, { internalQueue: internalQueue }) {
    const delaysMap = snapshot.machine.implementations.delays;
    if (typeof eventOrExpr === 'string') throw new Error(// eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    `Only event objects may be used with raise; use raise({ type: "${eventOrExpr}" }) instead`);
    const resolvedEvent = typeof eventOrExpr === 'function' ? eventOrExpr(args, actionParams) : eventOrExpr;
    let resolvedDelay;
    if (typeof delay === 'string') {
        const configDelay = delaysMap && delaysMap[delay];
        resolvedDelay = typeof configDelay === 'function' ? configDelay(args, actionParams) : configDelay;
    } else resolvedDelay = typeof delay === 'function' ? delay(args, actionParams) : delay;
    if (typeof resolvedDelay !== 'number') internalQueue.push(resolvedEvent);
    return [
        snapshot,
        {
            event: resolvedEvent,
            id: id,
            delay: resolvedDelay
        },
        undefined
    ];
}
function $69ff85b27d828958$var$executeRaise(actorScope, params) {
    const { event: event, delay: delay, id: id } = params;
    if (typeof delay === 'number') {
        actorScope.defer(()=>{
            const self = actorScope.self;
            actorScope.system.scheduler.schedule(self, self, event, delay, id);
        });
        return;
    }
}
/**
 * Raises an event. This places the event in the internal event queue, so that
 * the event is immediately consumed by the machine in the current step.
 *
 * @param eventType The event to raise.
 */ function $69ff85b27d828958$export$c4ce752e73470fba(eventOrExpr, options) {
    function raise(_args, _params) {}
    raise.type = 'xstate.raise';
    raise.event = eventOrExpr;
    raise.id = options?.id;
    raise.delay = options?.delay;
    raise.resolve = $69ff85b27d828958$var$resolveRaise;
    raise.execute = $69ff85b27d828958$var$executeRaise;
    return raise;
}
module.exports["S"] = $69ff85b27d828958$export$25ce5a424b770e84;
module.exports["N"] = $69ff85b27d828958$export$a07804094c3ecf2d;
module.exports["V"] = $69ff85b27d828958$export$e7c866399fa523f5;
module.exports["X"] = $69ff85b27d828958$export$78acf4525d8a74c4;
module.exports["W"] = $69ff85b27d828958$export$71cec2538cb2c617;
module.exports["q"] = $69ff85b27d828958$export$9e5f44173e64f162;
module.exports["v"] = $69ff85b27d828958$export$90a7f3efeed30595;
module.exports["m"] = $69ff85b27d828958$export$953cecd6e717a553;
module.exports["t"] = $69ff85b27d828958$export$625550452a3fa3ec;
module.exports["a"] = $69ff85b27d828958$export$407448d2b89b1813;
module.exports["L"] = $69ff85b27d828958$export$61196ced6d74a310;
module.exports["c"] = $69ff85b27d828958$export$db3b6bfb95261072;
module.exports["z"] = $69ff85b27d828958$export$df995fae86a55f06;
module.exports["$"] = $69ff85b27d828958$export$3d8c2f653ac9d0b9;
module.exports["T"] = $69ff85b27d828958$export$971d5caa766a69d7;
module.exports["A"] = $69ff85b27d828958$export$ebd11618f299a286;
module.exports["M"] = $69ff85b27d828958$export$3a1a48c8f6ef640e;
module.exports["U"] = $69ff85b27d828958$export$3a6d5c9ae78a2c08;
module.exports["P"] = $69ff85b27d828958$export$56c0d5a1e737357d;
module.exports["R"] = $69ff85b27d828958$export$db202ddc8be9136;
module.exports["w"] = $69ff85b27d828958$export$efccba1c4a2ef57b;
module.exports["e"] = $69ff85b27d828958$export$f1e1789686576879;
module.exports["i"] = $69ff85b27d828958$export$23f2a1d2818174ef;
module.exports["l"] = $69ff85b27d828958$export$882b5998b3b9117c;
module.exports["h"] = $69ff85b27d828958$export$dda1d9f60106f0e9;
module.exports["g"] = $69ff85b27d828958$export$39b482c5e57630a8;
module.exports["O"] = $69ff85b27d828958$export$c4ce752e73470fba;
module.exports["b"] = $69ff85b27d828958$export$8b22cf2602fb60ce;
module.exports["f"] = $69ff85b27d828958$export$2d1720544b23b823;
module.exports["d"] = $69ff85b27d828958$export$4368d992c4eafac0;
module.exports["x"] = $69ff85b27d828958$export$d141bba7fdc215a3;
module.exports["u"] = $69ff85b27d828958$export$3b14a55fb2447963;
module.exports["j"] = $69ff85b27d828958$export$35e795649ee09318;
module.exports["o"] = $69ff85b27d828958$export$ae1af26003f05816;
module.exports["s"] = $69ff85b27d828958$export$2408f22a0fab9ae5;
module.exports["p"] = $69ff85b27d828958$export$ffb5f4729a158638;
module.exports["n"] = $69ff85b27d828958$export$7ccc53e8f1e7dfc5;
module.exports["r"] = $69ff85b27d828958$export$43caf9889c228507;
module.exports["k"] = $69ff85b27d828958$export$342063e11d6c3cad;
module.exports["y"] = $69ff85b27d828958$export$4a5767248b18ef41;

});

parcelRegister("e6Soq", function(module, exports) {
// From https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/globalThis
function $a45bd1884ca79325$export$a4e55266d2135a7f() {
    if (typeof globalThis !== 'undefined') return globalThis;
    if (typeof self !== 'undefined') return self;
    if (typeof window !== 'undefined') return window;
    if (typeof $parcel$global !== 'undefined') return $parcel$global;
}
function $a45bd1884ca79325$var$getDevTools() {
    const w = $a45bd1884ca79325$export$a4e55266d2135a7f();
    if (w.__xstate__) return w.__xstate__;
    return undefined;
}
function $a45bd1884ca79325$export$4d7a7d14704ebc13(service) {
    if (typeof window === 'undefined') return;
    const devTools = $a45bd1884ca79325$var$getDevTools();
    if (devTools) devTools.register(service);
}
const $a45bd1884ca79325$export$3ee8010769463234 = (service)=>{
    if (typeof window === 'undefined') return;
    const devTools = $a45bd1884ca79325$var$getDevTools();
    if (devTools) devTools.register(service);
};
module.exports["devToolsAdapter"] = $a45bd1884ca79325$export$3ee8010769463234;

});

parcelRegister("banCF", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $iVxGn = parcelRequire("iVxGn");

parcelRequire("cgKJK");
var $96dZ7 = parcelRequire("96dZ7");




var $aSzLn = parcelRequire("aSzLn");


var $6nvBr = parcelRequire("6nvBr");

const $021914730fb82814$var$forEachActor = (actorRef, callback)=>{
    callback(actorRef);
    const children = actorRef.getSnapshot().children;
    if (children) Object.values(children).forEach((child)=>{
        $021914730fb82814$var$forEachActor(child, callback);
    });
};
function $021914730fb82814$var$stopRootWithRehydration(actorRef) {
    // persist snapshot here in a custom way allows us to persist inline actors and to preserve actor references
    // we do it to avoid setState in useEffect when the effect gets "reconnected"
    // this currently only happens in Strict Effects but it simulates the Offscreen aka Activity API
    // it also just allows us to end up with a somewhat more predictable behavior for the users
    const persistedSnapshots = [];
    $021914730fb82814$var$forEachActor(actorRef, (ref)=>{
        persistedSnapshots.push([
            ref,
            ref.getSnapshot()
        ]);
        // muting observers allow us to avoid `useSelector` from being notified about the stopped snapshot
        // React reconnects its subscribers (from the useSyncExternalStore) on its own
        // and userland subscibers should basically always do the same anyway
        // as each subscription should have its own cleanup logic and that should be called each such reconnect
        ref.observers = new Set();
    });
    const systemSnapshot = actorRef.system.getSnapshot?.();
    actorRef.stop();
    actorRef.system._snapshot = systemSnapshot;
    persistedSnapshots.forEach(([ref, snapshot])=>{
        ref._processingStatus = 0;
        ref._snapshot = snapshot;
    });
}
function $021914730fb82814$var$useIdleActorRef(logic, ...[options]) {
    let [[currentConfig, actorRef], setCurrent] = (0, $cozmU.useState)(()=>{
        const actorRef = (0, $96dZ7.A)(logic, options);
        return [
            logic.config,
            actorRef
        ];
    });
    if (logic.config !== currentConfig) {
        const newActorRef = (0, $96dZ7.A)(logic, {
            ...options,
            snapshot: actorRef.getPersistedSnapshot({
                __unsafeAllowInlineActors: true
            })
        });
        setCurrent([
            logic.config,
            newActorRef
        ]);
        actorRef = newActorRef;
    }
    // TODO: consider using `useAsapEffect` that would do this in `useInsertionEffect` is that's available
    (0, $iVxGn.default)(()=>{
        actorRef.logic.implementations = logic.implementations;
    });
    return actorRef;
}
function $021914730fb82814$export$e92bd910f9c89ff6(machine, ...[options, observerOrListener]) {
    const actorRef = $021914730fb82814$var$useIdleActorRef(machine, options);
    (0, $cozmU.useEffect)(()=>{
        if (!observerOrListener) return;
        const sub = actorRef.subscribe((0, $96dZ7.L)(observerOrListener));
        return ()=>{
            sub.unsubscribe();
        };
    }, [
        observerOrListener
    ]);
    (0, $cozmU.useEffect)(()=>{
        actorRef.start();
        return ()=>{
            $021914730fb82814$var$stopRootWithRehydration(actorRef);
        };
    }, [
        actorRef
    ]);
    return actorRef;
}
function $021914730fb82814$var$defaultCompare(a, b) {
    return a === b;
}
function $021914730fb82814$export$2105062e25df4afe(actor, selector, compare = $021914730fb82814$var$defaultCompare) {
    const subscribe = (0, $cozmU.useCallback)((handleStoreChange)=>{
        if (!actor) return ()=>{};
        const { unsubscribe: unsubscribe } = actor.subscribe(handleStoreChange);
        return unsubscribe;
    }, [
        actor
    ]);
    const boundGetSnapshot = (0, $cozmU.useCallback)(()=>actor?.getSnapshot(), [
        actor
    ]);
    const selectedSnapshot = (0, $aSzLn.useSyncExternalStoreWithSelector)(subscribe, boundGetSnapshot, boundGetSnapshot, selector, compare);
    return selectedSnapshot;
}
function $021914730fb82814$export$72ba36f8308928ab(actorLogic, actorOptions) {
    const ReactContext = /*#__PURE__*/ $cozmU.createContext(null);
    const OriginalProvider = ReactContext.Provider;
    function Provider({ children: children, logic: providedLogic = actorLogic, machine: machine, options: providedOptions }) {
        if (machine) throw new Error(`The "machine" prop has been deprecated. Please use "logic" instead.`);
        const actor = $021914730fb82814$export$e92bd910f9c89ff6(providedLogic, {
            ...actorOptions,
            ...providedOptions
        });
        return /*#__PURE__*/ $cozmU.createElement(OriginalProvider, {
            value: actor,
            children: children
        });
    }
    // TODO: add properties to actor ref to make more descriptive
    Provider.displayName = `ActorProvider`;
    function useContext() {
        const actor = $cozmU.useContext(ReactContext);
        if (!actor) throw new Error(`You used a hook from "${Provider.displayName}" but it's not inside a <${Provider.displayName}> component.`);
        return actor;
    }
    function useSelector$1(selector, compare) {
        const actor = useContext();
        return $021914730fb82814$export$2105062e25df4afe(actor, selector, compare);
    }
    return {
        Provider: Provider,
        useActorRef: useContext,
        useSelector: useSelector$1
    };
}
// From https://github.com/reduxjs/react-redux/blob/720f0ba79236cdc3e1115f4ef9a7760a21784b48/src/utils/shallowEqual.ts
function $021914730fb82814$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $021914730fb82814$export$d36bdfa510afb180(objA, objB) {
    if ($021914730fb82814$var$is(objA, objB)) return true;
    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(let i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$021914730fb82814$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}
function $021914730fb82814$export$25c4ab29592aabd9(logic, ...[options]) {
    const actorRef = $021914730fb82814$var$useIdleActorRef(logic, options);
    const getSnapshot = (0, $cozmU.useCallback)(()=>{
        return actorRef.getSnapshot();
    }, [
        actorRef
    ]);
    const subscribe = (0, $cozmU.useCallback)((handleStoreChange)=>{
        const { unsubscribe: unsubscribe } = actorRef.subscribe(handleStoreChange);
        return unsubscribe;
    }, [
        actorRef
    ]);
    const actorSnapshot = (0, $6nvBr.useSyncExternalStore)(subscribe, getSnapshot, getSnapshot);
    (0, $cozmU.useEffect)(()=>{
        actorRef.start();
        return ()=>{
            $021914730fb82814$var$stopRootWithRehydration(actorRef);
        };
    }, [
        actorRef
    ]);
    return [
        actorSnapshot,
        actorRef.send,
        actorRef
    ];
}
/** @alias useActor */ function $021914730fb82814$export$e0338c4153421160(machine, ...[options]) {
    return $021914730fb82814$export$25c4ab29592aabd9(machine, options);
}
module.exports["useActorRef"] = $021914730fb82814$export$e92bd910f9c89ff6;
module.exports["useSelector"] = $021914730fb82814$export$2105062e25df4afe;
module.exports["createActorContext"] = $021914730fb82814$export$72ba36f8308928ab;
module.exports["shallowEqual"] = $021914730fb82814$export$d36bdfa510afb180;
module.exports["useMachine"] = $021914730fb82814$export$e0338c4153421160;

});

parcelRegister("iVxGn", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

var $dc77ad8576485322$export$2e2bcd8739ae039 = (0, $cozmU.useLayoutEffect);
module.exports["default"] = $dc77ad8576485322$export$2e2bcd8739ae039;

});

parcelRegister("cgKJK", function(module, exports) {
$parcel$export(module.exports, "createActor", () => (parcelRequire("96dZ7")).A);
$parcel$export(module.exports, "assign", () => (parcelRequire("dpSRg")).a);

var $eXLWP = parcelRequire("eXLWP");


var $96dZ7 = parcelRequire("96dZ7");


var $dpSRg = parcelRequire("dpSRg");

parcelRequire("e6Soq");

/**
 * Asserts that the given event object is of the specified type or types. Throws
 * an error if the event object is not of the specified types.
 *
 * @example
 *
 * ```ts
 * // ...
 * entry: ({ event }) => {
 *   assertEvent(event, 'doNothing');
 *   // event is { type: 'doNothing' }
 * },
 * // ...
 * exit: ({ event }) => {
 *   assertEvent(event, 'greet');
 *   // event is { type: 'greet'; message: string }
 *
 *   assertEvent(event, ['greet', 'notify']);
 *   // event is { type: 'greet'; message: string }
 *   // or { type: 'notify'; message: string; level: 'info' | 'error' }
 * },
 * ```
 */ function $8eeb3b9b9ffbca82$export$b3e112bfd3a4f448(event, type) {
    const types = (0, $96dZ7.t)(type);
    if (!types.includes(event.type)) {
        const typesText = types.length === 1 ? `type "${types[0]}"` : `one of types "${types.join('", "')}"`;
        throw new Error(`Expected event ${JSON.stringify(event)} to have ${typesText}`);
    }
}
const $8eeb3b9b9ffbca82$var$cache = new WeakMap();
function $8eeb3b9b9ffbca82$var$memo(object, key, fn) {
    let memoizedData = $8eeb3b9b9ffbca82$var$cache.get(object);
    if (!memoizedData) {
        memoizedData = {
            [key]: fn()
        };
        $8eeb3b9b9ffbca82$var$cache.set(object, memoizedData);
    } else if (!(key in memoizedData)) memoizedData[key] = fn();
    return memoizedData[key];
}
const $8eeb3b9b9ffbca82$var$EMPTY_OBJECT = {};
const $8eeb3b9b9ffbca82$var$toSerializableAction = (action)=>{
    if (typeof action === 'string') return {
        type: action
    };
    if (typeof action === 'function') {
        if ('resolve' in action) return {
            type: action.type
        };
        return {
            type: action.name
        };
    }
    return action;
};
class $8eeb3b9b9ffbca82$export$342f24f5edd47b1 {
    /** @internal */ _initialize() {
        this.transitions = (0, $96dZ7.f)(this);
        if (this.config.always) this.always = (0, $96dZ7.a)(this.config.always).map((t)=>(0, $96dZ7.b)(this, (0, $96dZ7.N), t));
        Object.keys(this.states).forEach((key)=>{
            this.states[key]._initialize();
        });
    }
    /** The well-structured state node definition. */ get definition() {
        return {
            id: this.id,
            key: this.key,
            version: this.machine.version,
            type: this.type,
            initial: this.initial ? {
                target: this.initial.target,
                source: this,
                actions: this.initial.actions.map($8eeb3b9b9ffbca82$var$toSerializableAction),
                eventType: null,
                reenter: false,
                toJSON: ()=>({
                        target: this.initial.target.map((t)=>`#${t.id}`),
                        source: `#${this.id}`,
                        actions: this.initial.actions.map($8eeb3b9b9ffbca82$var$toSerializableAction),
                        eventType: null
                    })
            } : undefined,
            history: this.history,
            states: (0, $96dZ7.m)(this.states, (state)=>{
                return state.definition;
            }),
            on: this.on,
            transitions: [
                ...this.transitions.values()
            ].flat().map((t)=>({
                    ...t,
                    actions: t.actions.map($8eeb3b9b9ffbca82$var$toSerializableAction)
                })),
            entry: this.entry.map($8eeb3b9b9ffbca82$var$toSerializableAction),
            exit: this.exit.map($8eeb3b9b9ffbca82$var$toSerializableAction),
            meta: this.meta,
            order: this.order || -1,
            output: this.output,
            invoke: this.invoke,
            description: this.description,
            tags: this.tags
        };
    }
    /** @internal */ toJSON() {
        return this.definition;
    }
    /** The logic invoked as actors by this state node. */ get invoke() {
        return $8eeb3b9b9ffbca82$var$memo(this, 'invoke', ()=>(0, $96dZ7.t)(this.config.invoke).map((invokeConfig, i)=>{
                const { src: src, systemId: systemId } = invokeConfig;
                const resolvedId = invokeConfig.id ?? (0, $96dZ7.c)(this.id, i);
                const sourceName = typeof src === 'string' ? src : `xstate.invoke.${(0, $96dZ7.c)(this.id, i)}`;
                return {
                    ...invokeConfig,
                    src: sourceName,
                    id: resolvedId,
                    systemId: systemId,
                    toJSON () {
                        const { onDone: onDone, onError: onError, ...invokeDefValues } = invokeConfig;
                        return {
                            ...invokeDefValues,
                            type: 'xstate.invoke',
                            src: sourceName,
                            id: resolvedId
                        };
                    }
                };
            }));
    }
    /** The mapping of events to transitions. */ get on() {
        return $8eeb3b9b9ffbca82$var$memo(this, 'on', ()=>{
            const transitions = this.transitions;
            return [
                ...transitions
            ].flatMap(([descriptor, t])=>t.map((t)=>[
                        descriptor,
                        t
                    ])).reduce((map, [descriptor, transition])=>{
                map[descriptor] = map[descriptor] || [];
                map[descriptor].push(transition);
                return map;
            }, {});
        });
    }
    get after() {
        return $8eeb3b9b9ffbca82$var$memo(this, 'delayedTransitions', ()=>(0, $96dZ7.g)(this));
    }
    get initial() {
        return $8eeb3b9b9ffbca82$var$memo(this, 'initial', ()=>(0, $96dZ7.d)(this, this.config.initial));
    }
    /** @internal */ next(snapshot, event) {
        const eventType = event.type;
        const actions = [];
        let selectedTransition;
        const candidates = $8eeb3b9b9ffbca82$var$memo(this, `candidates-${eventType}`, ()=>(0, $96dZ7.h)(this, eventType));
        for (const candidate of candidates){
            const { guard: guard } = candidate;
            const resolvedContext = snapshot.context;
            let guardPassed = false;
            try {
                guardPassed = !guard || (0, $96dZ7.e)(guard, resolvedContext, event, snapshot);
            } catch (err) {
                const guardType = typeof guard === 'string' ? guard : typeof guard === 'object' ? guard.type : undefined;
                throw new Error(`Unable to evaluate guard ${guardType ? `'${guardType}' ` : ''}in transition for event '${eventType}' in state node '${this.id}':\n${err.message}`);
            }
            if (guardPassed) {
                actions.push(...candidate.actions);
                selectedTransition = candidate;
                break;
            }
        }
        return selectedTransition ? [
            selectedTransition
        ] : undefined;
    }
    /** All the event types accepted by this state node and its descendants. */ get events() {
        return $8eeb3b9b9ffbca82$var$memo(this, 'events', ()=>{
            const { states: states } = this;
            const events = new Set(this.ownEvents);
            if (states) for (const stateId of Object.keys(states)){
                const state = states[stateId];
                if (state.states) for (const event of state.events)events.add(`${event}`);
            }
            return Array.from(events);
        });
    }
    /**
   * All the events that have transitions directly from this state node.
   *
   * Excludes any inert events.
   */ get ownEvents() {
        const events = new Set([
            ...this.transitions.keys()
        ].filter((descriptor)=>{
            return this.transitions.get(descriptor).some((transition)=>!(!transition.target && !transition.actions.length && !transition.reenter));
        }));
        return Array.from(events);
    }
    constructor(/** The raw config used to create the machine. */ config, options){
        this.config = config;
        /**
     * The relative key of the state node, which represents its location in the
     * overall state value.
     */ this.key = void 0;
        /** The unique ID of the state node. */ this.id = void 0;
        /**
     * The type of this state node:
     *
     * - `'atomic'` - no child state nodes
     * - `'compound'` - nested child state nodes (XOR)
     * - `'parallel'` - orthogonal nested child state nodes (AND)
     * - `'history'` - history state node
     * - `'final'` - final state node
     */ this.type = void 0;
        /** The string path from the root machine node to this node. */ this.path = void 0;
        /** The child state nodes. */ this.states = void 0;
        /**
     * The type of history on this state node. Can be:
     *
     * - `'shallow'` - recalls only top-level historical state value
     * - `'deep'` - recalls historical state value at all levels
     */ this.history = void 0;
        /** The action(s) to be executed upon entering the state node. */ this.entry = void 0;
        /** The action(s) to be executed upon exiting the state node. */ this.exit = void 0;
        /** The parent state node. */ this.parent = void 0;
        /** The root machine node. */ this.machine = void 0;
        /**
     * The meta data associated with this state node, which will be returned in
     * State instances.
     */ this.meta = void 0;
        /**
     * The output data sent with the "xstate.done.state._id_" event if this is a
     * final state node.
     */ this.output = void 0;
        /**
     * The order this state node appears. Corresponds to the implicit document
     * order.
     */ this.order = -1;
        this.description = void 0;
        this.tags = [];
        this.transitions = void 0;
        this.always = void 0;
        this.parent = options._parent;
        this.key = options._key;
        this.machine = options._machine;
        this.path = this.parent ? this.parent.path.concat(this.key) : [];
        this.id = this.config.id || [
            this.machine.id,
            ...this.path
        ].join((0, $96dZ7.S));
        this.type = this.config.type || (this.config.states && Object.keys(this.config.states).length ? 'compound' : this.config.history ? 'history' : 'atomic');
        this.description = this.config.description;
        this.order = this.machine.idMap.size;
        this.machine.idMap.set(this.id, this);
        this.states = this.config.states ? (0, $96dZ7.m)(this.config.states, (stateConfig, key)=>{
            const stateNode = new $8eeb3b9b9ffbca82$export$342f24f5edd47b1(stateConfig, {
                _parent: this,
                _key: key,
                _machine: this.machine
            });
            return stateNode;
        }) : $8eeb3b9b9ffbca82$var$EMPTY_OBJECT;
        if (this.type === 'compound' && !this.config.initial) throw new Error(`No initial state specified for compound state node "#${this.id}". Try adding { initial: "${Object.keys(this.states)[0]}" } to the state config.`);
        // History config
        this.history = this.config.history === true ? 'shallow' : this.config.history || false;
        this.entry = (0, $96dZ7.t)(this.config.entry).slice();
        this.exit = (0, $96dZ7.t)(this.config.exit).slice();
        this.meta = this.config.meta;
        this.output = this.type === 'final' || !this.parent ? this.config.output : undefined;
        this.tags = (0, $96dZ7.t)(config.tags).slice();
    }
}
const $8eeb3b9b9ffbca82$var$STATE_IDENTIFIER = '#';
class $8eeb3b9b9ffbca82$export$cbf2d83d1eab018a {
    /**
   * Clones this state machine with the provided implementations and merges the
   * `context` (if provided).
   *
   * @param implementations Options (`actions`, `guards`, `actors`, `delays`,
   *   `context`) to recursively merge with the existing options.
   * @returns A new `StateMachine` instance with the provided implementations.
   */ provide(implementations) {
        const { actions: actions, guards: guards, actors: actors, delays: delays } = this.implementations;
        return new $8eeb3b9b9ffbca82$export$cbf2d83d1eab018a(this.config, {
            actions: {
                ...actions,
                ...implementations.actions
            },
            guards: {
                ...guards,
                ...implementations.guards
            },
            actors: {
                ...actors,
                ...implementations.actors
            },
            delays: {
                ...delays,
                ...implementations.delays
            }
        });
    }
    resolveState(config) {
        const resolvedStateValue = (0, $96dZ7.r)(this.root, config.value);
        const nodeSet = (0, $96dZ7.i)((0, $96dZ7.j)(this.root, resolvedStateValue));
        return (0, $96dZ7.k)({
            _nodes: [
                ...nodeSet
            ],
            context: config.context || {},
            children: {},
            status: (0, $96dZ7.l)(nodeSet, this.root) ? 'done' : config.status || 'active',
            output: config.output,
            error: config.error,
            historyValue: config.historyValue
        }, this);
    }
    /**
   * Determines the next snapshot given the current `snapshot` and received
   * `event`. Calculates a full macrostep from all microsteps.
   *
   * @param snapshot The current snapshot
   * @param event The received event
   */ transition(snapshot, event, actorScope) {
        return (0, $96dZ7.n)(snapshot, event, actorScope, []).snapshot;
    }
    /**
   * Determines the next state given the current `state` and `event`. Calculates
   * a microstep.
   *
   * @param state The current state
   * @param event The received event
   */ microstep(snapshot, event, actorScope) {
        return (0, $96dZ7.n)(snapshot, event, actorScope, []).microstates;
    }
    getTransitionData(snapshot, event) {
        return (0, $96dZ7.o)(this.root, snapshot.value, snapshot, event) || [];
    }
    /**
   * The initial state _before_ evaluating any microsteps. This "pre-initial"
   * state is provided to initial actions executed in the initial state.
   */ getPreInitialState(actorScope, initEvent, internalQueue) {
        const { context: context } = this.config;
        const preInitial = (0, $96dZ7.k)({
            context: typeof context !== 'function' && context ? context : {},
            _nodes: [
                this.root
            ],
            children: {},
            status: 'active'
        }, this);
        if (typeof context === 'function') {
            const assignment = ({ spawn: spawn, event: event, self: self })=>context({
                    spawn: spawn,
                    input: event.input,
                    self: self
                });
            return (0, $96dZ7.p)(preInitial, initEvent, actorScope, [
                (0, $dpSRg.a)(assignment)
            ], internalQueue, undefined);
        }
        return preInitial;
    }
    /**
   * Returns the initial `State` instance, with reference to `self` as an
   * `ActorRef`.
   */ getInitialSnapshot(actorScope, input) {
        const initEvent = (0, $96dZ7.q)(input); // TODO: fix;
        const internalQueue = [];
        const preInitialState = this.getPreInitialState(actorScope, initEvent, internalQueue);
        const nextState = (0, $96dZ7.s)([
            {
                target: [
                    ...(0, $96dZ7.u)(this.root)
                ],
                source: this.root,
                reenter: true,
                actions: [],
                eventType: null,
                toJSON: null // TODO: fix
            }
        ], preInitialState, actorScope, initEvent, true, internalQueue);
        const { snapshot: macroState } = (0, $96dZ7.n)(nextState, initEvent, actorScope, internalQueue);
        return macroState;
    }
    start(snapshot) {
        Object.values(snapshot.children).forEach((child)=>{
            if (child.getSnapshot().status === 'active') child.start();
        });
    }
    getStateNodeById(stateId) {
        const fullPath = (0, $96dZ7.v)(stateId);
        const relativePath = fullPath.slice(1);
        const resolvedStateId = (0, $96dZ7.w)(fullPath[0]) ? fullPath[0].slice($8eeb3b9b9ffbca82$var$STATE_IDENTIFIER.length) : fullPath[0];
        const stateNode = this.idMap.get(resolvedStateId);
        if (!stateNode) throw new Error(`Child state node '#${resolvedStateId}' does not exist on machine '${this.id}'`);
        return (0, $96dZ7.x)(stateNode, relativePath);
    }
    get definition() {
        return this.root.definition;
    }
    toJSON() {
        return this.definition;
    }
    getPersistedSnapshot(snapshot, options) {
        return (0, $96dZ7.y)(snapshot, options);
    }
    restoreSnapshot(snapshot, _actorScope) {
        const children = {};
        const snapshotChildren = snapshot.children;
        Object.keys(snapshotChildren).forEach((actorId)=>{
            const actorData = snapshotChildren[actorId];
            const childState = actorData.snapshot;
            const src = actorData.src;
            const logic = typeof src === 'string' ? (0, $96dZ7.z)(this, src) : src;
            if (!logic) return;
            const actorRef = (0, $96dZ7.A)(logic, {
                id: actorId,
                parent: _actorScope.self,
                syncSnapshot: actorData.syncSnapshot,
                snapshot: childState,
                src: src,
                systemId: actorData.systemId
            });
            children[actorId] = actorRef;
        });
        const restoredSnapshot = (0, $96dZ7.k)({
            ...snapshot,
            children: children,
            _nodes: Array.from((0, $96dZ7.i)((0, $96dZ7.j)(this.root, snapshot.value)))
        }, this);
        const seen = new Set();
        function reviveContext(contextPart, children) {
            if (seen.has(contextPart)) return;
            seen.add(contextPart);
            for(const key in contextPart){
                const value = contextPart[key];
                if (value && typeof value === 'object') {
                    if ('xstate$$type' in value && value.xstate$$type === (0, $96dZ7.$)) {
                        contextPart[key] = children[value.id];
                        continue;
                    }
                    reviveContext(value, children);
                }
            }
        }
        reviveContext(restoredSnapshot.context, children);
        return restoredSnapshot;
    }
    constructor(/** The raw config used to create the machine. */ config, implementations){
        this.config = config;
        /** The machine's own version. */ this.version = void 0;
        this.schemas = void 0;
        this.implementations = void 0;
        /** @internal */ this.__xstatenode = true;
        /** @internal */ this.idMap = new Map();
        this.root = void 0;
        this.id = void 0;
        this.states = void 0;
        this.events = void 0;
        this.id = config.id || '(machine)';
        this.implementations = {
            actors: implementations?.actors ?? {},
            actions: implementations?.actions ?? {},
            delays: implementations?.delays ?? {},
            guards: implementations?.guards ?? {}
        };
        this.version = this.config.version;
        this.schemas = this.config.schemas;
        this.transition = this.transition.bind(this);
        this.getInitialSnapshot = this.getInitialSnapshot.bind(this);
        this.getPersistedSnapshot = this.getPersistedSnapshot.bind(this);
        this.restoreSnapshot = this.restoreSnapshot.bind(this);
        this.start = this.start.bind(this);
        this.root = new $8eeb3b9b9ffbca82$export$342f24f5edd47b1(config, {
            _key: this.id,
            _machine: this
        });
        this.root._initialize();
        this.states = this.root.states; // TODO: remove!
        this.events = this.root.events;
    }
}
/**
 * Creates a state machine (statechart) with the given configuration.
 *
 * The state machine represents the pure logic of a state machine actor.
 *
 * @example
 *
 * ```ts
 * import { createMachine } from 'xstate';
 *
 * const lightMachine = createMachine({
 *   id: 'light',
 *   initial: 'green',
 *   states: {
 *     green: {
 *       on: {
 *         TIMER: { target: 'yellow' }
 *       }
 *     },
 *     yellow: {
 *       on: {
 *         TIMER: { target: 'red' }
 *       }
 *     },
 *     red: {
 *       on: {
 *         TIMER: { target: 'green' }
 *       }
 *     }
 *   }
 * });
 *
 * const lightActor = createActor(lightMachine);
 * lightActor.start();
 *
 * lightActor.send({ type: 'TIMER' });
 * ```
 *
 * @param config The state machine configuration.
 * @param options DEPRECATED: use `setup({ ... })` or `machine.provide({ ... })`
 *   to provide machine implementations instead.
 */ function $8eeb3b9b9ffbca82$export$aaa7fa18f8e9b2e8(config, implementations) {
    return new $8eeb3b9b9ffbca82$export$cbf2d83d1eab018a(config, implementations);
}
/** @internal */ function $8eeb3b9b9ffbca82$var$createInertActorScope(actorLogic) {
    const self = (0, $96dZ7.A)(actorLogic);
    const inertActorScope = {
        self: self,
        defer: ()=>{},
        id: '',
        logger: ()=>{},
        sessionId: '',
        stopChild: ()=>{},
        system: self.system,
        emit: ()=>{},
        actionExecutor: ()=>{}
    };
    return inertActorScope;
}
/** @deprecated Use `initialTransition(…)` instead. */ function $8eeb3b9b9ffbca82$export$e1c3f9a97f5088ae(actorLogic, ...[input]) {
    const actorScope = $8eeb3b9b9ffbca82$var$createInertActorScope(actorLogic);
    return actorLogic.getInitialSnapshot(actorScope, input);
}
/**
 * Determines the next snapshot for the given `actorLogic` based on the given
 * `snapshot` and `event`.
 *
 * If the `snapshot` is `undefined`, the initial snapshot of the `actorLogic` is
 * used.
 *
 * @deprecated Use `transition(…)` instead.
 * @example
 *
 * ```ts
 * import { getNextSnapshot } from 'xstate';
 * import { trafficLightMachine } from './trafficLightMachine.ts';
 *
 * const nextSnapshot = getNextSnapshot(
 *   trafficLightMachine, // actor logic
 *   undefined, // snapshot (or initial state if undefined)
 *   { type: 'TIMER' }
 * ); // event object
 *
 * console.log(nextSnapshot.value);
 * // => 'yellow'
 *
 * const nextSnapshot2 = getNextSnapshot(
 *   trafficLightMachine, // actor logic
 *   nextSnapshot, // snapshot
 *   { type: 'TIMER' }
 * ); // event object
 *
 * console.log(nextSnapshot2.value);
 * // =>'red'
 * ```
 */ function $8eeb3b9b9ffbca82$export$3629c64713e6dfd7(actorLogic, snapshot, event) {
    const inertActorScope = $8eeb3b9b9ffbca82$var$createInertActorScope(actorLogic);
    inertActorScope.self._snapshot = snapshot;
    return actorLogic.transition(snapshot, event, inertActorScope);
}
// at the moment we allow extra actors - ones that are not specified by `children`
// this could be reconsidered in the future
function $8eeb3b9b9ffbca82$export$de27182ff8187d6c({ schemas: schemas, actors: actors, actions: actions, guards: guards, delays: delays }) {
    return {
        createMachine: (config)=>$8eeb3b9b9ffbca82$export$aaa7fa18f8e9b2e8({
                ...config,
                schemas: schemas
            }, {
                actors: actors,
                actions: actions,
                guards: guards,
                delays: delays
            })
    };
}
// eslint-disable-next-line @typescript-eslint/no-unsafe-declaration-merging
// eslint-disable-next-line @typescript-eslint/no-unsafe-declaration-merging
class $8eeb3b9b9ffbca82$export$7413adad607e2cdf {
    now() {
        return this._now;
    }
    getId() {
        return this._id++;
    }
    setTimeout(fn, timeout) {
        this._flushingInvalidated = this._flushing;
        const id = this.getId();
        this.timeouts.set(id, {
            start: this.now(),
            timeout: timeout,
            fn: fn
        });
        return id;
    }
    clearTimeout(id) {
        this._flushingInvalidated = this._flushing;
        this.timeouts.delete(id);
    }
    set(time) {
        if (this._now > time) throw new Error('Unable to travel back in time');
        this._now = time;
        this.flushTimeouts();
    }
    flushTimeouts() {
        if (this._flushing) {
            this._flushingInvalidated = true;
            return;
        }
        this._flushing = true;
        const sorted = [
            ...this.timeouts
        ].sort(([_idA, timeoutA], [_idB, timeoutB])=>{
            const endA = timeoutA.start + timeoutA.timeout;
            const endB = timeoutB.start + timeoutB.timeout;
            return endB > endA ? -1 : 1;
        });
        for (const [id, timeout] of sorted){
            if (this._flushingInvalidated) {
                this._flushingInvalidated = false;
                this._flushing = false;
                this.flushTimeouts();
                return;
            }
            if (this.now() - timeout.start >= timeout.timeout) {
                this.timeouts.delete(id);
                timeout.fn.call(null);
            }
        }
        this._flushing = false;
    }
    increment(ms) {
        this._now += ms;
        this.flushTimeouts();
    }
    constructor(){
        this.timeouts = new Map();
        this._now = 0;
        this._id = 0;
        this._flushing = false;
        this._flushingInvalidated = false;
    }
}
/**
 * Returns a promise that resolves to the `output` of the actor when it is done.
 *
 * @example
 *
 * ```ts
 * const machine = createMachine({
 *   // ...
 *   output: {
 *     count: 42
 *   }
 * });
 *
 * const actor = createActor(machine);
 *
 * actor.start();
 *
 * const output = await toPromise(actor);
 *
 * console.log(output);
 * // logs { count: 42 }
 * ```
 */ function $8eeb3b9b9ffbca82$export$4dbaaf6c79705e6c(actor) {
    return new Promise((resolve, reject)=>{
        actor.subscribe({
            complete: ()=>{
                resolve(actor.getSnapshot().output);
            },
            error: reject
        });
    });
}
/**
 * Given actor `logic`, a `snapshot`, and an `event`, returns a tuple of the
 * `nextSnapshot` and `actions` to execute.
 *
 * This is a pure function that does not execute `actions`.
 */ function $8eeb3b9b9ffbca82$export$66bb15e2994e6a26(logic, snapshot, event) {
    const executableActions = [];
    const actorScope = $8eeb3b9b9ffbca82$var$createInertActorScope(logic);
    actorScope.actionExecutor = (action)=>{
        executableActions.push(action);
    };
    const nextSnapshot = logic.transition(snapshot, event, actorScope);
    return [
        nextSnapshot,
        executableActions
    ];
}
/**
 * Given actor `logic` and optional `input`, returns a tuple of the
 * `nextSnapshot` and `actions` to execute from the initial transition (no
 * previous state).
 *
 * This is a pure function that does not execute `actions`.
 */ function $8eeb3b9b9ffbca82$export$5f4d25c77127242(logic, ...[input]) {
    const executableActions = [];
    const actorScope = $8eeb3b9b9ffbca82$var$createInertActorScope(logic);
    actorScope.actionExecutor = (action)=>{
        executableActions.push(action);
    };
    const nextSnapshot = logic.getInitialSnapshot(actorScope, input);
    return [
        nextSnapshot,
        executableActions
    ];
}
const $8eeb3b9b9ffbca82$var$defaultWaitForOptions = {
    timeout: Infinity // much more than 10 seconds
};
/**
 * Subscribes to an actor ref and waits for its emitted value to satisfy a
 * predicate, and then resolves with that value. Will throw if the desired state
 * is not reached after an optional timeout. (defaults to Infinity).
 *
 * @example
 *
 * ```js
 * const state = await waitFor(someService, (state) => {
 *   return state.hasTag('loaded');
 * });
 *
 * state.hasTag('loaded'); // true
 * ```
 *
 * @param actorRef The actor ref to subscribe to
 * @param predicate Determines if a value matches the condition to wait for
 * @param options
 * @returns A promise that eventually resolves to the emitted value that matches
 *   the condition
 */ function $8eeb3b9b9ffbca82$export$9bbfceb27f687c1b(actorRef, predicate, options) {
    const resolvedOptions = {
        ...$8eeb3b9b9ffbca82$var$defaultWaitForOptions,
        ...options
    };
    return new Promise((res, rej)=>{
        const { signal: signal } = resolvedOptions;
        if (signal?.aborted) {
            // eslint-disable-next-line @typescript-eslint/prefer-promise-reject-errors
            rej(signal.reason);
            return;
        }
        let done = false;
        const handle = resolvedOptions.timeout === Infinity ? undefined : setTimeout(()=>{
            dispose();
            rej(new Error(`Timeout of ${resolvedOptions.timeout} ms exceeded`));
        }, resolvedOptions.timeout);
        const dispose = ()=>{
            clearTimeout(handle);
            done = true;
            sub?.unsubscribe();
            if (abortListener) signal.removeEventListener('abort', abortListener);
        };
        function checkEmitted(emitted) {
            if (predicate(emitted)) {
                dispose();
                res(emitted);
            }
        }
        /**
     * If the `signal` option is provided, this will be the listener for its
     * `abort` event
     */ let abortListener;
        // eslint-disable-next-line prefer-const
        let sub; // avoid TDZ when disposing synchronously
        // See if the current snapshot already matches the predicate
        checkEmitted(actorRef.getSnapshot());
        if (done) return;
        // only define the `abortListener` if the `signal` option is provided
        if (signal) {
            abortListener = ()=>{
                dispose();
                // XState does not "own" the signal, so we should reject with its reason (if any)
                // eslint-disable-next-line @typescript-eslint/prefer-promise-reject-errors
                rej(signal.reason);
            };
            signal.addEventListener('abort', abortListener);
        }
        sub = actorRef.subscribe({
            next: checkEmitted,
            error: (err)=>{
                dispose();
                // eslint-disable-next-line @typescript-eslint/prefer-promise-reject-errors
                rej(err);
            },
            complete: ()=>{
                dispose();
                rej(new Error(`Actor terminated without satisfying predicate`));
            }
        });
        if (done) sub.unsubscribe();
    });
}
module.exports["createMachine"] = $8eeb3b9b9ffbca82$export$aaa7fa18f8e9b2e8;
module.exports["setup"] = $8eeb3b9b9ffbca82$export$de27182ff8187d6c;

});

parcelRegister("dpSRg", function(module, exports) {

var $96dZ7 = parcelRequire("96dZ7");

function $9c4829d96c0398b3$var$createSpawner(actorScope, { machine: machine, context: context }, event, spawnedChildren) {
    const spawn = (src, options = {})=>{
        const { systemId: systemId, input: input } = options;
        if (typeof src === 'string') {
            const logic = (0, $96dZ7.z)(machine, src);
            if (!logic) throw new Error(`Actor logic '${src}' not implemented in machine '${machine.id}'`);
            const actorRef = (0, $96dZ7.A)(logic, {
                id: options.id,
                parent: actorScope.self,
                syncSnapshot: options.syncSnapshot,
                input: typeof input === 'function' ? input({
                    context: context,
                    event: event,
                    self: actorScope.self
                }) : input,
                src: src,
                systemId: systemId
            });
            spawnedChildren[actorRef.id] = actorRef;
            return actorRef;
        } else {
            const actorRef = (0, $96dZ7.A)(src, {
                id: options.id,
                parent: actorScope.self,
                syncSnapshot: options.syncSnapshot,
                input: options.input,
                src: src,
                systemId: systemId
            });
            return actorRef;
        }
    };
    return (src, options)=>{
        const actorRef = spawn(src, options); // TODO: fix types
        spawnedChildren[actorRef.id] = actorRef;
        actorScope.defer(()=>{
            if (actorRef._processingStatus === (0, $96dZ7.T).Stopped) return;
            actorRef.start();
        });
        return actorRef;
    };
}
function $9c4829d96c0398b3$var$resolveAssign(actorScope, snapshot, actionArgs, actionParams, { assignment: assignment }) {
    if (!snapshot.context) throw new Error('Cannot assign to undefined `context`. Ensure that `context` is defined in the machine config.');
    const spawnedChildren = {};
    const assignArgs = {
        context: snapshot.context,
        event: actionArgs.event,
        spawn: $9c4829d96c0398b3$var$createSpawner(actorScope, snapshot, actionArgs.event, spawnedChildren),
        self: actorScope.self,
        system: actorScope.system
    };
    let partialUpdate = {};
    if (typeof assignment === 'function') partialUpdate = assignment(assignArgs, actionParams);
    else for (const key of Object.keys(assignment)){
        const propAssignment = assignment[key];
        partialUpdate[key] = typeof propAssignment === 'function' ? propAssignment(assignArgs, actionParams) : propAssignment;
    }
    const updatedContext = Object.assign({}, snapshot.context, partialUpdate);
    return [
        (0, $96dZ7.U)(snapshot, {
            context: updatedContext,
            children: Object.keys(spawnedChildren).length ? {
                ...snapshot.children,
                ...spawnedChildren
            } : snapshot.children
        }),
        undefined,
        undefined
    ];
}
/**
 * Updates the current context of the machine.
 *
 * @example
 *
 * ```ts
 * import { createMachine, assign } from 'xstate';
 *
 * const countMachine = createMachine({
 *   context: {
 *     count: 0,
 *     message: ''
 *   },
 *   on: {
 *     inc: {
 *       actions: assign({
 *         count: ({ context }) => context.count + 1
 *       })
 *     },
 *     updateMessage: {
 *       actions: assign(({ context, event }) => {
 *         return {
 *           message: event.message.trim()
 *         };
 *       })
 *     }
 *   }
 * });
 * ```
 *
 * @param assignment An object that represents the partial context to update, or
 *   a function that returns an object that represents the partial context to
 *   update.
 */ function $9c4829d96c0398b3$export$407448d2b89b1813(assignment) {
    function assign(_args, _params) {}
    assign.type = 'xstate.assign';
    assign.assignment = assignment;
    assign.resolve = $9c4829d96c0398b3$var$resolveAssign;
    return assign;
}
function $9c4829d96c0398b3$var$resolveEmit(_, snapshot, args, actionParams, { event: eventOrExpr }) {
    const resolvedEvent = typeof eventOrExpr === 'function' ? eventOrExpr(args, actionParams) : eventOrExpr;
    return [
        snapshot,
        {
            event: resolvedEvent
        },
        undefined
    ];
}
function $9c4829d96c0398b3$var$executeEmit(actorScope, { event: event }) {
    actorScope.defer(()=>actorScope.emit(event));
}
/**
 * Emits an event to event handlers registered on the actor via `actor.on(event,
 * handler)`.
 *
 * @example
 *
 * ```ts
 * import { emit } from 'xstate';
 *
 * const machine = createMachine({
 *   // ...
 *   on: {
 *     something: {
 *       actions: emit({
 *         type: 'emitted',
 *         some: 'data'
 *       })
 *     }
 *   }
 *   // ...
 * });
 *
 * const actor = createActor(machine).start();
 *
 * actor.on('emitted', (event) => {
 *   console.log(event);
 * });
 *
 * actor.send({ type: 'something' });
 * // logs:
 * // {
 * //   type: 'emitted',
 * //   some: 'data'
 * // }
 * ```
 */ function $9c4829d96c0398b3$export$f1e1789686576879(/** The event to emit, or an expression that returns an event to emit. */ eventOrExpr) {
    function emit(_args, _params) {}
    emit.type = 'xstate.emit';
    emit.event = eventOrExpr;
    emit.resolve = $9c4829d96c0398b3$var$resolveEmit;
    emit.execute = $9c4829d96c0398b3$var$executeEmit;
    return emit;
}
/**
 * @remarks
 * `T | unknown` reduces to `unknown` and that can be problematic when it comes
 * to contextual typing. It especially is a problem when the union has a
 * function member, like here:
 *
 * ```ts
 * declare function test(
 *   cbOrVal: ((arg: number) => unknown) | unknown
 * ): void;
 * test((arg) => {}); // oops, implicit any
 * ```
 *
 * This type can be used to avoid this problem. This union represents the same
 * value space as `unknown`.
 */ // https://github.com/microsoft/TypeScript/issues/23182#issuecomment-379091887
// @TODO: Replace with native `NoInfer` when TS issue gets fixed:
// https://github.com/microsoft/TypeScript/pull/57673
/** @deprecated Use the built-in `NoInfer` type instead */ /** The full definition of an event, with a string `type`. */ /**
 * The string or object representing the state value relative to the parent
 * state node.
 *
 * @remarks
 * - For a child atomic state node, this is a string, e.g., `"pending"`.
 * - For complex state nodes, this is an object, e.g., `{ success:
 *   "someChildState" }`.
 */ /** @deprecated Use `AnyMachineSnapshot` instead */ // TODO: possibly refactor this somehow, use even a simpler type, and maybe even make `machine.options` private or something
/** @ignore */ let $9c4829d96c0398b3$export$25ce5a424b770e84 = /*#__PURE__*/ function(SpecialTargets) {
    SpecialTargets["Parent"] = "#_parent";
    SpecialTargets["Internal"] = "#_internal";
    return SpecialTargets;
}({});
/** @deprecated Use `AnyActor` instead. */ // Based on RxJS types
// TODO: in v6, this should only accept AnyActorLogic, like ActorRefFromLogic
/** @deprecated Use `Actor<T>` instead. */ /**
 * Represents logic which can be used by an actor.
 *
 * @template TSnapshot - The type of the snapshot.
 * @template TEvent - The type of the event object.
 * @template TInput - The type of the input.
 * @template TSystem - The type of the actor system.
 */ /** @deprecated */ // TODO: cover all that can be actually returned
function $9c4829d96c0398b3$var$resolveSendTo(actorScope, snapshot, args, actionParams, { to: to, event: eventOrExpr, id: id, delay: delay }, extra) {
    const delaysMap = snapshot.machine.implementations.delays;
    if (typeof eventOrExpr === 'string') throw new Error(// eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    `Only event objects may be used with sendTo; use sendTo({ type: "${eventOrExpr}" }) instead`);
    const resolvedEvent = typeof eventOrExpr === 'function' ? eventOrExpr(args, actionParams) : eventOrExpr;
    let resolvedDelay;
    if (typeof delay === 'string') {
        const configDelay = delaysMap && delaysMap[delay];
        resolvedDelay = typeof configDelay === 'function' ? configDelay(args, actionParams) : configDelay;
    } else resolvedDelay = typeof delay === 'function' ? delay(args, actionParams) : delay;
    const resolvedTarget = typeof to === 'function' ? to(args, actionParams) : to;
    let targetActorRef;
    if (typeof resolvedTarget === 'string') {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-enum-comparison
        if (resolvedTarget === $9c4829d96c0398b3$export$25ce5a424b770e84.Parent) targetActorRef = actorScope.self._parent;
        else if (resolvedTarget === $9c4829d96c0398b3$export$25ce5a424b770e84.Internal) targetActorRef = actorScope.self;
        else if (resolvedTarget.startsWith('#_')) // SCXML compatibility: https://www.w3.org/TR/scxml/#SCXMLEventProcessor
        // #_invokeid. If the target is the special term '#_invokeid', where invokeid is the invokeid of an SCXML session that the sending session has created by <invoke>, the Processor must add the event to the external queue of that session.
        targetActorRef = snapshot.children[resolvedTarget.slice(2)];
        else targetActorRef = extra.deferredActorIds?.includes(resolvedTarget) ? resolvedTarget : snapshot.children[resolvedTarget];
        if (!targetActorRef) throw new Error(`Unable to send event to actor '${resolvedTarget}' from machine '${snapshot.machine.id}'.`);
    } else targetActorRef = resolvedTarget || actorScope.self;
    return [
        snapshot,
        {
            to: targetActorRef,
            targetId: typeof resolvedTarget === 'string' ? resolvedTarget : undefined,
            event: resolvedEvent,
            id: id,
            delay: resolvedDelay
        },
        undefined
    ];
}
function $9c4829d96c0398b3$var$retryResolveSendTo(_, snapshot, params) {
    if (typeof params.to === 'string') params.to = snapshot.children[params.to];
}
function $9c4829d96c0398b3$var$executeSendTo(actorScope, params) {
    // this forms an outgoing events queue
    // thanks to that the recipient actors are able to read the *updated* snapshot value of the sender
    actorScope.defer(()=>{
        const { to: to, event: event, delay: delay, id: id } = params;
        if (typeof delay === 'number') {
            actorScope.system.scheduler.schedule(actorScope.self, to, event, delay, id);
            return;
        }
        actorScope.system._relay(actorScope.self, // at this point, in a deferred task, it should already be mutated by retryResolveSendTo
        // if it initially started as a string
        to, event.type === (0, $96dZ7.V) ? (0, $96dZ7.W)(actorScope.self.id, event.data) : event);
    });
}
/**
 * Sends an event to an actor.
 *
 * @param actor The `ActorRef` to send the event to.
 * @param event The event to send, or an expression that evaluates to the event
 *   to send
 * @param options Send action options
 *
 *   - `id` - The unique send event identifier (used with `cancel()`).
 *   - `delay` - The number of milliseconds to delay the sending of the event.
 */ function $9c4829d96c0398b3$export$db3b6bfb95261072(to, eventOrExpr, options) {
    function sendTo(_args, _params) {}
    sendTo.type = 'xstate.sendTo';
    sendTo.to = to;
    sendTo.event = eventOrExpr;
    sendTo.id = options?.id;
    sendTo.delay = options?.delay;
    sendTo.resolve = $9c4829d96c0398b3$var$resolveSendTo;
    sendTo.retryResolve = $9c4829d96c0398b3$var$retryResolveSendTo;
    sendTo.execute = $9c4829d96c0398b3$var$executeSendTo;
    return sendTo;
}
/**
 * Sends an event to this machine's parent.
 *
 * @param event The event to send to the parent machine.
 * @param options Options to pass into the send event.
 */ function $9c4829d96c0398b3$export$2408f22a0fab9ae5(event, options) {
    return $9c4829d96c0398b3$export$db3b6bfb95261072($9c4829d96c0398b3$export$25ce5a424b770e84.Parent, event, options);
}
/**
 * Forwards (sends) an event to the `target` actor.
 *
 * @param target The target actor to forward the event to.
 * @param options Options to pass into the send action creator.
 */ function $9c4829d96c0398b3$export$2d1720544b23b823(target, options) {
    return $9c4829d96c0398b3$export$db3b6bfb95261072(target, ({ event: event })=>event, options);
}
function $9c4829d96c0398b3$var$resolveEnqueueActions(actorScope, snapshot, args, actionParams, { collect: collect }) {
    const actions = [];
    const enqueue = function enqueue(action) {
        actions.push(action);
    };
    enqueue.assign = (...args)=>{
        actions.push($9c4829d96c0398b3$export$407448d2b89b1813(...args));
    };
    enqueue.cancel = (...args)=>{
        actions.push((0, $96dZ7.M)(...args));
    };
    enqueue.raise = (...args)=>{
        // for some reason it fails to infer `TDelay` from `...args` here and picks its default (`never`)
        // then it fails to typecheck that because `...args` use `string` in place of `TDelay`
        actions.push((0, $96dZ7.O)(...args));
    };
    enqueue.sendTo = (...args)=>{
        // for some reason it fails to infer `TDelay` from `...args` here and picks its default (`never`)
        // then it fails to typecheck that because `...args` use `string` in place of `TDelay
        actions.push($9c4829d96c0398b3$export$db3b6bfb95261072(...args));
    };
    enqueue.sendParent = (...args)=>{
        actions.push($9c4829d96c0398b3$export$2408f22a0fab9ae5(...args));
    };
    enqueue.spawnChild = (...args)=>{
        actions.push((0, $96dZ7.P)(...args));
    };
    enqueue.stopChild = (...args)=>{
        actions.push((0, $96dZ7.R)(...args));
    };
    enqueue.emit = (...args)=>{
        actions.push($9c4829d96c0398b3$export$f1e1789686576879(...args));
    };
    collect({
        context: args.context,
        event: args.event,
        enqueue: enqueue,
        check: (guard)=>(0, $96dZ7.e)(guard, snapshot.context, args.event, snapshot),
        self: actorScope.self,
        system: actorScope.system
    }, actionParams);
    return [
        snapshot,
        undefined,
        actions
    ];
}
/**
 * Creates an action object that will execute actions that are queued by the
 * `enqueue(action)` function.
 *
 * @example
 *
 * ```ts
 * import { createMachine, enqueueActions } from 'xstate';
 *
 * const machine = createMachine({
 *   entry: enqueueActions(({ enqueue, check }) => {
 *     enqueue.assign({ count: 0 });
 *
 *     if (check('someGuard')) {
 *       enqueue.assign({ count: 1 });
 *     }
 *
 *     enqueue('someAction');
 *   })
 * });
 * ```
 */ function $9c4829d96c0398b3$export$8b22cf2602fb60ce(collect) {
    function enqueueActions(_args, _params) {}
    enqueueActions.type = 'xstate.enqueueActions';
    enqueueActions.collect = collect;
    enqueueActions.resolve = $9c4829d96c0398b3$var$resolveEnqueueActions;
    return enqueueActions;
}
function $9c4829d96c0398b3$var$resolveLog(_, snapshot, actionArgs, actionParams, { value: value, label: label }) {
    return [
        snapshot,
        {
            value: typeof value === 'function' ? value(actionArgs, actionParams) : value,
            label: label
        },
        undefined
    ];
}
function $9c4829d96c0398b3$var$executeLog({ logger: logger }, { value: value, label: label }) {
    if (label) logger(label, value);
    else logger(value);
}
/**
 * @param expr The expression function to evaluate which will be logged. Takes
 *   in 2 arguments:
 *
 *   - `ctx` - the current state context
 *   - `event` - the event that caused this action to be executed.
 *
 * @param label The label to give to the logged expression.
 */ function $9c4829d96c0398b3$export$882b5998b3b9117c(value = ({ context: context, event: event })=>({
        context: context,
        event: event
    }), label) {
    function log1(_args, _params) {}
    log1.type = 'xstate.log';
    log1.value = value;
    log1.label = label;
    log1.resolve = $9c4829d96c0398b3$var$resolveLog;
    log1.execute = $9c4829d96c0398b3$var$executeLog;
    return log1;
}
module.exports["a"] = $9c4829d96c0398b3$export$407448d2b89b1813;
module.exports["e"] = $9c4829d96c0398b3$export$f1e1789686576879;
module.exports["c"] = $9c4829d96c0398b3$export$db3b6bfb95261072;
module.exports["b"] = $9c4829d96c0398b3$export$8b22cf2602fb60ce;

});

parcelRegister("hoXSS", function(module, exports) {
/**
 * @callback Handler
 *   Handle a value, with a certain ID field set to a certain value.
 *   The ID field is passed to `zwitch`, and it’s value is this function’s
 *   place on the `handlers` record.
 * @param {...any} parameters
 *   Arbitrary parameters passed to the zwitch.
 *   The first will be an object with a certain ID field set to a certain value.
 * @returns {any}
 *   Anything!
 */ /**
 * @callback UnknownHandler
 *   Handle values that do have a certain ID field, but it’s set to a value
 *   that is not listed in the `handlers` record.
 * @param {unknown} value
 *   An object with a certain ID field set to an unknown value.
 * @param {...any} rest
 *   Arbitrary parameters passed to the zwitch.
 * @returns {any}
 *   Anything!
 */ /**
 * @callback InvalidHandler
 *   Handle values that do not have a certain ID field.
 * @param {unknown} value
 *   Any unknown value.
 * @param {...any} rest
 *   Arbitrary parameters passed to the zwitch.
 * @returns {void|null|undefined|never}
 *   This should crash or return nothing.
 */ /**
 * @template {InvalidHandler} [Invalid=InvalidHandler]
 * @template {UnknownHandler} [Unknown=UnknownHandler]
 * @template {Record<string, Handler>} [Handlers=Record<string, Handler>]
 * @typedef Options
 *   Configuration (required).
 * @property {Invalid} [invalid]
 *   Handler to use for invalid values.
 * @property {Unknown} [unknown]
 *   Handler to use for unknown values.
 * @property {Handlers} [handlers]
 *   Handlers to use.
 */ const $cab3214b6aa77065$var$own = {}.hasOwnProperty;
function $cab3214b6aa77065$export$d6a12bfbbedf6185(key, options) {
    const settings = options || {};
    /**
   * Handle one value.
   *
   * Based on the bound `key`, a respective handler will be called.
   * If `value` is not an object, or doesn’t have a `key` property, the special
   * “invalid” handler will be called.
   * If `value` has an unknown `key`, the special “unknown” handler will be
   * called.
   *
   * All arguments, and the context object, are passed through to the handler,
   * and it’s result is returned.
   *
   * @this {unknown}
   *   Any context object.
   * @param {unknown} [value]
   *   Any value.
   * @param {...unknown} parameters
   *   Arbitrary parameters passed to the zwitch.
   * @property {Handler} invalid
   *   Handle for values that do not have a certain ID field.
   * @property {Handler} unknown
   *   Handle values that do have a certain ID field, but it’s set to a value
   *   that is not listed in the `handlers` record.
   * @property {Handlers} handlers
   *   Record of handlers.
   * @returns {unknown}
   *   Anything.
   */ function one(value, ...parameters) {
        /** @type {Handler|undefined} */ let fn = one.invalid;
        const handlers = one.handlers;
        if (value && $cab3214b6aa77065$var$own.call(value, key)) {
            // @ts-expect-error Indexable.
            const id = String(value[key]);
            // @ts-expect-error Indexable.
            fn = $cab3214b6aa77065$var$own.call(handlers, id) ? handlers[id] : one.unknown;
        }
        if (fn) return fn.call(this, value, ...parameters);
    }
    one.handlers = settings.handlers || {};
    one.invalid = settings.invalid;
    one.unknown = settings.unknown;
    // @ts-expect-error: matches!
    return one;
}
module.exports["zwitch"] = $cab3214b6aa77065$export$d6a12bfbbedf6185;

});

parcelRegister("3UYxt", function(module, exports) {

var $3IBnw = parcelRequire("3IBnw");


var $5ZqQS = parcelRequire("5ZqQS");


var $hBkCm = parcelRequire("hBkCm");

var $f7B1p = parcelRequire("f7B1p");

var $6fil2 = parcelRequire("6fil2");


var $7W8i8 = parcelRequire("7W8i8");

// Console diagnostics for local and dogfooding debugging. Opt in per session with
// sessionStorage.setItem('confluence.enable-logging', 'true') — silent for everyone else, and
// a no-op under NODE_ENV=testing.
//
// Never log identifiers. Not prompt content, and not contentId or agentIdentityAccountId either:
// the console is copied into tickets and screenshots, so keep it to the categorical shape of what
// happened — reason and status code. The identifiers are already visible in the network panel to
// anyone debugging a specific request.
const $ce75296042250ccb$var$logger = (0, $7W8i8.getLogger)('recordAgenticView');
// Served by conversational-ai-platform (ConfluenceAgenticViewV1Controller). Convo AI makes
// the ASAP S2S hop to Confluence's /wiki/api/v2/pages/{id}/agentic/view endpoint; the browser
// cannot call that endpoint directly.
const $ce75296042250ccb$var$AGENTIC_VIEW_URL = '/gateway/api/assist/api/confluence/v1/agentic-views';
var $ce75296042250ccb$export$3bdc8aca6e4e8d8f = /*#__PURE__*/ function(AgenticViewFailureReason) {
    /** 400 — the request violated the service contract. A bug on our side, not a service fault. */ AgenticViewFailureReason["BAD_REQUEST"] = "badRequest";
    /** 401 / 403 — the user may not record presence for this page. */ AgenticViewFailureReason["FORBIDDEN"] = "forbidden";
    /**
   * 404 — no route matched. Until CEPS-13034 adds this path to the Stargate service policy
   * allowlist, *every* call fails this way; afterwards it means the page no longer exists.
   * Expect this reason to dominate until that ticket lands.
   */ AgenticViewFailureReason["NOT_FOUND"] = "notFound";
    /** 429 — Stargate or Convo AI is shedding load. */ AgenticViewFailureReason["RATE_LIMITED"] = "rateLimited";
    /** 5xx — Convo AI or NCS is unhealthy. */ AgenticViewFailureReason["SERVER_ERROR"] = "serverError";
    /** No response at all — the user's connectivity, not a service fault. */ AgenticViewFailureReason["NETWORK"] = "network";
    /** Anything else, including a non-Error throw. */ AgenticViewFailureReason["UNKNOWN"] = "unknown";
    return AgenticViewFailureReason;
}({});
/**
 * Emits one operational event, absorbing anything it throws. Reporting is best-effort: the
 * call site voids this client's promise, so a throw while reporting would surface as an
 * unhandled rejection rather than as a report.
 */ const $ce75296042250ccb$var$fireOperationalEvent = (createAnalyticsEvent, action, attributes)=>{
    try {
        createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                action: action,
                actionSubject: 'agenticViewPresence',
                source: 'AIMate',
                tags: [
                    'aiMate'
                ],
                ...attributes && {
                    attributes: attributes
                }
            }
        }).fire();
    } catch  {
    // Intentionally swallowed — see above.
    }
};
/**
 * The status codes that have a dedicated reason, as data. 5xx is deliberately absent: it is a
 * range rather than a set of codes, so it stays a comparison in `reasonForStatusCode`.
 *
 * `Partial<Record<…>>` rather than `Record<…>` on purpose. Confluence does not enable
 * `noUncheckedIndexedAccess`, so a total `Record` would type every lookup as already resolved and
 * make the fallback below read as unreachable — when in fact it is what handles every 5xx.
 */ const $ce75296042250ccb$var$REASON_BY_STATUS_CODE = {
    400: "badRequest",
    // One reason for two codes: whether the caller is unauthenticated or merely unauthorised is not
    // a distinction worth its own failure bucket here.
    401: "forbidden",
    403: "forbidden",
    404: "notFound",
    // Reached by RateLimitedError as well as a plain BadStatusError — see `classifyFailure`.
    429: "rateLimited"
};
const $ce75296042250ccb$var$reasonForStatusCode = (statusCode)=>$ce75296042250ccb$var$REASON_BY_STATUS_CODE[statusCode] ?? (statusCode >= 500 ? "serverError" : "unknown");
const $ce75296042250ccb$var$classifyFailure = (error)=>{
    // Checked before the generic network case because BadStatusError extends NetworkError.
    // RateLimitedError extends BadStatusError and does not override `name`, so 429 lands here too.
    if ((0, $hBkCm.BadStatusError).isBadStatusError(error)) {
        const statusCode = error.response.status;
        return {
            reason: $ce75296042250ccb$var$reasonForStatusCode(statusCode),
            statusCode: statusCode
        };
    }
    if (error instanceof Error && (0, $6fil2.containsNetworkError)(error)) return {
        reason: "network"
    };
    return {
        reason: "unknown"
    };
};
const $ce75296042250ccb$export$925de989b5b3a909 = async (payload, cloudId, createAnalyticsEvent, telemetryAttributes)=>{
    // The denominator. Emitted before the request rather than after a 2xx, because a 204 cannot
    // distinguish "presence recorded" from "Convo AI's own gate is off" — an `attempted` count is
    // something this client can honestly assert, a success count is not. Paired with `failed`
    // it yields a failure rate; compared against platform's `aiMate onPromptSentInvoked` it
    // shows how many invocations this package's guards and experiment filtered out.
    $ce75296042250ccb$var$fireOperationalEvent(createAnalyticsEvent, 'attempted', telemetryAttributes);
    $ce75296042250ccb$var$logger.debug`Recording agent view presence for pageContext=${payload.pageContext}`;
    try {
        await (0, $f7B1p.cfetch)($ce75296042250ccb$var$AGENTIC_VIEW_URL, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
                'X-Product': 'confluence',
                // Not free text. Convo AI resolves this against a closed enum (`Experience.kt` in
                // conversational-ai-platform) in a request filter, before the controller deserialises
                // the body; an unregistered id throws `ExperienceIdNotFoundException`, which extends
                // `BadRequestException`, so it 400s. A descriptive
                // `confluence-agent-chat-view-presence` was rejected exactly that way.
                //
                // `ai-mate` is registered for all products and describes this surface accurately: the
                // write is a side effect of a Rovo Chat prompt. The cost is attribution — these calls
                // are indistinguishable from the rest of Rovo Chat in experience-level metrics, so the
                // `agenticViewPresence` operational events above are how this path gets measured.
                // A dedicated experience needs a conversational-ai-platform change: an `Experience`
                // entry plus a branch in `FeatureConfigServiceImpl`, whose `when` is exhaustive.
                'X-Experience-Id': 'ai-mate',
                'X-Cloudid': cloudId
            },
            body: JSON.stringify(payload),
            // Presence is a background side effect. Without this, a genuine connectivity failure
            // flips the global connection status to OFFLINE via the cfetch subscriber in
            // graphql/src/createClient.ts, showing an offline indicator for something the user
            // never initiated. Non-2xx responses take a different path and cannot do this.
            ignoreNoNetworkError: true
        });
        // Not "recorded" — the service also 204s when its own gate is off. See above.
        $ce75296042250ccb$var$logger.debug`Request accepted. A 2xx does not confirm presence was recorded: Convo AI returns 204 with CONFLUENCE_AGENTIC_VIEW_PRESENCE off too.`;
    } catch (error) {
        const { reason: reason, statusCode: statusCode } = $ce75296042250ccb$var$classifyFailure(error);
        // Mirrors the operational event exactly, and deliberately nothing more. The raw error
        // object is not logged: it carries the Response, and the full detail plus a stack trace
        // already reaches on-call through submitError below.
        $ce75296042250ccb$var$logger.error`Failed to record agent view presence: reason=${reason} statusCode=${statusCode}`;
        $ce75296042250ccb$var$fireOperationalEvent(createAnalyticsEvent, 'failed', {
            ...telemetryAttributes,
            reason: reason,
            ...statusCode !== undefined && {
                statusCode: statusCode
            }
        });
        (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).AI_MATE
        });
    }
};
module.exports["recordAgenticView"] = $ce75296042250ccb$export$925de989b5b3a909;

});

parcelRegister("80Dol", function(module, exports) {

var $55fM8 = parcelRequire("55fM8");


var $bijHC = parcelRequire("bijHC");


var $b3nqj = parcelRequire("b3nqj");


var $caelp = parcelRequire("caelp");


var $2yWJZ = parcelRequire("2yWJZ");


var $f7B1p = parcelRequire("f7B1p");


var $ge2sX = parcelRequire("ge2sX");


var $9fywD = parcelRequire("9fywD");


var $04e9M = parcelRequire("04e9M");


var $6mKj3 = parcelRequire("6mKj3");


var $5CrKL = parcelRequire("5CrKL");


var $j5rtD = parcelRequire("j5rtD");


var $gYPwD = parcelRequire("gYPwD");

const $76cb501321125a14$var$INITIAL_STATE = 'initialState';
const $76cb501321125a14$var$SEARCH = 'searchUser';
const $76cb501321125a14$var$SUCCEEDED = 'succeeded';
const $76cb501321125a14$var$FAILED = 'failed';
const $76cb501321125a14$var$CONTEXT_TYPE = 'Mentions';
/**
 * MAX_NOTIFIED_ITEMS in platform/packages/elements/mention/src/api/MentionResource.ts limits how many mentions returned by UserTeamMentionProvider will be used really! 20 is its value at the time of this writing.
 */ const $76cb501321125a14$var$MAX_RESULTS = 20;
/**
 * platform/packages/editor/editor-plugin-mentions/src/ui/type-ahead/index.tsx sections the mentions returned by UserTeamMentionProvider in agents and non-agents (such as people and teams).
 * But it also defines its own limit per section! 5 is its limit for agents at the time of this writing.
 * So to see both agents and people/non-agents in the sectioned UI, UserTeamMentionProvider needs to arrange enough of each section into the first MAX_RESULTS mentions it returns.
 */ const $76cb501321125a14$var$MIN_AGENT_RESULTS = 5;
const $76cb501321125a14$var$AGENT_LOADING_PLACEHOLDER_COUNT = 2;
const $76cb501321125a14$var$AGENT_LOADING_PLACEHOLDER_ID_PREFIX = '__confluence-agents-loading-';
const $76cb501321125a14$var$AGENT_MENTIONS_QUERY_TIMEOUT_MS = 5000;
const $76cb501321125a14$var$AGENT_MENTIONS_SEARCH_DEBOUNCE_TIME_MS = 300;
const $76cb501321125a14$var$ASYNC_AGENT_MENTIONS_REQUEST = Symbol('asyncAgentMentionsRequest');
const $76cb501321125a14$var$agentMentionsLoadErrorResult = (query)=>({
        mentions: [
            {
                appType: 'agent',
                id: (0, $caelp.AGENT_MENTION_LOAD_ERROR_ID),
                isPlaceholder: true,
                placeholderType: 'error',
                userType: 'APP'
            }
        ],
        query: query
    });
const $76cb501321125a14$var$emptyAgentMentionsResult = (query)=>({
        mentions: [],
        query: query
    });
const $76cb501321125a14$var$createAgentLoadingPlaceholders = ()=>Array.from({
        length: $76cb501321125a14$var$AGENT_LOADING_PLACEHOLDER_COUNT
    }, (_, index)=>({
            id: `${$76cb501321125a14$var$AGENT_LOADING_PLACEHOLDER_ID_PREFIX}${index}__`,
            isPlaceholder: true,
            placeholderType: 'loading',
            userType: 'APP',
            appType: 'agent'
        }));
const $76cb501321125a14$var$hasPlaceholders = (result)=>result.mentions.some((mention)=>mention.isPlaceholder);
const $76cb501321125a14$var$queryAgentMentionsWithoutTimeout = (query, maxResults, showLoadErrorOnFailure = false)=>(0, $gYPwD.queryAgentMentions)(query, maxResults).then((result)=>({
            result: result,
            successful: true,
            timedOut: false,
            timeoutApplied: false
        })).catch(()=>/* Do not let queryAgentMentions break the production-available people and teams search. */ ({
            result: showLoadErrorOnFailure ? $76cb501321125a14$var$agentMentionsLoadErrorResult(query) : $76cb501321125a14$var$emptyAgentMentionsResult(query),
            successful: false,
            timedOut: false,
            timeoutApplied: false
        }));
const $76cb501321125a14$var$queryAgentMentionsWithTimeout = async (query, maxResults, showLoadErrorOnFailure = true)=>{
    let timeoutId;
    const queryStartedAt = Date.now();
    const timeoutPromise = new Promise((resolve)=>{
        timeoutId = setTimeout(()=>{
            resolve({
                result: showLoadErrorOnFailure ? $76cb501321125a14$var$agentMentionsLoadErrorResult(query) : $76cb501321125a14$var$emptyAgentMentionsResult(query),
                successful: false,
                timedOut: true,
                timeoutApplied: true
            });
        }, $76cb501321125a14$var$AGENT_MENTIONS_QUERY_TIMEOUT_MS);
    });
    const queryPromise = $76cb501321125a14$var$queryAgentMentionsWithoutTimeout(query, maxResults, showLoadErrorOnFailure).then((result)=>({
            ...result,
            queryDurationMs: Date.now() - queryStartedAt,
            timeoutApplied: true
        }));
    const result = await Promise.race([
        queryPromise,
        timeoutPromise
    ]);
    if (timeoutId) clearTimeout(timeoutId);
    return result;
};
// Use in memory cache only
const $76cb501321125a14$var$defaultCache = {
    getStoredValues: ()=>Promise.resolve(new Map()),
    setStoredValues: ()=>Promise.resolve()
};
class $76cb501321125a14$export$f500b4849378edff extends (0, $bijHC.MentionResource) {
    async filter(query, contextIdentifier) {
        if (this.includeAgents) return this.filterWithAsyncAgentMentions(query, contextIdentifier);
        // Without agents, preserve MentionResource's existing single-emission behavior.
        return super.filter(query, contextIdentifier);
    }
    async filterWithAsyncAgentMentions(query, contextIdentifier) {
        const sequence = ++this.agentMentionsFilterSequence;
        const startedAt = Date.now();
        let markInitialResultEmitted = ()=>{};
        const initialResultEmitted = new Promise((resolve)=>{
            markInitialResultEmitted = resolve;
        });
        const asyncContextIdentifier = {
            ...contextIdentifier,
            [$76cb501321125a14$var$ASYNC_AGENT_MENTIONS_REQUEST]: {
                initialResultEmitted: initialResultEmitted,
                sequence: sequence,
                startedAt: startedAt
            }
        };
        try {
            await super.filter(query, asyncContextIdentifier);
        } finally{
            // `super.filter` notifies the first URS result before resolving. Agent
            // enrichment waits on this barrier so it can never become the first emission.
            markInitialResultEmitted();
        }
    }
    async notifyAgentMentionsWhenReady(query, ursMentions, agentMentionsQueryResultPromise, request) {
        const [agentMentionsQueryResult] = await Promise.all([
            agentMentionsQueryResultPromise,
            request.initialResultEmitted
        ]);
        if (request.sequence !== this.agentMentionsFilterSequence) return;
        const result = {
            query: query,
            mentions: this.mergeAsyncAgentMentions(agentMentionsQueryResult.result.mentions, ursMentions)
        };
        this._notifyListeners(result, {
            duration: Date.now() - request.startedAt
        });
        this._notifyAllResultsListeners(result);
        if (agentMentionsQueryResult.successful && query === '') this.offlineCache.set(this.userTeamEndpoint, result);
    }
    mergeAsyncAgentMentions(agentMentions, ursMentions) {
        if (!agentMentions.length) return ursMentions;
        // Studio agent results should win if URS ever returns the same agent ID.
        const agentMentionIds = new Set(agentMentions.map((mention)=>mention.id));
        const distinctUrsMentions = ursMentions.filter((mention)=>!agentMentionIds.has(mention.id));
        const limitedAgentMentions = agentMentions.slice(0, Math.max($76cb501321125a14$var$MIN_AGENT_RESULTS, $76cb501321125a14$var$MAX_RESULTS - distinctUrsMentions.length));
        return [
            ...limitedAgentMentions,
            ...distinctUrsMentions
        ];
    }
    debounceFilter(initialStateDebounceTime, searchDebounceTime) {
        const filter = this.filter.bind(this);
        const debouncedInitialStateFilter = (0, (/*@__PURE__*/$parcel$interopDefault($55fM8)))(filter, initialStateDebounceTime);
        const debouncedSearchFilter = (0, (/*@__PURE__*/$parcel$interopDefault($55fM8)))(filter, searchDebounceTime);
        this.filter = async (query, contextIdentifier)=>{
            if (query) {
                debouncedInitialStateFilter.cancel();
                return debouncedSearchFilter(query, contextIdentifier);
            } else {
                debouncedSearchFilter.cancel();
                return debouncedInitialStateFilter(query, contextIdentifier);
            }
        };
    }
    /**
   * Overrides `remoteInitialState` from `MentionResource`
   * This is invoked for bootstrap/empty queries,
   */ async remoteInitialState(contextIdentifier) {
        try {
            const promise = await this.doSearch('', contextIdentifier);
            // Without agents, cache the single settled result here. With agents, caching
            // happens only from notifyAgentMentionsWhenReady once both sources have succeeded.
            if (!this.includeAgents) this.offlineCache.set(this.userTeamEndpoint, promise);
            this._notifyAnalyticsListeners((0, $b3nqj.SLI_EVENT_TYPE), $76cb501321125a14$var$INITIAL_STATE, $76cb501321125a14$var$SUCCEEDED);
            return promise;
        } catch (e) {
            this._notifyAnalyticsListeners((0, $b3nqj.SLI_EVENT_TYPE), $76cb501321125a14$var$INITIAL_STATE, $76cb501321125a14$var$FAILED);
            throw e;
        }
    }
    /**
   * Overrides `remoteSearch` from `MentionResource`
   * This is invoked for non-empty queries.
   */ async remoteSearch(query, contextIdentifier) {
        try {
            const promise = await this.doSearch(query, contextIdentifier);
            this._notifyAnalyticsListeners((0, $b3nqj.SLI_EVENT_TYPE), $76cb501321125a14$var$SEARCH, $76cb501321125a14$var$SUCCEEDED);
            return promise;
        } catch (e) {
            this._notifyAnalyticsListeners((0, $b3nqj.SLI_EVENT_TYPE), $76cb501321125a14$var$SEARCH, $76cb501321125a14$var$FAILED);
            throw e;
        }
    }
    async getCachedValue(query) {
        const cachedValue = this.offlineCache.get(this.userTeamEndpoint);
        if (!cachedValue) return undefined;
        if (query === '') return Promise.resolve(cachedValue);
        else {
            // If we're offline allow basic filtering of the cached results by name.
            if (window?.navigator.onLine === false) return Promise.resolve({
                query: query,
                mentions: cachedValue.mentions?.filter((v)=>v?.name?.toLowerCase().includes(query.toLowerCase()) || v?.mentionName?.toLowerCase().includes(query.toLowerCase()) || v?.nickname?.toLowerCase().includes(query.toLowerCase()) || v?.email?.toLowerCase().includes(query.toLowerCase()) && (0, $6mKj3.expValEquals)('platform_editor_mentions_email_search', 'isEnabled', true))
            });
        }
    }
    async doSearch(query, contextIdentifier) {
        const cachedValue = await this.getCachedValue(query);
        // Use stale-while-revalidate - if the cached value exists use it first and
        // update the cache value in the background so that it's up to date when the
        // next call is made
        if (cachedValue) {
            if (query === '') this.doNetworkSearch(query, contextIdentifier).then((results)=>{
                if (!$76cb501321125a14$var$hasPlaceholders(results)) this.offlineCache.set(this.userTeamEndpoint, results);
            }).catch(()=>{
            // Pass, it's okay if the cache doesn't update
            });
            return cachedValue;
        }
        return this.doNetworkSearch(query, contextIdentifier);
    }
    async doNetworkSearch(query, contextIdentifier) {
        (0, $5CrKL.MENTIONS_QUERY_METRIC).start();
        const asyncAgentMentionsRequest = contextIdentifier?.[$76cb501321125a14$var$ASYNC_AGENT_MENTIONS_REQUEST];
        const responsePromise = (async ()=>this.post(await this.cloudId(), await this.orgId(), query, contextIdentifier))();
        const agentMentionsQueryResultPromise = this.includeAgents ? asyncAgentMentionsRequest ? $76cb501321125a14$var$queryAgentMentionsWithTimeout(query, $76cb501321125a14$var$MAX_RESULTS, (0, $6mKj3.expValEquals)('platform_editor_agent_mentions_rovo_query_timeout', 'isEnabled', true)) : (0, $6mKj3.expValEquals)('platform_editor_agent_mentions_rovo_query_timeout', 'isEnabled', true) ? $76cb501321125a14$var$queryAgentMentionsWithTimeout(query, $76cb501321125a14$var$MAX_RESULTS) : $76cb501321125a14$var$queryAgentMentionsWithoutTimeout(query, $76cb501321125a14$var$MAX_RESULTS) : undefined;
        const response = await responsePromise;
        if (!response.ok) {
            const errorBody = await response.json();
            (0, $5CrKL.MENTIONS_QUERY_METRIC).stop({
                customData: {
                    isExCoEnabled: this.includeExternalCollaborators,
                    success: false
                }
            });
            throw new Error(JSON.stringify(errorBody));
        }
        const body = await response.json();
        const mentions = body.recommendedUsers.map((recommended)=>{
            if (this.isAgent(recommended)) return this.convertToAgentMention(recommended);
            if (this.isUser(recommended)) return this.convertToUserMention(recommended);
            if (this.isTeam(recommended)) return this.convertToTeamMention(recommended);
            // Fallback to user mention for unknown types
            return this.convertToUserMention(recommended);
        });
        let jiraMentions = [];
        if (mentions.length < $76cb501321125a14$var$MAX_RESULTS && this.isEligibleXProductUserInvite && await this.isEligibleXProductUserInvite()) try {
            const jiraResponse = await this.searchXproductUsers(await this.cloudId(), await this.orgId(), query, contextIdentifier);
            if (!jiraResponse.ok) {
                const errorBody = await jiraResponse.json();
                throw new Error(JSON.stringify(errorBody));
            }
            const jiraBody = await jiraResponse.json();
            // Remove objects from jiraMentions if an object with the same id is present in mentions
            const mentionIds = new Set(mentions.map((mention)=>mention.id));
            const recommendedJiraUsers = (jiraBody.recommendedUsers || []).filter((mention)=>!mentionIds.has(mention?.id)).slice(0, $76cb501321125a14$var$MAX_RESULTS - mentions.length);
            //only evaluate the experiment cohort if there are jira mentions to show
            if (recommendedJiraUsers.length > 0 && (0, $6mKj3.expValEquals)('cc_virality_x_product_user_invite', 'cohort', 'test')) jiraMentions = recommendedJiraUsers.map((recommended)=>{
                return {
                    ...this.convertToUserMention(recommended),
                    isXProductUser: true
                };
            });
        } catch (error) {
            const client = await (0, $04e9M.getAnalyticsWebClient)();
            const errorMessages = error instanceof Error ? error.message : String(error);
            client.sendOperationalEvent({
                source: 'editor',
                action: 'errored',
                actionSubject: 'xProductUserSearch',
                attributes: {
                    error: errorMessages,
                    stack: error?.stack
                }
            });
        }
        // Return URS immediately and publish Agent Studio in a later emission.
        if (agentMentionsQueryResultPromise && asyncAgentMentionsRequest) {
            (0, $5CrKL.MENTIONS_QUERY_METRIC).stop({
                customData: {
                    isExCoEnabled: this.includeExternalCollaborators,
                    success: true
                }
            });
            this.notifyAgentMentionsWhenReady(query, [
                ...mentions,
                ...jiraMentions
            ], agentMentionsQueryResultPromise, asyncAgentMentionsRequest);
            return {
                query: query,
                // AbstractMentionResource only notifies its first 20 rows. Put placeholders
                // first so a full URS response cannot truncate the loading state.
                mentions: [
                    ...$76cb501321125a14$var$createAgentLoadingPlaceholders(),
                    ...mentions,
                    ...jiraMentions
                ]
            };
        }
        // Control: preserve the existing single-emission critical path below.
        const agentMentionsQueryResult = await agentMentionsQueryResultPromise;
        (0, $5CrKL.MENTIONS_QUERY_METRIC).stop({
            customData: {
                isExCoEnabled: this.includeExternalCollaborators,
                success: true,
                ...agentMentionsQueryResult?.timeoutApplied ? {
                    ...agentMentionsQueryResult.queryDurationMs !== undefined ? {
                        agentMentionsQueryDurationMs: agentMentionsQueryResult.queryDurationMs
                    } : {},
                    agentMentionsTimedOut: agentMentionsQueryResult?.timedOut ?? false,
                    agentMentionsTimeoutMs: $76cb501321125a14$var$AGENT_MENTIONS_QUERY_TIMEOUT_MS
                } : {}
            }
        });
        let agentMentions = agentMentionsQueryResult?.result.mentions ?? [];
        let nonAgentMentions = [
            ...mentions,
            ...jiraMentions
        ];
        if (agentMentions.length) {
            // Studio agent results should win if URS ever returns the same agent ID.
            const agentMentionIds = new Set(agentMentions.map((mention)=>mention.id));
            nonAgentMentions = nonAgentMentions.filter((mention)=>!agentMentionIds.has(mention.id));
            agentMentions = agentMentions.slice(0, Math.max($76cb501321125a14$var$MIN_AGENT_RESULTS, $76cb501321125a14$var$MAX_RESULTS - nonAgentMentions.length));
        }
        return {
            query: query,
            mentions: [
                ...agentMentions,
                ...nonAgentMentions
            ]
        };
    }
    async cloudId() {
        const { cloudId: cloudId } = await (0, $ge2sX.getSessionData)();
        return cloudId;
    }
    async orgId() {
        const { orgId: orgId } = await (0, $ge2sX.getSessionData)();
        return orgId;
    }
    async post(cloudId, orgId, query, contextIdentifier) {
        return await (0, $f7B1p.cfetch)(this.userTeamEndpoint, {
            method: 'POST',
            headers: {
                'content-type': 'application/json'
            },
            credentials: 'include',
            body: JSON.stringify({
                context: {
                    contextType: $76cb501321125a14$var$CONTEXT_TYPE,
                    principalId: 'context',
                    productKey: contextIdentifier && contextIdentifier.product || 'confluence',
                    // defaults to 'confluence' to work with old editor
                    siteId: cloudId,
                    containerId: contextIdentifier && contextIdentifier.containerId,
                    objectId: contextIdentifier && contextIdentifier.objectId,
                    childObjectId: contextIdentifier && contextIdentifier.childObjectId,
                    mentionsSessionId: contextIdentifier && contextIdentifier.sessionId,
                    ...orgId ? {
                        organizationId: orgId
                    } : {},
                    ...this.includeExternalCollaborators ? {
                        productAttributes: {
                            isEntitledConfluenceExternalCollaborator: true
                        }
                    } : {}
                },
                searchQuery: {
                    queryString: query,
                    ...query.includes('@') && (0, $6mKj3.expValEquals)('platform_editor_mentions_email_search', 'isEnabled', true) ? {
                        searchEmail: true
                    } : {},
                    ...this.includeExternalCollaborators ? {
                        productAccessPermissionIds: [
                            'write',
                            'external-collaborator-write'
                        ]
                    } : {}
                },
                maxNumberOfResults: $76cb501321125a14$var$MAX_RESULTS,
                includeTeams: true
            })
        });
    }
    async searchXproductUsers(cloudId, orgId, query, contextIdentifier) {
        return await (0, $f7B1p.cfetch)(this.userTeamEndpoint, {
            method: 'POST',
            headers: {
                'content-type': 'application/json'
            },
            credentials: 'include',
            body: JSON.stringify({
                context: {
                    contextType: $76cb501321125a14$var$CONTEXT_TYPE,
                    principalId: 'context',
                    productKey: 'jira',
                    // fetch only jira users
                    siteId: cloudId,
                    mentionsSessionId: contextIdentifier && contextIdentifier.sessionId,
                    ...orgId ? {
                        organizationId: orgId
                    } : {}
                },
                searchQuery: {
                    queryString: query,
                    ...query.includes('@') && (0, $6mKj3.expValEquals)('platform_editor_mentions_email_search', 'isEnabled', true) ? {
                        searchEmail: true
                    } : {},
                    productAccessPermissionIds: [
                        'write'
                    ]
                },
                maxNumberOfResults: $76cb501321125a14$var$MAX_RESULTS,
                includeTeams: false // Do not include teams
            })
        });
    }
    isAgent(recommended) {
        // Agents are returned as USER entity type with appType 'agent'
        return recommended.entityType === 'USER' && recommended.appType === 'agent';
    }
    convertToAgentMention(recommended) {
        return {
            id: recommended.id,
            name: recommended.name || recommended.nickname || '',
            mentionName: recommended.nickname || '',
            avatarUrl: recommended.avatarUrl,
            accessLevel: recommended.accessLevel,
            userType: 'APP',
            // Mark as app/agent type
            appType: 'agent'
        };
    }
    isUser(recommended) {
        // Regular users have entityType USER but no agent appType
        return recommended.entityType === 'USER' && recommended.appType !== 'agent';
    }
    convertToUserMention(recommended) {
        return {
            id: recommended.id,
            ...(0, $6mKj3.expValEquals)('platform_editor_mentions_email_search', 'isEnabled', true) ? {
                email: recommended.email
            } : {},
            name: recommended.name || recommended.nickname || '',
            mentionName: recommended.nickname || '',
            avatarUrl: recommended.avatarUrl,
            accessLevel: recommended.accessLevel,
            userType: recommended.userType,
            ...recommended?.attributes?.isConfluenceExternalCollaborator ? {
                lozenge: (0, $9fywD.ExternalUserLozengeProps)
            } : {}
        };
    }
    isTeam(recommended) {
        return recommended.entityType === 'TEAM';
    }
    convertToTeamMention(recommended) {
        const { teamLinkResolver: teamLinkResolver } = this.teamMentionConfig;
        let teamLink = '';
        const defaultTeamLink = `${window.location.origin}/people/team/${recommended.id}`;
        if (typeof teamLinkResolver === 'function') teamLink = teamLinkResolver(recommended.id);
        return {
            id: recommended.id,
            name: recommended.displayName,
            mentionName: recommended.displayName,
            avatarUrl: recommended.smallAvatarImageUrl,
            accessLevel: (0, $caelp.UserAccessLevel)[(0, $caelp.UserAccessLevel).CONTAINER],
            userType: (0, $caelp.UserType)[(0, $caelp.UserType).TEAM],
            context: {
                members: recommended.members,
                includesYou: recommended.includesYou,
                memberCount: recommended.memberCount,
                teamLink: teamLink || defaultTeamLink
            }
        };
    }
    constructor(userTeamEndpoint, userMentionConfig, teamMentionConfig, includeExternalCollaborators, isEligibleXProductUserInvite, includeAgents = false, rovoChatAgentIdentityAccountId){
        // To scale up agent search, use longer debounce time:
        let superDebounceTime = userMentionConfig.debounceTime ?? 0;
        let initialStateDebounceTime = 0;
        let searchDebounceTime = 0;
        if (includeAgents) {
            initialStateDebounceTime = superDebounceTime;
            searchDebounceTime = Math.max($76cb501321125a14$var$AGENT_MENTIONS_SEARCH_DEBOUNCE_TIME_MS, superDebounceTime);
            if (searchDebounceTime > superDebounceTime) superDebounceTime = 0; // UserTeamMentionProvider's debounceFilter rather than the super will do the debouncing
        }
        super({
            ...userMentionConfig,
            debounceTime: superDebounceTime
        });
        this.userTeamEndpoint = void 0;
        this.teamMentionConfig = void 0;
        this.includeExternalCollaborators = void 0;
        this.includeAgents = void 0;
        this.offlineCache = void 0;
        this.isEligibleXProductUserInvite = void 0;
        this.agentMentionsFilterSequence = 0;
        this.rovoChatAgentIdentityAccountId = void 0;
        this.getRovoChatAgentIdentityAccountId = async ()=>(0, $2yWJZ.normalizeAccountIdFromIdentityAri)(this.rovoChatAgentIdentityAccountId ? await this.rovoChatAgentIdentityAccountId : undefined);
        this.rovoChatAgentIdentityAccountId = rovoChatAgentIdentityAccountId;
        if (!superDebounceTime && (initialStateDebounceTime || searchDebounceTime)) this.debounceFilter(initialStateDebounceTime, searchDebounceTime);
        this.teamMentionConfig = teamMentionConfig;
        this.userTeamEndpoint = userTeamEndpoint;
        this.includeExternalCollaborators = includeExternalCollaborators;
        this.includeAgents = includeAgents;
        this.isEligibleXProductUserInvite = isEligibleXProductUserInvite;
        this.offlineCache = new (0, $j5rtD.OfflineCache)($76cb501321125a14$var$defaultCache);
    }
}
module.exports["UserTeamMentionProvider"] = $76cb501321125a14$export$f500b4849378edff;

});

parcelRegister("5CrKL", function(module, exports) {

var $lSOAM = parcelRequire("lSOAM");


var $fd6g2 = parcelRequire("fd6g2");

const $41760797bb45431a$export$59eae628ebf25df4 = (0, $lSOAM.createCustomMetric)({
    key: (0, $fd6g2.MENTIONS_QUERY_CUSTOM_KEY)
});
module.exports["MENTIONS_QUERY_METRIC"] = $41760797bb45431a$export$59eae628ebf25df4;

});

parcelRegister("j5rtD", function(module, exports) {

var $cbY7C = parcelRequire("cbY7C");


var $8UEfo = parcelRequire("8UEfo");

class $099b8337f3ad112c$export$8904fcd398c673fb {
    update() {
        this.storageManager.setStoredValues(this.map).catch(()=>{
        // Pass, it's okay if this fails
        });
    }
    destroy() {
        this.unloadCleanup();
    }
    get(key) {
        return this.map.get(key);
    }
    set(key, value) {
        this.map.set(key, value);
    }
    constructor(storageManager){
        this.map = new Map();
        this.storageManager = void 0;
        this.unloadCleanup = ()=>{};
        const cacheName = 'editor:offline-network-request-cache';
        this.storageManager = storageManager ?? new $099b8337f3ad112c$var$IndexedDBManager(cacheName);
        this.storageManager.getStoredValues()?.then((v)=>{
            this.map = v;
        }).catch(()=>{
        // If the offline cache is rejected, use the initial empty map
        });
        if (window !== undefined) this.unloadCleanup = (0, $cbY7C.bind)(window, {
            type: 'beforeunload',
            listener: ()=>{
                this.update();
            }
        });
    }
}
/** Storage manager using indexeddb */ class $099b8337f3ad112c$var$IndexedDBManager {
    openDatabase() {
        return new Promise((resolve, reject)=>{
            const request = (0, $8UEfo.atlIndexedDb).open(this.cacheName, 2);
            request.onupgradeneeded = (event)=>{
                const db = event.target.result;
                // Clear old results
                if (db.objectStoreNames.contains(this.objectStoreName)) db.deleteObjectStore(this.objectStoreName);
                db.createObjectStore(this.objectStoreName);
            };
            request.onsuccess = ()=>{
                resolve(request.result);
            };
            request.onerror = ()=>{
                reject(request.error);
            };
            request.addEventListener('storageItemBlocked', ()=>{
                reject(new Error('IndexedDB open blocked by consent settings'));
            });
        });
    }
    // Retrieve a map of values for a store based on a set of keys
    async getAllStoredValues(store, keys) {
        const allValues = [];
        for (const key of keys){
            const valueRequest = store.get(key);
            allValues.push(new Promise((resolve, reject)=>{
                valueRequest.onsuccess = ()=>resolve([
                        key,
                        JSON.parse(valueRequest.result)
                    ]);
                valueRequest.onerror = ()=>reject(valueRequest.error);
            }));
        }
        return new Map(await Promise.all(allValues));
    }
    getStoredValues() {
        return this.dbPromise?.then((db)=>{
            return new Promise((resolve, reject)=>{
                const transaction = db.transaction(this.objectStoreName, 'readonly');
                const store = transaction.objectStore(this.objectStoreName);
                const request = store.getAllKeys();
                request.onsuccess = async ()=>{
                    const keys = request.result;
                    const resultMap = await this.getAllStoredValues(store, keys);
                    resolve(resultMap);
                };
                request.onerror = ()=>{
                    reject(request.error);
                };
            });
        }) ?? Promise.reject();
    }
    setStoredValues(values) {
        return this.dbPromise?.then((db)=>{
            return new Promise((resolve, reject)=>{
                const transaction = db.transaction(this.objectStoreName, 'readwrite');
                const store = transaction.objectStore(this.objectStoreName);
                transaction.oncomplete = ()=>resolve();
                transaction.onerror = ()=>reject(transaction.error);
                if (values.size === 0) return;
                // Clear the existing entries before setting new values
                store.clear().onsuccess = ()=>{
                    values.forEach((value, key)=>{
                        const serialisedValue = $099b8337f3ad112c$export$ad730aacbc246ec2(value);
                        if (serialisedValue !== null) store.put(serialisedValue, key);
                    });
                };
            });
        }) ?? Promise.reject();
    }
    constructor(cacheName){
        this.cacheName = cacheName;
        this.dbPromise = undefined;
        this.objectStoreName = 'cache';
        // oxlint-disable-next-line no-restricted-properties -- Feature detection only; database access uses AtlIndexedDb.
        if (window?.indexedDB) this.dbPromise = this.openDatabase();
    }
}
function $099b8337f3ad112c$export$ad730aacbc246ec2(obj) {
    try {
        return JSON.stringify(obj, (_key, value)=>{
            if (typeof value !== 'string' && typeof value !== 'number' && typeof value !== 'boolean' && value !== null && value !== undefined && typeof value !== 'object' && !Array.isArray(value)) throw new Error('Non-serializable property found');
            return value;
        });
    } catch (error) {
        return null;
    }
}
module.exports["OfflineCache"] = $099b8337f3ad112c$export$8904fcd398c673fb;

});

parcelRegister("8UEfo", function(module, exports) {

var $3uUvc = parcelRequire("3uUvc");

var $9Y4TN = parcelRequire("9Y4TN");


var $aQZKS = parcelRequire("aQZKS");


var $8Qsoy = parcelRequire("8Qsoy");


var $TTB05 = parcelRequire("TTB05");


var $6lwsv = parcelRequire("6lwsv");


var $6FMPw = parcelRequire("6FMPw");


var $go83j = parcelRequire("go83j");

const $f7505c04a5df485b$export$4702e9fd6e5f70a8 = async (dbName)=>{
    const availability = (0, $go83j.checkDBAvailability)();
    if (availability.bypassImplementation) // Fallback to allowing if it bypassed for any reason (support disabled, killswitch, etc)
    return true;
    let isAllowed;
    let resolvedItemCategory;
    ({ isAllowed: isAllowed, itemCategory: resolvedItemCategory } = await (0, $aQZKS.isProcessingAllowedByPreferencesWithCategory)({
        itemKey: dbName,
        storageType: (0, $TTB05.CategoryStorageType).IndexedDB
    }));
    const categoryAttribute = resolvedItemCategory !== undefined ? {
        itemCategory: resolvedItemCategory ?? (0, $TTB05.PreferenceCategory).Unknown
    } : {};
    (0, $9Y4TN.sendPackageOperationalEvent)({
        action: 'usedAtlIndexedDBOpen',
        attributes: {
            databaseName: dbName,
            wasRejected: !isAllowed,
            ...categoryAttribute
        }
    });
    return isAllowed;
};
/**
 * AtlIndexedDb is a wrapper around the IDBFactory interface that provides
 * additional checks before opening the database, such as:
 * - SSR environment detection
 * - Feature flag checks
 * - Input validation
 * - Error logging
 *
 * When bypass mode is active, this wrapper skips special validation and delegates
 * directly to the configured IDBFactory, allowing the application to fall back to default
 * browser behavior.
 *
 * This class implements the IDBFactory interface and delegates all methods to the wrapped
 * IDBFactory instance.
 */ class $f7505c04a5df485b$export$f623e6c5a836bb02 {
    getIsAvailable() {
        return this.isAvailable;
    }
    getIsBypassingImplementation() {
        return this.bypassImplementation;
    }
    /**
   * Opens a database connection with additional validation and checks
   * @param dbName - The name of the database to open
   * @param version - Optional version number for the database
   * @returns An IDBOpenDBRequest (use with event handlers or wrap in Promise for async/await)
   * @throws Error if database name is invalid, IndexedDB is not available (unless bypass mode is active), or the wrapped IDBFactory throws an error
   *
   * When bypass mode is active, validation is skipped and the wrapped IDBFactory is used directly.
   */ open(dbName, version) {
        (0, $8Qsoy.Logger).debug(`IndexedDB operation: open on database \"${dbName}\"`, {
            version: String(version ?? 'unspecified')
        });
        if (!(0, $3uUvc.getBscGlobalState)().hasInitialized) (0, $9Y4TN.sendPackageOperationalEvent)({
            action: 'setItemWithoutInit',
            attributes: {
                itemKey: dbName,
                storageType: 'IndexedDB'
            }
        });
        // If bypass mode is active, skip implementation and use wrapped IDBFactory directly
        if (this.bypassImplementation) return this.config.idbFactory.open(dbName, version);
        if (!(0, $go83j.isValidDBName)(dbName)) {
            const error = new Error('Invalid database name: must be a non-empty string');
            (0, $8Qsoy.Logger).errorWithOperationalEvent({
                action: 'usedAtlIndexedDBOpenError',
                attributes: {
                    databaseName: dbName
                },
                message: `IndexedDB open failed: ${error.message}`
            });
            throw error;
        }
        if (!(0, $go83j.isValidVersion)(version)) {
            const error = new Error('Invalid version: must be a positive integer or undefined');
            (0, $8Qsoy.Logger).errorWithOperationalEvent({
                action: 'usedAtlIndexedDBOpenError',
                attributes: {
                    databaseName: dbName
                },
                message: `IndexedDB open failed: ${error.message}`
            });
            throw error;
        }
        const availabilityCheck = (0, $go83j.checkDBAvailability)(this.config.enableSSRCheck, this.config.enableFeatureFlagCheck);
        if (!availabilityCheck.available) {
            if (this.config.noOpWhenUnavailable) // In some runtimes (SSR/service worker), consumers still want to import a shared
            // instance without having to guard every call.
            return (0, $6FMPw.createIDBOpenDBRequestWrapper)();
            const error = new Error(`Cannot open database: ${availabilityCheck.reason || 'IndexedDB is not available'}`);
            (0, $8Qsoy.Logger).errorWithOperationalEvent({
                action: 'usedAtlIndexedDBOpenError',
                attributes: {
                    databaseName: dbName
                },
                message: `IndexedDB open failed: ${error.message}`
            });
            throw error;
        }
        const requestWrapper = (0, $6FMPw.createIDBOpenDBRequestWrapper)();
        const globalState = (0, $3uUvc.getBscGlobalState)();
        const productName = globalState.product;
        const disableIndexedDbConsentChecks = globalState.disableIndexedDbConsentChecks ?? false;
        if (disableIndexedDbConsentChecks) {
            (0, $aQZKS.getItemCategory)(dbName, (0, $TTB05.CategoryStorageType).IndexedDB, productName).then((itemCategory)=>{
                (0, $9Y4TN.sendPackageOperationalEvent)({
                    action: 'usedAtlIndexedDBOpen',
                    attributes: {
                        databaseName: dbName,
                        wasRejected: false,
                        consentChecksDisabled: true,
                        itemCategory: itemCategory ?? (0, $TTB05.PreferenceCategory).Unknown
                    }
                });
            }).catch((e)=>{
                const errorMessage = e instanceof Error ? e.message : String(e);
                (0, $8Qsoy.Logger).errorWithOperationalEvent({
                    action: 'usedAtlIndexedDBOpenError',
                    attributes: {
                        databaseName: dbName
                    },
                    message: `IndexedDB open failed: ${errorMessage}`
                });
            });
            (0, $6lwsv.ItemKeyCache).markSetByPackage((0, $TTB05.CategoryStorageType).IndexedDB, dbName);
            const actualRequest = this.config.idbFactory.open(dbName, version);
            requestWrapper.wrapRequest(actualRequest);
            return requestWrapper;
        }
        (0, $aQZKS.isProcessingAllowedByPreferencesWithCategory)({
            itemKey: dbName,
            storageType: (0, $TTB05.CategoryStorageType).IndexedDB,
            productName: productName
        }).then(({ isAllowed: isAllowed, itemCategory: itemCategory })=>{
            const categoryAttribute = {
                itemCategory: itemCategory ?? (0, $TTB05.PreferenceCategory).Unknown
            };
            if (isAllowed) {
                (0, $6lwsv.ItemKeyCache).markSetByPackage((0, $TTB05.CategoryStorageType).IndexedDB, dbName);
                (0, $9Y4TN.sendPackageOperationalEvent)({
                    action: 'usedAtlIndexedDBOpen',
                    attributes: {
                        databaseName: dbName,
                        wasRejected: false,
                        ...categoryAttribute
                    }
                });
                const actualRequest = this.config.idbFactory.open(dbName, version);
                // Wrap the actual request to forward all events
                requestWrapper.wrapRequest(actualRequest);
            } else {
                (0, $9Y4TN.sendPackageOperationalEvent)({
                    action: 'usedAtlIndexedDBOpen',
                    attributes: {
                        databaseName: dbName,
                        wasRejected: true,
                        ...categoryAttribute
                    }
                });
                if (itemCategory === null) (0, $8Qsoy.Logger).warn(`indexedDB.open('${dbName}') was blocked` + `${productName ? ` for product "${productName}"` : ''}` + `: '${dbName}' is not registered in the BSC data store. Add it to the data store before calling this API.`);
                const blockedEvent = new Event('storageItemBlocked');
                requestWrapper.dispatchEvent(blockedEvent);
            }
        }).catch((e)=>{
            const errorMessage = e instanceof Error ? e.message : String(e);
            (0, $8Qsoy.Logger).errorWithOperationalEvent({
                action: 'usedAtlIndexedDBOpenError',
                attributes: {
                    databaseName: dbName
                },
                message: `IndexedDB open failed during preference check: ${errorMessage}`
            });
            const errorEvent = new ErrorEvent('error', {
                message: errorMessage
            });
            requestWrapper.dispatchEvent(errorEvent);
        });
        return requestWrapper;
    }
    /**
   * Opens a database connection without checking user consent preferences.
   * This method should ONLY be used for strictly necessary databases that are critical
   * for application functionality and do not require user consent.
   *
   * @param dbName - The name of the database to open
   * @param version - Optional version number for the database
   * @returns An IDBOpenDBRequest
   * @throws Error if database name is invalid, IndexedDB is not available, or the wrapped IDBFactory throws an error
   *
   * This method performs validation and availability checks but bypasses consent enforcement.
   */ openStrictlyNecessary(dbName, version) {
        (0, $8Qsoy.Logger).debug(`IndexedDB operation: openStrictlyNecessary on database \"${dbName}\"`, {
            version: String(version ?? 'unspecified')
        });
        if (!(0, $3uUvc.getBscGlobalState)().hasInitialized) (0, $9Y4TN.sendPackageOperationalEvent)({
            action: 'setItemWithoutInit',
            attributes: {
                itemKey: dbName,
                storageType: 'IndexedDB'
            }
        });
        if (!(0, $go83j.isValidDBName)(dbName)) {
            const error = new Error('Invalid database name: must be a non-empty string');
            (0, $8Qsoy.Logger).errorWithOperationalEvent({
                action: 'usedAtlIndexedDBOpenStrictlyNecessaryError',
                attributes: {
                    databaseName: dbName
                },
                message: `IndexedDB openStrictlyNecessary failed: ${error.message}`
            });
            throw error;
        }
        if (!(0, $go83j.isValidVersion)(version)) {
            const error = new Error('Invalid version: must be a positive integer or undefined');
            (0, $8Qsoy.Logger).errorWithOperationalEvent({
                action: 'usedAtlIndexedDBOpenStrictlyNecessaryError',
                attributes: {
                    databaseName: dbName
                },
                message: `IndexedDB openStrictlyNecessary failed: ${error.message}`
            });
            throw error;
        }
        const availabilityCheck = (0, $go83j.checkDBAvailability)(this.config.enableSSRCheck, this.config.enableFeatureFlagCheck);
        if (!availabilityCheck.available) {
            if (this.config.noOpWhenUnavailable) return (0, $6FMPw.createIDBOpenDBRequestWrapper)();
            const error = new Error(`Cannot open database: ${availabilityCheck.reason || 'IndexedDB is not available'}`);
            (0, $8Qsoy.Logger).errorWithOperationalEvent({
                action: 'usedAtlIndexedDBOpenStrictlyNecessaryError',
                attributes: {
                    databaseName: dbName
                },
                message: `IndexedDB openStrictlyNecessary failed: ${error.message}`
            });
            throw error;
        }
        try {
            (0, $9Y4TN.sendPackageOperationalEvent)({
                action: 'usedAtlIndexedDBOpenStrictlyNecessary',
                attributes: {
                    databaseName: dbName
                }
            });
        } catch (e) {
            // Don't fail the operation if event sending fails
            const errorMessage = e instanceof Error ? e.message : String(e);
            (0, $8Qsoy.Logger).warn(`Failed to send operational event for openStrictlyNecessary: ${errorMessage}`);
        }
        return this.config.idbFactory.open(dbName, version);
    }
    /**
   * Deletes a database by delegating directly to the wrapped IDBFactory instance.
   * @param dbName - The name of the database to delete
   * @returns An IDBOpenDBRequest
   */ deleteDatabase(dbName) {
        if (!this.getIsAvailable() && this.config.noOpWhenUnavailable) return (0, $6FMPw.createIDBOpenDBRequestWrapper)();
        return this.config.idbFactory.deleteDatabase(dbName);
    }
    /**
   * Gets a list of available databases by delegating directly to the wrapped IDBFactory instance.
   * @returns A promise that resolves to a list of database info objects
   */ async databases() {
        if (this.config.idbFactory.databases && typeof this.config.idbFactory.databases === 'function') return await this.config.idbFactory.databases();
        return [];
    }
    /**
   * Compares two values for use as IndexedDB keys by delegating to the wrapped IDBFactory instance.
   * @param first - The first value to compare
   * @param second - The second value to compare
   * @returns A negative, zero, or positive value depending on the comparison result
   */ cmp(first, second) {
        return this.config.idbFactory.cmp(first, second);
    }
    constructor(config){
        this.config = void 0;
        this.isAvailable = void 0;
        this.bypassImplementation = void 0;
        this.config = {
            enableSSRCheck: config?.enableSSRCheck ?? true,
            enableFeatureFlagCheck: config?.enableFeatureFlagCheck ?? true,
            noOpWhenUnavailable: config?.noOpWhenUnavailable ?? false,
            idbFactory: config?.idbFactory ?? globalThis.indexedDB
        };
        // Perform initial availability check
        const availabilityCheck = (0, $go83j.checkDBAvailability)(this.config.enableSSRCheck, this.config.enableFeatureFlagCheck);
        this.isAvailable = availabilityCheck.available;
        this.bypassImplementation = availabilityCheck.bypassImplementation ?? false;
        if (!this.isAvailable) {
            if (this.config.noOpWhenUnavailable) (0, $8Qsoy.Logger).debug(`AtlIndexedDb unavailable (no-op mode): ${availabilityCheck.reason}`);
            else (0, $8Qsoy.Logger).warn(`AtlIndexedDb initialization warning: ${availabilityCheck.reason}`);
        } else if (this.bypassImplementation) (0, $8Qsoy.Logger).debug(`AtlIndexedDb bypassing implementation: ${availabilityCheck.reason}`);
    }
}
const $f7505c04a5df485b$export$e65012c747534318 = new $f7505c04a5df485b$export$f623e6c5a836bb02({
    noOpWhenUnavailable: true
});
module.exports["atlIndexedDb"] = $f7505c04a5df485b$export$e65012c747534318;

});

parcelRegister("gYPwD", function(module, exports) {

var $gNfbp = parcelRequire("gNfbp");


var $eKwxR = parcelRequire("eKwxR");


var $kCDdC = parcelRequire("kCDdC");


var $2khPJ = parcelRequire("2khPJ");


var $c0rhi = parcelRequire("c0rhi");


var $3IBnw = parcelRequire("3IBnw");


var $6mKj3 = parcelRequire("6mKj3");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $ge2sX = parcelRequire("ge2sX");

const $5016900c96a66750$var$PRODUCT = 'confluence';
const $5016900c96a66750$var$ROVO_CHAT_CREATOR_TYPE = 'ROVO_CHAT';
async function $5016900c96a66750$export$edde3720d795ca12(query, maxResults) {
    let mentions;
    try {
        mentions = query ? await $5016900c96a66750$var$queryAgentMentionsByName(query, maxResults) : await $5016900c96a66750$var$queryAgentMentionsForInitialState(maxResults);
    } catch (error) {
        (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).COMMENTS
        });
        (0, $7Sm4c.markErrorAsHandled)(error);
        throw error;
    }
    return {
        query: query,
        mentions: mentions
    };
}
async function $5016900c96a66750$var$queryAgentMentionsByName(query, maxResults) {
    const { cloudId: cloudId } = await (0, $ge2sX.getSessionData)();
    const { data: data, error: error } = await (0, $c0rhi.queryInterop)({
        query: $5016900c96a66750$var$queryAgentMentionsByNameQuery,
        context: {
            fetchOptions: {
                ignoreNoNetworkError: true
            }
        },
        variables: {
            cloudId: cloudId,
            first: maxResults,
            input: {
                name: query,
                includeRovoChatAgent: (0, $6mKj3.isExperimentEnabled)('platform_editor_mention_rovo')
            },
            product: $5016900c96a66750$var$PRODUCT
        },
        interopApolloAggClient: true,
        __callerPackage__: "fabric-media-support"
    });
    if (error) throw error;
    return $5016900c96a66750$var$convertToMentions(data?.agentStudio_getAgents?.edges);
}
async function $5016900c96a66750$var$queryAgentMentionsForInitialState(maxResults) {
    const { cloudId: cloudId } = await (0, $ge2sX.getSessionData)();
    const { data: data, error: error } = await (0, $c0rhi.queryInterop)({
        query: $5016900c96a66750$var$queryAgentMentionsForInitialStateQuery,
        context: {
            fetchOptions: {
                ignoreNoNetworkError: true
            }
        },
        variables: {
            cloudId: cloudId,
            first: maxResults,
            includeMyAgents: true,
            includeRovoChatAgent: (0, $6mKj3.isExperimentEnabled)('platform_editor_mention_rovo'),
            product: $5016900c96a66750$var$PRODUCT,
            creatorTypes: (0, $6mKj3.isExperimentEnabled)('platform_editor_mention_rovo') ? [
                $5016900c96a66750$var$ROVO_CHAT_CREATOR_TYPE
            ] : null
        },
        interopApolloAggClient: true,
        __callerPackage__: "fabric-media-support"
    });
    if (error) throw error;
    const mentions = $5016900c96a66750$var$convertToMentions([
        ...data?.rovoChatAgents?.edges ?? [],
        ...data?.favoriteAgents?.edges ?? [],
        ...data?.myAgents?.edges ?? [],
        ...data?.verifiedAgents?.edges ?? [],
        ...data?.allAgents?.edges ?? []
    ]);
    // Only return the first distinct maxResults:
    const returnedMentionIds = new Set();
    return mentions.filter((mention)=>{
        if (returnedMentionIds.size >= maxResults || returnedMentionIds.has(mention.id)) return false;
        returnedMentionIds.add(mention.id);
        return true;
    });
}
function $5016900c96a66750$var$convertToMentions(edges) {
    const agents = edges?.map((edge)=>edge.node).filter((agent)=>Boolean(agent?.identityAccountId && agent?.name)) ?? [];
    const orderedAgents = (0, $6mKj3.isExperimentEnabled)('platform_editor_mention_rovo') ? [
        ...agents.filter((agent)=>agent.creatorType === $5016900c96a66750$var$ROVO_CHAT_CREATOR_TYPE),
        ...agents.filter((agent)=>agent.creatorType !== $5016900c96a66750$var$ROVO_CHAT_CREATOR_TYPE)
    ] : agents;
    return orderedAgents.map($5016900c96a66750$var$convertToMentionDescription);
}
function $5016900c96a66750$var$convertToMentionDescription(agent) {
    return {
        appType: 'agent',
        avatarUrl: agent.identityAccount?.picture || undefined,
        description: agent.description || undefined,
        id: $5016900c96a66750$export$8cac12d91c2ad785(agent.identityAccountId),
        mentionName: agent.name,
        name: agent.name,
        userType: 'APP'
    };
}
function $5016900c96a66750$export$8cac12d91c2ad785(identityAccountId) {
    try {
        return (0, $2khPJ.IdentityUserAri).parse(identityAccountId).userId;
    } catch  {
        return identityAccountId;
    }
}
const $5016900c96a66750$export$ee0ef79a58e4aab4 = (0, $kCDdC.default);
const $5016900c96a66750$var$queryAgentMentionsByNameQuery = (0, $eKwxR.default);
const $5016900c96a66750$var$queryAgentMentionsForInitialStateQuery = (0, $gNfbp.default);
module.exports["queryAgentMentions"] = $5016900c96a66750$export$edde3720d795ca12;

});

parcelRegister("gNfbp", function(module, exports) {
/**
 * @generated SignedSource<<664f33157b0348f4d543ab06c4b8b42a>>
 * @relayHash d5a8635588991f154c1e7912f7284204
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 74657f4e43888ea31ee636aa6bebf881cc1e1a909af0f040209d3f269c524b11
const $23b05ae499fb93a6$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "creatorTypes"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeMyAgents"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeRovoChatAgent"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "product"
    }, v6 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v7 = {
        "kind": "Variable",
        "name": "product",
        "variableName": "product"
    }, v8 = [
        v6 /*: any*/ ,
        {
            "kind": "Literal",
            "name": "first",
            "value": 1
        },
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "creatorTypes",
                    "variableName": "creatorTypes"
                }
            ],
            "kind": "ObjectValue",
            "name": "input"
        },
        v7 /*: any*/ 
    ], v9 = {
        "kind": "ScalarField",
        "name": "id"
    }, v10 = {
        "kind": "ScalarField",
        "name": "creatorType"
    }, v11 = {
        "kind": "ScalarField",
        "name": "description"
    }, v12 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v13 = {
        "kind": "ScalarField",
        "name": "identityAccountId"
    }, v14 = {
        "kind": "ScalarField",
        "name": "name"
    }, v15 = [
        {
            "concreteType": "AgentStudioAgentEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "concreteType": "AgentStudioAssistant",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v9 /*: any*/ ,
                        v10 /*: any*/ ,
                        v11 /*: any*/ ,
                        {
                            "kind": "LinkedField",
                            "name": "identityAccount",
                            "plural": false,
                            "selections": [
                                v12 /*: any*/ 
                            ]
                        },
                        v13 /*: any*/ ,
                        v14 /*: any*/ 
                    ]
                }
            ]
        }
    ], v16 = {
        "kind": "Variable",
        "name": "first",
        "variableName": "first"
    }, v17 = {
        "kind": "Variable",
        "name": "includeRovoChatAgent",
        "variableName": "includeRovoChatAgent"
    }, v18 = [
        v6 /*: any*/ ,
        v16 /*: any*/ ,
        {
            "fields": [
                v17 /*: any*/ ,
                {
                    "kind": "Literal",
                    "name": "onlyFavouriteAgents",
                    "value": true
                }
            ],
            "kind": "ObjectValue",
            "name": "input"
        },
        v7 /*: any*/ 
    ], v19 = [
        v6 /*: any*/ ,
        v16 /*: any*/ ,
        {
            "fields": [
                v17 /*: any*/ ,
                {
                    "kind": "Literal",
                    "name": "onlyMyAgents",
                    "value": true
                }
            ],
            "kind": "ObjectValue",
            "name": "input"
        },
        v7 /*: any*/ 
    ], v20 = [
        v6 /*: any*/ ,
        v16 /*: any*/ ,
        {
            "fields": [
                v17 /*: any*/ ,
                {
                    "kind": "Literal",
                    "name": "onlyVerifiedAgents",
                    "value": true
                }
            ],
            "kind": "ObjectValue",
            "name": "input"
        },
        v7 /*: any*/ 
    ], v21 = [
        v6 /*: any*/ ,
        v16 /*: any*/ ,
        {
            "fields": [
                v17 /*: any*/ 
            ],
            "kind": "ObjectValue",
            "name": "input"
        },
        v7 /*: any*/ 
    ], v22 = [
        {
            "concreteType": "AgentStudioAgentEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "concreteType": "AgentStudioAssistant",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v9 /*: any*/ ,
                        v10 /*: any*/ ,
                        v11 /*: any*/ ,
                        {
                            "kind": "LinkedField",
                            "name": "identityAccount",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                },
                                v12 /*: any*/ ,
                                v9 /*: any*/ 
                            ]
                        },
                        v13 /*: any*/ ,
                        v14 /*: any*/ 
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "queryAgentMentionsForInitialStateQuery",
            "selections": [
                {
                    "condition": "includeRovoChatAgent",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "alias": "rovoChatAgents",
                            "args": v8 /*: any*/ ,
                            "concreteType": "AgentStudioAgentsConnection",
                            "kind": "LinkedField",
                            "name": "agentStudio_getAgents",
                            "plural": false,
                            "selections": v15 /*: any*/ 
                        }
                    ]
                },
                {
                    "alias": "favoriteAgents",
                    "args": v18 /*: any*/ ,
                    "concreteType": "AgentStudioAgentsConnection",
                    "kind": "LinkedField",
                    "name": "agentStudio_getAgents",
                    "plural": false,
                    "selections": v15 /*: any*/ 
                },
                {
                    "condition": "includeMyAgents",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "alias": "myAgents",
                            "args": v19 /*: any*/ ,
                            "concreteType": "AgentStudioAgentsConnection",
                            "kind": "LinkedField",
                            "name": "agentStudio_getAgents",
                            "plural": false,
                            "selections": v15 /*: any*/ 
                        }
                    ]
                },
                {
                    "alias": "verifiedAgents",
                    "args": v20 /*: any*/ ,
                    "concreteType": "AgentStudioAgentsConnection",
                    "kind": "LinkedField",
                    "name": "agentStudio_getAgents",
                    "plural": false,
                    "selections": v15 /*: any*/ 
                },
                {
                    "alias": "allAgents",
                    "args": v21 /*: any*/ ,
                    "concreteType": "AgentStudioAgentsConnection",
                    "kind": "LinkedField",
                    "name": "agentStudio_getAgents",
                    "plural": false,
                    "selections": v15 /*: any*/ 
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "queryAgentMentionsForInitialStateQuery",
            "selections": [
                {
                    "condition": "includeRovoChatAgent",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "alias": "rovoChatAgents",
                            "args": v8 /*: any*/ ,
                            "concreteType": "AgentStudioAgentsConnection",
                            "kind": "LinkedField",
                            "name": "agentStudio_getAgents",
                            "plural": false,
                            "selections": v22 /*: any*/ 
                        }
                    ]
                },
                {
                    "alias": "favoriteAgents",
                    "args": v18 /*: any*/ ,
                    "concreteType": "AgentStudioAgentsConnection",
                    "kind": "LinkedField",
                    "name": "agentStudio_getAgents",
                    "plural": false,
                    "selections": v22 /*: any*/ 
                },
                {
                    "condition": "includeMyAgents",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "alias": "myAgents",
                            "args": v19 /*: any*/ ,
                            "concreteType": "AgentStudioAgentsConnection",
                            "kind": "LinkedField",
                            "name": "agentStudio_getAgents",
                            "plural": false,
                            "selections": v22 /*: any*/ 
                        }
                    ]
                },
                {
                    "alias": "verifiedAgents",
                    "args": v20 /*: any*/ ,
                    "concreteType": "AgentStudioAgentsConnection",
                    "kind": "LinkedField",
                    "name": "agentStudio_getAgents",
                    "plural": false,
                    "selections": v22 /*: any*/ 
                },
                {
                    "alias": "allAgents",
                    "args": v21 /*: any*/ ,
                    "concreteType": "AgentStudioAgentsConnection",
                    "kind": "LinkedField",
                    "name": "agentStudio_getAgents",
                    "plural": false,
                    "selections": v22 /*: any*/ 
                }
            ]
        },
        "params": {
            "cacheID": "d5a8635588991f154c1e7912f7284204",
            "id": "74657f4e43888ea31ee636aa6bebf881cc1e1a909af0f040209d3f269c524b11",
            "metadata": {},
            "name": "queryAgentMentionsForInitialStateQuery",
            "operationKind": "query",
            "text": "query queryAgentMentionsForInitialStateQuery($cloudId:String!,$first:Int,$includeMyAgents:Boolean!,$includeRovoChatAgent:Boolean!,$product:String,$creatorTypes:[AgentStudioAgentCreatorType!]){rovoChatAgents:agentStudio_getAgents(cloudId:$cloudId,first:1,input:{creatorTypes:$creatorTypes},product:$product)@include(if:$includeRovoChatAgent)@optIn(to:\"AgentStudio\"){edges{node{id,creatorType,description,identityAccount{__typename,picture,id},identityAccountId,name}}},favoriteAgents:agentStudio_getAgents(cloudId:$cloudId,first:$first,input:{onlyFavouriteAgents:true,includeRovoChatAgent:$includeRovoChatAgent},product:$product)@optIn(to:\"AgentStudio\"){edges{node{id,creatorType,description,identityAccount{__typename,picture,id},identityAccountId,name}}},myAgents:agentStudio_getAgents(cloudId:$cloudId,first:$first,input:{onlyMyAgents:true,includeRovoChatAgent:$includeRovoChatAgent},product:$product)@include(if:$includeMyAgents)@optIn(to:\"AgentStudio\"){edges{node{id,creatorType,description,identityAccount{__typename,picture,id},identityAccountId,name}}},verifiedAgents:agentStudio_getAgents(cloudId:$cloudId,first:$first,input:{onlyVerifiedAgents:true,includeRovoChatAgent:$includeRovoChatAgent},product:$product)@optIn(to:\"AgentStudio\"){edges{node{id,creatorType,description,identityAccount{__typename,picture,id},identityAccountId,name}}},allAgents:agentStudio_getAgents(cloudId:$cloudId,first:$first,input:{includeRovoChatAgent:$includeRovoChatAgent},product:$product)@optIn(to:\"AgentStudio\"){edges{node{id,creatorType,description,identityAccount{__typename,picture,id},identityAccountId,name}}}}"
        }
    };
}();
$23b05ae499fb93a6$var$node.hash = "b7d4986a79659ed0d5512417992bd25f";
var $23b05ae499fb93a6$export$2e2bcd8739ae039 = $23b05ae499fb93a6$var$node;
module.exports["default"] = $23b05ae499fb93a6$export$2e2bcd8739ae039;

});

parcelRegister("eKwxR", function(module, exports) {
/**
 * @generated SignedSource<<1a2d4cf5562d0ff3fcb108641f768ef2>>
 * @relayHash 2cfd18d00a01329dfed88f0f370b5ebe
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 92aaaa15d7bff578f91fa2ea2e4dc4c7c84ea24e26cf77e6ff10df2396f89011
const $d9f9c84cb1e3d64f$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "first"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "product"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        },
        {
            "kind": "Variable",
            "name": "product",
            "variableName": "product"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "creatorType"
    }, v4 = {
        "kind": "ScalarField",
        "name": "description"
    }, v5 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v6 = {
        "kind": "ScalarField",
        "name": "identityAccountId"
    }, v7 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "queryAgentMentionsByNameQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "AgentStudioAgentsConnection",
                    "kind": "LinkedField",
                    "name": "agentStudio_getAgents",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "AgentStudioAgentEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "AgentStudioAssistant",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        v3 /*: any*/ ,
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "identityAccount",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ 
                                            ]
                                        },
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "queryAgentMentionsByNameQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "AgentStudioAgentsConnection",
                    "kind": "LinkedField",
                    "name": "agentStudio_getAgents",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "AgentStudioAgentEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "AgentStudioAssistant",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        v3 /*: any*/ ,
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "identityAccount",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v5 /*: any*/ ,
                                                v2 /*: any*/ 
                                            ]
                                        },
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "2cfd18d00a01329dfed88f0f370b5ebe",
            "id": "92aaaa15d7bff578f91fa2ea2e4dc4c7c84ea24e26cf77e6ff10df2396f89011",
            "metadata": {},
            "name": "queryAgentMentionsByNameQuery",
            "operationKind": "query",
            "text": "query queryAgentMentionsByNameQuery($cloudId:String!,$first:Int,$input:AgentStudioAgentQueryInput,$product:String){agentStudio_getAgents(cloudId:$cloudId,first:$first,input:$input,product:$product)@optIn(to:\"AgentStudio\"){edges{node{id,creatorType,description,identityAccount{__typename,picture,id},identityAccountId,name}}}}"
        }
    };
}();
$d9f9c84cb1e3d64f$var$node.hash = "f44bfcd4dfdb02102d0d5899552fd79b";
var $d9f9c84cb1e3d64f$export$2e2bcd8739ae039 = $d9f9c84cb1e3d64f$var$node;
module.exports["default"] = $d9f9c84cb1e3d64f$export$2e2bcd8739ae039;

});

parcelRegister("kCDdC", function(module, exports) {
/**
 * @generated SignedSource<<bd4227342e9ecb2e9d2338df013cfaf3>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $5c4367f6180fde75$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "queryAgentMentionsFragment",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "creatorType"
        },
        {
            "kind": "ScalarField",
            "name": "description"
        },
        {
            "kind": "LinkedField",
            "name": "identityAccount",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "picture"
                }
            ]
        },
        {
            "kind": "ScalarField",
            "name": "identityAccountId"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        }
    ],
    "type": "AgentStudioAssistant"
};
$5c4367f6180fde75$var$node.hash = "1c31489e6e76516963ed7f88e51ec981";
var $5c4367f6180fde75$export$2e2bcd8739ae039 = $5c4367f6180fde75$var$node;
module.exports["default"] = $5c4367f6180fde75$export$2e2bcd8739ae039;

});

parcelRegister("fQ3iN", function(module, exports) {

var $a33Aa = parcelRequire("a33Aa");


var $3YpC9 = parcelRequire("3YpC9");


var $kw6I9 = parcelRequire("kw6I9");


var $8W4Gr = parcelRequire("8W4Gr");

function $a96d58ddd476e3f0$export$34f706592a2f7442(config) {
    const metric = (0, $kw6I9.createBM3PageSegmentLoadMetricRaw)(config);
    const key = config.key;
    // Capture the original methods before overriding them.
    const realStart = metric.start.bind(metric);
    const realStartFromPageLoad = metric.startFromPageLoad.bind(metric);
    const realStop = metric.stop.bind(metric);
    const realCancel = metric.cancel.bind(metric);
    const realMark = metric.mark.bind(metric);
    const realMarkFMP = metric.markFMP.bind(metric);
    metric.start = (...args)=>{
        const binding = (0, $8W4Gr.bindPageSegmentToUFO)(metric, key, args[0]?.startTime);
        if (binding) {
            (0, $a33Aa.addMark)(binding.interactionId, 'custom', `${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_START)}:${key}`, [], binding.startTime);
            return;
        }
        return realStart(...args);
    };
    metric.startFromPageLoad = (...args)=>{
        const binding = (0, $8W4Gr.bindPageSegmentToUFO)(metric, key, 'page-load');
        if (binding) {
            (0, $a33Aa.addMark)(binding.interactionId, 'custom', `${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_START)}:${key}`, [], binding.startTime);
            return;
        }
        return realStartFromPageLoad(...args);
    };
    metric.stop = (...args)=>{
        const binding = (0, $8W4Gr.getPageSegmentUFOBinding)(metric);
        if (binding) {
            (0, $8W4Gr.reportPageSegmentEndToUFO)(binding, args[0]);
            return true;
        }
        return realStop(...args);
    };
    metric.cancel = (...args)=>{
        const binding = (0, $8W4Gr.getPageSegmentUFOBinding)(metric);
        if (binding) {
            // This is a legacy marker, not a native interaction cancellation/completion.
            (0, $a33Aa.addMark)(binding.interactionId, 'custom', `${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_END)}:${key}`, [], performance.now());
            return;
        }
        return realCancel(...args);
    };
    metric.mark = (...args)=>{
        const binding = (0, $8W4Gr.getPageSegmentUFOBinding)(metric);
        if (binding) {
            const [name, timestamp] = args;
            (0, $a33Aa.addMark)(binding.interactionId, 'custom', name, [], timestamp ?? performance.now());
            return;
        }
        return realMark(...args);
    };
    metric.markFMP = (...args)=>{
        const binding = (0, $8W4Gr.getPageSegmentUFOBinding)(metric);
        if (binding) {
            const [timestamp] = args;
            (0, $a33Aa.addMark)(binding.interactionId, 'custom', `fmp:${key}`, [], timestamp ?? performance.now());
            return;
        }
        return realMarkFMP(...args);
    };
    return metric;
}
module.exports["createPageSegmentLoadMetric"] = $a96d58ddd476e3f0$export$34f706592a2f7442;

});

parcelRegister("3YpC9", function(module, exports) {
const $4dbe182ee19642b3$export$f59b3ea823fcdb3d = 'segment-start';
const $4dbe182ee19642b3$export$a217b163593f51a = 'segment-end';
module.exports["PAGE_SEGMENT_MARK_PREFIX_START"] = $4dbe182ee19642b3$export$f59b3ea823fcdb3d;
module.exports["PAGE_SEGMENT_MARK_PREFIX_END"] = $4dbe182ee19642b3$export$a217b163593f51a;

});

parcelRegister("kw6I9", function(module, exports) {
// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ /* eslint-disable no-restricted-syntax */ 
var $iDdTC = parcelRequire("iDdTC");

const $864083edfead32eb$export$2a2fe1e11b4e0413 = (0, $iDdTC.metrics).pageSegmentLoad;
module.exports["createBM3PageSegmentLoadMetricRaw"] = $864083edfead32eb$export$2a2fe1e11b4e0413;

});

parcelRegister("8W4Gr", function(module, exports) {

var $a33Aa = parcelRequire("a33Aa");


var $9wGTI = parcelRequire("9wGTI");


var $iJ7Px = parcelRequire("iJ7Px");


var $3YpC9 = parcelRequire("3YpC9");

// Dispatch information only: UFO still owns holds, completion and reporting.
// Object identity keeps separate metric instances with the same key independent.
const $06e453a80b18c305$var$bindings = new WeakMap();
// Deduplicate end telemetry per captured start without changing UFO completion or holds.
const $06e453a80b18c305$var$reportedEnds = new WeakSet();
function $06e453a80b18c305$export$658d1540acda6146(metric, key = metric.key, startTime) {
    $06e453a80b18c305$var$bindings.delete(metric);
    const interaction = (0, $a33Aa.getActiveInteraction)();
    if (interaction && (0, $iJ7Px.BM3_MIGRATION_SCOPES).some(({ ufoNames: ufoNames, segmentKeys: segmentKeys })=>ufoNames.includes(interaction.ufoName) && segmentKeys.some((segment)=>segment === key)) && // eslint-disable-next-line confluence-feature-gating/no-new-feature-gates -- Existing phase-2 guard shared by React and imperative segment starts.
    (0, $9wGTI.fg)('cc_bm3_deprecation_phase_2')) {
        const binding = {
            interactionId: interaction.id,
            key: key,
            startTime: startTime === 'page-load' ? interaction.start : startTime ?? performance.now()
        };
        $06e453a80b18c305$var$bindings.set(metric, binding);
        return binding;
    }
    return undefined;
}
function $06e453a80b18c305$export$23d3c6fa6a541f1c(metric) {
    return $06e453a80b18c305$var$bindings.get(metric);
}
function $06e453a80b18c305$export$de99dc22751ce5a4(binding, options) {
    const { interactionId: interactionId, key: key, startTime: startTime } = binding;
    if (!$06e453a80b18c305$var$reportedEnds.has(binding)) {
        $06e453a80b18c305$var$reportedEnds.add(binding);
        const endTime = options?.stopTime ?? performance.now();
        (0, $a33Aa.addMark)(interactionId, 'custom', `${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_END)}:${key}`, [], endTime);
        (0, $a33Aa.addCustomTiming)(interactionId, [], {
            [`wf/react/${key}`]: {
                startTime: startTime,
                endTime: endTime
            }
        });
    }
    // Later React/imperative callbacks can still supply attributes to the same owner.
    if (options?.customData) (0, $a33Aa.addCustomData)(interactionId, [], typeof globalThis.structuredClone === 'function' ? globalThis.structuredClone(options.customData) : options.customData);
}
module.exports["bindPageSegmentToUFO"] = $06e453a80b18c305$export$658d1540acda6146;
module.exports["getPageSegmentUFOBinding"] = $06e453a80b18c305$export$23d3c6fa6a541f1c;
module.exports["reportPageSegmentEndToUFO"] = $06e453a80b18c305$export$de99dc22751ce5a4;

});

parcelRegister("iJ7Px", function(module, exports) {

var $1UCmC = parcelRequire("1UCmC");


var $jX1qB = parcelRequire("jX1qB");

const $9f5a9554b14e3be2$export$59f08ddb222dbbda = [
    {
        pageLoadKey: (0, $1UCmC.VIEW_PAGE_LOAD_KEY),
        ufoNames: [
            'view_page'
        ],
        segmentKeys: [
            // View Page's initial/transition segments, plus its header and content UI.
            (0, $jX1qB.APP_NAVIGATION_SEGMENT_KEY),
            (0, $jX1qB.BYLINE_SEGMENT_KEY),
            (0, $jX1qB.CONTENT_RENDERER_SEGMENT_KEY),
            (0, $jX1qB.CONTENT_TITLE_SEGMENT_KEY),
            (0, $jX1qB.CONTENT_TYPES_HEADER_TITLE_SEGMENT_KEY),
            (0, $jX1qB.CONNECT_APP_WEB_FRAGMENT_SEGMENT_KEY),
            (0, $jX1qB.END_OF_PAGE_RECOMMENDATIONS_SEGMENT_KEY),
            (0, $jX1qB.FABRIC_COMMENTS_HIGHLIGHTS_SEGMENT_KEY),
            (0, $jX1qB.FAVOURITE_BUTTON_SEGMENT_KEY),
            (0, $jX1qB.OBJECT_HEADER_SEGMENT_KEY),
            (0, $jX1qB.OBJECT_SIDEBAR_CONTROL_SEGMENT_KEY),
            (0, $jX1qB.PAGE_TREE_SEGMENT_KEY),
            (0, $jX1qB.READ_TIME_SEGMENT_KEY),
            (0, $jX1qB.RESTRICTIONS_BUTTON_SEGMENT_KEY),
            (0, $jX1qB.SHARE_BUTTON_SEGMENT_KEY),
            (0, $jX1qB.SPACE_NAVIGATION_SEGMENT_KEY),
            (0, $jX1qB.VIEW_PAGE_CONTAINER_SEGMENT_KEY),
            (0, $jX1qB.VIEW_PAGE_LABELS_METRIC_KEY),
            (0, $jX1qB.WATCH_BUTTON_SEGMENT_KEY)
        ]
    }
];
module.exports["BM3_MIGRATION_SCOPES"] = $9f5a9554b14e3be2$export$59f08ddb222dbbda;

});

parcelRegister("1UCmC", function(module, exports) {
const $00aca2e58bbddd9e$export$9ee3c9e81070f140 = 'admin-announcement-banner-setting-page';
const $00aca2e58bbddd9e$export$162462d8f302c50a = 'advanced-search';
const $00aca2e58bbddd9e$export$17e011598d6a739d = 'unified-search';
const $00aca2e58bbddd9e$export$a88513891a2ab6b7 = 'confluence-home';
const $00aca2e58bbddd9e$export$5614199f62986e3b = 'all-drafts';
const $00aca2e58bbddd9e$export$3bbaa81ece500746 = 'recent-pages';
const $00aca2e58bbddd9e$export$b634edee624f5dc2 = 'starred-pages';
const $00aca2e58bbddd9e$export$5946c48030569b81 = 'content-history';
const $00aca2e58bbddd9e$export$1eefb862c6c6ce00 = 'edit-page';
const $00aca2e58bbddd9e$export$e164999ba8681ff6 = 'edit-template';
const $00aca2e58bbddd9e$export$6cdf3f4614ddd679 = 'edit-template-old';
const $00aca2e58bbddd9e$export$8faa34d8ba45e128 = 'embedded-view-page';
const $00aca2e58bbddd9e$export$3fb3338cf2b36704 = 'embedded-edit-page';
const $00aca2e58bbddd9e$export$779fbc1a16a8cb5d = 'global-permissions';
const $00aca2e58bbddd9e$export$9d8c586f3355f180 = 'inaccessible-page';
const $00aca2e58bbddd9e$export$a0c73183bde575ec = 'not-found';
const $00aca2e58bbddd9e$export$6d480c75094dbd7f = 'space-directory';
const $00aca2e58bbddd9e$export$8d0f9920174f22b4 = 'space-overview';
const $00aca2e58bbddd9e$export$228f2841a225e5ad = 'space-pages';
const $00aca2e58bbddd9e$export$fe4f0edc4d6532a8 = 'tasks-home';
const $00aca2e58bbddd9e$export$cc53520b570e0a46 = 'content-manager';
const $00aca2e58bbddd9e$export$bdc26b2b517231a = 'space-manager';
const $00aca2e58bbddd9e$export$b6d237d1e8f12e5d = 'template-gallery';
const $00aca2e58bbddd9e$export$a715ad00b824ec3f = 'view-page';
const $00aca2e58bbddd9e$export$132f38e0c19c02b6 = 'embedded-marketplace';
const $00aca2e58bbddd9e$export$803e647119e41cc = 'embedded-store';
const $00aca2e58bbddd9e$export$d2dddf4422ad7ae8 = 'create-content';
const $00aca2e58bbddd9e$export$9c7a9f4f853f6fba = 'public-link-shared-page';
const $00aca2e58bbddd9e$export$643b9c181748da38 = 'public-link-site-setting-page';
const $00aca2e58bbddd9e$export$4716363caa82a23b = 'public-links-space-settings-page';
const $00aca2e58bbddd9e$export$75726af5c0ee9402 = 'whiteboard-view-page';
const $00aca2e58bbddd9e$export$afe76b61b3f9aaa8 = 'database-view-page';
const $00aca2e58bbddd9e$export$dd63a13fc6c1ba34 = 'embed-view-page';
const $00aca2e58bbddd9e$export$16aeb03ec0c24b89 = 'live-page';
const $00aca2e58bbddd9e$export$2b4bf316b2f90e51 = 'folder-page';
const $00aca2e58bbddd9e$export$ce4e0f6f3d614d45 = 'live-edit';
const $00aca2e58bbddd9e$export$ecea02b4eaa314f3 = 'team-calendars';
const $00aca2e58bbddd9e$export$726cbfa087a55101 = 'admin-team-calendars';
const $00aca2e58bbddd9e$export$2f245ed7ebaea89 = 'admin-general-configuration';
const $00aca2e58bbddd9e$export$2af60fefae96902b = 'admin-configure-code-macro';
const $00aca2e58bbddd9e$export$fbea00ed02ef2502 = 'admin-default-space-logo-config';
const $00aca2e58bbddd9e$export$6e9c07174668ae36 = 'admin-header-and-footer';
const $00aca2e58bbddd9e$export$51fdddeccf175d74 = 'admin-security-configuration';
const $00aca2e58bbddd9e$export$2d0370cc7d14b72e = 'admin-templates-and-blueprints';
const $00aca2e58bbddd9e$export$a8d02dbd84c83dd = 'admin-import-spaces';
const $00aca2e58bbddd9e$export$1d91ea2ef976728a = 'admin-trashed-spaces';
const $00aca2e58bbddd9e$export$a13bfc71dc6b7924 = 'admin-application-navigator';
const $00aca2e58bbddd9e$export$3ba6335cd90d2e59 = 'admin-themes';
const $00aca2e58bbddd9e$export$cb4b6b707a32ee92 = 'admin-jira-macro-repair';
const $00aca2e58bbddd9e$export$5cb6689cb672a5c0 = 'admin-pdf-export';
const $00aca2e58bbddd9e$export$fff7d33fb1514c44 = 'admin-macro-usage';
const $00aca2e58bbddd9e$export$87f484dad415164c = 'admin-storage-management';
const $00aca2e58bbddd9e$export$d4aa60a3ffc18652 = 'admin-user-access';
const $00aca2e58bbddd9e$export$52c0c13179848b50 = 'CONTENT_ANALYTICS';
const $00aca2e58bbddd9e$export$40dab65f060e1231 = 'SPACE_ANALYTICS';
const $00aca2e58bbddd9e$export$b682ed6d6fa429fb = 'INSTANCE_ANALYTICS';
const $00aca2e58bbddd9e$export$93cf1e51c6a6b6b1 = 'space-details';
const $00aca2e58bbddd9e$export$2633c6986b98b723 = 'pdf-export-route';
module.exports["ADMIN_ANNOUNCEMENT_BANNER_SETTING_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$9ee3c9e81070f140;
module.exports["ADVANCED_SEARCH_LOAD_KEY"] = $00aca2e58bbddd9e$export$162462d8f302c50a;
module.exports["UNIFIED_SEARCH_LOAD_KEY"] = $00aca2e58bbddd9e$export$17e011598d6a739d;
module.exports["CONFLUENCE_HOME_LOAD_KEY"] = $00aca2e58bbddd9e$export$a88513891a2ab6b7;
module.exports["CONFLUENCE_DRAFTS_LOAD_KEY"] = $00aca2e58bbddd9e$export$5614199f62986e3b;
module.exports["CONFLUENCE_RECENT_LOAD_KEY"] = $00aca2e58bbddd9e$export$3bbaa81ece500746;
module.exports["CONFLUENCE_STARRED_LOAD_KEY"] = $00aca2e58bbddd9e$export$b634edee624f5dc2;
module.exports["CONTENT_HISTORY_LOAD_KEY"] = $00aca2e58bbddd9e$export$5946c48030569b81;
module.exports["EDIT_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$1eefb862c6c6ce00;
module.exports["EDIT_TEMPLATE_LOAD_KEY"] = $00aca2e58bbddd9e$export$e164999ba8681ff6;
module.exports["EDIT_TEMPLATE_OLD_LOAD_KEY"] = $00aca2e58bbddd9e$export$6cdf3f4614ddd679;
module.exports["EMBEDDED_VIEW_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$8faa34d8ba45e128;
module.exports["EMBEDDED_EDIT_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$3fb3338cf2b36704;
module.exports["GLOBAL_PERMISSIONS_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$779fbc1a16a8cb5d;
module.exports["INACCESSIBLE_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$9d8c586f3355f180;
module.exports["NOT_FOUND_LOAD_KEY"] = $00aca2e58bbddd9e$export$a0c73183bde575ec;
module.exports["SPACE_DIRECTORY_LOAD_KEY"] = $00aca2e58bbddd9e$export$6d480c75094dbd7f;
module.exports["SPACE_OVERVIEW_LOAD_KEY"] = $00aca2e58bbddd9e$export$8d0f9920174f22b4;
module.exports["SPACE_PAGES_LOAD_KEY"] = $00aca2e58bbddd9e$export$228f2841a225e5ad;
module.exports["TASKS_HOME_LOAD_KEY"] = $00aca2e58bbddd9e$export$fe4f0edc4d6532a8;
module.exports["CONTENT_MANAGER_LOAD_KEY"] = $00aca2e58bbddd9e$export$cc53520b570e0a46;
module.exports["SPACE_MANAGER_LOAD_KEY"] = $00aca2e58bbddd9e$export$bdc26b2b517231a;
module.exports["TEMPLATE_GALLERY_LOAD_KEY"] = $00aca2e58bbddd9e$export$b6d237d1e8f12e5d;
module.exports["VIEW_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$a715ad00b824ec3f;
module.exports["EMBEDDED_MARKETPLACE_LOAD_KEY"] = $00aca2e58bbddd9e$export$132f38e0c19c02b6;
module.exports["EMBEDDED_STORE_LOAD_KEY"] = $00aca2e58bbddd9e$export$803e647119e41cc;
module.exports["CREATE_CONTENT_LOAD_KEY"] = $00aca2e58bbddd9e$export$d2dddf4422ad7ae8;
module.exports["PUBLIC_LINK_SHARED_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$9c7a9f4f853f6fba;
module.exports["PUBLIC_LINK_SITE_SETTING_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$643b9c181748da38;
module.exports["WHITEBOARD_VIEW_PAGE_KEY"] = $00aca2e58bbddd9e$export$75726af5c0ee9402;
module.exports["DATABASE_VIEW_PAGE_KEY"] = $00aca2e58bbddd9e$export$afe76b61b3f9aaa8;
module.exports["EMBED_VIEW_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$dd63a13fc6c1ba34;
module.exports["LIVE_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$16aeb03ec0c24b89;
module.exports["FOLDER_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$2b4bf316b2f90e51;
module.exports["LIVE_PAGE_REACT_UFO_LOAD_KEY"] = $00aca2e58bbddd9e$export$ce4e0f6f3d614d45;
module.exports["TEAM_CALENDARS_LOAD_KEY"] = $00aca2e58bbddd9e$export$ecea02b4eaa314f3;
module.exports["ADMIN_TEAM_CALENDARS_LOAD_KEY"] = $00aca2e58bbddd9e$export$726cbfa087a55101;
module.exports["ADMIN_GENERAL_CONFIGURATION_LOAD_KEY"] = $00aca2e58bbddd9e$export$2f245ed7ebaea89;
module.exports["ADMIN_CONFIGURE_CODE_MACRO_LOAD_KEY"] = $00aca2e58bbddd9e$export$2af60fefae96902b;
module.exports["ADMIN_DEFAULT_SPACE_LOGO_CONFIG_LOAD_KEY"] = $00aca2e58bbddd9e$export$fbea00ed02ef2502;
module.exports["ADMIN_HEADER_AND_FOOTER_LOAD_KEY"] = $00aca2e58bbddd9e$export$6e9c07174668ae36;
module.exports["ADMIN_SECURITY_CONFIGURATION_LOAD_KEY"] = $00aca2e58bbddd9e$export$51fdddeccf175d74;
module.exports["ADMIN_TEMPLATES_AND_BLUEPRINTS_LOAD_KEY"] = $00aca2e58bbddd9e$export$2d0370cc7d14b72e;
module.exports["ADMIN_IMPORT_SPACES_LOAD_KEY"] = $00aca2e58bbddd9e$export$a8d02dbd84c83dd;
module.exports["ADMIN_TRASHED_SPACES_LOAD_KEY"] = $00aca2e58bbddd9e$export$1d91ea2ef976728a;
module.exports["ADMIN_APPLICATION_NAVIGATOR_KEY"] = $00aca2e58bbddd9e$export$a13bfc71dc6b7924;
module.exports["ADMIN_THEMES_LOAD_KEY"] = $00aca2e58bbddd9e$export$3ba6335cd90d2e59;
module.exports["ADMIN_JIRA_MACRO_REPAIR_LOAD_KEY"] = $00aca2e58bbddd9e$export$cb4b6b707a32ee92;
module.exports["ADMIN_PDF_EXPORT_LOAD_KEY"] = $00aca2e58bbddd9e$export$5cb6689cb672a5c0;
module.exports["ADMIN_MACRO_USAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$fff7d33fb1514c44;
module.exports["ADMIN_STORAGE_MANAGEMENT_LOAD_KEY"] = $00aca2e58bbddd9e$export$87f484dad415164c;
module.exports["ADMIN_USER_ACCESS_KEY"] = $00aca2e58bbddd9e$export$d4aa60a3ffc18652;
module.exports["PAGE_ANALYTICS_LOAD_KEY"] = $00aca2e58bbddd9e$export$52c0c13179848b50;
module.exports["SPACE_ANALYTICS_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$40dab65f060e1231;
module.exports["SITE_ANALYTICS_LOAD_KEY"] = $00aca2e58bbddd9e$export$b682ed6d6fa429fb;
module.exports["SPACE_DETAILS_LOAD_KEY"] = $00aca2e58bbddd9e$export$93cf1e51c6a6b6b1;
module.exports["PDF_EXPORT_ROUTE_LOAD_KEY"] = $00aca2e58bbddd9e$export$2633c6986b98b723;

});

parcelRegister("jX1qB", function(module, exports) {
// "confluence.fe.page-segment-load.XXX"
const $fa0ea3428ec5aa62$export$9e40500efe28ac9e = 'app-navigation';
const $fa0ea3428ec5aa62$export$38b273cdbbf56c26 = 'blog-tree';
const $fa0ea3428ec5aa62$export$1ac23cd5807df863 = 'byline';
const $fa0ea3428ec5aa62$export$5bbb36bee09a5671 = 'read-time';
const $fa0ea3428ec5aa62$export$a79607497a4a710c = 'content-analytics-viewers';
const $fa0ea3428ec5aa62$export$c56a99673f1bb7bb = 'content-analytics-links-table';
const $fa0ea3428ec5aa62$export$140a493a9e781fe2 = 'content-renderer';
const $fa0ea3428ec5aa62$export$db1285ccb0399c01 = 'content-title';
const $fa0ea3428ec5aa62$export$eb5bb54418693284 = 'favourite-button';
const $fa0ea3428ec5aa62$export$3fde425dbc74423b = 'focused-inline-comment';
const $fa0ea3428ec5aa62$export$6a58cce6529da40e = 'inline-comments-highlights';
const $fa0ea3428ec5aa62$export$8910bc840e3ee4ce = 'fabric-comments-highlights';
const $fa0ea3428ec5aa62$export$bf572571ca036b67 = 'render-inline-comment';
const $fa0ea3428ec5aa62$export$644778267d4a4a82 = 'editor-render-inline-comment';
const $fa0ea3428ec5aa62$export$3afb71dd0b0dbc3a = 'reactions';
const $fa0ea3428ec5aa62$export$e4ff10a0a39a7217 = 'page-comments';
const $fa0ea3428ec5aa62$export$6648c9be174e6923 = 'page-reactions';
const $fa0ea3428ec5aa62$export$2d3d6144128aaee3 = 'feed-reactions';
const $fa0ea3428ec5aa62$export$2f4a07b2ab7a5499 = 'page-tree';
const $fa0ea3428ec5aa62$export$d1dfca9e0eb45581 = 'restrictions-button';
const $fa0ea3428ec5aa62$export$312db7b759bad970 = 'global-navigation';
const $fa0ea3428ec5aa62$export$cf2a6bf49e73b304 = 'space-navigation';
const $fa0ea3428ec5aa62$export$84f6b5717c3fb962 = 'space-apps';
const $fa0ea3428ec5aa62$export$1a423f2548c46be3 = 'watch-button';
const $fa0ea3428ec5aa62$export$b6426c6941656619 = 'home-overview-recent';
const $fa0ea3428ec5aa62$export$14f30a91623dfcf3 = 'home-overview-feed';
const $fa0ea3428ec5aa62$export$c6926beb57b60636 = 'home-overview-right-panel';
const $fa0ea3428ec5aa62$export$687913e127f52cc3 = 'home-overview-spaces-section';
const $fa0ea3428ec5aa62$export$2d52eeb1a0271bf0 = 'home-recents-view';
const $fa0ea3428ec5aa62$export$76243e8aa4afaa0b = 'home-starred-view';
const $fa0ea3428ec5aa62$export$e1df6f3f29083f48 = 'home-drafts-view';
const $fa0ea3428ec5aa62$export$7b32848c9413526a = 'end-of-page-recommendations';
const $fa0ea3428ec5aa62$export$58fbb0ba50341103 = 'in-editor-templates';
const $fa0ea3428ec5aa62$export$4f481f063369df3c = 'ncs-connected-fmp';
const $fa0ea3428ec5aa62$export$db1b9793e009e605 = 'advanced-search-component';
const $fa0ea3428ec5aa62$export$90bda069d4bf981b = 'advanced-search-filter-section';
const $fa0ea3428ec5aa62$export$f11e1d4269141c0e = 'advanced-search-result-section';
const $fa0ea3428ec5aa62$export$f0298cbab4a44998 = 'database-header';
const $fa0ea3428ec5aa62$export$fa02a8e56ccc9d5 = 'smart-link-embed-header';
const $fa0ea3428ec5aa62$export$cf2f52fec740bdea = 'whiteboard-header';
const $fa0ea3428ec5aa62$export$52050233077a1838 = 'object-header';
const $fa0ea3428ec5aa62$export$e1ab333f0b70b317 = 'content-types-header-title';
const $fa0ea3428ec5aa62$export$b6a22e6ed7750ea4 = 'whiteboard-view-page-content';
const $fa0ea3428ec5aa62$export$b95bd4bfc46932fc = 'database-view-page-content';
const $fa0ea3428ec5aa62$export$f6bd20f4f796eb89 = 'folder-page-content';
const $fa0ea3428ec5aa62$export$bf838b84ba2f7b95 = 'share-button';
const $fa0ea3428ec5aa62$export$79910402df6be117 = 'view-page-labels';
const $fa0ea3428ec5aa62$export$d86af34f7dc194b4 = 'admin-announcement-banner';
const $fa0ea3428ec5aa62$export$ae588ea5fb9e92bb = 'cp-web-fragment';
const $fa0ea3428ec5aa62$export$1939caa7fae28ef5 = 'view-space-permissions';
const $fa0ea3428ec5aa62$export$3f06ee123a5ad183 = 'view-page-container';
const $fa0ea3428ec5aa62$export$37da6122cd60d332 = 'embed-view-page-content';
const $fa0ea3428ec5aa62$export$3437c1f145cfce19 = 'embed-view-page-blank-content';
const $fa0ea3428ec5aa62$export$7903037283afbce0 = 'editor';
const $fa0ea3428ec5aa62$export$31d10d7597db11d3 = 'object-sidebar-control';
const $fa0ea3428ec5aa62$export$b64d520f9b37dcd7 = 'comments-panel-open-view';
const $fa0ea3428ec5aa62$export$50553e47471a0f5e = 'comments-panel-unread-view';
const $fa0ea3428ec5aa62$export$40d92ab0c1cc5298 = 'comments-panel-deleted-content-view';
const $fa0ea3428ec5aa62$export$f2a6407ac901fd8d = 'comments-panel-resolved-view';
const $fa0ea3428ec5aa62$export$b3aade49b91bdeba = 'comments-panel-mentions-me-view';
module.exports["APP_NAVIGATION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$9e40500efe28ac9e;
module.exports["BLOG_TREE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$38b273cdbbf56c26;
module.exports["BYLINE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$1ac23cd5807df863;
module.exports["READ_TIME_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$5bbb36bee09a5671;
module.exports["CONTENT_ANALYTICS_VIEWERS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$a79607497a4a710c;
module.exports["CONTENT_ANALYTICS_LINKS_TABLE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$c56a99673f1bb7bb;
module.exports["CONTENT_RENDERER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$140a493a9e781fe2;
module.exports["CONTENT_TITLE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$db1285ccb0399c01;
module.exports["FAVOURITE_BUTTON_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$eb5bb54418693284;
module.exports["FOCUSED_INLINE_COMMENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$3fde425dbc74423b;
module.exports["INLINE_COMMENTS_HIGHLIGHTS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$6a58cce6529da40e;
module.exports["FABRIC_COMMENTS_HIGHLIGHTS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$8910bc840e3ee4ce;
module.exports["RENDERER_INLINE_COMMENT_RENDER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$bf572571ca036b67;
module.exports["EDITOR_INLINE_COMMENT_RENDER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$644778267d4a4a82;
module.exports["PAGE_COMMENTS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$e4ff10a0a39a7217;
module.exports["PAGE_REACTIONS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$6648c9be174e6923;
module.exports["FEED_REACTIONS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$2d3d6144128aaee3;
module.exports["PAGE_TREE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$2f4a07b2ab7a5499;
module.exports["RESTRICTIONS_BUTTON_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$d1dfca9e0eb45581;
module.exports["GLOBAL_NAVIGATION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$312db7b759bad970;
module.exports["SPACE_NAVIGATION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$cf2a6bf49e73b304;
module.exports["SPACE_APPS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$84f6b5717c3fb962;
module.exports["WATCH_BUTTON_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$1a423f2548c46be3;
module.exports["HOME_OVERVIEW_RECENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$b6426c6941656619;
module.exports["HOME_OVERVIEW_FEED_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$14f30a91623dfcf3;
module.exports["HOME_OVERVIEW_RIGHT_PANEL_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$c6926beb57b60636;
module.exports["HOME_RECENTS_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$2d52eeb1a0271bf0;
module.exports["HOME_STARRED_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$76243e8aa4afaa0b;
module.exports["HOME_DRAFTS_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$e1df6f3f29083f48;
module.exports["END_OF_PAGE_RECOMMENDATIONS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$7b32848c9413526a;
module.exports["IN_EDITOR_TEMPLATES_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$58fbb0ba50341103;
module.exports["NCS_CONNECTED_FMP_KEY"] = $fa0ea3428ec5aa62$export$4f481f063369df3c;
module.exports["ADVANCED_SEARCH_COMPONENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$db1b9793e009e605;
module.exports["ADVANCED_SEARCH_FILTER_SECTION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$90bda069d4bf981b;
module.exports["ADVANCED_SEARCH_RESULT_SECTION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$f11e1d4269141c0e;
module.exports["DATABASE_HEADER_SEGMENT_METRIC_KEY"] = $fa0ea3428ec5aa62$export$f0298cbab4a44998;
module.exports["SMART_LINK_EMBED_HEADER_SEGMENT_METRIC_KEY"] = $fa0ea3428ec5aa62$export$fa02a8e56ccc9d5;
module.exports["WHITEBOARD_HEADER_SEGMENT_METRIC_KEY"] = $fa0ea3428ec5aa62$export$cf2f52fec740bdea;
module.exports["OBJECT_HEADER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$52050233077a1838;
module.exports["CONTENT_TYPES_HEADER_TITLE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$e1ab333f0b70b317;
module.exports["WHITEBOARD_VIEW_PAGE_CONTENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$b6a22e6ed7750ea4;
module.exports["DATABASE_VIEW_PAGE_CONTENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$b95bd4bfc46932fc;
module.exports["FOLDER_PAGE_CONTENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$f6bd20f4f796eb89;
module.exports["SHARE_BUTTON_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$bf838b84ba2f7b95;
module.exports["VIEW_PAGE_LABELS_METRIC_KEY"] = $fa0ea3428ec5aa62$export$79910402df6be117;
module.exports["ADMIN_ANNOUNCEMENT_BANNER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$d86af34f7dc194b4;
module.exports["CONNECT_APP_WEB_FRAGMENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$ae588ea5fb9e92bb;
module.exports["SPACE_PERMISSIONS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$1939caa7fae28ef5;
module.exports["VIEW_PAGE_CONTAINER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$3f06ee123a5ad183;
module.exports["EMBED_VIEW_PAGE_CONTENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$37da6122cd60d332;
module.exports["EMBED_VIEW_PAGE_BLANK_CONTENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$3437c1f145cfce19;
module.exports["EDITOR_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$7903037283afbce0;
module.exports["OBJECT_SIDEBAR_CONTROL_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$31d10d7597db11d3;
module.exports["COMMENTS_PANEL_OPEN_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$b64d520f9b37dcd7;
module.exports["COMMENTS_PANEL_UNREAD_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$50553e47471a0f5e;
module.exports["COMMENTS_PANEL_DELETED_CONTENT_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$40d92ab0c1cc5298;
module.exports["COMMENTS_PANEL_RESOLVED_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$f2a6407ac901fd8d;
module.exports["COMMENTS_PANEL_MENTIONS_ME_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$b3aade49b91bdeba;

});

parcelRegister("g2yI6", function(module, exports) {

var $89CKS = parcelRequire("89CKS");


var $c0rhi = parcelRequire("c0rhi");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");

const $28b5c5efee4d19cf$var$fetchMentionsProviderDataQuery = (0, $89CKS.default);
const $28b5c5efee4d19cf$export$5ced7267a5286f97 = async ()=>{
    return (0, $c0rhi.queryInterop)({
        query: $28b5c5efee4d19cf$var$fetchMentionsProviderDataQuery,
        __callerPackage__: "fabric-media-support"
    }).then(({ data: data })=>{
        return data;
    }).catch((error)=>{
        (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).ADMIN_EXPERIENCE
        });
        (0, $7Sm4c.markErrorAsHandled)(error);
        return undefined;
    });
};
module.exports["fetchMentionsProviderData"] = $28b5c5efee4d19cf$export$5ced7267a5286f97;

});

parcelRegister("5VSNw", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $a59ec0f880a08336$var$styles = {
    container: "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _0jFU0VxpxF _39xV02xpxF"
};
const $a59ec0f880a08336$var$ROVO_SVG_PATH = `<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M5.38007 0.169224C5.79665 -0.0605531 6.30508 -0.0563317 6.71827 0.181888L9.96761 2.05659L10.7381 2.50115C11.1589 2.7437 11.4193 3.1937 11.4193 3.67848V8.31707C11.4193 8.80377 11.1604 9.25178 10.7385 9.4942L7.71671 11.2376C7.72332 11.219 7.72963 11.2003 7.73565 11.1815C7.79172 11.0077 7.82146 10.8241 7.82146 10.6363V5.99777C7.82146 5.36053 7.4823 4.7729 6.92908 4.45501L6.37094 4.13313L4.67654 3.15598V1.35919C4.67654 1.21761 4.69845 1.0793 4.7399 0.948371C4.8418 0.631497 5.05854 0.357177 5.35505 0.185934L5.35594 0.185415C5.36443 0.180511 5.37252 0.175072 5.38007 0.169224Z" fill="#FCA700"/>
		<path d="M4.35709 0.762451L1.33533 2.50585C0.91337 2.74828 0.654541 3.19629 0.654541 3.68299V8.32158C0.654541 8.80636 0.914895 9.25633 1.33561 9.49887L2.05206 9.91223L5.35553 11.8182C5.76872 12.0563 6.27717 12.0606 6.69373 11.8308C6.70128 11.825 6.7093 11.8196 6.71781 11.8147C7.01463 11.6435 7.2317 11.3691 7.33376 11.0521C7.3753 10.9211 7.39725 10.7826 7.39725 10.6409V8.84408L5.64872 7.83569L5.14485 7.54513C4.59174 7.22722 4.25234 6.63946 4.25234 6.00228V1.3637C4.25234 1.17625 4.28199 0.992849 4.33793 0.81927C4.344 0.800208 4.35039 0.781265 4.35709 0.762451Z" fill="#FCA700"/>
		<path fill-rule="evenodd" clip-rule="evenodd" d="M5.64872 7.83569L2.05206 9.91223L1.33561 9.49887C0.914895 9.25633 0.654541 8.80636 0.654541 8.32158V3.68299C0.654541 3.19629 0.91337 2.74828 1.33533 2.50585L4.35709 0.762451C4.35039 0.781265 4.344 0.800208 4.33793 0.81927C4.28199 0.992849 4.25234 1.17625 4.25234 1.3637V6.00228C4.25234 6.63946 4.59174 7.22722 5.14485 7.54513L5.64872 7.83569Z" fill="#1868DB"/>
		<path fill-rule="evenodd" clip-rule="evenodd" d="M6.37094 4.13313L4.67654 3.15598V1.35919C4.67654 1.21761 4.69845 1.0793 4.7399 0.948371C4.8418 0.631497 5.05854 0.357177 5.35505 0.185934L5.35594 0.185415C5.36443 0.180511 5.37252 0.175072 5.38007 0.169224C5.79665 -0.0605531 6.30508 -0.0563317 6.71827 0.181888L9.96761 2.05659L6.37094 4.13313Z" fill="#FCA700"/>
		<path fill-rule="evenodd" clip-rule="evenodd" d="M10.7381 2.5012L9.9676 2.05664L6.37094 4.13318L6.92907 4.45507C7.48229 4.77296 7.82146 5.36059 7.82146 5.99783V10.6364C7.82146 10.8241 7.79172 11.0078 7.73565 11.1816C7.72963 11.2004 7.72332 11.2191 7.71671 11.2377L10.7385 9.49426C11.1604 9.25184 11.4193 8.80382 11.4193 8.31712V3.67853C11.4193 3.19376 11.1589 2.74376 10.7381 2.5012Z" fill="#AF59E0"/>
		<path fill-rule="evenodd" clip-rule="evenodd" d="M5.64873 7.83569L2.05206 9.91224L5.35553 11.8182C5.76873 12.0564 6.27718 12.0606 6.69373 11.8308C6.70128 11.825 6.70931 11.8196 6.71782 11.8147C7.01463 11.6436 7.2317 11.3691 7.33377 11.0521C7.37531 10.9211 7.39726 10.7826 7.39726 10.6409V8.84409L5.64873 7.83569Z" fill="#6A9A23"/>
	</svg>`;
const $a59ec0f880a08336$var$RovoLogoSVG = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { label: label, testId: testId } = t0;
    const isDecorative = label === "";
    const t1 = isDecorative ? undefined : "img";
    const t2 = isDecorative ? undefined : label;
    const t3 = isDecorative ? true : undefined;
    let t4;
    let t5;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = {
            __html: $a59ec0f880a08336$var$ROVO_SVG_PATH
        };
        t5 = (0, $hekY6.default)([
            $a59ec0f880a08336$var$styles.container
        ]);
        $[0] = t4;
        $[1] = t5;
    } else {
        t4 = $[0];
        t5 = $[1];
    }
    let t6;
    if ($[2] !== t1 || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t6 = /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            role: t1,
            "aria-label": t2,
            "aria-hidden": t3,
            "data-testid": testId,
            dangerouslySetInnerHTML: t4,
            className: t5
        });
        $[2] = t1;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t6;
    } else t6 = $[6];
    return t6;
} : ({ label: label, testId: testId })=>{
    const isDecorative = label === '';
    return /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
        role: isDecorative ? undefined : 'img',
        "aria-label": isDecorative ? undefined : label,
        "aria-hidden": isDecorative ? true : undefined,
        "data-testid": testId,
        dangerouslySetInnerHTML: {
            __html: $a59ec0f880a08336$var$ROVO_SVG_PATH
        },
        className: (0, $hekY6.default)([
            $a59ec0f880a08336$var$styles.container
        ])
    });
};
const $a59ec0f880a08336$export$4476d508de061a72 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { label: label, testId: testId } = t0;
    let t1;
    if ($[0] !== label || $[1] !== testId) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)($a59ec0f880a08336$var$RovoLogoSVG, {
            label: label,
            testId: testId
        });
        $[0] = label;
        $[1] = testId;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ label: label, testId: testId })=>/*#__PURE__*/ (0, $8aG6j.jsx)($a59ec0f880a08336$var$RovoLogoSVG, {
        label: label,
        testId: testId
    });
module.exports["AIChatIcon"] = $a59ec0f880a08336$export$4476d508de061a72;

});

parcelRegister("3N2DH", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6cFsl = parcelRequire("6cFsl");


var $ad7Ou = parcelRequire("ad7Ou");


var $1sCHt = parcelRequire("1sCHt");


var $5VSNw = parcelRequire("5VSNw");


var $6t3CY = parcelRequire("6t3CY");


var $lslMH = parcelRequire("lslMH");


var $cXtTj = parcelRequire("cXtTj");


var $dUI0h = parcelRequire("dUI0h");


var $dTHYM = parcelRequire("dTHYM");


var $7sJoX = parcelRequire("7sJoX");


var $blZUD = parcelRequire("blZUD");


var $etoPX = parcelRequire("etoPX");


var $4n1IT = parcelRequire("4n1IT");


var $iMnC5 = parcelRequire("iMnC5");


var $1l0kj = parcelRequire("1l0kj");


var $dinVW = parcelRequire("dinVW");


var $4aRua = parcelRequire("4aRua");


var $jPaq9 = parcelRequire("jPaq9");


var $hdBxM = parcelRequire("hdBxM");


var $4yg9g = parcelRequire("4yg9g");


var $lpNn5 = parcelRequire("lpNn5");


var $Ou0Zz = parcelRequire("Ou0Zz");


var $kMkDS = parcelRequire("kMkDS");


var $hS1LZ = parcelRequire("hS1LZ");


var $8VrqA = parcelRequire("8VrqA");


var $lsp0E = parcelRequire("lsp0E");

const $c1b3e570a8bf3f0c$var$styles = {
    popupContainer: "_0Of8r2NHnM _1ZnuxbNHnM _1wydGWNHnM _2Zuz6QNHnM",
    formWrapper: "_43nrzT4F84",
    sendIconWrapper: "_03SyCP8HPE",
    rovoChatMoreOptionsButtonContainer: "_0GTcwR4F84",
    rovoChatOpenChatIcon: "_0LQT5EFQfX"
};
const $c1b3e570a8bf3f0c$export$1ccbc9113b239d47 = ({ selectedContent: selectedContent, product: product, onClickChat: onClickChat, onClickPromptOverride: onClickPromptOverride, onSubmitCustomPromptOverride: onSubmitCustomPromptOverride })=>{
    (0, $6cFsl.di)((0, $cXtTj.default), (0, $hS1LZ.useRovoChatHighlightActions));
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const publish = (0, $hdBxM.usePublish)('ai-mate');
    const { setIsMoreOptionsPopupOpen: setIsMoreOptionsPopupOpen } = (0, $hS1LZ.useRovoChatHighlightActionsActions)();
    const [{ isMoreOptionsPopupOpen: isMoreOptionsPopupOpen }] = (0, $hS1LZ.useRovoChatHighlightActions)();
    const { insertHighlightActionsEditorPlaceholder: insertHighlightActionsEditorPlaceholder } = (0, $8VrqA.useHighlightActionsEditorPlaceholder)();
    (0, $cozmU.useEffect)(()=>{
        sendAnalyticsEvent({
            action: 'viewed',
            actionSubject: 'contextualMenuItem',
            actionSubjectId: 'rovoChatHighlightActions',
            attributes: {
                product: product
            }
        });
    }, [
        sendAnalyticsEvent,
        product
    ]);
    const onClose = (0, $cozmU.useCallback)(()=>{
        setIsMoreOptionsPopupOpen(false);
    }, [
        setIsMoreOptionsPopupOpen
    ]);
    const handleClickChat = (0, $cozmU.useCallback)(async ()=>{
        onClickChat();
        insertHighlightActionsEditorPlaceholder(selectedContent);
        sendAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'highlightActionsMenuRovoChatButton',
            attributes: {
                product: product
            }
        });
    }, [
        onClickChat,
        insertHighlightActionsEditorPlaceholder,
        selectedContent,
        sendAnalyticsEvent,
        product
    ]);
    const handlePromptSubmit = (0, $cozmU.useCallback)((values, form)=>{
        const formattedPrompt = (0, $kMkDS.appendADFContent)(selectedContent, values.prompt);
        if (onSubmitCustomPromptOverride) {
            onSubmitCustomPromptOverride(formattedPrompt);
            form.reset();
            sendAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'highlightActionsMenuSubmitPromptButton',
                attributes: {
                    product: product
                }
            });
            return;
        }
        publish({
            type: 'chat-new',
            source: `${product}-context-menu`,
            data: {
                name: values.prompt.substring(0, 30),
                dialogues: [],
                prompt: formattedPrompt
            }
        });
        form.reset();
        sendAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'highlightActionsMenuSubmitPromptButton',
            attributes: {
                product: product
            }
        });
    }, [
        publish,
        sendAnalyticsEvent,
        product,
        onSubmitCustomPromptOverride,
        selectedContent
    ]);
    const rovoChatPromptOptions = [
        {
            id: 'context-menu-rovo-chat-summarize-option',
            actionType: 'summarize',
            prompt: formatMessage((0, $lsp0E.default).rovoChatSummarizePrompt),
            optionText: formatMessage((0, $lsp0E.default).rovoChatSummarizeOptionText)
        },
        {
            id: 'context-menu-rovo-chat-explain-option',
            actionType: 'explain',
            prompt: formatMessage((0, $lsp0E.default).rovoChatExplainPrompt),
            optionText: formatMessage((0, $lsp0E.default).rovoChatExplainOptionText)
        },
        {
            id: 'context-menu-rovo-chat-find-resources-option',
            actionType: 'find-resources',
            prompt: formatMessage((0, $lsp0E.default).rovoChatFindResourcesPrompt),
            optionText: formatMessage((0, $lsp0E.default).rovoChatFindResourcesOptionText)
        },
        {
            id: 'context-menu-rovo-chat-give-feedback-option',
            actionType: 'give-feedback',
            prompt: formatMessage((0, $lsp0E.default).rovoChatGiveFeedbackPrompt),
            optionText: formatMessage((0, $lsp0E.default).rovoChatGiveFeedbackOptionText)
        },
        {
            id: 'context-menu-rovo-chat-give-examples-option',
            actionType: 'give-examples',
            prompt: formatMessage((0, $lsp0E.default).rovoChatGiveExamplesPrompt),
            optionText: formatMessage((0, $lsp0E.default).rovoChatGiveExamplesOptionText)
        }
    ];
    const renderPopupContent = ()=>{
        return /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
            testId: "context-menu-rovo-chat-popup",
            xcss: $c1b3e570a8bf3f0c$var$styles.popupContainer,
            space: "space.150"
        }, rovoChatPromptOptions.map((option)=>{
            return /*#__PURE__*/ $cozmU.createElement((0, $jPaq9.ChatPill), {
                key: option.id,
                testId: option.id,
                onClick: ()=>{
                    const formattedPrompt_0 = (0, $kMkDS.appendADFContent)(selectedContent, option.prompt);
                    if (onClickPromptOverride) {
                        onClickPromptOverride(formattedPrompt_0);
                        sendAnalyticsEvent({
                            action: 'clicked',
                            actionSubject: 'button',
                            actionSubjectId: 'highlightActionsMenuConvoStarterButton',
                            attributes: {
                                actionType: option.actionType,
                                product: product
                            }
                        });
                        return;
                    }
                    publish({
                        type: 'chat-new',
                        source: `${product}-context-menu`,
                        data: {
                            name: option.prompt.substring(0, 30),
                            dialogues: [],
                            prompt: formattedPrompt_0
                        }
                    });
                    sendAnalyticsEvent({
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'highlightActionsMenuConvoStarterButton',
                        attributes: {
                            actionType: option.actionType,
                            product: product
                        }
                    });
                }
            }, option.optionText);
        }), /*#__PURE__*/ $cozmU.createElement((0, $dTHYM.default), {
            onSubmit: handlePromptSubmit
        }, /*#__PURE__*/ $cozmU.createElement((0, $dUI0h.default), {
            name: "prompt"
        }, ({ fieldProps: { value: value, ...fieldPropsRest }, meta: { dirty: dirty } })=>/*#__PURE__*/ $cozmU.createElement((0, $4yg9g.default // this prevents the highlight actions popup from closing when clicking on the input
            ), {
                onClick: (e)=>e.stopPropagation(),
                ...fieldPropsRest,
                testId: "context-menu-rovo-chat-custom-prompt",
                id: "context-menu-rovo-chat-custom-prompt",
                autoComplete: "off",
                elemAfterInput: /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
                    xcss: $c1b3e570a8bf3f0c$var$styles.sendIconWrapper
                }, /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
                    testId: "context-menu-rovo-chat-custom-prompt-submit",
                    isDisabled: !dirty || !value,
                    label: formatMessage((0, $lsp0E.default).rovoChatCustomPromptSubmitButtonText),
                    type: "submit",
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($blZUD))),
                    spacing: "compact"
                })),
                placeholder: formatMessage((0, $lsp0E.default).rovoChatCustomPromptPlaceholder),
                "aria-label": formatMessage((0, $lsp0E.default).rovoChatCustomPromptPlaceholder)
            }))));
    };
    if (product === 'confluence') return /*#__PURE__*/ $cozmU.createElement((0, $lslMH.ToolbarTooltip), {
        content: formatMessage((0, $lsp0E.default).rovoChatOpenChatTooltip)
    }, /*#__PURE__*/ $cozmU.createElement((0, $6t3CY.ToolbarButton), {
        iconBefore: /*#__PURE__*/ $cozmU.createElement((0, $5VSNw.AIChatIcon), {
            label: ""
        }),
        onClick: handleClickChat,
        testId: "context-menu-rovo-chat-button"
    }, formatMessage((0, $lsp0E.default).rovoChatAskRovoButtonText)));
    return /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), null, /*#__PURE__*/ $cozmU.createElement((0, $lpNn5.default), {
        content: formatMessage((0, $lsp0E.default).rovoChatOpenChatTooltip)
    }, /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
        appearance: "subtle",
        iconBefore: ()=>/*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
                xcss: $c1b3e570a8bf3f0c$var$styles.rovoChatOpenChatIcon
            }, /*#__PURE__*/ $cozmU.createElement((0, $etoPX.RovoIcon), {
                size: "xsmall"
            })),
        onClick: handleClickChat,
        testId: "context-menu-rovo-chat-button"
    }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        weight: "medium"
    }, formatMessage((0, $lsp0E.default).rovoChatAskRovoButtonText)))), /*#__PURE__*/ $cozmU.createElement((0, $4n1IT.Popup), {
        placement: "bottom-start",
        isOpen: isMoreOptionsPopupOpen,
        onClose: onClose,
        content: renderPopupContent,
        zIndex: 600,
        trigger: (triggerProps)=>/*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
                xcss: $c1b3e570a8bf3f0c$var$styles.rovoChatMoreOptionsButtonContainer
            }, /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
                ...triggerProps,
                appearance: "subtle",
                id: "context-menu-rovo-chat-more-options",
                testId: "context-menu-rovo-chat-more-options",
                isTooltipDisabled: false,
                icon: (props)=>/*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                        ...props,
                        label: formatMessage((0, $lsp0E.default).rovoChatMoreOptionsTooltip),
                        size: "small"
                    }),
                label: formatMessage((0, $lsp0E.default).rovoChatMoreOptionsTooltip),
                onClick: ()=>{
                    setIsMoreOptionsPopupOpen(!isMoreOptionsPopupOpen);
                    sendAnalyticsEvent({
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'highlightActionsMenuRovoChatMoreOptionsButton',
                        attributes: {
                            product: product
                        }
                    });
                }
            }))
    }));
};
module.exports["RovoChatHighlightActions"] = $c1b3e570a8bf3f0c$export$1ccbc9113b239d47;

});

parcelRegister("hS1LZ", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $7fb521c50b890daa$var$store = (0, $8s9DV.createStore)({
    name: 'RovoChatHighlightActionsStore',
    initialState: {
        isMoreOptionsPopupOpen: false
    },
    actions: {
        setIsMoreOptionsPopupOpen: (isOpen)=>({ setState: setState })=>{
                setState({
                    isMoreOptionsPopupOpen: isOpen
                });
            }
    }
});
const $7fb521c50b890daa$export$6c9cf98a64763bb1 = (0, $kBr4q.createHook)($7fb521c50b890daa$var$store);
const $7fb521c50b890daa$export$f1e33ed2d48967b4 = (0, $kBr4q.createActionsHook)($7fb521c50b890daa$var$store);
module.exports["useRovoChatHighlightActions"] = $7fb521c50b890daa$export$6c9cf98a64763bb1;
module.exports["useRovoChatHighlightActionsActions"] = $7fb521c50b890daa$export$f1e33ed2d48967b4;

});

parcelRegister("lsp0E", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $47e267cfc6e317db$var$message = (0, $kSwu1.defineMessages)({
    rovoChatAskInChatButtonText: {
        id: "highlight-actions.rovo-chat.ask-in-chat-button-text",
        defaultMessage: "Ask in Chat"
    },
    rovoChatAskRovoButtonText: {
        id: "highlight-actions.rovo-chat.ask-rovo-button-text",
        defaultMessage: "Ask Rovo"
    },
    rovoChatOpenChatTooltip: {
        id: "highlight-actions.rovo-chat-open-chat.tooltip",
        defaultMessage: "Open Chat"
    },
    rovoChatMoreOptionsTooltip: {
        id: "highlight-actions.rovo-chat-more-options.tooltip",
        defaultMessage: "Chat recommendations"
    },
    rovoChatSummarizeOptionText: {
        id: "highlight-actions.rovo-chat-summarize-option.text",
        defaultMessage: "Summarize"
    },
    rovoChatExplainOptionText: {
        id: "highlight-actions.rovo-chat-explain-option.text",
        defaultMessage: "Explain"
    },
    rovoChatFindResourcesOptionText: {
        id: "highlight-actions.rovo-chat-find-resources-option.text",
        defaultMessage: "Find resources"
    },
    rovoChatGiveFeedbackOptionText: {
        id: "highlight-actions.rovo-chat-give-feedback-option.text",
        defaultMessage: "Give feedback"
    },
    rovoChatGiveExamplesOptionText: {
        id: "highlight-actions.rovo-chat-give-examples-option.text",
        defaultMessage: "Give examples"
    },
    rovoChatSummarizePrompt: {
        id: "highlight-actions.rovo-chat-summarize-prompt",
        defaultMessage: "Highlight the key points from this. Focus on essential information and exclude unnecessary details. Provide a concise overview in a single paragraph."
    },
    rovoChatExplainPrompt: {
        id: "highlight-actions.rovo-chat-explain-prompt",
        defaultMessage: "Explain this by rephrasing it and adding additional detail, but use very simple language, short sentences, and provide examples or definitions to any technical terminology used in the original phrasing."
    },
    rovoChatFindResourcesPrompt: {
        id: "highlight-actions.rovo-chat-find-resources-prompt",
        defaultMessage: "Find resources within organizational knowledge only that supports the statements made."
    },
    rovoChatGiveFeedbackPrompt: {
        id: "highlight-actions.rovo-chat-give-feedback-prompt",
        defaultMessage: "Give feedback by reviewing the phrasing of this. Provide commentary on word choice, grammar, punctuation. Be positive and enthusiastic but always provide at least one thing to improve or change."
    },
    rovoChatGiveExamplesPrompt: {
        id: "highlight-actions.rovo-chat-give-examples-prompt",
        defaultMessage: "Give examples of this from organizational resources or public knowledge. If there are no resources to provide attempt to give a metaphorical example that may help someone understand this more."
    },
    rovoChatCustomPromptPlaceholder: {
        id: "highlight-actions.rovo-chat-custom-prompt.placeholder",
        defaultMessage: "Ask AI about this"
    },
    rovoChatCustomPromptSubmitButtonText: {
        id: "highlight-actions.rovo-chat-custom-prompt-submit-button.text",
        defaultMessage: "Send"
    }
});
var $47e267cfc6e317db$export$2e2bcd8739ae039 = $47e267cfc6e317db$var$message;
module.exports["default"] = $47e267cfc6e317db$export$2e2bcd8739ae039;

});

parcelRegister("93Gae", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");


var $6UvXN = parcelRequire("6UvXN");

const $081573ec09156b80$var$initialState = {
    mode: undefined,
    isMiniModalAvailable: false,
    isSidebarAvailable: true,
    initialPrompt: undefined,
    openWithChatHistory: false,
    targetConversationId: null,
    targetConversationMetadata: null,
    autoFocusInput: true,
    wasAutoOpened: false,
    editorHadFocusBeforeChatOpen: false
};
const $081573ec09156b80$var$store = (0, $8s9DV.createStore)({
    name: 'rovoExperienceAPIStore',
    initialState: $081573ec09156b80$var$initialState,
    actions: {
        // created for resetting store during tests
        reset: ()=>({ setState: setState })=>{
                setState($081573ec09156b80$var$initialState);
            },
        setMode: (mode)=>({ setState: setState })=>{
                setState({
                    mode: mode,
                    wasAutoOpened: false
                });
            },
        clearInitialPrompt: ()=>({ setState: setState })=>{
                setState({
                    initialPrompt: undefined
                });
            },
        setOpenWithChatHistory: (openWithChatHistory)=>({ setState: setState })=>{
                setState({
                    openWithChatHistory: openWithChatHistory
                });
            },
        setTargetConversationId: (targetConversationId, metadata)=>({ setState: setState })=>{
                setState({
                    targetConversationId: targetConversationId,
                    targetConversationMetadata: metadata?.id === targetConversationId ? metadata : null
                });
            },
        setWasAutoOpened: (wasAutoOpened)=>({ setState: setState })=>{
                setState({
                    wasAutoOpened: wasAutoOpened
                });
            },
        setEditorHadFocusBeforeChatOpen: (editorHadFocusBeforeChatOpen)=>({ setState: setState })=>{
                setState({
                    editorHadFocusBeforeChatOpen: editorHadFocusBeforeChatOpen
                });
            },
        toggleConversationAssistantUIMode: ({ targetMode: targetMode, sidebarApi: sidebarApi, initialPrompt: initialPrompt, autoFocusInput: autoFocusInput = true })=>({ getState: getState, setState: setState })=>{
                const { mode: currentMode } = getState();
                // If no target mode is provided, close any open modes
                if (!targetMode) {
                    setState({
                        mode: undefined,
                        autoFocusInput: true,
                        wasAutoOpened: false
                    });
                    if (sidebarApi.isSidebarOpen()) sidebarApi.closeSidebar();
                    return;
                }
                // Toggle mode functionality
                if (currentMode === targetMode) switch(targetMode){
                    case (0, $6UvXN.ConversationAssistantUIModes).SIDEBAR:
                        /* Handles the edge case where the sidebar space is taken by another panel
              which results in currentMode = 'sidebar' && sidebarApi.isSidebarOpen() = false */ if (!sidebarApi.isSidebarOpen()) {
                            sidebarApi.openSidebar();
                            return;
                        }
                        sidebarApi.closeSidebar();
                        setState({
                            mode: undefined,
                            autoFocusInput: true,
                            wasAutoOpened: false
                        });
                        return;
                    case (0, $6UvXN.ConversationAssistantUIModes).MINI_MODAL:
                        setState({
                            mode: undefined,
                            autoFocusInput: true,
                            wasAutoOpened: false
                        });
                        return;
                    default:
                        return;
                }
                // Switch mode functionality
                switch(targetMode){
                    case (0, $6UvXN.ConversationAssistantUIModes).SIDEBAR:
                        if (!sidebarApi.isSidebarOpen()) sidebarApi.openSidebar();
                        setState({
                            mode: (0, $6UvXN.ConversationAssistantUIModes).SIDEBAR,
                            autoFocusInput: autoFocusInput,
                            wasAutoOpened: false
                        });
                        return;
                    case (0, $6UvXN.ConversationAssistantUIModes).MINI_MODAL:
                        if (sidebarApi.isSidebarOpen()) sidebarApi.closeSidebar();
                        setState({
                            mode: (0, $6UvXN.ConversationAssistantUIModes).MINI_MODAL,
                            initialPrompt: initialPrompt,
                            autoFocusInput: autoFocusInput,
                            wasAutoOpened: false
                        });
                        return;
                }
            },
        openConversationAssistantUIMode: ({ targetMode: targetMode, sidebarApi: sidebarApi, initialPrompt: initialPrompt, autoFocusInput: autoFocusInput = true })=>({ getState: getState, setState: setState })=>{
                const { mode: currentMode } = getState();
                // Already in the desired mode — ensure the sidebar is actually
                // visible (it may have been displaced by another panel) but
                // otherwise treat this as a no-op.
                if (currentMode === targetMode) {
                    if (targetMode === (0, $6UvXN.ConversationAssistantUIModes).SIDEBAR && !sidebarApi.isSidebarOpen()) sidebarApi.openSidebar();
                    return;
                }
                // Switch to the target mode
                switch(targetMode){
                    case (0, $6UvXN.ConversationAssistantUIModes).SIDEBAR:
                        if (!sidebarApi.isSidebarOpen()) sidebarApi.openSidebar();
                        setState({
                            mode: (0, $6UvXN.ConversationAssistantUIModes).SIDEBAR,
                            autoFocusInput: autoFocusInput,
                            wasAutoOpened: false
                        });
                        return;
                    case (0, $6UvXN.ConversationAssistantUIModes).MINI_MODAL:
                        if (sidebarApi.isSidebarOpen()) sidebarApi.closeSidebar();
                        // wasAutoOpened is managed by the dedicated setWasAutoOpened action and reset on close/toggle/setMode.
                        setState({
                            mode: (0, $6UvXN.ConversationAssistantUIModes).MINI_MODAL,
                            initialPrompt: initialPrompt,
                            autoFocusInput: autoFocusInput
                        });
                        return;
                }
            },
        setIsMiniModalAvailable: (isMiniModalAvailable)=>({ setState: setState })=>{
                setState({
                    isMiniModalAvailable: isMiniModalAvailable
                });
            },
        setIsSidebarAvailable: (isSidebarAvailable)=>({ setState: setState })=>{
                setState({
                    isSidebarAvailable: isSidebarAvailable
                });
            }
    }
});
const $081573ec09156b80$var$useStore = (0, $kBr4q.createHook)($081573ec09156b80$var$store);
const $081573ec09156b80$export$37440b51449f7ac6 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(21);
    const [t0, t1] = $081573ec09156b80$var$useStore();
    const { mode: mode, isMiniModalAvailable: isMiniModalAvailable, isSidebarAvailable: isSidebarAvailable, initialPrompt: initialPrompt, openWithChatHistory: openWithChatHistory, targetConversationId: targetConversationId, targetConversationMetadata: targetConversationMetadata, autoFocusInput: autoFocusInput, wasAutoOpened: wasAutoOpened, editorHadFocusBeforeChatOpen: editorHadFocusBeforeChatOpen } = t0;
    const { reset: reset, clearInitialPrompt: clearInitialPrompt, setOpenWithChatHistory: setOpenWithChatHistory, setTargetConversationId: setTargetConversationId, setWasAutoOpened: setWasAutoOpened, setEditorHadFocusBeforeChatOpen: setEditorHadFocusBeforeChatOpen, toggleConversationAssistantUIMode: toggleConversationAssistantUIMode, openConversationAssistantUIMode: openConversationAssistantUIMode, setIsMiniModalAvailable: setIsMiniModalAvailable, setIsSidebarAvailable: setIsSidebarAvailable } = t1;
    let t2;
    if ($[0] !== autoFocusInput || $[1] !== clearInitialPrompt || $[2] !== editorHadFocusBeforeChatOpen || $[3] !== initialPrompt || $[4] !== isMiniModalAvailable || $[5] !== isSidebarAvailable || $[6] !== mode || $[7] !== openConversationAssistantUIMode || $[8] !== openWithChatHistory || $[9] !== reset || $[10] !== setEditorHadFocusBeforeChatOpen || $[11] !== setIsMiniModalAvailable || $[12] !== setIsSidebarAvailable || $[13] !== setOpenWithChatHistory || $[14] !== setTargetConversationId || $[15] !== setWasAutoOpened || $[16] !== targetConversationId || $[17] !== targetConversationMetadata || $[18] !== toggleConversationAssistantUIMode || $[19] !== wasAutoOpened) {
        t2 = {
            mode: mode,
            initialPrompt: initialPrompt,
            openWithChatHistory: openWithChatHistory,
            targetConversationId: targetConversationId,
            targetConversationMetadata: targetConversationMetadata,
            autoFocusInput: autoFocusInput,
            wasAutoOpened: wasAutoOpened,
            editorHadFocusBeforeChatOpen: editorHadFocusBeforeChatOpen,
            reset: reset,
            clearInitialPrompt: clearInitialPrompt,
            setOpenWithChatHistory: setOpenWithChatHistory,
            setTargetConversationId: setTargetConversationId,
            setWasAutoOpened: setWasAutoOpened,
            setEditorHadFocusBeforeChatOpen: setEditorHadFocusBeforeChatOpen,
            toggleConversationAssistantUIMode: toggleConversationAssistantUIMode,
            openConversationAssistantUIMode: openConversationAssistantUIMode,
            setIsMiniModalAvailable: setIsMiniModalAvailable,
            setIsSidebarAvailable: setIsSidebarAvailable,
            isMiniModalAvailable: isMiniModalAvailable,
            isSidebarAvailable: isSidebarAvailable
        };
        $[0] = autoFocusInput;
        $[1] = clearInitialPrompt;
        $[2] = editorHadFocusBeforeChatOpen;
        $[3] = initialPrompt;
        $[4] = isMiniModalAvailable;
        $[5] = isSidebarAvailable;
        $[6] = mode;
        $[7] = openConversationAssistantUIMode;
        $[8] = openWithChatHistory;
        $[9] = reset;
        $[10] = setEditorHadFocusBeforeChatOpen;
        $[11] = setIsMiniModalAvailable;
        $[12] = setIsSidebarAvailable;
        $[13] = setOpenWithChatHistory;
        $[14] = setTargetConversationId;
        $[15] = setWasAutoOpened;
        $[16] = targetConversationId;
        $[17] = targetConversationMetadata;
        $[18] = toggleConversationAssistantUIMode;
        $[19] = wasAutoOpened;
        $[20] = t2;
    } else t2 = $[20];
    return t2;
} : ()=>{
    const [{ mode: mode, isMiniModalAvailable: isMiniModalAvailable, isSidebarAvailable: isSidebarAvailable, initialPrompt: initialPrompt, openWithChatHistory: openWithChatHistory, targetConversationId: targetConversationId, targetConversationMetadata: targetConversationMetadata, autoFocusInput: autoFocusInput, wasAutoOpened: wasAutoOpened, editorHadFocusBeforeChatOpen: editorHadFocusBeforeChatOpen }, { reset: reset, clearInitialPrompt: clearInitialPrompt, setOpenWithChatHistory: setOpenWithChatHistory, setTargetConversationId: setTargetConversationId, setWasAutoOpened: setWasAutoOpened, setEditorHadFocusBeforeChatOpen: setEditorHadFocusBeforeChatOpen, toggleConversationAssistantUIMode: toggleConversationAssistantUIMode, openConversationAssistantUIMode: openConversationAssistantUIMode, setIsMiniModalAvailable: setIsMiniModalAvailable, setIsSidebarAvailable: setIsSidebarAvailable }] = $081573ec09156b80$var$useStore();
    return {
        mode: mode,
        initialPrompt: initialPrompt,
        openWithChatHistory: openWithChatHistory,
        targetConversationId: targetConversationId,
        targetConversationMetadata: targetConversationMetadata,
        autoFocusInput: autoFocusInput,
        wasAutoOpened: wasAutoOpened,
        editorHadFocusBeforeChatOpen: editorHadFocusBeforeChatOpen,
        reset: reset,
        clearInitialPrompt: clearInitialPrompt,
        setOpenWithChatHistory: setOpenWithChatHistory,
        setTargetConversationId: setTargetConversationId,
        setWasAutoOpened: setWasAutoOpened,
        setEditorHadFocusBeforeChatOpen: setEditorHadFocusBeforeChatOpen,
        toggleConversationAssistantUIMode: toggleConversationAssistantUIMode,
        openConversationAssistantUIMode: openConversationAssistantUIMode,
        setIsMiniModalAvailable: setIsMiniModalAvailable,
        setIsSidebarAvailable: setIsSidebarAvailable,
        isMiniModalAvailable: isMiniModalAvailable,
        isSidebarAvailable: isSidebarAvailable
    };
};
const $081573ec09156b80$export$66cf76b7e04da11f = (0, $kBr4q.createActionsHook)($081573ec09156b80$var$store);
module.exports["useRovoExperienceAPIStore"] = $081573ec09156b80$export$37440b51449f7ac6;

});

parcelRegister("6UvXN", function(module, exports) {
/* Duplicates ConversationAssistantUIModes from conversation-assistant package
   to avoid circular dependencies. Any changes here should be mirrored in
	 platform/packages/ai-mate/conversation-assistant/src/types.ts
*/ // oxlint-disable-next-line eslint/no-redeclare
const $7c0481f515a47ac9$export$bc36ebf73899a71d = {
    SIDEBAR: 'sidebar',
    MINI_MODAL: 'mini-modal'
};
module.exports["ConversationAssistantUIModes"] = $7c0481f515a47ac9$export$bc36ebf73899a71d;

});

parcelRegister("jz8lo", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $hdBxM = parcelRequire("hdBxM");


var $k1Pvg = parcelRequire("k1Pvg");


var $5BOJB = parcelRequire("5BOJB");


var $6iWVH = parcelRequire("6iWVH");


var $jmjWc = parcelRequire("jmjWc");


var $lpaq2 = parcelRequire("lpaq2");


const $133397c2abdefdc4$var$LazyRovoChatRemixView = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "b2tBI",
    name: "LazyRovoChatRemixView",
    loader: async ()=>(await (parcelRequire("58Tpz"))).RovoChatRemixView
});
const $133397c2abdefdc4$var$isOpenRovoRemixSidebarPayload = (payload)=>payload.type === 'open-rovo-remix-sidebar';
const $133397c2abdefdc4$var$createRovoRemixAction = (session)=>{
    return {
        id: `confluence-rovo-remix:${crypto.randomUUID()}`,
        title: 'Remix',
        handleType: (0, $6iWVH.HandleActionType).Base,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null),
        presentation: {
            hideActionHeader: true,
            suppressPromptLibrary: true,
            fillAvailableHeight: true
        },
        viewConfig: {
            render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($133397c2abdefdc4$var$LazyRovoChatRemixView, {
                    renderRovoChatRemixPicker: (0, $lpaq2.renderRovoChatRemixPicker),
                    session: session
                })
        }
    };
};
const $133397c2abdefdc4$export$96c35e5f3a6712f8 = ()=>{
    const { setActiveAction: setActiveAction } = (0, $5BOJB.useActiveAction)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const handleEvent = (0, $cozmU.useCallback)((payload)=>{
        if (!$133397c2abdefdc4$var$isOpenRovoRemixSidebarPayload(payload)) return;
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'rovoChatRemixScreen',
                source: payload.source,
                attributes: {
                    entryPoint: payload.source,
                    product: 'confluence'
                }
            }
        }).fire();
        setActiveAction($133397c2abdefdc4$var$createRovoRemixAction({
            consumer: payload.data.remixConsumer,
            scope: payload.data.remixPreset
        }), {
            preserveSelectedConversation: true
        });
    }, [
        createAnalyticsEvent,
        setActiveAction
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hdBxM.Subscriber), {
        consumeOnceKey: "confluence-rovo-remix-action-launcher",
        onEvent: handleEvent,
        topic: (0, $k1Pvg.Topics).ROVO_REMIX_LAUNCH,
        triggerLatest: true
    });
};
module.exports["RovoRemixActionLauncher"] = $133397c2abdefdc4$export$96c35e5f3a6712f8;

});

parcelRegister("lpaq2", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $jmjWc = parcelRequire("jmjWc");


const $3c479359d4e5ebbf$var$LazyRovoChatRemixPickerAdapter = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "HAlgh",
    name: "LazyRovoChatRemixPickerAdapter",
    loader: async ()=>(await (parcelRequire("bE0aw"))).RovoChatRemixPickerAdapter
});
const $3c479359d4e5ebbf$export$ff3dbf3fd6d623a0 = ({ isDisabled: isDisabled, onSelect: onSelect, preset: preset })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3c479359d4e5ebbf$var$LazyRovoChatRemixPickerAdapter, {
        isDisabled: isDisabled,
        onSelect: onSelect,
        preset: preset
    });
module.exports["renderRovoChatRemixPicker"] = $3c479359d4e5ebbf$export$ff3dbf3fd6d623a0;

});

parcelRegister("bE0aw", function(module, exports) {

let $87a38fa146a56a5f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $87a38fa146a56a5f$var$load("6wr18"),
    $87a38fa146a56a5f$var$load("iLt7f"),
    $87a38fa146a56a5f$var$load("7BITa"),
    $87a38fa146a56a5f$var$load("hnpcA"),
    $87a38fa146a56a5f$var$load("ffEVr"),
    $87a38fa146a56a5f$var$load("j1ofJ")
]).then(()=>parcelRequire('fK5VE'));

});

parcelRegister("58Tpz", function(module, exports) {

let $3be8aeaa34c0b6b8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $3be8aeaa34c0b6b8$var$load("kT6dz"),
    $3be8aeaa34c0b6b8$var$load("7fhKs"),
    $3be8aeaa34c0b6b8$var$load("dEA3e"),
    $3be8aeaa34c0b6b8$var$load("bqdgP"),
    $3be8aeaa34c0b6b8$var$load("ennNB"),
    $3be8aeaa34c0b6b8$var$load("9Hr92"),
    $3be8aeaa34c0b6b8$var$load("khIi2"),
    $3be8aeaa34c0b6b8$var$load("eEjUf"),
    $3be8aeaa34c0b6b8$var$load("mRQTa"),
    $3be8aeaa34c0b6b8$var$load("hkiCw"),
    $3be8aeaa34c0b6b8$var$load("7I4uK"),
    $3be8aeaa34c0b6b8$var$load("hUbK8"),
    $3be8aeaa34c0b6b8$var$load("b5NUu"),
    $3be8aeaa34c0b6b8$var$load("5PoQp"),
    $3be8aeaa34c0b6b8$var$load("2j57H"),
    $3be8aeaa34c0b6b8$var$load("kXzPm"),
    $3be8aeaa34c0b6b8$var$load("7BUZH"),
    $3be8aeaa34c0b6b8$var$load("lPKve"),
    $3be8aeaa34c0b6b8$var$load("dmzjI"),
    $3be8aeaa34c0b6b8$var$load("f7eY1"),
    $3be8aeaa34c0b6b8$var$load("kedWY"),
    $3be8aeaa34c0b6b8$var$load("2o5fZ"),
    $3be8aeaa34c0b6b8$var$load("a1ETE"),
    $3be8aeaa34c0b6b8$var$load("cN2rp"),
    $3be8aeaa34c0b6b8$var$load("j5aD5"),
    $3be8aeaa34c0b6b8$var$load("iYvvi"),
    $3be8aeaa34c0b6b8$var$load("eWXZF"),
    $3be8aeaa34c0b6b8$var$load("VXbA1"),
    $3be8aeaa34c0b6b8$var$load("kfGHh"),
    $3be8aeaa34c0b6b8$var$load("lIiD7"),
    $3be8aeaa34c0b6b8$var$load("bJbqV"),
    $3be8aeaa34c0b6b8$var$load("hLB9K"),
    $3be8aeaa34c0b6b8$var$load("hpDuu"),
    $3be8aeaa34c0b6b8$var$load("lWstc"),
    $3be8aeaa34c0b6b8$var$load("ea3NB"),
    $3be8aeaa34c0b6b8$var$load("7qcPK"),
    $3be8aeaa34c0b6b8$var$load("2jERw"),
    $3be8aeaa34c0b6b8$var$load("b7144"),
    $3be8aeaa34c0b6b8$var$load("11yNG"),
    $3be8aeaa34c0b6b8$var$load("gQYVn"),
    $3be8aeaa34c0b6b8$var$load("cpTbC"),
    $3be8aeaa34c0b6b8$var$load("fhT77"),
    $3be8aeaa34c0b6b8$var$load("kMyku"),
    $3be8aeaa34c0b6b8$var$load("hG1ar"),
    $3be8aeaa34c0b6b8$var$load("ep2Eq"),
    $3be8aeaa34c0b6b8$var$load("9BBvG"),
    $3be8aeaa34c0b6b8$var$load("cYv6T"),
    $3be8aeaa34c0b6b8$var$load("el1U6"),
    $3be8aeaa34c0b6b8$var$load("2yyll"),
    $3be8aeaa34c0b6b8$var$load("cZjWF"),
    $3be8aeaa34c0b6b8$var$load("lIK0s"),
    $3be8aeaa34c0b6b8$var$load("6wr18"),
    $3be8aeaa34c0b6b8$var$load("ffEVr"),
    $3be8aeaa34c0b6b8$var$load("gnocL"),
    $3be8aeaa34c0b6b8$var$load("dYUYM"),
    $3be8aeaa34c0b6b8$var$load("lgRS0"),
    $3be8aeaa34c0b6b8$var$load("Wowvf"),
    $3be8aeaa34c0b6b8$var$load("4g6rd"),
    $3be8aeaa34c0b6b8$var$load("45r7q"),
    $3be8aeaa34c0b6b8$var$load("hhss7"),
    $3be8aeaa34c0b6b8$var$load("7EorR"),
    $3be8aeaa34c0b6b8$var$load("7XiLa")
]).then(()=>parcelRequire('f7cmi'));

});

parcelRegister("2bR8c", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kQqCc = parcelRequire("kQqCc");


var $jln20 = parcelRequire("jln20");

const $da7293b7c8deb7d1$export$c27f18f8bab3d8b9 = ()=>{
    const rightSidebarContext = (0, $jln20.useRightSidebarContext)();
    const { panelId: panelId } = rightSidebarContext.getCurrent() || {};
    const isConversationAssistantSidebarActive = panelId === (0, $kQqCc.CONVERSATION_ASSISTANT_CONTAINER_ID);
    return (0, $cozmU.useMemo)(()=>{
        return {
            isSidebarOpen: ()=>{
                return isConversationAssistantSidebarActive;
            },
            openSidebar: ()=>{
                rightSidebarContext.open((0, $kQqCc.CONVERSATION_ASSISTANT_CONTAINER_ID), (0, $kQqCc.CONVERSATION_ASSISTANT_CONTAINER_WIDTH));
            },
            closeSidebar: ()=>{
                if (isConversationAssistantSidebarActive) rightSidebarContext.close((0, $kQqCc.CONVERSATION_ASSISTANT_CONTAINER_ID));
            }
        };
    }, [
        isConversationAssistantSidebarActive,
        rightSidebarContext
    ]);
};
module.exports["useCreateRovoExperienceSidebarController"] = $da7293b7c8deb7d1$export$c27f18f8bab3d8b9;

});

parcelRegister("dbZCH", function(module, exports) {

var $2XyGK = parcelRequire("2XyGK");


var $PX2xE = parcelRequire("PX2xE");

const $704ed0928bc2ea63$export$6c2b92cb1ff351f1 = ()=>(0, $2XyGK.registerInferredProjectPopupContent)((0, $PX2xE.InferredProjectPopupContent));
module.exports["registerInferredProjectPopup"] = $704ed0928bc2ea63$export$6c2b92cb1ff351f1;

});

parcelRegister("PX2xE", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $36WdE = parcelRequire("36WdE");


var $4o1RV = parcelRequire("4o1RV");

const $3cd466a5de7ba5b4$export$ca915380b1b0ae60 = (project)=>{
    const { shimUrl: shimUrl } = (0, $4o1RV.useNavigationPolicy)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $36WdE.InferredProjectPopupContent), {
        ...project,
        shimUrl: shimUrl
    });
};
module.exports["InferredProjectPopupContent"] = $3cd466a5de7ba5b4$export$ca915380b1b0ae60;

});

parcelRegister("36WdE", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $d5gEx = parcelRequire("d5gEx");


var $ipkS0 = parcelRequire("ipkS0");


const $9ac7a8b407b71565$var$InferredProjectPopup = /*#__PURE__*/ (0, $cozmU.lazy)((0, $ipkS0.trackReactLazy)("rl-MUNPHa", ()=>(parcelRequire("iiGGt")).then((module)=>({
            default: module.InferredProjectPopup
        }))));
Object.assign($9ac7a8b407b71565$var$InferredProjectPopup, {
    displayName: 'lazy(InferredProjectPopup)'
});
const $9ac7a8b407b71565$export$ca915380b1b0ae60 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d5gEx.AtlassianRelayEnvironmentProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9ac7a8b407b71565$var$InferredProjectPopup, props)));
module.exports["InferredProjectPopupContent"] = $9ac7a8b407b71565$export$ca915380b1b0ae60;

});

parcelRegister("iiGGt", function(module, exports) {

let $d52b049471a0cfb8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $d52b049471a0cfb8$var$load("aeljk"),
    $d52b049471a0cfb8$var$load("6wr18"),
    $d52b049471a0cfb8$var$load("lg3b1"),
    $d52b049471a0cfb8$var$load("iWnyc"),
    $d52b049471a0cfb8$var$load("hhss7"),
    $d52b049471a0cfb8$var$load("ffEVr"),
    $d52b049471a0cfb8$var$load("Wowvf"),
    $d52b049471a0cfb8$var$load("4g6rd"),
    $d52b049471a0cfb8$var$load("7EorR"),
    $d52b049471a0cfb8$var$load("27osy")
]).then(()=>parcelRequire('6T3IK'));

});

parcelRegister("5ruin", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $2b71e6bc29f732db$var$noopConfiguration = {
    getActions: async ()=>[]
};
const $2b71e6bc29f732db$var$initialState = {
    configuration: $2b71e6bc29f732db$var$noopConfiguration
};
const $2b71e6bc29f732db$var$actions = {
    setConfiguration: (configuration)=>({ setState: setState })=>{
            setState({
                configuration: configuration
            });
        },
    resetConfiguration: ()=>({ setState: setState })=>{
            setState({
                configuration: $2b71e6bc29f732db$var$noopConfiguration
            });
        },
    updateConfiguration: (configuration)=>({ setState: setState, getState: getState })=>{
            const state = getState();
            setState({
                configuration: {
                    ...state.configuration,
                    ...configuration
                }
            });
        }
};
const $2b71e6bc29f732db$export$e0afd2e658e4f7ce = (0, $8s9DV.createStore)({
    initialState: $2b71e6bc29f732db$var$initialState,
    actions: $2b71e6bc29f732db$var$actions,
    name: 'RovoCurrentConfigStore'
});
const $2b71e6bc29f732db$export$2cefdfe72db08be4 = (0, $kBr4q.createActionsHook)($2b71e6bc29f732db$export$e0afd2e658e4f7ce);
const $2b71e6bc29f732db$export$d7809b5c7bef1f6d = (0, $kBr4q.createStateHook)($2b71e6bc29f732db$export$e0afd2e658e4f7ce, {
    selector: (state)=>state.configuration
});
const $2b71e6bc29f732db$export$897f16b7b08b0ac = (0, $kBr4q.createStateHook)($2b71e6bc29f732db$export$e0afd2e658e4f7ce, {
    selector: (state)=>state.configuration.getActions
});
const $2b71e6bc29f732db$export$1e0546f83460b30d = (0, $kBr4q.createStateHook)($2b71e6bc29f732db$export$e0afd2e658e4f7ce, {
    selector: (state)=>state.configuration.tags
});
const $2b71e6bc29f732db$export$2a73ca2333c94154 = (0, $kBr4q.createStateHook)($2b71e6bc29f732db$export$e0afd2e658e4f7ce, {
    selector: (state)=>state.configuration.customGreeting
});
const $2b71e6bc29f732db$export$9d0f592eafe765c0 = (0, $kBr4q.createStateHook)($2b71e6bc29f732db$export$e0afd2e658e4f7ce, {
    selector: (state)=>state.configuration.shouldShowGreeting
});
const $2b71e6bc29f732db$export$6745aa6ec6db525a = (0, $kBr4q.createStateHook)($2b71e6bc29f732db$export$e0afd2e658e4f7ce, {
    selector: (state)=>state.configuration.prioritizeCustomActionResults
});
const $2b71e6bc29f732db$export$77b1364ae13e9bf5 = (0, $kBr4q.createStateHook)($2b71e6bc29f732db$export$e0afd2e658e4f7ce, {
    selector: (state)=>state.configuration.numStartersToShow
});
module.exports["useRovoCurrentConfigStoreActions"] = $2b71e6bc29f732db$export$2cefdfe72db08be4;
module.exports["useRovoConfigGetActions"] = $2b71e6bc29f732db$export$897f16b7b08b0ac;
module.exports["useRovoConfigTags"] = $2b71e6bc29f732db$export$1e0546f83460b30d;
module.exports["useRovoConfigCustomGreeting"] = $2b71e6bc29f732db$export$2a73ca2333c94154;
module.exports["useRovoConfigShouldShowGreeting"] = $2b71e6bc29f732db$export$9d0f592eafe765c0;
module.exports["useRovoConfigPrioritizeCustomActionResults"] = $2b71e6bc29f732db$export$6745aa6ec6db525a;
module.exports["useRovoConfigNumStartersToShow"] = $2b71e6bc29f732db$export$77b1364ae13e9bf5;

});

parcelRegister("1JyKZ", function(module, exports) {

var $3J3Ej = parcelRequire("3J3Ej");


var $cozmU = parcelRequire("cozmU");


var $308Wd = parcelRequire("308Wd");


var $bQm3c = parcelRequire("bQm3c");


var $7Ndnw = parcelRequire("7Ndnw");


var $8a9Dm = parcelRequire("8a9Dm");

var $765515c26d11d063$var$_ContextTokenCache;
class $765515c26d11d063$var$ContextTokenCache {
    static getInstance() {
        if (!$765515c26d11d063$var$ContextTokenCache.instance) $765515c26d11d063$var$ContextTokenCache.instance = new $765515c26d11d063$var$ContextTokenCache();
        return $765515c26d11d063$var$ContextTokenCache.instance;
    }
    get(key) {
        return this.promiseCache.get(key);
    }
    set(key, value) {
        this.promiseCache.set(key, value);
    }
    delete(key) {
        this.promiseCache.delete(key);
    }
    constructor(){
        this.promiseCache = void 0;
        this.promiseCache = new Map();
    }
}
$765515c26d11d063$var$_ContextTokenCache = $765515c26d11d063$var$ContextTokenCache;
$765515c26d11d063$var$ContextTokenCache.instance = void 0;
const $765515c26d11d063$var$EXTRA_BUFFER_MS = 30000; // extra 30 seconds buffer for clock skew
const $765515c26d11d063$var$toGraphQLAttachmentActionLocation = (location)=>location === 'action' ? 'ACTION' : 'METADATA';
const $765515c26d11d063$var$toGraphQLAttachmentActionSurface = (surface)=>surface === 'attachmentMacro' ? 'ATTACHMENT_MACRO' : 'ATTACHMENT_PAGE';
const $765515c26d11d063$var$isAttachmentActionExtensionData = (extensionData)=>extensionData.type === (0, $7Ndnw.FORGE_MODULE_ATTACHMENT_ACTION) && extensionData.attachment !== undefined && extensionData.attachmentActionLocation !== undefined && extensionData.content !== undefined && extensionData.space?.id !== undefined && extensionData.space.key !== undefined && extensionData.surface !== undefined;
// GraphQL mutation to get context token
const $765515c26d11d063$var$UseGetContextTokenMutation = (0, $3J3Ej.default);
const $765515c26d11d063$export$42cd66ed92f75ea0 = ({ extension: extension, extensionData: extensionData, localId: localId, contextIds: contextIds, cachingEnabled: cachingEnabled = false })=>{
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const [runMutation] = (0, $308Wd.useMutationInterop)($765515c26d11d063$var$UseGetContextTokenMutation, {
        interopApolloAggClient: true,
        __callerPackage__: "forge-ui"
    });
    return (0, $cozmU.useMemo)(()=>{
        let attachmentActionExtensionData;
        let standardExtensionData;
        if ($765515c26d11d063$var$isAttachmentActionExtensionData(extensionData)) attachmentActionExtensionData = extensionData;
        else standardExtensionData = extensionData;
        const fetchTokenFromServer = async (effectiveContextIds, effectiveExtension, effectiveLocalId, cache, cacheKey)=>{
            try {
                // Build the input according to the schema
                const input = {
                    contextIds: effectiveContextIds,
                    extensionSpecificContexts: {
                        appVersion: effectiveExtension.appVersion ?? '',
                        context: {
                            appVersion: effectiveExtension.appVersion,
                            environmentId: effectiveExtension.environmentId,
                            environmentType: effectiveExtension.environmentType,
                            siteUrl: window?.location?.origin,
                            extension: {
                                location: undefined,
                                ...attachmentActionExtensionData ? {
                                    attachment: attachmentActionExtensionData.attachment,
                                    attachmentActionLocation: $765515c26d11d063$var$toGraphQLAttachmentActionLocation(attachmentActionExtensionData.attachmentActionLocation),
                                    attachmentActionSurface: $765515c26d11d063$var$toGraphQLAttachmentActionSurface(attachmentActionExtensionData.surface)
                                } : {},
                                content: extensionData.content ? {
                                    id: extensionData.content.id,
                                    type: extensionData.content.type,
                                    subtype: extensionData.content.subtype,
                                    version: standardExtensionData?.content?.version,
                                    status: standardExtensionData?.content?.status
                                } : undefined,
                                isEditing: standardExtensionData?.isEditing,
                                macro: standardExtensionData?.macro ? {
                                    isConfiguring: standardExtensionData.macro.isConfiguring,
                                    isInserting: standardExtensionData.macro.isInserting,
                                    layout: standardExtensionData.macro.layout
                                } : undefined,
                                space: extensionData.space ? {
                                    id: extensionData.space.id,
                                    key: extensionData.space.key
                                } : undefined,
                                ...standardExtensionData?.template?.id && {
                                    template: {
                                        id: standardExtensionData.template.id
                                    }
                                },
                                type: extensionData.type,
                                selectedText: standardExtensionData?.selectedText
                            },
                            localId: effectiveLocalId,
                            moduleKey: (0, $8a9Dm.getModuleKey)(effectiveExtension),
                            isConfig: standardExtensionData?.isConfig,
                            spaceKey: standardExtensionData?.space?.key,
                            contentId: standardExtensionData?.content?.id,
                            type: extensionData.type,
                            content: standardExtensionData?.content ? {
                                id: standardExtensionData.content.id,
                                type: standardExtensionData.content.type,
                                subtype: standardExtensionData.content.subtype,
                                status: standardExtensionData.content.status,
                                version: standardExtensionData.content.version
                            } : undefined,
                            space: standardExtensionData?.space ? {
                                id: standardExtensionData.space.id,
                                key: standardExtensionData.space.key
                            } : undefined,
                            macro: effectiveExtension.properties?.body ? {
                                body: JSON.stringify(effectiveExtension.properties.body)
                            } : null
                        },
                        extensionId: effectiveExtension.id,
                        extensionType: effectiveExtension.type,
                        installationId: effectiveExtension.installationId
                    }
                };
                const { data: data } = await runMutation({
                    variables: {
                        cloudId: cloudId,
                        input: input
                    }
                });
                if (!data?.confluence_generateForgeContextToken?.success) {
                    const errors = data?.confluence_generateForgeContextToken?.errors || [];
                    const errorMessage = errors.map((e)=>e.message).join(', ') || 'Unknown error';
                    throw new Error(`Token generation failed: ${errorMessage}`);
                }
                const forgeContextToken = data.confluence_generateForgeContextToken.forgeContextToken;
                if (!forgeContextToken?.jwt) throw new Error('No JWT token received from GraphQL endpoint');
                // Update cache with expiry info if available
                if (cachingEnabled) {
                    const cachedEntry = cache.get(cacheKey);
                    if (cachedEntry && forgeContextToken.expiresAt) cachedEntry.expiresAt = Number(forgeContextToken.expiresAt);
                }
                return forgeContextToken.jwt;
            } catch (error) {
                // Remove from cache on error so next call will retry
                if (cachingEnabled) cache.delete(cacheKey);
                throw new Error(`Failed to get context token: ${error.message}`);
            }
        };
        // Supports both contextIdsOverride and extensionOverride for embedded macros
        async function getForgeContextToken(options) {
            if (!cloudId) throw new Error('CloudId is required but not available');
            const { contextIdsOverride: contextIdsOverride, extensionOverride: extensionOverride } = options ?? {};
            // Use override values if provided (for embedded macros), otherwise use parent values
            const effectiveExtension_0 = extensionOverride?.extension ?? extension;
            const effectiveLocalId_0 = extensionOverride?.localId ?? localId;
            const effectiveContextIds_0 = contextIdsOverride ?? contextIds;
            const cacheKey_0 = JSON.stringify({
                id: effectiveLocalId_0 || effectiveExtension_0.id,
                data: extensionData,
                contextIds: effectiveContextIds_0
            });
            const cache_0 = $765515c26d11d063$var$ContextTokenCache.getInstance();
            const cached = cache_0.get(cacheKey_0);
            if (cachingEnabled) {
                if (cached) {
                    if (typeof cached.expiresAt !== 'number') return cached.promise;
                    if (Date.now() + $765515c26d11d063$var$EXTRA_BUFFER_MS < cached.expiresAt) return cached.promise;
                }
                const issuedAt = Date.now();
                const tokenPromise = fetchTokenFromServer(effectiveContextIds_0, effectiveExtension_0, effectiveLocalId_0, cache_0, cacheKey_0);
                cache_0.set(cacheKey_0, {
                    promise: tokenPromise,
                    expiresAt: undefined,
                    issuedAt: issuedAt
                });
                return tokenPromise;
            }
            return fetchTokenFromServer(effectiveContextIds_0, effectiveExtension_0, effectiveLocalId_0, cache_0, cacheKey_0);
        }
        return getForgeContextToken;
    }, [
        extension,
        extensionData,
        localId,
        cloudId,
        runMutation,
        contextIds,
        cachingEnabled
    ]);
};
module.exports["useGetContextToken"] = $765515c26d11d063$export$42cd66ed92f75ea0;

});

parcelRegister("3J3Ej", function(module, exports) {
/**
 * @generated SignedSource<<44676e88351503ec74d9733ae15d6987>>
 * @relayHash bfc43724fd2fc3a6f132a6d5f7e9da68
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID aebc4ac6f19efb4f09e20cf9c09e3afa223b9374353fd6d698d7b653144dd21f
const $dc4f7aee3cccfa96$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "ConfluenceForgeContextTokenPayload",
            "kind": "LinkedField",
            "name": "confluence_generateForgeContextToken",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "success"
                },
                {
                    "concreteType": "MutationError",
                    "kind": "LinkedField",
                    "name": "errors",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "message"
                        }
                    ]
                },
                {
                    "concreteType": "ConfluenceForgeContextToken",
                    "kind": "LinkedField",
                    "name": "forgeContextToken",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "jwt"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "expiresAt"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "extensionId"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useGetContextTokenMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useGetContextTokenMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "bfc43724fd2fc3a6f132a6d5f7e9da68",
            "id": "aebc4ac6f19efb4f09e20cf9c09e3afa223b9374353fd6d698d7b653144dd21f",
            "metadata": {},
            "name": "useGetContextTokenMutation",
            "operationKind": "mutation",
            "text": "mutation useGetContextTokenMutation($cloudId:ID!,$input:ConfluenceForgeContextTokenRequestInput!){confluence_generateForgeContextToken(cloudId:$cloudId,input:$input){success,errors{message},forgeContextToken{jwt,expiresAt,extensionId}}}"
        }
    };
}();
$dc4f7aee3cccfa96$var$node.hash = "881cc660c7be5fb9164424934214d110";
var $dc4f7aee3cccfa96$export$2e2bcd8739ae039 = $dc4f7aee3cccfa96$var$node;
module.exports["default"] = $dc4f7aee3cccfa96$export$2e2bcd8739ae039;

});

parcelRegister("aF5bm", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $bQm3c = parcelRequire("bQm3c");

const $3217b30f8fcccab4$export$c922e8420e7a46c9 = ({ cloudId: cloudId, activationId: activationId })=>{
    return `ari:cloud:confluence:${cloudId}:workspace/${activationId}`;
};
const $3217b30f8fcccab4$export$3c417c5065f4ac35 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $bDgLe.c)(3);
    const { cloudId: cloudId, activationId: activationId } = (0, $bQm3c.useSessionData)();
    let t0;
    if ($[0] !== activationId || $[1] !== cloudId) {
        t0 = $3217b30f8fcccab4$export$c922e8420e7a46c9({
            cloudId: cloudId,
            activationId: activationId
        });
        $[0] = activationId;
        $[1] = cloudId;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : ()=>{
    const { cloudId: cloudId, activationId: activationId } = (0, $bQm3c.useSessionData)();
    return $3217b30f8fcccab4$export$c922e8420e7a46c9({
        cloudId: cloudId,
        activationId: activationId
    });
};
module.exports["getWorkspaceARI"] = $3217b30f8fcccab4$export$c922e8420e7a46c9;
module.exports["useWorkspaceARI"] = $3217b30f8fcccab4$export$3c417c5065f4ac35;

});


//# sourceMappingURL=ConversationAssistant.b401da86.js.map
